
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6aWz6", function(module, exports) {

$parcel$export(module.exports, "FastshiftDashboardPage", function () { return $2319f1f3c66d5433$export$357a360ea405de82; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("271hx");
var $EzsFV = parcelRequire("EzsFV");
const $2319f1f3c66d5433$export$357a360ea405de82 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $EzsFV.FastshiftDashboardPageTemplate), {});

});
parcelRegister("271hx", function(module, exports) {
$parcel$export(module.exports, "FastshiftDashboardPageTemplate", function () { return (parcelRequire("EzsFV")).FastshiftDashboardPageTemplate; });

var $EzsFV = parcelRequire("EzsFV");

});
parcelRegister("EzsFV", function(module, exports) {

$parcel$export(module.exports, "FastshiftDashboardPageTemplate", function () { return $ef0874a7c49287eb$export$51b95d9ab7d14de8; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");



var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");

var $luVwe = parcelRequire("luVwe");

var $i1RHe = parcelRequire("i1RHe");
const $ef0874a7c49287eb$export$51b95d9ab7d14de8 = ()=>{
    const isFastshiftPortalEnabled = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).sxpEnableFastshiftPortal);
    if (!isFastshiftPortalEnabled) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $luVwe.FourOhFourPageTemplate), {});
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $i1RHe.FastshiftPortalPageRouter), {});
};

});
parcelRegister("i1RHe", function(module, exports) {

$parcel$export(module.exports, "FastshiftPortalPageRouter", function () { return $7f4909f2eeecf315$export$6e50b31916fa8824; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $laIa3 = parcelRequire("laIa3");

var $f6qj2 = parcelRequire("f6qj2");

var $6gPV0 = parcelRequire("6gPV0");

var $hK5Mw = parcelRequire("hK5Mw");
var $hea8X = parcelRequire("hea8X");

var $ePyB2 = parcelRequire("ePyB2");
parcelRequire("02sQp");
var $hWMXK = parcelRequire("hWMXK");
var $b8p6O = parcelRequire("b8p6O");
var $IM44x = parcelRequire("IM44x");
var $9r6Sh = parcelRequire("9r6Sh");
var $3VPg6 = parcelRequire("3VPg6");
parcelRequire("5m8h9");
var $5wrp0 = parcelRequire("5wrp0");
var $2Brms = parcelRequire("2Brms");

var $9OyVr = parcelRequire("9OyVr");

var $dO2cs = parcelRequire("dO2cs");

var $adqfu = parcelRequire("adqfu");
parcelRequire("bSbqT");
var $jwBCq = parcelRequire("jwBCq");

var $1LBjK = parcelRequire("1LBjK");

var $4KDmv = parcelRequire("4KDmv");

var $glqYA = parcelRequire("glqYA");
const $7f4909f2eeecf315$var$CustomRouterLink = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, ref)=>{
    var { href: href, children: children } = _param, rest = (0, $akGnX._)(_param, [
        "href",
        "children"
    ]);
    // A basic link by passing a string as the component's `href` prop.
    if (typeof href === "string") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hK5Mw.Link), (0, $6iHNw._)((0, $7Knp0._)({
        ref: ref,
        to: href
    }, rest), {
        children: children
    }));
    // Advanced link configuration by passing an object as the
    // component's `href` prop
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hK5Mw.Link), (0, $6iHNw._)((0, $7Knp0._)({
        ref: ref,
        // href={href.href}
        to: href.to,
        replace: href.replace
    }, rest), {
        children: children
    }));
});
const $7f4909f2eeecf315$export$6e50b31916fa8824 = ()=>{
    const intl = (0, $f6qj2.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useEffect(()=>{
        if (intl) document.title = intl.formatMessage({
            id: "FastshiftPortal.document.title",
            defaultMessage: "Fastshift Portal"
        });
    }, [
        intl
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4KDmv.ClientOnly), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)($laIa3.ErrorBoundary, {
            beforeCapture: (0, $dO2cs.beforeCaptureWithScope)("catch-all"),
            fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5wrp0.GenericErrorDisplay), {}),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ePyB2.default), {
                routerLinkComponent: $7f4909f2eeecf315$var$CustomRouterLink,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hK5Mw.BrowserRouter), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $adqfu.default).Provider, {
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6gPV0.Provider), {
                            store: (0, $1LBjK.store),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("style", {
                                    dangerouslySetInnerHTML: {
                                        __html: `.grecaptcha-badge { visibility: hidden !important; }`
                                    }
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $hea8X.Routes), {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hea8X.Route), {
                                        path: "/:locale?",
                                        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $hea8X.Route), {
                                            element: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hWMXK.PageLayout), {}),
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $hea8X.Route), {
                                                    path: (0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).SELECTION],
                                                    element: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jwBCq.FastshiftCustomerSelectionPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $hea8X.Route), {
                                                    path: (0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).OVERVIEW],
                                                    element: /*#__PURE__*/ (0, $loA2J.jsx)((0, $b8p6O.FastshiftDashboard), {})
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $hea8X.Route), {
                                                    path: (0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).PLANNING],
                                                    element: /*#__PURE__*/ (0, $loA2J.jsx)((0, $IM44x.FastshiftMigrationsManagementPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $hea8X.Route), {
                                                    path: (0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).RESOURCES_DOMAIN_SCOPED],
                                                    element: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9r6Sh.FastshiftResourcesPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $hea8X.Route), {
                                                    path: (0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).RESOURCES_PARTNER_SCOPED],
                                                    element: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9r6Sh.FastshiftResourcesPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $hea8X.Route), {
                                                    path: (0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).FASTSHIFT],
                                                    element: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3VPg6.FastshiftPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $hea8X.Route), {
                                                    path: "fastshift/dashboard",
                                                    element: /*#__PURE__*/ (0, $loA2J.jsx)((0, $glqYA.RedirectToSelectionPage), {})
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $hea8X.Route), {
                                                    path: "*",
                                                    element: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2Brms.FourOhFourDisplay), {})
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("ePyB2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acc0aa379578ca4b$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $388ly = parcelRequire("388ly");

var $ioYoi = parcelRequire("ioYoi");
var $acc0aa379578ca4b$var$InsideAppProviderContext = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $acc0aa379578ca4b$var$AppProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? "light" : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme, routerLinkComponent = _ref.routerLinkComponent, UNSAFE_isThemingDisabled = _ref.UNSAFE_isThemingDisabled;
    var isInsideAppProvider = (0, $iSvIT.useContext)($acc0aa379578ca4b$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error("App provider should not be nested within another app provider.");
    var routerLinkProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $388ly.default), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($acc0aa379578ca4b$var$InsideAppProviderContext.Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ioYoi.default), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider));
}
var $acc0aa379578ca4b$export$2e2bcd8739ae039 = $acc0aa379578ca4b$var$AppProvider;

});

parcelRegister("02sQp", function(module, exports) {

$parcel$export(module.exports, "FastshiftDashboard", function () { return (parcelRequire("b8p6O")).FastshiftDashboard; });
$parcel$export(module.exports, "FastshiftResourcesPage", function () { return (parcelRequire("9r6Sh")).FastshiftResourcesPage; });
$parcel$export(module.exports, "FastshiftMigrationsManagementPage", function () { return (parcelRequire("IM44x")).FastshiftMigrationsManagementPage; });
$parcel$export(module.exports, "PageLayout", function () { return (parcelRequire("hWMXK")).PageLayout; });
$parcel$export(module.exports, "FastshiftPage", function () { return (parcelRequire("3VPg6")).FastshiftPage; });
parcelRequire("9GmWy");
var $b8p6O = parcelRequire("b8p6O");
parcelRequire("bSbqT");
var $jwBCq = parcelRequire("jwBCq");
parcelRequire("cOojB");
var $9r6Sh = parcelRequire("9r6Sh");
parcelRequire("01Iri");
var $IM44x = parcelRequire("IM44x");

var $hWMXK = parcelRequire("hWMXK");
parcelRequire("57r8u");
var $3VPg6 = parcelRequire("3VPg6");

});
parcelRegister("9GmWy", function(module, exports) {

$parcel$export(module.exports, "FastshiftDashboard", function () { return (parcelRequire("b8p6O")).FastshiftDashboard; });

var $b8p6O = parcelRequire("b8p6O");

});
parcelRegister("b8p6O", function(module, exports) {

$parcel$export(module.exports, "FastshiftDashboard", function () { return $536251edd11397a6$export$12d84f115c5f031b; });

var $loA2J = parcelRequire("loA2J");

var $cgOuH = parcelRequire("cgOuH");

var $5wOn9 = parcelRequire("5wOn9");
parcelRequire("3owl2");
var $cJaOz = parcelRequire("cJaOz");

var $boF4D = parcelRequire("boF4D");
parcelRequire("jNqYB");
var $hybbY = parcelRequire("hybbY");
parcelRequire("iMIhQ");
var $lTj8F = parcelRequire("lTj8F");
parcelRequire("6D9is");
var $8Omk5 = parcelRequire("8Omk5");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");
parcelRequire("3oQlK");
var $b7yur = parcelRequire("b7yur");
parcelRequire("Vqc64");
var $5NmAE = parcelRequire("5NmAE");
parcelRequire("hxxJV");
var $dCkeh = parcelRequire("dCkeh");
const $536251edd11397a6$export$12d84f115c5f031b = ()=>{
    const { data: userDetails } = (0, $8KnwD.useFastshiftSelector)((state)=>state.userDetails);
    const userInfo = (0, $5wOn9.useLoggedInUser)();
    const currentTime = (0, $lTj8F.getCurrentTime)();
    (0, $b7yur.useDashboardPageAnalytics)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        space: "space.400",
        children: [
            (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "CUSTOMER" && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                space: "space.300",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $8Omk5.CustomerWelcomeBanner), {
                        currentTime: currentTime,
                        userName: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $boF4D.LegalBanner), {})
                ]
            }),
            (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) !== "CUSTOMER" && /*#__PURE__*/ (0, $loA2J.jsx)((0, $cJaOz.CustomerNameAndLogoHeader), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dCkeh.SummarySection), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hybbY.RelationshipSection), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5NmAE.MigrationStatusTable), {})
        ]
    });
};

});
parcelRegister("cgOuH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eee25c4d19287de$export$2e2bcd8739ae039; });

var $1XRzW = parcelRequire("1XRzW");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jAMCU = parcelRequire("jAMCU");

var $g2DEO = parcelRequire("g2DEO");
var $8eee25c4d19287de$var$flexGrowMap = {
    hug: (0, $jAMCU.xcss)({
        flexGrow: 0
    }),
    fill: (0, $jAMCU.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $8eee25c4d19287de$var$Stack = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $8eee25c4d19287de$var$flexGrowMap[grow]
    ].concat((0, $1XRzW.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $2ZUkg.jsx)((0, $g2DEO.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$8eee25c4d19287de$var$Stack.displayName = "Stack";
var $8eee25c4d19287de$export$2e2bcd8739ae039 = $8eee25c4d19287de$var$Stack;

});
parcelRegister("1XRzW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16e4dcbdf0ce430d$export$2e2bcd8739ae039; });

var $1OiL1 = parcelRequire("1OiL1");

var $4NxeI = parcelRequire("4NxeI");

var $fZJw1 = parcelRequire("fZJw1");

var $gwx6f = parcelRequire("gwx6f");
function $16e4dcbdf0ce430d$export$2e2bcd8739ae039(r) {
    return (0, $1OiL1.default)(r) || (0, $4NxeI.default)(r) || (0, $fZJw1.default)(r) || (0, $gwx6f.default)();
}

});
parcelRegister("1OiL1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $151902cd47fdd8f4$export$2e2bcd8739ae039; });

var $fbg15 = parcelRequire("fbg15");
function $151902cd47fdd8f4$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $fbg15.default)(r);
}

});
parcelRegister("fbg15", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0d44ea5fd9b940d$export$2e2bcd8739ae039; });
function $b0d44ea5fd9b940d$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("4NxeI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37e5850fe8767255$export$2e2bcd8739ae039; });
function $37e5850fe8767255$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("fZJw1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba4fdbec24f71e76$export$2e2bcd8739ae039; });

var $fbg15 = parcelRequire("fbg15");
function $ba4fdbec24f71e76$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $fbg15.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $fbg15.default)(r, a) : void 0;
    }
}

});

parcelRegister("gwx6f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0794f6e0d8cec7e$export$2e2bcd8739ae039; });
function $c0794f6e0d8cec7e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jAMCU", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $e437195a79f488af$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $e437195a79f488af$export$f6c783d06584602c; });

var $1XRzW = parcelRequire("1XRzW");

var $6BH4v = parcelRequire("6BH4v");

var $kOM80 = parcelRequire("kOM80");

var $hFZ5s = parcelRequire("hFZ5s");

var $2ZUkg = parcelRequire("2ZUkg");

var $1dqlv = parcelRequire("1dqlv");

var $XAEGR = parcelRequire("XAEGR");
function $e437195a79f488af$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e437195a79f488af$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e437195a79f488af$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e437195a79f488af$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e437195a79f488af$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e437195a79f488af$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $e437195a79f488af$export$9a199fbafee0014e = {
    backgroundColor: (0, $1dqlv.backgroundColorMap),
    blockSize: (0, $1dqlv.dimensionMap),
    borderBlockColor: (0, $1dqlv.borderColorMap),
    borderBlockEndColor: (0, $1dqlv.borderColorMap),
    borderBlockEndWidth: (0, $1dqlv.borderWidthMap),
    borderBlockStartColor: (0, $1dqlv.borderColorMap),
    borderBlockStartWidth: (0, $1dqlv.borderWidthMap),
    borderBlockWidth: (0, $1dqlv.borderWidthMap),
    borderBottomColor: (0, $1dqlv.borderColorMap),
    borderBottomLeftRadius: (0, $1dqlv.borderRadiusMap),
    borderBottomRightRadius: (0, $1dqlv.borderRadiusMap),
    borderBottomWidth: (0, $1dqlv.borderWidthMap),
    borderColor: (0, $1dqlv.borderColorMap),
    borderEndEndRadius: (0, $1dqlv.borderRadiusMap),
    borderEndStartRadius: (0, $1dqlv.borderRadiusMap),
    borderInlineColor: (0, $1dqlv.borderColorMap),
    borderInlineEndColor: (0, $1dqlv.borderColorMap),
    borderInlineEndWidth: (0, $1dqlv.borderWidthMap),
    borderInlineStartColor: (0, $1dqlv.borderColorMap),
    borderInlineStartWidth: (0, $1dqlv.borderWidthMap),
    borderInlineWidth: (0, $1dqlv.borderWidthMap),
    borderLeftColor: (0, $1dqlv.borderColorMap),
    borderLeftWidth: (0, $1dqlv.borderWidthMap),
    borderRadius: (0, $1dqlv.borderRadiusMap),
    borderRightColor: (0, $1dqlv.borderColorMap),
    borderRightWidth: (0, $1dqlv.borderWidthMap),
    borderStartEndRadius: (0, $1dqlv.borderRadiusMap),
    borderStartStartRadius: (0, $1dqlv.borderRadiusMap),
    borderTopColor: (0, $1dqlv.borderColorMap),
    borderTopLeftRadius: (0, $1dqlv.borderRadiusMap),
    borderTopRightRadius: (0, $1dqlv.borderRadiusMap),
    borderTopWidth: (0, $1dqlv.borderWidthMap),
    borderWidth: (0, $1dqlv.borderWidthMap),
    bottom: (0, $1dqlv.allSpaceMap),
    boxShadow: (0, $1dqlv.shadowMap),
    color: (0, $1dqlv.textColorMap),
    columnGap: (0, $1dqlv.positiveSpaceMap),
    font: (0, $1dqlv.fontMap),
    fontFamily: (0, $1dqlv.fontFamilyMap),
    fontWeight: (0, $1dqlv.fontWeightMap),
    gap: (0, $1dqlv.positiveSpaceMap),
    height: (0, $1dqlv.dimensionMap),
    inlineSize: (0, $1dqlv.dimensionMap),
    inset: (0, $1dqlv.allSpaceMap),
    insetBlock: (0, $1dqlv.allSpaceMap),
    insetBlockEnd: (0, $1dqlv.allSpaceMap),
    insetBlockStart: (0, $1dqlv.allSpaceMap),
    insetInline: (0, $1dqlv.allSpaceMap),
    insetInlineEnd: (0, $1dqlv.allSpaceMap),
    insetInlineStart: (0, $1dqlv.allSpaceMap),
    left: (0, $1dqlv.allSpaceMap),
    margin: (0, $1dqlv.allSpaceMap),
    marginBlock: (0, $1dqlv.allSpaceMap),
    marginBlockEnd: (0, $1dqlv.allSpaceMap),
    marginBlockStart: (0, $1dqlv.allSpaceMap),
    marginBottom: (0, $1dqlv.allSpaceMap),
    marginInline: (0, $1dqlv.allSpaceMap),
    marginInlineEnd: (0, $1dqlv.allSpaceMap),
    marginInlineStart: (0, $1dqlv.allSpaceMap),
    marginLeft: (0, $1dqlv.allSpaceMap),
    marginRight: (0, $1dqlv.allSpaceMap),
    marginTop: (0, $1dqlv.allSpaceMap),
    maxBlockSize: (0, $1dqlv.dimensionMap),
    maxHeight: (0, $1dqlv.dimensionMap),
    maxInlineSize: (0, $1dqlv.dimensionMap),
    maxWidth: (0, $1dqlv.dimensionMap),
    minBlockSize: (0, $1dqlv.dimensionMap),
    minHeight: (0, $1dqlv.dimensionMap),
    minInlineSize: (0, $1dqlv.dimensionMap),
    minWidth: (0, $1dqlv.dimensionMap),
    opacity: (0, $1dqlv.opacityMap),
    outlineColor: (0, $1dqlv.borderColorMap),
    outlineOffset: (0, $1dqlv.allSpaceMap),
    outlineWidth: (0, $1dqlv.borderWidthMap),
    padding: (0, $1dqlv.positiveSpaceMap),
    paddingBlock: (0, $1dqlv.positiveSpaceMap),
    paddingBlockEnd: (0, $1dqlv.positiveSpaceMap),
    paddingBlockStart: (0, $1dqlv.positiveSpaceMap),
    paddingBottom: (0, $1dqlv.positiveSpaceMap),
    paddingInline: (0, $1dqlv.positiveSpaceMap),
    paddingInlineEnd: (0, $1dqlv.positiveSpaceMap),
    paddingInlineStart: (0, $1dqlv.positiveSpaceMap),
    paddingLeft: (0, $1dqlv.positiveSpaceMap),
    paddingRight: (0, $1dqlv.positiveSpaceMap),
    paddingTop: (0, $1dqlv.positiveSpaceMap),
    right: (0, $1dqlv.allSpaceMap),
    rowGap: (0, $1dqlv.positiveSpaceMap),
    top: (0, $1dqlv.allSpaceMap),
    width: (0, $1dqlv.dimensionMap),
    zIndex: (0, $1dqlv.layerMap)
};
var $e437195a79f488af$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $e437195a79f488af$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $XAEGR === "undefined" ? "undefined" : (0, $hFZ5s.default)($XAEGR)) === "object" && (0, $hFZ5s.default)($XAEGR.env) === "object" && false;
};
var $e437195a79f488af$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $e437195a79f488af$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $e437195a79f488af$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $hFZ5s.default)(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($e437195a79f488af$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $kOM80.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $hFZ5s.default)(value) === "object" && $e437195a79f488af$var$safeSelectors.test(key)) {
            styleObj[key] = $e437195a79f488af$var$_transformStyles(value);
            return;
        }
        if ($e437195a79f488af$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($e437195a79f488af$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $e437195a79f488af$export$9a199fbafee0014e)) return;
        var tokenValue = $e437195a79f488af$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $e437195a79f488af$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $e437195a79f488af$var$_transformStyles(style);
    return (0, $6BH4v.default)({}, $e437195a79f488af$var$uniqueSymbol, (0, $2ZUkg.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $e437195a79f488af$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $e437195a79f488af$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $e437195a79f488af$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $1XRzW.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$e437195a79f488af$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $e437195a79f488af$export$f6c783d06584602c(style) {
    return $e437195a79f488af$var$baseXcss(style);
}

});
parcelRegister("6BH4v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cf79befa8deb2cb$export$2e2bcd8739ae039; });

var $7O5um = parcelRequire("7O5um");
function $4cf79befa8deb2cb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $7O5um.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("7O5um", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5af175e1635b3922$export$2e2bcd8739ae039; });

var $hFZ5s = parcelRequire("hFZ5s");

var $5DsHH = parcelRequire("5DsHH");
function $5af175e1635b3922$export$2e2bcd8739ae039(t) {
    var i = (0, $5DsHH.default)(t, "string");
    return "symbol" == (0, $hFZ5s.default)(i) ? i : i + "";
}

});
parcelRegister("hFZ5s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cde5a697aa2e376b$export$2e2bcd8739ae039; });
function $cde5a697aa2e376b$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $cde5a697aa2e376b$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cde5a697aa2e376b$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5DsHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41a6dc46a107bb2d$export$2e2bcd8739ae039; });

var $hFZ5s = parcelRequire("hFZ5s");
function $41a6dc46a107bb2d$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $hFZ5s.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $hFZ5s.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("kOM80", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f27dcf6367bb9ec7$export$2e2bcd8739ae039; });

var $60Asa = parcelRequire("60Asa");

var $bPGqc = parcelRequire("bPGqc");

var $fZJw1 = parcelRequire("fZJw1");

var $18jis = parcelRequire("18jis");
function $f27dcf6367bb9ec7$export$2e2bcd8739ae039(r, e) {
    return (0, $60Asa.default)(r) || (0, $bPGqc.default)(r, e) || (0, $fZJw1.default)(r, e) || (0, $18jis.default)();
}

});
parcelRegister("60Asa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45ff05079a5065b0$export$2e2bcd8739ae039; });
function $45ff05079a5065b0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("bPGqc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89d55d2d8d198936$export$2e2bcd8739ae039; });
function $89d55d2d8d198936$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("18jis", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d3581b7712978ea$export$2e2bcd8739ae039; });
function $0d3581b7712978ea$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("1dqlv", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $0e2b710fed9581ac$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $0e2b710fed9581ac$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $0e2b710fed9581ac$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $0e2b710fed9581ac$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $0e2b710fed9581ac$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $0e2b710fed9581ac$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $0e2b710fed9581ac$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $0e2b710fed9581ac$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $0e2b710fed9581ac$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $0e2b710fed9581ac$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $0e2b710fed9581ac$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $0e2b710fed9581ac$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $0e2b710fed9581ac$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $0e2b710fed9581ac$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $0e2b710fed9581ac$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $0e2b710fed9581ac$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $0e2b710fed9581ac$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $0e2b710fed9581ac$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $0e2b710fed9581ac$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "textSizeStylesMap", function () { return $0e2b710fed9581ac$export$219d364c0da35ae4; });
$parcel$export(module.exports, "textWeightStylesMap", function () { return $0e2b710fed9581ac$export$38845ca010b93505; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $0e2b710fed9581ac$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $0e2b710fed9581ac$export$5e65a44e5b6ecadb; });

var $6BH4v = parcelRequire("6BH4v");

var $2ZUkg = parcelRequire("2ZUkg");

var $ayHI4 = parcelRequire("ayHI4");
function $0e2b710fed9581ac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e2b710fed9581ac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e2b710fed9581ac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6BH4v.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e2b710fed9581ac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0e2b710fed9581ac$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $0e2b710fed9581ac$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $0e2b710fed9581ac$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $0e2b710fed9581ac$export$632685d741f3dbbf = $0e2b710fed9581ac$var$_objectSpread($0e2b710fed9581ac$var$_objectSpread({}, $0e2b710fed9581ac$export$958d0ae7f2977ae4), $0e2b710fed9581ac$export$d2dc61f58390201c);
var $0e2b710fed9581ac$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $0e2b710fed9581ac$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $0e2b710fed9581ac$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $0e2b710fed9581ac$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $0e2b710fed9581ac$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $0e2b710fed9581ac$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $0e2b710fed9581ac$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $0e2b710fed9581ac$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B778C)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $0e2b710fed9581ac$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $0e2b710fed9581ac$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $0e2b710fed9581ac$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $0e2b710fed9581ac$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $0e2b710fed9581ac$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $0e2b710fed9581ac$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $0e2b710fed9581ac$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $0e2b710fed9581ac$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $0e2b710fed9581ac$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $0e2b710fed9581ac$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $2ZUkg.css)((0, $6BH4v.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $0e2b710fed9581ac$export$e615f061ca585a6c = $0e2b710fed9581ac$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $0e2b710fed9581ac$export$ca0f9c2de39ffed7(spacingProperty, $0e2b710fed9581ac$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $0e2b710fed9581ac$export$bf46c3f9eeafc71f = $0e2b710fed9581ac$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $0e2b710fed9581ac$export$ca0f9c2de39ffed7(spacingProperty, $0e2b710fed9581ac$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $0e2b710fed9581ac$export$e7af83bafe7f9e63 = $0e2b710fed9581ac$export$ca0f9c2de39ffed7("backgroundColor", $0e2b710fed9581ac$export$d1d79bf68ac056bd);
var $0e2b710fed9581ac$export$3a1bcba60b23d7f0 = $0e2b710fed9581ac$export$ca0f9c2de39ffed7("color", $0e2b710fed9581ac$export$8473307aa00d6ea1);
var $0e2b710fed9581ac$export$45f3f4fe16f9f7d5 = $0e2b710fed9581ac$export$ca0f9c2de39ffed7("fontWeight", $0e2b710fed9581ac$export$303e322c6b1ed114);
var $0e2b710fed9581ac$export$68cc305da27dbaa4 = $0e2b710fed9581ac$export$ca0f9c2de39ffed7("fontFamily", $0e2b710fed9581ac$export$3c7e9587132614b4);
var $0e2b710fed9581ac$export$128f10c238242f83 = $0e2b710fed9581ac$export$ca0f9c2de39ffed7("font", $0e2b710fed9581ac$export$6ffa317d5e70375);
var $0e2b710fed9581ac$export$219d364c0da35ae4 = $0e2b710fed9581ac$export$ca0f9c2de39ffed7("font", $0e2b710fed9581ac$export$236bfe3a33ef1292);
var $0e2b710fed9581ac$export$38845ca010b93505 = $0e2b710fed9581ac$export$ca0f9c2de39ffed7("fontWeight", $0e2b710fed9581ac$export$855cfd311192d666);
var $0e2b710fed9581ac$export$ff257d957d48c421 = $0e2b710fed9581ac$export$ca0f9c2de39ffed7((0, $ayHI4.CURRENT_SURFACE_CSS_VAR), $0e2b710fed9581ac$export$41a358c9c2356760);
var $0e2b710fed9581ac$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $0e2b710fed9581ac$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("ayHI4", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $7afefc3334a294e4$export$9d7b58831ae93caa; });
var $7afefc3334a294e4$export$4ef52930e33717cd = "data-theme";
var $7afefc3334a294e4$export$a00eac3f8684bcd0 = "data-color-mode";
var $7afefc3334a294e4$export$2112803007239c61 = "data-contrast-mode";
var $7afefc3334a294e4$export$352e418ed5b6193a = "data-custom-theme";
var $7afefc3334a294e4$export$6f0c6fb8c80fcc92 = "ds";
var $7afefc3334a294e4$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $7afefc3334a294e4$export$dddac1532e822863 = "--".concat($7afefc3334a294e4$export$6f0c6fb8c80fcc92, "-token-not-found");
var $7afefc3334a294e4$export$9d7b58831ae93caa = "--".concat($7afefc3334a294e4$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});



parcelRegister("g2DEO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $badb985eeee83dcd$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $1dqlv = parcelRequire("1dqlv");

var $jAMCU = parcelRequire("jAMCU");
var $badb985eeee83dcd$var$justifyContentMap = {
    start: (0, $2ZUkg.css)({
        justifyContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyContent: "stretch"
    })
};
var $badb985eeee83dcd$var$flexDirectionMap = {
    column: (0, $2ZUkg.css)({
        flexDirection: "column"
    }),
    row: (0, $2ZUkg.css)({
        flexDirection: "row"
    })
};
var $badb985eeee83dcd$var$flexWrapMap = {
    wrap: (0, $2ZUkg.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $2ZUkg.css)({
        flexWrap: "nowrap"
    })
};
var $badb985eeee83dcd$var$alignItemsMap = {
    start: (0, $2ZUkg.css)({
        alignItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignItems: "center"
    }),
    baseline: (0, $2ZUkg.css)({
        alignItems: "baseline"
    }),
    end: (0, $2ZUkg.css)({
        alignItems: "end"
    }),
    stretch: (0, $2ZUkg.css)({
        alignItems: "stretch"
    })
};
var $badb985eeee83dcd$var$baseStyles = (0, $2ZUkg.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $badb985eeee83dcd$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $jAMCU.parseXcss)(xcss);
    return (0, $2ZUkg.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $badb985eeee83dcd$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $1dqlv.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $1dqlv.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $1dqlv.spaceStylesMap).rowGap[rowGap],
            alignItems && $badb985eeee83dcd$var$alignItemsMap[alignItems],
            direction && $badb985eeee83dcd$var$flexDirectionMap[direction],
            justifyContent && $badb985eeee83dcd$var$justifyContentMap[justifyContent],
            wrap && $badb985eeee83dcd$var$flexWrapMap[wrap],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$badb985eeee83dcd$var$Flex.displayName = "Flex";
var $badb985eeee83dcd$export$2e2bcd8739ae039 = $badb985eeee83dcd$var$Flex;

});


parcelRegister("3owl2", function(module, exports) {

$parcel$export(module.exports, "CustomerNameAndLogoHeader", function () { return (parcelRequire("cJaOz")).CustomerNameAndLogoHeader; });
parcelRequire("eKcEX");
var $cJaOz = parcelRequire("cJaOz");

});
parcelRegister("eKcEX", function(module, exports) {

$parcel$export(module.exports, "CustomerNameAndLogoHeader", function () { return (parcelRequire("cJaOz")).CustomerNameAndLogoHeader; });

var $cJaOz = parcelRequire("cJaOz");

});
parcelRegister("cJaOz", function(module, exports) {

$parcel$export(module.exports, "CustomerNameAndLogoHeader", function () { return $ea709b5c296cdce4$export$300e39a32dd2a6cf; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $gf1F9 = parcelRequire("gf1F9");

var $7akU3 = parcelRequire("7akU3");

var $g2OHD = parcelRequire("g2OHD");

var $bhreu = parcelRequire("bhreu");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");

var $hAe1a = parcelRequire("hAe1a");
const $ea709b5c296cdce4$var$CustomerLogo = ()=>{
    const intl = (0, $f6qj2.default)();
    const { data: customerDomain } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomain);
    // placeholder if no logo is available
    if (!(customerDomain === null || customerDomain === void 0 ? void 0 : customerDomain.customerLogoUrl)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), {
        height: "20px",
        width: "20px",
        borderRadius: "4px"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: (customerDomain === null || customerDomain === void 0 ? void 0 : customerDomain.customerLogoUrl) || "",
            alt: intl.formatMessage((0, $hAe1a.messages).logoAltText, {
                name: customerDomain === null || customerDomain === void 0 ? void 0 : customerDomain.customerName
            })
        },
        style: {
            width: "20px",
            height: "20px",
            borderRadius: "4px"
        }
    });
};
const $ea709b5c296cdce4$export$300e39a32dd2a6cf = ()=>{
    const { data: customerDomain, pending: customerDomainPending } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomain);
    if (customerDomainPending) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), {
                height: "20px",
                width: "20px",
                borderRadius: "4px"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), {
                width: "300px",
                height: "28px"
            })
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($ea709b5c296cdce4$var$CustomerLogo, {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                size: "large",
                children: customerDomain === null || customerDomain === void 0 ? void 0 : customerDomain.customerName
            })
        ]
    });
};

});
parcelRegister("7akU3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5379ae7daa4a96f0$export$2e2bcd8739ae039; });

var $1XRzW = parcelRequire("1XRzW");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jAMCU = parcelRequire("jAMCU");

var $g2DEO = parcelRequire("g2DEO");
var $5379ae7daa4a96f0$var$flexGrowMap = {
    hug: (0, $jAMCU.xcss)({
        flexGrow: 0
    }),
    fill: (0, $jAMCU.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $5379ae7daa4a96f0$var$separatorStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $5379ae7daa4a96f0$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $2ZUkg.jsx)("span", {
        css: $5379ae7daa4a96f0$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $5379ae7daa4a96f0$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $2ZUkg.jsx)($5379ae7daa4a96f0$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $5379ae7daa4a96f0$var$flexGrowMap[grow]
    ].concat((0, $1XRzW.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $2ZUkg.jsx)((0, $g2DEO.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$5379ae7daa4a96f0$var$Inline.displayName = "Inline";
var $5379ae7daa4a96f0$export$2e2bcd8739ae039 = $5379ae7daa4a96f0$var$Inline;

});

parcelRegister("7zqwM", function(module, exports) {
$parcel$export(module.exports, "getCustomerDomains", function () { return (parcelRequire("k0rCZ")).getCustomerDomains; });
$parcel$export(module.exports, "getFastshiftSupportRequests", function () { return (parcelRequire("k0rCZ")).getFastshiftSupportRequests; });
$parcel$export(module.exports, "setMigrationStatusTableControls", function () { return (parcelRequire("k0rCZ")).setMigrationStatusTableControls; });
$parcel$export(module.exports, "setSelectionTableControls", function () { return (parcelRequire("k0rCZ")).setSelectionTableControls; });
$parcel$export(module.exports, "DROPDOWN_ORG_ID", function () { return (parcelRequire("k4eOf")).DROPDOWN_ORG_ID; });
$parcel$export(module.exports, "NO_ORG_ID", function () { return (parcelRequire("k4eOf")).NO_ORG_ID; });
$parcel$export(module.exports, "useFastshiftDispatch", function () { return (parcelRequire("8KnwD")).useFastshiftDispatch; });
$parcel$export(module.exports, "useFastshiftSelector", function () { return (parcelRequire("8KnwD")).useFastshiftSelector; });
parcelRequire("k0rCZ");
parcelRequire("4lm9l");
parcelRequire("k4eOf");
parcelRequire("8KnwD");
parcelRequire("1LBjK");

});
parcelRegister("k0rCZ", function(module, exports) {

$parcel$export(module.exports, "setSelectedOrg", function () { return $871c0bb6590230bd$export$cd3edf940e33def3; });
$parcel$export(module.exports, "setSelectedDomainOrg", function () { return $871c0bb6590230bd$export$3d74855dfc7f881a; });
$parcel$export(module.exports, "getAccountOrgs", function () { return $871c0bb6590230bd$export$2644c4f3d6e7a492; });
$parcel$export(module.exports, "getAvailableProducts", function () { return $871c0bb6590230bd$export$bfcb57024ef3c3d; });
$parcel$export(module.exports, "getOrgServers", function () { return $871c0bb6590230bd$export$50c29419620a3e01; });
$parcel$export(module.exports, "getMigrationPlanTotals", function () { return $871c0bb6590230bd$export$ce2694aa86fc4617; });
$parcel$export(module.exports, "getL1Assessments", function () { return $871c0bb6590230bd$export$6a6875ffc42cb856; });
$parcel$export(module.exports, "getAllCustomerSupportRequests", function () { return $871c0bb6590230bd$export$f6d72bd88cc2b16f; });
$parcel$export(module.exports, "setResetCustomerSupportRequests", function () { return $871c0bb6590230bd$export$636a8752f16dfaff; });
$parcel$export(module.exports, "getInstances", function () { return $871c0bb6590230bd$export$506de6e030509e20; });
$parcel$export(module.exports, "getCustomerDomains", function () { return $871c0bb6590230bd$export$d64b3effe75ee91f; });
$parcel$export(module.exports, "getCustomerDomain", function () { return $871c0bb6590230bd$export$b5a74c1474416dd5; });
$parcel$export(module.exports, "getCustomerDomainEngagementDetails", function () { return $871c0bb6590230bd$export$e4e0db0484cb8896; });
$parcel$export(module.exports, "clearAllCustomerDomainScopedState", function () { return $871c0bb6590230bd$export$2dc587c028191d7c; });
$parcel$export(module.exports, "clearCustomerDomain", function () { return $871c0bb6590230bd$export$ef74ea2676036a4e; });
$parcel$export(module.exports, "getUserDetails", function () { return $871c0bb6590230bd$export$714d3544202969b; });
$parcel$export(module.exports, "getFastshiftSupportRequests", function () { return $871c0bb6590230bd$export$621cdc89556e1418; });
$parcel$export(module.exports, "setSelectionTableControls", function () { return $871c0bb6590230bd$export$f0f7449d51467749; });
$parcel$export(module.exports, "setMigrationStatusTableControls", function () { return $871c0bb6590230bd$export$cdbe09e5383e450a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $4m2lj = parcelRequire("4m2lj");

var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");

var $dO2cs = parcelRequire("dO2cs");

var $fUSY4 = parcelRequire("fUSY4");

var $6YCV2 = parcelRequire("6YCV2");

var $48WnD = parcelRequire("48WnD");
const $871c0bb6590230bd$var$appEnvironment = "production";
var $871c0bb6590230bd$export$b52183d5cfb26dc9;
(function(Actions) {
    Actions["GET_USER_DETAILS"] = "[FASTSHIFT] GET_USER_DETAILS";
    Actions["GET_CUSTOMER_DOMAINS"] = "[FASTSHIFT] GET_CUSTOMER_DOMAINS";
    Actions["SET_SELECTED_ORG"] = "[FASTSHIFT] SET_SELECTED_ORG";
    Actions["SET_SELECTED_DOMAIN_ORG"] = "[FASTSHIFT] SET_SELECTED_DOMAIN_ORG";
    Actions["GET_ACCOUNT_ORGS"] = "[FASTSHIFT] GET_ACCOUNT_ORGS";
    Actions["GET_ORG_SERVERS"] = "[FASTSHIFT] GET_ORG_SERVERS";
    Actions["GET_MIGRATION_PLANS"] = "[FASTSHIFT] GET_MIGRATION_PLANS";
    Actions["GET_MIGRATION_PLAN_TOTALS"] = "[FASTSHIFT] GET_MIGRATION_PLAN_TOTALS";
    Actions["GET_AVAILABLE_PRODUCTS"] = "[FASTSHIFT] GET_AVAILABLE_PRODUCTS";
    Actions["GET_L1_ASSESSMENTS"] = "[FASTSHIFT] GET_L1_ASSESSMENTS";
    Actions["GET_ALL_CUSTOMER_SUPPORT_REQUESTS"] = "[FASTSHIFT] GET_ALL_CUSTOMER_SUPPORT_REQUESTS";
    Actions["SET_RESET_CUSTOMER_SUPPORT_REQUESTS"] = "[FASTSHIFT] SET_RESET_CUSTOMER_SUPPORT_REQUESTS";
    Actions["GET_INSTANCES"] = "[FASTSHIFT] GET_INSTANCES";
    Actions["GET_CUSTOMER_DOMAIN"] = "[FASTSHIFT] GET_CUSTOMER_DOMAIN";
    Actions["GET_CUSTOMER_DOMAIN_ENGAGEMENT_DETAILS"] = "[FASTSHIFT] GET_CUSTOMER_DOMAIN_ENGAGEMENT_DETAILS";
    Actions["CLEAR_ALL_CUSTOMER_DOMAIN_SCOPED_STATE"] = "[FASTSHIFT] CLEAR_ALL_CUSTOMER_DOMAIN_SCOPED_STATE";
    Actions["CLEAR_CUSTOMER_DOMAIN"] = "[FASTSHIFT] CLEAR_CUSTOMER_DOMAIN";
    Actions["GET_USER_TYPE"] = "[FASTSHIFT] GET_USER_TYPE";
    Actions["GET_FASTSHIFT_SUPPORT_REQUESTS"] = "[FASTSHIFT] GET_FASTSHIFT_SUPPORT_REQUESTS";
    Actions["SET_SELECTION_TABLE_CONTROLS"] = "[FASTSHIFT] SET_SELECTION_TABLE_CONTROLS";
    Actions["SET_MIGRATION_STATUS_TABLE_CONTROLS"] = "[FASTSHIFT] SET_MIGRATION_STATUS_TABLE_CONTROLS";
})($871c0bb6590230bd$export$b52183d5cfb26dc9 || ($871c0bb6590230bd$export$b52183d5cfb26dc9 = {}));
const $871c0bb6590230bd$export$cd3edf940e33def3 = (0, $4m2lj.createAction)("[FASTSHIFT] SET_SELECTED_ORG");
const $871c0bb6590230bd$export$3d74855dfc7f881a = (0, $4m2lj.createAction)("[FASTSHIFT] SET_SELECTED_DOMAIN_ORG");
const $871c0bb6590230bd$export$2644c4f3d6e7a492 = (0, $4m2lj.createAsyncThunk)("[FASTSHIFT] GET_ACCOUNT_ORGS", async (stargateClient)=>{
    const response = await stargateClient.getAccountOrgs({});
    const responseAdminhub = await stargateClient.getAdminhubAccountOrgs({});
    return (0, $48WnD.filterForActiveOrgs)(response === null || response === void 0 ? void 0 : response.accountOrgs, responseAdminhub === null || responseAdminhub === void 0 ? void 0 : responseAdminhub.accountOrgs);
});
const $871c0bb6590230bd$export$bfcb57024ef3c3d = (0, $4m2lj.createAsyncThunk)("[FASTSHIFT] GET_AVAILABLE_PRODUCTS", async (stargateClient)=>{
    const response = await stargateClient.getAvailableSitesForFastshift({});
    return (0, $48WnD.transformAvailableProductsToCloudSitesByOrg)(response);
});
const $871c0bb6590230bd$export$50c29419620a3e01 = (0, $4m2lj.createAsyncThunk)("[FASTSHIFT] GET_ORG_SERVERS", async ({ stargateClient: stargateClient, orgId: orgId })=>{
    const response = await stargateClient.getOrgServers({
        orgId: orgId
    });
    return response;
});
const $871c0bb6590230bd$export$ce2694aa86fc4617 = (0, $4m2lj.createAsyncThunk)("[FASTSHIFT] GET_MIGRATION_PLAN_TOTALS", async ({ stargateClient: stargateClient, orgId: orgId })=>{
    const response = await stargateClient.getMigrationPlanTotals({
        orgId: orgId
    });
    return response;
});
const $871c0bb6590230bd$export$6a6875ffc42cb856 = (0, $4m2lj.createAsyncThunk)("[FASTSHIFT] GET_L1_ASSESSMENTS", async ({ stargateClient: stargateClient, orgId: orgId })=>{
    const response = await stargateClient.getL1Assessments({
        orgId: orgId
    });
    return response;
});
const $871c0bb6590230bd$export$f6d72bd88cc2b16f = (0, $4m2lj.createAsyncThunk)("[FASTSHIFT] GET_ALL_CUSTOMER_SUPPORT_REQUESTS", async (stargateClient)=>{
    var _firstPageResponse_errors;
    const PAGE_SIZE = 50;
    let firstPageResponse = null;
    try {
        firstPageResponse = await (0, $6YCV2.getCustomerSupportRequestsQuery)({
            stargateClient: stargateClient,
            page: 1,
            size: PAGE_SIZE
        });
    } catch (error) {
        console.error("Error fetching customer support requests", error);
        (0, $dO2cs.sendFastshiftSentryAlert)("Error on fetching customer support requests");
        throw new Error(`Error fetching customer support requests: ${error}`);
    }
    if (((_firstPageResponse_errors = firstPageResponse.errors) === null || _firstPageResponse_errors === void 0 ? void 0 : _firstPageResponse_errors.length) > 0) throw new Error(`Error fetching customer support requests: ${firstPageResponse.errors.map((error)=>error.message).join(", ")}`);
    const total = firstPageResponse.data.customerSupport.me.requests.total;
    const totalPages = Math.ceil(total / PAGE_SIZE);
    const requests = [
        ...firstPageResponse.data.customerSupport.me.requests.page.map((request)=>(0, $6iHNw._)((0, $7Knp0._)({}, request), {
                id: request.id.replace("GSAC-", "")
            }))
    ];
    if (totalPages < 1) return {
        requests: requests
    };
    // Set this to series to avoid rate limiting issues, to improve performance we can create an array of promises and resolve all
    const pages = new Array(totalPages - 1).fill(0).map((_, i)=>i + 2);
    for (const page of pages){
        var _firstPageResponse_errors1;
        let pageResponse = null;
        try {
            pageResponse = await (0, $6YCV2.getCustomerSupportRequestsQuery)({
                stargateClient: stargateClient,
                page: page,
                size: PAGE_SIZE
            });
        } catch (error) {
            console.error("Error fetching customer support requests", error);
            throw new Error("Error fetching customer support requests");
        }
        if (((_firstPageResponse_errors1 = firstPageResponse.errors) === null || _firstPageResponse_errors1 === void 0 ? void 0 : _firstPageResponse_errors1.length) > 0) throw new Error("Error fetching customer support requests");
        const pageRequests = pageResponse.data.customerSupport.me.requests.page.map((request)=>(0, $6iHNw._)((0, $7Knp0._)({}, request), {
                id: request.id.replace("GSAC-", "")
            }));
        requests.push(...pageRequests);
    }
    return {
        requests: requests
    };
});
const $871c0bb6590230bd$export$636a8752f16dfaff = (0, $4m2lj.createAction)("[FASTSHIFT] SET_RESET_CUSTOMER_SUPPORT_REQUESTS");
const $871c0bb6590230bd$export$506de6e030509e20 = (0, $4m2lj.createAsyncThunk)("[FASTSHIFT] GET_INSTANCES", async ({ stargateClient: stargateClient, orgId: orgId })=>{
    const response = await stargateClient.getInstances({
        orgId: orgId
    });
    return response;
});
const $871c0bb6590230bd$export$d64b3effe75ee91f = (0, $4m2lj.createAsyncThunk)("[FASTSHIFT] GET_CUSTOMER_DOMAINS", async ({ stargateClient: stargateClient, controls: controls })=>{
    const response = await stargateClient.getFastshiftCustomerDomains((0, $7Knp0._)({}, controls));
    return response;
});
const $871c0bb6590230bd$export$b5a74c1474416dd5 = (0, $4m2lj.createAsyncThunk)("[FASTSHIFT] GET_CUSTOMER_DOMAIN", async ({ stargateClient: stargateClient, customerDomainId: customerDomainId })=>{
    const response = await stargateClient.getFastshiftCustomerDomain({
        customerDomainId: customerDomainId
    });
    return response.data;
});
const $871c0bb6590230bd$export$e4e0db0484cb8896 = (0, $4m2lj.createAsyncThunk)("[FASTSHIFT] GET_CUSTOMER_DOMAIN_ENGAGEMENT_DETAILS", async ({ stargateClient: stargateClient, customerDomainId: customerDomainId })=>{
    // temporary: for smart link validation in prod
    const isProductionEngagementCallEnabled = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).sxpFastshiftPortalEnableEngagementCallInProduction);
    if ($871c0bb6590230bd$var$appEnvironment === "production" && !isProductionEngagementCallEnabled) return 0, $fUSY4.mockCustomerDomainEngagementProductionLinks;
    const response = await stargateClient.getFastshiftCustomerDomainEngagement({
        customerDomainId: customerDomainId
    });
    return response.data;
});
const $871c0bb6590230bd$export$2dc587c028191d7c = (0, $4m2lj.createAction)("[FASTSHIFT] CLEAR_ALL_CUSTOMER_DOMAIN_SCOPED_STATE");
const $871c0bb6590230bd$export$ef74ea2676036a4e = (0, $4m2lj.createAction)("[FASTSHIFT] CLEAR_CUSTOMER_DOMAIN");
const $871c0bb6590230bd$export$714d3544202969b = (0, $4m2lj.createAsyncThunk)("[FASTSHIFT] GET_USER_DETAILS", async (stargateClient)=>{
    const response = await stargateClient.getFastshiftUser({});
    return response.data;
});
const $871c0bb6590230bd$export$621cdc89556e1418 = (0, $4m2lj.createAsyncThunk)("[FASTSHIFT] GET_FASTSHIFT_SUPPORT_REQUESTS", async ({ stargateClient: stargateClient, customerDomainId: customerDomainId, orgId: orgId, permissionLevel: permissionLevel })=>{
    const response = await stargateClient.getFastshiftSupportRequests({
        customerDomainId: customerDomainId,
        orgId: orgId,
        permissionLevel: permissionLevel
    });
    return response;
});
const $871c0bb6590230bd$export$f0f7449d51467749 = (0, $4m2lj.createAction)("[FASTSHIFT] SET_SELECTION_TABLE_CONTROLS");
const $871c0bb6590230bd$export$cdbe09e5383e450a = (0, $4m2lj.createAction)("[FASTSHIFT] SET_MIGRATION_STATUS_TABLE_CONTROLS");

});
parcelRegister("fUSY4", function(module, exports) {

$parcel$export(module.exports, "mockCustomerDomainEngagementProductionLinks", function () { return $0acf19dcd78bac34$export$d09bc7f9d0ad7a31; });
// this mock was separated from mocks.ts to avoid a circular dependency.
// actions -> mocks -> fastshift-table -> analytics hooks -> state reducer -> actions
// once actions.tsx no longer consumes this mock, this file can be merged back into mocks.ts
const $0acf19dcd78bac34$export$d09bc7f9d0ad7a31 = {
    engagementProjects: [
        {
            projectName: "SXP",
            projectIcon: "https://hello.atlassian.net/rest/api/2/universal_avatar/view/type/project/avatar/35308",
            projectKey: "SXP",
            projectUrl: "https://hello.atlassian.net/browse/SXP",
            // this doesn't work
            boards: [
                {
                    boardName: "SXP Scrum",
                    boardId: "9225",
                    embeds: [
                        {
                            url: "https://hello.jira.atlassian.cloud/jira/software/c/projects/SXP/boards/9225/timeline",
                            type: "TIMELINE"
                        },
                        {
                            url: "https://hello.jira.atlassian.cloud/jira/software/c/projects/SXP/boards/9225/calendar",
                            type: "CALENDAR"
                        }
                    ]
                },
                {
                    boardName: "SXP Kanban",
                    boardId: "15730",
                    embeds: [
                        {
                            url: "https://hello.jira.atlassian.cloud/jira/software/c/projects/SXP/boards/15730/timeline",
                            type: "TIMELINE"
                        },
                        {
                            url: "https://hello.jira.atlassian.cloud/jira/software/c/projects/SXP/boards/15730/calendar",
                            type: "CALENDAR"
                        }
                    ]
                }
            ]
        },
        {
            projectName: "Engagement",
            projectIcon: "https://as-a-team.atlassian.net/rest/api/2/universal_avatar/view/type/project/avatar/12409?size=xlarge",
            projectKey: "ENGAGE",
            projectUrl: "https://as-a-team.atlassian.net/browse/ENGAGE",
            // this does work
            boards: [
                {
                    boardName: "Engagement",
                    boardId: "mock-board-id-2",
                    embeds: [
                        {
                            url: "https://as-a-team.atlassian.net/jira/core/projects/ENGAGE/timeline",
                            type: "TIMELINE"
                        },
                        {
                            url: "https://as-a-team.atlassian.net/jira/core/projects/ENGAGE/calendar",
                            type: "CALENDAR"
                        }
                    ]
                }
            ]
        },
        {
            // as-a-team live
            projectName: "Accenture",
            projectIcon: "https://as-a-team.atlassian.net/rest/api/2/universal_avatar/view/type/project/avatar/12421",
            projectKey: "ACNCIO",
            projectUrl: "https://as-a-team.atlassian.net/browse/ACNCIO",
            boards: [
                {
                    boardName: "ACNCIO Board",
                    boardId: "mock-board-id-3",
                    embeds: [
                        {
                            url: "https://as-a-team.atlassian.net/jira/software/c/projects/ACNCIO/boards/607/timeline",
                            type: "TIMELINE"
                        },
                        {
                            url: "https://as-a-team.atlassian.net/jira/software/c/projects/ACNCIO/boards/607/calendar",
                            type: "CALENDAR"
                        }
                    ]
                }
            ]
        },
        {
            // advanced roadmap
            projectName: "Sandisk FS Migration timeline",
            projectIcon: "",
            // there is no icon
            projectKey: "894",
            // no id, just number
            projectUrl: "https://as-a-team.atlassian.net/jira/plans/894/scenarios/895/summary",
            boards: [
                {
                    boardName: "Sandisk FS Migration timeline",
                    boardId: "mock-board-id-999",
                    embeds: [
                        {
                            url: "https://as-a-team.atlassian.net/jira/plans/894/scenarios/895/timeline?vid=1160",
                            type: "TIMELINE"
                        },
                        {
                            url: "https://as-a-team.atlassian.net/jira/plans/894/scenarios/895/calendar",
                            type: "CALENDAR"
                        }
                    ]
                }
            ]
        }
    ],
    engagementSpaces: [
        {
            spaceKey: "ACCENTURE",
            spaceUrl: "https://as-a-team.atlassian.net/wiki/spaces/ACCENTURE/overview"
        }
    ]
};

});

parcelRegister("6YCV2", function(module, exports) {

$parcel$export(module.exports, "getCustomerSupportRequestsQuery", function () { return $800dfac53b0e21b6$export$69f19449f9eaa775; });
const $800dfac53b0e21b6$export$69f19449f9eaa775 = async ({ stargateClient: stargateClient, page: page, size: size })=>{
    const offset = (page - 1) * size;
    const query = `
        query GetCustomerSupportRequests(
            $size: Int!
            $offset: Int!
        ) {
            customerSupport {
                me {
                    requests(project: "MOVE", size: $size, offset: $offset) {
                        total
                        page {
                            summary
                            description
                            status {
                                category
                                text
                            }
                            id
                            atlassianCloudUrl
                            planToMigrate
                            destinationLicense
                            sourceLicense
                            migrationProducts
                            migrationPhase
                        }
                    }
                }
            }
        }
    `;
    return await stargateClient.getCspGraphqlRequest({
        request: JSON.stringify({
            query: query,
            variables: {
                size: size,
                offset: offset
            }
        })
    });
};

});

parcelRegister("48WnD", function(module, exports) {

$parcel$export(module.exports, "transformAvailableProductsToCloudSitesByOrg", function () { return $47c9f14fedb2ecbc$export$e0a73f8804fdb3cb; });
$parcel$export(module.exports, "filterForActiveOrgs", function () { return $47c9f14fedb2ecbc$export$cf62ac3648a13fac; });
$parcel$export(module.exports, "getUserDomain", function () { return $47c9f14fedb2ecbc$export$e9ebe20ff7f8ff23; });
$parcel$export(module.exports, "captureErrorWithContext", function () { return $47c9f14fedb2ecbc$export$33d62652bf76a4d1; });

var $hW0KP = parcelRequire("hW0KP");

var $blvPD = parcelRequire("blvPD");
const $47c9f14fedb2ecbc$var$parseBaseUrlFromContinueUrl = (continueUrl)=>{
    return `https://${continueUrl.split("continue=https%3A%2F%2F")[1]}` || "";
};
const $47c9f14fedb2ecbc$export$e0a73f8804fdb3cb = (availableProducts)=>{
    const adminProducts = availableProducts.sites.filter((site)=>site.adminAccess);
    const cloudSitesByOrg = [];
    adminProducts.forEach((product)=>{
        const siteDetails = {
            displayName: product.displayName,
            baseUrl: $47c9f14fedb2ecbc$var$parseBaseUrlFromContinueUrl(product.url),
            cloudId: product.cloudId || ""
        };
        const org = product.org;
        if (org) {
            const seenOrg = cloudSitesByOrg.find((orgObject)=>orgObject.orgId === org.id);
            if (seenOrg) seenOrg.cloudSites.push(siteDetails);
            else cloudSitesByOrg.push({
                orgId: org.id,
                orgName: org.displayName,
                cloudSites: [
                    siteDetails
                ]
            });
        }
    });
    return cloudSitesByOrg;
};
const $47c9f14fedb2ecbc$export$cf62ac3648a13fac = (accountOrgs, adminhubAccountOrgs)=>{
    if (!accountOrgs || !adminhubAccountOrgs) return [];
    const mergedAccountOrgs = accountOrgs.filter((org)=>{
        return adminhubAccountOrgs === null || adminhubAccountOrgs === void 0 ? void 0 : adminhubAccountOrgs.find((adminhubOrg)=>adminhubOrg.id === org.id);
    });
    return mergedAccountOrgs;
};
const $47c9f14fedb2ecbc$export$e9ebe20ff7f8ff23 = (state)=>{
    var _state_userDetails_data_userDomain, _state_userDetails_data;
    return (_state_userDetails_data = state.userDetails.data) === null || _state_userDetails_data === void 0 ? void 0 : (_state_userDetails_data_userDomain = _state_userDetails_data.userDomain) === null || _state_userDetails_data_userDomain === void 0 ? void 0 : _state_userDetails_data_userDomain.domain;
};
const $47c9f14fedb2ecbc$export$33d62652bf76a4d1 = ({ error: error, message: message, userDomain: userDomain })=>{
    $hW0KP.captureException(new Error(error), {
        tags: {
            projectName: (0, $blvPD.SENTRY_PROJECT_NAME)
        },
        extra: {
            errorMessage: message,
            userDomain: userDomain || ""
        }
    });
};

});
parcelRegister("blvPD", function(module, exports) {

$parcel$export(module.exports, "SENTRY_PROJECT_NAME", function () { return $d7a989023edcb01f$export$4180ed4389ea0efb; });
const $d7a989023edcb01f$export$4180ed4389ea0efb = "FASTSHIFT_PORTAL";

});



parcelRegister("4lm9l", function(module, exports) {

$parcel$export(module.exports, "initialState", function () { return $0658b4aca3909f69$export$d4c72bab9d6cc13a; });
$parcel$export(module.exports, "reducer", function () { return $0658b4aca3909f69$export$1650419e431d3ba3; });

var $4m2lj = parcelRequire("4m2lj");

var $cDmHV = parcelRequire("cDmHV");

var $k0rCZ = parcelRequire("k0rCZ");

var $k4eOf = parcelRequire("k4eOf");
parcelRequire("gEaRO");
var $gkhN4 = parcelRequire("gkhN4");
var $gEaRO = parcelRequire("gEaRO");

var $48WnD = parcelRequire("48WnD");
const $0658b4aca3909f69$export$d4c72bab9d6cc13a = {
    userDetails: {
        pending: false,
        data: null,
        error: null
    },
    selectedOrg: null,
    selectedDomainOrg: null,
    orgs: {
        pending: false,
        data: [],
        error: null
    },
    orgServers: {
        pending: false,
        data: [],
        error: null
    },
    cloudSitesByOrg: {
        pending: false,
        data: [],
        error: null
    },
    migrationPlanTotals: {
        pending: false,
        data: {
            totalPlansCompleted: 0,
            totalPlansUnsuccessful: 0,
            totalPlansRunning: 0
        },
        error: null
    },
    l1Assessments: {
        pending: false,
        data: [],
        error: null
    },
    customerSupportRequests: {
        pending: false,
        error: null,
        data: []
    },
    instances: {
        pending: false,
        data: {
            instances: [],
            totalCount: 0
        },
        error: null
    },
    customerDomain: {
        pending: false,
        error: null,
        data: null
    },
    customerDomainEngagement: {
        pending: false,
        error: null,
        data: null
    },
    // states for partner and fastshift team roles only:
    customerDomains: {
        pending: false,
        error: null,
        data: {
            data: [],
            pagination: {
                page: 0,
                size: 20,
                totalElements: 0,
                totalPages: 0,
                hasNext: false,
                hasPrevious: false,
                sorted: false
            }
        }
    },
    supportRequests: {
        pending: false,
        error: null,
        data: []
    },
    pageStateCache: {
        selectionTableControls: (0, $cDmHV.DEFAULT_CONTROLS_PAYLOAD),
        migrationStatusTableControls: (0, $cDmHV.DEFAULT_CONTROLS_PAYLOAD)
    }
};
const $0658b4aca3909f69$export$cbf0ecd8bd2735d8 = {
    id: (0, $k4eOf.NO_ORG_ID),
    isAdmin: true,
    name: "No Org" // do not display this name to customers
};
const $0658b4aca3909f69$export$1650419e431d3ba3 = (state = $0658b4aca3909f69$export$d4c72bab9d6cc13a)=>(0, $4m2lj.createReducer)(state, (builder)=>{
        builder.addCase($k0rCZ.setSelectedOrg, (state, { payload: payload })=>{
            state.selectedOrg = payload;
            // save selected org to localstorage
            localStorage.setItem((0, $k4eOf.FASTSHIFT_LOCALSTORAGE_KEYS).SELECTED_ORG_ID, JSON.stringify(payload.id));
        }).addCase($k0rCZ.setSelectedDomainOrg, (state, { payload: payload })=>{
            state.selectedDomainOrg = payload;
        }).addCase($k0rCZ.getAccountOrgs.fulfilled, (state, { payload: payload })=>{
            state.orgs.pending = false;
            var _payload_reduce;
            // filter out orgs where user is not an admin
            const orgsList = (_payload_reduce = payload === null || payload === void 0 ? void 0 : payload.reduce((acc, { id: id, isAdmin: isAdmin, name: name })=>{
                if (isAdmin) acc.push({
                    id: id,
                    isAdmin: isAdmin,
                    name: name
                });
                return acc;
            }, [])) !== null && _payload_reduce !== void 0 ? _payload_reduce : [];
            state.orgs.data = [
                ...orgsList,
                $0658b4aca3909f69$export$cbf0ecd8bd2735d8
            ];
            state.orgs.error = null;
        }).addCase($k0rCZ.getAccountOrgs.pending, (state)=>{
            state.orgs.pending = true;
            state.orgs.error = null;
        }).addCase($k0rCZ.getAccountOrgs.rejected, (state, action)=>{
            state.orgs.pending = false;
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.orgs.error = message;
            (0, $48WnD.captureErrorWithContext)({
                error: "Error on fetching account orgs",
                message: message,
                userDomain: (0, $48WnD.getUserDomain)(state)
            });
        }).addCase($k0rCZ.getOrgServers.fulfilled, (state, { payload: payload })=>{
            state.orgServers.pending = false;
            state.orgServers.data = payload.data;
            state.orgServers.error = null;
        }).addCase($k0rCZ.getOrgServers.pending, (state)=>{
            state.orgServers.pending = true;
            state.orgServers.error = null;
        }).addCase($k0rCZ.getOrgServers.rejected, (state, action)=>{
            state.orgServers.pending = false;
            state.orgServers.data = [];
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.orgServers.error = message;
            (0, $48WnD.captureErrorWithContext)({
                error: "Error on fetching org servers",
                message: message,
                userDomain: (0, $48WnD.getUserDomain)(state)
            });
        }).addCase($k0rCZ.getAvailableProducts.pending, (state)=>{
            state.cloudSitesByOrg.pending = true;
            state.cloudSitesByOrg.error = null;
            state.cloudSitesByOrg.data = [];
        }).addCase($k0rCZ.getAvailableProducts.fulfilled, (state, { payload: payload })=>{
            state.cloudSitesByOrg.pending = false;
            state.cloudSitesByOrg.data = payload;
            state.cloudSitesByOrg.error = null;
        }).addCase($k0rCZ.getAvailableProducts.rejected, (state, action)=>{
            state.cloudSitesByOrg.pending = false;
            state.cloudSitesByOrg.data = [];
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.cloudSitesByOrg.error = message;
            (0, $48WnD.captureErrorWithContext)({
                error: "Error on fetching available products",
                message: message,
                userDomain: (0, $48WnD.getUserDomain)(state)
            });
        }).addCase($k0rCZ.getMigrationPlanTotals.fulfilled, (state, { payload: payload })=>{
            state.migrationPlanTotals.pending = false;
            state.migrationPlanTotals.data = payload;
            state.migrationPlanTotals.error = null;
        }).addCase($k0rCZ.getMigrationPlanTotals.pending, (state)=>{
            state.migrationPlanTotals.pending = true;
            state.migrationPlanTotals.error = null;
        }).addCase($k0rCZ.getMigrationPlanTotals.rejected, (state)=>{
            state.migrationPlanTotals.pending = false;
            state.migrationPlanTotals.data = {
                totalPlansCompleted: 0,
                totalPlansUnsuccessful: 0,
                totalPlansRunning: 0
            };
            const message = "error fetching migration plan totals";
            state.migrationPlanTotals.error = message;
            (0, $48WnD.captureErrorWithContext)({
                error: "Error on fetching migration plan totals",
                message: message,
                userDomain: (0, $48WnD.getUserDomain)(state)
            });
        }).addCase($k0rCZ.getL1Assessments.fulfilled, (state, { payload: payload })=>{
            state.l1Assessments.pending = false;
            state.l1Assessments.data = payload;
            state.l1Assessments.error = null;
        }).addCase($k0rCZ.getL1Assessments.pending, (state)=>{
            state.l1Assessments.pending = true;
            state.l1Assessments.error = null;
        }).addCase($k0rCZ.getL1Assessments.rejected, (state, action)=>{
            state.l1Assessments.pending = false;
            state.l1Assessments.data = [];
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.l1Assessments.error = message;
            (0, $48WnD.captureErrorWithContext)({
                error: "Error on fetching l1 assessments",
                message: message,
                userDomain: (0, $48WnD.getUserDomain)(state)
            });
        }).addCase($k0rCZ.setResetCustomerSupportRequests, (state)=>{
            state.customerSupportRequests.pending = false;
            state.customerSupportRequests.error = null;
            state.customerSupportRequests.data = [];
        }).addCase($k0rCZ.getAllCustomerSupportRequests.pending, (state)=>{
            state.customerSupportRequests.pending = true;
            state.customerSupportRequests.error = null;
        }).addCase($k0rCZ.getAllCustomerSupportRequests.fulfilled, (state, { payload: payload })=>{
            state.customerSupportRequests.pending = false;
            state.customerSupportRequests.data = payload.requests;
            state.customerSupportRequests.error = null;
        }).addCase($k0rCZ.getAllCustomerSupportRequests.rejected, (state, action)=>{
            state.customerSupportRequests.pending = false;
            state.customerSupportRequests.data = [];
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.customerSupportRequests.error = message;
            (0, $48WnD.captureErrorWithContext)({
                error: "Error on fetching customer support requests",
                message: message,
                userDomain: (0, $48WnD.getUserDomain)(state)
            });
        }).addCase($k0rCZ.getInstances.fulfilled, (state, { payload: payload })=>{
            state.instances.pending = false;
            state.instances.data.instances = payload.instances;
            state.instances.data.totalCount = payload.totalCount;
            state.instances.error = null;
        }).addCase($k0rCZ.getInstances.pending, (state)=>{
            state.instances.pending = true;
            state.instances.error = null;
        }).addCase($k0rCZ.getInstances.rejected, (state, action)=>{
            state.instances.pending = false;
            state.instances.data = {
                instances: [],
                totalCount: 0
            };
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.instances.error = message;
            (0, $48WnD.captureErrorWithContext)({
                error: "Error on fetching MMA instances",
                message: message,
                userDomain: (0, $48WnD.getUserDomain)(state)
            });
        }).addCase($k0rCZ.getCustomerDomains.fulfilled, (state, { payload: payload })=>{
            state.customerDomains.pending = false;
            state.customerDomains.data = payload;
            state.customerDomains.error = null;
        }).addCase($k0rCZ.getCustomerDomains.pending, (state)=>{
            state.customerDomains.pending = true;
            state.customerDomains.error = null;
        }).addCase($k0rCZ.getCustomerDomains.rejected, (state, action)=>{
            state.customerDomains.pending = false;
            state.customerDomains.data = {
                data: [],
                pagination: {
                    page: 0,
                    size: 20,
                    totalElements: 0,
                    totalPages: 0,
                    hasNext: false,
                    hasPrevious: false,
                    sorted: false
                }
            };
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.customerDomains.error = message;
            (0, $48WnD.captureErrorWithContext)({
                error: "Error on fetching customer domains list",
                message: message,
                userDomain: (0, $48WnD.getUserDomain)(state)
            });
        }).addCase($k0rCZ.getCustomerDomain.fulfilled, (state, { payload: payload })=>{
            state.customerDomain.pending = false;
            state.customerDomain.data = payload;
            state.customerDomain.error = null;
        }).addCase($k0rCZ.getCustomerDomain.pending, (state)=>{
            state.customerDomain.pending = true;
            state.customerDomain.error = null;
        }).addCase($k0rCZ.getCustomerDomain.rejected, (state, action)=>{
            state.customerDomain.pending = false;
            state.customerDomain.data = null;
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.customerDomain.error = message;
            (0, $48WnD.captureErrorWithContext)({
                error: "Error on fetching customer domain details",
                message: message,
                userDomain: (0, $48WnD.getUserDomain)(state)
            });
        }).addCase($k0rCZ.getCustomerDomainEngagementDetails.fulfilled, (state, { payload: payload })=>{
            state.customerDomainEngagement.pending = false;
            state.customerDomainEngagement.data = payload;
            state.customerDomainEngagement.error = null;
        }).addCase($k0rCZ.getCustomerDomainEngagementDetails.pending, (state)=>{
            state.customerDomainEngagement.pending = true;
            state.customerDomainEngagement.error = null;
        }).addCase($k0rCZ.getCustomerDomainEngagementDetails.rejected, (state, action)=>{
            state.customerDomainEngagement.pending = false;
            state.customerDomainEngagement.data = null;
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.customerDomainEngagement.error = message;
            // check if error is expected
            const isExpectedError = Object.values($gkhN4.CustomerDomainEngagementExpectedError).includes(message);
            // if unexpected, capture on Sentry
            if (!isExpectedError) (0, $48WnD.captureErrorWithContext)({
                error: "Error on fetching customer domain engagement details",
                message: message,
                userDomain: (0, $48WnD.getUserDomain)(state)
            });
        })// Fastshift support requests (M2-specific)
        .addCase($k0rCZ.getFastshiftSupportRequests.pending, (state)=>{
            state.supportRequests.pending = true;
            state.supportRequests.error = null;
            state.supportRequests.data = [];
        }).addCase($k0rCZ.getFastshiftSupportRequests.fulfilled, (state, { payload: payload })=>{
            state.supportRequests.pending = false;
            state.supportRequests.data = payload.data;
            state.supportRequests.error = null;
        }).addCase($k0rCZ.getFastshiftSupportRequests.rejected, (state, action)=>{
            if (action.error.name === $gEaRO.FastshiftApiAbortError) return;
            state.supportRequests.pending = false;
            state.supportRequests.data = [];
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.supportRequests.error = message;
            (0, $48WnD.captureErrorWithContext)({
                error: "Error on fetching support requests",
                message: message,
                userDomain: (0, $48WnD.getUserDomain)(state)
            });
        }).addCase($k0rCZ.clearAllCustomerDomainScopedState, (state)=>{
            state.customerDomain.pending = false;
            state.customerDomain.error = null;
            state.customerDomain.data = null;
            state.customerDomainEngagement.pending = false;
            state.customerDomainEngagement.error = null;
            state.customerDomainEngagement.data = null;
            state.selectedDomainOrg = null;
            state.pageStateCache.migrationStatusTableControls = (0, $cDmHV.DEFAULT_CONTROLS_PAYLOAD);
        }).addCase($k0rCZ.clearCustomerDomain, (state)=>{
            state.customerDomain.pending = false;
            state.customerDomain.data = null;
            state.customerDomain.error = null;
        }).addCase($k0rCZ.setSelectionTableControls, (state, { payload: payload })=>{
            state.pageStateCache.selectionTableControls = payload.selectionTableControls;
        }).addCase($k0rCZ.setMigrationStatusTableControls, (state, { payload: payload })=>{
            state.pageStateCache.migrationStatusTableControls = payload.migrationStatusTableControls;
        }).addCase($k0rCZ.getUserDetails.fulfilled, (state, { payload: payload })=>{
            state.userDetails.pending = false;
            state.userDetails.data = payload;
            state.userDetails.error = null;
        }).addCase($k0rCZ.getUserDetails.pending, (state)=>{
            state.userDetails.pending = true;
            state.userDetails.data = null;
            state.userDetails.error = null;
        }).addCase($k0rCZ.getUserDetails.rejected, (state, action)=>{
            state.userDetails.pending = false;
            state.userDetails.data = null;
            var _action_error_message;
            const message = (_action_error_message = action.error.message) !== null && _action_error_message !== void 0 ? _action_error_message : "unknown error";
            state.userDetails.error = message;
            // check if error is expected
            const isExpectedError = Object.values($gkhN4.FastshiftUserDetailsExpectedError).includes(message);
            // if unexpected, capture on Sentry
            if (!isExpectedError) (0, $48WnD.captureErrorWithContext)({
                error: "Error on fetching user details",
                message: message
            });
        });
    });

});
parcelRegister("cDmHV", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE_OPTIONS", function () { return $5acfa776b4050512$export$a6e06e7d29ab728f; });
$parcel$export(module.exports, "SORT_DIRECTION", function () { return $5acfa776b4050512$export$2e66878530bcbbc7; });
$parcel$export(module.exports, "PAGINATION_DIRECTION", function () { return $5acfa776b4050512$export$fd5e87f1af24bb82; });
$parcel$export(module.exports, "DEFAULT_CONTROLS_PAYLOAD", function () { return $5acfa776b4050512$export$29263a91418b8a52; });
const $5acfa776b4050512$export$a6e06e7d29ab728f = [
    {
        label: "20",
        value: 20
    },
    {
        label: "50",
        value: 50
    },
    {
        label: "100",
        value: 100
    }
];
const $5acfa776b4050512$export$2e66878530bcbbc7 = {
    ASC: "ASC",
    DESC: "DESC"
};
const $5acfa776b4050512$export$fd5e87f1af24bb82 = {
    NEXT: "NEXT",
    PREVIOUS: "PREVIOUS"
};
const $5acfa776b4050512$export$29263a91418b8a52 = {
    page: 0,
    size: $5acfa776b4050512$export$a6e06e7d29ab728f[0].value,
    sortBy: undefined,
    sortDirection: undefined,
    searchTerm: undefined
};

});

parcelRegister("k4eOf", function(module, exports) {

$parcel$export(module.exports, "FASTSHIFT_LOCALSTORAGE_KEYS", function () { return $9d652487cb6c1eb5$export$c800bcb193959663; });
$parcel$export(module.exports, "NO_ORG_ID", function () { return $9d652487cb6c1eb5$export$903575651e1ac5e2; });
$parcel$export(module.exports, "DROPDOWN_ORG_ID", function () { return $9d652487cb6c1eb5$export$2528f09b53619e8d; });
const $9d652487cb6c1eb5$export$c800bcb193959663 = {
    SELECTED_ORG_ID: "fastshift-selected-org"
};
const $9d652487cb6c1eb5$export$903575651e1ac5e2 = "no-org";
var $9d652487cb6c1eb5$export$2528f09b53619e8d;
(function(DROPDOWN_ORG_ID) {
    DROPDOWN_ORG_ID["NO_ORG"] = "no-org";
    DROPDOWN_ORG_ID["OTHER_ORGS"] = "other-orgs";
})($9d652487cb6c1eb5$export$2528f09b53619e8d || ($9d652487cb6c1eb5$export$2528f09b53619e8d = {}));

});

parcelRegister("gEaRO", function(module, exports) {

$parcel$export(module.exports, "FastshiftApiAbortError", function () { return $afd380baa180ce1d$export$4f590d2762a2c291; });
$parcel$export(module.exports, "CustomerDomainEngagementExpectedError", function () { return (parcelRequire("gkhN4")).CustomerDomainEngagementExpectedError; });
$parcel$export(module.exports, "FastshiftUserDetailsExpectedError", function () { return (parcelRequire("gkhN4")).FastshiftUserDetailsExpectedError; });

var $gkhN4 = parcelRequire("gkhN4");
const $afd380baa180ce1d$export$4f590d2762a2c291 = "AbortError";

});


parcelRegister("8KnwD", function(module, exports) {

$parcel$export(module.exports, "useFastshiftDispatch", function () { return $a9443ec81098c5a5$export$671a5d40d73a6cc5; });
$parcel$export(module.exports, "useFastshiftSelector", function () { return $a9443ec81098c5a5$export$5f2b59a93069b0dc; });

var $6gPV0 = parcelRequire("6gPV0");
const $a9443ec81098c5a5$export$671a5d40d73a6cc5 = ()=>(0, $6gPV0.useDispatch)();
const $a9443ec81098c5a5$export$5f2b59a93069b0dc = (0, $6gPV0.useSelector);

});

parcelRegister("1LBjK", function(module, exports) {

$parcel$export(module.exports, "store", function () { return $5268081f3a3e8a40$export$6f57813fe9f31bf9; });

var $4m2lj = parcelRequire("4m2lj");

var $4lm9l = parcelRequire("4lm9l");
const $5268081f3a3e8a40$export$6f57813fe9f31bf9 = (0, $4m2lj.configureStore)({
    reducer: (0, $4lm9l.reducer)((0, $4lm9l.initialState)),
    devTools: {
        name: "fastshift/global"
    }
});

});


parcelRegister("hAe1a", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $edfd340c8f59199e$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $edfd340c8f59199e$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    logoAltText: {
        id: "fastshift-portal.domain-scoped-page.customer-name-and-logo.logo-alt-text",
        defaultMessage: "{name} logo",
        dsecription: "Alt Text for company logo icon for the selected customer"
    }
});

});




parcelRegister("boF4D", function(module, exports) {

$parcel$export(module.exports, "LegalBanner", function () { return $1fb31b6c6d9be52d$export$543e27ba781fe46f; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $9CMNB = parcelRequire("9CMNB");

var $5P9nB = parcelRequire("5P9nB");

var $cUvUr = parcelRequire("cUvUr");

var $vJBxg = parcelRequire("vJBxg");
const $1fb31b6c6d9be52d$var$RESOURCE_LINKS = {
    AtlassianCustomerAgreementLink: "https://www.atlassian.com/legal/atlassian-customer-agreement#intro",
    AtlassianPrivacyPolicyLink: "https://www.atlassian.com/legal/privacy-policy"
};
const $1fb31b6c6d9be52d$export$543e27ba781fe46f = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cUvUr.default), {
        title: intl.formatMessage((0, $vJBxg.messages).legalTitle),
        appearance: "discovery",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $vJBxg.messages).legalDescription), {
                values: {
                    CustomerAgreementLink: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9CMNB.default), {
                        href: $1fb31b6c6d9be52d$var$RESOURCE_LINKS.AtlassianCustomerAgreementLink,
                        target: "_blank",
                        children: intl.formatMessage((0, $vJBxg.messages).atlassianCustomerAgreementLinkText)
                    }),
                    PrivacyPolicyLink: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9CMNB.default), {
                        href: $1fb31b6c6d9be52d$var$RESOURCE_LINKS.AtlassianPrivacyPolicyLink,
                        target: "_blank",
                        children: intl.formatMessage((0, $vJBxg.messages).atlassianPrivacyPolicyLinkText)
                    })
                }
            }))
        })
    });
};

});
parcelRegister("9CMNB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $701d84275a8ba7cc$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l4NVb = parcelRequire("l4NVb");

var $1Vueb = parcelRequire("1Vueb");

var $iSvIT = parcelRequire("iSvIT");

var $hyIWd = parcelRequire("hyIWd");

var $3fzVZ = parcelRequire("3fzVZ");

var $jxLBU = parcelRequire("jxLBU");

var $6MrOv = parcelRequire("6MrOv");
var $eToAw = parcelRequire("eToAw");
var $701d84275a8ba7cc$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $701d84275a8ba7cc$var$styles = {
    visitedLink: "_ect41gqc _1053w7te _1ienw7te _n0fxw7te _1vhvg3x0",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz14q2 _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj14q2 _9oik1r31 _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h16c2",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syaz1gjq _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1gjq _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31gjq _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h1fxt",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $701d84275a8ba7cc$var$iconStyles = null;
var $701d84275a8ba7cc$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, preventedClassName = _ref.className, preventedStyle = _ref.style, htmlAttributes = (0, $1Vueb.default)(_ref, $701d84275a8ba7cc$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement((0, $6MrOv.default), (0, $l4NVb.default)({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $3fzVZ.cx)(appearance === "default" && $701d84275a8ba7cc$var$styles.defaultAppearance, appearance === "subtle" && $701d84275a8ba7cc$var$styles.subtleAppearance, appearance === "inverse" && $701d84275a8ba7cc$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== "inverse" && $701d84275a8ba7cc$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === "_blank" && /*#__PURE__*/ $iSvIT.createElement((0, $eToAw.default), {
        as: "span",
        xcss: $701d84275a8ba7cc$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", (0, $jxLBU.fg)("platform-visual-refresh-icons") ? /*#__PURE__*/ $iSvIT.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $hyIWd.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    })) : /*#__PURE__*/ $iSvIT.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: (0, $hyIWd.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ $iSvIT.createElement("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $701d84275a8ba7cc$var$Link = /*#__PURE__*/ (0, $iSvIT.forwardRef)($701d84275a8ba7cc$var$LinkWithoutRef);
var $701d84275a8ba7cc$export$2e2bcd8739ae039 = $701d84275a8ba7cc$var$Link;

});
parcelRegister("l4NVb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f580b20ca25cd56b$export$2e2bcd8739ae039; });
function $f580b20ca25cd56b$export$2e2bcd8739ae039() {
    return $f580b20ca25cd56b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f580b20ca25cd56b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("1Vueb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16728fee08554cd1$export$2e2bcd8739ae039; });

var $kBLdl = parcelRequire("kBLdl");
function $16728fee08554cd1$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $kBLdl.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("kBLdl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f00be31a6a47e683$export$2e2bcd8739ae039; });
function $f00be31a6a47e683$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("hyIWd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc8878645119b559$export$2e2bcd8739ae039; });
const $cc8878645119b559$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $cc8878645119b559$var$ATOMIC_GROUP_LENGTH = 5;
function $cc8878645119b559$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $cc8878645119b559$var$UNDERSCORE_UNICODE ? $cc8878645119b559$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("3fzVZ", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $25dea599ae45d803$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("iSvIT");


var $cLwI4 = parcelRequire("cLwI4");
var $25dea599ae45d803$var$_createStrictAPI = (0, $cLwI4.createStrictAPI)(), $25dea599ae45d803$var$XCSSProp = $25dea599ae45d803$var$_createStrictAPI.XCSSProp, $25dea599ae45d803$export$dbf350e5966cf602 = $25dea599ae45d803$var$_createStrictAPI.css, $25dea599ae45d803$export$eb1ecd84a24ee424 = $25dea599ae45d803$var$_createStrictAPI.cssMap, $25dea599ae45d803$export$a274e22fb40f762e = $25dea599ae45d803$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("cLwI4", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $94b33f4c9428d344$export$39716b4af53f4ad; });

var $8Z9UW = parcelRequire("8Z9UW");

var $lqoG2 = parcelRequire("lqoG2");
function $94b33f4c9428d344$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $8Z9UW.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $8Z9UW.createStrictSetupError)();
        },
        cx: $lqoG2.cx,
        XCSSProp () {
            throw (0, $8Z9UW.createStrictSetupError)();
        }
    };
}

});
parcelRegister("8Z9UW", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $68abb69c6b0812f8$export$c4df1cb0c2b4d77c; });
const $68abb69c6b0812f8$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $68abb69c6b0812f8$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("lqoG2", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $f98f2b09d99cbe52$export$a274e22fb40f762e; });

var $hyIWd = parcelRequire("hyIWd");
const $f98f2b09d99cbe52$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $hyIWd.default)(actualStyles);
};

});



parcelRegister("6MrOv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4efcccf7ec2d97bc$export$2e2bcd8739ae039; });
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l4NVb = parcelRequire("l4NVb");

var $deYqV = parcelRequire("deYqV");

var $1Vueb = parcelRequire("1Vueb");

var $iSvIT = parcelRequire("iSvIT");


var $lqoG2 = parcelRequire("lqoG2");

var $jNYFj = parcelRequire("jNYFj");

var $kOfFm = parcelRequire("kOfFm");

var $6F6FS = parcelRequire("6F6FS");

var $bErTK = parcelRequire("bErTK");

var $hAclG = parcelRequire("hAclG");

var $7nG8r = parcelRequire("7nG8r");

var $iHJnp = parcelRequire("iHJnp");

var $6nVVZ = parcelRequire("6nVVZ");
var $4efcccf7ec2d97bc$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $4efcccf7ec2d97bc$var$_excluded2 = [
    "className"
];
var $4efcccf7ec2d97bc$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $4efcccf7ec2d97bc$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $4efcccf7ec2d97bc$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $4efcccf7ec2d97bc$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $bErTK.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? "(opens new window)" : _ref$newWindowLabel, htmlAttributes = (0, $1Vueb.default)(_ref, $4efcccf7ec2d97bc$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $hAclG.useId)();
    var onClick = (0, $kOfFm.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $1Vueb.default)(htmlAttributes, $4efcccf7ec2d97bc$var$_excluded2);
    var RouterLink = (0, $6F6FS.default)();
    var isExternal = typeof href === "string" && $4efcccf7ec2d97bc$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $4efcccf7ec2d97bc$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $deYqV.default)(href) === "object";
    (0, $jNYFj.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return /*#__PURE__*/ $iSvIT.createElement((0, $6nVVZ.default), (0, $l4NVb.default)({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $lqoG2.cx)($4efcccf7ec2d97bc$var$styles.root, $4efcccf7ec2d97bc$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $iSvIT.createElement((0, $iHJnp.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $4efcccf7ec2d97bc$var$Anchor = /*#__PURE__*/ (0, $iSvIT.forwardRef)($4efcccf7ec2d97bc$var$AnchorNoRef);
var $4efcccf7ec2d97bc$export$2e2bcd8739ae039 = $4efcccf7ec2d97bc$var$Anchor;

});
parcelRegister("deYqV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a3b75fb7fbf924a$export$2e2bcd8739ae039; });
function $9a3b75fb7fbf924a$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $9a3b75fb7fbf924a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9a3b75fb7fbf924a$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kOfFm", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $f264a11cf469ec6f$export$a4687b0234b40e28; });

var $42wCp = parcelRequire("42wCp");

var $iSvIT = parcelRequire("iSvIT");

var $kU54q = parcelRequire("kU54q");

var $lDFGS = parcelRequire("lDFGS");
function $f264a11cf469ec6f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f264a11cf469ec6f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f264a11cf469ec6f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $42wCp.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f264a11cf469ec6f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f264a11cf469ec6f$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $kU54q.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $lDFGS.useTrackedRef)(analyticsData);
    var fnRef = (0, $lDFGS.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $f264a11cf469ec6f$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("42wCp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f10a6b499711955$export$2e2bcd8739ae039; });

var $3SVUY = parcelRequire("3SVUY");
function $2f10a6b499711955$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3SVUY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("3SVUY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d435786d07f7646$export$2e2bcd8739ae039; });

var $deYqV = parcelRequire("deYqV");

var $avT4M = parcelRequire("avT4M");
function $2d435786d07f7646$export$2e2bcd8739ae039(t) {
    var i = (0, $avT4M.default)(t, "string");
    return "symbol" == (0, $deYqV.default)(i) ? i : i + "";
}

});
parcelRegister("avT4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a7785942844e6d6$export$2e2bcd8739ae039; });

var $deYqV = parcelRequire("deYqV");
function $7a7785942844e6d6$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $deYqV.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $deYqV.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("kU54q", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $f37cf87fcf056211$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $3tVT0 = parcelRequire("3tVT0");

var $1zklp = parcelRequire("1zklp");
function $f37cf87fcf056211$export$5bf35293e545f20c() {
    var analyticsContext = (0, $1zklp.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $3tVT0.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("3tVT0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2890fb80137e0716$export$2e2bcd8739ae039; });

var $6WEFV = parcelRequire("6WEFV");

var $A6xES = parcelRequire("A6xES");

var $c6Aqq = parcelRequire("c6Aqq");

var $95uCO = parcelRequire("95uCO");

var $hrT7G = parcelRequire("hrT7G");

var $hczFK = parcelRequire("hczFK");

var $38IF8 = parcelRequire("38IF8");

var $42wCp = parcelRequire("42wCp");

var $gci6F = parcelRequire("gci6F");
function $2890fb80137e0716$var$_callSuper(t, o, e) {
    return o = (0, $hrT7G.default)(o), (0, $95uCO.default)(t, $2890fb80137e0716$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hrT7G.default)(t).constructor) : o.apply(t, e));
}
function $2890fb80137e0716$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2890fb80137e0716$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2890fb80137e0716$var$_superPropGet(t, o, e, r) {
    var p = (0, $hczFK.default)((0, $hrT7G.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $2890fb80137e0716$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $2890fb80137e0716$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $2890fb80137e0716$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $A6xES.default)(this, UIAnalyticsEvent);
        _this = $2890fb80137e0716$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $42wCp.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $42wCp.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $6WEFV.default)(_this.context);
            var handlers = (0, $6WEFV.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $42wCp.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $38IF8.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $c6Aqq.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $2890fb80137e0716$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $gci6F.default));

});
parcelRegister("6WEFV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50e7b61f0f84d701$export$2e2bcd8739ae039; });

var $ciGQB = parcelRequire("ciGQB");

var $71pMs = parcelRequire("71pMs");

var $9YgwZ = parcelRequire("9YgwZ");

var $5uotM = parcelRequire("5uotM");
function $50e7b61f0f84d701$export$2e2bcd8739ae039(r) {
    return (0, $ciGQB.default)(r) || (0, $71pMs.default)(r) || (0, $9YgwZ.default)(r) || (0, $5uotM.default)();
}

});
parcelRegister("ciGQB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f48670fe4d17353$export$2e2bcd8739ae039; });

var $32aRg = parcelRequire("32aRg");
function $8f48670fe4d17353$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $32aRg.default)(r);
}

});
parcelRegister("32aRg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2359fb3527c09630$export$2e2bcd8739ae039; });
function $2359fb3527c09630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("71pMs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51cc9fdf6d319d26$export$2e2bcd8739ae039; });
function $51cc9fdf6d319d26$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("9YgwZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74268a60730ed3bb$export$2e2bcd8739ae039; });

var $32aRg = parcelRequire("32aRg");
function $74268a60730ed3bb$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $32aRg.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $32aRg.default)(r, a) : void 0;
    }
}

});

parcelRegister("5uotM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ff2be338bcf99ae$export$2e2bcd8739ae039; });
function $3ff2be338bcf99ae$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("A6xES", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06c86ffcee77e67b$export$2e2bcd8739ae039; });
function $06c86ffcee77e67b$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("c6Aqq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d024cdee3eb44b4$export$2e2bcd8739ae039; });

var $3SVUY = parcelRequire("3SVUY");
function $8d024cdee3eb44b4$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3SVUY.default)(o.key), o);
    }
}
function $8d024cdee3eb44b4$export$2e2bcd8739ae039(e, r, t) {
    return r && $8d024cdee3eb44b4$var$_defineProperties(e.prototype, r), t && $8d024cdee3eb44b4$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("95uCO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69dc5628c2ddb25a$export$2e2bcd8739ae039; });

var $deYqV = parcelRequire("deYqV");

var $eWB2v = parcelRequire("eWB2v");
function $69dc5628c2ddb25a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $deYqV.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $eWB2v.default)(t);
}

});
parcelRegister("eWB2v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae1336bf43ff3102$export$2e2bcd8739ae039; });
function $ae1336bf43ff3102$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("hrT7G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb3fb789c3f3a03d$export$2e2bcd8739ae039; });
function $cb3fb789c3f3a03d$export$2e2bcd8739ae039(t) {
    return $cb3fb789c3f3a03d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $cb3fb789c3f3a03d$export$2e2bcd8739ae039(t);
}

});

parcelRegister("hczFK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c85f3a744e3d868f$export$2e2bcd8739ae039; });

var $3WkwH = parcelRequire("3WkwH");
function $c85f3a744e3d868f$export$2e2bcd8739ae039() {
    return $c85f3a744e3d868f$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $3WkwH.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $c85f3a744e3d868f$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("3WkwH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2de6b5f843699c6e$export$2e2bcd8739ae039; });

var $hrT7G = parcelRequire("hrT7G");
function $2de6b5f843699c6e$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $hrT7G.default)(t)););
    return t;
}

});


parcelRegister("38IF8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2494c37bee9cb05a$export$2e2bcd8739ae039; });

var $7VRwn = parcelRequire("7VRwn");
function $2494c37bee9cb05a$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $7VRwn.default)(t, e);
}

});
parcelRegister("7VRwn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c675f7a7788b4d5$export$2e2bcd8739ae039; });
function $5c675f7a7788b4d5$export$2e2bcd8739ae039(t, e) {
    return $5c675f7a7788b4d5$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $5c675f7a7788b4d5$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("gci6F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcabcfe408a23dce$export$2e2bcd8739ae039; });

var $deYqV = parcelRequire("deYqV");

var $A6xES = parcelRequire("A6xES");

var $c6Aqq = parcelRequire("c6Aqq");

var $42wCp = parcelRequire("42wCp");
function $bcabcfe408a23dce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bcabcfe408a23dce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bcabcfe408a23dce$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $42wCp.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bcabcfe408a23dce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bcabcfe408a23dce$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $bcabcfe408a23dce$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $bcabcfe408a23dce$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $A6xES.default)(this, AnalyticsEvent);
        (0, $42wCp.default)(this, "_isAnalyticsEvent", true);
        (0, $42wCp.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $bcabcfe408a23dce$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $c6Aqq.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $deYqV.default)(updater) === "object") this.payload = $bcabcfe408a23dce$var$_objectSpread($bcabcfe408a23dce$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("1zklp", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $1248d74d8937c772$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $1248d74d8937c772$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("lDFGS", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $fc0d945e6cad2500$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $fc0d945e6cad2500$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("bErTK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87b9121b0872d96b$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $87b9121b0872d96b$export$2e2bcd8739ae039() {}

});

parcelRegister("hAclG", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $cccf60a3e4b34926$export$f680877a34711e37; });

var $deYqV = parcelRequire("deYqV");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $jxLBU = parcelRequire("jxLBU");
var $cccf60a3e4b34926$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $cccf60a3e4b34926$var$react18UseId = ($cccf60a3e4b34926$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $cccf60a3e4b34926$var$_React$useId !== void 0 ? $cccf60a3e4b34926$var$_React$useId : undefined;
function $cccf60a3e4b34926$export$f680877a34711e37() {
    if ($cccf60a3e4b34926$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) return $cccf60a3e4b34926$var$react18UseId();
    return "uid".concat((0, $lzzak.useUID)());
}
var $cccf60a3e4b34926$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($cccf60a3e4b34926$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $deYqV.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $deYqV.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $cccf60a3e4b34926$export$6ee17796e3d70de2() {
    if ($cccf60a3e4b34926$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        var uid = $cccf60a3e4b34926$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $lzzak.useUIDSeed)();
}

});

parcelRegister("iHJnp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9df70ffa2d2a9d0$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $iSvIT = parcelRequire("iSvIT");

var $9gqys = parcelRequire("9gqys");
var $d9df70ffa2d2a9d0$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $d9df70ffa2d2a9d0$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $9gqys.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $d9df70ffa2d2a9d0$export$2e2bcd8739ae039 = $d9df70ffa2d2a9d0$var$VisuallyHidden;

});
parcelRegister("9gqys", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bea34e5a24803b9$export$2e2bcd8739ae039; });
const $6bea34e5a24803b9$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $6bea34e5a24803b9$var$ATOMIC_GROUP_LENGTH = 5;
function $6bea34e5a24803b9$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $6bea34e5a24803b9$var$UNDERSCORE_UNICODE ? $6bea34e5a24803b9$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});


parcelRegister("6nVVZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a61d49d2aa1ce53$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l4NVb = parcelRequire("l4NVb");

var $42wCp = parcelRequire("42wCp");

var $1Vueb = parcelRequire("1Vueb");

var $iSvIT = parcelRequire("iSvIT");

var $hyIWd = parcelRequire("hyIWd");
var $bnDcA = parcelRequire("bnDcA");
var $4a61d49d2aa1ce53$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $4a61d49d2aa1ce53$var$_excluded2 = [
    "className"
];
function $4a61d49d2aa1ce53$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4a61d49d2aa1ce53$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4a61d49d2aa1ce53$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $42wCp.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4a61d49d2aa1ce53$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4a61d49d2aa1ce53$var$focusRingStyles = null;
var $4a61d49d2aa1ce53$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $4a61d49d2aa1ce53$var$Focusable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $1Vueb.default)(_ref, $4a61d49d2aa1ce53$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $1Vueb.default)(htmlAttributes, $4a61d49d2aa1ce53$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $l4NVb.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $hyIWd.default)([
            "_mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gt5 _2mwq1gt5",
            xcss
        ]),
        "data-testid": testId,
        style: $4a61d49d2aa1ce53$var$_objectSpread($4a61d49d2aa1ce53$var$_objectSpread({}, style), {}, {
            "--_12dc40g": (0, $bnDcA.default)("calc(0px - ".concat("var(--ds-border-width-focused, 2px)", ")"))
        })
    }), children);
});
var $4a61d49d2aa1ce53$export$2e2bcd8739ae039 = $4a61d49d2aa1ce53$var$Focusable;

});
parcelRegister("bnDcA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8490406568f32195$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $8490406568f32195$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});



parcelRegister("eToAw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad794671a0842a68$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l4NVb = parcelRequire("l4NVb");

var $1Vueb = parcelRequire("1Vueb");

var $iSvIT = parcelRequire("iSvIT");

var $hyIWd = parcelRequire("hyIWd");

var $eB5so = parcelRequire("eB5so");
var $ad794671a0842a68$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $ad794671a0842a68$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $ad794671a0842a68$var$baseStyles = null;
var $ad794671a0842a68$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhk1fno",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1eds",
    "color.background.accent.lime.subtler.pressed": "_bfhk1hgz",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhkhgj8",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhk1b17",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhk1pbw",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkrw5d",
    "color.background.accent.red.subtler.pressed": "_bfhk69rw",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1tf4",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhkprmn",
    "color.background.accent.orange.subtlest": "_bfhk1g3m",
    "color.background.accent.orange.subtlest.hovered": "_bfhkg4tm",
    "color.background.accent.orange.subtlest.pressed": "_bfhk1ya0",
    "color.background.accent.orange.subtler": "_bfhkf2vu",
    "color.background.accent.orange.subtler.hovered": "_bfhk1lml",
    "color.background.accent.orange.subtler.pressed": "_bfhkuxsx",
    "color.background.accent.orange.subtle": "_bfhk1g6e",
    "color.background.accent.orange.subtle.hovered": "_bfhk1oew",
    "color.background.accent.orange.subtle.pressed": "_bfhk1phk",
    "color.background.accent.orange.bolder": "_bfhkjgng",
    "color.background.accent.orange.bolder.hovered": "_bfhkhi52",
    "color.background.accent.orange.bolder.pressed": "_bfhkf767",
    "color.background.accent.yellow.subtlest": "_bfhk1ozg",
    "color.background.accent.yellow.subtlest.hovered": "_bfhk19g9",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk31d1",
    "color.background.accent.yellow.subtler": "_bfhk3fv2",
    "color.background.accent.yellow.subtler.hovered": "_bfhklg04",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1d44",
    "color.background.accent.yellow.subtle": "_bfhkry5t",
    "color.background.accent.yellow.subtle.hovered": "_bfhk17e6",
    "color.background.accent.yellow.subtle.pressed": "_bfhko0y5",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk32kj",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkv5yf",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhkung8",
    "color.background.accent.green.subtler.pressed": "_bfhk1p19",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk8h4p",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1azz",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1j2h",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkg5py",
    "color.background.accent.teal.subtler.pressed": "_bfhkq7li",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk10ai",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhkse6l",
    "color.background.accent.blue.subtlest": "_bfhkavxe",
    "color.background.accent.blue.subtlest.hovered": "_bfhkay3p",
    "color.background.accent.blue.subtlest.pressed": "_bfhk1xmr",
    "color.background.accent.blue.subtler": "_bfhk4v9p",
    "color.background.accent.blue.subtler.hovered": "_bfhk16e6",
    "color.background.accent.blue.subtler.pressed": "_bfhk1uh7",
    "color.background.accent.blue.subtle": "_bfhk1j89",
    "color.background.accent.blue.subtle.hovered": "_bfhk1f4s",
    "color.background.accent.blue.subtle.pressed": "_bfhkqctv",
    "color.background.accent.blue.bolder": "_bfhkc8cv",
    "color.background.accent.blue.bolder.hovered": "_bfhk1cwi",
    "color.background.accent.blue.bolder.pressed": "_bfhkhcrq",
    "color.background.accent.purple.subtlest": "_bfhkp7j4",
    "color.background.accent.purple.subtlest.hovered": "_bfhkm0d5",
    "color.background.accent.purple.subtlest.pressed": "_bfhkgslw",
    "color.background.accent.purple.subtler": "_bfhk1jkz",
    "color.background.accent.purple.subtler.hovered": "_bfhk1wyu",
    "color.background.accent.purple.subtler.pressed": "_bfhk5fkp",
    "color.background.accent.purple.subtle": "_bfhkdh45",
    "color.background.accent.purple.subtle.hovered": "_bfhk1wob",
    "color.background.accent.purple.subtle.pressed": "_bfhkwz05",
    "color.background.accent.purple.bolder": "_bfhkygwo",
    "color.background.accent.purple.bolder.hovered": "_bfhkadgs",
    "color.background.accent.purple.bolder.pressed": "_bfhk1uro",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1een",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1r0p",
    "color.background.accent.magenta.subtler.pressed": "_bfhkxuzc",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk1ovh",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkwaw3",
    "color.background.accent.gray.subtlest": "_bfhk11bn",
    "color.background.accent.gray.subtlest.hovered": "_bfhk12j4",
    "color.background.accent.gray.subtlest.pressed": "_bfhk1lb4",
    "color.background.accent.gray.subtler": "_bfhk1v33",
    "color.background.accent.gray.subtler.hovered": "_bfhk1f7l",
    "color.background.accent.gray.subtler.pressed": "_bfhkd8a2",
    "color.background.accent.gray.subtle": "_bfhk1t05",
    "color.background.accent.gray.subtle.hovered": "_bfhk1a2l",
    "color.background.accent.gray.subtle.pressed": "_bfhk1z0s",
    "color.background.accent.gray.bolder": "_bfhk1t1b",
    "color.background.accent.gray.bolder.hovered": "_bfhke4nv",
    "color.background.accent.gray.bolder.pressed": "_bfhk82ra",
    "color.background.disabled": "_bfhksyzs",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhk1d5g",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhkm7j4",
    "color.background.neutral.hovered": "_bfhk15ej",
    "color.background.neutral.pressed": "_bfhkip91",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk166n",
    "color.background.neutral.subtle.pressed": "_bfhk1dty",
    "color.background.neutral.bold": "_bfhkcdhy",
    "color.background.neutral.bold.hovered": "_bfhk1bsc",
    "color.background.neutral.bold.pressed": "_bfhk1b6k",
    "color.background.selected": "_bfhkfg4m",
    "color.background.selected.hovered": "_bfhki1yw",
    "color.background.selected.pressed": "_bfhk19ru",
    "color.background.selected.bold": "_bfhk1fvw",
    "color.background.selected.bold.hovered": "_bfhk18hz",
    "color.background.selected.bold.pressed": "_bfhkgr1v",
    "color.background.brand.subtlest": "_bfhk3wxy",
    "color.background.brand.subtlest.hovered": "_bfhkezq1",
    "color.background.brand.subtlest.pressed": "_bfhk2ggb",
    "color.background.brand.bold": "_bfhkb29m",
    "color.background.brand.bold.hovered": "_bfhku1se",
    "color.background.brand.bold.pressed": "_bfhkqkzo",
    "color.background.brand.boldest": "_bfhk15mt",
    "color.background.brand.boldest.hovered": "_bfhk1uwk",
    "color.background.brand.boldest.pressed": "_bfhk17jr",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1io2",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk9pqq",
    "color.background.warning": "_bfhk1tzq",
    "color.background.warning.hovered": "_bfhk1rd4",
    "color.background.warning.pressed": "_bfhk11dh",
    "color.background.warning.bold": "_bfhk190i",
    "color.background.warning.bold.hovered": "_bfhk1i4c",
    "color.background.warning.bold.pressed": "_bfhkrj9s",
    "color.background.success": "_bfhkmv6i",
    "color.background.success.hovered": "_bfhk1jgi",
    "color.background.success.pressed": "_bfhky4f1",
    "color.background.success.bold": "_bfhk8emd",
    "color.background.success.bold.hovered": "_bfhk1q4l",
    "color.background.success.bold.pressed": "_bfhkcrcn",
    "color.background.discovery": "_bfhk1nvp",
    "color.background.discovery.hovered": "_bfhk1xp7",
    "color.background.discovery.pressed": "_bfhkdlkp",
    "color.background.discovery.bold": "_bfhk1lri",
    "color.background.discovery.bold.hovered": "_bfhk1w72",
    "color.background.discovery.bold.pressed": "_bfhkrb53",
    "color.background.information": "_bfhk33gi",
    "color.background.information.hovered": "_bfhk1vps",
    "color.background.information.pressed": "_bfhk1s0z",
    "color.background.information.bold": "_bfhk14wj",
    "color.background.information.bold.hovered": "_bfhk1amz",
    "color.background.information.bold.pressed": "_bfhk5bth",
    "color.blanket": "_bfhk10xm",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkn82g",
    "color.skeleton.subtle": "_bfhkh3tw",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk108i",
    "elevation.surface.pressed": "_bfhk1ji5",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk16qz",
    "elevation.surface.overlay.pressed": "_bfhkvq0a",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk1a0f",
    "elevation.surface.raised.pressed": "_bfhkf7u5",
    "elevation.surface.sunken": "_bfhkqbzx",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $ad794671a0842a68$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $ad794671a0842a68$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l108i",
    "elevation.surface.pressed": "_1q1l1ji5",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l16qz",
    "elevation.surface.overlay.pressed": "_1q1lvq0a",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l1a0f",
    "elevation.surface.raised.pressed": "_1q1lf7u5",
    "elevation.surface.sunken": "_1q1lqbzx"
};
var $ad794671a0842a68$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $ad794671a0842a68$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $ad794671a0842a68$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $ad794671a0842a68$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $ad794671a0842a68$var$Box = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $1Vueb.default)(_ref, $ad794671a0842a68$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $1Vueb.default)(htmlAttributes, $ad794671a0842a68$var$_excluded2);
    var node = /*#__PURE__*/ $iSvIT.createElement(Component, (0, $l4NVb.default)({
        style: style,
        ref: ref,
        className: (0, $hyIWd.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $ad794671a0842a68$var$backgroundColorMap[backgroundColor],
            backgroundColor && $ad794671a0842a68$var$isSurfaceToken(backgroundColor) && $ad794671a0842a68$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $ad794671a0842a68$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $ad794671a0842a68$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $ad794671a0842a68$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $ad794671a0842a68$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $iSvIT.createElement((0, $eB5so.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $ad794671a0842a68$export$2e2bcd8739ae039 = $ad794671a0842a68$var$Box;
function $ad794671a0842a68$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $ad794671a0842a68$var$setSurfaceTokenMap;
}

});
parcelRegister("eB5so", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $aa08c100f35a2324$export$1ca2a26fecb070ae; });

var $iSvIT = parcelRequire("iSvIT");
var $aa08c100f35a2324$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $aa08c100f35a2324$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($aa08c100f35a2324$export$1ca2a26fecb070ae);
};
$aa08c100f35a2324$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("5P9nB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43d8fdcc6671c6da$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jNYFj = parcelRequire("jNYFj");

var $9IfaW = parcelRequire("9IfaW");

var $jeCQ2 = parcelRequire("jeCQ2");

var $1dqlv = parcelRequire("1dqlv");
var $43d8fdcc6671c6da$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $43d8fdcc6671c6da$var$resetStyles = (0, $2ZUkg.css)({
    margin: 0,
    overflowWrap: "anywhere"
});
var $43d8fdcc6671c6da$var$strongStyles = (0, $2ZUkg.css)({
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
var $43d8fdcc6671c6da$var$emStyles = (0, $2ZUkg.css)({
    fontStyle: "italic"
});
var $43d8fdcc6671c6da$var$textAlignMap = {
    center: (0, $2ZUkg.css)({
        textAlign: "center"
    }),
    end: (0, $2ZUkg.css)({
        textAlign: "end"
    }),
    start: (0, $2ZUkg.css)({
        textAlign: "start"
    })
};
var $43d8fdcc6671c6da$var$truncationStyles = (0, $2ZUkg.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $43d8fdcc6671c6da$var$wordBreakMap = {
    breakAll: (0, $2ZUkg.css)({
        wordBreak: "break-all"
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $43d8fdcc6671c6da$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $jeCQ2.useSurface)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $1dqlv.inverseColorMap).hasOwnProperty(surface)) return (0, $1dqlv.inverseColorMap)[surface];
    return "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $43d8fdcc6671c6da$var$Text = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $jNYFj.default)($43d8fdcc6671c6da$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $9IfaW.useHasTextAncestor)();
    var color = $43d8fdcc6671c6da$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = (0, $2ZUkg.jsx)(Component, {
        ref: ref,
        css: [
            $43d8fdcc6671c6da$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $1dqlv.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $1dqlv.textColorStylesMap)[color],
            maxLines && $43d8fdcc6671c6da$var$truncationStyles,
            maxLines === 1 && $43d8fdcc6671c6da$var$wordBreakMap.breakAll,
            align && $43d8fdcc6671c6da$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $1dqlv.textWeightStylesMap)[weight],
            Component === "em" && $43d8fdcc6671c6da$var$emStyles,
            Component === "strong" && $43d8fdcc6671c6da$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $2ZUkg.jsx)((0, $9IfaW.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $43d8fdcc6671c6da$export$2e2bcd8739ae039 = $43d8fdcc6671c6da$var$Text;

});
parcelRegister("9IfaW", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", function () { return $7123fea6fd0e0711$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $7123fea6fd0e0711$export$ae933c6cbe5643ad; });

var $iSvIT = parcelRequire("iSvIT");
var $7123fea6fd0e0711$var$HasTextAncestorContext = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
var $7123fea6fd0e0711$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $iSvIT.useContext)($7123fea6fd0e0711$var$HasTextAncestorContext);
};
var $7123fea6fd0e0711$export$ae933c6cbe5643ad = $7123fea6fd0e0711$var$HasTextAncestorContext.Provider;

});

parcelRegister("jeCQ2", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $e00d7397b3bb3f41$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $e00d7397b3bb3f41$export$1aeb4f6b93c4540d; });

var $iSvIT = parcelRequire("iSvIT");
var $e00d7397b3bb3f41$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $e00d7397b3bb3f41$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($e00d7397b3bb3f41$export$1ca2a26fecb070ae);
};
$e00d7397b3bb3f41$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("vJBxg", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $8da63e0a1754b91c$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $8da63e0a1754b91c$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    legalTitle: {
        id: "fastshift.legal-banner.title",
        defaultMessage: "FastShift Portal use agreement",
        description: "Title for Legal banner about usage agreement"
    },
    legalDescription: {
        id: "fastshift.legal-banner.description",
        defaultMessage: "By using this FastShift Portal, you agree that its use is governed by the {CustomerAgreementLink} and the {PrivacyPolicyLink}. This FastShift Portal is considered to be a \u201CFree or Beta product\u201D under Section 17 of the Atlassian Customer Agreement.",
        description: "Description for Legal banner about usage agreement"
    },
    atlassianCustomerAgreementLinkText: {
        id: "fastshift.legal-banner.customer-agreement-link-text",
        defaultMessage: "Atlassian Customer Agreement",
        description: "link text for link to Atlassian Customer Agreement"
    },
    atlassianPrivacyPolicyLinkText: {
        id: "fastshift.legal-banner.privacy-policy-link-text",
        defaultMessage: "Atlassian Privacy Policy",
        description: "link text for link to Atlassian Privacy Policy"
    }
});

});


parcelRegister("jNqYB", function(module, exports) {

$parcel$export(module.exports, "RelationshipSection", function () { return (parcelRequire("hybbY")).RelationshipSection; });
parcelRequire("ew9n7");
var $5nKIy = parcelRequire("5nKIy");

var $hybbY = parcelRequire("hybbY");

});
parcelRegister("ew9n7", function(module, exports) {
parcelRequire("9cVxH");
var $5nKIy = parcelRequire("5nKIy");
parcelRequire("8EbrV");
var $3w07O = parcelRequire("3w07O");
parcelRequire("9I3Pg");
var $54htJ = parcelRequire("54htJ");
parcelRequire("b7ahr");
var $iU2Al = parcelRequire("iU2Al");

});
parcelRegister("9cVxH", function(module, exports) {

$parcel$export(module.exports, "CustomerRelationshipsSection", function () { return (parcelRequire("5nKIy")).CustomerRelationshipsSection; });

var $5nKIy = parcelRequire("5nKIy");

});
parcelRegister("5nKIy", function(module, exports) {

$parcel$export(module.exports, "CustomerRelationshipsSection", function () { return $e73e7427968271a1$export$7befb07f457c87ff; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("bfgmV");
var $fLAqy = parcelRequire("fLAqy");
parcelRequire("89AVb");
var $hx13k = parcelRequire("hx13k");
parcelRequire("ghRFR");
var $KtL5L = parcelRequire("KtL5L");

var $ddzL3 = parcelRequire("ddzL3");
parcelRequire("l9XU5");
var $iCI8m = parcelRequire("iCI8m");
const $e73e7427968271a1$export$7befb07f457c87ff = ({ relationships: relationships })=>{
    const relationshipMapping = (0, $ddzL3.mapRelationships)(relationships);
    const engineers = (0, $ddzL3.filterEngineers)(relationships);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iCI8m.BaseRelationshipsSection), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fLAqy.FastshiftTeamCard), {
                isCustomer: true,
                relationships: relationshipMapping
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $KtL5L.SupportEngineersCard), {
                engineers: engineers
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hx13k.MigrationResourcesCard), {})
        ]
    });
};

});
parcelRegister("bfgmV", function(module, exports) {

$parcel$export(module.exports, "FastshiftTeamCard", function () { return (parcelRequire("fLAqy")).FastshiftTeamCard; });

var $fLAqy = parcelRequire("fLAqy");

});
parcelRegister("fLAqy", function(module, exports) {

$parcel$export(module.exports, "FastshiftTeamCard", function () { return $61843531d0644892$export$7817978309246061; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $cgOuH = parcelRequire("cgOuH");
parcelRequire("lnB9x");
var $jg6eR = parcelRequire("jg6eR");
parcelRequire("6f79W");
var $dWInj = parcelRequire("dWInj");

var $3xAIJ = parcelRequire("3xAIJ");
const $61843531d0644892$export$7817978309246061 = ({ isCustomer: isCustomer = false, relationships: relationships = {} })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jg6eR.BaseCard), {
        message: isCustomer ? (0, $3xAIJ.messages).fastshiftTeamCardTitleCustomer : (0, $3xAIJ.messages).fastshiftTeamCardTitleInternal,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
            space: "space.100",
            children: [
                relationships.fastshiftChampion && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dWInj.CardRelationship), {
                    name: relationships.fastshiftChampion.name,
                    imageUrl: relationships.fastshiftChampion.imageUrl,
                    titleMessage: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $3xAIJ.messages).fastshiftTeamCardCustomerFastshiftChampionTitle))
                }),
                relationships.accountExecutive && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dWInj.CardRelationship), {
                    name: relationships.accountExecutive.name,
                    imageUrl: relationships.accountExecutive.imageUrl,
                    titleMessage: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $3xAIJ.messages).fastshiftTeamCardAccountExecutiveTitle))
                }),
                relationships.customerSuccessManager && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dWInj.CardRelationship), {
                    name: relationships.customerSuccessManager.name,
                    imageUrl: relationships.customerSuccessManager.imageUrl,
                    titleMessage: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $3xAIJ.messages).fastshiftTeamCardCustomerSuccessManagerTitle))
                })
            ]
        })
    });
};

});
parcelRegister("lnB9x", function(module, exports) {

$parcel$export(module.exports, "BaseCard", function () { return (parcelRequire("jg6eR")).BaseCard; });

var $jg6eR = parcelRequire("jg6eR");

});
parcelRegister("jg6eR", function(module, exports) {

$parcel$export(module.exports, "BaseCard", function () { return $8a201d23fac4335f$export$ffd8d1a491a618f2; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $gf1F9 = parcelRequire("gf1F9");

var $jKp9A = parcelRequire("jKp9A");
var $g2DEO = parcelRequire("g2DEO");
var $jAMCU = parcelRequire("jAMCU");
const $8a201d23fac4335f$var$containerStyles = (0, $jAMCU.xcss)({
    borderRadius: "6px",
    borderColor: "color.border",
    borderWidth: "border.width",
    borderStyle: "solid",
    width: "100%",
    boxSizing: "border-box",
    height: "200px"
});
const $8a201d23fac4335f$var$outerContentStyles = (0, $jAMCU.xcss)({
    height: "100%"
});
const $8a201d23fac4335f$var$contentStyles = (0, $jAMCU.xcss)({
    flexGrow: 1
});
const $8a201d23fac4335f$export$ffd8d1a491a618f2 = ({ children: children, message: message })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
        padding: "space.150",
        xcss: $8a201d23fac4335f$var$containerStyles,
        as: "article",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g2DEO.default), {
            xcss: $8a201d23fac4335f$var$outerContentStyles,
            direction: "column",
            gap: "space.100",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                    size: "xsmall",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, message))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
                    xcss: $8a201d23fac4335f$var$contentStyles,
                    children: children
                })
            ]
        })
    });
};

});
parcelRegister("jKp9A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e605d33154ea3c0e$export$2e2bcd8739ae039; });

var $aB34E = parcelRequire("aB34E");

var $2OPES = parcelRequire("2OPES");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jeCQ2 = parcelRequire("jeCQ2");

var $1dqlv = parcelRequire("1dqlv");

var $jAMCU = parcelRequire("jAMCU");
var $e605d33154ea3c0e$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $e605d33154ea3c0e$var$_excluded2 = [
    "className"
];
var $e605d33154ea3c0e$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $2OPES.default)(_ref, $e605d33154ea3c0e$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $2OPES.default)(htmlAttributes, $e605d33154ea3c0e$var$_excluded2);
    var resolvedStyles = (0, $jAMCU.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $2ZUkg.jsx)(Component, (0, $aB34E.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $e605d33154ea3c0e$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1dqlv.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1dqlv.isSurfaceColorToken)(backgroundColor) && (0, $1dqlv.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1dqlv.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1dqlv.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1dqlv.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1dqlv.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1dqlv.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1dqlv.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1dqlv.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $2ZUkg.jsx)((0, $jeCQ2.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $e605d33154ea3c0e$export$2e2bcd8739ae039 = $e605d33154ea3c0e$export$e71c4d32a2263218;
var $e605d33154ea3c0e$var$baseStyles = (0, $2ZUkg.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("aB34E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b6fbe87b5062c89$export$2e2bcd8739ae039; });
function $7b6fbe87b5062c89$export$2e2bcd8739ae039() {
    return $7b6fbe87b5062c89$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7b6fbe87b5062c89$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("2OPES", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20d85290c55da6cf$export$2e2bcd8739ae039; });

var $kegab = parcelRequire("kegab");
function $20d85290c55da6cf$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $kegab.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("kegab", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eba1a71dbc365bf4$export$2e2bcd8739ae039; });
function $eba1a71dbc365bf4$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});





parcelRegister("6f79W", function(module, exports) {

$parcel$export(module.exports, "CardRelationship", function () { return (parcelRequire("dWInj")).CardRelationship; });

var $dWInj = parcelRequire("dWInj");

});
parcelRegister("dWInj", function(module, exports) {

$parcel$export(module.exports, "CardRelationship", function () { return $f9f5367deb03c182$export$dea2bd7bbed2f4ec; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $objBZ = parcelRequire("objBZ");

var $gf1F9 = parcelRequire("gf1F9");

var $g2DEO = parcelRequire("g2DEO");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");

var $eRDFr = parcelRequire("eRDFr");
const $f9f5367deb03c182$export$dea2bd7bbed2f4ec = ({ name: name, imageUrl: imageUrl, titleMessage: titleMessage })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g2DEO.default), {
        alignItems: "center",
        gap: "space.150",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $objBZ.default), {
                appearance: "circle",
                src: imageUrl,
                size: "large",
                name: name
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                        size: "xsmall",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $eRDFr.messages).cardRelationshipNameMessage), {
                            values: {
                                name: name
                            }
                        }))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                        children: titleMessage
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("eRDFr", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $6828c8fda92da356$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $6828c8fda92da356$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    cardRelationshipNameMessage: {
        id: "fastshift.card-relationship.relationship-name",
        defaultMessage: "{name}",
        description: "Name of the relationship"
    },
    cardRelationshipTitle: {
        id: "fastshift.card-relationship.relationship-title",
        defaultMessage: "{title}",
        description: "Title of the relationship"
    }
});

});



parcelRegister("3xAIJ", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $0e0a9d1f354e2a60$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $0e0a9d1f354e2a60$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    fastshiftTeamCardTitleCustomer: {
        id: "fastshift.relationships-card.title.customer",
        defaultMessage: "Your FastShift Team",
        description: "Title for the FastShift team card"
    },
    fastshiftTeamCardTitleInternal: {
        id: "fastshift.relationships-card.title.internal",
        defaultMessage: "Customer FastShift Team",
        description: "Title for the FastShift team card"
    },
    fastshiftTeamCardCustomerFastshiftChampionTitle: {
        id: "fastshift.relationships-card.relationship-title.customer-fastshift-champion",
        defaultMessage: "Customer FastShift Champion",
        description: "Title of the Customer FastShift Champion"
    },
    fastshiftTeamCardAccountExecutiveTitle: {
        id: "fastshift.relationships-card.relationship-title.account-executive",
        defaultMessage: "Account Executive",
        description: "Title of the Account Executive"
    },
    fastshiftTeamCardCustomerSuccessManagerTitle: {
        id: "fastshift.relationships-card.relationship-title.customer-success-manager",
        defaultMessage: "Customer Success Manager",
        description: "Title of the Customer Success Manager"
    }
});

});



parcelRegister("89AVb", function(module, exports) {

$parcel$export(module.exports, "MigrationResourcesCard", function () { return (parcelRequire("hx13k")).MigrationResourcesCard; });

var $hx13k = parcelRequire("hx13k");

});
parcelRegister("hx13k", function(module, exports) {

$parcel$export(module.exports, "MigrationResourcesCard", function () { return $8161d9ea7df09508$export$deaa4b29f6580987; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $hK5Mw = parcelRequire("hK5Mw");

var $9B16h = parcelRequire("9B16h");

var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");
parcelRequire("5XMUP");
var $gbLaZ = parcelRequire("gbLaZ");
parcelRequire("lnB9x");
var $jg6eR = parcelRequire("jg6eR");

var $7XLcH = parcelRequire("7XLcH");
const $8161d9ea7df09508$var$contentStyles = (0, $jAMCU.xcss)({
    height: "100%"
});
const $8161d9ea7df09508$export$deaa4b29f6580987 = ()=>{
    const navigate = (0, $hK5Mw.useNavigate)();
    const { paths: paths } = (0, $gbLaZ.useRoutes)();
    const navigateToDomainScopedResourcesPage = ()=>{
        const url = paths.domainScopedResources;
        if (url) navigate(url);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jg6eR.BaseCard), {
        message: (0, $7XLcH.messages).migrationResourcesCardTitle,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
            xcss: $8161d9ea7df09508$var$contentStyles,
            space: "space.100",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $7XLcH.messages).migrationResourcesCardDescription))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
                    alignBlock: "end",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                        onClick: ()=>navigateToDomainScopedResourcesPage(),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $7XLcH.messages).migrationResourcesCardButton))
                    })
                })
            ]
        })
    });
};

});
parcelRegister("9B16h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fc86c408f5d88b6$export$2e2bcd8739ae039; });

var $72NmR = parcelRequire("72NmR");

var $cJhvT = parcelRequire("cJhvT");

var $iSvIT = parcelRequire("iSvIT");

var $12ZPF = parcelRequire("12ZPF");

var $MIq2I = parcelRequire("MIq2I");

var $kMg75 = parcelRequire("kMg75");
var $6fc86c408f5d88b6$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $6fc86c408f5d88b6$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $6fc86c408f5d88b6$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, $cJhvT.default)(_ref, $6fc86c408f5d88b6$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $cJhvT.default)(unsafeRest, $6fc86c408f5d88b6$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $12ZPF.default), (0, $72NmR.default)({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $MIq2I.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $kMg75.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $MIq2I.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $MIq2I.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $kMg75.default), {
        icon: iconAfter
    }))));
}));
$6fc86c408f5d88b6$var$Button.displayName = "Button";
var $6fc86c408f5d88b6$export$2e2bcd8739ae039 = $6fc86c408f5d88b6$var$Button;

});

parcelRegister("5XMUP", function(module, exports) {

$parcel$export(module.exports, "useRoutes", function () { return (parcelRequire("gbLaZ")).useRoutes; });

var $gbLaZ = parcelRequire("gbLaZ");

});
parcelRegister("gbLaZ", function(module, exports) {

$parcel$export(module.exports, "useRoutes", function () { return $642f11683e33fb81$export$5d3fca4a98652595; });

var $akGnX = parcelRequire("akGnX");

var $iSvIT = parcelRequire("iSvIT");

var $hK5Mw = parcelRequire("hK5Mw");
var $hea8X = parcelRequire("hea8X");

var $9OyVr = parcelRequire("9OyVr");
const $642f11683e33fb81$var$PATHS_KEYS = {
    HOME: "home",
    SELECTION: "selection",
    PARTNER_RESOURCES: "partnerResources",
    DOMAIN_SCOPED_OVERVIEW: "domainScopedOverview",
    DOMAIN_SCOPED_PLANNING: "domainScopedPlanning",
    DOMAIN_SCOPED_RESOURCES: "domainScopedResources",
    EAP_HOME: "eapHome"
};
const $642f11683e33fb81$export$5d3fca4a98652595 = ()=>{
    const { pathname: pathname } = (0, $hK5Mw.useLocation)();
    const { locale: locale, domainId: domainId } = (0, $hea8X.useParams)();
    const injectParams = (0, $iSvIT.useCallback)((path, targetDomainId)=>{
        var _ref;
        return `${locale ? `/${locale}/` : "/"}${path.replace(":domainId", (_ref = targetDomainId !== null && targetDomainId !== void 0 ? targetDomainId : domainId) !== null && _ref !== void 0 ? _ref : "")}`;
    }, [
        locale,
        domainId
    ]);
    const paths = {
        [$642f11683e33fb81$var$PATHS_KEYS.HOME]: injectParams((0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).FASTSHIFT]),
        [$642f11683e33fb81$var$PATHS_KEYS.SELECTION]: injectParams((0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).SELECTION]),
        [$642f11683e33fb81$var$PATHS_KEYS.PARTNER_RESOURCES]: injectParams((0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).RESOURCES_PARTNER_SCOPED]),
        [$642f11683e33fb81$var$PATHS_KEYS.DOMAIN_SCOPED_OVERVIEW]: domainId ? injectParams((0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).OVERVIEW]) : null,
        [$642f11683e33fb81$var$PATHS_KEYS.DOMAIN_SCOPED_PLANNING]: domainId ? injectParams((0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).PLANNING]) : null,
        [$642f11683e33fb81$var$PATHS_KEYS.DOMAIN_SCOPED_RESOURCES]: domainId ? injectParams((0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).RESOURCES_DOMAIN_SCOPED]) : null,
        [$642f11683e33fb81$var$PATHS_KEYS.EAP_HOME]: injectParams((0, $9OyVr.FASTSHIFT_EAP_HOME_PATH))
    };
    const getPathByDomainId = (path, targetDomainId)=>{
        return injectParams(path, targetDomainId);
    };
    const isValidFastshiftRoute = (pathname)=>{
        const { eapHome: _ } = paths, rest = (0, $akGnX._)(paths, [
            "eapHome"
        ]);
        return Object.values(rest).includes(pathname);
    };
    const isValidFastshiftPartnerRoute = (pathname)=>{
        return [
            paths.selection,
            paths.partnerResources
        ].includes(pathname);
    };
    return {
        domainId: domainId,
        fullPathname: pathname,
        paths: paths,
        getPathByDomainId: getPathByDomainId,
        isValidFastshiftRoute: isValidFastshiftRoute,
        isValidFastshiftPartnerRoute: isValidFastshiftPartnerRoute
    };
};

});


parcelRegister("7XLcH", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $2bd58740e661d128$export$defe85febe8b728c; });

var $f2Ax6 = parcelRequire("f2Ax6");
const $2bd58740e661d128$export$defe85febe8b728c = (0, $f2Ax6.defineMessages)({
    migrationResourcesCardTitle: {
        id: "fastshift.relationships-card.title.migration-resources",
        defaultMessage: "Migration resources",
        description: "Title for the Migration Resources card"
    },
    migrationResourcesCardDescription: {
        id: "fastshift.relationships-card.description.migration-resources",
        defaultMessage: "Effortlessly find answers through our curated collection of help articles, providing practical tips and solutions for every phase of your cloud journey.",
        description: "Description for the Migration Resources card"
    },
    migrationResourcesCardButton: {
        id: "fastshift.relationships-card.button.migration-resources",
        defaultMessage: "View Articles",
        description: "Button text for the Migration Resources card"
    }
});

});



parcelRegister("ghRFR", function(module, exports) {

$parcel$export(module.exports, "SupportEngineersCard", function () { return (parcelRequire("KtL5L")).SupportEngineersCard; });

var $KtL5L = parcelRequire("KtL5L");

});
parcelRegister("KtL5L", function(module, exports) {

$parcel$export(module.exports, "SupportEngineersCard", function () { return $9420c5f06fdbec11$export$47c50ce9e6c40dd; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $RPX28 = parcelRequire("RPX28");

var $9B16h = parcelRequire("9B16h");

var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");
parcelRequire("2T6pW");
var $kCIZI = parcelRequire("kCIZI");
parcelRequire("lnB9x");
var $jg6eR = parcelRequire("jg6eR");
parcelRequire("kxNHH");
var $ivzWG = parcelRequire("ivzWG");

var $jcpuc = parcelRequire("jcpuc");
const $9420c5f06fdbec11$var$contentStyles = (0, $jAMCU.xcss)({
    height: "100%"
});
const $9420c5f06fdbec11$export$47c50ce9e6c40dd = ({ engineers: engineers })=>{
    const [isModalOpen, setIsModalOpen] = (0, $iSvIT.useState)(false);
    const { sendRequestAssistanceButtonClickUIEvent: sendRequestAssistanceButtonClickUIEvent } = (0, $kCIZI.useRelationshipsAnalytics)();
    const handleRequestAssistanceClick = ()=>{
        sendRequestAssistanceButtonClickUIEvent();
        setIsModalOpen(true);
    };
    const shouldRenderAvatarGroup = engineers.some(({ imageUrl: imageUrl })=>imageUrl !== "");
    const avatarGroupData = shouldRenderAvatarGroup ? engineers.map(({ id: id, name: name, imageUrl: imageUrl })=>({
            key: id,
            name: name,
            href: "#",
            src: imageUrl
        })).sort((a, b)=>b.src.localeCompare(a.src)) : [];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jg6eR.BaseCard), {
        message: (0, $jcpuc.messages).supportEngineersCardTitle,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
            xcss: $9420c5f06fdbec11$var$contentStyles,
            space: "space.100",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $jcpuc.messages).supportEngineersCardSubtitle))
                }),
                shouldRenderAvatarGroup ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $RPX28.default), {
                    size: "large",
                    data: avatarGroupData
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $jcpuc.messages).supportEngineersCardMessageWhenNoAvaters))
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $ivzWG.RequestAssistanceModal), {
                            isModalOpen: isModalOpen,
                            setIsModalOpen: setIsModalOpen
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                            onClick: handleRequestAssistanceClick,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $jcpuc.messages).supportEngineersCardButtonText))
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("2T6pW", function(module, exports) {

$parcel$export(module.exports, "useRelationshipsAnalytics", function () { return (parcelRequire("kCIZI")).useRelationshipsAnalytics; });
$parcel$export(module.exports, "useRelationshipsPageAnalytics", function () { return (parcelRequire("jAoD1")).useRelationshipsPageAnalytics; });

var $kCIZI = parcelRequire("kCIZI");

var $jAoD1 = parcelRequire("jAoD1");

});
parcelRegister("kCIZI", function(module, exports) {

$parcel$export(module.exports, "useRelationshipsAnalytics", function () { return $d861e10239181df0$export$651d36257792949e; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $h0mGD = parcelRequire("h0mGD");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
const $d861e10239181df0$export$651d36257792949e = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $h0mGD.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent, fireTrackEvent: fireTrackEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    const sendRequestAssistanceButtonClickUIEvent = (0, $iSvIT.useCallback)(()=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).REQUEST_ASSISTANCE_BUTTON,
            source: sourceKey
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendRequestAssistanceModalCommentSubmitButtonClickUIEvent = (0, $iSvIT.useCallback)((supportTicketId)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).REQUEST_FASTSHIFT_ASSISTANCE_MODAL_SUBMIT_BUTTON_CLICK,
            source: sourceKey,
            attributes: {
                supportTicketId: supportTicketId
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendRequestAssistanceModalDisplayedTrackEvent = (0, $iSvIT.useCallback)((isEmpty, supportTicketCount)=>{
        fireTrackEvent({
            action: (0, $k7z8r.ActionKey).DISPLAYED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).MODAL,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).REQUEST_FASTSHIFT_ASSISTANCE_MODAL,
            source: sourceKey,
            attributes: {
                isEmpty: isEmpty,
                supportTicketCount: supportTicketCount
            }
        });
    }, [
        fireTrackEvent,
        sourceKey
    ]);
    const sendPostCommentOutcomeFlagDisplayedTrackEvent = (0, $iSvIT.useCallback)((successFlag, supportTicketId)=>{
        fireTrackEvent({
            action: (0, $k7z8r.ActionKey).DISPLAYED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).FLAG,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).REQUEST_FASTSHIFT_ASSISTANCE_COMMENT_CONFIRMATION_FLAG,
            source: sourceKey,
            attributes: {
                successFlag: successFlag,
                supportTicketId: supportTicketId
            }
        });
    }, [
        fireTrackEvent,
        sourceKey
    ]);
    return {
        sendRequestAssistanceButtonClickUIEvent: // UI Events (button clicks)
        sendRequestAssistanceButtonClickUIEvent,
        sendRequestAssistanceModalCommentSubmitButtonClickUIEvent: sendRequestAssistanceModalCommentSubmitButtonClickUIEvent,
        sendRequestAssistanceModalDisplayedTrackEvent: // Track Events (manual triggers)
        sendRequestAssistanceModalDisplayedTrackEvent,
        sendPostCommentOutcomeFlagDisplayedTrackEvent: sendPostCommentOutcomeFlagDisplayedTrackEvent
    };
};

});
parcelRegister("enHYO", function(module, exports) {
$parcel$export(module.exports, "useBaseIdentityAttrs", function () { return (parcelRequire("aVSys")).useBaseIdentityAttrs; });
$parcel$export(module.exports, "useCustomerIdentityAttrs", function () { return (parcelRequire("ag6tB")).useCustomerIdentityAttrs; });
$parcel$export(module.exports, "useFastshiftAnalyticsData", function () { return (parcelRequire("h0mGD")).useFastshiftAnalyticsData; });

$parcel$export(module.exports, "useFireAnalyticsEvents", function () { return (parcelRequire("ih47h")).useFireAnalyticsEvents; });

var $ih47h = parcelRequire("ih47h");
parcelRequire("3rXRR");
parcelRequire("9aD4b");

});
parcelRegister("3rXRR", function(module, exports) {

$parcel$export(module.exports, "useBaseIdentityAttrs", function () { return (parcelRequire("aVSys")).useBaseIdentityAttrs; });
$parcel$export(module.exports, "useCustomerIdentityAttrs", function () { return (parcelRequire("ag6tB")).useCustomerIdentityAttrs; });
$parcel$export(module.exports, "useFastshiftAnalyticsData", function () { return (parcelRequire("h0mGD")).useFastshiftAnalyticsData; });

var $aVSys = parcelRequire("aVSys");

var $ag6tB = parcelRequire("ag6tB");

var $h0mGD = parcelRequire("h0mGD");

});
parcelRegister("aVSys", function(module, exports) {

$parcel$export(module.exports, "useBaseIdentityAttrs", function () { return $f4fa5387cf044761$export$627290518802a7d3; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");
const $f4fa5387cf044761$export$627290518802a7d3 = ()=>{
    const { data: userDetails } = (0, $8KnwD.useFastshiftSelector)((state)=>state.userDetails);
    return (0, $iSvIT.useMemo)(()=>{
        if (!userDetails) return null;
        return {
            role: userDetails.userType,
            userDomain: userDetails.userDomain.domain
        };
    }, [
        userDetails
    ]);
};

});

parcelRegister("ag6tB", function(module, exports) {

$parcel$export(module.exports, "useCustomerIdentityAttrs", function () { return $3f687a9417272563$export$57d44fbb0af76243; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");

var $aVSys = parcelRequire("aVSys");
const $3f687a9417272563$export$57d44fbb0af76243 = (allowFallback = false)=>{
    const baseAttrs = (0, $aVSys.useBaseIdentityAttrs)();
    const { data: customerDomain } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomain);
    return (0, $iSvIT.useMemo)(()=>{
        if (!baseAttrs) return null;
        if (customerDomain) return (0, $6iHNw._)((0, $7Knp0._)({}, baseAttrs), {
            selectedCustomerDomain: customerDomain.customerDomain,
            selectedCustomerDomainId: customerDomain.customerDomainId
        });
        // When customerDomain not ready: fallback to baseAttrs for UI events, null for critical events
        return allowFallback ? baseAttrs : null;
    }, [
        baseAttrs,
        customerDomain,
        allowFallback
    ]);
};

});

parcelRegister("h0mGD", function(module, exports) {

$parcel$export(module.exports, "useFastshiftAnalyticsData", function () { return $623b0bf7f16f3435$export$2b4091f90bc3079a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");

var $5wOn9 = parcelRequire("5wOn9");
parcelRequire("5XMUP");
var $gbLaZ = parcelRequire("gbLaZ");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");

var $k7z8r = parcelRequire("k7z8r");

var $e6NOY = parcelRequire("e6NOY");
parcelRequire("3rXRR");
var $aVSys = parcelRequire("aVSys");
var $ag6tB = parcelRequire("ag6tB");
const $623b0bf7f16f3435$export$2b4091f90bc3079a = (allowFallback = false)=>{
    const baseIdentityAttrs = (0, $aVSys.useBaseIdentityAttrs)();
    const customerIdentityAttrs = (0, $ag6tB.useCustomerIdentityAttrs)(allowFallback);
    const { domainId: domainId, fullPathname: fullPathname, paths: paths } = (0, $gbLaZ.useRoutes)();
    const { error: userDetailsError } = (0, $8KnwD.useFastshiftSelector)((state)=>state.userDetails);
    const loggedInUser = (0, $5wOn9.useLoggedInUser)();
    var _loggedInUser_email_split_;
    const userDomain = loggedInUser.email ? (_loggedInUser_email_split_ = loggedInUser.email.split("@")[1]) !== null && _loggedInUser_email_split_ !== void 0 ? _loggedInUser_email_split_ : "" : "";
    const sourceKey = (0, $iSvIT.useMemo)(()=>{
        if (userDetailsError) return (0, $e6NOY.getSourceKeyFromError)(userDetailsError);
        const pathToScreenMap = {
            [paths.selection]: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_SELECTION_SCREEN,
            [paths.partnerResources]: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_PARTNER_RESOURCES_SCREEN
        };
        // Add domain-scoped paths if they exist
        if (paths.domainScopedOverview) pathToScreenMap[paths.domainScopedOverview] = (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_FOR_YOU_SCREEN;
        if (paths.domainScopedPlanning) pathToScreenMap[paths.domainScopedPlanning] = (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN;
        if (paths.domainScopedResources) pathToScreenMap[paths.domainScopedResources] = (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_CUSTOMER_RESOURCES_SCREEN;
        return pathToScreenMap[fullPathname] || (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_404_SCREEN;
    }, [
        userDetailsError,
        fullPathname,
        paths
    ]);
    const isDomainScoped = !!domainId;
    const identityAttrs = (0, $iSvIT.useMemo)(()=>{
        const attrs = isDomainScoped ? customerIdentityAttrs : baseIdentityAttrs;
        if (userDetailsError && userDomain) return (0, $6iHNw._)((0, $7Knp0._)({}, attrs), {
            userDomain: userDomain
        });
        return attrs;
    }, [
        isDomainScoped,
        customerIdentityAttrs,
        baseIdentityAttrs,
        userDetailsError,
        userDomain
    ]);
    return {
        sourceKey: sourceKey,
        identityAttrs: identityAttrs
    };
};

});
parcelRegister("k7z8r", function(module, exports) {

$parcel$export(module.exports, "SourceKey", function () { return $0c9cfce89d1b4747$export$bfb20ca846513dde; });
$parcel$export(module.exports, "ActionKey", function () { return $0c9cfce89d1b4747$export$f4a12eb23846d703; });
$parcel$export(module.exports, "ActionSubjectKey", function () { return $0c9cfce89d1b4747$export$75d4c0092c8bfbec; });
$parcel$export(module.exports, "ActionSubjectIdKey", function () { return $0c9cfce89d1b4747$export$b272959d24ba2c3e; });
$parcel$export(module.exports, "SubjectAttributeKey", function () { return $0c9cfce89d1b4747$export$26783e579626c130; });
var $0c9cfce89d1b4747$export$bfb20ca846513dde;
(function(SourceKey) {
    // EAP
    SourceKey["FASTSHIFT_PORTAL_DASHBOARD_SCREEN"] = "fastshiftPortalDashboardScreen";
    // M2
    SourceKey["FASTSHIFT_PORTAL_SELECTION_SCREEN"] = "fastshiftPortalSelectionScreen";
    SourceKey["FASTSHIFT_PORTAL_FOR_YOU_SCREEN"] = "fastshiftPortalForYouScreen";
    SourceKey["FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN"] = "fastshiftPortalMigrationPlanningScreen";
    SourceKey["FASTSHIFT_PORTAL_CUSTOMER_RESOURCES_SCREEN"] = "fastshiftPortalCustomerResourcesScreen";
    SourceKey["FASTSHIFT_PORTAL_PARTNER_RESOURCES_SCREEN"] = "fastshiftPortalPartnerResourcesScreen";
    SourceKey["FASTSHIFT_PORTAL_INELIGIBLE_NO_LICENSE_SCREEN"] = "fastshiftPortalIneligibleNoLicenseScreen";
    SourceKey["FASTSHIFT_PORTAL_INELIGIBLE_NO_ACCESS_SCREEN"] = "fastshiftPortalIneligibleNoAccessScreen";
    SourceKey["FASTSHIFT_PORTAL_GENERIC_ERROR_SCREEN"] = "fastshiftPortalGenericErrorScreen";
    SourceKey["FASTSHIFT_PORTAL_404_SCREEN"] = "fastshiftPortal404Screen";
})($0c9cfce89d1b4747$export$bfb20ca846513dde || ($0c9cfce89d1b4747$export$bfb20ca846513dde = {}));
var $0c9cfce89d1b4747$export$f4a12eb23846d703;
(function(ActionKey) {
    ActionKey["DISPLAYED"] = "displayed";
    ActionKey["CLICKED"] = "clicked";
    ActionKey["SUBMITTED"] = "submitted";
})($0c9cfce89d1b4747$export$f4a12eb23846d703 || ($0c9cfce89d1b4747$export$f4a12eb23846d703 = {}));
var $0c9cfce89d1b4747$export$75d4c0092c8bfbec;
(function(ActionSubjectKey) {
    // General
    ActionSubjectKey["BUTTON"] = "button";
    ActionSubjectKey["DROPDOWN"] = "dropdown";
    ActionSubjectKey["FLAG"] = "flag";
    ActionSubjectKey["DROPDOWN_ITEM"] = "dropdownItem";
    ActionSubjectKey["MODAL"] = "modal";
    ActionSubjectKey["SECTION"] = "section";
    ActionSubjectKey["LINK"] = "link";
    ActionSubjectKey["SEARCH"] = "search";
    ActionSubjectKey["TABLE_COLUMN_SORT"] = "tableColumnSort";
})($0c9cfce89d1b4747$export$75d4c0092c8bfbec || ($0c9cfce89d1b4747$export$75d4c0092c8bfbec = {}));
var $0c9cfce89d1b4747$export$b272959d24ba2c3e;
(function(ActionSubjectIdKey) {
    // EAP - Dashboard Screen
    ActionSubjectIdKey["REQUEST_FASTSHIFT_ASSISTANCE_CARD"] = "requestFastshiftAssistanceCard";
    ActionSubjectIdKey["MIGRATION_PROGRESS_TABLE"] = "migrationProgressTable";
    ActionSubjectIdKey["FASTSHIFT_RESOURCES_CARD_LINK_CLICK"] = "fastshiftResourcesCardLinkClick";
    ActionSubjectIdKey["FASTSHIFT_MIGRATION_PROGRESS_TABLE_SHOW_MORE_BUTTON_CLICK"] = "fastshiftMigrationProgressTableShowMoreClick";
    ActionSubjectIdKey["FASTSHIFT_MIGRATION_PROGRESS_TABLE_COLUMN_SORT"] = "fastshiftMigrationProgressTableColumnSort";
    // Shared
    // EAP - Dashboard Screen & M2 - For You Screen
    ActionSubjectIdKey["ORG_SELECTOR_DROPDOWN"] = "orgSelectorDropdown";
    ActionSubjectIdKey["MIGRATION_SUMMARY_SECTION"] = "migrationSummarySection";
    ActionSubjectIdKey["FASTSHIFT_MIGRATION_PROGRESS_TABLE_OPEN_SUPPORT_TICKET_CLICK"] = "fastshiftMigrationProgressTableOpenSupportTicketClick";
    // EAP - Dashboard Screen & M2 - Relationships Section: For You Screen & Migration Planning Screen
    ActionSubjectIdKey["REQUEST_FASTSHIFT_ASSISTANCE_MODAL"] = "requestFastshiftAssistanceModal";
    ActionSubjectIdKey["REQUEST_FASTSHIFT_ASSISTANCE_MODAL_SUBMIT_BUTTON_CLICK"] = "fastshiftAssistanceModalCommentSubmitButtonClick";
    ActionSubjectIdKey["REQUEST_FASTSHIFT_ASSISTANCE_COMMENT_CONFIRMATION_FLAG"] = "postCommentOutcomeConfirmationFlag";
    // M2 - Selection Screen
    ActionSubjectIdKey["SELECTION_PAGE_DETAILS"] = "selectionPageDetails";
    ActionSubjectIdKey["SEE_DETAILS_BUTTON"] = "seeDetailsButton";
    ActionSubjectIdKey["DOMAIN_SELECTION_TABLE_SEARCH"] = "domainSelectionTableSearch";
    ActionSubjectIdKey["SELECTION_TABLE_PAGE_NAVIGATION_BUTTON"] = "selectionTablePageNavigationButton";
    ActionSubjectIdKey["SELECTION_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM"] = "selectionTableChangePageSizeDropdownItem";
    ActionSubjectIdKey["SELECTION_TABLE_COLUMN_SORT"] = "selectionTableColumnSort";
    // M2 - For You Screen
    ActionSubjectIdKey["FOR_YOU_PAGE_DETAILS"] = "forYouPageDetails";
    ActionSubjectIdKey["FASTSHIFT_MIGRATION_PROGRESS_TABLE_PAGE_NAVIGATION_BUTTON"] = "fastshiftMigrationProgressTablePageNavigationButton";
    ActionSubjectIdKey["FASTSHIFT_MIGRATION_PROGRESS_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM"] = "fastshiftMigrationProgressTableChangePageSizeDropdownItem";
    // M2 - Migration Planning Screen
    ActionSubjectIdKey["MIGRATION_PLANNER_EMBED_SECTION"] = "migrationPlannerEmbedSection";
    ActionSubjectIdKey["EMBED_VIEW_TYPE_TOGGLE_BUTTON"] = "embedViewTypeToggleButton";
    ActionSubjectIdKey["SELECT_BOARD_DROPDOWN_ITEM"] = "selectBoardDropdownItem";
    ActionSubjectIdKey["JIRA_EMBED_LINK"] = "jiraEmbedLink";
    // M2 - Partner Resources Screen & Customer Resources Screen
    ActionSubjectIdKey["RESOURCE_FILTER"] = "resourceFilter";
    ActionSubjectIdKey["RESOURCE_LINK"] = "resourceLink";
    ActionSubjectIdKey["USEFUL_LINK"] = "usefulLink";
    // M2 - Relationships Section: For You Screen & Migration Planning Screen
    ActionSubjectIdKey["REQUEST_ASSISTANCE_BUTTON"] = "requestAssistanceButton";
    ActionSubjectIdKey["FASTSHIFT_RELATIONSHIPS_SECTION"] = "fastshiftRelationshipsSection";
    // M2 - Fastshift Ineligible Screen
    ActionSubjectIdKey["GO_BACK_BUTTON"] = "goBackButton";
    ActionSubjectIdKey["SIGN_IN_WITH_ANOTHER_ACCOUNT_BUTTON"] = "signInWithAnotherAccountButton";
    ActionSubjectIdKey["CONTACT_SUPPORT_LINK"] = "contactSupportLink";
    // M2 -404 Display
    ActionSubjectIdKey["GO_BACK_TO_HOME_LINK"] = "goBackToHomeLink";
    // M2 - Across All Screens
    ActionSubjectIdKey["SIDE_NAV_LINK"] = "sideNavLink";
    ActionSubjectIdKey["CUSTOMER_SELECTION_BACK_LINK"] = "customerSelectionBackLink";
    // Feedback Collector
    ActionSubjectIdKey["FEEDBACK_COLLECTOR_OPEN_BUTTON"] = "feedbackCollectorOpenButton";
    ActionSubjectIdKey["FEEDBACK_COLLECTOR_SUBMIT_BUTTON"] = "feedbackCollectorSubmitButton";
})($0c9cfce89d1b4747$export$b272959d24ba2c3e || ($0c9cfce89d1b4747$export$b272959d24ba2c3e = {}));
var $0c9cfce89d1b4747$export$26783e579626c130;
(function(SubjectAttributeKey) {
    // EAP - Dashboard Screen
    SubjectAttributeKey["SEARCH_SUPPORT"] = "Search Support";
    SubjectAttributeKey["ATLASSIAN_COMMUNITY"] = "Atlassian Community";
    SubjectAttributeKey["ATLASSIAN_DOCUMENTATION"] = "Atlassian Documentation";
    // Shared: EAP - Dashboard Screen & M2 - For You Screen
    SubjectAttributeKey["VIEW_ASSESSMENTS"] = "View Assessments";
    SubjectAttributeKey["VIEW_MIGRATIONS"] = "View Migrations";
})($0c9cfce89d1b4747$export$26783e579626c130 || ($0c9cfce89d1b4747$export$26783e579626c130 = {}));

});

parcelRegister("e6NOY", function(module, exports) {

$parcel$export(module.exports, "getSourceKeyFromError", function () { return $904faa3cc84ed194$export$1d05dc8456901303; });

var $k7z8r = parcelRequire("k7z8r");

var $gkhN4 = parcelRequire("gkhN4");
const $904faa3cc84ed194$export$1d05dc8456901303 = (userDetailsError)=>{
    switch(userDetailsError){
        case (0, $gkhN4.FastshiftUserDetailsExpectedError).NO_ELIGIBLE_LICENSE:
            return (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_INELIGIBLE_NO_LICENSE_SCREEN;
        case (0, $gkhN4.FastshiftUserDetailsExpectedError).NO_ACCESS:
            return (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_INELIGIBLE_NO_ACCESS_SCREEN;
        default:
            return (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_GENERIC_ERROR_SCREEN;
    }
};

});



parcelRegister("9aD4b", function(module, exports) {

});



parcelRegister("jAoD1", function(module, exports) {

$parcel$export(module.exports, "useRelationshipsPageAnalytics", function () { return $23258e3f68d4a76e$export$5e811d905fce1292; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $h0mGD = parcelRequire("h0mGD");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
const $23258e3f68d4a76e$export$5e811d905fce1292 = (relationships)=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $h0mGD.useFastshiftAnalyticsData)();
    const { fireTrackEvent: fireTrackEvent } = (0, $ih47h.useFireAnalyticsEvents)();
    // Track event for relationships section displayed
    (0, $iSvIT.useEffect)(()=>{
        if (!identityAttrs) return;
        const fastshiftRelationships = relationships.map((r)=>r.type);
        const hasCustomerFastshiftChampion = relationships.some((r)=>r.type === "FAST_SHIFT_CHAMPION");
        fireTrackEvent({
            action: (0, $k7z8r.ActionKey).DISPLAYED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).SECTION,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).FASTSHIFT_RELATIONSHIPS_SECTION,
            source: sourceKey,
            attributes: {
                hasCustomerFastshiftChampion: hasCustomerFastshiftChampion,
                fastshiftRelationships: fastshiftRelationships
            }
        });
    }, [
        fireTrackEvent,
        identityAttrs,
        sourceKey,
        relationships
    ]);
};

});


parcelRegister("kxNHH", function(module, exports) {

$parcel$export(module.exports, "RequestAssistanceModal", function () { return (parcelRequire("ivzWG")).RequestAssistanceModal; });

var $ivzWG = parcelRequire("ivzWG");

});
parcelRegister("ivzWG", function(module, exports) {

$parcel$export(module.exports, "RequestAssistanceModal", function () { return $eb2bae77b83c5b95$export$2e4cd6d66faa547e; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $gf1F9 = parcelRequire("gf1F9");

var $8KELJ = parcelRequire("8KELJ");
var $hsvIJ = parcelRequire("hsvIJ");
var $bh8PA = parcelRequire("bh8PA");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");

var $6k5Ux = parcelRequire("6k5Ux");
parcelRequire("2T6pW");
var $kCIZI = parcelRequire("kCIZI");

var $ddzL3 = parcelRequire("ddzL3");

var $5P444 = parcelRequire("5P444");
parcelRequire("d1BgY");
var $awOw7 = parcelRequire("awOw7");
parcelRequire("elg6r");
var $3Bhg4 = parcelRequire("3Bhg4");
parcelRequire("73xnO");
var $be0VM = parcelRequire("be0VM");
const $eb2bae77b83c5b95$export$2e4cd6d66faa547e = ({ isModalOpen: isModalOpen, setIsModalOpen: setIsModalOpen })=>{
    const { data: supportRequestsData, pending: isSupportRequestsLoading } = (0, $8KnwD.useFastshiftSelector)((state)=>state.supportRequests);
    const { sendRequestAssistanceModalDisplayedTrackEvent: sendRequestAssistanceModalDisplayedTrackEvent } = (0, $kCIZI.useRelationshipsAnalytics)();
    const handleCloseModal = ()=>{
        setIsModalOpen(false);
    };
    const openTicketCount = supportRequestsData.filter((request)=>(0, $ddzL3.isSupportRequestOpen)(request.status)).length;
    // Track modal displayed event when modal opens
    (0, $iSvIT.useEffect)(()=>{
        if (isModalOpen && !isSupportRequestsLoading) {
            const isEmpty = openTicketCount === 0;
            sendRequestAssistanceModalDisplayedTrackEvent(isEmpty, openTicketCount);
        }
    }, [
        isModalOpen,
        isSupportRequestsLoading,
        openTicketCount,
        sendRequestAssistanceModalDisplayedTrackEvent
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bh8PA.default), {
            children: isModalOpen && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8KELJ.default), {
                onClose: handleCloseModal,
                testId: "request-assistance-modal",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $hsvIJ.default), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                                size: "medium",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $5P444.messages).requestAssistanceModalTitle))
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6k5Ux.CloseModalButton), {
                                onCloseClick: handleCloseModal
                            })
                        ]
                    }),
                    isSupportRequestsLoading ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $be0VM.RequestAssistanceModalLoader), {}) : openTicketCount > 0 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Bhg4.FastshiftAssistanceModalForm), {
                        handleCloseModal: handleCloseModal,
                        supportRequests: supportRequestsData,
                        isSupportRequestsLoading: isSupportRequestsLoading
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $awOw7.RequestAssistanceModalEmpty), {
                        handleCloseModal: handleCloseModal
                    })
                ]
            })
        })
    });
};

});
parcelRegister("ddzL3", function(module, exports) {

$parcel$export(module.exports, "findChampion", function () { return $31e99f9b927cc90c$export$9ddc6abef4422108; });
$parcel$export(module.exports, "filterEngineers", function () { return $31e99f9b927cc90c$export$8b32d0c78f83fe94; });
$parcel$export(module.exports, "mapRelationships", function () { return $31e99f9b927cc90c$export$df049a3bbd6d9380; });
$parcel$export(module.exports, "isSupportRequestOpen", function () { return $31e99f9b927cc90c$export$cdaa26bc186b101c; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");
const $31e99f9b927cc90c$export$9ddc6abef4422108 = (relationships)=>{
    const rawCampionData = relationships === null || relationships === void 0 ? void 0 : relationships.find((rel)=>rel.type === "FAST_SHIFT_CHAMPION");
    return rawCampionData ? (0, $6iHNw._)((0, $7Knp0._)({}, rawCampionData), {
        title: "Fastshift Champion"
    }) : undefined;
};
const $31e99f9b927cc90c$export$38d3b01fb880f962 = (relationships)=>{
    return relationships === null || relationships === void 0 ? void 0 : relationships.find((rel)=>rel.type === "ACCOUNT_EXECUTIVE");
};
const $31e99f9b927cc90c$export$8fa5216841a4aa79 = (relationships)=>{
    return relationships === null || relationships === void 0 ? void 0 : relationships.find((rel)=>rel.type === "CUSTOMER_SUCCESS_MANAGER");
};
const $31e99f9b927cc90c$export$8b32d0c78f83fe94 = (relationships)=>{
    return (relationships === null || relationships === void 0 ? void 0 : relationships.filter((rel)=>rel.type === "MIGRATION_SUPPORT_ENGINEER").map(({ name: name, imageUrl: imageUrl }, index)=>({
            id: `${name}-${index}`,
            name: name,
            title: "Migration Support Engineer",
            imageUrl: imageUrl
        }))) || [];
};
const $31e99f9b927cc90c$export$df049a3bbd6d9380 = (relationships)=>{
    const champion = $31e99f9b927cc90c$export$9ddc6abef4422108(relationships);
    return {
        fastshiftChampion: champion ? (0, $6iHNw._)((0, $7Knp0._)({}, champion), {
            title: "Fastshift Champion"
        }) : undefined,
        accountExecutive: $31e99f9b927cc90c$export$38d3b01fb880f962(relationships),
        customerSuccessManager: $31e99f9b927cc90c$export$8fa5216841a4aa79(relationships)
    };
};
const $31e99f9b927cc90c$export$cdaa26bc186b101c = (status)=>{
    const upperStatus = status.toUpperCase();
    return upperStatus !== "CLOSED" && upperStatus !== "DONE" && upperStatus !== "COMPLETED";
};

});

parcelRegister("5P444", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $f791f4e7eadb97e4$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $f791f4e7eadb97e4$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    requestAssistanceModalDescription: {
        id: "request.assistance.modal.description",
        defaultMessage: "Add a comment to a chosen ticket to receive the FastShift team\u2019s help.",
        description: "Description for the FastShift assistance modal"
    },
    requestAssistanceModalTitle: {
        id: "request.assistance.modal.title",
        defaultMessage: "Request FastShift assistance",
        description: "Title for the FastShift assistance modal"
    },
    requestAssistanceModalSubtitleNote: {
        id: "request.assistance.modal.subtitle-note",
        defaultMessage: "Required fields are marked with an asterisk",
        description: "Subtitle note for the FastShift assistance modal, describing that form fields with an asterisk are required"
    },
    requestAssistanceModalDropdownLabel: {
        id: "request.assistance.modal.dropdown-label",
        defaultMessage: "Select a MOVE ticket",
        description: "Label for the FastShift assistance modal dropdown where users can select a MOVE ticket"
    },
    requestAssistanceModalCommentLabel: {
        id: "request.assistance.modal.comment-label",
        defaultMessage: "Add a comment to the ticket",
        description: "Label for comment field in fastshift assistance modal"
    },
    requestAssistanceModalSendButton: {
        id: "request.assistance.modal.send-button",
        defaultMessage: "Send",
        description: "Button text for sending the comment to the selected move ticket, on the fastshift assistance modal"
    },
    requestAssistanceModalCancelButton: {
        id: "request.assistance.modal.cancel-button",
        defaultMessage: "Cancel",
        description: "Button text for closing the fastshift assistance modal"
    },
    requestAssistanceModalFailedRequestMessage: {
        id: "request.assistance.modal.failed-request-error-message",
        defaultMessage: "An error occurred. Please try again later",
        description: "Message shown if there is a server error when trying to create a comment after hitting send"
    },
    requestAssistanceModalFieldIsRequiredMessage: {
        id: "request.assistance.modal.form-field-required",
        defaultMessage: "This field is required",
        description: "Error message when user doesn't fill in a required field"
    },
    requestAssistanceModalSuccessFlagTitle: {
        id: "request.assistance.modal.success-flag-title",
        defaultMessage: "Comment created",
        description: "Title for flag shown when a comment is successfully created on a migration support ticket"
    },
    requestAssistanceModalSuccessFlagDescription: {
        id: "request.assistance.modal.success-flag-description",
        defaultMessage: "Comment has been successfully created.",
        description: "Description for flag shown when a comment is successfully created on a migration support ticket"
    },
    requestAssistanceModalSuccessFlagAction: {
        id: "request.assistance.modal.success-flag-action",
        defaultMessage: "View ticket",
        description: "Text for a link that will redirect customer to view their migration support ticket (to which they just posted a comment)"
    },
    requestAssistanceModalErrorFlagTitle: {
        id: "request.assistance.modal.error-flag-title",
        defaultMessage: "An error occurred",
        description: "Title for flag shown when there is an error creating a comment on a migration support ticket"
    },
    requestAssistanceModalErrorFlagDescription: {
        id: "request.assistance.modal.success-flag-description",
        defaultMessage: "Please try again later.",
        description: "Description for flag shown when there is an error creating a comment on a migration support ticket"
    },
    requestAssistanceModalEmptyDescription: {
        id: "request.assistance.modal.empty.description",
        defaultMessage: "You don\u2019t have any existing migration support tickets. To request assistance,\xa0please create one.",
        description: "Description for the FastShift assistance modal when the customer has no open support tickets"
    },
    requestAssistanceModalEmptyModalRaiseTicketButton: {
        id: "request.assistance.modal.empty.raise-ticket-button",
        defaultMessage: "Raise ticket",
        description: "Button to redirect to another website to raise a new support request"
    }
});

});

parcelRegister("d1BgY", function(module, exports) {

$parcel$export(module.exports, "RequestAssistanceModalEmpty", function () { return (parcelRequire("awOw7")).RequestAssistanceModalEmpty; });

var $awOw7 = parcelRequire("awOw7");

});
parcelRegister("awOw7", function(module, exports) {

$parcel$export(module.exports, "RequestAssistanceModalEmpty", function () { return $fb096e34fccfa77f$export$c2e8b7e5d248223e; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $9B16h = parcelRequire("9B16h");
var $bM10s = parcelRequire("bM10s");

var $7VPzO = parcelRequire("7VPzO");
var $cxMms = parcelRequire("cxMms");

var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");

var $9OyVr = parcelRequire("9OyVr");

var $5P444 = parcelRequire("5P444");
const $fb096e34fccfa77f$export$c2e8b7e5d248223e = ({ handleCloseModal: handleCloseModal })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7VPzO.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cgOuH.default), {
                    space: "space.200",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $5P444.messages).requestAssistanceModalEmptyDescription))
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cxMms.default), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                        appearance: "subtle",
                        onClick: handleCloseModal,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $5P444.messages).requestAssistanceModalCancelButton))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bM10s.default), {
                        appearance: "primary",
                        target: "_blank",
                        href: `${(0, $9OyVr.SAC_URL)}/contact`,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $5P444.messages).requestAssistanceModalEmptyModalRaiseTicketButton))
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("bM10s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8924f539add32f65$export$2e2bcd8739ae039; });
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $72NmR = parcelRequire("72NmR");

var $cJhvT = parcelRequire("cJhvT");

var $iSvIT = parcelRequire("iSvIT");


var $gmylQ = parcelRequire("gmylQ");

var $lL4Ma = parcelRequire("lL4Ma");

var $dyf9a = parcelRequire("dyf9a");

var $jxLBU = parcelRequire("jxLBU");

var $352yd = parcelRequire("352yd");

var $MIq2I = parcelRequire("MIq2I");

var $kMg75 = parcelRequire("kMg75");
var $8924f539add32f65$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "href",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId"
], $8924f539add32f65$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $8924f539add32f65$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    fullWidth: "_1bsb1osq"
};
var $8924f539add32f65$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $8924f539add32f65$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $8924f539add32f65$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $8924f539add32f65$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $8924f539add32f65$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $8924f539add32f65$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $8924f539add32f65$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l31pke _1di619ru _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $8924f539add32f65$var$LinkButtonBase = function LinkButtonBase(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, unsafeRest = (0, $cJhvT.default)(_ref, $8924f539add32f65$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $cJhvT.default)(unsafeRest, $8924f539add32f65$var$_excluded2);
    var hasIconAfter = Boolean(iconAfter);
    var hasIconBefore = Boolean(iconBefore);
    var localRef = (0, $iSvIT.useRef)(null);
    (0, $dyf9a.default)(localRef, autoFocus);
    var combinedRef = (0, $lL4Ma.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ $iSvIT.createElement((0, $352yd.default), (0, $72NmR.default)({
        analyticsContext: analyticsContext,
        ref: combinedRef,
        href: isDisabled ? undefined : href,
        role: isDisabled ? "link" : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName
    }, saferRest, {
        xcss: (0, $gmylQ.cx)($8924f539add32f65$var$styles.base, appearance === "default" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $8924f539add32f65$var$defaultStyles.rootRefreshed : $8924f539add32f65$var$defaultStyles.root), appearance === "primary" && $8924f539add32f65$var$primaryStyles.root, appearance === "warning" && $8924f539add32f65$var$warningStyles.root, appearance === "danger" && $8924f539add32f65$var$dangerStyles.root, appearance === "discovery" && $8924f539add32f65$var$discoveryStyles.root, appearance === "subtle" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $8924f539add32f65$var$subtleStyles.rootRefreshed : $8924f539add32f65$var$subtleStyles.root), $8924f539add32f65$var$styles.linkDecorationUnset, isSelected && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $8924f539add32f65$var$selectedStyles.rootRefreshed : $8924f539add32f65$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "danger" && $8924f539add32f65$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "warning" && $8924f539add32f65$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $8924f539add32f65$var$selectedStyles.discovery, isDisabled && $8924f539add32f65$var$styles.disabled, spacing === "compact" && $8924f539add32f65$var$styles.spacingCompact, hasIconBefore && $8924f539add32f65$var$styles.buttonIconBefore, hasIconAfter && $8924f539add32f65$var$styles.buttonIconAfter, shouldFitContainer && $8924f539add32f65$var$styles.fullWidth)
    }), iconBefore && /*#__PURE__*/ $iSvIT.createElement((0, $MIq2I.default), {
        type: "icon",
        position: "before",
        isLoading: false
    }, /*#__PURE__*/ $iSvIT.createElement((0, $kMg75.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ $iSvIT.createElement((0, $MIq2I.default), {
        isLoading: false
    }, children), iconAfter && /*#__PURE__*/ $iSvIT.createElement((0, $MIq2I.default), {
        type: "icon",
        position: "after",
        isLoading: false
    }, /*#__PURE__*/ $iSvIT.createElement((0, $kMg75.default), {
        icon: iconAfter
    })));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $8924f539add32f65$var$LinkButton = /*#__PURE__*/ (0, $iSvIT.forwardRef)($8924f539add32f65$var$LinkButtonBase);
$8924f539add32f65$var$LinkButton.displayName = "LinkButton";
var $8924f539add32f65$export$2e2bcd8739ae039 = $8924f539add32f65$var$LinkButton;

});
parcelRegister("352yd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23e3d1496c915c7f$export$2e2bcd8739ae039; });
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $72NmR = parcelRequire("72NmR");

var $dldEl = parcelRequire("dldEl");

var $cJhvT = parcelRequire("cJhvT");

var $iSvIT = parcelRequire("iSvIT");


var $iSupW = parcelRequire("iSupW");

var $jNYFj = parcelRequire("jNYFj");

var $1OPAa = parcelRequire("1OPAa");

var $ivTXh = parcelRequire("ivTXh");

var $4OZuI = parcelRequire("4OZuI");

var $dWwnB = parcelRequire("dWwnB");

var $7nG8r = parcelRequire("7nG8r");

var $eTo1d = parcelRequire("eTo1d");

var $ad8Y3 = parcelRequire("ad8Y3");
var $23e3d1496c915c7f$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $23e3d1496c915c7f$var$_excluded2 = [
    "className"
];
var $23e3d1496c915c7f$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi"
};
var $23e3d1496c915c7f$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $23e3d1496c915c7f$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $23e3d1496c915c7f$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $4OZuI.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? "(opens new window)" : _ref$newWindowLabel, htmlAttributes = (0, $cJhvT.default)(_ref, $23e3d1496c915c7f$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $dWwnB.useId)();
    var onClick = (0, $1OPAa.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.0",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $cJhvT.default)(htmlAttributes, $23e3d1496c915c7f$var$_excluded2);
    var RouterLink = (0, $ivTXh.default)();
    var isExternal = typeof href === "string" && $23e3d1496c915c7f$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $23e3d1496c915c7f$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $dldEl.default)(href) === "object";
    (0, $jNYFj.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return /*#__PURE__*/ $iSvIT.createElement((0, $ad8Y3.default), (0, $72NmR.default)({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $iSupW.cx)($23e3d1496c915c7f$var$styles.root, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $iSvIT.createElement((0, $eTo1d.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $23e3d1496c915c7f$var$Anchor = /*#__PURE__*/ (0, $iSvIT.forwardRef)($23e3d1496c915c7f$var$AnchorNoRef);
var $23e3d1496c915c7f$export$2e2bcd8739ae039 = $23e3d1496c915c7f$var$Anchor;

});
parcelRegister("ivTXh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7a686c744b446c9$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $gG1qa = parcelRequire("gG1qa");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $d7a686c744b446c9$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $iSvIT.useContext)((0, $gG1qa.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $d7a686c744b446c9$export$2e2bcd8739ae039 = $d7a686c744b446c9$var$useRouterLink;

});
parcelRegister("gG1qa", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $c241abcb059b83d9$export$2931e0ee690eee88; });

var $iSvIT = parcelRequire("iSvIT");
var $c241abcb059b83d9$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $iSvIT.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $c241abcb059b83d9$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($c241abcb059b83d9$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $c241abcb059b83d9$export$2e2bcd8739ae039 = $c241abcb059b83d9$var$RouterLinkProvider;

});




parcelRegister("7VPzO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c65dd54e3b9fea3$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $cpjHB = parcelRequire("cpjHB");

var $ecRo7 = parcelRequire("ecRo7");

var $bmh4x = parcelRequire("bmh4x");

var $jYs0i = parcelRequire("jYs0i");

var $gOh1f = parcelRequire("gOh1f");
var $5c65dd54e3b9fea3$var$bodyStyles = (0, $2ZUkg.css)({
    /* This ensures the body fills the whole space between header and footer. */ flex: "1 1 auto"
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ var $5c65dd54e3b9fea3$var$bodyScrollStyles = (0, $2ZUkg.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingBlock: (0, $jYs0i.keylineHeight),
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $5c65dd54e3b9fea3$var$viewportScrollStyles = (0, $2ZUkg.css)({
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $5c65dd54e3b9fea3$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $ecRo7.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $gOh1f.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $2ZUkg.jsx)("div", {
        css: [
            $5c65dd54e3b9fea3$var$bodyStyles,
            $5c65dd54e3b9fea3$var$viewportScrollStyles
        ],
        "data-testid": testId
    }, children) : (0, $2ZUkg.jsx)((0, $cpjHB.TouchScrollable), null, (0, $2ZUkg.jsx)((0, $bmh4x.default), {
        testId: userDefinedTestId || modalTestId
    }, (0, $2ZUkg.jsx)("div", {
        css: [
            $5c65dd54e3b9fea3$var$bodyStyles,
            $5c65dd54e3b9fea3$var$bodyScrollStyles
        ],
        "data-testid": testId
    }, children)));
};
var $5c65dd54e3b9fea3$export$2e2bcd8739ae039 = $5c65dd54e3b9fea3$var$ModalBody;

});
parcelRegister("bmh4x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $844efdf432c49ff2$export$2e2bcd8739ae039; });

var $kqVUu = parcelRequire("kqVUu");

var $7E4Ax = parcelRequire("7E4Ax");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $2e1kT = parcelRequire("2e1kT");

var $kA3CX = parcelRequire("kA3CX");

var $OOAI0 = parcelRequire("OOAI0");

var $8sPhw = parcelRequire("8sPhw");

var $ec0kq = parcelRequire("ec0kq");

var $ge0or = parcelRequire("ge0or");

var $hFf4Q = parcelRequire("hFf4Q");

var $jYs0i = parcelRequire("jYs0i");
var $844efdf432c49ff2$var$baseStyles = (0, $2ZUkg.css)((0, $7E4Ax.default)({
    display: "inherit",
    margin: "var(--ds-space-0, 0px)",
    flex: "inherit",
    flexDirection: "inherit",
    flexGrow: 1,
    overflowX: "hidden",
    overflowY: "auto"
}, (0, $hFf4Q.media).above.xs, {
    height: "unset",
    overflowY: "auto"
}));
var $844efdf432c49ff2$var$topKeylineStyles = (0, $2ZUkg.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockStart: "".concat((0, $jYs0i.keylineHeight), "px solid ").concat((0, $jYs0i.keylineColor))
});
var $844efdf432c49ff2$var$bottomKeylineStyles = (0, $2ZUkg.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: "".concat((0, $jYs0i.keylineHeight), "px solid ").concat((0, $jYs0i.keylineColor))
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $844efdf432c49ff2$var$ScrollContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $iSvIT.useRef)(null);
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $kqVUu.default)(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(false), _useState4 = (0, $kqVUu.default)(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)(false), _useState6 = (0, $kqVUu.default)(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $iSvIT.useEffect)(function() {
        var schedule = (0, $kA3CX.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $ec0kq.default)((0, $kA3CX.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > (0, $jYs0i.keylineHeight));
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $jYs0i.keylineHeight));
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $iSvIT.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $2e1kT.bind)(window, {
            type: "resize",
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $2e1kT.bind)(target, {
            type: "scroll",
            listener: setLazyKeylines
        }) : (0, $8sPhw.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return (0, $2ZUkg.jsx)((0, $ge0or.default), {
        isInset: true
    }, (0, $2ZUkg.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? "region" : undefined,
        "aria-label": showContentFocus ? "Scrollable content" : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $OOAI0.default)([
            ref,
            scrollableRef
        ]),
        css: [
            $844efdf432c49ff2$var$baseStyles,
            showTopKeyline && $844efdf432c49ff2$var$topKeylineStyles,
            showBottomKeyline && $844efdf432c49ff2$var$bottomKeylineStyles
        ]
    }, children));
});
$844efdf432c49ff2$var$ScrollContainer.displayName = "ScrollContainer";
var $844efdf432c49ff2$export$2e2bcd8739ae039 = $844efdf432c49ff2$var$ScrollContainer;

});

parcelRegister("gOh1f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3ce848001e92412$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $1vn5c = parcelRequire("1vn5c");
function $c3ce848001e92412$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $iSvIT.useContext)((0, $1vn5c.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("cxMms", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $921e14a6d2d76c7f$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2ZUkg = parcelRequire("2ZUkg");

var $ecRo7 = parcelRequire("ecRo7");

var $jYs0i = parcelRequire("jYs0i");
var $921e14a6d2d76c7f$var$footerStyles = (0, $2ZUkg.css)({
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginBlockStart: -(0, $jYs0i.keylineHeight),
    paddingBlockEnd: "var(--ds-space-300, 24px)",
    paddingBlockStart: "var(--ds-space-200, 16px)",
    paddingInline: "var(--ds-space-300, 24px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $921e14a6d2d76c7f$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $ecRo7.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $2ZUkg.jsx)("div", {
        css: $921e14a6d2d76c7f$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $921e14a6d2d76c7f$export$2e2bcd8739ae039 = $921e14a6d2d76c7f$var$ModalFooter;

});



parcelRegister("elg6r", function(module, exports) {

$parcel$export(module.exports, "FastshiftAssistanceModalForm", function () { return (parcelRequire("3Bhg4")).FastshiftAssistanceModalForm; });

var $3Bhg4 = parcelRequire("3Bhg4");

});
parcelRegister("3Bhg4", function(module, exports) {

$parcel$export(module.exports, "FastshiftAssistanceModalForm", function () { return $702edf8ca8c5b964$export$478b41a5c5725fea; });
/* request-assistance-modal-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $lw4Qf = parcelRequire("lw4Qf");

var $9B16h = parcelRequire("9B16h");

var $6oKbD = parcelRequire("6oKbD");
var $hGQlB = parcelRequire("hGQlB");
var $26kkA = parcelRequire("26kkA");
var $2IHui = parcelRequire("2IHui");

var $7VPzO = parcelRequire("7VPzO");
var $cxMms = parcelRequire("cxMms");

var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");

var $c9Cls = parcelRequire("c9Cls");

var $7mrZY = parcelRequire("7mrZY");

var $gkhN4 = parcelRequire("gkhN4");

var $adqfu = parcelRequire("adqfu");

var $9OyVr = parcelRequire("9OyVr");
parcelRequire("2T6pW");
var $kCIZI = parcelRequire("kCIZI");

var $ddzL3 = parcelRequire("ddzL3");

var $5P444 = parcelRequire("5P444");

var $fuwlX = parcelRequire("fuwlX");
const $702edf8ca8c5b964$var$StyledTextAreaWraper = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_12uszgxb",
            __cmplp.className
        ])
    }));
});
const $702edf8ca8c5b964$export$478b41a5c5725fea = ({ handleCloseModal: handleCloseModal, supportRequests: supportRequests, isSupportRequestsLoading: isSupportRequestsLoading })=>{
    const intl = (0, $f6qj2.default)();
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { showFlag: showFlag } = (0, $iSvIT.useContext)((0, $adqfu.default).Context);
    const { sendRequestAssistanceModalCommentSubmitButtonClickUIEvent: sendRequestAssistanceModalCommentSubmitButtonClickUIEvent, sendPostCommentOutcomeFlagDisplayedTrackEvent: sendPostCommentOutcomeFlagDisplayedTrackEvent } = (0, $kCIZI.useRelationshipsAnalytics)();
    const customerSupportRequestOptions = (0, $iSvIT.useMemo)(()=>supportRequests.filter((request)=>(0, $ddzL3.isSupportRequestOpen)(request.status)).map((request)=>{
            const productName = "";
            let siteDomainName = "";
            try {
                siteDomainName = request.destination.baseUrl ? new URL(request.destination.baseUrl).hostname : "";
            } catch (e) {
                siteDomainName = "";
            }
            return {
                label: `${request.supportTicketId} - ${request.title}`,
                site: siteDomainName,
                product: productName,
                value: request.supportTicketId
            };
        }), [
        supportRequests
    ]);
    const successFlag = (0, $iSvIT.useCallback)(({ ticketId: ticketId })=>{
        return {
            id: "success-flag",
            iconType: "success",
            styleOverride: true,
            autoDismiss: true,
            title: intl.formatMessage((0, $5P444.messages).requestAssistanceModalSuccessFlagTitle),
            description: intl.formatMessage((0, $5P444.messages).requestAssistanceModalSuccessFlagDescription),
            actions: [
                {
                    content: intl.formatMessage((0, $5P444.messages).requestAssistanceModalSuccessFlagAction),
                    href: `${(0, $9OyVr.SAC_URL)}/requests/${ticketId}`,
                    target: "_blank"
                }
            ]
        };
    }, [
        intl
    ]);
    const errorFlag = (0, $iSvIT.useMemo)(()=>{
        return {
            id: "error-flag",
            iconType: "error",
            styleOverride: true,
            autoDismiss: true,
            title: intl.formatMessage((0, $5P444.messages).requestAssistanceModalErrorFlagTitle),
            description: intl.formatMessage((0, $5P444.messages).requestAssistanceModalErrorFlagDescription)
        };
    }, [
        intl
    ]);
    const createMoveTicketCommentRequest = ({ stargateClient: stargateClient, issueId: issueId, comment: comment })=>{
        return new Promise((resolve, reject)=>(0, $fuwlX.createMoveTicketComment)({
                stargateClient: stargateClient,
                issueId: issueId,
                comment: comment
            }).then((response)=>{
                var _response_data_customerSupport, _response_data;
                if (!response || !(response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_customerSupport = _response_data.customerSupport) === null || _response_data_customerSupport === void 0 ? void 0 : _response_data_customerSupport.addComment)) // if response payload is not valid, the comment was not created, regardless of the HTTP status code
                reject(new Error("Server failed to execute the request - comment was not created"));
                resolve(response);
            }).catch((error)=>{
                reject(error);
            }));
    }; // Search for items by ticket id, summary, site domain name, or product name
    const searchDropdownOptions = (option, inputValue)=>{
        const lowerCaseInputValue = inputValue.toLowerCase();
        return option.label.toLowerCase().includes(lowerCaseInputValue) || option.site.toLowerCase().startsWith(lowerCaseInputValue) || option.product.toLowerCase().startsWith(lowerCaseInputValue);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: (data)=>{
            // validate form fields
            if (!data.ticketId || !data.comment) {
                const errors = {
                    ticketId: !data.ticketId ? intl.formatMessage((0, $5P444.messages).requestAssistanceModalFieldIsRequiredMessage) : undefined,
                    comment: !data.comment ? intl.formatMessage((0, $5P444.messages).requestAssistanceModalFieldIsRequiredMessage) : undefined
                };
                return errors;
            } // Fire UI event for button click
            sendRequestAssistanceModalCommentSubmitButtonClickUIEvent(data.ticketId.value);
            return createMoveTicketCommentRequest({
                stargateClient: stargateClient,
                issueId: data.ticketId.value,
                comment: data.comment
            }).then(()=>{
                // Show success flag and track event
                showFlag(successFlag({
                    ticketId: data.ticketId.value
                }));
                sendPostCommentOutcomeFlagDisplayedTrackEvent(true, data.ticketId.value);
                handleCloseModal();
            }).catch((error)=>{
                console.error(error); // Show error flag and track event
                showFlag(errorFlag);
                sendPostCommentOutcomeFlagDisplayedTrackEvent(false, data.ticketId.value);
            });
        },
        children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7VPzO.default), {
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                            space: "space.200",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $hGQlB.HelperMessage), {
                                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5P9nB.default), {
                                        color: "color.text.subtle",
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $5P444.messages).requestAssistanceModalSubtitleNote)),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2IHui.default), {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                                    space: "space.100",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                                            color: "color.text.subtle",
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $5P444.messages).requestAssistanceModalDescription))
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
                                            name: "ticketId",
                                            label: intl.formatMessage((0, $5P444.messages).requestAssistanceModalDropdownLabel),
                                            "aria-required": true,
                                            isRequired: true,
                                            children: (_param)=>/*#__PURE__*/ {
                                                var { fieldProps: { id: id }, error: error } = _param, rest = (0, $akGnX._)(_param.fieldProps, [
                                                    "id"
                                                ]);
                                                return (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $c9Cls.default), (0, $6iHNw._)((0, $7Knp0._)({
                                                            inputId: id
                                                        }, rest), {
                                                            options: customerSupportRequestOptions,
                                                            maxMenuHeight: 200,
                                                            isLoading: isSupportRequestsLoading,
                                                            filterOption: (option, inputValue)=>{
                                                                return searchDropdownOptions(option.data, inputValue);
                                                            }
                                                        })),
                                                        error && /*#__PURE__*/ (0, $loA2J.jsx)((0, $hGQlB.ErrorMessage), {
                                                            children: error
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)($702edf8ca8c5b964$var$StyledTextAreaWraper, {
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
                                                "aria-required": true,
                                                name: "comment",
                                                label: intl.formatMessage((0, $5P444.messages).requestAssistanceModalCommentLabel),
                                                isRequired: true,
                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7mrZY.default), (0, $6iHNw._)((0, $7Knp0._)({
                                                                autoComplete: "off"
                                                            }, fieldProps), {
                                                                isRequired: false,
                                                                resize: "auto",
                                                                maxHeight: "30vh",
                                                                minimumRows: 7
                                                            })),
                                                            error && /*#__PURE__*/ (0, $loA2J.jsx)((0, $hGQlB.ErrorMessage), {
                                                                children: error
                                                            })
                                                        ]
                                                    })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cxMms.default), {
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $lw4Qf.default), {
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                                    appearance: "subtle",
                                    onClick: handleCloseModal,
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $5P444.messages).requestAssistanceModalCancelButton))
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                                    type: "submit",
                                    appearance: "primary",
                                    isLoading: submitting,
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $5P444.messages).requestAssistanceModalSendButton))
                                })
                            ]
                        })
                    })
                ]
            }))
    });
};

});
parcelRegister("lw4Qf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faa057951678af59$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");
var $faa057951678af59$var$buttonGroupStyles = (0, $2ZUkg.css)({
    display: "inline-flex",
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> *": {
        flex: "1 0 auto"
    }
});
function $faa057951678af59$export$2e2bcd8739ae039(_ref) {
    var appearance = _ref.appearance, children = _ref.children;
    return (0, $2ZUkg.jsx)("div", {
        css: $faa057951678af59$var$buttonGroupStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), {
            key: idx
        }, appearance ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).cloneElement(child, {
            appearance: appearance
        }) : child);
    }));
}

});

parcelRegister("adqfu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4893fe85016881f4$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $keA7J = parcelRequire("keA7J");
var $3Xksr = parcelRequire("3Xksr");
var $3PqZG = parcelRequire("3PqZG");

var $gf1F9 = parcelRequire("gf1F9");

var $1cFxM = parcelRequire("1cFxM");

var $bPtgt = parcelRequire("bPtgt");

var $5P9nB = parcelRequire("5P9nB");
const $4893fe85016881f4$var$CustomFlag = (_param)=>{
    var { iconType: iconType, autoDismiss: autoDismiss, styleOverride: styleOverride } = _param, props = (0, $akGnX._)(_param, [
        "iconType",
        "autoDismiss",
        "styleOverride"
    ]);
    const icon = iconType === "success" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPtgt))), {
        label: "success",
        color: "var(--ds-icon-success)",
        LEGACY_size: "large"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1cFxM))), {
        label: "error",
        color: "var(--ds-icon-danger)",
        LEGACY_size: "large"
    });
    // Wrapping text in ADS components resolves WAC and ADS Design System Conflicts for staging and production
    // note while props.actions do not display correctly in localhost, they do in stg and prod
    const styleOverrideProps = styleOverride ? {
        title: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
            size: "small",
            children: props.title
        }),
        description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
            children: props.description
        })
    } : {};
    if (autoDismiss) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $keA7J.default), (0, $7Knp0._)({
        icon: icon
    }, props, styleOverrideProps));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Xksr.default), (0, $7Knp0._)({
        icon: icon
    }, props, styleOverrideProps));
};
const $4893fe85016881f4$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    showFlag: ()=>{} // for instantiation only
});
const $4893fe85016881f4$export$b0063bae72b769ca = ({ children: children })=>{
    const [flags, setFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState([]);
    const showFlag = (config)=>{
        setFlags([
            config,
            ...flags
        ]);
    };
    const handleDismiss = ()=>{
        setFlags(flags.slice(1));
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)($4893fe85016881f4$export$2eb95677cf2465e1.Provider, {
        value: {
            showFlag: showFlag
        },
        children: [
            children,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3PqZG.default), {
                onDismissed: handleDismiss,
                children: flags.map((props, index)=>{
                    return /*#__PURE__*/ (0, $loA2J.jsx)($4893fe85016881f4$var$CustomFlag, (0, $7Knp0._)({}, props), `flag-${index}`);
                })
            })
        ]
    });
};
var $4893fe85016881f4$export$2e2bcd8739ae039 = {
    Provider: $4893fe85016881f4$export$b0063bae72b769ca,
    Context: $4893fe85016881f4$export$2eb95677cf2465e1
};

});
parcelRegister("keA7J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebb122e37dd7b707$export$2e2bcd8739ae039; });

var $5lV35 = parcelRequire("5lV35");

var $iSvIT = parcelRequire("iSvIT");

var $6e0wq = parcelRequire("6e0wq");

var $4OZuI = parcelRequire("4OZuI");

var $3Xksr = parcelRequire("3Xksr");

var $3PqZG = parcelRequire("3PqZG");
var $ebb122e37dd7b707$var$packageName = "@atlaskit/flag";
var $ebb122e37dd7b707$var$packageVersion = "17.1.8";
var $ebb122e37dd7b707$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ var $ebb122e37dd7b707$var$AutoDismissFlag = function AutoDismissFlag(props) {
    var id = props.id, analyticsContext = props.analyticsContext, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $4OZuI.default) : _props$onDismissed;
    var autoDismissTimer = (0, $iSvIT.useRef)(null);
    var _useFlagGroup = (0, $3PqZG.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $iSvIT.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var onDismissedAnalytics = (0, $6e0wq.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext,
        componentName: "flag",
        packageName: $ebb122e37dd7b707$var$packageName,
        packageVersion: $ebb122e37dd7b707$var$packageVersion
    });
    var isAutoDismissAllowed = isDismissAllowed && onDismissed;
    var dismissFlag = (0, $iSvIT.useCallback)(function() {
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    var stopAutoDismissTimer = (0, $iSvIT.useCallback)(function() {
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    var startAutoDismissTimer = (0, $iSvIT.useCallback)(function() {
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $ebb122e37dd7b707$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $iSvIT.useEffect)(function() {
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $3Xksr.default), (0, $5lV35.default)({}, props, {
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    }));
};
var $ebb122e37dd7b707$export$2e2bcd8739ae039 = $ebb122e37dd7b707$var$AutoDismissFlag;

});
parcelRegister("5lV35", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e5b2a99d6b32167$export$2e2bcd8739ae039; });
function $3e5b2a99d6b32167$export$2e2bcd8739ae039() {
    return $3e5b2a99d6b32167$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3e5b2a99d6b32167$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("6e0wq", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $4884748fac1af16c$export$a4687b0234b40e28; });

var $iy89y = parcelRequire("iy89y");

var $iSvIT = parcelRequire("iSvIT");

var $loB9A = parcelRequire("loB9A");

var $jxgG4 = parcelRequire("jxgG4");
function $4884748fac1af16c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4884748fac1af16c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4884748fac1af16c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iy89y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4884748fac1af16c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4884748fac1af16c$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $loB9A.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $jxgG4.useTrackedRef)(analyticsData);
    var fnRef = (0, $jxgG4.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $4884748fac1af16c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("iy89y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d811b9fd701411e5$export$2e2bcd8739ae039; });

var $3djz2 = parcelRequire("3djz2");
function $d811b9fd701411e5$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3djz2.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("3djz2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2571c303452ecae8$export$2e2bcd8739ae039; });

var $c7GPN = parcelRequire("c7GPN");

var $fXKk1 = parcelRequire("fXKk1");
function $2571c303452ecae8$export$2e2bcd8739ae039(t) {
    var i = (0, $fXKk1.default)(t, "string");
    return "symbol" == (0, $c7GPN.default)(i) ? i : i + "";
}

});
parcelRegister("c7GPN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d375d7dc9fd191c$export$2e2bcd8739ae039; });
function $8d375d7dc9fd191c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8d375d7dc9fd191c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8d375d7dc9fd191c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fXKk1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9f04c4c802fbfd7$export$2e2bcd8739ae039; });

var $c7GPN = parcelRequire("c7GPN");
function $b9f04c4c802fbfd7$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $c7GPN.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $c7GPN.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("loB9A", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $f938a8c9a5b4267e$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $hh8Qh = parcelRequire("hh8Qh");

var $6djGR = parcelRequire("6djGR");
function $f938a8c9a5b4267e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $6djGR.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $hh8Qh.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("hh8Qh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c93ae2104a35905f$export$2e2bcd8739ae039; });

var $5PbkS = parcelRequire("5PbkS");

var $d2wai = parcelRequire("d2wai");

var $hniUP = parcelRequire("hniUP");

var $ajujQ = parcelRequire("ajujQ");

var $dCcTh = parcelRequire("dCcTh");

var $a3soi = parcelRequire("a3soi");

var $ic966 = parcelRequire("ic966");

var $iy89y = parcelRequire("iy89y");

var $eGUQ4 = parcelRequire("eGUQ4");
function $c93ae2104a35905f$var$_callSuper(t, o, e) {
    return o = (0, $dCcTh.default)(o), (0, $ajujQ.default)(t, $c93ae2104a35905f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $dCcTh.default)(t).constructor) : o.apply(t, e));
}
function $c93ae2104a35905f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c93ae2104a35905f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c93ae2104a35905f$var$_superPropGet(t, o, e, r) {
    var p = (0, $a3soi.default)((0, $dCcTh.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $c93ae2104a35905f$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c93ae2104a35905f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $c93ae2104a35905f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $d2wai.default)(this, UIAnalyticsEvent);
        _this = $c93ae2104a35905f$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $iy89y.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $iy89y.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $5PbkS.default)(_this.context);
            var handlers = (0, $5PbkS.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $iy89y.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $ic966.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $hniUP.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $c93ae2104a35905f$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $eGUQ4.default));

});
parcelRegister("5PbkS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43da82308ecb764c$export$2e2bcd8739ae039; });

var $bTJD4 = parcelRequire("bTJD4");

var $7uzfv = parcelRequire("7uzfv");

var $bI6b6 = parcelRequire("bI6b6");

var $bAi6W = parcelRequire("bAi6W");
function $43da82308ecb764c$export$2e2bcd8739ae039(r) {
    return (0, $bTJD4.default)(r) || (0, $7uzfv.default)(r) || (0, $bI6b6.default)(r) || (0, $bAi6W.default)();
}

});
parcelRegister("bTJD4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a9839c99ea3f54c$export$2e2bcd8739ae039; });

var $7MeV3 = parcelRequire("7MeV3");
function $8a9839c99ea3f54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7MeV3.default)(r);
}

});
parcelRegister("7MeV3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a9896bbc395b487$export$2e2bcd8739ae039; });
function $5a9896bbc395b487$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("7uzfv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5746ad7d36e6694f$export$2e2bcd8739ae039; });
function $5746ad7d36e6694f$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("bI6b6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8868989955c5619b$export$2e2bcd8739ae039; });

var $7MeV3 = parcelRequire("7MeV3");
function $8868989955c5619b$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7MeV3.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7MeV3.default)(r, a) : void 0;
    }
}

});

parcelRegister("bAi6W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86f11afbb60e0a1f$export$2e2bcd8739ae039; });
function $86f11afbb60e0a1f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("d2wai", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97e4699a6eb889a4$export$2e2bcd8739ae039; });
function $97e4699a6eb889a4$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hniUP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca6341e9761a4728$export$2e2bcd8739ae039; });

var $3djz2 = parcelRequire("3djz2");
function $ca6341e9761a4728$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3djz2.default)(o.key), o);
    }
}
function $ca6341e9761a4728$export$2e2bcd8739ae039(e, r, t) {
    return r && $ca6341e9761a4728$var$_defineProperties(e.prototype, r), t && $ca6341e9761a4728$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("ajujQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7823327aa32be343$export$2e2bcd8739ae039; });

var $c7GPN = parcelRequire("c7GPN");

var $dzwC2 = parcelRequire("dzwC2");
function $7823327aa32be343$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $c7GPN.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $dzwC2.default)(t);
}

});
parcelRegister("dzwC2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e17d76b016204af$export$2e2bcd8739ae039; });
function $9e17d76b016204af$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("dCcTh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e98d2cc3a23509f$export$2e2bcd8739ae039; });
function $9e98d2cc3a23509f$export$2e2bcd8739ae039(t) {
    return $9e98d2cc3a23509f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $9e98d2cc3a23509f$export$2e2bcd8739ae039(t);
}

});

parcelRegister("a3soi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7520350cb9647a4e$export$2e2bcd8739ae039; });

var $e3hju = parcelRequire("e3hju");
function $7520350cb9647a4e$export$2e2bcd8739ae039() {
    return $7520350cb9647a4e$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $e3hju.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $7520350cb9647a4e$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("e3hju", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3aec69445740dd5$export$2e2bcd8739ae039; });

var $dCcTh = parcelRequire("dCcTh");
function $a3aec69445740dd5$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $dCcTh.default)(t)););
    return t;
}

});


parcelRegister("ic966", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3f0678d5a173767$export$2e2bcd8739ae039; });

var $9WSYz = parcelRequire("9WSYz");
function $d3f0678d5a173767$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $9WSYz.default)(t, e);
}

});
parcelRegister("9WSYz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73e42cecd8656184$export$2e2bcd8739ae039; });
function $73e42cecd8656184$export$2e2bcd8739ae039(t, e) {
    return $73e42cecd8656184$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $73e42cecd8656184$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("eGUQ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab2113f2a3c9106f$export$2e2bcd8739ae039; });

var $c7GPN = parcelRequire("c7GPN");

var $d2wai = parcelRequire("d2wai");

var $hniUP = parcelRequire("hniUP");

var $iy89y = parcelRequire("iy89y");
function $ab2113f2a3c9106f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab2113f2a3c9106f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab2113f2a3c9106f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iy89y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab2113f2a3c9106f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ab2113f2a3c9106f$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ab2113f2a3c9106f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $ab2113f2a3c9106f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $d2wai.default)(this, AnalyticsEvent);
        (0, $iy89y.default)(this, "_isAnalyticsEvent", true);
        (0, $iy89y.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $ab2113f2a3c9106f$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $hniUP.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $c7GPN.default)(updater) === "object") this.payload = $ab2113f2a3c9106f$var$_objectSpread($ab2113f2a3c9106f$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("6djGR", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $48633b09306dee3d$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $48633b09306dee3d$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("jxgG4", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $e38e092e002f2129$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $e38e092e002f2129$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("3Xksr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e16c048c8088766$export$2e2bcd8739ae039; });
/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5lV35 = parcelRequire("5lV35");

var $iy89y = parcelRequire("iy89y");

var $9FZmC = parcelRequire("9FZmC");

var $iSvIT = parcelRequire("iSvIT");

var $bnGwB = parcelRequire("bnGwB");
var $cPdGV = parcelRequire("cPdGV");

var $6e0wq = parcelRequire("6e0wq");

var $4OZuI = parcelRequire("4OZuI");

var $975EH = parcelRequire("975EH");

var $jxLBU = parcelRequire("jxLBU");

var $gDNoM = parcelRequire("gDNoM");
var $lHitv = parcelRequire("lHitv");
var $hMIOK = parcelRequire("hMIOK");

var $dnYes = parcelRequire("dnYes");

var $jfVT7 = parcelRequire("jfVT7");

var $iqTTC = parcelRequire("iqTTC");

var $3PqZG = parcelRequire("3PqZG");

var $48jF4 = parcelRequire("48jF4");
var $80242 = parcelRequire("80242");

var $lek8Z = parcelRequire("lek8Z");
function $2e16c048c8088766$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e16c048c8088766$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e16c048c8088766$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iy89y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e16c048c8088766$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2e16c048c8088766$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkosqtm _1reo15vq _18m915vq _v564z97a _16qs8sq4 _1pbyni7l _1bsb1osq"
};
var $2e16c048c8088766$var$CSS_VAR_ICON_COLOR = "--flag-icon-color";
var $2e16c048c8088766$var$oldDescriptionStyles = null;
var $2e16c048c8088766$var$descriptionStyles = null;
var $2e16c048c8088766$var$oldIconWrapperStyles = null;
var $2e16c048c8088766$var$iconWrapperStyles = null;
var $2e16c048c8088766$var$flagWrapperStyles = null;
var $2e16c048c8088766$var$analyticsAttributes = {
    componentName: "flag",
    packageName: "@atlaskit/flag",
    packageVersion: "17.1.8"
};
var $2e16c048c8088766$var$transitionStyles = null;
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $2e16c048c8088766$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $jfVT7.DEFAULT_APPEARANCE) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $4OZuI.default) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $4OZuI.default) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $4OZuI.default) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $9FZmC.default)(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $3PqZG.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $iSvIT.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $iSvIT.useState)(false), _useState4 = (0, $9FZmC.default)(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $6e0wq.usePlatformLeafEventHandler)($2e16c048c8088766$var$_objectSpread({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext
    }, $2e16c048c8088766$var$analyticsAttributes));
    var isBold = appearance !== (0, $jfVT7.DEFAULT_APPEARANCE);
    var toggleExpand = (0, $iSvIT.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $iSvIT.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $iSvIT.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $6e0wq.usePlatformLeafEventHandler)($2e16c048c8088766$var$_objectSpread({
        fn: onFocus,
        action: "focused",
        analyticsData: analyticsContext
    }, $2e16c048c8088766$var$analyticsAttributes));
    var onBlurAnalytics = (0, $6e0wq.usePlatformLeafEventHandler)($2e16c048c8088766$var$_objectSpread({
        fn: onBlur,
        action: "blurred",
        analyticsData: analyticsContext
    }, $2e16c048c8088766$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $lek8Z.flagTextColor)[appearance];
    var iconColor = (0, $lek8Z.flagIconColor)[appearance];
    var iconGlyph = (0, $lek8Z.flagIconGlyph)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ $iSvIT.createElement((0, $dnYes.default), null, title, description) : undefined;
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $5lV35.default)({
        role: "alert",
        "data-testid": testId
    }, autoDismissProps, {
        className: (0, $bnGwB.default)([
            "_1bsb1osq"
        ])
    }), /*#__PURE__*/ $iSvIT.createElement((0, $gDNoM.default), {
        padding: "space.200",
        backgroundColor: (0, $lek8Z.flagBackgroundColor)[appearance],
        xcss: $2e16c048c8088766$var$styles.flag
    }, /*#__PURE__*/ $iSvIT.createElement((0, $lHitv.default), {
        alignBlock: (0, $jxLBU.fg)("platform_ads_component_no_icon_spacing_support") ? "start" : "stretch",
        space: "space.200"
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": testId && "".concat(testId, "-icon-container"),
        className: (0, $bnGwB.default)([
            (0, $jxLBU.fg)("platform_ads_component_no_icon_spacing_support") ? "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz16r9" : "_1e0c1txw _4cvrv2br _1o9zidpf _syaz16r9"
        ]),
        style: $2e16c048c8088766$var$_objectSpread($2e16c048c8088766$var$_objectSpread({}, (0, $iy89y.default)({}, $2e16c048c8088766$var$CSS_VAR_ICON_COLOR, iconColor)), {}, {
            "--_11v68d2": (0, $cPdGV.default)("var(".concat($2e16c048c8088766$var$CSS_VAR_ICON_COLOR, ")"))
        })
    }, icon || (iconGlyph && (0, $jxLBU.fg)("platform_ads_component_no_icon_spacing_support") ? iconGlyph : null)), /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $bnGwB.default)([
            "_v5641hdc _16jlkb7n"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement((0, $hMIOK.default), {
        space: shouldRenderGap ? "space.100" : "space.0" // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, isDelayToAnnounce && delayedAnnouncement, /*#__PURE__*/ $iSvIT.createElement((0, $lHitv.default), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ $iSvIT.createElement((0, $gDNoM.default), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $2e16c048c8088766$var$styles.overflowWrap
    }, /*#__PURE__*/ $iSvIT.createElement((0, $975EH.default), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, /*#__PURE__*/ $iSvIT.createElement("span", {
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce
    }, title))), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ $iSvIT.createElement((0, $48jF4.default), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ $iSvIT.createElement((0, $80242.default), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ $iSvIT.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $lek8Z.flagTextColorToken)[appearance]
        },
        "data-testid": testId && "".concat(testId, "-description"),
        "aria-hidden": isDelayToAnnounce,
        className: (0, $bnGwB.default)([
            (0, $jxLBU.fg)("platform_ads_explicit_font_styles") ? "_11c82smr _1reo1wug _18m91wug _c71l53f4 _1i4qfg65" : "_1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
        ])
    }, description), /*#__PURE__*/ $iSvIT.createElement((0, $iqTTC.default), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $2e16c048c8088766$export$2e2bcd8739ae039 = $2e16c048c8088766$var$Flag;

});
parcelRegister("9FZmC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70b78af222cd2d22$export$2e2bcd8739ae039; });

var $eMOj3 = parcelRequire("eMOj3");

var $eTsiI = parcelRequire("eTsiI");

var $bI6b6 = parcelRequire("bI6b6");

var $6eLzJ = parcelRequire("6eLzJ");
function $70b78af222cd2d22$export$2e2bcd8739ae039(r, e) {
    return (0, $eMOj3.default)(r) || (0, $eTsiI.default)(r, e) || (0, $bI6b6.default)(r, e) || (0, $6eLzJ.default)();
}

});
parcelRegister("eMOj3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac3c922f3e66a588$export$2e2bcd8739ae039; });
function $ac3c922f3e66a588$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("eTsiI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad7c27b8b4e63e5b$export$2e2bcd8739ae039; });
function $ad7c27b8b4e63e5b$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("6eLzJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48a8f45fbd62130e$export$2e2bcd8739ae039; });
function $48a8f45fbd62130e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bnGwB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8492d4426398bec6$export$2e2bcd8739ae039; });
const $8492d4426398bec6$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $8492d4426398bec6$var$ATOMIC_GROUP_LENGTH = 5;
function $8492d4426398bec6$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $8492d4426398bec6$var$UNDERSCORE_UNICODE ? $8492d4426398bec6$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("cPdGV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9564de48afa64a53$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $9564de48afa64a53$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("975EH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a2927889a28a5e1$export$2e2bcd8739ae039; });
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9FZmC = parcelRequire("9FZmC");

var $iSvIT = parcelRequire("iSvIT");

var $bnGwB = parcelRequire("bnGwB");

var $bEDQ6 = parcelRequire("bEDQ6");

var $8Zhg0 = parcelRequire("8Zhg0");

var $haxkx = parcelRequire("haxkx");

var $XAEGR = parcelRequire("XAEGR");
var $6a2927889a28a5e1$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $6a2927889a28a5e1$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $6a2927889a28a5e1$var$headingColorStylesMap = {
    "color.text": "_syaz1fxt",
    "color.text.inverse": "_syaz15cr",
    "color.text.warning.inverse": "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $6a2927889a28a5e1$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $6a2927889a28a5e1$var$useColor = function useColor(colorProp) {
    var surface = (0, $8Zhg0.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $bEDQ6.inverseColorMap).hasOwnProperty(surface)) return (0, $bEDQ6.inverseColorMap)[surface];
    return "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $6a2927889a28a5e1$var$Heading = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $XAEGR;
    var _useHeading = (0, $haxkx.useHeading)($6a2927889a28a5e1$var$sizeTagMap[size]), _useHeading2 = (0, $9FZmC.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $6a2927889a28a5e1$var$useColor(colorProp);
    return /*#__PURE__*/ $iSvIT.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $bnGwB.default)([
            $6a2927889a28a5e1$var$styles.reset,
            size && $6a2927889a28a5e1$var$headingSizeStylesMap[size],
            $6a2927889a28a5e1$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $6a2927889a28a5e1$export$2e2bcd8739ae039 = $6a2927889a28a5e1$var$Heading;

});
parcelRegister("bEDQ6", function(module, exports) {

$parcel$export(module.exports, "inverseColorMap", function () { return $87c2556ba7a56913$export$2185ce37f9bdd963; });

var $iy89y = parcelRequire("iy89y");

var $2ZUkg = parcelRequire("2ZUkg");

var $bPgiv = parcelRequire("bPgiv");
function $87c2556ba7a56913$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $87c2556ba7a56913$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $87c2556ba7a56913$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iy89y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $87c2556ba7a56913$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $87c2556ba7a56913$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $87c2556ba7a56913$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $87c2556ba7a56913$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $87c2556ba7a56913$export$632685d741f3dbbf = $87c2556ba7a56913$var$_objectSpread($87c2556ba7a56913$var$_objectSpread({}, $87c2556ba7a56913$export$958d0ae7f2977ae4), $87c2556ba7a56913$export$d2dc61f58390201c);
var $87c2556ba7a56913$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $87c2556ba7a56913$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $87c2556ba7a56913$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $87c2556ba7a56913$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $87c2556ba7a56913$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $87c2556ba7a56913$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $87c2556ba7a56913$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $87c2556ba7a56913$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B778C)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $87c2556ba7a56913$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $87c2556ba7a56913$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $87c2556ba7a56913$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $87c2556ba7a56913$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $87c2556ba7a56913$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $87c2556ba7a56913$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $87c2556ba7a56913$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $87c2556ba7a56913$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $87c2556ba7a56913$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $87c2556ba7a56913$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $2ZUkg.css)((0, $iy89y.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $87c2556ba7a56913$export$e615f061ca585a6c = $87c2556ba7a56913$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $87c2556ba7a56913$export$ca0f9c2de39ffed7(spacingProperty, $87c2556ba7a56913$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $87c2556ba7a56913$export$bf46c3f9eeafc71f = $87c2556ba7a56913$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $87c2556ba7a56913$export$ca0f9c2de39ffed7(spacingProperty, $87c2556ba7a56913$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $87c2556ba7a56913$export$e7af83bafe7f9e63 = $87c2556ba7a56913$export$ca0f9c2de39ffed7("backgroundColor", $87c2556ba7a56913$export$d1d79bf68ac056bd);
var $87c2556ba7a56913$export$3a1bcba60b23d7f0 = $87c2556ba7a56913$export$ca0f9c2de39ffed7("color", $87c2556ba7a56913$export$8473307aa00d6ea1);
var $87c2556ba7a56913$export$45f3f4fe16f9f7d5 = $87c2556ba7a56913$export$ca0f9c2de39ffed7("fontWeight", $87c2556ba7a56913$export$303e322c6b1ed114);
var $87c2556ba7a56913$export$68cc305da27dbaa4 = $87c2556ba7a56913$export$ca0f9c2de39ffed7("fontFamily", $87c2556ba7a56913$export$3c7e9587132614b4);
var $87c2556ba7a56913$export$128f10c238242f83 = $87c2556ba7a56913$export$ca0f9c2de39ffed7("font", $87c2556ba7a56913$export$6ffa317d5e70375);
var $87c2556ba7a56913$export$219d364c0da35ae4 = $87c2556ba7a56913$export$ca0f9c2de39ffed7("font", $87c2556ba7a56913$export$236bfe3a33ef1292);
var $87c2556ba7a56913$export$38845ca010b93505 = $87c2556ba7a56913$export$ca0f9c2de39ffed7("fontWeight", $87c2556ba7a56913$export$855cfd311192d666);
var $87c2556ba7a56913$export$ff257d957d48c421 = $87c2556ba7a56913$export$ca0f9c2de39ffed7((0, $bPgiv.CURRENT_SURFACE_CSS_VAR), $87c2556ba7a56913$export$41a358c9c2356760);
var $87c2556ba7a56913$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $87c2556ba7a56913$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("bPgiv", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $89c119754eda0689$export$9d7b58831ae93caa; });
var $89c119754eda0689$export$4ef52930e33717cd = "data-theme";
var $89c119754eda0689$export$a00eac3f8684bcd0 = "data-color-mode";
var $89c119754eda0689$export$2112803007239c61 = "data-contrast-mode";
var $89c119754eda0689$export$352e418ed5b6193a = "data-custom-theme";
var $89c119754eda0689$export$6f0c6fb8c80fcc92 = "ds";
var $89c119754eda0689$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $89c119754eda0689$export$dddac1532e822863 = "--".concat($89c119754eda0689$export$6f0c6fb8c80fcc92, "-token-not-found");
var $89c119754eda0689$export$9d7b58831ae93caa = "--".concat($89c119754eda0689$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("8Zhg0", function(module, exports) {

$parcel$export(module.exports, "useSurface", function () { return $68b1681ff8ab4fd5$export$1aeb4f6b93c4540d; });

var $iSvIT = parcelRequire("iSvIT");
var $68b1681ff8ab4fd5$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $68b1681ff8ab4fd5$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($68b1681ff8ab4fd5$export$1ca2a26fecb070ae);
};
$68b1681ff8ab4fd5$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});

parcelRegister("haxkx", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $0339c2fe000129b0$export$97a37b1befbbf9b1; });

var $iSvIT = parcelRequire("iSvIT");
// Allows support for heading levels 1-9 via aria-level
var $0339c2fe000129b0$var$HeadingLevelContext = /*#__PURE__*/ (0, $iSvIT.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $0339c2fe000129b0$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $iSvIT.useContext)($0339c2fe000129b0$var$HeadingLevelContext);
};
var $0339c2fe000129b0$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $0339c2fe000129b0$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $0339c2fe000129b0$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $0339c2fe000129b0$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($0339c2fe000129b0$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $0339c2fe000129b0$export$2e2bcd8739ae039 = $0339c2fe000129b0$var$HeadingLevelContextProvider;

});


parcelRegister("gDNoM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1d69b64d156fe04$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5lV35 = parcelRequire("5lV35");

var $gJD9k = parcelRequire("gJD9k");

var $iSvIT = parcelRequire("iSvIT");

var $bnGwB = parcelRequire("bnGwB");

var $2W59Q = parcelRequire("2W59Q");
var $c1d69b64d156fe04$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $c1d69b64d156fe04$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $c1d69b64d156fe04$var$baseStyles = null;
var $c1d69b64d156fe04$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhk1fno",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1eds",
    "color.background.accent.lime.subtler.pressed": "_bfhk1hgz",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhkhgj8",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhk1b17",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhk1pbw",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkrw5d",
    "color.background.accent.red.subtler.pressed": "_bfhk69rw",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1tf4",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhkprmn",
    "color.background.accent.orange.subtlest": "_bfhk1g3m",
    "color.background.accent.orange.subtlest.hovered": "_bfhkg4tm",
    "color.background.accent.orange.subtlest.pressed": "_bfhk1ya0",
    "color.background.accent.orange.subtler": "_bfhkf2vu",
    "color.background.accent.orange.subtler.hovered": "_bfhk1lml",
    "color.background.accent.orange.subtler.pressed": "_bfhkuxsx",
    "color.background.accent.orange.subtle": "_bfhk1g6e",
    "color.background.accent.orange.subtle.hovered": "_bfhk1oew",
    "color.background.accent.orange.subtle.pressed": "_bfhk1phk",
    "color.background.accent.orange.bolder": "_bfhkjgng",
    "color.background.accent.orange.bolder.hovered": "_bfhkhi52",
    "color.background.accent.orange.bolder.pressed": "_bfhkf767",
    "color.background.accent.yellow.subtlest": "_bfhk1ozg",
    "color.background.accent.yellow.subtlest.hovered": "_bfhk19g9",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk31d1",
    "color.background.accent.yellow.subtler": "_bfhk3fv2",
    "color.background.accent.yellow.subtler.hovered": "_bfhklg04",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1d44",
    "color.background.accent.yellow.subtle": "_bfhkry5t",
    "color.background.accent.yellow.subtle.hovered": "_bfhk17e6",
    "color.background.accent.yellow.subtle.pressed": "_bfhko0y5",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk32kj",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkv5yf",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhkung8",
    "color.background.accent.green.subtler.pressed": "_bfhk1p19",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk8h4p",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1azz",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1j2h",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkg5py",
    "color.background.accent.teal.subtler.pressed": "_bfhkq7li",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk10ai",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhkse6l",
    "color.background.accent.blue.subtlest": "_bfhkavxe",
    "color.background.accent.blue.subtlest.hovered": "_bfhkay3p",
    "color.background.accent.blue.subtlest.pressed": "_bfhk1xmr",
    "color.background.accent.blue.subtler": "_bfhk4v9p",
    "color.background.accent.blue.subtler.hovered": "_bfhk16e6",
    "color.background.accent.blue.subtler.pressed": "_bfhk1uh7",
    "color.background.accent.blue.subtle": "_bfhk1j89",
    "color.background.accent.blue.subtle.hovered": "_bfhk1f4s",
    "color.background.accent.blue.subtle.pressed": "_bfhkqctv",
    "color.background.accent.blue.bolder": "_bfhkc8cv",
    "color.background.accent.blue.bolder.hovered": "_bfhk1cwi",
    "color.background.accent.blue.bolder.pressed": "_bfhkhcrq",
    "color.background.accent.purple.subtlest": "_bfhkp7j4",
    "color.background.accent.purple.subtlest.hovered": "_bfhkm0d5",
    "color.background.accent.purple.subtlest.pressed": "_bfhkgslw",
    "color.background.accent.purple.subtler": "_bfhk1jkz",
    "color.background.accent.purple.subtler.hovered": "_bfhk1wyu",
    "color.background.accent.purple.subtler.pressed": "_bfhk5fkp",
    "color.background.accent.purple.subtle": "_bfhkdh45",
    "color.background.accent.purple.subtle.hovered": "_bfhk1wob",
    "color.background.accent.purple.subtle.pressed": "_bfhkwz05",
    "color.background.accent.purple.bolder": "_bfhkygwo",
    "color.background.accent.purple.bolder.hovered": "_bfhkadgs",
    "color.background.accent.purple.bolder.pressed": "_bfhk1uro",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1een",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1r0p",
    "color.background.accent.magenta.subtler.pressed": "_bfhkxuzc",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk1ovh",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkwaw3",
    "color.background.accent.gray.subtlest": "_bfhk11bn",
    "color.background.accent.gray.subtlest.hovered": "_bfhk12j4",
    "color.background.accent.gray.subtlest.pressed": "_bfhk1lb4",
    "color.background.accent.gray.subtler": "_bfhk1v33",
    "color.background.accent.gray.subtler.hovered": "_bfhk1f7l",
    "color.background.accent.gray.subtler.pressed": "_bfhkd8a2",
    "color.background.accent.gray.subtle": "_bfhk1t05",
    "color.background.accent.gray.subtle.hovered": "_bfhk1a2l",
    "color.background.accent.gray.subtle.pressed": "_bfhk1z0s",
    "color.background.accent.gray.bolder": "_bfhk1t1b",
    "color.background.accent.gray.bolder.hovered": "_bfhke4nv",
    "color.background.accent.gray.bolder.pressed": "_bfhk82ra",
    "color.background.disabled": "_bfhksyzs",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhk1d5g",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhkm7j4",
    "color.background.neutral.hovered": "_bfhk15ej",
    "color.background.neutral.pressed": "_bfhkip91",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk166n",
    "color.background.neutral.subtle.pressed": "_bfhk1dty",
    "color.background.neutral.bold": "_bfhkcdhy",
    "color.background.neutral.bold.hovered": "_bfhk1bsc",
    "color.background.neutral.bold.pressed": "_bfhk1b6k",
    "color.background.selected": "_bfhkfg4m",
    "color.background.selected.hovered": "_bfhki1yw",
    "color.background.selected.pressed": "_bfhk19ru",
    "color.background.selected.bold": "_bfhk1fvw",
    "color.background.selected.bold.hovered": "_bfhk18hz",
    "color.background.selected.bold.pressed": "_bfhkgr1v",
    "color.background.brand.subtlest": "_bfhk3wxy",
    "color.background.brand.subtlest.hovered": "_bfhkezq1",
    "color.background.brand.subtlest.pressed": "_bfhk2ggb",
    "color.background.brand.bold": "_bfhkb29m",
    "color.background.brand.bold.hovered": "_bfhku1se",
    "color.background.brand.bold.pressed": "_bfhkqkzo",
    "color.background.brand.boldest": "_bfhk15mt",
    "color.background.brand.boldest.hovered": "_bfhk1uwk",
    "color.background.brand.boldest.pressed": "_bfhk17jr",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1io2",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk9pqq",
    "color.background.warning": "_bfhk1tzq",
    "color.background.warning.hovered": "_bfhk1rd4",
    "color.background.warning.pressed": "_bfhk11dh",
    "color.background.warning.bold": "_bfhk190i",
    "color.background.warning.bold.hovered": "_bfhk1i4c",
    "color.background.warning.bold.pressed": "_bfhkrj9s",
    "color.background.success": "_bfhkmv6i",
    "color.background.success.hovered": "_bfhk1jgi",
    "color.background.success.pressed": "_bfhky4f1",
    "color.background.success.bold": "_bfhk8emd",
    "color.background.success.bold.hovered": "_bfhk1q4l",
    "color.background.success.bold.pressed": "_bfhkcrcn",
    "color.background.discovery": "_bfhk1nvp",
    "color.background.discovery.hovered": "_bfhk1xp7",
    "color.background.discovery.pressed": "_bfhkdlkp",
    "color.background.discovery.bold": "_bfhk1lri",
    "color.background.discovery.bold.hovered": "_bfhk1w72",
    "color.background.discovery.bold.pressed": "_bfhkrb53",
    "color.background.information": "_bfhk33gi",
    "color.background.information.hovered": "_bfhk1vps",
    "color.background.information.pressed": "_bfhk1s0z",
    "color.background.information.bold": "_bfhk14wj",
    "color.background.information.bold.hovered": "_bfhk1amz",
    "color.background.information.bold.pressed": "_bfhk5bth",
    "color.blanket": "_bfhk10xm",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkn82g",
    "color.skeleton.subtle": "_bfhkh3tw",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk108i",
    "elevation.surface.pressed": "_bfhk1ji5",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk16qz",
    "elevation.surface.overlay.pressed": "_bfhkvq0a",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk1a0f",
    "elevation.surface.raised.pressed": "_bfhkf7u5",
    "elevation.surface.sunken": "_bfhkqbzx",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $c1d69b64d156fe04$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $c1d69b64d156fe04$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l108i",
    "elevation.surface.pressed": "_1q1l1ji5",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l16qz",
    "elevation.surface.overlay.pressed": "_1q1lvq0a",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l1a0f",
    "elevation.surface.raised.pressed": "_1q1lf7u5",
    "elevation.surface.sunken": "_1q1lqbzx"
};
var $c1d69b64d156fe04$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $c1d69b64d156fe04$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $c1d69b64d156fe04$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $c1d69b64d156fe04$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $c1d69b64d156fe04$var$Box = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gJD9k.default)(_ref, $c1d69b64d156fe04$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gJD9k.default)(htmlAttributes, $c1d69b64d156fe04$var$_excluded2);
    var node = /*#__PURE__*/ $iSvIT.createElement(Component, (0, $5lV35.default)({
        style: style,
        ref: ref,
        className: (0, $bnGwB.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $c1d69b64d156fe04$var$backgroundColorMap[backgroundColor],
            backgroundColor && $c1d69b64d156fe04$var$isSurfaceToken(backgroundColor) && $c1d69b64d156fe04$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $c1d69b64d156fe04$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $c1d69b64d156fe04$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $c1d69b64d156fe04$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $c1d69b64d156fe04$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $iSvIT.createElement((0, $2W59Q.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $c1d69b64d156fe04$export$2e2bcd8739ae039 = $c1d69b64d156fe04$var$Box;
function $c1d69b64d156fe04$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $c1d69b64d156fe04$var$setSurfaceTokenMap;
}

});
parcelRegister("gJD9k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2ef37928382076d$export$2e2bcd8739ae039; });

var $jIXFP = parcelRequire("jIXFP");
function $c2ef37928382076d$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $jIXFP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("jIXFP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5c06a5184a1a167$export$2e2bcd8739ae039; });
function $e5c06a5184a1a167$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("2W59Q", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $2234ffc85bf9da95$export$1ca2a26fecb070ae; });

var $iSvIT = parcelRequire("iSvIT");
var $2234ffc85bf9da95$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $2234ffc85bf9da95$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($2234ffc85bf9da95$export$1ca2a26fecb070ae);
};
$2234ffc85bf9da95$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("lHitv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcbbf1d8fde362d9$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $bnGwB = parcelRequire("bnGwB");

var $8vnZo = parcelRequire("8vnZo");

var $doY2C = parcelRequire("doY2C");
var $fcbbf1d8fde362d9$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $fcbbf1d8fde362d9$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $bnGwB.default)([
            $fcbbf1d8fde362d9$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $fcbbf1d8fde362d9$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? /*#__PURE__*/ $iSvIT.createElement($fcbbf1d8fde362d9$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $iSvIT.createElement((0, $doY2C.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: (0, $8vnZo.cx)(grow === "hug" && $fcbbf1d8fde362d9$var$styles.hug, grow === "fill" && $fcbbf1d8fde362d9$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$fcbbf1d8fde362d9$var$Inline.displayName = "Inline";
var $fcbbf1d8fde362d9$export$2e2bcd8739ae039 = $fcbbf1d8fde362d9$var$Inline;

});
parcelRegister("8vnZo", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $6313d3bef8e1cdbd$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("iSvIT");


var $bK5J3 = parcelRequire("bK5J3");
var $6313d3bef8e1cdbd$var$_createStrictAPI = (0, $bK5J3.createStrictAPI)(), $6313d3bef8e1cdbd$var$XCSSProp = $6313d3bef8e1cdbd$var$_createStrictAPI.XCSSProp, $6313d3bef8e1cdbd$export$dbf350e5966cf602 = $6313d3bef8e1cdbd$var$_createStrictAPI.css, $6313d3bef8e1cdbd$export$eb1ecd84a24ee424 = $6313d3bef8e1cdbd$var$_createStrictAPI.cssMap, $6313d3bef8e1cdbd$export$a274e22fb40f762e = $6313d3bef8e1cdbd$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("bK5J3", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $88c86e9021872cbe$export$39716b4af53f4ad; });

var $klNYi = parcelRequire("klNYi");

var $cvxX2 = parcelRequire("cvxX2");
function $88c86e9021872cbe$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $klNYi.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $klNYi.createStrictSetupError)();
        },
        cx: $cvxX2.cx,
        XCSSProp () {
            throw (0, $klNYi.createStrictSetupError)();
        }
    };
}

});
parcelRegister("klNYi", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $ed0c881f84449882$export$c4df1cb0c2b4d77c; });
const $ed0c881f84449882$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $ed0c881f84449882$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("cvxX2", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $91b2b750efe138d2$export$a274e22fb40f762e; });

var $bnGwB = parcelRequire("bnGwB");
const $91b2b750efe138d2$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $bnGwB.default)(actualStyles);
};

});



parcelRegister("doY2C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c1c1732aa341975$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $bnGwB = parcelRequire("bnGwB");
var $9c1c1732aa341975$var$rowGapMap = {
    "space.0": "_1p57ze3t",
    "space.025": "_1p57v77o",
    "space.050": "_1p571b66",
    "space.075": "_1p5712x7",
    "space.100": "_1p57u2gc",
    "space.150": "_1p57utpp",
    "space.200": "_1p57pxbi",
    "space.250": "_1p57v47k",
    "space.300": "_1p571ejb",
    "space.400": "_1p57xy5q",
    "space.500": "_1p571jfw",
    "space.600": "_1p57oahv",
    "space.800": "_1p57xncg",
    "space.1000": "_1p571epz"
};
var $9c1c1732aa341975$var$columnGapMap = {
    "space.0": "_gy1pze3t",
    "space.025": "_gy1pv77o",
    "space.050": "_gy1p1b66",
    "space.075": "_gy1p12x7",
    "space.100": "_gy1pu2gc",
    "space.150": "_gy1putpp",
    "space.200": "_gy1ppxbi",
    "space.250": "_gy1pv47k",
    "space.300": "_gy1p1ejb",
    "space.400": "_gy1pxy5q",
    "space.500": "_gy1p1jfw",
    "space.600": "_gy1poahv",
    "space.800": "_gy1pxncg",
    "space.1000": "_gy1p1epz"
};
var $9c1c1732aa341975$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    "space-between": "_1bah1yb4",
    "space-around": "_1bah1b1v",
    "space-evenly": "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $9c1c1732aa341975$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $9c1c1732aa341975$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $9c1c1732aa341975$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $9c1c1732aa341975$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $9c1c1732aa341975$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    return /*#__PURE__*/ $iSvIT.createElement(Component, {
        role: role,
        className: (0, $bnGwB.default)([
            $9c1c1732aa341975$var$styles.root,
            gap && $9c1c1732aa341975$var$columnGapMap[gap],
            columnGap && $9c1c1732aa341975$var$columnGapMap[columnGap],
            gap && $9c1c1732aa341975$var$rowGapMap[gap],
            rowGap && $9c1c1732aa341975$var$rowGapMap[rowGap],
            alignItems && $9c1c1732aa341975$var$alignItemsMap[alignItems],
            direction && $9c1c1732aa341975$var$flexDirectionMap[direction],
            justifyContent && $9c1c1732aa341975$var$justifyContentMap[justifyContent],
            wrap && $9c1c1732aa341975$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$9c1c1732aa341975$var$Flex.displayName = "Flex";
var $9c1c1732aa341975$export$2e2bcd8739ae039 = $9c1c1732aa341975$var$Flex;

});


parcelRegister("hMIOK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf29af2e0a7a68c5$export$2e2bcd8739ae039; });
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");


var $8vnZo = parcelRequire("8vnZo");

var $doY2C = parcelRequire("doY2C");
var $cf29af2e0a7a68c5$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $cf29af2e0a7a68c5$var$Stack = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    return /*#__PURE__*/ $iSvIT.createElement((0, $doY2C.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $8vnZo.cx)(grow === "hug" && $cf29af2e0a7a68c5$var$styles.hug, grow === "fill" && $cf29af2e0a7a68c5$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$cf29af2e0a7a68c5$var$Stack.displayName = "Stack";
var $cf29af2e0a7a68c5$export$2e2bcd8739ae039 = $cf29af2e0a7a68c5$var$Stack;

});

parcelRegister("dnYes", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bec253661d38d40$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $iSvIT = parcelRequire("iSvIT");

var $1n2d7 = parcelRequire("1n2d7");
var $9bec253661d38d40$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $9bec253661d38d40$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $1n2d7.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $9bec253661d38d40$export$2e2bcd8739ae039 = $9bec253661d38d40$var$VisuallyHidden;

});
parcelRegister("1n2d7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ff9a76d39d960eb$export$2e2bcd8739ae039; });
const $0ff9a76d39d960eb$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $0ff9a76d39d960eb$var$ATOMIC_GROUP_LENGTH = 5;
function $0ff9a76d39d960eb$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $0ff9a76d39d960eb$var$UNDERSCORE_UNICODE ? $0ff9a76d39d960eb$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});


parcelRegister("jfVT7", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_APPEARANCE", function () { return $e04c52603992c8a0$export$d6830277b06edd6; });
var $e04c52603992c8a0$export$d6830277b06edd6 = "normal";

});

parcelRegister("iqTTC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6b6038374caaf37$export$2e2bcd8739ae039; });
/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iy89y = parcelRequire("iy89y");

var $iSvIT = parcelRequire("iSvIT");

var $bnGwB = parcelRequire("bnGwB");
var $cPdGV = parcelRequire("cPdGV");

var $3QOR9 = parcelRequire("3QOR9");

var $jxLBU = parcelRequire("jxLBU");

var $lHitv = parcelRequire("lHitv");

var $jfVT7 = parcelRequire("jfVT7");

var $lek8Z = parcelRequire("lek8Z");
function $d6b6038374caaf37$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d6b6038374caaf37$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d6b6038374caaf37$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iy89y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d6b6038374caaf37$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d6b6038374caaf37$var$buttonStyles = null;
var $d6b6038374caaf37$var$fontStyles = null;
var $d6b6038374caaf37$var$appearanceNormalButtonStyles = null;
var $d6b6038374caaf37$var$appearanceNormalActionsContainerStyles = null;
var $d6b6038374caaf37$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $jfVT7.DEFAULT_APPEARANCE) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $jfVT7.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $bnGwB.default)([
            !isBold && "_1g4l107e _y8dn107e",
            (0, $jxLBU.fg)("platform_ads_explicit_font_styles") && "_11c82smr"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement((0, $lHitv.default), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        return /*#__PURE__*/ $iSvIT.createElement((0, $3QOR9.default), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? "default" : "link",
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            className: (0, $bnGwB.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk69tn6 _1wy69tn6 _b3g39tn6 _eqps9tn6 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                appearance === (0, $jfVT7.DEFAULT_APPEARANCE) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ]),
            style: $d6b6038374caaf37$var$_objectSpread($d6b6038374caaf37$var$_objectSpread({}, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                "--color": (0, $lek8Z.actionTextColor)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--bg-color": (0, $lek8Z.actionBackgroundColor)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--bg-color-hover": (0, $lek8Z.actionBackgroundColor)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--bg-color-active": (0, $lek8Z.actionBackgroundColor)[appearance].active
            }), {}, {
                "--_zkfc5e": (0, $cPdGV.default)("var(--ds-space-100, 8px)".concat(" !important"))
            })
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d6b6038374caaf37$export$2e2bcd8739ae039 = $d6b6038374caaf37$var$FlagActions;

});
parcelRegister("3QOR9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cddad6c22a941f4$export$2e2bcd8739ae039; });

var $5lV35 = parcelRequire("5lV35");

var $9FZmC = parcelRequire("9FZmC");

var $iy89y = parcelRequire("iy89y");

var $gJD9k = parcelRequire("gJD9k");

var $iSvIT = parcelRequire("iSvIT");

var $4NcVB = parcelRequire("4NcVB");

var $i1x6l = parcelRequire("i1x6l");

var $cQ2st = parcelRequire("cQ2st");

var $d35yq = parcelRequire("d35yq");

var $ahWzU = parcelRequire("ahWzU");
var $2cddad6c22a941f4$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $2cddad6c22a941f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2cddad6c22a941f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2cddad6c22a941f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iy89y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2cddad6c22a941f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2cddad6c22a941f4$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $2cddad6c22a941f4$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $2cddad6c22a941f4$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $ahWzU.defaultThemeFn) : _ref2$theme, rest = (0, $gJD9k.default)(_ref2, $2cddad6c22a941f4$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $2cddad6c22a941f4$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $iSvIT.useState)($2cddad6c22a941f4$var$initial), _useState2 = (0, $9FZmC.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $iSvIT.useCallback)(function(event) {
        setState(function(current) {
            return $2cddad6c22a941f4$var$_objectSpread($2cddad6c22a941f4$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $iSvIT.useCallback)(function(event) {
        setState(function(current) {
            return $2cddad6c22a941f4$var$_objectSpread($2cddad6c22a941f4$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $iSvIT.useCallback)(function(event) {
        setState(function(current) {
            return $2cddad6c22a941f4$var$_objectSpread($2cddad6c22a941f4$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $iSvIT.useCallback)(function(event) {
        setState(function(current) {
            return $2cddad6c22a941f4$var$_objectSpread($2cddad6c22a941f4$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $iSvIT.useCallback)(function(event) {
        setState(function(current) {
            return $2cddad6c22a941f4$var$_objectSpread($2cddad6c22a941f4$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $iSvIT.useCallback)(function(event) {
        setState(function(current) {
            return $2cddad6c22a941f4$var$_objectSpread($2cddad6c22a941f4$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ahWzU.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4NcVB.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ahWzU.default).Consumer, (0, $5lV35.default)({
            mode: mode,
            state: $2cddad6c22a941f4$var$getInteractionState($2cddad6c22a941f4$var$_objectSpread($2cddad6c22a941f4$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $cQ2st.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $i1x6l.default), (0, $5lV35.default)({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $d35yq.default), restProps) : null,
                "aria-disabled": isLoading || restProps["aria-disabled"],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $ahWzU.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$2cddad6c22a941f4$var$CustomThemeButton.displayName = "CustomThemeButton";
var $2cddad6c22a941f4$export$2e2bcd8739ae039 = $2cddad6c22a941f4$var$CustomThemeButton;

});
parcelRegister("4NcVB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37d5c44bbcb7e645$export$2e2bcd8739ae039; });

var $18h2D = parcelRequire("18h2D");
// Create default global light theme
var $37d5c44bbcb7e645$var$_createTheme = (0, $18h2D.createTheme)(function() {
    return {
        mode: "light"
    };
}), $37d5c44bbcb7e645$var$Provider = $37d5c44bbcb7e645$var$_createTheme.Provider, $37d5c44bbcb7e645$var$Consumer = $37d5c44bbcb7e645$var$_createTheme.Consumer, $37d5c44bbcb7e645$export$7692396083754928 = $37d5c44bbcb7e645$var$_createTheme.useTheme;
var $37d5c44bbcb7e645$var$Theme = {
    Provider: $37d5c44bbcb7e645$var$Provider,
    Consumer: $37d5c44bbcb7e645$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$37d5c44bbcb7e645$export$2e2bcd8739ae039 = $37d5c44bbcb7e645$var$Theme;

});
parcelRegister("18h2D", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $0d33c1dd0805ae92$export$25d302a5b900a763; });

var $gJD9k = parcelRequire("gJD9k");

var $iSvIT = parcelRequire("iSvIT");
var $0d33c1dd0805ae92$var$_excluded = [
    "children"
];
function $0d33c1dd0805ae92$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $iSvIT.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $gJD9k.default)(props, $0d33c1dd0805ae92$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $iSvIT.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $iSvIT.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("i1x6l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1f1ff3be4dbc24c$export$2e2bcd8739ae039; });

var $5lV35 = parcelRequire("5lV35");

var $gJD9k = parcelRequire("gJD9k");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $iQ58E = parcelRequire("iQ58E");

var $4OZuI = parcelRequire("4OZuI");

var $dyf9a = parcelRequire("dyf9a");

var $7TCqn = parcelRequire("7TCqn");

var $7nG8r = parcelRequire("7nG8r");

var $9prI7 = parcelRequire("9prI7");

var $8pzHV = parcelRequire("8pzHV");

var $dtMM7 = parcelRequire("dtMM7");

var $6JiCZ = parcelRequire("6JiCZ");
var $d1f1ff3be4dbc24c$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $d1f1ff3be4dbc24c$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $d1f1ff3be4dbc24c$var$iconBeforeSpacingFixStyle = (0, $2ZUkg.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $d1f1ff3be4dbc24c$var$iconAfterSpacingFixStyle = (0, $2ZUkg.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $d1f1ff3be4dbc24c$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $6JiCZ.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $d1f1ff3be4dbc24c$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $6JiCZ.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $2ZUkg.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $d1f1ff3be4dbc24c$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $4OZuI.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $4OZuI.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, $gJD9k.default)(props, $d1f1ff3be4dbc24c$var$_excluded);
    var ourRef = (0, $iSvIT.useRef)();
    var setRef = (0, $iSvIT.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $dyf9a.default)(ourRef, autoFocus);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $iQ58E.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "23.2.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $iSvIT.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $iSvIT.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $2ZUkg.css)((0, $dtMM7.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $9prI7.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $9prI7.N500), ")"), " !important")
        }
    };
    return (0, $2ZUkg.jsx)((0, $7TCqn.default), null, (0, $2ZUkg.jsx)(Component, (0, $5lV35.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $d1f1ff3be4dbc24c$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $8pzHV.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $2ZUkg.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dtMM7.getIconStyle)({
                spacing: spacing
            }),
            $d1f1ff3be4dbc24c$var$getSpacingFix(children, $d1f1ff3be4dbc24c$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $d1f1ff3be4dbc24c$var$getChildren(children, [
        fadeStyles,
        (0, $dtMM7.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $2ZUkg.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dtMM7.getIconStyle)({
                spacing: spacing
            }),
            $d1f1ff3be4dbc24c$var$getSpacingFix(children, $d1f1ff3be4dbc24c$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $2ZUkg.jsx)("span", {
        css: [
            (0, $dtMM7.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d1f1ff3be4dbc24c$export$2e2bcd8739ae039 = $d1f1ff3be4dbc24c$var$ButtonBase;

});
parcelRegister("iQ58E", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $db7111bd943e3f6e$export$a4687b0234b40e28; });

var $iy89y = parcelRequire("iy89y");

var $iSvIT = parcelRequire("iSvIT");

var $2wEWn = parcelRequire("2wEWn");

var $hTAEY = parcelRequire("hTAEY");
function $db7111bd943e3f6e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $db7111bd943e3f6e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $db7111bd943e3f6e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iy89y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $db7111bd943e3f6e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $db7111bd943e3f6e$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $2wEWn.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $hTAEY.useTrackedRef)(analyticsData);
    var fnRef = (0, $hTAEY.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $db7111bd943e3f6e$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("2wEWn", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $1d6e53ddadfaa798$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $gfMz3 = parcelRequire("gfMz3");

var $aEdDh = parcelRequire("aEdDh");
function $1d6e53ddadfaa798$export$5bf35293e545f20c() {
    var analyticsContext = (0, $aEdDh.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $gfMz3.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("gfMz3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd53b7f194e15074$export$2e2bcd8739ae039; });

var $5PbkS = parcelRequire("5PbkS");

var $d2wai = parcelRequire("d2wai");

var $hniUP = parcelRequire("hniUP");

var $ajujQ = parcelRequire("ajujQ");

var $dCcTh = parcelRequire("dCcTh");

var $a3soi = parcelRequire("a3soi");

var $ic966 = parcelRequire("ic966");

var $iy89y = parcelRequire("iy89y");

var $5VFir = parcelRequire("5VFir");
function $bd53b7f194e15074$var$_callSuper(t, o, e) {
    return o = (0, $dCcTh.default)(o), (0, $ajujQ.default)(t, $bd53b7f194e15074$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $dCcTh.default)(t).constructor) : o.apply(t, e));
}
function $bd53b7f194e15074$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bd53b7f194e15074$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $bd53b7f194e15074$var$_superPropGet(t, o, e, r) {
    var p = (0, $a3soi.default)((0, $dCcTh.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $bd53b7f194e15074$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $bd53b7f194e15074$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $bd53b7f194e15074$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $d2wai.default)(this, UIAnalyticsEvent);
        _this = $bd53b7f194e15074$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $iy89y.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $iy89y.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $5PbkS.default)(_this.context);
            var handlers = (0, $5PbkS.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $iy89y.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $ic966.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $hniUP.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $bd53b7f194e15074$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $5VFir.default));

});
parcelRegister("5VFir", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45124f37c7ea4865$export$2e2bcd8739ae039; });

var $c7GPN = parcelRequire("c7GPN");

var $d2wai = parcelRequire("d2wai");

var $hniUP = parcelRequire("hniUP");

var $iy89y = parcelRequire("iy89y");
function $45124f37c7ea4865$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45124f37c7ea4865$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45124f37c7ea4865$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iy89y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45124f37c7ea4865$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $45124f37c7ea4865$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $45124f37c7ea4865$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $45124f37c7ea4865$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $d2wai.default)(this, AnalyticsEvent);
        (0, $iy89y.default)(this, "_isAnalyticsEvent", true);
        (0, $iy89y.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $45124f37c7ea4865$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $hniUP.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $c7GPN.default)(updater) === "object") this.payload = $45124f37c7ea4865$var$_objectSpread($45124f37c7ea4865$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("aEdDh", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $7c0836eeb8f1f8fe$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $7c0836eeb8f1f8fe$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("hTAEY", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $d07402974f8395ac$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $d07402974f8395ac$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("9prI7", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $6d9bf194055687d9$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $6d9bf194055687d9$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $6d9bf194055687d9$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $6d9bf194055687d9$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $6d9bf194055687d9$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $6d9bf194055687d9$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $6d9bf194055687d9$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $6d9bf194055687d9$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $6d9bf194055687d9$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $6d9bf194055687d9$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $6d9bf194055687d9$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $6d9bf194055687d9$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $6d9bf194055687d9$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $6d9bf194055687d9$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $6d9bf194055687d9$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $6d9bf194055687d9$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $6d9bf194055687d9$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $6d9bf194055687d9$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $6d9bf194055687d9$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $6d9bf194055687d9$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $6d9bf194055687d9$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $6d9bf194055687d9$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $6d9bf194055687d9$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $6d9bf194055687d9$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $6d9bf194055687d9$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $6d9bf194055687d9$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $6d9bf194055687d9$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $6d9bf194055687d9$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $6d9bf194055687d9$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $6d9bf194055687d9$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $6d9bf194055687d9$export$3d4f271a500072a; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $6d9bf194055687d9$export$4b84fd0e2c617bd = "#FFEBE6";
var $6d9bf194055687d9$export$b34b069eff244586 = "#FFBDAD";
var $6d9bf194055687d9$export$be802dd0d8b57f35 = "#FF8F73";
var $6d9bf194055687d9$export$60847d42f9da92a6 = "#FF7452";
var $6d9bf194055687d9$export$4a7404f376229999 = "#FF5630";
var $6d9bf194055687d9$export$2010d0fb4295b346 = "#DE350B";
var $6d9bf194055687d9$export$2837b5a1a71d5c02 = "#BF2600";
var $6d9bf194055687d9$export$8d9596b529bbb9cf = "#FFFAE6";
var $6d9bf194055687d9$export$41060a744ab0b7ae = "#FFF0B3";
var $6d9bf194055687d9$export$1cc05bbbf340e559 = "#FFE380";
var $6d9bf194055687d9$export$5aae31392d72caaa = "#FFC400";
var $6d9bf194055687d9$export$c6930421db9fa514 = "#FFAB00";
var $6d9bf194055687d9$export$59619663aa6500fb = "#FF991F";
var $6d9bf194055687d9$export$874739ea9e379ab6 = "#FF8B00";
var $6d9bf194055687d9$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $6d9bf194055687d9$export$69a3bf21b9686c2b = "#ABF5D1";
var $6d9bf194055687d9$export$afbce1382ec95f73 = "#79F2C0";
var $6d9bf194055687d9$export$747d86715d4175de = "#57D9A3";
var $6d9bf194055687d9$export$940e1f69e873f202 = "#36B37E";
var $6d9bf194055687d9$export$a49394138f7b8e85 = "#00875A";
var $6d9bf194055687d9$export$6fa04827ac68a4fb = "#006644";
var $6d9bf194055687d9$export$226de0355ed012f8 = "#DEEBFF";
var $6d9bf194055687d9$export$8c13c2ee36917869 = "#B3D4FF";
var $6d9bf194055687d9$export$ecfc1dff386a3e7a = "#4C9AFF";
var $6d9bf194055687d9$export$215b7063051591f1 = "#2684FF";
var $6d9bf194055687d9$export$e62e8919cca44969 = "#0065FF";
var $6d9bf194055687d9$export$b3de0ae08da2ce64 = "#0052CC";
var $6d9bf194055687d9$export$a6ee3d71bc067634 = "#0747A6";
var $6d9bf194055687d9$export$67f15409e87642a1 = "#669DF1";
var $6d9bf194055687d9$export$f0539dbc42dbb067 = "#8FB8F6";
var $6d9bf194055687d9$export$363e4475840015bb = "#EAE6FF";
var $6d9bf194055687d9$export$4b0a4417ed59760f = "#C0B6F2";
var $6d9bf194055687d9$export$6011520a64d9a187 = "#998DD9";
var $6d9bf194055687d9$export$a7175d4e9206bc80 = "#8777D9";
var $6d9bf194055687d9$export$b48405b95304b5a1 = "#6554C0";
var $6d9bf194055687d9$export$c71e4279dd54a18d = "#5243AA";
var $6d9bf194055687d9$export$147899de772240ec = "#403294";
var $6d9bf194055687d9$export$2cf711fe14c66f06 = "#E6FCFF";
var $6d9bf194055687d9$export$7a8f4d33f6f9772c = "#B3F5FF";
var $6d9bf194055687d9$export$776c9c497ef08533 = "#79E2F2";
var $6d9bf194055687d9$export$69cb3ca10c1e330e = "#00C7E6";
var $6d9bf194055687d9$export$9dc1ef0f3f48059b = "#00B8D9";
var $6d9bf194055687d9$export$7c835c78b6fcdef8 = "#00A3BF";
var $6d9bf194055687d9$export$6036577f95c3877e = "#008DA6";
var $6d9bf194055687d9$export$29a4f05edc054374 = "#FFFFFF";
var $6d9bf194055687d9$export$e655ef011c4aa1a2 = "#FAFBFC";
var $6d9bf194055687d9$export$9fdfb749e33cdf97 = "#F4F5F7";
var $6d9bf194055687d9$export$3e51e8f1440314ba = "#EBECF0";
var $6d9bf194055687d9$export$1ce2d1575d444ceb = "#DFE1E6";
var $6d9bf194055687d9$export$8754fc7e6d8b3000 = "#C1C7D0";
var $6d9bf194055687d9$export$c2e91cbeada39b8b = "#B3BAC5";
var $6d9bf194055687d9$export$5f71e19f3a7ad9de = "#A5ADBA";
var $6d9bf194055687d9$export$eaa8c8a70ac22806 = "#97A0AF";
var $6d9bf194055687d9$export$7c87d337fb91a97d = "#8993A4";
var $6d9bf194055687d9$export$d6447c357493214f = "#7A869A";
var $6d9bf194055687d9$export$f563ee71e9ee74cd = "#6B778C";
var $6d9bf194055687d9$export$e2ef2124cf4024b1 = "#5E6C84";
var $6d9bf194055687d9$export$eece5f492e429f08 = "#505F79";
var $6d9bf194055687d9$export$c39c0fe0f26207ae = "#42526E";
var $6d9bf194055687d9$export$7090862dc3038a9f = "#344563";
var $6d9bf194055687d9$export$ad0bacf983b7ddaa = "#253858";
var $6d9bf194055687d9$export$7d61b15e0da132af = "#172B4D";
var $6d9bf194055687d9$export$fbda843f0a27fe96 = "#091E42";
var $6d9bf194055687d9$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $6d9bf194055687d9$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $6d9bf194055687d9$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $6d9bf194055687d9$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $6d9bf194055687d9$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $6d9bf194055687d9$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $6d9bf194055687d9$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $6d9bf194055687d9$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $6d9bf194055687d9$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $6d9bf194055687d9$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $6d9bf194055687d9$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $6d9bf194055687d9$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $6d9bf194055687d9$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $6d9bf194055687d9$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $6d9bf194055687d9$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $6d9bf194055687d9$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $6d9bf194055687d9$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $6d9bf194055687d9$export$2f6319cf7d736c2a = "#E6EDFA";
var $6d9bf194055687d9$export$95126bc8884d6634 = "#DCE5F5";
var $6d9bf194055687d9$export$8338d8c35d44ff1 = "#CED9EB";
var $6d9bf194055687d9$export$5368d76ae4fbbda7 = "#B8C7E0";
var $6d9bf194055687d9$export$9f0a771d16ec8d36 = "#ABBBD6";
var $6d9bf194055687d9$export$abcf8c38338b4aa5 = "#9FB0CC";
var $6d9bf194055687d9$export$97e81faa16a182c7 = "#8C9CB8";
var $6d9bf194055687d9$export$bfe21c59123ecf33 = "#7988A3";
var $6d9bf194055687d9$export$ee82aa2ea6a1558 = "#67758F";
var $6d9bf194055687d9$export$682927c6ed76be02 = "#56637A";
var $6d9bf194055687d9$export$91fd9994c5be9757 = "#455166";
var $6d9bf194055687d9$export$d281fbfe3cff2df6 = "#3B475C";
var $6d9bf194055687d9$export$3902c91d8b98a753 = "#313D52";
var $6d9bf194055687d9$export$8e8133c1ba5845b5 = "#283447";
var $6d9bf194055687d9$export$33ff357f6620b39 = "#202B3D";
var $6d9bf194055687d9$export$633847cf062b69e0 = "#1B2638";
var $6d9bf194055687d9$export$9776a6e503bdbf76 = "#121A29";
var $6d9bf194055687d9$export$6c813d5160dff5db = "#0E1624";
var $6d9bf194055687d9$export$3d4f271a500072a = "#0D1424";
var $6d9bf194055687d9$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $6d9bf194055687d9$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $6d9bf194055687d9$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $6d9bf194055687d9$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $6d9bf194055687d9$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $6d9bf194055687d9$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $6d9bf194055687d9$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $6d9bf194055687d9$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $6d9bf194055687d9$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $6d9bf194055687d9$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $6d9bf194055687d9$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $6d9bf194055687d9$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $6d9bf194055687d9$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $6d9bf194055687d9$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $6d9bf194055687d9$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $6d9bf194055687d9$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $6d9bf194055687d9$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $6d9bf194055687d9$export$d2adc5dedf09fced = "#292A2E";
var $6d9bf194055687d9$export$f51762073d2bb381 = "#94C748";
var $6d9bf194055687d9$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("8pzHV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61fc5b441b52d126$export$2e2bcd8739ae039; });
function $61fc5b441b52d126$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $61fc5b441b52d126$var$tabKeyCode = 9;
function $61fc5b441b52d126$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $61fc5b441b52d126$var$tabKeyCode) return;
    $61fc5b441b52d126$var$abort(event);
}
var $61fc5b441b52d126$var$block = {
    onMouseDownCapture: $61fc5b441b52d126$var$abort,
    onMouseUpCapture: $61fc5b441b52d126$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $61fc5b441b52d126$var$onKey,
    onKeyUpCapture: $61fc5b441b52d126$var$onKey,
    onTouchStartCapture: $61fc5b441b52d126$var$abort,
    onTouchEndCapture: $61fc5b441b52d126$var$abort,
    onPointerDownCapture: $61fc5b441b52d126$var$abort,
    onPointerUpCapture: $61fc5b441b52d126$var$abort,
    onClickCapture: $61fc5b441b52d126$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $61fc5b441b52d126$var$abort
};
var $61fc5b441b52d126$var$doNotBlock = {};
function $61fc5b441b52d126$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $61fc5b441b52d126$var$doNotBlock : $61fc5b441b52d126$var$block;
}

});

parcelRegister("dtMM7", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $9d03d186256d0ddd$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $9d03d186256d0ddd$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $9d03d186256d0ddd$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $9d03d186256d0ddd$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $9d03d186256d0ddd$export$1a9fe1b84c876bb5; });

var $iy89y = parcelRequire("iy89y");

var $2ZUkg = parcelRequire("2ZUkg");

var $jxLBU = parcelRequire("jxLBU");

var $4ng00 = parcelRequire("4ng00");

var $dzEUz = parcelRequire("dzEUz");
function $9d03d186256d0ddd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d03d186256d0ddd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d03d186256d0ddd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iy89y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d03d186256d0ddd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9d03d186256d0ddd$var$gridSize = (0, $4ng00.gridSize)();
var $9d03d186256d0ddd$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $9d03d186256d0ddd$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $9d03d186256d0ddd$var$lineHeights = {
    default: $9d03d186256d0ddd$var$heights.default,
    compact: $9d03d186256d0ddd$var$heights.compact,
    none: "inherit"
};
var $9d03d186256d0ddd$var$padding = {
    // 10px gutter
    default: "0 ".concat($9d03d186256d0ddd$var$gridSize + $9d03d186256d0ddd$var$gridSize / 4, "px"),
    compact: "0 ".concat($9d03d186256d0ddd$var$gridSize + $9d03d186256d0ddd$var$gridSize / 4, "px"),
    none: "0"
};
var $9d03d186256d0ddd$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($9d03d186256d0ddd$var$gridSize / 4, "px"),
    default: "0 ".concat($9d03d186256d0ddd$var$gridSize / 4, "px"),
    none: "0"
};
var $9d03d186256d0ddd$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $9d03d186256d0ddd$var$innerMargin = {
    content: "0 ".concat($9d03d186256d0ddd$var$gridSize / 4, "px"),
    icon: "0 ".concat($9d03d186256d0ddd$var$gridSize / 4, "px")
};
var $9d03d186256d0ddd$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $9d03d186256d0ddd$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&:not([disabled])::after": $9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread({}, $9d03d186256d0ddd$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $9d03d186256d0ddd$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $9d03d186256d0ddd$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $9d03d186256d0ddd$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "transparent"
    }
};
var $9d03d186256d0ddd$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $9d03d186256d0ddd$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $9d03d186256d0ddd$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $9d03d186256d0ddd$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread({}, $9d03d186256d0ddd$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $9d03d186256d0ddd$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $9d03d186256d0ddd$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $9d03d186256d0ddd$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $9d03d186256d0ddd$var$getColor({
            group: (0, $dzEUz.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($9d03d186256d0ddd$var$getColor({
            group: (0, $dzEUz.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $9d03d186256d0ddd$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $9d03d186256d0ddd$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $jxLBU.fg)("platform-component-visual-refresh") && baseColors), {}, {
        cursor: "pointer",
        height: $9d03d186256d0ddd$var$heights[spacing],
        lineHeight: $9d03d186256d0ddd$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $9d03d186256d0ddd$var$singleIconPadding[spacing] : $9d03d186256d0ddd$var$padding[spacing],
        verticalAlign: $9d03d186256d0ddd$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $jxLBU.fg)("platform-component-visual-refresh") && $9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $9d03d186256d0ddd$var$_objectSpread({}, baseColors),
        "&:hover": $9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread({}, $9d03d186256d0ddd$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread({}, $9d03d186256d0ddd$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread({}, $9d03d186256d0ddd$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread({}, $9d03d186256d0ddd$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $9d03d186256d0ddd$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $9d03d186256d0ddd$var$_objectSpread({}, $9d03d186256d0ddd$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $jxLBU.fg)("platform-component-visual-refresh") && (isSelected ? $9d03d186256d0ddd$var$selectedStyles : $9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread($9d03d186256d0ddd$var$_objectSpread({}, appearance === "default" && $9d03d186256d0ddd$var$defaultStyles), appearance === "primary" && $9d03d186256d0ddd$var$primaryStyles), appearance === "link" && $9d03d186256d0ddd$var$linkStyles), appearance === "subtle" && $9d03d186256d0ddd$var$subtleStyles), appearance === "subtle-link" && $9d03d186256d0ddd$var$subtleLinkStyles), appearance === "warning" && $9d03d186256d0ddd$var$warningStyles), appearance === "danger" && $9d03d186256d0ddd$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $9d03d186256d0ddd$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $9d03d186256d0ddd$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $9d03d186256d0ddd$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $9d03d186256d0ddd$var$hasOverlayStyles))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $9d03d186256d0ddd$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $2ZUkg.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $9d03d186256d0ddd$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: "none"
    });
}
function $9d03d186256d0ddd$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $2ZUkg.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $9d03d186256d0ddd$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $9d03d186256d0ddd$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $2ZUkg.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $9d03d186256d0ddd$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("4ng00", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $32f5b88122a48f5d$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "layers", function () { return $32f5b88122a48f5d$export$7be255094ccdc533; });

var $KsdEf = parcelRequire("KsdEf");

var $9prI7 = parcelRequire("9prI7");
var $32f5b88122a48f5d$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $32f5b88122a48f5d$export$c93026a968943f95 = "light";
var $32f5b88122a48f5d$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $32f5b88122a48f5d$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $32f5b88122a48f5d$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $32f5b88122a48f5d$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $9prI7.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $32f5b88122a48f5d$export$6d8204c2cb2e06b8() / 4;
    (0, $KsdEf.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $32f5b88122a48f5d$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $32f5b88122a48f5d$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $32f5b88122a48f5d$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $KsdEf.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $32f5b88122a48f5d$export$ba1d834b86d72a09 = $32f5b88122a48f5d$export$a1b3edb637fb4f35;
var $32f5b88122a48f5d$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $9prI7.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $9prI7.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $9prI7.N30A), ")")
            }
        }
    };
};

});

parcelRegister("dzEUz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e1e476a03d16da6$export$2e2bcd8739ae039; });

var $9prI7 = parcelRequire("9prI7");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $9e1e476a03d16da6$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $9e1e476a03d16da6$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($9prI7.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($9prI7.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($9prI7.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($9prI7.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($9e1e476a03d16da6$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($9prI7.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($9prI7.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($9prI7.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($9prI7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($9prI7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($9prI7.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($9prI7.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($9prI7.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($9prI7.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($9prI7.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($9prI7.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($9prI7.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($9prI7.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($9prI7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($9prI7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($9prI7.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($9prI7.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($9prI7.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($9prI7.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($9prI7.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($9prI7.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($9prI7.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($9prI7.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($9prI7.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($9prI7.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($9prI7.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($9prI7.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($9prI7.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($9prI7.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($9prI7.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($9prI7.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($9prI7.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($9prI7.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($9prI7.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($9prI7.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($9prI7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($9prI7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($9prI7.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($9prI7.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($9e1e476a03d16da6$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($9prI7.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($9prI7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($9prI7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($9prI7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($9prI7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($9prI7.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($9prI7.N500, ")"),
                dark: "var(--ds-text, ".concat($9prI7.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($9prI7.B400, ")"),
                dark: "var(--ds-text, ".concat($9prI7.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($9prI7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($9prI7.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($9prI7.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($9prI7.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($9prI7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($9prI7.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($9prI7.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($9prI7.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($9prI7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($9prI7.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($9prI7.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($9prI7.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($9prI7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($9prI7.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($9prI7.B400, ")"),
                dark: "var(--ds-link, ".concat($9prI7.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($9prI7.B300, ")"),
                dark: "var(--ds-link, ".concat($9prI7.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($9prI7.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($9prI7.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($9prI7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($9prI7.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($9prI7.N500, ")"),
                dark: "var(--ds-text, ".concat($9prI7.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($9prI7.B400, ")"),
                dark: "var(--ds-text, ".concat($9prI7.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($9prI7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($9prI7.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($9prI7.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($9prI7.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($9prI7.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($9prI7.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($9prI7.N400, ")"),
                dark: "var(--ds-text, ".concat($9prI7.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($9prI7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($9prI7.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($9prI7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($9prI7.DN400, ")")
            }
        }
    }
};
var $9e1e476a03d16da6$export$2e2bcd8739ae039 = $9e1e476a03d16da6$var$values;

});


parcelRegister("6JiCZ", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $0143b32df365e33a$export$20bbd2efb0d734c4; });

var $iSvIT = parcelRequire("iSvIT");

var $dnYes = parcelRequire("dnYes");
var $0143b32df365e33a$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $iSvIT.isValidElement)(children) && children.type === (0, $dnYes.default);
};

});


parcelRegister("cQ2st", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $958c3f89ae9c9737$export$2e2bcd8739ae039; });

var $6JiCZ = parcelRequire("6JiCZ");
function $958c3f89ae9c9737$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $6JiCZ.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("d35yq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97ffdd2158b527e7$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $3sb31 = parcelRequire("3sb31");
function $97ffdd2158b527e7$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $97ffdd2158b527e7$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $3sb31.default), {
        size: size,
        label: ", Loading",
        appearance: $97ffdd2158b527e7$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("3sb31", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $283c8e76835bb031$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $d4b42 = parcelRequire("d4b42");

var $iSvIT = parcelRequire("iSvIT");

var $7nG8r = parcelRequire("7nG8r");

var $a4OcG = parcelRequire("a4OcG");

var $1ETbJ = parcelRequire("1ETbJ");
/**
 * Returns the appropriate circle stroke color.
 */ function $283c8e76835bb031$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $a4OcG.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $a4OcG.N0), ")");
}
var $283c8e76835bb031$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $283c8e76835bb031$var$loadIn = null;
var $283c8e76835bb031$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $283c8e76835bb031$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $283c8e76835bb031$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $1ETbJ.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $283c8e76835bb031$var$getStrokeColor(appearance);
    var context = (0, $iSvIT.useContext)((0, $7nG8r.default));
    $283c8e76835bb031$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $d4b42.default)([
            $283c8e76835bb031$var$styles.wrapperStyles,
            $283c8e76835bb031$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $d4b42.default)([
            $283c8e76835bb031$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $d4b42.default)([
            $283c8e76835bb031$var$styles.circleStyles
        ])
    })));
}));
var $283c8e76835bb031$export$2e2bcd8739ae039 = $283c8e76835bb031$var$Spinner;

});
parcelRegister("d4b42", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98343b2c8a9597d6$export$2e2bcd8739ae039; });
const $98343b2c8a9597d6$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $98343b2c8a9597d6$var$ATOMIC_GROUP_LENGTH = 5;
function $98343b2c8a9597d6$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $98343b2c8a9597d6$var$UNDERSCORE_UNICODE ? $98343b2c8a9597d6$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("a4OcG", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $7561387e9bc63ea7$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $7561387e9bc63ea7$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $7561387e9bc63ea7$export$4b84fd0e2c617bd = "#FFEBE6";
var $7561387e9bc63ea7$export$b34b069eff244586 = "#FFBDAD";
var $7561387e9bc63ea7$export$be802dd0d8b57f35 = "#FF8F73";
var $7561387e9bc63ea7$export$60847d42f9da92a6 = "#FF7452";
var $7561387e9bc63ea7$export$4a7404f376229999 = "#FF5630";
var $7561387e9bc63ea7$export$2010d0fb4295b346 = "#DE350B";
var $7561387e9bc63ea7$export$2837b5a1a71d5c02 = "#BF2600";
var $7561387e9bc63ea7$export$8d9596b529bbb9cf = "#FFFAE6";
var $7561387e9bc63ea7$export$41060a744ab0b7ae = "#FFF0B3";
var $7561387e9bc63ea7$export$1cc05bbbf340e559 = "#FFE380";
var $7561387e9bc63ea7$export$5aae31392d72caaa = "#FFC400";
var $7561387e9bc63ea7$export$c6930421db9fa514 = "#FFAB00";
var $7561387e9bc63ea7$export$59619663aa6500fb = "#FF991F";
var $7561387e9bc63ea7$export$874739ea9e379ab6 = "#FF8B00";
var $7561387e9bc63ea7$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $7561387e9bc63ea7$export$69a3bf21b9686c2b = "#ABF5D1";
var $7561387e9bc63ea7$export$afbce1382ec95f73 = "#79F2C0";
var $7561387e9bc63ea7$export$747d86715d4175de = "#57D9A3";
var $7561387e9bc63ea7$export$940e1f69e873f202 = "#36B37E";
var $7561387e9bc63ea7$export$a49394138f7b8e85 = "#00875A";
var $7561387e9bc63ea7$export$6fa04827ac68a4fb = "#006644";
var $7561387e9bc63ea7$export$226de0355ed012f8 = "#DEEBFF";
var $7561387e9bc63ea7$export$8c13c2ee36917869 = "#B3D4FF";
var $7561387e9bc63ea7$export$ecfc1dff386a3e7a = "#4C9AFF";
var $7561387e9bc63ea7$export$215b7063051591f1 = "#2684FF";
var $7561387e9bc63ea7$export$e62e8919cca44969 = "#0065FF";
var $7561387e9bc63ea7$export$b3de0ae08da2ce64 = "#0052CC";
var $7561387e9bc63ea7$export$a6ee3d71bc067634 = "#0747A6";
var $7561387e9bc63ea7$export$67f15409e87642a1 = "#669DF1";
var $7561387e9bc63ea7$export$f0539dbc42dbb067 = "#8FB8F6";
var $7561387e9bc63ea7$export$363e4475840015bb = "#EAE6FF";
var $7561387e9bc63ea7$export$4b0a4417ed59760f = "#C0B6F2";
var $7561387e9bc63ea7$export$6011520a64d9a187 = "#998DD9";
var $7561387e9bc63ea7$export$a7175d4e9206bc80 = "#8777D9";
var $7561387e9bc63ea7$export$b48405b95304b5a1 = "#6554C0";
var $7561387e9bc63ea7$export$c71e4279dd54a18d = "#5243AA";
var $7561387e9bc63ea7$export$147899de772240ec = "#403294";
var $7561387e9bc63ea7$export$2cf711fe14c66f06 = "#E6FCFF";
var $7561387e9bc63ea7$export$7a8f4d33f6f9772c = "#B3F5FF";
var $7561387e9bc63ea7$export$776c9c497ef08533 = "#79E2F2";
var $7561387e9bc63ea7$export$69cb3ca10c1e330e = "#00C7E6";
var $7561387e9bc63ea7$export$9dc1ef0f3f48059b = "#00B8D9";
var $7561387e9bc63ea7$export$7c835c78b6fcdef8 = "#00A3BF";
var $7561387e9bc63ea7$export$6036577f95c3877e = "#008DA6";
var $7561387e9bc63ea7$export$29a4f05edc054374 = "#FFFFFF";
var $7561387e9bc63ea7$export$e655ef011c4aa1a2 = "#FAFBFC";
var $7561387e9bc63ea7$export$9fdfb749e33cdf97 = "#F4F5F7";
var $7561387e9bc63ea7$export$3e51e8f1440314ba = "#EBECF0";
var $7561387e9bc63ea7$export$1ce2d1575d444ceb = "#DFE1E6";
var $7561387e9bc63ea7$export$8754fc7e6d8b3000 = "#C1C7D0";
var $7561387e9bc63ea7$export$c2e91cbeada39b8b = "#B3BAC5";
var $7561387e9bc63ea7$export$5f71e19f3a7ad9de = "#A5ADBA";
var $7561387e9bc63ea7$export$eaa8c8a70ac22806 = "#97A0AF";
var $7561387e9bc63ea7$export$7c87d337fb91a97d = "#8993A4";
var $7561387e9bc63ea7$export$d6447c357493214f = "#7A869A";
var $7561387e9bc63ea7$export$f563ee71e9ee74cd = "#6B778C";
var $7561387e9bc63ea7$export$e2ef2124cf4024b1 = "#5E6C84";
var $7561387e9bc63ea7$export$eece5f492e429f08 = "#505F79";
var $7561387e9bc63ea7$export$c39c0fe0f26207ae = "#42526E";
var $7561387e9bc63ea7$export$7090862dc3038a9f = "#344563";
var $7561387e9bc63ea7$export$ad0bacf983b7ddaa = "#253858";
var $7561387e9bc63ea7$export$7d61b15e0da132af = "#172B4D";
var $7561387e9bc63ea7$export$fbda843f0a27fe96 = "#091E42";
var $7561387e9bc63ea7$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $7561387e9bc63ea7$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $7561387e9bc63ea7$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $7561387e9bc63ea7$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $7561387e9bc63ea7$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $7561387e9bc63ea7$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $7561387e9bc63ea7$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $7561387e9bc63ea7$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $7561387e9bc63ea7$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $7561387e9bc63ea7$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $7561387e9bc63ea7$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $7561387e9bc63ea7$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $7561387e9bc63ea7$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $7561387e9bc63ea7$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $7561387e9bc63ea7$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $7561387e9bc63ea7$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $7561387e9bc63ea7$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $7561387e9bc63ea7$export$2f6319cf7d736c2a = "#E6EDFA";
var $7561387e9bc63ea7$export$95126bc8884d6634 = "#DCE5F5";
var $7561387e9bc63ea7$export$8338d8c35d44ff1 = "#CED9EB";
var $7561387e9bc63ea7$export$5368d76ae4fbbda7 = "#B8C7E0";
var $7561387e9bc63ea7$export$9f0a771d16ec8d36 = "#ABBBD6";
var $7561387e9bc63ea7$export$abcf8c38338b4aa5 = "#9FB0CC";
var $7561387e9bc63ea7$export$97e81faa16a182c7 = "#8C9CB8";
var $7561387e9bc63ea7$export$bfe21c59123ecf33 = "#7988A3";
var $7561387e9bc63ea7$export$ee82aa2ea6a1558 = "#67758F";
var $7561387e9bc63ea7$export$682927c6ed76be02 = "#56637A";
var $7561387e9bc63ea7$export$91fd9994c5be9757 = "#455166";
var $7561387e9bc63ea7$export$d281fbfe3cff2df6 = "#3B475C";
var $7561387e9bc63ea7$export$3902c91d8b98a753 = "#313D52";
var $7561387e9bc63ea7$export$8e8133c1ba5845b5 = "#283447";
var $7561387e9bc63ea7$export$33ff357f6620b39 = "#202B3D";
var $7561387e9bc63ea7$export$633847cf062b69e0 = "#1B2638";
var $7561387e9bc63ea7$export$9776a6e503bdbf76 = "#121A29";
var $7561387e9bc63ea7$export$6c813d5160dff5db = "#0E1624";
var $7561387e9bc63ea7$export$3d4f271a500072a = "#0D1424";
var $7561387e9bc63ea7$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $7561387e9bc63ea7$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $7561387e9bc63ea7$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $7561387e9bc63ea7$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $7561387e9bc63ea7$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $7561387e9bc63ea7$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $7561387e9bc63ea7$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $7561387e9bc63ea7$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $7561387e9bc63ea7$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $7561387e9bc63ea7$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $7561387e9bc63ea7$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $7561387e9bc63ea7$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $7561387e9bc63ea7$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $7561387e9bc63ea7$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $7561387e9bc63ea7$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $7561387e9bc63ea7$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $7561387e9bc63ea7$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $7561387e9bc63ea7$export$d2adc5dedf09fced = "#292A2E";
var $7561387e9bc63ea7$export$f51762073d2bb381 = "#94C748";
var $7561387e9bc63ea7$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("1ETbJ", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $1354562081e188dd$export$4e9f1640bbe7a1a8; });
var $1354562081e188dd$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("ahWzU", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $77d8ee568d0d4db3$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $77d8ee568d0d4db3$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $77d8ee568d0d4db3$export$2e2bcd8739ae039; });

var $iy89y = parcelRequire("iy89y");

var $18h2D = parcelRequire("18h2D");

var $dtMM7 = parcelRequire("dtMM7");
function $77d8ee568d0d4db3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77d8ee568d0d4db3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77d8ee568d0d4db3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iy89y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77d8ee568d0d4db3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $77d8ee568d0d4db3$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $77d8ee568d0d4db3$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $dtMM7.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $77d8ee568d0d4db3$var$stateToSelectorMap[state];
    if (selector) result = $77d8ee568d0d4db3$var$_objectSpread($77d8ee568d0d4db3$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $77d8ee568d0d4db3$var$_objectSpread($77d8ee568d0d4db3$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $77d8ee568d0d4db3$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $77d8ee568d0d4db3$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $77d8ee568d0d4db3$var$Theme = (0, $18h2D.createTheme)(function(themeProps) {
    return {
        buttonStyles: $77d8ee568d0d4db3$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$77d8ee568d0d4db3$export$2e2bcd8739ae039 = $77d8ee568d0d4db3$var$Theme;

});


parcelRegister("lek8Z", function(module, exports) {

$parcel$export(module.exports, "flagBackgroundColor", function () { return $f74a87f81cf93fad$export$59e42969c95d314; });
$parcel$export(module.exports, "flagIconColor", function () { return $f74a87f81cf93fad$export$7f70afe2167f8235; });
$parcel$export(module.exports, "flagIconGlyph", function () { return $f74a87f81cf93fad$export$73f08aee70487cd4; });
$parcel$export(module.exports, "flagTextColor", function () { return $f74a87f81cf93fad$export$f50075b2584087f; });
$parcel$export(module.exports, "flagTextColorToken", function () { return $f74a87f81cf93fad$export$13b42cd9d596bfe0; });
$parcel$export(module.exports, "actionBackgroundColor", function () { return $f74a87f81cf93fad$export$81ba6b63eedb299f; });
$parcel$export(module.exports, "actionTextColor", function () { return $f74a87f81cf93fad$export$7bcfe3cca4dd78b6; });

var $iSvIT = parcelRequire("iSvIT");

var $fQLjC = parcelRequire("fQLjC");

var $ffsFJ = parcelRequire("ffsFJ");

var $bX4nm = parcelRequire("bX4nm");

var $1Eh7B = parcelRequire("1Eh7B");

var $9prI7 = parcelRequire("9prI7");
var $f74a87f81cf93fad$export$59e42969c95d314 = {
    error: "color.background.danger.bold",
    info: "color.background.neutral.bold",
    normal: "elevation.surface.overlay",
    success: "color.background.success.bold",
    warning: "color.background.warning.bold"
};
var $f74a87f81cf93fad$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #626F86)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #172B4D)"
};
var $f74a87f81cf93fad$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fQLjC))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $9prI7.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ffsFJ))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $9prI7.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #44546F)"
    }),
    normal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ffsFJ))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-subtle, ".concat((0, $9prI7.N500), ")"),
        LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
    }),
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bX4nm))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $9prI7.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-success-bold, #1F845A)"
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Eh7B))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-warning-inverse, ".concat((0, $9prI7.N700), ")"),
        LEGACY_secondaryColor: "var(--ds-background-warning-bold, #F5CD47)"
    })
};
var $f74a87f81cf93fad$export$f50075b2584087f = {
    error: "color.text.inverse",
    info: "color.text.inverse",
    normal: "color.text",
    success: "color.text.inverse",
    warning: "color.text.warning.inverse"
};
var $f74a87f81cf93fad$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, ".concat((0, $9prI7.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $9prI7.N0), ")"),
    normal: "var(--ds-text, ".concat((0, $9prI7.N800), ")"),
    success: "var(--ds-text-inverse, ".concat((0, $9prI7.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $9prI7.N700), ")")
};
var $f74a87f81cf93fad$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $9prI7.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $9prI7.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $9prI7.N30A), ")")
    },
    info: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $9prI7.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $9prI7.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $9prI7.N30A), ")")
    },
    error: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $9prI7.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $9prI7.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $9prI7.N30A), ")")
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $9prI7.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $9prI7.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $9prI7.N30A), ")")
    },
    normal: {
        default: "none",
        active: "none",
        pressed: "none"
    }
};
var $f74a87f81cf93fad$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, ".concat((0, $9prI7.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $9prI7.N0), ")"),
    error: "var(--ds-text-inverse, ".concat((0, $9prI7.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $9prI7.N700), ")"),
    normal: "var(--ds-link, ".concat((0, $9prI7.B400), ")")
};

});
parcelRegister("fQLjC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::65cdc00c41545a5e974b615c0e363097>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b8a06a2d89e4dbef$var$_react = $b8a06a2d89e4dbef$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b8a06a2d89e4dbef$var$_error = $b8a06a2d89e4dbef$var$_interopRequireDefault((parcelRequire("aTs34")));

var $b8a06a2d89e4dbef$var$_error2 = $b8a06a2d89e4dbef$var$_interopRequireDefault((parcelRequire("dgWVG")));
function $b8a06a2d89e4dbef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b8a06a2d89e4dbef$var$ErrorIcon = (props)=>/*#__PURE__*/ $b8a06a2d89e4dbef$var$_react.default.createElement($b8a06a2d89e4dbef$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $b8a06a2d89e4dbef$var$_error2.default
    }, props));
$b8a06a2d89e4dbef$var$ErrorIcon.Name = "ErrorIconMigration";
var $b8a06a2d89e4dbef$var$_default = module.exports.default = $b8a06a2d89e4dbef$var$ErrorIcon;

});
parcelRegister("aTs34", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2cd3105f02ad146f4ebeeb5e7e40633>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ee4cc4ff780eb4c$var$_react = $7ee4cc4ff780eb4c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7ee4cc4ff780eb4c$var$_baseNew = $7ee4cc4ff780eb4c$var$_interopRequireDefault((parcelRequire("6K4Lu")));
function $7ee4cc4ff780eb4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ee4cc4ff780eb4c$var$ErrorIcon = (props)=>/*#__PURE__*/ $7ee4cc4ff780eb4c$var$_react.default.createElement($7ee4cc4ff780eb4c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$7ee4cc4ff780eb4c$var$ErrorIcon.displayName = "ErrorIcon";
var $7ee4cc4ff780eb4c$var$_default = module.exports.default = $7ee4cc4ff780eb4c$var$ErrorIcon;

});
parcelRegister("6K4Lu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("lhEn7")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("lhEn7")).Icon; });

var $lhEn7 = parcelRequire("lhEn7");

});
parcelRegister("lhEn7", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $f7ea8088c9bfe3c4$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $f7ea8088c9bfe3c4$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $bnGwB = parcelRequire("bnGwB");

var $jxLBU = parcelRequire("jxLBU");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $f7ea8088c9bfe3c4$var$svgStyles = null;
var $f7ea8088c9bfe3c4$var$iconStyles = null;
var $f7ea8088c9bfe3c4$var$utilityIconStyles = null;
var $f7ea8088c9bfe3c4$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $f7ea8088c9bfe3c4$var$baseHcmStyles = null;
var $f7ea8088c9bfe3c4$var$scaleSize = null;
var $f7ea8088c9bfe3c4$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f7ea8088c9bfe3c4$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f7ea8088c9bfe3c4$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f7ea8088c9bfe3c4$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $f7ea8088c9bfe3c4$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $f7ea8088c9bfe3c4$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $jxLBU.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return /*#__PURE__*/ $iSvIT.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core";
    var size = "size" in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === "small" || props.size === "medium") ? props.size : "medium";
    var baseSize = $f7ea8088c9bfe3c4$var$baseSizeMap[type];
    var viewBoxPadding = $f7ea8088c9bfe3c4$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $bnGwB.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === "utility" || size === "small") && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $bnGwB.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === "utility" ? $f7ea8088c9bfe3c4$var$utilSizes[spacing] : size === "small" ? $f7ea8088c9bfe3c4$var$coreSizeSmall[spacing] : $f7ea8088c9bfe3c4$var$coreSizeMedium[spacing]
        ])
    }));
});
var $f7ea8088c9bfe3c4$export$2e2bcd8739ae039 = $f7ea8088c9bfe3c4$export$f04a61298a47a40f;

});



parcelRegister("dgWVG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a9a7b2771134974$var$_react = $9a9a7b2771134974$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6XNyp = parcelRequire("6XNyp");

var $9a9a7b2771134974$var$_error = $9a9a7b2771134974$var$_interopRequireDefault((parcelRequire("aTs34")));
function $9a9a7b2771134974$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9a9a7b2771134974$var$ErrorIcon = (props)=>/*#__PURE__*/ $9a9a7b2771134974$var$_react.default.createElement($6XNyp.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $9a9a7b2771134974$var$_error.default
    }));
$9a9a7b2771134974$var$ErrorIcon.displayName = "ErrorIcon";
var $9a9a7b2771134974$var$_default = module.exports.default = $9a9a7b2771134974$var$ErrorIcon;

});
parcelRegister("6XNyp", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $511eb1229f8aafad$export$3cfb73f70dfca966; });

var $5lV35 = parcelRequire("5lV35");

var $gJD9k = parcelRequire("gJD9k");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $kzrql = parcelRequire("kzrql");
var $511eb1229f8aafad$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $511eb1229f8aafad$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $511eb1229f8aafad$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $iSvIT.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, $gJD9k.default)(_ref, $511eb1229f8aafad$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $jxLBU.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (iconSize === "small" || iconSize === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Icon, (0, $5lV35.default)({}, props, {
                spacing: (0, $jxLBU.fg)("platform-visual-refresh-icons-facade-button-fix") ? $511eb1229f8aafad$var$sizeSpacingMap["utility"][iconSize] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(_Icon, (0, $5lV35.default)({}, props, {
                size: iconSize,
                spacing: $511eb1229f8aafad$var$sizeSpacingMap["core"][iconSize],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $kzrql.Icon), (0, $5lV35.default)({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("kzrql", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $ef9c595488ab5579$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5lV35 = parcelRequire("5lV35");

var $iy89y = parcelRequire("iy89y");

var $iSvIT = parcelRequire("iSvIT");

var $bnGwB = parcelRequire("bnGwB");
function $ef9c595488ab5579$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef9c595488ab5579$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef9c595488ab5579$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iy89y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef9c595488ab5579$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $ef9c595488ab5579$var$iconStyles = null;
var $ef9c595488ab5579$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $ef9c595488ab5579$var$baseHcmStyles = null;
var $ef9c595488ab5579$var$primaryEqualsSecondaryHcmStyles = null;
var $ef9c595488ab5579$var$secondaryTransparentHcmStyles = null;
var $ef9c595488ab5579$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $iSvIT.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + "px",
        height: height + "px"
    } : null;
    return /*#__PURE__*/ $iSvIT.createElement("span", (0, $5lV35.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $ef9c595488ab5579$var$_objectSpread($ef9c595488ab5579$var$_objectSpread({}, customDimensions), {}, {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $bnGwB.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === "transparent" && "_4fyi1j28",
            size && $ef9c595488ab5579$var$sizeStyles[size]
        ])
    }));
});
var $ef9c595488ab5579$export$2e2bcd8739ae039 = $ef9c595488ab5579$export$f04a61298a47a40f;

});




parcelRegister("ffsFJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cba8aea4f01e137899fc410e6d59c613>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b19e7f66693ff3d8$var$_react = $b19e7f66693ff3d8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b19e7f66693ff3d8$var$_information = $b19e7f66693ff3d8$var$_interopRequireDefault((parcelRequire("lY5CH")));

var $b19e7f66693ff3d8$var$_info = $b19e7f66693ff3d8$var$_interopRequireDefault((parcelRequire("bGd0m")));
function $b19e7f66693ff3d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b19e7f66693ff3d8$var$InformationIcon = (props)=>/*#__PURE__*/ $b19e7f66693ff3d8$var$_react.default.createElement($b19e7f66693ff3d8$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $b19e7f66693ff3d8$var$_info.default
    }, props));
$b19e7f66693ff3d8$var$InformationIcon.Name = "InformationIconMigration";
var $b19e7f66693ff3d8$var$_default = module.exports.default = $b19e7f66693ff3d8$var$InformationIcon;

});
parcelRegister("lY5CH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ffe390399edffb25$var$_react = $ffe390399edffb25$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ffe390399edffb25$var$_baseNew = $ffe390399edffb25$var$_interopRequireDefault((parcelRequire("6K4Lu")));
function $ffe390399edffb25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ffe390399edffb25$var$InformationIcon = (props)=>/*#__PURE__*/ $ffe390399edffb25$var$_react.default.createElement($ffe390399edffb25$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$ffe390399edffb25$var$InformationIcon.displayName = "InformationIcon";
var $ffe390399edffb25$var$_default = module.exports.default = $ffe390399edffb25$var$InformationIcon;

});

parcelRegister("bGd0m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $880db475efd96d6c$var$_react = $880db475efd96d6c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6XNyp = parcelRequire("6XNyp");

var $880db475efd96d6c$var$_information = $880db475efd96d6c$var$_interopRequireDefault((parcelRequire("lY5CH")));
function $880db475efd96d6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $880db475efd96d6c$var$InfoIcon = (props)=>/*#__PURE__*/ $880db475efd96d6c$var$_react.default.createElement($6XNyp.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $880db475efd96d6c$var$_information.default
    }));
$880db475efd96d6c$var$InfoIcon.displayName = "InfoIcon";
var $880db475efd96d6c$var$_default = module.exports.default = $880db475efd96d6c$var$InfoIcon;

});


parcelRegister("bX4nm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c9288f6eb359396f296ae05aab18bb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b38995c84e451ea$var$_react = $8b38995c84e451ea$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8b38995c84e451ea$var$_success = $8b38995c84e451ea$var$_interopRequireDefault((parcelRequire("aZCvt")));

var $8b38995c84e451ea$var$_checkCircle = $8b38995c84e451ea$var$_interopRequireDefault((parcelRequire("5sOWh")));
function $8b38995c84e451ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b38995c84e451ea$var$SuccessIcon = (props)=>/*#__PURE__*/ $8b38995c84e451ea$var$_react.default.createElement($8b38995c84e451ea$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $8b38995c84e451ea$var$_checkCircle.default
    }, props));
$8b38995c84e451ea$var$SuccessIcon.Name = "SuccessIconMigration";
var $8b38995c84e451ea$var$_default = module.exports.default = $8b38995c84e451ea$var$SuccessIcon;

});
parcelRegister("aZCvt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20972219c6507a2ba31d70f1a6537d02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $800d787e5dcf6fe4$var$_react = $800d787e5dcf6fe4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $800d787e5dcf6fe4$var$_baseNew = $800d787e5dcf6fe4$var$_interopRequireDefault((parcelRequire("6K4Lu")));
function $800d787e5dcf6fe4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $800d787e5dcf6fe4$var$SuccessIcon = (props)=>/*#__PURE__*/ $800d787e5dcf6fe4$var$_react.default.createElement($800d787e5dcf6fe4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$800d787e5dcf6fe4$var$SuccessIcon.displayName = "SuccessIcon";
var $800d787e5dcf6fe4$var$_default = module.exports.default = $800d787e5dcf6fe4$var$SuccessIcon;

});

parcelRegister("5sOWh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3fa714b69cad3006$var$_react = $3fa714b69cad3006$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6XNyp = parcelRequire("6XNyp");

var $3fa714b69cad3006$var$_success = $3fa714b69cad3006$var$_interopRequireDefault((parcelRequire("aZCvt")));
function $3fa714b69cad3006$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3fa714b69cad3006$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $3fa714b69cad3006$var$_react.default.createElement($6XNyp.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $3fa714b69cad3006$var$_success.default
    }));
$3fa714b69cad3006$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $3fa714b69cad3006$var$_default = module.exports.default = $3fa714b69cad3006$var$CheckCircleIcon;

});


parcelRegister("1Eh7B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d5fac6bc179ab80298f715340f91ebf9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1336cedb3c3ada10$var$_react = $1336cedb3c3ada10$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1336cedb3c3ada10$var$_warning = $1336cedb3c3ada10$var$_interopRequireDefault((parcelRequire("apOFI")));

var $1336cedb3c3ada10$var$_warning2 = $1336cedb3c3ada10$var$_interopRequireDefault((parcelRequire("aYXtO")));
function $1336cedb3c3ada10$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1336cedb3c3ada10$var$WarningIcon = (props)=>/*#__PURE__*/ $1336cedb3c3ada10$var$_react.default.createElement($1336cedb3c3ada10$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $1336cedb3c3ada10$var$_warning2.default
    }, props));
$1336cedb3c3ada10$var$WarningIcon.Name = "WarningIconMigration";
var $1336cedb3c3ada10$var$_default = module.exports.default = $1336cedb3c3ada10$var$WarningIcon;

});
parcelRegister("apOFI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c615014b011664b243a37531e093f861>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79538b9414c09724$var$_react = $79538b9414c09724$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $79538b9414c09724$var$_baseNew = $79538b9414c09724$var$_interopRequireDefault((parcelRequire("6K4Lu")));
function $79538b9414c09724$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79538b9414c09724$var$WarningIcon = (props)=>/*#__PURE__*/ $79538b9414c09724$var$_react.default.createElement($79538b9414c09724$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$79538b9414c09724$var$WarningIcon.displayName = "WarningIcon";
var $79538b9414c09724$var$_default = module.exports.default = $79538b9414c09724$var$WarningIcon;

});

parcelRegister("aYXtO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7feda56a383115b1$var$_react = $7feda56a383115b1$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6XNyp = parcelRequire("6XNyp");

var $7feda56a383115b1$var$_warning = $7feda56a383115b1$var$_interopRequireDefault((parcelRequire("apOFI")));
function $7feda56a383115b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7feda56a383115b1$var$WarningIcon = (props)=>/*#__PURE__*/ $7feda56a383115b1$var$_react.default.createElement($6XNyp.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $7feda56a383115b1$var$_warning.default
    }));
$7feda56a383115b1$var$WarningIcon.displayName = "WarningIcon";
var $7feda56a383115b1$var$_default = module.exports.default = $7feda56a383115b1$var$WarningIcon;

});




parcelRegister("3PqZG", function(module, exports) {

$parcel$export(module.exports, "useFlagGroup", function () { return $2c9b12f1d6930dc6$export$e91ea202abb66350; });
$parcel$export(module.exports, "default", function () { return $2c9b12f1d6930dc6$export$2e2bcd8739ae039; });
/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $c7GPN = parcelRequire("c7GPN");

var $iSvIT = parcelRequire("iSvIT");

var $bnGwB = parcelRequire("bnGwB");

var $4OZuI = parcelRequire("4OZuI");

var $iy0QV = parcelRequire("iy0QV");
var $aTopn = parcelRequire("aTopn");

var $gWVOm = parcelRequire("gWVOm");

var $4ng00 = parcelRequire("4ng00");

var $dnYes = parcelRequire("dnYes");
var $2c9b12f1d6930dc6$export$1eee5ddc4f6d41c5 = 400;
var $2c9b12f1d6930dc6$var$defaultFlagGroupContext = {
    onDismissed: (0, $4OZuI.default),
    isDismissAllowed: false
};
var $2c9b12f1d6930dc6$export$c57ba665aaa722be = /*#__PURE__*/ (0, $iSvIT.createContext)($2c9b12f1d6930dc6$var$defaultFlagGroupContext);
function $2c9b12f1d6930dc6$export$e91ea202abb66350() {
    return (0, $iSvIT.useContext)($2c9b12f1d6930dc6$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $2c9b12f1d6930dc6$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $2c9b12f1d6930dc6$var$dismissAllowedStyles = null;
var $2c9b12f1d6930dc6$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $2c9b12f1d6930dc6$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? "Flag notifications" : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? "h2" : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $4OZuI.default) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $iSvIT.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, $c7GPN.default)(children) === "object" ? (0, $iSvIT.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return /*#__PURE__*/ $iSvIT.createElement((0, $aTopn.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in"
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return /*#__PURE__*/ $iSvIT.createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $bnGwB.default)([
                        $2c9b12f1d6930dc6$var$groupStyles.root,
                        index === 0 && $2c9b12f1d6930dc6$var$groupStyles.first,
                        index === 1 && $2c9b12f1d6930dc6$var$groupStyles.second,
                        index >= 1 && $2c9b12f1d6930dc6$var$groupStyles.nth,
                        index >= 2 && $2c9b12f1d6930dc6$var$groupStyles.hidden,
                        isDismissAllowed && "_12a7luct",
                        className
                    ]),
                    ref: ref
                }, /*#__PURE__*/ $iSvIT.createElement($2c9b12f1d6930dc6$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $2c9b12f1d6930dc6$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    var flags = /*#__PURE__*/ $iSvIT.createElement("div", {
        id: id,
        className: (0, $bnGwB.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ])
    }, hasFlags ? /*#__PURE__*/ $iSvIT.createElement((0, $dnYes.default), null, /*#__PURE__*/ $iSvIT.createElement(LabelTag, null, label)) : null, /*#__PURE__*/ $iSvIT.createElement((0, $iy0QV.default), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : /*#__PURE__*/ $iSvIT.createElement((0, $gWVOm.default), {
        zIndex: (0, $4ng00.layers).flag()
    }, flags);
};
var $2c9b12f1d6930dc6$export$2e2bcd8739ae039 = $2c9b12f1d6930dc6$var$FlagGroup;

});

parcelRegister("48jF4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3027292740be61e6$export$2e2bcd8739ae039; });
/* dismiss-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");


var $5klXm = parcelRequire("5klXm");

var $jRQIP = parcelRequire("jRQIP");

var $dTniq = parcelRequire("dTniq");

var $5znKT = parcelRequire("5znKT");

var $lek8Z = parcelRequire("lek8Z");
var $3027292740be61e6$var$styles = {
    button: "_16jlidpf _1o9zidpf _i0dl1wug _1dqoglyw _1e0c1txw _1bsb1tcg _4t3i1tcg _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1h6o _1bah1h6o _80omtlke _o5721q9c"
};
var $3027292740be61e6$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($dTniq)));
    var buttonLabel = "Dismiss";
    var size = "small";
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($jRQIP))) : (0, (/*@__PURE__*/$parcel$interopDefault($5klXm)));
        buttonLabel = isExpanded ? "Collapse" : "Expand";
        size = "medium";
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ $iSvIT.createElement((0, $5znKT.default), {
        xcss: $3027292740be61e6$var$styles.button,
        onClick: onClick,
        style: {
            background: "none"
        },
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId,
        "aria-label": buttonLabel
    }, /*#__PURE__*/ $iSvIT.createElement(ButtonIcon, {
        label: "",
        LEGACY_size: size,
        LEGACY_primaryColor: (0, $lek8Z.flagTextColorToken)[appearance],
        color: (0, $lek8Z.flagTextColorToken)[appearance],
        size: "small"
    }));
};
var $3027292740be61e6$var$DismissButton = /*#__PURE__*/ (0, $iSvIT.memo)($3027292740be61e6$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3027292740be61e6$export$2e2bcd8739ae039 = $3027292740be61e6$var$DismissButton;

});
parcelRegister("5klXm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e7cd534c00fe7f264597ee666bf617f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e0fda1bac517ef5$var$_react = $3e0fda1bac517ef5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3e0fda1bac517ef5$var$_chevronDown = $3e0fda1bac517ef5$var$_interopRequireDefault((parcelRequire("dFzSW")));

var $3e0fda1bac517ef5$var$_chevronDown2 = $3e0fda1bac517ef5$var$_interopRequireDefault((parcelRequire("bKbr2")));
function $3e0fda1bac517ef5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e0fda1bac517ef5$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $3e0fda1bac517ef5$var$_react.default.createElement($3e0fda1bac517ef5$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $3e0fda1bac517ef5$var$_chevronDown2.default
    }, props));
$3e0fda1bac517ef5$var$ChevronDownIcon.Name = "ChevronDownIconMigration";
var $3e0fda1bac517ef5$var$_default = module.exports.default = $3e0fda1bac517ef5$var$ChevronDownIcon;

});
parcelRegister("dFzSW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f3af0bebb6f02df$var$_react = $9f3af0bebb6f02df$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9f3af0bebb6f02df$var$_baseNew = $9f3af0bebb6f02df$var$_interopRequireDefault((parcelRequire("6K4Lu")));
function $9f3af0bebb6f02df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9f3af0bebb6f02df$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $9f3af0bebb6f02df$var$_react.default.createElement($9f3af0bebb6f02df$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$9f3af0bebb6f02df$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $9f3af0bebb6f02df$var$_default = module.exports.default = $9f3af0bebb6f02df$var$ChevronDownIcon;

});

parcelRegister("bKbr2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88ccdc5f36aef37e$var$_react = $88ccdc5f36aef37e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6XNyp = parcelRequire("6XNyp");

var $88ccdc5f36aef37e$var$_chevronDown = $88ccdc5f36aef37e$var$_interopRequireDefault((parcelRequire("dFzSW")));
function $88ccdc5f36aef37e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $88ccdc5f36aef37e$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $88ccdc5f36aef37e$var$_react.default.createElement($6XNyp.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $88ccdc5f36aef37e$var$_chevronDown.default
    }));
$88ccdc5f36aef37e$var$HipchatChevronDownIcon.displayName = "HipchatChevronDownIcon";
var $88ccdc5f36aef37e$var$_default = module.exports.default = $88ccdc5f36aef37e$var$HipchatChevronDownIcon;

});


parcelRegister("jRQIP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e591300488a0b21b4d41dc998cb671a7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e76bdd0cd1dc7513$var$_react = $e76bdd0cd1dc7513$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $e76bdd0cd1dc7513$var$_chevronUp = $e76bdd0cd1dc7513$var$_interopRequireDefault((parcelRequire("6JE7O")));

var $e76bdd0cd1dc7513$var$_chevronUp2 = $e76bdd0cd1dc7513$var$_interopRequireDefault((parcelRequire("2bRKA")));
function $e76bdd0cd1dc7513$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e76bdd0cd1dc7513$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $e76bdd0cd1dc7513$var$_react.default.createElement($e76bdd0cd1dc7513$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $e76bdd0cd1dc7513$var$_chevronUp2.default
    }, props));
$e76bdd0cd1dc7513$var$ChevronUpIcon.Name = "ChevronUpIconMigration";
var $e76bdd0cd1dc7513$var$_default = module.exports.default = $e76bdd0cd1dc7513$var$ChevronUpIcon;

});
parcelRegister("6JE7O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::186cfd732e4641b5fdb3f2d7a456f10c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e76120313a5547f$var$_react = $4e76120313a5547f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $4e76120313a5547f$var$_baseNew = $4e76120313a5547f$var$_interopRequireDefault((parcelRequire("6K4Lu")));
function $4e76120313a5547f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e76120313a5547f$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $4e76120313a5547f$var$_react.default.createElement($4e76120313a5547f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$4e76120313a5547f$var$ChevronUpIcon.displayName = "ChevronUpIcon";
var $4e76120313a5547f$var$_default = module.exports.default = $4e76120313a5547f$var$ChevronUpIcon;

});

parcelRegister("2bRKA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19864d8bd8fa206a$var$_react = $19864d8bd8fa206a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6XNyp = parcelRequire("6XNyp");

var $19864d8bd8fa206a$var$_chevronUp = $19864d8bd8fa206a$var$_interopRequireDefault((parcelRequire("6JE7O")));
function $19864d8bd8fa206a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $19864d8bd8fa206a$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $19864d8bd8fa206a$var$_react.default.createElement($6XNyp.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $19864d8bd8fa206a$var$_chevronUp.default
    }));
$19864d8bd8fa206a$var$HipchatChevronUpIcon.displayName = "HipchatChevronUpIcon";
var $19864d8bd8fa206a$var$_default = module.exports.default = $19864d8bd8fa206a$var$HipchatChevronUpIcon;

});


parcelRegister("dTniq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35b8c6b585772b9406ca86ab3c3befd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1d27b936ec34939$var$_react = $a1d27b936ec34939$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $a1d27b936ec34939$var$_close = $a1d27b936ec34939$var$_interopRequireDefault((parcelRequire("1Wek1")));

var $a1d27b936ec34939$var$_cross = $a1d27b936ec34939$var$_interopRequireDefault((parcelRequire("a5KUc")));
function $a1d27b936ec34939$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1d27b936ec34939$var$CloseIcon = (props)=>/*#__PURE__*/ $a1d27b936ec34939$var$_react.default.createElement($a1d27b936ec34939$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $a1d27b936ec34939$var$_cross.default
    }, props));
$a1d27b936ec34939$var$CloseIcon.Name = "CloseIconMigration";
var $a1d27b936ec34939$var$_default = module.exports.default = $a1d27b936ec34939$var$CloseIcon;

});
parcelRegister("1Wek1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2832ce3758295ab6ed0286f39d79816>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $169651446b68ed35$var$_react = $169651446b68ed35$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $169651446b68ed35$var$_baseNew = $169651446b68ed35$var$_interopRequireDefault((parcelRequire("6K4Lu")));
function $169651446b68ed35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Close".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $169651446b68ed35$var$CloseIcon = (props)=>/*#__PURE__*/ $169651446b68ed35$var$_react.default.createElement($169651446b68ed35$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m9.06 8 4.97-4.97-1.06-1.06L8 6.94 3.03 1.97 1.97 3.03 6.94 8l-4.97 4.97 1.06 1.06L8 9.06l4.97 4.97 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$169651446b68ed35$var$CloseIcon.displayName = "CloseIcon";
var $169651446b68ed35$var$_default = module.exports.default = $169651446b68ed35$var$CloseIcon;

});

parcelRegister("a5KUc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $758ec16f858745e1$var$_react = $758ec16f858745e1$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6XNyp = parcelRequire("6XNyp");

var $758ec16f858745e1$var$_close = $758ec16f858745e1$var$_interopRequireDefault((parcelRequire("1Wek1")));
function $758ec16f858745e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $758ec16f858745e1$var$CrossIcon = (props)=>/*#__PURE__*/ $758ec16f858745e1$var$_react.default.createElement($6XNyp.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $758ec16f858745e1$var$_close.default
    }));
$758ec16f858745e1$var$CrossIcon.displayName = "CrossIcon";
var $758ec16f858745e1$var$_default = module.exports.default = $758ec16f858745e1$var$CrossIcon;

});


parcelRegister("5znKT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40e2a5f921fc39be$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5lV35 = parcelRequire("5lV35");

var $gJD9k = parcelRequire("gJD9k");

var $iSvIT = parcelRequire("iSvIT");


var $cvxX2 = parcelRequire("cvxX2");

var $6e0wq = parcelRequire("6e0wq");

var $fxRez = parcelRequire("fxRez");

var $4OZuI = parcelRequire("4OZuI");

var $7nG8r = parcelRequire("7nG8r");

var $5XdYo = parcelRequire("5XdYo");
var $40e2a5f921fc39be$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $40e2a5f921fc39be$var$_excluded2 = [
    "className"
];
var $40e2a5f921fc39be$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $40e2a5f921fc39be$var$Pressable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $4OZuI.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $gJD9k.default)(_ref, $40e2a5f921fc39be$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $6e0wq.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.4",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gJD9k.default)(htmlAttributes, $40e2a5f921fc39be$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement((0, $5XdYo.default), (0, $5lV35.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $fxRez.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $cvxX2.cx)($40e2a5f921fc39be$var$styles.root, isDisabled && $40e2a5f921fc39be$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $40e2a5f921fc39be$export$2e2bcd8739ae039 = $40e2a5f921fc39be$var$Pressable;

});
parcelRegister("5XdYo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $455d4d350416c4b9$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5lV35 = parcelRequire("5lV35");

var $iy89y = parcelRequire("iy89y");

var $gJD9k = parcelRequire("gJD9k");

var $iSvIT = parcelRequire("iSvIT");

var $bnGwB = parcelRequire("bnGwB");
var $cPdGV = parcelRequire("cPdGV");
var $455d4d350416c4b9$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $455d4d350416c4b9$var$_excluded2 = [
    "className"
];
function $455d4d350416c4b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $455d4d350416c4b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $455d4d350416c4b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iy89y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $455d4d350416c4b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $455d4d350416c4b9$var$focusRingStyles = null;
var $455d4d350416c4b9$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $455d4d350416c4b9$var$Focusable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $gJD9k.default)(_ref, $455d4d350416c4b9$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gJD9k.default)(htmlAttributes, $455d4d350416c4b9$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $5lV35.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $bnGwB.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $455d4d350416c4b9$var$_objectSpread($455d4d350416c4b9$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $cPdGV.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $455d4d350416c4b9$export$2e2bcd8739ae039 = $455d4d350416c4b9$var$Focusable;

});



parcelRegister("80242", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d2fecb4a5cbf418$export$2e2bcd8739ae039; });
/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5lV35 = parcelRequire("5lV35");

var $iSvIT = parcelRequire("iSvIT");


var $iy0QV = parcelRequire("iy0QV");
var $g2f6i = parcelRequire("g2f6i");

var $gDNoM = parcelRequire("gDNoM");
var $hMIOK = parcelRequire("hMIOK");
var $5d2fecb4a5cbf418$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
var $5d2fecb4a5cbf418$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ $iSvIT.createElement((0, $gDNoM.default), {
        xcss: $5d2fecb4a5cbf418$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: "1 1 100%",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ $iSvIT.createElement((0, $iy0QV.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ $iSvIT.createElement((0, $g2f6i.default), null, function(props) {
        return /*#__PURE__*/ $iSvIT.createElement((0, $gDNoM.default), (0, $5lV35.default)({
            xcss: $5d2fecb4a5cbf418$var$styles.container
        }, props), /*#__PURE__*/ $iSvIT.createElement((0, $hMIOK.default), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5d2fecb4a5cbf418$export$2e2bcd8739ae039 = $5d2fecb4a5cbf418$var$Expander;

});



parcelRegister("bPtgt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20972219c6507a2ba31d70f1a6537d02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89cb2877c2082d69$var$_react = $89cb2877c2082d69$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $89cb2877c2082d69$var$_baseNew = $89cb2877c2082d69$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $89cb2877c2082d69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89cb2877c2082d69$var$SuccessIcon = (props)=>/*#__PURE__*/ $89cb2877c2082d69$var$_react.default.createElement($89cb2877c2082d69$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$89cb2877c2082d69$var$SuccessIcon.displayName = "SuccessIcon";
var $89cb2877c2082d69$var$_default = module.exports.default = $89cb2877c2082d69$var$SuccessIcon;

});


parcelRegister("fuwlX", function(module, exports) {

$parcel$export(module.exports, "createMoveTicketComment", function () { return $55e1e87c2c6fc24a$export$ec4b78e935e4dfc6; });
const $55e1e87c2c6fc24a$export$ec4b78e935e4dfc6 = async ({ stargateClient: stargateClient, issueId: issueId, comment: comment })=>{
    const query = `
            mutation AddComment($IssueID: String!, $message: String!) {
                customerSupport {
                    addComment(input: {issueKey: $IssueID, message: $message}) {
                        message
                        author {
                            user {
                                accountId
                                name
                                picture
                                __typename
                            }
                            __typename
                        }
                        createdDate {
                            dateTime
                            friendly
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
            }
        `;
    const response = await stargateClient.getCspGraphqlRequest({
        request: JSON.stringify({
            query: query,
            variables: {
                IssueID: issueId,
                message: comment
            }
        })
    });
    return response;
};

});



parcelRegister("73xnO", function(module, exports) {

$parcel$export(module.exports, "RequestAssistanceModalLoader", function () { return (parcelRequire("be0VM")).RequestAssistanceModalLoader; });

var $be0VM = parcelRequire("be0VM");

});
parcelRegister("be0VM", function(module, exports) {

$parcel$export(module.exports, "RequestAssistanceModalLoader", function () { return $d06dd0f033a3bd9b$export$157f3ac7606c323f; });

var $loA2J = parcelRequire("loA2J");

var $7VPzO = parcelRequire("7VPzO");

var $jKp9A = parcelRequire("jKp9A");

var $9gh2a = parcelRequire("9gh2a");
const $d06dd0f033a3bd9b$export$157f3ac7606c323f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7VPzO.default), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
            padding: "space.200",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
                testId: "spinner",
                interactionName: "load",
                label: "Loading",
                size: "medium"
            })
        })
    });
};

});




parcelRegister("jcpuc", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $13b3ae5d11c1173e$export$defe85febe8b728c; });

var $f2Ax6 = parcelRequire("f2Ax6");
const $13b3ae5d11c1173e$export$defe85febe8b728c = (0, $f2Ax6.defineMessages)({
    supportEngineersCardTitle: {
        id: "fastshift.relationships-card.title.support-engineers",
        defaultMessage: "Migration Support Engineers",
        description: "Title for the Support Engineers card"
    },
    supportEngineersCardSubtitle: {
        id: "fastshift.relationships-card.subtitle.support-engineers",
        defaultMessage: "Team of Atlassian experts",
        description: "Subtitle for the Support Engineers card"
    },
    supportEngineersCardButtonText: {
        id: "fastshift.relationships-card.button-text.support-engineers",
        defaultMessage: "Request assistance",
        description: "Button text for the Support Engineers card"
    },
    supportEngineersCardMessageWhenNoAvaters: {
        id: "fastshift.relationships-card.message-when-no-avaters.support-engineers",
        defaultMessage: "Get guidance or support directly from your FastShift team.",
        description: "Message when no avaters are available"
    }
});

});



parcelRegister("l9XU5", function(module, exports) {

$parcel$export(module.exports, "BaseRelationshipsSection", function () { return (parcelRequire("iCI8m")).BaseRelationshipsSection; });

var $iCI8m = parcelRequire("iCI8m");

});
parcelRegister("iCI8m", function(module, exports) {

$parcel$export(module.exports, "BaseRelationshipsSection", function () { return $70e1c3bb39310d1f$export$a1d442548f64d041; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $gf1F9 = parcelRequire("gf1F9");

var $g2DEO = parcelRequire("g2DEO");
var $cgOuH = parcelRequire("cgOuH");

var $7ub1B = parcelRequire("7ub1B");
const $70e1c3bb39310d1f$export$a1d442548f64d041 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $7ub1B.messages).relationshipsSectionBaseTitle))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2DEO.default), {
                gap: "space.200",
                justifyContent: "space-evenly",
                children: children
            })
        ]
    });
};

});
parcelRegister("7ub1B", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $c9024292ed9052f4$export$defe85febe8b728c; });

var $f2Ax6 = parcelRequire("f2Ax6");
const $c9024292ed9052f4$export$defe85febe8b728c = (0, $f2Ax6.defineMessages)({
    relationshipsSectionBaseTitle: {
        id: "fastshift.relationships-section.title",
        defaultMessage: "Help with migration",
        description: "Title for the relationships section"
    }
});

});





parcelRegister("8EbrV", function(module, exports) {

$parcel$export(module.exports, "PartnerRelationshipsSection", function () { return (parcelRequire("3w07O")).PartnerRelationshipsSection; });

var $3w07O = parcelRequire("3w07O");

});
parcelRegister("3w07O", function(module, exports) {

$parcel$export(module.exports, "PartnerRelationshipsSection", function () { return $b39480ef1b44b188$export$d39d039c5fedc1cb; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("7deev");
var $jvsfz = parcelRequire("jvsfz");
parcelRequire("bfgmV");
var $fLAqy = parcelRequire("fLAqy");
parcelRequire("ghRFR");
var $KtL5L = parcelRequire("KtL5L");

var $ddzL3 = parcelRequire("ddzL3");
parcelRequire("l9XU5");
var $iCI8m = parcelRequire("iCI8m");
const $b39480ef1b44b188$export$d39d039c5fedc1cb = ({ relationships: relationships })=>{
    const champion = (0, $ddzL3.findChampion)(relationships);
    const relationshipMapping = (0, $ddzL3.mapRelationships)(relationships);
    const engineers = (0, $ddzL3.filterEngineers)(relationships);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iCI8m.BaseRelationshipsSection), {
        children: [
            champion && /*#__PURE__*/ (0, $loA2J.jsx)((0, $jvsfz.FastshiftChampionCard), {
                champion: champion
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fLAqy.FastshiftTeamCard), {
                relationships: relationshipMapping
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $KtL5L.SupportEngineersCard), {
                engineers: engineers
            })
        ]
    });
};

});
parcelRegister("7deev", function(module, exports) {

$parcel$export(module.exports, "FastshiftChampionCard", function () { return (parcelRequire("jvsfz")).FastshiftChampionCard; });

var $jvsfz = parcelRequire("jvsfz");

});
parcelRegister("jvsfz", function(module, exports) {

$parcel$export(module.exports, "FastshiftChampionCard", function () { return $bb6dcafcae0725d7$export$2843e45fafe457e7; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");
parcelRequire("lnB9x");
var $jg6eR = parcelRequire("jg6eR");
parcelRequire("6f79W");
var $dWInj = parcelRequire("dWInj");

var $4ZovB = parcelRequire("4ZovB");
const $bb6dcafcae0725d7$var$contentStyles = (0, $jAMCU.xcss)({
    height: "100%"
});
const $bb6dcafcae0725d7$export$2843e45fafe457e7 = ({ champion: champion })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jg6eR.BaseCard), {
        message: (0, $4ZovB.messages).fastshiftChampionCardTitle,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
            xcss: $bb6dcafcae0725d7$var$contentStyles,
            space: "space.400",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $4ZovB.messages).fastshiftChampionCardSubtitle))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dWInj.CardRelationship), {
                    name: champion.name,
                    imageUrl: champion.imageUrl,
                    titleMessage: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $4ZovB.messages).fastshiftChampionTitle), {
                        values: {
                            title: champion.title
                        }
                    }))
                })
            ]
        })
    });
};

});
parcelRegister("4ZovB", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $33329ad44f4aed1c$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $33329ad44f4aed1c$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    fastshiftChampionCardTitle: {
        id: "fastshift.relationships-card.title.fastshift-champion",
        defaultMessage: "Your FastShift Champion",
        description: "Title for the FastShift champion card"
    },
    fastshiftChampionCardSubtitle: {
        id: "fastshift.relationships-card.subtitle.fastshift-champion",
        defaultMessage: "A dedicated expert for migration topics",
        description: "Subtitle for the FastShift champion card"
    },
    fastshiftChampionTitle: {
        id: "fastshift.relationships-card.relationship-name.fastshift-champion",
        defaultMessage: "{title}",
        description: "Name of the FastShift champion"
    }
});

});





parcelRegister("9I3Pg", function(module, exports) {

$parcel$export(module.exports, "NoRelationshipsSection", function () { return (parcelRequire("54htJ")).NoRelationshipsSection; });

var $54htJ = parcelRequire("54htJ");

});
parcelRegister("54htJ", function(module, exports) {

$parcel$export(module.exports, "NoRelationshipsSection", function () { return $8d6fbd5533bb3124$export$37a75793f68c1ae9; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("89AVb");
var $hx13k = parcelRequire("hx13k");
parcelRequire("ceQTh");
var $eAEjZ = parcelRequire("eAEjZ");
parcelRequire("l9XU5");
var $iCI8m = parcelRequire("iCI8m");
const $8d6fbd5533bb3124$export$37a75793f68c1ae9 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iCI8m.BaseRelationshipsSection), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eAEjZ.RequestSupportCard), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hx13k.MigrationResourcesCard), {})
        ]
    });
};

});
parcelRegister("ceQTh", function(module, exports) {

$parcel$export(module.exports, "RequestSupportCard", function () { return (parcelRequire("eAEjZ")).RequestSupportCard; });

var $eAEjZ = parcelRequire("eAEjZ");

});
parcelRegister("eAEjZ", function(module, exports) {

$parcel$export(module.exports, "RequestSupportCard", function () { return $336aed5f86ff62e4$export$104b222f73a621bd; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $9B16h = parcelRequire("9B16h");

var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");
parcelRequire("2T6pW");
var $kCIZI = parcelRequire("kCIZI");
parcelRequire("lnB9x");
var $jg6eR = parcelRequire("jg6eR");
parcelRequire("kxNHH");
var $ivzWG = parcelRequire("ivzWG");

var $hSVAz = parcelRequire("hSVAz");
const $336aed5f86ff62e4$var$contentStyles = (0, $jAMCU.xcss)({
    height: "100%"
});
const $336aed5f86ff62e4$export$104b222f73a621bd = ()=>{
    const [isModalOpen, setIsModalOpen] = (0, $iSvIT.useState)(false);
    const { sendRequestAssistanceButtonClickUIEvent: sendRequestAssistanceButtonClickUIEvent } = (0, $kCIZI.useRelationshipsAnalytics)();
    const handleRequestAssistanceClick = ()=>{
        sendRequestAssistanceButtonClickUIEvent();
        setIsModalOpen(true);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jg6eR.BaseCard), {
        message: (0, $hSVAz.messages).requestSupportCardTitle,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
            xcss: $336aed5f86ff62e4$var$contentStyles,
            space: "space.100",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $hSVAz.messages).requestSupportCardDescription))
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $ivzWG.RequestAssistanceModal), {
                            isModalOpen: isModalOpen,
                            setIsModalOpen: setIsModalOpen
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                            onClick: handleRequestAssistanceClick,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $hSVAz.messages).requestSupportCardButton))
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("hSVAz", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $5217db1f42cea753$export$defe85febe8b728c; });

var $f2Ax6 = parcelRequire("f2Ax6");
const $5217db1f42cea753$export$defe85febe8b728c = (0, $f2Ax6.defineMessages)({
    requestSupportCardTitle: {
        id: "fastshift.relationships-card.title.request-support",
        defaultMessage: "Reach out to your dedicated FastShift Team",
        description: "Title for the Request Support card"
    },
    requestSupportCardDescription: {
        id: "fastshift.relationships-card.description.request-support",
        defaultMessage: "Ask for guidance and assistance from a team of migration experts",
        description: "Description for the Request Support card"
    },
    requestSupportCardButton: {
        id: "fastshift.relationships-card.button.request-support",
        defaultMessage: "Request Assistance",
        description: "Button text for the Request Support card"
    }
});

});





parcelRegister("b7ahr", function(module, exports) {

$parcel$export(module.exports, "InternalRelationshipsSection", function () { return (parcelRequire("iU2Al")).InternalRelationshipsSection; });

var $iU2Al = parcelRequire("iU2Al");

});
parcelRegister("iU2Al", function(module, exports) {

$parcel$export(module.exports, "InternalRelationshipsSection", function () { return $82cf46b010c18aa7$export$9a4ec837500c7c49; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("bfgmV");
var $fLAqy = parcelRequire("fLAqy");
parcelRequire("ghRFR");
var $KtL5L = parcelRequire("KtL5L");

var $ddzL3 = parcelRequire("ddzL3");
parcelRequire("l9XU5");
var $iCI8m = parcelRequire("iCI8m");
const $82cf46b010c18aa7$export$9a4ec837500c7c49 = ({ relationships: relationships })=>{
    const relationshipMapping = (0, $ddzL3.mapRelationships)(relationships);
    const engineers = (0, $ddzL3.filterEngineers)(relationships);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iCI8m.BaseRelationshipsSection), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fLAqy.FastshiftTeamCard), {
                relationships: relationshipMapping
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $KtL5L.SupportEngineersCard), {
                engineers: engineers
            })
        ]
    });
};

});



parcelRegister("hybbY", function(module, exports) {

$parcel$export(module.exports, "RelationshipSection", function () { return $6d671885154deea1$export$3cd80b91cd232f4b; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $7akU3 = parcelRequire("7akU3");
var $jAMCU = parcelRequire("jAMCU");

var $9gh2a = parcelRequire("9gh2a");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");

var $bHtXm = parcelRequire("bHtXm");
parcelRequire("9cVxH");
var $5nKIy = parcelRequire("5nKIy");
parcelRequire("b7ahr");
var $iU2Al = parcelRequire("iU2Al");
parcelRequire("9I3Pg");
var $54htJ = parcelRequire("54htJ");
parcelRequire("8EbrV");
var $3w07O = parcelRequire("3w07O");
parcelRequire("2T6pW");
var $jAoD1 = parcelRequire("jAoD1");
const $6d671885154deea1$var$loadingWrapperStyles = (0, $jAMCU.xcss)({
    padding: "space.500"
});
const $6d671885154deea1$var$renderSectionByUserType = ({ userType: userType, relationships: relationships })=>{
    switch(userType){
        case (0, $bHtXm.USER_TYPE).CUSTOMER:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nKIy.CustomerRelationshipsSection), {
                relationships: relationships
            });
        case (0, $bHtXm.USER_TYPE).PARTNER:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3w07O.PartnerRelationshipsSection), {
                relationships: relationships
            });
        case (0, $bHtXm.USER_TYPE).INTERNAL:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iU2Al.InternalRelationshipsSection), {
                relationships: relationships
            });
        default:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $54htJ.NoRelationshipsSection), {});
    }
};
const $6d671885154deea1$export$3cd80b91cd232f4b = ()=>{
    const { pending: customerDomainPending, data: customerDomainData } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomain);
    const { pending: userDetailsPending, data: userDetailsData } = (0, $8KnwD.useFastshiftSelector)((state)=>state.userDetails);
    const relationships = (0, $iSvIT.useMemo)(()=>(customerDomainData === null || customerDomainData === void 0 ? void 0 : customerDomainData.relationships) || [], [
        customerDomainData === null || customerDomainData === void 0 ? void 0 : customerDomainData.relationships
    ]);
    // Use the page analytics hook (auto-fires section display event)
    (0, $jAoD1.useRelationshipsPageAnalytics)(relationships);
    if (customerDomainPending || userDetailsPending) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $6d671885154deea1$var$loadingWrapperStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
            testId: "spinner",
            interactionName: "load",
            label: "Loading",
            size: "medium"
        })
    });
    // No staffs assigned to this customer domain
    if (relationships.length === 0) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $54htJ.NoRelationshipsSection), {});
    return $6d671885154deea1$var$renderSectionByUserType({
        userType: (userDetailsData === null || userDetailsData === void 0 ? void 0 : userDetailsData.userType) || "",
        relationships: relationships
    });
};

});
parcelRegister("bHtXm", function(module, exports) {

$parcel$export(module.exports, "USER_TYPE", function () { return $3bac343a13a6a0bb$export$30fccd4d2a57a124; });
$parcel$export(module.exports, "PRODUCT_NAME", function () { return $3bac343a13a6a0bb$export$a75e537c279a265a; });
const $3bac343a13a6a0bb$export$30fccd4d2a57a124 = {
    INTERNAL: "INTERNAL",
    PARTNER: "PARTNER",
    CUSTOMER: "CUSTOMER"
};
const $3bac343a13a6a0bb$export$a75e537c279a265a = {
    JIRA: "JIRA",
    CONFLUENCE: "CONFLUENCE"
};

});



parcelRegister("iMIhQ", function(module, exports) {

$parcel$export(module.exports, "getCurrentTime", function () { return (parcelRequire("lTj8F")).getCurrentTime; });

var $lTj8F = parcelRequire("lTj8F");

});
parcelRegister("lTj8F", function(module, exports) {

$parcel$export(module.exports, "getCurrentTime", function () { return $7c625e52dbbe6e77$export$a86190deb5c4a8d0; });
const $7c625e52dbbe6e77$export$a86190deb5c4a8d0 = ()=>{
    return Date.now();
};

});


parcelRegister("6D9is", function(module, exports) {

$parcel$export(module.exports, "PartnerWelcomeBanner", function () { return (parcelRequire("dNgHf")).PartnerWelcomeBanner; });
$parcel$export(module.exports, "CustomerWelcomeBanner", function () { return (parcelRequire("8Omk5")).CustomerWelcomeBanner; });
parcelRequire("97rlo");
var $gdlbx = parcelRequire("gdlbx");
parcelRequire("lAxU3");
var $dNgHf = parcelRequire("dNgHf");
parcelRequire("jcGFk");
var $8Omk5 = parcelRequire("8Omk5");

});
parcelRegister("97rlo", function(module, exports) {

var $gdlbx = parcelRequire("gdlbx");

});
parcelRegister("gdlbx", function(module, exports) {

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $gf1F9 = parcelRequire("gf1F9");

var $257fv = parcelRequire("257fv");
var $6fxse = parcelRequire("6fxse");
var $jXVyf = parcelRequire("jXVyf");
var $agt8L = parcelRequire("agt8L");
var $j7TVc = parcelRequire("j7TVc");

var $5wOn9 = parcelRequire("5wOn9");
parcelRequire("g5UIP");
var $8Qr1d = parcelRequire("8Qr1d");

var $cRpOR = parcelRequire("cRpOR");
const $4715432c90ac21cf$var$headerContainerStyles = (0, $j7TVc.xcss)({
    borderRadius: "border.radius.200"
});
const $4715432c90ac21cf$var$getCurrentTimestamp = ()=>Date.now();
const $4715432c90ac21cf$export$7818bb44bde66378 = ()=>{
    const currentTime = $4715432c90ac21cf$var$getCurrentTimestamp();
    const userInfo = (0, $5wOn9.useLoggedInUser)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
        backgroundColor: "color.background.accent.teal.subtlest.hovered",
        padding: "space.200",
        xcss: $4715432c90ac21cf$var$headerContainerStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
            space: "space.250",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $agt8L.default), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6x1qA.FormattedDate), {
                                weekday: "long",
                                day: "numeric",
                                month: "long",
                                value: currentTime
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            size: "medium",
                            children: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $cRpOR.messages).bannerTitleWithName), {
                                values: {
                                    name: userInfo.name
                                }
                            })) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $cRpOR.messages).bannerTitleWithoutName))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6fxse.default), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8Qr1d.OrgSelectorDropdown), {})
                })
            ]
        })
    });
};

});
parcelRegister("g5UIP", function(module, exports) {

$parcel$export(module.exports, "OrgSelectorDropdown", function () { return (parcelRequire("8Qr1d")).OrgSelectorDropdown; });

var $8Qr1d = parcelRequire("8Qr1d");

});
parcelRegister("8Qr1d", function(module, exports) {

$parcel$export(module.exports, "OrgSelectorDropdown", function () { return $9be6ffb0a0d37015$export$dea5ca6f2210466; });
/* org-selector-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $3XfGP = parcelRequire("3XfGP");

var $4a5Re = parcelRequire("4a5Re");
var $3Oabj = parcelRequire("3Oabj");
var $c3HvU = parcelRequire("c3HvU");

var $4vcv5 = parcelRequire("4vcv5");

var $fud2I = parcelRequire("fud2I");

var $iy4Sr = parcelRequire("iy4Sr");

var $6fxse = parcelRequire("6fxse");
var $agt8L = parcelRequire("agt8L");
parcelRequire("enHYO");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");
var $k4eOf = parcelRequire("k4eOf");

var $k0rCZ = parcelRequire("k0rCZ");

var $duVls = parcelRequire("duVls");
// can be replaced with <Pressable/> once @atlaskit/primitives package is updated
const $9be6ffb0a0d37015$var$CustomStyledDropdownButton = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_zs12u2gc _7dir1fxt _dpd31txw _xlob1h6o _kewe18iy _1i07fg4m _1uc61lh4 _1i531lh4 _pmi91fxt _sqia15cr",
            __cmplp.className
        ])
    }));
});
const $9be6ffb0a0d37015$var$OrgSelectorButtonMessage = ()=>{
    const selectedOrg = (0, $8KnwD.useFastshiftSelector)((state)=>state.selectedOrg);
    const orgs = (0, $8KnwD.useFastshiftSelector)((state)=>state.orgs);
    const isOrgAdmin = orgs.data.length > 1;
    if (orgs === null || orgs === void 0 ? void 0 : orgs.pending) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $duVls.messages).orgSelectorDropdownLoadingOrgs));
    if (!isOrgAdmin) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $duVls.messages).orgSelectorDropdownNotOrgAdmin));
    if (isOrgAdmin && (selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id) === (0, $k4eOf.NO_ORG_ID)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $duVls.messages).orgSelectorDropdownNoOrgForOrgAdmin));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $duVls.messages).orgSelectorDropdownSelectedCloudOrg), {
        values: {
            orgName: selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.name
        }
    }));
};
const $9be6ffb0a0d37015$var$OrgSelectorDropdownButton = (_param)=>{
    var { triggerRef: triggerRef } = _param, providedProps = (0, $akGnX._)(_param, [
        "triggerRef"
    ]);
    const selectedOrg = (0, $8KnwD.useFastshiftSelector)((state)=>state.selectedOrg);
    const orgs = (0, $8KnwD.useFastshiftSelector)((state)=>state.orgs);
    const isOrgAdmin = orgs.data.length > 1;
    const { fireUIEvent: fireUIEvent } = (0, $ih47h.useFireAnalyticsEvents)();
    const sendClickDropdownEvent = ()=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).DROPDOWN,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).ORG_SELECTOR_DROPDOWN,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_DASHBOARD_SCREEN,
            attributes: {}
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)($9be6ffb0a0d37015$var$CustomStyledDropdownButton, {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XfGP.default), (0, $6iHNw._)((0, $7Knp0._)({
            ref: triggerRef
        }, providedProps), {
            appearance: "primary",
            spacing: "compact",
            isDisabled: !selectedOrg || !isOrgAdmin,
            isLoading: !orgs || (orgs === null || orgs === void 0 ? void 0 : orgs.pending),
            onClick: (e)=>{
                var _providedProps_onClick;
                sendClickDropdownEvent();
                (_providedProps_onClick = providedProps.onClick) === null || _providedProps_onClick === void 0 ? void 0 : _providedProps_onClick.call(providedProps, e);
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6fxse.default), {
                space: "space.100",
                alignInline: "center",
                alignBlock: "center",
                children: [
                    (selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id) === (0, $k4eOf.NO_ORG_ID) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fud2I))), {
                        label: "Unassociated icon",
                        color: "var(--ds-icon-accent-teal, #2898BD)"
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iy4Sr))), {
                        label: "Org icon",
                        color: "var(--ds-icon-accent-teal, #2898BD)"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $agt8L.default), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($9be6ffb0a0d37015$var$OrgSelectorButtonMessage, {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4vcv5))), {
                        label: "Chevron down icon",
                        size: "small"
                    })
                ]
            })
        }))
    });
};
const $9be6ffb0a0d37015$export$dea5ca6f2210466 = ()=>{
    const selectedOrg = (0, $8KnwD.useFastshiftSelector)((state)=>state.selectedOrg);
    const orgs = (0, $8KnwD.useFastshiftSelector)((state)=>state.orgs);
    const dispatch = (0, $8KnwD.useFastshiftDispatch)();
    const isOrgAdmin = orgs.data.length > 1;
    const { fireUIEvent: fireUIEvent, fireTrackEvent: fireTrackEvent } = (0, $ih47h.useFireAnalyticsEvents)(); // send track event once org selector dropdown is loaded
    const loadStartRef = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useRef(Date.now());
    const hasSentTrackEvent = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useEffect(()=>{
        const orgsLoaded = orgs && orgs.data && orgs.data.length > 0 && !orgs.pending;
        const selectedOrgLoaded = !!selectedOrg;
        if (orgsLoaded && selectedOrgLoaded && !hasSentTrackEvent.current) {
            const elapsed = Date.now() - loadStartRef.current;
            hasSentTrackEvent.current = true;
            fireTrackEvent({
                action: (0, $k7z8r.ActionKey).DISPLAYED,
                actionSubject: (0, $k7z8r.ActionSubjectKey).DROPDOWN,
                actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).ORG_SELECTOR_DROPDOWN,
                source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_DASHBOARD_SCREEN,
                attributes: {
                    orgDropdownEnabled: isOrgAdmin,
                    loadTime: elapsed,
                    selectedOrgId: selectedOrg.id,
                    totalOrgCount: orgs.data.length - 1 // excluding 'No Org'
                }
            });
        }
    }, [
        orgs,
        selectedOrg,
        isOrgAdmin,
        fireTrackEvent
    ]); // not org admin UI display
    if (!isOrgAdmin && selectedOrg) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $agt8L.default), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $duVls.messages).orgSelectorDropdownNotOrgAdmin))
    });
    const sendClickDropdownItemEvent = (orgId)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).DROPDOWN_ITEM,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).ORG_SELECTOR_DROPDOWN,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_DASHBOARD_SCREEN,
            attributes: {
                selectedOrgId: orgId
            }
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4a5Re.default), {
        // this is atlaskit's recommended pattern for custom trigger components
        // eslint-disable-next-line react/no-unstable-nested-components
        trigger: (_param)=>/*#__PURE__*/ {
            var { triggerRef: triggerRef } = _param, providedProps = (0, $akGnX._)(_param, [
                "triggerRef"
            ]);
            return (0, $loA2J.jsx)($9be6ffb0a0d37015$var$OrgSelectorDropdownButton, (0, $7Knp0._)({
                triggerRef: triggerRef
            }, providedProps));
        },
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $c3HvU.default), {
            children: orgs.data.map((org)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $3Oabj.default), {
                    isSelected: org.id === (selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.id),
                    onClick: ()=>{
                        dispatch((0, $k0rCZ.setSelectedOrg)(org));
                        sendClickDropdownItemEvent(org.id);
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6fxse.default), {
                        space: "space.100",
                        alignBlock: "center",
                        children: [
                            org.id === (0, $k4eOf.NO_ORG_ID) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fud2I))), {
                                label: "Unassociated icon",
                                color: "var(--ds-icon-accent-teal, #2898BD)"
                            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iy4Sr))), {
                                label: "Org icon",
                                color: "var(--ds-icon-accent-teal, #2898BD)"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $agt8L.default), {
                                children: org.id === (0, $k4eOf.NO_ORG_ID) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $duVls.messages).orgSelectorDropdownNoOrgForOrgAdmin)) : org === null || org === void 0 ? void 0 : org.name
                            })
                        ]
                    })
                }, org.id))
        })
    });
};

});
parcelRegister("fud2I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81177d596079c24ecbc8bf8bc933664f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b463c66689fa7558$var$_react = $b463c66689fa7558$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b463c66689fa7558$var$_baseNew = $b463c66689fa7558$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b463c66689fa7558$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b463c66689fa7558$var$InboxIcon = (props)=>/*#__PURE__*/ $b463c66689fa7558$var$_react.default.createElement($b463c66689fa7558$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v5h3a.75.75 0 0 1 .75.75 1.75 1.75 0 1 0 3.5 0A.75.75 0 0 1 10.5 8h3V3a.5.5 0 0 0-.5-.5zm10.5 7h-2.337a3.251 3.251 0 0 1-6.326 0H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 6H4V4.5h8z" clip-rule="evenodd"/>`
    }, props));
$b463c66689fa7558$var$InboxIcon.displayName = "InboxIcon";
var $b463c66689fa7558$var$_default = module.exports.default = $b463c66689fa7558$var$InboxIcon;

});

parcelRegister("duVls", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $745655f41bbc3ad9$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $745655f41bbc3ad9$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    orgSelectorDropdownSelectedCloudOrg: {
        id: "fastshift.dashboard.welcome-banner.org-selector.selected-org",
        defaultMessage: "Cloud org: {orgName}",
        description: "Selected org on org selector dropdown button on welcome banner"
    },
    orgSelectorDropdownNoOrgForOrgAdmin: {
        id: "fastshift.dashboard.welcome-banner.org-selector.selected-org-is-no-org",
        defaultMessage: "Tickets from Other Cloud Orgs",
        description: "Message for MOVE tickets from cloud orgs that the customer is NOT org admin of, in the org selector dropdown button on welcome banner"
    },
    orgSelectorDropdownLoadingOrgs: {
        id: "fastshift.dashboard.welcome-banner.org-selector.orgs-loading",
        defaultMessage: "Loading orgs...",
        description: "Message displayed on org selector while orgs are still loading"
    },
    orgSelectorDropdownNotOrgAdmin: {
        id: "fastshift.dashboard.welcome-banner.org-selector.not-org-admin",
        defaultMessage: "Welcome to the FastShift Portal. You can track migration progress for the products you're an admin of here.",
        description: "Message displayed instead of the dropdown when the user is not an org admin"
    }
});

});



parcelRegister("cRpOR", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $0cd78403da7d1c0d$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $0cd78403da7d1c0d$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    bannerTitleWithName: {
        id: "fastshift.dashboard.welcome-banner.title-with-name",
        defaultMessage: "Hello, {name}!",
        description: "Greeting message for the welcome banner"
    },
    bannerTitleWithoutName: {
        id: "fastshift.dashboard.welcome-banner.title-without-name",
        defaultMessage: "Hello!",
        description: "Greeting message for the welcome banner when the user's name is not available"
    }
});

});



parcelRegister("lAxU3", function(module, exports) {

$parcel$export(module.exports, "PartnerWelcomeBanner", function () { return (parcelRequire("dNgHf")).PartnerWelcomeBanner; });

var $dNgHf = parcelRequire("dNgHf");

});
parcelRegister("dNgHf", function(module, exports) {

$parcel$export(module.exports, "PartnerWelcomeBanner", function () { return $e30848f671d7417f$export$67eb7e9c5afe3a4c; });

var $365qV = parcelRequire("365qV");

var $gnPGs = parcelRequire("gnPGs");

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iri2o");
var $2f2l0 = parcelRequire("2f2l0");

var $kfVRP = parcelRequire("kfVRP");
const $e30848f671d7417f$export$67eb7e9c5afe3a4c = (_param)=>{
    var props = (0, $365qV._)({}, (0, $gnPGs._)(_param));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2f2l0.BaseWelcomeBanner), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        subtitleMessage: (0, $kfVRP.messages).partnerWelcomeBannerSubtitle
    }));
};

});
parcelRegister("iri2o", function(module, exports) {

$parcel$export(module.exports, "BaseWelcomeBanner", function () { return (parcelRequire("2f2l0")).BaseWelcomeBanner; });

var $2f2l0 = parcelRequire("2f2l0");

});
parcelRegister("2f2l0", function(module, exports) {

$parcel$export(module.exports, "BaseWelcomeBanner", function () { return $338b16ec733a1a69$export$cd351313b790cee4; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $gf1F9 = parcelRequire("gf1F9");

var $g2DEO = parcelRequire("g2DEO");
var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $FrcWq = parcelRequire("FrcWq");

var $hiu3w = parcelRequire("hiu3w");
const $338b16ec733a1a69$var$headerContainerStyles = (0, $jAMCU.xcss)({
    borderRadius: "border.radius.200",
    backgroundColor: "color.background.selected"
});
const $338b16ec733a1a69$var$contentContainerStyles = (0, $jAMCU.xcss)({
    padding: "space.200",
    flex: 1
});
const $338b16ec733a1a69$var$cloudIconContainerStyles = (0, $jAMCU.xcss)({
    width: "350px"
});
const $338b16ec733a1a69$export$cd351313b790cee4 = ({ currentTime: currentTime, userName: userName, subtitleMessage: subtitleMessage })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g2DEO.default), {
        xcss: $338b16ec733a1a69$var$headerContainerStyles,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                space: "space.250",
                xcss: $338b16ec733a1a69$var$contentContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6x1qA.FormattedDate), {
                                    weekday: "long",
                                    day: "numeric",
                                    month: "long",
                                    value: currentTime
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                                size: "medium",
                                children: userName ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $hiu3w.messages).bannerTitleWithName), {
                                    values: {
                                        name: userName
                                    }
                                })) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $hiu3w.messages).bannerTitleWithoutName))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, subtitleMessage))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2DEO.default), {
                xcss: $338b16ec733a1a69$var$cloudIconContainerStyles,
                justifyContent: "end",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $FrcWq.WelcomeBannerImage), {})
            })
        ]
    });
};

});
parcelRegister("FrcWq", function(module, exports) {

$parcel$export(module.exports, "WelcomeBannerImage", function () { return $f6a985f9cbb2ada8$export$678978e5abdb50f0; });

var $loA2J = parcelRequire("loA2J");
const $f6a985f9cbb2ada8$export$678978e5abdb50f0 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "340",
        height: "106",
        viewBox: "0 0 340 106",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M328.409 28.6662C327.932 28.6662 327.467 28.6721 326.996 28.6898C319.809 10.2571 304.704 2.54004 282.189 2.54004C249.919 2.54004 232.211 18.687 232.211 60.1296H361.817C358.164 39.5232 345.817 28.6662 328.404 28.6662H328.409Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M233.701 65.696H266.278C263.362 49.2368 253.501 40.5713 239.592 40.5713C226.638 40.5713 217.855 47.1514 212.653 65.696H233.701Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M239.592 40.5713C237.542 40.5713 235.604 40.7362 233.76 41.0897C232.741 46.7332 232.217 53.0541 232.217 60.1291H264.935C260.941 47.2928 251.839 40.5772 239.592 40.5772V40.5713Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M273.848 66.9864C274.231 66.9864 274.608 66.9923 274.985 67.0041C280.764 52.1943 292.899 45.9912 310.984 45.9912C336.916 45.9912 351.142 58.9689 351.142 92.2643H247.003C249.937 75.705 259.857 66.9864 273.854 66.9864H273.848Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M343.526 60.1235C336.822 50.2503 325.829 45.9912 310.99 45.9912C296.151 45.9912 285.117 50.2503 278.531 60.1235H343.526Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M151.237 58.562C151.982 58.7828 152.841 59.2341 153.562 59.4935C154.28 59.7904 155.149 60.2038 155.796 60.5183C155.796 60.5183 155.838 60.5633 155.9 60.6342C155.458 60.7412 154.933 60.8563 154.3 60.9473C154.264 60.9325 154.147 60.9257 154.132 60.8961C152.648 61.1483 151.121 60.9459 149.644 60.5577C148.16 60.1597 146.71 59.5904 145.203 59.0245C145.21 59.1325 145.083 59.167 145.01 59.0831L145.085 58.9806C142.999 58.3908 141.93 57.4337 139.974 56.9074C139.977 56.9072 140.242 56.8681 140.249 56.8677C137.183 55.3461 133.68 53.2607 130.053 51.1994C126.424 49.1552 122.634 47.1236 118.94 46.0516L118.971 46.0803L118.949 46.0917C119.274 46.2489 120.218 46.658 121.06 47.0594C121.479 47.2653 121.874 47.459 122.17 47.6044C122.459 47.7535 122.648 47.8508 122.648 47.8508C121.393 47.6123 120.167 47.1079 118.893 46.6165C117.626 46.128 116.292 45.657 114.938 45.5427L114.971 45.3851C116.15 45.4925 117.174 45.687 117.602 45.7129C116.587 45.4096 115.279 45.0895 113.772 45.0687C113.022 45.0378 112.224 45.1282 111.422 45.29C110.616 45.4587 109.819 45.7759 109.073 46.185C108.323 46.5943 107.663 47.1474 107.065 47.7239C106.498 48.3258 105.984 48.955 105.594 49.6041C105.255 50.1385 104.976 50.666 104.736 51.1778C103.232 50.1139 101.463 49.4853 99.6931 49.3275C98.6722 49.2378 97.6452 49.3178 96.6933 49.5763C95.7412 49.8315 94.871 50.2715 94.1486 50.8112C93.4127 51.3416 92.8786 52.0126 92.4376 52.6207C92.2473 52.9467 92.039 53.2398 91.9022 53.5424C91.7654 53.8449 91.6238 54.1207 91.53 54.3869C91.3457 54.9224 91.2041 55.3607 91.1564 55.6987C91.0957 56.0341 91.0734 56.2555 91.0951 56.349C91.1449 56.5358 91.3337 56.1862 91.7907 55.2487L91.831 55.4936C92.2171 54.5027 92.6952 53.6487 93.3195 52.9216C93.9441 52.2013 94.7282 51.6139 95.6978 51.2731C95.9506 51.1331 95.9898 51.141 95.9406 51.0186C96.0021 50.9676 96.1093 50.8733 96.0587 50.8356C95.9857 50.6909 96.1216 50.5916 96.3106 50.5162C96.4994 50.4375 96.7382 50.3864 96.8815 50.3577C96.8457 50.8948 98.3631 50.4409 100.126 50.6398C101.001 50.721 101.916 50.9286 102.647 51.1908C103.379 51.4497 103.928 51.7428 104.117 51.8842C104.095 52.004 104.166 52.1218 104.283 52.2436C104.16 52.5657 104.05 52.8701 103.957 53.1532C104.042 53.1245 104.158 52.6877 104.335 52.2948C104.389 52.3458 104.45 52.3965 104.518 52.4501C104.428 52.6788 104.345 52.9071 104.256 53.1358C104.082 53.6301 103.927 54.1233 103.768 54.5965C103.528 54.5122 103.8 53.9919 103.796 53.8668C103.747 53.9645 103.644 54.1838 103.522 54.516C103.464 54.6819 103.398 54.8754 103.324 55.0964C103.289 55.2068 103.25 55.3208 103.209 55.4417C103.168 55.5659 103.126 55.67 103.084 55.8891C102.984 56.264 103.007 56.7571 103.17 57.2217C103.336 57.6962 103.677 58.1132 104.109 58.3895C104.542 58.6657 105.074 58.8244 105.659 58.7531C105.804 58.738 105.952 58.6887 106.101 58.6462C106.246 58.5903 106.387 58.5111 106.527 58.4318C106.653 58.333 106.782 58.2273 106.901 58.1121C107.003 57.9876 107.105 57.8564 107.194 57.7192C107.266 57.5795 107.335 57.4367 107.397 57.2908C107.441 57.1563 107.475 57.0256 107.512 56.8914C107.6 56.6256 107.615 56.3369 107.643 56.0474C107.657 55.4709 107.57 54.8732 107.355 54.344C107.164 53.7963 106.862 53.3263 106.542 52.8742C106.368 52.6541 106.184 52.4413 105.992 52.2391C106.35 51.5411 106.757 50.8537 107.232 50.2065C107.696 49.6038 108.2 49.0294 108.784 48.5417C109.371 48.0639 110.021 47.6638 110.729 47.3721C112.149 46.7884 113.784 46.69 115.418 46.893C117.055 47.1025 118.699 47.5827 120.279 48.1883C121.863 48.7905 123.395 49.5141 124.856 50.2723C127.777 51.7956 130.422 53.4467 132.639 54.9567L132.595 54.8678C132.66 54.925 132.902 55.0328 132.926 55.1228C133.427 55.2969 134.295 55.6968 135.042 56.0496C135.785 56.4059 136.409 56.7049 136.409 56.7049C137.304 57.1134 138.201 57.5184 139.105 57.9061C139.105 57.9061 140.213 58.5527 141.601 59.217C142.985 59.8883 144.664 60.5356 145.683 60.6965C148.069 61.6177 150.577 62.3285 153.185 62.3733C153.185 62.3733 153.388 62.3616 153.708 62.3328C154.03 62.3141 154.464 62.2414 154.923 62.1606C155.509 62.0385 156.123 61.8369 156.597 61.6298C156.312 62.5268 155.127 64.0687 155.34 64.7877L154.66 65.7618C154.671 66.2826 154.528 66.8497 154.856 66.7866C155.184 66.7235 158.15 62.1423 158.262 60.5578L158.247 60.5723C158.247 60.5723 158.328 60.0901 158.375 60.128C157.542 59.506 156.4 58.5836 155.336 58.6861C155.072 58.4271 150.408 57.2422 151.244 58.565L151.237 58.562Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M193.108 39.0297C192.15 37.7183 190.267 36.3584 188.471 35.4958C185.049 30.734 196.317 38.4705 197.785 39.544C195.606 38.997 197.582 40.1529 198.518 40.3705C196.864 38.5777 203.003 42.1928 201.294 41.9887C201.484 42.1319 202.23 42.7362 201.904 42.1645C202.587 42.3202 210.215 46.2996 207.756 46.5295C203.507 44.7862 198.876 41.7879 193.109 39.0331L193.108 39.0297Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M193.065 51.8485C192.669 52.1496 192.056 52.1811 191.991 51.6128C190.421 52.3807 186.682 50.8245 183.661 50.6519C176.274 47.1145 182.525 47.5252 186.512 49.4196C185.157 49.7285 186.396 50.0442 187.014 49.8909C185.913 48.9054 189.858 49.8707 188.814 50.3127C189.026 50.4525 189.441 50.5281 189.199 50.2405C189.516 50.0184 194.54 51.0446 193.068 51.8474L193.065 51.8485Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M197.873 54.4197C197.787 54.0239 197.424 53.3936 196.735 53.4804C196.007 52.2502 197.679 51.4936 197.921 52.3934C197.899 52.0664 199.965 52.6325 198.997 52.9967C199.239 53.998 199.863 51.5095 200.357 53.3587C200.286 52.6269 202.313 53.0972 201.891 53.918C201.867 54.1176 201.268 54.8246 201.411 54.0105C201.193 55.0523 200.988 54.0161 200.925 54.0409C200.795 54.5314 200.812 54.0296 200.729 54.2303C200.714 54.9565 200.33 53.6304 200.316 54.334C199.472 55.2203 198.731 53.6901 197.874 54.423L197.873 54.4197Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M208.653 25.8541C212.145 27.3876 213.257 32.3331 214.38 33.4055C214.164 31.8618 216.056 34.8229 216.273 35.4419C215.896 35.0304 215.849 35.5119 216.172 35.8513C217.098 35.0541 221.641 43.0903 218.033 39.5892C216.489 37.1547 208.724 30.6924 208.654 25.8574L208.653 25.8541Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M202.947 32.1266C202.504 32.2179 202.082 32.1029 202.41 31.6293C201.664 32.3927 201.867 31.2054 201.771 31.1659C200.934 31.6406 201.222 30.3044 200.861 30.8343C199.48 30.814 198.897 28.6186 197.724 28.4461C194.055 21.614 201.113 27.8722 199.721 28.2274C199.531 29.3843 201.069 27.7854 201.467 29.6177C200.487 29.2118 204.606 31.5584 202.948 32.13L202.947 32.1266Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M205.434 36.5984C204.503 31.7577 208.36 35.9986 207.097 35.9388C206.713 36.5025 207.632 36.2601 207.517 35.9376C207.9 35.9715 208.479 36.4811 207.875 36.6976C210.288 36.7495 208.096 39.1603 208.385 37.8839C207.632 38.6348 208.062 37.691 207.999 37.682C207.625 38.0248 207.919 37.6222 207.743 37.7485C207.402 38.283 207.732 37.1171 207.37 37.6437C206.293 37.9729 206.311 36.2872 205.431 36.5995L205.434 36.5984Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M187.816 63.2548C187.518 63.6471 186.998 63.8434 186.803 63.3033C184.474 64.7374 179.838 64.2355 176.047 63.9705C172.557 61.7524 182.298 62.0966 180.825 62.9219C181.841 63.7631 181.907 61.6106 183.887 62.6074C183.159 62.7337 184.406 63.1972 183.983 62.7033C184.214 62.4045 188.943 62.1013 187.817 63.2581L187.816 63.2548Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M194.312 64.5159C189.41 62.8853 192.552 61.8075 195.92 62.5292C195.144 63.1561 195.914 63.1776 196.311 62.8574C195.67 62.218 197.217 62.2733 197.663 62.5417C197.51 62.5665 197.42 62.8709 197.797 62.8653C197.602 61.758 202.445 62.5553 199.811 63.5802C199.624 62.7447 199.938 64.4022 198.95 63.3863C198.935 63.8948 198.769 63.4054 198.716 63.6185C198.945 64.3086 197.851 63.1404 198.114 63.8192C197.18 64.8407 195.135 63.6477 194.316 64.5182L194.312 64.5159Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M180.442 76.9104C183.41 76.0073 186.216 75.2745 189.809 74.6702C187.158 76.2566 192.391 74.5643 190.139 74.6014C192.451 74.2813 200.727 70.7252 200.922 72.7492C202.508 72.5587 176.261 81.1714 180.442 76.9104Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M189.609 85.8882C190.699 85.1227 191.582 84.5803 193.102 84.0887C192.701 85.0189 193.408 84.6593 193.607 84.1869C192.727 83.932 194.151 83.2352 194.669 83.2544C193.978 84.0031 198.751 80.086 197.088 83.1315C196.535 82.4967 197.575 83.7957 196.223 83.3784C196.967 84.2613 188.607 89.0668 189.609 85.8882Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M201.249 79.5465C201.642 79.2951 201.669 78.8204 202.212 79.1237C204.168 77.0738 203.298 79.9942 203.991 78.5306C203.221 78.2578 204.718 77.3039 204.682 78.1011C204.765 76.642 207.935 76.9488 206.214 77.782C206.742 78.7066 205.868 78.0853 205.829 78.1507C206.062 78.6029 205.73 78.2252 205.797 78.4281C205.991 79.2163 201.133 82.2978 201.25 79.5499L201.249 79.5465Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M75.3463 24.3047H8.51752V41.3431H75.3463V24.3047Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M67.1936 37.0171H16.6672V45.0462H67.1936V37.0171Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M67.1936 41.3393V37.0137H16.6672V41.3393H67.1936Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M75.3564 89.2064H8.52765V72.168H75.3564V89.2064Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M67.1936 76.4934H16.6672V68.4644H67.1936V76.4934Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M67.2069 72.168V76.4936H16.6805V72.168H67.2069Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M75.3463 48.355H8.51752V65.3934H75.3463V48.355Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M52.2257 55.551C52.2826 55.5109 52.3495 55.4808 52.4231 55.454C52.4231 55.454 52.5034 55.4908 52.5971 55.531C52.6907 55.5678 52.7978 55.6046 52.9182 55.5778C53.052 55.715 53.1457 55.8822 53.1859 56.0528C53.1859 56.0528 53.2193 56.0997 53.2628 56.1532C53.3096 56.2101 53.3632 56.2803 53.4267 56.3171C53.507 56.3606 53.5973 56.3941 53.681 56.4041C53.7646 56.4142 53.8416 56.3907 53.8851 56.3138C53.9285 56.2402 53.9386 56.1097 53.8616 55.9424C53.8683 55.9358 53.875 55.919 53.8884 55.9123C53.7713 55.7451 53.7111 55.5811 53.6241 55.4038C53.5405 55.2332 53.4234 55.0559 53.2461 54.9522C53.2227 54.9957 53.1892 55.0191 53.1959 54.9923L53.2327 54.9422C53.0855 54.9221 53.0018 54.8585 52.9082 54.8117C52.8145 54.7648 52.7074 54.7381 52.5736 54.8184L52.6171 54.7448C52.219 54.6779 51.7105 54.728 51.299 55.0057C50.8875 55.2734 50.6132 55.7584 50.6199 56.1967H50.64C50.6734 56.1599 50.7303 56.0562 50.7872 55.9726C50.844 55.8889 50.8976 55.8187 50.8976 55.8187C50.9879 55.996 50.9511 56.0963 50.8976 56.2235C50.844 56.3439 50.7671 56.4878 50.7972 56.6249L50.7203 56.635C50.7035 56.5112 50.6667 56.4041 50.6366 56.3539C50.5697 56.5814 50.5998 56.9762 50.8005 57.2873C50.9879 57.6051 51.3157 57.8092 51.5432 57.8427C51.56 57.7891 51.3726 57.8326 51.4496 57.6486C51.5399 57.7022 51.6469 57.7222 51.7373 57.759C51.6938 57.8795 51.6503 57.8192 51.6336 57.8326C51.657 57.8795 51.9012 58.0334 52.2792 58.0534C52.6539 58.0835 53.1524 57.9196 53.4602 57.5918C53.7813 57.2706 53.8817 56.8357 53.8449 56.6082C53.8048 56.3673 53.7077 56.3372 53.5639 56.5145L53.5003 56.4911C53.4602 56.6617 53.3899 56.8123 53.2026 56.8959C53.2026 56.9193 53.1892 56.916 53.2461 56.9494C53.2528 56.9595 53.2628 56.9795 53.2862 56.9896C53.4267 57.0665 53.3397 57.0866 53.3297 57.1134C53.1256 56.9662 53.0587 57.0531 52.9918 57.1803C52.9282 57.3074 52.8346 57.4847 52.7911 57.4914C52.6807 57.284 52.6506 57.5416 52.5703 57.4579C52.5703 57.4479 52.5703 57.3944 52.5736 57.3843C52.5335 57.3141 52.4097 57.4278 52.2659 57.4747C52.122 57.5248 52.0016 57.5282 52.112 57.3977C51.9581 57.2505 51.8242 57.1334 51.7005 56.9929C51.58 56.8558 51.4663 56.6918 51.4261 56.4911C51.386 56.2904 51.4261 56.0662 51.5533 55.9123C51.6771 55.7551 51.8811 55.6882 52.0384 55.7518L52.025 55.725C52.025 55.725 52.0384 55.715 52.0517 55.7451C52.0618 55.6949 52.1019 55.638 52.1454 55.6046C52.1889 55.5644 52.2324 55.5477 52.2324 55.5477L52.2257 55.551ZM51.1217 56.5915C51.1217 56.5915 51.1351 56.5915 51.1384 56.5915C51.1117 56.5982 51.1518 56.6985 51.1485 56.7052L51.0715 56.7253C50.9779 56.6885 51.0581 56.5647 51.1384 56.5145C51.2254 56.4643 51.2923 56.4543 51.192 56.5747C51.212 56.5781 51.1485 56.5915 51.1217 56.5948V56.5915ZM51.6436 57.3676C51.6436 57.3676 51.6704 57.4011 51.6871 57.4178C51.5131 57.468 51.3726 57.3442 51.2923 57.2003C51.2087 57.0531 51.1786 56.8959 51.0782 56.7788C51.2622 56.7721 51.3224 56.8156 51.3525 56.8825C51.3827 56.9461 51.386 57.0398 51.4161 57.0899C51.5466 57.12 51.5733 57.2672 51.6403 57.371L51.6436 57.3676ZM53.1557 57.1836L53.1256 57.1568L53.1323 57.1502C53.1323 57.1502 53.1491 57.1669 53.1524 57.1702C53.1591 57.1769 53.1624 57.1836 53.1557 57.1836ZM52.0986 55.3771C52.0919 55.444 52.0216 55.4172 52.0417 55.2867C52.0584 55.3068 52.0819 55.2399 52.0986 55.3771ZM51.8744 57.575C51.9146 57.4546 52.0049 57.4446 51.9648 57.6219C51.9313 57.6152 51.9012 57.5951 51.8744 57.575ZM52.7744 55.3436C52.858 55.2299 52.7844 55.367 52.7509 55.4473C52.7543 55.4272 52.7376 55.4105 52.771 55.357V55.347L52.7744 55.3436ZM53.1925 55.5477C53.2461 55.5075 53.2996 55.4975 53.3096 55.5075C53.2929 55.5644 53.1557 55.5979 53.1925 55.5477ZM53.5405 56.2502C53.6174 56.2402 53.6475 56.2603 53.5706 56.2736C53.5137 56.2736 53.4669 56.2603 53.5539 56.2469C53.5505 56.2469 53.5438 56.2469 53.5405 56.2502ZM52.3461 57.9096C52.3227 58.1438 52.1989 57.9564 52.1354 58.0133C52.1655 57.7858 52.2592 57.9631 52.3093 57.9163C52.3261 57.9163 52.3361 57.9163 52.3461 57.9096ZM51.2421 55.3403C51.105 55.1931 51.3091 55.2232 51.3124 55.1696L51.3592 55.2332C51.3224 55.2867 51.3325 55.347 51.2421 55.3403ZM51.2455 57.6252C51.1752 57.672 51.192 57.5851 51.1752 57.5683C51.2522 57.4847 51.3392 57.5349 51.2455 57.6252ZM50.7169 56.7052C50.8373 56.6751 50.7872 56.7353 50.8039 56.7487C50.7771 56.7454 50.6968 56.742 50.6935 56.732C50.6935 56.7219 50.7069 56.7186 50.7136 56.7086L50.7169 56.7052ZM51.2622 55.4272C51.2355 55.4607 51.1987 55.4942 51.1685 55.5276L51.1083 55.4741L51.2087 55.3704L51.2622 55.4272ZM50.8909 55.7317L50.8206 55.6949C50.7872 55.5912 50.9678 55.6848 50.8909 55.7283V55.7317ZM51.7139 55.0291C51.7139 55.0291 51.6938 55.0291 51.6871 55.0291C51.5968 55.076 51.6202 54.7515 51.7139 55.0291ZM52.2123 54.8518C52.2123 54.8518 52.2357 54.815 52.2458 54.8184C52.3194 54.8318 52.2391 55.0191 52.2123 54.8518Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M59.1744 55.551C59.2313 55.5109 59.2982 55.4808 59.3718 55.454C59.3718 55.454 59.4521 55.4908 59.5457 55.531C59.6394 55.5678 59.7465 55.6046 59.8669 55.5778C60.0007 55.715 60.0944 55.8822 60.1345 56.0528C60.1345 56.0528 60.168 56.0997 60.2115 56.1532C60.2583 56.2101 60.3118 56.2803 60.3754 56.3171C60.4557 56.3606 60.546 56.3941 60.6297 56.4041C60.7133 56.4142 60.7902 56.3907 60.8337 56.3138C60.8772 56.2402 60.8873 56.1097 60.8103 55.9424C60.817 55.9358 60.8237 55.919 60.8371 55.9123C60.72 55.7451 60.6598 55.5811 60.5728 55.4038C60.4891 55.2332 60.3721 55.0559 60.1947 54.9522C60.1713 54.9957 60.1379 55.0191 60.1446 54.9923L60.1814 54.9422C60.0342 54.9221 59.9505 54.8585 59.8569 54.8117C59.7632 54.7648 59.6561 54.7381 59.5223 54.8184L59.5658 54.7448C59.1677 54.6779 58.6592 54.728 58.2477 55.0057C57.8362 55.2734 57.5619 55.7584 57.5686 56.1967H57.5886C57.6221 56.1599 57.679 56.0562 57.7358 55.9726C57.7927 55.8889 57.8462 55.8187 57.8462 55.8187C57.9366 55.996 57.8998 56.0963 57.8462 56.2235C57.7927 56.3439 57.7158 56.4878 57.7459 56.6249L57.6689 56.635C57.6522 56.5112 57.6154 56.4041 57.5853 56.3539C57.5184 56.5814 57.5485 56.9762 57.7492 57.2873C57.9366 57.6051 58.2644 57.8092 58.4919 57.8427C58.5086 57.7891 58.3213 57.8326 58.3982 57.6486C58.4886 57.7022 58.5956 57.7222 58.6859 57.759C58.6425 57.8795 58.599 57.8192 58.5822 57.8326C58.6057 57.8795 58.8499 58.0334 59.2279 58.0534C59.6026 58.0835 60.1011 57.9196 60.4089 57.5918C60.73 57.2706 60.8304 56.8357 60.7936 56.6082C60.7534 56.3673 60.6564 56.3372 60.5126 56.5145L60.449 56.4911C60.4089 56.6617 60.3386 56.8123 60.1513 56.8959C60.1513 56.9193 60.1379 56.916 60.1947 56.9494C60.2014 56.9595 60.2115 56.9795 60.2349 56.9896C60.3754 57.0665 60.2884 57.0866 60.2784 57.1134C60.0743 56.9662 60.0074 57.0531 59.9405 57.1803C59.8769 57.3074 59.7833 57.4847 59.7398 57.4914C59.6294 57.284 59.5993 57.5416 59.519 57.4579C59.519 57.4479 59.519 57.3944 59.5223 57.3843C59.4822 57.3141 59.3584 57.4278 59.2145 57.4747C59.0707 57.5248 58.9502 57.5282 59.0606 57.3977C58.9067 57.2505 58.7729 57.1334 58.6491 56.9929C58.5287 56.8558 58.415 56.6918 58.3748 56.4911C58.3347 56.2904 58.3748 56.0662 58.5019 55.9123C58.6257 55.7551 58.8298 55.6882 58.987 55.7518L58.9737 55.725C58.9737 55.725 58.987 55.715 59.0004 55.7451C59.0105 55.6949 59.0506 55.638 59.0941 55.6046C59.1376 55.5644 59.1811 55.5477 59.1811 55.5477L59.1744 55.551ZM58.0704 56.5915C58.0704 56.5915 58.0838 56.5915 58.0871 56.5915C58.0603 56.5982 58.1005 56.6985 58.0971 56.7052L58.0202 56.7253C57.9265 56.6885 58.0068 56.5647 58.0871 56.5145C58.1741 56.4643 58.241 56.4543 58.1406 56.5747C58.1607 56.5781 58.0971 56.5915 58.0704 56.5948V56.5915ZM58.5923 57.3676C58.5923 57.3676 58.619 57.4011 58.6358 57.4178C58.4618 57.468 58.3213 57.3442 58.241 57.2003C58.1574 57.0531 58.1273 56.8959 58.0269 56.7788C58.2109 56.7721 58.2711 56.8156 58.3012 56.8825C58.3313 56.9461 58.3347 57.0398 58.3648 57.0899C58.4953 57.12 58.522 57.2672 58.5889 57.371L58.5923 57.3676ZM60.1044 57.1836L60.0743 57.1568L60.081 57.1502C60.081 57.1502 60.0977 57.1669 60.1011 57.1702C60.1078 57.1769 60.1111 57.1836 60.1044 57.1836ZM59.0473 55.3771C59.0406 55.444 58.9703 55.4172 58.9904 55.2867C59.0071 55.3068 59.0305 55.2399 59.0473 55.3771ZM58.8231 57.575C58.8633 57.4546 58.9536 57.4446 58.9134 57.6219C58.88 57.6152 58.8499 57.5951 58.8231 57.575ZM59.723 55.3436C59.8067 55.2299 59.7331 55.367 59.6996 55.4473C59.703 55.4272 59.6862 55.4105 59.7197 55.357V55.347L59.723 55.3436ZM60.1412 55.5477C60.1947 55.5075 60.2483 55.4975 60.2583 55.5075C60.2416 55.5644 60.1044 55.5979 60.1412 55.5477ZM60.4891 56.2502C60.5661 56.2402 60.5962 56.2603 60.5193 56.2736C60.4624 56.2736 60.4156 56.2603 60.5025 56.2469C60.4992 56.2469 60.4925 56.2469 60.4891 56.2502ZM59.2948 57.9096C59.2714 58.1438 59.1476 57.9564 59.0841 58.0133C59.1142 57.7858 59.2078 57.9631 59.258 57.9163C59.2747 57.9163 59.2848 57.9163 59.2948 57.9096ZM58.1908 55.3403C58.0537 55.1931 58.2577 55.2232 58.2611 55.1696L58.3079 55.2332C58.2711 55.2867 58.2811 55.347 58.1908 55.3403ZM58.1942 57.6252C58.1239 57.672 58.1406 57.5851 58.1239 57.5683C58.2009 57.4847 58.2878 57.5349 58.1942 57.6252ZM57.6656 56.7052C57.786 56.6751 57.7358 56.7353 57.7526 56.7487C57.7258 56.7454 57.6455 56.742 57.6422 56.732C57.6422 56.7219 57.6555 56.7186 57.6622 56.7086L57.6656 56.7052ZM58.2109 55.4272C58.1841 55.4607 58.1473 55.4942 58.1172 55.5276L58.057 55.4741L58.1574 55.3704L58.2109 55.4272ZM57.8395 55.7317L57.7693 55.6949C57.7358 55.5912 57.9165 55.6848 57.8395 55.7283V55.7317ZM58.6625 55.0291C58.6625 55.0291 58.6425 55.0291 58.6358 55.0291C58.5454 55.076 58.5689 54.7515 58.6625 55.0291ZM59.161 54.8518C59.161 54.8518 59.1844 54.815 59.1945 54.8184C59.2681 54.8318 59.1878 55.0191 59.161 54.8518Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M66.1227 55.551C66.1796 55.5109 66.2465 55.4808 66.3201 55.454C66.3201 55.454 66.4004 55.4908 66.4941 55.531C66.5878 55.5678 66.6948 55.6046 66.8152 55.5778C66.9491 55.715 67.0427 55.8822 67.0829 56.0528C67.0829 56.0528 67.1163 56.0997 67.1598 56.1532C67.2067 56.2101 67.2602 56.2803 67.3238 56.3171C67.4041 56.3606 67.4944 56.3941 67.578 56.4041C67.6616 56.4142 67.7386 56.3907 67.7821 56.3138C67.8256 56.2402 67.8356 56.1097 67.7587 55.9424C67.7654 55.9358 67.772 55.919 67.7854 55.9123C67.6683 55.7451 67.6081 55.5811 67.5211 55.4038C67.4375 55.2332 67.3204 55.0559 67.1431 54.9522C67.1197 54.9957 67.0862 55.0191 67.0929 54.9923L67.1297 54.9422C66.9825 54.9221 66.8989 54.8585 66.8052 54.8117C66.7115 54.7648 66.6045 54.7381 66.4707 54.8184L66.5142 54.7448C66.1161 54.6779 65.6075 54.728 65.1961 55.0057C64.7846 55.2734 64.5102 55.7584 64.5169 56.1967H64.537C64.5704 56.1599 64.6273 56.0562 64.6842 55.9726C64.7444 55.8889 64.7946 55.8187 64.7946 55.8187C64.8849 55.996 64.8481 56.0963 64.7946 56.2235C64.7411 56.3439 64.6641 56.4878 64.6942 56.6249L64.6173 56.635C64.6006 56.5112 64.5638 56.4041 64.5336 56.3539C64.4667 56.5814 64.4968 56.9762 64.6976 57.2873C64.8849 57.6051 65.2128 57.8092 65.4403 57.8427C65.457 57.7891 65.2696 57.8326 65.3466 57.6486C65.4369 57.7022 65.544 57.7222 65.6343 57.759C65.5908 57.8795 65.5473 57.8192 65.5306 57.8326C65.554 57.8795 65.7982 58.0334 66.1763 58.0534C66.551 58.0835 67.0494 57.9196 67.3572 57.5918C67.6784 57.2706 67.7787 56.8357 67.7419 56.6082C67.7018 56.3673 67.6048 56.3372 67.4609 56.5145L67.3974 56.4911C67.3572 56.6617 67.287 56.8123 67.0996 56.8959C67.0996 56.9193 67.0862 56.916 67.1431 56.9494C67.1498 56.9595 67.1598 56.9795 67.1833 56.9896C67.3238 57.0665 67.2368 57.0866 67.2267 57.1134C67.0227 56.9662 66.9558 57.0531 66.8888 57.1803C66.8253 57.3074 66.7316 57.4847 66.6881 57.4914C66.5777 57.284 66.5476 57.5416 66.4673 57.4579C66.4673 57.4479 66.4673 57.3944 66.4707 57.3843C66.4305 57.3141 66.3067 57.4278 66.1629 57.4747C66.019 57.5248 65.8986 57.5282 66.009 57.3977C65.8551 57.2505 65.7213 57.1334 65.5975 56.9929C65.4771 56.8558 65.3633 56.6918 65.3232 56.4911C65.283 56.2904 65.3232 56.0662 65.4503 55.9123C65.5741 55.7551 65.7782 55.6882 65.9354 55.7518L65.922 55.725C65.922 55.725 65.9354 55.715 65.9488 55.7451C65.9588 55.6949 65.999 55.638 66.0424 55.6046C66.0859 55.5644 66.1294 55.5477 66.1294 55.5477L66.1227 55.551ZM65.0187 56.5915C65.0187 56.5915 65.0321 56.5915 65.0355 56.5915C65.0087 56.5982 65.0488 56.6985 65.0455 56.7052L64.9686 56.7253C64.8749 56.6885 64.9552 56.5647 65.0355 56.5145C65.1224 56.4643 65.1894 56.4543 65.089 56.5747C65.1091 56.5781 65.0455 56.5915 65.0187 56.5948V56.5915ZM65.5406 57.3676C65.5406 57.3676 65.5674 57.4011 65.5841 57.4178C65.4102 57.468 65.2696 57.3442 65.1894 57.2003C65.1057 57.0531 65.0756 56.8959 64.9752 56.7788C65.1592 56.7721 65.2195 56.8156 65.2496 56.8825C65.2797 56.9461 65.283 57.0398 65.3131 57.0899C65.4436 57.12 65.4704 57.2672 65.5373 57.371L65.5406 57.3676ZM67.0528 57.1836L67.0227 57.1568L67.0294 57.1502C67.0294 57.1502 67.0461 57.1669 67.0494 57.1702C67.0561 57.1769 67.0595 57.1836 67.0528 57.1836ZM65.9956 55.3771C65.9889 55.444 65.9187 55.4172 65.9387 55.2867C65.9555 55.3068 65.9789 55.2399 65.9956 55.3771ZM65.7715 57.575C65.8116 57.4546 65.9019 57.4446 65.8618 57.6219C65.8283 57.6152 65.7982 57.5951 65.7715 57.575ZM66.6714 55.3436C66.755 55.2299 66.6814 55.367 66.648 55.4473C66.6513 55.4272 66.6346 55.4105 66.668 55.357V55.347L66.6714 55.3436ZM67.0896 55.5477C67.1431 55.5075 67.1966 55.4975 67.2067 55.5075C67.1899 55.5644 67.0528 55.5979 67.0896 55.5477ZM67.4375 56.2502C67.5144 56.2402 67.5446 56.2603 67.4676 56.2736C67.4107 56.2736 67.3639 56.2603 67.4509 56.2469C67.4475 56.2469 67.4408 56.2469 67.4375 56.2502ZM66.2432 57.9096C66.2198 58.1438 66.096 57.9564 66.0324 58.0133C66.0625 57.7858 66.1562 57.9631 66.2064 57.9163C66.2231 57.9163 66.2331 57.9163 66.2432 57.9096ZM65.1392 55.3403C65.002 55.1931 65.2061 55.2232 65.2094 55.1696L65.2563 55.2332C65.2195 55.2867 65.2295 55.347 65.1392 55.3403ZM65.1425 57.6252C65.0723 57.672 65.089 57.5851 65.0723 57.5683C65.1492 57.4847 65.2362 57.5349 65.1425 57.6252ZM64.6173 56.7052C64.7377 56.6751 64.6875 56.7353 64.7043 56.7487C64.6775 56.7454 64.5972 56.742 64.5939 56.732C64.5939 56.7219 64.6072 56.7186 64.6139 56.7086L64.6173 56.7052ZM65.1593 55.4272C65.1325 55.4607 65.0957 55.4942 65.0656 55.5276L65.0054 55.4741L65.1057 55.3704L65.1593 55.4272ZM64.7879 55.7317L64.7176 55.6949C64.6842 55.5912 64.8649 55.6848 64.7879 55.7283V55.7317ZM65.6109 55.0291C65.6109 55.0291 65.5908 55.0291 65.5841 55.0291C65.4938 55.076 65.5172 54.7515 65.6109 55.0291ZM66.1094 54.8518C66.1094 54.8518 66.1328 54.815 66.1428 54.8184C66.2164 54.8318 66.1361 55.0191 66.1094 54.8518Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M66.2636 30.8318C66.3205 30.7916 66.3874 30.7615 66.461 30.7348C66.461 30.7348 66.5413 30.7716 66.6349 30.8117C66.7286 30.8485 66.8357 30.8853 66.9561 30.8586C67.0899 30.9957 67.1836 31.163 67.2237 31.3336C67.2237 31.3336 67.2572 31.3804 67.3007 31.434C67.3475 31.4908 67.4011 31.5611 67.4646 31.5979C67.5449 31.6414 67.6352 31.6748 67.7189 31.6849C67.8025 31.6949 67.8795 31.6715 67.9229 31.5946C67.9664 31.521 67.9765 31.3905 67.8995 31.2232C67.9062 31.2165 67.9129 31.1998 67.9263 31.1931C67.8092 31.0258 67.749 30.8619 67.662 30.6846C67.5784 30.514 67.4613 30.3367 67.284 30.233C67.2605 30.2764 67.2271 30.2999 67.2338 30.2731L67.2706 30.2229C67.1234 30.2028 67.0397 30.1393 66.9461 30.0924C66.8524 30.0456 66.7453 30.0188 66.6115 30.0991L66.655 30.0255C66.2569 29.9586 65.7484 30.0088 65.3369 30.2865C64.9254 30.5541 64.6511 31.0392 64.6578 31.4775H64.6678H64.6779C64.7113 31.4407 64.7682 31.337 64.8251 31.2533C64.8819 31.1697 64.9355 31.0994 64.9355 31.0994C65.0258 31.2767 64.989 31.3771 64.9355 31.5042C64.8819 31.6247 64.805 31.7685 64.8351 31.9057L64.7582 31.9157C64.7414 31.7919 64.7046 31.6849 64.6745 31.6347C64.6076 31.8622 64.6377 32.257 64.8384 32.5681C65.0258 32.8859 65.3536 33.09 65.5811 33.1234C65.5979 33.0699 65.4105 33.1134 65.4875 32.9294C65.5778 32.9829 65.6848 33.003 65.7752 33.0398C65.7317 33.1602 65.6882 33.1 65.6715 33.1134C65.6949 33.1602 65.9391 33.3141 66.3171 33.3342C66.6918 33.3643 67.1903 33.2004 67.4981 32.8725C67.8192 32.5514 67.9196 32.1164 67.8828 31.889C67.8427 31.6481 67.7456 31.618 67.6018 31.7953L67.5382 31.7719C67.4981 31.9425 67.4278 32.093 67.2405 32.1767C67.2405 32.2001 67.2271 32.1967 67.284 32.2302C67.2907 32.2402 67.3007 32.2603 67.3241 32.2703C67.4646 32.3473 67.3776 32.3674 67.3676 32.3941C67.1635 32.2469 67.0966 32.3339 67.0297 32.461C66.9661 32.5882 66.8725 32.7655 66.829 32.7722C66.7186 32.5647 66.6885 32.8223 66.6082 32.7387C66.6082 32.7287 66.6082 32.6751 66.6115 32.6651C66.5714 32.5948 66.4476 32.7086 66.3038 32.7554C66.1599 32.8056 66.0395 32.809 66.1499 32.6785C65.996 32.5313 65.8622 32.4142 65.7384 32.2737C65.6179 32.1365 65.5042 31.9726 65.464 31.7719C65.4239 31.5711 65.464 31.347 65.5912 31.1931C65.715 31.0359 65.919 30.969 66.0763 31.0325L66.0629 31.0058C66.0629 31.0058 66.0763 30.9957 66.0896 31.0258C66.0997 30.9756 66.1398 30.9188 66.1833 30.8853C66.2268 30.8452 66.2703 30.8284 66.2703 30.8284L66.2636 30.8318ZM65.163 31.8722C65.163 31.8722 65.1763 31.8722 65.1797 31.8722C65.1529 31.8789 65.1931 31.9793 65.1897 31.986L65.1128 32.006C65.0191 31.9692 65.0994 31.8455 65.1797 31.7953C65.2667 31.7451 65.3336 31.7351 65.2332 31.8555C65.2533 31.8588 65.1897 31.8722 65.163 31.8756V31.8722ZM65.6848 32.6484C65.6848 32.6484 65.7116 32.6818 65.7283 32.6986C65.5544 32.7487 65.4139 32.625 65.3336 32.4811C65.2499 32.3339 65.2198 32.1767 65.1195 32.0596C65.3035 32.0529 65.3637 32.0964 65.3938 32.1633C65.4239 32.2268 65.4272 32.3205 65.4574 32.3707C65.5878 32.4008 65.6146 32.548 65.6815 32.6517L65.6848 32.6484ZM67.1936 32.4644L67.1635 32.4376L67.1702 32.4309C67.1702 32.4309 67.1869 32.4476 67.1903 32.451C67.197 32.4577 67.2003 32.4644 67.1936 32.4644ZM66.1365 30.6578C66.1298 30.7247 66.0595 30.698 66.0796 30.5675C66.0963 30.5876 66.1198 30.5207 66.1365 30.6578ZM65.9123 32.8558C65.9525 32.7354 66.0428 32.7253 66.0027 32.9026C65.9692 32.8959 65.9391 32.8759 65.9123 32.8558ZM66.8123 30.6244C66.8959 30.5106 66.8223 30.6478 66.7888 30.7281C66.7922 30.708 66.7755 30.6913 66.8089 30.6378V30.6277L66.8123 30.6244ZM67.2338 30.8284C67.2873 30.7883 67.3408 30.7783 67.3509 30.7883C67.3342 30.8452 67.197 30.8786 67.2338 30.8284ZM67.5784 31.531C67.6553 31.521 67.6854 31.541 67.6085 31.5544C67.5516 31.5544 67.5048 31.541 67.5917 31.5276C67.5884 31.5276 67.5817 31.5276 67.5784 31.531ZM66.384 33.1903C66.3606 33.4245 66.2368 33.2372 66.1733 33.294C66.2034 33.0666 66.2971 33.2439 66.3472 33.197C66.364 33.197 66.374 33.197 66.384 33.1903ZM65.28 30.621C65.1429 30.4738 65.347 30.5039 65.3503 30.4504L65.3971 30.514C65.3603 30.5675 65.3704 30.6277 65.28 30.621ZM65.2834 32.906C65.2131 32.9528 65.2299 32.8658 65.2131 32.8491C65.2901 32.7655 65.3771 32.8156 65.2834 32.906ZM64.7582 31.986C64.8786 31.9559 64.8284 32.0161 64.8451 32.0295C64.8184 32.0261 64.7381 32.0228 64.7347 32.0127C64.7347 32.0027 64.7481 31.9994 64.7548 31.9893L64.7582 31.986ZM65.3035 30.708C65.2767 30.7415 65.2399 30.7749 65.2098 30.8084L65.1496 30.7548L65.2499 30.6511L65.3035 30.708ZM64.9288 31.0124L64.8585 30.9756C64.8251 30.8719 65.0057 30.9656 64.9288 31.0091V31.0124ZM65.7517 30.3099C65.7517 30.3099 65.7317 30.3099 65.725 30.3099C65.6347 30.3567 65.6581 30.0322 65.7517 30.3099ZM66.2502 30.1326C66.2502 30.1326 66.2736 30.0958 66.2837 30.0991C66.3573 30.1125 66.277 30.2999 66.2502 30.1326Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M66.1698 81.0369C66.2267 80.9967 66.2936 80.9666 66.3672 80.9398C66.3672 80.9398 66.4475 80.9767 66.5411 81.0168C66.6348 81.0536 66.7419 81.0904 66.8623 81.0636C66.9961 81.2008 67.0898 81.3681 67.1299 81.5387C67.1299 81.5387 67.1634 81.5855 67.2069 81.6391C67.2537 81.6959 67.3073 81.7662 67.3708 81.803C67.4511 81.8465 67.5414 81.8799 67.6251 81.89C67.7087 81.9 67.7857 81.8766 67.8291 81.7996C67.8726 81.726 67.8827 81.5956 67.8057 81.4283C67.8124 81.4216 67.8191 81.4049 67.8325 81.3982C67.7154 81.2309 67.6552 81.067 67.5682 80.8897C67.4846 80.7191 67.3675 80.5417 67.1902 80.438C67.1667 80.4815 67.1333 80.5049 67.14 80.4782L67.1768 80.428C67.0296 80.4079 66.9459 80.3444 66.8523 80.2975C66.7586 80.2507 66.6515 80.2239 66.5177 80.3042L66.5612 80.2306C66.1631 80.1637 65.6546 80.2139 65.2431 80.4916C64.8316 80.7592 64.5573 81.2443 64.564 81.6825H64.574H64.5841C64.6175 81.6457 64.6744 81.542 64.7313 81.4584C64.7881 81.3748 64.8417 81.3045 64.8417 81.3045C64.932 81.4818 64.8952 81.5822 64.8417 81.7093C64.7881 81.8297 64.7112 81.9736 64.7413 82.1108L64.6643 82.1208C64.6476 81.997 64.6108 81.89 64.5807 81.8398C64.5138 82.0673 64.5439 82.462 64.7446 82.7732C64.932 83.091 65.2598 83.295 65.4873 83.3285C65.5041 83.275 65.3167 83.3185 65.3937 83.1345C65.484 83.188 65.591 83.2081 65.6814 83.2449C65.6379 83.3653 65.5944 83.3051 65.5777 83.3185C65.6011 83.3653 65.8453 83.5192 66.2233 83.5393C66.598 83.5694 67.0965 83.4054 67.4043 83.0776C67.7254 82.7564 67.8258 82.3215 67.789 82.094C67.7489 81.8532 67.6518 81.823 67.508 82.0004L67.4444 81.9769C67.4043 82.1476 67.334 82.2981 67.1467 82.3817C67.1467 82.4052 67.1333 82.4018 67.1902 82.4353C67.1969 82.4453 67.2069 82.4654 67.2303 82.4754C67.3708 82.5524 67.2838 82.5724 67.2738 82.5992C67.0697 82.452 67.0028 82.539 66.9359 82.6661C66.8723 82.7932 66.7787 82.9705 66.7352 82.9772C66.6248 82.7698 66.5947 83.0274 66.5144 82.9438C66.5144 82.9337 66.5144 82.8802 66.5177 82.8702C66.4776 82.7999 66.3538 82.9137 66.2099 82.9605C66.0661 83.0107 65.9457 83.014 66.0561 82.8836C65.9022 82.7364 65.7683 82.6193 65.6446 82.4788C65.5241 82.3416 65.4104 82.1777 65.3702 81.9769C65.3301 81.7762 65.3702 81.5521 65.4974 81.3982C65.6211 81.2409 65.8252 81.174 65.9825 81.2376L65.9691 81.2108C65.9691 81.2108 65.9825 81.2008 65.9958 81.2309C66.0059 81.1807 66.046 81.1239 66.0895 81.0904C66.133 81.0503 66.1765 81.0335 66.1765 81.0335L66.1698 81.0369ZM65.0658 82.0773C65.0658 82.0773 65.0792 82.0773 65.0825 82.0773C65.0558 82.084 65.0959 82.1844 65.0926 82.1911L65.0156 82.2111C64.9219 82.1743 65.0022 82.0505 65.0825 82.0004C65.1695 81.9502 65.2364 81.9401 65.1361 82.0606C65.1561 82.0639 65.0926 82.0773 65.0658 82.0806V82.0773ZM65.5877 82.8534C65.5877 82.8534 65.6145 82.8869 65.6312 82.9036C65.4572 82.9538 65.3167 82.83 65.2364 82.6862C65.1528 82.539 65.1227 82.3817 65.0223 82.2647C65.2063 82.258 65.2665 82.3015 65.2966 82.3684C65.3267 82.4319 65.3301 82.5256 65.3602 82.5758C65.4907 82.6059 65.5174 82.7531 65.5843 82.8568L65.5877 82.8534ZM67.0998 82.6694L67.0697 82.6427L67.0764 82.636C67.0764 82.636 67.0931 82.6527 67.0965 82.6561C67.1032 82.6628 67.1065 82.6694 67.0998 82.6694ZM66.0393 80.8629C66.0326 80.9298 65.9624 80.903 65.9825 80.7726C65.9992 80.7926 66.0226 80.7257 66.0393 80.8629ZM65.8152 83.0609C65.8553 82.9404 65.9457 82.9304 65.9055 83.1077C65.8721 83.101 65.8419 83.0809 65.8152 83.0609ZM66.7151 80.8294C66.7987 80.7157 66.7251 80.8529 66.6917 80.9332C66.695 80.9131 66.6783 80.8964 66.7118 80.8428V80.8328L66.7151 80.8294ZM67.1366 81.0369C67.1902 80.9967 67.2437 80.9867 67.2537 80.9967C67.237 81.0536 67.0998 81.0871 67.1366 81.0369ZM67.4812 81.7394C67.5582 81.7294 67.5883 81.7495 67.5113 81.7628C67.4545 81.7628 67.4076 81.7495 67.4946 81.7361C67.4913 81.7361 67.4846 81.7361 67.4812 81.7394ZM66.2869 83.3954C66.2635 83.6296 66.1397 83.4423 66.0761 83.4991C66.1062 83.2716 66.1999 83.4489 66.2501 83.4021C66.2668 83.4021 66.2769 83.4021 66.2869 83.3954ZM65.1829 80.8261C65.0457 80.6789 65.2498 80.709 65.2531 80.6555L65.3 80.7191C65.2632 80.7726 65.2732 80.8328 65.1829 80.8261ZM65.1862 83.111C65.116 83.1579 65.1327 83.0709 65.116 83.0542C65.1929 82.9705 65.2799 83.0207 65.1862 83.111ZM64.661 82.1944C64.7814 82.1643 64.7313 82.2245 64.748 82.2379C64.7212 82.2345 64.6409 82.2312 64.6376 82.2212C64.6376 82.2111 64.651 82.2078 64.6577 82.1977L64.661 82.1944ZM65.2063 80.9131C65.1795 80.9465 65.1427 80.98 65.1126 81.0134L65.0524 80.9599L65.1528 80.8562L65.2063 80.9131ZM64.835 81.2175L64.7647 81.1807C64.7313 81.077 64.9119 81.1707 64.835 81.2142V81.2175ZM65.6546 80.515C65.6546 80.515 65.6345 80.515 65.6278 80.515C65.5375 80.5618 65.5609 80.2373 65.6546 80.515ZM66.1564 80.3377C66.1564 80.3377 66.1798 80.3009 66.1899 80.3042C66.2635 80.3176 66.1832 80.5049 66.1564 80.3377Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M79.0497 22.4373C79.1167 22.5009 79.1769 22.5645 79.2404 22.6314C79.2404 22.6314 79.2538 22.7451 79.2973 22.8689C79.3274 22.996 79.3876 23.1399 79.5081 23.2034C79.5415 23.4276 79.5415 23.6551 79.5449 23.8792C79.5449 23.8792 79.6151 24.1536 79.7423 24.2372C79.8225 24.2907 79.9129 24.3242 79.9965 24.3342C80.1638 24.3509 80.3009 24.2439 80.224 23.9395C80.234 23.9361 80.2441 23.9227 80.2575 23.9194C80.1939 23.7621 80.1839 23.6049 80.1939 23.441C80.2073 23.277 80.2207 23.1064 80.1604 22.9492C80.1136 22.9659 80.0735 22.9626 80.0969 22.9492L80.1571 22.9392C79.9865 22.7585 80.137 22.5611 79.8627 22.444L79.9463 22.4373C79.8761 22.2768 79.8125 22.1028 79.7188 21.9288C79.6352 21.7515 79.5449 21.5675 79.4311 21.3936C79.3308 21.2129 79.2036 21.0456 79.0732 20.8884C78.9494 20.7245 78.7988 20.594 78.655 20.4769V20.4869L78.6449 20.4903C78.6483 20.584 78.7955 20.8784 78.7955 20.8784C78.4074 20.9018 78.4743 20.4903 78.2602 20.333L78.3137 20.2762C78.394 20.3531 78.4944 20.3899 78.5479 20.3966C78.4342 20.226 78.2368 19.9784 77.9825 19.8045C77.7417 19.6104 77.4573 19.49 77.2633 19.4432C77.2432 19.5 77.4105 19.4465 77.3402 19.6305C77.2532 19.5837 77.1596 19.5536 77.0793 19.5168C77.1395 19.403 77.1663 19.4632 77.1863 19.4498C77.1663 19.403 76.9722 19.2625 76.6845 19.1153C76.5373 19.0517 76.37 18.9748 76.1894 18.9146C76.0054 18.8644 75.818 18.8075 75.6307 18.7774C75.4433 18.754 75.2627 18.7339 75.1055 18.7272C74.9449 18.7339 74.8077 18.7506 74.7073 18.7774C74.5033 18.8276 74.4564 18.9179 74.6404 19.0651L74.6204 19.1287C74.8077 19.1688 74.9683 19.1889 75.1423 19.3428C75.169 19.3361 75.1724 19.3495 75.1791 19.2826C75.1891 19.2725 75.2025 19.2558 75.2025 19.229C75.2192 19.0718 75.2727 19.1421 75.2995 19.1421C75.2493 19.3863 75.3898 19.4197 75.5604 19.3963C75.7277 19.3896 75.9318 19.3294 75.9719 19.3495C75.9217 19.5803 76.1325 19.3997 76.1492 19.5168C76.1425 19.5234 76.1057 19.5669 76.0991 19.5736C76.0991 19.6539 76.2998 19.6539 76.4737 19.664C76.6444 19.6773 76.7782 19.7141 76.6209 19.8011C76.9153 20.1925 77.4038 20.4669 77.8721 20.8482C78.3338 21.2196 78.7353 21.7214 78.7487 22.2098L78.7721 22.1898C78.7721 22.1898 78.7888 22.2132 78.762 22.2333C78.8858 22.2667 79.0531 22.4474 79.0531 22.4474L79.0497 22.4373ZM78.026 20.5639C78.026 20.5639 78.016 20.5706 78.016 20.5739C78.0327 20.5538 77.929 20.4836 77.929 20.4769L77.9825 20.4167C78.1833 20.3899 78.026 20.972 77.9825 20.6241C77.9625 20.6308 78.006 20.584 78.0227 20.5605L78.026 20.5639ZM77.1462 19.9182C77.1328 19.9015 77.1161 19.8814 77.096 19.8647C77.2767 19.8312 77.4272 19.9249 77.5476 20.052C77.6681 20.1825 77.7852 20.3163 77.9391 20.3765C77.638 20.5739 77.5543 20.2962 77.4573 20.1959C77.3068 20.1825 77.2198 20.032 77.1462 19.9216V19.9182ZM75.45 19.2491L75.4433 19.2893H75.4333C75.4333 19.2893 75.44 19.2625 75.44 19.2592C75.44 19.2525 75.4467 19.2458 75.45 19.2491ZM79.1568 22.2333C79.0899 22.2433 79.0899 22.1563 79.2237 22.1496C79.2103 22.1697 79.2806 22.1797 79.1568 22.2333ZM76.9087 19.684C76.8484 19.8011 76.7447 19.781 76.8217 19.6171C76.8551 19.6305 76.8819 19.6573 76.9087 19.684ZM79.5583 22.9024C79.6988 22.889 79.5482 22.9258 79.4679 22.9592C79.4847 22.9458 79.4847 22.9224 79.5482 22.909L79.5583 22.9024ZM79.7556 23.364C79.8225 23.3573 79.8694 23.3774 79.8761 23.3908C79.8292 23.4343 79.6988 23.3908 79.7556 23.364ZM79.8593 24.177C79.9363 24.177 79.9631 24.1937 79.8861 24.2037C79.8292 24.2037 79.7824 24.1803 79.8727 24.1736C79.8694 24.1736 79.8627 24.1736 79.8593 24.177ZM76.5607 19.2257C76.6711 19.025 76.7046 19.2257 76.7748 19.1989C76.6745 19.3997 76.6511 19.2123 76.5942 19.2357C76.5808 19.229 76.5708 19.229 76.5607 19.229V19.2257ZM79.1267 21.3233C79.294 21.2096 79.2204 21.3969 79.2772 21.4036L79.2103 21.4471C79.1635 21.4103 79.1033 21.4103 79.1267 21.3266V21.3233ZM77.5242 19.6305C77.5844 19.5736 77.5777 19.6573 77.5978 19.6673C77.5343 19.7643 77.4473 19.7309 77.5276 19.6305H77.5242ZM78.2736 20.226C78.1933 20.323 78.2 20.2461 78.1833 20.2461C78.2067 20.2327 78.2703 20.1858 78.2769 20.1959C78.2803 20.2026 78.2736 20.216 78.2736 20.226ZM79.0397 21.3333C79.0129 21.2999 78.9862 21.2631 78.9628 21.2263L79.0297 21.1794L79.11 21.2898L79.0431 21.3333H79.0397ZM78.8724 20.9085L78.9327 20.8583C79.0297 20.865 78.8758 20.9954 78.8724 20.9085ZM79.4144 21.7682C79.4144 21.7682 79.4144 21.7482 79.4144 21.7415C79.3642 21.6645 79.6787 21.6411 79.4144 21.7682ZM79.6954 22.1664C79.6954 22.1664 79.7356 22.173 79.7356 22.1831C79.7489 22.2466 79.5482 22.2567 79.6954 22.1664Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M83.5428 20.6575C83.6264 20.7612 83.7 20.8683 83.7803 20.9753C83.7803 20.9753 83.8138 21.1426 83.8807 21.3299C83.9309 21.524 84.0078 21.7414 84.1383 21.8518C84.1784 22.0191 84.1818 22.1897 84.1985 22.357C84.2086 22.5276 84.2353 22.6949 84.232 22.8621C84.232 22.8621 84.3089 23.277 84.436 23.4075C84.5163 23.4877 84.61 23.5413 84.6936 23.5513C84.8643 23.5781 84.9947 23.4208 84.9111 22.9759C84.9211 22.9692 84.9278 22.9525 84.9446 22.9491C84.881 22.7183 84.8576 22.4908 84.8576 22.2566V21.902C84.8408 21.7849 84.8174 21.6678 84.7806 21.5507C84.7338 21.5675 84.6936 21.5641 84.7137 21.5407L84.7739 21.5307C84.6736 21.3901 84.6602 21.2597 84.6334 21.1359C84.6033 21.0121 84.5531 20.8984 84.4026 20.798H84.4896C84.3926 20.5705 84.3022 20.3129 84.1684 20.062C84.1048 19.9349 84.0413 19.8044 83.9777 19.6706C83.9075 19.5401 83.8272 19.4163 83.7502 19.2859C83.6699 19.1587 83.5963 19.0283 83.5094 18.9045C83.4157 18.7874 83.3254 18.6669 83.235 18.5532C83.0611 18.3157 82.8436 18.1216 82.6429 17.941V17.951L82.6328 17.9544C82.6462 18.0112 82.7131 18.1417 82.78 18.2588C82.8436 18.3759 82.9072 18.4763 82.9072 18.4763C82.4422 18.4194 82.4288 17.9075 82.1243 17.6733L82.1812 17.6165C82.3016 17.7269 82.4355 17.7938 82.499 17.8139C82.412 17.6901 82.2849 17.5563 82.1444 17.4057C82.0708 17.3321 81.9972 17.2552 81.9169 17.1816C81.8299 17.1147 81.743 17.0477 81.656 16.9775C81.308 16.6965 80.8999 16.5125 80.6323 16.4188C80.6155 16.479 80.833 16.4523 80.7694 16.6463C80.6456 16.576 80.5118 16.5225 80.3914 16.469C80.4516 16.3552 80.5018 16.4288 80.5252 16.4121C80.4884 16.3586 80.1974 16.1679 79.7758 15.9638C79.5584 15.8768 79.3142 15.7698 79.0566 15.6828C78.7923 15.6125 78.5179 15.5323 78.247 15.4821C77.976 15.4453 77.715 15.4152 77.4842 15.3984C77.2534 15.4018 77.0526 15.4152 76.9054 15.4386C76.611 15.4854 76.5341 15.5757 76.8084 15.7229L76.7783 15.7865C77.0593 15.8333 77.2935 15.8501 77.5645 16.0173C77.6046 16.014 77.608 16.0274 77.618 15.9605C77.6314 15.9504 77.6515 15.9371 77.6481 15.9069C77.6649 15.7497 77.7485 15.8233 77.7886 15.8267C77.7318 16.0709 77.9459 16.1144 78.1968 16.1043C78.441 16.1177 78.7321 16.0776 78.7923 16.1043C78.7521 16.3385 79.0331 16.1746 79.0733 16.3017C79.0666 16.3084 79.0198 16.3485 79.0097 16.3552C79.0198 16.4389 79.3142 16.4723 79.5651 16.5091C79.8126 16.556 80.0033 16.6229 79.8026 16.6831C80.3011 17.1581 81.0571 17.5997 81.753 18.1952C82.4455 18.7773 83.0343 19.5435 83.1547 20.246L83.1748 20.2226C83.1748 20.2226 83.1982 20.2594 83.1748 20.2828C83.3187 20.3564 83.5428 20.6508 83.5428 20.6508V20.6575ZM81.8835 17.9042C81.8835 17.9042 81.8734 17.9109 81.8734 17.9142C81.8902 17.8941 81.743 17.7837 81.7396 17.7737L81.7931 17.7135C82.0374 17.7302 81.9905 18.406 81.8467 17.9677C81.8232 17.9744 81.8667 17.9243 81.8835 17.9008V17.9042ZM80.5654 16.9407C80.5419 16.9173 80.5152 16.8939 80.4851 16.8704C80.7259 16.8738 80.9501 17.0043 81.1408 17.1816C81.3281 17.3656 81.5188 17.5429 81.7296 17.6566C81.3917 17.8172 81.201 17.4659 81.0538 17.3254C80.8497 17.2685 80.6925 17.0845 80.5687 16.9407H80.5654ZM78.0195 15.9605L78.0128 16.0006H77.9994C77.9994 16.0006 78.0061 15.9739 78.0094 15.9705C78.0128 15.9638 78.0195 15.9571 78.0228 15.9605H78.0195ZM83.6131 20.3832C83.5395 20.3832 83.5227 20.2627 83.6699 20.2761C83.6599 20.3029 83.7402 20.3296 83.6131 20.3832ZM80.1873 16.6296C80.1271 16.7467 79.9766 16.7032 80.0535 16.5426C80.1037 16.5627 80.1438 16.5961 80.1873 16.6296ZM84.155 21.4136C84.2989 21.4136 84.145 21.447 84.068 21.4838C84.0848 21.4671 84.0814 21.4303 84.145 21.4203L84.155 21.4136ZM84.4093 22.1094C84.4762 22.1094 84.5264 22.1429 84.5331 22.1596C84.4896 22.2198 84.3524 22.1429 84.4093 22.1094ZM84.5531 23.3205C84.6301 23.3205 84.6568 23.3472 84.5832 23.3573C84.5264 23.3573 84.4795 23.3205 84.5699 23.3138C84.5665 23.3138 84.5598 23.3138 84.5565 23.3171L84.5531 23.3205ZM79.6219 16.0742C79.7457 15.8802 79.8227 16.0943 79.9163 16.0742C79.8126 16.2716 79.7457 16.0675 79.6721 16.0843C79.652 16.0776 79.6353 16.0709 79.6219 16.0709V16.0742ZM83.3956 19.1353C83.5629 19.0216 83.516 19.2524 83.583 19.2758L83.516 19.316C83.4558 19.2557 83.3856 19.2424 83.3956 19.1353ZM81.017 16.6965C81.0872 16.6463 81.0939 16.7366 81.1207 16.7533C81.0571 16.8504 80.9334 16.7968 81.017 16.6965ZM82.1177 17.5563C82.0407 17.6533 82.0307 17.5629 82.0072 17.5563C82.034 17.5462 82.1043 17.5061 82.1143 17.5161C82.121 17.5261 82.1143 17.5362 82.1143 17.5529L82.1177 17.5563ZM83.2986 19.1286C83.2584 19.0784 83.2183 19.0249 83.1815 18.968L83.2484 18.9245C83.2886 18.9781 83.3254 19.0316 83.3655 19.0851L83.2986 19.1286ZM83.0075 18.5398L83.0678 18.4896C83.1848 18.5197 83.031 18.6536 83.0075 18.5398ZM83.8104 19.791C83.8104 19.791 83.8104 19.7643 83.8038 19.7542C83.7335 19.6405 84.0781 19.6672 83.8104 19.791ZM84.1918 20.3899C84.2086 20.3965 84.2353 20.4066 84.2387 20.42C84.2621 20.5136 84.0513 20.4902 84.1918 20.3899Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.2883 57.0332L25.7031 56.9228C25.7031 56.9228 26.4224 57.0299 26.7101 56.8325L27.794 56.9061C27.794 56.9061 28.2457 56.8526 28.3828 56.7288C28.4665 56.6519 28.5233 56.5615 28.5334 56.4779C28.5568 56.3106 28.4029 56.1701 27.968 56.2303C27.9613 56.2203 27.9446 56.2103 27.9446 56.1969C27.4829 56.3207 27.0413 56.1099 26.5696 56.1367C26.5763 56.1868 26.5595 56.2236 26.5462 56.2002L26.5495 56.14C26.235 56.2638 26.041 56.0664 25.7566 56.2772C25.7566 56.2772 25.7901 56.1935 25.7901 56.1969C24.8099 56.237 23.4817 56.1567 22.4212 56.2604L22.4279 56.2705V56.2805C22.5249 56.3407 22.9933 56.4311 22.9933 56.4311C22.642 56.7288 22.2372 56.421 21.8625 56.4344V56.3541C22.0265 56.3541 22.1737 56.3207 22.2305 56.2872C21.6484 56.1801 20.4775 56.1634 19.9188 56.2872C19.9322 56.3474 20.1062 56.2136 20.1497 56.411C20.0058 56.411 19.8653 56.4444 19.7281 56.4411C19.7281 56.314 19.8051 56.3575 19.8218 56.334C19.5876 56.1935 14.8404 56.0631 15.9745 56.6017L15.9444 56.6686C16.2388 56.6953 16.4797 56.7188 16.7841 56.8459C16.8276 56.8359 16.831 56.8459 16.831 56.7823C16.841 56.7723 16.8611 56.7522 16.8577 56.7255C16.8544 56.5649 16.9481 56.6284 16.9915 56.6251C16.9414 57.1236 17.9383 56.6719 18.0721 56.692C18.0989 56.9295 18.3331 56.6987 18.4134 56.7991C18.4067 56.8091 18.3732 56.8593 18.3665 56.8693C18.4401 57.0199 19.6177 56.595 19.2798 56.8894C20.6749 57.3879 23.1974 56.7756 24.7028 57.2072L24.6928 57.1771C24.6928 57.1771 24.743 57.1737 24.7497 57.2072C24.8969 57.1102 25.2883 57.0399 25.2883 57.0399V57.0332ZM21.8391 56.7589C21.8391 56.7589 21.8391 56.7723 21.8391 56.7756C21.8391 56.7522 21.6451 56.7656 21.6384 56.7623V56.682C21.8358 56.5281 22.2874 57.0667 21.8592 56.8325C21.8458 56.8526 21.8458 56.7857 21.8425 56.7589H21.8391ZM20.1195 56.7556C20.0861 56.7489 20.0493 56.7422 20.0091 56.7355C20.4541 56.4846 21.0563 56.7924 21.5447 56.6753C21.3774 57.0299 20.9793 56.8425 20.7686 56.8225C20.5578 56.9028 20.3069 56.8057 20.1195 56.7556ZM17.2491 56.7054V56.7455H17.2324C17.2324 56.7355 17.2324 56.7221 17.2391 56.7154C17.2391 56.7054 17.2458 56.6987 17.2491 56.702V56.7054ZM25.0507 56.8459C25.0173 56.9095 24.8935 56.8727 24.9771 56.7489C24.9972 56.7689 25.0608 56.7087 25.0507 56.8459ZM19.6177 56.6619C19.6177 56.7924 19.4538 56.8191 19.4538 56.6385C19.5107 56.6385 19.5642 56.6485 19.6177 56.6619ZM26.2685 56.7087C26.312 56.5682 26.2986 56.7255 26.3153 56.8124C26.3053 56.7924 26.2651 56.7857 26.2718 56.7221V56.7087H26.2685ZM27.0346 56.6251C27.0446 56.5582 27.0881 56.5147 27.1082 56.5113C27.1617 56.5615 27.058 56.6853 27.0346 56.6251ZM28.2925 56.6084C28.2925 56.5314 28.3226 56.5047 28.3326 56.5816C28.3326 56.6385 28.2925 56.682 28.2891 56.595C28.2891 56.5983 28.2891 56.605 28.2925 56.6084ZM18.8617 56.3842C18.9051 56.1567 19.0557 56.3407 19.136 56.2805C19.1193 56.508 18.9754 56.3407 18.9118 56.3809C18.8918 56.3809 18.875 56.3809 18.8617 56.3876V56.3842ZM23.8163 56.4277C23.8163 56.227 23.9835 56.3876 24.0371 56.3407V56.421C23.9534 56.4411 23.9033 56.4946 23.8196 56.4277H23.8163ZM20.3838 56.314C20.4139 56.2337 20.4675 56.3106 20.5009 56.3073C20.5009 56.421 20.3638 56.4411 20.3838 56.3106V56.314ZM21.7755 56.3407C21.7822 56.4645 21.7153 56.4043 21.6953 56.4177C21.7086 56.3909 21.7354 56.314 21.7521 56.3173C21.7622 56.3173 21.7655 56.334 21.7789 56.3441L21.7755 56.3407ZM23.7561 56.5047C23.6925 56.5047 23.6222 56.5047 23.5553 56.5047V56.4244C23.6256 56.4244 23.6925 56.4244 23.7561 56.4244V56.5047ZM23.1037 56.3809V56.3006C23.1974 56.2236 23.2107 56.4277 23.1037 56.3809ZM24.5958 56.411C24.5958 56.411 24.569 56.4009 24.5623 56.4009C24.4285 56.411 24.6158 56.1199 24.5958 56.411ZM25.3017 56.3307C25.3017 56.3307 25.3318 56.2972 25.3485 56.2972C25.4422 56.3073 25.3385 56.498 25.3017 56.3307Z",
                fill: "#101214"
            })
        ]
    });

});

parcelRegister("hiu3w", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $9dc97c26ebadf63e$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $9dc97c26ebadf63e$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    bannerTitleWithName: {
        id: "fastshift.dashboard.base-welcome-banner.title-with-name",
        defaultMessage: "Hello, {name}!",
        description: "Greeting message for the welcome banner"
    },
    bannerTitleWithoutName: {
        id: "fastshift.dashboard.base-welcome-banner.title-without-name",
        defaultMessage: "Hello!",
        description: "Greeting message for the welcome banner when the user's name is not available"
    }
});

});



parcelRegister("kfVRP", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $ac220aa4fa6d46f3$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $ac220aa4fa6d46f3$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    partnerWelcomeBannerSubtitle: {
        id: "fastshift.dashboard.partner-welcome-banner.subtitle",
        defaultMessage: "Welcome to the FastShift Portal. Select a customer to view more details about their migration progress.",
        description: "Subtitle for the partner welcome banner"
    }
});

});



parcelRegister("jcGFk", function(module, exports) {

$parcel$export(module.exports, "CustomerWelcomeBanner", function () { return (parcelRequire("8Omk5")).CustomerWelcomeBanner; });

var $8Omk5 = parcelRequire("8Omk5");

});
parcelRegister("8Omk5", function(module, exports) {

$parcel$export(module.exports, "CustomerWelcomeBanner", function () { return $3c8cac61da1a5ae0$export$da496bb680f0711d; });

var $365qV = parcelRequire("365qV");

var $gnPGs = parcelRequire("gnPGs");

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iri2o");
var $2f2l0 = parcelRequire("2f2l0");

var $kRIwH = parcelRequire("kRIwH");
const $3c8cac61da1a5ae0$export$da496bb680f0711d = (_param)=>{
    var props = (0, $365qV._)({}, (0, $gnPGs._)(_param));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2f2l0.BaseWelcomeBanner), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        subtitleMessage: (0, $kRIwH.messages).customerWelcomeBannerSubtitle
    }));
};

});
parcelRegister("kRIwH", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $ce65a59df067a91e$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $ce65a59df067a91e$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    customerWelcomeBannerSubtitle: {
        id: "fastshift.dashboard.customer-welcome-banner.subtitle",
        defaultMessage: "Welcome to the FastShift Portal.",
        description: "Subtitle for the customer welcome banner"
    }
});

});




parcelRegister("3oQlK", function(module, exports) {
$parcel$export(module.exports, "useOrg", function () { return (parcelRequire("cHgxm")).useOrg; });
$parcel$export(module.exports, "useSummary", function () { return (parcelRequire("cKTNL")).useSummary; });
$parcel$export(module.exports, "useDashboardPageAnalytics", function () { return (parcelRequire("b7yur")).useDashboardPageAnalytics; });
$parcel$export(module.exports, "useDashboardUIAnalytics", function () { return (parcelRequire("gXwuJ")).useDashboardUIAnalytics; });
parcelRequire("cHgxm");
parcelRequire("cKTNL");
parcelRequire("5woPH");
parcelRequire("b7yur");
parcelRequire("gXwuJ");

});
parcelRegister("cHgxm", function(module, exports) {

$parcel$export(module.exports, "useOrg", function () { return $a7ad54110478f69d$export$7f785727a26e156; });

var $iSvIT = parcelRequire("iSvIT");

var $k4eOf = parcelRequire("k4eOf");

var $gkhN4 = parcelRequire("gkhN4");

var $k0rCZ = parcelRequire("k0rCZ");

var $8KnwD = parcelRequire("8KnwD");
const $a7ad54110478f69d$export$7f785727a26e156 = ()=>{
    const dispatch = (0, $8KnwD.useFastshiftDispatch)();
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const domainOrg = (0, $8KnwD.useFastshiftSelector)((state)=>state.selectedDomainOrg);
    const setDomainOrg = (0, $iSvIT.useCallback)((org)=>{
        dispatch((0, $k0rCZ.setSelectedDomainOrg)(org));
        const isValidCloudOrg = org && !Object.values((0, $k4eOf.DROPDOWN_ORG_ID)).includes(org.orgId);
        if (isValidCloudOrg) {
            dispatch((0, $k0rCZ.getL1Assessments)({
                stargateClient: stargateClient,
                orgId: org.orgId
            }));
            dispatch((0, $k0rCZ.getMigrationPlanTotals)({
                stargateClient: stargateClient,
                orgId: org.orgId
            }));
            dispatch((0, $k0rCZ.getInstances)({
                stargateClient: stargateClient,
                orgId: org.orgId
            }));
        }
    }, [
        dispatch,
        stargateClient
    ]);
    return {
        domainOrg: domainOrg,
        setDomainOrg: setDomainOrg
    };
};

});

parcelRegister("cKTNL", function(module, exports) {

$parcel$export(module.exports, "useSummary", function () { return $387fe95c681a95f6$export$80b235df19ed566d; });

var $8KnwD = parcelRequire("8KnwD");
const $387fe95c681a95f6$var$CONSOLIDATED_INSIGHTS_STATUS_HAS_ERRORS = "HAS_ERRORS";
const $387fe95c681a95f6$export$80b235df19ed566d = ()=>{
    const { l1Assessments: l1Assessments, migrationPlanTotals: migrationPlanTotals, instances: instances, selectedDomainOrg: selectedDomainOrg } = (0, $8KnwD.useFastshiftSelector)((state)=>({
            l1Assessments: state.l1Assessments,
            migrationPlanTotals: state.migrationPlanTotals,
            instances: state.instances,
            selectedDomainOrg: state.selectedDomainOrg
        }));
    const isLoading = l1Assessments.pending || migrationPlanTotals.pending || instances.pending || !selectedDomainOrg;
    const summaryData = {
        dataCenter: {
            count: l1Assessments.data.length
        },
        areaImprovement: {
            count: l1Assessments.data.filter(({ consolidatedInsightsStatus: consolidatedInsightsStatus })=>consolidatedInsightsStatus === $387fe95c681a95f6$var$CONSOLIDATED_INSIGHTS_STATUS_HAS_ERRORS).length
        },
        deletedApps: {
            count: instances.data.totalCount
        },
        migrationCompleted: {
            count: migrationPlanTotals.data.totalPlansCompleted
        },
        migrationInProgress: {
            count: migrationPlanTotals.data.totalPlansRunning
        },
        unsuccessfulMigration: {
            count: migrationPlanTotals.data.totalPlansUnsuccessful
        }
    };
    // isEmpty means there is no data and no errors and not loading
    const isEmpty = l1Assessments.data.length === 0 && instances.data.totalCount === 0 && migrationPlanTotals.data.totalPlansCompleted === 0 && migrationPlanTotals.data.totalPlansUnsuccessful === 0 && migrationPlanTotals.data.totalPlansRunning === 0 && !isLoading && !l1Assessments.error && !instances.error && !migrationPlanTotals.error;
    const errors = {
        l1Assessments: l1Assessments.error,
        migrationPlanTotals: migrationPlanTotals.error,
        instances: instances.error
    };
    return {
        summaryData: summaryData,
        isLoading: isLoading,
        isEmpty: isEmpty,
        errors: errors
    };
};

});

parcelRegister("5woPH", function(module, exports) {

$parcel$export(module.exports, "useMigrationStatusTable", function () { return $87ceea53231040c6$export$42bf17bbe46756f3; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $gf1F9 = parcelRequire("gf1F9");

var $5XRUs = parcelRequire("5XRUs");

var $9CMNB = parcelRequire("9CMNB");

var $hPMhU = parcelRequire("hPMhU");

var $iCoid = parcelRequire("iCoid");

var $jKp9A = parcelRequire("jKp9A");
var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $gkhN4 = parcelRequire("gkhN4");
parcelRequire("2al5y");
var $cDmHV = parcelRequire("cDmHV");

var $9OyVr = parcelRequire("9OyVr");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");
var $k0rCZ = parcelRequire("k0rCZ");

var $7cU9H = parcelRequire("7cU9H");

var $jxfFm = parcelRequire("jxfFm");

var $bqaPF = parcelRequire("bqaPF");

var $gXwuJ = parcelRequire("gXwuJ");
const $87ceea53231040c6$var$iconWrapperStyles = (0, $jAMCU.xcss)({
    width: "20px",
    height: "20px",
    borderRadius: "5px",
    backgroundColor: "color.background.accent.gray.subtler"
});
const $87ceea53231040c6$export$42bf17bbe46756f3 = ()=>{
    const dispatch = (0, $8KnwD.useFastshiftDispatch)();
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { sendMigrationProgressTableOpenSupportTicketClickUIEvent: sendMigrationProgressTableOpenSupportTicketClickUIEvent } = (0, $gXwuJ.useDashboardUIAnalytics)();
    const { migrationStatusTableControls: migrationStatusTableControls } = (0, $8KnwD.useFastshiftSelector)((state)=>state.pageStateCache);
    // TODO: Temp pagination and sortinguntil BE supports it
    const [pagination, setPagination] = (0, $iSvIT.useState)({
        page: (0, $cDmHV.DEFAULT_CONTROLS_PAYLOAD).page,
        size: (0, $cDmHV.DEFAULT_CONTROLS_PAYLOAD).size,
        totalElements: 0,
        totalPages: 0,
        hasNext: false,
        hasPrevious: false,
        sorted: false
    });
    const { pending: customerDomainPending, data: customerDomainData } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomain);
    const selectedDomainOrg = (0, $8KnwD.useFastshiftSelector)((state)=>state.selectedDomainOrg);
    const { data: supportRequestsData, pending: supportRequestsPending, error: supportRequestsError } = (0, $8KnwD.useFastshiftSelector)((state)=>state.supportRequests);
    (0, $iSvIT.useEffect)(()=>{
        const totalPages = Math.ceil(supportRequestsData.length / pagination.size);
        setPagination((0, $6iHNw._)((0, $7Knp0._)({}, pagination), {
            totalElements: supportRequestsData.length,
            totalPages: totalPages,
            hasNext: pagination.page < totalPages - 1,
            hasPrevious: pagination.page > 0
        }));
    }, [
        supportRequestsData
    ]);
    const onSetControlsPayload = (controls)=>{
        const { page: page, size: size } = controls;
        const totalPages = Math.ceil(supportRequestsData.length / size);
        dispatch((0, $k0rCZ.setMigrationStatusTableControls)({
            migrationStatusTableControls: controls
        }));
        setPagination((0, $6iHNw._)((0, $7Knp0._)({}, pagination), {
            page: page,
            size: size,
            totalPages: totalPages,
            hasNext: page < totalPages - 1,
            hasPrevious: page > 0
        }));
    };
    const supportTicketQueryParams = (0, $iSvIT.useMemo)(()=>{
        if (!selectedDomainOrg) return {};
        switch(selectedDomainOrg.orgId){
            case (0, $7cU9H.NO_ORG_FILTER).orgId:
                return {};
            case (0, $7cU9H.OTHER_ORG_FILTER).orgId:
                return {
                    permissionLevel: "NON_ADMIN"
                };
            default:
                return {
                    orgId: selectedDomainOrg.orgId,
                    permissionLevel: "ADMIN"
                };
        }
    }, [
        selectedDomainOrg
    ]);
    const handleRefresh = ()=>{
        if (customerDomainData && selectedDomainOrg) dispatch((0, $k0rCZ.getFastshiftSupportRequests)((0, $7Knp0._)({
            stargateClient: stargateClient,
            customerDomainId: customerDomainData.customerDomainId
        }, supportTicketQueryParams)));
    };
    (0, $iSvIT.useEffect)(()=>{
        let supportRequestsPromise = null;
        if (customerDomainData && selectedDomainOrg) supportRequestsPromise = dispatch((0, $k0rCZ.getFastshiftSupportRequests)((0, $7Knp0._)({
            stargateClient: stargateClient,
            customerDomainId: customerDomainData.customerDomainId
        }, supportTicketQueryParams)));
        return ()=>{
            if (supportRequestsPromise) supportRequestsPromise.abort();
        };
    }, [
        dispatch,
        stargateClient,
        customerDomainData,
        selectedDomainOrg,
        supportTicketQueryParams
    ]);
    const productIconMapping = {
        source: {
            JIRA: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hPMhU.JiraDataCenterIcon), {
                appearance: "brand",
                size: "xsmall"
            }),
            CONFLUENCE: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hPMhU.ConfluenceDataCenterIcon), {
                appearance: "brand",
                size: "xsmall"
            })
        },
        destination: {
            JIRA: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hPMhU.JiraIcon), {
                appearance: "brand",
                size: "xsmall",
                shouldUseNewLogoDesign: true
            }),
            CONFLUENCE: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hPMhU.ConfluenceIcon), {
                appearance: "brand",
                size: "xsmall",
                shouldUseNewLogoDesign: true
            })
        }
    };
    const productNameMapping = {
        JIRA: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTableJiraProductName)),
        CONFLUENCE: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTableConfluenceProductName))
    };
    const head = {
        cells: [
            {
                key: "source",
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTableSourceColumnTitle))
                }),
                width: 24
            },
            {
                key: "destination",
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTableDestinationColumnTitle))
                }),
                width: 24
            },
            {
                key: "phase",
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTablePhaseColumnTitle))
                })
            },
            {
                key: "status",
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTableStatusColumnTitle))
                })
            },
            {
                key: "ticket",
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTableTicketColumnTitle))
                }),
                width: 15
            },
            {
                key: "planToMigrateDate",
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTablePlanToMigrateDateColumnTitle))
                }),
                width: 15
            }
        ]
    };
    const rows = supportRequestsData.slice(pagination.page * pagination.size, (pagination.page + 1) * pagination.size).map((request)=>{
        return {
            key: request.supportTicketId,
            cells: [
                {
                    key: "source",
                    content: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
                                alignBlock: "center",
                                alignInline: "center",
                                xcss: $87ceea53231040c6$var$iconWrapperStyles,
                                children: (request.source.productName ? productIconMapping.source[request.source.productName] : null) || /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5XRUs))), {
                                    label: "globe",
                                    size: "small"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                                        size: "medium",
                                        children: (request.source.productName ? productNameMapping[request.source.productName] : null) || /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTableSourceDestinationColumnContentDefault))
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                                        size: "small",
                                        color: "color.text.subtlest",
                                        children: request.source.baseUrl ? request.source.baseUrl : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTableSourceDestinationColumnContentNoBaseUrl))
                                    })
                                ]
                            })
                        ]
                    })
                },
                {
                    key: "destination",
                    content: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
                                alignBlock: "center",
                                alignInline: "center",
                                xcss: $87ceea53231040c6$var$iconWrapperStyles,
                                children: (request.destination.productName ? productIconMapping.destination[request.destination.productName] : null) || /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5XRUs))), {
                                    label: "globe",
                                    size: "small"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                                        size: "medium",
                                        children: (request.destination.productName ? productNameMapping[request.destination.productName] : null) || /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTableSourceDestinationColumnContentDefault))
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                                        size: "small",
                                        color: "color.text.subtlest",
                                        children: request.destination.baseUrl ? request.destination.baseUrl : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTableSourceDestinationColumnContentNoBaseUrl))
                                    })
                                ]
                            })
                        ]
                    })
                },
                {
                    key: "phase",
                    content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                        size: "medium",
                        children: request.migrationPhase
                    })
                },
                {
                    key: "status",
                    content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
                        as: "span",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iCoid.default), {
                            appearance: (0, $jxfFm.getStatusCategoryStyleMapping)(request.status),
                            children: request.status
                        })
                    })
                },
                {
                    key: "ticket",
                    content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9CMNB.default), {
                        href: `${(0, $9OyVr.SAC_URL)}/requests/${request.supportTicketId}`,
                        target: "_blank",
                        onClick: ()=>sendMigrationProgressTableOpenSupportTicketClickUIEvent(request.source.senId, request.supportTicketId),
                        children: request.supportTicketId
                    })
                },
                {
                    key: "planToMigrateDate",
                    content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                        size: "medium",
                        children: request.planToMigrateDate ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $6x1qA.FormattedDate), {
                            value: new Date(request.planToMigrateDate),
                            day: "2-digit",
                            month: "short",
                            year: "numeric"
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bqaPF.messages).migrationStatusTablePlanToMigrateDateColumnContentDefault))
                    })
                }
            ]
        };
    });
    return {
        isTableLoading: customerDomainPending || supportRequestsPending,
        isTableError: !!supportRequestsError,
        rows: rows,
        head: head,
        controls: {
            pagination: pagination,
            onSetControlsPayload: onSetControlsPayload,
            controls: migrationStatusTableControls
        },
        handleRefresh: handleRefresh
    };
};

});
parcelRegister("iCoid", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8de9ea9430b1894$export$2e2bcd8739ae039; });
/* lozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $k95aP = parcelRequire("k95aP");

var $jxLBU = parcelRequire("jxLBU");

var $1ULah = parcelRequire("1ULah");
var $d8de9ea9430b1894$var$stylesOld = {
    container: "_2rko12b0 _1reo15vq _18m915vq _18zr1b66 _1e0c116y _1kz6184x _kqswpfqs _vchhusvi",
    "text.bold.default": "_syaz15cr",
    "text.bold.inprogress": "_syaz15cr",
    "text.bold.moved": "_syazal3n",
    "text.bold.new": "_syaz15cr",
    "text.bold.removed": "_syaz15cr",
    "text.bold.success": "_syaz15cr",
    "text.subtle.default": "_syazjjyb",
    "text.subtle.inprogress": "_syaz1lpn",
    "text.subtle.moved": "_syaz1tm6",
    "text.subtle.new": "_syaz1mvf",
    "text.subtle.removed": "_syaz1ick",
    "text.subtle.success": "_syaz17fi"
};
// NOTE: This is isolated to avoid breaking the bounded `stylesOld` interface as they do not fall within the Design System.
var $d8de9ea9430b1894$var$stylesOldUnbounded = {
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi"
};
var $d8de9ea9430b1894$var$backgroundColorsOld = {
    bold: {
        default: "color.background.neutral.bold",
        inprogress: "color.background.information.bold",
        moved: "color.background.warning.bold",
        new: "color.background.discovery.bold",
        removed: "color.background.danger.bold",
        success: "color.background.success.bold"
    },
    subtle: {
        default: "color.background.neutral",
        inprogress: "color.background.information",
        moved: "color.background.warning",
        new: "color.background.discovery",
        removed: "color.background.danger",
        success: "color.background.success"
    }
};
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $d8de9ea9430b1894$var$stylesNew = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    "bg.bold.default": "_bfhk1fkg",
    "bg.bold.inprogress": "_bfhk1ymo",
    "bg.bold.moved": "_bfhkxmjf",
    "bg.bold.new": "_bfhkshej",
    "bg.bold.removed": "_bfhk1366",
    "bg.bold.success": "_bfhk3uhp",
    "bg.subtle.default": "_bfhksm61",
    "bg.subtle.inprogress": "_bfhksm61",
    "bg.subtle.moved": "_bfhksm61",
    "bg.subtle.new": "_bfhksm61",
    "bg.subtle.removed": "_bfhksm61",
    "bg.subtle.success": "_bfhksm61",
    "border.subtle.default": "_19it14mp",
    "border.subtle.inprogress": "_19it1cy7",
    "border.subtle.moved": "_19itzi1n",
    "border.subtle.new": "_19it1apr",
    "border.subtle.removed": "_19itoa5t",
    "border.subtle.success": "_19it1am1",
    "outline.subtle.default": "_12ji14je _1qu2nqa1 _12y3t94y",
    "outline.subtle.inprogress": "_12jiuisw _1qu2nqa1 _12y3t94y",
    "outline.subtle.moved": "_12jih727 _1qu2nqa1 _12y3t94y",
    "outline.subtle.new": "_12ji157s _1qu2nqa1 _12y3t94y",
    "outline.subtle.removed": "_12jia2c0 _1qu2nqa1 _12y3t94y",
    "outline.subtle.success": "_12jin0nx _1qu2nqa1 _12y3t94y",
    "text.subtle": "_syaz1fxt",
    "text.bold": "_syazwwip"
};
var $d8de9ea9430b1894$var$appearanceTypes = [
    "default",
    "inprogress",
    "moved",
    "new",
    "removed",
    "success"
];
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $d8de9ea9430b1894$var$Lozenge = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? "bold" : "subtle";
    var appearanceType = (0, $iSvIT.useMemo)(function() {
        return $d8de9ea9430b1894$var$appearanceTypes.includes(appearance) ? appearance : "default";
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    if ((0, $jxLBU.fg)("platform-component-visual-refresh")) return /*#__PURE__*/ $iSvIT.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        "data-testid": testId,
        className: (0, $k95aP.default)([
            $d8de9ea9430b1894$var$stylesNew.container,
            $d8de9ea9430b1894$var$stylesNew["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === "subtle" && !(0, $jxLBU.fg)("visual-refresh_drop_5") && $d8de9ea9430b1894$var$stylesNew["border.subtle.".concat(appearanceType)],
            appearanceStyle === "subtle" && (0, $jxLBU.fg)("visual-refresh_drop_5") && $d8de9ea9430b1894$var$stylesNew["outline.subtle.".concat(appearanceType)],
            appearanceStyle === "subtle" && (0, $jxLBU.fg)("visual-refresh_drop_5") && $d8de9ea9430b1894$var$stylesNew.containerSubtle
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $k95aP.default)([
            $d8de9ea9430b1894$var$stylesNew.text,
            (0, $jxLBU.fg)("platform-lozenge-custom-letterspacing") && $d8de9ea9430b1894$var$stylesNew.customLetterspacing,
            $d8de9ea9430b1894$var$stylesNew["text.".concat(appearanceStyle)]
        ])
    }, children));
    return /*#__PURE__*/ $iSvIT.createElement((0, $1ULah.default), {
        as: "span",
        backgroundColor: $d8de9ea9430b1894$var$backgroundColorsOld[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        paddingInline: "space.050",
        xcss: $d8de9ea9430b1894$var$stylesOld.container,
        testId: testId
    }, /*#__PURE__*/ $iSvIT.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $k95aP.default)([
            $d8de9ea9430b1894$var$stylesOldUnbounded.text,
            (0, $jxLBU.fg)("platform-lozenge-custom-letterspacing") && $d8de9ea9430b1894$var$stylesOldUnbounded.customLetterspacing,
            $d8de9ea9430b1894$var$stylesOld["text.".concat(appearanceStyle, ".").concat(appearanceType)]
        ])
    }, children));
});
$d8de9ea9430b1894$var$Lozenge.displayName = "Lozenge";
var $d8de9ea9430b1894$export$2e2bcd8739ae039 = $d8de9ea9430b1894$var$Lozenge;

});
parcelRegister("k95aP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaa8a94f07e1c747$export$2e2bcd8739ae039; });
const $eaa8a94f07e1c747$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $eaa8a94f07e1c747$var$ATOMIC_GROUP_LENGTH = 5;
function $eaa8a94f07e1c747$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $eaa8a94f07e1c747$var$UNDERSCORE_UNICODE ? $eaa8a94f07e1c747$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("1ULah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $164f9b5ccb1e87ce$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwPVh = parcelRequire("bwPVh");

var $7Blqz = parcelRequire("7Blqz");

var $iSvIT = parcelRequire("iSvIT");

var $k95aP = parcelRequire("k95aP");

var $dj0xG = parcelRequire("dj0xG");
var $164f9b5ccb1e87ce$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $164f9b5ccb1e87ce$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $164f9b5ccb1e87ce$var$baseStyles = null;
var $164f9b5ccb1e87ce$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhk1fno",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1eds",
    "color.background.accent.lime.subtler.pressed": "_bfhk1hgz",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhkhgj8",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhk1b17",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhk1pbw",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkrw5d",
    "color.background.accent.red.subtler.pressed": "_bfhk69rw",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1tf4",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhkprmn",
    "color.background.accent.orange.subtlest": "_bfhk1g3m",
    "color.background.accent.orange.subtlest.hovered": "_bfhkg4tm",
    "color.background.accent.orange.subtlest.pressed": "_bfhk1ya0",
    "color.background.accent.orange.subtler": "_bfhkf2vu",
    "color.background.accent.orange.subtler.hovered": "_bfhk1lml",
    "color.background.accent.orange.subtler.pressed": "_bfhkuxsx",
    "color.background.accent.orange.subtle": "_bfhk1g6e",
    "color.background.accent.orange.subtle.hovered": "_bfhk1oew",
    "color.background.accent.orange.subtle.pressed": "_bfhk1phk",
    "color.background.accent.orange.bolder": "_bfhkjgng",
    "color.background.accent.orange.bolder.hovered": "_bfhkhi52",
    "color.background.accent.orange.bolder.pressed": "_bfhkf767",
    "color.background.accent.yellow.subtlest": "_bfhk1ozg",
    "color.background.accent.yellow.subtlest.hovered": "_bfhk19g9",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk31d1",
    "color.background.accent.yellow.subtler": "_bfhk3fv2",
    "color.background.accent.yellow.subtler.hovered": "_bfhklg04",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1d44",
    "color.background.accent.yellow.subtle": "_bfhkry5t",
    "color.background.accent.yellow.subtle.hovered": "_bfhk17e6",
    "color.background.accent.yellow.subtle.pressed": "_bfhko0y5",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk32kj",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkv5yf",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhkung8",
    "color.background.accent.green.subtler.pressed": "_bfhk1p19",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk8h4p",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1azz",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1j2h",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkg5py",
    "color.background.accent.teal.subtler.pressed": "_bfhkq7li",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk10ai",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhkse6l",
    "color.background.accent.blue.subtlest": "_bfhkavxe",
    "color.background.accent.blue.subtlest.hovered": "_bfhkay3p",
    "color.background.accent.blue.subtlest.pressed": "_bfhk1xmr",
    "color.background.accent.blue.subtler": "_bfhk4v9p",
    "color.background.accent.blue.subtler.hovered": "_bfhk16e6",
    "color.background.accent.blue.subtler.pressed": "_bfhk1uh7",
    "color.background.accent.blue.subtle": "_bfhk1j89",
    "color.background.accent.blue.subtle.hovered": "_bfhk1f4s",
    "color.background.accent.blue.subtle.pressed": "_bfhkqctv",
    "color.background.accent.blue.bolder": "_bfhkc8cv",
    "color.background.accent.blue.bolder.hovered": "_bfhk1cwi",
    "color.background.accent.blue.bolder.pressed": "_bfhkhcrq",
    "color.background.accent.purple.subtlest": "_bfhkp7j4",
    "color.background.accent.purple.subtlest.hovered": "_bfhkm0d5",
    "color.background.accent.purple.subtlest.pressed": "_bfhkgslw",
    "color.background.accent.purple.subtler": "_bfhk1jkz",
    "color.background.accent.purple.subtler.hovered": "_bfhk1wyu",
    "color.background.accent.purple.subtler.pressed": "_bfhk5fkp",
    "color.background.accent.purple.subtle": "_bfhkdh45",
    "color.background.accent.purple.subtle.hovered": "_bfhk1wob",
    "color.background.accent.purple.subtle.pressed": "_bfhkwz05",
    "color.background.accent.purple.bolder": "_bfhkygwo",
    "color.background.accent.purple.bolder.hovered": "_bfhkadgs",
    "color.background.accent.purple.bolder.pressed": "_bfhk1uro",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1een",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1r0p",
    "color.background.accent.magenta.subtler.pressed": "_bfhkxuzc",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk1ovh",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkwaw3",
    "color.background.accent.gray.subtlest": "_bfhk11bn",
    "color.background.accent.gray.subtlest.hovered": "_bfhk12j4",
    "color.background.accent.gray.subtlest.pressed": "_bfhk1lb4",
    "color.background.accent.gray.subtler": "_bfhk1v33",
    "color.background.accent.gray.subtler.hovered": "_bfhk1f7l",
    "color.background.accent.gray.subtler.pressed": "_bfhkd8a2",
    "color.background.accent.gray.subtle": "_bfhk1t05",
    "color.background.accent.gray.subtle.hovered": "_bfhk1a2l",
    "color.background.accent.gray.subtle.pressed": "_bfhk1z0s",
    "color.background.accent.gray.bolder": "_bfhk1t1b",
    "color.background.accent.gray.bolder.hovered": "_bfhke4nv",
    "color.background.accent.gray.bolder.pressed": "_bfhk82ra",
    "color.background.disabled": "_bfhksyzs",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhk1d5g",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhkm7j4",
    "color.background.neutral.hovered": "_bfhk15ej",
    "color.background.neutral.pressed": "_bfhkip91",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk166n",
    "color.background.neutral.subtle.pressed": "_bfhk1dty",
    "color.background.neutral.bold": "_bfhkcdhy",
    "color.background.neutral.bold.hovered": "_bfhk1bsc",
    "color.background.neutral.bold.pressed": "_bfhk1b6k",
    "color.background.selected": "_bfhkfg4m",
    "color.background.selected.hovered": "_bfhki1yw",
    "color.background.selected.pressed": "_bfhk19ru",
    "color.background.selected.bold": "_bfhk1fvw",
    "color.background.selected.bold.hovered": "_bfhk18hz",
    "color.background.selected.bold.pressed": "_bfhkgr1v",
    "color.background.brand.subtlest": "_bfhk3wxy",
    "color.background.brand.subtlest.hovered": "_bfhkezq1",
    "color.background.brand.subtlest.pressed": "_bfhk2ggb",
    "color.background.brand.bold": "_bfhkb29m",
    "color.background.brand.bold.hovered": "_bfhku1se",
    "color.background.brand.bold.pressed": "_bfhkqkzo",
    "color.background.brand.boldest": "_bfhk15mt",
    "color.background.brand.boldest.hovered": "_bfhk1uwk",
    "color.background.brand.boldest.pressed": "_bfhk17jr",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1io2",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk9pqq",
    "color.background.warning": "_bfhk1tzq",
    "color.background.warning.hovered": "_bfhk1rd4",
    "color.background.warning.pressed": "_bfhk11dh",
    "color.background.warning.bold": "_bfhk190i",
    "color.background.warning.bold.hovered": "_bfhk1i4c",
    "color.background.warning.bold.pressed": "_bfhkrj9s",
    "color.background.success": "_bfhkmv6i",
    "color.background.success.hovered": "_bfhk1jgi",
    "color.background.success.pressed": "_bfhky4f1",
    "color.background.success.bold": "_bfhk8emd",
    "color.background.success.bold.hovered": "_bfhk1q4l",
    "color.background.success.bold.pressed": "_bfhkcrcn",
    "color.background.discovery": "_bfhk1nvp",
    "color.background.discovery.hovered": "_bfhk1xp7",
    "color.background.discovery.pressed": "_bfhkdlkp",
    "color.background.discovery.bold": "_bfhk1lri",
    "color.background.discovery.bold.hovered": "_bfhk1w72",
    "color.background.discovery.bold.pressed": "_bfhkrb53",
    "color.background.information": "_bfhk33gi",
    "color.background.information.hovered": "_bfhk1vps",
    "color.background.information.pressed": "_bfhk1s0z",
    "color.background.information.bold": "_bfhk14wj",
    "color.background.information.bold.hovered": "_bfhk1amz",
    "color.background.information.bold.pressed": "_bfhk5bth",
    "color.blanket": "_bfhk10xm",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkn82g",
    "color.skeleton.subtle": "_bfhkh3tw",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk108i",
    "elevation.surface.pressed": "_bfhk1ji5",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk16qz",
    "elevation.surface.overlay.pressed": "_bfhkvq0a",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk1a0f",
    "elevation.surface.raised.pressed": "_bfhkf7u5",
    "elevation.surface.sunken": "_bfhkqbzx",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $164f9b5ccb1e87ce$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $164f9b5ccb1e87ce$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l108i",
    "elevation.surface.pressed": "_1q1l1ji5",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l16qz",
    "elevation.surface.overlay.pressed": "_1q1lvq0a",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l1a0f",
    "elevation.surface.raised.pressed": "_1q1lf7u5",
    "elevation.surface.sunken": "_1q1lqbzx"
};
var $164f9b5ccb1e87ce$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $164f9b5ccb1e87ce$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $164f9b5ccb1e87ce$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $164f9b5ccb1e87ce$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $164f9b5ccb1e87ce$var$Box = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $7Blqz.default)(_ref, $164f9b5ccb1e87ce$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $7Blqz.default)(htmlAttributes, $164f9b5ccb1e87ce$var$_excluded2);
    var node = /*#__PURE__*/ $iSvIT.createElement(Component, (0, $bwPVh.default)({
        style: style,
        ref: ref,
        className: (0, $k95aP.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $164f9b5ccb1e87ce$var$backgroundColorMap[backgroundColor],
            backgroundColor && $164f9b5ccb1e87ce$var$isSurfaceToken(backgroundColor) && $164f9b5ccb1e87ce$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $164f9b5ccb1e87ce$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $164f9b5ccb1e87ce$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $164f9b5ccb1e87ce$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $164f9b5ccb1e87ce$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $iSvIT.createElement((0, $dj0xG.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $164f9b5ccb1e87ce$export$2e2bcd8739ae039 = $164f9b5ccb1e87ce$var$Box;
function $164f9b5ccb1e87ce$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $164f9b5ccb1e87ce$var$setSurfaceTokenMap;
}

});
parcelRegister("bwPVh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $864af5a7ac3ce7c0$export$2e2bcd8739ae039; });
function $864af5a7ac3ce7c0$export$2e2bcd8739ae039() {
    return $864af5a7ac3ce7c0$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $864af5a7ac3ce7c0$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("7Blqz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $588c9c25a521c6e1$export$2e2bcd8739ae039; });

var $cdXFm = parcelRequire("cdXFm");
function $588c9c25a521c6e1$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $cdXFm.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("cdXFm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e64fb629709c94b$export$2e2bcd8739ae039; });
function $8e64fb629709c94b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("dj0xG", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $9afd786919451cfe$export$1ca2a26fecb070ae; });

var $iSvIT = parcelRequire("iSvIT");
var $9afd786919451cfe$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $9afd786919451cfe$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($9afd786919451cfe$export$1ca2a26fecb070ae);
};
$9afd786919451cfe$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("2al5y", function(module, exports) {

$parcel$export(module.exports, "FastshiftTable", function () { return (parcelRequire("505JK")).FastshiftTable; });
$parcel$export(module.exports, "DEFAULT_CONTROLS_PAYLOAD", function () { return (parcelRequire("cDmHV")).DEFAULT_CONTROLS_PAYLOAD; });

var $505JK = parcelRequire("505JK");

var $cDmHV = parcelRequire("cDmHV");

});
parcelRegister("505JK", function(module, exports) {

$parcel$export(module.exports, "FastshiftTable", function () { return $07d07cad71b7818e$export$86fd6b3c9e851f41; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $dJWJL = parcelRequire("dJWJL");

var $jKp9A = parcelRequire("jKp9A");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");
parcelRequire("eRD7U");
var $kQisC = parcelRequire("kQisC");

var $cDmHV = parcelRequire("cDmHV");
parcelRequire("7B32R");
var $5WUb7 = parcelRequire("5WUb7");
parcelRequire("kftet");
var $bPqst = parcelRequire("bPqst");
parcelRequire("jKbhD");
var $7LUEM = parcelRequire("7LUEM");
parcelRequire("j14dD");
var $282AX = parcelRequire("282AX");
var $2hGd2 = parcelRequire("2hGd2");

var $252Eh = parcelRequire("252Eh");
const $07d07cad71b7818e$var$emptyTableContainerStyles = (0, $jAMCU.xcss)({
    height: "200px",
    width: "100%",
    padding: "space.400"
});
const $07d07cad71b7818e$var$emptyTableIconContainer = (0, $jAMCU.xcss)({
    paddingBlock: "space.100"
});
const $07d07cad71b7818e$export$86fd6b3c9e851f41 = ({ enableSearch: enableSearch = false, summaryText: summaryText, isTableLoading: isTableLoading, isTableError: isTableError, errorComponent: errorComponent, head: head, rows: rows, controls: controls, id: id = "fastshift-table", testId: testId = "fastshift-table" })=>{
    const intl = (0, $f6qj2.default)();
    const { pagination: pagination, sorting: sorting, search: search } = (0, $282AX.useFastshiftTableControls)(controls);
    const { sendSearchUIEvent: sendSearchUIEvent, sendNavigationUIEvent: sendNavigationUIEvent, sendPageSizeChangeUIEvent: sendPageSizeChangeUIEvent, sendSortUIEvent: sendSortUIEvent } = (0, $2hGd2.useFastshiftTableAnalytics)();
    // Enhanced sort handler that triggers analytics
    const handleSort = (0, $iSvIT.useCallback)((key)=>{
        const nextOrder = sorting.sortBy === key && sorting.sortDirection === (0, $cDmHV.SORT_DIRECTION).ASC ? (0, $cDmHV.SORT_DIRECTION).DESC : (0, $cDmHV.SORT_DIRECTION).ASC;
        sorting.onSort(key, nextOrder);
        sendSortUIEvent(key, nextOrder);
    }, [
        sorting,
        sendSortUIEvent
    ]);
    // Enhanced search handler that triggers analytics
    const enhancedSearch = (0, $6iHNw._)((0, $7Knp0._)({}, search), {
        onSetSearchTerm: (0, $iSvIT.useCallback)((searchTerm)=>{
            search.onSetSearchTerm(searchTerm);
            sendSearchUIEvent();
        }, [
            search,
            sendSearchUIEvent
        ])
    });
    // Enhanced pagination handlers that trigger analytics
    const enhancedPagination = (0, $6iHNw._)((0, $7Knp0._)({}, pagination), {
        onClickNext: (0, $iSvIT.useCallback)(()=>{
            pagination.onClickNext();
            sendNavigationUIEvent((0, $cDmHV.PAGINATION_DIRECTION).NEXT, pagination.totalPages);
        }, [
            pagination,
            sendNavigationUIEvent
        ]),
        onClickPrevious: (0, $iSvIT.useCallback)(()=>{
            pagination.onClickPrevious();
            sendNavigationUIEvent((0, $cDmHV.PAGINATION_DIRECTION).PREVIOUS, pagination.totalPages);
        }, [
            pagination,
            sendNavigationUIEvent
        ]),
        onSizeChange: (0, $iSvIT.useCallback)((size)=>{
            pagination.onSizeChange(size);
            sendPageSizeChangeUIEvent(size);
        }, [
            pagination,
            sendPageSizeChangeUIEvent
        ])
    });
    if (isTableError) return errorComponent;
    var _sorting_sortDirection;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        space: "space.200",
        children: [
            enableSearch && /*#__PURE__*/ (0, $loA2J.jsx)((0, $bPqst.FastshiftTableSearch), {
                id: `${id}-search`,
                search: enhancedSearch,
                testId: `${testId}-search`
            }),
            summaryText && /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                size: "medium",
                children: summaryText
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7LUEM.FastshiftTableWrapper), {
                id: `${id}-wrapper`,
                testId: `${testId}-wrapper`,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJWJL.default), {
                        testId: `${testId}-table`,
                        head: head,
                        rows: rows,
                        isLoading: isTableLoading,
                        isFixedSize: true,
                        onSort: (data)=>handleSort(data.key),
                        sortOrder: (_sorting_sortDirection = sorting.sortDirection) !== null && _sorting_sortDirection !== void 0 ? _sorting_sortDirection : (0, $cDmHV.SORT_DIRECTION).ASC,
                        sortKey: sorting.sortBy,
                        emptyView: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                            alignBlock: "center",
                            alignInline: "center",
                            xcss: $07d07cad71b7818e$var$emptyTableContainerStyles,
                            space: "space.300",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
                                    xcss: $07d07cad71b7818e$var$emptyTableIconContainer,
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kQisC.EmptySearchVector), {})
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                                    children: intl.formatMessage((0, $252Eh.messages).emptyTableMessage)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5WUb7.FastshiftTablePagination), {
                        pagination: enhancedPagination
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("dJWJL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a00d0a4887cec745$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $lgwoD = parcelRequire("lgwoD");

var $iSvIT = parcelRequire("iSvIT");

var $6RvuE = parcelRequire("6RvuE");

var $jiOHx = parcelRequire("jiOHx");

var $gZthg = parcelRequire("gZthg");

var $8n6Ta = parcelRequire("8n6Ta");

var $2s5kv = parcelRequire("2s5kv");

var $4YOBA = parcelRequire("4YOBA");

var $Hg9Pj = parcelRequire("Hg9Pj");

var $cWQsB = parcelRequire("cWQsB");

var $Jdsr1 = parcelRequire("Jdsr1");

var $lNmzm = parcelRequire("lNmzm");

var $5h72J = parcelRequire("5h72J");

var $7WZcV = parcelRequire("7WZcV");
var $a00d0a4887cec745$var$_excluded = [
    "isRankable",
    "isRanking",
    "onRankStart",
    "onRankEnd",
    "isRankingDisabled"
];
function $a00d0a4887cec745$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $gZthg.DESC:
            return 0, $gZthg.ASC;
        case 0, $gZthg.ASC:
            return 0, $gZthg.DESC;
        default:
            return currentSortOrder;
    }
}
var $a00d0a4887cec745$var$DynamicTable = function DynamicTable(_ref) {
    var caption = _ref.caption, head = _ref.head, highlightedRowIndex = _ref.highlightedRowIndex, rows = _ref.rows, sortKey = _ref.sortKey, sortOrder = _ref.sortOrder, loadingLabel = _ref.loadingLabel, onPageRowsUpdate = _ref.onPageRowsUpdate, testId = _ref.testId, passedDownTotalRows = _ref.totalRows, label = _ref.label, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isFixedSize = _ref.isFixedSize, isFixedSize = _ref$isFixedSize === void 0 ? false : _ref$isFixedSize, _ref$rowsPerPage = _ref.rowsPerPage, rowsPerPage = _ref$rowsPerPage === void 0 ? Infinity : _ref$rowsPerPage, _ref$onSetPage = _ref.onSetPage, onSetPage = _ref$onSetPage === void 0 ? (0, $jiOHx.default) : _ref$onSetPage, _ref$onSort = _ref.onSort, providedOnSort = _ref$onSort === void 0 ? (0, $jiOHx.default) : _ref$onSort, _ref$page = _ref.page, page = _ref$page === void 0 ? 1 : _ref$page, emptyView = _ref.emptyView, _ref$isRankable = _ref.isRankable, isRankable = _ref$isRankable === void 0 ? false : _ref$isRankable, _ref$isRankingDisable = _ref.isRankingDisabled, isRankingDisabled = _ref$isRankingDisable === void 0 ? false : _ref$isRankingDisable, _ref$onRankStart = _ref.onRankStart, onRankStart = _ref$onRankStart === void 0 ? (0, $jiOHx.default) : _ref$onRankStart, _ref$onRankEnd = _ref.onRankEnd, providedOnRankEnd = _ref$onRankEnd === void 0 ? (0, $jiOHx.default) : _ref$onRankEnd, loadingSpinnerSize = _ref.loadingSpinnerSize, _ref$paginationi18n = _ref.paginationi18n, paginationi18n = _ref$paginationi18n === void 0 ? {
        prev: "Previous Page",
        next: "Next Page",
        label: "Pagination",
        pageLabel: "Page"
    } : _ref$paginationi18n;
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $lgwoD.default)(_useState, 2), isRanking = _useState2[0], setIsRanking = _useState2[1];
    var tableBodyRef = (0, $iSvIT.useRef)(null);
    var onSort = (0, $6RvuE.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: "sorted",
        componentName: "dynamicTable",
        packageName: "@atlaskit/dynamic-table",
        packageVersion: "18.2.7"
    });
    var onRankEnd = (0, $6RvuE.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: "ranked",
        componentName: "dynamicTable",
        packageName: "@atlaskit/dynamic-table",
        packageVersion: "18.2.7"
    });
    (0, $iSvIT.useEffect)(function() {
        (0, $8n6Ta.validateSortKey)(sortKey, head);
        (0, $8n6Ta.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    var onSortHandler = function onSortHandler(item) {
        return function() {
            var key = item.key;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $gZthg.DESC)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            var sortOrderFormatted = key !== sortKey ? (0, $gZthg.ASC) : $a00d0a4887cec745$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    };
    var onSetPageHandler = function onSetPageHandler(page, event) {
        onSetPage(page, event);
    };
    var onRankStartHandler = function onRankStartHandler(params) {
        setIsRanking(true);
        onRankStart(params);
    };
    var onRankEndHandler = function onRankEndHandler(params) {
        setIsRanking(false);
        onRankEnd(params);
    };
    var getSpinnerSize = function getSpinnerSize() {
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $8n6Ta.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $gZthg.LARGE) : (0, $gZthg.SMALL);
    };
    var renderEmptyBody = function renderEmptyBody() {
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4YOBA.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4YOBA.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    var rowsLength = rows && rows.length;
    var totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    var isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    var getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    var rowsExist = !!rowsLength;
    var spinnerSize = getSpinnerSize();
    var emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lNmzm.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: function targetRef() {
            return tableBodyRef.current;
        },
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2s5kv.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2s5kv.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7WZcV.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($a00d0a4887cec745$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : /*#__PURE__*/ // only show pagination if there's MORE than 1 page
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2s5kv.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5h72J.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $Jdsr1.default), {
        isLoading: isLoading,
        spinnerSize: (0, $gZthg.LARGE),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

var $a00d0a4887cec745$var$RankableTableBody = /*#__PURE__*/ (0, $iSvIT.lazy)(function() {
    return (parcelRequire("b9eLC"));
});
var $a00d0a4887cec745$var$TableBody = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TableBody(_ref2, ref) {
    var _ref2$isRankable = _ref2.isRankable, isRankable = _ref2$isRankable === void 0 ? false : _ref2$isRankable, isRanking = _ref2.isRanking, onRankStart = _ref2.onRankStart, onRankEnd = _ref2.onRankEnd, isRankingDisabled = _ref2.isRankingDisabled, bodyProps = (0, $cxbbJ.default)(_ref2, $a00d0a4887cec745$var$_excluded);
    var canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ var _useState3 = (0, $iSvIT.useState)(false), _useState4 = (0, $lgwoD.default)(_useState3, 2), canRenderRankable = _useState4[0], setCanRenderRankable = _useState4[1];
    (0, $iSvIT.useEffect)(function() {
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    var nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $Hg9Pj.default), (0, $7wyUQ.default)({
        ref: ref
    }, bodyProps));
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $cWQsB.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($a00d0a4887cec745$var$RankableTableBody, (0, $7wyUQ.default)({
        ref: ref
    }, bodyProps, {
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    })))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a00d0a4887cec745$export$2e2bcd8739ae039 = $a00d0a4887cec745$var$DynamicTable;

});
parcelRegister("7wyUQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57a69b1d7a1ec239$export$2e2bcd8739ae039; });
function $57a69b1d7a1ec239$export$2e2bcd8739ae039() {
    return $57a69b1d7a1ec239$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $57a69b1d7a1ec239$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("cxbbJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92013ed3993195c4$export$2e2bcd8739ae039; });

var $kDgHH = parcelRequire("kDgHH");
function $92013ed3993195c4$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $kDgHH.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("kDgHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0546830b354207c$export$2e2bcd8739ae039; });
function $f0546830b354207c$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("lgwoD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7b438d5c7ad8beb$export$2e2bcd8739ae039; });

var $hV5Q7 = parcelRequire("hV5Q7");

var $hjhEZ = parcelRequire("hjhEZ");

var $eDzZU = parcelRequire("eDzZU");

var $1HASk = parcelRequire("1HASk");
function $f7b438d5c7ad8beb$export$2e2bcd8739ae039(r, e) {
    return (0, $hV5Q7.default)(r) || (0, $hjhEZ.default)(r, e) || (0, $eDzZU.default)(r, e) || (0, $1HASk.default)();
}

});
parcelRegister("hV5Q7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0bc4a28124f85a7$export$2e2bcd8739ae039; });
function $d0bc4a28124f85a7$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("hjhEZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9a1e8ef7253b994$export$2e2bcd8739ae039; });
function $c9a1e8ef7253b994$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("eDzZU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa80a197b3e3abb3$export$2e2bcd8739ae039; });

var $fRZgQ = parcelRequire("fRZgQ");
function $aa80a197b3e3abb3$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $fRZgQ.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $fRZgQ.default)(r, a) : void 0;
    }
}

});
parcelRegister("fRZgQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8db555a2ee2e04c$export$2e2bcd8739ae039; });
function $b8db555a2ee2e04c$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("1HASk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13d6693d97bd914c$export$2e2bcd8739ae039; });
function $13d6693d97bd914c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6RvuE", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $4ff01f39d66e65ad$export$a4687b0234b40e28; });

var $eKFRo = parcelRequire("eKFRo");

var $iSvIT = parcelRequire("iSvIT");

var $8pdcq = parcelRequire("8pdcq");

var $iIL7u = parcelRequire("iIL7u");
function $4ff01f39d66e65ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4ff01f39d66e65ad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4ff01f39d66e65ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4ff01f39d66e65ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4ff01f39d66e65ad$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8pdcq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $iIL7u.useTrackedRef)(analyticsData);
    var fnRef = (0, $iIL7u.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $4ff01f39d66e65ad$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("eKFRo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abd5d5219f22939f$export$2e2bcd8739ae039; });

var $l5tmK = parcelRequire("l5tmK");
function $abd5d5219f22939f$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $l5tmK.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("l5tmK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5a0d815a19d594e$export$2e2bcd8739ae039; });

var $5xjzf = parcelRequire("5xjzf");

var $5PT6r = parcelRequire("5PT6r");
function $f5a0d815a19d594e$export$2e2bcd8739ae039(t) {
    var i = (0, $5PT6r.default)(t, "string");
    return "symbol" == (0, $5xjzf.default)(i) ? i : i + "";
}

});
parcelRegister("5xjzf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $407f3680b0f0944d$export$2e2bcd8739ae039; });
function $407f3680b0f0944d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $407f3680b0f0944d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $407f3680b0f0944d$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5PT6r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43fc7570722e10bb$export$2e2bcd8739ae039; });

var $5xjzf = parcelRequire("5xjzf");
function $43fc7570722e10bb$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5xjzf.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5xjzf.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("8pdcq", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $61eae5a2d2886854$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $7fEpr = parcelRequire("7fEpr");

var $33Y75 = parcelRequire("33Y75");
function $61eae5a2d2886854$export$5bf35293e545f20c() {
    var analyticsContext = (0, $33Y75.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $7fEpr.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("7fEpr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54794797ffef91fd$export$2e2bcd8739ae039; });

var $iwkI2 = parcelRequire("iwkI2");

var $lyawF = parcelRequire("lyawF");

var $dgt68 = parcelRequire("dgt68");

var $ixuga = parcelRequire("ixuga");

var $hqZvY = parcelRequire("hqZvY");

var $iB68L = parcelRequire("iB68L");

var $kUu2a = parcelRequire("kUu2a");

var $eKFRo = parcelRequire("eKFRo");

var $lKYHc = parcelRequire("lKYHc");
function $54794797ffef91fd$var$_callSuper(t, o, e) {
    return o = (0, $hqZvY.default)(o), (0, $ixuga.default)(t, $54794797ffef91fd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hqZvY.default)(t).constructor) : o.apply(t, e));
}
function $54794797ffef91fd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($54794797ffef91fd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $54794797ffef91fd$var$_superPropGet(t, o, e, r) {
    var p = (0, $iB68L.default)((0, $hqZvY.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $54794797ffef91fd$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $54794797ffef91fd$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $54794797ffef91fd$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $lyawF.default)(this, UIAnalyticsEvent);
        _this = $54794797ffef91fd$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $eKFRo.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $eKFRo.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $iwkI2.default)(_this.context);
            var handlers = (0, $iwkI2.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $eKFRo.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $kUu2a.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $dgt68.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $54794797ffef91fd$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $lKYHc.default));

});
parcelRegister("iwkI2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7bb479864bd0a9e$export$2e2bcd8739ae039; });

var $dVDok = parcelRequire("dVDok");

var $2rkuz = parcelRequire("2rkuz");

var $eDzZU = parcelRequire("eDzZU");

var $2C1dc = parcelRequire("2C1dc");
function $d7bb479864bd0a9e$export$2e2bcd8739ae039(r) {
    return (0, $dVDok.default)(r) || (0, $2rkuz.default)(r) || (0, $eDzZU.default)(r) || (0, $2C1dc.default)();
}

});
parcelRegister("dVDok", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a23f27872d209b9e$export$2e2bcd8739ae039; });

var $fRZgQ = parcelRequire("fRZgQ");
function $a23f27872d209b9e$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $fRZgQ.default)(r);
}

});

parcelRegister("2rkuz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c6dffac32ccb490$export$2e2bcd8739ae039; });
function $1c6dffac32ccb490$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("2C1dc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e70120a9e1d9b04$export$2e2bcd8739ae039; });
function $1e70120a9e1d9b04$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("lyawF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb04f02f151e020b$export$2e2bcd8739ae039; });
function $fb04f02f151e020b$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("dgt68", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a835736a80feed7$export$2e2bcd8739ae039; });

var $l5tmK = parcelRequire("l5tmK");
function $9a835736a80feed7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $l5tmK.default)(o.key), o);
    }
}
function $9a835736a80feed7$export$2e2bcd8739ae039(e, r, t) {
    return r && $9a835736a80feed7$var$_defineProperties(e.prototype, r), t && $9a835736a80feed7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("ixuga", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7f2c80a33985703$export$2e2bcd8739ae039; });

var $5xjzf = parcelRequire("5xjzf");

var $gmDtx = parcelRequire("gmDtx");
function $d7f2c80a33985703$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5xjzf.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $gmDtx.default)(t);
}

});
parcelRegister("gmDtx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be9d5267d9b51ce5$export$2e2bcd8739ae039; });
function $be9d5267d9b51ce5$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("hqZvY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb1494e65cc3b615$export$2e2bcd8739ae039; });
function $cb1494e65cc3b615$export$2e2bcd8739ae039(t) {
    return $cb1494e65cc3b615$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $cb1494e65cc3b615$export$2e2bcd8739ae039(t);
}

});

parcelRegister("iB68L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8a0720de88d52f9$export$2e2bcd8739ae039; });

var $5bTRU = parcelRequire("5bTRU");
function $d8a0720de88d52f9$export$2e2bcd8739ae039() {
    return $d8a0720de88d52f9$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $5bTRU.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $d8a0720de88d52f9$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("5bTRU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c79512aeeed85ab$export$2e2bcd8739ae039; });

var $hqZvY = parcelRequire("hqZvY");
function $3c79512aeeed85ab$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $hqZvY.default)(t)););
    return t;
}

});


parcelRegister("kUu2a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f39055b4d239c908$export$2e2bcd8739ae039; });

var $fJ5tq = parcelRequire("fJ5tq");
function $f39055b4d239c908$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $fJ5tq.default)(t, e);
}

});
parcelRegister("fJ5tq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b72f4df23375338c$export$2e2bcd8739ae039; });
function $b72f4df23375338c$export$2e2bcd8739ae039(t, e) {
    return $b72f4df23375338c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b72f4df23375338c$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("lKYHc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd6cf9c80b137588$export$2e2bcd8739ae039; });

var $5xjzf = parcelRequire("5xjzf");

var $lyawF = parcelRequire("lyawF");

var $dgt68 = parcelRequire("dgt68");

var $eKFRo = parcelRequire("eKFRo");
function $fd6cf9c80b137588$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd6cf9c80b137588$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd6cf9c80b137588$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd6cf9c80b137588$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fd6cf9c80b137588$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $fd6cf9c80b137588$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $fd6cf9c80b137588$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $lyawF.default)(this, AnalyticsEvent);
        (0, $eKFRo.default)(this, "_isAnalyticsEvent", true);
        (0, $eKFRo.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $fd6cf9c80b137588$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $dgt68.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $5xjzf.default)(updater) === "object") this.payload = $fd6cf9c80b137588$var$_objectSpread($fd6cf9c80b137588$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("33Y75", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $23b0482b2ecfc0b0$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $23b0482b2ecfc0b0$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("iIL7u", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $da10e31341106f93$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $da10e31341106f93$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("jiOHx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0d706fd803c9bff$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $e0d706fd803c9bff$export$2e2bcd8739ae039() {}

});

parcelRegister("gZthg", function(module, exports) {

$parcel$export(module.exports, "ASC", function () { return $c5e90dc32ec91bf6$export$1dee026a19752d6b; });
$parcel$export(module.exports, "DESC", function () { return $c5e90dc32ec91bf6$export$b6abcf7fa1d94f65; });
$parcel$export(module.exports, "SMALL", function () { return $c5e90dc32ec91bf6$export$71dd4c8ecd45e95f; });
$parcel$export(module.exports, "LARGE", function () { return $c5e90dc32ec91bf6$export$7b93a10c0fefe3e3; });
$parcel$export(module.exports, "LOADING_CONTENTS_OPACITY", function () { return $c5e90dc32ec91bf6$export$3843c586a90b9cbf; });
var $c5e90dc32ec91bf6$export$1dee026a19752d6b = "ASC";
var $c5e90dc32ec91bf6$export$b6abcf7fa1d94f65 = "DESC";
var $c5e90dc32ec91bf6$export$71dd4c8ecd45e95f = "small";
var $c5e90dc32ec91bf6$export$7b93a10c0fefe3e3 = "large";
var $c5e90dc32ec91bf6$export$3843c586a90b9cbf = 0.22;

});

parcelRegister("8n6Ta", function(module, exports) {

$parcel$export(module.exports, "getPageRows", function () { return $6185d0ab7032f5c1$export$3987dc24b734dcab; });
$parcel$export(module.exports, "assertIsSortable", function () { return $6185d0ab7032f5c1$export$5eb35a4771ec4090; });
$parcel$export(module.exports, "validateSortKey", function () { return $6185d0ab7032f5c1$export$9133f5a8bfe8a200; });
$parcel$export(module.exports, "inlineStylesIfRanking", function () { return $6185d0ab7032f5c1$export$a601f1775e10043f; });

var $lgwoD = parcelRequire("lgwoD");
var $6185d0ab7032f5c1$export$3987dc24b734dcab = function getPageRows(allRows, pageNumber, rowsPerPage) {
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
var $6185d0ab7032f5c1$export$5eb35a4771ec4090 = function assertIsSortable(head) {
    if (!head || !head.cells) return;
    head.cells.forEach(function(cell) {
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
var $6185d0ab7032f5c1$export$9133f5a8bfe8a200 = function validateSortKey(sortKey, head) {
    if (!sortKey) return;
    var headHasKey = head && head.cells.map(function(cell) {
        return cell.key;
    }).includes(sortKey);
    if (!headHasKey) try {
        throw Error("Cell with ".concat(sortKey, " key not found in head."));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
var $6185d0ab7032f5c1$export$a601f1775e10043f = function inlineStylesIfRanking(isRanking, width, height) {
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
var $6185d0ab7032f5c1$export$92bcb1ed38b134a1 = function computeIndex(index, page, rowsPerPage) {
    var itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
var $6185d0ab7032f5c1$export$c476bbe5da59992d = function reorderRows(rankEnd, rows) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var rowsPerPage = arguments.length > 3 ? arguments[3] : undefined;
    var destination = rankEnd.destination, sourceIndex = rankEnd.sourceIndex;
    if (!destination) return rows;
    var fromIndex = $6185d0ab7032f5c1$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    var toIndex = $6185d0ab7032f5c1$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    var reordered = rows.slice();
    var _reordered$splice = reordered.splice(fromIndex, 1), _reordered$splice2 = (0, $lgwoD.default)(_reordered$splice, 1), removed = _reordered$splice2[0];
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("2s5kv", function(module, exports) {

$parcel$export(module.exports, "Table", function () { return $1c9254a9f3cc7285$export$54ec01a60f47d33d; });
$parcel$export(module.exports, "Caption", function () { return $1c9254a9f3cc7285$export$32fbfacc5d962e0c; });
$parcel$export(module.exports, "PaginationWrapper", function () { return $1c9254a9f3cc7285$export$3e5e12dc01f20a43; });
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7wyUQ = parcelRequire("7wyUQ");

var $eKFRo = parcelRequire("eKFRo");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");
var $cRJ4t = parcelRequire("cRJ4t");

var $cvWPm = parcelRequire("cvWPm");
var $1c9254a9f3cc7285$var$_excluded = [
    "isFixedSize",
    "hasDataRow",
    "children",
    "testId",
    "isLoading"
];
function $1c9254a9f3cc7285$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c9254a9f3cc7285$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c9254a9f3cc7285$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c9254a9f3cc7285$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1c9254a9f3cc7285$var$fixedSizeTableStyles = null;
var $1c9254a9f3cc7285$var$tableStyles = null;
var $1c9254a9f3cc7285$var$bodyBorder = null;
var $1c9254a9f3cc7285$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var isFixedSize = _ref.isFixedSize, hasDataRow = _ref.hasDataRow, children = _ref.children, testId = _ref.testId, isLoading = _ref.isLoading, rest = (0, $cxbbJ.default)(_ref, $1c9254a9f3cc7285$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement("table", (0, $7wyUQ.default)({
        inert: isLoading ? "" : undefined,
        ref: ref
    }, rest, {
        "data-testid": testId && "".concat(testId, "--table"),
        className: (0, $gpt5O.default)([
            "_1bsb1osq _yq5hus1c _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179rralu"
        ]),
        style: $1c9254a9f3cc7285$var$_objectSpread($1c9254a9f3cc7285$var$_objectSpread({}, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            "--local-dynamic-table-hover-bg": "var(--ds-background-neutral-subtle-hovered, ".concat((0, $cvWPm.N10), ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            "--local-dynamic-table-highlighted-bg": "var(--ds-background-selected, ".concat((0, $cvWPm.B50), ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            "--local-dynamic-table-hover-highlighted-bg": "var(--ds-background-selected-hovered, ".concat((0, $cvWPm.B75), ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            "--local-dynamic-table-row-focus-outline": "var(--ds-border-focused, ".concat((0, $cvWPm.B100), ")")
        }), {}, {
            "--_k02y3n": (0, $cRJ4t.default)("2px solid ".concat("var(--ds-border, ".concat((0, $cvWPm.N40), ")")))
        })
    }), children);
});
var $1c9254a9f3cc7285$var$captionStyles = null;
var $1c9254a9f3cc7285$export$32fbfacc5d962e0c = function Caption(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $iSvIT.createElement("caption", {
        className: (0, $gpt5O.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ])
    }, children);
};
var $1c9254a9f3cc7285$var$paginationWrapperStyles = null;
var $1c9254a9f3cc7285$export$3e5e12dc01f20a43 = function PaginationWrapper(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": testId && "".concat(testId, "--pagination--container"),
        className: (0, $gpt5O.default)([
            "_1e0c1txw _1bah1h6o"
        ])
    }, children);
};

});
parcelRegister("gpt5O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf258c589895a998$export$2e2bcd8739ae039; });
const $bf258c589895a998$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $bf258c589895a998$var$ATOMIC_GROUP_LENGTH = 5;
function $bf258c589895a998$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $bf258c589895a998$var$UNDERSCORE_UNICODE ? $bf258c589895a998$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("cRJ4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95dd6570b02f899d$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $95dd6570b02f899d$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("cvWPm", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $91c6032f9912a01b$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $91c6032f9912a01b$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $91c6032f9912a01b$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $91c6032f9912a01b$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $91c6032f9912a01b$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $91c6032f9912a01b$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $91c6032f9912a01b$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $91c6032f9912a01b$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $91c6032f9912a01b$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $91c6032f9912a01b$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $91c6032f9912a01b$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $91c6032f9912a01b$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $91c6032f9912a01b$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $91c6032f9912a01b$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $91c6032f9912a01b$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $91c6032f9912a01b$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N40", function () { return $91c6032f9912a01b$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $91c6032f9912a01b$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $91c6032f9912a01b$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $91c6032f9912a01b$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $91c6032f9912a01b$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N400", function () { return $91c6032f9912a01b$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $91c6032f9912a01b$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $91c6032f9912a01b$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $91c6032f9912a01b$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $91c6032f9912a01b$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $91c6032f9912a01b$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $91c6032f9912a01b$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $91c6032f9912a01b$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "DN400", function () { return $91c6032f9912a01b$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $91c6032f9912a01b$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $91c6032f9912a01b$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $91c6032f9912a01b$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $91c6032f9912a01b$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $91c6032f9912a01b$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $91c6032f9912a01b$export$3d4f271a500072a; });
// Reds
var $91c6032f9912a01b$export$4b84fd0e2c617bd = "#FFEBE6";
var $91c6032f9912a01b$export$b34b069eff244586 = "#FFBDAD";
var $91c6032f9912a01b$export$be802dd0d8b57f35 = "#FF8F73";
var $91c6032f9912a01b$export$60847d42f9da92a6 = "#FF7452";
var $91c6032f9912a01b$export$4a7404f376229999 = "#FF5630";
var $91c6032f9912a01b$export$2010d0fb4295b346 = "#DE350B";
var $91c6032f9912a01b$export$2837b5a1a71d5c02 = "#BF2600";
var $91c6032f9912a01b$export$8d9596b529bbb9cf = "#FFFAE6";
var $91c6032f9912a01b$export$41060a744ab0b7ae = "#FFF0B3";
var $91c6032f9912a01b$export$1cc05bbbf340e559 = "#FFE380";
var $91c6032f9912a01b$export$5aae31392d72caaa = "#FFC400";
var $91c6032f9912a01b$export$c6930421db9fa514 = "#FFAB00";
var $91c6032f9912a01b$export$59619663aa6500fb = "#FF991F";
var $91c6032f9912a01b$export$874739ea9e379ab6 = "#FF8B00";
var $91c6032f9912a01b$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $91c6032f9912a01b$export$69a3bf21b9686c2b = "#ABF5D1";
var $91c6032f9912a01b$export$afbce1382ec95f73 = "#79F2C0";
var $91c6032f9912a01b$export$747d86715d4175de = "#57D9A3";
var $91c6032f9912a01b$export$940e1f69e873f202 = "#36B37E";
var $91c6032f9912a01b$export$a49394138f7b8e85 = "#00875A";
var $91c6032f9912a01b$export$6fa04827ac68a4fb = "#006644";
var $91c6032f9912a01b$export$226de0355ed012f8 = "#DEEBFF";
var $91c6032f9912a01b$export$8c13c2ee36917869 = "#B3D4FF";
var $91c6032f9912a01b$export$ecfc1dff386a3e7a = "#4C9AFF";
var $91c6032f9912a01b$export$215b7063051591f1 = "#2684FF";
var $91c6032f9912a01b$export$e62e8919cca44969 = "#0065FF";
var $91c6032f9912a01b$export$b3de0ae08da2ce64 = "#0052CC";
var $91c6032f9912a01b$export$a6ee3d71bc067634 = "#0747A6";
var $91c6032f9912a01b$export$67f15409e87642a1 = "#669DF1";
var $91c6032f9912a01b$export$f0539dbc42dbb067 = "#8FB8F6";
var $91c6032f9912a01b$export$363e4475840015bb = "#EAE6FF";
var $91c6032f9912a01b$export$4b0a4417ed59760f = "#C0B6F2";
var $91c6032f9912a01b$export$6011520a64d9a187 = "#998DD9";
var $91c6032f9912a01b$export$a7175d4e9206bc80 = "#8777D9";
var $91c6032f9912a01b$export$b48405b95304b5a1 = "#6554C0";
var $91c6032f9912a01b$export$c71e4279dd54a18d = "#5243AA";
var $91c6032f9912a01b$export$147899de772240ec = "#403294";
var $91c6032f9912a01b$export$2cf711fe14c66f06 = "#E6FCFF";
var $91c6032f9912a01b$export$7a8f4d33f6f9772c = "#B3F5FF";
var $91c6032f9912a01b$export$776c9c497ef08533 = "#79E2F2";
var $91c6032f9912a01b$export$69cb3ca10c1e330e = "#00C7E6";
var $91c6032f9912a01b$export$9dc1ef0f3f48059b = "#00B8D9";
var $91c6032f9912a01b$export$7c835c78b6fcdef8 = "#00A3BF";
var $91c6032f9912a01b$export$6036577f95c3877e = "#008DA6";
var $91c6032f9912a01b$export$29a4f05edc054374 = "#FFFFFF";
var $91c6032f9912a01b$export$e655ef011c4aa1a2 = "#FAFBFC";
var $91c6032f9912a01b$export$9fdfb749e33cdf97 = "#F4F5F7";
var $91c6032f9912a01b$export$3e51e8f1440314ba = "#EBECF0";
var $91c6032f9912a01b$export$1ce2d1575d444ceb = "#DFE1E6";
var $91c6032f9912a01b$export$8754fc7e6d8b3000 = "#C1C7D0";
var $91c6032f9912a01b$export$c2e91cbeada39b8b = "#B3BAC5";
var $91c6032f9912a01b$export$5f71e19f3a7ad9de = "#A5ADBA";
var $91c6032f9912a01b$export$eaa8c8a70ac22806 = "#97A0AF";
var $91c6032f9912a01b$export$7c87d337fb91a97d = "#8993A4";
var $91c6032f9912a01b$export$d6447c357493214f = "#7A869A";
var $91c6032f9912a01b$export$f563ee71e9ee74cd = "#6B778C";
var $91c6032f9912a01b$export$e2ef2124cf4024b1 = "#5E6C84";
var $91c6032f9912a01b$export$eece5f492e429f08 = "#505F79";
var $91c6032f9912a01b$export$c39c0fe0f26207ae = "#42526E";
var $91c6032f9912a01b$export$7090862dc3038a9f = "#344563";
var $91c6032f9912a01b$export$ad0bacf983b7ddaa = "#253858";
var $91c6032f9912a01b$export$7d61b15e0da132af = "#172B4D";
var $91c6032f9912a01b$export$fbda843f0a27fe96 = "#091E42";
var $91c6032f9912a01b$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $91c6032f9912a01b$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $91c6032f9912a01b$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $91c6032f9912a01b$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $91c6032f9912a01b$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $91c6032f9912a01b$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $91c6032f9912a01b$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $91c6032f9912a01b$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $91c6032f9912a01b$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $91c6032f9912a01b$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $91c6032f9912a01b$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $91c6032f9912a01b$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $91c6032f9912a01b$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $91c6032f9912a01b$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $91c6032f9912a01b$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $91c6032f9912a01b$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $91c6032f9912a01b$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $91c6032f9912a01b$export$2f6319cf7d736c2a = "#E6EDFA";
var $91c6032f9912a01b$export$95126bc8884d6634 = "#DCE5F5";
var $91c6032f9912a01b$export$8338d8c35d44ff1 = "#CED9EB";
var $91c6032f9912a01b$export$5368d76ae4fbbda7 = "#B8C7E0";
var $91c6032f9912a01b$export$9f0a771d16ec8d36 = "#ABBBD6";
var $91c6032f9912a01b$export$abcf8c38338b4aa5 = "#9FB0CC";
var $91c6032f9912a01b$export$97e81faa16a182c7 = "#8C9CB8";
var $91c6032f9912a01b$export$bfe21c59123ecf33 = "#7988A3";
var $91c6032f9912a01b$export$ee82aa2ea6a1558 = "#67758F";
var $91c6032f9912a01b$export$682927c6ed76be02 = "#56637A";
var $91c6032f9912a01b$export$91fd9994c5be9757 = "#455166";
var $91c6032f9912a01b$export$d281fbfe3cff2df6 = "#3B475C";
var $91c6032f9912a01b$export$3902c91d8b98a753 = "#313D52";
var $91c6032f9912a01b$export$8e8133c1ba5845b5 = "#283447";
var $91c6032f9912a01b$export$33ff357f6620b39 = "#202B3D";
var $91c6032f9912a01b$export$633847cf062b69e0 = "#1B2638";
var $91c6032f9912a01b$export$9776a6e503bdbf76 = "#121A29";
var $91c6032f9912a01b$export$6c813d5160dff5db = "#0E1624";
var $91c6032f9912a01b$export$3d4f271a500072a = "#0D1424";
var $91c6032f9912a01b$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $91c6032f9912a01b$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $91c6032f9912a01b$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $91c6032f9912a01b$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $91c6032f9912a01b$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $91c6032f9912a01b$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $91c6032f9912a01b$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $91c6032f9912a01b$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $91c6032f9912a01b$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $91c6032f9912a01b$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $91c6032f9912a01b$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $91c6032f9912a01b$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $91c6032f9912a01b$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $91c6032f9912a01b$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $91c6032f9912a01b$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $91c6032f9912a01b$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $91c6032f9912a01b$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $91c6032f9912a01b$export$d2adc5dedf09fced = "#292A2E";
var $91c6032f9912a01b$export$f51762073d2bb381 = "#94C748";
var $91c6032f9912a01b$export$95e26d54def96891 = "#B3DF72";

});


parcelRegister("4YOBA", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", function () { return $3a04052be17da112$export$8f45b9407d4090d7; });
$parcel$export(module.exports, "EmptyViewContainer", function () { return $3a04052be17da112$export$381ea436de119582; });
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");
var $3a04052be17da112$var$fixedHeightStyles = null;
var $3a04052be17da112$export$8f45b9407d4090d7 = function EmptyViewWithFixedHeight(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": testId && "".concat(testId, "--empty-view-with-fixed-height"),
        className: (0, $gpt5O.default)([
            "_4t3i1jdh"
        ])
    }, children);
};
var $3a04052be17da112$var$emptyViewContainerStyles = null;
var $3a04052be17da112$export$381ea436de119582 = function EmptyViewContainer(props) {
    var children = props.children, testId = props.testId;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": testId && "".concat(testId, "--empty-view-container"),
        className: (0, $gpt5O.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ])
    }, children);
};

});

parcelRegister("Hg9Pj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08208cceffab02af$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $lyawF = parcelRequire("lyawF");

var $dgt68 = parcelRequire("dgt68");

var $ixuga = parcelRequire("ixuga");

var $hqZvY = parcelRequire("hqZvY");

var $kUu2a = parcelRequire("kUu2a");

var $iSvIT = parcelRequire("iSvIT");

var $98Z7i = parcelRequire("98Z7i");

var $cCKAk = parcelRequire("cCKAk");
function $08208cceffab02af$var$_callSuper(t, o, e) {
    return o = (0, $hqZvY.default)(o), (0, $ixuga.default)(t, $08208cceffab02af$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hqZvY.default)(t).constructor) : o.apply(t, e));
}
function $08208cceffab02af$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($08208cceffab02af$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $08208cceffab02af$var$BodyComponent = /*#__PURE__*/ function(_React$Component) {
    function BodyComponent() {
        (0, $lyawF.default)(this, BodyComponent);
        return $08208cceffab02af$var$_callSuper(this, BodyComponent, arguments);
    }
    (0, $kUu2a.default)(BodyComponent, _React$Component);
    return (0, $dgt68.default)(BodyComponent, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, pageRows = _this$props.pageRows, head = _this$props.head, isFixedSize = _this$props.isFixedSize, highlightedRowIndex = _this$props.highlightedRowIndex, testId = _this$props.testId, forwardedRef = _this$props.forwardedRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("tbody", {
                    "data-testid": testId && "".concat(testId, "--body"),
                    ref: forwardedRef
                }, pageRows.map(function(row, rowIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $cCKAk.default), {
                        head: head,
                        isFixedSize: isFixedSize,
                        key: row.key || rowIndex,
                        row: row,
                        isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === "number" ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                        testId: testId
                    });
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Component);
var $08208cceffab02af$var$Body = (0, $98Z7i.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($08208cceffab02af$var$BodyComponent, (0, $7wyUQ.default)({}, props, {
        forwardedRef: ref
    }));
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$08208cceffab02af$export$2e2bcd8739ae039 = $08208cceffab02af$var$Body;

});
parcelRegister("98Z7i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a8444e984056cdf$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $lyawF = parcelRequire("lyawF");

var $dgt68 = parcelRequire("dgt68");

var $ixuga = parcelRequire("ixuga");

var $hqZvY = parcelRequire("hqZvY");

var $kUu2a = parcelRequire("kUu2a");

var $eKFRo = parcelRequire("eKFRo");

var $5xjzf = parcelRequire("5xjzf");

var $iSvIT = parcelRequire("iSvIT");

var $gZthg = parcelRequire("gZthg");

var $8n6Ta = parcelRequire("8n6Ta");
var $6a8444e984056cdf$var$_excluded = [
    "rows",
    "head",
    "sortKey",
    "sortOrder",
    "rowsPerPage",
    "page",
    "forwardedRef"
];
function $6a8444e984056cdf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6a8444e984056cdf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6a8444e984056cdf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6a8444e984056cdf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6a8444e984056cdf$var$_callSuper(t, o, e) {
    return o = (0, $hqZvY.default)(o), (0, $ixuga.default)(t, $6a8444e984056cdf$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hqZvY.default)(t).constructor) : o.apply(t, e));
}
function $6a8444e984056cdf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6a8444e984056cdf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $6a8444e984056cdf$var$getSortingCellValue = function getSortingCellValue(cells, head, sortKey) {
    for(var i = 0; i < cells.length; i++){
        var _head$cells$i;
        if (head.cells[i] && ((_head$cells$i = head.cells[i]) === null || _head$cells$i === void 0 ? void 0 : _head$cells$i.key) === sortKey) {
            var _cells$i;
            return (_cells$i = cells[i]) === null || _cells$i === void 0 ? void 0 : _cells$i.key;
        }
    }
    return undefined;
};
// sort all rows based on sort key and order
var $6a8444e984056cdf$var$getSortedRows = function getSortedRows(head, rows, sortKey, sortOrder) {
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    var modifier = sortOrder === (0, $gZthg.ASC) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    var collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: "accent"
    });
    // Get copy of rows to avoid sorting prop in place
    var sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort(function(a, b) {
        var valA = $6a8444e984056cdf$var$getSortingCellValue(a.cells, head, sortKey);
        var valB = $6a8444e984056cdf$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if ((0, $5xjzf.default)(valA) !== (0, $5xjzf.default)(valB)) {
            // numbers are always grouped higher in the sort
            if (typeof valA === "number") return -1;
            if (typeof valB === "number") return 1;
            // strings are grouped next
            if (typeof valA === "string") return -1;
            if (typeof valB === "string") return 1;
        }
        if (typeof valA === "string" && typeof valB === "string") return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $6a8444e984056cdf$export$2e2bcd8739ae039(WrappedComponent) {
    var WithSortedPageRows = /*#__PURE__*/ function(_React$Component) {
        function WithSortedPageRows() {
            var _this;
            (0, $lyawF.default)(this, WithSortedPageRows);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $6a8444e984056cdf$var$_callSuper(this, WithSortedPageRows, [].concat(args));
            (0, $eKFRo.default)(_this, "state", {
                pageRows: []
            });
            return _this;
        }
        (0, $kUu2a.default)(WithSortedPageRows, _React$Component);
        return (0, $dgt68.default)(WithSortedPageRows, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(_prevProps, prevState) {
                    if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, rows = _this$props.rows, head = _this$props.head, sortKey = _this$props.sortKey, sortOrder = _this$props.sortOrder, rowsPerPage = _this$props.rowsPerPage, page = _this$props.page, forwardedRef = _this$props.forwardedRef, restProps = (0, $cxbbJ.default)(_this$props, $6a8444e984056cdf$var$_excluded);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(WrappedComponent, (0, $7wyUQ.default)({
                        pageRows: this.state.pageRows,
                        head: head
                    }, restProps, {
                        ref: forwardedRef
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(props, state) {
                    var rows = props.rows, head = props.head, sortKey = props.sortKey, sortOrder = props.sortOrder, page = props.page, rowsPerPage = props.rowsPerPage, isTotalPagesControlledExternally = props.isTotalPagesControlledExternally;
                    (0, $8n6Ta.validateSortKey)(sortKey, head);
                    var sortedRows;
                    var pageRows;
                    if (isTotalPagesControlledExternally) {
                        sortedRows = rows;
                        pageRows = rows;
                    } else {
                        sortedRows = $6a8444e984056cdf$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                        pageRows = (0, $8n6Ta.getPageRows)(sortedRows, page, rowsPerPage);
                    }
                    return $6a8444e984056cdf$var$_objectSpread($6a8444e984056cdf$var$_objectSpread({}, state), {}, {
                        pageRows: pageRows
                    });
                }
            }
        ]);
    }((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Component);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(WithSortedPageRows, (0, $7wyUQ.default)({}, props, {
            forwardedRef: ref
        }));
    });
}

});

parcelRegister("cCKAk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $930d2b70f4c4f2a7$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $aCD05 = parcelRequire("aCD05");

var $iZ2AQ = parcelRequire("iZ2AQ");
var $930d2b70f4c4f2a7$var$_excluded = [
    "cells"
], $930d2b70f4c4f2a7$var$_excluded2 = [
    "content",
    "testId"
];
var $930d2b70f4c4f2a7$var$Row = function Row(_ref) {
    var row = _ref.row, head = _ref.head, testId = _ref.testId, isFixedSize = _ref.isFixedSize, isHighlighted = _ref.isHighlighted;
    var cells = row.cells, restRowProps = (0, $cxbbJ.default)(row, $930d2b70f4c4f2a7$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iZ2AQ.TableBodyRow), (0, $7wyUQ.default)({}, restRowProps, {
        isHighlighted: isHighlighted
    }, isHighlighted ? {
        "data-ts--dynamic-table--table-row--highlighted": true
    } : null, {
        testId: row.testId || testId && "".concat(testId, "--row-").concat(restRowProps.key)
    }), cells.map(function(cell, cellIndex) {
        var content = cell.content, cellTestId = cell.testId, restCellProps = (0, $cxbbJ.default)(cell, $930d2b70f4c4f2a7$var$_excluded2);
        var _ref2 = (head || {
            cells: []
        }).cells[cellIndex] || {}, shouldTruncate = _ref2.shouldTruncate, width = _ref2.width;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $aCD05.TableBodyCell), (0, $7wyUQ.default)({
            "data-testid": cellTestId || testId && "".concat(testId, "--cell-").concat(cellIndex)
        }, restCellProps, {
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }), content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$930d2b70f4c4f2a7$export$2e2bcd8739ae039 = $930d2b70f4c4f2a7$var$Row;

});
parcelRegister("aCD05", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", function () { return $7bbbb4a32ff84c5e$export$948e91fcef170792; });
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");

var $jSrVq = parcelRequire("jSrVq");
var $7bbbb4a32ff84c5e$var$_excluded = [
    "width",
    "isFixedSize",
    "shouldTruncate",
    "innerRef"
];
var $7bbbb4a32ff84c5e$var$fixedSizeTruncateStyles = null;
var $7bbbb4a32ff84c5e$var$overflowTruncateStyles = null;
var $7bbbb4a32ff84c5e$var$truncationWidthStyles = null;
var $7bbbb4a32ff84c5e$var$cellStyles = null;
var $7bbbb4a32ff84c5e$export$948e91fcef170792 = function TableBodyCell(_ref) {
    var width = _ref.width, isFixedSize = _ref.isFixedSize, shouldTruncate = _ref.shouldTruncate, innerRef = _ref.innerRef, props = (0, $cxbbJ.default)(_ref, $7bbbb4a32ff84c5e$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement("td", (0, $7wyUQ.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $jSrVq.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        className: (0, $gpt5O.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ])
    }, props));
};

});
parcelRegister("jSrVq", function(module, exports) {

$parcel$export(module.exports, "getTruncationStyleVars", function () { return $e788b8d6348468de$export$5e6497a652ae30b5; });

var $eKFRo = parcelRequire("eKFRo");
var $e788b8d6348468de$var$CSS_VAR_WIDTH = "--local-dynamic-table-width";
var $e788b8d6348468de$export$5e6497a652ae30b5 = function getTruncationStyleVars(_ref) {
    var width = _ref.width;
    return typeof width !== "undefined" ? (0, $eKFRo.default)({}, $e788b8d6348468de$var$CSS_VAR_WIDTH, "".concat(width, "%")) : undefined;
};

});


parcelRegister("iZ2AQ", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", function () { return $dd1fef7994d99ccb$export$45f39d9c38b886d5; });
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7wyUQ = parcelRequire("7wyUQ");

var $eKFRo = parcelRequire("eKFRo");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");
var $cRJ4t = parcelRequire("cRJ4t");
var $dd1fef7994d99ccb$var$_excluded = [
    "isHighlighted",
    "children",
    "style",
    "testId",
    "className"
];
function $dd1fef7994d99ccb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd1fef7994d99ccb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd1fef7994d99ccb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd1fef7994d99ccb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dd1fef7994d99ccb$var$rowStyles = null;
var $dd1fef7994d99ccb$var$rowBackgroundStyles = null;
var $dd1fef7994d99ccb$var$rowHighlightedBackgroundStyles = null;
var $dd1fef7994d99ccb$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var isHighlighted = _ref.isHighlighted, children = _ref.children, style = _ref.style, testId = _ref.testId, className = _ref.className, rest = (0, $cxbbJ.default)(_ref, $dd1fef7994d99ccb$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement("tr", (0, $7wyUQ.default)({
        /**
     * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
     * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gpt5O.default)([
            "_bfhkqtfy _1ygb1852 _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ])
    }, rest, {
        ref: ref,
        "data-testid": testId,
        style: $dd1fef7994d99ccb$var$_objectSpread($dd1fef7994d99ccb$var$_objectSpread({}, style), {}, {
            "--_akp1ox": (0, $cRJ4t.default)("2px solid ".concat("var(--ds-border-focused, var(--local-dynamic-table-hover-bg))"))
        })
    }), children);
});

});



parcelRegister("cWQsB", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", function () { return $96d398545d653ea3$export$e926676385687eaf; });

var $lyawF = parcelRequire("lyawF");

var $dgt68 = parcelRequire("dgt68");

var $ixuga = parcelRequire("ixuga");

var $hqZvY = parcelRequire("hqZvY");

var $kUu2a = parcelRequire("kUu2a");

var $iSvIT = parcelRequire("iSvIT");
function $96d398545d653ea3$var$_callSuper(t, o, e) {
    return o = (0, $hqZvY.default)(o), (0, $ixuga.default)(t, $96d398545d653ea3$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hqZvY.default)(t).constructor) : o.apply(t, e));
}
function $96d398545d653ea3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($96d398545d653ea3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $96d398545d653ea3$export$e926676385687eaf = /*#__PURE__*/ function(_React$Component) {
    function ErrorBoundary(props) {
        var _this;
        (0, $lyawF.default)(this, ErrorBoundary);
        _this = $96d398545d653ea3$var$_callSuper(this, ErrorBoundary, [
            props
        ]);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    (0, $kUu2a.default)(ErrorBoundary, _React$Component);
    return (0, $dgt68.default)(ErrorBoundary, [
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) // You can render any custom fallback UI
                return this.props.fallback;
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                // Update state so the next render will show the fallback UI.
                return {
                    hasError: true
                };
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Component);

});

parcelRegister("Jdsr1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $087ea47d0bfb3b7b$export$2e2bcd8739ae039; });

var $lyawF = parcelRequire("lyawF");

var $dgt68 = parcelRequire("dgt68");

var $ixuga = parcelRequire("ixuga");

var $hqZvY = parcelRequire("hqZvY");

var $kUu2a = parcelRequire("kUu2a");

var $eKFRo = parcelRequire("eKFRo");

var $iSvIT = parcelRequire("iSvIT");

var $ihlDi = parcelRequire("ihlDi");

var $gZthg = parcelRequire("gZthg");

var $1mA2n = parcelRequire("1mA2n");
function $087ea47d0bfb3b7b$var$_callSuper(t, o, e) {
    return o = (0, $hqZvY.default)(o), (0, $ixuga.default)(t, $087ea47d0bfb3b7b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hqZvY.default)(t).constructor) : o.apply(t, e));
}
function $087ea47d0bfb3b7b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($087ea47d0bfb3b7b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $087ea47d0bfb3b7b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function LoadingContainer() {
        (0, $lyawF.default)(this, LoadingContainer);
        return $087ea47d0bfb3b7b$var$_callSuper(this, LoadingContainer, arguments);
    }
    (0, $kUu2a.default)(LoadingContainer, _React$Component);
    return (0, $dgt68.default)(LoadingContainer, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, isLoading = _this$props.isLoading, spinnerSize = _this$props.spinnerSize, contentsOpacity = _this$props.contentsOpacity, testId = _this$props.testId, loadingLabel = _this$props.loadingLabel;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1mA2n.Container), {
                    testId: testId
                }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1mA2n.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId
                }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1mA2n.SpinnerContainer), {
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ihlDi.default), {
                    size: spinnerSize,
                    testId: testId && "".concat(testId, "--loadingSpinner"),
                    label: loadingLabel
                })));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Component);
(0, $eKFRo.default)($087ea47d0bfb3b7b$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: (0, $gZthg.LARGE),
    contentsOpacity: (0, $gZthg.LOADING_CONTENTS_OPACITY),
    loadingLabel: "Loading table"
});

});
parcelRegister("ihlDi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4ea98579be6df7c$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gpt5O = parcelRequire("gpt5O");

var $iSvIT = parcelRequire("iSvIT");

var $7nG8r = parcelRequire("7nG8r");

var $cvWPm = parcelRequire("cvWPm");

var $aqrXL = parcelRequire("aqrXL");
/**
 * Returns the appropriate circle stroke color.
 */ function $d4ea98579be6df7c$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $cvWPm.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $cvWPm.N0), ")");
}
var $d4ea98579be6df7c$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $d4ea98579be6df7c$var$loadIn = null;
var $d4ea98579be6df7c$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $d4ea98579be6df7c$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $d4ea98579be6df7c$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $aqrXL.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $d4ea98579be6df7c$var$getStrokeColor(appearance);
    var context = (0, $iSvIT.useContext)((0, $7nG8r.default));
    $d4ea98579be6df7c$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $gpt5O.default)([
            $d4ea98579be6df7c$var$styles.wrapperStyles,
            $d4ea98579be6df7c$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $gpt5O.default)([
            $d4ea98579be6df7c$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $gpt5O.default)([
            $d4ea98579be6df7c$var$styles.circleStyles
        ])
    })));
}));
var $d4ea98579be6df7c$export$2e2bcd8739ae039 = $d4ea98579be6df7c$var$Spinner;

});
parcelRegister("aqrXL", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $797205f1b2cf2190$export$4e9f1640bbe7a1a8; });
var $797205f1b2cf2190$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("1mA2n", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $0fe3ccc6a8cdf2a2$export$42a852a2b6b56249; });
$parcel$export(module.exports, "ContentsContainer", function () { return $0fe3ccc6a8cdf2a2$export$67c29eae8ae2137a; });
$parcel$export(module.exports, "SpinnerContainer", function () { return $0fe3ccc6a8cdf2a2$export$a5e06607a5ac6158; });
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eKFRo = parcelRequire("eKFRo");

var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");
var $cRJ4t = parcelRequire("cRJ4t");
function $0fe3ccc6a8cdf2a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0fe3ccc6a8cdf2a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0fe3ccc6a8cdf2a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0fe3ccc6a8cdf2a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0fe3ccc6a8cdf2a2$export$c335a80381ec61f5 = "--contents-opacity";
var $0fe3ccc6a8cdf2a2$var$containerStyles = null;
var $0fe3ccc6a8cdf2a2$export$42a852a2b6b56249 = function Container(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": testId && "".concat(testId, "--container"),
        className: (0, $gpt5O.default)([
            "_kqswh2mm"
        ])
    }, children);
};
var $0fe3ccc6a8cdf2a2$var$contentsContainerStyles = null;
var $0fe3ccc6a8cdf2a2$export$67c29eae8ae2137a = function ContentsContainer(_ref2) {
    var children = _ref2.children, contentsOpacity = _ref2.contentsOpacity, testId = _ref2.testId;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": testId && "".concat(testId, "--contents--container"),
        className: (0, $gpt5O.default)([
            "_tzy47hfw _lcxvglyw"
        ]),
        style: $0fe3ccc6a8cdf2a2$var$_objectSpread($0fe3ccc6a8cdf2a2$var$_objectSpread({}, (0, $eKFRo.default)({}, $0fe3ccc6a8cdf2a2$export$c335a80381ec61f5, contentsOpacity)), {}, {
            "--_cnddr8": (0, $cRJ4t.default)("var(".concat($0fe3ccc6a8cdf2a2$export$c335a80381ec61f5, ")"))
        })
    }, children);
};
var $0fe3ccc6a8cdf2a2$var$spinnerContainerStyles = null;
var $0fe3ccc6a8cdf2a2$export$a5e06607a5ac6158 = function SpinnerContainer(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": testId && "".concat(testId, "--spinner--container"),
        className: (0, $gpt5O.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ])
    }, children);
};

});


parcelRegister("lNmzm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fddfae62cde11ad4$export$2e2bcd8739ae039; });

var $5xjzf = parcelRequire("5xjzf");

var $lyawF = parcelRequire("lyawF");

var $dgt68 = parcelRequire("dgt68");

var $ixuga = parcelRequire("ixuga");

var $hqZvY = parcelRequire("hqZvY");

var $kUu2a = parcelRequire("kUu2a");

var $eKFRo = parcelRequire("eKFRo");

var $iSvIT = parcelRequire("iSvIT");

var $ihlDi = parcelRequire("ihlDi");

var $gZthg = parcelRequire("gZthg");

var $6wsH7 = parcelRequire("6wsH7");
function $fddfae62cde11ad4$var$_callSuper(t, o, e) {
    return o = (0, $hqZvY.default)(o), (0, $ixuga.default)(t, $fddfae62cde11ad4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hqZvY.default)(t).constructor) : o.apply(t, e));
}
function $fddfae62cde11ad4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fddfae62cde11ad4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $fddfae62cde11ad4$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function LoadingContainerAdvanced() {
        var _this;
        (0, $lyawF.default)(this, LoadingContainerAdvanced);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $fddfae62cde11ad4$var$_callSuper(this, LoadingContainerAdvanced, [].concat(args));
        (0, $eKFRo.default)(_this, "spinnerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createRef());
        (0, $eKFRo.default)(_this, "containerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createRef());
        (0, $eKFRo.default)(_this, "componentDidMount", function() {
            if (_this.props.isLoading && _this.hasTargetNode()) {
                _this.attachListeners();
                _this.updateTargetAppearance();
                _this.updateSpinnerPosition();
            }
        });
        (0, $eKFRo.default)(_this, "UNSAFE_componentWillReceiveProps", function(nextProps) {
            if (!nextProps.isLoading || !_this.hasTargetNode(nextProps)) _this.detachListeners();
            else if (!_this.props.isLoading) _this.attachListeners();
        });
        (0, $eKFRo.default)(_this, "componentDidUpdate", function() {
            if (_this.hasTargetNode()) {
                _this.updateTargetAppearance();
                if (_this.props.isLoading) _this.updateSpinnerPosition();
            }
        });
        (0, $eKFRo.default)(_this, "componentWillUnmount", function() {
            _this.detachListeners();
        });
        (0, $eKFRo.default)(_this, "getTargetNode", function() {
            var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            var targetRef = nextProps.targetRef;
            var target = targetRef === null || targetRef === void 0 ? void 0 : targetRef();
            return target || _this.containerRef.current;
        });
        (0, $eKFRo.default)(_this, "hasTargetNode", function(nextProps) {
            return !!_this.getTargetNode(nextProps);
        });
        (0, $eKFRo.default)(_this, "isVerticallyVisible", function(elementRect, viewportHeight) {
            var top = elementRect.top, bottom = elementRect.bottom;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        });
        (0, $eKFRo.default)(_this, "isFullyVerticallyVisible", function(elementRect, viewportHeight) {
            var top = elementRect.top, bottom = elementRect.bottom;
            return top >= 0 && bottom <= viewportHeight;
        });
        (0, $eKFRo.default)(_this, "handleResize", function() {
            _this.updateSpinnerPosition();
        });
        (0, $eKFRo.default)(_this, "handleScroll", function() {
            _this.updateSpinnerPosition();
        });
        (0, $eKFRo.default)(_this, "translateSpinner", function(spinnerNode, transformY, isFixed) {
            spinnerNode.style.position = isFixed ? "fixed" : "";
            spinnerNode.style.transform = transformY !== 0 ? "translate3d(0, ".concat(transformY, "px, 0)") : "";
        });
        (0, $eKFRo.default)(_this, "updateTargetAppearance", function() {
            var targetNode = _this.getTargetNode();
            var _this$props = _this.props, isLoading = _this$props.isLoading, contentsOpacity = _this$props.contentsOpacity;
            if (targetNode && targetNode.style && (0, $5xjzf.default)(targetNode.style) === "object") {
                targetNode.style.pointerEvents = isLoading ? "none" : "";
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : "";
            }
        });
        return _this;
    }
    (0, $kUu2a.default)(LoadingContainerAdvanced, _React$Component);
    return (0, $dgt68.default)(LoadingContainerAdvanced, [
        {
            key: "attachListeners",
            value: function attachListeners() {
                window.addEventListener("scroll", this.handleScroll);
                window.addEventListener("resize", this.handleResize);
            }
        },
        {
            key: "detachListeners",
            value: function detachListeners() {
                window.removeEventListener("scroll", this.handleScroll);
                window.removeEventListener("resize", this.handleResize);
            }
        },
        {
            key: "updateSpinnerPosition",
            value: function updateSpinnerPosition() {
                var _this$spinnerRef, _this$containerRef;
                var viewportHeight = window.innerHeight;
                var targetNode = this.getTargetNode();
                var spinnerNode = (_this$spinnerRef = this.spinnerRef) === null || _this$spinnerRef === void 0 ? void 0 : _this$spinnerRef.current;
                if (!targetNode || typeof targetNode.getBoundingClientRect !== "function" || !spinnerNode) return;
                var targetRect = targetNode.getBoundingClientRect();
                var spinnerRect = spinnerNode.getBoundingClientRect();
                var spinnerHeight = spinnerRect.height;
                var isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
                var top = targetRect.top, bottom = targetRect.bottom, height = targetRect.height;
                if (isInViewport) {
                    // The spinner may follow the element only if there is enough space:
                    // Let's say the element can fit at least three spinners (vertically)
                    var canFollow = height >= spinnerHeight * 3;
                    if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                        if (top >= 0) {
                            // Only the head of the element is visible
                            var viewportSpaceTakenByElement = viewportHeight - top;
                            var diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                            var y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                            this.translateSpinner(spinnerNode, y, true);
                        } else if (top < 0 && bottom > viewportHeight) {
                            // The element takes all viewport, nor its head nor tail are visible
                            var _y = viewportHeight / 2 - spinnerHeight / 2;
                            this.translateSpinner(spinnerNode, _y, true);
                        } else {
                            // Only the tail of the element is visible
                            var _diff = bottom / 2 - spinnerHeight / 2;
                            var _y2 = _diff < spinnerHeight ? _diff - (spinnerHeight - _diff) : _diff;
                            this.translateSpinner(spinnerNode, _y2, true);
                        }
                        return;
                    }
                } else {
                    // If both the element and the spinner are off screen - quit
                    if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
                }
                // Three options here:
                // 1) the element is fully visible
                // 2) the element is too small for the spinner to follow
                // 3) the spinner might still be visible while the element isn't
                var containerNode = (_this$containerRef = this.containerRef) === null || _this$containerRef === void 0 ? void 0 : _this$containerRef.current;
                if (containerNode && typeof containerNode.getBoundingClientRect === "function") {
                    var thisTop = containerNode.getBoundingClientRect().top;
                    var _y3 = (top - thisTop) / 2;
                    this.translateSpinner(spinnerNode, _y3, false);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, isLoading = _this$props2.isLoading, spinnerSize = _this$props2.spinnerSize, testId = _this$props2.testId, loadingLabel = _this$props2.loadingLabel;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6wsH7.Container), {
                    testId: testId && "".concat(testId, "--loading--container--advanced"),
                    ref: this.containerRef
                }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6wsH7.SpinnerBackdrop), {
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6wsH7.SpinnerContainer), {
                    ref: this.spinnerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ihlDi.default), {
                    size: spinnerSize,
                    testId: testId && "".concat(testId, "--loadingSpinner"),
                    label: loadingLabel
                }))));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Component);
(0, $eKFRo.default)($fddfae62cde11ad4$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: (0, $gZthg.LARGE),
    contentsOpacity: "var(--ds-opacity-loading, ".concat("".concat((0, $gZthg.LOADING_CONTENTS_OPACITY)), ")"),
    loadingLabel: "Loading table"
});

});
parcelRegister("6wsH7", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $4bfbfd55c0edca46$export$42a852a2b6b56249; });
$parcel$export(module.exports, "SpinnerBackdrop", function () { return $4bfbfd55c0edca46$export$aa207050321b0c53; });
$parcel$export(module.exports, "SpinnerContainer", function () { return $4bfbfd55c0edca46$export$a5e06607a5ac6158; });
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");
var $4bfbfd55c0edca46$var$_excluded = [
    "children",
    "testId"
];
var $4bfbfd55c0edca46$var$containerStyles = null;
var $4bfbfd55c0edca46$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var children = props.children, testId = props.testId, rest = (0, $cxbbJ.default)(props, $4bfbfd55c0edca46$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $7wyUQ.default)({}, rest, {
        "data-testid": testId,
        ref: ref,
        className: (0, $gpt5O.default)([
            "_kqswh2mm _6rth1ejb"
        ])
    }), children);
});
var $4bfbfd55c0edca46$var$spinnerBackdropStyles = null;
var $4bfbfd55c0edca46$export$aa207050321b0c53 = function SpinnerBackdrop(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": testId && "".concat(testId, "--spinner-backdrop"),
        className: (0, $gpt5O.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ])
    }, children);
};
var $4bfbfd55c0edca46$var$spinnerContainerStyles = null;
var $4bfbfd55c0edca46$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        ref: ref,
        className: (0, $gpt5O.default)([
            "_kqswh2mm _152tidpf"
        ])
    }, children);
});

});


parcelRegister("5h72J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d7400e102fd2103$export$2e2bcd8739ae039; });

var $iwkI2 = parcelRequire("iwkI2");

var $lyawF = parcelRequire("lyawF");

var $dgt68 = parcelRequire("dgt68");

var $ixuga = parcelRequire("ixuga");

var $hqZvY = parcelRequire("hqZvY");

var $kUu2a = parcelRequire("kUu2a");

var $eKFRo = parcelRequire("eKFRo");

var $iSvIT = parcelRequire("iSvIT");

var $kqJD3 = parcelRequire("kqJD3");
function $3d7400e102fd2103$var$_callSuper(t, o, e) {
    return o = (0, $hqZvY.default)(o), (0, $ixuga.default)(t, $3d7400e102fd2103$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hqZvY.default)(t).constructor) : o.apply(t, e));
}
function $3d7400e102fd2103$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3d7400e102fd2103$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $3d7400e102fd2103$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function ManagedPagination() {
        var _this;
        (0, $lyawF.default)(this, ManagedPagination);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $3d7400e102fd2103$var$_callSuper(this, ManagedPagination, [].concat(args));
        (0, $eKFRo.default)(_this, "onChange", function(_event, newValue, analyticsEvent) {
            _this.props.onChange(newValue, analyticsEvent);
        });
        return _this;
    }
    (0, $kUu2a.default)(ManagedPagination, _React$Component);
    return (0, $dgt68.default)(ManagedPagination, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, total = _this$props.total, _this$props$value = _this$props.value, value = _this$props$value === void 0 ? 1 : _this$props$value, i18n = _this$props.i18n, testId = _this$props.testId, isDisabled = _this$props.isDisabled;
                var pages = (0, $iwkI2.default)(Array(total)).map(function(_, index) {
                    return index + 1;
                });
                // Pagination accepts array now thus selectedIndex starts with 0
                // So, we are substracting value by one thus not breaking dynamic table
                var selectedIndex = value - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $kqJD3.default), {
                    selectedIndex: selectedIndex,
                    isDisabled: isDisabled,
                    label: i18n === null || i18n === void 0 ? void 0 : i18n.label,
                    nextLabel: i18n === null || i18n === void 0 ? void 0 : i18n.next,
                    previousLabel: i18n === null || i18n === void 0 ? void 0 : i18n.prev,
                    pageLabel: i18n === null || i18n === void 0 ? void 0 : i18n.pageLabel,
                    onChange: this.onChange,
                    pages: pages,
                    testId: testId && "".concat(testId, "--pagination")
                });
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Component);

});
parcelRegister("kqJD3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edf9a14e8dbb52b2$export$2e2bcd8739ae039; });
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eKFRo = parcelRequire("eKFRo");

var $lgwoD = parcelRequire("lgwoD");


var $iSvIT = parcelRequire("iSvIT");

var $6RvuE = parcelRequire("6RvuE");

var $jiOHx = parcelRequire("jiOHx");

var $hTjaF = parcelRequire("hTjaF");

var $gSKGP = parcelRequire("gSKGP");

var $igpPr = parcelRequire("igpPr");

var $ksogg = parcelRequire("ksogg");
var $ke1Eq = parcelRequire("ke1Eq");

var $dOrta = parcelRequire("dOrta");

var $eo1l0 = parcelRequire("eo1l0");

var $98SV3 = parcelRequire("98SV3");

var $1HCf5 = parcelRequire("1HCf5");

var $lqUTb = parcelRequire("lqUTb");
function $edf9a14e8dbb52b2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $edf9a14e8dbb52b2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $edf9a14e8dbb52b2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $edf9a14e8dbb52b2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $edf9a14e8dbb52b2$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
var $edf9a14e8dbb52b2$var$analyticsAttributes = {
    componentName: "pagination",
    packageName: "@atlaskit/pagination",
    packageVersion: "16.1.8"
};
function $edf9a14e8dbb52b2$var$NavigatorIcon(_ref) {
    var chevronDirection = _ref.chevronDirection;
    var Chevron = chevronDirection === "left" ? (0, (/*@__PURE__*/$parcel$interopDefault($gSKGP))) : (0, (/*@__PURE__*/$parcel$interopDefault($igpPr)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ksogg.default), {
        as: "span",
        xcss: $edf9a14e8dbb52b2$var$styles.navigatorIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Chevron, {
        label: "",
        LEGACY_margin: "0 ".concat("var(--ds-space-negative-075, -6px)"),
        color: "currentColor",
        size: "small"
    }));
}
function $edf9a14e8dbb52b2$var$InnerPagination(_ref2, ref) {
    var _ref2$components = _ref2.components, components = _ref2$components === void 0 ? (0, $1HCf5.emptyObject) : _ref2$components, _ref2$defaultSelected = _ref2.defaultSelectedIndex, defaultSelectedIndex = _ref2$defaultSelected === void 0 ? 0 : _ref2$defaultSelected, selectedIndex = _ref2.selectedIndex, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "pagination" : _ref2$label, _ref2$pageLabel = _ref2.pageLabel, pageLabel = _ref2$pageLabel === void 0 ? "page" : _ref2$pageLabel, _ref2$previousLabel = _ref2.previousLabel, previousLabel = _ref2$previousLabel === void 0 ? "previous" : _ref2$previousLabel, _ref2$nextLabel = _ref2.nextLabel, nextLabel = _ref2$nextLabel === void 0 ? "next" : _ref2$nextLabel, _ref2$style = _ref2.style, style = _ref2$style === void 0 ? (0, $1HCf5.emptyObject) : _ref2$style, _ref2$max = _ref2.max, max = _ref2$max === void 0 ? 7 : _ref2$max, _ref2$onChange = _ref2.onChange, onChange = _ref2$onChange === void 0 ? (0, $jiOHx.default) : _ref2$onChange, pages = _ref2.pages, getPageLabel = _ref2.getPageLabel, _ref2$renderEllipsis = _ref2.renderEllipsis, renderEllipsis = _ref2$renderEllipsis === void 0 ? (0, $98SV3.default) : _ref2$renderEllipsis, analyticsContext = _ref2.analyticsContext, testId = _ref2.testId, isDisabled = _ref2.isDisabled;
    var _useControlled = (0, $hTjaF.default)(selectedIndex, function() {
        return defaultSelectedIndex || 0;
    }), _useControlled2 = (0, $lgwoD.default)(_useControlled, 2), selectedIndexValue = _useControlled2[0], setSelectedIndexValue = _useControlled2[1];
    var onChangeWithAnalytics = (0, $6RvuE.usePlatformLeafEventHandler)($edf9a14e8dbb52b2$var$_objectSpread({
        fn: function fn(value, analyticsEvent) {
            var event = value.event, selectedPageIndex = value.selectedPageIndex;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: "changed",
        actionSubject: "pageNumber",
        analyticsData: analyticsContext
    }, $edf9a14e8dbb52b2$var$analyticsAttributes));
    var transform = function transform(page, currPageIndex, testId) {
        var selectedPage = pages[selectedIndexValue];
        var pageIndexLabel = "".concat(pageLabel, " ").concat(getPageLabel ? getPageLabel(page, currPageIndex) : page);
        var isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ke1Eq.default), {
            as: "li",
            xcss: $edf9a14e8dbb52b2$var$styles.paginationMenuItem,
            key: "page-".concat(getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eo1l0.default), {
            component: components.Page,
            onClick: function onClick(event) {
                return onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                });
            },
            "aria-current": isCurrentPage ? "page" : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && "".concat(testId, "--").concat(isCurrentPage ? "current-" : "", "page-").concat(currPageIndex)
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ksogg.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ke1Eq.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $dOrta.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: function onClick(event) {
            return onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            });
        },
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($edf9a14e8dbb52b2$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && "".concat(testId, "--left-navigator")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ke1Eq.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $edf9a14e8dbb52b2$var$styles.paginationMenu
    }, (0, $lqUTb.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $dOrta.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: function onClick(event) {
            return onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            });
        },
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($edf9a14e8dbb52b2$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && "".concat(testId, "--right-navigator")
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ var $edf9a14e8dbb52b2$var$Pagination = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)($edf9a14e8dbb52b2$var$InnerPagination));
var $edf9a14e8dbb52b2$export$2e2bcd8739ae039 = $edf9a14e8dbb52b2$var$Pagination;

});
parcelRegister("hTjaF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d06671aeb60b6cf7$export$2e2bcd8739ae039; });

var $lgwoD = parcelRequire("lgwoD");

var $iSvIT = parcelRequire("iSvIT");
function $d06671aeb60b6cf7$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $iSvIT.useState)(getDefaultPropValue), _useState2 = (0, $lgwoD.default)(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $iSvIT.useRef)(isControlled);
    (0, $iSvIT.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $iSvIT.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("gSKGP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e34bc8237f35d48455854b605c0f874a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4a5e81ad1f6bd29$var$_react = $c4a5e81ad1f6bd29$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c4a5e81ad1f6bd29$var$_chevronLeft = $c4a5e81ad1f6bd29$var$_interopRequireDefault((parcelRequire("c9BrD")));

var $c4a5e81ad1f6bd29$var$_chevronLeftLarge = $c4a5e81ad1f6bd29$var$_interopRequireDefault((parcelRequire("d0cJX")));
function $c4a5e81ad1f6bd29$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4a5e81ad1f6bd29$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $c4a5e81ad1f6bd29$var$_react.default.createElement($c4a5e81ad1f6bd29$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $c4a5e81ad1f6bd29$var$_chevronLeftLarge.default
    }, props));
$c4a5e81ad1f6bd29$var$ChevronLeftIcon.Name = "ChevronLeftIconMigration";
var $c4a5e81ad1f6bd29$var$_default = module.exports.default = $c4a5e81ad1f6bd29$var$ChevronLeftIcon;

});

parcelRegister("igpPr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4724a1e5dc4e8ab6ea5bb133724929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4bdc1a5b6dec9cc$var$_react = $d4bdc1a5b6dec9cc$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d4bdc1a5b6dec9cc$var$_chevronRight = $d4bdc1a5b6dec9cc$var$_interopRequireDefault((parcelRequire("eAfof")));

var $d4bdc1a5b6dec9cc$var$_chevronRightLarge = $d4bdc1a5b6dec9cc$var$_interopRequireDefault((parcelRequire("3Bf61")));
function $d4bdc1a5b6dec9cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4bdc1a5b6dec9cc$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $d4bdc1a5b6dec9cc$var$_react.default.createElement($d4bdc1a5b6dec9cc$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $d4bdc1a5b6dec9cc$var$_chevronRightLarge.default
    }, props));
$d4bdc1a5b6dec9cc$var$ChevronRightIcon.Name = "ChevronRightIconMigration";
var $d4bdc1a5b6dec9cc$var$_default = module.exports.default = $d4bdc1a5b6dec9cc$var$ChevronRightIcon;

});

parcelRegister("ksogg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee493dfa721376cc$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");

var $7U8EY = parcelRequire("7U8EY");
var $ee493dfa721376cc$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $ee493dfa721376cc$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $ee493dfa721376cc$var$baseStyles = null;
var $ee493dfa721376cc$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhk1fno",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1eds",
    "color.background.accent.lime.subtler.pressed": "_bfhk1hgz",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhkhgj8",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhk1b17",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhk1pbw",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkrw5d",
    "color.background.accent.red.subtler.pressed": "_bfhk69rw",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1tf4",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhkprmn",
    "color.background.accent.orange.subtlest": "_bfhk1g3m",
    "color.background.accent.orange.subtlest.hovered": "_bfhkg4tm",
    "color.background.accent.orange.subtlest.pressed": "_bfhk1ya0",
    "color.background.accent.orange.subtler": "_bfhkf2vu",
    "color.background.accent.orange.subtler.hovered": "_bfhk1lml",
    "color.background.accent.orange.subtler.pressed": "_bfhkuxsx",
    "color.background.accent.orange.subtle": "_bfhk1g6e",
    "color.background.accent.orange.subtle.hovered": "_bfhk1oew",
    "color.background.accent.orange.subtle.pressed": "_bfhk1phk",
    "color.background.accent.orange.bolder": "_bfhkjgng",
    "color.background.accent.orange.bolder.hovered": "_bfhkhi52",
    "color.background.accent.orange.bolder.pressed": "_bfhkf767",
    "color.background.accent.yellow.subtlest": "_bfhk1ozg",
    "color.background.accent.yellow.subtlest.hovered": "_bfhk19g9",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk31d1",
    "color.background.accent.yellow.subtler": "_bfhk3fv2",
    "color.background.accent.yellow.subtler.hovered": "_bfhklg04",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1d44",
    "color.background.accent.yellow.subtle": "_bfhkry5t",
    "color.background.accent.yellow.subtle.hovered": "_bfhk17e6",
    "color.background.accent.yellow.subtle.pressed": "_bfhko0y5",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk32kj",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkv5yf",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhkung8",
    "color.background.accent.green.subtler.pressed": "_bfhk1p19",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk8h4p",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1azz",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1j2h",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkg5py",
    "color.background.accent.teal.subtler.pressed": "_bfhkq7li",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk10ai",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhkse6l",
    "color.background.accent.blue.subtlest": "_bfhkavxe",
    "color.background.accent.blue.subtlest.hovered": "_bfhkay3p",
    "color.background.accent.blue.subtlest.pressed": "_bfhk1xmr",
    "color.background.accent.blue.subtler": "_bfhk4v9p",
    "color.background.accent.blue.subtler.hovered": "_bfhk16e6",
    "color.background.accent.blue.subtler.pressed": "_bfhk1uh7",
    "color.background.accent.blue.subtle": "_bfhk1j89",
    "color.background.accent.blue.subtle.hovered": "_bfhk1f4s",
    "color.background.accent.blue.subtle.pressed": "_bfhkqctv",
    "color.background.accent.blue.bolder": "_bfhkc8cv",
    "color.background.accent.blue.bolder.hovered": "_bfhk1cwi",
    "color.background.accent.blue.bolder.pressed": "_bfhkhcrq",
    "color.background.accent.purple.subtlest": "_bfhkp7j4",
    "color.background.accent.purple.subtlest.hovered": "_bfhkm0d5",
    "color.background.accent.purple.subtlest.pressed": "_bfhkgslw",
    "color.background.accent.purple.subtler": "_bfhk1jkz",
    "color.background.accent.purple.subtler.hovered": "_bfhk1wyu",
    "color.background.accent.purple.subtler.pressed": "_bfhk5fkp",
    "color.background.accent.purple.subtle": "_bfhkdh45",
    "color.background.accent.purple.subtle.hovered": "_bfhk1wob",
    "color.background.accent.purple.subtle.pressed": "_bfhkwz05",
    "color.background.accent.purple.bolder": "_bfhkygwo",
    "color.background.accent.purple.bolder.hovered": "_bfhkadgs",
    "color.background.accent.purple.bolder.pressed": "_bfhk1uro",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1een",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1r0p",
    "color.background.accent.magenta.subtler.pressed": "_bfhkxuzc",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk1ovh",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkwaw3",
    "color.background.accent.gray.subtlest": "_bfhk11bn",
    "color.background.accent.gray.subtlest.hovered": "_bfhk12j4",
    "color.background.accent.gray.subtlest.pressed": "_bfhk1lb4",
    "color.background.accent.gray.subtler": "_bfhk1v33",
    "color.background.accent.gray.subtler.hovered": "_bfhk1f7l",
    "color.background.accent.gray.subtler.pressed": "_bfhkd8a2",
    "color.background.accent.gray.subtle": "_bfhk1t05",
    "color.background.accent.gray.subtle.hovered": "_bfhk1a2l",
    "color.background.accent.gray.subtle.pressed": "_bfhk1z0s",
    "color.background.accent.gray.bolder": "_bfhk1t1b",
    "color.background.accent.gray.bolder.hovered": "_bfhke4nv",
    "color.background.accent.gray.bolder.pressed": "_bfhk82ra",
    "color.background.disabled": "_bfhksyzs",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhk1d5g",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhkm7j4",
    "color.background.neutral.hovered": "_bfhk15ej",
    "color.background.neutral.pressed": "_bfhkip91",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk166n",
    "color.background.neutral.subtle.pressed": "_bfhk1dty",
    "color.background.neutral.bold": "_bfhkcdhy",
    "color.background.neutral.bold.hovered": "_bfhk1bsc",
    "color.background.neutral.bold.pressed": "_bfhk1b6k",
    "color.background.selected": "_bfhkfg4m",
    "color.background.selected.hovered": "_bfhki1yw",
    "color.background.selected.pressed": "_bfhk19ru",
    "color.background.selected.bold": "_bfhk1fvw",
    "color.background.selected.bold.hovered": "_bfhk18hz",
    "color.background.selected.bold.pressed": "_bfhkgr1v",
    "color.background.brand.subtlest": "_bfhk3wxy",
    "color.background.brand.subtlest.hovered": "_bfhkezq1",
    "color.background.brand.subtlest.pressed": "_bfhk2ggb",
    "color.background.brand.bold": "_bfhkb29m",
    "color.background.brand.bold.hovered": "_bfhku1se",
    "color.background.brand.bold.pressed": "_bfhkqkzo",
    "color.background.brand.boldest": "_bfhk15mt",
    "color.background.brand.boldest.hovered": "_bfhk1uwk",
    "color.background.brand.boldest.pressed": "_bfhk17jr",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1io2",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk9pqq",
    "color.background.warning": "_bfhk1tzq",
    "color.background.warning.hovered": "_bfhk1rd4",
    "color.background.warning.pressed": "_bfhk11dh",
    "color.background.warning.bold": "_bfhk190i",
    "color.background.warning.bold.hovered": "_bfhk1i4c",
    "color.background.warning.bold.pressed": "_bfhkrj9s",
    "color.background.success": "_bfhkmv6i",
    "color.background.success.hovered": "_bfhk1jgi",
    "color.background.success.pressed": "_bfhky4f1",
    "color.background.success.bold": "_bfhk8emd",
    "color.background.success.bold.hovered": "_bfhk1q4l",
    "color.background.success.bold.pressed": "_bfhkcrcn",
    "color.background.discovery": "_bfhk1nvp",
    "color.background.discovery.hovered": "_bfhk1xp7",
    "color.background.discovery.pressed": "_bfhkdlkp",
    "color.background.discovery.bold": "_bfhk1lri",
    "color.background.discovery.bold.hovered": "_bfhk1w72",
    "color.background.discovery.bold.pressed": "_bfhkrb53",
    "color.background.information": "_bfhk33gi",
    "color.background.information.hovered": "_bfhk1vps",
    "color.background.information.pressed": "_bfhk1s0z",
    "color.background.information.bold": "_bfhk14wj",
    "color.background.information.bold.hovered": "_bfhk1amz",
    "color.background.information.bold.pressed": "_bfhk5bth",
    "color.blanket": "_bfhk10xm",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkn82g",
    "color.skeleton.subtle": "_bfhkh3tw",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk108i",
    "elevation.surface.pressed": "_bfhk1ji5",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk16qz",
    "elevation.surface.overlay.pressed": "_bfhkvq0a",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk1a0f",
    "elevation.surface.raised.pressed": "_bfhkf7u5",
    "elevation.surface.sunken": "_bfhkqbzx",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $ee493dfa721376cc$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $ee493dfa721376cc$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l108i",
    "elevation.surface.pressed": "_1q1l1ji5",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l16qz",
    "elevation.surface.overlay.pressed": "_1q1lvq0a",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l1a0f",
    "elevation.surface.raised.pressed": "_1q1lf7u5",
    "elevation.surface.sunken": "_1q1lqbzx"
};
var $ee493dfa721376cc$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $ee493dfa721376cc$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $ee493dfa721376cc$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $ee493dfa721376cc$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $ee493dfa721376cc$var$Box = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $cxbbJ.default)(_ref, $ee493dfa721376cc$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $cxbbJ.default)(htmlAttributes, $ee493dfa721376cc$var$_excluded2);
    var node = /*#__PURE__*/ $iSvIT.createElement(Component, (0, $7wyUQ.default)({
        style: style,
        ref: ref,
        className: (0, $gpt5O.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $ee493dfa721376cc$var$backgroundColorMap[backgroundColor],
            backgroundColor && $ee493dfa721376cc$var$isSurfaceToken(backgroundColor) && $ee493dfa721376cc$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $ee493dfa721376cc$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $ee493dfa721376cc$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $ee493dfa721376cc$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $ee493dfa721376cc$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $iSvIT.createElement((0, $7U8EY.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $ee493dfa721376cc$export$2e2bcd8739ae039 = $ee493dfa721376cc$var$Box;
function $ee493dfa721376cc$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $ee493dfa721376cc$var$setSurfaceTokenMap;
}

});
parcelRegister("7U8EY", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $5c147b06ec66694c$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $5c147b06ec66694c$export$1aeb4f6b93c4540d; });

var $iSvIT = parcelRequire("iSvIT");
var $5c147b06ec66694c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $5c147b06ec66694c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($5c147b06ec66694c$export$1ca2a26fecb070ae);
};
$5c147b06ec66694c$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("ke1Eq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb966551404c2bfe$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");

var $9Ntna = parcelRequire("9Ntna");

var $2hfcF = parcelRequire("2hfcF");
var $eb966551404c2bfe$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $eb966551404c2bfe$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $eb966551404c2bfe$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $gpt5O.default)([
            $eb966551404c2bfe$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $eb966551404c2bfe$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $cxbbJ.default)(_ref2, $eb966551404c2bfe$var$_excluded);
    var separatorComponent = typeof separator === "string" ? /*#__PURE__*/ $iSvIT.createElement($eb966551404c2bfe$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $iSvIT.createElement((0, $2hfcF.default), (0, $7wyUQ.default)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: (0, $9Ntna.cx)(grow === "hug" && $eb966551404c2bfe$var$styles.hug, grow === "fill" && $eb966551404c2bfe$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$eb966551404c2bfe$var$Inline.displayName = "Inline";
var $eb966551404c2bfe$export$2e2bcd8739ae039 = $eb966551404c2bfe$var$Inline;

});
parcelRegister("9Ntna", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $721f797a0492de9d$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("iSvIT");


var $cw2lq = parcelRequire("cw2lq");
var $721f797a0492de9d$var$_createStrictAPI = (0, $cw2lq.createStrictAPI)(), $721f797a0492de9d$var$XCSSProp = $721f797a0492de9d$var$_createStrictAPI.XCSSProp, $721f797a0492de9d$export$dbf350e5966cf602 = $721f797a0492de9d$var$_createStrictAPI.css, $721f797a0492de9d$export$eb1ecd84a24ee424 = $721f797a0492de9d$var$_createStrictAPI.cssMap, $721f797a0492de9d$export$a274e22fb40f762e = $721f797a0492de9d$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("cw2lq", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $91ca4aca3828d091$export$39716b4af53f4ad; });

var $bY6dE = parcelRequire("bY6dE");

var $c9xhG = parcelRequire("c9xhG");
function $91ca4aca3828d091$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $bY6dE.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $bY6dE.createStrictSetupError)();
        },
        cx: $c9xhG.cx,
        XCSSProp () {
            throw (0, $bY6dE.createStrictSetupError)();
        }
    };
}

});
parcelRegister("bY6dE", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $8b6a1f4999f1b86a$export$c4df1cb0c2b4d77c; });
const $8b6a1f4999f1b86a$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $8b6a1f4999f1b86a$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("c9xhG", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $8d9024d4cfe15e0a$export$a274e22fb40f762e; });

var $gpt5O = parcelRequire("gpt5O");
const $8d9024d4cfe15e0a$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $gpt5O.default)(actualStyles);
};

});



parcelRegister("2hfcF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a88f661d804fe37$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");
var $1a88f661d804fe37$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $1a88f661d804fe37$var$rowGapMap = {
    "space.0": "_1p57ze3t",
    "space.025": "_1p57v77o",
    "space.050": "_1p571b66",
    "space.075": "_1p5712x7",
    "space.100": "_1p57u2gc",
    "space.150": "_1p57utpp",
    "space.200": "_1p57pxbi",
    "space.250": "_1p57v47k",
    "space.300": "_1p571ejb",
    "space.400": "_1p57xy5q",
    "space.500": "_1p571jfw",
    "space.600": "_1p57oahv",
    "space.800": "_1p57xncg",
    "space.1000": "_1p571epz"
};
var $1a88f661d804fe37$var$columnGapMap = {
    "space.0": "_gy1pze3t",
    "space.025": "_gy1pv77o",
    "space.050": "_gy1p1b66",
    "space.075": "_gy1p12x7",
    "space.100": "_gy1pu2gc",
    "space.150": "_gy1putpp",
    "space.200": "_gy1ppxbi",
    "space.250": "_gy1pv47k",
    "space.300": "_gy1p1ejb",
    "space.400": "_gy1pxy5q",
    "space.500": "_gy1p1jfw",
    "space.600": "_gy1poahv",
    "space.800": "_gy1pxncg",
    "space.1000": "_gy1p1epz"
};
var $1a88f661d804fe37$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    "space-between": "_1bah1yb4",
    "space-around": "_1bah1b1v",
    "space-evenly": "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $1a88f661d804fe37$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $1a88f661d804fe37$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $1a88f661d804fe37$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $1a88f661d804fe37$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $1a88f661d804fe37$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $cxbbJ.default)(_ref, $1a88f661d804fe37$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $7wyUQ.default)({}, ariaAttributes, {
        role: role,
        className: (0, $gpt5O.default)([
            $1a88f661d804fe37$var$styles.root,
            gap && $1a88f661d804fe37$var$columnGapMap[gap],
            columnGap && $1a88f661d804fe37$var$columnGapMap[columnGap],
            gap && $1a88f661d804fe37$var$rowGapMap[gap],
            rowGap && $1a88f661d804fe37$var$rowGapMap[rowGap],
            alignItems && $1a88f661d804fe37$var$alignItemsMap[alignItems],
            direction && $1a88f661d804fe37$var$flexDirectionMap[direction],
            justifyContent && $1a88f661d804fe37$var$justifyContentMap[justifyContent],
            wrap && $1a88f661d804fe37$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$1a88f661d804fe37$var$Flex.displayName = "Flex";
var $1a88f661d804fe37$export$2e2bcd8739ae039 = $1a88f661d804fe37$var$Flex;

});


parcelRegister("dOrta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0e540b7ffa0fbae$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $8WZAM = parcelRequire("8WZAM");
function $a0e540b7ffa0fbae$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8WZAM.default), {
        "aria-label": props["aria-label"],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});
parcelRegister("8WZAM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68438477a24d7af0$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $lgwoD = parcelRequire("lgwoD");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $jiOHx = parcelRequire("jiOHx");

var $2U5DD = parcelRequire("2U5DD");

var $8CRp1 = parcelRequire("8CRp1");

var $epT07 = parcelRequire("epT07");

var $ciDUw = parcelRequire("ciDUw");
var $68438477a24d7af0$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $68438477a24d7af0$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $68438477a24d7af0$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $jiOHx.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $jiOHx.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, $cxbbJ.default)(_ref, $68438477a24d7af0$var$_excluded);
    var _useGlobalTheme = (0, $2U5DD.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $ciDUw.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $lgwoD.default)(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $iSvIT.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($68438477a24d7af0$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $iSvIT.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($68438477a24d7af0$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $iSvIT.useMemo)(function() {
        return (0, $epT07.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8CRp1.default), (0, $7wyUQ.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$68438477a24d7af0$var$Button.displayName = "Button";
var $68438477a24d7af0$export$2e2bcd8739ae039 = $68438477a24d7af0$var$Button;

});
parcelRegister("2U5DD", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $21d52f659e79809a$export$7692396083754928; });

var $oIWHz = parcelRequire("oIWHz");
// Create default global light theme
var $21d52f659e79809a$var$_createTheme = (0, $oIWHz.createTheme)(function() {
    return {
        mode: "light"
    };
}), $21d52f659e79809a$var$Provider = $21d52f659e79809a$var$_createTheme.Provider, $21d52f659e79809a$var$Consumer = $21d52f659e79809a$var$_createTheme.Consumer, $21d52f659e79809a$export$7692396083754928 = $21d52f659e79809a$var$_createTheme.useTheme;
var $21d52f659e79809a$var$Theme = {
    Provider: $21d52f659e79809a$var$Provider,
    Consumer: $21d52f659e79809a$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$21d52f659e79809a$export$2e2bcd8739ae039 = $21d52f659e79809a$var$Theme;

});
parcelRegister("oIWHz", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $04a51b4e525f7f30$export$25d302a5b900a763; });

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");
var $04a51b4e525f7f30$var$_excluded = [
    "children"
];
function $04a51b4e525f7f30$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $iSvIT.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $cxbbJ.default)(props, $04a51b4e525f7f30$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $iSvIT.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $iSvIT.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("8CRp1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $647b4bf8df0a2210$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $6RvuE = parcelRequire("6RvuE");

var $jiOHx = parcelRequire("jiOHx");

var $by3Q4 = parcelRequire("by3Q4");

var $7TCqn = parcelRequire("7TCqn");

var $7nG8r = parcelRequire("7nG8r");

var $cvWPm = parcelRequire("cvWPm");

var $dOWup = parcelRequire("dOWup");

var $epT07 = parcelRequire("epT07");

var $4E11T = parcelRequire("4E11T");
var $647b4bf8df0a2210$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $647b4bf8df0a2210$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $647b4bf8df0a2210$var$iconBeforeSpacingFixStyle = (0, $2ZUkg.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $647b4bf8df0a2210$var$iconAfterSpacingFixStyle = (0, $2ZUkg.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $647b4bf8df0a2210$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $4E11T.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $647b4bf8df0a2210$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $4E11T.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $2ZUkg.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $647b4bf8df0a2210$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $jiOHx.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $jiOHx.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, $cxbbJ.default)(props, $647b4bf8df0a2210$var$_excluded);
    var ourRef = (0, $iSvIT.useRef)();
    var setRef = (0, $iSvIT.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $by3Q4.default)(ourRef, autoFocus);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $6RvuE.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "23.3.2",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $iSvIT.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $iSvIT.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $2ZUkg.css)((0, $epT07.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $cvWPm.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $cvWPm.N500), ")"), " !important")
        }
    };
    return (0, $2ZUkg.jsx)((0, $7TCqn.default), null, (0, $2ZUkg.jsx)(Component, (0, $7wyUQ.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $647b4bf8df0a2210$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $dOWup.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $2ZUkg.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $epT07.getIconStyle)({
                spacing: spacing
            }),
            $647b4bf8df0a2210$var$getSpacingFix(children, $647b4bf8df0a2210$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $647b4bf8df0a2210$var$getChildren(children, [
        fadeStyles,
        (0, $epT07.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $2ZUkg.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $epT07.getIconStyle)({
                spacing: spacing
            }),
            $647b4bf8df0a2210$var$getSpacingFix(children, $647b4bf8df0a2210$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $2ZUkg.jsx)("span", {
        css: [
            (0, $epT07.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$647b4bf8df0a2210$export$2e2bcd8739ae039 = $647b4bf8df0a2210$var$ButtonBase;

});
parcelRegister("by3Q4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8685d8fbf33d39d5$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $8685d8fbf33d39d5$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $iSvIT.useRef)(true);
    (0, $iSvIT.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("dOWup", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0fd50a8af3c1f4b$export$2e2bcd8739ae039; });
function $a0fd50a8af3c1f4b$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $a0fd50a8af3c1f4b$var$tabKeyCode = 9;
function $a0fd50a8af3c1f4b$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $a0fd50a8af3c1f4b$var$tabKeyCode) return;
    $a0fd50a8af3c1f4b$var$abort(event);
}
var $a0fd50a8af3c1f4b$var$block = {
    onMouseDownCapture: $a0fd50a8af3c1f4b$var$abort,
    onMouseUpCapture: $a0fd50a8af3c1f4b$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $a0fd50a8af3c1f4b$var$onKey,
    onKeyUpCapture: $a0fd50a8af3c1f4b$var$onKey,
    onTouchStartCapture: $a0fd50a8af3c1f4b$var$abort,
    onTouchEndCapture: $a0fd50a8af3c1f4b$var$abort,
    onPointerDownCapture: $a0fd50a8af3c1f4b$var$abort,
    onPointerUpCapture: $a0fd50a8af3c1f4b$var$abort,
    onClickCapture: $a0fd50a8af3c1f4b$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $a0fd50a8af3c1f4b$var$abort
};
var $a0fd50a8af3c1f4b$var$doNotBlock = {};
function $a0fd50a8af3c1f4b$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $a0fd50a8af3c1f4b$var$doNotBlock : $a0fd50a8af3c1f4b$var$block;
}

});

parcelRegister("epT07", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $a7ee1084d72578d8$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $a7ee1084d72578d8$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $a7ee1084d72578d8$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $a7ee1084d72578d8$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $a7ee1084d72578d8$export$1a9fe1b84c876bb5; });

var $eKFRo = parcelRequire("eKFRo");

var $2ZUkg = parcelRequire("2ZUkg");

var $jxLBU = parcelRequire("jxLBU");

var $l7eXL = parcelRequire("l7eXL");

var $6hyVG = parcelRequire("6hyVG");
function $a7ee1084d72578d8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a7ee1084d72578d8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a7ee1084d72578d8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a7ee1084d72578d8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a7ee1084d72578d8$var$gridSize = (0, $l7eXL.gridSize)();
var $a7ee1084d72578d8$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $a7ee1084d72578d8$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $a7ee1084d72578d8$var$lineHeights = {
    default: $a7ee1084d72578d8$var$heights.default,
    compact: $a7ee1084d72578d8$var$heights.compact,
    none: "inherit"
};
var $a7ee1084d72578d8$var$padding = {
    // 10px gutter
    default: "0 ".concat($a7ee1084d72578d8$var$gridSize + $a7ee1084d72578d8$var$gridSize / 4, "px"),
    compact: "0 ".concat($a7ee1084d72578d8$var$gridSize + $a7ee1084d72578d8$var$gridSize / 4, "px"),
    none: "0"
};
var $a7ee1084d72578d8$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($a7ee1084d72578d8$var$gridSize / 4, "px"),
    default: "0 ".concat($a7ee1084d72578d8$var$gridSize / 4, "px"),
    none: "0"
};
var $a7ee1084d72578d8$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $a7ee1084d72578d8$var$innerMargin = {
    content: "0 ".concat($a7ee1084d72578d8$var$gridSize / 4, "px"),
    icon: "0 ".concat($a7ee1084d72578d8$var$gridSize / 4, "px")
};
var $a7ee1084d72578d8$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $a7ee1084d72578d8$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&::after": $a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread({}, $a7ee1084d72578d8$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "&:disabled[disabled]": {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "&:disabled[disabled]:hover": {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "&:disabled[disabled]:active": {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $a7ee1084d72578d8$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $a7ee1084d72578d8$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $a7ee1084d72578d8$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "transparent"
    }
};
var $a7ee1084d72578d8$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $a7ee1084d72578d8$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $a7ee1084d72578d8$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $a7ee1084d72578d8$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread({}, $a7ee1084d72578d8$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $a7ee1084d72578d8$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $a7ee1084d72578d8$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $a7ee1084d72578d8$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $a7ee1084d72578d8$var$getColor({
            group: (0, $6hyVG.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($a7ee1084d72578d8$var$getColor({
            group: (0, $6hyVG.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $a7ee1084d72578d8$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $a7ee1084d72578d8$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $jxLBU.fg)("platform-component-visual-refresh") && baseColors), {}, {
        cursor: "pointer",
        height: $a7ee1084d72578d8$var$heights[spacing],
        lineHeight: $a7ee1084d72578d8$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $a7ee1084d72578d8$var$singleIconPadding[spacing] : $a7ee1084d72578d8$var$padding[spacing],
        verticalAlign: $a7ee1084d72578d8$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $jxLBU.fg)("platform-component-visual-refresh") && $a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $a7ee1084d72578d8$var$_objectSpread({}, baseColors),
        "&:hover": $a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread({}, $a7ee1084d72578d8$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread({}, $a7ee1084d72578d8$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread({}, $a7ee1084d72578d8$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread({}, $a7ee1084d72578d8$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $a7ee1084d72578d8$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $a7ee1084d72578d8$var$_objectSpread({}, $a7ee1084d72578d8$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $jxLBU.fg)("platform-component-visual-refresh") && (isSelected ? $a7ee1084d72578d8$var$selectedStyles : $a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread($a7ee1084d72578d8$var$_objectSpread({}, appearance === "default" && $a7ee1084d72578d8$var$defaultStyles), appearance === "primary" && $a7ee1084d72578d8$var$primaryStyles), appearance === "link" && $a7ee1084d72578d8$var$linkStyles), appearance === "subtle" && $a7ee1084d72578d8$var$subtleStyles), appearance === "subtle-link" && $a7ee1084d72578d8$var$subtleLinkStyles), appearance === "warning" && $a7ee1084d72578d8$var$warningStyles), appearance === "danger" && $a7ee1084d72578d8$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $a7ee1084d72578d8$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $a7ee1084d72578d8$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $a7ee1084d72578d8$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $a7ee1084d72578d8$var$hasOverlayStyles))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $a7ee1084d72578d8$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $2ZUkg.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $a7ee1084d72578d8$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: "none"
    });
}
function $a7ee1084d72578d8$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $2ZUkg.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $a7ee1084d72578d8$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $a7ee1084d72578d8$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $2ZUkg.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $a7ee1084d72578d8$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("l7eXL", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $f5f5dbc6090515e7$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "layers", function () { return $f5f5dbc6090515e7$export$7be255094ccdc533; });

var $jWgwj = parcelRequire("jWgwj");

var $cvWPm = parcelRequire("cvWPm");
var $f5f5dbc6090515e7$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $f5f5dbc6090515e7$export$c93026a968943f95 = "light";
var $f5f5dbc6090515e7$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $f5f5dbc6090515e7$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $f5f5dbc6090515e7$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $f5f5dbc6090515e7$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $cvWPm.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f5f5dbc6090515e7$export$6d8204c2cb2e06b8() / 4;
    (0, $jWgwj.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $f5f5dbc6090515e7$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $f5f5dbc6090515e7$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $f5f5dbc6090515e7$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $jWgwj.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $f5f5dbc6090515e7$export$ba1d834b86d72a09 = $f5f5dbc6090515e7$export$a1b3edb637fb4f35;
var $f5f5dbc6090515e7$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $cvWPm.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $cvWPm.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $cvWPm.N30A), ")")
            }
        }
    };
};

});
parcelRegister("jWgwj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8403fa6a1628192$export$2e2bcd8739ae039; });

var $gsALO = parcelRequire("gsALO");

var $XAEGR = parcelRequire("XAEGR");
function $e8403fa6a1628192$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $gsALO.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $e8403fa6a1628192$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $XAEGR;
}

});
parcelRegister("gsALO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfbbc8ad06e178f8$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $bfbbc8ad06e178f8$var$printed = {};
function $bfbbc8ad06e178f8$export$2e2bcd8739ae039(message) {
    if ($bfbbc8ad06e178f8$var$printed[message]) return;
    $bfbbc8ad06e178f8$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});



parcelRegister("6hyVG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $492f6cdb34b41c48$export$2e2bcd8739ae039; });

var $cvWPm = parcelRequire("cvWPm");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $492f6cdb34b41c48$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $492f6cdb34b41c48$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($cvWPm.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($cvWPm.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($cvWPm.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($cvWPm.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($492f6cdb34b41c48$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($cvWPm.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($cvWPm.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($cvWPm.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($cvWPm.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($cvWPm.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($cvWPm.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($cvWPm.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($cvWPm.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($cvWPm.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($cvWPm.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($cvWPm.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($cvWPm.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($cvWPm.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($cvWPm.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($cvWPm.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($cvWPm.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($cvWPm.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($cvWPm.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($cvWPm.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($cvWPm.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($cvWPm.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($cvWPm.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($cvWPm.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($cvWPm.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($cvWPm.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($cvWPm.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($cvWPm.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($cvWPm.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($cvWPm.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($492f6cdb34b41c48$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($cvWPm.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cvWPm.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cvWPm.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($cvWPm.N500, ")"),
                dark: "var(--ds-text, ".concat($cvWPm.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($cvWPm.B400, ")"),
                dark: "var(--ds-text, ".concat($cvWPm.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cvWPm.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cvWPm.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($cvWPm.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($cvWPm.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cvWPm.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cvWPm.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($cvWPm.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($cvWPm.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cvWPm.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cvWPm.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($cvWPm.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($cvWPm.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cvWPm.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cvWPm.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($cvWPm.B400, ")"),
                dark: "var(--ds-link, ".concat($cvWPm.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($cvWPm.B300, ")"),
                dark: "var(--ds-link, ".concat($cvWPm.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($cvWPm.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($cvWPm.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cvWPm.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cvWPm.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($cvWPm.N500, ")"),
                dark: "var(--ds-text, ".concat($cvWPm.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($cvWPm.B400, ")"),
                dark: "var(--ds-text, ".concat($cvWPm.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cvWPm.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cvWPm.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($cvWPm.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($cvWPm.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($cvWPm.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($cvWPm.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($cvWPm.N400, ")"),
                dark: "var(--ds-text, ".concat($cvWPm.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cvWPm.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cvWPm.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cvWPm.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cvWPm.DN400, ")")
            }
        }
    }
};
var $492f6cdb34b41c48$export$2e2bcd8739ae039 = $492f6cdb34b41c48$var$values;

});


parcelRegister("4E11T", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $361bb24fff7e779c$export$20bbd2efb0d734c4; });

var $iSvIT = parcelRequire("iSvIT");

var $dtGQ8 = parcelRequire("dtGQ8");
var $361bb24fff7e779c$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $iSvIT.isValidElement)(children) && children.type === (0, $dtGQ8.default);
};

});
parcelRegister("dtGQ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cff36e46d5a3ed2$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $iSvIT = parcelRequire("iSvIT");

var $4DSeC = parcelRequire("4DSeC");
var $9cff36e46d5a3ed2$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $9cff36e46d5a3ed2$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $4DSeC.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $9cff36e46d5a3ed2$export$2e2bcd8739ae039 = $9cff36e46d5a3ed2$var$VisuallyHidden;

});
parcelRegister("4DSeC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3614dfda508124fd$export$2e2bcd8739ae039; });
const $3614dfda508124fd$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $3614dfda508124fd$var$ATOMIC_GROUP_LENGTH = 5;
function $3614dfda508124fd$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $3614dfda508124fd$var$UNDERSCORE_UNICODE ? $3614dfda508124fd$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});




parcelRegister("ciDUw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f461fe699f101fe$export$2e2bcd8739ae039; });

var $4E11T = parcelRequire("4E11T");
function $8f461fe699f101fe$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $4E11T.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});



parcelRegister("eo1l0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a794583a09375f4c$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $iSvIT = parcelRequire("iSvIT");

var $8WZAM = parcelRequire("8WZAM");
function $a794583a09375f4c$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8WZAM.default), (0, $7wyUQ.default)({}, props, {
        appearance: "subtle"
    }));
}

});

parcelRegister("98SV3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a7f76399e46884c$export$2e2bcd8739ae039; });
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $iSvIT = parcelRequire("iSvIT");

var $ksogg = parcelRequire("ksogg");
var $1Lgay = parcelRequire("1Lgay");

var $dtGQ8 = parcelRequire("dtGQ8");
var $6a7f76399e46884c$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $6a7f76399e46884c$export$2e2bcd8739ae039(_ref) {
    var key = _ref.key, testId = _ref.testId, from = _ref.from, to = _ref.to;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ksogg.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $6a7f76399e46884c$var$styles.container,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1Lgay.default), {
        testId: testId && "".concat(testId, "-text")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $dtGQ8.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});
parcelRegister("1Lgay", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1486b91a8887b6df$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");

var $jNYFj = parcelRequire("jNYFj");

var $2wWwQ = parcelRequire("2wWwQ");

var $7U8EY = parcelRequire("7U8EY");
var $1486b91a8887b6df$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $1486b91a8887b6df$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $7U8EY.useSurface)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($1486b91a8887b6df$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $1486b91a8887b6df$export$2185ce37f9bdd963[surface];
    return "color.text";
};
var $1486b91a8887b6df$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    "as.strong": "_k48pmoej",
    "as.em": "_zg8l1m30",
    "textAlign.center": "_y3gn1h6o",
    "textAlign.end": "_y3gnh9n0",
    "textAlign.start": "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $1486b91a8887b6df$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $1486b91a8887b6df$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $1486b91a8887b6df$var$textColorMap = {
    "color.text": "_syaz1fxt",
    "color.text.accent.lime": "_syaz1tco",
    "color.text.accent.lime.bolder": "_syaz1ik3",
    "color.text.accent.red": "_syaz9lu1",
    "color.text.accent.red.bolder": "_syazhwvp",
    "color.text.accent.orange": "_syaz1q28",
    "color.text.accent.orange.bolder": "_syaz1vps",
    "color.text.accent.yellow": "_syazfb2s",
    "color.text.accent.yellow.bolder": "_syazekll",
    "color.text.accent.green": "_syazh55r",
    "color.text.accent.green.bolder": "_syaz1y78",
    "color.text.accent.teal": "_syaz17qg",
    "color.text.accent.teal.bolder": "_syaz12v7",
    "color.text.accent.blue": "_syazpnps",
    "color.text.accent.blue.bolder": "_syazsc1o",
    "color.text.accent.purple": "_syaz10m5",
    "color.text.accent.purple.bolder": "_syaz2ibx",
    "color.text.accent.magenta": "_syaz1s8m",
    "color.text.accent.magenta.bolder": "_syaz1qur",
    "color.text.accent.gray": "_syaz1dyx",
    "color.text.accent.gray.bolder": "_syaz1x9z",
    "color.text.disabled": "_syaz1lh4",
    "color.text.inverse": "_syaz15cr",
    "color.text.selected": "_syazaqb7",
    "color.text.brand": "_syaz1e6v",
    "color.text.danger": "_syaz1tmw",
    "color.text.warning": "_syazwx40",
    "color.text.warning.inverse": "_syazal3n",
    "color.text.success": "_syazy73q",
    "color.text.discovery": "_syazzjem",
    "color.text.information": "_syaze0os",
    "color.text.subtlest": "_syaz131l",
    "color.text.subtle": "_syaz1gjq",
    "color.link": "_syaz14q2",
    "color.link.pressed": "_syaz16c2",
    "color.link.visited": "_syazw7te",
    "color.link.visited.pressed": "_syazg3x0"
};
var $1486b91a8887b6df$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $1486b91a8887b6df$var$Text = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $jNYFj.default)($1486b91a8887b6df$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $2wWwQ.useHasTextAncestor)();
    var color = $1486b91a8887b6df$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = /*#__PURE__*/ $iSvIT.createElement(Component, {
        id: id,
        className: (0, $gpt5O.default)([
            $1486b91a8887b6df$var$styles.root,
            size && $1486b91a8887b6df$var$fontSizeMap[size],
            color && $1486b91a8887b6df$var$textColorMap[color],
            maxLines && $1486b91a8887b6df$var$styles.truncation,
            maxLines === 1 && $1486b91a8887b6df$var$styles.breakAll,
            align && $1486b91a8887b6df$var$styles["textAlign.".concat(align)],
            weight && $1486b91a8887b6df$var$fontWeightMap[weight],
            Component === "em" && $1486b91a8887b6df$var$styles["as.em"],
            Component === "strong" && $1486b91a8887b6df$var$styles["as.strong"],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $iSvIT.createElement((0, $2wWwQ.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $1486b91a8887b6df$export$2e2bcd8739ae039 = $1486b91a8887b6df$var$Text;

});
parcelRegister("2wWwQ", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", function () { return $1d7bf884fbb3259f$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $1d7bf884fbb3259f$export$ae933c6cbe5643ad; });

var $iSvIT = parcelRequire("iSvIT");
var $1d7bf884fbb3259f$var$HasTextAncestorContext = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
var $1d7bf884fbb3259f$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $iSvIT.useContext)($1d7bf884fbb3259f$var$HasTextAncestorContext);
};
var $1d7bf884fbb3259f$export$ae933c6cbe5643ad = $1d7bf884fbb3259f$var$HasTextAncestorContext.Provider;

});



parcelRegister("1HCf5", function(module, exports) {

$parcel$export(module.exports, "emptyObject", function () { return $13d778bd9fdda146$export$3f860eba1218f8d3; });
var $13d778bd9fdda146$export$3f860eba1218f8d3 = {};

});

parcelRegister("lqUTb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9a827afb5df06fc$export$2e2bcd8739ae039; });

var $iwkI2 = parcelRequire("iwkI2");

var $fV0Sg = parcelRequire("fV0Sg");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
var $f9a827afb5df06fc$var$collapseRange = function collapseRange(pages, current, _ref, testId) {
    var max = _ref.max, ellipsis = _ref.ellipsis, transform = _ref.transform;
    var total = pages.length;
    // only need ellipsis if we have more pages than we can display
    var needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    var hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    var hasEndEllipsis = needEllipsis && current < total - max + 3;
    var getPageComponents = (0, $fV0Sg.default)(function() {
        var startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var lastIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : total;
        return pages.slice(startIndex, lastIndex).map(function(page, index) {
            return transform(page, startIndex + index, testId);
        });
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        var _pageCount = max - 2;
        return [].concat((0, $iwkI2.default)(getPageComponents(0, 1)), [
            ellipsis({
                key: "ellipsis-1",
                testId: testId && "".concat(testId, "-ellipsis"),
                from: 2,
                to: total - _pageCount
            })
        ], (0, $iwkI2.default)(getPageComponents(total - _pageCount)));
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        var _pageCount2 = max - 2;
        return [].concat((0, $iwkI2.default)(getPageComponents(0, _pageCount2)), [
            ellipsis({
                key: "ellipsis-1",
                testId: testId && "".concat(testId, "-ellipsis"),
                from: _pageCount2 + 1,
                to: total - 1
            })
        ], (0, $iwkI2.default)(getPageComponents(total - 1)));
    }
    // we have both start and end ellipsis
    var pageCount = max - 4;
    return [].concat((0, $iwkI2.default)(getPageComponents(0, 1)), [
        ellipsis({
            key: "ellipsis-1",
            testId: testId && "".concat(testId, "-ellipsis"),
            from: 2,
            to: current - Math.floor(pageCount / 2)
        })
    ], (0, $iwkI2.default)(getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1)), [
        ellipsis({
            key: "ellipsis-2",
            testId: testId && "".concat(testId, "-ellipsis"),
            from: current + 3,
            to: total - 1
        })
    ], (0, $iwkI2.default)(getPageComponents(total - 1)));
};
var $f9a827afb5df06fc$export$2e2bcd8739ae039 = $f9a827afb5df06fc$var$collapseRange;

});



parcelRegister("7WZcV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9d6db97fabfb7e$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $lyawF = parcelRequire("lyawF");

var $dgt68 = parcelRequire("dgt68");

var $ixuga = parcelRequire("ixuga");

var $hqZvY = parcelRequire("hqZvY");

var $kUu2a = parcelRequire("kUu2a");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $8n6Ta = parcelRequire("8n6Ta");

var $8eOUt = parcelRequire("8eOUt");

var $Yr4r8 = parcelRequire("Yr4r8");

var $csDsz = parcelRequire("csDsz");

var $5ukl3 = parcelRequire("5ukl3");

var $fAckW = parcelRequire("fAckW");
var $5c9d6db97fabfb7e$var$_excluded = [
    "cells"
], $5c9d6db97fabfb7e$var$_excluded2 = [
    "ascendingSortTooltip",
    "buttonAriaRoleDescription",
    "colSpan",
    "content",
    "descendingSortTooltip",
    "isIconOnlyHeader",
    "isSortable",
    "key",
    "shouldTruncate",
    "testId",
    "width"
];
function $5c9d6db97fabfb7e$var$_callSuper(t, o, e) {
    return o = (0, $hqZvY.default)(o), (0, $ixuga.default)(t, $5c9d6db97fabfb7e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hqZvY.default)(t).constructor) : o.apply(t, e));
}
function $5c9d6db97fabfb7e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5c9d6db97fabfb7e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5c9d6db97fabfb7e$var$TableHead = /*#__PURE__*/ function(_React$Component) {
    function TableHead(props) {
        var _this;
        (0, $lyawF.default)(this, TableHead);
        _this = $5c9d6db97fabfb7e$var$_callSuper(this, TableHead, [
            props
        ]);
        _this.state = {
            activeSortButtonId: null
        };
        return _this;
    }
    (0, $kUu2a.default)(TableHead, _React$Component);
    return (0, $dgt68.default)(TableHead, [
        {
            key: "UNSAFE_componentWillMount",
            value: function UNSAFE_componentWillMount() {
                (0, $8n6Ta.validateSortKey)(this.props.sortKey, this.props.head);
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $8n6Ta.validateSortKey)(nextProps.sortKey, nextProps.head);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, head = _this$props.head, sortKey = _this$props.sortKey, sortOrder = _this$props.sortOrder, isFixedSize = _this$props.isFixedSize, onSort = _this$props.onSort, isRanking = _this$props.isRanking, isRankable = _this$props.isRankable, testId = _this$props.testId;
                var activeSortButtonId = this.state.activeSortButtonId;
                if (!head) return null;
                var HeadCellComponentOld = isRankable ? (0, $csDsz.default) : (0, $fAckW.default);
                var HeadCellComponent = isRankable ? (0, $Yr4r8.default) : (0, $5ukl3.default);
                // TODO: Remove `rest` props and use only what is explicitly in the API.
                // Some tests use this to pass in onClick and other stuff within the `head`
                // variable here, but considering it's not in the API, it should probably
                // be removed.
                var cells = head.cells, rest = (0, $cxbbJ.default)(head, $5c9d6db97fabfb7e$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8eOUt.Head), (0, $7wyUQ.default)({}, rest, {
                    isRanking: isRanking,
                    testId: testId && "".concat(testId, "--head")
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("tr", null, cells.map(function(cell, index) {
                    var ascendingSortTooltip = cell.ascendingSortTooltip, buttonAriaRoleDescription = cell.buttonAriaRoleDescription, colSpan = cell.colSpan, content = cell.content, descendingSortTooltip = cell.descendingSortTooltip, isIconOnlyHeader = cell.isIconOnlyHeader, isSortable = cell.isSortable, key = cell.key, shouldTruncate = cell.shouldTruncate, cellTestId = cell.testId, width = cell.width, restCellProps = (0, $cxbbJ.default)(cell, $5c9d6db97fabfb7e$var$_excluded2);
                    var headCellId = "head-cell-".concat(index);
                    var handleClick = function handleClick() {
                        _this2.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return (0, $jxLBU.fg)("platform-component-visual-refresh") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(HeadCellComponent, (0, $7wyUQ.default)({
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        key: key || index,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription
                    }, restCellProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(HeadCellComponentOld, (0, $7wyUQ.default)({
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        key: key || index,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width
                    }, restCellProps));
                })));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Component); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $5c9d6db97fabfb7e$export$2e2bcd8739ae039 = $5c9d6db97fabfb7e$var$TableHead;

});
parcelRegister("8eOUt", function(module, exports) {

$parcel$export(module.exports, "Head", function () { return $5ff71f2a31bb5d22$export$e93312b7773dfcac; });
$parcel$export(module.exports, "HeadCell", function () { return $5ff71f2a31bb5d22$export$4e8024263ace498b; });
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eKFRo = parcelRequire("eKFRo");

var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");
var $cRJ4t = parcelRequire("cRJ4t");

var $jxLBU = parcelRequire("jxLBU");

var $cvWPm = parcelRequire("cvWPm");

var $gZthg = parcelRequire("gZthg");

var $jSrVq = parcelRequire("jSrVq");
var $5ff71f2a31bb5d22$var$_excluded = [
    "isRanking",
    "testId"
], $5ff71f2a31bb5d22$var$_excluded2 = [
    "width",
    "children",
    "isSortable",
    "sortOrder",
    "isFixedSize",
    "shouldTruncate",
    "onClick",
    "style",
    "testId"
];
function $5ff71f2a31bb5d22$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ff71f2a31bb5d22$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ff71f2a31bb5d22$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ff71f2a31bb5d22$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5ff71f2a31bb5d22$var$CSS_VAR_TEXT_COLOR = "--local-dynamic-table-text-color";
var $5ff71f2a31bb5d22$var$rankingStyles = null;
var $5ff71f2a31bb5d22$var$headStyles = null;
var $5ff71f2a31bb5d22$var$overflowTruncateStyles = null;
var $5ff71f2a31bb5d22$var$truncationWidthStyles = null;
var $5ff71f2a31bb5d22$var$fixedSizeTruncateStyles = null;
var $5ff71f2a31bb5d22$var$cellStyles = null;
var $5ff71f2a31bb5d22$export$e93312b7773dfcac = function Head(_ref) {
    var isRanking = _ref.isRanking, testId = _ref.testId, props = (0, $cxbbJ.default)(_ref, $5ff71f2a31bb5d22$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement("thead", (0, $7wyUQ.default)({
        "data-testid": testId
    }, props, {
        className: (0, $gpt5O.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    }));
};
var $5ff71f2a31bb5d22$var$headCellBaseStyles = null;
var $5ff71f2a31bb5d22$var$headCellBaseStylesOld = null;
var $5ff71f2a31bb5d22$var$onClickStyles = null;
var $5ff71f2a31bb5d22$var$baseStyles = null;
var $5ff71f2a31bb5d22$var$ascendingStyles = null;
var $5ff71f2a31bb5d22$var$descendingStyles = null;
var $5ff71f2a31bb5d22$export$4e8024263ace498b = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var width = _ref2.width, children = _ref2.children, isSortable = _ref2.isSortable, sortOrder = _ref2.sortOrder, isFixedSize = _ref2.isFixedSize, shouldTruncate = _ref2.shouldTruncate, onClick = _ref2.onClick, style = _ref2.style, testId = _ref2.testId, rest = (0, $cxbbJ.default)(_ref2, $5ff71f2a31bb5d22$var$_excluded2);
    var mergedStyles = $5ff71f2a31bb5d22$var$_objectSpread($5ff71f2a31bb5d22$var$_objectSpread($5ff71f2a31bb5d22$var$_objectSpread({}, style), width && (0, $jSrVq.getTruncationStyleVars)({
        width: width
    })), {}, (0, $eKFRo.default)({}, $5ff71f2a31bb5d22$var$CSS_VAR_TEXT_COLOR, "var(--ds-text-subtlest, ".concat((0, $cvWPm.N300), ")")));
    var isASC = sortOrder === (0, $gZthg.ASC);
    var isDESC = sortOrder === (0, $gZthg.DESC);
    var getFormattedSortOrder = function getFormattedSortOrder() {
        if (isASC) return "ascending";
        else if (isDESC) return "descending";
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    var Component = children ? "th" : "td";
    var isVisuallyRefreshed = (0, $jxLBU.fg)("platform-component-visual-refresh");
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $7wyUQ.default)({
        "aria-sort": getFormattedSortOrder(),
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId
    }, rest, {
        className: (0, $gpt5O.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            isVisuallyRefreshed ? "_11c8dcr7 _179rralu _mqm2glyw _kqswh2mm _syaz12fi _k48pmoej _y3gn1e5h _s7n4nkob _1ygbuwsq" : "_11c8dcr7 _179rralu _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz12fi _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbuwsq",
            !isVisuallyRefreshed && onClick && "_irr3bfnf _d0altlke",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk1j28 _1wfn1j28 _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77k1f6e _qzvtu2gc _f4731f6e _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b",
            !isVisuallyRefreshed && isASC && "_c77k2wk4 _142s94yt",
            !isVisuallyRefreshed && isDESC && "_f4732wk4 _17x894yt"
        ]),
        style: $5ff71f2a31bb5d22$var$_objectSpread($5ff71f2a31bb5d22$var$_objectSpread({}, mergedStyles), {}, {
            "--_k02y3n": (0, $cRJ4t.default)("2px solid ".concat("var(--ds-border, ".concat((0, $cvWPm.N40), ")"))),
            "--_17ckjys": (0, $cRJ4t.default)("var(--ds-text-subtle, ".concat("var(".concat($5ff71f2a31bb5d22$var$CSS_VAR_TEXT_COLOR, ")"), ")")),
            "--_jz8ahf": (0, $cRJ4t.default)("solid 2px ".concat("var(--ds-border-focused, ".concat((0, $cvWPm.B100), ")"))),
            "--_6j4ewu": (0, $cRJ4t.default)("var(--ds-background-neutral-hovered, ".concat((0, $cvWPm.N30A), ")")),
            "--_1rdacuj": (0, $cRJ4t.default)("3px solid ".concat("var(--ds-icon-disabled, ".concat((0, $cvWPm.N40), ")"))),
            "--_1qca9zt": (0, $cRJ4t.default)("3px solid ".concat("var(--ds-icon-subtle, ".concat((0, $cvWPm.N300), ")")))
        })
    }), children);
});

});

parcelRegister("Yr4r8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b5a9a5c566e8f40$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $lyawF = parcelRequire("lyawF");

var $dgt68 = parcelRequire("dgt68");

var $ixuga = parcelRequire("ixuga");

var $hqZvY = parcelRequire("hqZvY");

var $kUu2a = parcelRequire("kUu2a");

var $iSvIT = parcelRequire("iSvIT");

var $dPF8I = parcelRequire("dPF8I");

var $8n6Ta = parcelRequire("8n6Ta");

var $5ukl3 = parcelRequire("5ukl3");
var $0b5a9a5c566e8f40$var$_excluded = [
    "isRanking",
    "refHeight",
    "refWidth"
];
function $0b5a9a5c566e8f40$var$_callSuper(t, o, e) {
    return o = (0, $hqZvY.default)(o), (0, $ixuga.default)(t, $0b5a9a5c566e8f40$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hqZvY.default)(t).constructor) : o.apply(t, e));
}
function $0b5a9a5c566e8f40$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0b5a9a5c566e8f40$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $0b5a9a5c566e8f40$var$RankableTableHeadCellComponent = /*#__PURE__*/ function(_React$Component) {
    function RankableTableHeadCellComponent() {
        (0, $lyawF.default)(this, RankableTableHeadCellComponent);
        return $0b5a9a5c566e8f40$var$_callSuper(this, RankableTableHeadCellComponent, arguments);
    }
    (0, $kUu2a.default)(RankableTableHeadCellComponent, _React$Component);
    return (0, $dgt68.default)(RankableTableHeadCellComponent, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, isRanking = _this$props.isRanking, refHeight = _this$props.refHeight, refWidth = _this$props.refWidth, restProps = (0, $cxbbJ.default)(_this$props, $0b5a9a5c566e8f40$var$_excluded);
                var inlineStyles = (0, $8n6Ta.inlineStylesIfRanking)(isRanking, refWidth);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5ukl3.default), (0, $7wyUQ.default)({
                    inlineStyles: inlineStyles
                }, restProps));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Component);
var $0b5a9a5c566e8f40$var$RankableTableHeadCell = (0, $dPF8I.default)($0b5a9a5c566e8f40$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0b5a9a5c566e8f40$export$2e2bcd8739ae039 = $0b5a9a5c566e8f40$var$RankableTableHeadCell;

});
parcelRegister("dPF8I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a11ff343087d7ab0$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $lyawF = parcelRequire("lyawF");

var $dgt68 = parcelRequire("dgt68");

var $ixuga = parcelRequire("ixuga");

var $hqZvY = parcelRequire("hqZvY");

var $kUu2a = parcelRequire("kUu2a");

var $eKFRo = parcelRequire("eKFRo");

var $iSvIT = parcelRequire("iSvIT");
function $a11ff343087d7ab0$var$_callSuper(t, o, e) {
    return o = (0, $hqZvY.default)(o), (0, $ixuga.default)(t, $a11ff343087d7ab0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hqZvY.default)(t).constructor) : o.apply(t, e));
}
function $a11ff343087d7ab0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a11ff343087d7ab0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a11ff343087d7ab0$export$2e2bcd8739ae039(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        function WithDimensions() {
            var _this;
            (0, $lyawF.default)(this, WithDimensions);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $a11ff343087d7ab0$var$_callSuper(this, WithDimensions, [].concat(args));
            (0, $eKFRo.default)(_this, "state", {
                refWidth: 0,
                refHeight: 0
            });
            (0, $eKFRo.default)(_this, "innerRef", function(ref) {
                if (ref && !_this.props.isRanking) _this.ref = ref;
            });
            (0, $eKFRo.default)(_this, "updateDimensions", function() {
                if (!_this.ref) return;
                var clientRect = _this.ref.getBoundingClientRect();
                var width = clientRect.width;
                var height = clientRect.height;
                if (width !== _this.state.refWidth || height !== _this.state.refHeight) _this.setState({
                    refWidth: width,
                    refHeight: height
                });
            });
            return _this;
        }
        (0, $kUu2a.default)(WithDimensions, _React$Component);
        return (0, $dgt68.default)(WithDimensions, [
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    var wasRanking = this.props.isRanking;
                    var willRanking = nextProps.isRanking;
                    if (willRanking && !wasRanking) this.updateDimensions();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$state = this.state, refWidth = _this$state.refWidth, refHeight = _this$state.refHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(WrappedComponent, (0, $7wyUQ.default)({
                        refWidth: refWidth,
                        refHeight: refHeight,
                        innerRef: this.innerRef
                    }, this.props));
                }
            }
        ]);
    }((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Component);
}

});

parcelRegister("5ukl3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fef87e7bdc37521$export$2e2bcd8739ae039; });
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7wyUQ = parcelRequire("7wyUQ");

var $lgwoD = parcelRequire("lgwoD");

var $cxbbJ = parcelRequire("cxbbJ");

var $gpt5O = parcelRequire("gpt5O");

var $iSvIT = parcelRequire("iSvIT");

var $lzGN0 = parcelRequire("lzGN0");

var $hWh1T = parcelRequire("hWh1T");

var $ksogg = parcelRequire("ksogg");
var $2hfcF = parcelRequire("2hfcF");
var $bCvsg = parcelRequire("bCvsg");

var $bAF3p = parcelRequire("bAF3p");

var $gZthg = parcelRequire("gZthg");

var $8eOUt = parcelRequire("8eOUt");
var $3fef87e7bdc37521$var$_excluded = [
    "content",
    "inlineStyles",
    "testId",
    "isRanking",
    "innerRef",
    "isSortable",
    "sortOrder",
    "onClick",
    "headCellId",
    "activeSortButtonId",
    "ascendingSortTooltip",
    "descendingSortTooltip",
    "buttonAriaRoleDescription",
    "isIconOnlyHeader"
];
var $3fef87e7bdc37521$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
var $3fef87e7bdc37521$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syaz1gjq _k48pmoej"
};
var $3fef87e7bdc37521$var$TableHeadCell = function TableHeadCell(_ref) {
    var content = _ref.content, inlineStyles = _ref.inlineStyles, testId = _ref.testId, isRanking = _ref.isRanking, innerRef = _ref.innerRef, isSortable = _ref.isSortable, sortOrder = _ref.sortOrder, onClick = _ref.onClick, headCellId = _ref.headCellId, activeSortButtonId = _ref.activeSortButtonId, _ref$ascendingSortToo = _ref.ascendingSortTooltip, ascendingSortTooltip = _ref$ascendingSortToo === void 0 ? "Sort ascending" : _ref$ascendingSortToo, _ref$descendingSortTo = _ref.descendingSortTooltip, descendingSortTooltip = _ref$descendingSortTo === void 0 ? "Sort descending" : _ref$descendingSortTo, _ref$buttonAriaRoleDe = _ref.buttonAriaRoleDescription, buttonAriaRoleDescription = _ref$buttonAriaRoleDe === void 0 ? "Sort button" : _ref$buttonAriaRoleDe, isIconOnlyHeader = _ref.isIconOnlyHeader, rest = (0, $cxbbJ.default)(_ref, $3fef87e7bdc37521$var$_excluded);
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $lgwoD.default)(_useState, 2), isHovered = _useState2[0], setIsHovered = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(false), _useState4 = (0, $lgwoD.default)(_useState3, 2), isFocused = _useState4[0], setIsFocused = _useState4[1];
    var isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    var isSortIconVisible = isHovered || isActive || isFocused;
    var isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    var shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    var handleFocus = (0, $iSvIT.useCallback)(function() {
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(true);
    }, [
        setIsFocused
    ]);
    var handleBlur = (0, $iSvIT.useCallback)(function() {
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(false);
    }, [
        setIsFocused
    ]);
    var handleMouseEnter = (0, $iSvIT.useCallback)(function() {
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    var handleMouseLeave = (0, $iSvIT.useCallback)(function() {
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    var visuallyRefreshedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ksogg.default), {
        xcss: $3fef87e7bdc37521$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bAF3p.default), {
        content: sortOrder === (0, $gZthg.ASC) ? ascendingSortTooltip : descendingSortTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bCvsg.default), {
        onClick: onClick,
        xcss: $3fef87e7bdc37521$var$styles.buttonWrapper,
        "aria-roledescription": buttonAriaRoleDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2hfcF.default), {
        xcss: isVisibleIconOnlyHeader ? $3fef87e7bdc37521$var$styles.hideIconHeaderWrapper : $3fef87e7bdc37521$var$styles.visibleHeaderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $gpt5O.default)([
            $3fef87e7bdc37521$var$headCellStyles.text
        ])
    }, content)), shouldRenderSortIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2hfcF.default), {
        xcss: isSortIconVisible ? $3fef87e7bdc37521$var$styles.sortIconVisibleWrapper : $3fef87e7bdc37521$var$styles.sortIconHiddenWrapper
    }, sortOrder === (0, $gZthg.ASC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWh1T))), {
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        testId: testId && "".concat(testId, "--up--icon")
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lzGN0))), {
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        testId: testId && "".concat(testId, "--down--icon")
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8eOUt.HeadCell), (0, $7wyUQ.default)({
        style: inlineStyles,
        testId: testId && "".concat(testId, "--head--cell"),
        ref: typeof innerRef !== "string" ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs
    }, rest, {
        isSortable: isSortable,
        sortOrder: sortOrder
    }), isSortable ? visuallyRefreshedButton : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3fef87e7bdc37521$export$2e2bcd8739ae039 = $3fef87e7bdc37521$var$TableHeadCell;

});
parcelRegister("lzGN0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb4e0ef749a78415$var$_react = $fb4e0ef749a78415$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fb4e0ef749a78415$var$_baseNew = $fb4e0ef749a78415$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $fb4e0ef749a78415$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb4e0ef749a78415$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $fb4e0ef749a78415$var$_react.default.createElement($fb4e0ef749a78415$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$fb4e0ef749a78415$var$ArrowDownIcon.displayName = "ArrowDownIcon";
var $fb4e0ef749a78415$var$_default = module.exports.default = $fb4e0ef749a78415$var$ArrowDownIcon;

});

parcelRegister("hWh1T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $035eca9539192339$var$_react = $035eca9539192339$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $035eca9539192339$var$_baseNew = $035eca9539192339$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $035eca9539192339$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $035eca9539192339$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $035eca9539192339$var$_react.default.createElement($035eca9539192339$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$035eca9539192339$var$ArrowUpIcon.displayName = "ArrowUpIcon";
var $035eca9539192339$var$_default = module.exports.default = $035eca9539192339$var$ArrowUpIcon;

});

parcelRegister("bCvsg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $875ba49c1176ee81$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");


var $c9xhG = parcelRequire("c9xhG");

var $6RvuE = parcelRequire("6RvuE");

var $96Wvt = parcelRequire("96Wvt");

var $jiOHx = parcelRequire("jiOHx");

var $7nG8r = parcelRequire("7nG8r");

var $h4Ezw = parcelRequire("h4Ezw");
var $875ba49c1176ee81$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $875ba49c1176ee81$var$_excluded2 = [
    "className"
];
var $875ba49c1176ee81$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $875ba49c1176ee81$var$Pressable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $jiOHx.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $cxbbJ.default)(_ref, $875ba49c1176ee81$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $6RvuE.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.11.2",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $cxbbJ.default)(htmlAttributes, $875ba49c1176ee81$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement((0, $h4Ezw.default), (0, $7wyUQ.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $96Wvt.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $c9xhG.cx)($875ba49c1176ee81$var$styles.root, isDisabled && $875ba49c1176ee81$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $875ba49c1176ee81$export$2e2bcd8739ae039 = $875ba49c1176ee81$var$Pressable;

});
parcelRegister("96Wvt", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $6a220ec4ec5b1fda$export$95df08bae54cb4df; });
function $6a220ec4ec5b1fda$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? //@ts-expect-error ignore userAgentData type issue
    re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $6a220ec4ec5b1fda$var$isIPhone() {
    return $6a220ec4ec5b1fda$var$testPlatform(/^iPhone/i);
}
function $6a220ec4ec5b1fda$var$isMac() {
    return $6a220ec4ec5b1fda$var$testPlatform(/^Mac/i);
}
function $6a220ec4ec5b1fda$var$isIPad() {
    return $6a220ec4ec5b1fda$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $6a220ec4ec5b1fda$var$isMac() && navigator.maxTouchPoints > 1;
}
function $6a220ec4ec5b1fda$var$isIOS() {
    return $6a220ec4ec5b1fda$var$isIPhone() || $6a220ec4ec5b1fda$var$isIPad();
}
function $6a220ec4ec5b1fda$export$95df08bae54cb4df() {
    if (typeof window !== "undefined" && window.navigator != null) {
        var _window$navigator$use2;
        var ua = (_window$navigator$use2 = window.navigator.userAgent) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.toLowerCase();
        return ua ? ua.includes("safari") && !ua.includes("chrome") : false;
    }
    return false;
}
function $6a220ec4ec5b1fda$export$e1865c3bedcd822b() {
    return $6a220ec4ec5b1fda$var$isMac() || $6a220ec4ec5b1fda$var$isIOS();
}

});

parcelRegister("h4Ezw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6e2482748afdd29$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7wyUQ = parcelRequire("7wyUQ");

var $eKFRo = parcelRequire("eKFRo");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");
var $cRJ4t = parcelRequire("cRJ4t");
var $c6e2482748afdd29$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $c6e2482748afdd29$var$_excluded2 = [
    "className"
];
function $c6e2482748afdd29$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c6e2482748afdd29$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c6e2482748afdd29$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c6e2482748afdd29$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c6e2482748afdd29$var$focusRingStyles = null;
var $c6e2482748afdd29$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $c6e2482748afdd29$var$Focusable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $cxbbJ.default)(_ref, $c6e2482748afdd29$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $cxbbJ.default)(htmlAttributes, $c6e2482748afdd29$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $7wyUQ.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $gpt5O.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $c6e2482748afdd29$var$_objectSpread($c6e2482748afdd29$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $cRJ4t.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $c6e2482748afdd29$export$2e2bcd8739ae039 = $c6e2482748afdd29$var$Focusable;

});


parcelRegister("bAF3p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8702e6f3c189831d$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $lgwoD = parcelRequire("lgwoD");

var $eKFRo = parcelRequire("eKFRo");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $eE8kO = parcelRequire("eE8kO");

var $jiOHx = parcelRequire("jiOHx");

var $ldREQ = parcelRequire("ldREQ");

var $7ymsy = parcelRequire("7ymsy");

var $1Z36a = parcelRequire("1Z36a");

var $iy0QV = parcelRequire("iy0QV");
var $g2f6i = parcelRequire("g2f6i");

var $jxLBU = parcelRequire("jxLBU");

var $gr749 = parcelRequire("gr749");

var $gWVOm = parcelRequire("gWVOm");

var $l7eXL = parcelRequire("l7eXL");

var $6cf1B = parcelRequire("6cf1B");

var $9oLQ2 = parcelRequire("9oLQ2");

var $cdCDz = parcelRequire("cdCDz");

var $fd77T = parcelRequire("fd77T");

var $2ZtFq = parcelRequire("2ZtFq");
function $8702e6f3c189831d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8702e6f3c189831d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8702e6f3c189831d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8702e6f3c189831d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8702e6f3c189831d$var$tooltipZIndex = (0, $l7eXL.layers).tooltip();
var $8702e6f3c189831d$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.4.0"
};
// Inverts motion direction
var $8702e6f3c189831d$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $8702e6f3c189831d$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $8702e6f3c189831d$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $fd77T.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $jiOHx.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $jiOHx.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $eE8kO.usePlatformLeafSyntheticEventHandler)($8702e6f3c189831d$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $8702e6f3c189831d$var$analyticsAttributes));
    var onHideHandler = (0, $eE8kO.usePlatformLeafSyntheticEventHandler)($8702e6f3c189831d$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $8702e6f3c189831d$var$analyticsAttributes));
    var apiRef = (0, $iSvIT.useRef)(null);
    var _useState = (0, $iSvIT.useState)("hide"), _useState2 = (0, $lgwoD.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $iSvIT.useRef)(null);
    var containerRef = (0, $iSvIT.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $iSvIT.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $7ymsy.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $7ymsy.default)(onShowHandler);
    var onHideHandlerStable = (0, $7ymsy.default)(onHideHandler);
    var delayStable = (0, $7ymsy.default)(delay);
    var canAppearStable = (0, $7ymsy.default)(canAppear);
    var hasCalledShowHandler = (0, $iSvIT.useRef)(false);
    var start = (0, $iSvIT.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $iSvIT.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $iSvIT.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $iSvIT.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $iSvIT.useRef)(false);
    (0, $iSvIT.useEffect)(function() {
        return (0, $6cf1B.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $iSvIT.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $9oLQ2.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $iSvIT.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $ldREQ.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $iSvIT.useEffect)(function() {
        if (state === "hide") return 0, $jiOHx.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $2e1kT.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $iSvIT.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $iSvIT.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $iSvIT.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $2ZtFq.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $iSvIT.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $2ZtFq.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $iSvIT.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $iSvIT.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(":focus-visible") && (0, $jxLBU.fg)("platform-tooltip-focus-visible-new")) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $iSvIT.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $iSvIT.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var handleOpenLayerObserverCloseSignal = (0, $iSvIT.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $1Z36a.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === "mouse" && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $cdCDz.default)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $iSvIT.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children($8702e6f3c189831d$var$_objectSpread($8702e6f3c189831d$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(CastTargetContainer, (0, $7wyUQ.default)({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gWVOm.default), {
        zIndex: $8702e6f3c189831d$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gr749.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $8702e6f3c189831d$var$invertedDirection[$8702e6f3c189831d$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iy0QV.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $g2f6i.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $8702e6f3c189831d$var$_objectSpread($8702e6f3c189831d$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $8702e6f3c189831d$export$2e2bcd8739ae039 = $8702e6f3c189831d$var$Tooltip;

});
parcelRegister("eE8kO", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $aa9b443943cd0925$export$1a04351537078b55; });

var $eKFRo = parcelRequire("eKFRo");

var $iSvIT = parcelRequire("iSvIT");

var $8pdcq = parcelRequire("8pdcq");

var $iIL7u = parcelRequire("iIL7u");
function $aa9b443943cd0925$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aa9b443943cd0925$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aa9b443943cd0925$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aa9b443943cd0925$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $aa9b443943cd0925$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8pdcq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $iIL7u.useTrackedRef)(analyticsData);
    var fnRef = (0, $iIL7u.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $aa9b443943cd0925$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("ldREQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7346f2bc6883473$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $jxLBU = parcelRequire("jxLBU");

var $6keAl = parcelRequire("6keAl");
function $f7346f2bc6883473$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $iSvIT.useRef)(false);
    var onKeyDown = (0, $iSvIT.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $6keAl.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $iSvIT.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $iSvIT.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled && (0, $jxLBU.fg)("platform_only_attach_escape_handler_on_view")) return;
        return (0, $2e1kT.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("6keAl", function(module, exports) {

$parcel$export(module.exports, "ESCAPE", function () { return $013041c0b10f46c7$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $013041c0b10f46c7$export$390330c10ff2b9a1 = "ArrowUp";
var $013041c0b10f46c7$export$a80636c6f41931fe = "ArrowDown";
var $013041c0b10f46c7$export$4af703091671bc = "Home";
var $013041c0b10f46c7$export$e2bc30913faa5db7 = "End";
var $013041c0b10f46c7$export$10f6869ed0a7d75b = "Tab";
var $013041c0b10f46c7$export$8152f929a25a0ff4 = "Enter";
var $013041c0b10f46c7$export$e51a3576c045c8d5 = "Space";
var $013041c0b10f46c7$export$2bb790b9008907b4 = "Escape";

});


parcelRegister("7ymsy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57fd216327149b3a$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $57fd216327149b3a$export$2e2bcd8739ae039(value) {
    var ref = (0, $iSvIT.useRef)(value);
    (0, $iSvIT.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("6cf1B", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $482f84ab2ff47610$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $2e1kT = parcelRequire("2e1kT");
var $482f84ab2ff47610$var$registrations = new Set();
var $482f84ab2ff47610$var$cleanupEndEventListeners = null;
function $482f84ab2ff47610$var$onDragStart() {
    if ($482f84ab2ff47610$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $482f84ab2ff47610$var$cleanupEndEventListeners = (0, $2e1kT.bindAll)(window, [
        {
            type: "dragend",
            listener: $482f84ab2ff47610$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $482f84ab2ff47610$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $482f84ab2ff47610$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($482f84ab2ff47610$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $482f84ab2ff47610$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $482f84ab2ff47610$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $482f84ab2ff47610$var$cleanupEndEventListeners = null;
    var clone = Array.from($482f84ab2ff47610$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $482f84ab2ff47610$var$bindStartEvents() {
    return (0, $2e1kT.bindAll)(window, [
        {
            type: "dragstart",
            listener: $482f84ab2ff47610$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $482f84ab2ff47610$var$onDragStart
        }
    ]);
}
var $482f84ab2ff47610$var$cleanupStartEventListeners = null;
function $482f84ab2ff47610$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$482f84ab2ff47610$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $482f84ab2ff47610$var$cleanupStartEventListeners = $482f84ab2ff47610$var$bindStartEvents();
    $482f84ab2ff47610$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $482f84ab2ff47610$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $482f84ab2ff47610$var$registrations.delete(registration);
        if ($482f84ab2ff47610$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $482f84ab2ff47610$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $482f84ab2ff47610$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("9oLQ2", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $6d7b769de8011dd3$export$57bf213be019eeb0; });

var $jU5iV = parcelRequire("jU5iV");
// This file is a singleton for managing tooltips
var $6d7b769de8011dd3$var$active = null;
function $6d7b769de8011dd3$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($6d7b769de8011dd3$var$active && $6d7b769de8011dd3$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $jU5iV.clearScheduled)();
            $6d7b769de8011dd3$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $jU5iV.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $jU5iV.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $jU5iV.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($6d7b769de8011dd3$var$active && $6d7b769de8011dd3$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($6d7b769de8011dd3$var$active) {
            (0, $jU5iV.clearScheduled)();
            $6d7b769de8011dd3$var$active.entry.hide({
                isImmediate: true
            });
            $6d7b769de8011dd3$var$active.entry.done();
            $6d7b769de8011dd3$var$active = null;
        }
        // this tooltip is now the active tooltip
        $6d7b769de8011dd3$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $jU5iV.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("jU5iV", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $e7d75c9cb273f3b6$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $e7d75c9cb273f3b6$export$5f4d6617421d489b; });
var $e7d75c9cb273f3b6$var$delayId = null;
function $e7d75c9cb273f3b6$export$eaf678f6f93f5250() {
    if ($e7d75c9cb273f3b6$var$delayId != null) {
        window.clearTimeout($e7d75c9cb273f3b6$var$delayId);
        $e7d75c9cb273f3b6$var$delayId = null;
    }
}
function $e7d75c9cb273f3b6$export$5f4d6617421d489b(fn, delay) {
    $e7d75c9cb273f3b6$export$eaf678f6f93f5250();
    $e7d75c9cb273f3b6$var$delayId = window.setTimeout(function() {
        $e7d75c9cb273f3b6$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("cdCDz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e54ab7c7abe9c46$export$2e2bcd8739ae039; });

var $5pb5F = parcelRequire("5pb5F");
function $8e54ab7c7abe9c46$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $5pb5F.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("5pb5F", function(module, exports) {

$parcel$export(module.exports, "useIdSeed", function () { return $3ef7e3e589fdb41d$export$6ee17796e3d70de2; });

var $5xjzf = parcelRequire("5xjzf");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $jxLBU = parcelRequire("jxLBU");
var $3ef7e3e589fdb41d$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $3ef7e3e589fdb41d$var$react18UseId = ($3ef7e3e589fdb41d$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $3ef7e3e589fdb41d$var$_React$useId !== void 0 ? $3ef7e3e589fdb41d$var$_React$useId : undefined;
function $3ef7e3e589fdb41d$export$f680877a34711e37() {
    if ($3ef7e3e589fdb41d$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) return $3ef7e3e589fdb41d$var$react18UseId();
    return "uid".concat((0, $lzzak.useUID)());
}
var $3ef7e3e589fdb41d$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($3ef7e3e589fdb41d$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $5xjzf.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $5xjzf.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $3ef7e3e589fdb41d$export$6ee17796e3d70de2() {
    if ($3ef7e3e589fdb41d$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        var uid = $3ef7e3e589fdb41d$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $lzzak.useUIDSeed)();
}

});


parcelRegister("fd77T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b12d990eb2be97f7$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eKFRo = parcelRequire("eKFRo");

var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");
var $cRJ4t = parcelRequire("cRJ4t");

var $cvWPm = parcelRequire("cvWPm");

var $hbGNH = parcelRequire("hbGNH");
function $b12d990eb2be97f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b12d990eb2be97f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b12d990eb2be97f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eKFRo.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b12d990eb2be97f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b12d990eb2be97f7$var$baseStyles = null;
var $b12d990eb2be97f7$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $b12d990eb2be97f7$var$TooltipContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement((0, $hbGNH.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gpt5O.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $b12d990eb2be97f7$var$_objectSpread($b12d990eb2be97f7$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $cRJ4t.default)("var(--ds-background-neutral-bold, ".concat((0, $cvWPm.N800), ")")),
            "--_ywovvi": (0, $cRJ4t.default)("var(--ds-text-inverse, ".concat((0, $cvWPm.N0), ")"))
        })
    }, children);
});
$b12d990eb2be97f7$var$TooltipContainer.displayName = "TooltipContainer";
var $b12d990eb2be97f7$export$2e2bcd8739ae039 = $b12d990eb2be97f7$var$TooltipContainer;

});
parcelRegister("hbGNH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c834aa0c052c30af$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $gpt5O = parcelRequire("gpt5O");
var $c834aa0c052c30af$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $c834aa0c052c30af$var$TooltipPrimitive = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        role: "tooltip",
        className: (0, $gpt5O.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$c834aa0c052c30af$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $c834aa0c052c30af$export$2e2bcd8739ae039 = $c834aa0c052c30af$var$TooltipPrimitive;

});


parcelRegister("2ZtFq", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $22d84a8a3447fdef$export$642213d516a9b928; });
function $22d84a8a3447fdef$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});




parcelRegister("csDsz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9126b57783c174a9$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $lyawF = parcelRequire("lyawF");

var $dgt68 = parcelRequire("dgt68");

var $ixuga = parcelRequire("ixuga");

var $hqZvY = parcelRequire("hqZvY");

var $kUu2a = parcelRequire("kUu2a");

var $iSvIT = parcelRequire("iSvIT");

var $dPF8I = parcelRequire("dPF8I");

var $8n6Ta = parcelRequire("8n6Ta");

var $fAckW = parcelRequire("fAckW");
var $9126b57783c174a9$var$_excluded = [
    "isRanking",
    "refHeight",
    "refWidth"
];
function $9126b57783c174a9$var$_callSuper(t, o, e) {
    return o = (0, $hqZvY.default)(o), (0, $ixuga.default)(t, $9126b57783c174a9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hqZvY.default)(t).constructor) : o.apply(t, e));
}
function $9126b57783c174a9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9126b57783c174a9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $9126b57783c174a9$var$RankableTableHeadCellComponentOld = /*#__PURE__*/ function(_React$Component) {
    function RankableTableHeadCellComponentOld() {
        (0, $lyawF.default)(this, RankableTableHeadCellComponentOld);
        return $9126b57783c174a9$var$_callSuper(this, RankableTableHeadCellComponentOld, arguments);
    }
    (0, $kUu2a.default)(RankableTableHeadCellComponentOld, _React$Component);
    return (0, $dgt68.default)(RankableTableHeadCellComponentOld, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, isRanking = _this$props.isRanking, refHeight = _this$props.refHeight, refWidth = _this$props.refWidth, restProps = (0, $cxbbJ.default)(_this$props, $9126b57783c174a9$var$_excluded);
                var inlineStyles = (0, $8n6Ta.inlineStylesIfRanking)(isRanking, refWidth);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $fAckW.default), (0, $7wyUQ.default)({
                    inlineStyles: inlineStyles
                }, restProps));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Component);
var $9126b57783c174a9$var$RankableTableHeadCellOld = (0, $dPF8I.default)($9126b57783c174a9$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9126b57783c174a9$export$2e2bcd8739ae039 = $9126b57783c174a9$var$RankableTableHeadCellOld;

});
parcelRegister("fAckW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b583c99eefb6ed11$export$2e2bcd8739ae039; });

var $7wyUQ = parcelRequire("7wyUQ");

var $cxbbJ = parcelRequire("cxbbJ");

var $iSvIT = parcelRequire("iSvIT");

var $8eOUt = parcelRequire("8eOUt");
var $b583c99eefb6ed11$var$_excluded = [
    "content",
    "inlineStyles",
    "testId",
    "isRanking",
    "innerRef",
    "isSortable",
    "onClick"
];
var $b583c99eefb6ed11$var$TableHeadCellOld = function TableHeadCellOld(_ref) {
    var content = _ref.content, inlineStyles = _ref.inlineStyles, testId = _ref.testId, isRanking = _ref.isRanking, innerRef = _ref.innerRef, isSortable = _ref.isSortable, onClick = _ref.onClick, rest = (0, $cxbbJ.default)(_ref, $b583c99eefb6ed11$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8eOUt.HeadCell), (0, $7wyUQ.default)({
        style: inlineStyles,
        testId: testId && "".concat(testId, "--head--cell"),
        ref: typeof innerRef !== "string" ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs
    }, rest, {
        onClick: onClick,
        isSortable: isSortable
    }), isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b583c99eefb6ed11$export$2e2bcd8739ae039 = $b583c99eefb6ed11$var$TableHeadCellOld;

});



parcelRegister("b9eLC", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("s96vI")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("enmhV"))
]).then(()=>parcelRequire("lcoLE"));

});
parcelRegister("frKV3", function(module, exports) {
"use strict";

var $jhlcP = parcelRequire("jhlcP");
module.exports = $jhlcP(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("jhlcP", function(module, exports) {
"use strict";
var $039f3a07df33262a$var$cachedBundles = {};
var $039f3a07df33262a$var$cachedPreloads = {};
var $039f3a07df33262a$var$cachedPrefetches = {};
function $039f3a07df33262a$var$getCache(type) {
    switch(type){
        case "preload":
            return $039f3a07df33262a$var$cachedPreloads;
        case "prefetch":
            return $039f3a07df33262a$var$cachedPrefetches;
        default:
            return $039f3a07df33262a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $039f3a07df33262a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("hzK4Z", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf; }, function (v) { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ccb972f8f1c5733b$export$f7ad0328861e2f03; }, function (v) { return $ccb972f8f1c5733b$export$f7ad0328861e2f03 = v; });
var $ccb972f8f1c5733b$export$6503ec6e8aabbaf;
var $ccb972f8f1c5733b$export$f7ad0328861e2f03;
"use strict";
var $ccb972f8f1c5733b$var$mapping = new Map();
function $ccb972f8f1c5733b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ccb972f8f1c5733b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ccb972f8f1c5733b$var$resolve(id) {
    var resolved = $ccb972f8f1c5733b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ccb972f8f1c5733b$export$6503ec6e8aabbaf = $ccb972f8f1c5733b$var$register;
$ccb972f8f1c5733b$export$f7ad0328861e2f03 = $ccb972f8f1c5733b$var$resolve;

});



parcelRegister("eRD7U", function(module, exports) {

$parcel$export(module.exports, "EmptySearchVector", function () { return (parcelRequire("kQisC")).EmptySearchVector; });

var $kQisC = parcelRequire("kQisC");

});
parcelRegister("kQisC", function(module, exports) {

$parcel$export(module.exports, "EmptySearchVector", function () { return $7fe60463f5646de5$export$df81497daaac8d1d; });

var $loA2J = parcelRequire("loA2J");
const $7fe60463f5646de5$export$df81497daaac8d1d = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "49",
        height: "54",
        viewBox: "0 0 49 54",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M38.1406 12.9633C37.5384 11.8084 36.7995 10.6593 35.9181 9.51897C35.025 8.36406 34.0824 7.34588 33.105 6.46151C27.2839 1.20188 20.1304 0.718969 13.4308 4.35242C12.2875 4.97206 11.1588 5.71097 10.0504 6.56624C8.89553 7.45933 7.85699 8.4077 6.93771 9.3997C1.75081 14.9968 0.42135 22.0281 4.01699 28.9517C4.62499 30.1212 5.37262 31.2877 6.26572 32.4455C7.14717 33.5859 8.07517 34.5895 9.04099 35.4622C14.8243 40.6841 21.9719 41.1699 28.7035 37.551C29.8963 36.911 31.0744 36.1459 32.2294 35.2528C33.3377 34.3975 34.3355 33.487 35.2228 32.5386C40.433 26.9619 41.7624 19.9044 38.1348 12.9633H38.1406Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M19.9996 41.8919C15.5778 41.8919 11.3479 40.2279 7.70867 36.9436C6.64686 35.9836 5.63158 34.881 4.69195 33.6679C3.74067 32.4374 2.9174 31.1603 2.25122 29.8745C-1.62951 22.4068 -0.454237 14.4505 5.4774 8.04758C6.48104 6.96539 7.60976 5.93558 8.83158 4.99012C10.0098 4.07958 11.2374 3.27376 12.4796 2.59885C20.1538 -1.56406 28.1596 -0.694242 34.4403 4.98139C35.5138 5.95303 36.5407 7.06721 37.4949 8.29776C38.4345 9.51085 39.2461 10.7705 39.9094 12.0388C43.8309 19.5414 42.6556 27.5094 36.6861 33.8978C35.7232 34.9305 34.6352 35.9167 33.4541 36.8272C32.2294 37.7727 30.9494 38.6076 29.6519 39.3058C26.4374 41.0338 23.1676 41.889 19.9996 41.889V41.8919ZM22.1087 3.98649C19.5923 3.98649 16.9858 4.68758 14.3792 6.1043C13.3261 6.67739 12.2789 7.36394 11.2665 8.14357C10.2163 8.95521 9.25049 9.83376 8.39813 10.7559C3.60976 15.9254 2.68176 22.0607 5.78576 28.0359C6.34431 29.1094 7.03667 30.1858 7.8454 31.2272C8.63958 32.2541 9.49194 33.1821 10.3821 33.985C15.3741 38.4941 21.5472 39.137 27.7669 35.7974C28.8723 35.2039 29.9661 34.4912 31.0163 33.6767C32.0287 32.8941 32.9538 32.0534 33.7741 31.1778C38.5887 26.0258 39.5109 19.8847 36.3778 13.8861C35.825 12.8272 35.1385 11.7654 34.3443 10.7385C33.5356 9.69412 32.6716 8.75158 31.7727 7.93994C28.8636 5.31303 25.5705 3.98649 22.1145 3.98649H22.1087Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M36.4418 35.9924C35.4119 34.5582 34.3065 34.5669 33.2272 35.4018C32.2148 36.1844 31.9443 37.2433 33.0236 38.6367L34.257 40.2309L37.6752 37.5865L36.4418 35.9924Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M38.5348 36.9226L33.4026 40.8906L43.0469 53.3644L48.1791 49.3963L38.5348 36.9226Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M37.7098 37.5597L34.2278 40.252L37.4983 44.482L40.9804 41.7898L37.7098 37.5597Z",
                fill: "#B7B9BE"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.8362 25.8099H19.9262V25.6254C19.8271 23.5554 21.0019 21.3142 22.6724 20.3969L22.7036 20.3804C22.7489 20.3569 22.7925 20.3295 22.8349 20.3014C23.7464 19.7136 24.2651 18.7018 24.2332 17.5871C24.2014 16.4827 23.6315 15.5115 22.7088 14.9899C22.1258 14.66 21.4759 14.4858 20.8286 14.4858C18.8581 14.4858 17.2549 16.1002 17.2549 18.0846H14.3442C14.3442 14.4848 17.2529 11.5557 20.8282 11.5557C21.9739 11.5557 23.1168 11.8598 24.1338 12.435C25.9556 13.4653 27.0802 15.3598 27.1416 17.5028C27.2036 19.6555 26.184 21.622 24.4151 22.7627C24.2963 22.8408 24.1748 22.9132 24.0547 22.9763C23.3611 23.366 22.7804 24.566 22.8339 25.5038L22.8362 25.8102V25.8099Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.0997 27.4903C21.2463 27.4658 21.4063 27.4512 21.5703 27.4512C21.7092 27.4512 21.8667 27.4593 22.0325 27.4874C22.9812 27.6431 23.7528 28.3085 23.9401 29.3445L23.9415 29.3524L23.9428 29.3602C23.9669 29.5047 23.9819 29.662 23.9819 29.8279C23.9819 29.9928 23.9671 30.1521 23.9417 30.2991L23.9412 30.3021C23.7578 31.3491 22.9743 32.012 22.0294 32.166C21.8661 32.193 21.7139 32.2017 21.5703 32.2017C21.4035 32.2017 21.248 32.1865 21.1057 32.1636L21.1051 32.1635C20.1555 32.0098 19.3803 31.3454 19.1919 30.3095L19.1904 30.3011L19.189 30.2927C19.1653 30.1504 19.1499 29.9958 19.1499 29.8279C19.1499 29.662 19.1649 29.5047 19.189 29.3602L19.1904 29.3518L19.1919 29.3434C19.3812 28.3027 20.1594 27.6479 21.0986 27.4905L21.0997 27.4903Z",
                fill: "#DDDEE1"
            })
        ]
    });

});


parcelRegister("7B32R", function(module, exports) {

$parcel$export(module.exports, "FastshiftTablePagination", function () { return (parcelRequire("5WUb7")).FastshiftTablePagination; });

var $5WUb7 = parcelRequire("5WUb7");

});
parcelRegister("5WUb7", function(module, exports) {

$parcel$export(module.exports, "FastshiftTablePagination", function () { return $51ef74bafcd289bb$export$371a8aee6982c805; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $9B16h = parcelRequire("9B16h");

var $4a5Re = parcelRequire("4a5Re");
var $3Oabj = parcelRequire("3Oabj");

var $4vcv5 = parcelRequire("4vcv5");

var $jKp9A = parcelRequire("jKp9A");
var $g2DEO = parcelRequire("g2DEO");
var $7akU3 = parcelRequire("7akU3");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $cDmHV = parcelRequire("cDmHV");

var $bEPPl = parcelRequire("bEPPl");
const $51ef74bafcd289bb$var$paginationSectionStyles = (0, $jAMCU.xcss)({
    borderColor: "color.border",
    borderWidth: "1px",
    borderRadius: "border.radius.100",
    borderStartStartRadius: "0",
    borderStartEndRadius: "0",
    borderBlockStart: "0",
    borderStyle: "solid",
    padding: "space.150"
});
const $51ef74bafcd289bb$export$371a8aee6982c805 = ({ pagination: pagination })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g2DEO.default), {
        justifyContent: "space-between",
        alignItems: "center",
        xcss: $51ef74bafcd289bb$var$paginationSectionStyles,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                alignBlock: "center",
                alignInline: "center",
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                        color: "color.text.subtle",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bEPPl.messages).resultsPerPageLabel))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
                        style: {
                            width: "80px"
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4a5Re.default), {
                            // This is atlaskit's recommended pattern for custom trigger components
                            // eslint-disable-next-line react/no-unstable-nested-components
                            trigger: (_param)=>/*#__PURE__*/ {
                                var { triggerRef: triggerRef } = _param, providedProps = (0, $akGnX._)(_param, [
                                    "triggerRef"
                                ]);
                                return (0, $loA2J.jsx)($51ef74bafcd289bb$var$DropdownMenuTrigger, (0, $6iHNw._)((0, $7Knp0._)({
                                    triggerRef: triggerRef
                                }, providedProps), {
                                    pagination: pagination
                                }));
                            },
                            shouldRenderToParent: true,
                            spacing: "compact",
                            children: (0, $cDmHV.PAGE_SIZE_OPTIONS).map((option)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $3Oabj.default), {
                                    onClick: ()=>{
                                        pagination.onSizeChange(option.value);
                                    },
                                    isSelected: option.value === pagination.size,
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                                        children: option.label
                                    })
                                }, option.value))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
                spread: "space-between",
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                    alignBlock: "center",
                    alignInline: "center",
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $bEPPl.messages).resultsCountText), {
                                values: {
                                    startIndex: pagination.totalElements === 0 ? 0 : pagination.page * pagination.size + 1,
                                    endIndex: pagination.totalElements === 0 ? 0 : Math.min((pagination.page + 1) * pagination.size, pagination.totalElements),
                                    totalCount: pagination.totalElements
                                }
                            }))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                            onClick: pagination.onClickPrevious,
                            spacing: "compact",
                            isDisabled: !pagination.hasPrevious,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bEPPl.messages).previousButton))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                            onClick: pagination.onClickNext,
                            spacing: "compact",
                            isDisabled: !pagination.hasNext,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bEPPl.messages).nextButton))
                        })
                    ]
                })
            })
        ]
    });
};
const $51ef74bafcd289bb$var$DropdownMenuTrigger = (_param)=>/*#__PURE__*/ {
    var { triggerRef: triggerRef, pagination: pagination } = _param, providedProps = (0, $akGnX._)(_param, [
        "triggerRef",
        "pagination"
    ]);
    return (0, $loA2J.jsx)((0, $9B16h.default), (0, $6iHNw._)((0, $7Knp0._)({
        ref: triggerRef
    }, providedProps), {
        spacing: "compact",
        onClick: (e)=>{
            var // sendClickDropdownEvent();
            _providedProps_onClick;
            (_providedProps_onClick = providedProps.onClick) === null || _providedProps_onClick === void 0 ? void 0 : _providedProps_onClick.call(providedProps, e);
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
            space: "space.100",
            alignInline: "center",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                    children: pagination.size
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4vcv5))), {
                    label: "Chevron down icon",
                    size: "small"
                })
            ]
        })
    }));
};

});
parcelRegister("bEPPl", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $0e01a9195b44648c$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $0e01a9195b44648c$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    resultsPerPageLabel: {
        id: "fastshift.customer-selection.domain-selection-table.results-per-page-label",
        defaultMessage: "Results per page:",
        description: "Label for results per page dropdown"
    },
    resultsCountText: {
        id: "fastshift.customer-selection.domain-selection-table.results-count-text",
        defaultMessage: "{startIndex}-{endIndex} of {totalCount} results",
        description: "Text showing current page results count"
    },
    previousButton: {
        id: "fastshift.customer-selection.domain-selection-table.previous-button",
        defaultMessage: "Previous",
        description: "Previous page button text"
    },
    nextButton: {
        id: "fastshift.customer-selection.domain-selection-table.next-button",
        defaultMessage: "Next",
        description: "Next page button text"
    }
});

});



parcelRegister("kftet", function(module, exports) {

$parcel$export(module.exports, "FastshiftTableSearch", function () { return (parcelRequire("bPqst")).FastshiftTableSearch; });

var $bPqst = parcelRequire("bPqst");

});
parcelRegister("bPqst", function(module, exports) {

$parcel$export(module.exports, "FastshiftTableSearch", function () { return $9a314b15f185337a$export$337fb2e9ac52585b; });
/* fastshift-table-search.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dRxyd = parcelRequire("dRxyd");

var $f6qj2 = parcelRequire("f6qj2");

var $509Ny = parcelRequire("509Ny");

var $g2DEO = parcelRequire("g2DEO");
var $cgOuH = parcelRequire("cgOuH");
var $jAMCU = parcelRequire("jAMCU");

var $7OGW4 = parcelRequire("7OGW4");

var $7haYE = parcelRequire("7haYE");
const $9a314b15f185337a$var$searchIconContainerStyles = (0, $jAMCU.xcss)({
    paddingInlineStart: "space.100"
});
const $9a314b15f185337a$var$searchInputContainerStyles = null;
const $9a314b15f185337a$export$337fb2e9ac52585b = ({ search: search, id: id = "fastshift-table-search", testId: testId = "fastshift-table-search" })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { onSetSearchTerm: onSetSearchTerm, searchTerm: searchTerm } = search;
    const [inputValue, setInputValue] = (0, $iSvIT.useState)(searchTerm);
    (0, $iSvIT.useEffect)(()=>{
        setInputValue(searchTerm);
    }, [
        searchTerm
    ]);
    const debouncedSetSearchTerm = (0, $iSvIT.useMemo)(()=>(0, $dRxyd.debounce)((value)=>onSetSearchTerm(value), 500), [
        onSetSearchTerm
    ]);
    (0, $iSvIT.useEffect)(()=>{
        return ()=>{
            debouncedSetSearchTerm.cancel();
        };
    }, [
        debouncedSetSearchTerm
    ]);
    const handleInputChange = (0, $iSvIT.useCallback)((event)=>{
        const value = event.target.value;
        setInputValue(value);
        debouncedSetSearchTerm(value);
    }, [
        debouncedSetSearchTerm
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cgOuH.default), {
        space: "space.200",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1bsbuuw1 _zt0yzgxb _pytkzwfg _prm0u2gc"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), {
                appearance: "standard",
                id: `${id}-input`,
                testId: `${testId}-input`,
                placeholder: formatMessage((0, $7haYE.messages).searchPlaceholder),
                onChange: handleInputChange,
                value: inputValue,
                elemBeforeInput: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2DEO.default), {
                    xcss: $9a314b15f185337a$var$searchIconContainerStyles,
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($509Ny))), {
                        label: formatMessage((0, $7haYE.messages).searchLabel),
                        size: "medium"
                    })
                })
            })
        })
    });
};

});
parcelRegister("7haYE", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $fee8d629bd3b58f0$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $fee8d629bd3b58f0$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    searchPlaceholder: {
        id: "fastshift.customer-selection.domain-selection-table-search.search-placeholder",
        defaultMessage: "Search",
        description: "Placeholder for the search input"
    },
    searchLabel: {
        id: "fastshift.customer-selection.domain-selection-table-search.search-label",
        defaultMessage: "Search",
        description: "Label for the search input"
    }
});

});



parcelRegister("jKbhD", function(module, exports) {

$parcel$export(module.exports, "FastshiftTableWrapper", function () { return (parcelRequire("7LUEM")).FastshiftTableWrapper; });

var $7LUEM = parcelRequire("7LUEM");

});
parcelRegister("7LUEM", function(module, exports) {

$parcel$export(module.exports, "FastshiftTableWrapper", function () { return $aa1347ecce08f661$export$aca5068f6432850d; });
/* fastshift-table-wrapper.tsx generated by @compiled/babel-plugin v0.28.8 */ // Dynamic table is not composable currently, this is an override similar to AdminHub's TableWrapper
// We may make this generic for additional tables across Fastshift.
/* eslint-disable-next-line local/no-block-disable-of-nested-eslint */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $aa1347ecce08f661$var$StyledFastshiftTableWrapper = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_7yjtidpf _ldgnidpf _un3pidpf _29hzidpf _r8iguia5 _v5rg1wug _r93f1y44 _tuer1y44 _1nnouia5 _1pkkuia5 _i4czuia5 _1lmscfaq _kdhhuia5 _1esuu2gc _1ngwu2gc _1d28t94y _1vtcuia5 _1y73azsu _vejeglyw _1450xh9o _1a0zuia5 _1x7iglyw _a2nzu2gc _2jlbuia5 _w7vcglyw _1uq6glyw _80tlu2gc _u0xiu2gc _g3wlu2gc _1whbu2gc",
            __cmplp.className
        ])
    }));
});
const $aa1347ecce08f661$export$aca5068f6432850d = ({ children: children, id: id = "fastshift-table-wrapper", testId: testId = "fastshift-table-wrapper" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($aa1347ecce08f661$var$StyledFastshiftTableWrapper, {
        "data-testid": testId,
        id: id,
        children: children
    });
};

});


parcelRegister("j14dD", function(module, exports) {

$parcel$export(module.exports, "useFastshiftTableAnalytics", function () { return (parcelRequire("2hGd2")).useFastshiftTableAnalytics; });
$parcel$export(module.exports, "useFastshiftTableControls", function () { return (parcelRequire("282AX")).useFastshiftTableControls; });

var $2hGd2 = parcelRequire("2hGd2");
parcelRequire("c8DBP");
var $282AX = parcelRequire("282AX");

});
parcelRegister("2hGd2", function(module, exports) {

$parcel$export(module.exports, "useFastshiftTableAnalytics", function () { return $26641aae0828c661$export$2addd2cd93f089b7; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $h0mGD = parcelRequire("h0mGD");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
const $26641aae0828c661$var$TABLE_EVENT_TYPE = {
    SEARCH: "search",
    PAGE_SIZE: "pageSize",
    SORT: "sort",
    NAVIGATION: "navigation"
};
const $26641aae0828c661$var$getActionSubjectIdBySource = (source, eventType)=>{
    var _mapping_source;
    const mapping = {
        [(0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_SELECTION_SCREEN]: {
            [$26641aae0828c661$var$TABLE_EVENT_TYPE.SEARCH]: (0, $k7z8r.ActionSubjectIdKey).DOMAIN_SELECTION_TABLE_SEARCH,
            [$26641aae0828c661$var$TABLE_EVENT_TYPE.PAGE_SIZE]: (0, $k7z8r.ActionSubjectIdKey).SELECTION_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM,
            [$26641aae0828c661$var$TABLE_EVENT_TYPE.SORT]: (0, $k7z8r.ActionSubjectIdKey).SELECTION_TABLE_COLUMN_SORT,
            [$26641aae0828c661$var$TABLE_EVENT_TYPE.NAVIGATION]: (0, $k7z8r.ActionSubjectIdKey).SELECTION_TABLE_PAGE_NAVIGATION_BUTTON
        },
        [(0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_FOR_YOU_SCREEN]: {
            [$26641aae0828c661$var$TABLE_EVENT_TYPE.PAGE_SIZE]: (0, $k7z8r.ActionSubjectIdKey).FASTSHIFT_MIGRATION_PROGRESS_TABLE_CHANGE_PAGE_SIZE_DROPDOWN_ITEM,
            [$26641aae0828c661$var$TABLE_EVENT_TYPE.NAVIGATION]: (0, $k7z8r.ActionSubjectIdKey).FASTSHIFT_MIGRATION_PROGRESS_TABLE_PAGE_NAVIGATION_BUTTON
        }
    };
    return (_mapping_source = mapping[source]) === null || _mapping_source === void 0 ? void 0 : _mapping_source[eventType];
};
const $26641aae0828c661$export$2addd2cd93f089b7 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $h0mGD.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    const sendSearchUIEvent = (0, $iSvIT.useCallback)(()=>{
        const actionSubjectId = $26641aae0828c661$var$getActionSubjectIdBySource(sourceKey, $26641aae0828c661$var$TABLE_EVENT_TYPE.SEARCH);
        if (!actionSubjectId) return;
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).SUBMITTED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).SEARCH,
            actionSubjectId: actionSubjectId,
            source: sourceKey
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendNavigationUIEvent = (0, $iSvIT.useCallback)((buttonType, totalPages)=>{
        const actionSubjectId = $26641aae0828c661$var$getActionSubjectIdBySource(sourceKey, $26641aae0828c661$var$TABLE_EVENT_TYPE.NAVIGATION);
        if (!actionSubjectId) return;
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).BUTTON,
            actionSubjectId: actionSubjectId,
            source: sourceKey,
            attributes: {
                buttonType: buttonType,
                totalPages: totalPages
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendPageSizeChangeUIEvent = (0, $iSvIT.useCallback)((newPageSize)=>{
        const actionSubjectId = $26641aae0828c661$var$getActionSubjectIdBySource(sourceKey, $26641aae0828c661$var$TABLE_EVENT_TYPE.PAGE_SIZE);
        if (!actionSubjectId) return;
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).DROPDOWN_ITEM,
            actionSubjectId: actionSubjectId,
            source: sourceKey,
            attributes: {
                newPageSize: newPageSize
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendSortUIEvent = (0, $iSvIT.useCallback)((column, direction)=>{
        const actionSubjectId = $26641aae0828c661$var$getActionSubjectIdBySource(sourceKey, $26641aae0828c661$var$TABLE_EVENT_TYPE.SORT);
        if (!actionSubjectId) return;
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).TABLE_COLUMN_SORT,
            actionSubjectId: actionSubjectId,
            source: sourceKey,
            attributes: {
                columnTitle: column,
                sortType: direction
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendSearchUIEvent: sendSearchUIEvent,
        sendNavigationUIEvent: sendNavigationUIEvent,
        sendPageSizeChangeUIEvent: sendPageSizeChangeUIEvent,
        sendSortUIEvent: sendSortUIEvent
    };
};

});

parcelRegister("c8DBP", function(module, exports) {

$parcel$export(module.exports, "useFastshiftTableControls", function () { return (parcelRequire("282AX")).useFastshiftTableControls; });

var $282AX = parcelRequire("282AX");

});
parcelRegister("282AX", function(module, exports) {

$parcel$export(module.exports, "useFastshiftTableControls", function () { return $2b2cb136ddba6aa3$export$5b9b8621863ff48f; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $iSvIT = parcelRequire("iSvIT");
const $2b2cb136ddba6aa3$export$5b9b8621863ff48f = ({ pagination: pagination, controls: controls, onSetControlsPayload: onSetControlsPayload })=>{
    // Local state
    const searchTerm = (controls === null || controls === void 0 ? void 0 : controls.searchTerm) || "";
    const onClickNext = (0, $iSvIT.useCallback)(()=>{
        onSetControlsPayload((0, $6iHNw._)((0, $7Knp0._)({}, controls), {
            page: pagination.page + 1
        }));
    }, [
        onSetControlsPayload,
        pagination.page,
        controls
    ]);
    const onClickPrevious = (0, $iSvIT.useCallback)(()=>{
        onSetControlsPayload((0, $6iHNw._)((0, $7Knp0._)({}, controls), {
            page: pagination.page - 1
        }));
    }, [
        onSetControlsPayload,
        pagination.page,
        controls
    ]);
    const onSizeChange = (0, $iSvIT.useCallback)((size)=>{
        onSetControlsPayload((0, $6iHNw._)((0, $7Knp0._)({}, controls), {
            page: 0,
            size: size
        }));
    }, [
        onSetControlsPayload,
        controls
    ]);
    const onSort = (0, $iSvIT.useCallback)((key, order)=>{
        onSetControlsPayload((0, $6iHNw._)((0, $7Knp0._)({}, controls), {
            page: 0,
            sortBy: key,
            sortDirection: order
        }));
    }, [
        onSetControlsPayload,
        controls
    ]);
    const onSetSearchTerm = (0, $iSvIT.useCallback)((searchTerm)=>{
        onSetControlsPayload((0, $6iHNw._)((0, $7Knp0._)({}, controls), {
            page: 0,
            searchTerm: searchTerm
        }));
    }, [
        onSetControlsPayload,
        controls
    ]);
    return {
        pagination: (0, $7Knp0._)({
            onClickNext: onClickNext,
            onClickPrevious: onClickPrevious,
            onSizeChange: onSizeChange
        }, pagination),
        sorting: {
            onSort: onSort,
            sortBy: controls === null || controls === void 0 ? void 0 : controls.sortBy,
            sortDirection: controls === null || controls === void 0 ? void 0 : controls.sortDirection
        },
        search: {
            onSetSearchTerm: onSetSearchTerm,
            searchTerm: searchTerm
        }
    };
};

});



parcelRegister("252Eh", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $3f2d238fde0e2ff4$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $3f2d238fde0e2ff4$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    emptyTableMessage: {
        id: "fastshift.table.empty-table-message",
        defaultMessage: "We couldn\u2019t find what you\u2019re looking for",
        description: "Message for empty table"
    }
});

});



parcelRegister("7cU9H", function(module, exports) {

$parcel$export(module.exports, "NO_ORG_FILTER", function () { return $546d2cbc86f0975c$export$30872958cab48234; });
$parcel$export(module.exports, "OTHER_ORG_FILTER", function () { return $546d2cbc86f0975c$export$5104ef36eb44df08; });
$parcel$export(module.exports, "DEFAULT_ORG_FILTERS_ORDER", function () { return $546d2cbc86f0975c$export$4984c21048c8fcf6; });
parcelRequire("7zqwM");
var $k4eOf = parcelRequire("k4eOf");
const $546d2cbc86f0975c$export$30872958cab48234 = {
    orgId: (0, $k4eOf.DROPDOWN_ORG_ID).NO_ORG,
    orgName: "No Org" // do not display this name on UI
};
const $546d2cbc86f0975c$export$5104ef36eb44df08 = {
    orgId: (0, $k4eOf.DROPDOWN_ORG_ID).OTHER_ORGS,
    orgName: "Other Cloud Orgs" // do not display this name on UI
};
const $546d2cbc86f0975c$export$4984c21048c8fcf6 = [
    $546d2cbc86f0975c$export$5104ef36eb44df08,
    $546d2cbc86f0975c$export$30872958cab48234
];

});

parcelRegister("jxfFm", function(module, exports) {

$parcel$export(module.exports, "getStatusCategoryStyleMapping", function () { return $07bd305f47d27c72$export$ac16f2895bad9e64; });
const $07bd305f47d27c72$export$ac16f2895bad9e64 = (status)=>{
    switch(status){
        case "atlassian investigating":
            return "inprogress";
        case "completed":
            return "success";
        default:
            return "default";
    }
};

});

parcelRegister("bqaPF", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $4cf12818e79af0bb$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $4cf12818e79af0bb$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    migrationStatusTableSourceColumnTitle: {
        id: "fastshift.dashboard.migration-status-table.source-column-title",
        defaultMessage: "Source",
        description: "Column title for the source column in the migration status table"
    },
    migrationStatusTableDestinationColumnTitle: {
        id: "fastshift.dashboard.migration-status-table.destination-column-title",
        defaultMessage: "Destination",
        description: "Column title for the destination column in the migration status table"
    },
    migrationStatusTablePhaseColumnTitle: {
        id: "fastshift.dashboard.migration-status-table.Phase-column-title",
        defaultMessage: "Phase",
        description: "Column title for the Phase column in the migration status table"
    },
    migrationStatusTableStatusColumnTitle: {
        id: "fastshift.dashboard.migration-status-table.status-column-title",
        defaultMessage: "Status",
        description: "Column title for the status column in the migration status table"
    },
    migrationStatusTableTicketColumnTitle: {
        id: "fastshift.dashboard.migration-status-table.ticket-column-title",
        defaultMessage: "Ticket",
        description: "Column title for the ticket column in the migration status table"
    },
    migrationStatusTablePlanToMigrateDateColumnTitle: {
        id: "fastshift.dashboard.migration-status-table.plan-to-migrate-date-column-title",
        defaultMessage: "Plan to migrate date",
        description: "Column title for the plan to migrate date column in the migration status table"
    },
    migrationStatusTableSourceDestinationColumnContentDefault: {
        id: "fastshift.dashboard.migration-status-table.source-column-content-default",
        defaultMessage: "Atlassian product",
        description: "Column content for the source column and destination column in the migration status table when the product is unknown"
    },
    migrationStatusTableSourceDestinationColumnContentNoBaseUrl: {
        id: "fastshift.dashboard.migration-status-table.source-column-content-no-base-url",
        defaultMessage: "url not available",
        description: "Column content for the source column and destination column in the migration status table when the source base URL is not available"
    },
    migrationStatusTablePlanToMigrateDateColumnContentDefault: {
        id: "fastshift.dashboard.migration-status-table.plan-to-migrate-date-column-content-default",
        defaultMessage: "Pending",
        description: "Column content for the plan to migrate date column in the migration status table when the date is not available"
    },
    migrationStatusTableJiraProductName: {
        id: "fastshift.dashboard.migration-status-table.jira-product-name",
        defaultMessage: "Jira",
        description: "Column content for the Jira product name in the migration status table"
    },
    migrationStatusTableConfluenceProductName: {
        id: "fastshift.dashboard.migration-status-table.confluence-product-name",
        defaultMessage: "Confluence",
        description: "Column content for the Confluence product name in the migration status table"
    }
});

});

parcelRegister("gXwuJ", function(module, exports) {

$parcel$export(module.exports, "useDashboardUIAnalytics", function () { return $e87c09cff354b575$export$c2d1539a2ef03c27; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $ag6tB = parcelRequire("ag6tB");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");

var $ddzL3 = parcelRequire("ddzL3");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");
const $e87c09cff354b575$export$c2d1539a2ef03c27 = ()=>{
    const { data: supportRequests } = (0, $8KnwD.useFastshiftSelector)((state)=>state.supportRequests);
    const identityAttrs = (0, $ag6tB.useCustomerIdentityAttrs)(true);
    const { fireUIEvent: fireUIEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    const hasRequestAssistancePathway = (0, $iSvIT.useMemo)(()=>!!(supportRequests === null || supportRequests === void 0 ? void 0 : supportRequests.some((req)=>(0, $ddzL3.isSupportRequestOpen)(req.status))), [
        supportRequests
    ]);
    // UI event callbacks
    const sendOrgSelectorDropdownClickUIEvent = (0, $iSvIT.useCallback)(()=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).DROPDOWN,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).ORG_SELECTOR_DROPDOWN,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_FOR_YOU_SCREEN,
            attributes: {
                hasRequestAssistancePathway: hasRequestAssistancePathway
            }
        });
    }, [
        fireUIEvent,
        hasRequestAssistancePathway
    ]);
    const sendOrgSelectorDropdownItemClickUIEvent = (0, $iSvIT.useCallback)((selectedOrgId)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).DROPDOWN_ITEM,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).ORG_SELECTOR_DROPDOWN,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_FOR_YOU_SCREEN,
            attributes: {
                selectedOrgId: selectedOrgId
            }
        });
    }, [
        fireUIEvent
    ]);
    const sendMigrationSummarySectionLinkClickUIEvent = (0, $iSvIT.useCallback)((subject, selectedOrgId)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).LINK,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).MIGRATION_SUMMARY_SECTION,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_FOR_YOU_SCREEN,
            attributes: {
                subject: subject,
                selectedOrgId: selectedOrgId
            }
        });
    }, [
        fireUIEvent
    ]);
    const sendMigrationProgressTableOpenSupportTicketClickUIEvent = (0, $iSvIT.useCallback)((senId, ticketId)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).LINK,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).FASTSHIFT_MIGRATION_PROGRESS_TABLE_OPEN_SUPPORT_TICKET_CLICK,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_FOR_YOU_SCREEN,
            attributes: {
                senId: senId,
                ticketId: ticketId
            }
        });
    }, [
        fireUIEvent
    ]);
    return {
        sendOrgSelectorDropdownClickUIEvent: sendOrgSelectorDropdownClickUIEvent,
        sendOrgSelectorDropdownItemClickUIEvent: sendOrgSelectorDropdownItemClickUIEvent,
        sendMigrationSummarySectionLinkClickUIEvent: sendMigrationSummarySectionLinkClickUIEvent,
        sendMigrationProgressTableOpenSupportTicketClickUIEvent: sendMigrationProgressTableOpenSupportTicketClickUIEvent
    };
};

});


parcelRegister("b7yur", function(module, exports) {

$parcel$export(module.exports, "useDashboardPageAnalytics", function () { return $545485cdb5a23ef5$export$2bd0b0fa8a15d1c5; });

var $7Knp0 = parcelRequire("7Knp0");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $ag6tB = parcelRequire("ag6tB");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");

var $gmpgY = parcelRequire("gmpgY");
parcelRequire("3oQlK");
var $cHgxm = parcelRequire("cHgxm");
var $cKTNL = parcelRequire("cKTNL");
const $545485cdb5a23ef5$export$2bd0b0fa8a15d1c5 = ()=>{
    const { data: customerDomain } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomain);
    const { data: userDetails } = (0, $8KnwD.useFastshiftSelector)((state)=>state.userDetails);
    const { data: supportRequests, pending: supportRequestsPending } = (0, $8KnwD.useFastshiftSelector)((state)=>state.supportRequests);
    const { domainOrg: domainOrg } = (0, $cHgxm.useOrg)();
    const { summaryData: summaryData, isLoading: summaryLoading, isEmpty: summaryEmpty } = (0, $cKTNL.useSummary)();
    const identityAttrs = (0, $ag6tB.useCustomerIdentityAttrs)();
    const { fireScreenEvent: fireScreenEvent, fireTrackEvent: fireTrackEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    const lastFiredKeyRef = (0, $iSvIT.useRef)(null);
    // Screen event
    (0, $iSvIT.useEffect)(()=>{
        if (!identityAttrs) return;
        fireScreenEvent({
            name: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_FOR_YOU_SCREEN
        });
    }, [
        fireScreenEvent,
        identityAttrs
    ]);
    // Track event - when a different org is selected and all migration data is loaded
    (0, $iSvIT.useEffect)(()=>{
        if (!customerDomain || !identityAttrs || !domainOrg || summaryLoading || supportRequestsPending) return;
        const attrs = (0, $gmpgY.buildForYouPageDetailsAttributes)({
            customerDomain: customerDomain,
            domainOrg: domainOrg,
            summaryData: summaryData,
            summaryEmpty: summaryEmpty,
            supportRequests: supportRequests
        });
        if (!attrs) return;
        const key = JSON.stringify((0, $7Knp0._)({}, identityAttrs, attrs));
        if (lastFiredKeyRef.current === key) return;
        fireTrackEvent({
            action: (0, $k7z8r.ActionKey).DISPLAYED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).SECTION,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).FOR_YOU_PAGE_DETAILS,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_FOR_YOU_SCREEN,
            attributes: attrs
        });
        lastFiredKeyRef.current = key;
    }, [
        customerDomain,
        userDetails,
        domainOrg,
        summaryLoading,
        summaryEmpty,
        summaryData,
        supportRequests,
        supportRequestsPending,
        identityAttrs,
        fireTrackEvent
    ]);
};

});
parcelRegister("gmpgY", function(module, exports) {

$parcel$export(module.exports, "buildForYouPageDetailsAttributes", function () { return $d489aaa84962ef47$export$6231480d55d5c5c9; });

var $bHtXm = parcelRequire("bHtXm");

var $ddzL3 = parcelRequire("ddzL3");
parcelRequire("7zqwM");
var $k4eOf = parcelRequire("k4eOf");
const $d489aaa84962ef47$export$8e3def920b6ced5f = (productName)=>{
    const normalizedName = (productName !== null && productName !== void 0 ? productName : "").toUpperCase();
    return normalizedName === (0, $bHtXm.PRODUCT_NAME).JIRA || normalizedName === (0, $bHtXm.PRODUCT_NAME).CONFLUENCE;
};
function $d489aaa84962ef47$export$6231480d55d5c5c9(args) {
    const { customerDomain: customerDomain, domainOrg: domainOrg, summaryData: summaryData, summaryEmpty: summaryEmpty, supportRequests: supportRequests } = args;
    var _domainOrg_orgId;
    // orgs & support counts
    const selectedOrgId = (_domainOrg_orgId = domainOrg.orgId) !== null && _domainOrg_orgId !== void 0 ? _domainOrg_orgId : (0, $k4eOf.NO_ORG_ID);
    const orgCount = customerDomain.orgsWithAdminRole.length;
    const planTicketCount = supportRequests.length;
    const planTicketList = supportRequests.map((req)=>req.supportTicketId);
    // summary section
    const summaryCardsDisplayed = !summaryEmpty;
    const noAssessmentsBannerDisplayed = selectedOrgId !== (0, $k4eOf.NO_ORG_ID) && summaryEmpty;
    var _summaryData_dataCenter_count;
    const countAssessedInstances = (_summaryData_dataCenter_count = summaryData.dataCenter.count) !== null && _summaryData_dataCenter_count !== void 0 ? _summaryData_dataCenter_count : null;
    var _summaryData_areaImprovement_count;
    const countAreasToImprove = (_summaryData_areaImprovement_count = summaryData.areaImprovement.count) !== null && _summaryData_areaImprovement_count !== void 0 ? _summaryData_areaImprovement_count : null;
    var _summaryData_deletedApps_count;
    const countDetectedApps = (_summaryData_deletedApps_count = summaryData.deletedApps.count) !== null && _summaryData_deletedApps_count !== void 0 ? _summaryData_deletedApps_count : null;
    var _summaryData_migrationCompleted_count;
    const countMigrationsCompleted = (_summaryData_migrationCompleted_count = summaryData.migrationCompleted.count) !== null && _summaryData_migrationCompleted_count !== void 0 ? _summaryData_migrationCompleted_count : null;
    var _summaryData_migrationInProgress_count;
    const countMigrationsInProgress = (_summaryData_migrationInProgress_count = summaryData.migrationInProgress.count) !== null && _summaryData_migrationInProgress_count !== void 0 ? _summaryData_migrationInProgress_count : null;
    var _summaryData_unsuccessfulMigration_count;
    const countUnsuccessfulMigrations = (_summaryData_unsuccessfulMigration_count = summaryData.unsuccessfulMigration.count) !== null && _summaryData_unsuccessfulMigration_count !== void 0 ? _summaryData_unsuccessfulMigration_count : null;
    // request fastshift assistance section
    const hasRequestAssistancePathway = supportRequests.some((req)=>(0, $ddzL3.isSupportRequestOpen)(req.status));
    // data Quality of Progress Table
    const rowsMissingProductIcon = supportRequests.filter((r)=>{
        const sourceSupported = $d489aaa84962ef47$export$8e3def920b6ced5f(r.source.productName);
        const destinationSupported = $d489aaa84962ef47$export$8e3def920b6ced5f(r.destination.productName);
        return !(sourceSupported && destinationSupported);
    }).length;
    return {
        selectedOrgId: selectedOrgId,
        orgCount: orgCount,
        planTicketCount: planTicketCount,
        planTicketList: planTicketList,
        summaryCardsDisplayed: summaryCardsDisplayed,
        noAssessmentsBannerDisplayed: noAssessmentsBannerDisplayed,
        countAssessedInstances: countAssessedInstances,
        countAreasToImprove: countAreasToImprove,
        countDetectedApps: countDetectedApps,
        countMigrationsCompleted: countMigrationsCompleted,
        countMigrationsInProgress: countMigrationsInProgress,
        countUnsuccessfulMigrations: countUnsuccessfulMigrations,
        hasRequestAssistancePathway: hasRequestAssistancePathway,
        rowsMissingProductIcon: rowsMissingProductIcon
    };
}

});



parcelRegister("Vqc64", function(module, exports) {

$parcel$export(module.exports, "MigrationStatusTable", function () { return (parcelRequire("5NmAE")).MigrationStatusTable; });

var $5NmAE = parcelRequire("5NmAE");

});
parcelRegister("5NmAE", function(module, exports) {

$parcel$export(module.exports, "MigrationStatusTable", function () { return $5267cd53feb16b51$export$b53f90b5d00d2ada; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $gf1F9 = parcelRequire("gf1F9");

var $cgOuH = parcelRequire("cgOuH");
parcelRequire("5m8h9");
var $5wrp0 = parcelRequire("5wrp0");
parcelRequire("2al5y");
var $505JK = parcelRequire("505JK");

var $5woPH = parcelRequire("5woPH");

var $a9hbu = parcelRequire("a9hbu");
const $5267cd53feb16b51$export$b53f90b5d00d2ada = ()=>{
    const { isTableLoading: isTableLoading, isTableError: isTableError, rows: rows, head: head, controls: controls, handleRefresh: handleRefresh } = (0, $5woPH.useMigrationStatusTable)();
    const intl = (0, $f6qj2.default)();
    const ErrorComponent = /*#__PURE__*/ (0, $loA2J.jsx)((0, $5wrp0.GenericErrorDisplay), {
        customMessage: intl.formatMessage((0, $a9hbu.messages).errorMessageDescription),
        onRefresh: handleRefresh
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $a9hbu.messages).migrationStatusTableHeading))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $505JK.FastshiftTable), {
                id: "migration-status-table",
                enableSearch: false,
                isTableLoading: isTableLoading,
                isTableError: isTableError,
                errorComponent: ErrorComponent,
                head: head,
                rows: rows,
                controls: controls
            })
        ]
    });
};

});
parcelRegister("5m8h9", function(module, exports) {

$parcel$export(module.exports, "FourOhFourDisplay", function () { return (parcelRequire("2Brms")).FourOhFourDisplay; });
$parcel$export(module.exports, "GenericErrorDisplay", function () { return (parcelRequire("5wrp0")).GenericErrorDisplay; });
parcelRequire("lH9YA");
var $2Brms = parcelRequire("2Brms");
parcelRequire("5D3Xj");
var $5wrp0 = parcelRequire("5wrp0");

});
parcelRegister("lH9YA", function(module, exports) {

$parcel$export(module.exports, "FourOhFourDisplay", function () { return (parcelRequire("2Brms")).FourOhFourDisplay; });

var $2Brms = parcelRequire("2Brms");

});
parcelRegister("2Brms", function(module, exports) {

$parcel$export(module.exports, "FourOhFourDisplay", function () { return $d06626c94d532606$export$9203c83241c79bee; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $gf1F9 = parcelRequire("gf1F9");

var $9FeWi = parcelRequire("9FeWi");
var $jKp9A = parcelRequire("jKp9A");
var $g2DEO = parcelRequire("g2DEO");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");
parcelRequire("5XMUP");
var $gbLaZ = parcelRequire("gbLaZ");
parcelRequire("lI6Aw");
var $lBR5P = parcelRequire("lBR5P");
parcelRequire("dZXEE");
var $jfrRJ = parcelRequire("jfrRJ");

var $bO1py = parcelRequire("bO1py");
const $d06626c94d532606$var$iconContainerStyles = (0, $jAMCU.xcss)({
    width: "180px",
    height: "180px"
});
const $d06626c94d532606$export$9203c83241c79bee = ()=>{
    const { paths: paths } = (0, $gbLaZ.useRoutes)();
    const intl = (0, $f6qj2.default)();
    const { sendGoBackToHomeLinkClickUIEvent: sendGoBackToHomeLinkClickUIEvent } = (0, $jfrRJ.use404DisplayAnalytics)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
        padding: "space.400",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
            alignBlock: "center",
            space: "space.300",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2DEO.default), {
                    xcss: $d06626c94d532606$var$iconContainerStyles,
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lBR5P.CautionVector), {})
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $bO1py.messages).fourOhFourHeading))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $bO1py.messages).fourOhFourDescription), {
                        values: {
                            "404Link": /*#__PURE__*/ (0, $loA2J.jsx)((0, $9FeWi.default), {
                                href: paths.home,
                                onClick: ()=>sendGoBackToHomeLinkClickUIEvent(),
                                children: intl.formatMessage((0, $bO1py.messages).fourOhFourLinkText)
                            })
                        }
                    }))
                })
            ]
        })
    });
};

});
parcelRegister("9FeWi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $709387fef29c328e$export$2e2bcd8739ae039; });

var $aB34E = parcelRequire("aB34E");

var $hFZ5s = parcelRequire("hFZ5s");

var $2OPES = parcelRequire("2OPES");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jNYFj = parcelRequire("jNYFj");

var $4xoZa = parcelRequire("4xoZa");

var $1rsGj = parcelRequire("1rsGj");

var $4OZuI = parcelRequire("4OZuI");

var $dWwnB = parcelRequire("dWwnB");

var $7nG8r = parcelRequire("7nG8r");

var $lq8l8 = parcelRequire("lq8l8");

var $1dqlv = parcelRequire("1dqlv");

var $jAMCU = parcelRequire("jAMCU");
var $709387fef29c328e$var$_excluded = [
    "href",
    "children",
    "backgroundColor",
    "newWindowLabel",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss"
], $709387fef29c328e$var$_excluded2 = [
    "className"
];
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $709387fef29c328e$var$focusRingStyles = (0, $2ZUkg.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $1dqlv.borderColorMap)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $1dqlv.positiveSpaceMap)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $1dqlv.borderWidthMap)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $709387fef29c328e$var$baseStyles = (0, $2ZUkg.css)({
    boxSizing: "border-box",
    textDecoration: "underline"
});
var $709387fef29c328e$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $709387fef29c328e$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
var $709387fef29c328e$var$OPENS_NEW_WINDOW_LABEL = "(opens new window)";
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $709387fef29c328e$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, backgroundColor = _ref.backgroundColor, newWindowLabel = _ref.newWindowLabel, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $4OZuI.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $2OPES.default)(_ref, $709387fef29c328e$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $dWwnB.useId)();
    var onClick = (0, $4xoZa.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.3",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $2OPES.default)(htmlAttributes, $709387fef29c328e$var$_excluded2);
    var resolvedStyles = (0, $jAMCU.parseXcss)(xcss);
    var RouterLink = (0, $1rsGj.default)();
    var isExternal = typeof href === "string" && $709387fef29c328e$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $709387fef29c328e$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $hFZ5s.default)(href) === "object";
    (0, $jNYFj.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return (0, $2ZUkg.jsx)(Component, (0, $aB34E.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel ? newWindowLabel : $709387fef29c328e$var$OPENS_NEW_WINDOW_LABEL) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        css: [
            $709387fef29c328e$var$baseStyles,
            $709387fef29c328e$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1dqlv.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1dqlv.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1dqlv.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1dqlv.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1dqlv.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1dqlv.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1dqlv.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1dqlv.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $2ZUkg.jsx)((0, $lq8l8.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel ? newWindowLabel : $709387fef29c328e$var$OPENS_NEW_WINDOW_LABEL)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $709387fef29c328e$var$Anchor = /*#__PURE__*/ (0, $iSvIT.forwardRef)($709387fef29c328e$var$AnchorNoRef);
var $709387fef29c328e$export$2e2bcd8739ae039 = $709387fef29c328e$var$Anchor;

});
parcelRegister("4xoZa", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $34dda020fbdb1881$export$a4687b0234b40e28; });

var $6BH4v = parcelRequire("6BH4v");

var $iSvIT = parcelRequire("iSvIT");

var $5yk5M = parcelRequire("5yk5M");

var $ahuxo = parcelRequire("ahuxo");
function $34dda020fbdb1881$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $34dda020fbdb1881$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $34dda020fbdb1881$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6BH4v.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $34dda020fbdb1881$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $34dda020fbdb1881$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $5yk5M.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $ahuxo.useTrackedRef)(analyticsData);
    var fnRef = (0, $ahuxo.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $34dda020fbdb1881$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("5yk5M", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $40afb6a55f3f505f$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $l8PHT = parcelRequire("l8PHT");

var $fgUf5 = parcelRequire("fgUf5");
function $40afb6a55f3f505f$export$5bf35293e545f20c() {
    var analyticsContext = (0, $fgUf5.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $l8PHT.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("l8PHT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6427444e896623f$export$2e2bcd8739ae039; });

var $1XRzW = parcelRequire("1XRzW");

var $d5jr7 = parcelRequire("d5jr7");

var $c6mau = parcelRequire("c6mau");

var $kfXuH = parcelRequire("kfXuH");

var $8i9zt = parcelRequire("8i9zt");

var $cPM72 = parcelRequire("cPM72");

var $ktngo = parcelRequire("ktngo");

var $6BH4v = parcelRequire("6BH4v");

var $4lFaN = parcelRequire("4lFaN");
function $f6427444e896623f$var$_callSuper(t, o, e) {
    return o = (0, $8i9zt.default)(o), (0, $kfXuH.default)(t, $f6427444e896623f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8i9zt.default)(t).constructor) : o.apply(t, e));
}
function $f6427444e896623f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f6427444e896623f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f6427444e896623f$var$_superPropGet(t, o, e, r) {
    var p = (0, $cPM72.default)((0, $8i9zt.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $f6427444e896623f$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f6427444e896623f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $f6427444e896623f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $d5jr7.default)(this, UIAnalyticsEvent);
        _this = $f6427444e896623f$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $6BH4v.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $6BH4v.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $1XRzW.default)(_this.context);
            var handlers = (0, $1XRzW.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $6BH4v.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $ktngo.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $c6mau.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $f6427444e896623f$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $4lFaN.default));

});
parcelRegister("d5jr7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $986ad1a382853c4d$export$2e2bcd8739ae039; });
function $986ad1a382853c4d$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("c6mau", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cf73db5ad3cfd00$export$2e2bcd8739ae039; });

var $7O5um = parcelRequire("7O5um");
function $8cf73db5ad3cfd00$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $7O5um.default)(o.key), o);
    }
}
function $8cf73db5ad3cfd00$export$2e2bcd8739ae039(e, r, t) {
    return r && $8cf73db5ad3cfd00$var$_defineProperties(e.prototype, r), t && $8cf73db5ad3cfd00$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("kfXuH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebf35ba7e160848a$export$2e2bcd8739ae039; });

var $hFZ5s = parcelRequire("hFZ5s");

var $hT7N7 = parcelRequire("hT7N7");
function $ebf35ba7e160848a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $hFZ5s.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hT7N7.default)(t);
}

});
parcelRegister("hT7N7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d05d9decd1c4e51c$export$2e2bcd8739ae039; });
function $d05d9decd1c4e51c$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("8i9zt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60976dd0870c7fb3$export$2e2bcd8739ae039; });
function $60976dd0870c7fb3$export$2e2bcd8739ae039(t) {
    return $60976dd0870c7fb3$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $60976dd0870c7fb3$export$2e2bcd8739ae039(t);
}

});

parcelRegister("cPM72", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $957f919413f47b2a$export$2e2bcd8739ae039; });

var $aNpYH = parcelRequire("aNpYH");
function $957f919413f47b2a$export$2e2bcd8739ae039() {
    return $957f919413f47b2a$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $aNpYH.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $957f919413f47b2a$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("aNpYH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7dc2a1acb3c1bf91$export$2e2bcd8739ae039; });

var $8i9zt = parcelRequire("8i9zt");
function $7dc2a1acb3c1bf91$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $8i9zt.default)(t)););
    return t;
}

});


parcelRegister("ktngo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee788fb057734042$export$2e2bcd8739ae039; });

var $hQT5n = parcelRequire("hQT5n");
function $ee788fb057734042$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $hQT5n.default)(t, e);
}

});
parcelRegister("hQT5n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cff205df1cb137fb$export$2e2bcd8739ae039; });
function $cff205df1cb137fb$export$2e2bcd8739ae039(t, e) {
    return $cff205df1cb137fb$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $cff205df1cb137fb$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("4lFaN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32a90fbc1057f611$export$2e2bcd8739ae039; });

var $hFZ5s = parcelRequire("hFZ5s");

var $d5jr7 = parcelRequire("d5jr7");

var $c6mau = parcelRequire("c6mau");

var $6BH4v = parcelRequire("6BH4v");
function $32a90fbc1057f611$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32a90fbc1057f611$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32a90fbc1057f611$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6BH4v.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32a90fbc1057f611$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $32a90fbc1057f611$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $32a90fbc1057f611$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $32a90fbc1057f611$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $d5jr7.default)(this, AnalyticsEvent);
        (0, $6BH4v.default)(this, "_isAnalyticsEvent", true);
        (0, $6BH4v.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $32a90fbc1057f611$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $c6mau.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $hFZ5s.default)(updater) === "object") this.payload = $32a90fbc1057f611$var$_objectSpread($32a90fbc1057f611$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("fgUf5", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $b1e3fa2eb0b5da2e$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $b1e3fa2eb0b5da2e$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("ahuxo", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $77c32e0b890a83d9$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $77c32e0b890a83d9$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("1rsGj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10ce8f9d2467a2bb$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $gl70J = parcelRequire("gl70J");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $10ce8f9d2467a2bb$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $iSvIT.useContext)((0, $gl70J.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $10ce8f9d2467a2bb$export$2e2bcd8739ae039 = $10ce8f9d2467a2bb$var$useRouterLink;

});
parcelRegister("gl70J", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $be540baf81d6c1f5$export$2931e0ee690eee88; });

var $iSvIT = parcelRequire("iSvIT");
var $be540baf81d6c1f5$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $iSvIT.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $be540baf81d6c1f5$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($be540baf81d6c1f5$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $be540baf81d6c1f5$export$2e2bcd8739ae039 = $be540baf81d6c1f5$var$RouterLinkProvider;

});


parcelRegister("lq8l8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9827ed4ae95b723$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $iSvIT = parcelRequire("iSvIT");

var $767T1 = parcelRequire("767T1");
var $f9827ed4ae95b723$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $f9827ed4ae95b723$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $767T1.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $f9827ed4ae95b723$export$2e2bcd8739ae039 = $f9827ed4ae95b723$var$VisuallyHidden;

});
parcelRegister("767T1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52af360cf1a421a6$export$2e2bcd8739ae039; });
const $52af360cf1a421a6$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $52af360cf1a421a6$var$ATOMIC_GROUP_LENGTH = 5;
function $52af360cf1a421a6$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $52af360cf1a421a6$var$UNDERSCORE_UNICODE ? $52af360cf1a421a6$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});



parcelRegister("lI6Aw", function(module, exports) {

$parcel$export(module.exports, "CautionVector", function () { return (parcelRequire("lBR5P")).CautionVector; });
$parcel$export(module.exports, "ErrorVector", function () { return (parcelRequire("9I74z")).ErrorVector; });

var $lBR5P = parcelRequire("lBR5P");

var $9I74z = parcelRequire("9I74z");

});
parcelRegister("lBR5P", function(module, exports) {

$parcel$export(module.exports, "CautionVector", function () { return $8aaa5320d18ea94f$export$26b455e0e9f892ac; });

var $loA2J = parcelRequire("loA2J");
const $8aaa5320d18ea94f$export$26b455e0e9f892ac = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "108",
        height: "100",
        viewBox: "0 0 108 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0.654541 99.1828L0.71345 99.3006H107.293L107.359 99.1828L54.0065 0.582031L0.654541 99.1828Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M51.7909 71.9011V35.8945H56.5887V71.9011H51.7909Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M53.3074 77.8498C53.6565 77.7872 53.9895 77.7686 54.2749 77.7686C54.5768 77.7686 54.876 77.7895 55.1764 77.8357L55.1874 77.8374L55.1985 77.8392C57.1012 78.1501 58.685 79.4742 59.0687 81.5901C59.1362 81.9485 59.1545 82.2927 59.1545 82.5762C59.1545 82.7961 59.1435 83.0437 59.1087 83.3059V83.3461L59.071 83.5564C58.6923 85.6662 57.1123 87.007 55.1985 87.3197L55.1874 87.3215L55.1764 87.3232C54.876 87.3694 54.5768 87.3904 54.2749 87.3904C53.9874 87.3904 53.6515 87.3715 53.2997 87.3077C51.4218 86.9824 49.8458 85.6702 49.4617 83.564C49.3951 83.211 49.3756 82.881 49.3756 82.5827C49.3756 82.2876 49.3946 81.9472 49.4631 81.5875C49.8516 79.5134 51.3948 78.1714 53.3074 77.8498ZM54.1735 82.5702C54.1734 82.5742 54.1734 82.5784 54.1734 82.5827C54.1734 82.5848 54.1734 82.5868 54.1734 82.5888C54.1756 82.589 54.178 82.5892 54.1806 82.5894C54.203 82.5911 54.2343 82.5925 54.2749 82.5925C54.3056 82.5925 54.3327 82.5917 54.3566 82.5904C54.3567 82.5858 54.3567 82.5811 54.3567 82.5762C54.3567 82.5736 54.3567 82.5711 54.3567 82.5686C54.3327 82.5672 54.3056 82.5664 54.2749 82.5664C54.2343 82.5664 54.203 82.5678 54.1806 82.5696C54.178 82.5698 54.1756 82.57 54.1735 82.5702Z",
                fill: "white"
            })
        ]
    });

});

parcelRegister("9I74z", function(module, exports) {

$parcel$export(module.exports, "ErrorVector", function () { return $13f8d24eb2d5ab6c$export$355693f263ff741a; });

var $loA2J = parcelRequire("loA2J");
const $13f8d24eb2d5ab6c$export$355693f263ff741a = ({ alt: alt })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "160",
        height: "160",
        viewBox: "0 0 275 275",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M252.19 144H241.86L236.89 131.48H208.9C209.34 105.59 211.98 81.61 216.72 60H80.86C80.46 63.92 80.1 67.89 79.76 71.88H40.59L45.56 84.41H95.07L100.04 96.94H78.05C78.05 97.1 78.03 97.26 78.02 97.42L77.83 96.94H18L22.97 109.47H40.6L45.57 122H77.19C77.08 127.4 77.02 132.83 77.02 138.32C77.02 156.29 77.57 173.69 78.62 190.53H55.04L60.01 203.06H45.06L50.03 215.59H216.38C214.05 204.77 212.26 193.36 211 181.4H189.24L184.27 168.87H201.65L196.68 156.34L257.17 156.52L252.2 143.99L252.19 144Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M145.44 121.79C130.36 121.79 121.56 127.75 116.51 136.34C121.56 144.93 130.37 150.89 145.44 150.89V121.8V121.79Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M145.44 150.89C160.52 150.89 169.32 144.93 174.37 136.34C169.32 127.75 160.51 121.79 145.44 121.79V150.88V150.89Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M155.81 138.66C155.94 137.94 156.01 137.17 156.01 136.36C156.01 135.55 155.94 134.76 155.81 134.03C155.03 129.68 152 126.99 147.76 126.3C147.04 126.18 146.28 126.12 145.49 126.12C144.7 126.12 143.88 126.19 143.12 126.31C138.88 127.02 135.86 129.69 135.07 134.02C134.94 134.75 134.87 135.53 134.87 136.35C134.87 137.17 134.94 137.93 135.07 138.65C135.85 142.97 138.87 145.65 143.12 146.36C143.87 146.49 144.66 146.55 145.49 146.55C146.32 146.55 147.04 146.49 147.76 146.37C152.01 145.68 155.03 142.99 155.81 138.64V138.66Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.9 156.68L165.78 111.8L169.98 116L125.1 160.88L120.9 156.68Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M77.1799 122.001H106L101.03 109.471H77.1799V122.001Z",
                fill: "#B7B9BE"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M81.11 215.601H109.93L104.96 203.061H80.22L81.11 215.601Z",
                fill: "#B7B9BE"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M208.17 143.83H189.89L194.86 156.37H199.44H208.17V143.83Z",
                fill: "#B7B9BE"
            })
        ]
    });

});


parcelRegister("dZXEE", function(module, exports) {

$parcel$export(module.exports, "use404DisplayAnalytics", function () { return (parcelRequire("jfrRJ")).use404DisplayAnalytics; });

var $jfrRJ = parcelRequire("jfrRJ");

});
parcelRegister("jfrRJ", function(module, exports) {

$parcel$export(module.exports, "use404DisplayAnalytics", function () { return $519a3330404e2941$export$b04dd4b88dc7f99f; });

var $iSvIT = parcelRequire("iSvIT");

var $hK5Mw = parcelRequire("hK5Mw");
parcelRequire("enHYO");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");
const $519a3330404e2941$export$b04dd4b88dc7f99f = ()=>{
    const location = (0, $hK5Mw.useLocation)();
    const { fireScreenEvent: fireScreenEvent, fireUIEvent: fireUIEvent } = (0, $ih47h.useFireAnalyticsEvents)();
    const { data: userDetails } = (0, $8KnwD.useFastshiftSelector)((state)=>state.userDetails);
    // Screen event - when 404 page is displayed
    (0, $iSvIT.useEffect)(()=>{
        if (!userDetails) return;
        fireScreenEvent({
            name: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_404_SCREEN,
            attributes: {
                userDomain: userDetails.userDomain.domain,
                pageRoute: location.pathname
            }
        });
    }, [
        fireScreenEvent,
        userDetails,
        location.pathname
    ]);
    // UI event callback for home link click
    const sendGoBackToHomeLinkClickUIEvent = (0, $iSvIT.useCallback)(()=>{
        if (!userDetails) return;
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).LINK,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).GO_BACK_TO_HOME_LINK,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_404_SCREEN,
            attributes: {
                userDomain: userDetails.userDomain.domain,
                pageRoute: location.pathname
            }
        });
    }, [
        fireUIEvent,
        userDetails,
        location.pathname
    ]);
    return {
        sendGoBackToHomeLinkClickUIEvent: sendGoBackToHomeLinkClickUIEvent
    };
};

});


parcelRegister("bO1py", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $fa1a340910fe22d1$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $fa1a340910fe22d1$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    fourOhFourHeading: {
        id: "fastshift.common.displays.404-display.heading",
        defaultMessage: "We can\u2019t find the page you\u2019re looking for",
        description: "Heading for 404 display"
    },
    fourOhFourDescription: {
        id: "fastshift.common.displays.404-display.description",
        defaultMessage: "Go back to {404Link}",
        description: "Description for 404 display"
    },
    fourOhFourLinkText: {
        id: "fastshift.common.displays.404-display.link-text",
        defaultMessage: "atlassian.com/fastshift",
        description: "Link text for 404 display"
    }
});

});



parcelRegister("5D3Xj", function(module, exports) {

$parcel$export(module.exports, "GenericErrorDisplay", function () { return (parcelRequire("5wrp0")).GenericErrorDisplay; });

var $5wrp0 = parcelRequire("5wrp0");

});
parcelRegister("5wrp0", function(module, exports) {

$parcel$export(module.exports, "GenericErrorDisplay", function () { return $b53b78c55e25286f$export$4fa328de5601b947; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $9B16h = parcelRequire("9B16h");

var $gf1F9 = parcelRequire("gf1F9");

var $jKp9A = parcelRequire("jKp9A");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
parcelRequire("lI6Aw");
var $9I74z = parcelRequire("9I74z");

var $1gUzQ = parcelRequire("1gUzQ");
const $b53b78c55e25286f$export$4fa328de5601b947 = ({ customMessage: customMessage, refreshButtonLabel: refreshButtonLabel, onRefresh: onRefresh })=>{
    const intl = (0, $f6qj2.default)();
    const buttonLabel = refreshButtonLabel || intl.formatMessage((0, $1gUzQ.messages).defaultRefreshButtonLabel);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
        padding: "space.400",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
            alignBlock: "center",
            space: "space.200",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9I74z.ErrorVector), {
                    alt: intl.formatMessage((0, $1gUzQ.messages).genericErrorGraphicAltText)
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                    size: "medium",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $1gUzQ.messages).genericErrorHeading))
                }),
                customMessage && /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                    children: customMessage
                }),
                onRefresh && /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                    appearance: "primary",
                    onClick: onRefresh,
                    children: buttonLabel
                })
            ]
        })
    });
};

});
parcelRegister("1gUzQ", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $d7539c7cd56d47ef$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $d7539c7cd56d47ef$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    genericErrorHeading: {
        id: "fastshift.common.displays.generic-error.heading",
        defaultMessage: "Something went wrong",
        description: "Heading for error message displayed when an unknown error occurs, for example 500 internal server error, or server returns empty data"
    },
    genericErrorGraphicAltText: {
        id: "fastshift.common.displays.generic-error.graphic-alt-text",
        defaultMessage: "Error Graphic",
        description: "Alt Text for the generic error vector graphic displayed when an unknown error occurs"
    },
    defaultRefreshButtonLabel: {
        id: "fastshift.common.displays.generic-error.refresh-button-label",
        defaultMessage: "Refresh",
        description: "Label for the refresh button that when clicked, refetches the data from the server."
    }
});

});




parcelRegister("a9hbu", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $ffe7691fb80a8d94$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $ffe7691fb80a8d94$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    migrationStatusTableHeading: {
        id: "fastshift.dashboard.migrationStatusTable.heading",
        defaultMessage: "Migration progress",
        description: "Heading of the migration status table"
    },
    errorMessageDescription: {
        id: "fastshift.dashboard.migrationStatusTable.error-message-description",
        defaultMessage: "We\u2019re unable to retrieve the data about your migration progress.",
        description: "Error message for migration status table"
    }
});

});



parcelRegister("hxxJV", function(module, exports) {

$parcel$export(module.exports, "SummarySection", function () { return (parcelRequire("dCkeh")).SummarySection; });

var $dCkeh = parcelRequire("dCkeh");

});
parcelRegister("dCkeh", function(module, exports) {

$parcel$export(module.exports, "SummarySection", function () { return $97d5f4ddc068df4f$export$77fc3e7c6375c538; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bM10s = parcelRequire("bM10s");

var $gf1F9 = parcelRequire("gf1F9");

var $7xtRp = parcelRequire("7xtRp");

var $jKp9A = parcelRequire("jKp9A");
var $g2DEO = parcelRequire("g2DEO");
var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $jAMCU = parcelRequire("jAMCU");

var $k7z8r = parcelRequire("k7z8r");
parcelRequire("7zqwM");
var $k4eOf = parcelRequire("k4eOf");
parcelRequire("1OZTk");
var $9AY7L = parcelRequire("9AY7L");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");
parcelRequire("3oQlK");
var $cHgxm = parcelRequire("cHgxm");
var $cKTNL = parcelRequire("cKTNL");
var $gXwuJ = parcelRequire("gXwuJ");
parcelRequire("7WqkC");
var $4919S = parcelRequire("4919S");

var $lARZH = parcelRequire("lARZH");
parcelRequire("9M5ww");
var $ifRAV = parcelRequire("ifRAV");
parcelRequire("lAfje");
var $5PrOO = parcelRequire("5PrOO");
parcelRequire("giPyO");
var $cvJBr = parcelRequire("cvJBr");
const $97d5f4ddc068df4f$var$topItemsStyles = (0, $jAMCU.xcss)({
    height: "32px" // This prevents layout shift when buttons are hidden
});
const $97d5f4ddc068df4f$var$SummarySectionDetails = ()=>{
    const intl = (0, $f6qj2.default)();
    const { domainOrg: domainOrg } = (0, $cHgxm.useOrg)();
    const { summaryData: summaryData, errors: errors, isLoading: isLoading, isEmpty: isEmpty } = (0, $cKTNL.useSummary)();
    const isNoOrgSelected = domainOrg && domainOrg.orgId === (0, $k4eOf.DROPDOWN_ORG_ID).NO_ORG;
    const isOtherOrgsSelected = domainOrg && domainOrg.orgId === (0, $k4eOf.DROPDOWN_ORG_ID).OTHER_ORGS;
    // Show empty state if "Other orgs" is selected
    if (isNoOrgSelected) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ifRAV.NoOrgDisplay), {});
    if (isOtherOrgsSelected) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5PrOO.OtherOrgsDisplay), {});
    if (isEmpty) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9AY7L.EmptySummary), {
        orgId: (domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) || ""
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cvJBr.SummarySectionCard), {
                        title: intl.formatMessage((0, $lARZH.messages).dataCenterCardHeading),
                        value: summaryData.dataCenter.count,
                        isLoading: isLoading,
                        error: errors.l1Assessments
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cvJBr.SummarySectionCard), {
                        title: intl.formatMessage((0, $lARZH.messages).areaImprovementCardHeading),
                        value: summaryData.areaImprovement.count,
                        isLoading: isLoading,
                        error: errors.l1Assessments
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cvJBr.SummarySectionCard), {
                        title: intl.formatMessage((0, $lARZH.messages).deletedAppsCardHeading),
                        value: summaryData.deletedApps.count,
                        isLoading: isLoading,
                        error: errors.instances
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cvJBr.SummarySectionCard), {
                        title: intl.formatMessage((0, $lARZH.messages).migrationCompletedCardHeading),
                        value: summaryData.migrationCompleted.count,
                        isLoading: isLoading,
                        error: errors.migrationPlanTotals
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cvJBr.SummarySectionCard), {
                        title: intl.formatMessage((0, $lARZH.messages).migrationInProgressCardHeading),
                        value: summaryData.migrationInProgress.count,
                        isLoading: isLoading,
                        error: errors.migrationPlanTotals
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cvJBr.SummarySectionCard), {
                        title: intl.formatMessage((0, $lARZH.messages).unsuccessfulMigrationCardHeading),
                        value: summaryData.unsuccessfulMigration.count,
                        isLoading: isLoading,
                        error: errors.migrationPlanTotals
                    })
                ]
            })
        ]
    });
};
const $97d5f4ddc068df4f$export$77fc3e7c6375c538 = ()=>{
    const intl = (0, $f6qj2.default)();
    const customerDomain = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomain);
    const { domainOrg: domainOrg, setDomainOrg: setDomainOrg } = (0, $cHgxm.useOrg)();
    const { sendMigrationSummarySectionLinkClickUIEvent: sendMigrationSummarySectionLinkClickUIEvent } = (0, $gXwuJ.useDashboardUIAnalytics)();
    const baseUrl = "https://admin.atlassian.com";
    const migrationPlansUrl = `${baseUrl}/cloud-first-create-a-migration/${domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId}`;
    const assessmentsUrl = `${baseUrl}/o/${domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId}/product-insights/products`;
    // the selected org is not a special option (No org or Other orgs)
    const isValidCloudOrg = domainOrg && !Object.values((0, $k4eOf.DROPDOWN_ORG_ID)).includes(domainOrg.orgId);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
        as: "section",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g2DEO.default), {
                    alignItems: "center",
                    justifyContent: "space-between",
                    xcss: $97d5f4ddc068df4f$var$topItemsStyles,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                            space: "space.200",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $lARZH.messages).summarySectionTitle))
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4919S.OrgSelectorDropdown), {
                                    customerDomain: customerDomain,
                                    selectedDomainOrg: domainOrg,
                                    onSetSelectedDomainOrg: setDomainOrg
                                })
                            ]
                        }),
                        isValidCloudOrg && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bM10s.default), {
                                    href: assessmentsUrl,
                                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($7xtRp))),
                                    target: "_blank",
                                    onClick: ()=>sendMigrationSummarySectionLinkClickUIEvent((0, $k7z8r.SubjectAttributeKey).VIEW_ASSESSMENTS, (domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) || (0, $k4eOf.NO_ORG_ID)),
                                    children: intl.formatMessage((0, $lARZH.messages).viewAssessments)
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bM10s.default), {
                                    href: migrationPlansUrl,
                                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($7xtRp))),
                                    target: "_blank",
                                    onClick: ()=>sendMigrationSummarySectionLinkClickUIEvent((0, $k7z8r.SubjectAttributeKey).VIEW_MIGRATIONS, (domainOrg === null || domainOrg === void 0 ? void 0 : domainOrg.orgId) || (0, $k4eOf.NO_ORG_ID)),
                                    children: intl.formatMessage((0, $lARZH.messages).viewMigrations)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)($97d5f4ddc068df4f$var$SummarySectionDetails, {})
            ]
        })
    });
};

});
parcelRegister("1OZTk", function(module, exports) {

$parcel$export(module.exports, "EmptySummary", function () { return (parcelRequire("9AY7L")).EmptySummary; });

var $9AY7L = parcelRequire("9AY7L");

});
parcelRegister("9AY7L", function(module, exports) {

$parcel$export(module.exports, "EmptySummary", function () { return $18e59361795beb5e$export$ea887ee58e627c40; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $bM10s = parcelRequire("bM10s");

var $gf1F9 = parcelRequire("gf1F9");

var $257fv = parcelRequire("257fv");
var $6fxse = parcelRequire("6fxse");
var $jXVyf = parcelRequire("jXVyf");
var $agt8L = parcelRequire("agt8L");
var $j7TVc = parcelRequire("j7TVc");

var $64bXm = parcelRequire("64bXm");

var $7ksxW = parcelRequire("7ksxW");
const $18e59361795beb5e$var$containerStyles = (0, $j7TVc.xcss)({
    width: "100%",
    borderRadius: "border.radius.200",
    borderWidth: "border.width",
    borderStyle: "solid",
    borderColor: "color.border.disabled",
    backgroundColor: "elevation.surface.sunken",
    padding: "space.200"
});
const $18e59361795beb5e$var$PaperAirplaneStyles = (0, $j7TVc.xcss)({
    display: "flex",
    width: "115px",
    height: "115px",
    justifyContent: "center",
    alignItems: "center"
});
const $18e59361795beb5e$export$ea887ee58e627c40 = ({ orgId: orgId })=>{
    const assessmentsUrl = `https://admin.atlassian.com/o/${orgId}/product-insights/products`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6fxse.default), {
        xcss: $18e59361795beb5e$var$containerStyles,
        space: "space.400",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                xcss: $18e59361795beb5e$var$PaperAirplaneStyles,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $64bXm.CloudsIcon), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                        size: "small",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $7ksxW.messages).emptyAssessmentTitle))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $agt8L.default), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $7ksxW.messages).emptyAssessmentDescription))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6fxse.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bM10s.default), {
                                href: assessmentsUrl,
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $7ksxW.messages).startAssessmentButton))
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bM10s.default), {
                                appearance: "subtle",
                                href: "https://support.atlassian.com/portfolio-insights/docs/what-is-portfolio-insights/",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $7ksxW.messages).learnMoreLink))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("64bXm", function(module, exports) {

$parcel$export(module.exports, "CloudsIcon", function () { return $7b85b74b52c4e00b$export$3e275236e663d2b6; });

var $loA2J = parcelRequire("loA2J");
const $7b85b74b52c4e00b$export$3e275236e663d2b6 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "103",
        height: "104",
        viewBox: "0 0 103 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M76.2387 42.2507C75.9353 42.2507 75.6394 42.2545 75.3398 42.2657C70.7703 30.5462 61.167 25.6396 46.8519 25.6396C26.3343 25.6396 15.0754 35.9059 15.0754 62.2552H97.4792C95.157 49.1536 87.3065 42.2507 76.235 42.2507H76.2387Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.0231 65.7947H36.7355C34.8815 55.3299 28.6116 49.8203 19.7686 49.8203C11.5323 49.8203 5.94786 54.004 2.64062 65.7947H16.0231Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M19.7684 49.8203C18.465 49.8203 17.2327 49.9252 16.0604 50.1499C15.4124 53.7381 15.0791 57.7569 15.0791 62.2552H35.8814C33.3419 54.0939 27.5552 49.8241 19.7684 49.8241V49.8203Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M41.5483 66.6149C41.7917 66.6149 42.0314 66.6187 42.2711 66.6262C45.9454 57.2101 53.6611 53.2661 65.1596 53.2661C81.6471 53.2661 90.6924 61.5173 90.6924 82.6867H24.4802C26.3455 72.1582 32.6528 66.6149 41.552 66.6149H41.5483Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M85.8495 62.2515C81.5872 55.9741 74.5981 53.2661 65.1633 53.2661C55.7285 53.2661 48.7133 55.9741 44.5259 62.2515H85.8495Z",
                fill: "#09326C"
            })
        ]
    });

});

parcelRegister("7ksxW", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $2179856ee7e3bdf9$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $2179856ee7e3bdf9$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    emptyAssessmentTitle: {
        id: "fastshift.emptyAssessmentTitle",
        defaultMessage: "You have no assessment data for this organisation",
        description: "Title displayed when no assessments are available."
    },
    emptyAssessmentDescription: {
        id: "fastshift.emptyAssessmentDescription",
        defaultMessage: "First step on the journey to Cloud is to assess your Data Center instances and understand their Cloud readiness. Follow the link to start the process.",
        description: "Description displayed when no assessments are available, prompting the user to create one."
    },
    startAssessmentButton: {
        id: "fastshift.startAssessmentButton",
        defaultMessage: "Start assessment",
        description: "Button text to initiate a new assessment."
    },
    learnMoreLink: {
        id: "fastshift.learnMoreLink",
        defaultMessage: "Learn more about assessments",
        description: "Link text to provide more information about assessments."
    }
});

});



parcelRegister("7WqkC", function(module, exports) {

$parcel$export(module.exports, "OrgSelectorDropdown", function () { return (parcelRequire("4919S")).OrgSelectorDropdown; });

var $4919S = parcelRequire("4919S");

});
parcelRegister("4919S", function(module, exports) {

$parcel$export(module.exports, "OrgSelectorDropdown", function () { return $668569263e90e619$export$dea5ca6f2210466; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $4a5Re = parcelRequire("4a5Re");
var $c3HvU = parcelRequire("c3HvU");

var $7cU9H = parcelRequire("7cU9H");
parcelRequire("88u92");
var $6rtIK = parcelRequire("6rtIK");
parcelRequire("8Fsio");
var $7b61L = parcelRequire("7b61L");
const $668569263e90e619$export$dea5ca6f2210466 = ({ customerDomain: customerDomain, selectedDomainOrg: selectedDomainOrg, onSetSelectedDomainOrg: onSetSelectedDomainOrg })=>{
    const { data: customerDomainData, pending: customerDomainPending } = customerDomain;
    const hasOrgs = !customerDomainPending && customerDomainData && customerDomainData.orgsWithAdminRole.length > 0 || false;
    (0, $iSvIT.useEffect)(()=>{
        if (!customerDomainPending && customerDomainData) {
            if (hasOrgs && !selectedDomainOrg) {
                const firstOrg = customerDomainData.orgsWithAdminRole[0];
                if (firstOrg) onSetSelectedDomainOrg(firstOrg);
            }
            if (!hasOrgs && !selectedDomainOrg) onSetSelectedDomainOrg((0, $7cU9H.OTHER_ORG_FILTER));
        }
    }, [
        customerDomainData,
        customerDomainPending,
        hasOrgs,
        selectedDomainOrg,
        onSetSelectedDomainOrg
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4a5Re.default), {
        // This is atlaskit's recommended pattern for custom trigger components
        // eslint-disable-next-line react/no-unstable-nested-components
        trigger: (_param)=>/*#__PURE__*/ {
            var { triggerRef: triggerRef } = _param, providedProps = (0, $akGnX._)(_param, [
                "triggerRef"
            ]);
            return (0, $loA2J.jsx)((0, $6rtIK.OrgSelectorDropdownButton), (0, $6iHNw._)((0, $7Knp0._)({
                triggerRef: triggerRef
            }, providedProps), {
                selectedDomainOrg: selectedDomainOrg,
                isLoading: customerDomainPending,
                isDisabled: customerDomainPending
            }));
        },
        spacing: "compact",
        shouldRenderToParent: true,
        isLoading: customerDomainPending,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $c3HvU.default), {
            children: customerDomainData && [
                ...customerDomainData.orgsWithAdminRole,
                ...(0, $7cU9H.DEFAULT_ORG_FILTERS_ORDER)
            ].map((org)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $7b61L.OrgSelectorDropdownItem), {
                    org: org,
                    isSelected: org.orgId === (selectedDomainOrg === null || selectedDomainOrg === void 0 ? void 0 : selectedDomainOrg.orgId),
                    onSetSelectedDomainOrg: onSetSelectedDomainOrg
                }, org.orgId))
        })
    });
};

});
parcelRegister("88u92", function(module, exports) {

$parcel$export(module.exports, "OrgSelectorDropdownButton", function () { return (parcelRequire("6rtIK")).OrgSelectorDropdownButton; });

var $6rtIK = parcelRequire("6rtIK");

});
parcelRegister("6rtIK", function(module, exports) {

$parcel$export(module.exports, "OrgSelectorDropdownButton", function () { return $365802ad218d3d0f$export$d5fe24fe84b0508f; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $9B16h = parcelRequire("9B16h");

var $4vcv5 = parcelRequire("4vcv5");

var $iy4Sr = parcelRequire("iy4Sr");

var $7akU3 = parcelRequire("7akU3");
parcelRequire("3oQlK");
var $gXwuJ = parcelRequire("gXwuJ");

var $8Wdli = parcelRequire("8Wdli");
parcelRequire("8uckY");
var $GHIKl = parcelRequire("GHIKl");
const $365802ad218d3d0f$export$d5fe24fe84b0508f = (_param)=>{
    var { triggerRef: triggerRef, selectedDomainOrg: selectedDomainOrg, isLoading: isLoading, isDisabled: isDisabled } = _param, providedProps = (0, $akGnX._)(_param, [
        "triggerRef",
        "selectedDomainOrg",
        "isLoading",
        "isDisabled"
    ]);
    const { sendOrgSelectorDropdownClickUIEvent: sendOrgSelectorDropdownClickUIEvent } = (0, $gXwuJ.useDashboardUIAnalytics)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), (0, $6iHNw._)((0, $7Knp0._)({
        ref: triggerRef
    }, providedProps), {
        spacing: "compact",
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: (e)=>{
            var _providedProps_onClick;
            sendOrgSelectorDropdownClickUIEvent();
            (_providedProps_onClick = providedProps.onClick) === null || _providedProps_onClick === void 0 ? void 0 : _providedProps_onClick.call(providedProps, e);
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
            space: "space.100",
            alignInline: "center",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iy4Sr))), {
                    label: "Org icon"
                }),
                selectedDomainOrg ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $GHIKl.OrgSelectorItemMessage), {
                    org: selectedDomainOrg
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $8Wdli.messages).orgSelectorDropdownNoOrgSelected)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4vcv5))), {
                    label: "Chevron down icon",
                    size: "small"
                })
            ]
        })
    }));
};

});
parcelRegister("8Wdli", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $b4ad1775c384b3ba$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $b4ad1775c384b3ba$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    orgSelectorDropdownNoOrgForOrgAdmin: {
        id: "fastshift.dashboard.welcome-banner.org-selector.selected-org-is-no-org",
        defaultMessage: "No cloud organization",
        description: "Message for MOVE tickets that do not contain a reference to a destination cloud org, in the org selector dropdown button on welcome banner"
    },
    orgSelectorDropdownOtherOrgsForOrgAdmin: {
        id: "fastshift.dashboard.welcome-banner.org-selector.selected-org-is-other-orgs",
        defaultMessage: "Other cloud organizations",
        description: "Message for MOVE tickets associated with cloud orgs that the customer is NOT org admin of, in the org selector dropdown button on welcome banner"
    },
    orgSelectorDropdownNoOrgSelected: {
        id: "fastshift.dashboard.welcome-banner.org-selector.org-not-selected-fallback",
        defaultMessage: "Select an organization...",
        description: "Fallback message displayed instead of the dropdown when the org has not been selected. Since orgs are selected automatically, this is only shown if there is a bug."
    }
});

});

parcelRegister("8uckY", function(module, exports) {

$parcel$export(module.exports, "OrgSelectorItemMessage", function () { return (parcelRequire("GHIKl")).OrgSelectorItemMessage; });

var $GHIKl = parcelRequire("GHIKl");

});
parcelRegister("GHIKl", function(module, exports) {

$parcel$export(module.exports, "OrgSelectorItemMessage", function () { return $7acdd6b1bcc2519f$export$e4d0ffcb60a134c7; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $5P9nB = parcelRequire("5P9nB");
parcelRequire("7zqwM");
var $k4eOf = parcelRequire("k4eOf");

var $8Wdli = parcelRequire("8Wdli");
const $7acdd6b1bcc2519f$export$e4d0ffcb60a134c7 = ({ org: org })=>{
    switch(org.orgId){
        case (0, $k4eOf.DROPDOWN_ORG_ID).NO_ORG:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $8Wdli.messages).orgSelectorDropdownNoOrgForOrgAdmin))
            });
        case (0, $k4eOf.DROPDOWN_ORG_ID).OTHER_ORGS:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $8Wdli.messages).orgSelectorDropdownOtherOrgsForOrgAdmin))
            });
        default:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                children: org.orgName
            });
    }
};

});




parcelRegister("8Fsio", function(module, exports) {

$parcel$export(module.exports, "OrgSelectorDropdownItem", function () { return (parcelRequire("7b61L")).OrgSelectorDropdownItem; });

var $7b61L = parcelRequire("7b61L");

});
parcelRegister("7b61L", function(module, exports) {

$parcel$export(module.exports, "OrgSelectorDropdownItem", function () { return $62f809aa6a764660$export$1127d69ac57174e1; });

var $loA2J = parcelRequire("loA2J");

var $3Oabj = parcelRequire("3Oabj");

var $iy4Sr = parcelRequire("iy4Sr");

var $7akU3 = parcelRequire("7akU3");
parcelRequire("3oQlK");
var $gXwuJ = parcelRequire("gXwuJ");
parcelRequire("8uckY");
var $GHIKl = parcelRequire("GHIKl");
const $62f809aa6a764660$export$1127d69ac57174e1 = ({ org: org, isSelected: isSelected, onSetSelectedDomainOrg: onSetSelectedDomainOrg })=>{
    const { sendOrgSelectorDropdownItemClickUIEvent: sendOrgSelectorDropdownItemClickUIEvent } = (0, $gXwuJ.useDashboardUIAnalytics)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Oabj.default), {
        isSelected: isSelected,
        onClick: ()=>{
            sendOrgSelectorDropdownItemClickUIEvent(org.orgId);
            onSetSelectedDomainOrg(org);
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iy4Sr))), {
                    label: "Org Icon"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $GHIKl.OrgSelectorItemMessage), {
                    org: org
                })
            ]
        })
    }, org.orgId);
};

});




parcelRegister("lARZH", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $692fd6076acf5e99$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $692fd6076acf5e99$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    summarySectionTitle: {
        id: "fastshift.dashboard.summary-section.title",
        defaultMessage: "Summary",
        description: "Title for the summary section"
    },
    dataCenterCardHeading: {
        id: "fastshift.dashboard.data-center-card.heading",
        defaultMessage: "Data Center instances assessed",
        description: "Heading for the data center summary card"
    },
    areaImprovementCardHeading: {
        id: "fastshift.dashboard.area-improvement-card.heading",
        defaultMessage: "Areas to improve",
        description: "Heading for the area improvement summary card"
    },
    deletedAppsCardHeading: {
        id: "fastshift.dashboard.deleted-apps-card.heading",
        defaultMessage: "Deleted apps",
        description: "Heading for the deleted apps summary card"
    },
    migrationCompletedCardHeading: {
        id: "fastshift.dashboard.migration-completed-card.heading",
        defaultMessage: "Migrations completed",
        description: "Heading for the migration completed summary card"
    },
    migrationInProgressCardHeading: {
        id: "fastshift.dashboard.migration-running-card.heading",
        defaultMessage: "Migrations in progress",
        description: "Heading for the migration in progress summary card"
    },
    unsuccessfulMigrationCardHeading: {
        id: "fastshift.dashboard.unsuccessful-migration-card.heading",
        defaultMessage: "Unsuccessful migrations",
        description: "Heading for the unsuccessful migration summary card"
    },
    viewMigrations: {
        id: "fastshift.dashboard.organisation-summary.view-migrations",
        defaultMessage: "View migrations",
        description: "Button text to view migrations in the migration summary"
    },
    viewAssessments: {
        id: "fastshift.dashboard.organisation-summary.view-assessments",
        defaultMessage: "View assessments",
        description: "Button text to view assessments in the migration summary"
    }
});

});

parcelRegister("9M5ww", function(module, exports) {

$parcel$export(module.exports, "NoOrgDisplay", function () { return (parcelRequire("ifRAV")).NoOrgDisplay; });

var $ifRAV = parcelRequire("ifRAV");

});
parcelRegister("ifRAV", function(module, exports) {

$parcel$export(module.exports, "NoOrgDisplay", function () { return $87f2aed2b7a6494d$export$e538b736891fca54; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $gf1F9 = parcelRequire("gf1F9");

var $jKp9A = parcelRequire("jKp9A");
var $g2DEO = parcelRequire("g2DEO");
var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $kwHar = parcelRequire("kwHar");
parcelRequire("50Y5g");
var $cmIvX = parcelRequire("cmIvX");

var $jFEFQ = parcelRequire("jFEFQ");
const $87f2aed2b7a6494d$var$boxStyles = (0, $jAMCU.xcss)({
    borderRadius: "border.radius.200",
    border: `1px solid ${(0, $kwHar.default)("color.border.disabled")}`
});
const $87f2aed2b7a6494d$var$iconContainerStyles = (0, $jAMCU.xcss)({
    width: "111px",
    height: "111px"
});
const $87f2aed2b7a6494d$export$e538b736891fca54 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
        padding: "space.300",
        backgroundColor: "elevation.surface.sunken",
        xcss: $87f2aed2b7a6494d$var$boxStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
            space: "space.400",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2DEO.default), {
                    xcss: $87f2aed2b7a6494d$var$iconContainerStyles,
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cmIvX.PaperPlaneVector), {})
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $jFEFQ.messages).noOrgDisplayTitle))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $jFEFQ.messages).noOrgDisplayDescription))
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("50Y5g", function(module, exports) {

$parcel$export(module.exports, "PaperPlaneVector", function () { return (parcelRequire("cmIvX")).PaperPlaneVector; });

var $cmIvX = parcelRequire("cmIvX");

});
parcelRegister("cmIvX", function(module, exports) {

$parcel$export(module.exports, "PaperPlaneVector", function () { return $1696c2523107ab64$export$65ceaa350e9dc3d8; });

var $loA2J = parcelRequire("loA2J");
const $1696c2523107ab64$export$65ceaa350e9dc3d8 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "87",
        height: "67",
        viewBox: "0 0 87 67",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M86.8991 11.3607L5.23535 37.4356L34.3819 51.793L86.8991 11.3607Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M85.2155 12.3213L26.0303 50.7354L52.6541 66.3803L85.2155 12.3213Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M85.2202 12.3213L85.0183 12.8057L34.3822 51.7929L28.707 48.9997L85.2202 12.3213Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M85.2202 12.3213L85.0183 12.8057L34.3822 51.7929L28.707 48.9997L85.2202 12.3213Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M33.6556 0.401855L0.109375 7.46549L11.1246 14.3596L33.6556 0.401855Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M32.9488 0.716797L7.84668 13.6009L16.1858 23.0581L32.9488 0.716797Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M32.9494 0.716797L32.8485 0.902469L11.1248 14.3597L8.98145 13.0196L32.9494 0.716797Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M32.9494 0.716797L32.8485 0.902469L11.1248 14.3597L8.98145 13.0196L32.9494 0.716797Z",
                fill: "#AE2A19"
            })
        ]
    });

});


parcelRegister("jFEFQ", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $c0db9cf097e798aa$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $c0db9cf097e798aa$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    noOrgDisplayTitle: {
        id: "fastshift.dashboard.no-org-display.title",
        defaultMessage: "You\u2019re viewing tickets that aren\u2019t associated with any cloud organization",
        description: "Title for the no org display"
    },
    noOrgDisplayDescription: {
        id: "fastshift.dashboard.no-org-display.description",
        defaultMessage: "Tickets linked to an existing cloud organization appear under that organization\u2019s name. Once linked, you\u2019ll find the ticket in its respective view.",
        description: "Description for the no org display"
    }
});

});



parcelRegister("lAfje", function(module, exports) {

$parcel$export(module.exports, "OtherOrgsDisplay", function () { return (parcelRequire("5PrOO")).OtherOrgsDisplay; });

var $5PrOO = parcelRequire("5PrOO");

});
parcelRegister("5PrOO", function(module, exports) {

$parcel$export(module.exports, "OtherOrgsDisplay", function () { return $1a017da63225a564$export$dd105b474c1cc1e4; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $gf1F9 = parcelRequire("gf1F9");

var $jKp9A = parcelRequire("jKp9A");
var $g2DEO = parcelRequire("g2DEO");
var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $kwHar = parcelRequire("kwHar");
parcelRequire("50Y5g");
var $cmIvX = parcelRequire("cmIvX");

var $cUFaN = parcelRequire("cUFaN");
const $1a017da63225a564$var$boxStyles = (0, $jAMCU.xcss)({
    borderRadius: "border.radius.200",
    border: `1px solid ${(0, $kwHar.default)("color.border.disabled")}`
});
const $1a017da63225a564$var$iconContainerStyles = (0, $jAMCU.xcss)({
    width: "111px",
    height: "111px"
});
const $1a017da63225a564$export$dd105b474c1cc1e4 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
        padding: "space.300",
        backgroundColor: "elevation.surface.sunken",
        xcss: $1a017da63225a564$var$boxStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
            space: "space.400",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2DEO.default), {
                    xcss: $1a017da63225a564$var$iconContainerStyles,
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cmIvX.PaperPlaneVector), {})
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $cUFaN.messages).otherOrgsDisplayTitle))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $cUFaN.messages).otherOrgsDisplayDescription))
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("cUFaN", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $4b23a83ae7c0c4c6$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $4b23a83ae7c0c4c6$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    otherOrgsDisplayTitle: {
        id: "fastshift.dashboard.other-orgs-display.title",
        defaultMessage: "You\u2019re viewing tickets associated with cloud organizations where you\u2019re not an org admin",
        description: "Title for the other orgs display"
    },
    otherOrgsDisplayDescription: {
        id: "fastshift.dashboard.other-orgs-display.description",
        defaultMessage: "If you have access to a ticket, but not sufficient permissions in cloud, you\u2019ll see it here without extra details about the organization.",
        description: "Description for the other orgs display"
    }
});

});



parcelRegister("giPyO", function(module, exports) {

$parcel$export(module.exports, "SummarySectionCard", function () { return (parcelRequire("cvJBr")).SummarySectionCard; });

var $cvJBr = parcelRequire("cvJBr");

});
parcelRegister("cvJBr", function(module, exports) {

$parcel$export(module.exports, "SummarySectionCard", function () { return $2ba52868794929f8$export$791caf28437942a5; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $hK5Mw = parcelRequire("hK5Mw");

var $gf1F9 = parcelRequire("gf1F9");

var $9CMNB = parcelRequire("9CMNB");

var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $g2OHD = parcelRequire("g2OHD");

var $eXeDE = parcelRequire("eXeDE");
const $2ba52868794929f8$var$containerStyle = (0, $jAMCU.xcss)({
    borderRadius: "border.radius.200",
    borderColor: "color.border",
    borderWidth: "border.width",
    borderStyle: "solid",
    padding: "space.200"
});
const $2ba52868794929f8$export$791caf28437942a5 = ({ title: title, value: value, isLoading: isLoading, error: error })=>{
    const { pathname: pathname } = (0, $hK5Mw.useLocation)();
    if (isLoading) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        xcss: $2ba52868794929f8$var$containerStyle,
        grow: "fill",
        alignBlock: "center",
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), {
                height: "12px",
                width: "100%"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), {
                height: "20px",
                width: "100%"
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        xcss: $2ba52868794929f8$var$containerStyle,
        grow: "fill",
        alignBlock: "center",
        alignInline: "center",
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $eXeDE.messages).errorHeading))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $9CMNB.default), {
                href: pathname,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                    size: "small",
                    color: "color.link",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $eXeDE.messages).refreshPage))
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        xcss: $2ba52868794929f8$var$containerStyle,
        grow: "fill",
        alignBlock: "center",
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                size: "xxsmall",
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                size: "medium",
                children: value
            })
        ]
    });
};

});
parcelRegister("eXeDE", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $d472d2ca2b0d0f90$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $d472d2ca2b0d0f90$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    errorHeading: {
        id: "fastshift.dashboard.summary-section-card.error-heading",
        defaultMessage: "An Error Occurred",
        description: "Error heading for the summary section card"
    },
    refreshPage: {
        id: "fastshift.dashboard.summary-section-card.refresh-page-link",
        defaultMessage: "Refresh the page",
        description: "Refresh page link for the summary section card"
    }
});

});







parcelRegister("bSbqT", function(module, exports) {

$parcel$export(module.exports, "FastshiftCustomerSelectionPage", function () { return (parcelRequire("jwBCq")).FastshiftCustomerSelectionPage; });

var $jwBCq = parcelRequire("jwBCq");

});
parcelRegister("jwBCq", function(module, exports) {

$parcel$export(module.exports, "FastshiftCustomerSelectionPage", function () { return $0d2230e0c7bff2ec$export$2d7c9f9e8f1be7b; });
/* fastshift-customer-selection.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");

var $aYwtv = parcelRequire("aYwtv");

var $5wOn9 = parcelRequire("5wOn9");
parcelRequire("5m8h9");
var $5wrp0 = parcelRequire("5wrp0");
parcelRequire("2al5y");
var $cDmHV = parcelRequire("cDmHV");
var $505JK = parcelRequire("505JK");

var $boF4D = parcelRequire("boF4D");
parcelRequire("iMIhQ");
var $lTj8F = parcelRequire("lTj8F");
parcelRequire("6D9is");
var $dNgHf = parcelRequire("dNgHf");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");
var $k0rCZ = parcelRequire("k0rCZ");
parcelRequire("e1y4u");
var $8tdES = parcelRequire("8tdES");

var $jfmcr = parcelRequire("jfmcr");
parcelRequire("fWMR8");
var $lyKz9 = parcelRequire("lyKz9");
const $0d2230e0c7bff2ec$var$PageContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1bsb1osq _p12f1yae",
            __cmplp.className
        ])
    }));
});
const $0d2230e0c7bff2ec$export$2d7c9f9e8f1be7b = ()=>{
    const userInfo = (0, $5wOn9.useLoggedInUser)();
    const currentTime = (0, $lTj8F.getCurrentTime)();
    const dispatch = (0, $8KnwD.useFastshiftDispatch)();
    const stargateClient = (0, $aYwtv.useBxpWebStargateClient)();
    const intl = (0, $f6qj2.default)();
    const { data: customerDomains } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomains);
    const { selectionTableControls: selectionTableControls } = (0, $8KnwD.useFastshiftSelector)((state)=>state.pageStateCache);
    (0, $iSvIT.useEffect)(()=>{
        if (!customerDomains || customerDomains.data.length === 0) dispatch((0, $k0rCZ.getCustomerDomains)({
            stargateClient: stargateClient,
            controls: selectionTableControls
        }));
         // we only want this effect to run once on page load once stargate client is available
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        stargateClient
    ]);
    const onSetControlsPayload = (controls)=>{
        dispatch((0, $k0rCZ.setSelectionTableControls)({
            selectionTableControls: controls
        }));
        dispatch((0, $k0rCZ.getCustomerDomains)({
            stargateClient: stargateClient,
            controls: controls
        }));
    };
    (0, $8tdES.useCustomerSelectionPageAnalytics)();
    const { isTableLoading: isTableLoading, isTableError: isTableError, rows: rows, head: head, pagination: pagination } = (0, $lyKz9.useDomainSelectionTable)();
    const ErrorComponent = /*#__PURE__*/ (0, $loA2J.jsx)((0, $5wrp0.GenericErrorDisplay), {
        customMessage: intl.formatMessage((0, $jfmcr.messages).errorMessage),
        onRefresh: ()=>{
            dispatch((0, $k0rCZ.getCustomerDomains)({
                stargateClient: stargateClient,
                controls: (0, $cDmHV.DEFAULT_CONTROLS_PAYLOAD)
            }));
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
        alignInline: "center",
        children: /*#__PURE__*/ (0, $loA2J.jsx)($0d2230e0c7bff2ec$var$PageContainer, {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                space: "space.400",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                        space: "space.300",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dNgHf.PartnerWelcomeBanner), {
                                currentTime: currentTime,
                                userName: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $boF4D.LegalBanner), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $505JK.FastshiftTable), {
                        id: "customer-selection-table",
                        enableSearch: true,
                        summaryText: intl.formatMessage((0, $jfmcr.messages).summaryText, {
                            viewSize: rows.length,
                            totalNumber: pagination.totalElements
                        }),
                        isTableLoading: isTableLoading,
                        isTableError: isTableError,
                        errorComponent: ErrorComponent,
                        head: head,
                        rows: rows,
                        controls: {
                            onSetControlsPayload: onSetControlsPayload,
                            controls: selectionTableControls,
                            pagination: pagination
                        }
                    })
                ]
            })
        })
    });
};

});
parcelRegister("e1y4u", function(module, exports) {

$parcel$export(module.exports, "useCustomerSelectionPageAnalytics", function () { return (parcelRequire("8tdES")).useCustomerSelectionPageAnalytics; });
$parcel$export(module.exports, "useCustomerSelectionUIAnalytics", function () { return (parcelRequire("gJXDU")).useCustomerSelectionUIAnalytics; });

var $8tdES = parcelRequire("8tdES");

var $gJXDU = parcelRequire("gJXDU");

});
parcelRegister("8tdES", function(module, exports) {

$parcel$export(module.exports, "useCustomerSelectionPageAnalytics", function () { return $02f917655b4152d4$export$659ed48541bfb328; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $aVSys = parcelRequire("aVSys");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");
const $02f917655b4152d4$export$659ed48541bfb328 = ()=>{
    const identityAttrs = (0, $aVSys.useBaseIdentityAttrs)();
    const { data: customerDomains, pending: customerDomainsPending } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomains);
    const { fireScreenEvent: fireScreenEvent, fireTrackEvent: fireTrackEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    // Screen event
    (0, $iSvIT.useEffect)(()=>{
        if (!identityAttrs) return;
        fireScreenEvent({
            name: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_SELECTION_SCREEN
        });
    }, [
        fireScreenEvent,
        identityAttrs
    ]);
    // Track event
    (0, $iSvIT.useEffect)(()=>{
        if (!identityAttrs || !customerDomains || customerDomainsPending) return;
        fireTrackEvent({
            action: (0, $k7z8r.ActionKey).DISPLAYED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).SECTION,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).SELECTION_PAGE_DETAILS,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_SELECTION_SCREEN,
            attributes: {
                customerDomainCount: customerDomains.data.length
            }
        });
    }, [
        fireTrackEvent,
        identityAttrs,
        customerDomains,
        customerDomainsPending
    ]);
};

});

parcelRegister("gJXDU", function(module, exports) {

$parcel$export(module.exports, "useCustomerSelectionUIAnalytics", function () { return $891db841ad9e4ada$export$2e1db01705171632; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $aVSys = parcelRequire("aVSys");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
const $891db841ad9e4ada$export$2e1db01705171632 = ()=>{
    const identityAttrs = (0, $aVSys.useBaseIdentityAttrs)();
    const { fireUIEvent: fireUIEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    // UI event callbacks
    const sendSeeDetailsClickUIEvent = (0, $iSvIT.useCallback)((selectedCustomerDomain, selectedCustomerDomainId)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).LINK,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).SEE_DETAILS_BUTTON,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_SELECTION_SCREEN,
            attributes: {
                selectedCustomerDomain: selectedCustomerDomain,
                selectedCustomerDomainId: selectedCustomerDomainId
            }
        });
    }, [
        fireUIEvent
    ]);
    return {
        sendSeeDetailsClickUIEvent: sendSeeDetailsClickUIEvent
    };
};

});


parcelRegister("jfmcr", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $906d0b14df880c12$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $906d0b14df880c12$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    customerColumnTitle: {
        id: "fastshift.customer-selection.domain-selection-table.customer-column-title",
        defaultMessage: "Customer",
        description: "Column title for customer name in domain selection table"
    },
    customerDomainColumnTitle: {
        id: "fastshift.customer-selection.domain-selection-table.customer-domain-column-title",
        defaultMessage: "Customer domain",
        description: "Column title for customer domain in domain selection table"
    },
    actionsColumnTitle: {
        id: "fastshift.customer-selection.domain-selection-table.actions-column-title",
        defaultMessage: "Actions",
        description: "Column title for actions in domain selection table"
    },
    seeDetailsButton: {
        id: "fastshift.customer-selection.domain-selection-table.see-details-button",
        defaultMessage: "View details",
        description: "Button text for viewing customer details"
    },
    summaryText: {
        id: "fastshift.customer-selection.domain-selection-table.summary-text",
        defaultMessage: "Showing {viewSize} out of {totalNumber} customers",
        description: "Summary text for domain selection table"
    },
    errorMessage: {
        id: "fastshift.customer-selection.domain-selection-table.error-message",
        defaultMessage: "We\u2019re unable to retrieve the data about your customers.",
        description: "Error message for domain selection table"
    }
});

});

parcelRegister("fWMR8", function(module, exports) {

$parcel$export(module.exports, "useDomainSelectionTable", function () { return (parcelRequire("lyKz9")).useDomainSelectionTable; });

var $lyKz9 = parcelRequire("lyKz9");

});
parcelRegister("lyKz9", function(module, exports) {

$parcel$export(module.exports, "useDomainSelectionTable", function () { return $10f15157a823a787$export$6add7dfbb40ea047; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $hK5Mw = parcelRequire("hK5Mw");

var $9B16h = parcelRequire("9B16h");

var $gf1F9 = parcelRequire("gf1F9");

var $1KI7W = parcelRequire("1KI7W");

var $7akU3 = parcelRequire("7akU3");
var $5P9nB = parcelRequire("5P9nB");
parcelRequire("5XMUP");
var $gbLaZ = parcelRequire("gbLaZ");

var $9OyVr = parcelRequire("9OyVr");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");
parcelRequire("e1y4u");
var $gJXDU = parcelRequire("gJXDU");

var $jfmcr = parcelRequire("jfmcr");
const $10f15157a823a787$export$6add7dfbb40ea047 = ()=>{
    const { getPathByDomainId: getPathByDomainId } = (0, $gbLaZ.useRoutes)();
    const { pending: customerDomainsPending, data: customerDomainsData, error: customerDomainsError } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomains);
    const navigate = (0, $hK5Mw.useNavigate)();
    const { sendSeeDetailsClickUIEvent: sendSeeDetailsClickUIEvent } = (0, $gJXDU.useCustomerSelectionUIAnalytics)();
    const head = {
        cells: [
            {
                key: "customerName",
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $jfmcr.messages).customerColumnTitle))
                }),
                width: 40,
                isSortable: true
            },
            {
                key: "customerDomain",
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $jfmcr.messages).customerDomainColumnTitle))
                }),
                width: 40,
                isSortable: true
            },
            {
                key: "actions",
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
                    alignInline: "end",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                        size: "xxsmall",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $jfmcr.messages).actionsColumnTitle))
                    })
                }),
                width: 20
            }
        ]
    };
    const rows = customerDomainsData.data.map((customer)=>{
        const domainScopedOverviewPath = getPathByDomainId((0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).OVERVIEW], customer.customerDomainId || "");
        return {
            key: customer.customerDomainId,
            cells: [
                {
                    key: "customerName",
                    content: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1KI7W.default), {
                                src: customer.customerLogoUrl,
                                alt: `${customer.customerName} logo`,
                                style: {
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "3px"
                                }
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                                size: "medium",
                                children: customer.customerName
                            })
                        ]
                    })
                },
                {
                    key: "customerDomain",
                    content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
                        space: "space.100",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                            children: customer.customerDomain
                        })
                    })
                },
                {
                    key: "actions",
                    content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
                        alignInline: "end",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                            appearance: "default",
                            spacing: "compact",
                            isDisabled: !domainScopedOverviewPath,
                            onClick: ()=>{
                                if (domainScopedOverviewPath) {
                                    sendSeeDetailsClickUIEvent(customer.customerDomain, customer.customerDomainId);
                                    navigate(domainScopedOverviewPath);
                                }
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $jfmcr.messages).seeDetailsButton))
                        })
                    })
                }
            ]
        };
    });
    return {
        isTableLoading: customerDomainsPending,
        isTableError: !!customerDomainsError,
        rows: rows,
        head: head,
        pagination: customerDomainsData.pagination
    };
};

});
parcelRegister("1KI7W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $146c510926b1cd55$export$2e2bcd8739ae039; });

var $gW9cz = parcelRequire("gW9cz");

var $hs5x9 = parcelRequire("hs5x9");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $kFM7Y = parcelRequire("kFM7Y");

var $7cetU = parcelRequire("7cetU");
var $146c510926b1cd55$var$_excluded = [
    "src",
    "srcDark",
    "alt",
    "testId"
];
var $146c510926b1cd55$var$baseImageStyles = (0, $2ZUkg.css)({
    maxWidth: "100%",
    height: "auto"
});
var $146c510926b1cd55$var$themedImageStyles = (0, $2ZUkg.css)({
    content: "url(var(--img-source))",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "html[data-color-mode=dark] &": {
        content: "var(--img-source-dark)"
    }
});
function $146c510926b1cd55$export$2e2bcd8739ae039(_ref) {
    var src = _ref.src, srcDark = _ref.srcDark, alt = _ref.alt, testId = _ref.testId, props = (0, $hs5x9.default)(_ref, $146c510926b1cd55$var$_excluded);
    var imgRef = (0, $iSvIT.useRef)(null);
    var providedColorMode = (0, $kFM7Y.UNSAFE_useColorModeForMigration)();
    var _useThemeObserver = (0, $7cetU.default)(), observedColorMode = _useThemeObserver.colorMode;
    var colorMode = providedColorMode || observedColorMode;
    (0, $iSvIT.useEffect)(function() {
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === "dark") imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return (0, $2ZUkg.jsx)("img", (0, $gW9cz.default)({
        alt: alt,
        "data-testid": testId,
        src: src,
        style: {
            "--img-source": src,
            "--img-source-dark": srcDark || src
        },
        css: [
            $146c510926b1cd55$var$baseImageStyles,
            $146c510926b1cd55$var$themedImageStyles
        ],
        ref: imgRef
    }, props));
}

});
parcelRegister("gW9cz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c549336a8d160bbc$export$2e2bcd8739ae039; });
function $c549336a8d160bbc$export$2e2bcd8739ae039() {
    return $c549336a8d160bbc$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c549336a8d160bbc$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hs5x9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb4958132ca8907f$export$2e2bcd8739ae039; });

var $118gk = parcelRequire("118gk");
function $cb4958132ca8907f$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $118gk.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("118gk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bdc4b3020021367$export$2e2bcd8739ae039; });
function $0bdc4b3020021367$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("kFM7Y", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", function () { return $f0ccf821e93a9dd1$export$ce91654eb9fea460; });

var $bWcnT = parcelRequire("bWcnT");

var $iLMI3 = parcelRequire("iLMI3");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $cs0Xq = parcelRequire("cs0Xq");
function $f0ccf821e93a9dd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f0ccf821e93a9dd1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f0ccf821e93a9dd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $bWcnT.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f0ccf821e93a9dd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f0ccf821e93a9dd1$var$defaultThemeSettings = {
    dark: "dark",
    light: "light",
    spacing: "spacing"
};
var $f0ccf821e93a9dd1$var$ColorModeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $f0ccf821e93a9dd1$var$SetColorModeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $f0ccf821e93a9dd1$var$ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $f0ccf821e93a9dd1$var$SetThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
function $f0ccf821e93a9dd1$export$ce91654eb9fea460() {
    var value = (0, $iSvIT.useContext)($f0ccf821e93a9dd1$var$ColorModeContext);
    return value;
}
function $f0ccf821e93a9dd1$export$20f3076712c8dfa() {
    var value = (0, $iSvIT.useContext)($f0ccf821e93a9dd1$var$ColorModeContext);
    if (!value) throw new Error("useColorMode must be used within AppProvider.");
    return value;
}
function $f0ccf821e93a9dd1$export$e2afe7397c3d11c7() {
    var value = (0, $iSvIT.useContext)($f0ccf821e93a9dd1$var$SetColorModeContext);
    if (!value) throw new Error("useSetColorMode must be used within AppProvider.");
    return value;
}
function $f0ccf821e93a9dd1$export$93d4e7f90805808f() {
    var value = (0, $iSvIT.useContext)($f0ccf821e93a9dd1$var$ThemeContext);
    if (!value) throw new Error("useTheme must be used within AppProvider.");
    return value;
}
function $f0ccf821e93a9dd1$export$501aa0dcd5527a48() {
    var value = (0, $iSvIT.useContext)($f0ccf821e93a9dd1$var$SetThemeContext);
    if (!value) throw new Error("useSetTheme must be used within AppProvider.");
    return value;
}
var $f0ccf821e93a9dd1$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
var $f0ccf821e93a9dd1$var$prefersDarkModeMql = $f0ccf821e93a9dd1$var$isMatchMediaAvailable ? window.matchMedia("(prefers-color-scheme: dark)") : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $f0ccf821e93a9dd1$var$getReconciledColorMode(colorMode) {
    if (colorMode === "auto") return $f0ccf821e93a9dd1$var$prefersDarkModeMql !== null && $f0ccf821e93a9dd1$var$prefersDarkModeMql !== void 0 && $f0ccf821e93a9dd1$var$prefersDarkModeMql.matches ? "dark" : "light";
    return colorMode;
}
function $f0ccf821e93a9dd1$export$d8964aec282183a3(_ref) {
    var children = _ref.children, defaultColorMode = _ref.defaultColorMode, _ref$defaultTheme = _ref.defaultTheme, _ref$defaultTheme2 = _ref$defaultTheme === void 0 ? $f0ccf821e93a9dd1$var$defaultThemeSettings : _ref$defaultTheme, _ref$defaultTheme2$da = _ref$defaultTheme2.dark, dark = _ref$defaultTheme2$da === void 0 ? "dark" : _ref$defaultTheme2$da, _ref$defaultTheme2$li = _ref$defaultTheme2.light, light = _ref$defaultTheme2$li === void 0 ? "light" : _ref$defaultTheme2$li, _ref$defaultTheme2$sp = _ref$defaultTheme2.spacing, spacing = _ref$defaultTheme2$sp === void 0 ? "spacing" : _ref$defaultTheme2$sp, typography = _ref$defaultTheme2.typography, shape = _ref$defaultTheme2.shape;
    var _useState = (0, $iSvIT.useState)(defaultColorMode), _useState2 = (0, $iLMI3.default)(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)($f0ccf821e93a9dd1$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, $iLMI3.default)(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)({
        dark: dark,
        light: light,
        spacing: spacing,
        typography: typography,
        shape: shape
    }), _useState6 = (0, $iLMI3.default)(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $iSvIT.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($f0ccf821e93a9dd1$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $iSvIT.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $f0ccf821e93a9dd1$var$_objectSpread($f0ccf821e93a9dd1$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    (0, $iSvIT.useEffect)(function() {
        (0, $cs0Xq.default)($f0ccf821e93a9dd1$var$_objectSpread($f0ccf821e93a9dd1$var$_objectSpread({}, theme), {}, {
            colorMode: reconciledColorMode
        }));
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!$f0ccf821e93a9dd1$var$prefersDarkModeMql) return;
        var unbindListener = (0, $2e1kT.bind)($f0ccf821e93a9dd1$var$prefersDarkModeMql, {
            type: "change",
            listener: function listener(event) {
                if (chosenColorMode === "auto") setReconciledColorMode(event.matches ? "dark" : "light");
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($f0ccf821e93a9dd1$var$ColorModeContext.Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($f0ccf821e93a9dd1$var$SetColorModeContext.Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($f0ccf821e93a9dd1$var$ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($f0ccf821e93a9dd1$var$SetThemeContext.Provider, {
        value: setPartialTheme
    }, children))));
}
var $f0ccf821e93a9dd1$export$2e2bcd8739ae039 = $f0ccf821e93a9dd1$export$d8964aec282183a3;

});
parcelRegister("bWcnT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b0eb7c92ca47dde$export$2e2bcd8739ae039; });

var $eGJjs = parcelRequire("eGJjs");
function $8b0eb7c92ca47dde$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $eGJjs.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("eGJjs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab18231c93c67a44$export$2e2bcd8739ae039; });

var $dmuib = parcelRequire("dmuib");

var $d70j5 = parcelRequire("d70j5");
function $ab18231c93c67a44$export$2e2bcd8739ae039(t) {
    var i = (0, $d70j5.default)(t, "string");
    return "symbol" == (0, $dmuib.default)(i) ? i : i + "";
}

});
parcelRegister("dmuib", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ba4d3dde895ff5d$export$2e2bcd8739ae039; });
function $9ba4d3dde895ff5d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $9ba4d3dde895ff5d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9ba4d3dde895ff5d$export$2e2bcd8739ae039(o);
}

});

parcelRegister("d70j5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98bc2ab9be6b6093$export$2e2bcd8739ae039; });

var $dmuib = parcelRequire("dmuib");
function $98bc2ab9be6b6093$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $dmuib.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $dmuib.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("iLMI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $daa26676f95cd801$export$2e2bcd8739ae039; });

var $j2Y7w = parcelRequire("j2Y7w");

var $bvccu = parcelRequire("bvccu");

var $b79Qo = parcelRequire("b79Qo");

var $89YLe = parcelRequire("89YLe");
function $daa26676f95cd801$export$2e2bcd8739ae039(r, e) {
    return (0, $j2Y7w.default)(r) || (0, $bvccu.default)(r, e) || (0, $b79Qo.default)(r, e) || (0, $89YLe.default)();
}

});
parcelRegister("j2Y7w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dddcd6e08e26b2b6$export$2e2bcd8739ae039; });
function $dddcd6e08e26b2b6$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("bvccu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85fc0db3f9cccf78$export$2e2bcd8739ae039; });
function $85fc0db3f9cccf78$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("b79Qo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8177fbf565e9a624$export$2e2bcd8739ae039; });

var $bakWc = parcelRequire("bakWc");
function $8177fbf565e9a624$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $bakWc.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $bakWc.default)(r, a) : void 0;
    }
}

});
parcelRegister("bakWc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8210deb25e6c687d$export$2e2bcd8739ae039; });
function $8210deb25e6c687d$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("89YLe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f0e4bcd3d74d28f$export$2e2bcd8739ae039; });
function $5f0e4bcd3d74d28f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("cs0Xq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9108d7b7d1e1546f$export$2e2bcd8739ae039; });

var $88bju = parcelRequire("88bju");

var $1X1H4 = parcelRequire("1X1H4");

var $9TKPv = parcelRequire("9TKPv");

var $5w20G = parcelRequire("5w20G");

var $jRV4R = parcelRequire("jRV4R");

var $g5jeU = parcelRequire("g5jeU");

var $dtCTo = parcelRequire("dtCTo");

var $avBc8 = parcelRequire("avBc8");

var $iR3ws = parcelRequire("iR3ws");
function $9108d7b7d1e1546f$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $9108d7b7d1e1546f$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $9108d7b7d1e1546f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9108d7b7d1e1546f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9108d7b7d1e1546f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9108d7b7d1e1546f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $9108d7b7d1e1546f$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, $88bju.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1X1H4))).mark(function _callee3() {
        var _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeLoader, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1X1H4))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _ref2 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $5w20G.themeStateDefaults)["colorMode"] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $5w20G.themeStateDefaults)["contrastMode"] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $5w20G.themeStateDefaults)["dark"] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $5w20G.themeStateDefaults)["light"] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $5w20G.themeStateDefaults)["shape"] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $5w20G.themeStateDefaults)["spacing"] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $5w20G.themeStateDefaults)["typography"]() : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $5w20G.themeStateDefaults)["UNSAFE_themeOptions"] : _ref2$UNSAFE_themeOpt;
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $9TKPv.fg)("platform_increased-contrast-themes")) {
                        if (light === "light-increased-contrast") light = "light";
                        if (dark === "dark-increased-contrast") dark = "dark";
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $avBc8.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $iR3ws.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, $88bju.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1X1H4))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($1X1H4))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $jRV4R.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $5w20G.themeStateDefaults)["colorMode"];
                        attrOfMissingCustomStyles = (0, $dtCTo.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, $88bju.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1X1H4))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($1X1H4))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("8OtO4"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? "auto" : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 10;
                    return Promise.all(loadingTasks);
                case 10:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $avBc8.getThemeOverridePreferences)(themeState);
                    _iterator = $9108d7b7d1e1546f$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 12;
                    _iterator.s();
                case 14:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 20;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 18;
                    return loadingStrategy(themeId);
                case 18:
                    _context3.next = 14;
                    break;
                case 20:
                    _context3.next = 25;
                    break;
                case 22:
                    _context3.prev = 22;
                    _context3.t0 = _context3["catch"](12);
                    _iterator.e(_context3.t0);
                case 25:
                    _context3.prev = 25;
                    _iterator.f();
                    return _context3.finish(25);
                case 28:
                    autoUnbind = (0, $g5jeU.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 30:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                12,
                22,
                25,
                28
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $9108d7b7d1e1546f$export$2e2bcd8739ae039 = $9108d7b7d1e1546f$var$setGlobalTheme;

});
parcelRegister("88bju", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5eb7d8ae015a3781$export$2e2bcd8739ae039; });
function $5eb7d8ae015a3781$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $5eb7d8ae015a3781$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $5eb7d8ae015a3781$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $5eb7d8ae015a3781$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("1X1H4", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $16bc9d719781691a$var$runtime = (parcelRequire("k4dWT"))();
module.exports = $16bc9d719781691a$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $16bc9d719781691a$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $16bc9d719781691a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($16bc9d719781691a$var$runtime);
}

});
parcelRegister("k4dWT", function(module, exports) {

var $9Cb02 = parcelRequire("9Cb02");

var $crXjm = parcelRequire("crXjm");

var $kD5Bl = parcelRequire("kD5Bl");

var $79V2A = parcelRequire("79V2A");

var $lIYBM = parcelRequire("lIYBM");

var $kPylX = parcelRequire("kPylX");

var $h4hqT = parcelRequire("h4hqT");
function $e9bf00543b3a6e59$var$_regeneratorRuntime() {
    "use strict";
    var r = $crXjm(), e = r.m($e9bf00543b3a6e59$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $h4hqT(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $e9bf00543b3a6e59$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $9Cb02(r, e);
            },
            AsyncIterator: $lIYBM,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $79V2A : $kD5Bl)(a(r), e, t, o, u);
            },
            keys: $kPylX,
            values: $h4hqT
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $e9bf00543b3a6e59$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9Cb02", function(module, exports) {
function $700031fa4765c860$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $700031fa4765c860$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("crXjm", function(module, exports) {

var $hYmgI = parcelRequire("hYmgI");
function $910603a2c0601e39$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $hYmgI(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($hYmgI(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $hYmgI(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $hYmgI(u, "constructor", GeneratorFunctionPrototype), $hYmgI(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $hYmgI(GeneratorFunctionPrototype, o, "GeneratorFunction"), $hYmgI(u), $hYmgI(u, o, "Generator"), $hYmgI(u, n, function() {
        return this;
    }), $hYmgI(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $910603a2c0601e39$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $910603a2c0601e39$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hYmgI", function(module, exports) {
function $d1595053bafb7df4$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $d1595053bafb7df4$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $d1595053bafb7df4$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d1595053bafb7df4$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $d1595053bafb7df4$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kD5Bl", function(module, exports) {

var $79V2A = parcelRequire("79V2A");
function $f04bcb7af9fb6135$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $79V2A(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $f04bcb7af9fb6135$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("79V2A", function(module, exports) {

var $crXjm = parcelRequire("crXjm");

var $lIYBM = parcelRequire("lIYBM");
function $53659ebf934c89d6$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $lIYBM($crXjm().w(r, e, t, o), n || Promise);
}
module.exports = $53659ebf934c89d6$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lIYBM", function(module, exports) {

var $9Cb02 = parcelRequire("9Cb02");

var $hYmgI = parcelRequire("hYmgI");
function $fd0cb891672f9c40$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $9Cb02 ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($hYmgI($fd0cb891672f9c40$var$AsyncIterator.prototype), $hYmgI($fd0cb891672f9c40$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $hYmgI(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $fd0cb891672f9c40$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("kPylX", function(module, exports) {
function $f2a337e952632d6c$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $f2a337e952632d6c$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("h4hqT", function(module, exports) {

var $6Ngx5 = parcelRequire("6Ngx5");
var $c6d055286c8ad6bf$var$_typeof = $6Ngx5.default;
function $c6d055286c8ad6bf$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($c6d055286c8ad6bf$var$_typeof(e) + " is not iterable");
}
module.exports = $c6d055286c8ad6bf$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6Ngx5", function(module, exports) {
function $4f2424b482864456$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $4f2424b482864456$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $4f2424b482864456$var$_typeof(o);
}
module.exports = $4f2424b482864456$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("9TKPv", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $734d938b5add819a$export$b40ec24ac8275656; });

var $kMNao = parcelRequire("kMNao");
function $734d938b5add819a$export$ba05d765b8392e5e(flagResolver) {
    (0, $kMNao.setBooleanResolver)(flagResolver);
}
function $734d938b5add819a$export$470e5c2be1411c89(name) {
    return (0, $kMNao.resolveBooleanFlag)(name);
}
function $734d938b5add819a$export$b40ec24ac8275656(name) {
    return (0, $kMNao.resolveBooleanFlag)(name);
}

});
parcelRegister("kMNao", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $f21e6dcc578164e9$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $f21e6dcc578164e9$export$6333b6aff9fc6275; });

var $fawwq = parcelRequire("fawwq");

var $XAEGR = parcelRequire("XAEGR");
var $f21e6dcc578164e9$var$pkgName = "@atlaskit/platform-feature-flags";
var $f21e6dcc578164e9$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $f21e6dcc578164e9$var$hasProcessEnv = typeof $XAEGR !== "undefined" && typeof $XAEGR.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $f21e6dcc578164e9$var$ENV_ENABLE_PLATFORM_FF = $f21e6dcc578164e9$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $f21e6dcc578164e9$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $f21e6dcc578164e9$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $f21e6dcc578164e9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $f21e6dcc578164e9$var$ENV_ENABLE_PLATFORM_FF || $f21e6dcc578164e9$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $f21e6dcc578164e9$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $f21e6dcc578164e9$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$f21e6dcc578164e9$var$globalVar[$f21e6dcc578164e9$export$7e41b1b2bdee3f98] = $f21e6dcc578164e9$var$globalVar[$f21e6dcc578164e9$export$7e41b1b2bdee3f98] || $f21e6dcc578164e9$var$DEFAULT_PFF_GLOBAL;
function $f21e6dcc578164e9$export$f2b591175b3e424c(resolver) {
    $f21e6dcc578164e9$var$globalVar[$f21e6dcc578164e9$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $f21e6dcc578164e9$export$6333b6aff9fc6275(flagKey) {
    if ($f21e6dcc578164e9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $fawwq.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $f21e6dcc578164e9$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $f21e6dcc578164e9$var$globalVar[$f21e6dcc578164e9$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("fawwq", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $b0b1046314bed73b$export$1c9f709888824e05; });
var $b0b1046314bed73b$var$_ref, $b0b1046314bed73b$var$_process, $b0b1046314bed73b$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $b0b1046314bed73b$var$TESTS_MODE = ($b0b1046314bed73b$var$_ref = (globalThis === null || globalThis === void 0 || ($b0b1046314bed73b$var$_process = globalThis.process) === null || $b0b1046314bed73b$var$_process === void 0 || ($b0b1046314bed73b$var$_process = $b0b1046314bed73b$var$_process.env) === null || $b0b1046314bed73b$var$_process === void 0 ? void 0 : $b0b1046314bed73b$var$_process.JEST_WORKER_ID) !== undefined, $b0b1046314bed73b$var$_ref !== void 0) ? $b0b1046314bed73b$var$_ref : false;
var $b0b1046314bed73b$var$DEBUG_MODE = !$b0b1046314bed73b$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($b0b1046314bed73b$var$_process2 = globalThis.process) === null || $b0b1046314bed73b$var$_process2 === void 0 || ($b0b1046314bed73b$var$_process2 = $b0b1046314bed73b$var$_process2.env) === null || $b0b1046314bed73b$var$_process2 === void 0 ? void 0 : $b0b1046314bed73b$var$_process2.NODE_ENV) !== "production";
var $b0b1046314bed73b$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$b0b1046314bed73b$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("5w20G", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $4041800efb4fc218$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $4041800efb4fc218$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $4041800efb4fc218$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $4041800efb4fc218$export$2e2bcd8739ae039; });

var $9TKPv = parcelRequire("9TKPv");
var $4041800efb4fc218$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
var $4041800efb4fc218$export$8ce7e340c74e86c5 = [
    "more",
    "no-preference",
    "auto"
];
var $4041800efb4fc218$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "light-brand-refresh",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "dark-brand-refresh",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography-adg3",
    "typography-modernized",
    "typography-refreshed"
];
var $4041800efb4fc218$export$ba8a43b83ecc69f8 = [];
var $4041800efb4fc218$export$92ba366331403db2 = [].concat($4041800efb4fc218$export$7d43e72a58e3283f, $4041800efb4fc218$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $4041800efb4fc218$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-modernized": {
        id: "typography-modernized",
        displayName: "Atlassian Typography (Modernized)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-refreshed": {
        id: "typography-refreshed",
        displayName: "Atlassian Typography (Refreshed)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-light-brand-refresh": {
        id: "light-brand-refresh",
        displayName: "Light theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-brand-refresh": {
        id: "dark-brand-refresh",
        displayName: "Dark theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    }
};
var $4041800efb4fc218$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: function typography() {
        if ((0, $9TKPv.fg)("platform-default-typography-modernized")) return "typography-modernized";
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $4041800efb4fc218$export$2e2bcd8739ae039 = $4041800efb4fc218$var$themeConfig;

});

parcelRegister("jRV4R", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $e76f3dedd031d1df$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $e76f3dedd031d1df$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $e76f3dedd031d1df$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $e76f3dedd031d1df$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $e76f3dedd031d1df$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $e76f3dedd031d1df$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $e76f3dedd031d1df$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $e76f3dedd031d1df$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $e76f3dedd031d1df$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $e76f3dedd031d1df$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $e76f3dedd031d1df$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $e76f3dedd031d1df$export$34d09c4a771c46ef(r, g, b) {
    return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $e76f3dedd031d1df$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $e76f3dedd031d1df$export$b36dbdb4f463f05c(hex) {
    if (!$e76f3dedd031d1df$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $e76f3dedd031d1df$export$1212645cf40ebf71(hex)
    ];
}
function $e76f3dedd031d1df$export$5a544e13ad4e1fa5(hex) {
    if (!$e76f3dedd031d1df$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $e76f3dedd031d1df$export$47ea145a83f50dc0(hex) {
    if (!$e76f3dedd031d1df$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $e76f3dedd031d1df$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $e76f3dedd031d1df$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $e76f3dedd031d1df$export$d061e26956a60b0a(foreground, background) {
    if (!$e76f3dedd031d1df$var$isValidHex(foreground) || !$e76f3dedd031d1df$var$isValidHex(background)) throw new Error("Invalid HEX");
    var foregroundRgb = $e76f3dedd031d1df$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $e76f3dedd031d1df$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $e76f3dedd031d1df$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $e76f3dedd031d1df$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $e76f3dedd031d1df$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $e76f3dedd031d1df$var$rgbToLab(rgbA);
    var labB = $e76f3dedd031d1df$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $e76f3dedd031d1df$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("g5jeU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb5c098a268d2659$export$2e2bcd8739ae039; });

var $iLMI3 = parcelRequire("iLMI3");

var $9TKPv = parcelRequire("9TKPv");

var $1xMQ3 = parcelRequire("1xMQ3");

var $3UrVx = parcelRequire("3UrVx");

var $3GY34 = parcelRequire("3GY34");
function $bb5c098a268d2659$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === "auto") {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $3UrVx.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $3UrVx.default).bind();
    } else (0, $3UrVx.default).unbind();
    if ((0, $9TKPv.fg)("platform_increased-contrast-themes")) {
        if (themeState.contrastMode === "auto") {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $3GY34.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $3GY34.default).bind();
        } else (0, $3GY34.default).unbind();
    }
    var themeAttributes = (0, $1xMQ3.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, $iLMI3.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $3UrVx.default).unbind();
        if ((0, $9TKPv.fg)("platform_increased-contrast-themes")) (0, $3GY34.default).unbind();
    };
}

});
parcelRegister("1xMQ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11fec1d24b4a0055$export$2e2bcd8739ae039; });

var $bWcnT = parcelRequire("bWcnT");

var $9TKPv = parcelRequire("9TKPv");

var $2qVEY = parcelRequire("2qVEY");

var $5w20G = parcelRequire("5w20G");

var $jOzZf = parcelRequire("jOzZf");

var $jRV4R = parcelRequire("jRV4R");

var $jyb2Y = parcelRequire("jyb2Y");
function $11fec1d24b4a0055$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11fec1d24b4a0055$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11fec1d24b4a0055$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $bWcnT.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11fec1d24b4a0055$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $11fec1d24b4a0055$var$defaultColorMode = "light";
var $11fec1d24b4a0055$var$defaultContrastMode = "no-preference";
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $11fec1d24b4a0055$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _result;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $5w20G.themeStateDefaults)["colorMode"] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $5w20G.themeStateDefaults)["dark"] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $5w20G.themeStateDefaults)["light"] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $5w20G.themeStateDefaults)["contrastMode"] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $5w20G.themeStateDefaults)["shape"] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $5w20G.themeStateDefaults)["spacing"] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $5w20G.themeStateDefaults)["typography"]() : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $5w20G.themeStateDefaults)["UNSAFE_themeOptions"] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $jOzZf.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (_result = {}, (0, $bWcnT.default)(_result, (0, $2qVEY.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $bWcnT.default)(_result, (0, $2qVEY.COLOR_MODE_ATTRIBUTE), colorMode === "auto" ? $11fec1d24b4a0055$var$defaultColorMode : colorMode), _result);
    if ((0, $9TKPv.fg)("platform_increased-contrast-themes")) result = $11fec1d24b4a0055$var$_objectSpread($11fec1d24b4a0055$var$_objectSpread({}, result), {}, (0, $bWcnT.default)({}, (0, $2qVEY.CONTRAST_MODE_ATTRIBUTE), contrastMode === "auto" ? $11fec1d24b4a0055$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $jRV4R.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $jyb2Y.hash)(optionString);
        result[0, $2qVEY.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $11fec1d24b4a0055$export$2e2bcd8739ae039 = $11fec1d24b4a0055$var$getThemeHtmlAttrs;

});
parcelRegister("2qVEY", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $1c5abc8bdfacee0c$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $1c5abc8bdfacee0c$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $1c5abc8bdfacee0c$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $1c5abc8bdfacee0c$export$352e418ed5b6193a; });
var $1c5abc8bdfacee0c$export$4ef52930e33717cd = "data-theme";
var $1c5abc8bdfacee0c$export$a00eac3f8684bcd0 = "data-color-mode";
var $1c5abc8bdfacee0c$export$2112803007239c61 = "data-contrast-mode";
var $1c5abc8bdfacee0c$export$352e418ed5b6193a = "data-custom-theme";
var $1c5abc8bdfacee0c$export$2faeed762aac6741 = "light";
var $1c5abc8bdfacee0c$export$6f0c6fb8c80fcc92 = "ds";
var $1c5abc8bdfacee0c$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $1c5abc8bdfacee0c$export$dddac1532e822863 = "--".concat($1c5abc8bdfacee0c$export$6f0c6fb8c80fcc92, "-token-not-found");
var $1c5abc8bdfacee0c$export$9d7b58831ae93caa = "--".concat($1c5abc8bdfacee0c$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("jOzZf", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $e6ce9a12fd8a1a14$export$f19b488f7c0547ee; });
$parcel$export(module.exports, "themeObjectToString", function () { return $e6ce9a12fd8a1a14$export$62c37ab81302621a; });

var $dmuib = parcelRequire("dmuib");

var $iLMI3 = parcelRequire("iLMI3");

var $5w20G = parcelRequire("5w20G");
var $e6ce9a12fd8a1a14$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $e6ce9a12fd8a1a14$var$customThemeOptions = "UNSAFE_themeOptions";
var $e6ce9a12fd8a1a14$var$isThemeKind = function isThemeKind(themeKind) {
    return $e6ce9a12fd8a1a14$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $e6ce9a12fd8a1a14$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $5w20G.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $e6ce9a12fd8a1a14$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $e6ce9a12fd8a1a14$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([\s\S]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $iLMI3.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $e6ce9a12fd8a1a14$var$isColorMode(id)) themeObject[kind] = id;
        if ($e6ce9a12fd8a1a14$var$isThemeKind(kind) && $e6ce9a12fd8a1a14$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $e6ce9a12fd8a1a14$var$customThemeOptions) try {
            themeObject[$e6ce9a12fd8a1a14$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $e6ce9a12fd8a1a14$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, $iLMI3.default)(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $e6ce9a12fd8a1a14$var$isColorMode(id) || // custom theme state
        kind === $e6ce9a12fd8a1a14$var$customThemeOptions && (0, $dmuib.default)(id) === "object" || // other theme states
        $e6ce9a12fd8a1a14$var$isThemeKind(kind) && typeof id === "string" && $e6ce9a12fd8a1a14$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, $dmuib.default)(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};

});

parcelRegister("jyb2Y", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $e3b9c2fb32e15a1d$export$d6af199866bfb566; });
var $e3b9c2fb32e15a1d$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("3UrVx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d8c43cb36ba190f$export$2e2bcd8739ae039; });

var $bV5Tq = parcelRequire("bV5Tq");

var $8m3pq = parcelRequire("8m3pq");

var $bWcnT = parcelRequire("bWcnT");

var $2e1kT = parcelRequire("2e1kT");

var $2qVEY = parcelRequire("2qVEY");

var $iR3ws = parcelRequire("iR3ws");
var $2d8c43cb36ba190f$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $2d8c43cb36ba190f$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $2qVEY.COLOR_MODE_ATTRIBUTE), e.matches ? "dark" : "light");
}
var $2d8c43cb36ba190f$var$darkModeMql = $2d8c43cb36ba190f$var$isMatchMediaAvailable && window.matchMedia((0, $iR3ws.darkModeMediaQuery));
var $2d8c43cb36ba190f$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, $bV5Tq.default)(this, ColorModeObserver);
        (0, $bWcnT.default)(this, "unbindThemeChangeListener", null);
    }
    (0, $8m3pq.default)(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$2d8c43cb36ba190f$var$darkModeMql) return "light";
                return $2d8c43cb36ba190f$var$darkModeMql !== null && $2d8c43cb36ba190f$var$darkModeMql !== void 0 && $2d8c43cb36ba190f$var$darkModeMql.matches ? "dark" : "light";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($2d8c43cb36ba190f$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $2e1kT.bind)($2d8c43cb36ba190f$var$darkModeMql, {
                    type: "change",
                    listener: $2d8c43cb36ba190f$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
    return ColorModeObserver;
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $2d8c43cb36ba190f$var$SingletonColorModeObserver = new $2d8c43cb36ba190f$var$ColorModeObserver();
var $2d8c43cb36ba190f$export$2e2bcd8739ae039 = $2d8c43cb36ba190f$var$SingletonColorModeObserver;

});
parcelRegister("bV5Tq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ad996c9ea57eb18$export$2e2bcd8739ae039; });
function $8ad996c9ea57eb18$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("8m3pq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $615305c1f4207837$export$2e2bcd8739ae039; });

var $eGJjs = parcelRequire("eGJjs");
function $615305c1f4207837$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $eGJjs.default)(o.key), o);
    }
}
function $615305c1f4207837$export$2e2bcd8739ae039(e, r, t) {
    return r && $615305c1f4207837$var$_defineProperties(e.prototype, r), t && $615305c1f4207837$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("iR3ws", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $db9fe8b84952b058$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $db9fe8b84952b058$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $db9fe8b84952b058$export$8662df6937d86fcb; });

var $88bju = parcelRequire("88bju");

var $1X1H4 = parcelRequire("1X1H4");

var $9TKPv = parcelRequire("9TKPv");

var $gq0d6 = parcelRequire("gq0d6");

var $2qVEY = parcelRequire("2qVEY");
var $db9fe8b84952b058$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, $88bju.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1X1H4))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1X1H4))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $2qVEY.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]:not([').concat((0, $2qVEY.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $db9fe8b84952b058$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement("style");
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $db9fe8b84952b058$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, $88bju.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1X1H4))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1X1H4))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((themeId === "light" || themeId === "dark") && (0, $9TKPv.fg)("platform-component-visual-refresh")) themeId += "-brand-refresh";
                    _context2.next = 3;
                    return (0, $gq0d6.default)[themeId]();
                case 3:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $db9fe8b84952b058$export$bb1e815119d30f8b = "(prefers-color-scheme: dark)";
var $db9fe8b84952b058$export$8662df6937d86fcb = "(prefers-contrast: more)";

});
parcelRegister("gq0d6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf3f3ccc76e76a7c$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::8352f41e09dfe9d45ead708661744456>>
 * @codegenCommand yarn build tokens
 */ 














var $bf3f3ccc76e76a7c$var$themeImportsMap = {
    "light": function light() {
        return (parcelRequire("79Kqe"));
    },
    "light-future": function lightFuture() {
        return (parcelRequire("lh587"));
    },
    "light-increased-contrast": function lightIncreasedContrast() {
        return (parcelRequire("lOX4o"));
    },
    "dark": function dark() {
        return (parcelRequire("efcjb"));
    },
    "dark-future": function darkFuture() {
        return (parcelRequire("d1tGC"));
    },
    "dark-increased-contrast": function darkIncreasedContrast() {
        return (parcelRequire("2V375"));
    },
    "legacy-light": function legacyLight() {
        return (parcelRequire("fjr3I"));
    },
    "legacy-dark": function legacyDark() {
        return (parcelRequire("bzhpS"));
    },
    "spacing": function spacing() {
        return (parcelRequire("avBbi"));
    },
    "typography-adg3": function typographyAdg3() {
        return (parcelRequire("bZCOA"));
    },
    "shape": function shape() {
        return (parcelRequire("6Y3jW"));
    },
    "typography-modernized": function typographyModernized() {
        return (parcelRequire("6Ebfn"));
    },
    "typography-refreshed": function typographyRefreshed() {
        return (parcelRequire("3hpuG"));
    },
    "light-brand-refresh": function lightBrandRefresh() {
        return (parcelRequire("iT1HY"));
    },
    "dark-brand-refresh": function darkBrandRefresh() {
        return (parcelRequire("vMqkD"));
    }
};
var $bf3f3ccc76e76a7c$export$2e2bcd8739ae039 = $bf3f3ccc76e76a7c$var$themeImportsMap;

});
parcelRegister("79Kqe", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("dvBWP")).then(()=>parcelRequire("5bneZ"));

});

parcelRegister("lh587", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("5FgMr")).then(()=>parcelRequire("bfgpa"));

});

parcelRegister("lOX4o", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("awwCm")).then(()=>parcelRequire("1da2C"));

});

parcelRegister("efcjb", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("6LoRj")).then(()=>parcelRequire("h5uZi"));

});

parcelRegister("d1tGC", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("jRbPf")).then(()=>parcelRequire("akka3"));

});

parcelRegister("2V375", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("gxBJW")).then(()=>parcelRequire("4hDRl"));

});

parcelRegister("fjr3I", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("b3x3u")).then(()=>parcelRequire("gUOzw"));

});

parcelRegister("bzhpS", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("e9wbO")).then(()=>parcelRequire("cAR3q"));

});

parcelRegister("avBbi", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("5dCDe")).then(()=>parcelRequire("XuvPD"));

});

parcelRegister("bZCOA", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("7A4Mk")).then(()=>parcelRequire("4GnBo"));

});

parcelRegister("6Y3jW", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("9pFAP")).then(()=>parcelRequire("ivwa6"));

});

parcelRegister("6Ebfn", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("5gkxf")).then(()=>parcelRequire("jrMtC"));

});

parcelRegister("3hpuG", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("2n8SJ")).then(()=>parcelRequire("lVFKn"));

});

parcelRegister("iT1HY", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("dw1Bv")).then(()=>parcelRequire("2b0kH"));

});

parcelRegister("vMqkD", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("luEUK")).then(()=>parcelRequire("kIzLp"));

});




parcelRegister("3GY34", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b03dfb761445717$export$2e2bcd8739ae039; });

var $bV5Tq = parcelRequire("bV5Tq");

var $8m3pq = parcelRequire("8m3pq");

var $bWcnT = parcelRequire("bWcnT");

var $2e1kT = parcelRequire("2e1kT");

var $2qVEY = parcelRequire("2qVEY");

var $iR3ws = parcelRequire("iR3ws");
var $2b03dfb761445717$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $2b03dfb761445717$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $2qVEY.CONTRAST_MODE_ATTRIBUTE), e.matches ? "more" : "no-preference");
}
var $2b03dfb761445717$var$contrastModeMql = $2b03dfb761445717$var$isMatchMediaAvailable && window.matchMedia((0, $iR3ws.moreContrastMediaQuery));
var $2b03dfb761445717$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, $bV5Tq.default)(this, ContrastModeObserver);
        (0, $bWcnT.default)(this, "unbindContrastChangeListener", null);
    }
    (0, $8m3pq.default)(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$2b03dfb761445717$var$contrastModeMql) return "no-preference";
                return $2b03dfb761445717$var$contrastModeMql !== null && $2b03dfb761445717$var$contrastModeMql !== void 0 && $2b03dfb761445717$var$contrastModeMql.matches ? "more" : "no-preference";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($2b03dfb761445717$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $2e1kT.bind)($2b03dfb761445717$var$contrastModeMql, {
                    type: "change",
                    listener: $2b03dfb761445717$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
    return ContrastModeObserver;
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $2b03dfb761445717$var$SingletonContrastModeObserver = new $2b03dfb761445717$var$ContrastModeObserver();
var $2b03dfb761445717$export$2e2bcd8739ae039 = $2b03dfb761445717$var$SingletonContrastModeObserver;

});


parcelRegister("dtCTo", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $9cfc27009c54eeb6$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $9cfc27009c54eeb6$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $9cfc27009c54eeb6$export$e673f367da2ff23e; });

var $iLMI3 = parcelRequire("iLMI3");

var $2CS4M = parcelRequire("2CS4M");

var $4DpkS = parcelRequire("4DpkS");

var $2qVEY = parcelRequire("2qVEY");

var $jyb2Y = parcelRequire("jyb2Y");
function $9cfc27009c54eeb6$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $jyb2Y.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === "auto" ? [
        "light",
        "dark"
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $2qVEY.CUSTOM_THEME_ATTRIBUTE), '="').concat(uniqueId, '"][').concat((0, $2qVEY.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $9cfc27009c54eeb6$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, $2CS4M.default)(Array.from(document.head.querySelectorAll("style[".concat((0, $2qVEY.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $2qVEY.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $9cfc27009c54eeb6$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, $iLMI3.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $4DpkS.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === "string" ? value : themeRamp[value], ";") : acc;
    }, "");
}

});
parcelRegister("2CS4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e9913cb25c1ff76$export$2e2bcd8739ae039; });

var $d2pC7 = parcelRequire("d2pC7");

var $eoJub = parcelRequire("eoJub");

var $b79Qo = parcelRequire("b79Qo");

var $dmQrp = parcelRequire("dmQrp");
function $1e9913cb25c1ff76$export$2e2bcd8739ae039(r) {
    return (0, $d2pC7.default)(r) || (0, $eoJub.default)(r) || (0, $b79Qo.default)(r) || (0, $dmQrp.default)();
}

});
parcelRegister("d2pC7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97df54a25bf61c4f$export$2e2bcd8739ae039; });

var $bakWc = parcelRequire("bakWc");
function $97df54a25bf61c4f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $bakWc.default)(r);
}

});

parcelRegister("eoJub", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7b6971b3852e838$export$2e2bcd8739ae039; });
function $a7b6971b3852e838$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("dmQrp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bb60225747c3e02$export$2e2bcd8739ae039; });
function $9bb60225747c3e02$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("4DpkS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35fe7519ff3530c2$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db26fca19e3969bcba2e77bc6fe6eb89>>
 * @codegenCommand yarn build tokens
 */ var $35fe7519ff3530c2$var$tokens = {
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.success": "--ds-text-success",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.information": "--ds-text-information",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.link.visited.pressed": "--ds-link-visited-pressed",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtlest": "--ds-icon-subtlest",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.textTransformUppercase": "--ds-UNSAFE-textTransformUppercase",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "border.radius.050": "--ds-border-radius-050",
    "border.radius": "--ds-border-radius",
    "border.radius.100": "--ds-border-radius-100",
    "border.radius.200": "--ds-border-radius-200",
    "border.radius.300": "--ds-border-radius-300",
    "border.radius.400": "--ds-border-radius-400",
    "border.radius.circle": "--ds-border-radius-circle",
    "border.width": "--ds-border-width",
    "border.width.0": "--ds-border-width-0",
    "border.width.indicator": "--ds-border-width-indicator",
    "border.width.outline": "--ds-border-width-outline",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.letterSpacing.0": "--ds-font-letterSpacing-0",
    "font.letterSpacing.100": "--ds-font-letterSpacing-100",
    "font.letterSpacing.200": "--ds-font-letterSpacing-200",
    "font.letterSpacing.300": "--ds-font-letterSpacing-300",
    "font.letterSpacing.400": "--ds-font-letterSpacing-400",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.body.large": "--ds-font-body-large",
    "font.body": "--ds-font-body",
    "font.body.small": "--ds-font-body-small",
    "font.body.UNSAFE_small": "--ds-font-body-UNSAFE_small",
    "font.code": "--ds-font-code",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.monospace": "--ds-font-family-monospace",
    "font.family.sans": "--ds-font-family-sans",
    "font.family.brand.heading": "--ds-font-family-brand-heading",
    "font.family.brand.body": "--ds-font-family-brand-body",
    "font.size.050": "--ds-font-size-050",
    "font.size.075": "--ds-font-size-075",
    "font.size.100": "--ds-font-size-100",
    "font.size.200": "--ds-font-size-200",
    "font.size.300": "--ds-font-size-300",
    "font.size.400": "--ds-font-size-400",
    "font.size.500": "--ds-font-size-500",
    "font.size.600": "--ds-font-size-600",
    "font.lineHeight.1": "--ds-font-lineHeight-1",
    "font.lineHeight.100": "--ds-font-lineHeight-100",
    "font.lineHeight.200": "--ds-font-lineHeight-200",
    "font.lineHeight.300": "--ds-font-lineHeight-300",
    "font.lineHeight.400": "--ds-font-lineHeight-400",
    "font.lineHeight.500": "--ds-font-lineHeight-500",
    "font.lineHeight.600": "--ds-font-lineHeight-600"
};
var $35fe7519ff3530c2$export$2e2bcd8739ae039 = $35fe7519ff3530c2$var$tokens;

});


parcelRegister("avBc8", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", function () { return $7a69a6b825c29d81$export$dd6aeb7c823fc03d; });
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $7a69a6b825c29d81$export$5d76d7014f4a5d08; });

var $2CS4M = parcelRequire("2CS4M");

var $9TKPv = parcelRequire("9TKPv");

var $lNzi3 = parcelRequire("lNzi3");
var $7a69a6b825c29d81$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === "auto") {
        if (contrastMode !== "no-preference" && (0, $9TKPv.fg)("platform_increased-contrast-themes")) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $lNzi3.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== "no-preference" && (0, $9TKPv.fg)("platform_increased-contrast-themes")) {
            var increasedContrastTheme = (0, $lNzi3.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, $2CS4M.default)(new Set(themePreferences));
};
var $7a69a6b825c29d81$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, $2CS4M.default)(new Set(themeOverridePreferences));
};

});
parcelRegister("lNzi3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fde98c73a66af1f7$export$2e2bcd8739ae039; });

var $iLMI3 = parcelRequire("iLMI3");

var $5w20G = parcelRequire("5w20G");
function $fde98c73a66af1f7$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $5w20G.default)).find(function(_ref) {
        var _ref2 = (0, $iLMI3.default)(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});


parcelRegister("8OtO4", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("cg3Ub")).then(()=>parcelRequire("8oxt9"));

});



parcelRegister("7cetU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53d4e3157b16e39b$export$2e2bcd8739ae039; });

var $iLMI3 = parcelRequire("iLMI3");

var $iSvIT = parcelRequire("iSvIT");

var $aJOXF = parcelRequire("aJOXF");

var $fpyid = parcelRequire("fpyid");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $53d4e3157b16e39b$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $iSvIT.useState)((0, $aJOXF.default)()), _useState2 = (0, $iLMI3.default)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        var observer = new (0, $fpyid.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $53d4e3157b16e39b$export$2e2bcd8739ae039 = $53d4e3157b16e39b$var$useThemeObserver;

});
parcelRegister("aJOXF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d15a33c0be88e8d$export$2e2bcd8739ae039; });

var $bWcnT = parcelRequire("bWcnT");

var $2qVEY = parcelRequire("2qVEY");

var $5w20G = parcelRequire("5w20G");

var $jOzZf = parcelRequire("jOzZf");
function $7d15a33c0be88e8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d15a33c0be88e8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d15a33c0be88e8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $bWcnT.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d15a33c0be88e8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7d15a33c0be88e8d$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $5w20G.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $7d15a33c0be88e8d$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $2qVEY.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $2qVEY.THEME_DATA_ATTRIBUTE)) || "";
    return $7d15a33c0be88e8d$var$_objectSpread($7d15a33c0be88e8d$var$_objectSpread({}, (0, $jOzZf.themeStringToObject)(theme)), $7d15a33c0be88e8d$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $7d15a33c0be88e8d$export$2e2bcd8739ae039 = $7d15a33c0be88e8d$var$getGlobalTheme;

});

parcelRegister("fpyid", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b383caab7b61152d$export$2e2bcd8739ae039; });

var $bV5Tq = parcelRequire("bV5Tq");

var $8m3pq = parcelRequire("8m3pq");

var $bWcnT = parcelRequire("bWcnT");

var $2qVEY = parcelRequire("2qVEY");

var $aJOXF = parcelRequire("aJOXF");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $b383caab7b61152d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $bV5Tq.default)(this, ThemeMutationObserver);
        (0, $bWcnT.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    (0, $8m3pq.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $aJOXF.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $2qVEY.THEME_DATA_ATTRIBUTE),
                            (0, $2qVEY.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
    return ThemeMutationObserver;
}();
(0, $bWcnT.default)($b383caab7b61152d$export$2e2bcd8739ae039, "observer", null);
(0, $bWcnT.default)($b383caab7b61152d$export$2e2bcd8739ae039, "callbacks", new Set());

});







parcelRegister("cOojB", function(module, exports) {

$parcel$export(module.exports, "FastshiftResourcesPage", function () { return (parcelRequire("9r6Sh")).FastshiftResourcesPage; });

var $9r6Sh = parcelRequire("9r6Sh");

});
parcelRegister("9r6Sh", function(module, exports) {

$parcel$export(module.exports, "FastshiftResourcesPage", function () { return $99291cb49e221515$export$b08eba65734a7bc3; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $gf1F9 = parcelRequire("gf1F9");

var $iofXe = parcelRequire("iofXe");
var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");

var $5WY8G = parcelRequire("5WY8G");
parcelRequire("9tKvJ");
var $anWa4 = parcelRequire("anWa4");
parcelRequire("2Zjkw");
var $arEIt = parcelRequire("arEIt");

var $eVVKF = parcelRequire("eVVKF");
parcelRequire("20BDH");
var $c9tcd = parcelRequire("c9tcd");
parcelRequire("gTtdI");
var $jul4s = parcelRequire("jul4s");
const $99291cb49e221515$export$b08eba65734a7bc3 = ()=>{
    const [currentTab, setCurrentTab] = (0, $iSvIT.useState)((0, $5WY8G.TAB_KEYS).ALL);
    (0, $anWa4.useResourcesPageAnalytics)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        space: "space.300",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                size: "large",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $eVVKF.messages).pageHeading))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jul4s.TabSelector), {
                currentTab: currentTab,
                tabs: (0, $5WY8G.TABS),
                onTabSelect: setCurrentTab
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $iofXe.default), {
                gap: "space.200",
                templateColumns: "1fr 1fr 1fr",
                children: (0, $5WY8G.RESOURCE_LINK_CARDS).filter((card)=>currentTab === (0, $5WY8G.TAB_KEYS).ALL || card.category === currentTab).map((card)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $c9tcd.ResourceLinkCard), (0, $7Knp0._)({}, card), card.id))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
                space: "space.200",
                grow: "fill",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $arEIt.LinkCardWrapper), {
                    heading: (0, $eVVKF.messages).usefulLinksHeading,
                    links: (0, $5WY8G.USEFUL_LINKS)
                })
            })
        ]
    });
};

});
parcelRegister("iofXe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d636d8173e3dd04b$export$2e2bcd8739ae039; });

var $6BH4v = parcelRequire("6BH4v");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $1dqlv = parcelRequire("1dqlv");

var $jAMCU = parcelRequire("jAMCU");
var $d636d8173e3dd04b$var$gridTemplateAreasVar = "--ds-grid--grid-template-areas";
var $d636d8173e3dd04b$var$gridTemplateColumnsVar = "--ds-grid--grid-template-columns";
var $d636d8173e3dd04b$var$gridTemplateRowsVar = "--ds-grid--grid-template-rows";
var $d636d8173e3dd04b$var$justifyContentMap = {
    start: (0, $2ZUkg.css)({
        justifyContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyContent: "stretch"
    })
};
var $d636d8173e3dd04b$var$justifyItemsMap = {
    start: (0, $2ZUkg.css)({
        justifyItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyItems: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyItems: "end"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyItems: "stretch"
    })
};
var $d636d8173e3dd04b$var$alignContentMap = {
    start: (0, $2ZUkg.css)({
        alignContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        alignContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        alignContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        alignContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        alignContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        alignContent: "stretch"
    })
};
var $d636d8173e3dd04b$var$alignItemsMap = {
    start: (0, $2ZUkg.css)({
        alignItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignItems: "center"
    }),
    baseline: (0, $2ZUkg.css)({
        alignItems: "baseline"
    }),
    end: (0, $2ZUkg.css)({
        alignItems: "end"
    })
};
var $d636d8173e3dd04b$var$baseStyles = (0, $2ZUkg.css)({
    display: "grid",
    boxSizing: "border-box",
    gridTemplateAreas: "var(".concat($d636d8173e3dd04b$var$gridTemplateAreasVar, ")"),
    gridTemplateColumns: "var(".concat($d636d8173e3dd04b$var$gridTemplateColumnsVar, ")"),
    gridTemplateRows: "var(".concat($d636d8173e3dd04b$var$gridTemplateRowsVar, ")")
});
var $d636d8173e3dd04b$var$gridAutoFlowMap = {
    row: (0, $2ZUkg.css)({
        gridAutoFlow: "row"
    }),
    column: (0, $2ZUkg.css)({
        gridAutoFlow: "column"
    }),
    dense: (0, $2ZUkg.css)({
        gridAutoFlow: "dense"
    }),
    "row dense": (0, $2ZUkg.css)({
        gridAutoFlow: "row dense"
    }),
    "column dense": (0, $2ZUkg.css)({
        gridAutoFlow: "column dense"
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ var $d636d8173e3dd04b$var$Grid = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignItems, alignContent = _ref.alignContent, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, id = _ref.id, role = _ref.role, testId = _ref.testId, autoFlow = _ref.autoFlow, gridTemplateAreas = _ref.templateAreas, gridTemplateRows = _ref.templateRows, gridTemplateColumns = _ref.templateColumns, xcss = _ref.xcss;
    var Component = as || "div";
    var resolvedStyles = (0, $jAMCU.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ var style = (0, $iSvIT.useMemo)(function() {
        return (0, $6BH4v.default)((0, $6BH4v.default)((0, $6BH4v.default)({}, $d636d8173e3dd04b$var$gridTemplateAreasVar, gridTemplateAreas ? gridTemplateAreas.map(function(str) {
            return '"'.concat(str, '"');
        }).join("\n") || "initial" : "initial"), $d636d8173e3dd04b$var$gridTemplateColumnsVar, gridTemplateColumns || "initial"), $d636d8173e3dd04b$var$gridTemplateRowsVar, gridTemplateRows || "initial");
    }, [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return (0, $2ZUkg.jsx)(Component, {
        id: id,
        role: role,
        style: style,
        className: resolvedStyles.static,
        css: [
            $d636d8173e3dd04b$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $1dqlv.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $1dqlv.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $1dqlv.spaceStylesMap).rowGap[rowGap],
            alignItems && $d636d8173e3dd04b$var$alignItemsMap[alignItems],
            alignContent && $d636d8173e3dd04b$var$alignContentMap[alignContent],
            justifyContent && $d636d8173e3dd04b$var$justifyContentMap[justifyContent],
            autoFlow && $d636d8173e3dd04b$var$gridAutoFlowMap[autoFlow],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$d636d8173e3dd04b$var$Grid.displayName = "Grid";
var $d636d8173e3dd04b$export$2e2bcd8739ae039 = $d636d8173e3dd04b$var$Grid;

});

parcelRegister("5WY8G", function(module, exports) {

$parcel$export(module.exports, "TAB_KEYS", function () { return $7e319c358ef9b36c$export$c672a3478ed79724; });
$parcel$export(module.exports, "TABS", function () { return $7e319c358ef9b36c$export$73b877b58963a4f; });
$parcel$export(module.exports, "RESOURCE_LINK_CARDS", function () { return $7e319c358ef9b36c$export$115c227af3fc4874; });
$parcel$export(module.exports, "USEFUL_LINKS", function () { return $7e319c358ef9b36c$export$9b1e1aec2488ce2e; });

var $loA2J = parcelRequire("loA2J");

var $kqqsh = parcelRequire("kqqsh");

var $6x3OQ = parcelRequire("6x3OQ");

var $9LeTf = parcelRequire("9LeTf");

var $eueWN = parcelRequire("eueWN");

var $ko7jr = parcelRequire("ko7jr");

var $afd57 = parcelRequire("afd57");

var $dIlnf = parcelRequire("dIlnf");

var $4w8Rb = parcelRequire("4w8Rb");

var $eVVKF = parcelRequire("eVVKF");
var $7e319c358ef9b36c$export$c672a3478ed79724;
(function(TAB_KEYS) {
    TAB_KEYS["ALL"] = "all";
    TAB_KEYS["ASSESSMENTS"] = "assessments";
    TAB_KEYS["PLANNING"] = "planning";
    TAB_KEYS["TEST_RUN"] = "testRun";
    TAB_KEYS["LAUNCH"] = "launch";
})($7e319c358ef9b36c$export$c672a3478ed79724 || ($7e319c358ef9b36c$export$c672a3478ed79724 = {}));
const $7e319c358ef9b36c$export$73b877b58963a4f = [
    {
        id: "all",
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dIlnf))), {
            label: ""
        }),
        tagIcon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dIlnf))), {
            label: "",
            size: "small"
        }),
        text: (0, $eVVKF.messages).tabPillAllText
    },
    {
        id: "assessments",
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6x3OQ))), {
            label: ""
        }),
        tagIcon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6x3OQ))), {
            label: "",
            size: "small"
        }),
        text: (0, $eVVKF.messages).tabPillAssessmentsText
    },
    {
        id: "planning",
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4w8Rb))), {
            label: ""
        }),
        tagIcon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4w8Rb))), {
            label: "",
            size: "small"
        }),
        text: (0, $eVVKF.messages).tabPillPlanningText
    },
    {
        id: "testRun",
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eueWN))), {
            label: ""
        }),
        tagIcon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eueWN))), {
            label: "",
            size: "small"
        }),
        text: (0, $eVVKF.messages).tabPillTestRunText
    },
    {
        id: "launch",
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ko7jr))), {
            label: ""
        }),
        tagIcon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ko7jr))), {
            label: "",
            size: "small"
        }),
        text: (0, $eVVKF.messages).tabPillLaunchText
    }
];
const $7e319c358ef9b36c$export$115c227af3fc4874 = [
    {
        id: "portfolio_insights",
        heading: (0, $eVVKF.messages).card1Heading,
        description: (0, $eVVKF.messages).card1Description,
        category: "assessments",
        link: {
            linkText: (0, $eVVKF.messages).linkText,
            href: "https://support.atlassian.com/portfolio-insights/docs/about-portfolio-insights/"
        }
    },
    {
        id: "detect_and_connect_to_your_portfolio",
        heading: (0, $eVVKF.messages).card2Heading,
        description: (0, $eVVKF.messages).card2Description,
        category: "assessments",
        link: {
            linkText: (0, $eVVKF.messages).linkText,
            href: "https://support.atlassian.com/portfolio-insights/docs/detect-and-connect-to-your-portfolio/"
        }
    },
    {
        id: "assess_jira_cloud_readiness",
        heading: (0, $eVVKF.messages).card3Heading,
        description: (0, $eVVKF.messages).card3Description,
        category: "assessments",
        link: {
            linkText: (0, $eVVKF.messages).linkText,
            href: "https://confluence.atlassian.com/support/assess-your-instance-scale-using-jira-cloud-migration-assistant-database-queries-and-usage-metrics-1267761445.html"
        }
    },
    {
        id: "assess_confluence_cloud_readiness",
        heading: (0, $eVVKF.messages).card4Heading,
        description: (0, $eVVKF.messages).card4Description,
        category: "assessments",
        link: {
            linkText: (0, $eVVKF.messages).linkText,
            href: "https://confluence.atlassian.com/support/assess-your-instance-scale-using-confluence-cloud-migration-assistant-database-queries-and-usage-metrics-1318881830.html"
        }
    },
    {
        id: "compare_cloud_migration_methods",
        heading: (0, $eVVKF.messages).card5Heading,
        description: (0, $eVVKF.messages).card5Description,
        category: "planning",
        link: {
            linkText: (0, $eVVKF.messages).linkText,
            href: "https://support.atlassian.com/migration/docs/compare-cloud-migration-methods/"
        }
    },
    {
        id: "milestone_tracker_template",
        heading: (0, $eVVKF.messages).card6Heading,
        description: (0, $eVVKF.messages).card6Description,
        category: "planning",
        link: {
            linkText: (0, $eVVKF.messages).linkText,
            href: "https://support.atlassian.com/migration/docs/milestone-tracker/"
        }
    },
    {
        id: "fastshift_stages_and_data_handling",
        heading: (0, $eVVKF.messages).card7Heading,
        description: (0, $eVVKF.messages).card7Description,
        category: "planning",
        link: {
            linkText: (0, $eVVKF.messages).linkText,
            href: "https://support.atlassian.com/migration/docs/fastshift-migration-stages-and-data-handling/"
        }
    },
    {
        id: "roles_and_responsibilities",
        heading: (0, $eVVKF.messages).card8Heading,
        description: (0, $eVVKF.messages).card8Description,
        category: "planning",
        link: {
            linkText: (0, $eVVKF.messages).linkText,
            href: "https://support.atlassian.com/migration/docs/roles-and-responsibilities-in-the-migration-process/"
        }
    },
    {
        id: "issue_tracker",
        heading: (0, $eVVKF.messages).card9Heading,
        description: (0, $eVVKF.messages).card9Description,
        category: "testRun",
        link: {
            linkText: (0, $eVVKF.messages).linkText,
            href: "https://support.atlassian.com/migration/docs/issue-tracker/"
        }
    },
    {
        id: "cloud_migration_runbook",
        heading: (0, $eVVKF.messages).card10Heading,
        description: (0, $eVVKF.messages).card10Description,
        category: "testRun",
        link: {
            linkText: (0, $eVVKF.messages).downloadText,
            href: "https://www.atlassian.com/dam/jcr:5451577b-91c9-4fc8-97f2-765ab8e89114/Cloud%20Migration%20Runbook%20Template.xlsx"
        }
    },
    {
        id: "link_fixing",
        heading: (0, $eVVKF.messages).card11Heading,
        description: (0, $eVVKF.messages).card11Description,
        category: "launch",
        link: {
            linkText: (0, $eVVKF.messages).linkText,
            href: "https://support.atlassian.com/migration/docs/what-are-product-links/"
        }
    },
    {
        id: "macro_repair",
        heading: (0, $eVVKF.messages).card12Heading,
        description: (0, $eVVKF.messages).card12Description,
        category: "launch",
        link: {
            linkText: (0, $eVVKF.messages).linkText,
            href: "https://confluence.atlassian.com/confkb/using-the-jira-macro-repair-1084362152.html"
        }
    }
];
const $7e319c358ef9b36c$export$9b1e1aec2488ce2e = [
    {
        id: "partner_portal",
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kqqsh))), {
            label: "",
            spacing: "spacious"
        }),
        text: (0, $eVVKF.messages).partnerPortalLinkText,
        href: "https://partnercentral.atlassian.com/get-started"
    },
    {
        id: "billing_console",
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9LeTf))), {
            label: "",
            spacing: "spacious"
        }),
        text: (0, $eVVKF.messages).billingConsoleLinkText,
        href: "https://admin.atlassian.com/billing"
    },
    {
        id: "migration_support",
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($afd57))), {
            label: "",
            spacing: "spacious"
        }),
        text: (0, $eVVKF.messages).migrationSupportLinkText,
        href: "https://support.atlassian.com/"
    }
];

});
parcelRegister("6x3OQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::149b2cd6a95881a63bc7d331a2f52240>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c18c9878111b334$var$_react = $4c18c9878111b334$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $4c18c9878111b334$var$_baseNew = $4c18c9878111b334$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $4c18c9878111b334$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c18c9878111b334$var$CompassIcon = (props)=>/*#__PURE__*/ $4c18c9878111b334$var$_react.default.createElement($4c18c9878111b334$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m11.78-3.78a.75.75 0 0 1 .155.834l-2 4.5a.75.75 0 0 1-.38.381l-4.5 2a.75.75 0 0 1-.99-.99l2-4.5a.75.75 0 0 1 .38-.38l4.5-2a.75.75 0 0 1 .835.154M6.992 8.051l.955.956-1.72.764zm2.016-.105-.956-.955 1.72-.765z" clip-rule="evenodd"/>`
    }, props));
$4c18c9878111b334$var$CompassIcon.displayName = "CompassIcon";
var $4c18c9878111b334$var$_default = module.exports.default = $4c18c9878111b334$var$CompassIcon;

});

parcelRegister("9LeTf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4932f6dfff92518aeab5d46f90dd8b8a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71b40dba4cf70743$var$_react = $71b40dba4cf70743$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $71b40dba4cf70743$var$_baseNew = $71b40dba4cf70743$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $71b40dba4cf70743$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CreditCard".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $71b40dba4cf70743$var$CreditCardIcon = (props)=>/*#__PURE__*/ $71b40dba4cf70743$var$_react.default.createElement($71b40dba4cf70743$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.5h13V4a.5.5 0 0 0-.5-.5zM14.5 7h-13v5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM9 9.5h4V11H9z" clip-rule="evenodd"/>`
    }, props));
$71b40dba4cf70743$var$CreditCardIcon.displayName = "CreditCardIcon";
var $71b40dba4cf70743$var$_default = module.exports.default = $71b40dba4cf70743$var$CreditCardIcon;

});

parcelRegister("afd57", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cf49c9cacb111227a84470c71b4079f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $775573cf5e18706d$var$_react = $775573cf5e18706d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $775573cf5e18706d$var$_baseNew = $775573cf5e18706d$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $775573cf5e18706d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Support".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing help support.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $775573cf5e18706d$var$SupportIcon = (props)=>/*#__PURE__*/ $775573cf5e18706d$var$_react.default.createElement($775573cf5e18706d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.964 2.904 5.752 4.69a4 4 0 0 1 4.497 0l1.787-1.787a6.5 6.5 0 0 0-8.072 0m9.132 1.06L11.31 5.752a4 4 0 0 1 0 4.497l1.787 1.787a6.5 6.5 0 0 0 0-8.072m-1.06 9.132-1.787-1.787a4 4 0 0 1-4.497 0l-1.788 1.787a6.5 6.5 0 0 0 8.072 0m-9.132-1.06 1.787-1.787a4 4 0 0 1 0-4.497L2.904 3.964a6.5 6.5 0 0 0 0 8.072m-.56-9.693a8 8 0 1 1 11.313 11.314A8 8 0 0 1 2.343 2.343m7.424 3.89a2.5 2.5 0 1 0-3.536 3.535 2.5 2.5 0 0 0 3.536-3.536" clip-rule="evenodd"/>`
    }, props));
$775573cf5e18706d$var$SupportIcon.displayName = "SupportIcon";
var $775573cf5e18706d$var$_default = module.exports.default = $775573cf5e18706d$var$SupportIcon;

});

parcelRegister("dIlnf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c07c4c04f9f99a3868a6c26b78654ed8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fbff6de80b62dae$var$_react = $9fbff6de80b62dae$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9fbff6de80b62dae$var$_baseNew = $9fbff6de80b62dae$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $9fbff6de80b62dae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fbff6de80b62dae$var$BookOpenIcon = (props)=>/*#__PURE__*/ $9fbff6de80b62dae$var$_react.default.createElement($9fbff6de80b62dae$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$9fbff6de80b62dae$var$BookOpenIcon.displayName = "BookOpenIcon";
var $9fbff6de80b62dae$var$_default = module.exports.default = $9fbff6de80b62dae$var$BookOpenIcon;

});

parcelRegister("eVVKF", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $aeee1f5e0075548e$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $aeee1f5e0075548e$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    planningResourcesHeading: {
        id: "fastshift.resources-page.planning-resources-heading",
        defaultMessage: "Planning resources",
        description: "Heading for planning resources section"
    },
    card1Heading: {
        id: "fastshift.resources-page.card1.heading",
        defaultMessage: "Portfolio insights",
        description: "Heading for the assessments card 1"
    },
    card1Description: {
        id: "fastshift.resources-page.tooling-card.description",
        defaultMessage: "Understand how you\u2019ll assess your cloud readiness with Portfolio insights.",
        description: "Description for the assessments card 1"
    },
    card2Heading: {
        id: "fastshift.resources-page.card2.heading",
        defaultMessage: "Detect and connect to your portfolio",
        description: "Heading for the assessments card 2"
    },
    card2Description: {
        id: "fastshift.resources-page.card2.description",
        defaultMessage: "Use Portfolio insights to discover and connect to your instances.",
        description: "Description for the assessments card 2"
    },
    card3Heading: {
        id: "fastshift.resources-page.card3.heading",
        defaultMessage: "Assess Jira cloud readiness",
        description: "Heading for the assessments card 3"
    },
    card3Description: {
        id: "fastshift.resources-page.card3.description",
        defaultMessage: "How to assess cloud readiness by collecting data from your Jira instance.",
        description: "Description for the assessments card 3"
    },
    card4Heading: {
        id: "fastshift.resources-page.card4.heading",
        defaultMessage: "Assess Confluence cloud readiness",
        description: "Heading for the assessments card 4"
    },
    card4Description: {
        id: "fastshift.resources-page.card4.description",
        defaultMessage: "How to assess cloud readiness by collecting data from your Confluence instance.",
        description: "Description for the assessments card 4"
    },
    card5Heading: {
        id: "fastshift.resources-page.card5.heading",
        defaultMessage: "Compare cloud migration methods",
        description: "Heading for the Planning card 5"
    },
    card5Description: {
        id: "fastshift.resources-page.card5.description",
        defaultMessage: "Understand which migration method is best for your use case.",
        description: "Description for the Planning card 5"
    },
    card6Heading: {
        id: "fastshift.resources-page.card6.heading",
        defaultMessage: "Milestone tracker template",
        description: "Heading for the Planning card 6"
    },
    card6Description: {
        id: "fastshift.resources-page.card6.description",
        defaultMessage: "Use the document to track important milestones.",
        description: "Description for the Planning card 6"
    },
    card7Heading: {
        id: "fastshift.resources-page.card7.heading",
        defaultMessage: "FastShift stages and data handling",
        description: "Heading for the Planning card 7"
    },
    card7Description: {
        id: "fastshift.resources-page.card7.description",
        defaultMessage: "Understand migration stages and how we handle your data.",
        description: "Description for the Planning card 7"
    },
    card8Heading: {
        id: "fastshift.resources-page.card8.heading",
        defaultMessage: "Roles and responsibilities",
        description: "Heading for the Planning card 8"
    },
    card8Description: {
        id: "fastshift.resources-page.card8.description",
        defaultMessage: "Learn about roles and responsibilities in the FastShift migration process.",
        description: "Description for the Planning card 8"
    },
    card9Heading: {
        id: "fastshift.resources-page.card9.heading",
        defaultMessage: "Issue tracker",
        description: "Heading for the test run card 9"
    },
    card9Description: {
        id: "fastshift.resources-page.card9.description",
        defaultMessage: "Use this template to record and track issues that come up during test runs.",
        description: "Description for the test run card 9"
    },
    card10Heading: {
        id: "fastshift.resources-page.card10.heading",
        defaultMessage: "Cloud Migration Runbook",
        description: "Heading for the test run card 10"
    },
    card10Description: {
        id: "fastshift.resources-page.card10.description",
        defaultMessage: "View sample steps to help you prepare and execute a migration.",
        description: "Description for the test run card 10"
    },
    card11Heading: {
        id: "fastshift.resources-page.card11.heading",
        defaultMessage: "Link fixing",
        description: "Heading for the launch card 11"
    },
    card11Description: {
        id: "fastshift.resources-page.card11.description",
        defaultMessage: "Learn how to fix broken issue or page links after migration.",
        description: "Description for the launch card 11"
    },
    card12Heading: {
        id: "fastshift.resources-page.card12.heading",
        defaultMessage: "Macro repair",
        description: "Heading for the launch card 12"
    },
    card12Description: {
        id: "fastshift.resources-page.card12.description",
        defaultMessage: "Remap the Jira issue macro to correct app links after migration.",
        description: "Description for the launch card 12"
    },
    linkText: {
        id: "fastshift.resources-page.link-text",
        defaultMessage: "Read",
        description: "Text for the resource card link"
    },
    downloadText: {
        id: "fastshift.resources-page.download-text",
        defaultMessage: "Download",
        description: "Download text for the resource card link"
    },
    usefulLinksHeading: {
        id: "fastshift.resources-page.useful-links.heading",
        defaultMessage: "Useful links",
        description: "Heading for the useful links section"
    },
    partnerPortalLinkText: {
        id: "fastshift.resources-page.useful-links.partner-portal.link-text",
        defaultMessage: "Partner Portal",
        description: "Link text for the partner portal link button"
    },
    billingConsoleLinkText: {
        id: "fastshift.resources-page.useful-links.billing-console.link-text",
        defaultMessage: "Billing Console",
        description: "Link text for the billing console link button"
    },
    migrationSupportLinkText: {
        id: "fastshift.resources-page.useful-links.migration-support.link-text",
        defaultMessage: "Migration Support",
        description: "Link text for the migration support link button"
    },
    tabPillAllText: {
        id: "fastshift.resources-page.tabPill.all",
        defaultMessage: "All",
        description: "Text for the tab pill All"
    },
    tabPillAssessmentsText: {
        id: "fastshift.resources-page.tabPill.assess",
        defaultMessage: "Assess",
        description: "Text for the tab pill Assessments"
    },
    tabPillPlanningText: {
        id: "fastshift.resources-page.tabPill.plan",
        defaultMessage: "Plan",
        description: "Text for the tab pill Plan"
    },
    tabPillTestRunText: {
        id: "fastshift.resources-page.tabPill.test",
        defaultMessage: "Test",
        description: "Text for the tab pill Test"
    },
    tabPillProductionRunText: {
        id: "fastshift.resources-page.tabPill.production-run",
        defaultMessage: "Production-run",
        description: "Text for the tab pill Production-run"
    },
    tabPillLaunchText: {
        id: "fastshift.resources-page.tabPill.launch",
        defaultMessage: "Launch",
        description: "Text for the tab pill Launch"
    },
    pageHeading: {
        id: "fastshift.resources-page.page-heading",
        defaultMessage: "Resources",
        description: "Page heading for fastshift resources page"
    }
});

});


parcelRegister("9tKvJ", function(module, exports) {

$parcel$export(module.exports, "useResourcesPageAnalytics", function () { return (parcelRequire("anWa4")).useResourcesPageAnalytics; });
$parcel$export(module.exports, "useResourcesPageUIAnalytics", function () { return (parcelRequire("jh76W")).useResourcesPageUIAnalytics; });

var $anWa4 = parcelRequire("anWa4");

var $jh76W = parcelRequire("jh76W");

});
parcelRegister("anWa4", function(module, exports) {

$parcel$export(module.exports, "useResourcesPageAnalytics", function () { return $54204d663fd29eae$export$98f7cbe9106b954; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $h0mGD = parcelRequire("h0mGD");
var $ih47h = parcelRequire("ih47h");
const $54204d663fd29eae$export$98f7cbe9106b954 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $h0mGD.useFastshiftAnalyticsData)();
    const { fireScreenEvent: fireScreenEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    (0, $iSvIT.useEffect)(()=>{
        if (!identityAttrs) return;
        fireScreenEvent({
            name: sourceKey,
            attributes: identityAttrs
        });
    }, [
        fireScreenEvent,
        identityAttrs,
        sourceKey
    ]);
};

});

parcelRegister("jh76W", function(module, exports) {

$parcel$export(module.exports, "useResourcesPageUIAnalytics", function () { return $335bec121fe5d95c$export$d9f0d1eef9318778; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $h0mGD = parcelRequire("h0mGD");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
const $335bec121fe5d95c$export$d9f0d1eef9318778 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $h0mGD.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    const sendResourceFilterClickUIEvent = (0, $iSvIT.useCallback)((selectedFilter)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).RESOURCE_FILTER,
            source: sourceKey,
            attributes: {
                selectedFilter: selectedFilter
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendResourceLinkClickUIEvent = (0, $iSvIT.useCallback)((resourceSubject, resourceCategory)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).LINK,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).RESOURCE_LINK,
            source: sourceKey,
            attributes: {
                resourceSubject: resourceSubject,
                resourceType: resourceCategory
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendUsefulLinkClickUIEvent = (0, $iSvIT.useCallback)((linkSubject)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).LINK,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).USEFUL_LINK,
            source: sourceKey,
            attributes: {
                linkSubject: linkSubject
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendResourceFilterClickUIEvent: sendResourceFilterClickUIEvent,
        sendResourceLinkClickUIEvent: sendResourceLinkClickUIEvent,
        sendUsefulLinkClickUIEvent: sendUsefulLinkClickUIEvent
    };
};

});


parcelRegister("2Zjkw", function(module, exports) {

$parcel$export(module.exports, "LinkCardWrapper", function () { return (parcelRequire("arEIt")).LinkCardWrapper; });

var $arEIt = parcelRequire("arEIt");

});
parcelRegister("arEIt", function(module, exports) {

$parcel$export(module.exports, "LinkCardWrapper", function () { return $e9ce56b1facaba9e$export$8463c987d12d7028; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $gf1F9 = parcelRequire("gf1F9");

var $6fxse = parcelRequire("6fxse");
var $jXVyf = parcelRequire("jXVyf");
var $j7TVc = parcelRequire("j7TVc");

var $S7Wj8 = parcelRequire("S7Wj8");
const $e9ce56b1facaba9e$var$linkCardWrapperStyle = (0, $j7TVc.xcss)({
    borderRadius: "border.radius.200",
    borderWidth: "border.width",
    borderStyle: "solid",
    borderColor: "color.border",
    backgroundColor: "elevation.surface.overlay",
    paddingBlockStart: "space.200",
    paddingBlockEnd: "space.150",
    paddingInline: "space.150"
});
const $e9ce56b1facaba9e$export$8463c987d12d7028 = ({ heading: heading, links: links })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
        space: "space.200",
        xcss: $e9ce56b1facaba9e$var$linkCardWrapperStyle,
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                size: "xsmall",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, heading))
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6fxse.default), {
                space: "space.200",
                children: links.map((linkData, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $S7Wj8.LinkCard), (0, $7Knp0._)({}, linkData), index))
            })
        ]
    });
};

});
parcelRegister("S7Wj8", function(module, exports) {

$parcel$export(module.exports, "LinkCard", function () { return $55ffae9a687a07f7$export$2c381a86421d5abf; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $7xtRp = parcelRequire("7xtRp");

var $9FeWi = parcelRequire("9FeWi");
var $7akU3 = parcelRequire("7akU3");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");
parcelRequire("9tKvJ");
var $jh76W = parcelRequire("jh76W");
const $55ffae9a687a07f7$var$anchorStyle = (0, $jAMCU.xcss)({
    "display": "flex",
    "flexGrow": 1,
    "alignItems": "center",
    "gap": "space.100",
    "color": "color.text",
    "backgroundColor": "elevation.surface",
    "textDecoration": "none",
    "borderRadius": "border.radius.200",
    "borderWidth": "border.width",
    "borderStyle": "solid",
    "borderColor": "color.border",
    ":hover": {
        color: "color.text",
        backgroundColor: "elevation.surface.hovered",
        textDecoration: "none",
        boxShadow: "elevation.shadow.raised"
    }
});
const $55ffae9a687a07f7$export$2c381a86421d5abf = ({ id: id, icon: icon, text: text, href: href })=>{
    const { sendUsefulLinkClickUIEvent: sendUsefulLinkClickUIEvent } = (0, $jh76W.useResourcesPageUIAnalytics)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9FeWi.default), {
        href: href,
        target: "_blank",
        xcss: $55ffae9a687a07f7$var$anchorStyle,
        paddingBlock: "space.075",
        paddingInline: "space.150",
        onClick: ()=>sendUsefulLinkClickUIEvent(id),
        children: [
            icon,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
                grow: "fill",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, text))
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7xtRp))), {
                label: "",
                spacing: "spacious"
            })
        ]
    });
};

});



parcelRegister("20BDH", function(module, exports) {

$parcel$export(module.exports, "ResourceLinkCard", function () { return (parcelRequire("c9tcd")).ResourceLinkCard; });

var $c9tcd = parcelRequire("c9tcd");

});
parcelRegister("c9tcd", function(module, exports) {

$parcel$export(module.exports, "ResourceLinkCard", function () { return $5be84c2344b8e272$export$167499258be5d5a1; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $bM10s = parcelRequire("bM10s");

var $gf1F9 = parcelRequire("gf1F9");

var $1U6T0 = parcelRequire("1U6T0");

var $g2DEO = parcelRequire("g2DEO");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $5pB2m = parcelRequire("5pB2m");

var $5WY8G = parcelRequire("5WY8G");
parcelRequire("9tKvJ");
var $jh76W = parcelRequire("jh76W");
const $5be84c2344b8e272$var$linkResourceCardStyles = (0, $jAMCU.xcss)({
    minHeight: "156px",
    borderRadius: "border.radius.200",
    borderWidth: "border.width",
    borderStyle: "solid",
    borderColor: "color.border",
    backgroundColor: "elevation.surface.overlay",
    paddingBlockStart: "space.200",
    paddingBlockEnd: "space.150",
    paddingInline: "space.150"
});
const $5be84c2344b8e272$export$167499258be5d5a1 = ({ id: id, heading: heading, description: description, link: link, category: category })=>{
    const { sendResourceLinkClickUIEvent: sendResourceLinkClickUIEvent } = (0, $jh76W.useResourcesPageUIAnalytics)();
    const mappedCategory = (0, $5WY8G.TABS).find((tab)=>tab.id === category);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        spread: "space-between",
        space: "space.200",
        grow: "fill",
        xcss: $5be84c2344b8e272$var$linkResourceCardStyles,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                        size: "small",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, heading))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, description))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g2DEO.default), {
                gap: "space.200",
                justifyContent: "space-between",
                children: [
                    mappedCategory && /*#__PURE__*/ (0, $loA2J.jsx)((0, $5pB2m.default), {
                        text: mappedCategory.text.defaultMessage,
                        elemBefore: mappedCategory.tagIcon
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bM10s.default), {
                        testId: "card-link",
                        appearance: "subtle",
                        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($1U6T0))),
                        href: link.href,
                        target: "_blank",
                        onClick: ()=>sendResourceLinkClickUIEvent(id, category),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, link.linkText))
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("gTtdI", function(module, exports) {

$parcel$export(module.exports, "TabSelector", function () { return (parcelRequire("jul4s")).TabSelector; });

var $jul4s = parcelRequire("jul4s");

});
parcelRegister("jul4s", function(module, exports) {

$parcel$export(module.exports, "TabSelector", function () { return $418dd08413653044$export$a3a7254f7f149b03; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $7akU3 = parcelRequire("7akU3");
parcelRequire("9tKvJ");
var $jh76W = parcelRequire("jh76W");

var $bMWYf = parcelRequire("bMWYf");
const $418dd08413653044$export$a3a7254f7f149b03 = ({ currentTab: currentTab, tabs: tabs, onTabSelect: onTabSelect })=>{
    const { sendResourceFilterClickUIEvent: sendResourceFilterClickUIEvent } = (0, $jh76W.useResourcesPageUIAnalytics)();
    const handleTabSelect = (tabId)=>{
        onTabSelect(tabId);
        sendResourceFilterClickUIEvent(tabId);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
        alignBlock: "center",
        space: "space.100",
        shouldWrap: true,
        children: tabs.map((tab)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bMWYf.TabPill), {
                icon: tab.icon,
                text: tab.text,
                isSelected: tab.id === currentTab,
                onSelect: ()=>handleTabSelect(tab.id)
            }, tab.id))
    });
};

});
parcelRegister("bMWYf", function(module, exports) {

$parcel$export(module.exports, "TabPill", function () { return $824da1c5b4907171$export$78d1357ca0402517; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $7akU3 = parcelRequire("7akU3");
var $5Rpi7 = parcelRequire("5Rpi7");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $kwHar = parcelRequire("kwHar");
const $824da1c5b4907171$var$tabPillCommonStyle = (0, $jAMCU.xcss)({
    "borderRadius": "90px",
    "padding": "unset",
    "border": `1px solid ${(0, $kwHar.default)("color.background.neutral")}`,
    ":focus": {
        outlineColor: "color.border.focused",
        outlineWidth: "border.width.focused",
        outlineStyle: "solid"
    }
});
const $824da1c5b4907171$var$tabPillSelectedStyle = (0, $jAMCU.xcss)({
    "borderWidth": "border.width",
    "borderStyle": "solid",
    "borderColor": "color.border.selected",
    "color": "color.text.brand",
    "backgroundColor": "color.background.selected",
    ":hover": {
        backgroundColor: "color.background.selected.hovered"
    }
});
const $824da1c5b4907171$var$tabPillDefaultStyle = (0, $jAMCU.xcss)({
    "color": "color.text",
    "backgroundColor": "color.background.neutral",
    ":hover": {
        backgroundColor: "color.background.neutral.hovered"
    }
});
const $824da1c5b4907171$var$tabPillContentStyle = (0, $jAMCU.xcss)({
    height: "32px",
    paddingBlock: "space.075",
    paddingInline: "space.150"
});
const $824da1c5b4907171$export$78d1357ca0402517 = ({ icon: icon, text: text, isSelected: isSelected = false, onSelect: onSelect })=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5Rpi7.default), {
        xcss: [
            $824da1c5b4907171$var$tabPillCommonStyle,
            isSelected ? $824da1c5b4907171$var$tabPillSelectedStyle : $824da1c5b4907171$var$tabPillDefaultStyle
        ],
        onClick: onSelect,
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": intl.formatMessage(text),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
            alignBlock: "center",
            xcss: $824da1c5b4907171$var$tabPillContentStyle,
            space: "space.050",
            children: [
                icon,
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                    color: isSelected ? "color.text.brand" : "color.text",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, text))
                })
            ]
        })
    });
};

});
parcelRegister("5Rpi7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $444585531d4cae18$export$2e2bcd8739ae039; });

var $aB34E = parcelRequire("aB34E");

var $2OPES = parcelRequire("2OPES");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $4xoZa = parcelRequire("4xoZa");

var $4OZuI = parcelRequire("4OZuI");

var $7nG8r = parcelRequire("7nG8r");

var $1dqlv = parcelRequire("1dqlv");

var $jAMCU = parcelRequire("jAMCU");
var $444585531d4cae18$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $444585531d4cae18$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $444585531d4cae18$var$focusRingStyles = (0, $2ZUkg.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $1dqlv.borderColorMap)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $1dqlv.positiveSpaceMap)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $1dqlv.borderWidthMap)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $444585531d4cae18$var$baseStyles = (0, $2ZUkg.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $444585531d4cae18$var$enabledStyles = (0, $2ZUkg.css)({
    cursor: "pointer"
});
var $444585531d4cae18$var$disabledStyles = (0, $2ZUkg.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $444585531d4cae18$var$Pressable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $4OZuI.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $2OPES.default)(_ref, $444585531d4cae18$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $4xoZa.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.3",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $2OPES.default)(htmlAttributes, $444585531d4cae18$var$_excluded2);
    var resolvedStyles = (0, $jAMCU.parseXcss)(xcss);
    return (0, $2ZUkg.jsx)("button", (0, $aB34E.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $444585531d4cae18$var$baseStyles,
            $444585531d4cae18$var$focusRingStyles,
            isDisabled ? $444585531d4cae18$var$disabledStyles : $444585531d4cae18$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1dqlv.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1dqlv.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1dqlv.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1dqlv.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1dqlv.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1dqlv.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1dqlv.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1dqlv.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
});
var $444585531d4cae18$export$2e2bcd8739ae039 = $444585531d4cae18$var$Pressable;

});






parcelRegister("01Iri", function(module, exports) {

$parcel$export(module.exports, "FastshiftMigrationsManagementPage", function () { return (parcelRequire("IM44x")).FastshiftMigrationsManagementPage; });
parcelRequire("cwwLl");
var $IM44x = parcelRequire("IM44x");

});
parcelRegister("cwwLl", function(module, exports) {

$parcel$export(module.exports, "FastshiftMigrationsManagementPage", function () { return (parcelRequire("IM44x")).FastshiftMigrationsManagementPage; });

var $IM44x = parcelRequire("IM44x");

});
parcelRegister("IM44x", function(module, exports) {

$parcel$export(module.exports, "FastshiftMigrationsManagementPage", function () { return $973856e279738fda$export$47413fb85996cfab; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $hea8X = parcelRequire("hea8X");

var $gf1F9 = parcelRequire("gf1F9");

var $2uQhU = parcelRequire("2uQhU");
var $lcrai = parcelRequire("lcrai");

var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");

var $g2OHD = parcelRequire("g2OHD");

var $gkhN4 = parcelRequire("gkhN4");
parcelRequire("5m8h9");
var $5wrp0 = parcelRequire("5wrp0");
parcelRequire("jNqYB");
var $hybbY = parcelRequire("hybbY");

var $9OyVr = parcelRequire("9OyVr");

var $k0rCZ = parcelRequire("k0rCZ");

var $8KnwD = parcelRequire("8KnwD");
parcelRequire("j6VaV");
var $lDaVQ = parcelRequire("lDaVQ");
parcelRequire("bi7Jk");
var $2irAK = parcelRequire("2irAK");
var $kvOKb = parcelRequire("kvOKb");
var $bShUa = parcelRequire("bShUa");
parcelRequire("awInG");
var $bAVaZ = parcelRequire("bAVaZ");
parcelRequire("jix7L");
var $5V63Y = parcelRequire("5V63Y");

var $SxcVD = parcelRequire("SxcVD");
const $973856e279738fda$var$appEnvironment = "production";
const $973856e279738fda$var$MigrationPlannerIntegration = ()=>{
    const intl = (0, $f6qj2.default)();
    const cardClient = new (0, $2uQhU.default)($973856e279738fda$var$appEnvironment, `${(0, $9OyVr.BASE_URL)}/gateway/api`);
    const { data: engagementData, error: engagementError, pending: engagementPending } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomainEngagement);
    (0, $bAVaZ.useMigrationsManagementPageAnalytics)();
    const { domainId: domainId } = (0, $hea8X.useParams)();
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const dispatch = (0, $8KnwD.useFastshiftDispatch)();
    const handleRefreshEngagementEndpoint = ()=>{
        dispatch($k0rCZ.getCustomerDomainEngagementDetails({
            stargateClient: stargateClient,
            customerDomainId: domainId || ""
        }));
    };
    if (engagementPending) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), {
                height: "650px",
                width: "100%",
                testId: "migration-planner-loading-skeleton",
                isShimmering: true
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), {
                height: "90px",
                width: "100%",
                testId: "confluence-card-skeleton",
                isShimmering: true
            })
        ]
    });
    if (engagementError) switch(engagementError){
        case (0, $gkhN4.CustomerDomainEngagementExpectedError).NO_ENGAGEMENT:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2irAK.NoEngagementErrorDisplay), {});
        case (0, $gkhN4.CustomerDomainEngagementExpectedError).USER_NOT_PROVISIONED:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kvOKb.UserNotProvisionedErrorDisplay), {});
        case (0, $gkhN4.CustomerDomainEngagementExpectedError).NO_ACCESS:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bShUa.NoAccessErrorDisplay), {});
        default:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5wrp0.GenericErrorDisplay), {
                onRefresh: handleRefreshEngagementEndpoint,
                customMessage: intl.formatMessage((0, $SxcVD.messages).genericErrorDescription)
            });
    }
    if (!engagementData) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5wrp0.GenericErrorDisplay), {
        onRefresh: handleRefreshEngagementEndpoint,
        customMessage: intl.formatMessage((0, $SxcVD.messages).genericErrorDescription)
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $lcrai.SmartCardProvider), {
        client: cardClient,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5V63Y.JiraEmbeddedBoardSection), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $lDaVQ.ConfluenceCardLinkSection), {})
        ]
    });
};
const $973856e279738fda$export$47413fb85996cfab = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        space: "space.300",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                        size: "large",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $SxcVD.messages).pageHeading))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $SxcVD.messages).pageHeadingSubtext))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($973856e279738fda$var$MigrationPlannerIntegration, {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hybbY.RelationshipSection), {})
        ]
    });
};

});
parcelRegister("2uQhU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d16f15df58245cb$export$2e2bcd8739ae039; });

var $8afK4 = parcelRequire("8afK4");

var $1151q = parcelRequire("1151q");

var $1SJdX = parcelRequire("1SJdX");

var $3OzAF = parcelRequire("3OzAF");

var $iyxmX = parcelRequire("iyxmX");

var $foAXX = parcelRequire("foAXX");

var $e7oBD = parcelRequire("e7oBD");

var $8qNJA = parcelRequire("8qNJA");

var $3Oxa8 = parcelRequire("3Oxa8");

var $4ZE1Z = parcelRequire("4ZE1Z");

var $eZyT4 = parcelRequire("eZyT4");

var $hp04i = parcelRequire("hp04i");

var $1YLM0 = parcelRequire("1YLM0");
var $hcmgL = parcelRequire("hcmgL");
var $8nPmF = parcelRequire("8nPmF");
var $4F3Il = parcelRequire("4F3Il");

var $l4n7k = parcelRequire("l4n7k");

var $4vAGs = parcelRequire("4vAGs");

var $lBw9p = parcelRequire("lBw9p");

var $jxLBU = parcelRequire("jxLBU");
var $1d16f15df58245cb$var$_excluded = [
    "error"
];
function $1d16f15df58245cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d16f15df58245cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d16f15df58245cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e7oBD.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d16f15df58245cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1d16f15df58245cb$var$MAX_BATCH_SIZE = 50;
var $1d16f15df58245cb$var$MIN_TIME_BETWEEN_BATCHES = 250;
var $1d16f15df58245cb$var$URL_RESPONSE_CACHE_SIZE = 100;
var $1d16f15df58245cb$export$d6a66073b5d79eb3 = new (0, $4vAGs.LRUMap)($1d16f15df58245cb$var$URL_RESPONSE_CACHE_SIZE);
var $1d16f15df58245cb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CardClient(envKey, baseUrlOverride) {
        var _this = this;
        (0, $iyxmX.default)(this, CardClient);
        (0, $e7oBD.default)(this, "postBatchResolveNew", /*#__PURE__*/ function() {
            var _ref = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee(resources, resourceType, keyGetter) {
                var deDuplicatedResources, resolvedResources, headers, map, i, resource, data;
                return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            // De-duplicate requested URLs (see `this.createLoader` for more detail).
                            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
                            deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($lBw9p)))(resources, keyGetter);
                            resolvedResources = [];
                            headers = $1d16f15df58245cb$var$_objectSpread($1d16f15df58245cb$var$_objectSpread({
                                /**
                 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
                 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
                 */ "origin-timezone": Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone
                            }, _this.product ? {
                                "X-Product": _this.product
                            } : {}), (0, $4ZE1Z.expValEquals)("platform_editor_smart_card_otp", "isEnabled", true) && _this.headers ? _this.headers : {});
                            _context.prev = 3;
                            if (!(resourceType === "URL")) {
                                _context.next = 8;
                                break;
                            }
                            _context.next = 7;
                            return (0, $4F3Il.request)("post", "".concat(_this.resolverUrl, "/resolve/batch"), deDuplicatedResources, headers);
                        case 7:
                            resolvedResources = _context.sent;
                        case 8:
                            if (!(resourceType === "ARI")) {
                                _context.next = 12;
                                break;
                            }
                            _context.next = 11;
                            return (0, $4F3Il.request)("post", "".concat(_this.resolverUrl, "/resolve/ari/batch"), deDuplicatedResources, headers);
                        case 11:
                            resolvedResources = _context.sent;
                        case 12:
                            _context.next = 17;
                            break;
                        case 14:
                            _context.prev = 14;
                            _context.t0 = _context["catch"](3);
                            // we make sure we return a valid dataloader response by creating an error
                            // response for each url/ari
                            resolvedResources = resources.map(function() {
                                // @ts-ignore
                                var status = (0, $l4n7k.isErrorResponse)(_context.t0) ? _context.t0.status : 500;
                                var errorResponse = {
                                    status: status,
                                    // @ts-ignore
                                    error: _context.t0
                                };
                                return errorResponse;
                            });
                        case 17:
                            // Reduce into a map to make accessing faster and easier.
                            map = {}; // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
                            for(i = 0; i < deDuplicatedResources.length; ++i){
                                resource = deDuplicatedResources[i];
                                data = resolvedResources[i];
                                map[keyGetter(resource)] = data;
                            }
                            // Reconvert list back into the original order in which it was given to us.
                            return _context.abrupt("return", resources.map(function(originalResource) {
                                return map[keyGetter(originalResource)];
                            }));
                        case 20:
                        case "end":
                            return _context.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        14
                    ]
                ]);
            }));
            return function(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            };
        }());
        (0, $e7oBD.default)(this, "postBatchResolve", /*#__PURE__*/ function() {
            var _ref2 = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee2(resources) {
                var resourceType, deDuplicatedResources, resolvedResources, headers, map, i, resource, data, _args2 = arguments;
                return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            resourceType = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "URL";
                            // De-duplicate requested URLs (see `this.createLoader` for more detail).
                            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
                            deDuplicatedResources = (0, $1SJdX.default)(new Set(resources));
                            resolvedResources = [];
                            headers = $1d16f15df58245cb$var$_objectSpread($1d16f15df58245cb$var$_objectSpread({
                                /**
                 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
                 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
                 */ "origin-timezone": Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone
                            }, _this.product ? {
                                "X-Product": _this.product
                            } : {}), (0, $4ZE1Z.expValEquals)("platform_editor_smart_card_otp", "isEnabled", true) && _this.headers ? _this.headers : {});
                            _context2.prev = 4;
                            if (!(resourceType === "URL")) {
                                _context2.next = 9;
                                break;
                            }
                            _context2.next = 8;
                            return (0, $4F3Il.request)("post", "".concat(_this.resolverUrl, "/resolve/batch"), deDuplicatedResources.map(function(resourceUrl) {
                                return {
                                    resourceUrl: resourceUrl
                                };
                            }), headers);
                        case 8:
                            resolvedResources = _context2.sent;
                        case 9:
                            if (!(resourceType === "ARI")) {
                                _context2.next = 13;
                                break;
                            }
                            _context2.next = 12;
                            return (0, $4F3Il.request)("post", "".concat(_this.resolverUrl, "/resolve/ari/batch"), deDuplicatedResources.map(function(ari) {
                                return {
                                    ari: ari
                                };
                            }), headers);
                        case 12:
                            resolvedResources = _context2.sent;
                        case 13:
                            _context2.next = 18;
                            break;
                        case 15:
                            _context2.prev = 15;
                            _context2.t0 = _context2["catch"](4);
                            // we make sure we return a valid dataloader response by creating an error
                            // response for each url/ari
                            resolvedResources = resources.map(function() {
                                // @ts-ignore
                                var status = (0, $l4n7k.isErrorResponse)(_context2.t0) ? _context2.t0.status : 500;
                                var errorResponse = {
                                    status: status,
                                    // @ts-ignore
                                    error: _context2.t0
                                };
                                return errorResponse;
                            });
                        case 18:
                            // Reduce into a map to make accessing faster and easier.
                            map = {}; // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
                            for(i = 0; i < deDuplicatedResources.length; ++i){
                                resource = deDuplicatedResources[i];
                                data = resolvedResources[i];
                                map[resource] = data;
                            }
                            // Reconvert list back into the original order in which it was given to us.
                            return _context2.abrupt("return", resources.map(function(originalResource) {
                                return map[originalResource];
                            }));
                        case 21:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2, null, [
                    [
                        4,
                        15
                    ]
                ]);
            }));
            return function(_x4) {
                return _ref2.apply(this, arguments);
            };
        }());
        (0, $e7oBD.default)(this, "batchResolveUrl", /*#__PURE__*/ function() {
            var _ref3 = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee3(urls) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee3$(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            return _context3.abrupt("return", _this.postBatchResolveNew(urls, "URL", function(resource) {
                                return resource.resourceUrl;
                            }));
                        case 1:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3);
            }));
            return function(_x5) {
                return _ref3.apply(this, arguments);
            };
        }());
        // Endpoint for batch resolve url
        (0, $e7oBD.default)(this, "batchResolve", /*#__PURE__*/ function() {
            var _ref4 = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee4(urls) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee4$(_context4) {
                    while(true)switch(_context4.prev = _context4.next){
                        case 0:
                            return _context4.abrupt("return", _this.postBatchResolve(urls, "URL"));
                        case 1:
                        case "end":
                            return _context4.stop();
                    }
                }, _callee4);
            }));
            return function(_x6) {
                return _ref4.apply(this, arguments);
            };
        }());
        // Endpoint for batch resolve ari
        (0, $e7oBD.default)(this, "batchResolveAris", /*#__PURE__*/ function() {
            var _ref5 = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee5(aris) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee5$(_context5) {
                    while(true)switch(_context5.prev = _context5.next){
                        case 0:
                            return _context5.abrupt("return", _this.postBatchResolve(aris, "ARI"));
                        case 1:
                        case "end":
                            return _context5.stop();
                    }
                }, _callee5);
            }));
            return function(_x7) {
                return _ref5.apply(this, arguments);
            };
        }());
        this.resolverUrl = (0, $hcmgL.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    return (0, $foAXX.default)(CardClient, [
        {
            key: "setProduct",
            value: function setProduct(product) {
                this.product = product;
            }
        },
        {
            key: "setHeaders",
            value: function setHeaders(headers) {
                this.headers = headers;
            }
        },
        {
            key: "createUrlLoader",
            value: function createUrlLoader() {
                var batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($hp04i)))({
                    limit: 1,
                    interval: $1d16f15df58245cb$var$MIN_TIME_BETWEEN_BATCHES
                });
                var throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
                return new (0, (/*@__PURE__*/$parcel$interopDefault($3Oxa8)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
                // This is for two reasons:
                //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
                //  2: we want to avoid sending out heaps of requests from the client at once
                function(urls) {
                    return throttledBatchResolve(urls);
                }, {
                    maxBatchSize: $1d16f15df58245cb$var$MAX_BATCH_SIZE,
                    // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
                    // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
                    // - the user clicks "request access", and then following the auth prompts and gets access
                    // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
                    //   because the smartlink's URL (which is the cache key) is exactly the same
                    //
                    // For this reason, we disable DataLoader's cache.
                    // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
                    // ourselves in `this.batchResolve`.
                    cache: false
                });
            }
        },
        {
            key: "createLoader",
            value: function createLoader() {
                var batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($hp04i)))({
                    limit: 1,
                    interval: $1d16f15df58245cb$var$MIN_TIME_BETWEEN_BATCHES
                });
                var throttledBatchResolve = batchResolveThrottler(this.batchResolve);
                return new (0, (/*@__PURE__*/$parcel$interopDefault($3Oxa8)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
                // This is for two reasons:
                //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
                //  2: we want to avoid sending out heaps of requests from the client at once
                function(urls) {
                    return throttledBatchResolve(urls);
                }, {
                    maxBatchSize: $1d16f15df58245cb$var$MAX_BATCH_SIZE,
                    // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
                    // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
                    // - the user clicks "request access", and then following the auth prompts and gets access
                    // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
                    //   because the smartlink's URL (which is the cache key) is exactly the same
                    //
                    // For this reason, we disable DataLoader's cache.
                    // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
                    // ourselves in `this.batchResolve`.
                    cache: false
                });
            }
        },
        {
            key: "getLoader",
            value: function getLoader(hostname) {
                if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
                return this.loadersByDomain[hostname];
            }
        },
        {
            key: "getUrlLoader",
            value: function getUrlLoader(hostname) {
                if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
                return this.urlLoadersByDomain[hostname];
            }
        },
        {
            key: "resolveUrl",
            value: function() {
                var _resolveUrl = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee6(url) {
                    var force, hostname, loader, responsePromise, urlLoader, response, isUnresolvedLink, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                force = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
                                hostname = new URL(url).hostname;
                                loader = this.getLoader(hostname);
                                responsePromise = $1d16f15df58245cb$export$d6a66073b5d79eb3.get(url);
                                if (!responsePromise || force) {
                                    if ((0, $jxLBU.fg)("platform_linking_force_no_cache_smart_card_client")) {
                                        urlLoader = this.getUrlLoader(hostname);
                                        responsePromise = urlLoader.load({
                                            resourceUrl: url,
                                            ignoreCachedValue: force || undefined
                                        });
                                    } else responsePromise = loader.load(url);
                                    $1d16f15df58245cb$export$d6a66073b5d79eb3.set(url, responsePromise);
                                }
                                _context6.prev = 5;
                                _context6.next = 8;
                                return responsePromise;
                            case 8:
                                response = _context6.sent;
                                _context6.next = 15;
                                break;
                            case 11:
                                _context6.prev = 11;
                                _context6.t0 = _context6["catch"](5);
                                // Technically this never happens, since batchResolve handles errors and doesn't throw,
                                // But just in case.
                                $1d16f15df58245cb$export$d6a66073b5d79eb3.delete(url);
                                throw _context6.t0;
                            case 15:
                                isUnresolvedLink = !(0, $l4n7k.isSuccessfulResponse)(response) || (0, $8nPmF.getStatus)(response.body) !== "resolved";
                                if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
                                $1d16f15df58245cb$export$d6a66073b5d79eb3.delete(url);
                                return _context6.abrupt("return", response);
                            case 18:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this, [
                        [
                            5,
                            11
                        ]
                    ]);
                }));
                function resolveUrl(_x8) {
                    return _resolveUrl.apply(this, arguments);
                }
                return resolveUrl;
            }()
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee8(url) {
                    var _this2 = this;
                    var response, retriedResponse;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                _context8.next = 2;
                                return this.resolveUrl(url, false);
                            case 2:
                                response = _context8.sent;
                                if (!(0, $l4n7k.isSuccessfulResponse)(response)) {
                                    _context8.next = 7;
                                    break;
                                }
                                return _context8.abrupt("return", response.body);
                            case 7:
                                _context8.prev = 7;
                                _context8.next = 10;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($eZyT4)))(/*#__PURE__*/ (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee7() {
                                    var _response;
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee7$(_context7) {
                                        while(true)switch(_context7.prev = _context7.next){
                                            case 0:
                                                if (_this2.resolvedCache[url]) {
                                                    _context7.next = 11;
                                                    break;
                                                }
                                                _context7.next = 3;
                                                return _this2.resolveUrl(url, false);
                                            case 3:
                                                _response = _context7.sent;
                                                if (!(0, $l4n7k.isSuccessfulResponse)(_response)) {
                                                    _context7.next = 8;
                                                    break;
                                                }
                                                return _context7.abrupt("return", _response);
                                            case 8:
                                                throw new Error("Retry for URL failed");
                                            case 9:
                                                _context7.next = 12;
                                                break;
                                            case 11:
                                                throw new Error("Retry unneeded - link has been resolved.");
                                            case 12:
                                            case "end":
                                                return _context7.stop();
                                        }
                                    }, _callee7);
                                })), this.retryConfig);
                            case 10:
                                retriedResponse = _context8.sent;
                                return _context8.abrupt("return", retriedResponse.body);
                            case 14:
                                _context8.prev = 14;
                                _context8.t0 = _context8["catch"](7);
                                return _context8.abrupt("return", undefined);
                            case 17:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            7,
                            14
                        ]
                    ]);
                }));
                function prefetchData(_x9) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "isRateLimitError",
            value: function isRateLimitError(response) {
                return (0, $l4n7k.isErrorResponse)(response) && response.error.status === 429;
            }
        },
        {
            key: "fetchData",
            value: function() {
                var _fetchData = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee0(url, force) {
                    var _this3 = this;
                    var response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee0$(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                _context0.next = 2;
                                return this.resolveUrl(url, force);
                            case 2:
                                response = _context0.sent;
                                if (!this.isRateLimitError(response)) {
                                    _context0.next = 7;
                                    break;
                                }
                                _context0.next = 6;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($eZyT4)))(/*#__PURE__*/ (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee9() {
                                    var retryResponse;
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee9$(_context9) {
                                        while(true)switch(_context9.prev = _context9.next){
                                            case 0:
                                                _context9.next = 2;
                                                return _this3.resolveUrl(url, false);
                                            case 2:
                                                retryResponse = _context9.sent;
                                                if (!_this3.isRateLimitError(retryResponse)) {
                                                    _context9.next = 5;
                                                    break;
                                                }
                                                throw _this3.mapErrorResponse(retryResponse, new URL(url).hostname);
                                            case 5:
                                                return _context9.abrupt("return", retryResponse);
                                            case 6:
                                            case "end":
                                                return _context9.stop();
                                        }
                                    }, _callee9);
                                })), this.retryConfig);
                            case 6:
                                response = _context0.sent;
                            case 7:
                                if ((0, $l4n7k.isSuccessfulResponse)(response)) {
                                    _context0.next = 9;
                                    break;
                                }
                                throw this.mapErrorResponse(response, new URL(url).hostname);
                            case 9:
                                // Set a flag in the `resolvedCache` for this URL. The intent of this is
                                // to ensure that the exponential backoff method in `prefetchData` does
                                // not continue to retry fetching for this URL, especially if it was previously
                                // in a failed state. Note: this scenario only occurs on initial page load, if the
                                // user scrolls through the page very fast. Once the URL is visible, prefetching
                                // no longer takes place.
                                this.resolvedCache[url] = true;
                                // Return the JSON-LD response back up!
                                return _context0.abrupt("return", response.body);
                            case 11:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this);
                }));
                function fetchData(_x0, _x1) {
                    return _fetchData.apply(this, arguments);
                }
                return fetchData;
            }()
        },
        {
            key: "fetchDataAris",
            value: function() {
                var _fetchDataAris = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee1(aris) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                _context1.next = 2;
                                return this.batchResolveAris(aris);
                            case 2:
                                return _context1.abrupt("return", _context1.sent);
                            case 3:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this);
                }));
                function fetchDataAris(_x10) {
                    return _fetchDataAris.apply(this, arguments);
                }
                return fetchDataAris;
            }()
        },
        {
            key: "postData",
            value: function() {
                var _postData = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee10(data) {
                    var requestData;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                requestData = {
                                    key: data.key,
                                    action: data.action,
                                    context: data.context
                                };
                                _context10.next = 3;
                                return (0, $4F3Il.request)("post", "".concat(this.resolverUrl, "/invoke"), requestData);
                            case 3:
                                return _context10.abrupt("return", _context10.sent);
                            case 4:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function postData(_x11) {
                    return _postData.apply(this, arguments);
                }
                return postData;
            }()
        },
        {
            key: "search",
            value: function() {
                var _search = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee11(data) {
                    var key, action, query, context, requestData, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                key = data.key, action = data.action; // Note: context in action is different to context in data, see types.
                                query = action.query, context = action.context;
                                requestData = {
                                    key: key,
                                    search: {
                                        query: query,
                                        context: context
                                    }
                                };
                                _context11.next = 5;
                                return (0, $4F3Il.request)("post", "".concat(this.resolverUrl, "/invoke/search"), requestData);
                            case 5:
                                response = _context11.sent;
                                if (!(0, $l4n7k.isErrorResponse)(response)) {
                                    _context11.next = 8;
                                    break;
                                }
                                throw this.mapErrorResponse(response);
                            case 8:
                                return _context11.abrupt("return", response);
                            case 9:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this);
                }));
                function search(_x12) {
                    return _search.apply(this, arguments);
                }
                return search;
            }()
        },
        {
            key: "fetchAvailableSearchProviders",
            value: function() {
                var _fetchAvailableSearchProviders = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee12() {
                    var response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                _context12.next = 2;
                                return (0, $4F3Il.request)("post", "".concat(this.resolverUrl, "/providers"), {
                                    type: "search"
                                });
                            case 2:
                                response = _context12.sent;
                                return _context12.abrupt("return", response.providers);
                            case 4:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function fetchAvailableSearchProviders() {
                    return _fetchAvailableSearchProviders.apply(this, arguments);
                }
                return fetchAvailableSearchProviders;
            }()
        },
        {
            key: "mapErrorResponse",
            value: function mapErrorResponse(response) {
                var hostname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                // Catch non-200 server responses to fallback or return useful information.
                if (response !== null && response !== void 0 && response.error) {
                    var errorType = response.error.type;
                    var errorMessage = response.error.message;
                    var extensionKey = response.error.extensionKey;
                    // this means there was a network error and we fallback to blue link
                    // without impacting SLO's
                    if (response.error instanceof (0, $4F3Il.NetworkError)) return new (0, $1YLM0.APIError)("fallback", hostname, errorMessage, errorType);
                    switch(errorType){
                        // BadRequestError - indicative of an API error, render
                        // a blue link to mitigate customer impact.
                        case "ResolveBadRequestError":
                        case "SearchBadRequestError":
                        case "BadRequestError":
                            return new (0, $1YLM0.APIError)("fallback", hostname, errorMessage, errorType, extensionKey);
                        // AuthError - if the user logs in, we may be able
                        // to recover. Render an unauthorized card.
                        case "ResolveAuthError":
                        case "SearchAuthError":
                        case "AuthError":
                            return new (0, $1YLM0.APIError)("auth", hostname, errorMessage, errorType, extensionKey);
                        // UnsupportedError - we do not know how to render this URL.
                        // Bail out and ask the Editor to render as a blue link.
                        case "ResolveUnsupportedError":
                        case "SearchUnsupportedError":
                        case "UnsupportedError":
                            // URL isn't supported
                            return new (0, $1YLM0.APIError)("fatal", hostname, errorMessage, errorType, extensionKey);
                        case "ResolveFailedError":
                        case "SearchFailedError":
                        case "ResolveTimeoutError":
                        case "SearchTimeoutError":
                        case "SearchRateLimitError":
                        case "ResolveRateLimitError":
                        case "InternalServerError":
                        case "TimeoutError":
                        case "RateLimitError":
                            return new (0, $1YLM0.APIError)("error", hostname, errorMessage, errorType, extensionKey);
                    }
                }
                // Catch all: we don't know this error, bail out.
                var _ref8 = response || {}, error = _ref8.error, rest = (0, $1151q.default)(_ref8, $1d16f15df58245cb$var$_excluded);
                return new (0, $1YLM0.APIError)("fatal", hostname, // reason we stringify the error differently is because
                // JSON.stringify will return "{}" if it is an instance of Error
                // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
                // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
                // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
                // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
                // we assume 'rest'  to "serializable" meaning all its properties are enumerable
                response ? "".concat(this.stringifyError(error), " ").concat(JSON.stringify(rest)) : "Response undefined", "UnexpectedError");
            }
        },
        {
            key: "stringifyError",
            value: function stringifyError(err) {
                /**
       * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
       * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
       * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
       */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
                (0, $8afK4.default)(err) === "object" ? Object.getOwnPropertyNames(err) : undefined);
            }
        }
    ]);
}();

});
parcelRegister("8afK4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f1b77f3d470a4e8$export$2e2bcd8739ae039; });
function $5f1b77f3d470a4e8$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5f1b77f3d470a4e8$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5f1b77f3d470a4e8$export$2e2bcd8739ae039(o);
}

});

parcelRegister("1151q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bd9c7b0579ac6c1$export$2e2bcd8739ae039; });

var $eo9ED = parcelRequire("eo9ED");
function $0bd9c7b0579ac6c1$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $eo9ED.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("eo9ED", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a79acbbd39be2e82$export$2e2bcd8739ae039; });
function $a79acbbd39be2e82$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("1SJdX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15edea2ebf5c7ea7$export$2e2bcd8739ae039; });

var $hjior = parcelRequire("hjior");

var $3V4df = parcelRequire("3V4df");

var $i1OMi = parcelRequire("i1OMi");

var $d4ejc = parcelRequire("d4ejc");
function $15edea2ebf5c7ea7$export$2e2bcd8739ae039(r) {
    return (0, $hjior.default)(r) || (0, $3V4df.default)(r) || (0, $i1OMi.default)(r) || (0, $d4ejc.default)();
}

});
parcelRegister("hjior", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9a27a86608da308$export$2e2bcd8739ae039; });

var $26Ajb = parcelRequire("26Ajb");
function $c9a27a86608da308$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $26Ajb.default)(r);
}

});
parcelRegister("26Ajb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18884e673238e5d0$export$2e2bcd8739ae039; });
function $18884e673238e5d0$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("3V4df", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2da9f67ed621112d$export$2e2bcd8739ae039; });
function $2da9f67ed621112d$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("i1OMi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1ffb56ba0223e0a$export$2e2bcd8739ae039; });

var $26Ajb = parcelRequire("26Ajb");
function $d1ffb56ba0223e0a$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $26Ajb.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $26Ajb.default)(r, a) : void 0;
    }
}

});

parcelRegister("d4ejc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9836bf821d4dc2fd$export$2e2bcd8739ae039; });
function $9836bf821d4dc2fd$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("3OzAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c71a61947b4e7ce$export$2e2bcd8739ae039; });
function $2c71a61947b4e7ce$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $2c71a61947b4e7ce$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $2c71a61947b4e7ce$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $2c71a61947b4e7ce$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("iyxmX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d82549698c592b98$export$2e2bcd8739ae039; });
function $d82549698c592b98$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("foAXX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b355c591faa8740d$export$2e2bcd8739ae039; });

var $5efmM = parcelRequire("5efmM");
function $b355c591faa8740d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $5efmM.default)(o.key), o);
    }
}
function $b355c591faa8740d$export$2e2bcd8739ae039(e, r, t) {
    return r && $b355c591faa8740d$var$_defineProperties(e.prototype, r), t && $b355c591faa8740d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("5efmM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cea2dfb6eb1a391$export$2e2bcd8739ae039; });

var $8afK4 = parcelRequire("8afK4");

var $fbVEp = parcelRequire("fbVEp");
function $3cea2dfb6eb1a391$export$2e2bcd8739ae039(t) {
    var i = (0, $fbVEp.default)(t, "string");
    return "symbol" == (0, $8afK4.default)(i) ? i : i + "";
}

});
parcelRegister("fbVEp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0f49a5707915f3b$export$2e2bcd8739ae039; });

var $8afK4 = parcelRequire("8afK4");
function $b0f49a5707915f3b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8afK4.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8afK4.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("e7oBD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a474ce64036b752b$export$2e2bcd8739ae039; });

var $5efmM = parcelRequire("5efmM");
function $a474ce64036b752b$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $5efmM.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("8qNJA", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $6237549d5fe0a29f$var$runtime = (parcelRequire("aXcFJ"))();
module.exports = $6237549d5fe0a29f$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $6237549d5fe0a29f$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $6237549d5fe0a29f$var$runtime;
    else Function("r", "regeneratorRuntime = r")($6237549d5fe0a29f$var$runtime);
}

});
parcelRegister("aXcFJ", function(module, exports) {

var $3W1ei = parcelRequire("3W1ei");

var $elmAO = parcelRequire("elmAO");

var $4KwdM = parcelRequire("4KwdM");

var $1LD3E = parcelRequire("1LD3E");

var $78rCE = parcelRequire("78rCE");

var $kT1An = parcelRequire("kT1An");

var $3oZTP = parcelRequire("3oZTP");
function $7f993e763b3c535e$var$_regeneratorRuntime() {
    "use strict";
    var r = $elmAO(), e = r.m($7f993e763b3c535e$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $3oZTP(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $7f993e763b3c535e$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $3W1ei(r, e);
            },
            AsyncIterator: $78rCE,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $1LD3E : $4KwdM)(a(r), e, t, o, u);
            },
            keys: $kT1An,
            values: $3oZTP
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $7f993e763b3c535e$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3W1ei", function(module, exports) {
function $2dd7be0e668d9d95$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $2dd7be0e668d9d95$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("elmAO", function(module, exports) {

var $129yW = parcelRequire("129yW");
function $a7148d50f544d1bb$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $129yW(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($129yW(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $129yW(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $129yW(u, "constructor", GeneratorFunctionPrototype), $129yW(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $129yW(GeneratorFunctionPrototype, o, "GeneratorFunction"), $129yW(u), $129yW(u, o, "Generator"), $129yW(u, n, function() {
        return this;
    }), $129yW(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $a7148d50f544d1bb$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $a7148d50f544d1bb$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("129yW", function(module, exports) {
function $0c0d6540d409987f$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $0c0d6540d409987f$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $0c0d6540d409987f$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0c0d6540d409987f$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $0c0d6540d409987f$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4KwdM", function(module, exports) {

var $1LD3E = parcelRequire("1LD3E");
function $375473ca9c39646d$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $1LD3E(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $375473ca9c39646d$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1LD3E", function(module, exports) {

var $elmAO = parcelRequire("elmAO");

var $78rCE = parcelRequire("78rCE");
function $14987a50a639207c$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $78rCE($elmAO().w(r, e, t, o), n || Promise);
}
module.exports = $14987a50a639207c$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("78rCE", function(module, exports) {

var $3W1ei = parcelRequire("3W1ei");

var $129yW = parcelRequire("129yW");
function $531eb4ffbdd1b315$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $3W1ei ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($129yW($531eb4ffbdd1b315$var$AsyncIterator.prototype), $129yW($531eb4ffbdd1b315$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $129yW(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $531eb4ffbdd1b315$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("kT1An", function(module, exports) {
function $f34a2c9dfb4da21b$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $f34a2c9dfb4da21b$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3oZTP", function(module, exports) {

var $eKnng = parcelRequire("eKnng");
var $27a3a0ee00181001$var$_typeof = $eKnng.default;
function $27a3a0ee00181001$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($27a3a0ee00181001$var$_typeof(e) + " is not iterable");
}
module.exports = $27a3a0ee00181001$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eKnng", function(module, exports) {
function $abc77e339078a713$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $abc77e339078a713$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $abc77e339078a713$var$_typeof(o);
}
module.exports = $abc77e339078a713$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("4ZE1Z", function(module, exports) {

$parcel$export(module.exports, "expValEquals", function () { return $3a2be94b09cbf924$export$45abdb3f977b5b14; });

var $kZHvk = parcelRequire("kZHvk");
function $3a2be94b09cbf924$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue) {
    var experimentDefaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return (0, $kZHvk.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("kZHvk", function(module, exports) {

$parcel$export(module.exports, "expValEqualsInternal", function () { return $f48b402e2e10a1ed$export$58e581060588c6bb; });

var $jGlEr = parcelRequire("jGlEr");

var $4hj8T = parcelRequire("4hj8T");
function $f48b402e2e10a1ed$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $4hj8T._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $4hj8T._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $jGlEr.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $jGlEr.default).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("jGlEr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e542bc0d3fe43457$export$2e2bcd8739ae039; });

var $iyxmX = parcelRequire("iyxmX");

var $foAXX = parcelRequire("foAXX");

var $e7oBD = parcelRequire("e7oBD");

var $gYzUp = parcelRequire("gYzUp");

var $1LEhT = parcelRequire("1LEhT");



var $e542bc0d3fe43457$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $e542bc0d3fe43457$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $iyxmX.default)(this, FeatureGates);
    }
    return (0, $foAXX.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$e542bc0d3fe43457$var$_FeatureGates = $e542bc0d3fe43457$var$FeatureGates;
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "client", new (0, $gYzUp.Client)());
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === "function") {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e542bc0d3fe43457$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.",
                gateName: gateName,
                error: error
            });
            $e542bc0d3fe43457$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $e542bc0d3fe43457$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === "function") {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$e542bc0d3fe43457$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.",
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $e542bc0d3fe43457$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $e542bc0d3fe43457$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "initializeCalled", $e542bc0d3fe43457$var$_FeatureGates.client.initializeCalled.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "initializeCompleted", $e542bc0d3fe43457$var$_FeatureGates.client.initializeCompleted.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "initialize", $e542bc0d3fe43457$var$_FeatureGates.client.initialize.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "initializeWithProvider", $e542bc0d3fe43457$var$_FeatureGates.client.initializeWithProvider.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "initializeFromValues", $e542bc0d3fe43457$var$_FeatureGates.client.initializeFromValues.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "manuallyLogGateExposure", $e542bc0d3fe43457$var$_FeatureGates.client.manuallyLogGateExposure.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "getExperiment", $e542bc0d3fe43457$var$_FeatureGates.client.getExperiment.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "manuallyLogExperimentExposure", $e542bc0d3fe43457$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "manuallyLogLayerExposure", $e542bc0d3fe43457$var$_FeatureGates.client.manuallyLogLayerExposure.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "shutdownStatsig", $e542bc0d3fe43457$var$_FeatureGates.client.shutdownStatsig.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "overrideGate", $e542bc0d3fe43457$var$_FeatureGates.client.overrideGate.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "clearGateOverride", $e542bc0d3fe43457$var$_FeatureGates.client.clearGateOverride.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "overrideConfig", $e542bc0d3fe43457$var$_FeatureGates.client.overrideConfig.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "clearConfigOverride", $e542bc0d3fe43457$var$_FeatureGates.client.clearConfigOverride.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "setOverrides", $e542bc0d3fe43457$var$_FeatureGates.client.setOverrides.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "getOverrides", $e542bc0d3fe43457$var$_FeatureGates.client.getOverrides.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "clearAllOverrides", $e542bc0d3fe43457$var$_FeatureGates.client.clearAllOverrides.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "isCurrentUser", $e542bc0d3fe43457$var$_FeatureGates.client.isCurrentUser.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "onGateUpdated", $e542bc0d3fe43457$var$_FeatureGates.client.onGateUpdated.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "onExperimentValueUpdated", $e542bc0d3fe43457$var$_FeatureGates.client.onExperimentValueUpdated.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "onAnyUpdated", $e542bc0d3fe43457$var$_FeatureGates.client.onAnyUpdated.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "updateUser", $e542bc0d3fe43457$var$_FeatureGates.client.updateUser.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "updateUserWithProvider", $e542bc0d3fe43457$var$_FeatureGates.client.updateUserWithProvider.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "updateUserWithValues", $e542bc0d3fe43457$var$_FeatureGates.client.updateUserWithValues.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "getPackageVersion", $e542bc0d3fe43457$var$_FeatureGates.client.getPackageVersion.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "getLayer", $e542bc0d3fe43457$var$_FeatureGates.client.getLayer.bind($e542bc0d3fe43457$var$_FeatureGates.client));
(0, $e7oBD.default)($e542bc0d3fe43457$var$FeatureGates, "getLayerValue", $e542bc0d3fe43457$var$_FeatureGates.client.getLayerValue.bind($e542bc0d3fe43457$var$_FeatureGates.client));
var $e542bc0d3fe43457$var$boundFGJS = $e542bc0d3fe43457$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $e542bc0d3fe43457$var$FeatureGates;
    else {
        var $e542bc0d3fe43457$var$_boundFGJS, $e542bc0d3fe43457$var$_boundFGJS$getPackage;
        $e542bc0d3fe43457$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $e542bc0d3fe43457$var$boundVersion = (($e542bc0d3fe43457$var$_boundFGJS = $e542bc0d3fe43457$var$boundFGJS) === null || $e542bc0d3fe43457$var$_boundFGJS === void 0 || ($e542bc0d3fe43457$var$_boundFGJS$getPackage = $e542bc0d3fe43457$var$_boundFGJS.getPackageVersion) === null || $e542bc0d3fe43457$var$_boundFGJS$getPackage === void 0 ? void 0 : $e542bc0d3fe43457$var$_boundFGJS$getPackage.call($e542bc0d3fe43457$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($e542bc0d3fe43457$var$boundVersion !== (0, $1LEhT.CLIENT_VERSION)) {
            var $e542bc0d3fe43457$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($e542bc0d3fe43457$var$boundVersion, " when module version ").concat((0, $1LEhT.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($e542bc0d3fe43457$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $e542bc0d3fe43457$export$2e2bcd8739ae039 = $e542bc0d3fe43457$var$boundFGJS;

});
parcelRegister("gYzUp", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $c5be1ab26b8b599b$export$1f2bb630327ac4b6; });

var $1151q = parcelRequire("1151q");

var $iKZ8Y = parcelRequire("iKZ8Y");

var $3OzAF = parcelRequire("3OzAF");

var $iyxmX = parcelRequire("iyxmX");

var $foAXX = parcelRequire("foAXX");

var $e7oBD = parcelRequire("e7oBD");

var $8qNJA = parcelRequire("8qNJA");

var $63U7U = parcelRequire("63U7U");

var $6SGHN = parcelRequire("6SGHN");

var $3c2PL = parcelRequire("3c2PL");

var $lid87 = parcelRequire("lid87");

var $iA3OF = parcelRequire("iA3OF");

var $7KL9J = parcelRequire("7KL9J");

var $8Mh0h = parcelRequire("8Mh0h");

var $af3Uh = parcelRequire("af3Uh");

var $kzVmY = parcelRequire("kzVmY");

var $cPxTg = parcelRequire("cPxTg");

var $1LEhT = parcelRequire("1LEhT");
var $c5be1ab26b8b599b$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $c5be1ab26b8b599b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5be1ab26b8b599b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5be1ab26b8b599b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e7oBD.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5be1ab26b8b599b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c5be1ab26b8b599b$var$DEFAULT_CLIENT_KEY = "client-default-key";
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $c5be1ab26b8b599b$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/rgstr";
var $c5be1ab26b8b599b$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $af3Uh.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $iyxmX.default)(this, Client);
        (0, $e7oBD.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $e7oBD.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $e7oBD.default)(this, "initWithDefaults", false);
        (0, $e7oBD.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $e7oBD.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $e7oBD.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $e7oBD.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $e7oBD.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $e7oBD.default)(this, "subscriptions", new (0, $6SGHN.default)());
        (0, $e7oBD.default)(this, "dataAdapter", new (0, $8Mh0h.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $e7oBD.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $af3Uh.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $foAXX.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $cPxTg.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $cPxTg.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, "initialize", _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $cPxTg.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $cPxTg.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $1LEhT.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, "initializeWithProvider", _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn("Error when attempting to apply update", error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $c5be1ab26b8b599b$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $1LEhT.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $kzVmY.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $cPxTg.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $cPxTg.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, "has_updates")) initializeValues["has_updates"] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, "initializeFromValues", _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error("Client must be initialized before using this method");
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $cPxTg.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $7KL9J.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error("Cannot update user using provider as the client was not initialised with a provider");
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $3c2PL.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $3c2PL.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $iA3OF.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $cPxTg.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $cPxTg.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $c5be1ab26b8b599b$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $7KL9J.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $7KL9J.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, $iKZ8Y.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $c5be1ab26b8b599b$var$_objectSpread($c5be1ab26b8b599b$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, $iKZ8Y.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $cPxTg.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $c5be1ab26b8b599b$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $c5be1ab26b8b599b$var$_objectSpread($c5be1ab26b8b599b$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $c5be1ab26b8b599b$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $kzVmY.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $1151q.default)(newClientOptions, $c5be1ab26b8b599b$var$_excluded);
                                this.user = (0, $cPxTg.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $c5be1ab26b8b599b$var$_objectSpread($c5be1ab26b8b599b$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $63U7U.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $63U7U.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context9.prev = 12;
                                this.statsigClient = new (0, $63U7U.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $63U7U.StatsigClient)($c5be1ab26b8b599b$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee1(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context1.next = 3;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can update the user.");
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context1.next = 5;
                                    break;
                                }
                                return _context1.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context1.prev = 6;
                                _context1.next = 9;
                                return this.initPromise;
                            case 9:
                                _context1.next = 13;
                                break;
                            case 11:
                                _context1.prev = 11;
                                _context1.t0 = _context1["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee0() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee0$(_context0) {
                                        while(true)switch(_context0.prev = _context0.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context0.next = 4;
                                                    break;
                                                }
                                                _context0.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context0.stop();
                                        }
                                    }, _callee0);
                                })));
                                return _context1.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee10(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context10.prev = 1;
                                _context10.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context10.sent;
                                user = (0, $cPxTg.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context10.next = 13;
                                break;
                            case 8:
                                _context10.prev = 8;
                                _context10.t0 = _context10["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context10.t0 instanceof Error ? _context10.t0.message : JSON.stringify(_context10.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context10.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context10.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context10.next = 21;
                                    break;
                                }
                                _context10.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context10.next = 27;
                                break;
                            case 23:
                                _context10.prev = 23;
                                _context10.t1 = _context10["catch"](15);
                                success = false;
                                errorMessage = String(_context10.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context10.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context10.next = 35;
                                break;
                            case 34:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 35:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $1LEhT.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $lid87.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $lid87.Layer).fromLayer((0, $63U7U._makeLayer)(layerName, {
                        reason: "Error"
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("iKZ8Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da7bf3c2db5b9c0d$export$2e2bcd8739ae039; });

var $gOwVy = parcelRequire("gOwVy");

var $b0hza = parcelRequire("b0hza");

var $i1OMi = parcelRequire("i1OMi");

var $c6m6c = parcelRequire("c6m6c");
function $da7bf3c2db5b9c0d$export$2e2bcd8739ae039(r, e) {
    return (0, $gOwVy.default)(r) || (0, $b0hza.default)(r, e) || (0, $i1OMi.default)(r, e) || (0, $c6m6c.default)();
}

});
parcelRegister("gOwVy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3dadb853a89e02d$export$2e2bcd8739ae039; });
function $c3dadb853a89e02d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("b0hza", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $802d52108cc3af00$export$2e2bcd8739ae039; });
function $802d52108cc3af00$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("c6m6c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cf72ff3a9e6b857$export$2e2bcd8739ae039; });
function $8cf72ff3a9e6b857$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("63U7U", function(module, exports) {
"use strict";
var $469e8f7a9beddb34$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $469e8f7a9beddb34$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $469e8f7a9beddb34$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $dmmnC = parcelRequire("dmmnC");
module.exports.StatsigClient = $dmmnC.default;

$469e8f7a9beddb34$var$__exportStar((parcelRequire("iNYlF")), module.exports);
const $469e8f7a9beddb34$var$__STATSIG__ = Object.assign((0, (parcelRequire("iNYlF"))._getStatsigGlobal)(), {
    StatsigClient: $dmmnC.default
});
module.exports.default = $469e8f7a9beddb34$var$__STATSIG__;

});
parcelRegister("iNYlF", function(module, exports) {
"use strict";
var $db0b9d877e89f3ee$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $db0b9d877e89f3ee$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $db0b9d877e89f3ee$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("dWy6I")).Diagnostics;
    }
});

var $c9hY4 = parcelRequire("c9hY4");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $c9hY4.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("2AsQc")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("kWskg")).Storage;
    }
});

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("l0nby")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("7on1s")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("cDAHj")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("6Msbd")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("dWy6I")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("gzoJ4")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("13ZQJ")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("15xGS")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("6Ong9")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("rK4iv")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("a8ic2")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("2AsQc")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("aVLDx")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("i5Iju")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("1G4Fb")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("3a2r6")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("lJpY0")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("fG7fH")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("cMY7N")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("zCGVF")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("jXArS")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("1AWzd")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("hvzXn")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("2pmXG")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("efzGd")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("kybCf")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("2MtjN")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("6NsOg")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("6ufXv")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("339yS")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("fTxwE")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("gaJI5")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("kWskg")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("e7izm")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("cUpr9")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("97vvV")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("dvixL")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("4asVk")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("1y5iW")), module.exports);

$db0b9d877e89f3ee$var$__exportStar((parcelRequire("gfsNb")), module.exports);
Object.assign((0, (parcelRequire("l0nby"))._getStatsigGlobal)(), {
    Log: (parcelRequire("2AsQc")).Log,
    SDK_VERSION: (parcelRequire("2MtjN")).SDK_VERSION
});

});
parcelRegister("l0nby", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $f4ab9533cfdbe794$var$_a, $f4ab9533cfdbe794$var$_b, $f4ab9533cfdbe794$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $2AsQc = parcelRequire("2AsQc");
const $f4ab9533cfdbe794$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== "undefined" ? __STATSIG__ : $f4ab9533cfdbe794$var$statsigGlobal;
    } catch (e) {
        return $f4ab9533cfdbe794$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $f4ab9533cfdbe794$var$_getStatsigGlobal;
const $f4ab9533cfdbe794$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $f4ab9533cfdbe794$var$_getStatsigGlobalFlag;
const $f4ab9533cfdbe794$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $2AsQc.Log.warn("Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.");
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $f4ab9533cfdbe794$var$_getInstance;
const $f4ab9533cfdbe794$var$GLOBAL_KEY = "__STATSIG__";
const $f4ab9533cfdbe794$var$_window = typeof window !== "undefined" ? window : {};
const $f4ab9533cfdbe794$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $f4ab9533cfdbe794$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : {};
const $f4ab9533cfdbe794$var$statsigGlobal = ($f4ab9533cfdbe794$var$_c = ($f4ab9533cfdbe794$var$_b = ($f4ab9533cfdbe794$var$_a = $f4ab9533cfdbe794$var$_window[$f4ab9533cfdbe794$var$GLOBAL_KEY]) !== null && $f4ab9533cfdbe794$var$_a !== void 0 ? $f4ab9533cfdbe794$var$_a : $f4ab9533cfdbe794$var$_global[$f4ab9533cfdbe794$var$GLOBAL_KEY]) !== null && $f4ab9533cfdbe794$var$_b !== void 0 ? $f4ab9533cfdbe794$var$_b : $f4ab9533cfdbe794$var$_globalThis[$f4ab9533cfdbe794$var$GLOBAL_KEY]) !== null && $f4ab9533cfdbe794$var$_c !== void 0 ? $f4ab9533cfdbe794$var$_c : {
    instance: module.exports._getInstance
};
$f4ab9533cfdbe794$var$_window[$f4ab9533cfdbe794$var$GLOBAL_KEY] = $f4ab9533cfdbe794$var$statsigGlobal;
$f4ab9533cfdbe794$var$_global[$f4ab9533cfdbe794$var$GLOBAL_KEY] = $f4ab9533cfdbe794$var$statsigGlobal;
$f4ab9533cfdbe794$var$_globalThis[$f4ab9533cfdbe794$var$GLOBAL_KEY] = $f4ab9533cfdbe794$var$statsigGlobal;

});
parcelRegister("2AsQc", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $1e2550c25e79fec1$var$DEBUG = " DEBUG ";
const $1e2550c25e79fec1$var$_INFO = "  INFO ";
const $1e2550c25e79fec1$var$_WARN = "  WARN ";
const $1e2550c25e79fec1$var$ERROR = " ERROR ";
function $1e2550c25e79fec1$var$addTag(args) {
    args.unshift("[Statsig]");
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $1e2550c25e79fec1$var$Log {
    static info(...args) {
        if ($1e2550c25e79fec1$var$Log.level >= module.exports.LogLevel.Info) console.info($1e2550c25e79fec1$var$_INFO, ...$1e2550c25e79fec1$var$addTag(args));
    }
    static debug(...args) {
        if ($1e2550c25e79fec1$var$Log.level >= module.exports.LogLevel.Debug) console.debug($1e2550c25e79fec1$var$DEBUG, ...$1e2550c25e79fec1$var$addTag(args));
    }
    static warn(...args) {
        if ($1e2550c25e79fec1$var$Log.level >= module.exports.LogLevel.Warn) console.warn($1e2550c25e79fec1$var$_WARN, ...$1e2550c25e79fec1$var$addTag(args));
    }
    static error(...args) {
        if ($1e2550c25e79fec1$var$Log.level >= module.exports.LogLevel.Error) console.error($1e2550c25e79fec1$var$ERROR, ...$1e2550c25e79fec1$var$addTag(args));
    }
}
module.exports.Log = $1e2550c25e79fec1$var$Log;
$1e2550c25e79fec1$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("dWy6I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $a26b26280fce8254$var$MARKER_MAP = new Map();
const $a26b26280fce8254$var$ACT_START = "start";
const $a26b26280fce8254$var$ACT_END = "end";
const $a26b26280fce8254$var$DIAGNOSTICS_EVENT = "statsig::diagnostics";
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $a26b26280fce8254$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $a26b26280fce8254$var$_addMarker(sdkKey, $a26b26280fce8254$var$_createMarker({}, $a26b26280fce8254$var$ACT_START, "overall"));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $a26b26280fce8254$var$_addMarker(sdkKey, $a26b26280fce8254$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: "InitializeError",
                message: "Failed to initialize"
            },
            evaluationDetails: evaluationDetails
        }, $a26b26280fce8254$var$ACT_END, "overall"));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $a26b26280fce8254$var$_addMarker(sdkKey, $a26b26280fce8254$var$_createMarker(data, $a26b26280fce8254$var$ACT_START, "initialize", "network_request"));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $a26b26280fce8254$var$_addMarker(sdkKey, $a26b26280fce8254$var$_createMarker(data, $a26b26280fce8254$var$ACT_END, "initialize", "network_request"));
    },
    _markInitProcessStart: (sdkKey)=>{
        $a26b26280fce8254$var$_addMarker(sdkKey, $a26b26280fce8254$var$_createMarker({}, $a26b26280fce8254$var$ACT_START, "initialize", "process"));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $a26b26280fce8254$var$_addMarker(sdkKey, $a26b26280fce8254$var$_createMarker(data, $a26b26280fce8254$var$ACT_END, "initialize", "process"));
    },
    _clearMarkers: (sdkKey)=>{
        $a26b26280fce8254$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === "object")) return;
        return {
            code: $a26b26280fce8254$var$_safeGetField(e, "code"),
            name: $a26b26280fce8254$var$_safeGetField(e, "name"),
            message: $a26b26280fce8254$var$_safeGetField(e, "message")
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get("x-statsig-region"),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $a26b26280fce8254$var$_makeDiagnosticsEvent(user, {
            context: "initialize",
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $a26b26280fce8254$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $a26b26280fce8254$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $a26b26280fce8254$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $a26b26280fce8254$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $a26b26280fce8254$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $a26b26280fce8254$var$MARKER_MAP.set(sdkKey, markers);
}
function $a26b26280fce8254$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("c9hY4", function(module, exports) {
"use strict";
var $8d84435bef0572cf$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $7on1s = parcelRequire("7on1s");

var $rK4iv = parcelRequire("rK4iv");

var $2AsQc = parcelRequire("2AsQc");

var $i5Iju = parcelRequire("i5Iju");

var $fG7fH = parcelRequire("fG7fH");

var $kybCf = parcelRequire("kybCf");

var $6NsOg = parcelRequire("6NsOg");

var $kWskg = parcelRequire("kWskg");

var $97vvV = parcelRequire("97vvV");

var $4asVk = parcelRequire("4asVk");
const $8d84435bef0572cf$var$DEFAULT_QUEUE_SIZE = 100;
const $8d84435bef0572cf$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $8d84435bef0572cf$var$MAX_DEDUPER_KEYS = 1000;
const $8d84435bef0572cf$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $8d84435bef0572cf$var$MAX_FAILED_LOGS = 500;
const $8d84435bef0572cf$var$QUICK_FLUSH_WINDOW_MS = 200;
const $8d84435bef0572cf$var$EVENT_LOGGER_MAP = {};
const $8d84435bef0572cf$var$RetryFailedLogsTrigger = {
    Startup: "startup",
    GainedFocus: "gained_focus"
};
class $8d84435bef0572cf$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $8d84435bef0572cf$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $8d84435bef0572cf$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($8d84435bef0572cf$var$RetryFailedLogsTrigger.GainedFocus);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $8d84435bef0572cf$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $fG7fH._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== "always") return;
        $8d84435bef0572cf$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $4asVk._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === "background") $8d84435bef0572cf$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === "foreground") $8d84435bef0572cf$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($8d84435bef0572cf$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $8d84435bef0572cf$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $8d84435bef0572cf$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $8d84435bef0572cf$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $8d84435bef0572cf$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$8d84435bef0572cf$var$EventLogger._safeFlushAndForget(this._sdkKey), $8d84435bef0572cf$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== "always" && (0, $fG7fH._isServerEnv)()) return false;
        if (!(0, $kybCf._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $7on1s._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata["gate"],
            metadata["config"],
            metadata["ruleID"],
            metadata["allocatedExperiment"],
            metadata["parameterName"],
            String(metadata["isExplicitParameter"]),
            metadata["reason"]
        ].join("|");
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $8d84435bef0572cf$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $8d84435bef0572cf$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $8d84435bef0572cf$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === "disabled") {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $4asVk._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: "pre_logs_flushed",
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: "logs_flushed",
                        events: events
                    });
                    return true;
                } else {
                    $2AsQc.Log.warn("Failed to flush events.");
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $2AsQc.Log.warn("Failed to flush events.");
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $8d84435bef0572cf$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$i5Iju.NetworkParam.EventCount]: String(events.length)
            },
            credentials: "same-origin"
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $8d84435bef0572cf$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $kWskg._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $2AsQc.Log.warn("Unable to save failed logs to storage");
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$8d84435bef0572cf$var$__awaiter(this, void 0, void 0, function*() {
                if (!$kWskg.Storage.isReady()) yield $kWskg.Storage.isReadyResolver();
                const events = (0, $kWskg._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $8d84435bef0572cf$var$RetryFailedLogsTrigger.Startup) $kWskg.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $8d84435bef0572cf$var$RetryFailedLogsTrigger.GainedFocus) $kWskg.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $2AsQc.Log.warn("Failed to flush stored logs");
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $rK4iv._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $2AsQc.Log.debug("Enqueued Event:", final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: "statsig::non_exposed_checks",
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $fG7fH._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $8d84435bef0572cf$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $8d84435bef0572cf$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $8d84435bef0572cf$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $6NsOg.LoggingEnabledOption.disabled : $6NsOg.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $2AsQc.Log.warn("Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.");
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $8d84435bef0572cf$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $97vvV.UrlConfiguration($i5Iju.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
module.exports.EventLogger = $8d84435bef0572cf$var$EventLogger;

});
parcelRegister("7on1s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $rK4iv = parcelRequire("rK4iv");
function $561ca21562f54517$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(",")}`,
        `k:${sdkKey}`
    ];
    return (0, $rK4iv._DJB2)(parts.join("|"));
}
module.exports._getUserStorageKey = $561ca21562f54517$var$_getUserStorageKey;
function $561ca21562f54517$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $561ca21562f54517$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $rK4iv._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $561ca21562f54517$var$_getStorageKey;

});
parcelRegister("rK4iv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $cUpr9 = parcelRequire("cUpr9");
const $053641f0422f288c$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $053641f0422f288c$var$_DJB2;
const $053641f0422f288c$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $053641f0422f288c$var$_DJB2Object;
const $053641f0422f288c$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $cUpr9._typeOf)(value) !== "object") {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $053641f0422f288c$var$_getSortedObject;

});
parcelRegister("cUpr9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $965e72413f57b687$var$_typeOf(input) {
    return Array.isArray(input) ? "array" : typeof input;
}
module.exports._typeOf = $965e72413f57b687$var$_typeOf;
function $965e72413f57b687$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? "array" : x === null ? "null" : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $965e72413f57b687$var$_isTypeMatch;

});



parcelRegister("i5Iju", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: "initialize",
    _rgstr: "rgstr",
    _download_config_specs: "download_config_specs"
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: "https://prodregistryv2.org/v1",
    [module.exports.Endpoint._initialize]: "https://featureassets.org/v1",
    [module.exports.Endpoint._download_config_specs]: "https://api.statsigcdn.com/v1"
};
module.exports.NetworkParam = {
    EventCount: "ec",
    SdkKey: "k",
    SdkType: "st",
    SdkVersion: "sv",
    Time: "t",
    SessionID: "sid",
    StatsigEncoded: "se",
    IsGzipped: "gz"
};

});

parcelRegister("fG7fH", function(module, exports) {

var $XAEGR = parcelRequire("XAEGR");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $b6a0676b2fbbabc9$var$_getWindowSafe = ()=>{
    return typeof window !== "undefined" ? window : null;
};
module.exports._getWindowSafe = $b6a0676b2fbbabc9$var$_getWindowSafe;
const $b6a0676b2fbbabc9$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $b6a0676b2fbbabc9$var$_getDocumentSafe;
const $b6a0676b2fbbabc9$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $XAEGR !== "undefined" && $XAEGR.versions != null && $XAEGR.versions.node != null;
    const isVercel = typeof EdgeRuntime === "string";
    return isVercel || isNode;
};
module.exports._isServerEnv = $b6a0676b2fbbabc9$var$_isServerEnv;
const $b6a0676b2fbbabc9$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === "function") win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $b6a0676b2fbbabc9$var$_addWindowEventListenerSafe;
const $b6a0676b2fbbabc9$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === "function") doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $b6a0676b2fbbabc9$var$_addDocumentEventListenerSafe;
const $b6a0676b2fbbabc9$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $b6a0676b2fbbabc9$var$_getCurrentPageUrlSafe;
const $b6a0676b2fbbabc9$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return "beforeunload";
    const eventType = "onpagehide" in win ? "pagehide" : "beforeunload";
    return eventType;
};
module.exports._getUnloadEvent = $b6a0676b2fbbabc9$var$_getUnloadEvent;

});

parcelRegister("kybCf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $ef5ffe4feecd8466$var$CONFIG_EXPOSURE_NAME = "statsig::config_exposure";
const $ef5ffe4feecd8466$var$GATE_EXPOSURE_NAME = "statsig::gate_exposure";
const $ef5ffe4feecd8466$var$LAYER_EXPOSURE_NAME = "statsig::layer_exposure";
const $ef5ffe4feecd8466$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata["bootstrapMetadata"] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $ef5ffe4feecd8466$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $ef5ffe4feecd8466$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $ef5ffe4feecd8466$var$GATE_EXPOSURE_NAME || eventName === $ef5ffe4feecd8466$var$CONFIG_EXPOSURE_NAME || eventName === $ef5ffe4feecd8466$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $ef5ffe4feecd8466$var$_isExposureEvent;
const $ef5ffe4feecd8466$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = gate.__evaluation.version;
    return $ef5ffe4feecd8466$var$_createExposure($ef5ffe4feecd8466$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $ef5ffe4feecd8466$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $ef5ffe4feecd8466$var$_createGateExposure;
function $ef5ffe4feecd8466$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === "string") return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $ef5ffe4feecd8466$var$_mapExposures;
const $ef5ffe4feecd8466$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata["rulePassed"] = String(config.__evaluation.passed);
    return $ef5ffe4feecd8466$var$_createExposure($ef5ffe4feecd8466$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $ef5ffe4feecd8466$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $ef5ffe4feecd8466$var$_createConfigExposure;
const $ef5ffe4feecd8466$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = "";
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : "";
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata["configVersion"] = layer.__evaluation.version;
    return $ef5ffe4feecd8466$var$_createExposure($ef5ffe4feecd8466$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $ef5ffe4feecd8466$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $ef5ffe4feecd8466$var$_createLayerParameterExposure;
const $ef5ffe4feecd8466$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata["reason"] = details.reason;
    if (details.lcut) metadata["lcut"] = String(details.lcut);
    if (details.receivedAt) metadata["receivedAt"] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("6NsOg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: "d",
    /** Compress request bodies unless a network proxy is configured */ Enabled: "e",
    /** Always compress request bodies, even when a proxy is configured */ Forced: "f"
};
module.exports.LoggingEnabledOption = {
    disabled: "disabled",
    browserOnly: "browser-only",
    always: "always"
};

});

parcelRegister("kWskg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $2AsQc = parcelRequire("2AsQc");

var $fG7fH = parcelRequire("fG7fH");
const $f3ef3252c7907aa9$var$inMemoryStore = {};
const $f3ef3252c7907aa9$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>"InMemory",
    getItem: (key)=>$f3ef3252c7907aa9$var$inMemoryStore[key] ? $f3ef3252c7907aa9$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $f3ef3252c7907aa9$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $f3ef3252c7907aa9$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($f3ef3252c7907aa9$var$inMemoryStore)
};
let $f3ef3252c7907aa9$var$_localStorageProvider = null;
try {
    const win = (0, $fG7fH._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === "function") $f3ef3252c7907aa9$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>"LocalStorage",
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $2AsQc.Log.warn("Failed to setup localStorageProvider.");
}
let $f3ef3252c7907aa9$var$_main = $f3ef3252c7907aa9$var$_localStorageProvider !== null && $f3ef3252c7907aa9$var$_localStorageProvider !== void 0 ? $f3ef3252c7907aa9$var$_localStorageProvider : $f3ef3252c7907aa9$var$_inMemoryProvider;
let $f3ef3252c7907aa9$var$_current = $f3ef3252c7907aa9$var$_main;
function $f3ef3252c7907aa9$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === "SecurityError") {
            module.exports.Storage._setProvider($f3ef3252c7907aa9$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === "QuotaExceededError") {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith("statsig."));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$f3ef3252c7907aa9$var$_current.isReady(),
    isReadyResolver: ()=>$f3ef3252c7907aa9$var$_current.isReadyResolver(),
    getProviderName: ()=>$f3ef3252c7907aa9$var$_current.getProviderName(),
    getItem: (key)=>$f3ef3252c7907aa9$var$_inMemoryBreaker(()=>$f3ef3252c7907aa9$var$_current.getItem(key)),
    setItem: (key, value)=>$f3ef3252c7907aa9$var$_inMemoryBreaker(()=>$f3ef3252c7907aa9$var$_current.setItem(key, value)),
    removeItem: (key)=>$f3ef3252c7907aa9$var$_current.removeItem(key),
    getAllKeys: ()=>$f3ef3252c7907aa9$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $f3ef3252c7907aa9$var$_main = newProvider;
        $f3ef3252c7907aa9$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $f3ef3252c7907aa9$var$_current = $f3ef3252c7907aa9$var$_inMemoryProvider;
        else $f3ef3252c7907aa9$var$_current = $f3ef3252c7907aa9$var$_main;
    }
};
function $f3ef3252c7907aa9$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : "null");
}
module.exports._getObjectFromStorage = $f3ef3252c7907aa9$var$_getObjectFromStorage;
function $f3ef3252c7907aa9$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $f3ef3252c7907aa9$var$_setObjectInStorage;

});

parcelRegister("97vvV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $rK4iv = parcelRequire("rK4iv");

var $i5Iju = parcelRequire("i5Iju");
const $6a3d367f96c268f4$var$ENDPOINT_DNS_KEY_MAP = {
    [$i5Iju.Endpoint._initialize]: "i",
    [$i5Iju.Endpoint._rgstr]: "e",
    [$i5Iju.Endpoint._download_config_specs]: "d"
};
class $6a3d367f96c268f4$var$UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(",");
        return (0, $rK4iv._DJB2)(this.customUrl + fallbacks);
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $6a3d367f96c268f4$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith("/") ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $i5Iju.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
module.exports.UrlConfiguration = $6a3d367f96c268f4$var$UrlConfiguration;

});

parcelRegister("4asVk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $fG7fH = parcelRequire("fG7fH");
const $308e8836a0201ceb$var$FOREGROUND = "foreground";
const $308e8836a0201ceb$var$BACKGROUND = "background";
const $308e8836a0201ceb$var$LISTENERS = [];
let $308e8836a0201ceb$var$current = $308e8836a0201ceb$var$FOREGROUND;
let $308e8836a0201ceb$var$isUnloading = false;
const $308e8836a0201ceb$var$_isCurrentlyVisible = ()=>{
    return $308e8836a0201ceb$var$current === $308e8836a0201ceb$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $308e8836a0201ceb$var$_isCurrentlyVisible;
const $308e8836a0201ceb$var$_isUnloading = ()=>$308e8836a0201ceb$var$isUnloading;
module.exports._isUnloading = $308e8836a0201ceb$var$_isUnloading;
const $308e8836a0201ceb$var$_subscribeToVisiblityChanged = (listener)=>{
    $308e8836a0201ceb$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $308e8836a0201ceb$var$_subscribeToVisiblityChanged;
const $308e8836a0201ceb$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $308e8836a0201ceb$var$current) return;
    $308e8836a0201ceb$var$current = visibility;
    $308e8836a0201ceb$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $308e8836a0201ceb$var$_notifyVisibilityChanged;
(0, $fG7fH._addWindowEventListenerSafe)("focus", ()=>{
    $308e8836a0201ceb$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($308e8836a0201ceb$var$FOREGROUND);
});
(0, $fG7fH._addWindowEventListenerSafe)("blur", ()=>(0, module.exports._notifyVisibilityChanged)($308e8836a0201ceb$var$BACKGROUND));
(0, $fG7fH._addDocumentEventListenerSafe)("visibilitychange", ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === "visible" ? $308e8836a0201ceb$var$FOREGROUND : $308e8836a0201ceb$var$BACKGROUND);
});
(0, $fG7fH._addWindowEventListenerSafe)((0, $fG7fH._getUnloadEvent)(), ()=>{
    $308e8836a0201ceb$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($308e8836a0201ceb$var$BACKGROUND);
});

});


parcelRegister("2MtjN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = "3.22.0";
let $2066ce79e6dba5c7$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: "js-mono"
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$2066ce79e6dba5c7$var$metadata,
    add: (additions)=>{
        $2066ce79e6dba5c7$var$metadata = Object.assign(Object.assign({}, $2066ce79e6dba5c7$var$metadata), additions);
    }
};

});

parcelRegister("cDAHj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6Msbd", function(module, exports) {
"use strict";
var $4efd15b9af118764$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $2AsQc = parcelRequire("2AsQc");

var $1AWzd = parcelRequire("1AWzd");

var $gaJI5 = parcelRequire("gaJI5");

var $kWskg = parcelRequire("kWskg");

var $e7izm = parcelRequire("e7izm");
const $4efd15b9af118764$var$CACHE_LIMIT = 10;
class $4efd15b9af118764$var$DataAdapterCore {
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $gaJI5._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $gaJI5._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $4efd15b9af118764$var$_makeDataAdapterResult("Bootstrap", data, null, normalized));
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $1AWzd.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $4efd15b9af118764$var$__awaiter(this, void 0, void 0, function*() {
            if (!$kWskg.Storage.isReady()) yield $kWskg.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $2AsQc.Log.debug("Fetching latest value timed out");
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $4efd15b9af118764$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $gaJI5._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: "Prefetch"
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $4efd15b9af118764$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $2AsQc.Log.debug("No response returned for latest value");
                return null;
            }
            const response = (0, $e7izm._typedJsonParse)(latest, "has_updates", "Response");
            const sdkKey = this._getSdkKey();
            const stableID = $1AWzd.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $4efd15b9af118764$var$_makeDataAdapterResult("Network", latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $4efd15b9af118764$var$_makeDataAdapterResult("NetworkNotModified", cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $2AsQc.Log.error(`${this._adapterName} is not attached to a Client`);
        return "";
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $kWskg.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($kWskg.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $e7izm._typedJsonParse)(cache, "source", "Cached Result");
        return result ? Object.assign(Object.assign({}, result), {
            source: "Cache"
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $kWskg.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $kWskg._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $4efd15b9af118764$var$_getEvictableKey(lastModifiedTimeMap, $4efd15b9af118764$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $kWskg.Storage.removeItem(evictable);
        }
        (0, $kWskg._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $4efd15b9af118764$var$InMemoryCache();
    }
}
module.exports.DataAdapterCore = $4efd15b9af118764$var$DataAdapterCore;
function $4efd15b9af118764$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $gaJI5._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $4efd15b9af118764$var$_makeDataAdapterResult;
class $4efd15b9af118764$var$InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $2AsQc.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $4efd15b9af118764$var$_getEvictableKey(this._data, $4efd15b9af118764$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function $4efd15b9af118764$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === "object" && typeof current === "object") return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("1AWzd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $7on1s = parcelRequire("7on1s");

var $2AsQc = parcelRequire("2AsQc");

var $fG7fH = parcelRequire("fG7fH");

var $kWskg = parcelRequire("kWskg");

var $dvixL = parcelRequire("dvixL");
const $129695694b5bcebf$var$PROMISE_MAP = {};
const $129695694b5bcebf$var$COOKIE_ENABLED_MAP = {};
const $129695694b5bcebf$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($129695694b5bcebf$var$DISABLED_MAP[sdkKey]) return null;
        if ($129695694b5bcebf$var$PROMISE_MAP[sdkKey] != null) return $129695694b5bcebf$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $129695694b5bcebf$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $129695694b5bcebf$var$PROMISE_MAP[sdkKey] = stableID;
            $129695694b5bcebf$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $129695694b5bcebf$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $dvixL.getUUID)();
        $129695694b5bcebf$var$_persistToStorage(stableID, sdkKey);
        $129695694b5bcebf$var$_persistToCookie(stableID, sdkKey);
        $129695694b5bcebf$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $129695694b5bcebf$var$PROMISE_MAP[sdkKey] = override;
        $129695694b5bcebf$var$_persistToStorage(override, sdkKey);
        $129695694b5bcebf$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $129695694b5bcebf$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $129695694b5bcebf$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $129695694b5bcebf$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $7on1s._getStorageKey)(sdkKey)}`;
}
function $129695694b5bcebf$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $129695694b5bcebf$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $kWskg._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $2AsQc.Log.warn("Failed to save StableID to storage");
    }
}
function $129695694b5bcebf$var$_loadFromStorage(sdkKey) {
    const storageKey = $129695694b5bcebf$var$_getStableIDStorageKey(sdkKey);
    return (0, $kWskg._getObjectFromStorage)(storageKey);
}
function $129695694b5bcebf$var$_loadFromCookie(sdkKey) {
    if (!$129695694b5bcebf$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $fG7fH._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(";");
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split("=");
        if (key === $129695694b5bcebf$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $129695694b5bcebf$var$_persistToCookie(stableID, sdkKey) {
    if (!$129695694b5bcebf$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$129695694b5bcebf$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $129695694b5bcebf$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $7on1s._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("dvixL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $9d4c8df8f8818697$var$getUUID() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1000 || 0;
    const y = "89ab"[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $9d4c8df8f8818697$var$getUUID;

});


parcelRegister("gaJI5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $rK4iv = parcelRequire("rK4iv");

var $2AsQc = parcelRequire("2AsQc");
function $bc610990f6397c10$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $2AsQc.Log.error("Failed to JSON.stringify user");
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $bc610990f6397c10$var$_normalizeUser;
function $bc610990f6397c10$var$_getFullUserHash(user) {
    return user ? (0, $rK4iv._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $bc610990f6397c10$var$_getFullUserHash;

});

parcelRegister("e7izm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $2AsQc = parcelRequire("2AsQc");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $a4701fa12c4de541$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === "object" && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $2AsQc.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $a4701fa12c4de541$var$_typedJsonParse;

});


parcelRegister("gzoJ4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("13ZQJ", function(module, exports) {
"use strict";
var $0c660c44ccbb36dd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $2AsQc = parcelRequire("2AsQc");

var $cMY7N = parcelRequire("cMY7N");

var $2MtjN = parcelRequire("2MtjN");
module.exports.EXCEPTION_ENDPOINT = "https://statsigapi.net/v1/sdk_exception";
const $0c660c44ccbb36dd$var$UNKNOWN_ERROR = "[Statsig] UnknownError";
class $0c660c44ccbb36dd$var$ErrorBoundary {
    wrap(instance) {
        try {
            const obj = instance;
            $0c660c44ccbb36dd$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ("$EB" in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError("eb:wrap", err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $0c660c44ccbb36dd$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $2AsQc.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$0c660c44ccbb36dd$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($0c660c44ccbb36dd$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : "No Name";
                    const resolvedError = $0c660c44ccbb36dd$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: "error",
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $cMY7N.SDKType._get(this._sdkKey);
                    const statsigMetadata = $2MtjN.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $0c660c44ccbb36dd$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $0c660c44ccbb36dd$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: "POST",
                        headers: {
                            "STATSIG-API-KEY": this._sdkKey,
                            "STATSIG-SDK-TYPE": String(sdkType),
                            "STATSIG-SDK-VERSION": String(statsigMetadata.sdkVersion),
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: "error",
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
module.exports.ErrorBoundary = $0c660c44ccbb36dd$var$ErrorBoundary;
function $0c660c44ccbb36dd$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === "string") return new Error(error);
    else return new Error("An unknown error occurred.");
}
function $0c660c44ccbb36dd$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $0c660c44ccbb36dd$var$UNKNOWN_ERROR;
    }
}
function $0c660c44ccbb36dd$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === "function").forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $0c660c44ccbb36dd$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case "number":
            case "bigint":
            case "boolean":
                loggingCopy[String(option)] = value;
                break;
            case "string":
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = "set";
                break;
            case "object":
                if (option === "environment") loggingCopy["environment"] = value;
                else if (option === "networkConfig") loggingCopy["networkConfig"] = value;
                else loggingCopy[String(option)] = value != null ? "set" : "unset";
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("cMY7N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $94f89b45350a70f9$var$SDK_CLIENT = {};
let $94f89b45350a70f9$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $94f89b45350a70f9$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : "js-mono") + ($94f89b45350a70f9$var$suffix !== null && $94f89b45350a70f9$var$suffix !== void 0 ? $94f89b45350a70f9$var$suffix : "");
    },
    _setClientType (sdkKey, client) {
        $94f89b45350a70f9$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$94f89b45350a70f9$var$suffix || $94f89b45350a70f9$var$suffix === "-react") $94f89b45350a70f9$var$suffix = "-" + binding;
    }
};

});


parcelRegister("15xGS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6Ong9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("a8ic2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aVLDx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: "g",
    _dynamicConfig: "c",
    _experiment: "e",
    _configList: "cl",
    _layer: "l",
    _paramStore: "p"
};
const $7f542dec7419862b$var$EXIST_KEYS = new Set([]);
const $7f542dec7419862b$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    "userPersistedValues"
]);
function $7f542dec7419862b$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($7f542dec7419862b$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($7f542dec7419862b$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $7f542dec7419862b$var$createMemoKey;

});

parcelRegister("1G4Fb", function(module, exports) {
"use strict";
var $138d54b96c21bfc3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $l0nby = parcelRequire("l0nby");

var $l0nby = parcelRequire("l0nby");

var $dWy6I = parcelRequire("dWy6I");

var $2AsQc = parcelRequire("2AsQc");

var $i5Iju = parcelRequire("i5Iju");

var $ksQte = parcelRequire("ksQte");

var $gfsNb = parcelRequire("gfsNb");

var $cMY7N = parcelRequire("cMY7N");

var $fG7fH = parcelRequire("fG7fH");

var $zCGVF = parcelRequire("zCGVF");

var $1AWzd = parcelRequire("1AWzd");

var $2pmXG = parcelRequire("2pmXG");

var $2MtjN = parcelRequire("2MtjN");

var $6NsOg = parcelRequire("6NsOg");

var $4asVk = parcelRequire("4asVk");
const $138d54b96c21bfc3$var$DEFAULT_TIMEOUT_MS = 10000;
const $138d54b96c21bfc3$var$BACKOFF_BASE_MS = 500;
const $138d54b96c21bfc3$var$BACKOFF_MAX_MS = 30000;
const $138d54b96c21bfc3$var$RATE_LIMIT_WINDOW_MS = 1000;
const $138d54b96c21bfc3$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $138d54b96c21bfc3$var$LEAK_RATE = $138d54b96c21bfc3$var$RATE_LIMIT_MAX_REQ_COUNT / $138d54b96c21bfc3$var$RATE_LIMIT_WINDOW_MS;
const $138d54b96c21bfc3$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $138d54b96c21bfc3$var$NetworkCore {
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function";
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$138d54b96c21bfc3$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs("POST", args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $138d54b96c21bfc3$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs("POST", args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs("GET", args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $138d54b96c21bfc3$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$138d54b96c21bfc3$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $2AsQc.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== "undefined" ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $4asVk._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $138d54b96c21bfc3$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>"No Text");
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = "NetworkError";
                    throw err;
                }
                const text = yield response.text();
                $138d54b96c21bfc3$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $138d54b96c21bfc3$var$_getErrorMessage(abortController, error);
                const timedOut = $138d54b96c21bfc3$var$_didTimeout(abortController);
                $138d54b96c21bfc3$var$_tryMarkInitEnd(args, response, currentAttempt, "", error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$138d54b96c21bfc3$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: "error",
                        error: error,
                        tag: $2pmXG.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $2AsQc.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $138d54b96c21bfc3$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $6NsOg.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $6NsOg.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $138d54b96c21bfc3$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $138d54b96c21bfc3$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $i5Iju.Endpoint._initialize || args.urlConfig.endpoint === $i5Iju.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$i5Iju.NetworkParam.SdkKey]: args.sdkKey,
            [$i5Iju.NetworkParam.SdkType]: $cMY7N.SDKType._get(args.sdkKey),
            [$i5Iju.NetworkParam.SdkVersion]: $2MtjN.SDK_VERSION,
            [$i5Iju.NetworkParam.Time]: String(Date.now()),
            [$i5Iju.NetworkParam.SessionID]: $zCGVF.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join("&");
        return `${url}${query ? `?${query}` : ""}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $fG7fH._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== "string" || (0, $l0nby._getStatsigGlobalFlag)("no-encode") != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split("").reverse().join("");
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$i5Iju.NetworkParam.StatsigEncoded]: "1"
            });
        } catch (e) {
            $2AsQc.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $138d54b96c21bfc3$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== "string" || !$138d54b96c21bfc3$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream("gzip");
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($2AsQc.Log.error);
                writer.close().catch($2AsQc.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$i5Iju.NetworkParam.IsGzipped]: "1"
                });
            } catch (e) {
                $2AsQc.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ("data" in args) $138d54b96c21bfc3$var$_populateRequestBody(result, args.data);
        return result;
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $138d54b96c21bfc3$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $ksQte.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
}
module.exports.NetworkCore = $138d54b96c21bfc3$var$NetworkCore;
const $138d54b96c21bfc3$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $2AsQc.Log.warn("Unable to make request without an SDK key");
        return false;
    }
    return true;
};
const $138d54b96c21bfc3$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $1AWzd.StableID.get(sdkKey);
    const sessionID = $zCGVF.SessionID.get(sdkKey);
    const sdkType = $cMY7N.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $2MtjN.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $138d54b96c21bfc3$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $l0nby._getStatsigGlobalFlag)("no-compress") != null || typeof CompressionStream === "undefined" || typeof TextEncoder === "undefined") return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $gfsNb.SDKFlags.get(args.sdkKey, "enable_log_event_compression") === true;
    switch(options.logEventCompressionMode){
        case $6NsOg.LogEventCompressionMode.Disabled:
            return false;
        case $6NsOg.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $6NsOg.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $138d54b96c21bfc3$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === "string") return controller.signal.reason;
    if (typeof error === "string") return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return "Unknown Error";
}
function $138d54b96c21bfc3$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === "string" && controller.signal.reason.includes("Timeout");
    return timeout || false;
}
function $138d54b96c21bfc3$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $i5Iju.Endpoint._initialize) return;
    $dWy6I.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $138d54b96c21bfc3$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $i5Iju.Endpoint._initialize) return;
    $dWy6I.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $dWy6I.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $138d54b96c21bfc3$var$_exponentialBackoff(attempt) {
    return $138d54b96c21bfc3$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($138d54b96c21bfc3$var$BACKOFF_BASE_MS * (attempt * attempt), $138d54b96c21bfc3$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("ksQte", function(module, exports) {
"use strict";
var $ee5f1fbdcf4b3f9a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $kOVQF = parcelRequire("kOVQF");

var $rK4iv = parcelRequire("rK4iv");

var $2AsQc = parcelRequire("2AsQc");

var $kWskg = parcelRequire("kWskg");
const $ee5f1fbdcf4b3f9a$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $ee5f1fbdcf4b3f9a$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $ee5f1fbdcf4b3f9a$var$NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $ee5f1fbdcf4b3f9a$var$DEFAULT_TTL_MS;
        $ee5f1fbdcf4b3f9a$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $ee5f1fbdcf4b3f9a$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $ee5f1fbdcf4b3f9a$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $ee5f1fbdcf4b3f9a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$ee5f1fbdcf4b3f9a$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError("tryFetchUpdatedFallbackInfo", error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $ee5f1fbdcf4b3f9a$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $ee5f1fbdcf4b3f9a$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $ee5f1fbdcf4b3f9a$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $ee5f1fbdcf4b3f9a$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $kOVQF._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $ee5f1fbdcf4b3f9a$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + "=")) continue;
                const parts = record.split("=");
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith("/")) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith("/") ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
module.exports.NetworkFallbackResolver = $ee5f1fbdcf4b3f9a$var$NetworkFallbackResolver;
function $ee5f1fbdcf4b3f9a$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : "";
    return timedOut || lowerErrorMsg.includes("uncaught exception") || lowerErrorMsg.includes("failed to fetch") || lowerErrorMsg.includes("networkerror when attempting to fetch resource");
}
module.exports._isDomainFailure = $ee5f1fbdcf4b3f9a$var$_isDomainFailure;
function $ee5f1fbdcf4b3f9a$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $rK4iv._DJB2)(sdkKey)}`;
}
function $ee5f1fbdcf4b3f9a$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $ee5f1fbdcf4b3f9a$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $kWskg.Storage.removeItem(hashKey);
        return;
    }
    $kWskg.Storage.setItem(hashKey, JSON.stringify(info));
}
function $ee5f1fbdcf4b3f9a$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $ee5f1fbdcf4b3f9a$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $kWskg.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $2AsQc.Log.error("Failed to parse FallbackInfo");
        return null;
    }
}
function $ee5f1fbdcf4b3f9a$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("kOVQF", function(module, exports) {
"use strict";
var $f28559ad9d219083$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $f28559ad9d219083$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $f28559ad9d219083$var$DNS_QUERY_ENDPOINT = "https://cloudflare-dns.com/dns-query";
const $f28559ad9d219083$var$DOMAIN_CHARS = [
    "i",
    "e",
    "d"
];
const $f28559ad9d219083$var$MAX_START_LOOKUP = 200;
function $f28559ad9d219083$var$_fetchTxtRecords(networkFunc) {
    return $f28559ad9d219083$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($f28559ad9d219083$var$DNS_QUERY_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/dns-message",
                Accept: "application/dns-message"
            },
            body: $f28559ad9d219083$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error("Failed to fetch TXT records from DNS");
            err.name = "DnsTxtFetchError";
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $f28559ad9d219083$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $f28559ad9d219083$var$_fetchTxtRecords;
function $f28559ad9d219083$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $f28559ad9d219083$var$MAX_START_LOOKUP && String.fromCharCode(byte) === "=" && $f28559ad9d219083$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error("Failed to parse TXT records from DNS");
        err.name = "DnsTxtParseError";
        throw err;
    }
    // decode the remaining bytes as a string
    let result = "";
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(",");
}

});


parcelRegister("gfsNb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $bd44619bd902f9b3$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $bd44619bd902f9b3$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $bd44619bd902f9b3$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("zCGVF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $l0nby = parcelRequire("l0nby");

var $7on1s = parcelRequire("7on1s");

var $2AsQc = parcelRequire("2AsQc");

var $kWskg = parcelRequire("kWskg");

var $dvixL = parcelRequire("dvixL");
const $06b1484e5166d8cd$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $06b1484e5166d8cd$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $06b1484e5166d8cd$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($06b1484e5166d8cd$var$PROMISE_MAP[sdkKey] == null) $06b1484e5166d8cd$var$PROMISE_MAP[sdkKey] = $06b1484e5166d8cd$var$_loadSession(sdkKey);
        const session = $06b1484e5166d8cd$var$PROMISE_MAP[sdkKey];
        return $06b1484e5166d8cd$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $06b1484e5166d8cd$var$PROMISE_MAP[sdkKey] = $06b1484e5166d8cd$var$_overrideSessionId(override, sdkKey);
    }
};
function $06b1484e5166d8cd$var$_loadSession(sdkKey) {
    let data = $06b1484e5166d8cd$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $dvixL.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $06b1484e5166d8cd$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $06b1484e5166d8cd$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($06b1484e5166d8cd$var$_isIdle(data) || $06b1484e5166d8cd$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $dvixL.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }
    data.lastUpdate = now;
    $06b1484e5166d8cd$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $06b1484e5166d8cd$var$_createSessionTimeout(sdkKey, $06b1484e5166d8cd$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $06b1484e5166d8cd$var$_createSessionTimeout(sdkKey, $06b1484e5166d8cd$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $06b1484e5166d8cd$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $l0nby._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }, duration);
}
function $06b1484e5166d8cd$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $06b1484e5166d8cd$var$MAX_SESSION_IDLE_TIME;
}
function $06b1484e5166d8cd$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $06b1484e5166d8cd$var$MAX_SESSION_AGE;
}
function $06b1484e5166d8cd$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $7on1s._getStorageKey)(sdkKey)}`;
}
function $06b1484e5166d8cd$var$_persistToStorage(session, sdkKey) {
    const storageKey = $06b1484e5166d8cd$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $kWskg._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $2AsQc.Log.warn("Failed to save SessionID");
    }
}
function $06b1484e5166d8cd$var$_loadFromStorage(sdkKey) {
    const storageKey = $06b1484e5166d8cd$var$_getSessionIDStorageKey(sdkKey);
    return (0, $kWskg._getObjectFromStorage)(storageKey);
}

});

parcelRegister("2pmXG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: "NetworkError"
};

});


parcelRegister("3a2r6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lJpY0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jXArS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $e87fccf3b88a7165$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $e87fccf3b88a7165$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $e87fccf3b88a7165$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === "object" && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $e87fccf3b88a7165$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $e87fccf3b88a7165$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $e87fccf3b88a7165$var$_fastApproxSizeOf;

});

parcelRegister("hvzXn", function(module, exports) {
"use strict";
var $cbf13930cbbcba7c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $l0nby = parcelRequire("l0nby");

var $l0nby = parcelRequire("l0nby");

var $13ZQJ = parcelRequire("13ZQJ");

var $c9hY4 = parcelRequire("c9hY4");

var $2AsQc = parcelRequire("2AsQc");

var $aVLDx = parcelRequire("aVLDx");

var $fG7fH = parcelRequire("fG7fH");

var $zCGVF = parcelRequire("zCGVF");

var $1AWzd = parcelRequire("1AWzd");

var $6NsOg = parcelRequire("6NsOg");

var $kWskg = parcelRequire("kWskg");
const $cbf13930cbbcba7c$var$MAX_MEMO_CACHE_SIZE = 3000;
class $cbf13930cbbcba7c$var$StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? "disabled" : "browser-only");
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $kWskg.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $1AWzd.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($6NsOg.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $cbf13930cbbcba7c$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: "pre_shutdown"
            });
            this._setStatus("Uninitialized", null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $2AsQc.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners["*"]) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: "values_updated",
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $aVLDx.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $cbf13930cbbcba7c$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = "Uninitialized";
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($2AsQc.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $kWskg.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $zCGVF.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $kWskg.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $1AWzd.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $1AWzd.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $c9hY4.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $13ZQJ.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $kWskg.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError("OA::loadFromStorage", e));
        this._primeReadyRipcord();
        $cbf13930cbbcba7c$var$_assignGlobalInstance(sdkKey, this);
    }
}
module.exports.StatsigClientBase = $cbf13930cbbcba7c$var$StatsigClientBase;
function $cbf13930cbbcba7c$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $fG7fH._isServerEnv)()) return;
    const statsigGlobal = (0, $l0nby._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $2AsQc.Log.warn("Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.");
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("efzGd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = "statsig.cached";

});

parcelRegister("6ufXv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("339yS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $2AsQc = parcelRequire("2AsQc");

var $cUpr9 = parcelRequire("cUpr9");
function $2389119dc5498223$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : "",
        __evaluation: evaluation,
        value: value
    };
}
function $2389119dc5498223$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $2389119dc5498223$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $2389119dc5498223$var$_makeFeatureGate;
function $2389119dc5498223$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $2389119dc5498223$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $2389119dc5498223$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $2389119dc5498223$var$_makeDynamicConfig;
function $2389119dc5498223$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $2389119dc5498223$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $2389119dc5498223$var$_makeExperiment;
function $2389119dc5498223$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $2389119dc5498223$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $2389119dc5498223$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $2389119dc5498223$var$_makeLayer;
function $2389119dc5498223$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $2389119dc5498223$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $2389119dc5498223$var$_mergeOverride;
function $2389119dc5498223$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $cUpr9._isTypeMatch)(found, fallback)) {
            $2AsQc.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $2389119dc5498223$var$_makeTypedGet;

});

parcelRegister("fTxwE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1y5iW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $120d14c74671d0e7$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $120d14c74671d0e7$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: "No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error."
};

});


parcelRegister("dmmnC", function(module, exports) {
"use strict";
var $9b9eb0a455fe51dd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iNYlF = parcelRequire("iNYlF");

var $8KXg7 = parcelRequire("8KXg7");

var $fvtFX = parcelRequire("fvtFX");

var $4knYa = parcelRequire("4knYa");

var $6fX6r = parcelRequire("6fX6r");
class $9b9eb0a455fe51dd$var$StatsigClient extends $iNYlF.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $iNYlF._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $9b9eb0a455fe51dd$var$StatsigClient) return instance;
        $iNYlF.Log.warn((0, $iNYlF._isServerEnv)() ? "StatsigClient.instance is not supported in server environments" : "Unable to find StatsigClient instance");
        return new $9b9eb0a455fe51dd$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "", {});
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== "Uninitialized") return (0, $iNYlF.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            "MultipleInitializations",
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $9b9eb0a455fe51dd$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push("NoCachedValues");
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === "Bootstrap") return (0, $iNYlF.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $iNYlF.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $9b9eb0a455fe51dd$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $9b9eb0a455fe51dd$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $iNYlF.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus("Loading", result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $iNYlF.createUpdateDetails)(false, this._store.getSource(), -1, new Error("User changed during update"), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $iNYlF.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $iNYlF.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($iNYlF.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: "initialization_failure"
                });
            }
            $iNYlF.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $iNYlF.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $iNYlF.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $iNYlF.StatsigSession.get(this._sdkKey),
            stableID: $iNYlF.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === "string" ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: "log_event_called",
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on("error", ()=>{
            this.loadingStatus === "Loading" && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $9b9eb0a455fe51dd$var$__awaiter(this, void 0, void 0, function*() {
            if (!$iNYlF.Storage.isReady()) yield $iNYlF.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $iNYlF.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus("Ready", values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: "low"
        }).catch((err)=>{
            $iNYlF.Log.error("An error occurred after update.", err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $iNYlF._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $iNYlF.StableID.setOverride(stableIdOverride, this._sdkKey);
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $iNYlF._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $iNYlF._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "gate_evaluation",
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $iNYlF._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $iNYlF._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "dynamic_config_evaluation",
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $iNYlF._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $iNYlF._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $iNYlF._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "experiment_evaluation",
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $iNYlF._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $iNYlF._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $iNYlF._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: "layer_evaluation",
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $4knYa._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $4knYa._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $iNYlF.SDKType._setClientType(sdkKey, "javascript-client");
        const network = new $fvtFX.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $6fX6r.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($iNYlF.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($iNYlF.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($iNYlF.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($iNYlF.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($iNYlF.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($iNYlF.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $8KXg7.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $iNYlF.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
}
module.exports.default = $9b9eb0a455fe51dd$var$StatsigClient;

});
parcelRegister("8KXg7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iNYlF = parcelRequire("iNYlF");
class $66009635a814ecde$var$EvaluationStore {
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = "Loading";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = "NoValues";
    }
    getValues() {
        return this._rawValues ? (0, $iNYlF._typedJsonParse)(this._rawValues, "has_updates", "EvaluationStoreValues") : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $iNYlF._typedJsonParse)(result.data, "has_updates", "EvaluationResponse");
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $iNYlF.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getConfigList() {
        var _a;
        if (!((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs)) return [];
        return Object.values(this._values.dynamic_configs).map((config)=>config.name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== "Bootstrap") return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $iNYlF._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $iNYlF.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add("StableIDMismatch");
            return;
        }
        if ("user" in values) {
            const bootstrapUser = values["user"];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $iNYlF._getFullUserHash)(userForComparison) !== (0, $iNYlF._getFullUserHash)(bootstrapUser)) this._warnings.add("PartialUserMatch");
        }
    }
    getCurrentSourceDetails() {
        if (this._source === "Uninitialized" || this._source === "NoValues") return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === "Bootstrap" && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== "Uninitialized" && reason !== "NoValues") {
            const subreason = isUnrecognized ? "Unrecognized" : "Recognized";
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === "Bootstrap" ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = "Uninitialized";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
}
module.exports.default = $66009635a814ecde$var$EvaluationStore;

});

parcelRegister("fvtFX", function(module, exports) {
"use strict";
var $b4a0c542cd60a00f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iNYlF = parcelRequire("iNYlF");

var $kxWb9 = parcelRequire("kxWb9");
class $b4a0c542cd60a00f$var$StatsigNetwork extends $iNYlF.NetworkCore {
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $b4a0c542cd60a00f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $iNYlF._typedJsonParse)(current, "has_updates", "InitializeResponse") : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : "djb2",
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : "djb2");
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: "derived_fields" in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $b4a0c542cd60a00f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $kxWb9._resolveDeltasResponse)(cache, response.body);
            if (typeof result === "string") return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $iNYlF.UrlConfiguration($iNYlF.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
}
module.exports.default = $b4a0c542cd60a00f$var$StatsigNetwork;

});
parcelRegister("kxWb9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $iNYlF = parcelRequire("iNYlF");
const $ef5404ccbdc0f18d$var$MAX_DELTAS_SORT_DEPTH = 2;
function $ef5404ccbdc0f18d$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $iNYlF._typedJsonParse)(deltasString, "checksum", "DeltasEvaluationResponse");
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $ef5404ccbdc0f18d$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $ef5404ccbdc0f18d$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $iNYlF._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $ef5404ccbdc0f18d$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $ef5404ccbdc0f18d$var$_resolveDeltasResponse;
function $ef5404ccbdc0f18d$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $ef5404ccbdc0f18d$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $ef5404ccbdc0f18d$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $ef5404ccbdc0f18d$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $ef5404ccbdc0f18d$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $ef5404ccbdc0f18d$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("4knYa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $iNYlF = parcelRequire("iNYlF");
const $326b9f874dded7a1$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $326b9f874dded7a1$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $326b9f874dded7a1$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $iNYlF._isTypeMatch)(value, fallback);
}
function $326b9f874dded7a1$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $326b9f874dded7a1$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $326b9f874dded7a1$var$_shouldLogExposure(options) ? undefined : $326b9f874dded7a1$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $326b9f874dded7a1$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $326b9f874dded7a1$var$_shouldLogExposure(options) ? undefined : $326b9f874dded7a1$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($326b9f874dded7a1$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $326b9f874dded7a1$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $326b9f874dded7a1$var$_shouldLogExposure(options) ? undefined : $326b9f874dded7a1$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($326b9f874dded7a1$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $326b9f874dded7a1$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $326b9f874dded7a1$var$_shouldLogExposure(options) ? undefined : $326b9f874dded7a1$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($326b9f874dded7a1$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $326b9f874dded7a1$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $iNYlF._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case "static":
                return $326b9f874dded7a1$var$_getMappedStaticValue(param, options);
            case "gate":
                return $326b9f874dded7a1$var$_getMappedGateValue(client, param, options);
            case "dynamic_config":
                return $326b9f874dded7a1$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case "experiment":
                return $326b9f874dded7a1$var$_getMappedExperimentValue(client, param, fallback, options);
            case "layer":
                return $326b9f874dded7a1$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $326b9f874dded7a1$var$_makeParamStoreGetter;

});

parcelRegister("6fX6r", function(module, exports) {
"use strict";
var $48e1fd650a5404f4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $iNYlF = parcelRequire("iNYlF");

var $fvtFX = parcelRequire("fvtFX");
class $48e1fd650a5404f4$var$StatsigEvaluationsDataAdapter extends $iNYlF.DataAdapterCore {
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $fvtFX.default) this._network = network;
        else this._network = new $fvtFX.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $iNYlF._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $iNYlF._typedJsonParse)(data, "has_updates", "data");
        if (values && "user" in values) super.setData(data, values.user);
        else $iNYlF.Log.error("StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.");
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $48e1fd650a5404f4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $iNYlF._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$iNYlF.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $iNYlF._getFullUserHash)(user);
    }
    constructor(){
        super("EvaluationsDataAdapter", "evaluations");
        this._network = null;
        this._options = null;
    }
}
module.exports.StatsigEvaluationsDataAdapter = $48e1fd650a5404f4$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("6SGHN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5028e9a472f5ecb6$export$2e2bcd8739ae039; });

var $iyxmX = parcelRequire("iyxmX");

var $foAXX = parcelRequire("foAXX");

var $e7oBD = parcelRequire("e7oBD");

var $kZv7b = parcelRequire("kZv7b");
function $5028e9a472f5ecb6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5028e9a472f5ecb6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5028e9a472f5ecb6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e7oBD.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5028e9a472f5ecb6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5028e9a472f5ecb6$export$a66cbd9b2289cd78 = "@all-features";
var $5028e9a472f5ecb6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $iyxmX.default)(this, Subscriptions);
        (0, $e7oBD.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($kZv7b)))();
    }
    return (0, $foAXX.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $5028e9a472f5ecb6$var$_objectSpread($5028e9a472f5ecb6$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $5028e9a472f5ecb6$var$_objectSpread($5028e9a472f5ecb6$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $5028e9a472f5ecb6$var$_objectSpread($5028e9a472f5ecb6$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $5028e9a472f5ecb6$var$_objectSpread($5028e9a472f5ecb6$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($5028e9a472f5ecb6$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($5028e9a472f5ecb6$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($5028e9a472f5ecb6$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $5028e9a472f5ecb6$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("3c2PL", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", function () { return $2534b0d292784bbf$export$6dc24881a3d96325; });

var $8afK4 = parcelRequire("8afK4");

var $iyxmX = parcelRequire("iyxmX");

var $foAXX = parcelRequire("foAXX");

var $cPxTg = parcelRequire("cPxTg");
var $2534b0d292784bbf$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $iyxmX.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $foAXX.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? "array" : (0, $8afK4.default)(defaultValue);
                var actualType = Array.isArray(val) ? "array" : (0, $8afK4.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $cPxTg.migrateEvaluationDetails)(experiment.details), (0, $cPxTg.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("cPxTg", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $9574895f8572f2e5$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $9574895f8572f2e5$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $9574895f8572f2e5$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $9574895f8572f2e5$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $9574895f8572f2e5$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $9574895f8572f2e5$export$55fd683752d01e67; });

var $1151q = parcelRequire("1151q");

var $iKZ8Y = parcelRequire("iKZ8Y");

var $e7oBD = parcelRequire("e7oBD");

var $46ZMu = parcelRequire("46ZMu");

var $iA3OF = parcelRequire("iA3OF");

var $kzVmY = parcelRequire("kzVmY");
var $9574895f8572f2e5$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $9574895f8572f2e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9574895f8572f2e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9574895f8572f2e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e7oBD.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9574895f8572f2e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9574895f8572f2e5$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $9574895f8572f2e5$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $46ZMu.isFedRamp)() ? (0, $kzVmY.PerimeterType).FEDRAMP_MODERATE : (0, $kzVmY.PerimeterType).COMMERCIAL
    }, options);
};
var $9574895f8572f2e5$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $iKZ8Y.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $iKZ8Y.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $iKZ8Y.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $iKZ8Y.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $9574895f8572f2e5$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $9574895f8572f2e5$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $1151q.default)(options, $9574895f8572f2e5$var$_excluded);
    return $9574895f8572f2e5$var$_objectSpread($9574895f8572f2e5$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + "rgstr" : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === "undefined"
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $9574895f8572f2e5$var$evaluationReasonMappings = Object.entries((0, $iA3OF.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $iKZ8Y.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $9574895f8572f2e5$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $9574895f8572f2e5$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $iKZ8Y.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $iA3OF.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $9574895f8572f2e5$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === "string") // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("46ZMu", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $2fe7a56b5dd7e476$export$64d6499adf9b2e51; });

var $515WF = parcelRequire("515WF");
function $2fe7a56b5dd7e476$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $515WF.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("515WF", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $3a71a85ac0862d45$export$ce553301d55c2fd8; });
var $3a71a85ac0862d45$export$ce553301d55c2fd8 = "fedramp-moderate";
var $3a71a85ac0862d45$export$f005e2e9f707cb5f = "commercial";
var $3a71a85ac0862d45$export$bd6b5a7802d76127 = "fedramp-fedex";
var $3a71a85ac0862d45$export$a739cd5aac835909 = "stg";
var $3a71a85ac0862d45$export$42dd0cdd351a4a9 = "prod";
var $3a71a85ac0862d45$export$404582bc18fe4d9e = "dev";

});


parcelRegister("iA3OF", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", function () { return $d86e8c95f4cad590$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $d86e8c95f4cad590$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("kzVmY", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $efb393f1da966bd4$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $efb393f1da966bd4$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $efb393f1da966bd4$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $efb393f1da966bd4$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $efb393f1da966bd4$export$42f4885608027d0c = "non_boolean"; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("lid87", function(module, exports) {

$parcel$export(module.exports, "Layer", function () { return $f80576bf42ed8b43$export$936d0764594b6eb3; });

var $8afK4 = parcelRequire("8afK4");

var $iyxmX = parcelRequire("iyxmX");

var $foAXX = parcelRequire("foAXX");

var $cPxTg = parcelRequire("cPxTg");
var $f80576bf42ed8b43$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $iyxmX.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $foAXX.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $8afK4.default)(val) === (0, $8afK4.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $cPxTg.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $cPxTg.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $cPxTg.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("7KL9J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a51687f20630fb2$export$2e2bcd8739ae039; });

var $e7oBD = parcelRequire("e7oBD");

var $3OzAF = parcelRequire("3OzAF");

var $iyxmX = parcelRequire("iyxmX");

var $foAXX = parcelRequire("foAXX");

var $8qNJA = parcelRequire("8qNJA");

var $kzVmY = parcelRequire("kzVmY");

var $1LEhT = parcelRequire("1LEhT");

var $dx4L2 = parcelRequire("dx4L2");
function $5a51687f20630fb2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5a51687f20630fb2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5a51687f20630fb2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e7oBD.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5a51687f20630fb2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5a51687f20630fb2$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $5a51687f20630fb2$export$250a58ecde616daa = "https://api.atlassian.com/flags";
var $5a51687f20630fb2$export$942ba04389b0d5a2 = "https://api.stg.atlassian.com/flags";
var $5a51687f20630fb2$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $5a51687f20630fb2$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $5a51687f20630fb2$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $5a51687f20630fb2$export$4e8a0415edbfa1f7 = "https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net";
var $5a51687f20630fb2$export$cb3cd156f70d7e94 = "oasis-stg.com/flags";
var $5a51687f20630fb2$export$921fbc6cdfd4eee0 = "atlassian-isolated.net/flags";
var $5a51687f20630fb2$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $5a51687f20630fb2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $iyxmX.default)(this, Fetcher);
    }
    return (0, $foAXX.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $dx4L2.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $dx4L2.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $5a51687f20630fb2$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $kzVmY.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $kzVmY.FeatureGateEnvironment).Production:
                        return $5a51687f20630fb2$export$18c93900db9358a4;
                    case (0, $kzVmY.FeatureGateEnvironment).Staging:
                        return $5a51687f20630fb2$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $kzVmY.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $kzVmY.FeatureGateEnvironment).Development:
                        return $5a51687f20630fb2$export$f058dbf75c3bc647;
                    case (0, $kzVmY.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $5a51687f20630fb2$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $5a51687f20630fb2$export$250a58ecde616daa;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $5a51687f20630fb2$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $5a51687f20630fb2$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $1LEhT.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $5a51687f20630fb2$export$4e8a0415edbfa1f7.replace("%s", isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($5a51687f20630fb2$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($5a51687f20630fb2$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== "undefined" && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("1LEhT", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $14996e7fae7b4444$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $14996e7fae7b4444$export$a59f8d67326bd1cb = "5.5.3";

});

parcelRegister("dx4L2", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $9da20c2edf91cc8f$export$286baf652d0b1206; });

var $foAXX = parcelRequire("foAXX");

var $iyxmX = parcelRequire("iyxmX");

var $8eNG1 = parcelRequire("8eNG1");

var $hPSHi = parcelRequire("hPSHi");

var $aglwT = parcelRequire("aglwT");

var $ec0tJ = parcelRequire("ec0tJ");
function $9da20c2edf91cc8f$var$_callSuper(t, o, e) {
    return o = (0, $hPSHi.default)(o), (0, $8eNG1.default)(t, $9da20c2edf91cc8f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hPSHi.default)(t).constructor) : o.apply(t, e));
}
function $9da20c2edf91cc8f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9da20c2edf91cc8f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $9da20c2edf91cc8f$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $iyxmX.default)(this, ResponseError);
        return $9da20c2edf91cc8f$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $aglwT.default)(ResponseError, _Error);
    return (0, $foAXX.default)(ResponseError);
}(/*#__PURE__*/ (0, $ec0tJ.default)(Error));

});
parcelRegister("8eNG1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ff62a54754e55c0$export$2e2bcd8739ae039; });

var $8afK4 = parcelRequire("8afK4");

var $15QEX = parcelRequire("15QEX");
function $5ff62a54754e55c0$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $8afK4.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $15QEX.default)(t);
}

});
parcelRegister("15QEX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cbf1b2af5eba991$export$2e2bcd8739ae039; });
function $0cbf1b2af5eba991$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("hPSHi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfc1a0d14fcf4f1b$export$2e2bcd8739ae039; });
function $cfc1a0d14fcf4f1b$export$2e2bcd8739ae039(t) {
    return $cfc1a0d14fcf4f1b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $cfc1a0d14fcf4f1b$export$2e2bcd8739ae039(t);
}

});

parcelRegister("aglwT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $778c1957fd72837c$export$2e2bcd8739ae039; });

var $aSAQS = parcelRequire("aSAQS");
function $778c1957fd72837c$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $aSAQS.default)(t, e);
}

});
parcelRegister("aSAQS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ebb888d557154d0$export$2e2bcd8739ae039; });
function $7ebb888d557154d0$export$2e2bcd8739ae039(t, e) {
    return $7ebb888d557154d0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7ebb888d557154d0$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("ec0tJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5528eb08b80e876$export$2e2bcd8739ae039; });

var $hPSHi = parcelRequire("hPSHi");

var $aSAQS = parcelRequire("aSAQS");

var $9F7pp = parcelRequire("9F7pp");

var $f5vFV = parcelRequire("f5vFV");
function $a5528eb08b80e876$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $a5528eb08b80e876$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $9F7pp.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $f5vFV.default)(t, arguments, (0, $hPSHi.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $aSAQS.default)(Wrapper, t);
    }, $a5528eb08b80e876$export$2e2bcd8739ae039(t);
}

});
parcelRegister("9F7pp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $708db0a49cda56e1$export$2e2bcd8739ae039; });
function $708db0a49cda56e1$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("f5vFV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afbfe4b23ec335aa$export$2e2bcd8739ae039; });

var $VgSRf = parcelRequire("VgSRf");

var $aSAQS = parcelRequire("aSAQS");
function $afbfe4b23ec335aa$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $VgSRf.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $aSAQS.default)(p, r.prototype), p;
}

});
parcelRegister("VgSRf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ac26bc1e8d74e7f$export$2e2bcd8739ae039; });
function $0ac26bc1e8d74e7f$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0ac26bc1e8d74e7f$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("8Mh0h", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $663ffef6ca088ed5$export$55fffef3474104af; });

var $3OzAF = parcelRequire("3OzAF");

var $iyxmX = parcelRequire("iyxmX");

var $foAXX = parcelRequire("foAXX");

var $8eNG1 = parcelRequire("8eNG1");

var $hPSHi = parcelRequire("hPSHi");

var $apyVo = parcelRequire("apyVo");

var $aglwT = parcelRequire("aglwT");

var $e7oBD = parcelRequire("e7oBD");

var $8qNJA = parcelRequire("8qNJA");

var $63U7U = parcelRequire("63U7U");
function $663ffef6ca088ed5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $663ffef6ca088ed5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $663ffef6ca088ed5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e7oBD.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $663ffef6ca088ed5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $663ffef6ca088ed5$var$_callSuper(t, o, e) {
    return o = (0, $hPSHi.default)(o), (0, $8eNG1.default)(t, $663ffef6ca088ed5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hPSHi.default)(t).constructor) : o.apply(t, e));
}
function $663ffef6ca088ed5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($663ffef6ca088ed5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $663ffef6ca088ed5$var$_superPropGet(t, o, e, r) {
    var p = (0, $apyVo.default)((0, $hPSHi.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $663ffef6ca088ed5$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $iyxmX.default)(this, NoFetchDataAdapter);
        _this = $663ffef6ca088ed5$var$_callSuper(this, NoFetchDataAdapter, [
            "NoFetchDataAdapter",
            "nofetch"
        ]);
        (0, $e7oBD.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $aglwT.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $foAXX.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: "Bootstrap",
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $63U7U.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $663ffef6ca088ed5$var$_objectSpread($663ffef6ca088ed5$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $63U7U._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $663ffef6ca088ed5$var$_objectSpread($663ffef6ca088ed5$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $63U7U._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $3OzAF.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8qNJA))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $63U7U._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $63U7U.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $663ffef6ca088ed5$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $663ffef6ca088ed5$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $63U7U.DataAdapterCore));

});
parcelRegister("apyVo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7947547e516826c9$export$2e2bcd8739ae039; });

var $03aTf = parcelRequire("03aTf");
function $7947547e516826c9$export$2e2bcd8739ae039() {
    return $7947547e516826c9$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $03aTf.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $7947547e516826c9$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("03aTf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0098ba76216ff832$export$2e2bcd8739ae039; });

var $hPSHi = parcelRequire("hPSHi");
function $0098ba76216ff832$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $hPSHi.default)(t)););
    return t;
}

});



parcelRegister("af3Uh", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $774e55e4378935fa$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $774e55e4378935fa$export$bcb28fbac1def494; });

var $e7oBD = parcelRequire("e7oBD");

var $iKZ8Y = parcelRequire("iKZ8Y");

var $iyxmX = parcelRequire("iyxmX");

var $foAXX = parcelRequire("foAXX");

var $iNYlF = parcelRequire("iNYlF");
function $774e55e4378935fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $774e55e4378935fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $774e55e4378935fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e7oBD.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $774e55e4378935fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $774e55e4378935fa$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $774e55e4378935fa$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $774e55e4378935fa$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $774e55e4378935fa$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $774e55e4378935fa$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $774e55e4378935fa$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $774e55e4378935fa$var$LOCAL_OVERRIDE_REASON = "LocalOverride:Recognized";
var $774e55e4378935fa$export$d8474cff104280f3 = "STATSIG_OVERRIDES";
var $774e55e4378935fa$var$LEGACY_LOCAL_STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
var $774e55e4378935fa$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $774e55e4378935fa$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ":" + hash;
};
var $774e55e4378935fa$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $iyxmX.default)(this, PersistentOverrideAdapter);
        this._overrides = $774e55e4378935fa$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $foAXX.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $774e55e4378935fa$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $774e55e4378935fa$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $774e55e4378935fa$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $iKZ8Y.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $iKZ8Y.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $iKZ8Y.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($774e55e4378935fa$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($774e55e4378935fa$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $774e55e4378935fa$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $iNYlF._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $774e55e4378935fa$var$_objectSpread($774e55e4378935fa$var$_objectSpread({}, $774e55e4378935fa$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $iKZ8Y.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $iKZ8Y.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($774e55e4378935fa$var$djb2MapKey((0, $iNYlF._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($774e55e4378935fa$var$djb2MapKey((0, $iNYlF._DJB2)(name), "gates"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($774e55e4378935fa$var$djb2MapKey((0, $iNYlF._DJB2)(name), "gates"));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($774e55e4378935fa$var$djb2MapKey(current.name, "gates"));
                if (overridden == null) return null;
                return $774e55e4378935fa$var$_objectSpread($774e55e4378935fa$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $774e55e4378935fa$var$_objectSpread($774e55e4378935fa$var$_objectSpread({}, current.details), {}, {
                        reason: $774e55e4378935fa$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($774e55e4378935fa$var$djb2MapKey((0, $iNYlF._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($774e55e4378935fa$var$djb2MapKey((0, $iNYlF._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($774e55e4378935fa$var$djb2MapKey((0, $iNYlF._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($774e55e4378935fa$var$djb2MapKey((0, $iNYlF._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($774e55e4378935fa$var$djb2MapKey((0, $iNYlF._DJB2)(name), "layers"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($774e55e4378935fa$var$djb2MapKey((0, $iNYlF._DJB2)(name), "layers"));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $774e55e4378935fa$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($774e55e4378935fa$var$djb2MapKey(current.name, "layers"));
                if (overridden == null) return null;
                return $774e55e4378935fa$var$_objectSpread($774e55e4378935fa$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $iNYlF._makeTypedGet)(current.name, overridden),
                    details: $774e55e4378935fa$var$_objectSpread($774e55e4378935fa$var$_objectSpread({}, current.details), {}, {
                        reason: $774e55e4378935fa$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($774e55e4378935fa$var$djb2MapKey(current.name, "configs"));
                if (overridden == null) return null;
                return $774e55e4378935fa$var$_objectSpread($774e55e4378935fa$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $iNYlF._makeTypedGet)(current.name, overridden),
                    details: $774e55e4378935fa$var$_objectSpread($774e55e4378935fa$var$_objectSpread({}, current.details), {}, {
                        reason: $774e55e4378935fa$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("4hj8T", function(module, exports) {

$parcel$export(module.exports, "_overrides", function () { return $31d79943015ee14f$export$e5d73bf4f8e2ae96; });

var $e7oBD = parcelRequire("e7oBD");

var $iKZ8Y = parcelRequire("iKZ8Y");

var $5Akwl = parcelRequire("5Akwl");

var $d5HBq = parcelRequire("d5HBq");
function $31d79943015ee14f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $31d79943015ee14f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $31d79943015ee14f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e7oBD.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $31d79943015ee14f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $31d79943015ee14f$export$e5d73bf4f8e2ae96 = {};
var $31d79943015ee14f$export$4e849416bb5c5b52 = {};
var $31d79943015ee14f$export$cf7305fc65acbf0d;
function $31d79943015ee14f$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce(function(acc, _ref) {
            var _ref2 = (0, $iKZ8Y.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
            var config = (0, $5Akwl.editorExperimentsConfig)[key];
            if (config) acc = $31d79943015ee14f$var$_objectSpread($31d79943015ee14f$var$_objectSpread({}, acc), {}, (0, $e7oBD.default)({}, key, config.typeGuard(value) ? value : config.defaultValue));
            return acc;
        }, {});
        $31d79943015ee14f$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === "test") {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        var testOverrides = Object.fromEntries(Object.entries((0, $5Akwl.editorExperimentsConfig)).map(function(_ref3) {
            var _ref5, _ref6, _groupOverrides, _groupOverrides2;
            var _ref4 = (0, $iKZ8Y.default)(_ref3, 2), key = _ref4[0], value = _ref4[1];
            var defaultValue = typeof value.defaultValue === "boolean" ? true : value.defaultValue;
            return [
                key,
                (_ref5 = (_ref6 = (_groupOverrides = (_groupOverrides2 = groupOverrides) === null || _groupOverrides2 === void 0 ? void 0 : _groupOverrides2[key]) !== null && _groupOverrides !== void 0 ? _groupOverrides : (0, $d5HBq.testMultivariateOverrides)[key]) !== null && _ref6 !== void 0 ? _ref6 : (0, $d5HBq.testBooleanOverrides)[key]) !== null && _ref5 !== void 0 ? _ref5 : defaultValue
            ];
        }));
        $31d79943015ee14f$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $31d79943015ee14f$export$cf7305fc65acbf0d = product;
    $31d79943015ee14f$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("5Akwl", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", function () { return $41103b887a708d40$export$6cbb856f286b07ef; });
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $6c7ox = parcelRequire("6c7ox");
var $41103b887a708d40$export$6cbb856f286b07ef = {
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_reduce_noisy_steps_ncs"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    platform_editor_memoized_node_check: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_memoized_node_check"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    platform_editor_media_card_vc_wrapper_attribute: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_media_card_vc_wrapper_attribute"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_prevent_numbered_column_too_big_jira_1: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            jira: "editor_prevent_numbered_column_too_big_jira_1"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_block_control_optimise_render"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2024-08-08
    "example-boolean": (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "confluence_editor_experiment_test_new_package_boolean"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2024-08-08
    "example-multivariate": (0, $6c7ox.createMultivariateExperiment)({
        productKeys: {
            confluence: "confluence_editor_experiment_test_new_package_multivariate"
        },
        param: "variant",
        values: [
            "one",
            "two",
            "three"
        ],
        defaultValue: "one"
    }),
    // Added 2024-08-08
    "test-new-experiments-package": (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "confluence_editor_experiment_test_new_package",
            jira: "jira_editor_experiment_test_new_package"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_support_table_in_comment_exp"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_exp_lazy_node_views"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_renderer_table_sticky_scrollbar"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-05-28
    platform_editor_controls_performance_fixes: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_controls_performance_fixes"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_prevent_toolbar_layout_shifts"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_comment_on_bodied_extensions"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_advanced_layouts"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_single_column_layout"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            jira: "platform_editor_support_table_in_comment_jira"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    "platform_editor_ai-prompts-placeholder": (0, $6c7ox.createMultivariateExperiment)({
        productKeys: {
            confluence: "platform_editor_ai-prompts-placeholder"
        },
        param: "cohort",
        values: [
            "control",
            "test"
        ],
        defaultValue: "control"
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    "nested-tables-in-tables": (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_nested_tables"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_ai_unsplash_page_header"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_blockquote_in_text_formatting_menu"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_element_drag_and_drop_multiselect"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_ai_edit_response_in_preview"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $6c7ox.createMultivariateExperiment)({
        productKeys: {
            confluence: "platform_editor_controls"
        },
        param: "cohort",
        values: [
            "control",
            "variant1"
        ],
        defaultValue: "control"
    }),
    // Added 2025-08-01
    platform_editor_controls_block_controls_state_fix: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_controls_block_controls_state_fix"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_smart_link_cmd_ctrl_click: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_smart_link_cmd_ctrl_click"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $6c7ox.createMultivariateExperiment)({
        productKeys: {
            confluence: "platform_editor_insertion"
        },
        param: "cohort",
        values: [
            "control",
            "variant1"
        ],
        defaultValue: "control"
    }),
    // Added 2025-04-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_vanilla_dom/setup
    platform_editor_vanilla_dom: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_vanilla_dom"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $6c7ox.createMultivariateExperiment)({
        productKeys: {
            confluence: "platform_editor_ai_proactive_ai_nudge_parameters"
        },
        param: "cohort",
        values: [
            "control",
            "variant1"
        ],
        defaultValue: "control"
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_offline_editing_web"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $6c7ox.createMultivariateExperiment)({
        productKeys: {
            confluence: "editor_ai_inline_suggestion_date_v2"
        },
        param: "cohort",
        values: [
            "control",
            "test"
        ],
        defaultValue: "control"
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_tables_drag_and_drop"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_tables_table_selector"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_usesharedpluginstateselector"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_usesharedpluginstatewithselector: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_usesharedpluginstatewithselector"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_renderer_fix_analytics_memo_callback"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_stop_width_reflows"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-05-08
    platform_editor_core_static_emotion: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_core_static_emotion"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-06-11
    platform_editor_core_static_emotion_non_central: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_core_static_emotion_non_central"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_no_cursor_on_edit_page_init"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_debounce_portal_provider"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-14
    platform_editor_jira_advanced_code_blocks: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            jira: "platform_editor_jira_advanced_code_blocks"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    "jira-work-sync-desc-comment-summary": (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            jira: "jira-work-sync-desc-comment-summary"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-05-21
    platform_editor_nodevisibility: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_nodevisibility"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_breakout_resizing"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_ai_quickstart_command"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-05-28
    platform_editor_toolbar_rerender_optimization_exp: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_toolbar_rerender_optimization_exp"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_block_controls_perf_optimization"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_enable_single_player_step_merging"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_code_block_fold_gutter"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-06-18
    platform_editor_ai_iw_adf_streaming: (0, $6c7ox.createMultivariateExperiment)({
        productKeys: {
            confluence: "platform_editor_ai_iw_adf_streaming"
        },
        param: "cohort",
        values: [
            "control",
            "adf",
            "adf_personalisation"
        ],
        defaultValue: "control"
    }),
    // Added 2025-06-18
    platform_editor_ai_ct_sg_adf_streaming: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_ai_ct_sg_adf_streaming"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-20
    platform_editor_ai_non_iw_adf_streaming: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_ai_non_iw_adf_streaming"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_ai_remove_trivial_prompts_cc: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_ai_remove_trivial_prompts_cc"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    //Added 2025-07-25
    platform_editor_extension_styles: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_extension_styles"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-06-20
    confluence_whiteboards_quick_insert_aa: (0, $6c7ox.createMultivariateExperiment)({
        productKeys: {
            confluence: "confluence_whiteboards_quick_insert_aa"
        },
        param: "cohort",
        values: [
            "control",
            "test_blank",
            "test_diagram"
        ],
        defaultValue: "control"
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_find_and_replace_improvements"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $6c7ox.createMultivariateExperiment)({
        productKeys: {
            confluence: "confluence_whiteboards_quick_insert"
        },
        param: "cohort",
        values: [
            "control",
            "test_blank",
            "test_diagram"
        ],
        defaultValue: "control"
    }),
    // added out of order to avoid known conflict that will occur otherwise
    // Added 2025-07-11
    cc_editor_ufo_hold_table_till_resize_complete: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "cc_editor_ufo_hold_table_till_resize_complete"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_feedback_mandatory_rating"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_drag_handle_aria_label: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_drag_handle_aria_label"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_toggle_expand_on_match_found"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    platform_editor_smart_card_otp: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_smart_card_otp"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_preview_panel_responsiveness"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_preview_panel_linking_exp_conf",
            jira: "platform_editor_preview_panel_linking_exp_jira"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $6c7ox.createMultivariateExperiment)({
        productKeys: {
            confluence: "platform_hover_card_preview_panel",
            jira: "platform_hover_card_preview_panel"
        },
        param: "cohort",
        values: [
            "control",
            "test"
        ],
        defaultValue: "control"
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_block_menu"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-23
    platform_editor_renderer_breakout_fix: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_renderer_breakout_fix"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "editor_enghealth_hyperlink_toolbar_aria_values"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-011
    cc_editor_interactions_trigger_traceufointeraction: (0, $6c7ox.createMultivariateExperiment)({
        productKeys: {
            confluence: "cc_editor_interactions_trigger_traceufointeraction"
        },
        param: "cohort",
        values: [
            "control",
            "all_events",
            "only_mousedown_event"
        ],
        defaultValue: "control"
    }),
    // Added 2025-07-14
    platform_editor_add_orange_highlight_color: (0, $6c7ox.createMultivariateExperiment)({
        productKeys: {
            confluence: "platform_editor_add_orange_highlight_color"
        },
        param: "cohort",
        values: [
            "control",
            "test"
        ],
        defaultValue: "control"
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            jira: "platform_editor_toolbar_aifc",
            confluence: "platform_editor_toolbar_aifc"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    //Added 2025-08-13
    platform_editor_ai_aifc: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            jira: "platform_editor_ai_aifc_jira",
            confluence: "platform_editor_ai_aifc_confluence"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_floating_toolbar_button_aria_label"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_enghealth_table_plugin_lable_rule: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_enghealth_table_plugin_lable_rule"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-28
    platform_editor_create_link_on_blur: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            jira: "platform_editor_create_link_on_blur"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-29
    cc_comments_include_path_for_renderer_emojis: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "cc_comments_include_path_for_renderer_emojis"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_breakout_interaction_rerender"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_aifc_responsive: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_toolbar_aifc_responsive",
            jira: "platform_editor_toolbar_aifc_responsive"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_pasting_nested_table_fix: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_pasting_nested_table_fix"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 20205-07-28
    platform_editor_fix_quick_insert_consistency_exp: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_fix_quick_insert_consistency_exp"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_fix_a11y_aria_posinset_0: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_fix_a11y_aria_posinset_0"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_blocktaskitem_node"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_editor_limited_mode: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "cc_editor_limited_mode"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_support: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_native_anchor_support"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_tables_scaling_css: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_tables_scaling_css"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_august_a11y"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_synced_block"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_improve_writing_on_paste: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "cc_improve_writing_on_paste"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_locale_datepicker"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_find_replace_a11y_fixes: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_find_replace_a11y_fixes"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-19
    platform_editor_breakout_resizing_vc90_fix: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_breakout_resizing_vc90_fix"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_support_custom_components: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_toolbar_support_custom_components"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-21
    platform_editor_paste_rich_text_bugfix: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_paste_rich_text_bugfix",
            jira: "platform_editor_paste_rich_text_bugfix"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-25
    platform_editor_toolbar_aifc_template_editor: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_toolbar_aifc_template_editor"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-26
    platform_editor_toolbar_migrate_loom: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_toolbar_migrate_loom",
            jira: "platform_editor_toolbar_migrate_loom"
        },
        param: "isEnabled",
        defaultValue: false
    }),
    // Added 2025-08-26
    platform_editor_toolbar_aifc_patch_1: (0, $6c7ox.createBooleanExperiment)({
        productKeys: {
            confluence: "platform_editor_toolbar_aifc_patch_1",
            jira: "platform_editor_toolbar_aifc_patch_1"
        },
        param: "isEnabled",
        defaultValue: false
    })
};

});
parcelRegister("6c7ox", function(module, exports) {

$parcel$export(module.exports, "createBooleanExperiment", function () { return $48299984cd968299$export$456f1587c9c92021; });
$parcel$export(module.exports, "createMultivariateExperiment", function () { return $48299984cd968299$export$fb89e8a786694d1; });

var $1SJdX = parcelRequire("1SJdX");

var $e7oBD = parcelRequire("e7oBD");

var $e2pVS = parcelRequire("e2pVS");
function $48299984cd968299$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $48299984cd968299$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $48299984cd968299$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e7oBD.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $48299984cd968299$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $48299984cd968299$export$456f1587c9c92021(config) {
    return $48299984cd968299$var$_objectSpread($48299984cd968299$var$_objectSpread({}, config), {}, {
        typeGuard: (0, $e2pVS.isBoolean),
        defaultValue: config.defaultValue
    });
}
function $48299984cd968299$export$fb89e8a786694d1(config) {
    var values = config.values;
    return $48299984cd968299$var$_objectSpread($48299984cd968299$var$_objectSpread({}, config), {}, {
        values: (0, $1SJdX.default)(values),
        // Maintains the tuple
        typeGuard: (0, $e2pVS.oneOf)(config.values),
        defaultValue: config.defaultValue
    });
}

});
parcelRegister("e2pVS", function(module, exports) {

$parcel$export(module.exports, "isBoolean", function () { return $a3855e3f70007dc0$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "oneOf", function () { return $a3855e3f70007dc0$export$a9a18ae5ba42aeab; });
function $a3855e3f70007dc0$export$f9ce7b637dfbe238(value) {
    return typeof value === "boolean";
}
function $a3855e3f70007dc0$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($a3855e3f70007dc0$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
// @ts-ignore
var $a3855e3f70007dc0$var$IS_TESTING_ENV = false;

});



parcelRegister("d5HBq", function(module, exports) {

$parcel$export(module.exports, "testMultivariateOverrides", function () { return $987d908a81dca5b6$export$7e849a84a00ffd1c; });
$parcel$export(module.exports, "testBooleanOverrides", function () { return $987d908a81dca5b6$export$54960937bb713f97; });
var $987d908a81dca5b6$export$7e849a84a00ffd1c = {
    "example-multivariate": "one",
    "platform_editor_ai-prompts-placeholder": "control",
    platform_editor_ai_proactive_ai_nudge_parameters: "control",
    platform_editor_controls: "control",
    confluence_whiteboards_quick_insert_aa: "control",
    confluence_whiteboards_quick_insert: "control",
    cc_editor_interactions_trigger_traceufointeraction: "control",
    platform_editor_insertion: "control",
    editor_ai_inline_suggestion_date_v2: "control",
    platform_editor_add_orange_highlight_color: "control",
    platform_editor_ai_iw_adf_streaming: "control",
    platform_hover_card_preview_panel: "control"
};
var $987d908a81dca5b6$export$54960937bb713f97 = {
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_renderer_breakout_fix: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_memoized_node_check: false,
    platform_editor_media_card_vc_wrapper_attribute: false,
    platform_editor_block_control_optimise_render: false,
    "test-new-experiments-package": false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_controls_performance_fixes: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    "nested-tables-in-tables": false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_smart_link_cmd_ctrl_click: false,
    platform_editor_vanilla_dom: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_stop_width_reflows: false,
    platform_editor_core_static_emotion: false,
    platform_editor_core_static_emotion_non_central: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    "jira-work-sync-desc-comment-summary": false,
    platform_editor_nodevisibility: false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_toolbar_rerender_optimization_exp: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_ai_remove_trivial_prompts_cc: false,
    platform_editor_find_and_replace_improvements: false,
    cc_editor_ufo_hold_table_till_resize_complete: false,
    platform_editor_toggle_expand_on_match_found: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    cc_improve_writing_on_paste: false,
    platform_editor_ai_aifc: false
};

});




parcelRegister("eZyT4", function(module, exports) {
// Packages

var $6BsmU = parcelRequire("6BsmU");
function $aea1d311d3bf94d7$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!("randomize" in options)) options.randomize = true;
        op = $6BsmU.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error("Aborted"));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $aea1d311d3bf94d7$var$retry;

});

parcelRegister("hp04i", function(module, exports) {
"use strict";
class $cab4d3085ed4c11a$var$AbortError extends Error {
    constructor(){
        super("Throttled function aborted");
        this.name = "AbortError";
    }
}
const $cab4d3085ed4c11a$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError("Expected `limit` to be a finite number");
    if (!Number.isFinite(interval)) throw new TypeError("Expected `interval` to be a finite number");
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $cab4d3085ed4c11a$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $cab4d3085ed4c11a$var$pThrottle;
module.exports.AbortError = $cab4d3085ed4c11a$var$AbortError;

});

parcelRegister("l4n7k", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", function () { return $f56be746df9d91b0$export$1b59fe731a28a49d; });
$parcel$export(module.exports, "isErrorResponse", function () { return $f56be746df9d91b0$export$bea7bee8a87e7c52; });
var $f56be746df9d91b0$export$1b59fe731a28a49d = function isSuccessfulResponse(response) {
    if (!response) return false;
    var hasSuccessfulStatus = response.status === 200;
    var hasSuccessBody = "body" in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
var $f56be746df9d91b0$export$bea7bee8a87e7c52 = function isErrorResponse(response) {
    if (!response) return false;
    var hasStatus = "status" in response && response.status >= 200;
    var hasErrorBody = "error" in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("lBw9p", function(module, exports) {

var $4GkEf = parcelRequire("4GkEf");

var $coWck = parcelRequire("coWck");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $fba5fe2203fee1c6$var$uniqBy(array, iteratee) {
    return array && array.length ? $coWck(array, $4GkEf(iteratee, 2)) : [];
}
module.exports = $fba5fe2203fee1c6$var$uniqBy;

});
parcelRegister("coWck", function(module, exports) {

var $iPCwY = parcelRequire("iPCwY");

var $h2Igw = parcelRequire("h2Igw");

var $iBrOB = parcelRequire("iBrOB");

var $jWXQR = parcelRequire("jWXQR");

var $jrLEY = parcelRequire("jrLEY");

var $fQAkw = parcelRequire("fQAkw");
/** Used as the size to enable large array optimizations. */ var $9074decc5464391b$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $9074decc5464391b$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $h2Igw, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $iBrOB;
    } else if (length >= $9074decc5464391b$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $jrLEY(array);
        if (set) return $fQAkw(set);
        isCommon = false;
        includes = $jWXQR;
        seen = new $iPCwY;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $9074decc5464391b$var$baseUniq;

});
parcelRegister("h2Igw", function(module, exports) {

var $esr5t = parcelRequire("esr5t");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $c684f5c438b012b7$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $esr5t(array, value, 0) > -1;
}
module.exports = $c684f5c438b012b7$var$arrayIncludes;

});
parcelRegister("esr5t", function(module, exports) {

var $fQfAE = parcelRequire("fQfAE");

var $h8i4C = parcelRequire("h8i4C");

var $7StRM = parcelRequire("7StRM");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a868b12d4048a879$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $7StRM(array, value, fromIndex) : $fQfAE(array, $h8i4C, fromIndex);
}
module.exports = $a868b12d4048a879$var$baseIndexOf;

});
parcelRegister("fQfAE", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $b887ce35b65e0a12$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $b887ce35b65e0a12$var$baseFindIndex;

});

parcelRegister("h8i4C", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c791340b14c2c5db$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $c791340b14c2c5db$var$baseIsNaN;

});

parcelRegister("7StRM", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $5bc4be6c6bb84233$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $5bc4be6c6bb84233$var$strictIndexOf;

});



parcelRegister("iBrOB", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $d8b142361a3d8faf$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $d8b142361a3d8faf$var$arrayIncludesWith;

});

parcelRegister("jrLEY", function(module, exports) {

var $c6mom = parcelRequire("c6mom");

var $h0Muo = parcelRequire("h0Muo");

var $fQAkw = parcelRequire("fQAkw");
/** Used as references for various `Number` constants. */ var $e28582320264a5cd$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $e28582320264a5cd$var$createSet = !($c6mom && 1 / $fQAkw(new $c6mom([
    ,
    -0
]))[1] == $e28582320264a5cd$var$INFINITY) ? $h0Muo : function(values) {
    return new $c6mom(values);
};
module.exports = $e28582320264a5cd$var$createSet;

});




parcelRegister("lcrai", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", function () { return $f6efca65e649e3cb$export$497ecb0280204df4; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("3fPRZ");
var $lmr0s = parcelRequire("lmr0s");

var $bLzLw = parcelRequire("bLzLw");

var $ekdp0 = parcelRequire("ekdp0");

var $7H2lE = parcelRequire("7H2lE");

var $77VJc = parcelRequire("77VJc");

var $a5aKR = parcelRequire("a5aKR");

var $2uQhU = parcelRequire("2uQhU");
function $f6efca65e649e3cb$export$497ecb0280204df4(_ref) {
    var storeOptions = _ref.storeOptions, customClient = _ref.client, customAuthFlow = _ref.authFlow, children = _ref.children, renderers = _ref.renderers, isAdminHubAIEnabled = _ref.isAdminHubAIEnabled, product = _ref.product, shouldControlDataExport = _ref.shouldControlDataExport, isPreviewPanelAvailable = _ref.isPreviewPanelAvailable, openPreviewPanel = _ref.openPreviewPanel;
    var parentContext = (0, $iSvIT.useContext)((0, $a5aKR.SmartCardContext));
    var defaultInitialState = (0, $iSvIT.useMemo)(function() {
        return {};
    }, []);
    var _ref2 = storeOptions || {
        initialState: defaultInitialState
    }, initialState = _ref2.initialState;
    var store = (0, $iSvIT.useMemo)(function() {
        return (0, $lmr0s.default)((0, $77VJc.cardReducer), initialState);
    }, [
        initialState
    ]);
    var providerValue = (0, $iSvIT.useMemo)(function() {
        var client = customClient || new (0, $2uQhU.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        var authFlow = customAuthFlow || "oauth2";
        var getPreview = function getPreview(url, platform) {
            var cardState = (0, $ekdp0.getUrl)(store, url);
            return cardState.details ? (0, $7H2lE.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        };
    }, [
        customAuthFlow,
        customClient,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        store
    ]);
    var value = (0, $iSvIT.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bLzLw)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        });
    }, [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a5aKR.SmartCardContext).Provider, {
        value: value
    }, children);
}
var $f6efca65e649e3cb$export$2e2bcd8739ae039 = $f6efca65e649e3cb$export$497ecb0280204df4;

});
parcelRegister("3fPRZ", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return (parcelRequire("lmr0s")).default; });

var $lmr0s = parcelRequire("lmr0s");

var $9UsuU = parcelRequire("9UsuU");

var $8zmTe = parcelRequire("8zmTe");

var $f5Xbd = parcelRequire("f5Xbd");

var $dpkLA = parcelRequire("dpkLA");
parcelRequire("gda3b");
/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $25eb020e0c372162$var$isCrushed() {}

});
parcelRegister("lmr0s", function(module, exports) {

$parcel$export(module.exports, "ActionTypes", function () { return $f8d099f36fa43078$export$1385d81a6c6bbcd4; });
$parcel$export(module.exports, "default", function () { return $f8d099f36fa43078$export$2e2bcd8739ae039; });

var $497Zb = parcelRequire("497Zb");

var $5WaJi = parcelRequire("5WaJi");
var $f8d099f36fa43078$export$1385d81a6c6bbcd4 = {
    INIT: "@@redux/INIT"
};
function $f8d099f36fa43078$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error("Expected the enhancer to be a function.");
        return enhancer($f8d099f36fa43078$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error("Expected the reducer to be a function.");
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error("Expected listener to be a function.");
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $497Zb.default)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === "undefined") throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error("Reducers may not dispatch actions.");
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error("Expected the nextReducer to be a function.");
        currentReducer = nextReducer;
        dispatch({
            type: $f8d099f36fa43078$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object") throw new TypeError("Expected the observer to be an object.");
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $5WaJi.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $f8d099f36fa43078$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $5WaJi.default] = observable, _ref2;
}

});
parcelRegister("497Zb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $304e32813cce3a09$export$2e2bcd8739ae039; });

var $2DbTp = parcelRequire("2DbTp");

var $5ZzP0 = parcelRequire("5ZzP0");

var $40glB = parcelRequire("40glB");
/** `Object#toString` result references. */ var $304e32813cce3a09$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $304e32813cce3a09$var$funcProto = Function.prototype, $304e32813cce3a09$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $304e32813cce3a09$var$funcToString = $304e32813cce3a09$var$funcProto.toString;
/** Used to check objects for own properties. */ var $304e32813cce3a09$var$hasOwnProperty = $304e32813cce3a09$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $304e32813cce3a09$var$objectCtorString = $304e32813cce3a09$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $304e32813cce3a09$var$isPlainObject(value) {
    if (!(0, $40glB.default)(value) || (0, $2DbTp.default)(value) != $304e32813cce3a09$var$objectTag) return false;
    var proto = (0, $5ZzP0.default)(value);
    if (proto === null) return true;
    var Ctor = $304e32813cce3a09$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $304e32813cce3a09$var$funcToString.call(Ctor) == $304e32813cce3a09$var$objectCtorString;
}
var $304e32813cce3a09$export$2e2bcd8739ae039 = $304e32813cce3a09$var$isPlainObject;

});
parcelRegister("2DbTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ea872ec7613a3dc$export$2e2bcd8739ae039; });

var $6CoFJ = parcelRequire("6CoFJ");

var $5EboV = parcelRequire("5EboV");

var $eqPq5 = parcelRequire("eqPq5");
/** `Object#toString` result references. */ var $1ea872ec7613a3dc$var$nullTag = "[object Null]", $1ea872ec7613a3dc$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $1ea872ec7613a3dc$var$symToStringTag = (0, $6CoFJ.default) ? (0, $6CoFJ.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $1ea872ec7613a3dc$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $1ea872ec7613a3dc$var$undefinedTag : $1ea872ec7613a3dc$var$nullTag;
    return $1ea872ec7613a3dc$var$symToStringTag && $1ea872ec7613a3dc$var$symToStringTag in Object(value) ? (0, $5EboV.default)(value) : (0, $eqPq5.default)(value);
}
var $1ea872ec7613a3dc$export$2e2bcd8739ae039 = $1ea872ec7613a3dc$var$baseGetTag;

});
parcelRegister("6CoFJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d196e0edbf7fbd1$export$2e2bcd8739ae039; });

var $bmR3N = parcelRequire("bmR3N");
/** Built-in value references. */ var $4d196e0edbf7fbd1$var$Symbol = (0, $bmR3N.default).Symbol;
var $4d196e0edbf7fbd1$export$2e2bcd8739ae039 = $4d196e0edbf7fbd1$var$Symbol;

});
parcelRegister("bmR3N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $846ae8751a238c12$export$2e2bcd8739ae039; });

var $3cH1v = parcelRequire("3cH1v");
/** Detect free variable `self`. */ var $846ae8751a238c12$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $846ae8751a238c12$var$root = (0, $3cH1v.default) || $846ae8751a238c12$var$freeSelf || Function("return this")();
var $846ae8751a238c12$export$2e2bcd8739ae039 = $846ae8751a238c12$var$root;

});
parcelRegister("3cH1v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2553dd988f77a440$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $2553dd988f77a440$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $2553dd988f77a440$export$2e2bcd8739ae039 = $2553dd988f77a440$var$freeGlobal;

});



parcelRegister("5EboV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41c988328adf04ca$export$2e2bcd8739ae039; });

var $6CoFJ = parcelRequire("6CoFJ");
/** Used for built-in method references. */ var $41c988328adf04ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $41c988328adf04ca$var$hasOwnProperty = $41c988328adf04ca$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $41c988328adf04ca$var$nativeObjectToString = $41c988328adf04ca$var$objectProto.toString;
/** Built-in value references. */ var $41c988328adf04ca$var$symToStringTag = (0, $6CoFJ.default) ? (0, $6CoFJ.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $41c988328adf04ca$var$getRawTag(value) {
    var isOwn = $41c988328adf04ca$var$hasOwnProperty.call(value, $41c988328adf04ca$var$symToStringTag), tag = value[$41c988328adf04ca$var$symToStringTag];
    try {
        value[$41c988328adf04ca$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $41c988328adf04ca$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$41c988328adf04ca$var$symToStringTag] = tag;
        else delete value[$41c988328adf04ca$var$symToStringTag];
    }
    return result;
}
var $41c988328adf04ca$export$2e2bcd8739ae039 = $41c988328adf04ca$var$getRawTag;

});

parcelRegister("eqPq5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a81b614fd08480f5$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $a81b614fd08480f5$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a81b614fd08480f5$var$nativeObjectToString = $a81b614fd08480f5$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $a81b614fd08480f5$var$objectToString(value) {
    return $a81b614fd08480f5$var$nativeObjectToString.call(value);
}
var $a81b614fd08480f5$export$2e2bcd8739ae039 = $a81b614fd08480f5$var$objectToString;

});


parcelRegister("5ZzP0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45ce6fb4e211bf83$export$2e2bcd8739ae039; });

var $yI6QY = parcelRequire("yI6QY");
/** Built-in value references. */ var $45ce6fb4e211bf83$var$getPrototype = (0, $yI6QY.default)(Object.getPrototypeOf, Object);
var $45ce6fb4e211bf83$export$2e2bcd8739ae039 = $45ce6fb4e211bf83$var$getPrototype;

});
parcelRegister("yI6QY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0685645373ebdda4$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $0685645373ebdda4$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $0685645373ebdda4$export$2e2bcd8739ae039 = $0685645373ebdda4$var$overArg;

});


parcelRegister("40glB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ea3d7cb56fca5f5$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2ea3d7cb56fca5f5$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $2ea3d7cb56fca5f5$export$2e2bcd8739ae039 = $2ea3d7cb56fca5f5$var$isObjectLike;

});


parcelRegister("5WaJi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $452ab12dda83090f$export$2e2bcd8739ae039; });
/* global window */ 
var $5q6qE = parcelRequire("5q6qE");
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = (0, $5q6qE.default)(root);
var $452ab12dda83090f$export$2e2bcd8739ae039 = result;

});
parcelRegister("5q6qE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f245e15861d0a38$export$2e2bcd8739ae039; });
function $3f245e15861d0a38$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol("observable");
            Symbol.observable = result;
        }
    } else result = "@@observable";
    return result;
}

});



parcelRegister("9UsuU", function(module, exports) {

var $lmr0s = parcelRequire("lmr0s");

var $497Zb = parcelRequire("497Zb");
parcelRequire("gda3b");
function $736f7302ccf66f74$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || "an action";
    return "Given action " + actionName + ', reducer "' + key + '" returned undefined. ' + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}
function $736f7302ccf66f74$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $lmr0s.ActionTypes).INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $497Zb.default)(inputState)) return "The " + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $736f7302ccf66f74$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $lmr0s.ActionTypes).INIT
        });
        if (typeof initialState === "undefined") throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
        var type = "@@redux/PROBE_UNKNOWN_ACTION_" + Math.random().toString(36).substring(7).split("").join(".");
        if (typeof reducer(undefined, {
            type: type
        }) === "undefined") throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ("Don't try to handle " + (0, $lmr0s.ActionTypes).INIT + ' or other actions in "redux/*" ') + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    });
}
function $736f7302ccf66f74$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $736f7302ccf66f74$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var errorMessage = $736f7302ccf66f74$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}

});
parcelRegister("gda3b", function(module, exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $bcd5a809991a6aa6$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});


parcelRegister("8zmTe", function(module, exports) {
function $63d35910e6ea9b0e$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $63d35910e6ea9b0e$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $63d35910e6ea9b0e$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? "null" : typeof actionCreators) + ". " + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $63d35910e6ea9b0e$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}

});

parcelRegister("f5Xbd", function(module, exports) {

var $dpkLA = parcelRequire("dpkLA");
var $afd53a88098b99d5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $afd53a88098b99d5$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $dpkLA.default).apply(undefined, chain)(store.dispatch);
            return $afd53a88098b99d5$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("dpkLA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c2db7f65ea787e9$export$2e2bcd8739ae039; });
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $9c2db7f65ea787e9$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}

});



parcelRegister("77VJc", function(module, exports) {

$parcel$export(module.exports, "cardReducer", function () { return $5305f7715b5890f7$export$3c7c3113a97b6492; });

var $e7oBD = parcelRequire("e7oBD");

var $5lFdr = parcelRequire("5lFdr");
var $8nPmF = parcelRequire("8nPmF");
function $5305f7715b5890f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5305f7715b5890f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5305f7715b5890f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e7oBD.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5305f7715b5890f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5305f7715b5890f7$var$isCardAction = function isCardAction(action) {
    return [
        (0, $5lFdr.ACTION_PENDING),
        (0, $5lFdr.ACTION_RESOLVING),
        (0, $5lFdr.ACTION_RESOLVED),
        (0, $5lFdr.ACTION_RELOADING),
        (0, $5lFdr.ACTION_ERROR),
        (0, $5lFdr.ACTION_ERROR_FALLBACK),
        (0, $5lFdr.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $5305f7715b5890f7$var$persistPayloadToState(payload, state, type) {
    var nextDetails = payload;
    var nextState = $5305f7715b5890f7$var$_objectSpread({}, state);
    if (nextDetails) {
        nextState.status = (0, $8nPmF.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $5305f7715b5890f7$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $5lFdr.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $5lFdr.ACTION_RESOLVING:
            return $5305f7715b5890f7$var$_objectSpread($5305f7715b5890f7$var$_objectSpread({}, state), {}, {
                status: action.type
            });
        case 0, $5lFdr.ACTION_RESOLVED:
            return $5305f7715b5890f7$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $5lFdr.ACTION_RELOADING:
            return $5305f7715b5890f7$var$persistPayloadToState(action.payload, state, "resolved");
        case 0, $5lFdr.ACTION_ERROR:
            return $5305f7715b5890f7$var$_objectSpread($5305f7715b5890f7$var$_objectSpread({}, state), {}, {
                status: action.type,
                error: action.error
            });
        case 0, $5lFdr.ACTION_ERROR_FALLBACK:
            return $5305f7715b5890f7$var$_objectSpread($5305f7715b5890f7$var$_objectSpread({}, state), {}, {
                status: action.type,
                error: action.error,
                details: action.payload
            });
        case 0, $5lFdr.ACTION_UPDATE_METADATA_STATUS:
            return $5305f7715b5890f7$var$_objectSpread($5305f7715b5890f7$var$_objectSpread({}, state), {}, {
                metadataStatus: action.metadataStatus
            });
    }
}
var $5305f7715b5890f7$export$3c7c3113a97b6492 = function cardReducer(state, action) {
    if (!$5305f7715b5890f7$var$isCardAction(action)) return state;
    var cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    var hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        var nextState = $5305f7715b5890f7$var$reduceToNextState(cardState, action);
        return $5305f7715b5890f7$var$_objectSpread($5305f7715b5890f7$var$_objectSpread({}, state), {}, (0, $e7oBD.default)({}, action.url, nextState));
    }
};

});


parcelRegister("j6VaV", function(module, exports) {

$parcel$export(module.exports, "ConfluenceCardLinkSection", function () { return (parcelRequire("lDaVQ")).ConfluenceCardLinkSection; });

var $lDaVQ = parcelRequire("lDaVQ");

});
parcelRegister("lDaVQ", function(module, exports) {

$parcel$export(module.exports, "ConfluenceCardLinkSection", function () { return $3fbf991cbf623eb5$export$2d0695a48fb0c352; });

var $loA2J = parcelRequire("loA2J");

var $cgOuH = parcelRequire("cgOuH");

var $8TROD = parcelRequire("8TROD");

var $8KnwD = parcelRequire("8KnwD");
const $3fbf991cbf623eb5$export$2d0695a48fb0c352 = ()=>{
    const { data: engagementData } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomainEngagement);
    if ((engagementData === null || engagementData === void 0 ? void 0 : engagementData.engagementSpaces.length) === 0) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cgOuH.default), {
        children: engagementData === null || engagementData === void 0 ? void 0 : engagementData.engagementSpaces.map((space)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $8TROD.Card), {
                url: space.spaceUrl,
                appearance: "block"
            }, space.spaceKey))
    });
};

});


parcelRegister("bi7Jk", function(module, exports) {

$parcel$export(module.exports, "NoAccessErrorDisplay", function () { return (parcelRequire("bShUa")).NoAccessErrorDisplay; });
$parcel$export(module.exports, "NoEngagementErrorDisplay", function () { return (parcelRequire("2irAK")).NoEngagementErrorDisplay; });
$parcel$export(module.exports, "UserNotProvisionedErrorDisplay", function () { return (parcelRequire("kvOKb")).UserNotProvisionedErrorDisplay; });

var $bShUa = parcelRequire("bShUa");

var $2irAK = parcelRequire("2irAK");

var $kvOKb = parcelRequire("kvOKb");

});
parcelRegister("bShUa", function(module, exports) {

$parcel$export(module.exports, "NoAccessErrorDisplay", function () { return $1d5bbe35ce013bdd$export$5797fd0edc12feb5; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $gf1F9 = parcelRequire("gf1F9");

var $jKp9A = parcelRequire("jKp9A");
var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $kwHar = parcelRequire("kwHar");
parcelRequire("fMp47");
var $4klQA = parcelRequire("4klQA");

var $4ttem = parcelRequire("4ttem");
const $1d5bbe35ce013bdd$var$boxStyles = (0, $jAMCU.xcss)({
    borderRadius: "border.radius.200",
    border: `1px solid ${(0, $kwHar.default)("color.border.disabled")}`
});
const $1d5bbe35ce013bdd$export$5797fd0edc12feb5 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
        padding: "space.300",
        backgroundColor: "elevation.surface.sunken",
        xcss: $1d5bbe35ce013bdd$var$boxStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
            space: "space.400",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4klQA.PadlockVector), {
                    alt: intl.formatMessage((0, $4ttem.messages).noAccessGraphicAltText)
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $4ttem.messages).noAccessHeading))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $4ttem.messages).noAccessDescription))
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("fMp47", function(module, exports) {

$parcel$export(module.exports, "PadlockVector", function () { return (parcelRequire("4klQA")).PadlockVector; });
$parcel$export(module.exports, "BlueprintVector", function () { return (parcelRequire("b4BuT")).BlueprintVector; });

var $4klQA = parcelRequire("4klQA");

var $b4BuT = parcelRequire("b4BuT");

});
parcelRegister("4klQA", function(module, exports) {

$parcel$export(module.exports, "PadlockVector", function () { return $724e421472a2d17c$export$627608150531cee2; });

var $loA2J = parcelRequire("loA2J");
const $724e421472a2d17c$export$627608150531cee2 = ({ alt: alt })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "103",
        height: "103",
        viewBox: "0 0 275 276",
        fill: "none",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M207.85 185.032C208.72 180.132 209.18 174.932 209.18 169.422C209.18 163.912 208.72 158.562 207.83 153.602C202.53 124.102 182.03 105.912 153.3 101.242C148.4 100.442 143.26 100.032 137.91 100.032C132.56 100.032 126.98 100.472 121.88 101.322C93.12 106.122 72.67 124.262 67.36 153.592C66.46 158.552 66 163.822 66 169.412C66 175.002 66.46 180.122 67.34 185.022C72.61 214.322 93.08 232.492 121.89 237.292C126.99 238.142 132.34 238.582 137.92 238.582C143.5 238.582 148.41 238.172 153.31 237.372C182.1 232.692 202.61 214.472 207.87 185.012L207.85 185.032Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M156.92 162.162C157.16 160.812 157.29 159.382 157.29 157.862C157.29 156.342 157.16 154.872 156.92 153.512C155.46 145.392 149.82 140.392 141.91 139.102C140.56 138.882 139.15 138.772 137.67 138.772C136.19 138.772 134.66 138.892 133.26 139.132C125.34 140.452 119.71 145.442 118.25 153.522C118 154.882 117.87 156.342 117.87 157.872C117.87 159.402 118 160.822 118.24 162.172C119.69 170.232 125.33 175.242 133.25 176.562C134.65 176.792 136.13 176.922 137.66 176.922C139.19 176.922 140.55 176.812 141.9 176.592C149.82 175.302 155.47 170.292 156.92 162.182V162.162Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M189.62 82.2422H85.5303V127.532H189.62V82.2422Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M150.11 167.092H125.04V200.312H150.11V167.092Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M137.74 126.482C134.47 126.482 131.24 126.222 128.16 125.702C109.13 122.532 96.3099 110.162 93.0099 91.7825C92.4699 88.7625 92.1899 85.5625 92.1899 82.2925C92.1899 79.0225 92.4699 75.7425 93.0199 72.6825C96.3499 54.3025 109.15 41.9425 128.16 38.7725C134.23 37.7625 140.9 37.7425 146.96 38.7225C166 41.8225 178.83 54.2025 182.15 72.7025C182.7 75.7625 182.98 78.9925 182.98 82.2925C182.98 85.5925 182.71 88.7525 182.17 91.7725C178.87 110.272 166.04 122.662 146.97 125.762C144.01 126.242 140.91 126.492 137.75 126.492L137.74 126.482ZM137.74 47.2725C135 47.2725 132.25 47.4825 129.69 47.9125C114.55 50.4425 104.77 59.8225 102.14 74.3325C101.68 76.8425 101.45 79.5225 101.45 82.2925C101.45 85.0625 101.68 87.6625 102.12 90.1425C104.73 104.652 114.52 114.042 129.68 116.572C134.75 117.422 140.44 117.432 145.47 116.612C160.64 114.142 170.43 104.742 173.04 90.1425C173.48 87.6525 173.71 85.0125 173.71 82.2925C173.71 79.5725 173.48 76.8525 173.03 74.3325C170.41 59.7325 160.62 50.3325 145.47 47.8625C143.01 47.4625 140.37 47.2625 137.73 47.2625L137.74 47.2725Z",
                fill: "#BF63F3"
            })
        ]
    });

});

parcelRegister("b4BuT", function(module, exports) {

$parcel$export(module.exports, "BlueprintVector", function () { return $8f654e4ce9ce1f38$export$3cb8cd060458893; });

var $loA2J = parcelRequire("loA2J");
const $8f654e4ce9ce1f38$export$3cb8cd060458893 = ({ alt: alt })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "103",
        height: "103",
        viewBox: "0 0 187 174",
        fill: "none",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M11.0994 12.6406L0.649414 173.651H180.859L186.389 12.6406H11.0994Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M62.9297 79.8306H48.8096L98.5296 32.3906L149.87 79.8306H136.073C131.974 108.204 136.969 136.581 136.969 136.581H64.3993C59.1247 120.533 61.3153 93.5329 62.9297 79.8306Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M48.8691 17.092C48.9091 13.072 47.7891 13.032 47.5191 17.042C47.1391 22.732 46.8191 28.712 46.5091 36.402C46.2291 45.122 46.3691 47.302 46.1191 53.202C45.7391 63.182 44.7791 80.002 44.5391 84.062C44.5091 84.662 44.4791 85.262 44.4591 85.862C44.3391 90.162 43.7791 109.022 43.0691 125.252C42.6291 136.712 42.3591 143.812 42.2191 147.522C41.8891 156.272 41.7491 162.822 41.7191 169.252C41.6991 172.782 42.6691 172.822 42.9191 169.302C43.3791 162.892 43.7491 156.352 44.0891 147.602C44.2191 144.202 44.7591 137.122 45.1891 127.122C45.2591 125.492 45.2991 123.862 45.3291 122.242C45.5091 108.282 46.3091 90.172 46.3091 90.172C46.3091 90.172 47.3591 63.152 47.7991 51.742C48.1291 43.152 48.2891 39.022 48.3791 36.482C48.6691 28.792 48.8091 22.802 48.8691 17.102V17.092Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M100.119 17.092C100.159 13.072 99.0391 13.032 98.7691 17.042C98.3791 22.732 98.0691 28.712 97.7591 36.402C97.4791 45.122 97.619 47.302 97.369 53.202C96.989 63.182 96.0291 80.002 95.7891 84.062C95.7591 84.662 95.7291 85.262 95.7091 85.862C95.5891 90.162 95.0291 109.022 94.3191 125.252C93.8791 136.712 93.6091 143.812 93.4691 147.522C93.1391 156.272 92.9991 162.822 92.9691 169.252C92.9491 172.782 93.9191 172.822 94.1691 169.302C94.6291 162.892 94.999 156.352 95.339 147.602C95.469 144.202 96.009 137.122 96.439 127.122C96.509 125.492 96.5491 123.862 96.5791 122.242C96.7591 108.282 97.5591 90.172 97.5591 90.172C97.5591 90.172 98.609 63.152 99.049 51.742C99.379 43.152 99.5391 39.022 99.6291 36.482C99.9191 28.792 100.059 22.802 100.119 17.102V17.092Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M151.369 17.092C151.409 13.072 150.289 13.032 150.019 17.042C149.639 22.732 149.319 28.712 149.009 36.402C148.729 45.122 148.869 47.302 148.619 53.202C148.239 63.182 147.279 80.002 147.039 84.062C147.009 84.662 146.979 85.262 146.959 85.862C146.839 90.162 146.279 109.022 145.569 125.252C145.129 136.712 144.859 143.812 144.719 147.522C144.389 156.272 144.249 162.822 144.219 169.252C144.199 172.782 145.169 172.822 145.419 169.302C145.879 162.892 146.249 156.352 146.589 147.602C146.719 144.202 147.259 137.122 147.689 127.122C147.759 125.492 147.799 123.862 147.829 122.242C148.009 108.282 148.809 90.172 148.809 90.172C148.809 90.172 149.859 63.152 150.299 51.742C150.629 43.152 150.789 39.022 150.879 36.482C151.169 28.792 151.309 22.802 151.369 17.102V17.092Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M180.31 50.8316C184.3 50.7316 184.3 49.6116 180.31 49.4816C174.66 49.3016 168.72 49.1916 161.08 49.1616C152.43 49.1916 150.27 49.4116 144.41 49.3716C134.5 49.3416 117.79 48.9816 113.76 48.8916C113.16 48.8816 112.57 48.8716 111.97 48.8816C107.7 48.9116 88.9897 49.0216 72.8797 48.8916C61.4997 48.8616 54.4597 48.8416 50.7797 48.8316C42.0897 48.8116 35.5997 48.9116 29.2197 49.1016C25.7197 49.2116 25.7197 50.1816 29.2197 50.3016C35.5897 50.5316 42.0897 50.6716 50.7697 50.7016C54.1497 50.7116 61.1797 51.0016 71.1097 51.0816C72.7297 51.0916 74.3497 51.0816 75.9497 51.0416C89.7997 50.7216 107.78 50.8816 107.78 50.8816C107.78 50.8816 134.61 50.9716 145.93 51.0016C154.46 51.0216 158.56 51.0316 161.08 51.0416C168.71 51.0616 174.65 50.9916 180.31 50.8416V50.8316Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M180.32 93.3512C184.29 93.2512 184.29 92.1311 180.32 92.0011C174.69 91.8211 168.78 91.7111 161.18 91.6811C152.56 91.7111 150.42 91.9311 144.58 91.8911C134.72 91.8611 118.08 91.5011 114.07 91.4111C113.48 91.4111 112.88 91.3911 112.29 91.4111C108.04 91.4411 89.4097 91.5511 73.3697 91.4111C62.0397 91.3811 55.0297 91.3612 51.3597 91.3512C42.7097 91.3312 36.2397 91.4311 29.8997 91.6211C26.4097 91.7311 26.4097 92.7011 29.8997 92.8211C36.2397 93.0511 42.7097 93.1911 51.3597 93.2211C54.7197 93.2211 61.7197 93.5212 71.6097 93.6012C73.2197 93.6012 74.8297 93.6011 76.4297 93.5611C90.2197 93.2411 108.12 93.4011 108.12 93.4011C108.12 93.4011 134.83 93.4911 146.1 93.5211C154.59 93.5411 158.67 93.5511 161.18 93.5611C168.78 93.5811 174.7 93.5111 180.32 93.3611V93.3512Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M180.32 135.511C184.29 135.411 184.29 134.291 180.32 134.161C174.69 133.981 168.78 133.871 161.18 133.841C152.56 133.871 150.42 134.091 144.58 134.051C134.72 134.021 118.08 133.661 114.07 133.571C113.48 133.571 112.88 133.551 112.29 133.571C108.04 133.601 89.4097 133.711 73.3697 133.571C62.0397 133.541 55.0297 133.521 51.3597 133.511C42.7097 133.491 36.2397 133.591 29.8997 133.781C26.4097 133.891 26.4097 134.861 29.8997 134.981C36.2397 135.211 42.7097 135.351 51.3597 135.381C54.7197 135.381 61.7197 135.681 71.6097 135.761C73.2197 135.761 74.8297 135.761 76.4297 135.721C90.2197 135.401 108.12 135.561 108.12 135.561C108.12 135.561 134.83 135.651 146.1 135.681C154.59 135.701 158.67 135.711 161.18 135.721C168.78 135.741 174.7 135.671 180.32 135.521V135.511Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0.649998 173.641C0.649998 173.641 1.46 155.421 27.8 157.141V0.000976562C27.8 0.000976562 4.88 10.941 0 30.511C0 30.511 0.649998 170.771 0.649998 173.651V173.641Z",
                fill: "#09326C"
            })
        ]
    });

});


parcelRegister("4ttem", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $af5ad0108db2549f$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $af5ad0108db2549f$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    noEngagementHeading: {
        id: "fastshift.migrations-management-page.error-display.no-engagement.heading",
        defaultMessage: "A migration project hasn\u2019t started yet",
        description: "Heading for error banner displayed when there is no engagement project"
    },
    noEngagementDescription: {
        id: "fastshift.migrations-management-page.error-display.no-engagement.description",
        defaultMessage: "The FastShift team will engage with the customer to create a detailed migration project, defining tasks and timelines. Once that work has kicked off, it will be visible on this page.",
        description: "Description for error banner displayed when there is no engagement project"
    },
    noEngagementGraphicAltText: {
        id: "fastshift.migrations-management-page.error-display.no-engagement.graphic-alt-text",
        defaultMessage: "Blueprint Graphic",
        description: "Alt Text for the blueprint vector graphic displayed when a no-engagement-project error occurs"
    },
    noAccessHeading: {
        id: "fastshift.migrations-management-page.error-display.no-access.heading",
        defaultMessage: "You do not have permissions to view the migration project",
        description: "Heading for error banner displayed when customer does not have permissions to access the existing engagement project"
    },
    noAccessDescription: {
        id: "fastshift.migrations-management-page.error-display.no-access.description",
        defaultMessage: "If you believe you should be able to see the content of the migration project, contact your FastShift Champion.",
        description: "Description for error banner displayed when customer does not have permissions to access the existing  engagement project"
    },
    noAccessGraphicAltText: {
        id: "fastshift.migrations-management-page.error-display.no-access.graphic-alt-text",
        defaultMessage: "Padlock Graphic",
        description: "Alt Text for the generic error vector graphic displayed when a no-access error occurs"
    },
    userAccountNotProvisionedHeading: {
        id: "fastshift.migrations-management-page.error-display.userAccountNotProvisioned.heading",
        defaultMessage: "Get started with your project",
        description: "Heading for error banner displayed when the user's account has not been provisioned in as-a-team site yet"
    },
    userAccountNotProvisionedDescription: {
        id: "fastshift.migrations-management-page.error-display.userAccountNotProvisioned.description",
        defaultMessage: "To get access to a project with your migration plan, you need to first log in so we can set up your account.",
        description: "Description for error banner displayed when the user's account has not been provisioned in as-a-team site yet"
    },
    userAccountNotProvisionedButton: {
        id: "fastshift.migrations-management-page.error-display.userAccountNotProvisioned.button",
        defaultMessage: "Log In",
        description: "Log In Button Text on the error banner displayed when the user's account has not been provisioned in as-a-team site yet"
    }
});

});


parcelRegister("2irAK", function(module, exports) {

$parcel$export(module.exports, "NoEngagementErrorDisplay", function () { return $3c3c5cf1c3aaba9c$export$9f8c7430254f1f61; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $gf1F9 = parcelRequire("gf1F9");

var $jKp9A = parcelRequire("jKp9A");
var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $kwHar = parcelRequire("kwHar");
parcelRequire("fMp47");
var $b4BuT = parcelRequire("b4BuT");

var $4ttem = parcelRequire("4ttem");
const $3c3c5cf1c3aaba9c$var$boxStyles = (0, $jAMCU.xcss)({
    borderRadius: "border.radius.200",
    border: `1px solid ${(0, $kwHar.default)("color.border.disabled")}`
});
const $3c3c5cf1c3aaba9c$export$9f8c7430254f1f61 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
        padding: "space.300",
        backgroundColor: "elevation.surface.sunken",
        xcss: $3c3c5cf1c3aaba9c$var$boxStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
            space: "space.400",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $b4BuT.BlueprintVector), {
                    alt: intl.formatMessage((0, $4ttem.messages).noEngagementGraphicAltText)
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $4ttem.messages).noEngagementHeading))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $4ttem.messages).noEngagementDescription))
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("kvOKb", function(module, exports) {

$parcel$export(module.exports, "UserNotProvisionedErrorDisplay", function () { return $ad6a57d50ab5a491$export$b36df73398da08ac; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bM10s = parcelRequire("bM10s");

var $gf1F9 = parcelRequire("gf1F9");

var $jKp9A = parcelRequire("jKp9A");
var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $kwHar = parcelRequire("kwHar");

var $9OyVr = parcelRequire("9OyVr");
parcelRequire("fMp47");
var $b4BuT = parcelRequire("b4BuT");

var $4ttem = parcelRequire("4ttem");
const $ad6a57d50ab5a491$var$boxStyles = (0, $jAMCU.xcss)({
    borderRadius: "border.radius.200",
    border: `1px solid ${(0, $kwHar.default)("color.border.disabled")}`
});
const $ad6a57d50ab5a491$export$b36df73398da08ac = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
        padding: "space.300",
        backgroundColor: "elevation.surface.sunken",
        xcss: $ad6a57d50ab5a491$var$boxStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
            space: "space.400",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $b4BuT.BlueprintVector), {
                    alt: intl.formatMessage((0, $4ttem.messages).noEngagementGraphicAltText)
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $4ttem.messages).userAccountNotProvisionedHeading))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $4ttem.messages).userAccountNotProvisionedDescription))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bM10s.default), {
                                href: (0, $9OyVr.AS_A_TEAM_URL),
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $4ttem.messages).userAccountNotProvisionedButton))
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("awInG", function(module, exports) {

$parcel$export(module.exports, "useMigrationsManagementPageAnalytics", function () { return (parcelRequire("bAVaZ")).useMigrationsManagementPageAnalytics; });
$parcel$export(module.exports, "useMigrationsManagementUIAnalytics", function () { return (parcelRequire("hdFIy")).useMigrationsManagementUIAnalytics; });

var $bAVaZ = parcelRequire("bAVaZ");

var $hdFIy = parcelRequire("hdFIy");

});
parcelRegister("bAVaZ", function(module, exports) {

$parcel$export(module.exports, "useMigrationsManagementPageAnalytics", function () { return $38c8fe5767b8ba6d$export$80981aa7a88d8f7b; });

var $7Knp0 = parcelRequire("7Knp0");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $ag6tB = parcelRequire("ag6tB");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");

var $hls9e = parcelRequire("hls9e");
const $38c8fe5767b8ba6d$export$80981aa7a88d8f7b = ()=>{
    const identityAttrs = (0, $ag6tB.useCustomerIdentityAttrs)();
    const { fireScreenEvent: fireScreenEvent, fireTrackEvent: fireTrackEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    const { data: engagementData, error: engagementError, pending: engagementPending } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomainEngagement);
    // Screen event
    (0, $iSvIT.useEffect)(()=>{
        if (!identityAttrs) return;
        fireScreenEvent({
            name: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN
        });
    }, [
        fireScreenEvent,
        identityAttrs
    ]);
    // Track event
    (0, $iSvIT.useEffect)(()=>{
        if (!identityAttrs || engagementPending) return;
        const hasError = !!engagementError;
        const metrics = !hasError && engagementData ? (0, $hls9e.calculateEngagementMetrics)(engagementData) : {
            embedCount: null,
            boardCount: null,
            projectCount: null,
            spaceCount: null
        };
        fireTrackEvent({
            action: (0, $k7z8r.ActionKey).DISPLAYED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).SECTION,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).MIGRATION_PLANNER_EMBED_SECTION,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN,
            attributes: (0, $7Knp0._)({
                hasError: hasError,
                errorType: engagementError
            }, metrics)
        });
    }, [
        fireTrackEvent,
        identityAttrs,
        engagementData,
        engagementError,
        engagementPending
    ]);
};

});
parcelRegister("hls9e", function(module, exports) {

$parcel$export(module.exports, "calculateEngagementMetrics", function () { return $764647ae3f15597e$export$772abf2d17c1bdd; });
const $764647ae3f15597e$export$772abf2d17c1bdd = (engagementData)=>{
    const embedCount = engagementData.engagementProjects.reduce((total, project)=>{
        return total + project.boards.reduce((boardTotal, board)=>{
            return boardTotal + board.embeds.length;
        }, 0);
    }, 0);
    const boardCount = engagementData.engagementProjects.reduce((total, project)=>{
        return total + project.boards.length;
    }, 0);
    const projectCount = engagementData.engagementProjects.length;
    const spaceCount = engagementData.engagementSpaces.length;
    return {
        embedCount: embedCount,
        boardCount: boardCount,
        projectCount: projectCount,
        spaceCount: spaceCount
    };
};

});


parcelRegister("hdFIy", function(module, exports) {

$parcel$export(module.exports, "useMigrationsManagementUIAnalytics", function () { return $40d4c141fce51e8d$export$9c3d8ec90db18545; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $ag6tB = parcelRequire("ag6tB");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
const $40d4c141fce51e8d$export$9c3d8ec90db18545 = ()=>{
    const identityAttrs = (0, $ag6tB.useCustomerIdentityAttrs)(true);
    const { fireUIEvent: fireUIEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    // UI event callbacks
    const sendEmbedViewToggleUIEvent = (0, $iSvIT.useCallback)((selectedEmbedType)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).EMBED_VIEW_TYPE_TOGGLE_BUTTON,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN,
            attributes: {
                selectedEmbedType: selectedEmbedType
            }
        });
    }, [
        fireUIEvent
    ]);
    const sendBoardSelectionUIEvent = (0, $iSvIT.useCallback)((selectedProjectKey, selectedBoardId)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).SELECT_BOARD_DROPDOWN_ITEM,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN,
            attributes: {
                selectedProjectKey: selectedProjectKey,
                selectedBoardId: selectedBoardId
            }
        });
    }, [
        fireUIEvent
    ]);
    const sendJiraEmbedLinkClickUIEvent = (0, $iSvIT.useCallback)((engagementUrl, selectedEmbedType)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).LINK,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).JIRA_EMBED_LINK,
            source: (0, $k7z8r.SourceKey).FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN,
            attributes: {
                engagementUrl: engagementUrl,
                selectedEmbedType: selectedEmbedType
            }
        });
    }, [
        fireUIEvent
    ]);
    return {
        sendEmbedViewToggleUIEvent: sendEmbedViewToggleUIEvent,
        sendBoardSelectionUIEvent: sendBoardSelectionUIEvent,
        sendJiraEmbedLinkClickUIEvent: sendJiraEmbedLinkClickUIEvent
    };
};

});


parcelRegister("jix7L", function(module, exports) {

$parcel$export(module.exports, "JiraEmbeddedBoardSection", function () { return (parcelRequire("5V63Y")).JiraEmbeddedBoardSection; });

var $5V63Y = parcelRequire("5V63Y");

});
parcelRegister("5V63Y", function(module, exports) {

$parcel$export(module.exports, "JiraEmbeddedBoardSection", function () { return $0d014d0e1a1b0781$export$7384e6c1e69f7f00; });
/* jira-embedded-board-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $gf1F9 = parcelRequire("gf1F9");

var $9CMNB = parcelRequire("9CMNB");

var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");

var $g2OHD = parcelRequire("g2OHD");

var $8TROD = parcelRequire("8TROD");

var $cssyA = parcelRequire("cssyA");
parcelRequire("awInG");
var $hdFIy = parcelRequire("hdFIy");
parcelRequire("2Jv1p");
var $9qzUM = parcelRequire("9qzUM");

var $76Evp = parcelRequire("76Evp");

var $azrUl = parcelRequire("azrUl");
const $0d014d0e1a1b0781$var$EmbedContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1bsb1osq _ybkbstmo _5pue1osq _1gdjidpf _8s22idpf _14whidpf _zc4widpf",
            __cmplp.className
        ])
    }));
});
const $0d014d0e1a1b0781$var$SelectedBoardProjectTitle = ({ projectIcon: projectIcon, projectName: projectName, projectEmbedViewUrl: projectEmbedViewUrl, onLinkClick: onLinkClick })=>{
    const intl = (0, $f6qj2.default)(); // placeholder if no icon is available
    if (!projectIcon) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), {
                height: "20px",
                width: "20px",
                borderRadius: "border.radius"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9CMNB.default), {
                    href: projectEmbedViewUrl || "",
                    target: "_blank",
                    onClick: onLinkClick,
                    children: projectName
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $cssyA.Picture), {
                image: {
                    src: projectIcon,
                    alt: intl.formatMessage((0, $76Evp.messages).logoAltText, {
                        name: projectName
                    })
                },
                style: {
                    width: "20px",
                    height: "20px",
                    borderRadius: "border.radius"
                }
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9CMNB.default), {
                    href: projectEmbedViewUrl || "",
                    target: "_blank",
                    onClick: onLinkClick,
                    children: projectName
                })
            })
        ]
    });
};
const $0d014d0e1a1b0781$var$SelectedBoardView = ({ selectedEmbedViewUrl: selectedEmbedViewUrl })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($0d014d0e1a1b0781$var$EmbedContainer, {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8TROD.Card), {
                    appearance: "embed",
                    inheritDimensions: true,
                    frameStyle: "hide",
                    url: selectedEmbedViewUrl !== null && selectedEmbedViewUrl !== void 0 ? selectedEmbedViewUrl : ""
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $76Evp.messages).havingTroubleSubtext), {
                    values: {
                        Link: (msg)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $9CMNB.default), {
                                href: selectedEmbedViewUrl !== null && selectedEmbedViewUrl !== void 0 ? selectedEmbedViewUrl : "",
                                target: "_blank",
                                children: msg
                            })
                    }
                }))
            })
        ]
    });
};
const $0d014d0e1a1b0781$export$7384e6c1e69f7f00 = ()=>{
    const { boards: boards, selectedBoard: selectedBoard, setSelectedBoard: setSelectedBoard, selectedEmbedViewUrl: selectedEmbedViewUrl } = (0, $azrUl.useJiraBoardEmbeds)();
    const { sendJiraEmbedLinkClickUIEvent: sendJiraEmbedLinkClickUIEvent } = (0, $hdFIy.useMigrationsManagementUIAnalytics)();
    if (boards.length === 0) return null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                space: "space.100",
                alignBlock: "center",
                grow: "fill",
                spread: "space-between",
                children: [
                    selectedBoard && /*#__PURE__*/ (0, $loA2J.jsx)($0d014d0e1a1b0781$var$SelectedBoardProjectTitle, {
                        projectName: selectedBoard.projectName,
                        projectIcon: selectedBoard.projectIcon,
                        projectEmbedViewUrl: selectedEmbedViewUrl,
                        onLinkClick: ()=>{
                            if (selectedEmbedViewUrl) sendJiraEmbedLinkClickUIEvent(selectedEmbedViewUrl, selectedBoard.selectedView);
                        }
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9qzUM.BoardAndEmbedViewOptions), {
                        boards: boards,
                        selectedBoard: selectedBoard,
                        setSelectedBoard: setSelectedBoard
                    })
                ]
            }),
            selectedEmbedViewUrl && /*#__PURE__*/ (0, $loA2J.jsx)($0d014d0e1a1b0781$var$SelectedBoardView, {
                selectedEmbedViewUrl: selectedEmbedViewUrl
            })
        ]
    });
};

});
parcelRegister("2Jv1p", function(module, exports) {

$parcel$export(module.exports, "BoardAndEmbedViewOptions", function () { return (parcelRequire("9qzUM")).BoardAndEmbedViewOptions; });

var $9qzUM = parcelRequire("9qzUM");

});
parcelRegister("9qzUM", function(module, exports) {

$parcel$export(module.exports, "BoardAndEmbedViewOptions", function () { return $7cf6e9d1cd7de4f7$export$21d724bbb4c4a7e4; });
/* board-and-embed-view-options.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $9B16h = parcelRequire("9B16h");
var $5XkWH = parcelRequire("5XkWH");
var $7dQwL = parcelRequire("7dQwL");

var $4a5Re = parcelRequire("4a5Re");
var $3Oabj = parcelRequire("3Oabj");
var $c3HvU = parcelRequire("c3HvU");

var $lPup9 = parcelRequire("lPup9");

var $4vcv5 = parcelRequire("4vcv5");

var $7akU3 = parcelRequire("7akU3");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");
parcelRequire("awInG");
var $hdFIy = parcelRequire("hdFIy");

var $76Evp = parcelRequire("76Evp");

var $7fNYC = parcelRequire("7fNYC");
const $7cf6e9d1cd7de4f7$var$BorderlessButtonWrapper = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_419v1j28 _1w7j1j28 _ryt31j28 _179i1j28 _k0itmzrp _1ix6grf3",
            __cmplp.className
        ])
    }));
});
const $7cf6e9d1cd7de4f7$var$toggleButtonGroupStyles = (0, $jAMCU.xcss)({
    // add border
    borderRadius: "border.radius.100",
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    padding: "space.050"
});
const $7cf6e9d1cd7de4f7$export$21d724bbb4c4a7e4 = ({ boards: boards, selectedBoard: selectedBoard, setSelectedBoard: setSelectedBoard })=>{
    const intl = (0, $f6qj2.default)();
    const { sendEmbedViewToggleUIEvent: sendEmbedViewToggleUIEvent, sendBoardSelectionUIEvent: sendBoardSelectionUIEvent } = (0, $hdFIy.useMigrationsManagementUIAnalytics)();
    const boardOptions = boards.map((boardState)=>({
            label: boardState.board.boardName,
            value: boardState.board.boardId,
            data: boardState
        }));
    const handleSelectedBoardChange = (option)=>{
        if (option) {
            setSelectedBoard(option.data);
            sendBoardSelectionUIEvent(option.data.projectKey, option.data.board.boardId);
        }
    };
    const setSelectedView = (embedType)=>{
        // if only one view is present, there is nothing to toggle
        if (!selectedBoard || !selectedBoard.calendarUrl || !selectedBoard.timelineUrl) return;
         // toggle the isSelected state of timeline and calendar
        const updatedBoard = (0, $6iHNw._)((0, $7Knp0._)({}, selectedBoard), {
            selectedView: embedType
        });
        setSelectedBoard(updatedBoard);
        sendEmbedViewToggleUIEvent(embedType);
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
        space: "space.100",
        alignInline: "end",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($7cf6e9d1cd7de4f7$var$BorderlessButtonWrapper, {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                    xcss: $7cf6e9d1cd7de4f7$var$toggleButtonGroupStyles,
                    space: "space.025",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                            appearance: "subtle",
                            isDisabled: !(selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.timelineUrl),
                            isSelected: (selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.selectedView) === (0, $7fNYC.CustomerDomainJiraBoardEmbedType).TIMELINE,
                            spacing: "compact",
                            onClick: ()=>// alter the isSelected state of timeline and calendar
                                setSelectedView((0, $7fNYC.CustomerDomainJiraBoardEmbedType).TIMELINE),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $76Evp.messages).timelineViewToggleLabel))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                            appearance: "subtle",
                            isDisabled: !(selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.calendarUrl),
                            isSelected: (selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.selectedView) === (0, $7fNYC.CustomerDomainJiraBoardEmbedType).CALENDAR,
                            spacing: "compact",
                            onClick: ()=>setSelectedView((0, $7fNYC.CustomerDomainJiraBoardEmbedType).CALENDAR),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $76Evp.messages).calendarViewToggleLabel))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7dQwL.SplitButton), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9B16h.default), {
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($lPup9))),
                        children: selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.board.boardName
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4a5Re.default), {
                        shouldRenderToParent: true,
                        // eslint-disable-next-line react/no-unstable-nested-components
                        trigger: (_param)=>/*#__PURE__*/ {
                            var { triggerRef: triggerRef } = _param, triggerProps = (0, $akGnX._)(_param, [
                                "triggerRef"
                            ]);
                            return (0, $loA2J.jsx)((0, $5XkWH.default), (0, $6iHNw._)((0, $7Knp0._)({
                                ref: triggerRef
                            }, triggerProps), {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4vcv5))),
                                label: intl.formatMessage((0, $76Evp.messages).selectBoardSplitButtonDropdownLabel)
                            }));
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $c3HvU.default), {
                            children: boardOptions.map((option)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $3Oabj.default), {
                                    onClick: ()=>handleSelectedBoardChange(option),
                                    isSelected: (selectedBoard === null || selectedBoard === void 0 ? void 0 : selectedBoard.board.boardId) === option.value,
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                                        children: option.label
                                    })
                                }, option.value))
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("7dQwL", function(module, exports) {

$parcel$export(module.exports, "SplitButton", function () { return $54227e2292b1c935$export$651ad66661acd392; });
/* split-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8fP1t = parcelRequire("8fP1t");

var $jxLBU = parcelRequire("jxLBU");

var $2i2fk = parcelRequire("2i2fk");

var $dUceh = parcelRequire("dUceh");
var $54227e2292b1c935$var$dividerStyles = {
    baseDivider: "_1bsbe4h9 _kqswh2mm _1pbykb7n",
    dividerDisabled: "_bfhkojnm _80om13gf _tzy41uwv",
    dividerDisabledRefreshed: "_bfhk9xzm _80om13gf",
    dividerOffsetRefreshed: "_195g1n1a"
};
var $54227e2292b1c935$var$dividerAppearanceStyles = {
    default: "_bfhk1fxt _tzy41uwv",
    primary: "_bfhk15cr _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
var $54227e2292b1c935$var$dividerRefreshedAppearanceStyles = {
    default: "_bfhkmuej",
    primary: "_bfhkveue _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
var $54227e2292b1c935$var$dividerHeightStyles = {
    default: "_4t3iviql",
    compact: "_4t3i1k8s"
};
// The divider height is calculated by subtracting twice the border width from the button height.
// This ensures the divider does not intersect with the button's border, avoiding visual issues
// caused by overlapping alpha colors (color.border) at the intersection.
var $54227e2292b1c935$var$defaultDividerHeightStyles = {
    default: "_4t3im1ee",
    compact: "_4t3i1hvu"
};
var $54227e2292b1c935$export$2e0a83ec2e27ecbb = function Divider(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
    var isDefaultDivider = appearance === "default" && !isDisabled && (0, $jxLBU.fg)("platform-component-visual-refresh");
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $8fP1t.default)([
            $54227e2292b1c935$var$dividerStyles.baseDivider,
            isDefaultDivider && $54227e2292b1c935$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $54227e2292b1c935$var$dividerHeightStyles[spacing],
            isDisabled && (0, $jxLBU.fg)("platform-component-visual-refresh") && $54227e2292b1c935$var$dividerStyles.dividerDisabledRefreshed,
            isDisabled && !(0, $jxLBU.fg)("platform-component-visual-refresh") && $54227e2292b1c935$var$dividerStyles.dividerDisabled,
            !isDisabled && (0, $jxLBU.fg)("platform-component-visual-refresh") && $54227e2292b1c935$var$dividerRefreshedAppearanceStyles[appearance],
            !isDisabled && !(0, $jxLBU.fg)("platform-component-visual-refresh") && $54227e2292b1c935$var$dividerAppearanceStyles[appearance],
            (0, $jxLBU.fg)("platform-component-visual-refresh") && $54227e2292b1c935$var$dividerStyles.dividerOffsetRefreshed
        ])
    });
};
var $54227e2292b1c935$var$buttonStyles = {
    splitButton: "_1e0c116y _kqswh2mm _4cvr1h6o _o5721q9c",
    primaryButton: "_traeidpf _anlpidpf _p9ykidpf _bepvidpf",
    secondaryButton: "_1j4hidpf _1553idpf _1qgbidpf _y1n3idpf",
    defaultAppearanceContainer: "_2rko1sit _12jimuej _1cwg1n1a _1qu2nqa1 _12y3t94y"
};
var $54227e2292b1c935$export$994ba1b4c598f7 = function SplitButtonContainer(_ref2) {
    var appearance = _ref2.appearance, children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $8fP1t.default)([
            appearance === "default" && !isDisabled && (0, $jxLBU.fg)("platform-component-visual-refresh") && $54227e2292b1c935$var$buttonStyles.defaultAppearanceContainer,
            $54227e2292b1c935$var$buttonStyles.splitButton
        ])
    }, children);
};
var $54227e2292b1c935$export$651ad66661acd392 = function SplitButton(_ref3) {
    var children = _ref3.children, _ref3$appearance = _ref3.appearance, appearance = _ref3$appearance === void 0 ? "default" : _ref3$appearance, _ref3$spacing = _ref3.spacing, spacing = _ref3$spacing === void 0 ? "default" : _ref3$spacing, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? false : _ref3$isDisabled;
    var _getActions = (0, $dUceh.getActions)(children), PrimaryAction = _getActions.PrimaryAction, SecondaryAction = _getActions.SecondaryAction;
    return /*#__PURE__*/ $iSvIT.createElement($54227e2292b1c935$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, /*#__PURE__*/ $iSvIT.createElement((0, $2i2fk.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $8fP1t.default)([
            $54227e2292b1c935$var$buttonStyles.primaryButton
        ])
    }, PrimaryAction), /*#__PURE__*/ $iSvIT.createElement($54227e2292b1c935$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $8fP1t.default)([
            $54227e2292b1c935$var$buttonStyles.secondaryButton
        ])
    }, SecondaryAction)));
};
var $54227e2292b1c935$export$e3ca81100b492e15 = function SplitButtonWithSlots(_ref4) {
    var primaryAction = _ref4.primaryAction, secondaryAction = _ref4.secondaryAction, _ref4$appearance = _ref4.appearance, appearance = _ref4$appearance === void 0 ? "default" : _ref4$appearance, _ref4$spacing = _ref4.spacing, spacing = _ref4$spacing === void 0 ? "default" : _ref4$spacing, _ref4$isDisabled = _ref4.isDisabled, isDisabled = _ref4$isDisabled === void 0 ? false : _ref4$isDisabled;
    return /*#__PURE__*/ $iSvIT.createElement($54227e2292b1c935$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, /*#__PURE__*/ $iSvIT.createElement((0, $2i2fk.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $8fP1t.default)([
            $54227e2292b1c935$var$buttonStyles.primaryButton
        ])
    }, primaryAction), /*#__PURE__*/ $iSvIT.createElement($54227e2292b1c935$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $8fP1t.default)([
            $54227e2292b1c935$var$buttonStyles.secondaryButton
        ])
    }, secondaryAction)));
};

});
parcelRegister("dUceh", function(module, exports) {

$parcel$export(module.exports, "getActions", function () { return $a1f9fdd49abd6bdb$export$fe3955935f564b31; });

var $98ZsH = parcelRequire("98ZsH");

var $iSvIT = parcelRequire("iSvIT");

var $XAEGR = parcelRequire("XAEGR");
var $a1f9fdd49abd6bdb$export$fe3955935f564b31 = function getActions(children) {
    var _Children$toArray = (0, $iSvIT.Children).toArray(children), _Children$toArray2 = (0, $98ZsH.default)(_Children$toArray, 2), PrimaryAction = _Children$toArray2[0], SecondaryAction = _Children$toArray2[1];
    typeof $XAEGR;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("76Evp", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $6c7d6891069d7e98$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $6c7d6891069d7e98$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    timelineViewToggleLabel: {
        id: "fastshift.migrations-management-page.jira-embed-view-toggle.timeline",
        defaultMessage: "Timeline",
        description: "Label for toggling to the Jira Board Timeline View"
    },
    calendarViewToggleLabel: {
        id: "fastshift.migrations-management-page.jira-embed-view-toggle.calendar",
        defaultMessage: "Calendar",
        description: "Label for toggling to the Jira Board Calendar View"
    },
    selectBoardSplitButtonDropdownLabel: {
        id: "fastshift.migrations-management-page.jira-embed-view-dropdown.label",
        defaultMessage: "More Boards",
        description: "Label for opening a split button dropdown to select from more boards"
    },
    logoAltText: {
        id: "fastshift.migrations-management-page.jira-embed-view-title.logo-alt-text",
        defaultMessage: "Project Icon",
        description: "Alt Text for project icon for the selected board"
    },
    havingTroubleSubtext: {
        id: "fastshift.migrations-management-page.having-trouble-subtext",
        defaultMessage: "Having trouble viewing the plan? <Link>Log in to your project</Link> and refresh the page.",
        description: "Subtext for the migrations management page under the migration planner"
    }
});

});

parcelRegister("7fNYC", function(module, exports) {

$parcel$export(module.exports, "CustomerDomainJiraBoardEmbedType", function () { return $eb01cb5c52732f4d$export$d373f8d380344366; });
var $eb01cb5c52732f4d$export$d373f8d380344366;
(function(CustomerDomainJiraBoardEmbedType) {
    CustomerDomainJiraBoardEmbedType["TIMELINE"] = "TIMELINE";
    CustomerDomainJiraBoardEmbedType["CALENDAR"] = "CALENDAR";
})($eb01cb5c52732f4d$export$d373f8d380344366 || ($eb01cb5c52732f4d$export$d373f8d380344366 = {}));

});



parcelRegister("azrUl", function(module, exports) {

$parcel$export(module.exports, "useJiraBoardEmbeds", function () { return $0620e654356cbda2$export$3252b8787313d9f9; });

var $iSvIT = parcelRequire("iSvIT");

var $8KnwD = parcelRequire("8KnwD");

var $7fNYC = parcelRequire("7fNYC");
const $0620e654356cbda2$var$getEmbedUrlByType = (board, type)=>{
    var _board_embeds_find;
    var _board_embeds_find_url;
    return (_board_embeds_find_url = board === null || board === void 0 ? void 0 : (_board_embeds_find = board.embeds.find((embed)=>embed.type === type)) === null || _board_embeds_find === void 0 ? void 0 : _board_embeds_find.url) !== null && _board_embeds_find_url !== void 0 ? _board_embeds_find_url : null;
};
const $0620e654356cbda2$export$3252b8787313d9f9 = ()=>{
    const { data: engagementData } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomainEngagement);
    const [selectedBoard, setSelectedBoard] = (0, $iSvIT.useState)(null);
    const boards = (0, $iSvIT.useMemo)(()=>{
        return engagementData ? engagementData.engagementProjects.flatMap((project)=>project.boards.map((board)=>{
                const timelineUrl = $0620e654356cbda2$var$getEmbedUrlByType(board, (0, $7fNYC.CustomerDomainJiraBoardEmbedType).TIMELINE);
                const calendarUrl = $0620e654356cbda2$var$getEmbedUrlByType(board, (0, $7fNYC.CustomerDomainJiraBoardEmbedType).CALENDAR);
                if (!timelineUrl && !calendarUrl) return null;
                return {
                    timelineUrl: timelineUrl,
                    calendarUrl: calendarUrl,
                    selectedView: timelineUrl ? (0, $7fNYC.CustomerDomainJiraBoardEmbedType).TIMELINE : (0, $7fNYC.CustomerDomainJiraBoardEmbedType).CALENDAR,
                    board: board,
                    projectName: project.projectName,
                    projectIcon: project.projectIcon,
                    projectKey: project.projectKey
                };
            })).filter((boardState)=>boardState !== null) : [];
    }, [
        engagementData
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (boards.length > 0 && boards[0]) setSelectedBoard(boards[0]);
    }, [
        boards
    ]);
    const selectedEmbedViewUrl = (0, $iSvIT.useMemo)(()=>{
        if (!selectedBoard) return null;
        switch(selectedBoard.selectedView){
            case (0, $7fNYC.CustomerDomainJiraBoardEmbedType).CALENDAR:
                return selectedBoard.calendarUrl;
            case (0, $7fNYC.CustomerDomainJiraBoardEmbedType).TIMELINE:
                return selectedBoard.timelineUrl;
            default:
                return null;
        }
    }, [
        selectedBoard
    ]);
    return {
        boards: boards,
        selectedBoard: selectedBoard,
        setSelectedBoard: setSelectedBoard,
        selectedEmbedViewUrl: selectedEmbedViewUrl
    };
};

});



parcelRegister("SxcVD", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $a8b639285964a4ea$export$defe85febe8b728c; });

var $abcSr = parcelRequire("abcSr");
const $a8b639285964a4ea$export$defe85febe8b728c = (0, $abcSr.defineMessages)({
    pageHeading: {
        id: "fastshift.migrations-management-page.page-heading",
        defaultMessage: "Migration planning",
        description: "Heading for the migrations management page"
    },
    pageHeadingSubtext: {
        id: "fastshift.migrations-management-page.page-heading-subtext",
        defaultMessage: "Monitor your migration progress and review upcoming tasks to make sure everything stays on track.",
        description: "Subtext for the migrations management page under the heading"
    },
    genericErrorDescription: {
        id: "fastshift.migrations-management-page.error-display.generic-error.description",
        defaultMessage: "We couldn\u2019t retrieve the data.",
        description: "Description for error message displayed when an unknown error occurs, for example 500 internal server error, or server returns empty data"
    }
});

});
parcelRegister("abcSr", function(module, exports) {
$parcel$export(module.exports, "IntlError", function () { return (parcelRequire("lP6cc")).IntlError; });
$parcel$export(module.exports, "IntlErrorCode", function () { return (parcelRequire("lP6cc")).IntlErrorCode; });
$parcel$export(module.exports, "InvalidConfigError", function () { return (parcelRequire("lP6cc")).InvalidConfigError; });
$parcel$export(module.exports, "MessageFormatError", function () { return (parcelRequire("lP6cc")).MessageFormatError; });
$parcel$export(module.exports, "MissingDataError", function () { return (parcelRequire("lP6cc")).MissingDataError; });
$parcel$export(module.exports, "MissingTranslationError", function () { return (parcelRequire("lP6cc")).MissingTranslationError; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return (parcelRequire("lP6cc")).UnsupportedFormatterError; });

$parcel$export(module.exports, "defineMessages", function () { return $7694eb9745783ce8$export$1adfeb024f5185b; });


var $8NEa0 = parcelRequire("8NEa0");
parcelRequire("lP6cc");

var $jmp3h = parcelRequire("jmp3h");







var $iGRAf = parcelRequire("iGRAf");
function $7694eb9745783ce8$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $7694eb9745783ce8$export$747d244ee58120dd(msg) {
    return msg;
}

});





parcelRegister("hWMXK", function(module, exports) {

$parcel$export(module.exports, "PageLayout", function () { return $2ffb23b5bf99737b$export$6d1402fb58384e4f; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $laIa3 = parcelRequire("laIa3");

var $f6qj2 = parcelRequire("f6qj2");

var $hea8X = parcelRequire("hea8X");

var $6hUR8 = parcelRequire("6hUR8");

var $iCoid = parcelRequire("iCoid");

var $e2uDT = parcelRequire("e2uDT");

var $2W9NO = parcelRequire("2W9NO");

var $irAt9 = parcelRequire("irAt9");
var $kxCzi = parcelRequire("kxCzi");
var $9emui = parcelRequire("9emui");
var $kNBG6 = parcelRequire("kNBG6");

var $6WUrJ = parcelRequire("6WUrJ");
var $5t82q = parcelRequire("5t82q");
var $fXAq9 = parcelRequire("fXAq9");

var $45W3N = parcelRequire("45W3N");

var $ljksb = parcelRequire("ljksb");

var $etUAM = parcelRequire("etUAM");

var $jKp9A = parcelRequire("jKp9A");
var $7akU3 = parcelRequire("7akU3");
var $jAMCU = parcelRequire("jAMCU");
parcelRequire("gL1Hw");
var $e1z14 = parcelRequire("e1z14");
parcelRequire("4XYQf");
var $dB3mG = parcelRequire("dB3mG");
parcelRequire("8wCJ8");
var $jVPPg = parcelRequire("jVPPg");

var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");
parcelRequire("5m8h9");
var $5wrp0 = parcelRequire("5wrp0");

var $9OyVr = parcelRequire("9OyVr");

var $dO2cs = parcelRequire("dO2cs");
parcelRequire("jCR8P");
var $g1CGj = parcelRequire("g1CGj");
parcelRequire("eFHR3");
var $jGM2I = parcelRequire("jGM2I");
parcelRequire("h4ybs");
var $cPOxq = parcelRequire("cPOxq");
var $c14sc = parcelRequire("c14sc");
var $grNmQ = parcelRequire("grNmQ");

var $d5VIE = parcelRequire("d5VIE");

var $HPkW5 = parcelRequire("HPkW5");
const $2ffb23b5bf99737b$var$mainStyles = (0, $jAMCU.xcss)({
    padding: "space.200"
});
// Adapter to convert BaseLogoProps to LogoProps for AppLogo
// resolves incompatible typing issues from package versioning
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2ffb23b5bf99737b$var$AtlassianAdminIconAdapter = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $6hUR8.AtlassianAdminIcon), (0, $7Knp0._)({}, props));
const $2ffb23b5bf99737b$var$staticValueForTestingOnly = {
    userAccessState: (0, $d5VIE.UserAccessValidationState).VALIDATION_SUCCESS,
    shouldShowSideNav: true,
    isPartnerOrInternal: true
};
const $2ffb23b5bf99737b$export$6d1402fb58384e4f = ()=>{
    const { domainId: domainId } = (0, $hea8X.useParams)();
    const isDisableAuthHookForTestingOnlyEnabled = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).sxpFastshiftPortalDisableAuthHookTestingOnly);
    const isFastshiftChatWidgetEnabled = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).sxpFastshiftPortalChatAgent);
    const isCustomerFeedbackEnabled = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).sxpFastshiftPortalEnableCustomerFeedback);
    const accessControlState = (0, $d5VIE.usePortalAuthenticationAndAccessControl)();
    const { userAccessState: userAccessState, shouldShowSideNav: shouldShowSideNav, isPartnerOrInternal: isPartnerOrInternal } = isDisableAuthHookForTestingOnlyEnabled ? $2ffb23b5bf99737b$var$staticValueForTestingOnly : accessControlState;
    const shouldDisplayAIChatWidget = isFastshiftChatWidgetEnabled && !accessControlState.isOnHomeRoute && (accessControlState.userAccessState === (0, $d5VIE.UserAccessValidationState).VALIDATION_SUCCESS || isDisableAuthHookForTestingOnlyEnabled);
    const shouldDisplayFeedbackCollector = (0, $iSvIT.useMemo)(()=>{
        return isCustomerFeedbackEnabled && accessControlState.userAccessState === (0, $d5VIE.UserAccessValidationState).VALIDATION_SUCCESS;
    }, [
        isCustomerFeedbackEnabled,
        accessControlState
    ]);
    (0, $cPOxq.useLoadDomainScopedState)(domainId || "");
    const { pageKey: pageKey, links: pageMenuItems, isOnDomainScopedPage: isOnDomainScopedPage } = (0, $c14sc.usePageNavLinks)();
    const { sendSideNavLinkClickEvent: sendSideNavLinkClickEvent } = (0, $grNmQ.usePageLayoutAnalytics)();
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $2W9NO.Root), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6WUrJ.TopNav), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)($laIa3.ErrorBoundary, {
                    beforeCapture: (0, $dO2cs.beforeCaptureWithScope)("top-nav"),
                    fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5wrp0.GenericErrorDisplay), {}),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fXAq9.TopNavStart), {
                            children: [
                                shouldShowSideNav && /*#__PURE__*/ (0, $loA2J.jsx)((0, $kNBG6.SideNavToggleButton), {
                                    defaultCollapsed: true,
                                    collapseLabel: formatMessage((0, $HPkW5.messages).collapseSidebarLabel),
                                    expandLabel: formatMessage((0, $HPkW5.messages).expandSidebarLabel)
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $etUAM.AppLogo), {
                                    icon: $2ffb23b5bf99737b$var$AtlassianAdminIconAdapter,
                                    name: formatMessage((0, $HPkW5.messages).fastshiftAppName),
                                    label: formatMessage((0, $HPkW5.messages).homePageLabel),
                                    href: (0, $9OyVr.FASTSHIFT_HOME_PATH)
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $iCoid.default), {
                                    appearance: "removed",
                                    children: formatMessage((0, $HPkW5.messages).betaLozenge)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5t82q.TopNavEnd), {
                            children: [
                                shouldDisplayFeedbackCollector && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dB3mG.FeedbackCollector), {}),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jVPPg.NavigationProfile), {})
                            ]
                        })
                    ]
                })
            }),
            shouldShowSideNav && /*#__PURE__*/ (0, $loA2J.jsx)((0, $irAt9.SideNav), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)($laIa3.ErrorBoundary, {
                    beforeCapture: (0, $dO2cs.beforeCaptureWithScope)("side-nav"),
                    fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5wrp0.GenericErrorDisplay), {}),
                    children: [
                        isPartnerOrInternal && isOnDomainScopedPage && /*#__PURE__*/ (0, $loA2J.jsx)((0, $9emui.SideNavHeader), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jGM2I.DomainScopedNavHeader), {
                                isOnDomainScopedPage: isOnDomainScopedPage
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $kxCzi.SideNavContent), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ljksb.MenuList), {
                                children: pageMenuItems.map((navItem)=>{
                                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $45W3N.LinkMenuItem), {
                                        href: navItem.link || "",
                                        elemBefore: navItem.icon,
                                        isSelected: navItem.key == pageKey,
                                        onClick: ()=>{
                                            sendSideNavLinkClickEvent(navItem.label, navItem.link || "", isOnDomainScopedPage);
                                        },
                                        children: navItem.label
                                    }, navItem.key);
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $e2uDT.Main), {
                testId: "main",
                id: "main",
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                    alignInline: "center",
                    children: [
                        shouldDisplayAIChatWidget && /*#__PURE__*/ (0, $loA2J.jsx)((0, $e1z14.AIChatWidget), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $g1CGj.AccessControlledPageContent), {
                            userAccessState: userAccessState,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
                                xcss: $2ffb23b5bf99737b$var$mainStyles,
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($laIa3.ErrorBoundary, {
                                    beforeCapture: (0, $dO2cs.beforeCaptureWithScope)("page-content"),
                                    fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5wrp0.GenericErrorDisplay), {}),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hea8X.Outlet), {})
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("e2uDT", function(module, exports) {

$parcel$export(module.exports, "Main", function () { return $a389058a08742fe6$export$861edd1ccea2f746; });
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $jxLBU = parcelRequire("jxLBU");

var $hA2VN = parcelRequire("hA2VN");


var $4lOHN = parcelRequire("4lOHN");
var $a389058a08742fe6$var$mainElementStyles = {
    root: "_nd5l1gzg _1reo1wug _18m91wug _19121cl4 _152timx3 _qwfh1wug _165teqxy _13wn1if8",
    containPaint: "_njlp1t7j"
};
function $a389058a08742fe6$export$861edd1ccea2f746(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? "Main Content" : _ref$skipLinkLabel, testId = _ref.testId, providedId = _ref.id;
    var id = (0, $4lOHN.useLayoutId)({
        providedId: providedId
    });
    (0, $hA2VN.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ $iSvIT.createElement("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $8lTdX.default)([
            $a389058a08742fe6$var$mainElementStyles.root,
            (0, $jxLBU.fg)("platform_dst_nav4_layering_in_main_slot_fixes") && $a389058a08742fe6$var$mainElementStyles.containPaint,
            xcss
        ]),
        role: "main",
        "data-testid": testId
    }, children));
}

});
parcelRegister("8lTdX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $614b1f3b4148b8d1$export$2e2bcd8739ae039; });
const $614b1f3b4148b8d1$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $614b1f3b4148b8d1$var$ATOMIC_GROUP_LENGTH = 5;
function $614b1f3b4148b8d1$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $614b1f3b4148b8d1$var$UNDERSCORE_UNICODE ? $614b1f3b4148b8d1$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("hA2VN", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", function () { return $ccc81287ad34f056$export$4c5cc3b14c7678a; });
$parcel$export(module.exports, "useSkipLinkInternal", function () { return $ccc81287ad34f056$export$707b94c26b8b75aa; });
$parcel$export(module.exports, "useSkipLink", function () { return $ccc81287ad34f056$export$89d9323301efc7d6; });

var $iSvIT = parcelRequire("iSvIT");

var $emfh8 = parcelRequire("emfh8");
var $ccc81287ad34f056$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $iSvIT.createContext)({
    registerSkipLink: (0, $emfh8.default),
    unregisterSkipLink: (0, $emfh8.default)
});
var $ccc81287ad34f056$var$useSkipLinks = function useSkipLinks() {
    return (0, $iSvIT.useContext)($ccc81287ad34f056$export$4c5cc3b14c7678a);
};
var $ccc81287ad34f056$export$707b94c26b8b75aa = function useSkipLinkInternal(_ref) {
    var id = _ref.id, label = _ref.label, listIndex = _ref.listIndex, onBeforeNavigate = _ref.onBeforeNavigate, isHidden = _ref.isHidden;
    var _useSkipLinks = $ccc81287ad34f056$var$useSkipLinks(), registerSkipLink = _useSkipLinks.registerSkipLink, unregisterSkipLink = _useSkipLinks.unregisterSkipLink;
    (0, $iSvIT.useEffect)(function() {
        if (isHidden) /**
       * Skip links are hidden for slots with 0 height or width.
       * They should not be registered.
       */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return function() {
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
var $ccc81287ad34f056$export$89d9323301efc7d6 = function useSkipLink(id, label, listIndex) {
    $ccc81287ad34f056$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});
parcelRegister("emfh8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a73ef824e40c84bb$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $a73ef824e40c84bb$export$2e2bcd8739ae039() {}

});


parcelRegister("4lOHN", function(module, exports) {

$parcel$export(module.exports, "useLayoutId", function () { return $32b0749fa9bc1b45$export$110c3550c7c1c9aa; });

var $5CqIy = parcelRequire("5CqIy");
function $32b0749fa9bc1b45$export$fa3cfac0c8e29c5c() {
    var uniqueId = (0, $5CqIy.useId)();
    return uniqueId;
}
function $32b0749fa9bc1b45$export$110c3550c7c1c9aa() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, providedId = _ref.providedId;
    var uniqueId = $32b0749fa9bc1b45$export$fa3cfac0c8e29c5c();
    var id = providedId ? providedId : uniqueId;
    return id;
}

});
parcelRegister("5CqIy", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $417539ea7b0ec43f$export$f680877a34711e37; });
$parcel$export(module.exports, "useIdSeed", function () { return $417539ea7b0ec43f$export$6ee17796e3d70de2; });

var $dMCdc = parcelRequire("dMCdc");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $jxLBU = parcelRequire("jxLBU");
var $417539ea7b0ec43f$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $417539ea7b0ec43f$var$react18UseId = ($417539ea7b0ec43f$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $417539ea7b0ec43f$var$_React$useId !== void 0 ? $417539ea7b0ec43f$var$_React$useId : undefined;
function $417539ea7b0ec43f$export$f680877a34711e37() {
    if ($417539ea7b0ec43f$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) return $417539ea7b0ec43f$var$react18UseId();
    return "uid".concat((0, $lzzak.useUID)());
}
var $417539ea7b0ec43f$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($417539ea7b0ec43f$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $dMCdc.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $dMCdc.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $417539ea7b0ec43f$export$6ee17796e3d70de2() {
    if ($417539ea7b0ec43f$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        var uid = $417539ea7b0ec43f$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $lzzak.useUIDSeed)();
}

});
parcelRegister("dMCdc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a08d66294e9ec71f$export$2e2bcd8739ae039; });
function $a08d66294e9ec71f$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a08d66294e9ec71f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a08d66294e9ec71f$export$2e2bcd8739ae039(o);
}

});




parcelRegister("2W9NO", function(module, exports) {

$parcel$export(module.exports, "gridRootId", function () { return $22389a17ed50d4ec$export$a6d827031bcb31d1; });
$parcel$export(module.exports, "Root", function () { return $22389a17ed50d4ec$export$be92b6f5f03c0fe9; });
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8lTdX = parcelRequire("8lTdX");

var $iSvIT = parcelRequire("iSvIT");

var $lUOdI = parcelRequire("lUOdI");

var $jxLBU = parcelRequire("jxLBU");

var $biEPH = parcelRequire("biEPH");

var $eyp4T = parcelRequire("eyp4T");

var $2SmDo = parcelRequire("2SmDo");

var $7eVqT = parcelRequire("7eVqT");

var $bLRT0 = parcelRequire("bLRT0");

var $jOmA4 = parcelRequire("jOmA4");

var $4j1RV = parcelRequire("4j1RV");
var $22389a17ed50d4ec$export$a6d827031bcb31d1 = "unsafe-design-system-page-layout-root";
var $22389a17ed50d4ec$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $22389a17ed50d4ec$export$be92b6f5f03c0fe9(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$UNSAFE_dangerous = _ref.UNSAFE_dangerouslyHoistSlotSizes, UNSAFE_dangerouslyHoistSlotSizes = _ref$UNSAFE_dangerous === void 0 ? false : _ref$UNSAFE_dangerous, _ref$skipLinksLabel = _ref.skipLinksLabel, skipLinksLabel = _ref$skipLinksLabel === void 0 ? "Skip to:" : _ref$skipLinksLabel, testId = _ref.testId;
    var ref = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(function() {
        var IGNORED_ELEMENTS;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4j1RV.SideNavVisibilityProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $jOmA4.SideNavToggleButtonProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bLRT0.SideNavElementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2SmDo.TopNavStartProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lUOdI.OpenLayerObserver), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7eVqT.DangerouslyHoistSlotSizes).Provider, {
        value: UNSAFE_dangerouslyHoistSlotSizes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eyp4T.SkipLinksProvider), {
        label: skipLinksLabel,
        testId: testId
    }, !(0, $jxLBU.fg)("platform_dst_nav4_skip_links_hydration_fix") && /*#__PURE__*/ // SkipLinksContainer is rendered directly inside SkipLinksProvider when the FG is enabled.
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $biEPH.SkipLinksContainer), {
        label: skipLinksLabel,
        testId: testId,
        links: // The links prop won't be used when the FG is disabled.
        []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        ref: ref,
        className: (0, $8lTdX.default)([
            $22389a17ed50d4ec$var$styles.root,
            xcss
        ]),
        id: $22389a17ed50d4ec$export$a6d827031bcb31d1,
        "data-testid": testId
    }, children))))))));
}

});
parcelRegister("lUOdI", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserver", function () { return $ff45c8a254bb585b$export$97afddda23bcd287; });

var $eaALl = parcelRequire("eaALl");

var $iSvIT = parcelRequire("iSvIT");

var $jNYFj = parcelRequire("jNYFj");

var $ktFjJ = parcelRequire("ktFjJ");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ var $ff45c8a254bb585b$var$noNamespaceSymbol = Symbol("no-namespace");
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $ff45c8a254bb585b$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce(function(acc, listeners) {
        return acc + listeners.size;
    }, 0);
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $ff45c8a254bb585b$var$getListeners(_ref) {
    var registry = _ref.registry, namespace = _ref.namespace;
    // 1. If there are existing listeners for this namespace, return the existing set.
    var existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    var newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $ff45c8a254bb585b$var$createInternalAPI() {
    /**
   * The layer count change listeners for each namespace.
   */ var namespaceToChangeListenerRegistry = new Map();
    /**
   * The `onClose` listeners for each namespace.
   * Each layer provides an `onClose` callback. **When the layer is open**, its `onClose`
   * callback is registered in this set.
   *
   * This data structure is also used determine the number of open layers.
   */ var namespaceToLayerCloseListenerRegistry = new Map();
    /**
   * Calls the appropriate layer count change listeners after the number of open layers has changed.
   */ function callChangeListeners(_ref2) {
        var namespace = _ref2.namespace, newCount = _ref2.newCount;
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            var listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace !== null && listenersForNamespace !== void 0 ? listenersForNamespace : []).forEach(function(listener) {
                return listener({
                    count: newCount
                });
            });
        }
        // 2. Call listeners registered without a specific namespace
        var noNamespaceListeners = namespaceToChangeListenerRegistry.get($ff45c8a254bb585b$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        var totalCount = $ff45c8a254bb585b$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
        Array.from(noNamespaceListeners).forEach(function(listener) {
            return listener({
                count: totalCount
            });
        });
    }
    /**
   * Returns the current count of open layers.
   *
   * If a namespace is provided, the count for that namespace is returned.
   * Otherwise, the sum of all namespace counts is returned.
   */ function getCount() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, namespace = _ref3.namespace;
        if (namespace) {
            var _namespaceToLayerClos, _namespaceToLayerClos2;
            return (_namespaceToLayerClos = (_namespaceToLayerClos2 = namespaceToLayerCloseListenerRegistry.get(namespace)) === null || _namespaceToLayerClos2 === void 0 ? void 0 : _namespaceToLayerClos2.size) !== null && _namespaceToLayerClos !== void 0 ? _namespaceToLayerClos : 0;
        }
        // A specific namespace was not requested, so we return the sum across all namespaces.
        return $ff45c8a254bb585b$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
    }
    /**
   * Adds a listener that will be called when the number of open layers changes.
   *
   * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
   */ function onChange(listener) {
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, providedNamespace = _ref4.namespace;
        /**
     * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
     * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
     * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
     */ function wrapped() {
            listener.apply(void 0, arguments);
        }
        var namespace = providedNamespace !== null && providedNamespace !== void 0 ? providedNamespace : $ff45c8a254bb585b$var$noNamespaceSymbol;
        var listenersForNamespace = $ff45c8a254bb585b$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
   * Adds a listener to the registry that tells the observer how to close the layer component.
   * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
   *
   * All close listeners will be called by the observer when `closeLayers` is called.
   *
   * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
   */ function onClose(listener, _ref5) {
        var providedNamespace = _ref5.namespace;
        /**
     * We are wrapping the passed listener in a function to ensure that each call to `onClose` creates a unique
     * function reference. This is to handle scenarios where the same function is provided to several different `onClose`
     * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
     */ function wrapped() {
            listener();
        }
        var namespace = providedNamespace !== null && providedNamespace !== void 0 ? providedNamespace : $ff45c8a254bb585b$var$noNamespaceSymbol;
        var listenersForNamespace = $ff45c8a254bb585b$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerCloseListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerCloseListenerRegistry.delete(namespace);
        };
    }
    /**
   * Closes all open layers registered across all namespaces.
   */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerCloseListenerRegistry.values()).forEach(function(listeners) {
            Array.from(listeners).forEach(function(listener) {
                return listener();
            });
        });
    }
    var internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $ff45c8a254bb585b$export$97afddda23bcd287(_ref6) {
    var children = _ref6.children;
    // Using state to ensure a stable reference to a single instance.
    var _useState = (0, $iSvIT.useState)(function() {
        return $ff45c8a254bb585b$var$createInternalAPI();
    }), _useState2 = (0, $eaALl.default)(_useState, 1), internalAPI = _useState2[0];
    var parentContext = (0, $iSvIT.useContext)((0, $ktFjJ.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $jNYFj.default)(parentContext === null, "`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ktFjJ.OpenLayerObserverContext).Provider, {
        value: internalAPI
    }, children);
}

});
parcelRegister("eaALl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a50e842cc97c1aea$export$2e2bcd8739ae039; });

var $MDnlE = parcelRequire("MDnlE");

var $b51CI = parcelRequire("b51CI");

var $2f4BU = parcelRequire("2f4BU");

var $22NvC = parcelRequire("22NvC");
function $a50e842cc97c1aea$export$2e2bcd8739ae039(r, e) {
    return (0, $MDnlE.default)(r) || (0, $b51CI.default)(r, e) || (0, $2f4BU.default)(r, e) || (0, $22NvC.default)();
}

});
parcelRegister("MDnlE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $092306fae1b4d60d$export$2e2bcd8739ae039; });
function $092306fae1b4d60d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("b51CI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81116bbd111b65ae$export$2e2bcd8739ae039; });
function $81116bbd111b65ae$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("22NvC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17d22c2276efb71b$export$2e2bcd8739ae039; });
function $17d22c2276efb71b$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("biEPH", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContainer", function () { return $83a10cae8f045382$export$fce25a0c32fbc1e1; });
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $9EBzK = parcelRequire("9EBzK");

var $blkUm = parcelRequire("blkUm");

var $4fpbm = parcelRequire("4fpbm");
var $83a10cae8f045382$var$styles = {
    root: "_zulp1b66 _2rkoglpi _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    skipLinkList: "_zulp1b66 _1e0c1txw _2lx21bp4 _1x8w11lx _2mzuglyw _1pfhze3t _bozgze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them when the user presses Escape, when
 * they press TAB it will reopen the list and move to the next one...
 *
 * One potential option is to use a tree walker to focus on the
 * next focusable element in the DOM (outside the skip links
 * container).
 */ var $83a10cae8f045382$var$closeOnEscape = function closeOnEscape(event) {
    if (event.key !== "Escape") return;
    var activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
var $83a10cae8f045382$var$isOnlyWhitespaceRegex = /^\s*$/;
function $83a10cae8f045382$export$fce25a0c32fbc1e1(_ref) {
    var label = _ref.label, testId = _ref.testId, links = _ref.links;
    var sortedLinks = (0, $blkUm.useSortedSkipLinks)(links);
    if (sortedLinks.length === 0) return null;
    var isEmptyLabel = $83a10cae8f045382$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        onKeyDown: $83a10cae8f045382$var$closeOnEscape,
        "data-testid": testId ? "".concat(testId, "--skip-links-container") : undefined,
        className: (0, $8lTdX.default)([
            $83a10cae8f045382$var$styles.root
        ])
    }, !isEmptyLabel && /*#__PURE__*/ $iSvIT.createElement((0, $9EBzK.default), {
        weight: "bold",
        testId: testId ? "".concat(testId, "--skip-links-container--label") : undefined
    }, label), /*#__PURE__*/ $iSvIT.createElement("ol", {
        className: (0, $8lTdX.default)([
            $83a10cae8f045382$var$styles.skipLinkList
        ])
    }, sortedLinks.map(function(_ref2) {
        var id = _ref2.id, label = _ref2.label, onBeforeNavigate = _ref2.onBeforeNavigate;
        return /*#__PURE__*/ $iSvIT.createElement((0, $4fpbm.SkipLink), {
            key: id,
            id: id,
            onBeforeNavigate: onBeforeNavigate
        }, label);
    })));
}

});
parcelRegister("9EBzK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7074ff3a6266ecfe$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $jNYFj = parcelRequire("jNYFj");

var $7Jyon = parcelRequire("7Jyon");

var $39nwL = parcelRequire("39nwL");
var $7074ff3a6266ecfe$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $7074ff3a6266ecfe$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $39nwL.useSurface)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($7074ff3a6266ecfe$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $7074ff3a6266ecfe$export$2185ce37f9bdd963[surface];
    return "color.text";
};
var $7074ff3a6266ecfe$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    "as.strong": "_k48pmoej",
    "as.em": "_zg8l1m30",
    "textAlign.center": "_y3gn1h6o",
    "textAlign.end": "_y3gnh9n0",
    "textAlign.start": "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $7074ff3a6266ecfe$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $7074ff3a6266ecfe$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $7074ff3a6266ecfe$var$textColorMap = {
    "color.text": "_syaz1fxt",
    "color.text.accent.lime": "_syaz1tco",
    "color.text.accent.lime.bolder": "_syaz1ik3",
    "color.text.accent.red": "_syaz9lu1",
    "color.text.accent.red.bolder": "_syazhwvp",
    "color.text.accent.orange": "_syaz1q28",
    "color.text.accent.orange.bolder": "_syaz1vps",
    "color.text.accent.yellow": "_syazfb2s",
    "color.text.accent.yellow.bolder": "_syazekll",
    "color.text.accent.green": "_syazh55r",
    "color.text.accent.green.bolder": "_syaz1y78",
    "color.text.accent.teal": "_syaz17qg",
    "color.text.accent.teal.bolder": "_syaz12v7",
    "color.text.accent.blue": "_syazpnps",
    "color.text.accent.blue.bolder": "_syazsc1o",
    "color.text.accent.purple": "_syaz10m5",
    "color.text.accent.purple.bolder": "_syaz2ibx",
    "color.text.accent.magenta": "_syaz1s8m",
    "color.text.accent.magenta.bolder": "_syaz1qur",
    "color.text.accent.gray": "_syaz1dyx",
    "color.text.accent.gray.bolder": "_syaz1x9z",
    "color.text.disabled": "_syaz1lh4",
    "color.text.inverse": "_syaz15cr",
    "color.text.selected": "_syazaqb7",
    "color.text.brand": "_syaz1e6v",
    "color.text.danger": "_syaz1tmw",
    "color.text.warning": "_syazwx40",
    "color.text.warning.inverse": "_syazal3n",
    "color.text.success": "_syazy73q",
    "color.text.discovery": "_syazzjem",
    "color.text.information": "_syaze0os",
    "color.text.subtlest": "_syaz131l",
    "color.text.subtle": "_syaz1gjq",
    "color.link": "_syaz14q2",
    "color.link.pressed": "_syaz16c2",
    "color.link.visited": "_syazw7te",
    "color.link.visited.pressed": "_syazg3x0"
};
var $7074ff3a6266ecfe$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $7074ff3a6266ecfe$var$Text = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $jNYFj.default)($7074ff3a6266ecfe$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $7Jyon.useHasTextAncestor)();
    var color = $7074ff3a6266ecfe$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = /*#__PURE__*/ $iSvIT.createElement(Component, {
        id: id,
        className: (0, $8lTdX.default)([
            $7074ff3a6266ecfe$var$styles.root,
            size && $7074ff3a6266ecfe$var$fontSizeMap[size],
            color && $7074ff3a6266ecfe$var$textColorMap[color],
            maxLines && $7074ff3a6266ecfe$var$styles.truncation,
            maxLines === 1 && $7074ff3a6266ecfe$var$styles.breakAll,
            align && $7074ff3a6266ecfe$var$styles["textAlign.".concat(align)],
            weight && $7074ff3a6266ecfe$var$fontWeightMap[weight],
            Component === "em" && $7074ff3a6266ecfe$var$styles["as.em"],
            Component === "strong" && $7074ff3a6266ecfe$var$styles["as.strong"],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $iSvIT.createElement((0, $7Jyon.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $7074ff3a6266ecfe$export$2e2bcd8739ae039 = $7074ff3a6266ecfe$var$Text;

});
parcelRegister("7Jyon", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", function () { return $5a1769eefb7438f8$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $5a1769eefb7438f8$export$ae933c6cbe5643ad; });

var $iSvIT = parcelRequire("iSvIT");
var $5a1769eefb7438f8$var$HasTextAncestorContext = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
var $5a1769eefb7438f8$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $iSvIT.useContext)($5a1769eefb7438f8$var$HasTextAncestorContext);
};
var $5a1769eefb7438f8$export$ae933c6cbe5643ad = $5a1769eefb7438f8$var$HasTextAncestorContext.Provider;

});

parcelRegister("39nwL", function(module, exports) {

$parcel$export(module.exports, "useSurface", function () { return $24b476660bac1759$export$1aeb4f6b93c4540d; });

var $iSvIT = parcelRequire("iSvIT");
var $24b476660bac1759$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $24b476660bac1759$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($24b476660bac1759$export$1ca2a26fecb070ae);
};
$24b476660bac1759$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("blkUm", function(module, exports) {

$parcel$export(module.exports, "SkipLinksDataContext", function () { return $8421dfca825b6c13$export$e9ab38ce6147d3d2; });
$parcel$export(module.exports, "useSortedSkipLinks", function () { return $8421dfca825b6c13$export$b0b0d4fc1b356759; });

var $lcRu8 = parcelRequire("lcRu8");

var $eLTr6 = parcelRequire("eLTr6");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");
function $8421dfca825b6c13$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8421dfca825b6c13$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8421dfca825b6c13$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8421dfca825b6c13$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8421dfca825b6c13$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $iSvIT.createContext)([]);
var $8421dfca825b6c13$var$_assignIndex = function assignIndex(num, arr) {
    if (!arr.includes(num)) return num;
    return $8421dfca825b6c13$var$_assignIndex(num + 1, arr);
};
var $8421dfca825b6c13$export$fa48cafc8c96d283 = function sortSkipLinks(arr) {
    var customLinks = arr.filter(function(link) {
        return Number.isInteger(link.listIndex);
    });
    if (customLinks.length === 0) return arr;
    var usedIndexes = customLinks.map(function(a) {
        return a.listIndex;
    });
    var regularLinksWithIndex = arr.filter(function(link) {
        return link.listIndex === undefined;
    }).map(function(link, index) {
        var listIndex = $8421dfca825b6c13$var$_assignIndex(index, usedIndexes);
        usedIndexes.push(listIndex);
        return $8421dfca825b6c13$var$_objectSpread($8421dfca825b6c13$var$_objectSpread({}, link), {}, {
            listIndex: listIndex
        });
    });
    return [].concat((0, $lcRu8.default)(customLinks), (0, $lcRu8.default)(regularLinksWithIndex)).sort(function(a, b) {
        return a.listIndex - b.listIndex;
    });
};
function $8421dfca825b6c13$export$b0b0d4fc1b356759(providedLinks) {
    var skipLinksData = (0, $iSvIT.useContext)($8421dfca825b6c13$export$e9ab38ce6147d3d2);
    var links = (0, $jxLBU.fg)("platform_dst_nav4_skip_links_hydration_fix") ? providedLinks : skipLinksData;
    return (0, $iSvIT.useMemo)(function() {
        return $8421dfca825b6c13$export$fa48cafc8c96d283(links);
    }, [
        links
    ]);
}

});
parcelRegister("lcRu8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f70434f6a39e372b$export$2e2bcd8739ae039; });

var $8X6gh = parcelRequire("8X6gh");

var $dbENg = parcelRequire("dbENg");

var $fszTJ = parcelRequire("fszTJ");

var $4m67l = parcelRequire("4m67l");
function $f70434f6a39e372b$export$2e2bcd8739ae039(r) {
    return (0, $8X6gh.default)(r) || (0, $dbENg.default)(r) || (0, $fszTJ.default)(r) || (0, $4m67l.default)();
}

});
parcelRegister("8X6gh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6848b0d282204c03$export$2e2bcd8739ae039; });

var $5r0F6 = parcelRequire("5r0F6");
function $6848b0d282204c03$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5r0F6.default)(r);
}

});
parcelRegister("5r0F6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f4ffccbda2b4d99$export$2e2bcd8739ae039; });
function $3f4ffccbda2b4d99$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("dbENg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $999bf22ee4250602$export$2e2bcd8739ae039; });
function $999bf22ee4250602$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("fszTJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b415511edca28cd4$export$2e2bcd8739ae039; });

var $5r0F6 = parcelRequire("5r0F6");
function $b415511edca28cd4$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5r0F6.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5r0F6.default)(r, a) : void 0;
    }
}

});

parcelRegister("4m67l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32bdf64ff40f0f35$export$2e2bcd8739ae039; });
function $32bdf64ff40f0f35$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("eLTr6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac1074ee725eabcc$export$2e2bcd8739ae039; });

var $iRfYT = parcelRequire("iRfYT");
function $ac1074ee725eabcc$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $iRfYT.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("iRfYT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dba992c41cbfcfe2$export$2e2bcd8739ae039; });

var $dMCdc = parcelRequire("dMCdc");

var $fU9v6 = parcelRequire("fU9v6");
function $dba992c41cbfcfe2$export$2e2bcd8739ae039(t) {
    var i = (0, $fU9v6.default)(t, "string");
    return "symbol" == (0, $dMCdc.default)(i) ? i : i + "";
}

});
parcelRegister("fU9v6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b943749dd3a381ca$export$2e2bcd8739ae039; });

var $dMCdc = parcelRequire("dMCdc");
function $b943749dd3a381ca$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $dMCdc.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $dMCdc.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("4fpbm", function(module, exports) {

$parcel$export(module.exports, "SkipLink", function () { return $317c18d1ec8f694c$export$ef95c37428582a65; });
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8lTdX = parcelRequire("8lTdX");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $blsV0 = parcelRequire("blsV0");
var $317c18d1ec8f694c$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function $317c18d1ec8f694c$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute("tabindex", "-1");
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   *
   * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
   *
   * - mess with click events
   * - potentially cause a focus ring to be always visible
   */ (0, $2e1kT.bind)(element, {
        type: "blur",
        listener: function listener() {
            element.removeAttribute("tabindex");
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
var $317c18d1ec8f694c$export$ef95c37428582a65 = function SkipLink(_ref) {
    var id = _ref.id, children = _ref.children, onBeforeNavigate = _ref.onBeforeNavigate;
    var href = "#".concat(id);
    var onClick = (0, $iSvIT.useCallback)(function(event) {
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        var target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate === null || onBeforeNavigate === void 0 || onBeforeNavigate();
        $317c18d1ec8f694c$var$focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("li", {
        className: (0, $8lTdX.default)([
            $317c18d1ec8f694c$var$styles.skipLinkListItem
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $blsV0.default), {
        tabIndex: 0,
        href: href,
        onClick: onClick
    }, children));
};

});
parcelRegister("blsV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8428167aa85ec628$export$2e2bcd8739ae039; });

var $jRswm = parcelRequire("jRswm");

var $dMCdc = parcelRequire("dMCdc");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jNYFj = parcelRequire("jNYFj");

var $lOOEF = parcelRequire("lOOEF");

var $6F6FS = parcelRequire("6F6FS");

var $emfh8 = parcelRequire("emfh8");

var $5CqIy = parcelRequire("5CqIy");

var $7nG8r = parcelRequire("7nG8r");

var $jxLBU = parcelRequire("jxLBU");

var $hozmE = parcelRequire("hozmE");

var $amV2N = parcelRequire("amV2N");

var $hQJLC = parcelRequire("hQJLC");
var $8428167aa85ec628$var$_excluded = [
    "href",
    "children",
    "backgroundColor",
    "newWindowLabel",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss"
], $8428167aa85ec628$var$_excluded2 = [
    "className"
];
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $8428167aa85ec628$var$focusRingStyles = (0, $2ZUkg.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $amV2N.borderColorMap)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $amV2N.positiveSpaceMap)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $amV2N.borderWidthMap)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $8428167aa85ec628$var$baseStyles = (0, $2ZUkg.css)({
    boxSizing: "border-box",
    textDecoration: "underline"
});
var $8428167aa85ec628$var$positionStyles = (0, $2ZUkg.css)({
    position: "relative"
});
var $8428167aa85ec628$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $8428167aa85ec628$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
var $8428167aa85ec628$var$OPENS_NEW_WINDOW_LABEL = "(opens new window)";
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $8428167aa85ec628$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, backgroundColor = _ref.backgroundColor, newWindowLabel = _ref.newWindowLabel, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $emfh8.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $fzcGG.default)(_ref, $8428167aa85ec628$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $5CqIy.useId)();
    var onClick = (0, $lOOEF.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.11.4",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $fzcGG.default)(htmlAttributes, $8428167aa85ec628$var$_excluded2);
    var resolvedStyles = (0, $hQJLC.parseXcss)(xcss);
    var RouterLink = (0, $6F6FS.default)();
    var isExternal = typeof href === "string" && $8428167aa85ec628$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $8428167aa85ec628$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $dMCdc.default)(href) === "object";
    (0, $jNYFj.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return (0, $2ZUkg.jsx)(Component, (0, $jRswm.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel ? newWindowLabel : $8428167aa85ec628$var$OPENS_NEW_WINDOW_LABEL) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        css: [
            $8428167aa85ec628$var$baseStyles,
            (0, $jxLBU.fg)("platform_design-system-team_anchor-positioning") ? $8428167aa85ec628$var$positionStyles : undefined,
            $8428167aa85ec628$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $amV2N.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $amV2N.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $amV2N.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $amV2N.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $amV2N.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $amV2N.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $amV2N.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $amV2N.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $2ZUkg.jsx)((0, $hozmE.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel ? newWindowLabel : $8428167aa85ec628$var$OPENS_NEW_WINDOW_LABEL)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $8428167aa85ec628$var$Anchor = /*#__PURE__*/ (0, $iSvIT.forwardRef)($8428167aa85ec628$var$AnchorNoRef);
var $8428167aa85ec628$export$2e2bcd8739ae039 = $8428167aa85ec628$var$Anchor;

});
parcelRegister("jRswm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e75917396fd41c7d$export$2e2bcd8739ae039; });
function $e75917396fd41c7d$export$2e2bcd8739ae039() {
    return $e75917396fd41c7d$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e75917396fd41c7d$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("fzcGG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b553f75cfa36324e$export$2e2bcd8739ae039; });

var $fflSA = parcelRequire("fflSA");
function $b553f75cfa36324e$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $fflSA.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("fflSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1993a8c52d45124$export$2e2bcd8739ae039; });
function $b1993a8c52d45124$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("lOOEF", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $fe258f7cb4a1c50c$export$a4687b0234b40e28; });

var $eLTr6 = parcelRequire("eLTr6");

var $iSvIT = parcelRequire("iSvIT");

var $3XQNt = parcelRequire("3XQNt");

var $jbLrn = parcelRequire("jbLrn");
function $fe258f7cb4a1c50c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fe258f7cb4a1c50c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fe258f7cb4a1c50c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fe258f7cb4a1c50c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fe258f7cb4a1c50c$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $3XQNt.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $jbLrn.useTrackedRef)(analyticsData);
    var fnRef = (0, $jbLrn.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $fe258f7cb4a1c50c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("3XQNt", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $2e2fd623ebda9893$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $5bbDD = parcelRequire("5bbDD");

var $2UZTd = parcelRequire("2UZTd");
function $2e2fd623ebda9893$export$5bf35293e545f20c() {
    var analyticsContext = (0, $2UZTd.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $5bbDD.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("5bbDD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c5701ed959976d9$export$2e2bcd8739ae039; });

var $lcRu8 = parcelRequire("lcRu8");

var $blGcH = parcelRequire("blGcH");

var $iinBY = parcelRequire("iinBY");

var $3Xvyp = parcelRequire("3Xvyp");

var $dJfHB = parcelRequire("dJfHB");

var $9C8bK = parcelRequire("9C8bK");

var $94p3F = parcelRequire("94p3F");

var $eLTr6 = parcelRequire("eLTr6");

var $bRne8 = parcelRequire("bRne8");
function $3c5701ed959976d9$var$_callSuper(t, o, e) {
    return o = (0, $dJfHB.default)(o), (0, $3Xvyp.default)(t, $3c5701ed959976d9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $dJfHB.default)(t).constructor) : o.apply(t, e));
}
function $3c5701ed959976d9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3c5701ed959976d9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3c5701ed959976d9$var$_superPropGet(t, o, e, r) {
    var p = (0, $9C8bK.default)((0, $dJfHB.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $3c5701ed959976d9$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $3c5701ed959976d9$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $3c5701ed959976d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $blGcH.default)(this, UIAnalyticsEvent);
        _this = $3c5701ed959976d9$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $eLTr6.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $eLTr6.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $lcRu8.default)(_this.context);
            var handlers = (0, $lcRu8.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $eLTr6.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $94p3F.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $iinBY.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $3c5701ed959976d9$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $bRne8.default));

});
parcelRegister("blGcH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $843264af4be6e1eb$export$2e2bcd8739ae039; });
function $843264af4be6e1eb$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("iinBY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d51c3934db42a18d$export$2e2bcd8739ae039; });

var $iRfYT = parcelRequire("iRfYT");
function $d51c3934db42a18d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $iRfYT.default)(o.key), o);
    }
}
function $d51c3934db42a18d$export$2e2bcd8739ae039(e, r, t) {
    return r && $d51c3934db42a18d$var$_defineProperties(e.prototype, r), t && $d51c3934db42a18d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("3Xvyp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e1f5bc4ca1dad6e$export$2e2bcd8739ae039; });

var $dMCdc = parcelRequire("dMCdc");

var $jWFOf = parcelRequire("jWFOf");
function $2e1f5bc4ca1dad6e$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $dMCdc.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $jWFOf.default)(t);
}

});
parcelRegister("jWFOf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e853dd9756dbde99$export$2e2bcd8739ae039; });
function $e853dd9756dbde99$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("dJfHB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9feba87fb68d89b1$export$2e2bcd8739ae039; });
function $9feba87fb68d89b1$export$2e2bcd8739ae039(t) {
    return $9feba87fb68d89b1$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $9feba87fb68d89b1$export$2e2bcd8739ae039(t);
}

});

parcelRegister("9C8bK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ffe03bbf77163b0$export$2e2bcd8739ae039; });

var $1AcqF = parcelRequire("1AcqF");
function $6ffe03bbf77163b0$export$2e2bcd8739ae039() {
    return $6ffe03bbf77163b0$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $1AcqF.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $6ffe03bbf77163b0$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("1AcqF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1272cb6c18a9f425$export$2e2bcd8739ae039; });

var $dJfHB = parcelRequire("dJfHB");
function $1272cb6c18a9f425$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $dJfHB.default)(t)););
    return t;
}

});


parcelRegister("94p3F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69a7ecccbe7d2c20$export$2e2bcd8739ae039; });

var $b8Wjv = parcelRequire("b8Wjv");
function $69a7ecccbe7d2c20$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $b8Wjv.default)(t, e);
}

});
parcelRegister("b8Wjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81cdaceb996b14e2$export$2e2bcd8739ae039; });
function $81cdaceb996b14e2$export$2e2bcd8739ae039(t, e) {
    return $81cdaceb996b14e2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $81cdaceb996b14e2$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("bRne8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a26a95836e7a41c$export$2e2bcd8739ae039; });

var $dMCdc = parcelRequire("dMCdc");

var $blGcH = parcelRequire("blGcH");

var $iinBY = parcelRequire("iinBY");

var $eLTr6 = parcelRequire("eLTr6");
function $8a26a95836e7a41c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a26a95836e7a41c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a26a95836e7a41c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a26a95836e7a41c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8a26a95836e7a41c$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $8a26a95836e7a41c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $8a26a95836e7a41c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $blGcH.default)(this, AnalyticsEvent);
        (0, $eLTr6.default)(this, "_isAnalyticsEvent", true);
        (0, $eLTr6.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $8a26a95836e7a41c$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $iinBY.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $dMCdc.default)(updater) === "object") this.payload = $8a26a95836e7a41c$var$_objectSpread($8a26a95836e7a41c$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("2UZTd", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $2200d1b9a637feb0$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $2200d1b9a637feb0$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("jbLrn", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $df83d81f1cf7488a$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $df83d81f1cf7488a$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("hozmE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caa01c2e2b8e609f$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $iSvIT = parcelRequire("iSvIT");

var $28cTJ = parcelRequire("28cTJ");
var $caa01c2e2b8e609f$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $caa01c2e2b8e609f$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $28cTJ.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $caa01c2e2b8e609f$export$2e2bcd8739ae039 = $caa01c2e2b8e609f$var$VisuallyHidden;

});
parcelRegister("28cTJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18d6556234079aeb$export$2e2bcd8739ae039; });
const $18d6556234079aeb$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $18d6556234079aeb$var$ATOMIC_GROUP_LENGTH = 5;
function $18d6556234079aeb$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $18d6556234079aeb$var$UNDERSCORE_UNICODE ? $18d6556234079aeb$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});


parcelRegister("amV2N", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $78c835383a80cdd3$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $78c835383a80cdd3$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $78c835383a80cdd3$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $78c835383a80cdd3$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $78c835383a80cdd3$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $78c835383a80cdd3$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $78c835383a80cdd3$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $78c835383a80cdd3$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $78c835383a80cdd3$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $78c835383a80cdd3$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $78c835383a80cdd3$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $78c835383a80cdd3$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $78c835383a80cdd3$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $78c835383a80cdd3$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $78c835383a80cdd3$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $78c835383a80cdd3$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $78c835383a80cdd3$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $78c835383a80cdd3$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $78c835383a80cdd3$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "textSizeStylesMap", function () { return $78c835383a80cdd3$export$219d364c0da35ae4; });
$parcel$export(module.exports, "textWeightStylesMap", function () { return $78c835383a80cdd3$export$38845ca010b93505; });

var $eLTr6 = parcelRequire("eLTr6");

var $2ZUkg = parcelRequire("2ZUkg");

var $jDHu3 = parcelRequire("jDHu3");
function $78c835383a80cdd3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $78c835383a80cdd3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $78c835383a80cdd3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $78c835383a80cdd3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $78c835383a80cdd3$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $78c835383a80cdd3$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $78c835383a80cdd3$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $78c835383a80cdd3$export$632685d741f3dbbf = $78c835383a80cdd3$var$_objectSpread($78c835383a80cdd3$var$_objectSpread({}, $78c835383a80cdd3$export$958d0ae7f2977ae4), $78c835383a80cdd3$export$d2dc61f58390201c);
var $78c835383a80cdd3$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $78c835383a80cdd3$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $78c835383a80cdd3$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $78c835383a80cdd3$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $78c835383a80cdd3$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $78c835383a80cdd3$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $78c835383a80cdd3$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $78c835383a80cdd3$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B778C)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $78c835383a80cdd3$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $78c835383a80cdd3$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    // @deprecated
    "border.width.0": "var(--ds-border-width-0, 0px)",
    // @deprecated
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    // @deprecated
    "border.width.outline": "var(--ds-border-width-outline, 2px)",
    "border.width.selected": "var(--ds-border-width-selected, 2px)",
    "border.width.focused": "var(--ds-border-width-focused, 2px)"
};
var $78c835383a80cdd3$export$3c0a6c3e64bb180d = {
    "radius.xsmall": "var(--ds-radius-xsmall, 2px)",
    "radius.small": "var(--ds-radius-small, 3px)",
    "radius.medium": "var(--ds-radius-medium, 6px)",
    "radius.large": "var(--ds-radius-large, 8px)",
    "radius.xlarge": "var(--ds-radius-xlarge, 12px)",
    "radius.full": "var(--ds-radius-full, 9999px)",
    // @deprecated
    "border.radius": "var(--ds-border-radius, 3px)",
    // @deprecated
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    // @deprecated
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    // @deprecated
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    // @deprecated
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    // @deprecated
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    // @deprecated
    "border.radius.circle": "var(--ds-border-radius-circle, 9999px)"
};
var $78c835383a80cdd3$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.large": 'var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.medium": 'var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.small": 'var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $78c835383a80cdd3$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $78c835383a80cdd3$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $78c835383a80cdd3$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $78c835383a80cdd3$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $78c835383a80cdd3$export$b805719bc8cb376 = {
    large: 'var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    medium: 'var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $78c835383a80cdd3$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $78c835383a80cdd3$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $2ZUkg.css)((0, $eLTr6.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $78c835383a80cdd3$export$e615f061ca585a6c = $78c835383a80cdd3$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $78c835383a80cdd3$export$ca0f9c2de39ffed7(spacingProperty, $78c835383a80cdd3$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $78c835383a80cdd3$export$bf46c3f9eeafc71f = $78c835383a80cdd3$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $78c835383a80cdd3$export$ca0f9c2de39ffed7(spacingProperty, $78c835383a80cdd3$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $78c835383a80cdd3$export$e7af83bafe7f9e63 = $78c835383a80cdd3$export$ca0f9c2de39ffed7("backgroundColor", $78c835383a80cdd3$export$d1d79bf68ac056bd);
var $78c835383a80cdd3$export$3a1bcba60b23d7f0 = $78c835383a80cdd3$export$ca0f9c2de39ffed7("color", $78c835383a80cdd3$export$8473307aa00d6ea1);
var $78c835383a80cdd3$export$45f3f4fe16f9f7d5 = $78c835383a80cdd3$export$ca0f9c2de39ffed7("fontWeight", $78c835383a80cdd3$export$303e322c6b1ed114);
var $78c835383a80cdd3$export$68cc305da27dbaa4 = $78c835383a80cdd3$export$ca0f9c2de39ffed7("fontFamily", $78c835383a80cdd3$export$3c7e9587132614b4);
var $78c835383a80cdd3$export$128f10c238242f83 = $78c835383a80cdd3$export$ca0f9c2de39ffed7("font", $78c835383a80cdd3$export$6ffa317d5e70375);
var $78c835383a80cdd3$export$219d364c0da35ae4 = $78c835383a80cdd3$export$ca0f9c2de39ffed7("font", $78c835383a80cdd3$export$236bfe3a33ef1292);
var $78c835383a80cdd3$export$38845ca010b93505 = $78c835383a80cdd3$export$ca0f9c2de39ffed7("fontWeight", $78c835383a80cdd3$export$855cfd311192d666);
var $78c835383a80cdd3$export$ff257d957d48c421 = $78c835383a80cdd3$export$ca0f9c2de39ffed7((0, $jDHu3.CURRENT_SURFACE_CSS_VAR), $78c835383a80cdd3$export$41a358c9c2356760);
var $78c835383a80cdd3$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $78c835383a80cdd3$export$41a358c9c2356760[color] !== undefined;
};
var $78c835383a80cdd3$export$7001ce64d9ff7c7f = $78c835383a80cdd3$export$ca0f9c2de39ffed7("font", $78c835383a80cdd3$export$b805719bc8cb376);

});
parcelRegister("jDHu3", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $e4c363d1cf160622$export$9d7b58831ae93caa; });
var $e4c363d1cf160622$export$4ef52930e33717cd = "data-theme";
var $e4c363d1cf160622$export$a00eac3f8684bcd0 = "data-color-mode";
var $e4c363d1cf160622$export$2112803007239c61 = "data-contrast-mode";
var $e4c363d1cf160622$export$352e418ed5b6193a = "data-custom-theme";
var $e4c363d1cf160622$export$6f0c6fb8c80fcc92 = "ds";
var $e4c363d1cf160622$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border",
    "radius"
];
var $e4c363d1cf160622$export$dddac1532e822863 = "--".concat($e4c363d1cf160622$export$6f0c6fb8c80fcc92, "-token-not-found");
var $e4c363d1cf160622$export$9d7b58831ae93caa = "--".concat($e4c363d1cf160622$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("hQJLC", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $cfeacb65e986618d$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $cfeacb65e986618d$export$f6c783d06584602c; });

var $lcRu8 = parcelRequire("lcRu8");

var $eLTr6 = parcelRequire("eLTr6");

var $gaNY9 = parcelRequire("gaNY9");

var $dMCdc = parcelRequire("dMCdc");

var $2ZUkg = parcelRequire("2ZUkg");

var $amV2N = parcelRequire("amV2N");

var $XAEGR = parcelRequire("XAEGR");
function $cfeacb65e986618d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $cfeacb65e986618d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $cfeacb65e986618d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cfeacb65e986618d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cfeacb65e986618d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $cfeacb65e986618d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $cfeacb65e986618d$export$9a199fbafee0014e = {
    backgroundColor: (0, $amV2N.backgroundColorMap),
    blockSize: (0, $amV2N.dimensionMap),
    borderBlockColor: (0, $amV2N.borderColorMap),
    borderBlockEndColor: (0, $amV2N.borderColorMap),
    borderBlockEndWidth: (0, $amV2N.borderWidthMap),
    borderBlockStartColor: (0, $amV2N.borderColorMap),
    borderBlockStartWidth: (0, $amV2N.borderWidthMap),
    borderBlockWidth: (0, $amV2N.borderWidthMap),
    borderBottomColor: (0, $amV2N.borderColorMap),
    borderBottomLeftRadius: (0, $amV2N.borderRadiusMap),
    borderBottomRightRadius: (0, $amV2N.borderRadiusMap),
    borderBottomWidth: (0, $amV2N.borderWidthMap),
    borderColor: (0, $amV2N.borderColorMap),
    borderEndEndRadius: (0, $amV2N.borderRadiusMap),
    borderEndStartRadius: (0, $amV2N.borderRadiusMap),
    borderInlineColor: (0, $amV2N.borderColorMap),
    borderInlineEndColor: (0, $amV2N.borderColorMap),
    borderInlineEndWidth: (0, $amV2N.borderWidthMap),
    borderInlineStartColor: (0, $amV2N.borderColorMap),
    borderInlineStartWidth: (0, $amV2N.borderWidthMap),
    borderInlineWidth: (0, $amV2N.borderWidthMap),
    borderLeftColor: (0, $amV2N.borderColorMap),
    borderLeftWidth: (0, $amV2N.borderWidthMap),
    borderRadius: (0, $amV2N.borderRadiusMap),
    borderRightColor: (0, $amV2N.borderColorMap),
    borderRightWidth: (0, $amV2N.borderWidthMap),
    borderStartEndRadius: (0, $amV2N.borderRadiusMap),
    borderStartStartRadius: (0, $amV2N.borderRadiusMap),
    borderTopColor: (0, $amV2N.borderColorMap),
    borderTopLeftRadius: (0, $amV2N.borderRadiusMap),
    borderTopRightRadius: (0, $amV2N.borderRadiusMap),
    borderTopWidth: (0, $amV2N.borderWidthMap),
    borderWidth: (0, $amV2N.borderWidthMap),
    bottom: (0, $amV2N.allSpaceMap),
    boxShadow: (0, $amV2N.shadowMap),
    color: (0, $amV2N.textColorMap),
    columnGap: (0, $amV2N.positiveSpaceMap),
    font: (0, $amV2N.fontMap),
    fontFamily: (0, $amV2N.fontFamilyMap),
    fontWeight: (0, $amV2N.fontWeightMap),
    gap: (0, $amV2N.positiveSpaceMap),
    height: (0, $amV2N.dimensionMap),
    inlineSize: (0, $amV2N.dimensionMap),
    inset: (0, $amV2N.allSpaceMap),
    insetBlock: (0, $amV2N.allSpaceMap),
    insetBlockEnd: (0, $amV2N.allSpaceMap),
    insetBlockStart: (0, $amV2N.allSpaceMap),
    insetInline: (0, $amV2N.allSpaceMap),
    insetInlineEnd: (0, $amV2N.allSpaceMap),
    insetInlineStart: (0, $amV2N.allSpaceMap),
    left: (0, $amV2N.allSpaceMap),
    margin: (0, $amV2N.allSpaceMap),
    marginBlock: (0, $amV2N.allSpaceMap),
    marginBlockEnd: (0, $amV2N.allSpaceMap),
    marginBlockStart: (0, $amV2N.allSpaceMap),
    marginBottom: (0, $amV2N.allSpaceMap),
    marginInline: (0, $amV2N.allSpaceMap),
    marginInlineEnd: (0, $amV2N.allSpaceMap),
    marginInlineStart: (0, $amV2N.allSpaceMap),
    marginLeft: (0, $amV2N.allSpaceMap),
    marginRight: (0, $amV2N.allSpaceMap),
    marginTop: (0, $amV2N.allSpaceMap),
    maxBlockSize: (0, $amV2N.dimensionMap),
    maxHeight: (0, $amV2N.dimensionMap),
    maxInlineSize: (0, $amV2N.dimensionMap),
    maxWidth: (0, $amV2N.dimensionMap),
    minBlockSize: (0, $amV2N.dimensionMap),
    minHeight: (0, $amV2N.dimensionMap),
    minInlineSize: (0, $amV2N.dimensionMap),
    minWidth: (0, $amV2N.dimensionMap),
    opacity: (0, $amV2N.opacityMap),
    outlineColor: (0, $amV2N.borderColorMap),
    outlineOffset: (0, $amV2N.allSpaceMap),
    outlineWidth: (0, $amV2N.borderWidthMap),
    padding: (0, $amV2N.positiveSpaceMap),
    paddingBlock: (0, $amV2N.positiveSpaceMap),
    paddingBlockEnd: (0, $amV2N.positiveSpaceMap),
    paddingBlockStart: (0, $amV2N.positiveSpaceMap),
    paddingBottom: (0, $amV2N.positiveSpaceMap),
    paddingInline: (0, $amV2N.positiveSpaceMap),
    paddingInlineEnd: (0, $amV2N.positiveSpaceMap),
    paddingInlineStart: (0, $amV2N.positiveSpaceMap),
    paddingLeft: (0, $amV2N.positiveSpaceMap),
    paddingRight: (0, $amV2N.positiveSpaceMap),
    paddingTop: (0, $amV2N.positiveSpaceMap),
    right: (0, $amV2N.allSpaceMap),
    rowGap: (0, $amV2N.positiveSpaceMap),
    top: (0, $amV2N.allSpaceMap),
    width: (0, $amV2N.dimensionMap),
    zIndex: (0, $amV2N.layerMap)
};
var $cfeacb65e986618d$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $cfeacb65e986618d$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $XAEGR === "undefined" ? "undefined" : (0, $dMCdc.default)($XAEGR)) === "object" && (0, $dMCdc.default)($XAEGR.env) === "object" && false;
};
var $cfeacb65e986618d$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $cfeacb65e986618d$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $cfeacb65e986618d$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $dMCdc.default)(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($cfeacb65e986618d$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $gaNY9.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $dMCdc.default)(value) === "object" && $cfeacb65e986618d$var$safeSelectors.test(key)) {
            styleObj[key] = $cfeacb65e986618d$var$_transformStyles(value);
            return;
        }
        if ($cfeacb65e986618d$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($cfeacb65e986618d$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $cfeacb65e986618d$export$9a199fbafee0014e)) return;
        var tokenValue = $cfeacb65e986618d$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $cfeacb65e986618d$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $cfeacb65e986618d$var$_transformStyles(style);
    return (0, $eLTr6.default)({}, $cfeacb65e986618d$var$uniqueSymbol, (0, $2ZUkg.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $cfeacb65e986618d$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $cfeacb65e986618d$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $cfeacb65e986618d$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $lcRu8.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$cfeacb65e986618d$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $cfeacb65e986618d$export$f6c783d06584602c(style) {
    return $cfeacb65e986618d$var$baseXcss(style);
}

});
parcelRegister("gaNY9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc645756ec912835$export$2e2bcd8739ae039; });

var $bMIdf = parcelRequire("bMIdf");

var $9bntR = parcelRequire("9bntR");

var $fszTJ = parcelRequire("fszTJ");

var $7uzv8 = parcelRequire("7uzv8");
function $bc645756ec912835$export$2e2bcd8739ae039(r, e) {
    return (0, $bMIdf.default)(r) || (0, $9bntR.default)(r, e) || (0, $fszTJ.default)(r, e) || (0, $7uzv8.default)();
}

});
parcelRegister("bMIdf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8946791c57dca297$export$2e2bcd8739ae039; });
function $8946791c57dca297$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("9bntR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6af75ae094af9bf7$export$2e2bcd8739ae039; });
function $6af75ae094af9bf7$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("7uzv8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5746df90a7f76b40$export$2e2bcd8739ae039; });
function $5746df90a7f76b40$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});






parcelRegister("eyp4T", function(module, exports) {

$parcel$export(module.exports, "SkipLinksProvider", function () { return $a987b19b5f70bbdd$export$fe514f9f7b03d46f; });

var $lcRu8 = parcelRequire("lcRu8");

var $gaNY9 = parcelRequire("gaNY9");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $biEPH = parcelRequire("biEPH");

var $hA2VN = parcelRequire("hA2VN");

var $blkUm = parcelRequire("blkUm");
var $a987b19b5f70bbdd$var$getByDomOrderSortFunction = function getByDomOrderSortFunction() {
    var layoutSlots = Array.from(document.querySelectorAll("[data-layout-slot]"));
    return function(a, b) {
        var _a$listIndex, _b$listIndex;
        var indexA = (_a$listIndex = a.listIndex) !== null && _a$listIndex !== void 0 ? _a$listIndex : layoutSlots.indexOf(document.getElementById(a.id));
        var indexB = (_b$listIndex = b.listIndex) !== null && _b$listIndex !== void 0 ? _b$listIndex : layoutSlots.indexOf(document.getElementById(b.id));
        /**
     * If they are tied it is because one (or both) is
     * a custom skiplink with a set index.
     *
     * Give the custom skiplink priority.
     */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
function $a987b19b5f70bbdd$export$fe514f9f7b03d46f(_ref) {
    var children = _ref.children, label = _ref.label, testId = _ref.testId;
    var _useState = (0, $iSvIT.useState)([]), _useState2 = (0, $gaNY9.default)(_useState, 2), links = _useState2[0], setLinks = _useState2[1];
    var registerSkipLink = (0, $iSvIT.useCallback)(function(skipLinkData) {
        // Don't add duplicate skip links
        setLinks(function(oldLinks) {
            if (oldLinks.some(function(_ref2) {
                var id = _ref2.id;
                return id === skipLinkData.id;
            })) return oldLinks;
            return [].concat((0, $lcRu8.default)(oldLinks), [
                skipLinkData
            ]).sort($a987b19b5f70bbdd$var$getByDomOrderSortFunction());
        });
    }, []);
    var unregisterSkipLink = (0, $iSvIT.useCallback)(function(id) {
        setLinks(function(links) {
            return links.filter(function(link) {
                return link.id !== id;
            });
        });
    }, []);
    var contextValue = (0, $iSvIT.useMemo)(function() {
        var data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hA2VN.SkipLinksContext).Provider, {
        value: contextValue
    }, (0, $jxLBU.fg)("platform_dst_nav4_skip_links_hydration_fix") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $biEPH.SkipLinksContainer), {
        label: label,
        testId: testId,
        links: links
    }), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $blkUm.SkipLinksDataContext).Provider, {
        value: links
    }, children));
}

});

parcelRegister("2SmDo", function(module, exports) {

$parcel$export(module.exports, "TopNavStartProvider", function () { return $21822ea5b86660f2$export$bc9d0ad0bce43e75; });

var $gaNY9 = parcelRequire("gaNY9");

var $iSvIT = parcelRequire("iSvIT");

var $4NsJA = parcelRequire("4NsJA");
var $21822ea5b86660f2$export$bc9d0ad0bce43e75 = function TopNavStartProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $gaNY9.default)(_useState, 2), element = _useState2[0], setElement = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4NsJA.TopNavStartElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4NsJA.TopNavStartAttachRef).Provider, {
        value: setElement
    }, children));
};

});
parcelRegister("4NsJA", function(module, exports) {

$parcel$export(module.exports, "TopNavStartElement", function () { return $37e2070c056260b7$export$e9e5087bd319cc8c; });
$parcel$export(module.exports, "TopNavStartAttachRef", function () { return $37e2070c056260b7$export$55f0a642b785fb1f; });

var $iSvIT = parcelRequire("iSvIT");

var $emfh8 = parcelRequire("emfh8");
var $37e2070c056260b7$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
var $37e2070c056260b7$export$55f0a642b785fb1f = /*#__PURE__*/ (0, $iSvIT.createContext)((0, $emfh8.default));

});


parcelRegister("7eVqT", function(module, exports) {

$parcel$export(module.exports, "DangerouslyHoistSlotSizes", function () { return $5456642a284901fc$export$66e2c1a0115af861; });

var $iSvIT = parcelRequire("iSvIT");
var $5456642a284901fc$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $iSvIT.createContext)(false);

});

parcelRegister("bLRT0", function(module, exports) {

$parcel$export(module.exports, "SideNavElementProvider", function () { return $891de22c742e232a$export$85c1ff84bbf6e6dc; });
$parcel$export(module.exports, "useSideNavRef", function () { return $891de22c742e232a$export$fa4d0cff03b1ea4f; });

var $iSvIT = parcelRequire("iSvIT");
var $891de22c742e232a$var$SideNavRefContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    current: null
});
function $891de22c742e232a$export$85c1ff84bbf6e6dc(_ref) {
    var children = _ref.children;
    var sideNavRef = (0, $iSvIT.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($891de22c742e232a$var$SideNavRefContext.Provider, {
        value: sideNavRef
    }, children);
}
function $891de22c742e232a$export$fa4d0cff03b1ea4f() {
    return (0, $iSvIT.useContext)($891de22c742e232a$var$SideNavRefContext);
}

});

parcelRegister("jOmA4", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonProvider", function () { return $e6c433eb42f515a9$export$ceb8e60e9790fc0f; });

var $gaNY9 = parcelRequire("gaNY9");

var $iSvIT = parcelRequire("iSvIT");

var $ei9j3 = parcelRequire("ei9j3");
var $e6c433eb42f515a9$export$ceb8e60e9790fc0f = function SideNavToggleButtonProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $gaNY9.default)(_useState, 2), element = _useState2[0], setElement = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ei9j3.SideNavToggleButtonElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ei9j3.SideNavToggleButtonAttachRef).Provider, {
        value: setElement
    }, children));
};

});
parcelRegister("ei9j3", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonElement", function () { return $a679f72969727361$export$9c1768094bef896; });
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", function () { return $a679f72969727361$export$fb8fa9a80240785e; });

var $iSvIT = parcelRequire("iSvIT");

var $emfh8 = parcelRequire("emfh8");
var $a679f72969727361$export$9c1768094bef896 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
var $a679f72969727361$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $iSvIT.createContext)((0, $emfh8.default));

});


parcelRegister("4j1RV", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityProvider", function () { return $322a62e33792de35$export$aac8e996360f6ad9; });

var $gaNY9 = parcelRequire("gaNY9");

var $iSvIT = parcelRequire("iSvIT");

var $5C9o6 = parcelRequire("5C9o6");
var $322a62e33792de35$export$aac8e996360f6ad9 = function SideNavVisibilityProvider(_ref) {
    var children = _ref.children;
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $gaNY9.default)(_useState, 2), sideNavState = _useState2[0], setSideNavState = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5C9o6.SideNavVisibilityState).Provider, {
        value: sideNavState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5C9o6.SetSideNavVisibilityState).Provider, {
        value: setSideNavState
    }, children));
};

});
parcelRegister("5C9o6", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityState", function () { return $4167c8910405ea7a$export$eb04201bb6dd1e4e; });
$parcel$export(module.exports, "SetSideNavVisibilityState", function () { return $4167c8910405ea7a$export$f6b496b07d1ea493; });

var $iSvIT = parcelRequire("iSvIT");

var $emfh8 = parcelRequire("emfh8");
var $4167c8910405ea7a$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
var $4167c8910405ea7a$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $iSvIT.createContext)((0, $emfh8.default));

});



parcelRegister("irAt9", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $d6d709a75ed34a31$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $eLTr6 = parcelRequire("eLTr6");

var $gaNY9 = parcelRequire("gaNY9");

var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $2e1kT = parcelRequire("2e1kT");

var $i5UxU = parcelRequire("i5UxU");

var $6Qy6S = parcelRequire("6Qy6S");

var $abjxm = parcelRequire("abjxm");
var $4iorf = parcelRequire("4iorf");

var $jxLBU = parcelRequire("jxLBU");

var $1lxXS = parcelRequire("1lxXS");

var $2aJIQ = parcelRequire("2aJIQ");

var $hA2VN = parcelRequire("hA2VN");

var $4NsJA = parcelRequire("4NsJA");

var $nvCjc = parcelRequire("nvCjc");

var $7eVqT = parcelRequire("7eVqT");

var $1gr3O = parcelRequire("1gr3O");

var $4lOHN = parcelRequire("4lOHN");

var $1lJzT = parcelRequire("1lJzT");

var $CrgWO = parcelRequire("CrgWO");

var $bLRT0 = parcelRequire("bLRT0");

var $kCMQ4 = parcelRequire("kCMQ4");

var $ei9j3 = parcelRequire("ei9j3");

var $a6Jfn = parcelRequire("a6Jfn");

var $iVL2e = parcelRequire("iVL2e");

var $1KdxI = parcelRequire("1KdxI");

var $3Cnch = parcelRequire("3Cnch");

var $5C9o6 = parcelRequire("5C9o6");
var $d6d709a75ed34a31$var$panelSplitterResizingVar = "--n_snvRsz";
var $d6d709a75ed34a31$var$widthResizeBounds = {
    min: "240px",
    max: "50vw"
};
function $d6d709a75ed34a31$var$getResizeBounds() {
    return $d6d709a75ed34a31$var$widthResizeBounds;
}
var $d6d709a75ed34a31$var$openLayerObserverSideNavNamespace = "side-nav";
var $d6d709a75ed34a31$var$styles = {
    root: "_nd5l1b6c _bfhk1bhr _16qs1cd0 _vchhusvi _4t3ieqxy _152timx3 _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _4ap3vuon _scbpglyw",
    oldBorder: "_t51zzgxb",
    newBorder: "_191wglyw _t51zglyw _p5clzgxb",
    newBorderFlyoutOpen: "_p5clglyw",
    flyoutOpen: "_qiln1gzg _4ap31bhr _scbp1cd0 _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $d6d709a75ed34a31$var$SideNavInternal(_ref) {
    var children = _ref.children, defaultCollapsed = _ref.defaultCollapsed, _ref$defaultWidth = _ref.defaultWidth, defaultWidth = _ref$defaultWidth === void 0 ? 320 : _ref$defaultWidth, testId = _ref.testId, _ref$label = _ref.label, label = _ref$label === void 0 ? "Sidebar" : _ref$label, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? label : _ref$skipLinkLabel, onExpand = _ref.onExpand, onCollapse = _ref.onCollapse, providedId = _ref.id;
    var id = (0, $4lOHN.useLayoutId)({
        providedId: providedId
    });
    var expandSideNav = (0, $a6Jfn.useExpandSideNav)();
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   */ var synchronouslyExpandSideNav = (0, $iSvIT.useCallback)(function() {
        (0, $i5UxU.flushSync)(function() {
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $hA2VN.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    var sideNavState = (0, $iSvIT.useContext)((0, $5C9o6.SideNavVisibilityState));
    var setSideNavState = (0, $iSvIT.useContext)((0, $5C9o6.SetSideNavVisibilityState));
    var _useSideNavVisibility = (0, $iVL2e.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    }), isExpandedOnDesktop = _useSideNavVisibility.isExpandedOnDesktop, isExpandedOnMobile = _useSideNavVisibility.isExpandedOnMobile;
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    var _useState = (0, $iSvIT.useState)(defaultCollapsed), _useState2 = (0, $gaNY9.default)(_useState, 1), initialDefaultCollapsed = _useState2[0];
    var _useState3 = (0, $iSvIT.useState)(defaultWidth), _useState4 = (0, $gaNY9.default)(_useState3, 2), width = _useState4[0], setWidth = _useState4[1];
    var clampedWidth = "clamp(".concat($d6d709a75ed34a31$var$widthResizeBounds.min, ", ").concat(width, "px, ").concat($d6d709a75ed34a31$var$widthResizeBounds.max, ")");
    var dangerouslyHoistSlotSizes = (0, $iSvIT.useContext)((0, $7eVqT.DangerouslyHoistSlotSizes));
    var navRef = (0, $iSvIT.useRef)(null);
    /**
   * Used to share the side nav element with the `Panel`,
   * which observes the side nav to determine its maximum width.
   */ var sharedRef = (0, $bLRT0.useSideNavRef)();
    var mergedRef = (0, $6Qy6S.default)([
        navRef,
        sharedRef
    ]);
    var toggleButtonElement = (0, $iSvIT.useContext)((0, $ei9j3.SideNavToggleButtonElement));
    var topNavStartElement = (0, $iSvIT.useContext)((0, $4NsJA.TopNavStartElement));
    var devTimeOnlyAttributes = {};
    var openLayerObserver = (0, $4iorf.useOpenLayerObserver)();
    var flyoutStateRef = (0, $iSvIT.useRef)({
        type: "not-active"
    });
    var isFlyoutVisible = (sideNavState === null || sideNavState === void 0 ? void 0 : sideNavState.flyout) === "open";
    var updateFlyoutState = (0, $iSvIT.useMemo)(function() {
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === "waiting-for-close") flyoutStateRef.current.abort();
        }
        function open() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: "open"
            };
            setSideNavState(function(currentState) {
                if ((currentState === null || currentState === void 0 ? void 0 : currentState.desktop) === "collapsed" && (currentState === null || currentState === void 0 ? void 0 : currentState.flyout) !== "open") return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: "open"
                };
                return currentState;
            });
        }
        function close() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: "not-active"
            };
            setSideNavState(function(currentState) {
                if ((currentState === null || currentState === void 0 ? void 0 : currentState.desktop) === "collapsed" && (currentState === null || currentState === void 0 ? void 0 : currentState.flyout) === "open") return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: "triggered-animate-close"
                };
                return currentState;
            });
        }
        return function onAction(action) {
            if (action === "drag-from-flyout-started") {
                open();
                flyoutStateRef.current = {
                    type: "is-dragging-from-flyout"
                };
                return;
            }
            if (action === "drag-from-flyout-finished") {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === "is-dragging-from-flyout") return;
            if (action === "open") {
                open();
                return;
            }
            if (action === "waiting-for-close") {
                if (flyoutStateRef.current.type === "waiting-for-close") return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                var timeout = setTimeout(function() {
                    updateFlyoutState("ready-to-close");
                }, (0, $kCMQ4.sideNavFlyoutCloseDelayMs));
                flyoutStateRef.current = {
                    type: "waiting-for-close",
                    abort: function abort() {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === "ready-to-close") {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver.getCount({
                    namespace: $d6d709a75ed34a31$var$openLayerObserverSideNavNamespace
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: "ready-to-close"
                };
                return;
            }
            if (action === "force-close") {
                close();
                return;
            }
        };
    }, [
        openLayerObserver,
        setSideNavState
    ]);
    var toggleVisibility = (0, $3Cnch.useToggleSideNav)();
    (0, $iSvIT.useEffect)(function() {
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        setSideNavState({
            desktop: initialDefaultCollapsed ? "collapsed" : "expanded",
            mobile: "collapsed",
            flyout: "closed"
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState
    ]);
    var handleExpand = (0, $iSvIT.useCallback)(function(_ref2) {
        var screen = _ref2.screen;
        onExpand === null || onExpand === void 0 || onExpand({
            screen: screen
        });
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState("force-close");
    }, [
        onExpand,
        updateFlyoutState
    ]);
    var handleCollapse = (0, $iSvIT.useCallback)(function(_ref3) {
        var screen = _ref3.screen;
        onCollapse === null || onCollapse === void 0 || onCollapse({
            screen: screen
        });
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState("force-close");
    }, [
        onCollapse,
        updateFlyoutState
    ]);
    (0, $1KdxI.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile
    });
    (0, $iSvIT.useEffect)(function() {
        var mediaQueryList = window.matchMedia("(min-width: 64rem)");
        return (0, $2e1kT.bind)(mediaQueryList, {
            type: "change",
            listener: function listener() {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $iSvIT.useEffect)(function() {
        if (!isExpandedOnMobile) return;
        /**
     * The expected URL fragment used by the side nav skip link.
     */ var skipLinkUrlFragment = "#".concat(id);
        return (0, $2e1kT.bind)(window, {
            type: "click",
            listener: function listener(event) {
                if (window.matchMedia("(min-width: 64rem)").matches) // Clicks on desktop should do nothing
                return;
                var sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement !== null && toggleButtonElement !== void 0 && toggleButtonElement.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute("href") === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibility();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibility
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!toggleButtonElement) return;
        return (0, $2e1kT.bind)(toggleButtonElement, {
            type: "mouseenter",
            listener: function listener() {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                var _window$matchMedia = window.matchMedia("(min-width: 64rem)"), matches = _window$matchMedia.matches;
                if (matches) updateFlyoutState("open");
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!toggleButtonElement) return;
        return (0, $2e1kT.bind)(toggleButtonElement, {
            type: "mouseleave",
            listener: function listener() {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState("waiting-for-close");
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!navRef.current) return;
        return (0, $2e1kT.bind)(navRef.current, {
            type: "mouseenter",
            listener: function listener() {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState("open");
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!navRef.current) return;
        return (0, $2e1kT.bind)(navRef.current, {
            type: "mouseleave",
            listener: function listener() {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState("waiting-for-close");
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $iSvIT.useEffect)(function() {
        var nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $1lxXS.monitorForElements)({
            canMonitor: function canMonitor(_ref4) {
                var source = _ref4.source;
                return nav.contains(source.element);
            },
            onGenerateDragPreview: function onGenerateDragPreview() {
                updateFlyoutState("drag-from-flyout-started");
            },
            onDrop: function onDrop(_ref5) {
                var location = _ref5.location;
                // Always marking the drag and done
                updateFlyoutState("drag-from-flyout-finished");
                // If the user dropped outside of the flyout, we will close the flyout
                var underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState("waiting-for-close");
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $2e1kT.bind)(topNavStartElement, {
            type: "mouseover",
            listener: function listener(event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState("open");
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState("waiting-for-close");
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!topNavStartElement) return;
        return (0, $2e1kT.bind)(topNavStartElement, {
            type: "mouseleave",
            listener: function listener() {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState("waiting-for-close");
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $iSvIT.useEffect)(function() {
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver.onChange(function(_ref6) {
            var count = _ref6.count;
            if (flyoutStateRef.current.type === "ready-to-close" && count === 0) updateFlyoutState("force-close");
        }, {
            namespace: $d6d709a75ed34a31$var$openLayerObserverSideNavNamespace
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $iSvIT.useEffect)(function() {
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === "waiting-for-close") flyoutStateRef.current.abort();
        };
    }, []);
    var visible;
    (0, $CrgWO.useResizingWidthCssVarOnRootElement)({
        isEnabled: true,
        cssVar: $d6d709a75ed34a31$var$panelSplitterResizingVar,
        panelId: (0, $nvCjc.sideNavPanelSplitterId)
    });
    return /*#__PURE__*/ $iSvIT.createElement("nav", (0, $jRswm.default)({
        id: id
    }, devTimeOnlyAttributes, {
        "data-layout-slot": true,
        "aria-label": label,
        style: (0, $eLTr6.default)({}, (0, $nvCjc.sideNavVar), clampedWidth),
        ref: mergedRef,
        "data-testid": testId,
        className: (0, $8lTdX.default)([
            $d6d709a75ed34a31$var$styles.root,
            (0, $jxLBU.fg)("platform_design_system_nav4_sidenav_border") ? $d6d709a75ed34a31$var$styles.newBorder : $d6d709a75ed34a31$var$styles.oldBorder,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $d6d709a75ed34a31$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $d6d709a75ed34a31$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $d6d709a75ed34a31$var$styles.hiddenMobileAndDesktop,
            (sideNavState === null || sideNavState === void 0 ? void 0 : sideNavState.flyout) === "open" && $d6d709a75ed34a31$var$styles.flyoutOpen,
            (sideNavState === null || sideNavState === void 0 ? void 0 : sideNavState.flyout) === "open" && (0, $jxLBU.fg)("platform_design_system_nav4_sidenav_border") && $d6d709a75ed34a31$var$styles.newBorderFlyoutOpen,
            (sideNavState === null || sideNavState === void 0 ? void 0 : sideNavState.flyout) === "triggered-animate-close" && $d6d709a75ed34a31$var$styles.flyoutAnimateClosed
        ])
    }), /*#__PURE__*/ $iSvIT.createElement((0, $1gr3O.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $nvCjc.sideNavLiveWidthVar),
        value: "0px",
        mediaQuery: (0, $2aJIQ.media).above.md,
        responsiveValue: isExpandedOnDesktop ? "var(".concat($d6d709a75ed34a31$var$panelSplitterResizingVar, ", ").concat(clampedWidth, ")") : 0
    }), dangerouslyHoistSlotSizes && /*#__PURE__*/ // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    $iSvIT.createElement((0, $1gr3O.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $nvCjc.UNSAFE_sideNavLayoutVar),
        value: "var(".concat((0, $nvCjc.sideNavLiveWidthVar), ")")
    }), /*#__PURE__*/ $iSvIT.createElement((0, $1lJzT.PanelSplitterProvider), {
        panelId: (0, $nvCjc.sideNavPanelSplitterId),
        panelRef: navRef,
        panelWidth: width,
        onCompleteResize: setWidth,
        getResizeBounds: $d6d709a75ed34a31$var$getResizeBounds,
        resizingCssVar: $d6d709a75ed34a31$var$panelSplitterResizingVar,
        isEnabled: isExpandedOnDesktop && !isFlyoutVisible
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $8lTdX.default)([
            $d6d709a75ed34a31$var$styles.flexContainer
        ])
    }, children)));
}
function $d6d709a75ed34a31$export$1a35787d6353cf6a(_ref8) {
    var children = _ref8.children, defaultCollapsed = _ref8.defaultCollapsed, _ref8$defaultWidth = _ref8.defaultWidth, defaultWidth = _ref8$defaultWidth === void 0 ? 320 : _ref8$defaultWidth, testId = _ref8.testId, label = _ref8.label, _ref8$skipLinkLabel = _ref8.skipLinkLabel, skipLinkLabel = _ref8$skipLinkLabel === void 0 ? label : _ref8$skipLinkLabel, onExpand = _ref8.onExpand, onCollapse = _ref8.onCollapse, id = _ref8.id;
    return /*#__PURE__*/ $iSvIT.createElement((0, $abjxm.OpenLayerObserverNamespaceProvider), {
        namespace: $d6d709a75ed34a31$var$openLayerObserverSideNavNamespace
    }, /*#__PURE__*/ $iSvIT.createElement($d6d709a75ed34a31$var$SideNavInternal, {
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        testId: testId,
        label: label,
        skipLinkLabel: skipLinkLabel,
        onExpand: onExpand,
        onCollapse: onCollapse,
        id: id
    }, children));
}

});
parcelRegister("6Qy6S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fc20ef335dd51e8$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $4fc20ef335dd51e8$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("abjxm", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", function () { return $769a161f4bca643f$export$327d0d2a7ae6f7cc; });

var $iSvIT = parcelRequire("iSvIT");

var $jNYFj = parcelRequire("jNYFj");

var $j31Pm = parcelRequire("j31Pm");

var $fikNO = parcelRequire("fikNO");
function $769a161f4bca643f$export$327d0d2a7ae6f7cc(_ref) {
    var children = _ref.children, namespace = _ref.namespace;
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    var parentContext = (0, $fikNO.useOpenLayerObserverNamespace)();
    (0, $iSvIT.useEffect)(function() {
        (0, $jNYFj.default)(parentContext === null, "An OpenLayerObserver namespace already exists in this component tree: ".concat(parentContext, ". Nesting OpenLayerObserverNamespaceProvider is not supported."));
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $j31Pm.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace
    }, children);
}

});

parcelRegister("4iorf", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserver", function () { return $320bccd0de3f97c7$export$750f5b0d6c51617e; });

var $iSvIT = parcelRequire("iSvIT");

var $jNYFj = parcelRequire("jNYFj");

var $ktFjJ = parcelRequire("ktFjJ");
function $320bccd0de3f97c7$export$750f5b0d6c51617e() {
    var context = (0, $iSvIT.useContext)((0, $ktFjJ.OpenLayerObserverContext));
    (0, $jNYFj.default)(context, "useOpenLayerObserver must be used within an OpenLayerObserver");
    var publicAPI = (0, $iSvIT.useMemo)(function() {
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context.getCount,
        context.onChange,
        context.closeLayers
    ]);
    return publicAPI;
}

});

parcelRegister("2aJIQ", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $194ffb6fee394686$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $194ffb6fee394686$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};
var $194ffb6fee394686$export$c881183ca713c214 = $194ffb6fee394686$export$987d49ffe1b0900f;

});

parcelRegister("nvCjc", function(module, exports) {

$parcel$export(module.exports, "sideNavVar", function () { return $046aac8d307ad59e$export$951bf5156e86d974; });
$parcel$export(module.exports, "topNavMountedVar", function () { return $046aac8d307ad59e$export$60ef3a7b1ed42328; });
$parcel$export(module.exports, "sideNavLiveWidthVar", function () { return $046aac8d307ad59e$export$1216dacffd1e9e65; });
$parcel$export(module.exports, "sideNavPanelSplitterId", function () { return $046aac8d307ad59e$export$5db28b16b6e686bc; });
$parcel$export(module.exports, "UNSAFE_topNavVar", function () { return $046aac8d307ad59e$export$855f5a09f5c99ac; });
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", function () { return $046aac8d307ad59e$export$6bfc931a04ec5741; });
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
var $046aac8d307ad59e$export$951bf5156e86d974 = "--n_sNvw";
var $046aac8d307ad59e$export$594e6a30db7c057e = "--n_asDw";
var $046aac8d307ad59e$export$db0c2e1d744fb281 = "--n_pnlW";
var $046aac8d307ad59e$export$515a0b1baafe906c = "--n_bnrM";
var $046aac8d307ad59e$export$60ef3a7b1ed42328 = "--n_tNvM";
var $046aac8d307ad59e$export$1216dacffd1e9e65 = "--n_sNvlw";
var $046aac8d307ad59e$export$5db28b16b6e686bc = Symbol("SideNav PanelSplitter");
var $046aac8d307ad59e$export$de580d653bac8ad9 = Symbol("Aside PanelSplitter");
var $046aac8d307ad59e$export$3452dcb65711af44 = Symbol("Panel PanelSplitter");
var $046aac8d307ad59e$export$2874e68531ce3163 = "calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))";
var $046aac8d307ad59e$export$bfabd8c2c572ad29 = "calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))";
var $046aac8d307ad59e$export$855f5a09f5c99ac = "--topNavigationHeight";
var $046aac8d307ad59e$export$26354f9814213292 = "--bannerHeight";
var $046aac8d307ad59e$export$6bfc931a04ec5741 = "--leftSidebarWidth";
var $046aac8d307ad59e$export$bbbace2ff0c7ae1b = "--rightSidebarWidth";
var $046aac8d307ad59e$export$753bf7651b25db91 = "--rightPanelWidth";
var $046aac8d307ad59e$export$6460bd6a2446260 = "calc(var(".concat($046aac8d307ad59e$export$26354f9814213292, ", 0px) + var(").concat($046aac8d307ad59e$export$855f5a09f5c99ac, ", 0px))");
var $046aac8d307ad59e$export$3055529fab2b4edf = "var(".concat($046aac8d307ad59e$export$6bfc931a04ec5741, ", 0px)");
var $046aac8d307ad59e$export$166d8fd766c3eb92 = "calc(var(".concat($046aac8d307ad59e$export$bbbace2ff0c7ae1b, ", 0px) + var(").concat($046aac8d307ad59e$export$753bf7651b25db91, ", 0px))");
var $046aac8d307ad59e$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    sideNav: 2,
    panelSmallViewports: 1
};

});

parcelRegister("1gr3O", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", function () { return $0ebc46ba534851f2$export$cfa3cd08d675e56e; });
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", function () { return $0ebc46ba534851f2$export$9f45a1325e3cdfb8; });

var $iSvIT = parcelRequire("iSvIT");

var $2W9NO = parcelRequire("2W9NO");
var $0ebc46ba534851f2$export$cfa3cd08d675e56e = function HoistCssVarToLocalGrid(_ref) {
    var variableName = _ref.variableName, value = _ref.value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("style", null, "#".concat((0, $2W9NO.gridRootId), " { ").concat(variableName, ": ").concat(value, "px }"));
};
var $0ebc46ba534851f2$var$getCssStringValue = function getCssStringValue(value) {
    return typeof value === "number" ? "".concat(value, "px") : value;
};
var $0ebc46ba534851f2$export$9f45a1325e3cdfb8 = function DangerouslyHoistCssVarToDocumentRoot(_ref2) {
    var variableName = _ref2.variableName, value = _ref2.value, mediaQuery = _ref2.mediaQuery, responsiveValue = _ref2.responsiveValue;
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ var style = ":root { ".concat(variableName, ": ").concat($0ebc46ba534851f2$var$getCssStringValue(value), " }");
    if (mediaQuery && responsiveValue) style += " ".concat(mediaQuery, " { :root { ").concat(variableName, ": ").concat($0ebc46ba534851f2$var$getCssStringValue(responsiveValue), " } }");
    return(/*#__PURE__*/ // Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("style", null, style));
};

});

parcelRegister("1lJzT", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", function () { return $0fbb1b6df4debf80$export$f662bfb764348932; });

var $iSvIT = parcelRequire("iSvIT");

var $aUWDs = parcelRequire("aUWDs");
var $0fbb1b6df4debf80$export$f662bfb764348932 = function PanelSplitterProvider(_ref) {
    var panelId = _ref.panelId, panelWidth = _ref.panelWidth, onCompleteResize = _ref.onCompleteResize, getResizeBounds = _ref.getResizeBounds, resizingCssVar = _ref.resizingCssVar, panelRef = _ref.panelRef, _ref$position = _ref.position, position = _ref$position === void 0 ? "end" : _ref$position, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, children = _ref.children;
    var portalRef = (0, $iSvIT.useRef)(null);
    var context = (0, $iSvIT.useMemo)(function() {
        return {
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled,
            portalRef: portalRef
        };
    }, [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        portalRef,
        panelRef,
        isEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $aUWDs.PanelSplitterContext).Provider, {
        value: context
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        ref: portalRef
    }));
};

});
parcelRegister("aUWDs", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterContext", function () { return $7f2c9e20453ad21a$export$7a4054f2c546f2cd; });

var $iSvIT = parcelRequire("iSvIT");
var $7f2c9e20453ad21a$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});


parcelRegister("CrgWO", function(module, exports) {

$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", function () { return $0738b471d1ea6200$export$d4931ecf0fbcc8fc; });

var $iSvIT = parcelRequire("iSvIT");

var $jwzfp = parcelRequire("jwzfp");

var $1lxXS = parcelRequire("1lxXS");

var $j3yJt = parcelRequire("j3yJt");
function $0738b471d1ea6200$export$d4931ecf0fbcc8fc(_ref) {
    var _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, cssVar = _ref.cssVar, panelId = _ref.panelId;
    (0, $iSvIT.useEffect)(function() {
        if (!isEnabled) return;
        return (0, $jwzfp.combine)((0, $1lxXS.monitorForElements)({
            canMonitor: function canMonitor(_ref2) {
                var source = _ref2.source;
                return source.data.panelId === panelId;
            },
            onDrag: function onDrag(_ref3) {
                var source = _ref3.source;
                if (!(0, $j3yJt.isPanelSplitterDragData)(source.data)) return;
                /**
         * Copies the resizing width value to the `<html>` element.
         *
         * Required to reflect the live width of the side navigation.
         *
         * Used by:
         *   - Legacy `--leftSidebarWidth` variable
         *   - Panel slot max-width constraint
         *
         * When the legacy `--leftSidebarWidth` variable is no longer needed,
         * we could consider writing to the `Panel` element instead.
         */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop: function onDrop() {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!isEnabled) return;
        /**
     * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
     * if the component unmounts during a drag.
     */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});
parcelRegister("j3yJt", function(module, exports) {

$parcel$export(module.exports, "isPanelSplitterDragData", function () { return $ddf93d45197e4ccc$export$e239b3966b677000; });
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gaNY9 = parcelRequire("gaNY9");

var $eLTr6 = parcelRequire("eLTr6");

var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $2e1kT = parcelRequire("2e1kT");

var $i5UxU = parcelRequire("i5UxU");

var $jNYFj = parcelRequire("jNYFj");

var $5CqIy = parcelRequire("5CqIy");

var $jixdz = parcelRequire("jixdz");

var $4iorf = parcelRequire("4iorf");

var $jwzfp = parcelRequire("jwzfp");

var $1lxXS = parcelRequire("1lxXS");
parcelRequire("9AbOd");
var $iiuYj = parcelRequire("iiuYj");

var $5iYet = parcelRequire("5iYet");

var $gxbtf = parcelRequire("gxbtf");

var $hozmE = parcelRequire("hozmE");

var $aUWDs = parcelRequire("aUWDs");

var $6Cbfr = parcelRequire("6Cbfr");

var $2jVJu = parcelRequire("2jVJu");

var $BAnVW = parcelRequire("BAnVW");

var $ef1C7 = parcelRequire("ef1C7");
function $ddf93d45197e4ccc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ddf93d45197e4ccc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ddf93d45197e4ccc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ddf93d45197e4ccc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ddf93d45197e4ccc$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
var $ddf93d45197e4ccc$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz1j28 _bfhk1j28 _k8m01ylx _1oec1yx9 _1lww5cps _d0aluf7j _1gavfnf5 _vp7gaqb7 _30l3aqb7 _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h16c2"
};
var $ddf93d45197e4ccc$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
var $ddf93d45197e4ccc$var$panelSplitterDragDataSymbol = Symbol("panel-splitter-drag-data");
function $ddf93d45197e4ccc$var$signPanelSplitterDragData(data) {
    return $ddf93d45197e4ccc$var$_objectSpread($ddf93d45197e4ccc$var$_objectSpread({}, data), {}, (0, $eLTr6.default)({}, $ddf93d45197e4ccc$var$panelSplitterDragDataSymbol, true));
}
function $ddf93d45197e4ccc$export$e239b3966b677000(data) {
    return data[$ddf93d45197e4ccc$var$panelSplitterDragDataSymbol] === true;
}
function $ddf93d45197e4ccc$var$getTextDirection(element) {
    var _window$getComputedSt = window.getComputedStyle(element), direction = _window$getComputedSt.direction;
    return direction === "rtl" ? "rtl" : "ltr";
}
var $ddf93d45197e4ccc$var$PortaledPanelSplitter = function PortaledPanelSplitter(_ref) {
    var label = _ref.label, onResizeStart = _ref.onResizeStart, onResizeEnd = _ref.onResizeEnd, testId = _ref.testId, panelId = _ref.panelId, panelWidth = _ref.panelWidth, onCompleteResize = _ref.onCompleteResize, getResizeBounds = _ref.getResizeBounds, panel = _ref.panel, portal = _ref.portal, resizingCssVar = _ref.resizingCssVar, position = _ref.position;
    var splitterRef = (0, $iSvIT.useRef)(null);
    var labelId = (0, $5CqIy.useId)();
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    var _useState = (0, $iSvIT.useState)(panelWidth), _useState2 = (0, $gaNY9.default)(_useState, 2), rangeInputValue = _useState2[0], setRangeInputValue = _useState2[1];
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ var _useState3 = (0, $iSvIT.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    }), _useState4 = (0, $gaNY9.default)(_useState3, 2), rangeInputBounds = _useState4[0], setRangeInputBounds = _useState4[1];
    var openLayerObserver = (0, $4iorf.useOpenLayerObserver)();
    (0, $iSvIT.useEffect)(function() {
        var splitter = splitterRef.current;
        (0, $jNYFj.default)(splitter, "Splitter ref must be set");
        return (0, $jwzfp.combine)((0, $iiuYj.blockDraggingToIFrames)({
            element: splitter
        }), (0, $1lxXS.draggable)({
            element: splitter,
            onGenerateDragPreview: function onGenerateDragPreview(_ref2) {
                var nativeSetDragImage = _ref2.nativeSetDragImage;
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $5iYet.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $gxbtf.preventUnhandled).start();
            },
            getInitialData: function getInitialData() {
                var initialWidth = (0, $BAnVW.getPixelWidth)(panel);
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return $ddf93d45197e4ccc$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: "".concat(initialWidth, "px"),
                    resizeBounds: getResizeBounds(),
                    // Only computing text direction when we need it, just as the drag is starting.
                    // Recomputing text direction on each new drag in case the text direction
                    // has changed. This is unlikely, but being safe.
                    direction: $ddf93d45197e4ccc$var$getTextDirection(panel)
                });
            },
            onDragStart: function onDragStart(_ref3) {
                var source = _ref3.source;
                (0, $jNYFj.default)($ddf93d45197e4ccc$export$e239b3966b677000(source.data));
                onResizeStart === null || onResizeStart === void 0 || onResizeStart({
                    initialWidth: source.data.initialWidth
                });
                // Close any open layers when the user starts resizing
                openLayerObserver === null || openLayerObserver === void 0 || openLayerObserver.closeLayers();
            },
            onDrag: function onDrag(_ref4) {
                var location = _ref4.location, source = _ref4.source;
                (0, $jNYFj.default)($ddf93d45197e4ccc$export$e239b3966b677000(source.data));
                var _source$data = source.data, initialWidth = _source$data.initialWidth, resizeBounds = _source$data.resizeBounds, direction = _source$data.direction;
                /**
         * How wide the element would be if there were no width constraints,
         * based on the pointer's position.
         */ var targetWidth = (0, $BAnVW.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    direction: direction,
                    position: position
                });
                var resizingWidth = "clamp(".concat(resizeBounds.min, ", ").concat(targetWidth, "px, ").concat(resizeBounds.max, ")");
                panel.style.setProperty(resizingCssVar, resizingWidth);
                source.data.resizingWidth = resizingWidth;
            },
            onDrop: function onDrop(_ref5) {
                var source = _ref5.source;
                (0, $jNYFj.default)($ddf93d45197e4ccc$export$e239b3966b677000(source.data));
                (0, $gxbtf.preventUnhandled).stop();
                (0, $jNYFj.default)($ddf93d45197e4ccc$export$e239b3966b677000(source.data));
                var finalWidth = (0, $BAnVW.getPixelWidth)(panel);
                onCompleteResize(finalWidth);
                onResizeEnd === null || onResizeEnd === void 0 || onResizeEnd({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panel.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panel,
        resizingCssVar,
        panelWidth,
        position,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    var onResizeStartStableRef = (0, $jixdz.default)(onResizeStart);
    var onResizeEndStableRef = (0, $jixdz.default)(onResizeEnd);
    var _useState5 = (0, $iSvIT.useState)(function() {
        return (0, $ef1C7.createKeyboardResizeManager)({
            onResizeStart: function onResizeStart() {
                var _onResizeStartStableR;
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver === null || openLayerObserver === void 0 || openLayerObserver.closeLayers();
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                (_onResizeStartStableR = onResizeStartStableRef.current) === null || _onResizeStartStableR === void 0 || _onResizeStartStableR.call.apply(_onResizeStartStableR, [
                    onResizeStartStableRef
                ].concat(args));
            },
            onResizeEnd: function onResizeEnd() {
                var _onResizeEndStableRef;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return (_onResizeEndStableRef = onResizeEndStableRef.current) === null || _onResizeEndStableRef === void 0 ? void 0 : _onResizeEndStableRef.call.apply(_onResizeEndStableRef, [
                    onResizeEndStableRef
                ].concat(args));
            }
        });
    }), _useState6 = (0, $gaNY9.default)(_useState5, 1), keyboardResizeManager = _useState6[0];
    var handleSliderInputChange = (0, $iSvIT.useCallback)(function(event) {
        var value = parseInt(event.target.value);
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    var resizeEventListenerCleanupFn = (0, $iSvIT.useRef)(null);
    var handleSliderFocus = (0, $iSvIT.useCallback)(function() {
        var _resizeEventListenerC;
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        (_resizeEventListenerC = resizeEventListenerCleanupFn.current) === null || _resizeEventListenerC === void 0 || _resizeEventListenerC.call(resizeEventListenerCleanupFn);
        // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        var resizeBounds = getResizeBounds();
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $6Cbfr.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $6Cbfr.convertResizeBoundToPixels)(resizeBounds.max)
        });
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $2e1kT.bind)(window, {
            type: "resize",
            listener: function updateState() {
                var resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $6Cbfr.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $6Cbfr.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    var handleSliderBlur = (0, $iSvIT.useCallback)(function() {
        var _resizeEventListenerC2;
        // Remove the resize event listener when the range input is blurred.
        (_resizeEventListenerC2 = resizeEventListenerCleanupFn.current) === null || _resizeEventListenerC2 === void 0 || _resizeEventListenerC2.call(resizeEventListenerCleanupFn);
    }, []);
    (0, $iSvIT.useEffect)(function() {
        return function cleanup() {
            var _resizeEventListenerC3;
            // Cleanup the resize event listener when the component is unmounted.
            (_resizeEventListenerC3 = resizeEventListenerCleanupFn.current) === null || _resizeEventListenerC3 === void 0 || _resizeEventListenerC3.call(resizeEventListenerCleanupFn);
        };
    }, []);
    var ariaValueText = (0, $iSvIT.useMemo)(function() {
        return "".concat((0, $2jVJu.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        }), "% width");
    }, [
        rangeInputValue,
        rangeInputBounds
    ]);
    return /*#__PURE__*/ (0, $i5UxU.createPortal)(/*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": testId ? "".concat(testId, "-container") : undefined,
        className: (0, $8lTdX.default)([
            $ddf93d45197e4ccc$var$containerStyles.root,
            position === "start" && $ddf93d45197e4ccc$var$containerStyles.positionStart,
            position === "end" && $ddf93d45197e4ccc$var$containerStyles.positionEnd
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        ref: splitterRef,
        "data-testid": testId,
        className: (0, $8lTdX.default)([
            $ddf93d45197e4ccc$var$grabAreaStyles.root
        ])
    }, /*#__PURE__*/ $iSvIT.createElement((0, $hozmE.default), null, /*#__PURE__*/ $iSvIT.createElement("input", {
        type: "range",
        value: rangeInputValue,
        step: 20,
        min: rangeInputBounds.min,
        max: rangeInputBounds.max,
        "aria-valuetext": ariaValueText,
        "aria-labelledby": labelId,
        onChange: handleSliderInputChange,
        onFocus: handleSliderFocus,
        onBlur: handleSliderBlur
    }), /*#__PURE__*/ $iSvIT.createElement("span", {
        id: labelId
    }, label)), /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $8lTdX.default)([
            $ddf93d45197e4ccc$var$lineStyles.root
        ])
    }))), portal);
};
var $ddf93d45197e4ccc$export$db67e3f8d3d6da0f = function PanelSplitter(_ref6) {
    var label = _ref6.label, onResizeStart = _ref6.onResizeStart, onResizeEnd = _ref6.onResizeEnd, testId = _ref6.testId;
    var _useState7 = (0, $iSvIT.useState)(null), _useState8 = (0, $gaNY9.default)(_useState7, 2), panel = _useState8[0], setPanel = _useState8[1];
    var _useState9 = (0, $iSvIT.useState)(null), _useState0 = (0, $gaNY9.default)(_useState9, 2), portal = _useState0[0], setPortal = _useState0[1];
    var context = (0, $iSvIT.useContext)((0, $aUWDs.PanelSplitterContext));
    (0, $jNYFj.default)(context, "Panel splitter context not set");
    var panelRef = context.panelRef, portalRef = context.portalRef, isEnabled = context.isEnabled, panelId = context.panelId, panelWidth = context.panelWidth, onCompleteResize = context.onCompleteResize, getResizeBounds = context.getResizeBounds, resizingCssVar = context.resizingCssVar, position = context.position;
    /**
   * **Explanation**
   *
   * _How React Suspense works_
   *
   * When a component is suspended:
   *
   * - it is _not_ "unmounted" and effects are _not_ cleaned up
   * - refs to react managed elements are cleared
   * - react adds `display:none !important` as an inline style to hide the element
   * - state is preserved
   *
   * When a suspended component is resumed:
   * - `display:none !important` inline style is removed
   * - it will re-render (without the refs set)
   * - refs will be set
   * - `useEffect` will _not_ re-run
   *
   * [More details](https://x.com/alexandereardon/status/1944617494569992440)
   *
   * _What does this mean for the panel splitter?_
   *
   * - The panel splitter renders into content into a react managed element (eg managed by Aside)
   * - When UI is suspended the portal ref is cleared
   * - After a suspense, we will get a render with cleared refs
   * - 🔥 This is problematic if we want to portal into that ref during the render
   *
   * _Approach: initial render_
   *
   * - We cannot portal the panel splitter until after the refs are initially set
   * - Effects run after refs being set. In an effect we set the ref values (which are populated),
   *   trigger a re-render and then portal into the refs.
   *
   * _Approach: suspense_
   *
   * - We put the refs into react `state` after every render
   * - The refs in `state` will not be cleared by suspending as effects are not run, or cleaned up,
   *   when components are suspended / resumed.
   * - After the post suspense render, we can use the `portalRef` (which was captured in an effect)
   *   to continue to portal into.
   *
   * _Why not store `portalRef` in `state` in `<PanelSplitterProvider>`?_
   *
   * - The `portalRef` is set high in the tree, so a re-render will cause a
   *   large amount of components to re-render (eg the whole sidebar)
   * - After a suspense, we would need to do _another_ large re-render to propagate the new refs
   * - With our current approach, any changes to `portalRef` will cause a re-render low in the tree
   *   (just in the `<PanelSplitter>`)
   */ // We want this effect to run after each render (see above)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $iSvIT.useEffect)(function() {
        // Don't need to do anything
        if (!isEnabled) return;
        // It is safe to access refs in useEffect, even with Suspense
        var panelEl = panelRef.current;
        var portalEl = portalRef.current;
        (0, $jNYFj.default)(panelEl, "panelRef not set");
        (0, $jNYFj.default)(portalEl, "portal element not set");
        // Doing our own check, as this results in fewer re-renders than react
        // (which also does it's own checks to see if a re-render should occur)
        if (panelEl === panel && portalEl === portal) return;
        // If refs don't change, react won't cause infinite loops
        setPanel(panelEl);
        setPortal(portalEl);
    });
    if (!isEnabled) return null;
    if (!portal || !panel) return null;
    return /*#__PURE__*/ $iSvIT.createElement($ddf93d45197e4ccc$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        panelId: panelId,
        panel: panel,
        portal: portal,
        panelWidth: panelWidth,
        onCompleteResize: onCompleteResize,
        getResizeBounds: getResizeBounds,
        resizingCssVar: resizingCssVar,
        position: position
    });
};

});
parcelRegister("jixdz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0c9772125cf3b2f$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $e0c9772125cf3b2f$export$2e2bcd8739ae039(value) {
    var ref = (0, $iSvIT.useRef)(value);
    (0, $iSvIT.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("9AbOd", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", function () { return (parcelRequire("iiuYj")).blockDraggingToIFrames; });

var $iiuYj = parcelRequire("iiuYj");

});
parcelRegister("iiuYj", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", function () { return $d521eec9f7766b70$export$6ae1d8fab001518c; });

var $1Nakb = parcelRequire("1Nakb");

var $9cik8 = parcelRequire("9cik8");

var $gienU = parcelRequire("gienU");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $d521eec9f7766b70$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? "" : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
var $d521eec9f7766b70$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $d521eec9f7766b70$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($d521eec9f7766b70$var$isActive) return;
    $d521eec9f7766b70$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    var iframeCleanups = Array.from(document.querySelectorAll("iframe")).map(function(iframe) {
        return $d521eec9f7766b70$var$setStyle(iframe, {
            property: "pointer-events",
            rule: "none",
            priority: "important"
        });
    });
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    var cleanup = (0, $gienU.combine).apply(void 0, (0, $1Nakb.default)(iframeCleanups).concat([
        // We only need this monitor for listening to the drop
        // as our monitor in `blockDraggingToIFrames()` will only
        // call this function when the drag has started
        (0, $9cik8.monitorForElements)({
            onDrop: function onDrop() {
                cleanup();
            }
        }),
        function release() {
            $d521eec9f7766b70$var$isActive = false;
        }
    ]));
}
function $d521eec9f7766b70$export$6ae1d8fab001518c(_ref2) {
    var element = _ref2.element;
    return (0, $9cik8.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview(_ref3) {
            var source = _ref3.source;
            // only starting if we are dragging the provided element
            if (source.element === element) $d521eec9f7766b70$var$tryStart();
        }
    });
}

});


parcelRegister("6Cbfr", function(module, exports) {

$parcel$export(module.exports, "convertResizeBoundToPixels", function () { return $4d0f044bbe3cd408$export$3d412b3011b66f82; });
/**
 * Resize bounds can either be provided in `vw` or `px` units. This function will convert the value into pixels.
 *
 * It accesses the `window` object to get the viewport width, so should only be used in the browser.
 */ function $4d0f044bbe3cd408$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith("vw")) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        var maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("2jVJu", function(module, exports) {

$parcel$export(module.exports, "getPercentageWithinPixelBounds", function () { return $1b0a23a6bd1b7103$export$b5423678cdf09f5; });
/**
 * Returns the percentage of the current width within the resize bounds.
 * It expects the resize bounds to already have been converted into numeric values, in pixel units.
 *
 * The return value is clamped between 0 and 100. This is to prevent the screen reader text (aria-valuetext)
 * from announcing an out-of-bounds percentage when the user is resizing the viewport.
 *
 * Examples:
 * - if the current width is 200px, and the resize bounds are 100px and 300px,
 * the percentage is 50%, and the function will return the number 50.
 * - if the current value is 400, and the resize bounds are 100 and 300, the
 * "percentage" is 100% and the function will return the number 100.
 */ function $1b0a23a6bd1b7103$export$b5423678cdf09f5(_ref) {
    var currentWidth = _ref.currentWidth, resizeBounds = _ref.resizeBounds;
    var resizeRange = resizeBounds.max - resizeBounds.min;
    var widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("BAnVW", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", function () { return $070fae1fb7489c96$export$e360234971cb95b8; });
$parcel$export(module.exports, "getPixelWidth", function () { return $070fae1fb7489c96$export$d942790ad00c41f9; });
var $070fae1fb7489c96$export$e360234971cb95b8 = function getWidthFromDragLocation(_ref) {
    var initialWidth = _ref.initialWidth, location = _ref.location, direction = _ref.direction, position = _ref.position;
    var diffX = location.current.input.clientX - location.initial.input.clientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === "end") return direction === "ltr" ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === "ltr" ? initialWidth - diffX : initialWidth + diffX;
};
var $070fae1fb7489c96$export$d942790ad00c41f9 = function getPixelWidth(element) {
    var _window$getComputedSt = window.getComputedStyle(element), width = _window$getComputedSt.width;
    return parseInt(width);
};

});

parcelRegister("ef1C7", function(module, exports) {

$parcel$export(module.exports, "createKeyboardResizeManager", function () { return $a5e3b7e0182dd6dc$export$f7d3d5dae65f74aa; });
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ var $a5e3b7e0182dd6dc$var$resizeCallbackDebounceTimeMs = 500;
function $a5e3b7e0182dd6dc$export$f7d3d5dae65f74aa(_ref) {
    var onResizeStart = _ref.onResizeStart, onResizeEnd = _ref.onResizeEnd;
    var resizingState = {
        type: "idle"
    };
    /**
   * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
   */ function startResizeEndTimer(_ref2) {
        var initialWidth = _ref2.initialWidth, finalWidth = _ref2.finalWidth;
        var markResizeAsEndedTimeout = setTimeout(function() {
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: "idle"
            };
        }, $a5e3b7e0182dd6dc$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: "resizing",
            initialWidth: initialWidth,
            abort: function abort() {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize(_ref3) {
        var initialWidth = _ref3.initialWidth, finalWidth = _ref3.finalWidth;
        if (resizingState.type === "idle") {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === "resizing") {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});



parcelRegister("kCMQ4", function(module, exports) {

$parcel$export(module.exports, "sideNavFlyoutCloseDelayMs", function () { return $f03d3d9e66f30875$export$a7801e29f563faad; });
// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ var $f03d3d9e66f30875$export$a7801e29f563faad = 400;

});

parcelRegister("a6Jfn", function(module, exports) {

$parcel$export(module.exports, "useExpandSideNav", function () { return $75bd900c38b15881$export$e44b4744d8ff971a; });

var $iSvIT = parcelRequire("iSvIT");

var $jNYFj = parcelRequire("jNYFj");

var $5C9o6 = parcelRequire("5C9o6");
function $75bd900c38b15881$export$e44b4744d8ff971a() {
    var setSideNavState = (0, $iSvIT.useContext)((0, $5C9o6.SetSideNavVisibilityState));
    var expandSideNav = (0, $iSvIT.useCallback)(function() {
        var _window$matchMedia = window.matchMedia("(min-width: 64rem)"), matches = _window$matchMedia.matches;
        if (matches) setSideNavState(function(currentState) {
            (0, $jNYFj.default)(currentState, "Side nav state should not be null");
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === "expanded" && currentState.flyout === "closed") return currentState;
            return {
                mobile: currentState.mobile,
                desktop: "expanded",
                flyout: "closed"
            };
        });
        else setSideNavState(function(currentState) {
            (0, $jNYFj.default)(currentState, "Side nav state should not be null");
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === "expanded" && currentState.flyout === "closed") return currentState;
            return {
                desktop: currentState.desktop,
                mobile: "expanded",
                flyout: "closed"
            };
        });
    }, [
        setSideNavState
    ]);
    return expandSideNav;
}

});

parcelRegister("iVL2e", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibility", function () { return $dc82090af6606e4b$export$4a602ad7e09bdb2c; });

var $iSvIT = parcelRequire("iSvIT");

var $5C9o6 = parcelRequire("5C9o6");
var $dc82090af6606e4b$export$4a602ad7e09bdb2c = function useSideNavVisibility() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$defaultCollapsed = _ref.defaultCollapsed, defaultCollapsed = _ref$defaultCollapsed === void 0 ? false : _ref$defaultCollapsed;
    var sideNavState = (0, $iSvIT.useContext)((0, $5C9o6.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === "expanded",
        isExpandedOnMobile: sideNavState.mobile === "expanded"
    };
};

});

parcelRegister("1KdxI", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibilityCallbacks", function () { return $145497aa69ff7796$export$1904b8f2577aba9a; });

var $iSvIT = parcelRequire("iSvIT");

var $wLJoW = parcelRequire("wLJoW");
function $145497aa69ff7796$export$1904b8f2577aba9a(_ref) {
    var onExpand = _ref.onExpand, onCollapse = _ref.onCollapse, isExpandedOnDesktop = _ref.isExpandedOnDesktop, isExpandedOnMobile = _ref.isExpandedOnMobile;
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    var onExpandRef = (0, $iSvIT.useRef)(onExpand);
    var onCollapseRef = (0, $iSvIT.useRef)(onCollapse);
    (0, $iSvIT.useEffect)(function() {
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    var previousIsExpandedOnDesktop = (0, $wLJoW.default)(isExpandedOnDesktop);
    (0, $iSvIT.useEffect)(function() {
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnDesktop) {
            var _onExpandRef$current;
            (_onExpandRef$current = onExpandRef.current) === null || _onExpandRef$current === void 0 || _onExpandRef$current.call(onExpandRef, {
                screen: "desktop"
            });
        } else {
            var _onCollapseRef$curren;
            (_onCollapseRef$curren = onCollapseRef.current) === null || _onCollapseRef$curren === void 0 || _onCollapseRef$curren.call(onCollapseRef, {
                screen: "desktop"
            });
        }
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop
    ]);
    var previousIsExpandedOnMobile = (0, $wLJoW.default)(isExpandedOnMobile);
    (0, $iSvIT.useEffect)(function() {
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnMobile) {
            var _onExpandRef$current2;
            (_onExpandRef$current2 = onExpandRef.current) === null || _onExpandRef$current2 === void 0 || _onExpandRef$current2.call(onExpandRef, {
                screen: "mobile"
            });
        } else {
            var _onCollapseRef$curren2;
            (_onCollapseRef$curren2 = onCollapseRef.current) === null || _onCollapseRef$curren2 === void 0 || _onCollapseRef$curren2.call(onCollapseRef, {
                screen: "mobile"
            });
        }
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile
    ]);
}

});
parcelRegister("wLJoW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $062803b6011101ce$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $062803b6011101ce$export$2e2bcd8739ae039(value) {
    var ref = (0, $iSvIT.useRef)();
    (0, $iSvIT.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});


parcelRegister("3Cnch", function(module, exports) {

$parcel$export(module.exports, "useToggleSideNav", function () { return $2a26ea25a260aff5$export$477ee35601a0a8ce; });

var $iSvIT = parcelRequire("iSvIT");

var $jNYFj = parcelRequire("jNYFj");

var $5C9o6 = parcelRequire("5C9o6");
function $2a26ea25a260aff5$export$477ee35601a0a8ce() {
    var setSideNavState = (0, $iSvIT.useContext)((0, $5C9o6.SetSideNavVisibilityState));
    var toggleSideNav = (0, $iSvIT.useCallback)(function() {
        var _window$matchMedia = window.matchMedia("(min-width: 64rem)"), matches = _window$matchMedia.matches;
        if (matches) setSideNavState(function(currentState) {
            (0, $jNYFj.default)(currentState, "Side nav state should not be null");
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === "expanded" ? "collapsed" : "expanded",
                flyout: "closed"
            };
        });
        else setSideNavState(function(currentState) {
            (0, $jNYFj.default)(currentState, "Side nav state should not be null");
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === "expanded" ? "collapsed" : "expanded",
                flyout: "closed"
            };
        });
    }, [
        setSideNavState
    ]);
    return toggleSideNav;
}

});


parcelRegister("kxCzi", function(module, exports) {

$parcel$export(module.exports, "SideNavContent", function () { return $ef44ce99575c3592$export$babe3c784778f3ba; });
/* side-nav-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");
var $ef44ce99575c3592$export$babe3c784778f3ba = /*#__PURE__*/ (0, $iSvIT.forwardRef)($ef44ce99575c3592$var$_SideNavContent);
// Placing this const below the function breaks Compiled!
var $ef44ce99575c3592$var$styles = {
    scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    paddingContainer: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
function $ef44ce99575c3592$var$_SideNavContent(_ref, ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $8lTdX.default)([
            $ef44ce99575c3592$var$styles.scrollContainer
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $8lTdX.default)([
            $ef44ce99575c3592$var$styles.paddingContainer
        ])
    }, children));
}

});

parcelRegister("9emui", function(module, exports) {

$parcel$export(module.exports, "SideNavHeader", function () { return $6b86dd6c7b45d363$export$9d28ff3a0d89869c; });
/* side-nav-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");
var $6b86dd6c7b45d363$var$styles = {
    root: "_18zrutpp _1q51utpp _85i51b66"
};
var $6b86dd6c7b45d363$export$9d28ff3a0d89869c = function SideNavHeader(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $8lTdX.default)([
            $6b86dd6c7b45d363$var$styles.root
        ])
    }, children);
};

});

parcelRegister("kNBG6", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButton", function () { return $f2459c5571169876$export$8bd77667631fec25; });
/* toggle-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gaNY9 = parcelRequire("gaNY9");

var $8lTdX = parcelRequire("8lTdX");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $7srWP = parcelRequire("7srWP");

var $lE2bL = parcelRequire("lE2bL");

var $jxLBU = parcelRequire("jxLBU");

var $hDoCV = parcelRequire("hDoCV");

var $ei9j3 = parcelRequire("ei9j3");

var $iVL2e = parcelRequire("iVL2e");

var $3Cnch = parcelRequire("3Cnch");
var $f2459c5571169876$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
// For duplicate "mouseenter" issue when changing icons (see below)
var $f2459c5571169876$var$silentIconStyles = null;
var $f2459c5571169876$export$8bd77667631fec25 = function SideNavToggleButton(_ref) {
    var _ref$defaultCollapsed = _ref.defaultCollapsed, defaultCollapsed = _ref$defaultCollapsed === void 0 ? false : _ref$defaultCollapsed, expandLabel = _ref.expandLabel, collapseLabel = _ref.collapseLabel, testId = _ref.testId, interactionName = _ref.interactionName, onClick = _ref.onClick;
    var _useSideNavVisibility = (0, $iVL2e.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    }), isSideNavExpandedOnDesktop = _useSideNavVisibility.isExpandedOnDesktop, isSideNavExpandedOnMobile = _useSideNavVisibility.isExpandedOnMobile;
    var _useState = (0, $iSvIT.useState)(!defaultCollapsed), _useState2 = (0, $gaNY9.default)(_useState, 2), isSideNavExpanded = _useState2[0], setIsSideNavExpanded = _useState2[1];
    var ref = (0, $iSvIT.useContext)((0, $ei9j3.SideNavToggleButtonAttachRef));
    var elementRef = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(function() {
        if ((0, $jxLBU.fg)("platform_fix_component_state_update_for_suspense")) ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    (0, $iSvIT.useEffect)(function() {
        var _window$matchMedia = window.matchMedia("(min-width: 64rem)"), matches = _window$matchMedia.matches;
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $iSvIT.useEffect)(function() {
        // When screen size changes, ensure we use the correct visibility state
        var mediaQueryList = window.matchMedia("(min-width: 64rem)");
        return (0, $2e1kT.bind)(mediaQueryList, {
            type: "change",
            listener: function listener() {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    var toggleVisibility = (0, $3Cnch.useToggleSideNav)();
    var handleClick = (0, $iSvIT.useCallback)(function(event, analyticsEvent) {
        onClick === null || onClick === void 0 || onClick(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
    }, [
        onClick,
        toggleVisibility,
        isSideNavExpanded
    ]);
    /**
   * ## Behaviour
   * It is intentional that collapse icon will be used while the flyout is open.
   * The icon is tied to the expanded / collapse state, and not the flyout state.
   *
   * ## Why a function?
   * Unfortunately, changing the icon inside an <IconButton> when the user is over
   * the button will cause the svg element to be replaced, which can trigger a
   * "mouseenter" event. This is problematic when the user is already over the button,
   * as it can result in a "mouseenter" event after the user manually entered the button.
   *
   * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
   * memoize it, or pull it out into a new function
   */ var icon = function icon(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
            className: (0, $8lTdX.default)([
                "_1e0c1bgi _lcxvglyw"
            ])
        }, isSideNavExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7srWP))), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lE2bL))), props));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hDoCV.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: (0, $jxLBU.fg)("platform_fix_component_state_update_for_suspense") ? elementRef : ref,
        tooltip: $f2459c5571169876$var$toggleButtonTooltipOptions
    });
};

});
parcelRegister("7srWP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7c03d2728886be26240ae9af453c127>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56e0d3cd8b7e3b68$var$_react = $56e0d3cd8b7e3b68$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $56e0d3cd8b7e3b68$var$_baseNew = $56e0d3cd8b7e3b68$var$_interopRequireDefault((parcelRequire("kPVdq")));
function $56e0d3cd8b7e3b68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56e0d3cd8b7e3b68$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $56e0d3cd8b7e3b68$var$_react.default.createElement($56e0d3cd8b7e3b68$var$_baseNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$56e0d3cd8b7e3b68$var$SidebarCollapseIcon.displayName = "SidebarCollapseIcon";
var $56e0d3cd8b7e3b68$var$_default = module.exports.default = $56e0d3cd8b7e3b68$var$SidebarCollapseIcon;

});
parcelRegister("kPVdq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9J4UL")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("9J4UL")).Icon; });

var $9J4UL = parcelRequire("9J4UL");

});
parcelRegister("9J4UL", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $714c20eef80fe7de$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $714c20eef80fe7de$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $jxLBU = parcelRequire("jxLBU");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $714c20eef80fe7de$var$svgStyles = null;
var $714c20eef80fe7de$var$iconStyles = null;
var $714c20eef80fe7de$var$utilityIconStyles = null;
var $714c20eef80fe7de$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $714c20eef80fe7de$var$baseHcmStyles = null;
var $714c20eef80fe7de$var$scaleSize = null;
var $714c20eef80fe7de$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $714c20eef80fe7de$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $714c20eef80fe7de$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $714c20eef80fe7de$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $714c20eef80fe7de$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $714c20eef80fe7de$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $jxLBU.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return /*#__PURE__*/ $iSvIT.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core";
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = $714c20eef80fe7de$var$baseSizeMap[type];
    var viewBoxPadding = $714c20eef80fe7de$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $8lTdX.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === "utility" || size === "small") && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $8lTdX.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === "utility" ? $714c20eef80fe7de$var$utilSizes[spacing] : size === "small" ? $714c20eef80fe7de$var$coreSizeSmall[spacing] : $714c20eef80fe7de$var$coreSizeMedium[spacing]
        ])
    }));
});
var $714c20eef80fe7de$export$2e2bcd8739ae039 = $714c20eef80fe7de$export$f04a61298a47a40f;

});



parcelRegister("lE2bL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::87b126ba38d591666b6bb1a2ae894895>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc1f0806960cc9fb$var$_react = $fc1f0806960cc9fb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fc1f0806960cc9fb$var$_baseNew = $fc1f0806960cc9fb$var$_interopRequireDefault((parcelRequire("kPVdq")));
function $fc1f0806960cc9fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc1f0806960cc9fb$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $fc1f0806960cc9fb$var$_react.default.createElement($fc1f0806960cc9fb$var$_baseNew.default, Object.assign({
        name: "SidebarExpandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$fc1f0806960cc9fb$var$SidebarExpandIcon.displayName = "SidebarExpandIcon";
var $fc1f0806960cc9fb$var$_default = module.exports.default = $fc1f0806960cc9fb$var$SidebarExpandIcon;

});

parcelRegister("hDoCV", function(module, exports) {

$parcel$export(module.exports, "IconButton", function () { return $cd692e94de89b12c$export$c25acd513dcc8062; });

var $jRswm = parcelRequire("jRswm");

var $iSvIT = parcelRequire("iSvIT");

var $chB1b = parcelRequire("chB1b");
var $hUeuq = parcelRequire("hUeuq");
var $kd5Gv = parcelRequire("kd5Gv");
var $bE0u1 = parcelRequire("bE0u1");

var $7HvyC = parcelRequire("7HvyC");

var $gSLRZ = parcelRequire("gSLRZ");
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $cd692e94de89b12c$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $gSLRZ.useHasCustomTheme)();
    var Component = hasCustomTheme ? (0, $7HvyC.ThemedIconButton) : (0, $hUeuq.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Component, (0, $jRswm.default)({
        ref: ref
    }, props));
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $cd692e94de89b12c$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $gSLRZ.useHasCustomTheme)();
    var Component = hasCustomTheme ? (0, $7HvyC.ThemedLinkIconButton) : (0, $bE0u1.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Component, (0, $jRswm.default)({
        ref: ref
    }, props));
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $cd692e94de89b12c$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $gSLRZ.useHasCustomTheme)();
    var Component = hasCustomTheme ? (0, $7HvyC.ThemedButton) : (0, $chB1b.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Component, (0, $jRswm.default)({
        ref: ref
    }, props));
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $cd692e94de89b12c$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $gSLRZ.useHasCustomTheme)();
    var Component = hasCustomTheme ? (0, $7HvyC.ThemedLinkButton) : (0, $kd5Gv.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Component, (0, $jRswm.default)({
        ref: ref
    }, props));
});

});
parcelRegister("chB1b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f13c995bda74d14$export$2e2bcd8739ae039; });

var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");

var $4yf7N = parcelRequire("4yf7N");

var $12Nm2 = parcelRequire("12Nm2");

var $2GhoB = parcelRequire("2GhoB");
var $8f13c995bda74d14$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $8f13c995bda74d14$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $8f13c995bda74d14$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, $fzcGG.default)(_ref, $8f13c995bda74d14$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $fzcGG.default)(unsafeRest, $8f13c995bda74d14$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4yf7N.default), (0, $jRswm.default)({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $12Nm2.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2GhoB.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $12Nm2.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $12Nm2.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2GhoB.default), {
        icon: iconAfter
    }))));
}));
$8f13c995bda74d14$var$Button.displayName = "Button";
var $8f13c995bda74d14$export$2e2bcd8739ae039 = $8f13c995bda74d14$var$Button;

});
parcelRegister("4yf7N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $350611db5a5b62fc$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $8lTdX = parcelRequire("8lTdX");

var $iSvIT = parcelRequire("iSvIT");

var $1erle = parcelRequire("1erle");

var $6Qy6S = parcelRequire("6Qy6S");

var $j9Qy5 = parcelRequire("j9Qy5");

var $5CqIy = parcelRequire("5CqIy");

var $jxLBU = parcelRequire("jxLBU");

var $1NPmK = parcelRequire("1NPmK");

var $hozmE = parcelRequire("hozmE");

var $kF2zt = parcelRequire("kF2zt");

var $1lJ5s = parcelRequire("1lJ5s");

var $kfX83 = parcelRequire("kfX83");
var $350611db5a5b62fc$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $350611db5a5b62fc$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $350611db5a5b62fc$var$LOADING_LABEL = ", Loading";
var $350611db5a5b62fc$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1lh4 _30l31lh4 _9h8h1lh4",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $350611db5a5b62fc$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $350611db5a5b62fc$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $350611db5a5b62fc$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $350611db5a5b62fc$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $350611db5a5b62fc$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $350611db5a5b62fc$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $350611db5a5b62fc$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $350611db5a5b62fc$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $fzcGG.default)(_ref, $350611db5a5b62fc$var$_excluded);
    var localRef = (0, $iSvIT.useRef)(null);
    var splitButtonContext = (0, $kF2zt.useSplitButtonContext)();
    var loadingLabelId = (0, $5CqIy.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton && (0, $jxLBU.fg)("platform-component-visual-refresh") ? "subtle" : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || "default";
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $j9Qy5.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $fzcGG.default)(unsafeRest, $350611db5a5b62fc$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1NPmK.default), (0, $jRswm.default)({}, saferRest, {
        componentName: componentName || "button",
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $6Qy6S.default)([
            localRef,
            ref
        ]),
        xcss: (0, $1erle.cx)($350611db5a5b62fc$var$styles.base, appearance === "default" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $350611db5a5b62fc$var$defaultStyles.rootRefreshed : $350611db5a5b62fc$var$defaultStyles.root), appearance === "default" && isInteractive && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $350611db5a5b62fc$var$defaultStyles.interactiveRefreshed : $350611db5a5b62fc$var$defaultStyles.interactive), appearance === "primary" && $350611db5a5b62fc$var$primaryStyles.root, appearance === "primary" && isInteractive && $350611db5a5b62fc$var$primaryStyles.interactive, appearance === "warning" && $350611db5a5b62fc$var$warningStyles.root, appearance === "warning" && isInteractive && $350611db5a5b62fc$var$warningStyles.interactive, appearance === "danger" && $350611db5a5b62fc$var$dangerStyles.root, appearance === "danger" && isInteractive && $350611db5a5b62fc$var$dangerStyles.interactive, appearance === "discovery" && $350611db5a5b62fc$var$discoveryStyles.root, appearance === "discovery" && isInteractive && $350611db5a5b62fc$var$discoveryStyles.interactive, appearance === "subtle" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $350611db5a5b62fc$var$subtleStyles.rootRefreshed : $350611db5a5b62fc$var$subtleStyles.root), appearance === "subtle" && isInteractive && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $350611db5a5b62fc$var$subtleStyles.interactiveRefreshed : $350611db5a5b62fc$var$subtleStyles.interactive), $350611db5a5b62fc$var$styles.linkDecorationUnset, isSelected && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $350611db5a5b62fc$var$selectedStyles.rootRefreshed : $350611db5a5b62fc$var$selectedStyles.root), isSelected && isSplitButton && $350611db5a5b62fc$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $350611db5a5b62fc$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "danger" && $350611db5a5b62fc$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "warning" && $350611db5a5b62fc$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $350611db5a5b62fc$var$selectedStyles.discovery, isDisabled && $350611db5a5b62fc$var$styles.disabled, isDisabled && (!(0, $jxLBU.fg)("platform-component-visual-refresh") || appearance !== "default" && appearance !== "subtle") && $350611db5a5b62fc$var$styles.sharedDisabled, isDisabled && appearance === "default" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $350611db5a5b62fc$var$defaultStyles.disabledRefreshed : $350611db5a5b62fc$var$defaultStyles.disabled), isCircle && !isSplitButton && $350611db5a5b62fc$var$styles.circle, spacing === "compact" && $350611db5a5b62fc$var$styles.spacingCompact, hasIconBefore && $350611db5a5b62fc$var$styles.buttonIconBefore, shouldFitContainer && $350611db5a5b62fc$var$styles.fullWidth, hasIconAfter && $350611db5a5b62fc$var$styles.buttonIconAfter, isIconButton && $350611db5a5b62fc$var$styles.iconButton, isIconButton && spacing === "compact" && $350611db5a5b62fc$var$styles.iconButtonCompact, isLoading && $350611db5a5b62fc$var$styles.loading, isSplitButton && $350611db5a5b62fc$var$styles.splitButton, isNavigationSplitButton && $350611db5a5b62fc$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($350611db5a5b62fc$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $1lJ5s.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $kF2zt.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $8lTdX.default)([
            $350611db5a5b62fc$var$styles.loadingOverlay
        ])
    }, (0, $kfX83.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hozmE.default), {
        id: loadingLabelId
    }, $350611db5a5b62fc$var$LOADING_LABEL)));
});
var $350611db5a5b62fc$export$2e2bcd8739ae039 = $350611db5a5b62fc$var$ButtonBase;

});
parcelRegister("1erle", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $0e5c4eaf2ceb5668$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("iSvIT");


var $loXwu = parcelRequire("loXwu");
var $0e5c4eaf2ceb5668$var$_createStrictAPI = (0, $loXwu.createStrictAPI)(), $0e5c4eaf2ceb5668$var$XCSSProp = $0e5c4eaf2ceb5668$var$_createStrictAPI.XCSSProp, $0e5c4eaf2ceb5668$export$dbf350e5966cf602 = $0e5c4eaf2ceb5668$var$_createStrictAPI.css, $0e5c4eaf2ceb5668$export$eb1ecd84a24ee424 = $0e5c4eaf2ceb5668$var$_createStrictAPI.cssMap, $0e5c4eaf2ceb5668$export$a274e22fb40f762e = $0e5c4eaf2ceb5668$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("loXwu", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $f94a02e720b89c3a$export$39716b4af53f4ad; });

var $1DqIA = parcelRequire("1DqIA");

var $hHqGT = parcelRequire("hHqGT");
function $f94a02e720b89c3a$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $1DqIA.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $1DqIA.createStrictSetupError)();
        },
        cx: $hHqGT.cx,
        XCSSProp () {
            throw (0, $1DqIA.createStrictSetupError)();
        }
    };
}

});
parcelRegister("1DqIA", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $130e28a2c8d9259b$export$c4df1cb0c2b4d77c; });
const $130e28a2c8d9259b$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $130e28a2c8d9259b$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("hHqGT", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $ce2b2813971d934b$export$a274e22fb40f762e; });

var $8lTdX = parcelRequire("8lTdX");
const $ce2b2813971d934b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $8lTdX.default)(actualStyles);
};

});



parcelRegister("j9Qy5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df279eadde3c1bd0$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $df279eadde3c1bd0$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $iSvIT.useRef)(true);
    (0, $iSvIT.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("1NPmK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $150236427eb98101$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");


var $hHqGT = parcelRequire("hHqGT");

var $lOOEF = parcelRequire("lOOEF");

var $9SZA7 = parcelRequire("9SZA7");

var $emfh8 = parcelRequire("emfh8");

var $7nG8r = parcelRequire("7nG8r");

var $cWGA8 = parcelRequire("cWGA8");
var $150236427eb98101$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $150236427eb98101$var$_excluded2 = [
    "className"
];
var $150236427eb98101$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $150236427eb98101$var$Pressable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $emfh8.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $fzcGG.default)(_ref, $150236427eb98101$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $lOOEF.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.11.2",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $fzcGG.default)(htmlAttributes, $150236427eb98101$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement((0, $cWGA8.default), (0, $jRswm.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $9SZA7.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $hHqGT.cx)($150236427eb98101$var$styles.root, isDisabled && $150236427eb98101$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $150236427eb98101$export$2e2bcd8739ae039 = $150236427eb98101$var$Pressable;

});
parcelRegister("9SZA7", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $7328ed0a2520f091$export$95df08bae54cb4df; });
function $7328ed0a2520f091$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? //@ts-expect-error ignore userAgentData type issue
    re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $7328ed0a2520f091$var$isIPhone() {
    return $7328ed0a2520f091$var$testPlatform(/^iPhone/i);
}
function $7328ed0a2520f091$var$isMac() {
    return $7328ed0a2520f091$var$testPlatform(/^Mac/i);
}
function $7328ed0a2520f091$var$isIPad() {
    return $7328ed0a2520f091$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $7328ed0a2520f091$var$isMac() && navigator.maxTouchPoints > 1;
}
function $7328ed0a2520f091$var$isIOS() {
    return $7328ed0a2520f091$var$isIPhone() || $7328ed0a2520f091$var$isIPad();
}
function $7328ed0a2520f091$export$95df08bae54cb4df() {
    if (typeof window !== "undefined" && window.navigator != null) {
        var _window$navigator$use2;
        var ua = (_window$navigator$use2 = window.navigator.userAgent) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.toLowerCase();
        return ua ? ua.includes("safari") && !ua.includes("chrome") : false;
    }
    return false;
}
function $7328ed0a2520f091$export$e1865c3bedcd822b() {
    return $7328ed0a2520f091$var$isMac() || $7328ed0a2520f091$var$isIOS();
}

});

parcelRegister("cWGA8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96cbeeaa04cc85f0$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $eLTr6 = parcelRequire("eLTr6");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");
var $6XKda = parcelRequire("6XKda");
var $96cbeeaa04cc85f0$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $96cbeeaa04cc85f0$var$_excluded2 = [
    "className"
];
function $96cbeeaa04cc85f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $96cbeeaa04cc85f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $96cbeeaa04cc85f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $96cbeeaa04cc85f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $96cbeeaa04cc85f0$var$focusRingStyles = null;
var $96cbeeaa04cc85f0$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $96cbeeaa04cc85f0$var$Focusable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $fzcGG.default)(_ref, $96cbeeaa04cc85f0$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $fzcGG.default)(htmlAttributes, $96cbeeaa04cc85f0$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $jRswm.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $8lTdX.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $96cbeeaa04cc85f0$var$_objectSpread($96cbeeaa04cc85f0$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $6XKda.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $96cbeeaa04cc85f0$export$2e2bcd8739ae039 = $96cbeeaa04cc85f0$var$Focusable;

});
parcelRegister("6XKda", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $511c195cf043472f$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $511c195cf043472f$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});



parcelRegister("kF2zt", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", function () { return $f0a9a190866941d2$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $f0a9a190866941d2$export$47e2c6fdb142d947; });

var $iSvIT = parcelRequire("iSvIT");
var $f0a9a190866941d2$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $f0a9a190866941d2$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $iSvIT.useContext)($f0a9a190866941d2$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("1lJ5s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fbab9f723aa8ec6$export$2e2bcd8739ae039; });
function $0fbab9f723aa8ec6$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $0fbab9f723aa8ec6$var$tabKeyCode = 9;
function $0fbab9f723aa8ec6$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $0fbab9f723aa8ec6$var$tabKeyCode) return;
    $0fbab9f723aa8ec6$var$abort(event);
}
function $0fbab9f723aa8ec6$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $0fbab9f723aa8ec6$var$abort,
        onMouseUpCapture: $0fbab9f723aa8ec6$var$abort,
        onKeyDownCapture: $0fbab9f723aa8ec6$var$onKey,
        onKeyUpCapture: $0fbab9f723aa8ec6$var$onKey,
        onTouchStartCapture: $0fbab9f723aa8ec6$var$abort,
        onTouchEndCapture: $0fbab9f723aa8ec6$var$abort,
        onPointerDownCapture: $0fbab9f723aa8ec6$var$abort,
        onPointerUpCapture: $0fbab9f723aa8ec6$var$abort,
        onClickCapture: $0fbab9f723aa8ec6$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $0fbab9f723aa8ec6$var$abort
    } : events;
}

});

parcelRegister("kfX83", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebf31326c9681687$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $j7bY5 = parcelRequire("j7bY5");
function $ebf31326c9681687$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $ebf31326c9681687$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $ebf31326c9681687$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $j7bY5.default), {
        size: $ebf31326c9681687$var$getIconSpacing(spacing),
        appearance: $ebf31326c9681687$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("j7bY5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dea7f469167acc0b$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8lTdX = parcelRequire("8lTdX");

var $iSvIT = parcelRequire("iSvIT");

var $7nG8r = parcelRequire("7nG8r");

var $6owtp = parcelRequire("6owtp");

var $74jYn = parcelRequire("74jYn");
/**
 * Returns the appropriate circle stroke color.
 */ function $dea7f469167acc0b$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $6owtp.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $6owtp.N0), ")");
}
var $dea7f469167acc0b$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $dea7f469167acc0b$var$loadIn = null;
var $dea7f469167acc0b$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $dea7f469167acc0b$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $dea7f469167acc0b$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $74jYn.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $dea7f469167acc0b$var$getStrokeColor(appearance);
    var context = (0, $iSvIT.useContext)((0, $7nG8r.default));
    $dea7f469167acc0b$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $8lTdX.default)([
            $dea7f469167acc0b$var$styles.wrapperStyles,
            $dea7f469167acc0b$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $8lTdX.default)([
            $dea7f469167acc0b$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $8lTdX.default)([
            $dea7f469167acc0b$var$styles.circleStyles
        ])
    })));
}));
var $dea7f469167acc0b$export$2e2bcd8739ae039 = $dea7f469167acc0b$var$Spinner;

});
parcelRegister("6owtp", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $4a7e2c7a13f94f15$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $4a7e2c7a13f94f15$export$2010d0fb4295b346; });
$parcel$export(module.exports, "G300", function () { return $4a7e2c7a13f94f15$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $4a7e2c7a13f94f15$export$a49394138f7b8e85; });
$parcel$export(module.exports, "B200", function () { return $4a7e2c7a13f94f15$export$215b7063051591f1; });
$parcel$export(module.exports, "P300", function () { return $4a7e2c7a13f94f15$export$b48405b95304b5a1; });
$parcel$export(module.exports, "N0", function () { return $4a7e2c7a13f94f15$export$29a4f05edc054374; });
$parcel$export(module.exports, "N40", function () { return $4a7e2c7a13f94f15$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N200", function () { return $4a7e2c7a13f94f15$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N500", function () { return $4a7e2c7a13f94f15$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N800", function () { return $4a7e2c7a13f94f15$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $4a7e2c7a13f94f15$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $4a7e2c7a13f94f15$export$920c0d5c49070351; });
// Reds
var $4a7e2c7a13f94f15$export$4b84fd0e2c617bd = "#FFEBE6";
var $4a7e2c7a13f94f15$export$b34b069eff244586 = "#FFBDAD";
var $4a7e2c7a13f94f15$export$be802dd0d8b57f35 = "#FF8F73";
var $4a7e2c7a13f94f15$export$60847d42f9da92a6 = "#FF7452";
var $4a7e2c7a13f94f15$export$4a7404f376229999 = "#FF5630";
var $4a7e2c7a13f94f15$export$2010d0fb4295b346 = "#DE350B";
var $4a7e2c7a13f94f15$export$2837b5a1a71d5c02 = "#BF2600";
var $4a7e2c7a13f94f15$export$8d9596b529bbb9cf = "#FFFAE6";
var $4a7e2c7a13f94f15$export$41060a744ab0b7ae = "#FFF0B3";
var $4a7e2c7a13f94f15$export$1cc05bbbf340e559 = "#FFE380";
var $4a7e2c7a13f94f15$export$5aae31392d72caaa = "#FFC400";
var $4a7e2c7a13f94f15$export$c6930421db9fa514 = "#FFAB00";
var $4a7e2c7a13f94f15$export$59619663aa6500fb = "#FF991F";
var $4a7e2c7a13f94f15$export$874739ea9e379ab6 = "#FF8B00";
var $4a7e2c7a13f94f15$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $4a7e2c7a13f94f15$export$69a3bf21b9686c2b = "#ABF5D1";
var $4a7e2c7a13f94f15$export$afbce1382ec95f73 = "#79F2C0";
var $4a7e2c7a13f94f15$export$747d86715d4175de = "#57D9A3";
var $4a7e2c7a13f94f15$export$940e1f69e873f202 = "#36B37E";
var $4a7e2c7a13f94f15$export$a49394138f7b8e85 = "#00875A";
var $4a7e2c7a13f94f15$export$6fa04827ac68a4fb = "#006644";
var $4a7e2c7a13f94f15$export$226de0355ed012f8 = "#DEEBFF";
var $4a7e2c7a13f94f15$export$8c13c2ee36917869 = "#B3D4FF";
var $4a7e2c7a13f94f15$export$ecfc1dff386a3e7a = "#4C9AFF";
var $4a7e2c7a13f94f15$export$215b7063051591f1 = "#2684FF";
var $4a7e2c7a13f94f15$export$e62e8919cca44969 = "#0065FF";
var $4a7e2c7a13f94f15$export$b3de0ae08da2ce64 = "#0052CC";
var $4a7e2c7a13f94f15$export$a6ee3d71bc067634 = "#0747A6";
var $4a7e2c7a13f94f15$export$67f15409e87642a1 = "#669DF1";
var $4a7e2c7a13f94f15$export$f0539dbc42dbb067 = "#8FB8F6";
var $4a7e2c7a13f94f15$export$363e4475840015bb = "#EAE6FF";
var $4a7e2c7a13f94f15$export$4b0a4417ed59760f = "#C0B6F2";
var $4a7e2c7a13f94f15$export$6011520a64d9a187 = "#998DD9";
var $4a7e2c7a13f94f15$export$a7175d4e9206bc80 = "#8777D9";
var $4a7e2c7a13f94f15$export$b48405b95304b5a1 = "#6554C0";
var $4a7e2c7a13f94f15$export$c71e4279dd54a18d = "#5243AA";
var $4a7e2c7a13f94f15$export$147899de772240ec = "#403294";
var $4a7e2c7a13f94f15$export$2cf711fe14c66f06 = "#E6FCFF";
var $4a7e2c7a13f94f15$export$7a8f4d33f6f9772c = "#B3F5FF";
var $4a7e2c7a13f94f15$export$776c9c497ef08533 = "#79E2F2";
var $4a7e2c7a13f94f15$export$69cb3ca10c1e330e = "#00C7E6";
var $4a7e2c7a13f94f15$export$9dc1ef0f3f48059b = "#00B8D9";
var $4a7e2c7a13f94f15$export$7c835c78b6fcdef8 = "#00A3BF";
var $4a7e2c7a13f94f15$export$6036577f95c3877e = "#008DA6";
var $4a7e2c7a13f94f15$export$29a4f05edc054374 = "#FFFFFF";
var $4a7e2c7a13f94f15$export$e655ef011c4aa1a2 = "#FAFBFC";
var $4a7e2c7a13f94f15$export$9fdfb749e33cdf97 = "#F4F5F7";
var $4a7e2c7a13f94f15$export$3e51e8f1440314ba = "#EBECF0";
var $4a7e2c7a13f94f15$export$1ce2d1575d444ceb = "#DFE1E6";
var $4a7e2c7a13f94f15$export$8754fc7e6d8b3000 = "#C1C7D0";
var $4a7e2c7a13f94f15$export$c2e91cbeada39b8b = "#B3BAC5";
var $4a7e2c7a13f94f15$export$5f71e19f3a7ad9de = "#A5ADBA";
var $4a7e2c7a13f94f15$export$eaa8c8a70ac22806 = "#97A0AF";
var $4a7e2c7a13f94f15$export$7c87d337fb91a97d = "#8993A4";
var $4a7e2c7a13f94f15$export$d6447c357493214f = "#7A869A";
var $4a7e2c7a13f94f15$export$f563ee71e9ee74cd = "#6B778C";
var $4a7e2c7a13f94f15$export$e2ef2124cf4024b1 = "#5E6C84";
var $4a7e2c7a13f94f15$export$eece5f492e429f08 = "#505F79";
var $4a7e2c7a13f94f15$export$c39c0fe0f26207ae = "#42526E";
var $4a7e2c7a13f94f15$export$7090862dc3038a9f = "#344563";
var $4a7e2c7a13f94f15$export$ad0bacf983b7ddaa = "#253858";
var $4a7e2c7a13f94f15$export$7d61b15e0da132af = "#172B4D";
var $4a7e2c7a13f94f15$export$fbda843f0a27fe96 = "#091E42";
var $4a7e2c7a13f94f15$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $4a7e2c7a13f94f15$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $4a7e2c7a13f94f15$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $4a7e2c7a13f94f15$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $4a7e2c7a13f94f15$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $4a7e2c7a13f94f15$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $4a7e2c7a13f94f15$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $4a7e2c7a13f94f15$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $4a7e2c7a13f94f15$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $4a7e2c7a13f94f15$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $4a7e2c7a13f94f15$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $4a7e2c7a13f94f15$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $4a7e2c7a13f94f15$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $4a7e2c7a13f94f15$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $4a7e2c7a13f94f15$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $4a7e2c7a13f94f15$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $4a7e2c7a13f94f15$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $4a7e2c7a13f94f15$export$2f6319cf7d736c2a = "#E6EDFA";
var $4a7e2c7a13f94f15$export$95126bc8884d6634 = "#DCE5F5";
var $4a7e2c7a13f94f15$export$8338d8c35d44ff1 = "#CED9EB";
var $4a7e2c7a13f94f15$export$5368d76ae4fbbda7 = "#B8C7E0";
var $4a7e2c7a13f94f15$export$9f0a771d16ec8d36 = "#ABBBD6";
var $4a7e2c7a13f94f15$export$abcf8c38338b4aa5 = "#9FB0CC";
var $4a7e2c7a13f94f15$export$97e81faa16a182c7 = "#8C9CB8";
var $4a7e2c7a13f94f15$export$bfe21c59123ecf33 = "#7988A3";
var $4a7e2c7a13f94f15$export$ee82aa2ea6a1558 = "#67758F";
var $4a7e2c7a13f94f15$export$682927c6ed76be02 = "#56637A";
var $4a7e2c7a13f94f15$export$91fd9994c5be9757 = "#455166";
var $4a7e2c7a13f94f15$export$d281fbfe3cff2df6 = "#3B475C";
var $4a7e2c7a13f94f15$export$3902c91d8b98a753 = "#313D52";
var $4a7e2c7a13f94f15$export$8e8133c1ba5845b5 = "#283447";
var $4a7e2c7a13f94f15$export$33ff357f6620b39 = "#202B3D";
var $4a7e2c7a13f94f15$export$633847cf062b69e0 = "#1B2638";
var $4a7e2c7a13f94f15$export$9776a6e503bdbf76 = "#121A29";
var $4a7e2c7a13f94f15$export$6c813d5160dff5db = "#0E1624";
var $4a7e2c7a13f94f15$export$3d4f271a500072a = "#0D1424";
var $4a7e2c7a13f94f15$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $4a7e2c7a13f94f15$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $4a7e2c7a13f94f15$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $4a7e2c7a13f94f15$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $4a7e2c7a13f94f15$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $4a7e2c7a13f94f15$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $4a7e2c7a13f94f15$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $4a7e2c7a13f94f15$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $4a7e2c7a13f94f15$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $4a7e2c7a13f94f15$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $4a7e2c7a13f94f15$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $4a7e2c7a13f94f15$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $4a7e2c7a13f94f15$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $4a7e2c7a13f94f15$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $4a7e2c7a13f94f15$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $4a7e2c7a13f94f15$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $4a7e2c7a13f94f15$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $4a7e2c7a13f94f15$export$d2adc5dedf09fced = "#292A2E";
var $4a7e2c7a13f94f15$export$f51762073d2bb381 = "#94C748";
var $4a7e2c7a13f94f15$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("74jYn", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $52586655742994f4$export$4e9f1640bbe7a1a8; });
var $52586655742994f4$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("12Nm2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c2c431754e73b44$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8lTdX = parcelRequire("8lTdX");

var $iSvIT = parcelRequire("iSvIT");
var $0c2c431754e73b44$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $0c2c431754e73b44$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $8lTdX.default)([
            $0c2c431754e73b44$var$styles.common,
            type === "text" && $0c2c431754e73b44$var$styles.text,
            type === "icon" && $0c2c431754e73b44$var$styles.icon,
            isLoading && $0c2c431754e73b44$var$styles.fade,
            position === "before" && $0c2c431754e73b44$var$styles.beforeIcon,
            position === "after" && $0c2c431754e73b44$var$styles.afterIcon
        ])
    }, children);
};
var $0c2c431754e73b44$export$2e2bcd8739ae039 = $0c2c431754e73b44$var$Content;

});

parcelRegister("2GhoB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f3cff79e8d12185$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $1f3cff79e8d12185$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $1f3cff79e8d12185$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return(/*#__PURE__*/ // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, $1f3cff79e8d12185$var$isIconRenderProp(Icon) ? Icon({
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Icon, {
        label: "",
        color: "currentColor"
    })));
};
var $1f3cff79e8d12185$export$2e2bcd8739ae039 = $1f3cff79e8d12185$var$IconRenderer;

});


parcelRegister("hUeuq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d092e7fc57e6e3c5$export$2e2bcd8739ae039; });

var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");

var $6Qy6S = parcelRequire("6Qy6S");

var $6ePKy = parcelRequire("6ePKy");

var $hozmE = parcelRequire("hozmE");

var $4yf7N = parcelRequire("4yf7N");

var $12Nm2 = parcelRequire("12Nm2");

var $2GhoB = parcelRequire("2GhoB");
var $d092e7fc57e6e3c5$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $d092e7fc57e6e3c5$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $d092e7fc57e6e3c5$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, $fzcGG.default)(_ref, $d092e7fc57e6e3c5$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $fzcGG.default)(unsafeRest, $d092e7fc57e6e3c5$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4yf7N.default), (0, $jRswm.default)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === "circle",
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $12Nm2.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2GhoB.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hozmE.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6ePKy.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4yf7N.default), (0, $jRswm.default)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === "circle",
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $6Qy6S.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $12Nm2.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2GhoB.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hozmE.default), null, label)));
    });
}));
$d092e7fc57e6e3c5$var$IconButton.displayName = "IconButton";
var $d092e7fc57e6e3c5$export$2e2bcd8739ae039 = $d092e7fc57e6e3c5$var$IconButton;

});
parcelRegister("6ePKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48ac315adc16a3ad$export$2e2bcd8739ae039; });

var $jRswm = parcelRequire("jRswm");

var $gaNY9 = parcelRequire("gaNY9");

var $eLTr6 = parcelRequire("eLTr6");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $hkGkf = parcelRequire("hkGkf");

var $emfh8 = parcelRequire("emfh8");

var $eTVns = parcelRequire("eTVns");

var $jixdz = parcelRequire("jixdz");

var $1Z36a = parcelRequire("1Z36a");

var $iy0QV = parcelRequire("iy0QV");
var $g2f6i = parcelRequire("g2f6i");

var $jxLBU = parcelRequire("jxLBU");

var $gr749 = parcelRequire("gr749");

var $gWVOm = parcelRequire("gWVOm");

var $2X3P3 = parcelRequire("2X3P3");

var $7r3bA = parcelRequire("7r3bA");

var $6MkAc = parcelRequire("6MkAc");

var $aarCp = parcelRequire("aarCp");

var $5y4qX = parcelRequire("5y4qX");

var $cPDs1 = parcelRequire("cPDs1");
function $48ac315adc16a3ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $48ac315adc16a3ad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $48ac315adc16a3ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $48ac315adc16a3ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $48ac315adc16a3ad$var$tooltipZIndex = (0, $2X3P3.layers).tooltip();
var $48ac315adc16a3ad$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.4.0"
};
// Inverts motion direction
var $48ac315adc16a3ad$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $48ac315adc16a3ad$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $48ac315adc16a3ad$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $5y4qX.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $emfh8.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $emfh8.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $hkGkf.usePlatformLeafSyntheticEventHandler)($48ac315adc16a3ad$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $48ac315adc16a3ad$var$analyticsAttributes));
    var onHideHandler = (0, $hkGkf.usePlatformLeafSyntheticEventHandler)($48ac315adc16a3ad$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $48ac315adc16a3ad$var$analyticsAttributes));
    var apiRef = (0, $iSvIT.useRef)(null);
    var _useState = (0, $iSvIT.useState)("hide"), _useState2 = (0, $gaNY9.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $iSvIT.useRef)(null);
    var containerRef = (0, $iSvIT.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $iSvIT.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $jixdz.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $jixdz.default)(onShowHandler);
    var onHideHandlerStable = (0, $jixdz.default)(onHideHandler);
    var delayStable = (0, $jixdz.default)(delay);
    var canAppearStable = (0, $jixdz.default)(canAppear);
    var hasCalledShowHandler = (0, $iSvIT.useRef)(false);
    var start = (0, $iSvIT.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $iSvIT.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $iSvIT.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $iSvIT.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $iSvIT.useRef)(false);
    (0, $iSvIT.useEffect)(function() {
        return (0, $7r3bA.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $iSvIT.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $6MkAc.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $iSvIT.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $eTVns.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $iSvIT.useEffect)(function() {
        if (state === "hide") return 0, $emfh8.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $2e1kT.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $iSvIT.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $iSvIT.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $iSvIT.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $cPDs1.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $iSvIT.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $cPDs1.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $iSvIT.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $iSvIT.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(":focus-visible") && (0, $jxLBU.fg)("platform-tooltip-focus-visible-new")) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $iSvIT.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $iSvIT.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var handleOpenLayerObserverCloseSignal = (0, $iSvIT.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $1Z36a.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === "mouse" && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $aarCp.default)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $iSvIT.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children($48ac315adc16a3ad$var$_objectSpread($48ac315adc16a3ad$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(CastTargetContainer, (0, $jRswm.default)({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gWVOm.default), {
        zIndex: $48ac315adc16a3ad$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gr749.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $48ac315adc16a3ad$var$invertedDirection[$48ac315adc16a3ad$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iy0QV.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $g2f6i.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $48ac315adc16a3ad$var$_objectSpread($48ac315adc16a3ad$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $48ac315adc16a3ad$export$2e2bcd8739ae039 = $48ac315adc16a3ad$var$Tooltip;

});
parcelRegister("hkGkf", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $c9e522e8b459d36e$export$1a04351537078b55; });

var $eLTr6 = parcelRequire("eLTr6");

var $iSvIT = parcelRequire("iSvIT");

var $3XQNt = parcelRequire("3XQNt");

var $jbLrn = parcelRequire("jbLrn");
function $c9e522e8b459d36e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c9e522e8b459d36e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c9e522e8b459d36e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c9e522e8b459d36e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c9e522e8b459d36e$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $3XQNt.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $jbLrn.useTrackedRef)(analyticsData);
    var fnRef = (0, $jbLrn.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c9e522e8b459d36e$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("eTVns", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad92b5b1359de078$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $jxLBU = parcelRequire("jxLBU");

var $fK3t5 = parcelRequire("fK3t5");
function $ad92b5b1359de078$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $iSvIT.useRef)(false);
    var onKeyDown = (0, $iSvIT.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $fK3t5.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $iSvIT.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $iSvIT.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled && (0, $jxLBU.fg)("platform_only_attach_escape_handler_on_view")) return;
        return (0, $2e1kT.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("fK3t5", function(module, exports) {

$parcel$export(module.exports, "ESCAPE", function () { return $b75dd791621ef8c3$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $b75dd791621ef8c3$export$390330c10ff2b9a1 = "ArrowUp";
var $b75dd791621ef8c3$export$a80636c6f41931fe = "ArrowDown";
var $b75dd791621ef8c3$export$4af703091671bc = "Home";
var $b75dd791621ef8c3$export$e2bc30913faa5db7 = "End";
var $b75dd791621ef8c3$export$10f6869ed0a7d75b = "Tab";
var $b75dd791621ef8c3$export$8152f929a25a0ff4 = "Enter";
var $b75dd791621ef8c3$export$e51a3576c045c8d5 = "Space";
var $b75dd791621ef8c3$export$2bb790b9008907b4 = "Escape";

});


parcelRegister("2X3P3", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $22640e85d29be983$export$7be255094ccdc533; });

var $bWQUW = parcelRequire("bWQUW");

var $6owtp = parcelRequire("6owtp");
var $22640e85d29be983$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $22640e85d29be983$export$c93026a968943f95 = "light";
var $22640e85d29be983$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $22640e85d29be983$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $22640e85d29be983$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $22640e85d29be983$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $6owtp.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $22640e85d29be983$export$6d8204c2cb2e06b8() / 4;
    (0, $bWQUW.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $22640e85d29be983$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $22640e85d29be983$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $22640e85d29be983$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $bWQUW.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $22640e85d29be983$export$ba1d834b86d72a09 = $22640e85d29be983$export$a1b3edb637fb4f35;
var $22640e85d29be983$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $6owtp.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $6owtp.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $6owtp.N30A), ")")
            }
        }
    };
};

});
parcelRegister("bWQUW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b2e28c5506f3ce2$export$2e2bcd8739ae039; });

var $3ijE7 = parcelRequire("3ijE7");

var $XAEGR = parcelRequire("XAEGR");
function $8b2e28c5506f3ce2$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $3ijE7.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $8b2e28c5506f3ce2$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $XAEGR;
}

});
parcelRegister("3ijE7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26624ad132a39d57$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $26624ad132a39d57$var$printed = {};
function $26624ad132a39d57$export$2e2bcd8739ae039(message) {
    if ($26624ad132a39d57$var$printed[message]) return;
    $26624ad132a39d57$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});



parcelRegister("7r3bA", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $569d86ae5b52f49a$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $2e1kT = parcelRequire("2e1kT");
var $569d86ae5b52f49a$var$registrations = new Set();
var $569d86ae5b52f49a$var$cleanupEndEventListeners = null;
function $569d86ae5b52f49a$var$onDragStart() {
    if ($569d86ae5b52f49a$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $569d86ae5b52f49a$var$cleanupEndEventListeners = (0, $2e1kT.bindAll)(window, [
        {
            type: "dragend",
            listener: $569d86ae5b52f49a$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $569d86ae5b52f49a$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $569d86ae5b52f49a$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($569d86ae5b52f49a$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $569d86ae5b52f49a$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $569d86ae5b52f49a$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $569d86ae5b52f49a$var$cleanupEndEventListeners = null;
    var clone = Array.from($569d86ae5b52f49a$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $569d86ae5b52f49a$var$bindStartEvents() {
    return (0, $2e1kT.bindAll)(window, [
        {
            type: "dragstart",
            listener: $569d86ae5b52f49a$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $569d86ae5b52f49a$var$onDragStart
        }
    ]);
}
var $569d86ae5b52f49a$var$cleanupStartEventListeners = null;
function $569d86ae5b52f49a$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$569d86ae5b52f49a$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $569d86ae5b52f49a$var$cleanupStartEventListeners = $569d86ae5b52f49a$var$bindStartEvents();
    $569d86ae5b52f49a$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $569d86ae5b52f49a$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $569d86ae5b52f49a$var$registrations.delete(registration);
        if ($569d86ae5b52f49a$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $569d86ae5b52f49a$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $569d86ae5b52f49a$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("6MkAc", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $4ef7311f109b61d3$export$57bf213be019eeb0; });

var $a1IQk = parcelRequire("a1IQk");
// This file is a singleton for managing tooltips
var $4ef7311f109b61d3$var$active = null;
function $4ef7311f109b61d3$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($4ef7311f109b61d3$var$active && $4ef7311f109b61d3$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $a1IQk.clearScheduled)();
            $4ef7311f109b61d3$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $a1IQk.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $a1IQk.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $a1IQk.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($4ef7311f109b61d3$var$active && $4ef7311f109b61d3$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($4ef7311f109b61d3$var$active) {
            (0, $a1IQk.clearScheduled)();
            $4ef7311f109b61d3$var$active.entry.hide({
                isImmediate: true
            });
            $4ef7311f109b61d3$var$active.entry.done();
            $4ef7311f109b61d3$var$active = null;
        }
        // this tooltip is now the active tooltip
        $4ef7311f109b61d3$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $a1IQk.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("a1IQk", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $74ccc843002b633a$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $74ccc843002b633a$export$5f4d6617421d489b; });
var $74ccc843002b633a$var$delayId = null;
function $74ccc843002b633a$export$eaf678f6f93f5250() {
    if ($74ccc843002b633a$var$delayId != null) {
        window.clearTimeout($74ccc843002b633a$var$delayId);
        $74ccc843002b633a$var$delayId = null;
    }
}
function $74ccc843002b633a$export$5f4d6617421d489b(fn, delay) {
    $74ccc843002b633a$export$eaf678f6f93f5250();
    $74ccc843002b633a$var$delayId = window.setTimeout(function() {
        $74ccc843002b633a$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("aarCp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7670430211ead3c1$export$2e2bcd8739ae039; });

var $5CqIy = parcelRequire("5CqIy");
function $7670430211ead3c1$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $5CqIy.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("5y4qX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40a3912df68e72c9$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eLTr6 = parcelRequire("eLTr6");

var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");
var $6XKda = parcelRequire("6XKda");

var $6owtp = parcelRequire("6owtp");

var $9nYH6 = parcelRequire("9nYH6");
function $40a3912df68e72c9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $40a3912df68e72c9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $40a3912df68e72c9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $40a3912df68e72c9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $40a3912df68e72c9$var$baseStyles = null;
var $40a3912df68e72c9$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $40a3912df68e72c9$var$TooltipContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement((0, $9nYH6.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8lTdX.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $40a3912df68e72c9$var$_objectSpread($40a3912df68e72c9$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $6XKda.default)("var(--ds-background-neutral-bold, ".concat((0, $6owtp.N800), ")")),
            "--_ywovvi": (0, $6XKda.default)("var(--ds-text-inverse, ".concat((0, $6owtp.N0), ")"))
        })
    }, children);
});
$40a3912df68e72c9$var$TooltipContainer.displayName = "TooltipContainer";
var $40a3912df68e72c9$export$2e2bcd8739ae039 = $40a3912df68e72c9$var$TooltipContainer;

});
parcelRegister("9nYH6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d5557a1e9dd30db$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");
var $6d5557a1e9dd30db$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $6d5557a1e9dd30db$var$TooltipPrimitive = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        role: "tooltip",
        className: (0, $8lTdX.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$6d5557a1e9dd30db$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $6d5557a1e9dd30db$export$2e2bcd8739ae039 = $6d5557a1e9dd30db$var$TooltipPrimitive;

});


parcelRegister("cPDs1", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $9578d999edc6be21$export$642213d516a9b928; });
function $9578d999edc6be21$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});



parcelRegister("kd5Gv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb696e675413faa5$export$2e2bcd8739ae039; });
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");


var $1erle = parcelRequire("1erle");

var $6Qy6S = parcelRequire("6Qy6S");

var $j9Qy5 = parcelRequire("j9Qy5");

var $jxLBU = parcelRequire("jxLBU");

var $gp20o = parcelRequire("gp20o");

var $12Nm2 = parcelRequire("12Nm2");

var $2GhoB = parcelRequire("2GhoB");
var $eb696e675413faa5$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "href",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId"
], $eb696e675413faa5$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $eb696e675413faa5$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    fullWidth: "_1bsb1osq"
};
var $eb696e675413faa5$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $eb696e675413faa5$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $eb696e675413faa5$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $eb696e675413faa5$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $eb696e675413faa5$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $eb696e675413faa5$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $eb696e675413faa5$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l31pke _1di619ru _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $eb696e675413faa5$var$LinkButtonBase = function LinkButtonBase(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, unsafeRest = (0, $fzcGG.default)(_ref, $eb696e675413faa5$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $fzcGG.default)(unsafeRest, $eb696e675413faa5$var$_excluded2);
    var hasIconAfter = Boolean(iconAfter);
    var hasIconBefore = Boolean(iconBefore);
    var localRef = (0, $iSvIT.useRef)(null);
    (0, $j9Qy5.default)(localRef, autoFocus);
    var combinedRef = (0, $6Qy6S.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ $iSvIT.createElement((0, $gp20o.default), (0, $jRswm.default)({
        analyticsContext: analyticsContext,
        ref: combinedRef,
        href: isDisabled ? undefined : href,
        role: isDisabled ? "link" : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName
    }, saferRest, {
        xcss: (0, $1erle.cx)($eb696e675413faa5$var$styles.base, appearance === "default" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $eb696e675413faa5$var$defaultStyles.rootRefreshed : $eb696e675413faa5$var$defaultStyles.root), appearance === "primary" && $eb696e675413faa5$var$primaryStyles.root, appearance === "warning" && $eb696e675413faa5$var$warningStyles.root, appearance === "danger" && $eb696e675413faa5$var$dangerStyles.root, appearance === "discovery" && $eb696e675413faa5$var$discoveryStyles.root, appearance === "subtle" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $eb696e675413faa5$var$subtleStyles.rootRefreshed : $eb696e675413faa5$var$subtleStyles.root), $eb696e675413faa5$var$styles.linkDecorationUnset, isSelected && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $eb696e675413faa5$var$selectedStyles.rootRefreshed : $eb696e675413faa5$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "danger" && $eb696e675413faa5$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "warning" && $eb696e675413faa5$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $eb696e675413faa5$var$selectedStyles.discovery, isDisabled && $eb696e675413faa5$var$styles.disabled, spacing === "compact" && $eb696e675413faa5$var$styles.spacingCompact, hasIconBefore && $eb696e675413faa5$var$styles.buttonIconBefore, hasIconAfter && $eb696e675413faa5$var$styles.buttonIconAfter, shouldFitContainer && $eb696e675413faa5$var$styles.fullWidth)
    }), iconBefore && /*#__PURE__*/ $iSvIT.createElement((0, $12Nm2.default), {
        type: "icon",
        position: "before",
        isLoading: false
    }, /*#__PURE__*/ $iSvIT.createElement((0, $2GhoB.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ $iSvIT.createElement((0, $12Nm2.default), {
        isLoading: false
    }, children), iconAfter && /*#__PURE__*/ $iSvIT.createElement((0, $12Nm2.default), {
        type: "icon",
        position: "after",
        isLoading: false
    }, /*#__PURE__*/ $iSvIT.createElement((0, $2GhoB.default), {
        icon: iconAfter
    })));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $eb696e675413faa5$var$LinkButton = /*#__PURE__*/ (0, $iSvIT.forwardRef)($eb696e675413faa5$var$LinkButtonBase);
$eb696e675413faa5$var$LinkButton.displayName = "LinkButton";
var $eb696e675413faa5$export$2e2bcd8739ae039 = $eb696e675413faa5$var$LinkButton;

});
parcelRegister("gp20o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf108960334b4a82$export$2e2bcd8739ae039; });
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $dMCdc = parcelRequire("dMCdc");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");


var $hHqGT = parcelRequire("hHqGT");

var $jNYFj = parcelRequire("jNYFj");

var $lOOEF = parcelRequire("lOOEF");

var $6F6FS = parcelRequire("6F6FS");

var $emfh8 = parcelRequire("emfh8");

var $5CqIy = parcelRequire("5CqIy");

var $7nG8r = parcelRequire("7nG8r");

var $jxLBU = parcelRequire("jxLBU");

var $hozmE = parcelRequire("hozmE");

var $cWGA8 = parcelRequire("cWGA8");
var $bf108960334b4a82$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $bf108960334b4a82$var$_excluded2 = [
    "className"
];
var $bf108960334b4a82$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $bf108960334b4a82$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $bf108960334b4a82$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $bf108960334b4a82$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $emfh8.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? "(opens new window)" : _ref$newWindowLabel, htmlAttributes = (0, $fzcGG.default)(_ref, $bf108960334b4a82$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $5CqIy.useId)();
    var onClick = (0, $lOOEF.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.11.2",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $fzcGG.default)(htmlAttributes, $bf108960334b4a82$var$_excluded2);
    var RouterLink = (0, $6F6FS.default)();
    var isExternal = typeof href === "string" && $bf108960334b4a82$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $bf108960334b4a82$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $dMCdc.default)(href) === "object";
    (0, $jNYFj.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return /*#__PURE__*/ $iSvIT.createElement((0, $cWGA8.default), (0, $jRswm.default)({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $hHqGT.cx)($bf108960334b4a82$var$styles.root, (0, $jxLBU.fg)("platform_design-system-team_anchor-positioning") ? $bf108960334b4a82$var$styles.position : undefined, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $iSvIT.createElement((0, $hozmE.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $bf108960334b4a82$var$Anchor = /*#__PURE__*/ (0, $iSvIT.forwardRef)($bf108960334b4a82$var$AnchorNoRef);
var $bf108960334b4a82$export$2e2bcd8739ae039 = $bf108960334b4a82$var$Anchor;

});


parcelRegister("bE0u1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87a3ce138b19e198$export$2e2bcd8739ae039; });
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");


var $1erle = parcelRequire("1erle");

var $6Qy6S = parcelRequire("6Qy6S");

var $j9Qy5 = parcelRequire("j9Qy5");

var $jxLBU = parcelRequire("jxLBU");

var $gp20o = parcelRequire("gp20o");

var $6ePKy = parcelRequire("6ePKy");

var $hozmE = parcelRequire("hozmE");

var $12Nm2 = parcelRequire("12Nm2");

var $2GhoB = parcelRequire("2GhoB");
var $87a3ce138b19e198$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "href",
    "icon",
    "interactionName",
    "isDisabled",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip"
], $87a3ce138b19e198$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $87a3ce138b19e198$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _y4tiutpp _bozgutpp _s7n4nkob _4t3i1k8s _1bsb1k8s",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    circle: "_2rko14q2"
};
var $87a3ce138b19e198$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $87a3ce138b19e198$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $87a3ce138b19e198$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $87a3ce138b19e198$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $87a3ce138b19e198$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
var $87a3ce138b19e198$var$LinkIconButtonBase = function LinkIconButtonBase(_ref, ref) {
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, href = _ref.href, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, unsafeRest = (0, $fzcGG.default)(_ref, $87a3ce138b19e198$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $fzcGG.default)(unsafeRest, $87a3ce138b19e198$var$_excluded2);
    var localRef = (0, $iSvIT.useRef)(null);
    (0, $j9Qy5.default)(localRef, autoFocus);
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ $iSvIT.createElement((0, $6ePKy.default), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
        }, function(triggerProps) {
            return /*#__PURE__*/ $iSvIT.createElement((0, $gp20o.default), (0, $jRswm.default)({}, saferRest, {
                "aria-labelledby": ariaLabelledBy,
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _triggerProps$onClick;
                    _onClick === null || _onClick === void 0 || _onClick(event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: (0, $6Qy6S.default)([
                    localRef,
                    ref,
                    triggerProps.ref
                ].filter(Boolean)),
                xcss: (0, $1erle.cx)($87a3ce138b19e198$var$styles.base, appearance === "default" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $87a3ce138b19e198$var$defaultStyles.rootRefreshed : $87a3ce138b19e198$var$defaultStyles.root), appearance === "primary" && $87a3ce138b19e198$var$primaryStyles.root, appearance === "discovery" && $87a3ce138b19e198$var$discoveryStyles.root, appearance === "subtle" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $87a3ce138b19e198$var$subtleStyles.rootRefreshed : $87a3ce138b19e198$var$subtleStyles.root), $87a3ce138b19e198$var$styles.linkDecorationUnset, isSelected && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $87a3ce138b19e198$var$selectedStyles.rootRefreshed : $87a3ce138b19e198$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
                isSelected && appearance === "discovery" && $87a3ce138b19e198$var$selectedStyles.discovery, isDisabled && $87a3ce138b19e198$var$styles.disabled, spacing === "compact" && $87a3ce138b19e198$var$styles.spacingCompact, $87a3ce138b19e198$var$styles.iconButton, shape === "circle" && $87a3ce138b19e198$var$styles.circle),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                href: isDisabled ? undefined : href,
                role: isDisabled ? "link" : undefined,
                "aria-disabled": isDisabled === true ? true : undefined
            }), /*#__PURE__*/ $iSvIT.createElement((0, $12Nm2.default), {
                type: "icon",
                isLoading: false
            }, /*#__PURE__*/ $iSvIT.createElement((0, $2GhoB.default), {
                icon: icon
            }), /*#__PURE__*/ $iSvIT.createElement((0, $hozmE.default), null, label)));
        });
    }
    return /*#__PURE__*/ $iSvIT.createElement((0, $gp20o.default), (0, $jRswm.default)({}, saferRest, {
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        ref: (0, $6Qy6S.default)([
            localRef,
            ref
        ]),
        xcss: (0, $1erle.cx)($87a3ce138b19e198$var$styles.base, appearance === "default" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $87a3ce138b19e198$var$defaultStyles.rootRefreshed : $87a3ce138b19e198$var$defaultStyles.root), appearance === "primary" && $87a3ce138b19e198$var$primaryStyles.root, appearance === "discovery" && $87a3ce138b19e198$var$discoveryStyles.root, appearance === "subtle" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $87a3ce138b19e198$var$subtleStyles.rootRefreshed : $87a3ce138b19e198$var$subtleStyles.root), $87a3ce138b19e198$var$styles.linkDecorationUnset, isSelected && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $87a3ce138b19e198$var$selectedStyles.rootRefreshed : $87a3ce138b19e198$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $87a3ce138b19e198$var$selectedStyles.discovery, isDisabled && $87a3ce138b19e198$var$styles.disabled, $87a3ce138b19e198$var$styles.iconButton, spacing === "compact" && $87a3ce138b19e198$var$styles.spacingCompact, shape === "circle" && $87a3ce138b19e198$var$styles.circle),
        onClick: _onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        href: isDisabled ? undefined : href,
        role: isDisabled ? "link" : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), /*#__PURE__*/ $iSvIT.createElement((0, $12Nm2.default), {
        type: "icon",
        isLoading: false
    }, /*#__PURE__*/ $iSvIT.createElement((0, $2GhoB.default), {
        icon: icon
    }), /*#__PURE__*/ $iSvIT.createElement((0, $hozmE.default), null, label)));
};
// Workarounds to support generic types with forwardRef + memo
var $87a3ce138b19e198$var$WithRef = /*#__PURE__*/ (0, $iSvIT.forwardRef)($87a3ce138b19e198$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ var $87a3ce138b19e198$var$LinkIconButton = /*#__PURE__*/ (0, $iSvIT.memo)($87a3ce138b19e198$var$WithRef);
var $87a3ce138b19e198$export$2e2bcd8739ae039 = $87a3ce138b19e198$var$LinkIconButton;

});

parcelRegister("7HvyC", function(module, exports) {

$parcel$export(module.exports, "themedButtonBackground", function () { return $59b507358cf5fcd0$export$b93b81aa41a8061a; });
$parcel$export(module.exports, "themedButtonBackgroundHovered", function () { return $59b507358cf5fcd0$export$96a2312c81489aa1; });
$parcel$export(module.exports, "themedButtonBackgroundPressed", function () { return $59b507358cf5fcd0$export$9db7a918ddfed23e; });
$parcel$export(module.exports, "themedButtonBorder", function () { return $59b507358cf5fcd0$export$2b00bded80635cbb; });
$parcel$export(module.exports, "themedButtonPrimaryText", function () { return $59b507358cf5fcd0$export$eca746d7c1a9cd6e; });
$parcel$export(module.exports, "themedButtonPrimaryBackground", function () { return $59b507358cf5fcd0$export$2c2bc298cddb8aca; });
$parcel$export(module.exports, "themedButtonPrimaryBackgroundHovered", function () { return $59b507358cf5fcd0$export$6b28e650669cd3c7; });
$parcel$export(module.exports, "themedButtonPrimaryBackgroundPressed", function () { return $59b507358cf5fcd0$export$1656be06aad539b9; });
$parcel$export(module.exports, "themedButtonSelectedText", function () { return $59b507358cf5fcd0$export$c26a897d419ef487; });
$parcel$export(module.exports, "themedButtonSelectedBackground", function () { return $59b507358cf5fcd0$export$4e50e625ccffdb13; });
$parcel$export(module.exports, "themedButtonSelectedBackgroundHovered", function () { return $59b507358cf5fcd0$export$55c84c90f36bda4d; });
$parcel$export(module.exports, "themedButtonSelectedBackgroundPressed", function () { return $59b507358cf5fcd0$export$c5c0213472126c08; });
$parcel$export(module.exports, "themedButtonSelectedBorder", function () { return $59b507358cf5fcd0$export$22928007ff541429; });
$parcel$export(module.exports, "themedButtonDisabledText", function () { return $59b507358cf5fcd0$export$787ad93d0f2276af; });
$parcel$export(module.exports, "themedButtonDisabledBackground", function () { return $59b507358cf5fcd0$export$5e774f44b77335d6; });
$parcel$export(module.exports, "ThemedButton", function () { return $59b507358cf5fcd0$export$f67fb575035cc7d0; });
$parcel$export(module.exports, "ThemedLinkButton", function () { return $59b507358cf5fcd0$export$b0b5aeed52623827; });
$parcel$export(module.exports, "ThemedIconButton", function () { return $59b507358cf5fcd0$export$d9c2d067feb61447; });
$parcel$export(module.exports, "ThemedLinkIconButton", function () { return $59b507358cf5fcd0$export$a1ab08e79d264ec8; });
/* button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $8lTdX = parcelRequire("8lTdX");

var $iSvIT = parcelRequire("iSvIT");

var $hHqGT = parcelRequire("hHqGT");

var $6Qy6S = parcelRequire("6Qy6S");

var $jSKNZ = parcelRequire("jSKNZ");
var $Nz6G4 = parcelRequire("Nz6G4");

var $6ePKy = parcelRequire("6ePKy");

var $hozmE = parcelRequire("hozmE");

var $8PgM1 = parcelRequire("8PgM1");
var $59b507358cf5fcd0$var$_excluded = [
    "style",
    "xcss",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd"
], $59b507358cf5fcd0$var$_excluded2 = [
    "appearance",
    "shape",
    "isSelected",
    "isDisabled"
], $59b507358cf5fcd0$var$_excluded3 = [
    "appearance",
    "shape",
    "isSelected",
    "isDisabled"
], $59b507358cf5fcd0$var$_excluded4 = [
    "iconBefore",
    "children"
], $59b507358cf5fcd0$var$_excluded5 = [
    "iconBefore",
    "children"
], $59b507358cf5fcd0$var$_excluded6 = [
    "icon",
    "label",
    "tooltip"
], $59b507358cf5fcd0$var$_excluded7 = [
    "icon",
    "label",
    "tooltip"
];
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ /**
 * Returns the spread props to pass through to underlying primitive components.
 *
 * It removes the props which apply styles.
 */ function $59b507358cf5fcd0$var$getPrimitiveSpreadProps(_ref) {
    var style = _ref.style, xcss = _ref.xcss, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, props = (0, $fzcGG.default)(_ref, $59b507358cf5fcd0$var$_excluded);
    return props;
}
var $59b507358cf5fcd0$export$b93b81aa41a8061a = "--ds-top-bar-button-background";
var $59b507358cf5fcd0$export$96a2312c81489aa1 = "--ds-top-bar-button-background-hovered";
var $59b507358cf5fcd0$export$9db7a918ddfed23e = "--ds-top-bar-button-background-pressed";
var $59b507358cf5fcd0$export$2b00bded80635cbb = "--ds-top-bar-button-border";
var $59b507358cf5fcd0$export$eca746d7c1a9cd6e = "--ds-top-bar-button-primary-text";
var $59b507358cf5fcd0$export$2c2bc298cddb8aca = "--ds-top-bar-button-primary-background";
var $59b507358cf5fcd0$export$6b28e650669cd3c7 = "--ds-top-bar-button-primary-background-hovered";
var $59b507358cf5fcd0$export$1656be06aad539b9 = "--ds-top-bar-button-primary-background-pressed";
var $59b507358cf5fcd0$export$c26a897d419ef487 = "--ds-top-bar-button-selected-text";
var $59b507358cf5fcd0$export$4e50e625ccffdb13 = "--ds-top-bar-button-selected-background";
var $59b507358cf5fcd0$export$55c84c90f36bda4d = "--ds-top-bar-button-selected-background-hovered";
var $59b507358cf5fcd0$export$c5c0213472126c08 = "--ds-top-bar-button-selected-background-pressed";
var $59b507358cf5fcd0$export$22928007ff541429 = "--ds-top-bar-button-selected-border";
var $59b507358cf5fcd0$export$787ad93d0f2276af = "--ds-top-bar-button-disabled-text";
var $59b507358cf5fcd0$export$5e774f44b77335d6 = "--ds-top-bar-button-disabled-background";
var $59b507358cf5fcd0$var$styles = {
    root: "_zulp12x7 _11c82smr _2rkosqtm _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
var $59b507358cf5fcd0$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
var $59b507358cf5fcd0$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
};
/**
 * Props shared by `ThemedPressable` and `ThemedAnchor`
 */ /**
 * Intentionally an almost-duplicate of `ThemedAnchor` - make sure to update both.
 *
 * See `ThemedAnchor` for more context.
 */ var $59b507358cf5fcd0$var$ThemedPressable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function ThemedPressable(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? "default" : _ref2$shape, isSelected = _ref2.isSelected, isDisabled = _ref2.isDisabled, props = (0, $fzcGG.default)(_ref2, $59b507358cf5fcd0$var$_excluded2);
    var hasBorder = appearance === "default" || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $Nz6G4.default), (0, $jRswm.default)({}, $59b507358cf5fcd0$var$getPrimitiveSpreadProps(props), {
        ref: ref,
        type: "button",
        xcss: (0, $hHqGT.cx)($59b507358cf5fcd0$var$styles.root, $59b507358cf5fcd0$var$shapeStyles[shape], hasBorder && $59b507358cf5fcd0$var$styles.border, $59b507358cf5fcd0$var$appearanceStyles[appearance], isSelected && $59b507358cf5fcd0$var$styles.selected, isDisabled && $59b507358cf5fcd0$var$styles.disabled),
        isDisabled: isDisabled
    }));
});
/**
 * Intentionally an almost-duplicate of `ThemedPressable` - make sure to update both.
 *
 * More 'clever' solutions were tried but I couldn't get them working in an acceptable state.
 *
 * Polymorphism had many typing issues and required sacrificing type safety.
 *
 * Render props had problems passing down styles through `xcss` to the `children` function.
 */ var $59b507358cf5fcd0$var$ThemedAnchor = (0, $8PgM1.forwardRefWithGeneric)(function ThemedAnchor(_ref3, ref) {
    var _ref3$appearance = _ref3.appearance, appearance = _ref3$appearance === void 0 ? "default" : _ref3$appearance, _ref3$shape = _ref3.shape, shape = _ref3$shape === void 0 ? "default" : _ref3$shape, isSelected = _ref3.isSelected, isDisabled = _ref3.isDisabled, props = (0, $fzcGG.default)(_ref3, $59b507358cf5fcd0$var$_excluded3);
    var hasBorder = appearance === "default" || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $jSKNZ.default), (0, $jRswm.default)({}, $59b507358cf5fcd0$var$getPrimitiveSpreadProps(props), {
        ref: ref,
        xcss: (0, $hHqGT.cx)($59b507358cf5fcd0$var$styles.root, $59b507358cf5fcd0$var$shapeStyles[shape], hasBorder && $59b507358cf5fcd0$var$styles.border, $59b507358cf5fcd0$var$appearanceStyles[appearance], isSelected && $59b507358cf5fcd0$var$styles.selected, isDisabled && $59b507358cf5fcd0$var$styles.disabled)
    }));
});
var $59b507358cf5fcd0$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
var $59b507358cf5fcd0$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function ThemedButton(_ref4, ref) {
    var IconBefore = _ref4.iconBefore, children = _ref4.children, props = (0, $fzcGG.default)(_ref4, $59b507358cf5fcd0$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($59b507358cf5fcd0$var$ThemedPressable, (0, $jRswm.default)({}, props, {
        ref: ref
    }), IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $8lTdX.default)([
            $59b507358cf5fcd0$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(IconBefore, {
        label: "",
        color: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $8lTdX.default)([
            $59b507358cf5fcd0$var$textButtonStyles.text
        ])
    }, children));
});
var $59b507358cf5fcd0$export$b0b5aeed52623827 = (0, $8PgM1.forwardRefWithGeneric)(function ThemedLinkButton(_ref5, ref) {
    var IconBefore = _ref5.iconBefore, children = _ref5.children, props = (0, $fzcGG.default)(_ref5, $59b507358cf5fcd0$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($59b507358cf5fcd0$var$ThemedAnchor, (0, $jRswm.default)({}, props, {
        ref: ref
    }), IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $8lTdX.default)([
            $59b507358cf5fcd0$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(IconBefore, {
        label: "",
        color: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $8lTdX.default)([
            $59b507358cf5fcd0$var$textButtonStyles.text
        ])
    }, children));
});
var $59b507358cf5fcd0$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function ThemedIconButton(_ref6, ref) {
    var _tooltip$content;
    var Icon = _ref6.icon, label = _ref6.label, tooltip = _ref6.tooltip, props = (0, $fzcGG.default)(_ref6, $59b507358cf5fcd0$var$_excluded6);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6ePKy.default), (0, $jRswm.default)({}, tooltip, {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label
    }), function(triggerProps) {
        return(/*#__PURE__*/ /**
       * The `aria-describedby` from `triggerProps` is intentionally not passed down,
       * because it would cause double announcements with the `VisuallyHidden` label.
       *
       * The `@atlaskit/button` IconButton uses the same approach.
       */ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($59b507358cf5fcd0$var$ThemedPressable, (0, $jRswm.default)({}, props, {
            shape: "square",
            ref: (0, $6Qy6S.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: function onClick(event, analyticsEvent) {
                var _props$onClick, _triggerProps$onClick;
                (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event, analyticsEvent);
                triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _props$onMouseOver;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_props$onMouseOver = props.onMouseOver) === null || _props$onMouseOver === void 0 || _props$onMouseOver.call(props, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _props$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_props$onMouseOut = props.onMouseOut) === null || _props$onMouseOut === void 0 || _props$onMouseOut.call(props, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _props$onMouseMove;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_props$onMouseMove = props.onMouseMove) === null || _props$onMouseMove === void 0 || _props$onMouseMove.call(props, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _props$onMouseDown;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_props$onMouseDown = props.onMouseDown) === null || _props$onMouseDown === void 0 || _props$onMouseDown.call(props, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _props$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _props$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, e);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Icon, {
            label: "",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hozmE.default), null, label)));
    });
});
var $59b507358cf5fcd0$export$a1ab08e79d264ec8 = (0, $8PgM1.forwardRefWithGeneric)(function ThemedLinkIconButton(_ref7, ref) {
    var _tooltip$content2;
    var Icon = _ref7.icon, label = _ref7.label, tooltip = _ref7.tooltip, props = (0, $fzcGG.default)(_ref7, $59b507358cf5fcd0$var$_excluded7);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6ePKy.default), (0, $jRswm.default)({}, tooltip, {
        content: (_tooltip$content2 = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content2 !== void 0 ? _tooltip$content2 : label
    }), function(triggerProps) {
        return(/*#__PURE__*/ /**
       * The `aria-describedby` from `triggerProps` is intentionally not passed down,
       * because it would cause double announcements with the `VisuallyHidden` label.
       *
       * The `@atlaskit/button` IconButton uses the same approach.
       */ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($59b507358cf5fcd0$var$ThemedAnchor, (0, $jRswm.default)({}, props, {
            shape: "square",
            ref: (0, $6Qy6S.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: function onClick(event, analyticsEvent) {
                var _props$onClick2, _triggerProps$onClick2;
                (_props$onClick2 = props.onClick) === null || _props$onClick2 === void 0 || _props$onClick2.call(props, event, analyticsEvent);
                triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick2 = triggerProps.onClick) === null || _triggerProps$onClick2 === void 0 || _triggerProps$onClick2.call(triggerProps, event);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse5, _props$onMouseOver2;
                (_triggerProps$onMouse5 = triggerProps.onMouseOver) === null || _triggerProps$onMouse5 === void 0 || _triggerProps$onMouse5.call(triggerProps, e);
                (_props$onMouseOver2 = props.onMouseOver) === null || _props$onMouseOver2 === void 0 || _props$onMouseOver2.call(props, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse6, _props$onMouseOut2;
                (_triggerProps$onMouse6 = triggerProps.onMouseOut) === null || _triggerProps$onMouse6 === void 0 || _triggerProps$onMouse6.call(triggerProps, e);
                (_props$onMouseOut2 = props.onMouseOut) === null || _props$onMouseOut2 === void 0 || _props$onMouseOut2.call(props, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse7, _props$onMouseMove2;
                (_triggerProps$onMouse7 = triggerProps.onMouseMove) === null || _triggerProps$onMouse7 === void 0 || _triggerProps$onMouse7.call(triggerProps, e);
                (_props$onMouseMove2 = props.onMouseMove) === null || _props$onMouseMove2 === void 0 || _props$onMouseMove2.call(props, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse8, _props$onMouseDown2;
                (_triggerProps$onMouse8 = triggerProps.onMouseDown) === null || _triggerProps$onMouse8 === void 0 || _triggerProps$onMouse8.call(triggerProps, e);
                (_props$onMouseDown2 = props.onMouseDown) === null || _props$onMouseDown2 === void 0 || _props$onMouseDown2.call(props, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus2, _props$onFocus2;
                (_triggerProps$onFocus2 = triggerProps.onFocus) === null || _triggerProps$onFocus2 === void 0 || _triggerProps$onFocus2.call(triggerProps, e);
                (_props$onFocus2 = props.onFocus) === null || _props$onFocus2 === void 0 || _props$onFocus2.call(props, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur2, _props$onBlur2;
                (_triggerProps$onBlur2 = triggerProps.onBlur) === null || _triggerProps$onBlur2 === void 0 || _triggerProps$onBlur2.call(triggerProps, e);
                (_props$onBlur2 = props.onBlur) === null || _props$onBlur2 === void 0 || _props$onBlur2.call(props, e);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Icon, {
            label: "",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hozmE.default), null, label)));
    });
});

});
parcelRegister("jSKNZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7975e0754db54e3$export$2e2bcd8739ae039; });
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $dMCdc = parcelRequire("dMCdc");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");


var $hHqGT = parcelRequire("hHqGT");

var $jNYFj = parcelRequire("jNYFj");

var $lOOEF = parcelRequire("lOOEF");

var $6F6FS = parcelRequire("6F6FS");

var $emfh8 = parcelRequire("emfh8");

var $5CqIy = parcelRequire("5CqIy");

var $7nG8r = parcelRequire("7nG8r");

var $jxLBU = parcelRequire("jxLBU");

var $hozmE = parcelRequire("hozmE");

var $65Ozq = parcelRequire("65Ozq");
var $e7975e0754db54e3$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $e7975e0754db54e3$var$_excluded2 = [
    "className"
];
var $e7975e0754db54e3$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $e7975e0754db54e3$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $e7975e0754db54e3$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $e7975e0754db54e3$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $emfh8.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? "(opens new window)" : _ref$newWindowLabel, htmlAttributes = (0, $fzcGG.default)(_ref, $e7975e0754db54e3$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $5CqIy.useId)();
    var onClick = (0, $lOOEF.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.11.4",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $fzcGG.default)(htmlAttributes, $e7975e0754db54e3$var$_excluded2);
    var RouterLink = (0, $6F6FS.default)();
    var isExternal = typeof href === "string" && $e7975e0754db54e3$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $e7975e0754db54e3$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $dMCdc.default)(href) === "object";
    (0, $jNYFj.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return /*#__PURE__*/ $iSvIT.createElement((0, $65Ozq.default), (0, $jRswm.default)({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $hHqGT.cx)($e7975e0754db54e3$var$styles.root, (0, $jxLBU.fg)("platform_design-system-team_anchor-positioning") ? $e7975e0754db54e3$var$styles.position : undefined, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $iSvIT.createElement((0, $hozmE.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $e7975e0754db54e3$var$Anchor = /*#__PURE__*/ (0, $iSvIT.forwardRef)($e7975e0754db54e3$var$AnchorNoRef);
var $e7975e0754db54e3$export$2e2bcd8739ae039 = $e7975e0754db54e3$var$Anchor;

});
parcelRegister("65Ozq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46fa6ff019d6bcc0$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $eLTr6 = parcelRequire("eLTr6");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");
var $6XKda = parcelRequire("6XKda");
var $46fa6ff019d6bcc0$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $46fa6ff019d6bcc0$var$_excluded2 = [
    "className"
];
function $46fa6ff019d6bcc0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $46fa6ff019d6bcc0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $46fa6ff019d6bcc0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $46fa6ff019d6bcc0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $46fa6ff019d6bcc0$var$focusRingStyles = null;
var $46fa6ff019d6bcc0$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $46fa6ff019d6bcc0$var$Focusable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $fzcGG.default)(_ref, $46fa6ff019d6bcc0$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $fzcGG.default)(htmlAttributes, $46fa6ff019d6bcc0$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $jRswm.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $8lTdX.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $46fa6ff019d6bcc0$var$_objectSpread($46fa6ff019d6bcc0$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $6XKda.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $46fa6ff019d6bcc0$export$2e2bcd8739ae039 = $46fa6ff019d6bcc0$var$Focusable;

});


parcelRegister("Nz6G4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $094fcf2d7ee1318e$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");


var $hHqGT = parcelRequire("hHqGT");

var $lOOEF = parcelRequire("lOOEF");

var $9SZA7 = parcelRequire("9SZA7");

var $emfh8 = parcelRequire("emfh8");

var $7nG8r = parcelRequire("7nG8r");

var $65Ozq = parcelRequire("65Ozq");
var $094fcf2d7ee1318e$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $094fcf2d7ee1318e$var$_excluded2 = [
    "className"
];
var $094fcf2d7ee1318e$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $094fcf2d7ee1318e$var$Pressable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $emfh8.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $fzcGG.default)(_ref, $094fcf2d7ee1318e$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $lOOEF.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.11.4",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $fzcGG.default)(htmlAttributes, $094fcf2d7ee1318e$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement((0, $65Ozq.default), (0, $jRswm.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $9SZA7.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $hHqGT.cx)($094fcf2d7ee1318e$var$styles.root, isDisabled && $094fcf2d7ee1318e$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $094fcf2d7ee1318e$export$2e2bcd8739ae039 = $094fcf2d7ee1318e$var$Pressable;

});

parcelRegister("8PgM1", function(module, exports) {

$parcel$export(module.exports, "forwardRefWithGeneric", function () { return $66d0190ad1c5f518$export$8ab756e06c5d9001; });

var $iSvIT = parcelRequire("iSvIT");
var $66d0190ad1c5f518$export$8ab756e06c5d9001 = (0, $iSvIT.forwardRef);

});


parcelRegister("gSLRZ", function(module, exports) {

$parcel$export(module.exports, "HasCustomThemeContext", function () { return $c4a6d27305b41190$export$d158fa15757a1890; });
$parcel$export(module.exports, "useHasCustomTheme", function () { return $c4a6d27305b41190$export$abfcaeeca4ae7a55; });

var $iSvIT = parcelRequire("iSvIT");
var $c4a6d27305b41190$export$d158fa15757a1890 = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
function $c4a6d27305b41190$export$abfcaeeca4ae7a55() {
    return (0, $iSvIT.useContext)($c4a6d27305b41190$export$d158fa15757a1890);
}

});



parcelRegister("6WUrJ", function(module, exports) {

$parcel$export(module.exports, "TopNav", function () { return $50f3f1e9c13127ec$export$41d0d88a6b0e456f; });
/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $hA2VN = parcelRequire("hA2VN");

var $gSLRZ = parcelRequire("gSLRZ");

var $53N3b = parcelRequire("53N3b");

var $nvCjc = parcelRequire("nvCjc");

var $7eVqT = parcelRequire("7eVqT");

var $1gr3O = parcelRequire("1gr3O");

var $4lOHN = parcelRequire("4lOHN");
var $50f3f1e9c13127ec$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i1dgc _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi _1j8b18ax"
};
function $50f3f1e9c13127ec$export$41d0d88a6b0e456f(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$height = _ref.height, height = _ref$height === void 0 ? 48 : _ref$height, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? "Top Bar" : _ref$skipLinkLabel, testId = _ref.testId, providedId = _ref.id, UNSAFE_theme = _ref.UNSAFE_theme;
    var dangerouslyHoistSlotSizes = (0, $iSvIT.useContext)((0, $7eVqT.DangerouslyHoistSlotSizes));
    var id = (0, $4lOHN.useLayoutId)({
        providedId: providedId
    });
    (0, $hA2VN.useSkipLink)(id, skipLinkLabel);
    var customTheme = (0, $53N3b.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ $iSvIT.createElement((0, $gSLRZ.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled
    }, /*#__PURE__*/ $iSvIT.createElement("header", {
        id: id,
        "data-layout-slot": true,
        className: (0, $8lTdX.default)([
            $50f3f1e9c13127ec$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        style: customTheme.isEnabled ? customTheme.style : undefined
    }, /*#__PURE__*/ $iSvIT.createElement((0, $1gr3O.HoistCssVarToLocalGrid), {
        variableName: (0, $nvCjc.topNavMountedVar),
        value: height
    }), dangerouslyHoistSlotSizes && /*#__PURE__*/ // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    $iSvIT.createElement((0, $1gr3O.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $nvCjc.UNSAFE_topNavVar),
        value: height
    }), children));
}

});
parcelRegister("53N3b", function(module, exports) {

$parcel$export(module.exports, "useCustomTheme", function () { return $3af347f27e27fd2c$export$c0c5f5b297b77726; });

var $iSvIT = parcelRequire("iSvIT");

var $byCTr = parcelRequire("byCTr");
function $3af347f27e27fd2c$export$c0c5f5b297b77726(theme) {
    var value = (0, $iSvIT.useMemo)(function() {
        if (!(theme !== null && theme !== void 0 && theme.backgroundColor) || !(theme !== null && theme !== void 0 && theme.highlightColor)) return {
            isEnabled: false
        };
        /**
     * Re-creating the `theme` object from it's pieces.
     *
     * _Technically_ we could just use `theme`, but that would involve an eslint opt out
     * as we would be leveraging a value (`theme`) not in the dependency array.
     *
     * The current approach is the most correct™️ and avoids foot guns.
     * We are only using values in the effect that are defined in the dependency array 🙌
     */ var value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        var style = (0, $byCTr.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme === null || theme === void 0 ? void 0 : theme.backgroundColor,
        theme === null || theme === void 0 ? void 0 : theme.highlightColor
    ]);
    return value;
}

});
parcelRegister("byCTr", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeStyles", function () { return $86a10a11521fcb2b$export$3986d75fe2da3239; });

var $eLTr6 = parcelRequire("eLTr6");

var $8ZJIC = parcelRequire("8ZJIC");

var $7HvyC = parcelRequire("7HvyC");

var $eA9N2 = parcelRequire("eA9N2");

var $2cD7J = parcelRequire("2cD7J");

var $c43do = parcelRequire("c43do");

var $bDbmx = parcelRequire("bDbmx");
function $86a10a11521fcb2b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $86a10a11521fcb2b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $86a10a11521fcb2b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $86a10a11521fcb2b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Expects colors to be passed as `RGB` objects.
 *
 * Allows `string` for hex strings only, for backwards compatibility.
 * This will likely be removed in the future.
 *
 * Allows `null` for ergonomic reasons, because our color parsing utilities can return
 * `null` if they cannot parse a color string.
 */ function $86a10a11521fcb2b$var$toRGBString(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
}
function $86a10a11521fcb2b$var$toRGBAString(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b, a = _ref2.a;
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
var $86a10a11521fcb2b$var$buttonStyles = {
    light: (0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)({}, (0, $7HvyC.themedButtonBackground), "transparent"), (0, $7HvyC.themedButtonBackgroundHovered), (0, $c43do.palette).Neutral200A), (0, $7HvyC.themedButtonBackgroundPressed), (0, $c43do.palette).Neutral300A), (0, $7HvyC.themedButtonBorder), (0, $c43do.palette).Neutral300A), (0, $7HvyC.themedButtonSelectedBackground), (0, $c43do.palette).Neutral300A), (0, $7HvyC.themedButtonSelectedBackgroundHovered), (0, $c43do.palette).Neutral400A), (0, $7HvyC.themedButtonSelectedBackgroundPressed), (0, $c43do.palette).Neutral500A), (0, $7HvyC.themedButtonDisabledText), (0, $c43do.palette).Neutral400A), (0, $7HvyC.themedButtonDisabledBackground), (0, $c43do.palette).Neutral100A),
    dark: (0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)({}, (0, $7HvyC.themedButtonBackground), "transparent"), (0, $7HvyC.themedButtonBackgroundHovered), (0, $c43do.palette).DarkNeutral200A), (0, $7HvyC.themedButtonBackgroundPressed), (0, $c43do.palette).DarkNeutral300A), (0, $7HvyC.themedButtonBorder), (0, $c43do.palette).DarkNeutral300A), (0, $7HvyC.themedButtonSelectedBackground), (0, $c43do.palette).DarkNeutral300A), (0, $7HvyC.themedButtonSelectedBackgroundHovered), (0, $c43do.palette).DarkNeutral400A), (0, $7HvyC.themedButtonSelectedBackgroundPressed), (0, $c43do.palette).DarkNeutral500A), (0, $7HvyC.themedButtonDisabledText), (0, $c43do.palette).DarkNeutral400A), (0, $7HvyC.themedButtonDisabledBackground), (0, $c43do.palette).DarkNeutral100A)
};
var $86a10a11521fcb2b$var$logoStyles = {
    light: (0, $eLTr6.default)((0, $eLTr6.default)({}, (0, $8ZJIC.themedLogoIcon), (0, $c43do.palette).DarkNeutral0), (0, $8ZJIC.themedLogoText), (0, $c43do.palette).DarkNeutral0),
    dark: (0, $eLTr6.default)((0, $eLTr6.default)({}, (0, $8ZJIC.themedLogoIcon), (0, $c43do.palette).Neutral0), (0, $8ZJIC.themedLogoText), (0, $c43do.palette).Neutral0)
};
function $86a10a11521fcb2b$export$3986d75fe2da3239(_ref3) {
    var backgroundColor = _ref3.backgroundColor, highlightColor = _ref3.highlightColor;
    var backgroundRgb = typeof backgroundColor === "string" ? (0, $2cD7J.parseHex)(backgroundColor) : backgroundColor;
    var highlightRgb = typeof highlightColor === "string" ? (0, $2cD7J.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    var textColor = (0, $eA9N2.getTextColor)(backgroundRgb);
    var colorMode = (0, $eA9N2.getColorMode)(backgroundRgb);
    var highlightTextColor = (0, $eA9N2.getTextColor)(highlightRgb);
    return $86a10a11521fcb2b$var$_objectSpread($86a10a11521fcb2b$var$_objectSpread($86a10a11521fcb2b$var$_objectSpread($86a10a11521fcb2b$var$_objectSpread({
        backgroundColor: $86a10a11521fcb2b$var$toRGBString(backgroundRgb),
        color: textColor.hex
    }, $86a10a11521fcb2b$var$buttonStyles[colorMode]), $86a10a11521fcb2b$var$logoStyles[colorMode]), $86a10a11521fcb2b$var$getSelectedStyles({
        backgroundColor: backgroundRgb,
        colorMode: colorMode
    })), {}, (0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)((0, $eLTr6.default)({}, (0, $bDbmx.themedSearchBorder), $86a10a11521fcb2b$var$toRGBAString($86a10a11521fcb2b$var$_objectSpread($86a10a11521fcb2b$var$_objectSpread({}, textColor.rgb), {}, {
        a: 0.5
    }))), (0, $bDbmx.themedSearchBorderFocused), $86a10a11521fcb2b$var$toRGBAString($86a10a11521fcb2b$var$_objectSpread($86a10a11521fcb2b$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.8
    }))), (0, $7HvyC.themedButtonPrimaryBackground), $86a10a11521fcb2b$var$toRGBString(highlightRgb)), (0, $7HvyC.themedButtonPrimaryBackgroundHovered), $86a10a11521fcb2b$var$toRGBAString($86a10a11521fcb2b$var$_objectSpread($86a10a11521fcb2b$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.8
    }))), (0, $7HvyC.themedButtonPrimaryBackgroundPressed), $86a10a11521fcb2b$var$toRGBAString($86a10a11521fcb2b$var$_objectSpread($86a10a11521fcb2b$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.65
    }))), (0, $7HvyC.themedButtonPrimaryText), highlightTextColor.hex));
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ var $86a10a11521fcb2b$var$selectedBackgroundRGBA = {
    light: (0, $c43do.paletteRgba).Neutral300A,
    dark: (0, $c43do.paletteRgba).DarkNeutral300A
};
function $86a10a11521fcb2b$var$getSelectedStyles(_ref4) {
    var backgroundColor = _ref4.backgroundColor, colorMode = _ref4.colorMode;
    /**
   * The background color of the selected button in its default state.
   *
   * We are referring to this as a foreground color because it is semi-transparent,
   * so is not the actual color displayed when the button is on top of a background color.
   */ var foregroundColor = $86a10a11521fcb2b$var$selectedBackgroundRGBA[colorMode];
    /**
   * The blended color seen when the selected background is over the top bar.
   */ var blendedBackground = (0, $eA9N2.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return (0, $eLTr6.default)((0, $eLTr6.default)({}, (0, $7HvyC.themedButtonSelectedText), (0, $eA9N2.getTextColor)(blendedBackground).hex), (0, $7HvyC.themedButtonSelectedBorder), (0, $eA9N2.isLight)(blendedBackground) ? (0, $c43do.palette).Neutral1100 : (0, $c43do.palette).DarkNeutral1100);
}

});
parcelRegister("8ZJIC", function(module, exports) {

$parcel$export(module.exports, "themedLogoIcon", function () { return $68c77c027e2cb84b$export$24328117f1132113; });
$parcel$export(module.exports, "themedLogoText", function () { return $68c77c027e2cb84b$export$91b0830f8f4ab279; });
$parcel$export(module.exports, "LogoRenderer", function () { return $68c77c027e2cb84b$export$35e88bd9b061a3a4; });
/* logo-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $gSLRZ = parcelRequire("gSLRZ");
var $68c77c027e2cb84b$export$24328117f1132113 = "--ds-top-bar-logo-icon";
var $68c77c027e2cb84b$export$91b0830f8f4ab279 = "--ds-top-bar-logo-text";
function $68c77c027e2cb84b$export$35e88bd9b061a3a4(_ref) {
    var logoOrIcon = _ref.logoOrIcon, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign;
    return (0, $jxLBU.fg)("jiv-20710-fix-nav-rerender") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($68c77c027e2cb84b$var$LogoRendererMemo, {
        logoOrIcon: logoOrIcon,
        shouldUseNewLogoDesign: shouldUseNewLogoDesign
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($68c77c027e2cb84b$var$LogoRendererNoMemo, {
        logoOrIcon: logoOrIcon,
        shouldUseNewLogoDesign: shouldUseNewLogoDesign
    });
}
var $68c77c027e2cb84b$var$LogoRendererMemo = /*#__PURE__*/ (0, $iSvIT.memo)($68c77c027e2cb84b$var$LogoRendererNoMemo);
function $68c77c027e2cb84b$var$LogoRendererNoMemo(_ref2) {
    var LogoOrIcon = _ref2.logoOrIcon, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign;
    var hasCustomTheme = (0, $gSLRZ.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(LogoOrIcon, {
        label: "",
        size: "small",
        shouldUseNewLogoDesign: shouldUseNewLogoDesign,
        iconColor: "var(".concat($68c77c027e2cb84b$export$24328117f1132113, ")"),
        textColor: "var(".concat($68c77c027e2cb84b$export$91b0830f8f4ab279, ")")
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(LogoOrIcon, {
        size: "small",
        shouldUseNewLogoDesign: shouldUseNewLogoDesign,
        label: "",
        appearance: "brand"
    });
}

});

parcelRegister("eA9N2", function(module, exports) {

$parcel$export(module.exports, "isLight", function () { return $a9dc058b6147f83e$export$44af652f4cca9039; });
$parcel$export(module.exports, "getColorMode", function () { return $a9dc058b6147f83e$export$5573a5bab3e074b5; });
$parcel$export(module.exports, "getTextColor", function () { return $a9dc058b6147f83e$export$5357fe757c335c0d; });
$parcel$export(module.exports, "simpleAlphaComposite", function () { return $a9dc058b6147f83e$export$e5e64c30bee1469b; });
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $a9dc058b6147f83e$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $a9dc058b6147f83e$var$relativeLuminanceW3C(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    /**
   * Normalized sRGB - each channel is between 0 and 1
   */ var normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
   * linear RGB - the gamma correction of sRGB is removed and
   * the channels correspond directly to subpixel intensity
   */ var linear = {
        r: $a9dc058b6147f83e$var$linearizeRGBChannel(normal.r),
        g: $a9dc058b6147f83e$var$linearizeRGBChannel(normal.g),
        b: $a9dc058b6147f83e$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    var L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ var $a9dc058b6147f83e$var$flipLuminance = 0.179129;
function $a9dc058b6147f83e$export$44af652f4cca9039(color) {
    return $a9dc058b6147f83e$var$relativeLuminanceW3C(color) >= $a9dc058b6147f83e$var$flipLuminance;
}
function $a9dc058b6147f83e$export$5573a5bab3e074b5(backgroundColor) {
    if ($a9dc058b6147f83e$var$relativeLuminanceW3C(backgroundColor) >= $a9dc058b6147f83e$var$flipLuminance) return "light";
    return "dark";
}
var $a9dc058b6147f83e$var$textColor = {
    light: {
        hex: "#000",
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: "#FFF",
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $a9dc058b6147f83e$export$5357fe757c335c0d(backgroundColor) {
    var colorMode = $a9dc058b6147f83e$export$5573a5bab3e074b5(backgroundColor);
    return $a9dc058b6147f83e$var$textColor[colorMode];
}
function $a9dc058b6147f83e$export$e5e64c30bee1469b(_ref2) {
    var background = _ref2.background, foreground = _ref2.foreground;
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("2cD7J", function(module, exports) {

$parcel$export(module.exports, "parseHex", function () { return $19ab0ce698275aac$export$103711ef09c6edec; });
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
var $19ab0ce698275aac$var$isValidHex = function isValidHex(hex) {
    return(// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex));
};
function $19ab0ce698275aac$export$103711ef09c6edec(color) {
    if (!$19ab0ce698275aac$var$isValidHex(color)) return null;
    var channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("c43do", function(module, exports) {

$parcel$export(module.exports, "palette", function () { return $8c885a2dff796040$export$eaad8caa32d2521d; });
$parcel$export(module.exports, "paletteRgba", function () { return $8c885a2dff796040$export$c9b84419dae66a82; });
/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ var $8c885a2dff796040$export$eaad8caa32d2521d = {
    "DarkNeutral-100": "#111213",
    "DarkNeutral-100A": "#01040475",
    DarkNeutral0: "#18191A",
    DarkNeutral100: "#1F1F21",
    DarkNeutral100A: "#BDBDBD0A",
    DarkNeutral200: "#242528",
    DarkNeutral200A: "#CECED912",
    DarkNeutral250: "#2B2C2F",
    DarkNeutral250A: "#D9DAE71A",
    DarkNeutral300: "#303134",
    DarkNeutral300A: "#E3E4F21F",
    DarkNeutral350: "#3D3F43",
    DarkNeutral350A: "#E8EDFD2E",
    DarkNeutral400: "#4B4D51",
    DarkNeutral400A: "#E5E9F640",
    DarkNeutral500: "#63666B",
    DarkNeutral500A: "#E9F0FB5C",
    DarkNeutral600: "#7E8188",
    DarkNeutral700: "#96999E",
    DarkNeutral800: "#A9ABAF",
    DarkNeutral900: "#BFC1C4",
    DarkNeutral1000: "#CECFD2",
    DarkNeutral1100: "#E2E3E4",
    Neutral0: "#FFFFFF",
    Neutral100: "#F8F8F8",
    Neutral100A: "#17171708",
    Neutral200: "#F0F1F2",
    Neutral200A: "#0515240F",
    Neutral300: "#DDDEE1",
    Neutral300A: "#0B120E24",
    Neutral400: "#B7B9BE",
    Neutral400A: "#080F214A",
    Neutral500: "#8C8F97",
    Neutral500A: "#050C1F75",
    Neutral600: "#7D818A",
    Neutral700: "#6B6E76",
    Neutral800: "#505258",
    Neutral900: "#3B3D42",
    Neutral1000: "#292A2E",
    Neutral1100: "#1E1F21"
};
var $8c885a2dff796040$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});

parcelRegister("bDbmx", function(module, exports) {

$parcel$export(module.exports, "themedSearchBorder", function () { return $877c26975910cb4b$export$ae6fbf5ba3a7a784; });
$parcel$export(module.exports, "themedSearchBorderFocused", function () { return $877c26975910cb4b$export$ee42b8430f4c19bd; });

var $7HvyC = parcelRequire("7HvyC");

var $gSLRZ = parcelRequire("gSLRZ");
var $877c26975910cb4b$export$ae6fbf5ba3a7a784 = "--ds-top-bar-search-border";
var $877c26975910cb4b$export$ee42b8430f4c19bd = "--ds-top-bar-search-border-focused";
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ var $877c26975910cb4b$var$legacySearchTheme = {
    default: {
        backgroundColor: "transparent",
        color: "currentColor",
        borderColor: "var(".concat($877c26975910cb4b$export$ae6fbf5ba3a7a784, ")")
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #172B4D)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: "var(".concat($877c26975910cb4b$export$ee42b8430f4c19bd, ")"),
        boxShadow: "inset 0px 0px 0px 1px var(".concat($877c26975910cb4b$export$ee42b8430f4c19bd, ")")
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: "var(".concat((0, $7HvyC.themedButtonBackgroundHovered), ")")
    }
};
function $877c26975910cb4b$export$18a29b1ed2212823() {
    var hasCustomTheme = (0, $gSLRZ.useHasCustomTheme)();
    if (hasCustomTheme) return $877c26975910cb4b$var$legacySearchTheme;
    return undefined;
}

});




parcelRegister("5t82q", function(module, exports) {

$parcel$export(module.exports, "TopNavEnd", function () { return $3fb5e56320dabcd6$export$8b7a38b70a3c9839; });
/* top-nav-end.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $gaNY9 = parcelRequire("gaNY9");

var $8lTdX = parcelRequire("8lTdX");

var $iSvIT = parcelRequire("iSvIT");

var $hHqGT = parcelRequire("hHqGT");

var $5SoPc = parcelRequire("5SoPc");

var $hn7Fv = parcelRequire("hn7Fv");

var $l9IXf = parcelRequire("l9IXf");

var $kqQOc = parcelRequire("kqQOc");

var $bsDru = parcelRequire("bsDru");

var $gSLRZ = parcelRequire("gSLRZ");

var $hDoCV = parcelRequire("hDoCV");
var $3fb5e56320dabcd6$var$containerStyles = {
    root: "_yyhy11wp _1e0c1txw _1bahh9n0 _1ul9zwfg _1d2y1ris _glte1ris _15ri1mjv _1gs5usvi _ndwch9n0"
};
var $3fb5e56320dabcd6$var$listStyles = {
    root: "_zulp1b66 _4cvr1h6o _1e0c1txw",
    hideOnSmallViewport: "_1e0cglyw _181n1txw",
    popupContainer: "_1yt4u2gc"
};
function $3fb5e56320dabcd6$export$8b7a38b70a3c9839(_ref) {
    var children = _ref.children, _ref$label = _ref.label, label = _ref$label === void 0 ? "Actions" : _ref$label, _ref$showMoreButtonLa = _ref.showMoreButtonLabel, showMoreButtonLabel = _ref$showMoreButtonLa === void 0 ? "Show more" : _ref$showMoreButtonLa;
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $gaNY9.default)(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    // Always setting to `false` for the initial render (will flip in an effect for mobile)
    var _useState3 = (0, $iSvIT.useState)(false), _useState4 = (0, $gaNY9.default)(_useState3, 2), isMobile = _useState4[0], setIsMobile = _useState4[1];
    // Note: `query` is a stable value between renders
    var query = (0, $kqQOc.UNSAFE_useMediaQuery)("below.sm", function onChange(event) {
        setIsMobile(event.matches);
        // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $5SoPc.useLayoutEffect)(function() {
        var _query$matches;
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile((_query$matches = query === null || query === void 0 ? void 0 : query.matches) !== null && _query$matches !== void 0 ? _query$matches : false);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("nav", {
        "aria-label": label,
        className: (0, $8lTdX.default)([
            $3fb5e56320dabcd6$var$containerStyles.root
        ])
    }, isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $l9IXf.default), {
        isOpen: isOpen,
        onClose: function onClose() {
            return setIsOpen(false);
        },
        placement: "bottom-start",
        shouldRenderToParent: true,
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gSLRZ.HasCustomThemeContext).Provider, {
                value: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bsDru.List), {
                xcss: (0, $hHqGT.cx)($3fb5e56320dabcd6$var$listStyles.root, $3fb5e56320dabcd6$var$listStyles.popupContainer)
            }, children));
        },
        trigger: function trigger(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hDoCV.IconButton), (0, $jRswm.default)({}, triggerProps, {
                label: showMoreButtonLabel,
                isSelected: isOpen,
                onClick: function onClick() {
                    return setIsOpen(!isOpen);
                },
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hn7Fv))),
                isTooltipDisabled: false
            }));
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bsDru.List), {
        xcss: (0, $hHqGT.cx)($3fb5e56320dabcd6$var$listStyles.root, $3fb5e56320dabcd6$var$listStyles.hideOnSmallViewport)
    }, children));
}

});
parcelRegister("5SoPc", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $4475409b59bc2cb7$export$e5c5a5f917a5871c; });

var $iSvIT = parcelRequire("iSvIT");
var $4475409b59bc2cb7$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);

});

parcelRegister("hn7Fv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a789640350a4d3b29556a43626f35de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca5a886fd9372b8f$var$_react = $ca5a886fd9372b8f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ca5a886fd9372b8f$var$_baseNew = $ca5a886fd9372b8f$var$_interopRequireDefault((parcelRequire("kPVdq")));
function $ca5a886fd9372b8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca5a886fd9372b8f$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $ca5a886fd9372b8f$var$_react.default.createElement($ca5a886fd9372b8f$var$_baseNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$ca5a886fd9372b8f$var$ShowMoreHorizontalIcon.displayName = "ShowMoreHorizontalIcon";
var $ca5a886fd9372b8f$var$_default = module.exports.default = $ca5a886fd9372b8f$var$ShowMoreHorizontalIcon;

});

parcelRegister("l9IXf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f66d4f4c83435eff$export$2e2bcd8739ae039; });

var $jDp96 = parcelRequire("jDp96");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f66d4f4c83435eff$export$2e2bcd8739ae039 = (0, $jDp96.Popup);

});
parcelRegister("jDp96", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return $e4b52a4758e170e3$export$129a32eedafa97c5; });
/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gaNY9 = parcelRequire("gaNY9");

var $iSvIT = parcelRequire("iSvIT");


var $5CqIy = parcelRequire("5CqIy");

var $9bV5B = parcelRequire("9bV5B");

var $1Z36a = parcelRequire("1Z36a");

var $jxLBU = parcelRequire("jxLBU");

var $5X460 = parcelRequire("5X460");
var $b2CZb = parcelRequire("b2CZb");

var $gWVOm = parcelRequire("gWVOm");

var $dCVz3 = parcelRequire("dCVz3");

var $jeYKP = parcelRequire("jeYKP");

var $kWlmR = parcelRequire("kWlmR");

var $1TteW = parcelRequire("1TteW");

var $kFtse = parcelRequire("kFtse");
var $e4b52a4758e170e3$var$defaultLayer = 400;
var $e4b52a4758e170e3$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $e4b52a4758e170e3$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? "viewport" : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $e4b52a4758e170e3$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $gaNY9.default)(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $1TteW.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $kFtse.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $5CqIy.useId)();
    var _usePopupAppearance = (0, $kWlmR.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $iSvIT.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $1Z36a.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    var renderPopperWrapper = /*#__PURE__*/ $iSvIT.createElement((0, $9bV5B.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $iSvIT.createElement((0, $jeYKP.default), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? "absolute" : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $iSvIT.createElement((0, $5X460.Manager), null, /*#__PURE__*/ $iSvIT.createElement((0, $b2CZb.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $jxLBU.fg)("platform-design-system-popup-ref") ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            "aria-controls": isOpen ? id : undefined,
            "aria-expanded": isOpen,
            "aria-haspopup": role === "dialog" && (0, $jxLBU.fg)("platform_dst_popup-disable-focuslock") ? "dialog" : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $iSvIT.createElement((0, $gWVOm.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return /*#__PURE__*/ $iSvIT.createElement((0, $dCVz3.default), {
        xcss: $e4b52a4758e170e3$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});

});
parcelRegister("dCVz3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ebb7a0e1e0a3a42$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $iPRdB = parcelRequire("iPRdB");
var $9ebb7a0e1e0a3a42$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $9ebb7a0e1e0a3a42$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $9ebb7a0e1e0a3a42$var$baseStyles = null;
var $9ebb7a0e1e0a3a42$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhk1fno",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1eds",
    "color.background.accent.lime.subtler.pressed": "_bfhk1hgz",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhkhgj8",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhk1b17",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhk1pbw",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkrw5d",
    "color.background.accent.red.subtler.pressed": "_bfhk69rw",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1tf4",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhkprmn",
    "color.background.accent.orange.subtlest": "_bfhk1g3m",
    "color.background.accent.orange.subtlest.hovered": "_bfhkg4tm",
    "color.background.accent.orange.subtlest.pressed": "_bfhk1ya0",
    "color.background.accent.orange.subtler": "_bfhkf2vu",
    "color.background.accent.orange.subtler.hovered": "_bfhk1lml",
    "color.background.accent.orange.subtler.pressed": "_bfhkuxsx",
    "color.background.accent.orange.subtle": "_bfhk1g6e",
    "color.background.accent.orange.subtle.hovered": "_bfhk1oew",
    "color.background.accent.orange.subtle.pressed": "_bfhk1phk",
    "color.background.accent.orange.bolder": "_bfhkjgng",
    "color.background.accent.orange.bolder.hovered": "_bfhkhi52",
    "color.background.accent.orange.bolder.pressed": "_bfhkf767",
    "color.background.accent.yellow.subtlest": "_bfhk1ozg",
    "color.background.accent.yellow.subtlest.hovered": "_bfhk19g9",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk31d1",
    "color.background.accent.yellow.subtler": "_bfhk3fv2",
    "color.background.accent.yellow.subtler.hovered": "_bfhklg04",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1d44",
    "color.background.accent.yellow.subtle": "_bfhkry5t",
    "color.background.accent.yellow.subtle.hovered": "_bfhk17e6",
    "color.background.accent.yellow.subtle.pressed": "_bfhko0y5",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk32kj",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkv5yf",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhkung8",
    "color.background.accent.green.subtler.pressed": "_bfhk1p19",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk8h4p",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1azz",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1j2h",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkg5py",
    "color.background.accent.teal.subtler.pressed": "_bfhkq7li",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk10ai",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhkse6l",
    "color.background.accent.blue.subtlest": "_bfhkavxe",
    "color.background.accent.blue.subtlest.hovered": "_bfhkay3p",
    "color.background.accent.blue.subtlest.pressed": "_bfhk1xmr",
    "color.background.accent.blue.subtler": "_bfhk4v9p",
    "color.background.accent.blue.subtler.hovered": "_bfhk16e6",
    "color.background.accent.blue.subtler.pressed": "_bfhk1uh7",
    "color.background.accent.blue.subtle": "_bfhk1j89",
    "color.background.accent.blue.subtle.hovered": "_bfhk1f4s",
    "color.background.accent.blue.subtle.pressed": "_bfhkqctv",
    "color.background.accent.blue.bolder": "_bfhkc8cv",
    "color.background.accent.blue.bolder.hovered": "_bfhk1cwi",
    "color.background.accent.blue.bolder.pressed": "_bfhkhcrq",
    "color.background.accent.purple.subtlest": "_bfhkp7j4",
    "color.background.accent.purple.subtlest.hovered": "_bfhkm0d5",
    "color.background.accent.purple.subtlest.pressed": "_bfhkgslw",
    "color.background.accent.purple.subtler": "_bfhk1jkz",
    "color.background.accent.purple.subtler.hovered": "_bfhk1wyu",
    "color.background.accent.purple.subtler.pressed": "_bfhk5fkp",
    "color.background.accent.purple.subtle": "_bfhkdh45",
    "color.background.accent.purple.subtle.hovered": "_bfhk1wob",
    "color.background.accent.purple.subtle.pressed": "_bfhkwz05",
    "color.background.accent.purple.bolder": "_bfhkygwo",
    "color.background.accent.purple.bolder.hovered": "_bfhkadgs",
    "color.background.accent.purple.bolder.pressed": "_bfhk1uro",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1een",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1r0p",
    "color.background.accent.magenta.subtler.pressed": "_bfhkxuzc",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk1ovh",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkwaw3",
    "color.background.accent.gray.subtlest": "_bfhk11bn",
    "color.background.accent.gray.subtlest.hovered": "_bfhk12j4",
    "color.background.accent.gray.subtlest.pressed": "_bfhk1lb4",
    "color.background.accent.gray.subtler": "_bfhk1v33",
    "color.background.accent.gray.subtler.hovered": "_bfhk1f7l",
    "color.background.accent.gray.subtler.pressed": "_bfhkd8a2",
    "color.background.accent.gray.subtle": "_bfhk1t05",
    "color.background.accent.gray.subtle.hovered": "_bfhk1a2l",
    "color.background.accent.gray.subtle.pressed": "_bfhk1z0s",
    "color.background.accent.gray.bolder": "_bfhk1t1b",
    "color.background.accent.gray.bolder.hovered": "_bfhke4nv",
    "color.background.accent.gray.bolder.pressed": "_bfhk82ra",
    "color.background.disabled": "_bfhksyzs",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhk1d5g",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhkm7j4",
    "color.background.neutral.hovered": "_bfhk15ej",
    "color.background.neutral.pressed": "_bfhkip91",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk166n",
    "color.background.neutral.subtle.pressed": "_bfhk1dty",
    "color.background.neutral.bold": "_bfhkcdhy",
    "color.background.neutral.bold.hovered": "_bfhk1bsc",
    "color.background.neutral.bold.pressed": "_bfhk1b6k",
    "color.background.selected": "_bfhkfg4m",
    "color.background.selected.hovered": "_bfhki1yw",
    "color.background.selected.pressed": "_bfhk19ru",
    "color.background.selected.bold": "_bfhk1fvw",
    "color.background.selected.bold.hovered": "_bfhk18hz",
    "color.background.selected.bold.pressed": "_bfhkgr1v",
    "color.background.brand.subtlest": "_bfhk3wxy",
    "color.background.brand.subtlest.hovered": "_bfhkezq1",
    "color.background.brand.subtlest.pressed": "_bfhk2ggb",
    "color.background.brand.bold": "_bfhkb29m",
    "color.background.brand.bold.hovered": "_bfhku1se",
    "color.background.brand.bold.pressed": "_bfhkqkzo",
    "color.background.brand.boldest": "_bfhk15mt",
    "color.background.brand.boldest.hovered": "_bfhk1uwk",
    "color.background.brand.boldest.pressed": "_bfhk17jr",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1io2",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk9pqq",
    "color.background.warning": "_bfhk1tzq",
    "color.background.warning.hovered": "_bfhk1rd4",
    "color.background.warning.pressed": "_bfhk11dh",
    "color.background.warning.bold": "_bfhk190i",
    "color.background.warning.bold.hovered": "_bfhk1i4c",
    "color.background.warning.bold.pressed": "_bfhkrj9s",
    "color.background.success": "_bfhkmv6i",
    "color.background.success.hovered": "_bfhk1jgi",
    "color.background.success.pressed": "_bfhky4f1",
    "color.background.success.bold": "_bfhk8emd",
    "color.background.success.bold.hovered": "_bfhk1q4l",
    "color.background.success.bold.pressed": "_bfhkcrcn",
    "color.background.discovery": "_bfhk1nvp",
    "color.background.discovery.hovered": "_bfhk1xp7",
    "color.background.discovery.pressed": "_bfhkdlkp",
    "color.background.discovery.bold": "_bfhk1lri",
    "color.background.discovery.bold.hovered": "_bfhk1w72",
    "color.background.discovery.bold.pressed": "_bfhkrb53",
    "color.background.information": "_bfhk33gi",
    "color.background.information.hovered": "_bfhk1vps",
    "color.background.information.pressed": "_bfhk1s0z",
    "color.background.information.bold": "_bfhk14wj",
    "color.background.information.bold.hovered": "_bfhk1amz",
    "color.background.information.bold.pressed": "_bfhk5bth",
    "color.blanket": "_bfhk10xm",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkn82g",
    "color.skeleton.subtle": "_bfhkh3tw",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk108i",
    "elevation.surface.pressed": "_bfhk1ji5",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk16qz",
    "elevation.surface.overlay.pressed": "_bfhkvq0a",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk1a0f",
    "elevation.surface.raised.pressed": "_bfhkf7u5",
    "elevation.surface.sunken": "_bfhkqbzx",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $9ebb7a0e1e0a3a42$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $9ebb7a0e1e0a3a42$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l108i",
    "elevation.surface.pressed": "_1q1l1ji5",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l16qz",
    "elevation.surface.overlay.pressed": "_1q1lvq0a",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l1a0f",
    "elevation.surface.raised.pressed": "_1q1lf7u5",
    "elevation.surface.sunken": "_1q1lqbzx"
};
var $9ebb7a0e1e0a3a42$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $9ebb7a0e1e0a3a42$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $9ebb7a0e1e0a3a42$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $9ebb7a0e1e0a3a42$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $9ebb7a0e1e0a3a42$var$Box = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $fzcGG.default)(_ref, $9ebb7a0e1e0a3a42$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $fzcGG.default)(htmlAttributes, $9ebb7a0e1e0a3a42$var$_excluded2);
    var node = /*#__PURE__*/ $iSvIT.createElement(Component, (0, $jRswm.default)({
        style: style,
        ref: ref,
        className: (0, $8lTdX.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $9ebb7a0e1e0a3a42$var$backgroundColorMap[backgroundColor],
            backgroundColor && $9ebb7a0e1e0a3a42$var$isSurfaceToken(backgroundColor) && $9ebb7a0e1e0a3a42$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $9ebb7a0e1e0a3a42$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $9ebb7a0e1e0a3a42$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $9ebb7a0e1e0a3a42$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $9ebb7a0e1e0a3a42$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $iSvIT.createElement((0, $iPRdB.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $9ebb7a0e1e0a3a42$export$2e2bcd8739ae039 = $9ebb7a0e1e0a3a42$var$Box;
function $9ebb7a0e1e0a3a42$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $9ebb7a0e1e0a3a42$var$setSurfaceTokenMap;
}

});
parcelRegister("iPRdB", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $db66458181a2f059$export$1ca2a26fecb070ae; });

var $iSvIT = parcelRequire("iSvIT");
var $db66458181a2f059$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $db66458181a2f059$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($db66458181a2f059$export$1ca2a26fecb070ae);
};
$db66458181a2f059$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("jeYKP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e01e73a6268558fc$export$2e2bcd8739ae039; });
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $lcRu8 = parcelRequire("lcRu8");

var $gaNY9 = parcelRequire("gaNY9");

var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $47p9E = parcelRequire("47p9E");

var $jxLBU = parcelRequire("jxLBU");

var $gr749 = parcelRequire("gr749");

var $gxMmK = parcelRequire("gxMmK");

var $6QWxj = parcelRequire("6QWxj");

var $4MA63 = parcelRequire("4MA63");
var $e01e73a6268558fc$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden"
];
var $e01e73a6268558fc$var$LOCAL_CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $e01e73a6268558fc$var$fullWidthStyles = null;
var $e01e73a6268558fc$var$wrapperStyles = {
    root: "_2rkoglpi _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _syaz1fxt _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
var $e01e73a6268558fc$var$scrollableStyles = null;
var $e01e73a6268558fc$var$blanketStyles = null;
var $e01e73a6268558fc$var$modalStyles = null;
var $e01e73a6268558fc$var$focusRingStyles = {
    root: "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y"
};
var $e01e73a6268558fc$var$DefaultPopupComponent = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, isReferenceHidden = props.isReferenceHidden, htmlAttributes = (0, $fzcGG.default)(props, $e01e73a6268558fc$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $jRswm.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $8lTdX.default)([
            $e01e73a6268558fc$var$wrapperStyles.root,
            appearance === "UNSAFE_modal-below-sm" && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $e01e73a6268558fc$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $e01e73a6268558fc$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance;
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $gaNY9.default)(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(null), _useState4 = (0, $gaNY9.default)(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== "dialog";
    (0, $4MA63.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $6QWxj.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $47p9E.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $iSvIT.useMemo)(function() {
        return [
            {
                name: "flip",
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, $lcRu8.default)(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $iSvIT.createElement((0, $gr749.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $iSvIT.createElement(PopupContainer, {
            className: (0, $8lTdX.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $jxLBU.fg)("platform-design-system-apply-popup-wrapper-focus") && $e01e73a6268558fc$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === "UNSAFE_modal-below-sm" ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $iSvIT.createElement((0, $gxMmK.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), null, popupContainer, appearance === "UNSAFE_modal-below-sm" && /*#__PURE__*/ $iSvIT.createElement("div", {
            className: (0, $8lTdX.default)([
                "_1r04idpf _kqsw1n9t _bfhk10xm"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e01e73a6268558fc$export$2e2bcd8739ae039 = $e01e73a6268558fc$var$PopperWrapper;

});
parcelRegister("gxMmK", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", function () { return $c0b53ee48327a758$export$51eddd7655ca235a; });

var $iSvIT = parcelRequire("iSvIT");
var $c0b53ee48327a758$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $iSvIT.useRef)(true);
    (0, $iSvIT.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, children);
};

});

parcelRegister("6QWxj", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", function () { return $4fd5017e34aa9d56$export$92dae2778ae88f9d; });
// eslint-disable-next-line no-duplicate-imports

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $emfh8 = parcelRequire("emfh8");

var $47p9E = parcelRequire("47p9E");

var $jxLBU = parcelRequire("jxLBU");

var $62Qd8 = parcelRequire("62Qd8");

var $1bREG = parcelRequire("1bREG");
var $4fd5017e34aa9d56$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $47p9E.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $1bREG.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $iSvIT.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $emfh8.default;
        var inIframe = window && window.self !== window.top && (0, $jxLBU.fg)("fix-dropdown-close-outside-iframe");
        var closePopup = function closePopup(event) {
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest;
                    _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute("data-ds--level");
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $jxLBU.fg)("platform_dst_popup-disable-focuslock")) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "0");
                if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "0");
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute("[data-ds--close--type]");
                        if (closeType === "single") // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute("data-ds--level");
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $62Qd8.isInteractiveElement)(document.activeElement) && (0, $jxLBU.fg)("platform_dst_popup-disable-focuslock")) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $jxLBU.fg)("platform_dst_popup-disable-focuslock")) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === "Tab" && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === "Tab") {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest("[aria-modal]")) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === "Escape" || key === "Esc") {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === "Escape" || _key === "Esc" || shouldCloseOnTab && _key === "Tab") closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $2e1kT.bind)(window.parent.window, {
            type: "click",
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $emfh8.default);
        if ((0, $jxLBU.fg)("popup-onclose-fix")) setTimeout(function() {
            unbind = (0, $2e1kT.bindAll)(window, [
                {
                    type: "click",
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: "keydown",
                    listener: onKeyDown
                }
            ]);
        }, 0);
        else unbind = (0, $2e1kT.bindAll)(window, [
            {
                type: "click",
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: "keydown",
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $emfh8.default);
        unbindBlur = (0, $2e1kT.bind)(window, {
            type: "blur",
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            if ((0, $jxLBU.fg)("popup-onclose-fix")) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("62Qd8", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", function () { return $466b6dfc2e0a6a71$export$3dee5e4542c672d9; });
var $466b6dfc2e0a6a71$var$interactiveTags = [
    "button",
    "a",
    "input",
    "select",
    "textarea"
];
var $466b6dfc2e0a6a71$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($466b6dfc2e0a6a71$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute("tabindex") !== null || element.hasAttribute("contenteditable")) return true;
    return false;
};

});

parcelRegister("1bREG", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrame", function () { return $0de0705725be8623$export$641fa9c94086b46e; });

var $iSvIT = parcelRequire("iSvIT");
var $0de0705725be8623$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $iSvIT.useRef)([]);
    var requestFrame = (0, $iSvIT.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $iSvIT.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $iSvIT.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("4MA63", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", function () { return $37b7a5260af2afb3$export$10c5169755ce7bd7; });

var $iSvIT = parcelRequire("iSvIT");

var $17K1G = parcelRequire("17K1G");

var $emfh8 = parcelRequire("emfh8");

var $47p9E = parcelRequire("47p9E");

var $jxLBU = parcelRequire("jxLBU");

var $1bREG = parcelRequire("1bREG");
var $37b7a5260af2afb3$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $1bREG.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $47p9E.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $iSvIT.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $emfh8.default;
        if (shouldDisableFocusTrap && (0, $jxLBU.fg)("platform_dst_popup-disable-focuslock")) {
            var isDropdown = popupRef.matches("[id^=ds--dropdown--]");
            var popups = document.querySelectorAll('[data-ds--level="'.concat(currentLevel - 1, '"]'));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "-1");
                    if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "-1");
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $emfh8.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($17K1G)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("kWlmR", function(module, exports) {

$parcel$export(module.exports, "usePopupAppearance", function () { return $f3e9cc963842d336$export$4065aef1d79a5730; });

var $gaNY9 = parcelRequire("gaNY9");

var $iSvIT = parcelRequire("iSvIT");

var $sAIt2 = parcelRequire("sAIt2");
function $f3e9cc963842d336$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $sAIt2.UNSAFE_useMediaQuery)("below.sm", function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $iSvIT.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, $gaNY9.default)(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === "UNSAFE_modal-below-sm" && isSmallViewport ? "UNSAFE_modal-below-sm" : "default";
    var shouldRenderToParent = _shouldRenderToParent && appearance === "default";
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("sAIt2", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $055f18b702b04e07$export$49e55ae2c03d6045; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $1qHV5 = parcelRequire("1qHV5");
var $055f18b702b04e07$var$_window, $055f18b702b04e07$var$_window$matchMedia, $055f18b702b04e07$var$_window2, $055f18b702b04e07$var$_window2$matchMedia, $055f18b702b04e07$var$_window3, $055f18b702b04e07$var$_window3$matchMedia, $055f18b702b04e07$var$_window4, $055f18b702b04e07$var$_window4$matchMedia, $055f18b702b04e07$var$_window5, $055f18b702b04e07$var$_window5$matchMedia, $055f18b702b04e07$var$_window6, $055f18b702b04e07$var$_window6$matchMedia, $055f18b702b04e07$var$_window7, $055f18b702b04e07$var$_window7$matchMedia, $055f18b702b04e07$var$_window8, $055f18b702b04e07$var$_window8$matchMedia, $055f18b702b04e07$var$_window9, $055f18b702b04e07$var$_window9$matchMedia, $055f18b702b04e07$var$_window0, $055f18b702b04e07$var$_window0$matchMedia, $055f18b702b04e07$var$_window1, $055f18b702b04e07$var$_window1$matchMedia;
var $055f18b702b04e07$var$queries = {
    "above.xxs": typeof window === "undefined" ? undefined : ($055f18b702b04e07$var$_window = window) === null || $055f18b702b04e07$var$_window === void 0 || ($055f18b702b04e07$var$_window$matchMedia = $055f18b702b04e07$var$_window.matchMedia) === null || $055f18b702b04e07$var$_window$matchMedia === void 0 ? void 0 : $055f18b702b04e07$var$_window$matchMedia.call($055f18b702b04e07$var$_window, (0, $1qHV5.media).above.xxs.replace("@media ", "").trim()),
    "above.xs": typeof window === "undefined" ? undefined : ($055f18b702b04e07$var$_window2 = window) === null || $055f18b702b04e07$var$_window2 === void 0 || ($055f18b702b04e07$var$_window2$matchMedia = $055f18b702b04e07$var$_window2.matchMedia) === null || $055f18b702b04e07$var$_window2$matchMedia === void 0 ? void 0 : $055f18b702b04e07$var$_window2$matchMedia.call($055f18b702b04e07$var$_window2, (0, $1qHV5.media).above.xs.replace("@media ", "").trim()),
    "above.sm": typeof window === "undefined" ? undefined : ($055f18b702b04e07$var$_window3 = window) === null || $055f18b702b04e07$var$_window3 === void 0 || ($055f18b702b04e07$var$_window3$matchMedia = $055f18b702b04e07$var$_window3.matchMedia) === null || $055f18b702b04e07$var$_window3$matchMedia === void 0 ? void 0 : $055f18b702b04e07$var$_window3$matchMedia.call($055f18b702b04e07$var$_window3, (0, $1qHV5.media).above.sm.replace("@media ", "").trim()),
    "above.md": typeof window === "undefined" ? undefined : ($055f18b702b04e07$var$_window4 = window) === null || $055f18b702b04e07$var$_window4 === void 0 || ($055f18b702b04e07$var$_window4$matchMedia = $055f18b702b04e07$var$_window4.matchMedia) === null || $055f18b702b04e07$var$_window4$matchMedia === void 0 ? void 0 : $055f18b702b04e07$var$_window4$matchMedia.call($055f18b702b04e07$var$_window4, (0, $1qHV5.media).above.md.replace("@media ", "").trim()),
    "above.lg": typeof window === "undefined" ? undefined : ($055f18b702b04e07$var$_window5 = window) === null || $055f18b702b04e07$var$_window5 === void 0 || ($055f18b702b04e07$var$_window5$matchMedia = $055f18b702b04e07$var$_window5.matchMedia) === null || $055f18b702b04e07$var$_window5$matchMedia === void 0 ? void 0 : $055f18b702b04e07$var$_window5$matchMedia.call($055f18b702b04e07$var$_window5, (0, $1qHV5.media).above.lg.replace("@media ", "").trim()),
    "above.xl": typeof window === "undefined" ? undefined : ($055f18b702b04e07$var$_window6 = window) === null || $055f18b702b04e07$var$_window6 === void 0 || ($055f18b702b04e07$var$_window6$matchMedia = $055f18b702b04e07$var$_window6.matchMedia) === null || $055f18b702b04e07$var$_window6$matchMedia === void 0 ? void 0 : $055f18b702b04e07$var$_window6$matchMedia.call($055f18b702b04e07$var$_window6, (0, $1qHV5.media).above.xl.replace("@media ", "").trim()),
    "below.xs": typeof window === "undefined" ? undefined : ($055f18b702b04e07$var$_window7 = window) === null || $055f18b702b04e07$var$_window7 === void 0 || ($055f18b702b04e07$var$_window7$matchMedia = $055f18b702b04e07$var$_window7.matchMedia) === null || $055f18b702b04e07$var$_window7$matchMedia === void 0 ? void 0 : $055f18b702b04e07$var$_window7$matchMedia.call($055f18b702b04e07$var$_window7, (0, $1qHV5.media).below.xs.replace("@media ", "").trim()),
    "below.sm": typeof window === "undefined" ? undefined : ($055f18b702b04e07$var$_window8 = window) === null || $055f18b702b04e07$var$_window8 === void 0 || ($055f18b702b04e07$var$_window8$matchMedia = $055f18b702b04e07$var$_window8.matchMedia) === null || $055f18b702b04e07$var$_window8$matchMedia === void 0 ? void 0 : $055f18b702b04e07$var$_window8$matchMedia.call($055f18b702b04e07$var$_window8, (0, $1qHV5.media).below.sm.replace("@media ", "").trim()),
    "below.md": typeof window === "undefined" ? undefined : ($055f18b702b04e07$var$_window9 = window) === null || $055f18b702b04e07$var$_window9 === void 0 || ($055f18b702b04e07$var$_window9$matchMedia = $055f18b702b04e07$var$_window9.matchMedia) === null || $055f18b702b04e07$var$_window9$matchMedia === void 0 ? void 0 : $055f18b702b04e07$var$_window9$matchMedia.call($055f18b702b04e07$var$_window9, (0, $1qHV5.media).below.md.replace("@media ", "").trim()),
    "below.lg": typeof window === "undefined" ? undefined : ($055f18b702b04e07$var$_window0 = window) === null || $055f18b702b04e07$var$_window0 === void 0 || ($055f18b702b04e07$var$_window0$matchMedia = $055f18b702b04e07$var$_window0.matchMedia) === null || $055f18b702b04e07$var$_window0$matchMedia === void 0 ? void 0 : $055f18b702b04e07$var$_window0$matchMedia.call($055f18b702b04e07$var$_window0, (0, $1qHV5.media).below.lg.replace("@media ", "").trim()),
    "below.xl": typeof window === "undefined" ? undefined : ($055f18b702b04e07$var$_window1 = window) === null || $055f18b702b04e07$var$_window1 === void 0 || ($055f18b702b04e07$var$_window1$matchMedia = $055f18b702b04e07$var$_window1.matchMedia) === null || $055f18b702b04e07$var$_window1$matchMedia === void 0 ? void 0 : $055f18b702b04e07$var$_window1$matchMedia.call($055f18b702b04e07$var$_window1, (0, $1qHV5.media).below.xl.replace("@media ", "").trim())
};
var $055f18b702b04e07$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $iSvIT.useRef)(listener);
    (0, $iSvIT.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $055f18b702b04e07$var$queries[queryString];
    (0, $iSvIT.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $2e1kT.bind)(mq, {
            type: "change",
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("1qHV5", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $10aa49ad921250b7$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $10aa49ad921250b7$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};

});



parcelRegister("1TteW", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $16119bf1847b3970$export$7cc5c058dd769dff; });

var $gaNY9 = parcelRequire("gaNY9");

var $iSvIT = parcelRequire("iSvIT");

var $fV0Sg = parcelRequire("fV0Sg");
var $16119bf1847b3970$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $iSvIT.useState)(function() {
        return (0, $fV0Sg.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $gaNY9.default)(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("kFtse", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", function () { return $03e20a421a3a6ab5$export$5d3a2de79e07b376; });

var $gaNY9 = parcelRequire("gaNY9");

var $iSvIT = parcelRequire("iSvIT");

var $fV0Sg = parcelRequire("fV0Sg");
var $03e20a421a3a6ab5$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $iSvIT.useState)(function() {
        return (0, $fV0Sg.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $gaNY9.default)(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("kqQOc", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $03d6b25f3584340f$export$49e55ae2c03d6045; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $bR74j = parcelRequire("bR74j");
var $03d6b25f3584340f$var$_window, $03d6b25f3584340f$var$_window$matchMedia, $03d6b25f3584340f$var$_window2, $03d6b25f3584340f$var$_window2$matchMedia, $03d6b25f3584340f$var$_window3, $03d6b25f3584340f$var$_window3$matchMedia, $03d6b25f3584340f$var$_window4, $03d6b25f3584340f$var$_window4$matchMedia, $03d6b25f3584340f$var$_window5, $03d6b25f3584340f$var$_window5$matchMedia, $03d6b25f3584340f$var$_window6, $03d6b25f3584340f$var$_window6$matchMedia, $03d6b25f3584340f$var$_window7, $03d6b25f3584340f$var$_window7$matchMedia, $03d6b25f3584340f$var$_window8, $03d6b25f3584340f$var$_window8$matchMedia, $03d6b25f3584340f$var$_window9, $03d6b25f3584340f$var$_window9$matchMedia, $03d6b25f3584340f$var$_window0, $03d6b25f3584340f$var$_window0$matchMedia, $03d6b25f3584340f$var$_window1, $03d6b25f3584340f$var$_window1$matchMedia;
var $03d6b25f3584340f$var$queries = {
    "above.xxs": typeof window === "undefined" ? undefined : ($03d6b25f3584340f$var$_window = window) === null || $03d6b25f3584340f$var$_window === void 0 || ($03d6b25f3584340f$var$_window$matchMedia = $03d6b25f3584340f$var$_window.matchMedia) === null || $03d6b25f3584340f$var$_window$matchMedia === void 0 ? void 0 : $03d6b25f3584340f$var$_window$matchMedia.call($03d6b25f3584340f$var$_window, (0, $bR74j.media).above.xxs.replace("@media ", "").trim()),
    "above.xs": typeof window === "undefined" ? undefined : ($03d6b25f3584340f$var$_window2 = window) === null || $03d6b25f3584340f$var$_window2 === void 0 || ($03d6b25f3584340f$var$_window2$matchMedia = $03d6b25f3584340f$var$_window2.matchMedia) === null || $03d6b25f3584340f$var$_window2$matchMedia === void 0 ? void 0 : $03d6b25f3584340f$var$_window2$matchMedia.call($03d6b25f3584340f$var$_window2, (0, $bR74j.media).above.xs.replace("@media ", "").trim()),
    "above.sm": typeof window === "undefined" ? undefined : ($03d6b25f3584340f$var$_window3 = window) === null || $03d6b25f3584340f$var$_window3 === void 0 || ($03d6b25f3584340f$var$_window3$matchMedia = $03d6b25f3584340f$var$_window3.matchMedia) === null || $03d6b25f3584340f$var$_window3$matchMedia === void 0 ? void 0 : $03d6b25f3584340f$var$_window3$matchMedia.call($03d6b25f3584340f$var$_window3, (0, $bR74j.media).above.sm.replace("@media ", "").trim()),
    "above.md": typeof window === "undefined" ? undefined : ($03d6b25f3584340f$var$_window4 = window) === null || $03d6b25f3584340f$var$_window4 === void 0 || ($03d6b25f3584340f$var$_window4$matchMedia = $03d6b25f3584340f$var$_window4.matchMedia) === null || $03d6b25f3584340f$var$_window4$matchMedia === void 0 ? void 0 : $03d6b25f3584340f$var$_window4$matchMedia.call($03d6b25f3584340f$var$_window4, (0, $bR74j.media).above.md.replace("@media ", "").trim()),
    "above.lg": typeof window === "undefined" ? undefined : ($03d6b25f3584340f$var$_window5 = window) === null || $03d6b25f3584340f$var$_window5 === void 0 || ($03d6b25f3584340f$var$_window5$matchMedia = $03d6b25f3584340f$var$_window5.matchMedia) === null || $03d6b25f3584340f$var$_window5$matchMedia === void 0 ? void 0 : $03d6b25f3584340f$var$_window5$matchMedia.call($03d6b25f3584340f$var$_window5, (0, $bR74j.media).above.lg.replace("@media ", "").trim()),
    "above.xl": typeof window === "undefined" ? undefined : ($03d6b25f3584340f$var$_window6 = window) === null || $03d6b25f3584340f$var$_window6 === void 0 || ($03d6b25f3584340f$var$_window6$matchMedia = $03d6b25f3584340f$var$_window6.matchMedia) === null || $03d6b25f3584340f$var$_window6$matchMedia === void 0 ? void 0 : $03d6b25f3584340f$var$_window6$matchMedia.call($03d6b25f3584340f$var$_window6, (0, $bR74j.media).above.xl.replace("@media ", "").trim()),
    "below.xs": typeof window === "undefined" ? undefined : ($03d6b25f3584340f$var$_window7 = window) === null || $03d6b25f3584340f$var$_window7 === void 0 || ($03d6b25f3584340f$var$_window7$matchMedia = $03d6b25f3584340f$var$_window7.matchMedia) === null || $03d6b25f3584340f$var$_window7$matchMedia === void 0 ? void 0 : $03d6b25f3584340f$var$_window7$matchMedia.call($03d6b25f3584340f$var$_window7, (0, $bR74j.media).below.xs.replace("@media ", "").trim()),
    "below.sm": typeof window === "undefined" ? undefined : ($03d6b25f3584340f$var$_window8 = window) === null || $03d6b25f3584340f$var$_window8 === void 0 || ($03d6b25f3584340f$var$_window8$matchMedia = $03d6b25f3584340f$var$_window8.matchMedia) === null || $03d6b25f3584340f$var$_window8$matchMedia === void 0 ? void 0 : $03d6b25f3584340f$var$_window8$matchMedia.call($03d6b25f3584340f$var$_window8, (0, $bR74j.media).below.sm.replace("@media ", "").trim()),
    "below.md": typeof window === "undefined" ? undefined : ($03d6b25f3584340f$var$_window9 = window) === null || $03d6b25f3584340f$var$_window9 === void 0 || ($03d6b25f3584340f$var$_window9$matchMedia = $03d6b25f3584340f$var$_window9.matchMedia) === null || $03d6b25f3584340f$var$_window9$matchMedia === void 0 ? void 0 : $03d6b25f3584340f$var$_window9$matchMedia.call($03d6b25f3584340f$var$_window9, (0, $bR74j.media).below.md.replace("@media ", "").trim()),
    "below.lg": typeof window === "undefined" ? undefined : ($03d6b25f3584340f$var$_window0 = window) === null || $03d6b25f3584340f$var$_window0 === void 0 || ($03d6b25f3584340f$var$_window0$matchMedia = $03d6b25f3584340f$var$_window0.matchMedia) === null || $03d6b25f3584340f$var$_window0$matchMedia === void 0 ? void 0 : $03d6b25f3584340f$var$_window0$matchMedia.call($03d6b25f3584340f$var$_window0, (0, $bR74j.media).below.lg.replace("@media ", "").trim()),
    "below.xl": typeof window === "undefined" ? undefined : ($03d6b25f3584340f$var$_window1 = window) === null || $03d6b25f3584340f$var$_window1 === void 0 || ($03d6b25f3584340f$var$_window1$matchMedia = $03d6b25f3584340f$var$_window1.matchMedia) === null || $03d6b25f3584340f$var$_window1$matchMedia === void 0 ? void 0 : $03d6b25f3584340f$var$_window1$matchMedia.call($03d6b25f3584340f$var$_window1, (0, $bR74j.media).below.xl.replace("@media ", "").trim())
};
var $03d6b25f3584340f$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $iSvIT.useRef)(listener);
    (0, $iSvIT.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $03d6b25f3584340f$var$queries[queryString];
    (0, $iSvIT.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $2e1kT.bind)(mq, {
            type: "change",
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("bR74j", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $8a1a20a15595f447$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $8a1a20a15595f447$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};

});


parcelRegister("bsDru", function(module, exports) {

$parcel$export(module.exports, "List", function () { return $8580e7a9928f8cc7$export$54c2e3dc7acea9f5; });
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

function $8580e7a9928f8cc7$var$_List(_ref, forwardedRef) {
    var children = _ref.children, testId = _ref.testId, xcss = _ref.xcss;
    return(/*#__PURE__*/ /**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ $iSvIT.createElement("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId
    }, children));
}
var $8580e7a9928f8cc7$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $iSvIT.forwardRef)($8580e7a9928f8cc7$var$_List);

});


parcelRegister("fXAq9", function(module, exports) {

$parcel$export(module.exports, "TopNavStart", function () { return $b9e89e205d8cfbe8$export$4c15269b98c5129; });
/* top-nav-start.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8lTdX = parcelRequire("8lTdX");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $4NsJA = parcelRequire("4NsJA");
var $b9e89e205d8cfbe8$var$styles = {
    root: "_zulp1b66 _yyhykb7n _4t3i1osq _4cvr1h6o _1e0c1txw _glte1ris _15ri1mjv _1gs5usvi"
};
function $b9e89e205d8cfbe8$export$4c15269b98c5129(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var ref = (0, $iSvIT.useContext)((0, $4NsJA.TopNavStartAttachRef));
    var elementRef = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(function() {
        if ((0, $jxLBU.fg)("platform_fix_component_state_update_for_suspense")) ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        ref: (0, $jxLBU.fg)("platform_fix_component_state_update_for_suspense") ? elementRef : ref,
        "data-testid": testId,
        className: (0, $8lTdX.default)([
            $b9e89e205d8cfbe8$var$styles.root
        ])
    }, children);
}

});

parcelRegister("45W3N", function(module, exports) {

$parcel$export(module.exports, "LinkMenuItem", function () { return $2fb4aa97ecdf5003$export$d2cad7a1cce7b35f; });
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");


var $6Qy6S = parcelRequire("6Qy6S");

var $8PgM1 = parcelRequire("8PgM1");

var $gQLF3 = parcelRequire("gQLF3");

var $1Wawh = parcelRequire("1Wawh");

var $ad57L = parcelRequire("ad57L");
var $2fb4aa97ecdf5003$var$listItemStyles = {
    root: "_10m98stt"
};
var $2fb4aa97ecdf5003$var$LinkMenuItemNoRef = function LinkMenuItemNoRef(_ref, forwardedRef) {
    var testId = _ref.testId, actions = _ref.actions, children = _ref.children, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, target = _ref.target, actionsOnHover = _ref.actionsOnHover, isSelected = _ref.isSelected, onClick = _ref.onClick, interactionName = _ref.interactionName, isContentTooltipDisabled = _ref.isContentTooltipDisabled, visualContentRef = _ref.visualContentRef, listItemRef = _ref.listItemRef, isDragging = _ref.isDragging, hasDragIndicator = _ref.hasDragIndicator, dropIndicator = _ref.dropIndicator;
    var itemRef = (0, $iSvIT.useRef)(null);
    (0, $ad57L.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected !== null && isSelected !== void 0 ? isSelected : false
    });
    var ref = (0, $iSvIT.useMemo)(function() {
        return (0, $6Qy6S.default)([
            itemRef,
            listItemRef !== null && listItemRef !== void 0 ? listItemRef : null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ $iSvIT.createElement((0, $gQLF3.ListItem), {
        ref: ref,
        xcss: $2fb4aa97ecdf5003$var$listItemStyles.root
    }, /*#__PURE__*/ $iSvIT.createElement((0, $1Wawh.MenuItemBase), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
};
var $2fb4aa97ecdf5003$export$d2cad7a1cce7b35f = (0, $8PgM1.forwardRefWithGeneric)($2fb4aa97ecdf5003$var$LinkMenuItemNoRef);

});
parcelRegister("gQLF3", function(module, exports) {

$parcel$export(module.exports, "ListItem", function () { return $c446792e915898b1$export$a7b06bfba60a8a78; });
/* list-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

function $c446792e915898b1$var$_ListItem(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, xcss = _ref.xcss;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId
    }, children);
}
var $c446792e915898b1$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $iSvIT.forwardRef)($c446792e915898b1$var$_ListItem);

});

parcelRegister("1Wawh", function(module, exports) {

$parcel$export(module.exports, "MenuItemBase", function () { return $16935e393f5d30ff$export$859b390bf71e044e; });
/* menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eLTr6 = parcelRequire("eLTr6");

var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $8lTdX = parcelRequire("8lTdX");

var $iSvIT = parcelRequire("iSvIT");

var $hHqGT = parcelRequire("hHqGT");

var $7uJIT = parcelRequire("7uJIT");

var $6Qy6S = parcelRequire("6Qy6S");

var $jxLBU = parcelRequire("jxLBU");

var $jSKNZ = parcelRequire("jSKNZ");
var $Nz6G4 = parcelRequire("Nz6G4");
var $9EBzK = parcelRequire("9EBzK");

var $6ePKy = parcelRequire("6ePKy");
var $9nYH6 = parcelRequire("9nYH6");

var $8PgM1 = parcelRequire("8PgM1");

var $4mMEe = parcelRequire("4mMEe");

var $h1Yxi = parcelRequire("h1Yxi");

var $iaFrw = parcelRequire("iaFrw");

var $3j7i2 = parcelRequire("3j7i2");
var $16935e393f5d30ff$var$_excluded = [
    "children",
    "className"
];
function $16935e393f5d30ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16935e393f5d30ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16935e393f5d30ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16935e393f5d30ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

// Using `lazy` so that only consumers who want drag and drop
// need to include code for the drag handle.
var $16935e393f5d30ff$var$LazyDragHandle = /*#__PURE__*/ (0, $iSvIT.lazy)(function() {
    return (parcelRequire("6YQtS"));
});
var $16935e393f5d30ff$var$tooltipStyles = {
    root: "_2rkoglpi _11c8dcr7 _1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7 _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
};
var $16935e393f5d30ff$var$MenuItemTooltip = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function MenuItemTooltip(_ref, ref) {
    var children = _ref.children, className = _ref.className, rest = (0, $fzcGG.default)(_ref, $16935e393f5d30ff$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9nYH6.default), (0, $jRswm.default)({}, rest, {
        // Manually passing on `className` so it gets merged correctly in the build output.
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $8lTdX.default)([
            $16935e393f5d30ff$var$tooltipStyles.root,
            className
        ]),
        ref: ref
    }), children);
});
function $16935e393f5d30ff$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
var $16935e393f5d30ff$var$defaultAvatarValues = {
    size: "small"
};
var $16935e393f5d30ff$var$elemAfterDisplayVar = "--elem-after-display";
// Note: actionsOnHoverDisplayVar wll be cleaned up with fg('platform_dst_nav4_actionsonhover_focus_fix')
var $16935e393f5d30ff$var$actionsOnHoverDisplayVar = "--actions-on-hover-display";
var $16935e393f5d30ff$var$actionsOnHoverOpacityVar = "--actions-on-hover-opacity";
var $16935e393f5d30ff$var$actionsOnHoverWidthVar = "--actions-on-hover-width";
var $16935e393f5d30ff$var$actionsOnHoverPaddingInlineEndVar = "--actions-on-hover-padding";
var $16935e393f5d30ff$var$notchColorVar = "--notch-color";
// Note: this is also used in `drag-handle.tsx`
var $16935e393f5d30ff$var$dragHandleDisplayVar = "--drag-handle-display";
var $16935e393f5d30ff$var$dragCursorAnimation = null;
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ var $16935e393f5d30ff$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ var $16935e393f5d30ff$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
var $16935e393f5d30ff$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
var $16935e393f5d30ff$var$containerStyles = {
    root: "_2rkoglpi _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3iviql _4cvr1h6o _uiztglyw _syaz1gjq _1yyu1j28 _91ju1txw _1swv108i _irr3108i",
    actionsOnHoverFocusFixEnabled: "_uomdidpf _pmxpidpf _db80idpf _qxq9kb7n _1rbv1wug _kwq51b66 _t7p8kb7n _g4kikb7n _91nl1wug _ynyi1wug _iy5o1b66 _v4o21b66",
    actionsOnHoverFocusFixDisabled: "_ek6gglyw _1ojv1txw _1brr1txw _109x1txw",
    removeElemAfter: "_91juglyw",
    showHoverActionsWithFocusFixEnabled: "_uomdkb7n _pmxp1wug _db801b66",
    showHoverActionsWithFocusFixDisabled: "_ek6g1txw",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1djyglyw _1mfcglyw _1sjuglyw",
    selected: "_bfhkfg4m _syazaqb7 _1yyu1fvw _1swvi1yw _30l3aqb7 _irr3i1yw",
    disabled: "_syaz1lh4 _irr3n7od",
    hasDescription: "_4t3i1wto",
    dragging: "_tzy41ou4"
};
var $16935e393f5d30ff$var$buttonOrAnchorStyles = {
    root: "_2rkoglpi _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk1j28 _syaz1gjq _4cvr1h6o _y3gnv2br _14iu1ji5",
    selected: "_syazaqb7 _14iu19ru",
    hasDragIndicator: "_1ifmglyw _1cykglyw _x0kw1txw _11om6b4r _7psyru3m _1uy01amc _bir2q7pw"
};
var $16935e393f5d30ff$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
var $16935e393f5d30ff$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
var $16935e393f5d30ff$var$actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
var $16935e393f5d30ff$var$actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1guo18uv _12s918uv",
    focusFixEnabled: "_1e0c1txw _tzy4pnc3 _1bsbty16 _y4tidria",
    focusFixDisabled: "_1e0c1c3z _y4ti1b66"
};
var $16935e393f5d30ff$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
var $16935e393f5d30ff$var$elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh1ntv _1guo18uv _12s918uv"
};
var $16935e393f5d30ff$var$elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */ var $16935e393f5d30ff$var$interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function $16935e393f5d30ff$var$getTextColor(_ref2) {
    var isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected;
    if (isDisabled) return "color.text.disabled";
    if (isSelected) return "color.text.selected";
    return "color.text.subtle";
}
/**
 * Includes all props that are used by any menu item, as MenuItembase is the base component for all menu item components.
 *
 * We also include additional `aria` props to support the menu item being a trigger for the FlyoutMenuItem popup and for the
 * expanded content for ExpandableMenuItem.
 */ /**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */ var $16935e393f5d30ff$var$MenuItemBaseNoRef = function MenuItemBaseNoRef(_ref3, forwardedRef) {
    var id = _ref3.id, testId = _ref3.testId, actions = _ref3.actions, actionsOnHover = _ref3.actionsOnHover, children = _ref3.children, description = _ref3.description, elemAfter = _ref3.elemAfter, elemBefore = _ref3.elemBefore, href = _ref3.href, target = _ref3.target, isDisabled = _ref3.isDisabled, isSelected = _ref3.isSelected, onClick = _ref3.onClick, ariaControls = _ref3.ariaControls, ariaExpanded = _ref3.ariaExpanded, ariaHasPopup = _ref3.ariaHasPopup, interactionName = _ref3.interactionName, isContentTooltipDisabled = _ref3.isContentTooltipDisabled, visualContentRef = _ref3.visualContentRef, isDragging = _ref3.isDragging, hasDragIndicator = _ref3.hasDragIndicator, dropIndicator = _ref3.dropIndicator;
    var level = (0, $h1Yxi.useLevel)();
    var setFlyoutMenuOpen = (0, $iaFrw.useSetFlyoutMenuOpen)();
    var isFlyoutMenuOpen = (0, $iaFrw.useFlyoutMenuOpen)();
    var isLink = typeof href !== "undefined";
    var labelRef = (0, $iSvIT.useRef)(null);
    var descriptionRef = (0, $iSvIT.useRef)(null);
    var tooltipOnClick = (0, $iSvIT.useRef)(null);
    var handleClick = (0, $iSvIT.useCallback)(function(event, analyticsEvent) {
        var _tooltipOnClick$curre;
        onClick === null || onClick === void 0 || onClick(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        (_tooltipOnClick$curre = tooltipOnClick.current) === null || _tooltipOnClick$curre === void 0 || _tooltipOnClick$curre.call(tooltipOnClick, event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ var canTooltipAppear = (0, $iSvIT.useCallback)(function() {
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        var label = labelRef.current;
        var description = descriptionRef.current;
        if (label && $16935e393f5d30ff$var$isTextClamped(label)) return true;
        return Boolean(description && $16935e393f5d30ff$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    var showElemBefore = elemBefore !== (0, $3j7i2.COLLAPSE_ELEM_BEFORE);
    var interactiveElemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        className: (0, $8lTdX.default)([
            $16935e393f5d30ff$var$interactiveContentStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        // This extends the clickable area of nested menu items to the width
        // of the root level menu items, while being visually indented.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            insetInlineStart: "calc(-1 * ".concat(level, " * ").concat((0, $4mMEe.expandableMenuItemIndentation), ")")
        },
        "aria-hidden": "true",
        className: (0, $8lTdX.default)([
            $16935e393f5d30ff$var$extendButtonOrAnchorStyles.root
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        className: (0, $8lTdX.default)([
            $16935e393f5d30ff$var$textStyles.root,
            !showElemBefore && $16935e393f5d30ff$var$textStyles.noElemBeforeIndent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9EBzK.default), {
        weight: "medium",
        maxLines: 1,
        color: $16935e393f5d30ff$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        ref: labelRef
    }, children), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9EBzK.default), {
        color: isDisabled ? "color.text.disabled" : "color.text.subtle",
        size: "small",
        maxLines: 1,
        ref: descriptionRef
    }, description)), hasDragIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($16935e393f5d30ff$var$LazyDragHandle, null)) : null, dropIndicator);
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ var showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7uJIT.AvatarContext).Provider, {
        value: $16935e393f5d30ff$var$defaultAvatarValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        ref: visualContentRef,
        "data-testid": testId ? "".concat(testId, "-container") : undefined,
        "data-selected": isSelected,
        className: (0, $8lTdX.default)([
            $16935e393f5d30ff$var$containerStyles.root,
            (0, $jxLBU.fg)("platform_dst_nav4_actionsonhover_focus_fix") ? $16935e393f5d30ff$var$containerStyles.actionsOnHoverFocusFixEnabled : $16935e393f5d30ff$var$containerStyles.actionsOnHoverFocusFixDisabled,
            isSelected && $16935e393f5d30ff$var$containerStyles.selected,
            isDragging && $16935e393f5d30ff$var$containerStyles.dragging,
            description && $16935e393f5d30ff$var$containerStyles.hasDescription,
            showHoverActionsWhenNotHovered && !(0, $jxLBU.fg)("platform_dst_nav4_actionsonhover_focus_fix") && $16935e393f5d30ff$var$containerStyles.showHoverActionsWithFocusFixDisabled,
            showHoverActionsWhenNotHovered && (0, $jxLBU.fg)("platform_dst_nav4_actionsonhover_focus_fix") && $16935e393f5d30ff$var$containerStyles.showHoverActionsWithFocusFixEnabled,
            showHoverActionsWhenNotHovered && elemAfter && $16935e393f5d30ff$var$containerStyles.removeElemAfter,
            actionsOnHover && elemAfter && $16935e393f5d30ff$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            isDisabled && $16935e393f5d30ff$var$containerStyles.disabled
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6ePKy.default), {
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", null, children), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", null, description) : null);
        },
        position: "right",
        component: $16935e393f5d30ff$var$MenuItemTooltip,
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true,
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, function(tooltipProps) {
        // Putting the tooltip onClick into a ref.
        // This way we don't need to create a new `onClick` function on each
        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
        tooltipOnClick.current = tooltipProps.onClick;
        var sharedProps = $16935e393f5d30ff$var$_objectSpread($16935e393f5d30ff$var$_objectSpread({}, tooltipProps), {}, {
            "aria-controls": ariaControls,
            "aria-haspopup": ariaHasPopup,
            ref: (0, $6Qy6S.default)([
                forwardedRef,
                tooltipProps.ref
            ]),
            id: id,
            testId: testId,
            interactionName: interactionName
        });
        return isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $jSKNZ.default), (0, $jRswm.default)({}, sharedProps, {
            onClick: handleClick,
            xcss: (0, $hHqGT.cx)($16935e393f5d30ff$var$buttonOrAnchorStyles.root, $16935e393f5d30ff$var$topLevelSiblingStyles.root, isSelected && $16935e393f5d30ff$var$buttonOrAnchorStyles.selected, hasDragIndicator && $16935e393f5d30ff$var$buttonOrAnchorStyles.hasDragIndicator),
            style: {
                textDecoration: "none"
            },
            "aria-current": isSelected ? "page" : undefined,
            href: href,
            target: target,
            draggable: hasDragIndicator ? undefined : false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
            "aria-hidden": "true",
            className: (0, $8lTdX.default)([
                $16935e393f5d30ff$var$notchStyles.root
            ])
        }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $Nz6G4.default), (0, $jRswm.default)({}, sharedProps, {
            onClick: handleClick,
            xcss: (0, $hHqGT.cx)($16935e393f5d30ff$var$buttonOrAnchorStyles.root, $16935e393f5d30ff$var$topLevelSiblingStyles.root, isSelected && $16935e393f5d30ff$var$buttonOrAnchorStyles.selected, hasDragIndicator && $16935e393f5d30ff$var$buttonOrAnchorStyles.hasDragIndicator),
            "aria-expanded": ariaExpanded,
            isDisabled: isDisabled
        }), interactiveElemContent);
    }), showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        className: (0, $8lTdX.default)([
            $16935e393f5d30ff$var$elemBeforeStyles.root,
            $16935e393f5d30ff$var$topLevelSiblingStyles.root,
            $16935e393f5d30ff$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemBefore), actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        className: (0, $8lTdX.default)([
            $16935e393f5d30ff$var$actionsOnHoverStyles.root,
            (0, $jxLBU.fg)("platform_dst_nav4_actionsonhover_focus_fix") ? $16935e393f5d30ff$var$actionsOnHoverStyles.focusFixEnabled : $16935e393f5d30ff$var$actionsOnHoverStyles.focusFixDisabled
        ])
    }, actionsOnHover), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        className: (0, $8lTdX.default)([
            $16935e393f5d30ff$var$elemAfterStyles.root,
            $16935e393f5d30ff$var$topLevelSiblingStyles.root,
            $16935e393f5d30ff$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemAfter), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        className: (0, $8lTdX.default)([
            $16935e393f5d30ff$var$actionStyles.root,
            $16935e393f5d30ff$var$topLevelSiblingStyles.root,
            $16935e393f5d30ff$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, actions)));
};
var $16935e393f5d30ff$export$859b390bf71e044e = (0, $8PgM1.forwardRefWithGeneric)($16935e393f5d30ff$var$MenuItemBaseNoRef);

});
parcelRegister("7uJIT", function(module, exports) {

$parcel$export(module.exports, "AvatarContext", function () { return $574ecd64b61aa477$export$a20dad690e1279e2; });
$parcel$export(module.exports, "useAvatarContext", function () { return $574ecd64b61aa477$export$b50b87a1c4086b23; });
$parcel$export(module.exports, "AvatarContentContext", function () { return $574ecd64b61aa477$export$b983474ddd0b6d28; });
$parcel$export(module.exports, "useAvatarContent", function () { return $574ecd64b61aa477$export$79d078b69b7e4842; });
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", function () { return $574ecd64b61aa477$export$6b4cbd90d24955ad; });
$parcel$export(module.exports, "useEnsureIsInsideAvatar", function () { return $574ecd64b61aa477$export$7db5c57474082dd9; });

var $iSvIT = parcelRequire("iSvIT");
var $574ecd64b61aa477$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $574ecd64b61aa477$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $iSvIT.useContext)($574ecd64b61aa477$export$a20dad690e1279e2);
};
var $574ecd64b61aa477$var$defaultAvatarContentProps = {
    as: "span",
    appearance: "circle",
    avatarImage: null,
    ref: null,
    size: "medium"
};
var $574ecd64b61aa477$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $iSvIT.createContext)($574ecd64b61aa477$var$defaultAvatarContentProps);
var $574ecd64b61aa477$export$79d078b69b7e4842 = function useAvatarContent() {
    return (0, $iSvIT.useContext)($574ecd64b61aa477$export$b983474ddd0b6d28);
};
var $574ecd64b61aa477$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
var $574ecd64b61aa477$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $iSvIT.useContext)($574ecd64b61aa477$export$6b4cbd90d24955ad);
    if (!context) throw new Error("Avatar sub-components must be used within a Avatar component.");
};

});

parcelRegister("4mMEe", function(module, exports) {

$parcel$export(module.exports, "expandableMenuItemIndentation", function () { return $32def3f3273a5194$export$d492445a79a49b48; });
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ var $32def3f3273a5194$export$d492445a79a49b48 = "12px";

});

parcelRegister("h1Yxi", function(module, exports) {

$parcel$export(module.exports, "useLevel", function () { return $c6617ce1cce28ca7$export$fdfe9e5e8183d4f2; });
$parcel$export(module.exports, "useAreAllAncestorsExpanded", function () { return $c6617ce1cce28ca7$export$57108b5f08ae5194; });

var $iSvIT = parcelRequire("iSvIT");

var $jNYFj = parcelRequire("jNYFj");

var $7T1Lv = parcelRequire("7T1Lv");
var $c6617ce1cce28ca7$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
var $c6617ce1cce28ca7$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
var $c6617ce1cce28ca7$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
var $c6617ce1cce28ca7$export$572ce188c913ceba = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
var $c6617ce1cce28ca7$export$650d12d3c2ddb8fc = (0, $7T1Lv.ExpandableMenuItemLevelContext);
var $c6617ce1cce28ca7$export$37e565a09598825e = function useIsExpanded() {
    var context = (0, $iSvIT.useContext)($c6617ce1cce28ca7$export$c856e5885cc34d81);
    (0, $jNYFj.default)(context !== null, "useIsExpanded must be used within an ExpandableMenuItem");
    return context;
};
var $c6617ce1cce28ca7$export$c9a171ea8de5861b = function useSetIsExpanded() {
    var context = (0, $iSvIT.useContext)($c6617ce1cce28ca7$export$48cb11cb8691f597);
    (0, $jNYFj.default)(context !== null, "useSetIsExpanded must be used within an ExpandableMenuItem");
    return context;
};
var $c6617ce1cce28ca7$export$56c8438498b72c7a = function useOnExpansionToggle() {
    return (0, $iSvIT.useContext)($c6617ce1cce28ca7$export$572ce188c913ceba);
};
var $c6617ce1cce28ca7$export$fdfe9e5e8183d4f2 = function useLevel() {
    return (0, $iSvIT.useContext)($c6617ce1cce28ca7$export$650d12d3c2ddb8fc);
};
var $c6617ce1cce28ca7$export$57108b5f08ae5194 = function useAreAllAncestorsExpanded() {
    var _useContext;
    return (_useContext = (0, $iSvIT.useContext)($c6617ce1cce28ca7$export$9c01e0e6a504d553)) !== null && _useContext !== void 0 ? _useContext : true;
};

});
parcelRegister("7T1Lv", function(module, exports) {

$parcel$export(module.exports, "ExpandableMenuItemLevelContext", function () { return $5bdf09ffe5ad3aee$export$f8d6463f9b5ca897; });

var $iSvIT = parcelRequire("iSvIT");
var $5bdf09ffe5ad3aee$export$f8d6463f9b5ca897 = /*#__PURE__*/ (0, $iSvIT.createContext)(0);

});


parcelRegister("iaFrw", function(module, exports) {

$parcel$export(module.exports, "useFlyoutMenuOpen", function () { return $d3a94edad9e8ce8f$export$6927118f874a49aa; });
$parcel$export(module.exports, "useSetFlyoutMenuOpen", function () { return $d3a94edad9e8ce8f$export$538ac1aa421adb94; });

var $iSvIT = parcelRequire("iSvIT");

var $emfh8 = parcelRequire("emfh8");
var $d3a94edad9e8ce8f$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
var $d3a94edad9e8ce8f$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $iSvIT.createContext)((0, $emfh8.default));
var $d3a94edad9e8ce8f$export$6927118f874a49aa = function useFlyoutMenuOpen() {
    return (0, $iSvIT.useContext)($d3a94edad9e8ce8f$export$efa4d9670e96ac31);
};
var $d3a94edad9e8ce8f$export$538ac1aa421adb94 = function useSetFlyoutMenuOpen() {
    return (0, $iSvIT.useContext)($d3a94edad9e8ce8f$export$4c55b1c61a116b42);
};

});

parcelRegister("3j7i2", function(module, exports) {

$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", function () { return $2688cd12efb7d80f$export$f4b8e24fae579c6f; });
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ var $2688cd12efb7d80f$export$f4b8e24fae579c6f = Symbol("collapse-elem-before");

});

parcelRegister("6YQtS", function(module, exports) {


module.exports = (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("9Qbxa")).then(()=>parcelRequire("hakVG"));

});


parcelRegister("ad57L", function(module, exports) {

$parcel$export(module.exports, "useScrollMenuItemIntoView", function () { return $76ef17d7e55ff7e0$export$2c52ec851fcc6058; });

var $iSvIT = parcelRequire("iSvIT");

var $jNYFj = parcelRequire("jNYFj");

var $h1Yxi = parcelRequire("h1Yxi");
function $76ef17d7e55ff7e0$var$scrollMenuItemIntoView(element) {
    var _element$scrollIntoVi;
    /**
   * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
   * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
   * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
   *
   * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
   */ if (typeof element.scrollIntoViewIfNeeded === "function") {
        element.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    (_element$scrollIntoVi = element.scrollIntoView) === null || _element$scrollIntoVi === void 0 || _element$scrollIntoVi.call(element, {
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: "nearest"
    });
}
function $76ef17d7e55ff7e0$export$2c52ec851fcc6058(_ref) {
    var elementRef = _ref.elementRef, isSelected = _ref.isSelected;
    var areAllAncestorsExpanded = (0, $h1Yxi.useAreAllAncestorsExpanded)();
    var waitingStateRef = (0, $iSvIT.useRef)({
        type: "waiting-to-be-selected-and-all-ancestors-expanded"
    });
    (0, $iSvIT.useEffect)(function() {
        if (waitingStateRef.current.type === "waiting-to-be-selected-and-all-ancestors-expanded") {
            var shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            var element = elementRef.current;
            (0, $jNYFj.default)(element, "Element ref must be set");
            $76ef17d7e55ff7e0$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = "waiting-to-be-unselected";
            return;
        }
        if (waitingStateRef.current.type === "waiting-to-be-unselected") {
            if (!isSelected) waitingStateRef.current.type = "waiting-to-be-selected-and-all-ancestors-expanded";
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}

});


parcelRegister("ljksb", function(module, exports) {

$parcel$export(module.exports, "MenuList", function () { return $f83b3cfe10c24159$export$d4c4e98c5044dc8; });

var $bsDru = parcelRequire("bsDru");
var $f83b3cfe10c24159$export$d4c4e98c5044dc8 = (0, $bsDru.List);

});

parcelRegister("etUAM", function(module, exports) {

$parcel$export(module.exports, "AppLogo", function () { return $a8afac2b38ee15af$export$113a612889e1565d; });
/* app-logo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8lTdX = parcelRequire("8lTdX");

var $iSvIT = parcelRequire("iSvIT");

var $hHqGT = parcelRequire("hHqGT");

var $blsV0 = parcelRequire("blsV0");
var $aPYo2 = parcelRequire("aPYo2");
var $cdoKU = parcelRequire("cdoKU");

var $6ePKy = parcelRequire("6ePKy");

var $gSLRZ = parcelRequire("gSLRZ");

var $8ZJIC = parcelRequire("8ZJIC");
var $a8afac2b38ee15af$var$anchorStyles = {
    root: "_2rko19bv _1e0c1txw _4cvr1h6o _4t3izwfg _1o9zidpf _ahbq1b66 _1toh1r31 _5jyqglyw _mrqmnqa1 _1w901kw7",
    interactionStates: "_irr3166n _1di61wwy",
    interactionStatesCustomTheming: "_irr31rps _1di6yhlj"
};
var $a8afac2b38ee15af$var$logoWrapperStyles = {
    root: "_18zr1b66"
};
var $a8afac2b38ee15af$var$iconContainerStyles = {
    root: "_1reo15vq _18m915vq _1e0c1txw _p12f1tcg"
};
var $a8afac2b38ee15af$var$logoTextStyles = {
    root: "_1bsb1ris _p12fnklw _uiztglyw _y4tiv77o _1e0cglyw _10y418uv"
};
function $a8afac2b38ee15af$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
var $a8afac2b38ee15af$export$113a612889e1565d = function AppLogo(_ref) {
    var name = _ref.name, label = _ref.label, href = _ref.href, icon = _ref.icon, onClick = _ref.onClick;
    var ref = (0, $iSvIT.useRef)(null);
    var nameRef = (0, $iSvIT.useRef)(null);
    var hasCustomTheme = (0, $gSLRZ.useHasCustomTheme)();
    /**
   * Show the tooltip if the name is truncated
   */ var canTooltipAppear = (0, $iSvIT.useCallback)(function() {
        var text = nameRef.current;
        return Boolean(text && $a8afac2b38ee15af$var$isTextClamped(text));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $blsV0.default), {
        ref: ref,
        "aria-label": label,
        href: href,
        xcss: (0, $hHqGT.cx)($a8afac2b38ee15af$var$anchorStyles.root, hasCustomTheme ? $a8afac2b38ee15af$var$anchorStyles.interactionStatesCustomTheming : $a8afac2b38ee15af$var$anchorStyles.interactionStates),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $aPYo2.default), {
        space: "space.075",
        alignBlock: "center",
        xcss: $a8afac2b38ee15af$var$logoWrapperStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        className: (0, $8lTdX.default)([
            $a8afac2b38ee15af$var$iconContainerStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8ZJIC.LogoRenderer), {
        shouldUseNewLogoDesign: true,
        logoOrIcon: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $8lTdX.default)([
            $a8afac2b38ee15af$var$logoTextStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6ePKy.default), {
        content: name,
        position: "bottom",
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true,
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, function(tooltipProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $cdoKU.default), {
            "aria-hidden": true,
            color: "inherit",
            weight: "semibold",
            maxLines: 1,
            ref: nameRef
        }, name));
    }))));
};

});
parcelRegister("aPYo2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e3d8258e5c86686$export$2e2bcd8739ae039; });

var $lcRu8 = parcelRequire("lcRu8");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $hQJLC = parcelRequire("hQJLC");

var $9NU0t = parcelRequire("9NU0t");
var $7e3d8258e5c86686$var$flexGrowMap = {
    hug: (0, $hQJLC.xcss)({
        flexGrow: 0
    }),
    fill: (0, $hQJLC.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $7e3d8258e5c86686$var$separatorStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $7e3d8258e5c86686$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $2ZUkg.jsx)("span", {
        css: $7e3d8258e5c86686$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $7e3d8258e5c86686$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $2ZUkg.jsx)($7e3d8258e5c86686$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $7e3d8258e5c86686$var$flexGrowMap[grow]
    ].concat((0, $lcRu8.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $2ZUkg.jsx)((0, $9NU0t.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$7e3d8258e5c86686$var$Inline.displayName = "Inline";
var $7e3d8258e5c86686$export$2e2bcd8739ae039 = $7e3d8258e5c86686$var$Inline;

});
parcelRegister("9NU0t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72342269da629711$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $amV2N = parcelRequire("amV2N");

var $hQJLC = parcelRequire("hQJLC");
var $72342269da629711$var$justifyContentMap = {
    start: (0, $2ZUkg.css)({
        justifyContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyContent: "stretch"
    })
};
var $72342269da629711$var$flexDirectionMap = {
    column: (0, $2ZUkg.css)({
        flexDirection: "column"
    }),
    row: (0, $2ZUkg.css)({
        flexDirection: "row"
    })
};
var $72342269da629711$var$flexWrapMap = {
    wrap: (0, $2ZUkg.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $2ZUkg.css)({
        flexWrap: "nowrap"
    })
};
var $72342269da629711$var$alignItemsMap = {
    start: (0, $2ZUkg.css)({
        alignItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignItems: "center"
    }),
    baseline: (0, $2ZUkg.css)({
        alignItems: "baseline"
    }),
    end: (0, $2ZUkg.css)({
        alignItems: "end"
    }),
    stretch: (0, $2ZUkg.css)({
        alignItems: "stretch"
    })
};
var $72342269da629711$var$baseStyles = (0, $2ZUkg.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $72342269da629711$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $hQJLC.parseXcss)(xcss);
    return (0, $2ZUkg.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $72342269da629711$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $amV2N.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $amV2N.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $amV2N.spaceStylesMap).rowGap[rowGap],
            alignItems && $72342269da629711$var$alignItemsMap[alignItems],
            direction && $72342269da629711$var$flexDirectionMap[direction],
            justifyContent && $72342269da629711$var$justifyContentMap[justifyContent],
            wrap && $72342269da629711$var$flexWrapMap[wrap],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$72342269da629711$var$Flex.displayName = "Flex";
var $72342269da629711$export$2e2bcd8739ae039 = $72342269da629711$var$Flex;

});


parcelRegister("cdoKU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e49e6e2f05ecb21$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jNYFj = parcelRequire("jNYFj");

var $7Jyon = parcelRequire("7Jyon");

var $39nwL = parcelRequire("39nwL");

var $amV2N = parcelRequire("amV2N");
var $8e49e6e2f05ecb21$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $8e49e6e2f05ecb21$var$resetStyles = (0, $2ZUkg.css)({
    margin: 0,
    overflowWrap: "anywhere"
});
var $8e49e6e2f05ecb21$var$strongStyles = (0, $2ZUkg.css)({
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
var $8e49e6e2f05ecb21$var$emStyles = (0, $2ZUkg.css)({
    fontStyle: "italic"
});
var $8e49e6e2f05ecb21$var$textAlignMap = {
    center: (0, $2ZUkg.css)({
        textAlign: "center"
    }),
    end: (0, $2ZUkg.css)({
        textAlign: "end"
    }),
    start: (0, $2ZUkg.css)({
        textAlign: "start"
    })
};
var $8e49e6e2f05ecb21$var$truncationStyles = (0, $2ZUkg.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $8e49e6e2f05ecb21$var$wordBreakMap = {
    breakAll: (0, $2ZUkg.css)({
        wordBreak: "break-all"
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $8e49e6e2f05ecb21$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $39nwL.useSurface)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $amV2N.inverseColorMap).hasOwnProperty(surface)) return (0, $amV2N.inverseColorMap)[surface];
    return "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $8e49e6e2f05ecb21$var$Text = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $jNYFj.default)($8e49e6e2f05ecb21$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $7Jyon.useHasTextAncestor)();
    var color = $8e49e6e2f05ecb21$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = (0, $2ZUkg.jsx)(Component, {
        ref: ref,
        css: [
            $8e49e6e2f05ecb21$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $amV2N.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $amV2N.textColorStylesMap)[color],
            maxLines && $8e49e6e2f05ecb21$var$truncationStyles,
            maxLines === 1 && $8e49e6e2f05ecb21$var$wordBreakMap.breakAll,
            align && $8e49e6e2f05ecb21$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $amV2N.textWeightStylesMap)[weight],
            Component === "em" && $8e49e6e2f05ecb21$var$emStyles,
            Component === "strong" && $8e49e6e2f05ecb21$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $2ZUkg.jsx)((0, $7Jyon.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $8e49e6e2f05ecb21$export$2e2bcd8739ae039 = $8e49e6e2f05ecb21$var$Text;

});


parcelRegister("gL1Hw", function(module, exports) {

$parcel$export(module.exports, "AIChatWidget", function () { return (parcelRequire("e1z14")).AIChatWidget; });

var $e1z14 = parcelRequire("e1z14");

});
parcelRegister("e1z14", function(module, exports) {

$parcel$export(module.exports, "AIChatWidget", function () { return $076d53e4152bd9d1$export$10ed193107df4e03; });

var $iSvIT = parcelRequire("iSvIT");
const $076d53e4152bd9d1$var$WIDGET_CONTAINER_SELECTOR = "#atlassian-conversation-assistant-widget";
const $076d53e4152bd9d1$var$CHAT_WIDGET_LOADER_SCRIPT_URL = "https://jcs-chat-widget.atlassian.com/assets/loader.js";
const $076d53e4152bd9d1$var$CHAT_WIDGET_SCRIPT_ID = "ai-chat-widget-loader";
const $076d53e4152bd9d1$export$10ed193107df4e03 = ()=>{
    (0, $iSvIT.useEffect)(()=>{
        // Add SSR guards
        if (typeof window === "undefined" || typeof document === "undefined") return;
        const loadScript = (url)=>{
            const script = document.createElement("script");
            script.src = url;
            script.defer = true;
            script.id = $076d53e4152bd9d1$var$CHAT_WIDGET_SCRIPT_ID;
            document.body.append(script);
        };
        const checkAndLoadWidget = ()=>{
            try {
                const widget = document.querySelector($076d53e4152bd9d1$var$WIDGET_CONTAINER_SELECTOR);
                const existingScript = document.querySelector(`script[src="${$076d53e4152bd9d1$var$CHAT_WIDGET_LOADER_SCRIPT_URL}"], script#${$076d53e4152bd9d1$var$CHAT_WIDGET_SCRIPT_ID}`);
                if (!widget && !existingScript) loadScript($076d53e4152bd9d1$var$CHAT_WIDGET_LOADER_SCRIPT_URL);
            } catch (error) {
                console.error("Error checking and loading widget", error);
            }
        };
        checkAndLoadWidget();
    }, []);
    return null;
};

});


parcelRegister("4XYQf", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollector", function () { return (parcelRequire("dB3mG")).FeedbackCollector; });

var $dB3mG = parcelRequire("dB3mG");

});
parcelRegister("dB3mG", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollector", function () { return $30a9529e07a0932b$export$fa63c8dd87ea8148; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $5XkWH = parcelRequire("5XkWH");

var $fJ5Su = parcelRequire("fJ5Su");

var $jKp9A = parcelRequire("jKp9A");

var $adqfu = parcelRequire("adqfu");

var $ikouU = parcelRequire("ikouU");
parcelRequire("elrWR");
var $hgmFX = parcelRequire("hgmFX");
parcelRequire("hRDFa");
var $6BFI3 = parcelRequire("6BFI3");
const $30a9529e07a0932b$export$fa63c8dd87ea8148 = ()=>{
    const ref = (0, $iSvIT.useRef)(null);
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { showFlag: showFlag } = (0, $iSvIT.useContext)((0, $adqfu.default).Context);
    const handleClose = ()=>setIsOpen(false);
    const { sendFeedbackCollectorOpenButtonClickUIEvent: sendFeedbackCollectorOpenButtonClickUIEvent, sendFeedbackCollectorSubmitButtonClickUIEvent: sendFeedbackCollectorSubmitButtonClickUIEvent } = (0, $6BFI3.useFeedbackCollectorAnalytics)();
    const handleOpen = ()=>{
        setIsOpen(true);
        sendFeedbackCollectorOpenButtonClickUIEvent();
    };
    const handleSubmit = (formFields)=>{
        setIsOpen(false);
        showFlag({
            autoDismiss: true,
            iconType: "success",
            title: formatMessage((0, $ikouU.messages).feedbackSubmittedTitle),
            description: formatMessage((0, $ikouU.messages).feedbackSubmittedDescription),
            id: "feedback-submitted-flag"
        });
        sendFeedbackCollectorSubmitButtonClickUIEvent(formFields.type);
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jKp9A.default), {
        id: "fastshift-feedback-collector",
        testId: "fastshift-feedback-collector",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5XkWH.default), {
                appearance: "subtle",
                label: formatMessage((0, $ikouU.messages).iconButtonLabel),
                onClick: handleOpen,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($fJ5Su))),
                ref: ref
            }),
            isOpen && /*#__PURE__*/ (0, $loA2J.jsx)((0, $hgmFX.FeedbackCollectorModal), {
                onClose: handleClose,
                onSubmit: handleSubmit,
                shouldReturnFocusRef: ref
            })
        ]
    });
};

});
parcelRegister("ikouU", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $a8a0f1cf5ad9f4e1$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $a8a0f1cf5ad9f4e1$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    feedbackSubmittedTitle: {
        id: "fastshift.feedback-collector.feedback-submitted-title",
        defaultMessage: "Thanks!",
        description: "Title for the feedback submitted flag"
    },
    feedbackSubmittedDescription: {
        id: "fastshift.feedback-collector.feedback-submitted-description",
        defaultMessage: "Your valuable feedback helps us continually improve our products.",
        description: "Description for the feedback submitted flag"
    },
    iconButtonLabel: {
        id: "fastshift.feedback-collector.icon-button-label",
        defaultMessage: "open customer feedback collector",
        description: "Label for the icon button"
    }
});

});

parcelRegister("elrWR", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorModal", function () { return (parcelRequire("hgmFX")).FeedbackCollectorModal; });

var $hgmFX = parcelRequire("hgmFX");

});
parcelRegister("hgmFX", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorModal", function () { return $6622d91012383ad6$export$21ca6c649ed55a5a; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $asQ9z = parcelRequire("asQ9z");

var $gkhN4 = parcelRequire("gkhN4");

var $5wOn9 = parcelRequire("5wOn9");

var $hdt5D = parcelRequire("hdt5D");
const $6622d91012383ad6$var$ENTRYPOINT_ID = "b06cac34-19fe-4a8a-bbf7-085cd5fd3d0c";
const $6622d91012383ad6$export$21ca6c649ed55a5a = ({ onClose: onClose, onSubmit: onSubmit, shouldReturnFocusRef: shouldReturnFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const userInfo = (0, $5wOn9.useLoggedInUser)();
    const stargateBaseUrl = (0, $gkhN4.getStargateBaseUrl)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $asQ9z.default), {
        locale: "en",
        customGatewayUrl: stargateBaseUrl,
        customFeedbackUrl: `${stargateBaseUrl}/feedback-collector-api`,
        atlassianAccountId: userInfo.accountId,
        email: userInfo.email,
        name: userInfo.name,
        shouldGetEntitlementDetails: false,
        entrypointId: $6622d91012383ad6$var$ENTRYPOINT_ID,
        onClose: onClose,
        onSubmit: (formFields)=>onSubmit(formFields),
        shouldReturnFocusRef: shouldReturnFocusRef,
        feedbackTitle: formatMessage((0, $hdt5D.messages).feedbackTitle),
        feedbackTitleDetails: formatMessage((0, $hdt5D.messages).feedbackTitleDetails)
    });
};

});
parcelRegister("asQ9z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79e4f97938e92534$export$2e2bcd8739ae039; });


var $f5OLO = parcelRequire("f5OLO");


var $79e4f97938e92534$export$2e2bcd8739ae039 = (0, $f5OLO.default);

});
parcelRegister("f5OLO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afceb490c9f13a49$export$2e2bcd8739ae039; });

var $5VbRa = parcelRequire("5VbRa");

var $d5B2s = parcelRequire("d5B2s");

var $4FQw5 = parcelRequire("4FQw5");

var $6ji6y = parcelRequire("6ji6y");

var $ehCmD = parcelRequire("ehCmD");

var $cMQbY = parcelRequire("cMQbY");

var $lTcQE = parcelRequire("lTcQE");

var $llkr9 = parcelRequire("llkr9");

var $fACfu = parcelRequire("fACfu");

var $4QZRY = parcelRequire("4QZRY");

var $jjovn = parcelRequire("jjovn");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $axHYa = parcelRequire("axHYa");

var $aCMxT = parcelRequire("aCMxT");

var $ljK9M = parcelRequire("ljK9M");
function $afceb490c9f13a49$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $afceb490c9f13a49$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $afceb490c9f13a49$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $afceb490c9f13a49$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $afceb490c9f13a49$var$_callSuper(t, o, e) {
    return o = (0, $lTcQE.default)(o), (0, $cMQbY.default)(t, $afceb490c9f13a49$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $lTcQE.default)(t).constructor) : o.apply(t, e));
}
function $afceb490c9f13a49$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($afceb490c9f13a49$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $afceb490c9f13a49$var$MAX_SUMMARY_LENGTH_CHARS = 100;
var $afceb490c9f13a49$var$singleLineTruncatedText = function singleLineTruncatedText(text) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $afceb490c9f13a49$var$MAX_SUMMARY_LENGTH_CHARS;
    var singleLineText = text.replace(/\n/g, " ");
    return (0, $aCMxT.default)(singleLineText, length);
};
var $afceb490c9f13a49$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    function FeedbackCollector() {
        var _this;
        (0, $6ji6y.default)(this, FeedbackCollector);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $afceb490c9f13a49$var$_callSuper(this, FeedbackCollector, [].concat(args));
        (0, $fACfu.default)(_this, "state", {
            anonymousFeedback: true
        });
        (0, $fACfu.default)(_this, "postFeedback", /*#__PURE__*/ function() {
            var _ref = (0, $4FQw5.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).mark(function _callee(formValues) {
                var entrypointId, fetchUrl, formData, body, postData;
                return (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            entrypointId = _this.props.entrypointId;
                            fetchUrl = _this.getFeedbackUrl(); // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
                            if (!entrypointId) {
                                _context.next = 10;
                                break;
                            }
                            _context.next = 5;
                            return _this.mapFormToJSD(formValues);
                        case 5:
                            formData = _context.sent;
                            body = {
                                feedback: $afceb490c9f13a49$var$_objectSpread({
                                    entrypointId: _this.props.entrypointId,
                                    entrypointUiVersion: _this.getPackageVersion()
                                }, formData)
                            };
                            if ((0, $axHYa.isApiGatewayUrl)(fetchUrl)) fetchUrl += "/feedback-collector-api";
                            else if (!_this.props.customFeedbackUrl) fetchUrl = "https://feedback-collector-api.services.atlassian.com";
                            postData = (0, $jjovn.Buffer).from(JSON.stringify(body)).toString("base64");
                            fetch("".concat(fetchUrl, "/v2/feedback"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    data: postData
                                }),
                                credentials: "include"
                            });
                        case 10:
                            _this.props.onClose();
                            // slightly delay confirming submit since we don't wait for the REST call to succeed
                            //
                            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
                            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
                            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
                            //
                            setTimeout(function() {
                                return _this.props.onSubmit(formValues);
                            }, _this.props.timeoutOnSubmit);
                        case 12:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref.apply(this, arguments);
            };
        }());
        return _this;
    }
    (0, $llkr9.default)(FeedbackCollector, _Component);
    return (0, $ehCmD.default)(FeedbackCollector, [
        {
            key: "componentDidMount",
            value: function() {
                var _componentDidMount = (0, $4FQw5.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).mark(function _callee2() {
                    var anonymousFeedback;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.shouldShowOptInCheckboxesNew();
                            case 2:
                                anonymousFeedback = !_context2.sent;
                                this.setState({
                                    anonymousFeedback: anonymousFeedback
                                });
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function componentDidMount() {
                    return _componentDidMount.apply(this, arguments);
                }
                return componentDidMount;
            }()
        },
        {
            key: "getGatewayUrl",
            value: function getGatewayUrl() {
                var _this$props = this.props, customGatewayUrl = _this$props.customGatewayUrl, url = _this$props.url;
                if (customGatewayUrl) return customGatewayUrl;
                if (url) return url;
                return FeedbackCollector.defaultProps.url;
            }
        },
        {
            key: "getFeedbackUrl",
            value: function getFeedbackUrl() {
                var _this$props2 = this.props, customFeedbackUrl = _this$props2.customFeedbackUrl, url = _this$props2.url;
                if (customFeedbackUrl) return customFeedbackUrl;
                if (url) return url;
                return FeedbackCollector.defaultProps.url;
            }
        },
        {
            key: "getPackageVersion",
            value: function getPackageVersion() {
                return "0.0.0-development";
            }
        },
        {
            key: "getEntitlementInformation",
            value: function() {
                var _getEntitlementInformation = (0, $4FQw5.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).mark(function _callee3() {
                    var _entitlementDetails, _entitlementDetails2, _productName, _entitlement;
                    var url, productName, productEntitlement, entitlementDetails, productKey, _document$querySelect, hasPremium, entitlement, entitlementInformation, cloudSiteId, _entitlementDetails3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                url = this.getGatewayUrl(); // jira / confluence / bitbucket / trello
                                if (!window.location.host.includes("bitbucket.org")) {
                                    _context3.next = 9;
                                    break;
                                }
                                productName = "Bitbucket";
                                productKey = "bitbucket";
                                entitlementDetails = JSON.parse(JSON.stringify((_document$querySelect = document.querySelector('meta[id="bb-bootstrap"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute("data-current-user")));
                                hasPremium = entitlementDetails["hasPremium"];
                                productEntitlement = hasPremium ? "PREMIUM" : "STANDARD";
                                _context3.next = 24;
                                break;
                            case 9:
                                if (![
                                    "trellis.coffee",
                                    "trello.com"
                                ].includes(window.location.host)) {
                                    _context3.next = 14;
                                    break;
                                }
                                productName = "Trello";
                                productKey = "trello";
                                _context3.next = 24;
                                break;
                            case 14:
                                if (document.querySelector('meta[id="confluence-context-path"]')) {
                                    productName = "Confluence";
                                    productKey = "pricingplan.confluence.ondemand";
                                } else {
                                    productName = "Jira";
                                    productKey = "jira-software.ondemand";
                                }
                                _context3.prev = 15;
                                _context3.next = 18;
                                return fetch("".concat(url, "/customer-context/entitlements/").concat(window.location.host), $afceb490c9f13a49$var$_objectSpread({
                                    method: "GET",
                                    headers: {
                                        "Content-Type": "application/json"
                                    }
                                }, (0, $axHYa.isApiGatewayUrl)(url) ? {
                                    credentials: "include"
                                } : {}));
                            case 18:
                                entitlementDetails = _context3.sent;
                                _context3.next = 24;
                                break;
                            case 21:
                                _context3.prev = 21;
                                _context3.t0 = _context3["catch"](15);
                                entitlementDetails = undefined;
                            case 24:
                                entitlementInformation = [];
                                cloudSiteId = ((_entitlementDetails = entitlementDetails) === null || _entitlementDetails === void 0 ? void 0 : _entitlementDetails.cloudSiteId) || "";
                                if ((_entitlementDetails2 = entitlementDetails) !== null && _entitlementDetails2 !== void 0 && _entitlementDetails2.children) entitlement = (_entitlementDetails3 = entitlementDetails) === null || _entitlementDetails3 === void 0 ? void 0 : _entitlementDetails3.children.find(function(entitlement) {
                                    return entitlement.key === productKey;
                                });
                                entitlementInformation.push({
                                    id: "product",
                                    value: productName ? (_productName = productName) === null || _productName === void 0 ? void 0 : _productName.toLowerCase() : ""
                                }, {
                                    id: "hostingType",
                                    value: (_entitlement = entitlement) !== null && _entitlement !== void 0 && _entitlement.product ? entitlement.product.hostingType : "CLOUD"
                                }, {
                                    id: "entitlementEdition",
                                    value: productEntitlement !== null && productEntitlement !== void 0 ? productEntitlement : ""
                                }, {
                                    id: "cloudId",
                                    value: cloudSiteId
                                });
                                return _context3.abrupt("return", entitlementInformation);
                            case 29:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this, [
                        [
                            15,
                            21
                        ]
                    ]);
                }));
                function getEntitlementInformation() {
                    return _getEntitlementInformation.apply(this, arguments);
                }
                return getEntitlementInformation;
            }()
        },
        {
            key: "getTypeFieldValue",
            value: function getTypeFieldValue(dtype) {
                switch(dtype){
                    case "bug":
                        return this.props.typeBugDefaultValue;
                    case "comment":
                        return this.props.typeCommentDefaultValue;
                    case "suggestion":
                        return this.props.typeSuggestionDefaultValue;
                    case "question":
                        return this.props.typeQuestionDefaultValue;
                    case "empty":
                    default:
                        return this.props.typeEmptyDefaultValue;
                }
            }
        },
        {
            key: "getAtlassianID",
            value: function() {
                var _getAtlassianID = (0, $4FQw5.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).mark(function _callee4() {
                    var _this$props3, atlassianAccountId, shouldGetEntitlementDetails, url, result, json;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _this$props3 = this.props, atlassianAccountId = _this$props3.atlassianAccountId, shouldGetEntitlementDetails = _this$props3.shouldGetEntitlementDetails;
                                _context4.prev = 1;
                                if (!(atlassianAccountId || !shouldGetEntitlementDetails)) {
                                    _context4.next = 4;
                                    break;
                                }
                                return _context4.abrupt("return", atlassianAccountId);
                            case 4:
                                url = this.getGatewayUrl();
                                _context4.next = 7;
                                return fetch("".concat(url, "/me"), $afceb490c9f13a49$var$_objectSpread({
                                    method: "GET",
                                    headers: {
                                        "Content-Type": "application/json"
                                    }
                                }, (0, $axHYa.isApiGatewayUrl)(url) ? {
                                    credentials: "include"
                                } : {}));
                            case 7:
                                result = _context4.sent;
                                _context4.next = 10;
                                return result.json();
                            case 10:
                                json = _context4.sent;
                                return _context4.abrupt("return", json.account_id);
                            case 14:
                                _context4.prev = 14;
                                _context4.t0 = _context4["catch"](1);
                                return _context4.abrupt("return", undefined);
                            case 17:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this, [
                        [
                            1,
                            14
                        ]
                    ]);
                }));
                function getAtlassianID() {
                    return _getAtlassianID.apply(this, arguments);
                }
                return getAtlassianID;
            }()
        },
        {
            key: "shouldShowOptInCheckboxes",
            value: function shouldShowOptInCheckboxes() {
                if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
                if (this.props.atlassianAccountId) return true;
                var response;
                this.getAtlassianID().then(function(result) {
                    response = result !== undefined;
                }).catch(function() {
                    response = false;
                });
                // @ts-ignore
                return response;
            }
        },
        {
            key: "shouldShowOptInCheckboxesNew",
            value: function shouldShowOptInCheckboxesNew() {
                var _this2 = this;
                return new Promise(function(resolve) {
                    if (_this2.props.anonymousFeedback) resolve(!_this2.props.anonymousFeedback);
                    if (_this2.props.atlassianAccountId) resolve(true);
                    _this2.getAtlassianID().then(function(result) {
                        resolve(result !== undefined);
                    }).catch(function() {
                        resolve(false);
                    });
                });
            }
        },
        {
            key: "getDescription",
            value: function getDescription(formValues) {
                return formValues.description || this.props.descriptionDefaultValue;
            }
        },
        {
            key: "getSummary",
            value: function getSummary(formValues) {
                return $afceb490c9f13a49$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
            }
        },
        {
            key: "getCustomerName",
            value: function getCustomerName() {
                var _this$props$name;
                return (_this$props$name = this.props.name) !== null && _this$props$name !== void 0 ? _this$props$name : this.props.customerNameDefaultValue;
            }
        },
        {
            key: "addEmailToContext",
            value: function addEmailToContext() {
                var contextField = this.props.additionalFields.find(function(field) {
                    return field.id === "customfield_10047";
                });
                if (contextField) contextField.value = "".concat(contextField.value, "\n        email: ").concat(this.props.email);
                else this.props.additionalFields.push({
                    id: "customfield_10047",
                    value: "email: ".concat(this.props.email)
                });
            }
        },
        {
            key: "addAccountIdToContext",
            value: function addAccountIdToContext(atlassianID) {
                if (atlassianID) {
                    var contextField = this.props.additionalFields.find(function(field) {
                        return field.id === "customfield_10047";
                    });
                    if (contextField) contextField.value = "".concat(contextField.value, "\n			atlassian-account-id: ").concat(atlassianID);
                }
            }
        },
        {
            key: "mapFormToJSD",
            value: function() {
                var _mapFormToJSD = (0, $4FQw5.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).mark(function _callee5(formValues) {
                    var _this$props4, _this$props5;
                    var entitlementInformation, atlassianID;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                entitlementInformation = null;
                                if (!((_this$props4 = this.props) !== null && _this$props4 !== void 0 && _this$props4.shouldGetEntitlementDetails)) {
                                    _context5.next = 5;
                                    break;
                                }
                                _context5.next = 4;
                                return this.getEntitlementInformation();
                            case 4:
                                entitlementInformation = _context5.sent;
                            case 5:
                                if ((_this$props5 = this.props) !== null && _this$props5 !== void 0 && _this$props5.email) this.addEmailToContext();
                                _context5.next = 8;
                                return this.getAtlassianID();
                            case 8:
                                atlassianID = _context5.sent;
                                this.addAccountIdToContext(atlassianID);
                                return _context5.abrupt("return", {
                                    fields: [].concat((0, $d5B2s.default)(entitlementInformation !== null && entitlementInformation || []), [
                                        this.props.showTypeField ? {
                                            id: this.props.typeFieldId,
                                            value: this.getTypeFieldValue(formValues.type)
                                        } : undefined,
                                        {
                                            id: this.props.summaryFieldId,
                                            value: this.getSummary(formValues)
                                        },
                                        {
                                            id: this.props.descriptionFieldId,
                                            value: this.getDescription(formValues)
                                        },
                                        {
                                            id: "aaidOrHash",
                                            value: formValues.canBeContacted ? atlassianID : undefined
                                        },
                                        {
                                            id: this.props.customerNameFieldId,
                                            value: this.getCustomerName()
                                        },
                                        formValues.canBeContacted ? {
                                            id: this.props.canBeContactedFieldId,
                                            value: this.props.canBeContactedAgreeValue
                                        } : {
                                            id: this.props.canBeContactedFieldId,
                                            value: this.props.canBeContactedDeclineValue
                                        },
                                        formValues.enrollInResearchGroup ? {
                                            id: this.props.enrollInResearchFieldId,
                                            value: this.props.enrollInResearchAgreeValue
                                        } : {
                                            id: this.props.enrollInResearchFieldId,
                                            value: this.props.enrollInResearchDeclineValue
                                        }
                                    ], (0, $d5B2s.default)(this.props.additionalFields)).filter(Boolean)
                                });
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function mapFormToJSD(_x2) {
                    return _mapFormToJSD.apply(this, arguments);
                }
                return mapFormToJSD;
            }()
        },
        {
            key: "render",
            value: function render() {
                var anonymousFeedback = !this.shouldShowOptInCheckboxes();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ljK9M.default), (0, $5VbRa.default)({
                    customContent: this.props.customContent,
                    feedbackTitle: this.props.feedbackTitle,
                    feedbackTitleDetails: this.props.feedbackTitleDetails,
                    showTypeField: this.props.showTypeField,
                    showDefaultTextFields: this.props.showDefaultTextFields,
                    hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
                    canBeContactedLabel: this.props.canBeContactedLabel,
                    enrolInResearchLabel: this.props.enrolInResearchLabel,
                    summaryPlaceholder: this.props.summaryPlaceholder,
                    submitButtonLabel: this.props.submitButtonLabel,
                    cancelButtonLabel: this.props.cancelButtonLabel,
                    feedbackGroupLabels: this.props.feedbackGroupLabels,
                    onSubmit: this.postFeedback,
                    onClose: this.props.onClose,
                    locale: this.props.locale,
                    anonymousFeedback: (0, $jxLBU.fg)("platform.proforma-form-builder-feedback_hupaz") ? this.state.anonymousFeedback : anonymousFeedback,
                    selectLabel: this.props.selectLabel,
                    customTextAreaLabel: this.props.customTextAreaLabel,
                    customFeedbackOptions: this.props.customFeedbackOptions,
                    shouldReturnFocusRef: this.props.shouldReturnFocusRef,
                    disableSubmitButton: this.props.disableSubmitButton
                }, (0, $jxLBU.fg)("jfp_a11y_team_feedback_collector_nested_elements") && {
                    enrolInResearchLink: this.props.enrolInResearchLink,
                    canBeContactedLink: this.props.canBeContactedLink
                }));
            }
        }
    ]);
}((0, $iSvIT.Component));
(0, $fACfu.default)($afceb490c9f13a49$export$2e2bcd8739ae039, "defaultProps", {
    locale: "en",
    url: "/gateway/api",
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: "customfield_10043",
    canBeContactedAgreeValue: [
        {
            id: "10109"
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: "10111"
        }
    ],
    additionalFields: [],
    customerNameFieldId: "customfield_10045",
    customerNameDefaultValue: "unknown",
    descriptionFieldId: "description",
    descriptionDefaultValue: "",
    enrollInResearchFieldId: "customfield_10044",
    enrollInResearchAgreeValue: [
        {
            id: "10110"
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: "10112"
        }
    ],
    summaryFieldId: "summary",
    summaryDefaultValue: "",
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: "customfield_10042",
    typeBugDefaultValue: {
        id: "10105"
    },
    typeCommentDefaultValue: {
        id: "10106"
    },
    typeSuggestionDefaultValue: {
        id: "10107"
    },
    typeQuestionDefaultValue: {
        id: "10108"
    },
    typeEmptyDefaultValue: {
        id: "empty"
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: function onClose() {},
    onSubmit: function onSubmit() {}
});

});
parcelRegister("5VbRa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44fb7913eaa12dcf$export$2e2bcd8739ae039; });
function $44fb7913eaa12dcf$export$2e2bcd8739ae039() {
    return $44fb7913eaa12dcf$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $44fb7913eaa12dcf$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("d5B2s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98787914fbbe23d6$export$2e2bcd8739ae039; });

var $kOu4B = parcelRequire("kOu4B");

var $7kSqN = parcelRequire("7kSqN");

var $264k1 = parcelRequire("264k1");

var $alFqZ = parcelRequire("alFqZ");
function $98787914fbbe23d6$export$2e2bcd8739ae039(r) {
    return (0, $kOu4B.default)(r) || (0, $7kSqN.default)(r) || (0, $264k1.default)(r) || (0, $alFqZ.default)();
}

});
parcelRegister("kOu4B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f26fce134f2f3b0a$export$2e2bcd8739ae039; });

var $hpoCq = parcelRequire("hpoCq");
function $f26fce134f2f3b0a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $hpoCq.default)(r);
}

});
parcelRegister("hpoCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cac7de3c0f0b9a06$export$2e2bcd8739ae039; });
function $cac7de3c0f0b9a06$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("7kSqN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55749f9653b35e42$export$2e2bcd8739ae039; });
function $55749f9653b35e42$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("264k1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $186f7e8dc839c718$export$2e2bcd8739ae039; });

var $hpoCq = parcelRequire("hpoCq");
function $186f7e8dc839c718$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $hpoCq.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $hpoCq.default)(r, a) : void 0;
    }
}

});

parcelRegister("alFqZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $788c018e77dcae8c$export$2e2bcd8739ae039; });
function $788c018e77dcae8c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("4FQw5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3673ba77eb8541b3$export$2e2bcd8739ae039; });
function $3673ba77eb8541b3$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $3673ba77eb8541b3$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $3673ba77eb8541b3$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $3673ba77eb8541b3$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("6ji6y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49828fa38dcdcd9f$export$2e2bcd8739ae039; });
function $49828fa38dcdcd9f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("ehCmD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a660698ca3dcec5d$export$2e2bcd8739ae039; });

var $3E3RM = parcelRequire("3E3RM");
function $a660698ca3dcec5d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3E3RM.default)(o.key), o);
    }
}
function $a660698ca3dcec5d$export$2e2bcd8739ae039(e, r, t) {
    return r && $a660698ca3dcec5d$var$_defineProperties(e.prototype, r), t && $a660698ca3dcec5d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("3E3RM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a781b51910fd7f6$export$2e2bcd8739ae039; });

var $132G4 = parcelRequire("132G4");

var $hj0QT = parcelRequire("hj0QT");
function $2a781b51910fd7f6$export$2e2bcd8739ae039(t) {
    var i = (0, $hj0QT.default)(t, "string");
    return "symbol" == (0, $132G4.default)(i) ? i : i + "";
}

});
parcelRegister("132G4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c3825f4acdf6dda$export$2e2bcd8739ae039; });
function $0c3825f4acdf6dda$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0c3825f4acdf6dda$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0c3825f4acdf6dda$export$2e2bcd8739ae039(o);
}

});

parcelRegister("hj0QT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c994df3654faee19$export$2e2bcd8739ae039; });

var $132G4 = parcelRequire("132G4");
function $c994df3654faee19$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $132G4.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $132G4.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("cMQbY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94f274050f0c8c0c$export$2e2bcd8739ae039; });

var $132G4 = parcelRequire("132G4");

var $2HKqw = parcelRequire("2HKqw");
function $94f274050f0c8c0c$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $132G4.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $2HKqw.default)(t);
}

});
parcelRegister("2HKqw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f839c52ebe75d54$export$2e2bcd8739ae039; });
function $1f839c52ebe75d54$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("lTcQE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef8b36bb869a2a4$export$2e2bcd8739ae039; });
function $fef8b36bb869a2a4$export$2e2bcd8739ae039(t) {
    return $fef8b36bb869a2a4$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $fef8b36bb869a2a4$export$2e2bcd8739ae039(t);
}

});

parcelRegister("llkr9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f89b697bd4d35ebf$export$2e2bcd8739ae039; });

var $hVCvu = parcelRequire("hVCvu");
function $f89b697bd4d35ebf$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $hVCvu.default)(t, e);
}

});
parcelRegister("hVCvu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0d5a1345039062e$export$2e2bcd8739ae039; });
function $d0d5a1345039062e$export$2e2bcd8739ae039(t, e) {
    return $d0d5a1345039062e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $d0d5a1345039062e$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("fACfu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b597e33f8b273ca5$export$2e2bcd8739ae039; });

var $3E3RM = parcelRequire("3E3RM");
function $b597e33f8b273ca5$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3E3RM.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("4QZRY", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $388c02bb4fdba41e$var$runtime = (parcelRequire("9HwDF"))();
module.exports = $388c02bb4fdba41e$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $388c02bb4fdba41e$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $388c02bb4fdba41e$var$runtime;
    else Function("r", "regeneratorRuntime = r")($388c02bb4fdba41e$var$runtime);
}

});
parcelRegister("9HwDF", function(module, exports) {

var $3jzg6 = parcelRequire("3jzg6");

var $6E3C2 = parcelRequire("6E3C2");

var $hrGjB = parcelRequire("hrGjB");

var $cIurU = parcelRequire("cIurU");

var $kS2Rw = parcelRequire("kS2Rw");

var $aEDen = parcelRequire("aEDen");

var $ajIcx = parcelRequire("ajIcx");
function $710172961ee9af33$var$_regeneratorRuntime() {
    "use strict";
    var r = $6E3C2(), e = r.m($710172961ee9af33$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $ajIcx(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $710172961ee9af33$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $3jzg6(r, e);
            },
            AsyncIterator: $kS2Rw,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $cIurU : $hrGjB)(a(r), e, t, o, u);
            },
            keys: $aEDen,
            values: $ajIcx
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $710172961ee9af33$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3jzg6", function(module, exports) {
function $269e7f163a968906$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $269e7f163a968906$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6E3C2", function(module, exports) {

var $drhCu = parcelRequire("drhCu");
function $4d6947db32cb17ad$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $drhCu(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($drhCu(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $drhCu(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $drhCu(u, "constructor", GeneratorFunctionPrototype), $drhCu(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $drhCu(GeneratorFunctionPrototype, o, "GeneratorFunction"), $drhCu(u), $drhCu(u, o, "Generator"), $drhCu(u, n, function() {
        return this;
    }), $drhCu(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $4d6947db32cb17ad$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $4d6947db32cb17ad$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("drhCu", function(module, exports) {
function $9c8b76ebd706aaa1$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $9c8b76ebd706aaa1$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $9c8b76ebd706aaa1$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9c8b76ebd706aaa1$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $9c8b76ebd706aaa1$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hrGjB", function(module, exports) {

var $cIurU = parcelRequire("cIurU");
function $cb35c82e7089c88c$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $cIurU(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $cb35c82e7089c88c$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cIurU", function(module, exports) {

var $6E3C2 = parcelRequire("6E3C2");

var $kS2Rw = parcelRequire("kS2Rw");
function $942136a616e0f487$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $kS2Rw($6E3C2().w(r, e, t, o), n || Promise);
}
module.exports = $942136a616e0f487$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kS2Rw", function(module, exports) {

var $3jzg6 = parcelRequire("3jzg6");

var $drhCu = parcelRequire("drhCu");
function $f31b123219e8ca07$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $3jzg6 ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($drhCu($f31b123219e8ca07$var$AsyncIterator.prototype), $drhCu($f31b123219e8ca07$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $drhCu(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $f31b123219e8ca07$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("aEDen", function(module, exports) {
function $7c1c123b053195f2$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $7c1c123b053195f2$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ajIcx", function(module, exports) {

var $29YYa = parcelRequire("29YYa");
var $782df727cf6ad855$var$_typeof = $29YYa.default;
function $782df727cf6ad855$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($782df727cf6ad855$var$_typeof(e) + " is not iterable");
}
module.exports = $782df727cf6ad855$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("29YYa", function(module, exports) {
function $192bb748584dee1f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $192bb748584dee1f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $192bb748584dee1f$var$_typeof(o);
}
module.exports = $192bb748584dee1f$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("axHYa", function(module, exports) {

$parcel$export(module.exports, "isApiGatewayUrl", function () { return $7acf17e1ea70ec17$export$f0f6fc934288a17c; });
var $7acf17e1ea70ec17$export$f0f6fc934288a17c = function isApiGatewayUrl(url) {
    return [
        "/gateway/api"
    ].includes(url);
};

});

parcelRegister("aCMxT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bc31c26f292a7a1$export$2e2bcd8739ae039; });
function $7bc31c26f292a7a1$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
}

});

parcelRegister("ljK9M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f84f2d19f8cdbd98$export$2e2bcd8739ae039; });

var $5VbRa = parcelRequire("5VbRa");

var $fACfu = parcelRequire("fACfu");

var $4Onlm = parcelRequire("4Onlm");

var $4FQw5 = parcelRequire("4FQw5");

var $fOsVV = parcelRequire("fOsVV");

var $4QZRY = parcelRequire("4QZRY");

var $iSvIT = parcelRequire("iSvIT");

var $bKQO4 = parcelRequire("bKQO4");
var $3SA17 = parcelRequire("3SA17");

var $9kCMC = parcelRequire("9kCMC");

var $3y1xc = parcelRequire("3y1xc");

var $1yYoC = parcelRequire("1yYoC");
var $bIEuP = parcelRequire("bIEuP");
var $e7pIZ = parcelRequire("e7pIZ");
var $1xDXj = parcelRequire("1xDXj");
var $eWtZW = parcelRequire("eWtZW");

var $aKVSf = parcelRequire("aKVSf");

var $keKJr = parcelRequire("keKJr");
var $e4PnT = parcelRequire("e4PnT");
var $787yF = parcelRequire("787yF");
var $7Y8FR = parcelRequire("7Y8FR");
var $32E8S = parcelRequire("32E8S");

var $jxLBU = parcelRequire("jxLBU");

var $eZqvo = parcelRequire("eZqvo");

var $iUd7u = parcelRequire("iUd7u");

var $aUrB9 = parcelRequire("aUrB9");

var $h7Vgg = parcelRequire("h7Vgg");

var $29nIK = parcelRequire("29nIK");

var $6MdMQ = parcelRequire("6MdMQ");
var $f84f2d19f8cdbd98$var$_excluded = [
    "id"
], $f84f2d19f8cdbd98$var$_excluded2 = [
    "locale"
];
function $f84f2d19f8cdbd98$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f84f2d19f8cdbd98$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f84f2d19f8cdbd98$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f84f2d19f8cdbd98$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f84f2d19f8cdbd98$var$LinkWrapper = function LinkWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        }
    }, children);
};
var $f84f2d19f8cdbd98$var$FeedbackForm = function FeedbackForm(_ref2) {
    var _ref2$showTypeField = _ref2.showTypeField, showTypeField = _ref2$showTypeField === void 0 ? true : _ref2$showTypeField, _ref2$showDefaultText = _ref2.showDefaultTextFields, showDefaultTextFields = _ref2$showDefaultText === void 0 ? true : _ref2$showDefaultText, customContent = _ref2.customContent, onClose = _ref2.onClose, onSubmit = _ref2.onSubmit, feedbackTitle = _ref2.feedbackTitle, feedbackTitleDetails = _ref2.feedbackTitleDetails, feedbackGroupLabels = _ref2.feedbackGroupLabels, summaryPlaceholder = _ref2.summaryPlaceholder, canBeContactedLabel = _ref2.canBeContactedLabel, canBeContactedLink = _ref2.canBeContactedLink, enrolInResearchLabel = _ref2.enrolInResearchLabel, enrolInResearchLink = _ref2.enrolInResearchLink, submitButtonLabel = _ref2.submitButtonLabel, cancelButtonLabel = _ref2.cancelButtonLabel, anonymousFeedback = _ref2.anonymousFeedback, hasDescriptionDefaultValue = _ref2.hasDescriptionDefaultValue, selectLabel = _ref2.selectLabel, customTextAreaLabel = _ref2.customTextAreaLabel, _ref2$customFeedbackO = _ref2.customFeedbackOptions, customFeedbackOptions = _ref2$customFeedbackO === void 0 ? [] : _ref2$customFeedbackO, shouldReturnFocusRef = _ref2.shouldReturnFocusRef, disableSubmitButton = _ref2.disableSubmitButton;
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $fOsVV.default)(_useState, 2), canBeContacted = _useState2[0], setCanBeContacted = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(""), _useState4 = (0, $fOsVV.default)(_useState3, 2), description = _useState4[0], setDescription = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)(false), _useState6 = (0, $fOsVV.default)(_useState5, 2), enrollInResearchGroup = _useState6[0], setEnrollInResearchGroup = _useState6[1];
    var _useState7 = (0, $iSvIT.useState)("empty"), _useState8 = (0, $fOsVV.default)(_useState7, 2), type = _useState8[0], setType = _useState8[1];
    var _useState9 = (0, $iSvIT.useState)(false), _useState0 = (0, $fOsVV.default)(_useState9, 2), isSubmitting = _useState0[0], setIsSubmitting = _useState0[1];
    var _useState1 = (0, $iSvIT.useState)({}), _useState10 = (0, $fOsVV.default)(_useState1, 2), validationErrors = _useState10[0], setValidationErrors = _useState10[1];
    var _useIntl = (0, $3SA17.default)(), formatMessage = _useIntl.formatMessage;
    var isTypeSelected = function isTypeSelected() {
        return type !== "empty";
    };
    var canShowTextField = isTypeSelected() || !showTypeField;
    var hasDescription = description || hasDescriptionDefaultValue;
    // Feature flag determines validation behavior
    var useNewValidation = (0, $jxLBU.fg)("feedback-collector-custom-validation");
    var isDisabled = useNewValidation ? isSubmitting || disableSubmitButton // New: only disable when submitting or explicitly disabled
     : disableSubmitButton || (showTypeField ? !isTypeSelected() || !hasDescription : !hasDescription); // Old: disable based on form validation
    var getValidationErrors = function getValidationErrors() {
        var errors = {};
        // Validate type selection if showTypeField is true
        if (showTypeField && !isTypeSelected()) errors.type = formatMessage((0, $29nIK.messages).validationErrorTypeRequired);
        // Validate description if showDefaultTextFields is true
        if (showDefaultTextFields && !hasDescription) errors.description = formatMessage((0, $29nIK.messages).validationErrorDescriptionRequired);
        return errors;
    };
    var getFieldLabels = function getFieldLabels(record) {
        var _record$bug, _record$comment, _record$suggestion, _record$question, _record$empty, _record$not_relevant, _record$not_accurate, _record$too_slow, _record$unhelpful_lin, _record$other;
        return {
            bug: (record === null || record === void 0 || (_record$bug = record.bug) === null || _record$bug === void 0 ? void 0 : _record$bug.fieldLabel) || formatMessage((0, $29nIK.messages).formBugLabel),
            comment: (record === null || record === void 0 || (_record$comment = record.comment) === null || _record$comment === void 0 ? void 0 : _record$comment.fieldLabel) || formatMessage((0, $29nIK.messages).formCommentLabel),
            suggestion: (record === null || record === void 0 || (_record$suggestion = record.suggestion) === null || _record$suggestion === void 0 ? void 0 : _record$suggestion.fieldLabel) || formatMessage((0, $29nIK.messages).formSuggestionLabel),
            question: (record === null || record === void 0 || (_record$question = record.question) === null || _record$question === void 0 ? void 0 : _record$question.fieldLabel) || formatMessage((0, $29nIK.messages).formQuestionLabel),
            empty: (record === null || record === void 0 || (_record$empty = record.empty) === null || _record$empty === void 0 ? void 0 : _record$empty.fieldLabel) || formatMessage((0, $29nIK.messages).formEmptyLabel),
            not_relevant: (record === null || record === void 0 || (_record$not_relevant = record.not_relevant) === null || _record$not_relevant === void 0 ? void 0 : _record$not_relevant.fieldLabel) || formatMessage((0, $29nIK.messages).formNotRelevantLabel),
            not_accurate: (record === null || record === void 0 || (_record$not_accurate = record.not_accurate) === null || _record$not_accurate === void 0 ? void 0 : _record$not_accurate.fieldLabel) || formatMessage((0, $29nIK.messages).formNotAccurateLabel),
            too_slow: (record === null || record === void 0 || (_record$too_slow = record.too_slow) === null || _record$too_slow === void 0 ? void 0 : _record$too_slow.fieldLabel) || formatMessage((0, $29nIK.messages).formTooSlowLabel),
            unhelpful_links: (record === null || record === void 0 || (_record$unhelpful_lin = record.unhelpful_links) === null || _record$unhelpful_lin === void 0 ? void 0 : _record$unhelpful_lin.fieldLabel) || formatMessage((0, $29nIK.messages).formUnhelpfulLinksLabel),
            other: (record === null || record === void 0 || (_record$other = record.other) === null || _record$other === void 0 ? void 0 : _record$other.fieldLabel) || formatMessage((0, $29nIK.messages).formOtherLabel)
        };
    };
    var getSelectOptions = function getSelectOptions(record) {
        var _record$question2, _record$comment2, _record$bug2, _record$suggestion2;
        return [
            {
                label: (record === null || record === void 0 || (_record$question2 = record.question) === null || _record$question2 === void 0 ? void 0 : _record$question2.selectOptionLabel) || formatMessage((0, $29nIK.messages).selectionOptionQuestionLabel),
                value: "question"
            },
            {
                label: (record === null || record === void 0 || (_record$comment2 = record.comment) === null || _record$comment2 === void 0 ? void 0 : _record$comment2.selectOptionLabel) || formatMessage((0, $29nIK.messages).selectionOptionCommentLabel),
                value: "comment"
            },
            {
                label: (record === null || record === void 0 || (_record$bug2 = record.bug) === null || _record$bug2 === void 0 ? void 0 : _record$bug2.selectOptionLabel) || formatMessage((0, $29nIK.messages).selectionOptionBugLabel),
                value: "bug"
            },
            {
                label: (record === null || record === void 0 || (_record$suggestion2 = record.suggestion) === null || _record$suggestion2 === void 0 ? void 0 : _record$suggestion2.selectOptionLabel) || formatMessage((0, $29nIK.messages).selectionOptionSuggestionLabel),
                value: "suggestion"
            }
        ];
    };
    var getDefaultPlaceholder = function getDefaultPlaceholder(record) {
        var _record$empty2;
        return (record === null || record === void 0 || (_record$empty2 = record.empty) === null || _record$empty2 === void 0 ? void 0 : _record$empty2.selectOptionLabel) || formatMessage((0, $29nIK.messages).selectionOptionDefaultPlaceholder);
    };
    var focusRef = (0, $iSvIT.useRef)();
    var selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    var renderContactLabelAppify = function renderContactLabelAppify() {
        if ((0, $jxLBU.fg)("jfp_a11y_team_feedback_collector_nested_elements")) return (0, $29nIK.messages).canBeContactedLabelAppifyWithoutLink;
        return (0, $29nIK.messages).canBeContactedLabelAppify;
    };
    var renderContactLabel = function renderContactLabel() {
        if ((0, $jxLBU.fg)("jfp_a11y_team_feedback_collector_nested_elements")) return (0, $29nIK.messages).canBeContactedLabelWithoutLink;
        return (0, $29nIK.messages).canBeContactedLabel;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $keKJr.default), {
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1yYoC.default), {
        onSubmit: /*#__PURE__*/ (0, $4FQw5.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).mark(function _callee() {
            var errors;
            return (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (!useNewValidation) {
                            _context.next = 5;
                            break;
                        }
                        // New validation: validate on submit and show errors
                        errors = getValidationErrors(); // If there are validation errors, show them and don't submit
                        if (!(Object.keys(errors).length > 0)) {
                            _context.next = 5;
                            break;
                        }
                        setValidationErrors(errors);
                        return _context.abrupt("return");
                    case 5:
                        // Submit the form (both old and new validation paths reach here)
                        setIsSubmitting(true);
                        _context.prev = 6;
                        _context.next = 9;
                        return onSubmit({
                            canBeContacted: canBeContacted,
                            description: description,
                            enrollInResearchGroup: enrollInResearchGroup,
                            type: type
                        });
                    case 9:
                        _context.prev = 9;
                        setIsSubmitting(false);
                        return _context.finish(9);
                    case 12:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    6,
                    ,
                    9,
                    12
                ]
            ]);
        }))
    }, function(_ref4) {
        var formProps = _ref4.formProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7Y8FR.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $32E8S.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bKQO4.default), (0, $29nIK.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $e4PnT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("p", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                color: "var(--ds-text-subtle, ".concat((0, $h7Vgg.N300), ")"),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                marginBottom: "var(--ds-space-300, 24px)"
            }
        }, formatMessage((0, $29nIK.messages).requiredFieldsSummary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eWtZW.default), null)), feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $e7pIZ.default), {
            name: "topic",
            label: selectLabel || formatMessage((0, $29nIK.messages).selectionOptionDefaultLabel),
            isRequired: true,
            "aria-required": true // JCA11Y-1619
        }, function(_ref5) {
            var _ref5$fieldProps = _ref5.fieldProps, id = _ref5$fieldProps.id, restProps = (0, $4Onlm.default)(_ref5$fieldProps, $f84f2d19f8cdbd98$var$_excluded);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iUd7u.default), (0, $5VbRa.default)({}, restProps, {
                onChange: function onChange(option) {
                    if (!option || option instanceof Array) return;
                    setType(option.value);
                    // Clear validation error when user selects a type (only for new validation)
                    if (useNewValidation && validationErrors.type) setValidationErrors(function(prev) {
                        return $f84f2d19f8cdbd98$var$_objectSpread($f84f2d19f8cdbd98$var$_objectSpread({}, prev), {}, {
                            type: undefined
                        });
                    });
                },
                menuPortalTarget: document.body,
                styles: {
                    menuPortal: function menuPortal(base) {
                        return $f84f2d19f8cdbd98$var$_objectSpread($f84f2d19f8cdbd98$var$_objectSpread({}, base), {}, {
                            zIndex: 9999
                        });
                    }
                },
                options: selectOptions,
                ref: focusRef,
                placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                inputId: id
            })), useNewValidation && validationErrors.type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bIEuP.ErrorMessage), null, validationErrors.type));
        }) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $e7pIZ.default), {
            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $29nIK.messages).defaultCustomTextAreaLabel),
            isRequired: true,
            name: "description"
        }, function(_ref6) {
            var fieldProps = _ref6.fieldProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $aUrB9.default), (0, $5VbRa.default)({}, fieldProps, {
                name: "foo",
                minimumRows: 6,
                placeholder: summaryPlaceholder || undefined,
                onChange: function onChange(e) {
                    setDescription(e.target.value);
                    // Clear validation error when user types
                    if (useNewValidation && validationErrors.description) setValidationErrors(function(prev) {
                        return $f84f2d19f8cdbd98$var$_objectSpread($f84f2d19f8cdbd98$var$_objectSpread({}, prev), {}, {
                            description: undefined
                        });
                    });
                },
                value: description
            })), useNewValidation && validationErrors.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bIEuP.ErrorMessage), null, validationErrors.description));
        }), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1xDXj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("legend", {
            "aria-hidden": false,
            hidden: true
        }, "Atlassian opt-in options"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $e7pIZ.default), {
            name: "can-be-contacted"
        }, function(_ref7) {
            var fieldProps = _ref7.fieldProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $3y1xc.default), (0, $5VbRa.default)({}, fieldProps, {
                "aria-describedby": undefined // JCA11Y-1988
                ,
                label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bKQO4.default), (0, $5VbRa.default)({}, (0, $jxLBU.fg)("product-terminology-refresh") ? renderContactLabelAppify() : renderContactLabel(), !(0, $jxLBU.fg)("jfp_a11y_team_feedback_collector_nested_elements") && {
                    values: {
                        a: function a(chunks) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $aKVSf.default), {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                target: "_blank"
                            }, chunks);
                        }
                    }
                })),
                onChange: function onChange(event) {
                    return setCanBeContacted(event.target.checked);
                }
            })), canBeContactedLabel && canBeContactedLink && (0, $jxLBU.fg)("jfp_a11y_team_feedback_collector_nested_elements") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($f84f2d19f8cdbd98$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $jxLBU.fg)("jfp_a11y_team_feedback_collector_nested_elements") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($f84f2d19f8cdbd98$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $aKVSf.default), {
                href: "https://www.atlassian.com/legal/privacy-policy",
                target: "_blank"
            }, formatMessage((0, $29nIK.messages).privacyPolicy))));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $e7pIZ.default), {
            name: "enroll-in-research-group"
        }, function(_ref8) {
            var fieldProps = _ref8.fieldProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $3y1xc.default), (0, $5VbRa.default)({}, fieldProps, {
                "aria-describedby": undefined // JCA11Y-1988
                ,
                label: enrolInResearchLabel || formatMessage((0, $29nIK.messages).enrolInResearchLabel),
                onChange: function onChange(event) {
                    return setEnrollInResearchGroup(event.target.checked);
                }
            })), enrolInResearchLabel && enrolInResearchLink && (0, $jxLBU.fg)("jfp_a11y_team_feedback_collector_nested_elements") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($f84f2d19f8cdbd98$var$LinkWrapper, null, enrolInResearchLink));
        })) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $e7pIZ.default), {
            name: "anonymousFeedback"
        }, function() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eZqvo.default), {
                title: formatMessage((0, $29nIK.messages).feedbackIsAnonymousTitle),
                appearance: "information"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("p", null, formatMessage((0, $29nIK.messages).feedbackIsAnonymous)));
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $787yF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9kCMC.default), {
            appearance: "subtle",
            onClick: onClose
        }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bKQO4.default), (0, $29nIK.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9kCMC.default), {
            appearance: "primary",
            type: "submit",
            isDisabled: isSubmitting || isDisabled,
            testId: "feedbackCollectorSubmitBtn"
        }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bKQO4.default), (0, $29nIK.messages).submitButtonLabel))));
    }));
};
var $f84f2d19f8cdbd98$var$FeedbackFormWithIntl = function FeedbackFormWithIntl(_ref9) {
    var locale = _ref9.locale, props = (0, $4Onlm.default)(_ref9, $f84f2d19f8cdbd98$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6MdMQ.IntlProviderWithResolvedMessages), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($f84f2d19f8cdbd98$var$FeedbackForm, props));
};
var $f84f2d19f8cdbd98$export$2e2bcd8739ae039 = $f84f2d19f8cdbd98$var$FeedbackFormWithIntl;

});
parcelRegister("4Onlm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $380df0751ef50086$export$2e2bcd8739ae039; });

var $2k3Cs = parcelRequire("2k3Cs");
function $380df0751ef50086$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $2k3Cs.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("2k3Cs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b1041bf552d9c33$export$2e2bcd8739ae039; });
function $1b1041bf552d9c33$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("fOsVV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b831f811af2c7743$export$2e2bcd8739ae039; });

var $dwDy0 = parcelRequire("dwDy0");

var $dZjkc = parcelRequire("dZjkc");

var $264k1 = parcelRequire("264k1");

var $2TCnV = parcelRequire("2TCnV");
function $b831f811af2c7743$export$2e2bcd8739ae039(r, e) {
    return (0, $dwDy0.default)(r) || (0, $dZjkc.default)(r, e) || (0, $264k1.default)(r, e) || (0, $2TCnV.default)();
}

});
parcelRegister("dwDy0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d8cf0da42f40369$export$2e2bcd8739ae039; });
function $9d8cf0da42f40369$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("dZjkc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2eff661f80363de$export$2e2bcd8739ae039; });
function $a2eff661f80363de$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("2TCnV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21be7e4979f254d8$export$2e2bcd8739ae039; });
function $21be7e4979f254d8$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9kCMC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cb410d65dc2ec53$export$2e2bcd8739ae039; });

var $5VbRa = parcelRequire("5VbRa");

var $fOsVV = parcelRequire("fOsVV");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");

var $4etuF = parcelRequire("4etuF");

var $4Cnyc = parcelRequire("4Cnyc");

var $aqear = parcelRequire("aqear");

var $8cAyP = parcelRequire("8cAyP");

var $9Ilk6 = parcelRequire("9Ilk6");
var $6cb410d65dc2ec53$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $6cb410d65dc2ec53$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $6cb410d65dc2ec53$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $4etuF.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $4etuF.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, $4Onlm.default)(_ref, $6cb410d65dc2ec53$var$_excluded);
    var _useGlobalTheme = (0, $4Cnyc.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $9Ilk6.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $fOsVV.default)(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $iSvIT.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($6cb410d65dc2ec53$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $iSvIT.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($6cb410d65dc2ec53$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $iSvIT.useMemo)(function() {
        return (0, $8cAyP.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $aqear.default), (0, $5VbRa.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$6cb410d65dc2ec53$var$Button.displayName = "Button";
var $6cb410d65dc2ec53$export$2e2bcd8739ae039 = $6cb410d65dc2ec53$var$Button;

});
parcelRegister("4etuF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $314f590d40c7a28c$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $314f590d40c7a28c$export$2e2bcd8739ae039() {}

});

parcelRegister("4Cnyc", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $35ccfab3c0d65b48$export$7692396083754928; });

var $N0OoQ = parcelRequire("N0OoQ");
// Create default global light theme
var $35ccfab3c0d65b48$var$_createTheme = (0, $N0OoQ.createTheme)(function() {
    return {
        mode: "light"
    };
}), $35ccfab3c0d65b48$var$Provider = $35ccfab3c0d65b48$var$_createTheme.Provider, $35ccfab3c0d65b48$var$Consumer = $35ccfab3c0d65b48$var$_createTheme.Consumer, $35ccfab3c0d65b48$export$7692396083754928 = $35ccfab3c0d65b48$var$_createTheme.useTheme;
var $35ccfab3c0d65b48$var$Theme = {
    Provider: $35ccfab3c0d65b48$var$Provider,
    Consumer: $35ccfab3c0d65b48$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$35ccfab3c0d65b48$export$2e2bcd8739ae039 = $35ccfab3c0d65b48$var$Theme;

});
parcelRegister("N0OoQ", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $093534f19855f532$export$25d302a5b900a763; });

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");
var $093534f19855f532$var$_excluded = [
    "children"
];
function $093534f19855f532$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $iSvIT.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $4Onlm.default)(props, $093534f19855f532$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $iSvIT.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $iSvIT.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("aqear", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7967526d33b5b0dd$export$2e2bcd8739ae039; });

var $5VbRa = parcelRequire("5VbRa");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $lxoX2 = parcelRequire("lxoX2");

var $4etuF = parcelRequire("4etuF");

var $4JfNt = parcelRequire("4JfNt");

var $7TCqn = parcelRequire("7TCqn");

var $ivZTz = parcelRequire("ivZTz");

var $h7Vgg = parcelRequire("h7Vgg");

var $diFc0 = parcelRequire("diFc0");

var $8cAyP = parcelRequire("8cAyP");

var $ayqeI = parcelRequire("ayqeI");
var $7967526d33b5b0dd$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $7967526d33b5b0dd$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $7967526d33b5b0dd$var$iconBeforeSpacingFixStyle = (0, $2ZUkg.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $7967526d33b5b0dd$var$iconAfterSpacingFixStyle = (0, $2ZUkg.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $7967526d33b5b0dd$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $ayqeI.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $7967526d33b5b0dd$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $ayqeI.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $2ZUkg.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $7967526d33b5b0dd$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $4etuF.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $4etuF.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, $4Onlm.default)(props, $7967526d33b5b0dd$var$_excluded);
    var ourRef = (0, $iSvIT.useRef)();
    var setRef = (0, $iSvIT.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $4JfNt.default)(ourRef, autoFocus);
    var interactionContext = (0, $iSvIT.useContext)((0, $ivZTz.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $lxoX2.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $iSvIT.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $iSvIT.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $2ZUkg.css)((0, $8cAyP.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $h7Vgg.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $h7Vgg.N500), ")"), " !important")
        }
    };
    return (0, $2ZUkg.jsx)((0, $7TCqn.default), null, (0, $2ZUkg.jsx)(Component, (0, $5VbRa.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $7967526d33b5b0dd$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $diFc0.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $2ZUkg.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $8cAyP.getIconStyle)({
                spacing: spacing
            }),
            $7967526d33b5b0dd$var$getSpacingFix(children, $7967526d33b5b0dd$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $7967526d33b5b0dd$var$getChildren(children, [
        fadeStyles,
        (0, $8cAyP.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $2ZUkg.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $8cAyP.getIconStyle)({
                spacing: spacing
            }),
            $7967526d33b5b0dd$var$getSpacingFix(children, $7967526d33b5b0dd$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $2ZUkg.jsx)("span", {
        css: [
            (0, $8cAyP.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7967526d33b5b0dd$export$2e2bcd8739ae039 = $7967526d33b5b0dd$var$ButtonBase;

});
parcelRegister("lxoX2", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $040bdf1c45aa66b8$export$a4687b0234b40e28; });

var $fACfu = parcelRequire("fACfu");

var $iSvIT = parcelRequire("iSvIT");

var $8ipIc = parcelRequire("8ipIc");

var $kXY8N = parcelRequire("kXY8N");
function $040bdf1c45aa66b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $040bdf1c45aa66b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $040bdf1c45aa66b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $040bdf1c45aa66b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $040bdf1c45aa66b8$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8ipIc.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $kXY8N.useTrackedRef)(analyticsData);
    var fnRef = (0, $kXY8N.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $040bdf1c45aa66b8$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("8ipIc", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $60a3f3055a2ee3ee$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $iJdpP = parcelRequire("iJdpP");

var $gK3vQ = parcelRequire("gK3vQ");
function $60a3f3055a2ee3ee$export$5bf35293e545f20c() {
    var analyticsContext = (0, $gK3vQ.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $iJdpP.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("iJdpP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da26d608cddaa5c6$export$2e2bcd8739ae039; });

var $d5B2s = parcelRequire("d5B2s");

var $6ji6y = parcelRequire("6ji6y");

var $ehCmD = parcelRequire("ehCmD");

var $cMQbY = parcelRequire("cMQbY");

var $lTcQE = parcelRequire("lTcQE");

var $dISfo = parcelRequire("dISfo");

var $llkr9 = parcelRequire("llkr9");

var $fACfu = parcelRequire("fACfu");

var $67jsa = parcelRequire("67jsa");
function $da26d608cddaa5c6$var$_callSuper(t, o, e) {
    return o = (0, $lTcQE.default)(o), (0, $cMQbY.default)(t, $da26d608cddaa5c6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $lTcQE.default)(t).constructor) : o.apply(t, e));
}
function $da26d608cddaa5c6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($da26d608cddaa5c6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $da26d608cddaa5c6$var$_superPropGet(t, o, e, r) {
    var p = (0, $dISfo.default)((0, $lTcQE.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $da26d608cddaa5c6$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $da26d608cddaa5c6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $da26d608cddaa5c6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $6ji6y.default)(this, UIAnalyticsEvent);
        _this = $da26d608cddaa5c6$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $fACfu.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $fACfu.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $d5B2s.default)(_this.context);
            var handlers = (0, $d5B2s.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $fACfu.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $llkr9.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $ehCmD.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $da26d608cddaa5c6$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $67jsa.default));

});
parcelRegister("dISfo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fd976c8c13a819c$export$2e2bcd8739ae039; });

var $8eSWe = parcelRequire("8eSWe");
function $9fd976c8c13a819c$export$2e2bcd8739ae039() {
    return $9fd976c8c13a819c$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $8eSWe.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $9fd976c8c13a819c$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("8eSWe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ffa3f1b35170fda$export$2e2bcd8739ae039; });

var $lTcQE = parcelRequire("lTcQE");
function $5ffa3f1b35170fda$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $lTcQE.default)(t)););
    return t;
}

});


parcelRegister("67jsa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47427c85665f474d$export$2e2bcd8739ae039; });

var $132G4 = parcelRequire("132G4");

var $6ji6y = parcelRequire("6ji6y");

var $ehCmD = parcelRequire("ehCmD");

var $fACfu = parcelRequire("fACfu");
function $47427c85665f474d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $47427c85665f474d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $47427c85665f474d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $47427c85665f474d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $47427c85665f474d$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $47427c85665f474d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $47427c85665f474d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $6ji6y.default)(this, AnalyticsEvent);
        (0, $fACfu.default)(this, "_isAnalyticsEvent", true);
        (0, $fACfu.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $47427c85665f474d$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $ehCmD.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $132G4.default)(updater) === "object") this.payload = $47427c85665f474d$var$_objectSpread($47427c85665f474d$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("gK3vQ", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $c303aac36227e77b$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $c303aac36227e77b$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("kXY8N", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $f437f80b90f6e32d$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $f437f80b90f6e32d$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("4JfNt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37179e594d2adc2b$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $37179e594d2adc2b$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $iSvIT.useRef)(true);
    (0, $iSvIT.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("ivZTz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7ab225eb889fb98$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $d7ab225eb889fb98$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});

parcelRegister("h7Vgg", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $c77f820392862e66$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R300", function () { return $c77f820392862e66$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $c77f820392862e66$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $c77f820392862e66$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $c77f820392862e66$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y200", function () { return $c77f820392862e66$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $c77f820392862e66$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $c77f820392862e66$export$59619663aa6500fb; });
$parcel$export(module.exports, "Y500", function () { return $c77f820392862e66$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $c77f820392862e66$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G500", function () { return $c77f820392862e66$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $c77f820392862e66$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $c77f820392862e66$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $c77f820392862e66$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $c77f820392862e66$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $c77f820392862e66$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $c77f820392862e66$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $c77f820392862e66$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $c77f820392862e66$export$363e4475840015bb; });
$parcel$export(module.exports, "P500", function () { return $c77f820392862e66$export$147899de772240ec; });
$parcel$export(module.exports, "N0", function () { return $c77f820392862e66$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $c77f820392862e66$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $c77f820392862e66$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $c77f820392862e66$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $c77f820392862e66$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $c77f820392862e66$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N400", function () { return $c77f820392862e66$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $c77f820392862e66$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $c77f820392862e66$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $c77f820392862e66$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $c77f820392862e66$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $c77f820392862e66$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $c77f820392862e66$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $c77f820392862e66$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $c77f820392862e66$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $c77f820392862e66$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $c77f820392862e66$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $c77f820392862e66$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $c77f820392862e66$export$3d4f271a500072a; });
// Reds
var $c77f820392862e66$export$4b84fd0e2c617bd = "#FFEBE6";
var $c77f820392862e66$export$b34b069eff244586 = "#FFBDAD";
var $c77f820392862e66$export$be802dd0d8b57f35 = "#FF8F73";
var $c77f820392862e66$export$60847d42f9da92a6 = "#FF7452";
var $c77f820392862e66$export$4a7404f376229999 = "#FF5630";
var $c77f820392862e66$export$2010d0fb4295b346 = "#DE350B";
var $c77f820392862e66$export$2837b5a1a71d5c02 = "#BF2600";
var $c77f820392862e66$export$8d9596b529bbb9cf = "#FFFAE6";
var $c77f820392862e66$export$41060a744ab0b7ae = "#FFF0B3";
var $c77f820392862e66$export$1cc05bbbf340e559 = "#FFE380";
var $c77f820392862e66$export$5aae31392d72caaa = "#FFC400";
var $c77f820392862e66$export$c6930421db9fa514 = "#FFAB00";
var $c77f820392862e66$export$59619663aa6500fb = "#FF991F";
var $c77f820392862e66$export$874739ea9e379ab6 = "#FF8B00";
var $c77f820392862e66$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $c77f820392862e66$export$69a3bf21b9686c2b = "#ABF5D1";
var $c77f820392862e66$export$afbce1382ec95f73 = "#79F2C0";
var $c77f820392862e66$export$747d86715d4175de = "#57D9A3";
var $c77f820392862e66$export$940e1f69e873f202 = "#36B37E";
var $c77f820392862e66$export$a49394138f7b8e85 = "#00875A";
var $c77f820392862e66$export$6fa04827ac68a4fb = "#006644";
var $c77f820392862e66$export$226de0355ed012f8 = "#DEEBFF";
var $c77f820392862e66$export$8c13c2ee36917869 = "#B3D4FF";
var $c77f820392862e66$export$ecfc1dff386a3e7a = "#4C9AFF";
var $c77f820392862e66$export$215b7063051591f1 = "#2684FF";
var $c77f820392862e66$export$e62e8919cca44969 = "#0065FF";
var $c77f820392862e66$export$b3de0ae08da2ce64 = "#0052CC";
var $c77f820392862e66$export$a6ee3d71bc067634 = "#0747A6";
var $c77f820392862e66$export$67f15409e87642a1 = "#669DF1";
var $c77f820392862e66$export$f0539dbc42dbb067 = "#8FB8F6";
var $c77f820392862e66$export$363e4475840015bb = "#EAE6FF";
var $c77f820392862e66$export$4b0a4417ed59760f = "#C0B6F2";
var $c77f820392862e66$export$6011520a64d9a187 = "#998DD9";
var $c77f820392862e66$export$a7175d4e9206bc80 = "#8777D9";
var $c77f820392862e66$export$b48405b95304b5a1 = "#6554C0";
var $c77f820392862e66$export$c71e4279dd54a18d = "#5243AA";
var $c77f820392862e66$export$147899de772240ec = "#403294";
var $c77f820392862e66$export$2cf711fe14c66f06 = "#E6FCFF";
var $c77f820392862e66$export$7a8f4d33f6f9772c = "#B3F5FF";
var $c77f820392862e66$export$776c9c497ef08533 = "#79E2F2";
var $c77f820392862e66$export$69cb3ca10c1e330e = "#00C7E6";
var $c77f820392862e66$export$9dc1ef0f3f48059b = "#00B8D9";
var $c77f820392862e66$export$7c835c78b6fcdef8 = "#00A3BF";
var $c77f820392862e66$export$6036577f95c3877e = "#008DA6";
var $c77f820392862e66$export$29a4f05edc054374 = "#FFFFFF";
var $c77f820392862e66$export$e655ef011c4aa1a2 = "#FAFBFC";
var $c77f820392862e66$export$9fdfb749e33cdf97 = "#F4F5F7";
var $c77f820392862e66$export$3e51e8f1440314ba = "#EBECF0";
var $c77f820392862e66$export$1ce2d1575d444ceb = "#DFE1E6";
var $c77f820392862e66$export$8754fc7e6d8b3000 = "#C1C7D0";
var $c77f820392862e66$export$c2e91cbeada39b8b = "#B3BAC5";
var $c77f820392862e66$export$5f71e19f3a7ad9de = "#A5ADBA";
var $c77f820392862e66$export$eaa8c8a70ac22806 = "#97A0AF";
var $c77f820392862e66$export$7c87d337fb91a97d = "#8993A4";
var $c77f820392862e66$export$d6447c357493214f = "#7A869A";
var $c77f820392862e66$export$f563ee71e9ee74cd = "#6B778C";
var $c77f820392862e66$export$e2ef2124cf4024b1 = "#5E6C84";
var $c77f820392862e66$export$eece5f492e429f08 = "#505F79";
var $c77f820392862e66$export$c39c0fe0f26207ae = "#42526E";
var $c77f820392862e66$export$7090862dc3038a9f = "#344563";
var $c77f820392862e66$export$ad0bacf983b7ddaa = "#253858";
var $c77f820392862e66$export$7d61b15e0da132af = "#172B4D";
var $c77f820392862e66$export$fbda843f0a27fe96 = "#091E42";
var $c77f820392862e66$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $c77f820392862e66$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $c77f820392862e66$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $c77f820392862e66$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $c77f820392862e66$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $c77f820392862e66$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $c77f820392862e66$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $c77f820392862e66$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $c77f820392862e66$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $c77f820392862e66$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $c77f820392862e66$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $c77f820392862e66$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $c77f820392862e66$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $c77f820392862e66$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $c77f820392862e66$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $c77f820392862e66$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $c77f820392862e66$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $c77f820392862e66$export$2f6319cf7d736c2a = "#E6EDFA";
var $c77f820392862e66$export$95126bc8884d6634 = "#DCE5F5";
var $c77f820392862e66$export$8338d8c35d44ff1 = "#CED9EB";
var $c77f820392862e66$export$5368d76ae4fbbda7 = "#B8C7E0";
var $c77f820392862e66$export$9f0a771d16ec8d36 = "#ABBBD6";
var $c77f820392862e66$export$abcf8c38338b4aa5 = "#9FB0CC";
var $c77f820392862e66$export$97e81faa16a182c7 = "#8C9CB8";
var $c77f820392862e66$export$bfe21c59123ecf33 = "#7988A3";
var $c77f820392862e66$export$ee82aa2ea6a1558 = "#67758F";
var $c77f820392862e66$export$682927c6ed76be02 = "#56637A";
var $c77f820392862e66$export$91fd9994c5be9757 = "#455166";
var $c77f820392862e66$export$d281fbfe3cff2df6 = "#3B475C";
var $c77f820392862e66$export$3902c91d8b98a753 = "#313D52";
var $c77f820392862e66$export$8e8133c1ba5845b5 = "#283447";
var $c77f820392862e66$export$33ff357f6620b39 = "#202B3D";
var $c77f820392862e66$export$633847cf062b69e0 = "#1B2638";
var $c77f820392862e66$export$9776a6e503bdbf76 = "#121A29";
var $c77f820392862e66$export$6c813d5160dff5db = "#0E1624";
var $c77f820392862e66$export$3d4f271a500072a = "#0D1424";
var $c77f820392862e66$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $c77f820392862e66$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $c77f820392862e66$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $c77f820392862e66$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $c77f820392862e66$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $c77f820392862e66$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $c77f820392862e66$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $c77f820392862e66$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $c77f820392862e66$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $c77f820392862e66$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $c77f820392862e66$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $c77f820392862e66$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $c77f820392862e66$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $c77f820392862e66$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $c77f820392862e66$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $c77f820392862e66$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $c77f820392862e66$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $c77f820392862e66$export$d2adc5dedf09fced = "#292A2E";
var $c77f820392862e66$export$f51762073d2bb381 = "#94C748";
var $c77f820392862e66$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("diFc0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aece8c8631ad1f2$export$2e2bcd8739ae039; });
function $9aece8c8631ad1f2$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $9aece8c8631ad1f2$var$tabKeyCode = 9;
function $9aece8c8631ad1f2$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $9aece8c8631ad1f2$var$tabKeyCode) return;
    $9aece8c8631ad1f2$var$abort(event);
}
var $9aece8c8631ad1f2$var$block = {
    onMouseDownCapture: $9aece8c8631ad1f2$var$abort,
    onMouseUpCapture: $9aece8c8631ad1f2$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $9aece8c8631ad1f2$var$onKey,
    onKeyUpCapture: $9aece8c8631ad1f2$var$onKey,
    onTouchStartCapture: $9aece8c8631ad1f2$var$abort,
    onTouchEndCapture: $9aece8c8631ad1f2$var$abort,
    onPointerDownCapture: $9aece8c8631ad1f2$var$abort,
    onPointerUpCapture: $9aece8c8631ad1f2$var$abort,
    onClickCapture: $9aece8c8631ad1f2$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $9aece8c8631ad1f2$var$abort
};
var $9aece8c8631ad1f2$var$doNotBlock = {};
function $9aece8c8631ad1f2$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $9aece8c8631ad1f2$var$doNotBlock : $9aece8c8631ad1f2$var$block;
}

});

parcelRegister("8cAyP", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $5f8bcde887312b24$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $5f8bcde887312b24$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $5f8bcde887312b24$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $5f8bcde887312b24$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $5f8bcde887312b24$export$1a9fe1b84c876bb5; });

var $fACfu = parcelRequire("fACfu");

var $2ZUkg = parcelRequire("2ZUkg");

var $jxLBU = parcelRequire("jxLBU");

var $8IwzF = parcelRequire("8IwzF");
function $5f8bcde887312b24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5f8bcde887312b24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5f8bcde887312b24$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5f8bcde887312b24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5f8bcde887312b24$var$gridSize = 8;
var $5f8bcde887312b24$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $5f8bcde887312b24$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $5f8bcde887312b24$var$lineHeights = {
    default: $5f8bcde887312b24$var$heights.default,
    compact: $5f8bcde887312b24$var$heights.compact,
    none: "inherit"
};
var $5f8bcde887312b24$var$padding = {
    // 10px gutter
    default: "0 ".concat($5f8bcde887312b24$var$gridSize + $5f8bcde887312b24$var$gridSize / 4, "px"),
    compact: "0 ".concat($5f8bcde887312b24$var$gridSize + $5f8bcde887312b24$var$gridSize / 4, "px"),
    none: "0"
};
var $5f8bcde887312b24$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($5f8bcde887312b24$var$gridSize / 4, "px"),
    default: "0 ".concat($5f8bcde887312b24$var$gridSize / 4, "px"),
    none: "0"
};
var $5f8bcde887312b24$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $5f8bcde887312b24$var$innerMargin = {
    content: "0 ".concat($5f8bcde887312b24$var$gridSize / 4, "px"),
    icon: "0 ".concat($5f8bcde887312b24$var$gridSize / 4, "px")
};
var $5f8bcde887312b24$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $5f8bcde887312b24$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&::after": $5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread({}, $5f8bcde887312b24$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "&:disabled[disabled]": {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "&:disabled[disabled]:hover": {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "&:disabled[disabled]:active": {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $5f8bcde887312b24$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $5f8bcde887312b24$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $5f8bcde887312b24$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "transparent"
    }
};
var $5f8bcde887312b24$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $5f8bcde887312b24$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $5f8bcde887312b24$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $5f8bcde887312b24$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread({}, $5f8bcde887312b24$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $5f8bcde887312b24$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $5f8bcde887312b24$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $5f8bcde887312b24$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $5f8bcde887312b24$var$getColor({
            group: (0, $8IwzF.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($5f8bcde887312b24$var$getColor({
            group: (0, $8IwzF.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $5f8bcde887312b24$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $5f8bcde887312b24$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $jxLBU.fg)("platform-component-visual-refresh") && baseColors), {}, {
        cursor: "pointer",
        height: $5f8bcde887312b24$var$heights[spacing],
        lineHeight: $5f8bcde887312b24$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $5f8bcde887312b24$var$singleIconPadding[spacing] : $5f8bcde887312b24$var$padding[spacing],
        verticalAlign: $5f8bcde887312b24$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $jxLBU.fg)("platform-component-visual-refresh") && $5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $5f8bcde887312b24$var$_objectSpread({}, baseColors),
        "&:hover": $5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread({}, $5f8bcde887312b24$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread({}, $5f8bcde887312b24$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread({}, $5f8bcde887312b24$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread({}, $5f8bcde887312b24$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $5f8bcde887312b24$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $5f8bcde887312b24$var$_objectSpread({}, $5f8bcde887312b24$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $jxLBU.fg)("platform-component-visual-refresh") && (isSelected ? $5f8bcde887312b24$var$selectedStyles : $5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread($5f8bcde887312b24$var$_objectSpread({}, appearance === "default" && $5f8bcde887312b24$var$defaultStyles), appearance === "primary" && $5f8bcde887312b24$var$primaryStyles), appearance === "link" && $5f8bcde887312b24$var$linkStyles), appearance === "subtle" && $5f8bcde887312b24$var$subtleStyles), appearance === "subtle-link" && $5f8bcde887312b24$var$subtleLinkStyles), appearance === "warning" && $5f8bcde887312b24$var$warningStyles), appearance === "danger" && $5f8bcde887312b24$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $5f8bcde887312b24$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $5f8bcde887312b24$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $5f8bcde887312b24$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $5f8bcde887312b24$var$hasOverlayStyles))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $5f8bcde887312b24$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $2ZUkg.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $5f8bcde887312b24$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: "none"
    });
}
function $5f8bcde887312b24$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $2ZUkg.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $5f8bcde887312b24$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $5f8bcde887312b24$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $2ZUkg.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $5f8bcde887312b24$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("8IwzF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $658bb35e8e1cf298$export$2e2bcd8739ae039; });

var $h7Vgg = parcelRequire("h7Vgg");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $658bb35e8e1cf298$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $658bb35e8e1cf298$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($h7Vgg.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($h7Vgg.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($h7Vgg.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($h7Vgg.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($658bb35e8e1cf298$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($h7Vgg.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($h7Vgg.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($h7Vgg.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($h7Vgg.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($h7Vgg.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($h7Vgg.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($h7Vgg.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($h7Vgg.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($h7Vgg.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($h7Vgg.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($h7Vgg.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($h7Vgg.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($h7Vgg.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($h7Vgg.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($h7Vgg.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($h7Vgg.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($h7Vgg.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($h7Vgg.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($h7Vgg.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($h7Vgg.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($h7Vgg.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($h7Vgg.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($h7Vgg.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($h7Vgg.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($h7Vgg.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($h7Vgg.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($h7Vgg.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($h7Vgg.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($h7Vgg.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($658bb35e8e1cf298$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($h7Vgg.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($h7Vgg.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($h7Vgg.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($h7Vgg.N500, ")"),
                dark: "var(--ds-text, ".concat($h7Vgg.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($h7Vgg.B400, ")"),
                dark: "var(--ds-text, ".concat($h7Vgg.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($h7Vgg.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($h7Vgg.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($h7Vgg.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($h7Vgg.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($h7Vgg.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($h7Vgg.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($h7Vgg.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($h7Vgg.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($h7Vgg.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($h7Vgg.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($h7Vgg.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($h7Vgg.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($h7Vgg.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($h7Vgg.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($h7Vgg.B400, ")"),
                dark: "var(--ds-link, ".concat($h7Vgg.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($h7Vgg.B300, ")"),
                dark: "var(--ds-link, ".concat($h7Vgg.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($h7Vgg.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($h7Vgg.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($h7Vgg.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($h7Vgg.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($h7Vgg.N500, ")"),
                dark: "var(--ds-text, ".concat($h7Vgg.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($h7Vgg.B400, ")"),
                dark: "var(--ds-text, ".concat($h7Vgg.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($h7Vgg.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($h7Vgg.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($h7Vgg.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($h7Vgg.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($h7Vgg.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($h7Vgg.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($h7Vgg.N400, ")"),
                dark: "var(--ds-text, ".concat($h7Vgg.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($h7Vgg.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($h7Vgg.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($h7Vgg.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($h7Vgg.DN400, ")")
            }
        }
    }
};
var $658bb35e8e1cf298$export$2e2bcd8739ae039 = $658bb35e8e1cf298$var$values;

});


parcelRegister("ayqeI", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $7af16e5e79954730$export$20bbd2efb0d734c4; });

var $iSvIT = parcelRequire("iSvIT");

var $ibbno = parcelRequire("ibbno");
var $7af16e5e79954730$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $iSvIT.isValidElement)(children) && children.type === (0, $ibbno.default);
};

});
parcelRegister("ibbno", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3c21427c96bb750$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $iSvIT = parcelRequire("iSvIT");

var $2nOu0 = parcelRequire("2nOu0");
var $d3c21427c96bb750$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $d3c21427c96bb750$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $2nOu0.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $d3c21427c96bb750$export$2e2bcd8739ae039 = $d3c21427c96bb750$var$VisuallyHidden;

});
parcelRegister("2nOu0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bc4e39db8f56c28$export$2e2bcd8739ae039; });
const $1bc4e39db8f56c28$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $1bc4e39db8f56c28$var$ATOMIC_GROUP_LENGTH = 5;
function $1bc4e39db8f56c28$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $1bc4e39db8f56c28$var$UNDERSCORE_UNICODE ? $1bc4e39db8f56c28$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});




parcelRegister("9Ilk6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7128c37258d5e7d8$export$2e2bcd8739ae039; });

var $ayqeI = parcelRequire("ayqeI");
function $7128c37258d5e7d8$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $ayqeI.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("3y1xc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2955bcc3cc1b3368$export$2e2bcd8739ae039; });
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $fOsVV = parcelRequire("fOsVV");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");

var $lxoX2 = parcelRequire("lxoX2");

var $cCILt = parcelRequire("cCILt");

var $brJuY = parcelRequire("brJuY");
var $gpHqF = parcelRequire("gpHqF");
var $9tfK2 = parcelRequire("9tfK2");
var $iERag = parcelRequire("iERag");
var $2955bcc3cc1b3368$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * Using `cssMap` to avoid a Compiled bug with the transformed styles.
 * It was using a CSS variable for the outline template string,
 * which broke because of the use of a sibling selector.
 *
 * Related to: https://github.com/atlassian-labs/compiled/pull/1795
 *
 * Using `cssMap` seems to be a workaround for this.
 */ var $2955bcc3cc1b3368$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $2955bcc3cc1b3368$var$Checkbox = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, $4Onlm.default)(_ref, $2955bcc3cc1b3368$var$_excluded);
    var _useState = (0, $iSvIT.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, $fOsVV.default)(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $lxoX2.usePlatformLeafEventHandler)({
        fn: onChange,
        action: "changed",
        analyticsData: analyticsContext,
        componentName: "checkbox",
        packageName: "@atlaskit/checkbox",
        packageVersion: "17.1.8"
    });
    var internalRef = (0, $iSvIT.useRef)(null);
    var mergedRefs = (0, $cCILt.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $iSvIT.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $iSvIT.createElement((0, $gpHqF.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $iSvIT.createElement("input", (0, $5VbRa.default)({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $8v5gX.default)([
            $2955bcc3cc1b3368$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? "true" : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? "true" : undefined
    })), /*#__PURE__*/ $iSvIT.createElement((0, $brJuY.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $iSvIT.createElement((0, $9tfK2.default), null, label, isRequired && /*#__PURE__*/ $iSvIT.createElement((0, $iERag.default), null)));
}));
$2955bcc3cc1b3368$var$Checkbox.displayName = "Checkbox";
var $2955bcc3cc1b3368$export$2e2bcd8739ae039 = $2955bcc3cc1b3368$var$Checkbox;

});
parcelRegister("8v5gX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63054efdcab9d993$export$2e2bcd8739ae039; });
const $63054efdcab9d993$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $63054efdcab9d993$var$ATOMIC_GROUP_LENGTH = 5;
function $63054efdcab9d993$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $63054efdcab9d993$var$UNDERSCORE_UNICODE ? $63054efdcab9d993$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("cCILt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $930bc1fd0317767f$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $930bc1fd0317767f$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("brJuY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8555826305498644$export$2e2bcd8739ae039; });
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");


var $4c3Jq = parcelRequire("4c3Jq");

var $jxLBU = parcelRequire("jxLBU");
function $8555826305498644$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $jxLBU.fg)("platform-visual-refresh-icons")) return /*#__PURE__*/ $iSvIT.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ $iSvIT.createElement("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $jxLBU.fg)("platform-visual-refresh-icons")) return /*#__PURE__*/ $iSvIT.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ $iSvIT.createElement("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $8555826305498644$var$CheckboxIcon = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $iSvIT.useMemo)(function() {
        return $8555826305498644$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $iSvIT.createElement((0, $4c3Jq.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ $iSvIT.createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $jxLBU.fg)("platform-visual-refresh-icons") ? /*#__PURE__*/ $iSvIT.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5"
    }) : /*#__PURE__*/ $iSvIT.createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $8555826305498644$export$2e2bcd8739ae039 = $8555826305498644$var$CheckboxIcon;

});
parcelRegister("4c3Jq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30db2d75a87973f3$export$2e2bcd8739ae039; });
/* svg.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");
var $30db2d75a87973f3$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
var $30db2d75a87973f3$var$svgStyles = null;
/**
 * __SVG__
 *
 * @deprecated Custom SVG is deprecated and will be removed from `atlaskit/icon` in an upcoming major release. Please use either an existing icon from @atlaskit/icon or @atlaskit/icon-lab, or contributing to @atlaskit/icon-lab directly. For third party logos, use an SVG element along with a label.
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $30db2d75a87973f3$var$SVG = /*#__PURE__*/ (0, $iSvIT.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor
        },
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? "img" : "presentation",
        className: (0, $8v5gX.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw _vc881r31",
            $30db2d75a87973f3$var$sizeStyles[size]
        ])
    }, children);
});
var $30db2d75a87973f3$export$2e2bcd8739ae039 = $30db2d75a87973f3$var$SVG;

});


parcelRegister("gpHqF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf30ab44ee8d8beb$export$2e2bcd8739ae039; });
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");
var $15sNJ = parcelRequire("15sNJ");

var $7370U = parcelRequire("7370U");
var $bf30ab44ee8d8beb$var$baseStyles = null;
var $bf30ab44ee8d8beb$var$textLabelLayoutStyles = null;
var $bf30ab44ee8d8beb$var$disabledStyles = null;
var $bf30ab44ee8d8beb$var$labelStyles = null;
function $bf30ab44ee8d8beb$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $iSvIT.createElement("label", {
        className: (0, $8v5gX.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazovqm _80om73ad",
            label && "_zulp1te3 _yv0ey09t",
            isDisabled && "_syaz7wap _80om13gf",
            "_h5e31kd8 _1nzs1kc0 _1esz1j4g _yp0j1ehr _ay2w1ouc _d51u12ci _phftddza _1g1fe69j _l6wk1j4g _1dik1ehr _1sfg1380 _fpdj1ouc _1yjc3zdg _oaj1ddza _1j3h1380 _eawbxz7c _1rdaeh7q _18q0snw8 _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        style: {
            "--_5xk3r4": (0, $15sNJ.default)("var(--ds-text, ".concat((0, $7370U.N900), ")")),
            "--_1l71759": (0, $15sNJ.default)("var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)")),
            "--_1ynhf1h": (0, $15sNJ.default)("var(--ds-text-disabled, ".concat((0, $7370U.N80), ")")),
            "--_4mkb4g": (0, $15sNJ.default)("var(--ds-background-input, ".concat((0, $7370U.N10), ")")),
            "--_1cd0fcx": (0, $15sNJ.default)("var(--ds-background-input-pressed, ".concat((0, $7370U.B50), ")")),
            "--_1gcp7nr": (0, $15sNJ.default)("var(--ds-background-selected-bold, ".concat((0, $7370U.B400), ")")),
            "--_14y1fod": (0, $15sNJ.default)("var(--ds-background-selected-bold-hovered, ".concat((0, $7370U.B300), ")")),
            "--_r5pknd": (0, $15sNJ.default)("var(--ds-background-disabled, ".concat((0, $7370U.N20), ")")),
            "--_1z08gfx": (0, $15sNJ.default)("var(--ds-background-input-hovered, ".concat((0, $7370U.N30), ")")),
            "--_vnm8xo": (0, $15sNJ.default)("var(--ds-border-input, ".concat((0, $7370U.N100), ")")),
            "--_rczcge": (0, $15sNJ.default)("var(--ds-border, ".concat((0, $7370U.B50), ")")),
            "--_1i4xulb": (0, $15sNJ.default)("var(--ds-border-danger, ".concat((0, $7370U.R300), ")")),
            "--_xjqa3d": (0, $15sNJ.default)("var(--ds-border-focused, ".concat((0, $7370U.B200), ")")),
            "--_uq1ko9": (0, $15sNJ.default)("var(--ds-icon-inverse, ".concat((0, $7370U.B400), ")")),
            "--_jf353p": (0, $15sNJ.default)("var(--ds-icon-inverse, ".concat((0, $7370U.N10), ")")),
            "--_1xmcmw9": (0, $15sNJ.default)("var(--ds-icon-disabled, ".concat((0, $7370U.N70), ")"))
        }
    }, children);
}

});
parcelRegister("15sNJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cac9966554988a9$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $0cac9966554988a9$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("7370U", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $521e40f5d1104470$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $521e40f5d1104470$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "B50", function () { return $521e40f5d1104470$export$226de0355ed012f8; });
$parcel$export(module.exports, "B200", function () { return $521e40f5d1104470$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $521e40f5d1104470$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $521e40f5d1104470$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N10", function () { return $521e40f5d1104470$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $521e40f5d1104470$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $521e40f5d1104470$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N70", function () { return $521e40f5d1104470$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $521e40f5d1104470$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N100", function () { return $521e40f5d1104470$export$d6447c357493214f; });
$parcel$export(module.exports, "N900", function () { return $521e40f5d1104470$export$fbda843f0a27fe96; });
// Reds
var $521e40f5d1104470$export$4b84fd0e2c617bd = "#FFEBE6";
var $521e40f5d1104470$export$b34b069eff244586 = "#FFBDAD";
var $521e40f5d1104470$export$be802dd0d8b57f35 = "#FF8F73";
var $521e40f5d1104470$export$60847d42f9da92a6 = "#FF7452";
var $521e40f5d1104470$export$4a7404f376229999 = "#FF5630";
var $521e40f5d1104470$export$2010d0fb4295b346 = "#DE350B";
var $521e40f5d1104470$export$2837b5a1a71d5c02 = "#BF2600";
var $521e40f5d1104470$export$8d9596b529bbb9cf = "#FFFAE6";
var $521e40f5d1104470$export$41060a744ab0b7ae = "#FFF0B3";
var $521e40f5d1104470$export$1cc05bbbf340e559 = "#FFE380";
var $521e40f5d1104470$export$5aae31392d72caaa = "#FFC400";
var $521e40f5d1104470$export$c6930421db9fa514 = "#FFAB00";
var $521e40f5d1104470$export$59619663aa6500fb = "#FF991F";
var $521e40f5d1104470$export$874739ea9e379ab6 = "#FF8B00";
var $521e40f5d1104470$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $521e40f5d1104470$export$69a3bf21b9686c2b = "#ABF5D1";
var $521e40f5d1104470$export$afbce1382ec95f73 = "#79F2C0";
var $521e40f5d1104470$export$747d86715d4175de = "#57D9A3";
var $521e40f5d1104470$export$940e1f69e873f202 = "#36B37E";
var $521e40f5d1104470$export$a49394138f7b8e85 = "#00875A";
var $521e40f5d1104470$export$6fa04827ac68a4fb = "#006644";
var $521e40f5d1104470$export$226de0355ed012f8 = "#DEEBFF";
var $521e40f5d1104470$export$8c13c2ee36917869 = "#B3D4FF";
var $521e40f5d1104470$export$ecfc1dff386a3e7a = "#4C9AFF";
var $521e40f5d1104470$export$215b7063051591f1 = "#2684FF";
var $521e40f5d1104470$export$e62e8919cca44969 = "#0065FF";
var $521e40f5d1104470$export$b3de0ae08da2ce64 = "#0052CC";
var $521e40f5d1104470$export$a6ee3d71bc067634 = "#0747A6";
var $521e40f5d1104470$export$67f15409e87642a1 = "#669DF1";
var $521e40f5d1104470$export$f0539dbc42dbb067 = "#8FB8F6";
var $521e40f5d1104470$export$363e4475840015bb = "#EAE6FF";
var $521e40f5d1104470$export$4b0a4417ed59760f = "#C0B6F2";
var $521e40f5d1104470$export$6011520a64d9a187 = "#998DD9";
var $521e40f5d1104470$export$a7175d4e9206bc80 = "#8777D9";
var $521e40f5d1104470$export$b48405b95304b5a1 = "#6554C0";
var $521e40f5d1104470$export$c71e4279dd54a18d = "#5243AA";
var $521e40f5d1104470$export$147899de772240ec = "#403294";
var $521e40f5d1104470$export$2cf711fe14c66f06 = "#E6FCFF";
var $521e40f5d1104470$export$7a8f4d33f6f9772c = "#B3F5FF";
var $521e40f5d1104470$export$776c9c497ef08533 = "#79E2F2";
var $521e40f5d1104470$export$69cb3ca10c1e330e = "#00C7E6";
var $521e40f5d1104470$export$9dc1ef0f3f48059b = "#00B8D9";
var $521e40f5d1104470$export$7c835c78b6fcdef8 = "#00A3BF";
var $521e40f5d1104470$export$6036577f95c3877e = "#008DA6";
var $521e40f5d1104470$export$29a4f05edc054374 = "#FFFFFF";
var $521e40f5d1104470$export$e655ef011c4aa1a2 = "#FAFBFC";
var $521e40f5d1104470$export$9fdfb749e33cdf97 = "#F4F5F7";
var $521e40f5d1104470$export$3e51e8f1440314ba = "#EBECF0";
var $521e40f5d1104470$export$1ce2d1575d444ceb = "#DFE1E6";
var $521e40f5d1104470$export$8754fc7e6d8b3000 = "#C1C7D0";
var $521e40f5d1104470$export$c2e91cbeada39b8b = "#B3BAC5";
var $521e40f5d1104470$export$5f71e19f3a7ad9de = "#A5ADBA";
var $521e40f5d1104470$export$eaa8c8a70ac22806 = "#97A0AF";
var $521e40f5d1104470$export$7c87d337fb91a97d = "#8993A4";
var $521e40f5d1104470$export$d6447c357493214f = "#7A869A";
var $521e40f5d1104470$export$f563ee71e9ee74cd = "#6B778C";
var $521e40f5d1104470$export$e2ef2124cf4024b1 = "#5E6C84";
var $521e40f5d1104470$export$eece5f492e429f08 = "#505F79";
var $521e40f5d1104470$export$c39c0fe0f26207ae = "#42526E";
var $521e40f5d1104470$export$7090862dc3038a9f = "#344563";
var $521e40f5d1104470$export$ad0bacf983b7ddaa = "#253858";
var $521e40f5d1104470$export$7d61b15e0da132af = "#172B4D";
var $521e40f5d1104470$export$fbda843f0a27fe96 = "#091E42";
var $521e40f5d1104470$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $521e40f5d1104470$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $521e40f5d1104470$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $521e40f5d1104470$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $521e40f5d1104470$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $521e40f5d1104470$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $521e40f5d1104470$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $521e40f5d1104470$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $521e40f5d1104470$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $521e40f5d1104470$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $521e40f5d1104470$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $521e40f5d1104470$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $521e40f5d1104470$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $521e40f5d1104470$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $521e40f5d1104470$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $521e40f5d1104470$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $521e40f5d1104470$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $521e40f5d1104470$export$2f6319cf7d736c2a = "#E6EDFA";
var $521e40f5d1104470$export$95126bc8884d6634 = "#DCE5F5";
var $521e40f5d1104470$export$8338d8c35d44ff1 = "#CED9EB";
var $521e40f5d1104470$export$5368d76ae4fbbda7 = "#B8C7E0";
var $521e40f5d1104470$export$9f0a771d16ec8d36 = "#ABBBD6";
var $521e40f5d1104470$export$abcf8c38338b4aa5 = "#9FB0CC";
var $521e40f5d1104470$export$97e81faa16a182c7 = "#8C9CB8";
var $521e40f5d1104470$export$bfe21c59123ecf33 = "#7988A3";
var $521e40f5d1104470$export$ee82aa2ea6a1558 = "#67758F";
var $521e40f5d1104470$export$682927c6ed76be02 = "#56637A";
var $521e40f5d1104470$export$91fd9994c5be9757 = "#455166";
var $521e40f5d1104470$export$d281fbfe3cff2df6 = "#3B475C";
var $521e40f5d1104470$export$3902c91d8b98a753 = "#313D52";
var $521e40f5d1104470$export$8e8133c1ba5845b5 = "#283447";
var $521e40f5d1104470$export$33ff357f6620b39 = "#202B3D";
var $521e40f5d1104470$export$633847cf062b69e0 = "#1B2638";
var $521e40f5d1104470$export$9776a6e503bdbf76 = "#121A29";
var $521e40f5d1104470$export$6c813d5160dff5db = "#0E1624";
var $521e40f5d1104470$export$3d4f271a500072a = "#0D1424";
var $521e40f5d1104470$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $521e40f5d1104470$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $521e40f5d1104470$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $521e40f5d1104470$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $521e40f5d1104470$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $521e40f5d1104470$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $521e40f5d1104470$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $521e40f5d1104470$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $521e40f5d1104470$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $521e40f5d1104470$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $521e40f5d1104470$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $521e40f5d1104470$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $521e40f5d1104470$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $521e40f5d1104470$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $521e40f5d1104470$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $521e40f5d1104470$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $521e40f5d1104470$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $521e40f5d1104470$export$d2adc5dedf09fced = "#292A2E";
var $521e40f5d1104470$export$f51762073d2bb381 = "#94C748";
var $521e40f5d1104470$export$95e26d54def96891 = "#B3DF72";

});


parcelRegister("9tfK2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e530871818fb12c$export$2e2bcd8739ae039; });
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");
var $6e530871818fb12c$var$labelTextStyles = null;
function $6e530871818fb12c$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $8v5gX.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

});

parcelRegister("iERag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d95533d147430f03$export$2e2bcd8739ae039; });
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");
var $15sNJ = parcelRequire("15sNJ");

var $7370U = parcelRequire("7370U");
var $d95533d147430f03$var$requiredIndicatorStyles = null;
function $d95533d147430f03$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "aria-hidden": true,
        className: (0, $8v5gX.default)([
            "_syaz1ml5 _bozgv77o"
        ]),
        style: {
            "--_1xw92dq": (0, $15sNJ.default)("var(--ds-text-danger, ".concat((0, $7370U.R500), ")"))
        }
    }, "*");
}

});


parcelRegister("1yYoC", function(module, exports) {

$parcel$export(module.exports, "FormContext", function () { return $1237d0ccf408c450$export$c24727297075ec6a; });
$parcel$export(module.exports, "IsDisabledContext", function () { return $1237d0ccf408c450$export$c17cf6b332a82dbc; });
$parcel$export(module.exports, "default", function () { return $1237d0ccf408c450$export$2e2bcd8739ae039; });

var $5VbRa = parcelRequire("5VbRa");

var $fACfu = parcelRequire("fACfu");

var $fOsVV = parcelRequire("fOsVV");

var $iSvIT = parcelRequire("iSvIT");

var $cJbdZ = parcelRequire("cJbdZ");

var $4Q2tx = parcelRequire("4Q2tx");

var $1laVI = parcelRequire("1laVI");

var $hQhXc = parcelRequire("hQhXc");

var $blKWW = parcelRequire("blKWW");

var $jxLBU = parcelRequire("jxLBU");

var $8h3Q2 = parcelRequire("8h3Q2");
function $1237d0ccf408c450$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1237d0ccf408c450$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1237d0ccf408c450$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1237d0ccf408c450$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1237d0ccf408c450$export$c24727297075ec6a = /*#__PURE__*/ (0, $iSvIT.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var $1237d0ccf408c450$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
var $1237d0ccf408c450$var$FormBase = function FormBase(props, ref) {
    var autocomplete = props.autocomplete, userProvidedFormProps = props.formProps, id = props.id, label = props.label, labelId = props.labelId, name = props.name, noValidate = props.noValidate, onSubmit = props.onSubmit, testId = props.testId, xcss = props.xcss;
    var formRef = (0, $iSvIT.useRef)(null);
    var onSubmitRef = (0, $iSvIT.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    var _useState = (0, $iSvIT.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $cJbdZ.createForm)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, $fOsVV.default)(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === "function" ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($1laVI)))(initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($1laVI)))(values, name, _value);
                    }
                }
            }
        });
        (0, $4Q2tx.default)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll("input")) : [];
        }, (0, $jxLBU.fg)("platform-form-field-error-focus") ? (0, $8h3Q2.getFirstErrorField) : undefined)(finalForm);
        return finalForm;
    }), _useState2 = (0, $fOsVV.default)(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $iSvIT.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, $fOsVV.default)(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $iSvIT.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $iSvIT.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === "Enter" && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $iSvIT.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $iSvIT.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    var conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        "aria-label": label,
        "aria-labelledby": labelId,
        name: name,
        noValidate: noValidate,
        "data-testid": testId
    };
    // Abstracting so we can use the same for both rendering patterns
    var formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $blKWW.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach(function(attr) {
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    var childrenContent = function() {
        if (typeof children === "function") {
            var result = children.length > 0 ? children($1237d0ccf408c450$var$_objectSpread({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: function getState() {
                    return form.getState();
                },
                getValues: function getValues() {
                    return form.getState().values;
                },
                setFieldValue: form.change
            }, (0, $jxLBU.fg)("platform-form-reset-field-state") && {
                resetFieldState: form.resetFieldState
            })) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("form", (0, $5VbRa.default)({}, formProps, userProvidedFormProps), children);
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($1237d0ccf408c450$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($1237d0ccf408c450$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, childrenContent));
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ var $1237d0ccf408c450$var$Form = (0, $hQhXc.default)($1237d0ccf408c450$var$FormBase);
var $1237d0ccf408c450$export$2e2bcd8739ae039 = $1237d0ccf408c450$var$Form;

});
parcelRegister("hQhXc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfd53842b147bbd6$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $cfd53842b147bbd6$export$2e2bcd8739ae039 = (0, $iSvIT.forwardRef);

});

parcelRegister("blKWW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8436131ebb1e1bda$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $8436131ebb1e1bda$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("8h3Q2", function(module, exports) {

$parcel$export(module.exports, "getFirstErrorField", function () { return $6062e37494387721$export$fc06342dc8588d3b; });

var $cJbdZ = parcelRequire("cJbdZ");
var $6062e37494387721$export$fc06342dc8588d3b = function getFirstErrorField(inputs, errors) {
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    var htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === "hidden") return false;
        // If input ID matches the error, focus
        if (input.id && (0, $cJbdZ.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $cJbdZ.getIn)(errors, input.name);
    });
};

});


parcelRegister("bIEuP", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", function () { return $888337749e5ae678$export$8fbe3c7d0ed2c683; });
$parcel$export(module.exports, "ErrorMessage", function () { return $888337749e5ae678$export$915e9e7bd4f0f96d; });
$parcel$export(module.exports, "ValidMessage", function () { return $888337749e5ae678$export$5505afb209a532c8; });
$parcel$export(module.exports, "MessageWrapper", function () { return $888337749e5ae678$export$ec445f12f63100a5; });
/* messages.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $fOsVV = parcelRequire("fOsVV");

var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");

var $58uPW = parcelRequire("58uPW");

var $EbaUf = parcelRequire("EbaUf");

var $jxLBU = parcelRequire("jxLBU");

var $j52hW = parcelRequire("j52hW");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $888337749e5ae678$var$messageStyles = null;
var $888337749e5ae678$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
var $888337749e5ae678$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
var $888337749e5ae678$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $8v5gX.default)([
            $888337749e5ae678$var$iconWrapperStyles.root
        ])
    }, children);
};
var $888337749e5ae678$var$messageIcons = {
    error: /*#__PURE__*/ $iSvIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($58uPW))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ $iSvIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($EbaUf))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
var $888337749e5ae678$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $888337749e5ae678$var$messageIcons[appearance];
    var _useContext = (0, $iSvIT.useContext)($888337749e5ae678$var$MessageWrapperContext), isWrapper = _useContext.isWrapper;
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $fOsVV.default)(_useState, 2), shouldRenderAfterDelay = _useState2[0], setShouldRenderAfterDelay = _useState2[1];
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    var isDelayRenderEnabled = (0, $jxLBU.fg)("platform_dst_form_screenreader_message_fix") && !isWrapper;
    (0, $iSvIT.useEffect)(function() {
        if (isDelayRenderEnabled) {
            // Only delay rendering if there is no wrapper and feature flag is enabled
            var timer = setTimeout(function() {
                setShouldRenderAfterDelay(true);
            }, 10);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        isDelayRenderEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === "string" ? children : /*#__PURE__*/ $iSvIT.createElement("span", null, children);
    var childrenToRender = /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), null, icon && /*#__PURE__*/ $iSvIT.createElement($888337749e5ae678$var$IconWrapper, null, icon), content);
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        "aria-live": !isWrapper ? "polite" : undefined,
        className: (0, $8v5gX.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $888337749e5ae678$var$messageAppearanceStyles[appearance]
        ])
    }, isDelayRenderEnabled ? shouldRenderAfterDelay && childrenToRender : childrenToRender);
};
var $888337749e5ae678$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $iSvIT.createElement((0, $j52hW.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $iSvIT.createElement($888337749e5ae678$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $888337749e5ae678$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return /*#__PURE__*/ $iSvIT.createElement((0, $j52hW.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $iSvIT.createElement($888337749e5ae678$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $888337749e5ae678$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return /*#__PURE__*/ $iSvIT.createElement((0, $j52hW.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $iSvIT.createElement($888337749e5ae678$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ var $888337749e5ae678$var$MessageWrapperContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    isWrapper: false
});
var $888337749e5ae678$export$ec445f12f63100a5 = function MessageWrapper(_ref6) {
    var children = _ref6.children;
    var contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ $iSvIT.createElement($888337749e5ae678$var$MessageWrapperContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("58uPW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bd59ea031e34d2d$var$_react = $3bd59ea031e34d2d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3bd59ea031e34d2d$var$_statusError = $3bd59ea031e34d2d$var$_interopRequireDefault((parcelRequire("dmP23")));

var $3bd59ea031e34d2d$var$_error = $3bd59ea031e34d2d$var$_interopRequireDefault((parcelRequire("fNE2h")));
function $3bd59ea031e34d2d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bd59ea031e34d2d$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $3bd59ea031e34d2d$var$_react.default.createElement($3bd59ea031e34d2d$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $3bd59ea031e34d2d$var$_error.default
    }, props));
$3bd59ea031e34d2d$var$StatusErrorIcon.displayName = "StatusErrorIconMigration";
var $3bd59ea031e34d2d$var$_default = module.exports.default = $3bd59ea031e34d2d$var$StatusErrorIcon;

});
parcelRegister("dmP23", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bb4ea58c0612921$var$_react = $9bb4ea58c0612921$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9bb4ea58c0612921$var$_baseNew = $9bb4ea58c0612921$var$_interopRequireDefault((parcelRequire("hZbUR")));
function $9bb4ea58c0612921$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9bb4ea58c0612921$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $9bb4ea58c0612921$var$_react.default.createElement($9bb4ea58c0612921$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$9bb4ea58c0612921$var$StatusErrorIcon.displayName = "StatusErrorIcon";
var $9bb4ea58c0612921$var$_default = module.exports.default = $9bb4ea58c0612921$var$StatusErrorIcon;

});
parcelRegister("hZbUR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9gwiO")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("9gwiO")).Icon; });

var $9gwiO = parcelRequire("9gwiO");

});
parcelRegister("9gwiO", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $6beeaa49130a0b8f$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $6beeaa49130a0b8f$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");

var $jxLBU = parcelRequire("jxLBU");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $6beeaa49130a0b8f$var$svgStyles = null;
var $6beeaa49130a0b8f$var$iconStyles = null;
var $6beeaa49130a0b8f$var$utilityIconStyles = null;
var $6beeaa49130a0b8f$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $6beeaa49130a0b8f$var$baseHcmStyles = null;
var $6beeaa49130a0b8f$var$scaleSize = null;
var $6beeaa49130a0b8f$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $6beeaa49130a0b8f$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $6beeaa49130a0b8f$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $6beeaa49130a0b8f$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $6beeaa49130a0b8f$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $6beeaa49130a0b8f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $jxLBU.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return /*#__PURE__*/ $iSvIT.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core";
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = $6beeaa49130a0b8f$var$baseSizeMap[type];
    var viewBoxPadding = $6beeaa49130a0b8f$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $8v5gX.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === "utility" || size === "small") && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $8v5gX.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === "utility" ? $6beeaa49130a0b8f$var$utilSizes[spacing] : size === "small" ? $6beeaa49130a0b8f$var$coreSizeSmall[spacing] : $6beeaa49130a0b8f$var$coreSizeMedium[spacing]
        ])
    }));
});
var $6beeaa49130a0b8f$export$2e2bcd8739ae039 = $6beeaa49130a0b8f$export$f04a61298a47a40f;

});



parcelRegister("fNE2h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b80a7ce93db44769$var$_react = $b80a7ce93db44769$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $aIzjI = parcelRequire("aIzjI");
function $b80a7ce93db44769$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b80a7ce93db44769$var$ErrorIcon = (props)=>/*#__PURE__*/ $b80a7ce93db44769$var$_react.default.createElement($aIzjI.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$b80a7ce93db44769$var$ErrorIcon.displayName = "ErrorIcon";
var $b80a7ce93db44769$var$_default = module.exports.default = $b80a7ce93db44769$var$ErrorIcon;

});
parcelRegister("aIzjI", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $7cd968ab035384de$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $fACfu = parcelRequire("fACfu");

var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");
function $7cd968ab035384de$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7cd968ab035384de$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7cd968ab035384de$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7cd968ab035384de$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $7cd968ab035384de$var$iconStyles = null;
var $7cd968ab035384de$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $7cd968ab035384de$var$baseHcmStyles = null;
var $7cd968ab035384de$var$primaryEqualsSecondaryHcmStyles = null;
var $7cd968ab035384de$var$secondaryTransparentHcmStyles = null;
var $7cd968ab035384de$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $iSvIT.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + "px",
        height: height + "px"
    } : null;
    return /*#__PURE__*/ $iSvIT.createElement("span", (0, $5VbRa.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $7cd968ab035384de$var$_objectSpread($7cd968ab035384de$var$_objectSpread({}, customDimensions), {}, {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $8v5gX.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === "transparent" && "_4fyi1j28",
            size && $7cd968ab035384de$var$sizeStyles[size]
        ])
    }));
});
var $7cd968ab035384de$export$2e2bcd8739ae039 = $7cd968ab035384de$export$f04a61298a47a40f;

});



parcelRegister("EbaUf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $078c67a51e3958cf$var$_react = $078c67a51e3958cf$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $078c67a51e3958cf$var$_statusSuccess = $078c67a51e3958cf$var$_interopRequireDefault((parcelRequire("bgmDL")));

var $078c67a51e3958cf$var$_success = $078c67a51e3958cf$var$_interopRequireDefault((parcelRequire("b9BrP")));
function $078c67a51e3958cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $078c67a51e3958cf$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $078c67a51e3958cf$var$_react.default.createElement($078c67a51e3958cf$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $078c67a51e3958cf$var$_success.default
    }, props));
$078c67a51e3958cf$var$StatusSuccessIcon.displayName = "StatusSuccessIconMigration";
var $078c67a51e3958cf$var$_default = module.exports.default = $078c67a51e3958cf$var$StatusSuccessIcon;

});
parcelRegister("bgmDL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8332c037a97604ef$var$_react = $8332c037a97604ef$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8332c037a97604ef$var$_baseNew = $8332c037a97604ef$var$_interopRequireDefault((parcelRequire("hZbUR")));
function $8332c037a97604ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8332c037a97604ef$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $8332c037a97604ef$var$_react.default.createElement($8332c037a97604ef$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$8332c037a97604ef$var$StatusSuccessIcon.displayName = "StatusSuccessIcon";
var $8332c037a97604ef$var$_default = module.exports.default = $8332c037a97604ef$var$StatusSuccessIcon;

});

parcelRegister("b9BrP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81ed955b0796d591$var$_react = $81ed955b0796d591$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $aIzjI = parcelRequire("aIzjI");
function $81ed955b0796d591$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $81ed955b0796d591$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $81ed955b0796d591$var$_react.default.createElement($aIzjI.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$81ed955b0796d591$var$EditorSuccessIcon.displayName = "EditorSuccessIcon";
var $81ed955b0796d591$var$_default = module.exports.default = $81ed955b0796d591$var$EditorSuccessIcon;

});


parcelRegister("j52hW", function(module, exports) {

$parcel$export(module.exports, "FieldId", function () { return $de404261adc90aa4$export$3c4232819458a302; });

var $iSvIT = parcelRequire("iSvIT");
var $de404261adc90aa4$export$3c4232819458a302 = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);

});


parcelRegister("e7pIZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a475ac7cf775344b$export$2e2bcd8739ae039; });
/* field.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $fACfu = parcelRequire("fACfu");

var $fOsVV = parcelRequire("fOsVV");

var $132G4 = parcelRequire("132G4");

var $8v5gX = parcelRequire("8v5gX");

var $iSvIT = parcelRequire("iSvIT");

var $dvjDi = parcelRequire("dvjDi");

var $j52hW = parcelRequire("j52hW");

var $1yYoC = parcelRequire("1yYoC");

var $lgurO = parcelRequire("lgurO");

var $bIEuP = parcelRequire("bIEuP");

var $eWtZW = parcelRequire("eWtZW");
function $a475ac7cf775344b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a475ac7cf775344b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a475ac7cf775344b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a475ac7cf775344b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a475ac7cf775344b$var$fieldWrapperStyles = null;
function $a475ac7cf775344b$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $a475ac7cf775344b$var$isFunction(x) {
    return typeof x === "function";
}
// Must be exported to satisfy error TS4023 from Jira builds
// src/packages/servicedesk/virtual-agent/common/src/ui/base-text-field/index.tsx(10,14):
// error TS4023: Exported variable `BaseTextField` has or is using name
// `FieldComponentProps` from external module
// `/opt/atlassian/pipelines/agent/build/jira/tsDist/@atlaskit__form/app/src/field`
// but cannot be named.
function $a475ac7cf775344b$var$usePreviousRef(current) {
    var ref = (0, $iSvIT.useRef)(current);
    // will be updated on the next render
    (0, $iSvIT.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $a475ac7cf775344b$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === "function" && typeof currentValue === "function") return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, $132G4.default)(previousValue) === "object" && (0, $132G4.default)(currentValue) === "object") return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $a475ac7cf775344b$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _props$children = props.children, children = _props$children === void 0 ? function() {
        return null;
    } : _props$children, component = props.component;
    var _useContext = (0, $iSvIT.useContext)((0, $1yYoC.FormContext)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $iSvIT.useContext)((0, $1yYoC.IsDisabledContext)) || props.isDisabled || false;
    var defaultValue = $a475ac7cf775344b$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $a475ac7cf775344b$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$a475ac7cf775344b$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $iSvIT.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explicitly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, $fOsVV.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $a475ac7cf775344b$var$usePreviousRef(state);
    (0, $iSvIT.useEffect)(function() {
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $a475ac7cf775344b$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($a475ac7cf775344b$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === "checkbox") {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var uid = (0, $dvjDi.useId)();
    var fieldId = (0, $iSvIT.useMemo)(function() {
        return props.id ? props.id : "".concat(props.name, "-").concat(uid);
    }, [
        props.id,
        props.name,
        uid
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = "";
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $a475ac7cf775344b$var$_objectSpread($a475ac7cf775344b$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        "aria-invalid": state.error ? "true" : "false",
        "aria-describedby": getDescribedBy(),
        "aria-labelledby": "".concat(fieldId, "-label"),
        id: fieldId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        "data-testid": props.testId,
        className: (0, $8v5gX.default)([
            "_1pfhu2gc"
        ])
    }, props.label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lgurO.Label), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eWtZW.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $j52hW.FieldId).Provider, {
        value: fieldId
    }, component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, component({
        fieldProps: extendedFieldProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bIEuP.MessageWrapper), null, props.helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bIEuP.HelperMessage), null, props.helperMessage), state.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bIEuP.ErrorMessage), null, props.errorMessage || state.error), state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bIEuP.ValidMessage), null, props.validMessage))) : children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("dvjDi", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $9d4d664a197407ea$export$f680877a34711e37; });

var $132G4 = parcelRequire("132G4");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $jxLBU = parcelRequire("jxLBU");
var $9d4d664a197407ea$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $9d4d664a197407ea$var$react18UseId = ($9d4d664a197407ea$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $9d4d664a197407ea$var$_React$useId !== void 0 ? $9d4d664a197407ea$var$_React$useId : undefined;
function $9d4d664a197407ea$export$f680877a34711e37() {
    if ($9d4d664a197407ea$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        if ((0, $jxLBU.fg)("platform-dst-react-18-use-id-selector-safe")) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $9d4d664a197407ea$var$react18UseId().replace(/[:«»]/g, "_");
        return $9d4d664a197407ea$var$react18UseId();
    }
    return "uid".concat((0, $lzzak.useUID)());
}
var $9d4d664a197407ea$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($9d4d664a197407ea$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $132G4.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $132G4.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $9d4d664a197407ea$export$6ee17796e3d70de2() {
    if ($9d4d664a197407ea$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $9d4d664a197407ea$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $lzzak.useUIDSeed)();
}

});

parcelRegister("lgurO", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $f7b2b5dd4100e490$export$b04be29aa201d4f5; });
$parcel$export(module.exports, "Legend", function () { return $f7b2b5dd4100e490$export$ed247974535929c7; });
/* label.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");
var $f7b2b5dd4100e490$var$fieldsetLabelStyles = null;
var $f7b2b5dd4100e490$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return /*#__PURE__*/ $iSvIT.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $8v5gX.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};
var $f7b2b5dd4100e490$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $iSvIT.createElement("legend", {
        className: (0, $8v5gX.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};

});

parcelRegister("eWtZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae0dc0722e32ede8$export$2e2bcd8739ae039; });
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");
var $ae0dc0722e32ede8$var$requiredIndicatorStyles = null;
function $ae0dc0722e32ede8$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $8v5gX.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ])
    }, "*");
}

});


parcelRegister("1xDXj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11f7ddd9d941dd77$export$2e2bcd8739ae039; });
/* fieldset.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");

var $lgurO = parcelRequire("lgurO");
var $11f7ddd9d941dd77$var$fieldSetStyles = null;
/**
 * __Fieldset__
 *
 * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
 * a fieldset can be used to group them together. This makes the form more accessible.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 */ var $11f7ddd9d941dd77$var$Fieldset = function Fieldset(_ref) {
    var children = _ref.children, legend = _ref.legend;
    return /*#__PURE__*/ $iSvIT.createElement("fieldset", {
        className: (0, $8v5gX.default)([
            "_1pfhu2gc"
        ])
    }, legend && /*#__PURE__*/ $iSvIT.createElement((0, $lgurO.Legend), null, legend), children);
};
var $11f7ddd9d941dd77$export$2e2bcd8739ae039 = $11f7ddd9d941dd77$var$Fieldset;

});

parcelRegister("aKVSf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d4b17cd71a79f59$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");

var $3H6bl = parcelRequire("3H6bl");

var $jxLBU = parcelRequire("jxLBU");

var $cswM7 = parcelRequire("cswM7");
var $ghwNg = parcelRequire("ghwNg");
var $7d4b17cd71a79f59$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $7d4b17cd71a79f59$var$styles = {
    visitedLink: "_ect41gqc _1053w7te _1ienw7te _n0fxw7te _1vhvg3x0",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz14q2 _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj14q2 _9oik1r31 _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h16c2",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syaz1gjq _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1gjq _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31gjq _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h1fxt",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n4jp4b _kqswh2mm _152ttb3r"
};
var $7d4b17cd71a79f59$var$iconStyles = null;
var $7d4b17cd71a79f59$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, preventedClassName = _ref.className, preventedStyle = _ref.style, htmlAttributes = (0, $4Onlm.default)(_ref, $7d4b17cd71a79f59$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement((0, $cswM7.default), (0, $5VbRa.default)({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $3H6bl.cx)(appearance === "default" && $7d4b17cd71a79f59$var$styles.defaultAppearance, appearance === "subtle" && $7d4b17cd71a79f59$var$styles.subtleAppearance, appearance === "inverse" && $7d4b17cd71a79f59$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== "inverse" && $7d4b17cd71a79f59$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === "_blank" && /*#__PURE__*/ $iSvIT.createElement((0, $ghwNg.default), {
        as: "span",
        xcss: $7d4b17cd71a79f59$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", (0, $jxLBU.fg)("platform-visual-refresh-icons") ? /*#__PURE__*/ $iSvIT.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $8v5gX.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    })) : /*#__PURE__*/ $iSvIT.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: (0, $8v5gX.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ $iSvIT.createElement("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $7d4b17cd71a79f59$var$Link = /*#__PURE__*/ (0, $iSvIT.forwardRef)($7d4b17cd71a79f59$var$LinkWithoutRef);
var $7d4b17cd71a79f59$export$2e2bcd8739ae039 = $7d4b17cd71a79f59$var$Link;

});
parcelRegister("3H6bl", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $2b0a2edd97d5e4c0$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("iSvIT");


var $61hbH = parcelRequire("61hbH");
var $2b0a2edd97d5e4c0$var$_createStrictAPI = (0, $61hbH.createStrictAPI)(), $2b0a2edd97d5e4c0$var$XCSSProp = $2b0a2edd97d5e4c0$var$_createStrictAPI.XCSSProp, $2b0a2edd97d5e4c0$export$dbf350e5966cf602 = $2b0a2edd97d5e4c0$var$_createStrictAPI.css, $2b0a2edd97d5e4c0$export$eb1ecd84a24ee424 = $2b0a2edd97d5e4c0$var$_createStrictAPI.cssMap, $2b0a2edd97d5e4c0$export$a274e22fb40f762e = $2b0a2edd97d5e4c0$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("61hbH", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $46202b355834c9b1$export$39716b4af53f4ad; });

var $eCDwP = parcelRequire("eCDwP");

var $c3Rw5 = parcelRequire("c3Rw5");
function $46202b355834c9b1$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $eCDwP.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $eCDwP.createStrictSetupError)();
        },
        cx: $c3Rw5.cx,
        XCSSProp () {
            throw (0, $eCDwP.createStrictSetupError)();
        }
    };
}

});
parcelRegister("eCDwP", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $aa5346d507651f7d$export$c4df1cb0c2b4d77c; });
const $aa5346d507651f7d$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $aa5346d507651f7d$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("c3Rw5", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $8c7f4720a69d6e6b$export$a274e22fb40f762e; });

var $9AVkE = parcelRequire("9AVkE");
const $8c7f4720a69d6e6b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $9AVkE.default)(actualStyles);
};

});
parcelRegister("9AVkE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fc3f2cba2419dbb$export$2e2bcd8739ae039; });
const $6fc3f2cba2419dbb$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $6fc3f2cba2419dbb$var$ATOMIC_GROUP_LENGTH = 5;
function $6fc3f2cba2419dbb$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $6fc3f2cba2419dbb$var$UNDERSCORE_UNICODE ? $6fc3f2cba2419dbb$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});




parcelRegister("cswM7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $912186077e97fa81$export$2e2bcd8739ae039; });
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $132G4 = parcelRequire("132G4");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");


var $f9DLK = parcelRequire("f9DLK");

var $jNYFj = parcelRequire("jNYFj");

var $cOSXI = parcelRequire("cOSXI");

var $c2v1B = parcelRequire("c2v1B");

var $aFqvt = parcelRequire("aFqvt");

var $lLTmq = parcelRequire("lLTmq");

var $bl6zx = parcelRequire("bl6zx");

var $ibbno = parcelRequire("ibbno");

var $aFurW = parcelRequire("aFurW");
var $912186077e97fa81$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $912186077e97fa81$var$_excluded2 = [
    "className"
];
var $912186077e97fa81$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi"
};
var $912186077e97fa81$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $912186077e97fa81$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $912186077e97fa81$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $aFqvt.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? "(opens new window)" : _ref$newWindowLabel, htmlAttributes = (0, $4Onlm.default)(_ref, $912186077e97fa81$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $bl6zx.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $lLTmq.useId)();
    var onClick = (0, $cOSXI.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.0",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $4Onlm.default)(htmlAttributes, $912186077e97fa81$var$_excluded2);
    var RouterLink = (0, $c2v1B.default)();
    var isExternal = typeof href === "string" && $912186077e97fa81$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $912186077e97fa81$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $132G4.default)(href) === "object";
    (0, $jNYFj.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return /*#__PURE__*/ $iSvIT.createElement((0, $aFurW.default), (0, $5VbRa.default)({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $f9DLK.cx)($912186077e97fa81$var$styles.root, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $iSvIT.createElement((0, $ibbno.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $912186077e97fa81$var$Anchor = /*#__PURE__*/ (0, $iSvIT.forwardRef)($912186077e97fa81$var$AnchorNoRef);
var $912186077e97fa81$export$2e2bcd8739ae039 = $912186077e97fa81$var$Anchor;

});
parcelRegister("f9DLK", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $b0868b9be3f1623b$export$a274e22fb40f762e; });

var $8v5gX = parcelRequire("8v5gX");
const $b0868b9be3f1623b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $8v5gX.default)(actualStyles);
};

});

parcelRegister("cOSXI", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $9554c9e1e8b2b292$export$a4687b0234b40e28; });

var $fACfu = parcelRequire("fACfu");

var $iSvIT = parcelRequire("iSvIT");

var $k99nH = parcelRequire("k99nH");

var $jX9QM = parcelRequire("jX9QM");
function $9554c9e1e8b2b292$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9554c9e1e8b2b292$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9554c9e1e8b2b292$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9554c9e1e8b2b292$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9554c9e1e8b2b292$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $k99nH.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $jX9QM.useTrackedRef)(analyticsData);
    var fnRef = (0, $jX9QM.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $9554c9e1e8b2b292$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("k99nH", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $eaabecd856ed4cf9$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $67aXD = parcelRequire("67aXD");

var $eKbqg = parcelRequire("eKbqg");
function $eaabecd856ed4cf9$export$5bf35293e545f20c() {
    var analyticsContext = (0, $eKbqg.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $67aXD.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("67aXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $473be61bec56002e$export$2e2bcd8739ae039; });

var $d5B2s = parcelRequire("d5B2s");

var $6ji6y = parcelRequire("6ji6y");

var $ehCmD = parcelRequire("ehCmD");

var $cMQbY = parcelRequire("cMQbY");

var $lTcQE = parcelRequire("lTcQE");

var $dISfo = parcelRequire("dISfo");

var $llkr9 = parcelRequire("llkr9");

var $fACfu = parcelRequire("fACfu");

var $gMj4m = parcelRequire("gMj4m");
function $473be61bec56002e$var$_callSuper(t, o, e) {
    return o = (0, $lTcQE.default)(o), (0, $cMQbY.default)(t, $473be61bec56002e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $lTcQE.default)(t).constructor) : o.apply(t, e));
}
function $473be61bec56002e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($473be61bec56002e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $473be61bec56002e$var$_superPropGet(t, o, e, r) {
    var p = (0, $dISfo.default)((0, $lTcQE.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $473be61bec56002e$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $473be61bec56002e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $473be61bec56002e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $6ji6y.default)(this, UIAnalyticsEvent);
        _this = $473be61bec56002e$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $fACfu.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $fACfu.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $d5B2s.default)(_this.context);
            var handlers = (0, $d5B2s.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $fACfu.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $llkr9.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $ehCmD.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $473be61bec56002e$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $gMj4m.default));

});
parcelRegister("gMj4m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c36febcb91968dea$export$2e2bcd8739ae039; });

var $132G4 = parcelRequire("132G4");

var $6ji6y = parcelRequire("6ji6y");

var $ehCmD = parcelRequire("ehCmD");

var $fACfu = parcelRequire("fACfu");
function $c36febcb91968dea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c36febcb91968dea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c36febcb91968dea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c36febcb91968dea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c36febcb91968dea$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c36febcb91968dea$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $c36febcb91968dea$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $6ji6y.default)(this, AnalyticsEvent);
        (0, $fACfu.default)(this, "_isAnalyticsEvent", true);
        (0, $fACfu.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $c36febcb91968dea$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $ehCmD.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $132G4.default)(updater) === "object") this.payload = $c36febcb91968dea$var$_objectSpread($c36febcb91968dea$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("eKbqg", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $abbe38dde7202472$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $abbe38dde7202472$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("jX9QM", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $e86b2b13484d43e8$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $e86b2b13484d43e8$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("c2v1B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c3dbccf06ced44a$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $56bwP = parcelRequire("56bwP");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $8c3dbccf06ced44a$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $iSvIT.useContext)((0, $56bwP.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $8c3dbccf06ced44a$export$2e2bcd8739ae039 = $8c3dbccf06ced44a$var$useRouterLink;

});
parcelRegister("56bwP", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $3b66749b32bbf0b2$export$2931e0ee690eee88; });

var $iSvIT = parcelRequire("iSvIT");
var $3b66749b32bbf0b2$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $iSvIT.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $3b66749b32bbf0b2$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($3b66749b32bbf0b2$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $3b66749b32bbf0b2$export$2e2bcd8739ae039 = $3b66749b32bbf0b2$var$RouterLinkProvider;

});


parcelRegister("aFqvt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c424b60cb9e2191$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $7c424b60cb9e2191$export$2e2bcd8739ae039() {}

});

parcelRegister("lLTmq", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $fd98ee3e17351a55$export$f680877a34711e37; });

var $132G4 = parcelRequire("132G4");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $jxLBU = parcelRequire("jxLBU");
var $fd98ee3e17351a55$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $fd98ee3e17351a55$var$react18UseId = ($fd98ee3e17351a55$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $fd98ee3e17351a55$var$_React$useId !== void 0 ? $fd98ee3e17351a55$var$_React$useId : undefined;
function $fd98ee3e17351a55$export$f680877a34711e37() {
    if ($fd98ee3e17351a55$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $fd98ee3e17351a55$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $lzzak.useUID)());
}
var $fd98ee3e17351a55$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($fd98ee3e17351a55$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $132G4.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $132G4.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $fd98ee3e17351a55$export$6ee17796e3d70de2() {
    if ($fd98ee3e17351a55$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $fd98ee3e17351a55$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $lzzak.useUIDSeed)();
}

});

parcelRegister("bl6zx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8416c0f91913e9d9$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $8416c0f91913e9d9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});

parcelRegister("aFurW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c455a5cc4b6b1cc$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $fACfu = parcelRequire("fACfu");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");
var $15sNJ = parcelRequire("15sNJ");
var $7c455a5cc4b6b1cc$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $7c455a5cc4b6b1cc$var$_excluded2 = [
    "className"
];
function $7c455a5cc4b6b1cc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7c455a5cc4b6b1cc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7c455a5cc4b6b1cc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7c455a5cc4b6b1cc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7c455a5cc4b6b1cc$var$focusRingStyles = null;
var $7c455a5cc4b6b1cc$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $7c455a5cc4b6b1cc$var$Focusable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $4Onlm.default)(_ref, $7c455a5cc4b6b1cc$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $4Onlm.default)(htmlAttributes, $7c455a5cc4b6b1cc$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $5VbRa.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $8v5gX.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $7c455a5cc4b6b1cc$var$_objectSpread($7c455a5cc4b6b1cc$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $15sNJ.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $7c455a5cc4b6b1cc$export$2e2bcd8739ae039 = $7c455a5cc4b6b1cc$var$Focusable;

});


parcelRegister("ghwNg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bda7abffde6e23c4$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");

var $7SMnI = parcelRequire("7SMnI");
var $bda7abffde6e23c4$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $bda7abffde6e23c4$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $bda7abffde6e23c4$var$baseStyles = null;
var $bda7abffde6e23c4$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhk1fno",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1eds",
    "color.background.accent.lime.subtler.pressed": "_bfhk1hgz",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhkhgj8",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhk1b17",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhk1pbw",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkrw5d",
    "color.background.accent.red.subtler.pressed": "_bfhk69rw",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1tf4",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhkprmn",
    "color.background.accent.orange.subtlest": "_bfhk1g3m",
    "color.background.accent.orange.subtlest.hovered": "_bfhkg4tm",
    "color.background.accent.orange.subtlest.pressed": "_bfhk1ya0",
    "color.background.accent.orange.subtler": "_bfhkf2vu",
    "color.background.accent.orange.subtler.hovered": "_bfhk1lml",
    "color.background.accent.orange.subtler.pressed": "_bfhkuxsx",
    "color.background.accent.orange.subtle": "_bfhk1g6e",
    "color.background.accent.orange.subtle.hovered": "_bfhk1oew",
    "color.background.accent.orange.subtle.pressed": "_bfhk1phk",
    "color.background.accent.orange.bolder": "_bfhkjgng",
    "color.background.accent.orange.bolder.hovered": "_bfhkhi52",
    "color.background.accent.orange.bolder.pressed": "_bfhkf767",
    "color.background.accent.yellow.subtlest": "_bfhk1ozg",
    "color.background.accent.yellow.subtlest.hovered": "_bfhk19g9",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk31d1",
    "color.background.accent.yellow.subtler": "_bfhk3fv2",
    "color.background.accent.yellow.subtler.hovered": "_bfhklg04",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1d44",
    "color.background.accent.yellow.subtle": "_bfhkry5t",
    "color.background.accent.yellow.subtle.hovered": "_bfhk17e6",
    "color.background.accent.yellow.subtle.pressed": "_bfhko0y5",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk32kj",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkv5yf",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhkung8",
    "color.background.accent.green.subtler.pressed": "_bfhk1p19",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk8h4p",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1azz",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1j2h",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkg5py",
    "color.background.accent.teal.subtler.pressed": "_bfhkq7li",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk10ai",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhkse6l",
    "color.background.accent.blue.subtlest": "_bfhkavxe",
    "color.background.accent.blue.subtlest.hovered": "_bfhkay3p",
    "color.background.accent.blue.subtlest.pressed": "_bfhk1xmr",
    "color.background.accent.blue.subtler": "_bfhk4v9p",
    "color.background.accent.blue.subtler.hovered": "_bfhk16e6",
    "color.background.accent.blue.subtler.pressed": "_bfhk1uh7",
    "color.background.accent.blue.subtle": "_bfhk1j89",
    "color.background.accent.blue.subtle.hovered": "_bfhk1f4s",
    "color.background.accent.blue.subtle.pressed": "_bfhkqctv",
    "color.background.accent.blue.bolder": "_bfhkc8cv",
    "color.background.accent.blue.bolder.hovered": "_bfhk1cwi",
    "color.background.accent.blue.bolder.pressed": "_bfhkhcrq",
    "color.background.accent.purple.subtlest": "_bfhkp7j4",
    "color.background.accent.purple.subtlest.hovered": "_bfhkm0d5",
    "color.background.accent.purple.subtlest.pressed": "_bfhkgslw",
    "color.background.accent.purple.subtler": "_bfhk1jkz",
    "color.background.accent.purple.subtler.hovered": "_bfhk1wyu",
    "color.background.accent.purple.subtler.pressed": "_bfhk5fkp",
    "color.background.accent.purple.subtle": "_bfhkdh45",
    "color.background.accent.purple.subtle.hovered": "_bfhk1wob",
    "color.background.accent.purple.subtle.pressed": "_bfhkwz05",
    "color.background.accent.purple.bolder": "_bfhkygwo",
    "color.background.accent.purple.bolder.hovered": "_bfhkadgs",
    "color.background.accent.purple.bolder.pressed": "_bfhk1uro",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1een",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1r0p",
    "color.background.accent.magenta.subtler.pressed": "_bfhkxuzc",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk1ovh",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkwaw3",
    "color.background.accent.gray.subtlest": "_bfhk11bn",
    "color.background.accent.gray.subtlest.hovered": "_bfhk12j4",
    "color.background.accent.gray.subtlest.pressed": "_bfhk1lb4",
    "color.background.accent.gray.subtler": "_bfhk1v33",
    "color.background.accent.gray.subtler.hovered": "_bfhk1f7l",
    "color.background.accent.gray.subtler.pressed": "_bfhkd8a2",
    "color.background.accent.gray.subtle": "_bfhk1t05",
    "color.background.accent.gray.subtle.hovered": "_bfhk1a2l",
    "color.background.accent.gray.subtle.pressed": "_bfhk1z0s",
    "color.background.accent.gray.bolder": "_bfhk1t1b",
    "color.background.accent.gray.bolder.hovered": "_bfhke4nv",
    "color.background.accent.gray.bolder.pressed": "_bfhk82ra",
    "color.background.disabled": "_bfhksyzs",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhk1d5g",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhkm7j4",
    "color.background.neutral.hovered": "_bfhk15ej",
    "color.background.neutral.pressed": "_bfhkip91",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk166n",
    "color.background.neutral.subtle.pressed": "_bfhk1dty",
    "color.background.neutral.bold": "_bfhkcdhy",
    "color.background.neutral.bold.hovered": "_bfhk1bsc",
    "color.background.neutral.bold.pressed": "_bfhk1b6k",
    "color.background.selected": "_bfhkfg4m",
    "color.background.selected.hovered": "_bfhki1yw",
    "color.background.selected.pressed": "_bfhk19ru",
    "color.background.selected.bold": "_bfhk1fvw",
    "color.background.selected.bold.hovered": "_bfhk18hz",
    "color.background.selected.bold.pressed": "_bfhkgr1v",
    "color.background.brand.subtlest": "_bfhk3wxy",
    "color.background.brand.subtlest.hovered": "_bfhkezq1",
    "color.background.brand.subtlest.pressed": "_bfhk2ggb",
    "color.background.brand.bold": "_bfhkb29m",
    "color.background.brand.bold.hovered": "_bfhku1se",
    "color.background.brand.bold.pressed": "_bfhkqkzo",
    "color.background.brand.boldest": "_bfhk15mt",
    "color.background.brand.boldest.hovered": "_bfhk1uwk",
    "color.background.brand.boldest.pressed": "_bfhk17jr",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1io2",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk9pqq",
    "color.background.warning": "_bfhk1tzq",
    "color.background.warning.hovered": "_bfhk1rd4",
    "color.background.warning.pressed": "_bfhk11dh",
    "color.background.warning.bold": "_bfhk190i",
    "color.background.warning.bold.hovered": "_bfhk1i4c",
    "color.background.warning.bold.pressed": "_bfhkrj9s",
    "color.background.success": "_bfhkmv6i",
    "color.background.success.hovered": "_bfhk1jgi",
    "color.background.success.pressed": "_bfhky4f1",
    "color.background.success.bold": "_bfhk8emd",
    "color.background.success.bold.hovered": "_bfhk1q4l",
    "color.background.success.bold.pressed": "_bfhkcrcn",
    "color.background.discovery": "_bfhk1nvp",
    "color.background.discovery.hovered": "_bfhk1xp7",
    "color.background.discovery.pressed": "_bfhkdlkp",
    "color.background.discovery.bold": "_bfhk1lri",
    "color.background.discovery.bold.hovered": "_bfhk1w72",
    "color.background.discovery.bold.pressed": "_bfhkrb53",
    "color.background.information": "_bfhk33gi",
    "color.background.information.hovered": "_bfhk1vps",
    "color.background.information.pressed": "_bfhk1s0z",
    "color.background.information.bold": "_bfhk14wj",
    "color.background.information.bold.hovered": "_bfhk1amz",
    "color.background.information.bold.pressed": "_bfhk5bth",
    "color.blanket": "_bfhk10xm",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkn82g",
    "color.skeleton.subtle": "_bfhkh3tw",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk108i",
    "elevation.surface.pressed": "_bfhk1ji5",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk16qz",
    "elevation.surface.overlay.pressed": "_bfhkvq0a",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk1a0f",
    "elevation.surface.raised.pressed": "_bfhkf7u5",
    "elevation.surface.sunken": "_bfhkqbzx",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $bda7abffde6e23c4$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $bda7abffde6e23c4$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l108i",
    "elevation.surface.pressed": "_1q1l1ji5",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l16qz",
    "elevation.surface.overlay.pressed": "_1q1lvq0a",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l1a0f",
    "elevation.surface.raised.pressed": "_1q1lf7u5",
    "elevation.surface.sunken": "_1q1lqbzx"
};
var $bda7abffde6e23c4$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $bda7abffde6e23c4$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $bda7abffde6e23c4$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $bda7abffde6e23c4$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $bda7abffde6e23c4$var$Box = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $4Onlm.default)(_ref, $bda7abffde6e23c4$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $4Onlm.default)(htmlAttributes, $bda7abffde6e23c4$var$_excluded2);
    var node = /*#__PURE__*/ $iSvIT.createElement(Component, (0, $5VbRa.default)({
        style: style,
        ref: ref,
        className: (0, $8v5gX.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $bda7abffde6e23c4$var$backgroundColorMap[backgroundColor],
            backgroundColor && $bda7abffde6e23c4$var$isSurfaceToken(backgroundColor) && $bda7abffde6e23c4$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $bda7abffde6e23c4$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $bda7abffde6e23c4$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $bda7abffde6e23c4$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $bda7abffde6e23c4$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $iSvIT.createElement((0, $7SMnI.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $bda7abffde6e23c4$export$2e2bcd8739ae039 = $bda7abffde6e23c4$var$Box;
function $bda7abffde6e23c4$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $bda7abffde6e23c4$var$setSurfaceTokenMap;
}

});
parcelRegister("7SMnI", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $5bd31b1c8afa183d$export$1ca2a26fecb070ae; });

var $iSvIT = parcelRequire("iSvIT");
var $5bd31b1c8afa183d$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $5bd31b1c8afa183d$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($5bd31b1c8afa183d$export$1ca2a26fecb070ae);
};
$5bd31b1c8afa183d$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("keKJr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebb95d6c3348f474$export$2e2bcd8739ae039; });

var $5VbRa = parcelRequire("5VbRa");

var $iSvIT = parcelRequire("iSvIT");

var $8ODlt = parcelRequire("8ODlt");
function $ebb95d6c3348f474$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8ODlt.default), (0, $5VbRa.default)({}, props, {
        isFullScreen: false
    }));
}

});
parcelRegister("8ODlt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66b18364806fb2c7$export$2e2bcd8739ae039; });
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $iSvIT = parcelRequire("iSvIT");

var $hgIUG = parcelRequire("hgIUG");

var $fmHcJ = parcelRequire("fmHcJ");

var $cpjHB = parcelRequire("cpjHB");

var $lxoX2 = parcelRequire("lxoX2");

var $52xdm = parcelRequire("52xdm");

var $2KCPo = parcelRequire("2KCPo");

var $aoG47 = parcelRequire("aoG47");

var $5YSC2 = parcelRequire("5YSC2");

var $cMUcc = parcelRequire("cMUcc");

var $jxLBU = parcelRequire("jxLBU");

var $gWVOm = parcelRequire("gWVOm");

var $eR9DZ = parcelRequire("eR9DZ");

var $4851s = parcelRequire("4851s");

var $bhyUW = parcelRequire("bhyUW");

var $jWNxo = parcelRequire("jWNxo");
var $66b18364806fb2c7$var$fillScreenStyles = null;
var $66b18364806fb2c7$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector(".aui-blanket:not([hidden])")) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === "function") return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $66b18364806fb2c7$var$InternalModalWrapper = function InternalModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $2KCPo.default) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId, isFullScreen = props.isFullScreen;
    var calculatedStackIndex = (0, $4851s.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === "boolean" ? autoFocus : false;
    var onCloseHandler = (0, $lxoX2.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $2KCPo.default),
        action: "closed",
        componentName: "modalDialog",
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "0.0.0-development"
    });
    var onBlanketClicked = (0, $iSvIT.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $iSvIT.useCallback)(function(element) {
        return $66b18364806fb2c7$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $bhyUW.default)();
    (0, $5YSC2.useNotifyOpenLayerObserver)({
        type: "modal",
        // Modal dialog is conditionally rendered when visible, so when this runs it is always open.
        isOpen: (0, $jxLBU.fg)("platform-dst-open-layer-observer-layer-type"),
        // Passing a no-op for now, as there isn't a real use case for closing the modal dialog programmatically
        // by the OpenLayerObserver. The only current use case is closing layers when resizing the nav layout,
        // which cannot happen while a modal dialog is open.
        onClose: (0, $2KCPo.default)
    });
    var modalDialogWithBlanket = /*#__PURE__*/ $iSvIT.createElement((0, $52xdm.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, /*#__PURE__*/ $iSvIT.createElement((0, $jWNxo.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ("boolean" === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ $iSvIT.createElement((0, $aoG47.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $iSvIT.createElement((0, $gWVOm.default), {
        zIndex: (0, $eR9DZ.layers).modal()
    }, /*#__PURE__*/ $iSvIT.createElement((0, $cMUcc.default), null, function(fadeInProps) {
        return /*#__PURE__*/ $iSvIT.createElement("div", (0, $5VbRa.default)({}, fadeInProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $hgIUG.default)([
                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }), /*#__PURE__*/ $iSvIT.createElement((0, $fmHcJ.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $iSvIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cpjHB))), null), shouldScrollInViewport ? /*#__PURE__*/ $iSvIT.createElement((0, $cpjHB.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $66b18364806fb2c7$export$2e2bcd8739ae039 = $66b18364806fb2c7$var$InternalModalWrapper;

});
parcelRegister("hgIUG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c926c5223b38d7db$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c926c5223b38d7db$var$ATOMIC_GROUP_LENGTH = 5;
function $c926c5223b38d7db$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $c926c5223b38d7db$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("fmHcJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2fa6c956a513c08$export$2e2bcd8739ae039; });

var $geF4l = parcelRequire("geF4l");

var $b2fa6c956a513c08$export$2e2bcd8739ae039 = (0, $geF4l.default);

});
parcelRegister("geF4l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd1dcf982fc47a93$export$2e2bcd8739ae039; });

var $2k3Cs = parcelRequire("2k3Cs");

var $5VbRa = parcelRequire("5VbRa");

var $iSvIT = parcelRequire("iSvIT");

var $aatQL = parcelRequire("aatQL");

var $hceks = parcelRequire("hceks");
/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/ var $bd1dcf982fc47a93$var$FocusLockCombination = /*#__PURE__*/ $iSvIT.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $iSvIT.createElement((0, $aatQL.default), (0, $5VbRa.default)({
        sideCar: (0, $hceks.default),
        ref: ref
    }, props));
});
var $bd1dcf982fc47a93$var$_ref = (0, $aatQL.default).propTypes || {}, $bd1dcf982fc47a93$var$sideCar = $bd1dcf982fc47a93$var$_ref.sideCar, $bd1dcf982fc47a93$var$propTypes = (0, $2k3Cs.default)($bd1dcf982fc47a93$var$_ref, [
    "sideCar"
]);
$bd1dcf982fc47a93$var$FocusLockCombination.propTypes = {};
var $bd1dcf982fc47a93$export$2e2bcd8739ae039 = $bd1dcf982fc47a93$var$FocusLockCombination;

});
parcelRegister("aatQL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7671fe2771dde761$export$2e2bcd8739ae039; });

var $5VbRa = parcelRequire("5VbRa");

var $iSvIT = parcelRequire("iSvIT");


var $f0uRo = parcelRequire("f0uRo");

var $3G6C2 = parcelRequire("3G6C2");

var $dYjAf = parcelRequire("dYjAf");

var $75wld = parcelRequire("75wld");
var $7671fe2771dde761$var$emptyArray = [];
var $7671fe2771dde761$var$FocusLock = /*#__PURE__*/ $iSvIT.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $iSvIT.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $iSvIT.useRef();
    var isActive = $iSvIT.useRef(false);
    var originalFocusedElement = $iSvIT.useRef(null);
    var children = props.children, disabled = props.disabled, noFocusGuards = props.noFocusGuards, persistentFocus = props.persistentFocus, crossFrame = props.crossFrame, autoFocus = props.autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $7671fe2771dde761$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, shouldReturnFocus = props.returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState2 = $iSvIT.useState({}), id = _React$useState2[0]; // SIDE EFFECT CALLBACKS
    var onActivation = $iSvIT.useCallback(function() {
        originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $iSvIT.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
    }, [
        onDeactivationCallback
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!disabled) // cleanup return focus on trap deactivation
        // sideEffect/returnFocus should happen by this time
        originalFocusedElement.current = null;
    }, []);
    var returnFocus = $iSvIT.useCallback(function(allowDefer) {
        var returnFocusTo = originalFocusedElement.current;
        if (returnFocusTo && returnFocusTo.focus) {
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) // React might return focus after update
                // it's safer to defer the action
                Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]); // MEDIUM CALLBACKS
    var onFocus = $iSvIT.useCallback(function(event) {
        if (isActive.current) (0, $75wld.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $75wld.mediumBlur).useMedium; // REF PROPAGATION
    // not using real refs due to race conditions
    var setObserveNode = $iSvIT.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $5VbRa.default)((_extends2 = {}, _extends2[$f0uRo.FOCUS_DISABLED] = disabled && "disabled", _extends2[$f0uRo.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $3G6C2.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    return /*#__PURE__*/ $iSvIT.createElement($iSvIT.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ // nearest focus guard
        $iSvIT.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $dYjAf.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $iSvIT.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $dYjAf.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $iSvIT.createElement(SideCar, {
        id: id,
        sideCar: (0, $75wld.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $iSvIT.createElement(Container, (0, $5VbRa.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), children), hasTailingGuards && /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $dYjAf.hiddenGuard)
    }));
});
$7671fe2771dde761$var$FocusLock.propTypes = {};
$7671fe2771dde761$var$FocusLock.defaultProps = {
    children: undefined,
    disabled: false,
    returnFocus: false,
    focusOptions: undefined,
    noFocusGuards: false,
    autoFocus: true,
    persistentFocus: false,
    crossFrame: true,
    hasPositiveIndices: undefined,
    allowTextSelection: undefined,
    group: undefined,
    className: undefined,
    whiteList: undefined,
    shards: undefined,
    as: "div",
    lockProps: {},
    onActivation: undefined,
    onDeactivation: undefined
};
var $7671fe2771dde761$export$2e2bcd8739ae039 = $7671fe2771dde761$var$FocusLock;

});
parcelRegister("3G6C2", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $2ada6c6e910d9d7e$export$74665b213cb5c4cf; });

var $cUrew = parcelRequire("cUrew");

var $4QDGh = parcelRequire("4QDGh");
function $2ada6c6e910d9d7e$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $4QDGh.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $cUrew.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("cUrew", function(module, exports) {

$parcel$export(module.exports, "assignRef", function () { return $965fd6edf44a7533$export$d734136a7b018efe; });
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $965fd6edf44a7533$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("4QDGh", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", function () { return $387acc901ad67abb$export$25bec8c6f54ee79a; });

var $iSvIT = parcelRequire("iSvIT");
function $387acc901ad67abb$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $iSvIT.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("dYjAf", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", function () { return $a2c011dbecb1f6f1$export$b8c7b07253306600; });

var $iSvIT = parcelRequire("iSvIT");

var $a2c011dbecb1f6f1$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $a2c011dbecb1f6f1$var$InFocusGuard = function InFocusGuard(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement($iSvIT.Fragment, null, /*#__PURE__*/ $iSvIT.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $a2c011dbecb1f6f1$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $iSvIT.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $a2c011dbecb1f6f1$export$b8c7b07253306600
    }));
};
$a2c011dbecb1f6f1$var$InFocusGuard.propTypes = {};
$a2c011dbecb1f6f1$var$InFocusGuard.defaultProps = {
    children: null
};
var $a2c011dbecb1f6f1$export$2e2bcd8739ae039 = $a2c011dbecb1f6f1$var$InFocusGuard;

});

parcelRegister("75wld", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", function () { return $5292164c09a5f8f6$export$5733e022b1d538cb; });
$parcel$export(module.exports, "mediumBlur", function () { return $5292164c09a5f8f6$export$b3e9a9312f73723c; });
$parcel$export(module.exports, "mediumEffect", function () { return $5292164c09a5f8f6$export$3a1d52767cbc07b8; });
$parcel$export(module.exports, "mediumSidecar", function () { return $5292164c09a5f8f6$export$892cbf28e5518020; });

var $8Wf6W = parcelRequire("8Wf6W");
var $5292164c09a5f8f6$export$5733e022b1d538cb = (0, $8Wf6W.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $5292164c09a5f8f6$export$b3e9a9312f73723c = (0, $8Wf6W.createMedium)();
var $5292164c09a5f8f6$export$3a1d52767cbc07b8 = (0, $8Wf6W.createMedium)();
var $5292164c09a5f8f6$export$892cbf28e5518020 = (0, $8Wf6W.createSidecarMedium)({
    async: true // focus-lock sidecar is not required on the server
});

});


parcelRegister("hceks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $033b134aa7f226fe$export$2e2bcd8739ae039; });
/* eslint-disable no-mixed-operators */ 
var $iSvIT = parcelRequire("iSvIT");


var $kge4v = parcelRequire("kge4v");

var $9MUZH = parcelRequire("9MUZH");
var $arLwg = parcelRequire("arLwg");
var $eMGHY = parcelRequire("eMGHY");
var $1CR4f = parcelRequire("1CR4f");

var $7cncT = parcelRequire("7cncT");

var $75wld = parcelRequire("75wld");
var $033b134aa7f226fe$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $033b134aa7f226fe$var$isFreeFocus = function isFreeFocus() {
    return $033b134aa7f226fe$var$focusOnBody() || (0, $eMGHY.focusIsHidden)();
};
var $033b134aa7f226fe$var$lastActiveTrap = null;
var $033b134aa7f226fe$var$lastActiveFocus = null;
var $033b134aa7f226fe$var$lastPortaledElement = null;
var $033b134aa7f226fe$var$focusWasOutsideWindow = false;
var $033b134aa7f226fe$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $033b134aa7f226fe$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($033b134aa7f226fe$var$lastActiveTrap.whiteList || $033b134aa7f226fe$var$defaultWhitelist)(activeElement);
};
var $033b134aa7f226fe$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $033b134aa7f226fe$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $033b134aa7f226fe$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $033b134aa7f226fe$var$lastPortaledElement && $033b134aa7f226fe$var$lastPortaledElement.portaledElement === element;
};
function $033b134aa7f226fe$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) // we will tab to the next element
            return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $033b134aa7f226fe$var$extractRef = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $033b134aa7f226fe$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) // with cross frame return true for any value
    return Boolean($033b134aa7f226fe$var$focusWasOutsideWindow);
     // in other case return only of focus went a while aho
    return $033b134aa7f226fe$var$focusWasOutsideWindow === "meanwhile";
};
var $033b134aa7f226fe$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement) // dive up
    ) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $033b134aa7f226fe$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $033b134aa7f226fe$var$checkInHost(activeElement, area, area);
    });
};
var $033b134aa7f226fe$var$activateTrap = function activateTrap() {
    var result = false;
    if ($033b134aa7f226fe$var$lastActiveTrap) {
        var _lastActiveTrap = $033b134aa7f226fe$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $033b134aa7f226fe$var$lastPortaledElement && $033b134aa7f226fe$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map($033b134aa7f226fe$var$extractRef).filter(Boolean));
            if (!activeElement || $033b134aa7f226fe$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $033b134aa7f226fe$var$focusWasOutside(crossFrame) || !$033b134aa7f226fe$var$isFreeFocus() || !$033b134aa7f226fe$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $arLwg.focusInside)(workingArea) || // check for shadow-dom contained elements
                    activeElement && $033b134aa7f226fe$var$withinHost(activeElement, workingArea) || $033b134aa7f226fe$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$033b134aa7f226fe$var$lastActiveFocus && activeElement && !autoFocus) {
                            // Check if blur() exists, which is missing on certain elements on IE
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $1CR4f.moveFocusInside)(workingArea, $033b134aa7f226fe$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $033b134aa7f226fe$var$lastPortaledElement = {};
                        }
                    }
                    $033b134aa7f226fe$var$focusWasOutsideWindow = false;
                    $033b134aa7f226fe$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $9MUZH.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    // remove old focus
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $033b134aa7f226fe$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $033b134aa7f226fe$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $033b134aa7f226fe$var$onTrap = function onTrap(event) {
    if ($033b134aa7f226fe$var$activateTrap() && event) {
        // prevent scroll jump
        event.stopPropagation();
        event.preventDefault();
    }
};
var $033b134aa7f226fe$var$onBlur = function onBlur() {
    return (0, $7cncT.deferAction)($033b134aa7f226fe$var$activateTrap);
};
var $033b134aa7f226fe$var$onFocus = function onFocus(event) {
    // detect portal
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $033b134aa7f226fe$var$recordPortal(currentNode, source);
};
var $033b134aa7f226fe$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $033b134aa7f226fe$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        onBlur: $033b134aa7f226fe$var$onBlur,
        onFocus: $033b134aa7f226fe$var$onFocus
    }, children);
};
$033b134aa7f226fe$var$FocusTrap.propTypes = {};
var $033b134aa7f226fe$var$onWindowBlur = function onWindowBlur() {
    $033b134aa7f226fe$var$focusWasOutsideWindow = "just"; // using setTimeout to set  this variable after React/sidecar reaction
    (0, $7cncT.deferAction)(function() {
        $033b134aa7f226fe$var$focusWasOutsideWindow = "meanwhile";
    });
};
var $033b134aa7f226fe$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $033b134aa7f226fe$var$onTrap);
    document.addEventListener("focusout", $033b134aa7f226fe$var$onBlur);
    window.addEventListener("blur", $033b134aa7f226fe$var$onWindowBlur);
};
var $033b134aa7f226fe$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $033b134aa7f226fe$var$onTrap);
    document.removeEventListener("focusout", $033b134aa7f226fe$var$onBlur);
    window.removeEventListener("blur", $033b134aa7f226fe$var$onWindowBlur);
};
function $033b134aa7f226fe$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
function $033b134aa7f226fe$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$033b134aa7f226fe$var$lastActiveTrap) $033b134aa7f226fe$var$attachHandler();
    var lastTrap = $033b134aa7f226fe$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $033b134aa7f226fe$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation(); // return focus only of last trap was removed
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) // allow defer is no other trap is awaiting restore
        lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $033b134aa7f226fe$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation();
        $033b134aa7f226fe$var$activateTrap(true);
        (0, $7cncT.deferAction)($033b134aa7f226fe$var$activateTrap);
    } else {
        $033b134aa7f226fe$var$detachHandler();
        $033b134aa7f226fe$var$lastActiveFocus = null;
    }
} // bind medium
(0, $75wld.mediumFocus).assignSyncMedium($033b134aa7f226fe$var$onFocus);
(0, $75wld.mediumBlur).assignMedium($033b134aa7f226fe$var$onBlur);
(0, $75wld.mediumEffect).assignMedium(function(cb) {
    return cb({
        moveFocusInside: (0, $1CR4f.moveFocusInside),
        focusInside: (0, $arLwg.focusInside)
    });
});
var $033b134aa7f226fe$export$2e2bcd8739ae039 = (0, $kge4v.default)($033b134aa7f226fe$var$reducePropsToState, $033b134aa7f226fe$var$handleStateChangeOnClient)($033b134aa7f226fe$var$FocusWatcher);

});
parcelRegister("7cncT", function(module, exports) {

$parcel$export(module.exports, "deferAction", function () { return $015a40a461626aaa$export$6523025722806278; });
function $015a40a461626aaa$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $015a40a461626aaa$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};

});




parcelRegister("2KCPo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $200dff14efe4f74b$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $200dff14efe4f74b$export$2e2bcd8739ae039() {}

});

parcelRegister("aoG47", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $791cc6962006c9a7$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "LevelNodeContext", function () { return $791cc6962006c9a7$export$18f4d8b5b3a77f59; });
$parcel$export(module.exports, "RootNodeContext", function () { return $791cc6962006c9a7$export$fa973f110e8f6ca8; });
$parcel$export(module.exports, "Layering", function () { return $791cc6962006c9a7$export$7c885f891c940977; });

var $iSvIT = parcelRequire("iSvIT");

var $akhH7 = parcelRequire("akhH7");
var $791cc6962006c9a7$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $iSvIT.createContext)(0);
var $791cc6962006c9a7$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    current: null
});
var $791cc6962006c9a7$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    current: null
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $791cc6962006c9a7$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $iSvIT.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($791cc6962006c9a7$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($791cc6962006c9a7$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
var $791cc6962006c9a7$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $iSvIT.useContext)($791cc6962006c9a7$export$650d12d3c2ddb8fc);
    var parentNode = (0, $iSvIT.useContext)($791cc6962006c9a7$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $iSvIT.useRef)(new (0, $akhH7.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($791cc6962006c9a7$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($791cc6962006c9a7$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};

});
parcelRegister("akhH7", function(module, exports) {

$parcel$export(module.exports, "LayerNode", function () { return $78497f6352b7598f$export$da4f61fd78d35243; });

var $d5B2s = parcelRequire("d5B2s");

var $6ji6y = parcelRequire("6ji6y");

var $ehCmD = parcelRequire("ehCmD");
var $78497f6352b7598f$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, $6ji6y.default)(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, $ehCmD.default)(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, $d5B2s.default)(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});


parcelRegister("5YSC2", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $45aceb3ca6befd88$export$469bb693f11edc7f; });

var $iSvIT = parcelRequire("iSvIT");

var $2ZCia = parcelRequire("2ZCia");

var $7VbDS = parcelRequire("7VbDS");
function $45aceb3ca6befd88$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $iSvIT.useContext)((0, $2ZCia.OpenLayerObserverContext));
    var namespace = (0, $7VbDS.useOpenLayerObserverNamespace)();
    (0, $iSvIT.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("2ZCia", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $22defb4b30f8525f$export$5fbf4d7fae6cdc00; });

var $iSvIT = parcelRequire("iSvIT");
var $22defb4b30f8525f$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});

parcelRegister("7VbDS", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserverNamespace", function () { return $5c46e324e1c78eac$export$1d57e79091cc3046; });

var $iSvIT = parcelRequire("iSvIT");

var $jLBCb = parcelRequire("jLBCb");
function $5c46e324e1c78eac$export$1d57e79091cc3046() {
    var namespace = (0, $iSvIT.useContext)((0, $jLBCb.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("jLBCb", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", function () { return $e63f95a7c097bf9d$export$644a49f3b8c50fcd; });

var $iSvIT = parcelRequire("iSvIT");
var $e63f95a7c097bf9d$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});



parcelRegister("cMUcc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94f58f095989decc$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $kSxoH = parcelRequire("kSxoH");
var $94f58f095989decc$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $94f58f095989decc$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $94f58f095989decc$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-out";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $kSxoH.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-in",
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $94f58f095989decc$export$2e2bcd8739ae039 = $94f58f095989decc$var$FadeIn;

});
parcelRegister("kSxoH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f332c1ce28cc0c5a$export$2e2bcd8739ae039; });
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $fOsVV = parcelRequire("fOsVV");

var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");

var $7ZeA8 = parcelRequire("7ZeA8");

var $5IRnr = parcelRequire("5IRnr");

var $heb4S = parcelRequire("heb4S");

var $dH5of = parcelRequire("dH5of");

var $78rvu = parcelRequire("78rvu");
var $f332c1ce28cc0c5a$var$zoomIn = null;
var $f332c1ce28cc0c5a$var$zoomOut = null;
var $f332c1ce28cc0c5a$var$fadeIn = null;
var $f332c1ce28cc0c5a$var$fadeOut = null;
var $f332c1ce28cc0c5a$var$fadeInFromTop = null;
var $f332c1ce28cc0c5a$var$fadeOutFromTop = null;
var $f332c1ce28cc0c5a$var$fadeInFromLeft = null;
var $f332c1ce28cc0c5a$var$fadeOutFromLeft = null;
var $f332c1ce28cc0c5a$var$fadeInFromBottom = null;
var $f332c1ce28cc0c5a$var$fadeOutFromBottom = null;
var $f332c1ce28cc0c5a$var$fadeInFromRight = null;
var $f332c1ce28cc0c5a$var$fadeOutFromRight = null;
var $f332c1ce28cc0c5a$var$fadeInFromTopConstant = null;
var $f332c1ce28cc0c5a$var$fadeOutFromTopConstant = null;
var $f332c1ce28cc0c5a$var$fadeInFromLeftConstant = null;
var $f332c1ce28cc0c5a$var$fadeOutFromLeftConstant = null;
var $f332c1ce28cc0c5a$var$fadeInFromBottomConstant = null;
var $f332c1ce28cc0c5a$var$fadeOutFromBottomConstant = null;
var $f332c1ce28cc0c5a$var$fadeInFromRightConstant = null;
var $f332c1ce28cc0c5a$var$fadeOutFromRightConstant = null;
var $f332c1ce28cc0c5a$var$slideInFromTop = null;
var $f332c1ce28cc0c5a$var$slideOutFromTop = null;
var $f332c1ce28cc0c5a$var$slideInFromRight = null;
var $f332c1ce28cc0c5a$var$slideOutFromRight = null;
var $f332c1ce28cc0c5a$var$slideInFromBottom = null;
var $f332c1ce28cc0c5a$var$slideOutFromBottom = null;
var $f332c1ce28cc0c5a$var$slideInFromLeft = null;
var $f332c1ce28cc0c5a$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $f332c1ce28cc0c5a$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration;
    var staggered = (0, $78rvu.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $dH5of.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $heb4S.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $iSvIT.useState)(appear), _useState2 = (0, $fOsVV.default)(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === "exiting") // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $7ZeA8.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $5IRnr.exitingDurations)[duration] : (0, $5IRnr.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $8v5gX.default)([
            (0, $8v5gX.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $8v5gX.default)([
                "_1y0ctrqk"
            ]),
            duration === "small" && (0, $8v5gX.default)([
                "_5sag1yx9"
            ]),
            duration === "medium" && (0, $8v5gX.default)([
                "_5sag1ttt"
            ]),
            duration === "large" && (0, $8v5gX.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === "small" && (0, $8v5gX.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === "medium" && (0, $8v5gX.default)([
                "_5sagluct"
            ]),
            isExiting && duration === "large" && (0, $8v5gX.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $8v5gX.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === "linear" && (0, $8v5gX.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === "ease-out" && (0, $8v5gX.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === "ease-in" && (0, $8v5gX.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === "ease-in-40-out" && (0, $8v5gX.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === "ease-in-60-out" && (0, $8v5gX.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === "ease-in-80-out" && (0, $8v5gX.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === "ease-in-out" && (0, $8v5gX.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === "linear" && (0, $8v5gX.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-out" && (0, $8v5gX.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in" && (0, $8v5gX.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-40-out" && (0, $8v5gX.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-60-out" && (0, $8v5gX.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-80-out" && (0, $8v5gX.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-out" && (0, $8v5gX.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === "fade-in" || isExiting && exitingAnimation === "fade-in") && (0, $8v5gX.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === "fade-out" || isExiting && exitingAnimation === "fade-out") && (0, $8v5gX.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === "zoom-in" || isExiting && exitingAnimation === "zoom-in") && (0, $8v5gX.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === "zoom-out" || isExiting && exitingAnimation === "zoom-out") && (0, $8v5gX.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-top" || isExiting && exitingAnimation === "slide-in-from-top") && (0, $8v5gX.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-top" || isExiting && exitingAnimation === "slide-out-from-top") && (0, $8v5gX.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-right" || isExiting && exitingAnimation === "slide-in-from-right") && (0, $8v5gX.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-right" || isExiting && exitingAnimation === "slide-out-from-right") && (0, $8v5gX.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-bottom" || isExiting && exitingAnimation === "slide-in-from-bottom") && (0, $8v5gX.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-bottom" || isExiting && exitingAnimation === "slide-out-from-bottom") && (0, $8v5gX.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-left" || isExiting && exitingAnimation === "slide-in-from-left") && (0, $8v5gX.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-left" || isExiting && exitingAnimation === "slide-out-from-left") && (0, $8v5gX.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top" || isExiting && exitingAnimation === "fade-in-from-top") && (0, $8v5gX.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top" || isExiting && exitingAnimation === "fade-out-from-top") && (0, $8v5gX.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left" || isExiting && exitingAnimation === "fade-in-from-left") && (0, $8v5gX.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left" || isExiting && exitingAnimation === "fade-out-from-left") && (0, $8v5gX.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom" || isExiting && exitingAnimation === "fade-in-from-bottom") && (0, $8v5gX.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom" || isExiting && exitingAnimation === "fade-out-from-bottom") && (0, $8v5gX.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right" || isExiting && exitingAnimation === "fade-in-from-right") && (0, $8v5gX.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right" || isExiting && exitingAnimation === "fade-out-from-right") && (0, $8v5gX.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top-constant" || isExiting && exitingAnimation === "fade-in-from-top-constant") && (0, $8v5gX.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top-constant" || isExiting && exitingAnimation === "fade-out-from-top-constant") && (0, $8v5gX.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left-constant" || isExiting && exitingAnimation === "fade-in-from-left-constant") && (0, $8v5gX.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left-constant" || isExiting && exitingAnimation === "fade-out-from-left-constant") && (0, $8v5gX.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom-constant" || isExiting && exitingAnimation === "fade-in-from-bottom-constant") && (0, $8v5gX.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom-constant" || isExiting && exitingAnimation === "fade-out-from-bottom-constant") && (0, $8v5gX.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right-constant" || isExiting && exitingAnimation === "fade-in-from-right-constant") && (0, $8v5gX.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right-constant" || isExiting && exitingAnimation === "fade-out-from-right-constant") && (0, $8v5gX.default)([
                "_j7hq1pgp"
            ])
        ]) : "",
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $f332c1ce28cc0c5a$export$2e2bcd8739ae039 = $f332c1ce28cc0c5a$var$EnteringMotion;

});
parcelRegister("7ZeA8", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $5d098a88ea82f867$export$b7baf7667a68d87c; });

var $fOsVV = parcelRequire("fOsVV");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");
var $5d098a88ea82f867$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $5d098a88ea82f867$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$5d098a88ea82f867$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $5d098a88ea82f867$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $iSvIT.useState)($5d098a88ea82f867$export$b7baf7667a68d87c), _useState2 = (0, $fOsVV.default)(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        if (!$5d098a88ea82f867$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $2e1kT.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $5d098a88ea82f867$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $5d098a88ea82f867$export$ff7706047246b98b = function prefersReducedMotion() {
    return $5d098a88ea82f867$export$f0f789643ba5a83c;
};

});

parcelRegister("5IRnr", function(module, exports) {

$parcel$export(module.exports, "durations", function () { return $42aa7762ac1e34b6$export$38b928a7167ce124; });
$parcel$export(module.exports, "exitingDurations", function () { return $42aa7762ac1e34b6$export$30fa1a2e62ae150c; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $42aa7762ac1e34b6$export$368bacef0dacbe05 = 25;
var $42aa7762ac1e34b6$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $42aa7762ac1e34b6$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $42aa7762ac1e34b6$export$30fa1a2e62ae150c = {
    none: $42aa7762ac1e34b6$export$38b928a7167ce124.none,
    small: $42aa7762ac1e34b6$export$38b928a7167ce124.small * $42aa7762ac1e34b6$var$EXITING_MOTION_MULTIPLIER,
    medium: $42aa7762ac1e34b6$export$38b928a7167ce124.medium * $42aa7762ac1e34b6$var$EXITING_MOTION_MULTIPLIER,
    large: $42aa7762ac1e34b6$export$38b928a7167ce124.large * $42aa7762ac1e34b6$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("heb4S", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $c8ac5641869e5070$export$4f34107a2b00f39c; });

var $iSvIT = parcelRequire("iSvIT");
var $c8ac5641869e5070$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $c8ac5641869e5070$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $iSvIT.useRef)([]);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $c8ac5641869e5070$var$getHookDeps(opts));
    return (0, $iSvIT.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $c8ac5641869e5070$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $iSvIT.useRef)([]);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $c8ac5641869e5070$var$getHookDeps(opts));
    return (0, $iSvIT.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("dH5of", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $9f8378dab18c7669$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $9f8378dab18c7669$export$2e2bcd8739ae039; });

var $fOsVV = parcelRequire("fOsVV");

var $iSvIT = parcelRequire("iSvIT");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $9f8378dab18c7669$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $9f8378dab18c7669$var$ExitingContext = /*#__PURE__*/ (0, $iSvIT.createContext)($9f8378dab18c7669$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $9f8378dab18c7669$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f8378dab18c7669$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($9f8378dab18c7669$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $9f8378dab18c7669$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $iSvIT.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $9f8378dab18c7669$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $9f8378dab18c7669$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $9f8378dab18c7669$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $9f8378dab18c7669$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $9f8378dab18c7669$var$ExitingPersistence = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $iSvIT.useState)([
        null,
        children
    ]), _useState2 = (0, $fOsVV.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)([]), _useState4 = (0, $fOsVV.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, $fOsVV.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $iSvIT.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, $fOsVV.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $9f8378dab18c7669$var$childrenToArray(previousChildren);
    var current = $9f8378dab18c7669$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $9f8378dab18c7669$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $9f8378dab18c7669$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $9f8378dab18c7669$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $9f8378dab18c7669$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $9f8378dab18c7669$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $iSvIT.useContext)($9f8378dab18c7669$var$ExitingContext);
};
$9f8378dab18c7669$var$ExitingPersistence.displayName = "ExitingPersistence";
var $9f8378dab18c7669$export$2e2bcd8739ae039 = $9f8378dab18c7669$var$ExitingPersistence;

});

parcelRegister("78rvu", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $531e9e123afec190$export$25c7213fc07ec080; });

var $fOsVV = parcelRequire("fOsVV");

var $iSvIT = parcelRequire("iSvIT");

var $kykJa = parcelRequire("kykJa");

var $ic1xa = parcelRequire("ic1xa");

var $3jEAD = parcelRequire("3jEAD");
var $531e9e123afec190$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $iSvIT.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $kykJa.default)
    };
});
var $531e9e123afec190$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $3jEAD.useUniqueId)();
    var context = (0, $iSvIT.useContext)($531e9e123afec190$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $531e9e123afec190$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $iSvIT.useRef)([]);
    var indexes = [];
    var _useState = (0, $iSvIT.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $fOsVV.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $ic1xa.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($531e9e123afec190$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $531e9e123afec190$export$2e2bcd8739ae039 = $531e9e123afec190$var$StaggeredEntrance;

});
parcelRegister("kykJa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef670fadd8736dff$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $ef670fadd8736dff$export$2e2bcd8739ae039() {}

});

parcelRegister("ic1xa", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $d3ea899e922477bb$export$e5c5a5f917a5871c; });

var $iSvIT = parcelRequire("iSvIT");
var $d3ea899e922477bb$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);

});

parcelRegister("3jEAD", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $26a2a1bf02e8a76e$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $iSvIT = parcelRequire("iSvIT");
function $26a2a1bf02e8a76e$export$c485849f2e393253() {
    var identifier = (0, $iSvIT.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("eR9DZ", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $ad0d7f003656b46e$export$7be255094ccdc533; });

var $4DuOb = parcelRequire("4DuOb");

var $h7Vgg = parcelRequire("h7Vgg");
var $ad0d7f003656b46e$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $ad0d7f003656b46e$export$c93026a968943f95 = "light";
var $ad0d7f003656b46e$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $ad0d7f003656b46e$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $h7Vgg.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $4DuOb.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $ad0d7f003656b46e$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $ad0d7f003656b46e$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $ad0d7f003656b46e$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $4DuOb.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $ad0d7f003656b46e$export$ba1d834b86d72a09 = $ad0d7f003656b46e$export$a1b3edb637fb4f35;
var $ad0d7f003656b46e$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $h7Vgg.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $h7Vgg.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $h7Vgg.N30A), ")")
            }
        }
    };
};

});
parcelRegister("4DuOb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3602b3dfba421bd0$export$2e2bcd8739ae039; });

var $45FcF = parcelRequire("45FcF");

var $XAEGR = parcelRequire("XAEGR");
function $3602b3dfba421bd0$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $45FcF.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $3602b3dfba421bd0$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $XAEGR;
}

});
parcelRegister("45FcF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fa7972a57ef0877$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $2fa7972a57ef0877$var$printed = {};
function $2fa7972a57ef0877$export$2e2bcd8739ae039(message) {
    if ($2fa7972a57ef0877$var$printed[message]) return;
    $2fa7972a57ef0877$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});



parcelRegister("4851s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $301bce285551e585$export$2e2bcd8739ae039; });

var $fOsVV = parcelRequire("fOsVV");

var $iSvIT = parcelRequire("iSvIT");

var $dgalS = parcelRequire("dgalS");

var $8JrFL = parcelRequire("8JrFL");

var $6MfrX = parcelRequire("6MfrX");

var $dH5of = parcelRequire("dH5of");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $301bce285551e585$var$modalStackRegister = [];
function $301bce285551e585$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $dH5of.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $6MfrX.default)(0), _useStateRef2 = (0, $fOsVV.default)(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $8JrFL.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $dgalS.default)(function() {
        var newStackIndex = $301bce285551e585$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $iSvIT.useEffect)(function() {
        var currentStackIndex = $301bce285551e585$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $301bce285551e585$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $301bce285551e585$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $301bce285551e585$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $301bce285551e585$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $301bce285551e585$var$modalStackRegister.splice(currentStackIndex, 1);
                $301bce285551e585$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("dgalS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a74cca8aa53ac94$export$2e2bcd8739ae039; });

var $1TTAl = parcelRequire("1TTAl");
function $9a74cca8aa53ac94$export$2e2bcd8739ae039(callback) {
    var ref = (0, $1TTAl.default)(function() {
        return callback;
    });
    return ref.current;
}

});
parcelRegister("1TTAl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16260b8af36c8da2$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $16260b8af36c8da2$var$uniqueReferencedValue = {};
function $16260b8af36c8da2$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $iSvIT.useRef)($16260b8af36c8da2$var$uniqueReferencedValue);
    if (ref.current === $16260b8af36c8da2$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("8JrFL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65b7fdeb5bc1482d$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $65b7fdeb5bc1482d$export$2e2bcd8739ae039(value) {
    var ref = (0, $iSvIT.useRef)();
    (0, $iSvIT.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("6MfrX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ef335cb58cfca52$export$2e2bcd8739ae039; });

var $fOsVV = parcelRequire("fOsVV");

var $iSvIT = parcelRequire("iSvIT");
function $4ef335cb58cfca52$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $iSvIT.useState)(initialState), _useState2 = (0, $fOsVV.default)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $iSvIT.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("bhyUW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $836c5e1f27f348f5$export$2e2bcd8739ae039; });

var $fOsVV = parcelRequire("fOsVV");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $836c5e1f27f348f5$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $836c5e1f27f348f5$export$2e2bcd8739ae039() {
    var _useState = (0, $iSvIT.useState)(0), _useState2 = (0, $fOsVV.default)(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $iSvIT.useLayoutEffect)(function() {
        setScrollTopOffset($836c5e1f27f348f5$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $iSvIT.useCallback)(function() {
        if ($836c5e1f27f348f5$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $iSvIT.useEffect)(function() {
        return (0, $2e1kT.bind)(window, {
            type: "scroll",
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("jWNxo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e859dc3ff1f2881c$export$2e2bcd8739ae039; });
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $fOsVV = parcelRequire("fOsVV");

var $132G4 = parcelRequire("132G4");

var $iSvIT = parcelRequire("iSvIT");

var $hgIUG = parcelRequire("hgIUG");

var $6gbTC = parcelRequire("6gbTC");

var $iPP84 = parcelRequire("iPP84");

var $4etXW = parcelRequire("4etXW");

var $lFCz3 = parcelRequire("lFCz3");

var $cMUcc = parcelRequire("cMUcc");

var $jwzfp = parcelRequire("jwzfp");

var $6D25d = parcelRequire("6D25d");

var $6QytW = parcelRequire("6QytW");

var $hLDz7 = parcelRequire("hLDz7");

var $96apG = parcelRequire("96apG");

var $21irZ = parcelRequire("21irZ");

var $1pt6P = parcelRequire("1pt6P");

var $424Mh = parcelRequire("424Mh");
var $e859dc3ff1f2881c$var$LOCAL_CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $e859dc3ff1f2881c$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syaz1fxt _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1p6i _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p1cd0 _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl"
};
var $e859dc3ff1f2881c$var$viewportScrollStyles = null;
var $e859dc3ff1f2881c$var$bodyScrollStyles = null;
var $e859dc3ff1f2881c$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? "medium" : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId, _props$isFullScreen = props.isFullScreen, isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen;
    var id = (0, $4etXW.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    var defaultTestId = testId || "modal-dialog";
    (0, $iSvIT.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $jwzfp.combine)((0, $hLDz7.disableDraggingToCrossOriginIFramesForElement)(), (0, $21irZ.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $96apG.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $iPP84.default)((0, $132G4.default)(autoFocus) === "object" ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, $132G4.default)(autoFocus) === "object");
    var _useOnMotionFinish = (0, $6QytW.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, $fOsVV.default)(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $iSvIT.useMemo)(function() {
        return {
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        };
    }, [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $lFCz3.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $lFCz3.useLayering)(), currentLevel = _useLayering.currentLevel;
    return /*#__PURE__*/ $iSvIT.createElement((0, $424Mh.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ $iSvIT.createElement((0, $6D25d.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $iSvIT.createElement((0, $6D25d.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, /*#__PURE__*/ $iSvIT.createElement((0, $cMUcc.default), {
        entranceDirection: isFullScreen ? undefined : "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return /*#__PURE__*/ $iSvIT.createElement("section", (0, $5VbRa.default)({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $6gbTC.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--modal-dialog-width": (0, $1pt6P.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--modal-dialog-height": (0, $1pt6P.dialogHeight)(height)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $hgIUG.default)([
                $e859dc3ff1f2881c$var$dialogStyles.root,
                !isFullScreen && $e859dc3ff1f2881c$var$dialogStyles.borderRadius,
                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children);
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e859dc3ff1f2881c$export$2e2bcd8739ae039 = $e859dc3ff1f2881c$var$ModalDialog;

});
parcelRegister("6gbTC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48ed76fdecc923e6$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $48ed76fdecc923e6$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("iPP84", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db64a69a9ea2c081$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $db64a69a9ea2c081$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $iSvIT.useRef)(true);
    (0, $iSvIT.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("4etXW", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $314fb6cce3497356$export$f680877a34711e37; });

var $132G4 = parcelRequire("132G4");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $jxLBU = parcelRequire("jxLBU");
var $314fb6cce3497356$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $314fb6cce3497356$var$react18UseId = ($314fb6cce3497356$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $314fb6cce3497356$var$_React$useId !== void 0 ? $314fb6cce3497356$var$_React$useId : undefined;
function $314fb6cce3497356$export$f680877a34711e37() {
    if ($314fb6cce3497356$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        if ((0, $jxLBU.fg)("platform-dst-react-18-use-id-selector-safe")) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $314fb6cce3497356$var$react18UseId().replace(/[:«»]/g, "_");
        return $314fb6cce3497356$var$react18UseId();
    }
    return "uid".concat((0, $lzzak.useUID)());
}
var $314fb6cce3497356$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($314fb6cce3497356$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $132G4.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $132G4.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $314fb6cce3497356$export$6ee17796e3d70de2() {
    if ($314fb6cce3497356$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $314fb6cce3497356$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $lzzak.useUIDSeed)();
}

});

parcelRegister("lFCz3", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", function () { return $fc6b5768b7b1568e$export$4a4bf067ea9e7886; });
$parcel$export(module.exports, "useLayering", function () { return $fc6b5768b7b1568e$export$c8b4d54e03dee6ed; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $aoG47 = parcelRequire("aoG47");
var $fc6b5768b7b1568e$var$ESCAPE = "Escape";
function $fc6b5768b7b1568e$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $iSvIT.useRef)(false);
    var _useLayering = $fc6b5768b7b1568e$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $iSvIT.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $fc6b5768b7b1568e$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $iSvIT.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $iSvIT.useEffect)(function() {
        return (0, $2e1kT.bindAll)(window, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $fc6b5768b7b1568e$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $iSvIT.useContext)((0, $aoG47.LevelContext));
    var layerNode = (0, $iSvIT.useContext)((0, $aoG47.LevelNodeContext));
    var rootNode = (0, $iSvIT.useContext)((0, $aoG47.RootNodeContext));
    var isLayerDisabled = (0, $iSvIT.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $iSvIT.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});

parcelRegister("6D25d", function(module, exports) {

$parcel$export(module.exports, "ModalContext", function () { return $4d380043e6256669$export$ab57792b9b6974a6; });
$parcel$export(module.exports, "ScrollContext", function () { return $4d380043e6256669$export$dece24112a937f92; });

var $iSvIT = parcelRequire("iSvIT");
var $4d380043e6256669$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
var $4d380043e6256669$export$dece24112a937f92 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});

parcelRegister("6QytW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fc258cf3f1f7351$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $4fc258cf3f1f7351$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $iSvIT.useRef)(null);
    var onMotionFinish = (0, $iSvIT.useCallback)(function(state) {
        if (state === "entering" && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === "exiting" && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("hLDz7", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", function () { return $cef5844dedbcf309$export$ec28e97c7d8b1b35; });

var $2e1kT = parcelRequire("2e1kT");

var $jwzfp = parcelRequire("jwzfp");

var $1lxXS = parcelRequire("1lxXS");

var $kycWO = parcelRequire("kycWO");
function $cef5844dedbcf309$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $2e1kT.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: "pointerdown",
            listener: stop
        },
        {
            // The user did not start a drag
            type: "pointerup",
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: "dragstart",
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $1lxXS.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $jwzfp.combine)(unbindEvents, unbindMonitor);
}
function $cef5844dedbcf309$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $2e1kT.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: "mousedown",
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $cef5844dedbcf309$var$api = (0, $kycWO.makeFixForAdapter)({
    watchForInteractionStart: $cef5844dedbcf309$var$watchForInteractionStart,
    watchForInteractionEnd: $cef5844dedbcf309$var$watchForInteractionEnd
});
function $cef5844dedbcf309$export$ec28e97c7d8b1b35() {
    return $cef5844dedbcf309$var$api.registerUsage();
}

});
parcelRegister("kycWO", function(module, exports) {

$parcel$export(module.exports, "makeFixForAdapter", function () { return $ef6106bcba06286e$export$a74bff2507e6126b; });

var $d5B2s = parcelRequire("d5B2s");

var $jwzfp = parcelRequire("jwzfp");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $ef6106bcba06286e$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? "" : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $ef6106bcba06286e$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $ef6106bcba06286e$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith("data:")) return false;
    return !$ef6106bcba06286e$var$hasSameOrigin(window.location.href, iframe.src);
}
var $ef6106bcba06286e$var$registry = new Map();
function $ef6106bcba06286e$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll("iframe")).filter($ef6106bcba06286e$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $ef6106bcba06286e$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $ef6106bcba06286e$var$setStyle(iframe, {
                    property: "pointer-events",
                    rule: "none",
                    priority: "important"
                }),
                count: 1
            };
            $ef6106bcba06286e$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $ef6106bcba06286e$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $jwzfp.combine).apply(void 0, (0, $d5B2s.default)(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $ef6106bcba06286e$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $ef6106bcba06286e$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("96apG", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", function () { return $69fcc0721ac99ed6$export$27d79116d3a4e7d5; });

var $lLlRm = parcelRequire("lLlRm");

var $kycWO = parcelRequire("kycWO");
function $69fcc0721ac99ed6$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $lLlRm.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $69fcc0721ac99ed6$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $lLlRm.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $69fcc0721ac99ed6$var$api = (0, $kycWO.makeFixForAdapter)({
    watchForInteractionStart: $69fcc0721ac99ed6$var$watchForInteractionStart,
    watchForInteractionEnd: $69fcc0721ac99ed6$var$watchForInteractionEnd
});
function $69fcc0721ac99ed6$export$27d79116d3a4e7d5() {
    return $69fcc0721ac99ed6$var$api.registerUsage();
}

});

parcelRegister("21irZ", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", function () { return $1789fca54c062dee$export$9c0606fcefb5d1e2; });

var $2e1kT = parcelRequire("2e1kT");

var $jwzfp = parcelRequire("jwzfp");

var $adrrV = parcelRequire("adrrV");

var $kycWO = parcelRequire("kycWO");
function $1789fca54c062dee$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $2e1kT.bindAll)(window, [
        {
            // User is starting another interaction
            type: "pointerdown",
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: "pointerup",
            listener: stopIfNotDragging
        },
        {
            type: "dragstart",
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $adrrV.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $jwzfp.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $1789fca54c062dee$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $2e1kT.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: "mousedown",
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $1789fca54c062dee$var$api = (0, $kycWO.makeFixForAdapter)({
    watchForInteractionStart: $1789fca54c062dee$var$watchForInteractionStart,
    watchForInteractionEnd: $1789fca54c062dee$var$watchForInteractionEnd
});
function $1789fca54c062dee$export$9c0606fcefb5d1e2() {
    return $1789fca54c062dee$var$api.registerUsage();
}

});

parcelRegister("1pt6P", function(module, exports) {

$parcel$export(module.exports, "dialogWidth", function () { return $106eb4bc454c0b56$export$a3da89b899389ed8; });
$parcel$export(module.exports, "dialogHeight", function () { return $106eb4bc454c0b56$export$ceba93bf0bdd16f2; });
var $106eb4bc454c0b56$export$7e3df82ee760448c = {
    values: [
        "small",
        "medium",
        "large",
        "x-large"
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        "x-large": 968
    },
    defaultValue: "medium"
};
var $106eb4bc454c0b56$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return "auto";
    var isWidthName = $106eb4bc454c0b56$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($106eb4bc454c0b56$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === "number" ? "".concat(input, "px") : input;
};
var $106eb4bc454c0b56$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return "auto";
    return typeof input === "number" ? "".concat(input, "px") : input;
};

});

parcelRegister("424Mh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2efb0e1782cd91b7$export$2e2bcd8739ae039; });
/* positioner.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $hgIUG = parcelRequire("hgIUG");

var $9PE6U = parcelRequire("9PE6U");

var $5IRnr = parcelRequire("5IRnr");

// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $2efb0e1782cd91b7$var$positionerStyles = null;
var $2efb0e1782cd91b7$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
var $2efb0e1782cd91b7$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $2efb0e1782cd91b7$var$getScrollBehavior(_ref) {
    var isFullScreen = _ref.isFullScreen, shouldScrollInViewport = _ref.shouldScrollInViewport;
    if (isFullScreen) return "fullScreen";
    if (shouldScrollInViewport) return "viewport";
    return "body";
}
var $2efb0e1782cd91b7$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId, isFullScreen = props.isFullScreen;
    var scrollBehavior = $2efb0e1782cd91b7$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        style: {
            "--modal-dialog-translate-y": "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: "".concat((0, $5IRnr.durations).medium, "ms"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $9PE6U.easeInOut)
        },
        "data-testid": testId && "".concat(testId, "--positioner"),
        className: (0, $hgIUG.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            $2efb0e1782cd91b7$var$stackStyles.stackTransition,
            stackIndex > 0 ? $2efb0e1782cd91b7$var$stackStyles.stackTransform : $2efb0e1782cd91b7$var$stackStyles.stackIdle,
            $2efb0e1782cd91b7$var$scrollStyles[scrollBehavior]
        ])
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2efb0e1782cd91b7$export$2e2bcd8739ae039 = $2efb0e1782cd91b7$var$Positioner;

});
parcelRegister("9PE6U", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $7287fd9142c73617$export$c07234257a03d5e9; });
var $7287fd9142c73617$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $7287fd9142c73617$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $7287fd9142c73617$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";
var $7287fd9142c73617$export$fc825baa2ef870d0 = "cubic-bezier(0.4,0,0,1)";
var $7287fd9142c73617$export$816ee5d79b5bd9a5 = "cubic-bezier(0.6,0,0,1)";
var $7287fd9142c73617$export$53ce3390a1a8f2a2 = "cubic-bezier(0.8,0,0,1)";
var $7287fd9142c73617$export$45db2fc2f15997e7 = "cubic-bezier(0,0,1,1)";

});





parcelRegister("e4PnT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3f94c4170e2b187$export$2e2bcd8739ae039; });
/* modal-body.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $hgIUG = parcelRequire("hgIUG");

var $iSvIT = parcelRequire("iSvIT");

var $cpjHB = parcelRequire("cpjHB");

var $jxLBU = parcelRequire("jxLBU");

var $2v5e9 = parcelRequire("2v5e9");

var $3j0XZ = parcelRequire("3j0XZ");

var $gywYi = parcelRequire("gywYi");
var $a3f94c4170e2b187$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug",
    font: "_11c82smr",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $a3f94c4170e2b187$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasInlinePaddi = props.hasInlinePadding, hasInlinePadding = _props$hasInlinePaddi === void 0 ? true : _props$hasInlinePaddi;
    var _useModal = (0, $2v5e9.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $gywYi.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        "data-testid": testId,
        className: (0, $hgIUG.default)([
            $a3f94c4170e2b187$var$styles.root,
            hasInlinePadding && $a3f94c4170e2b187$var$styles.paddingInline,
            (0, $jxLBU.fg)("platform_ads_explicit_font_styles") && $a3f94c4170e2b187$var$styles.font
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $cpjHB.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $3j0XZ.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        "data-testid": testId,
        className: (0, $hgIUG.default)([
            $a3f94c4170e2b187$var$styles.root,
            /**
     * Adding block padding for scroll keylines, which are only shown when the scrolling
     * is on the container.
     */ $a3f94c4170e2b187$var$styles.paddingBlock,
            hasInlinePadding && $a3f94c4170e2b187$var$styles.paddingInline,
            (0, $jxLBU.fg)("platform_ads_explicit_font_styles") && $a3f94c4170e2b187$var$styles.font
        ])
    }, children)));
};
var $a3f94c4170e2b187$export$2e2bcd8739ae039 = $a3f94c4170e2b187$var$ModalBody;

});
parcelRegister("2v5e9", function(module, exports) {

$parcel$export(module.exports, "useModal", function () { return $1d22880519baa922$export$33ffd74ebf07f060; });

var $iSvIT = parcelRequire("iSvIT");

var $6D25d = parcelRequire("6D25d");
var $1d22880519baa922$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $iSvIT.useContext)((0, $6D25d.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("3j0XZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2683e55ed613746b$export$2e2bcd8739ae039; });
/* scroll-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $fOsVV = parcelRequire("fOsVV");


var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $kA3CX = parcelRequire("kA3CX");

var $hjIOW = parcelRequire("hjIOW");

var $6gbTC = parcelRequire("6gbTC");

var $2KCPo = parcelRequire("2KCPo");

var $dgalS = parcelRequire("dgalS");

var $92i9t = parcelRequire("92i9t");
var $2683e55ed613746b$var$keylineColor = "var(--ds-border, #091E4224)";
var $2683e55ed613746b$var$styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm2187z",
    bottomKeyline: "_179r187z"
};
var $2683e55ed613746b$var$keylineHeight = 2;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $2683e55ed613746b$var$ScrollContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $iSvIT.useRef)(null);
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $fOsVV.default)(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(false), _useState4 = (0, $fOsVV.default)(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)(false), _useState6 = (0, $fOsVV.default)(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $iSvIT.useEffect)(function() {
        var schedule = (0, $kA3CX.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $dgalS.default)((0, $kA3CX.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $2683e55ed613746b$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $2683e55ed613746b$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $iSvIT.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $2e1kT.bind)(window, {
            type: "resize",
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $2e1kT.bind)(target, {
            type: "scroll",
            listener: setLazyKeylines
        }) : (0, $2KCPo.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $92i9t.default), {
        as: "div",
        isInset: true,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? "region" : undefined,
        "aria-label": showContentFocus ? "Scrollable content" : undefined,
        testId: testId && "".concat(testId, "--scrollable"),
        ref: (0, $6gbTC.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $hjIOW.cx)($2683e55ed613746b$var$styles.base, showTopKeyline && $2683e55ed613746b$var$styles.topKeyline, showBottomKeyline && $2683e55ed613746b$var$styles.bottomKeyline)
    }, children);
});
$2683e55ed613746b$var$ScrollContainer.displayName = "ScrollContainer";
var $2683e55ed613746b$export$2e2bcd8739ae039 = $2683e55ed613746b$var$ScrollContainer;

});
parcelRegister("hjIOW", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $c9b6fa7163930da4$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("iSvIT");


var $9Vj0T = parcelRequire("9Vj0T");
var $c9b6fa7163930da4$var$strictApi = (0, $9Vj0T.createStrictAPI)();
var $c9b6fa7163930da4$export$dbf350e5966cf602 = $c9b6fa7163930da4$var$strictApi.css;
var $c9b6fa7163930da4$export$eb1ecd84a24ee424 = $c9b6fa7163930da4$var$strictApi.cssMap;
$c9b6fa7163930da4$var$strictApi.cssMap;
var $c9b6fa7163930da4$export$a274e22fb40f762e = $c9b6fa7163930da4$var$strictApi.cx;
var $c9b6fa7163930da4$var$XCSSProp = $c9b6fa7163930da4$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("9Vj0T", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $73982f9331579b03$export$39716b4af53f4ad; });

var $itF4Q = parcelRequire("itF4Q");

var $cwNao = parcelRequire("cwNao");
function $73982f9331579b03$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $itF4Q.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $itF4Q.createStrictSetupError)();
        },
        cx: $cwNao.cx,
        XCSSProp () {
            throw (0, $itF4Q.createStrictSetupError)();
        }
    };
}

});
parcelRegister("itF4Q", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $d73acc82a650da5e$export$c4df1cb0c2b4d77c; });
const $d73acc82a650da5e$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $d73acc82a650da5e$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("cwNao", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $91ee9ca53b270cae$export$a274e22fb40f762e; });

var $hgIUG = parcelRequire("hgIUG");
const $91ee9ca53b270cae$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $hgIUG.default)(actualStyles);
};

});



parcelRegister("92i9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69426188e22f8337$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");

var $jmw91 = parcelRequire("jmw91");
var $69426188e22f8337$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $69426188e22f8337$var$_excluded2 = [
    "className"
];
var $69426188e22f8337$var$focusRingStyles = null;
var $69426188e22f8337$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $69426188e22f8337$var$Focusable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $4Onlm.default)(_ref, $69426188e22f8337$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $4Onlm.default)(htmlAttributes, $69426188e22f8337$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $5VbRa.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $jmw91.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $69426188e22f8337$export$2e2bcd8739ae039 = $69426188e22f8337$var$Focusable;

});
parcelRegister("jmw91", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e189019ee5991295$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $e189019ee5991295$var$ATOMIC_GROUP_LENGTH = 5;
function $e189019ee5991295$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $e189019ee5991295$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("gywYi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0d965c5653e619a$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $6D25d = parcelRequire("6D25d");
function $c0d965c5653e619a$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $iSvIT.useContext)((0, $6D25d.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("787yF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $530f24a7dd198f47$export$2e2bcd8739ae039; });
/* modal-footer.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $hgIUG = parcelRequire("hgIUG");

var $2v5e9 = parcelRequire("2v5e9");
var $530f24a7dd198f47$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $530f24a7dd198f47$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $2v5e9.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        "data-testid": testId,
        className: (0, $hgIUG.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ])
    }, children);
};
var $530f24a7dd198f47$export$2e2bcd8739ae039 = $530f24a7dd198f47$var$ModalFooter;

});

parcelRegister("7Y8FR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cd4dd8781bded39$export$2e2bcd8739ae039; });
/* modal-header.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $hgIUG = parcelRequire("hgIUG");

var $iSvIT = parcelRequire("iSvIT");

var $dHLdV = parcelRequire("dHLdV");
var $7Ed46 = parcelRequire("7Ed46");

var $glVwi = parcelRequire("glVwi");

var $2v5e9 = parcelRequire("2v5e9");
var $5cd4dd8781bded39$var$headerStyles = null;
var $5cd4dd8781bded39$var$flexStyles = (0, $7Ed46.xcss)({
    flexDirection: "row-reverse",
    width: "100%"
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $5cd4dd8781bded39$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $2v5e9.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        "data-testid": testId,
        className: (0, $hgIUG.default)([
            "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb"
        ])
    }, shouldShowCloseButton ? /*#__PURE__*/ // The reason we are putting the close button first in the DOM and then
    // reordering them is to ensure that users of assistive technology get
    // all the context of a modal when initial focus is placed on the close
    // button, since it's the first interactive element.
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $dHLdV.default), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $5cd4dd8781bded39$var$flexStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $dHLdV.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $glVwi.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $dHLdV.default), {
        justifyContent: "start",
        alignItems: "center"
    }, children)) : children);
};
var $5cd4dd8781bded39$export$2e2bcd8739ae039 = $5cd4dd8781bded39$var$ModalHeader;

});
parcelRegister("dHLdV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fa3ec20ae695694$export$2e2bcd8739ae039; });

var $d5B2s = parcelRequire("d5B2s");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $lNjCj = parcelRequire("lNjCj");

var $7Ed46 = parcelRequire("7Ed46");
var $9fa3ec20ae695694$var$justifyContentMap = {
    start: (0, $2ZUkg.css)({
        justifyContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyContent: "stretch"
    })
};
var $9fa3ec20ae695694$var$flexDirectionMap = {
    column: (0, $2ZUkg.css)({
        flexDirection: "column"
    }),
    row: (0, $2ZUkg.css)({
        flexDirection: "row"
    })
};
var $9fa3ec20ae695694$var$flexWrapMap = {
    wrap: (0, $2ZUkg.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $2ZUkg.css)({
        flexWrap: "nowrap"
    })
};
var $9fa3ec20ae695694$var$alignItemsMap = {
    start: (0, $2ZUkg.css)({
        alignItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignItems: "center"
    }),
    baseline: (0, $2ZUkg.css)({
        alignItems: "baseline"
    }),
    end: (0, $2ZUkg.css)({
        alignItems: "end"
    }),
    stretch: (0, $2ZUkg.css)({
        alignItems: "stretch"
    })
};
var $9fa3ec20ae695694$var$baseStyles = (0, $2ZUkg.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $9fa3ec20ae695694$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $7Ed46.parseXcss)(xcss);
    return (0, $2ZUkg.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $9fa3ec20ae695694$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $lNjCj.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $lNjCj.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $lNjCj.spaceStylesMap).rowGap[rowGap],
            alignItems && $9fa3ec20ae695694$var$alignItemsMap[alignItems],
            direction && $9fa3ec20ae695694$var$flexDirectionMap[direction],
            justifyContent && $9fa3ec20ae695694$var$justifyContentMap[justifyContent],
            wrap && $9fa3ec20ae695694$var$flexWrapMap[wrap]
        ].concat((0, $d5B2s.default)(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$9fa3ec20ae695694$var$Flex.displayName = "Flex";
var $9fa3ec20ae695694$export$2e2bcd8739ae039 = $9fa3ec20ae695694$var$Flex;

});
parcelRegister("lNjCj", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $fddd6412f6ba7574$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $fddd6412f6ba7574$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $fddd6412f6ba7574$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $fddd6412f6ba7574$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $fddd6412f6ba7574$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $fddd6412f6ba7574$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $fddd6412f6ba7574$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $fddd6412f6ba7574$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $fddd6412f6ba7574$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $fddd6412f6ba7574$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $fddd6412f6ba7574$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $fddd6412f6ba7574$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $fddd6412f6ba7574$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $fddd6412f6ba7574$export$3c7e9587132614b4; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $fddd6412f6ba7574$export$bf46c3f9eeafc71f; });

var $fACfu = parcelRequire("fACfu");

var $2ZUkg = parcelRequire("2ZUkg");

var $7R1y6 = parcelRequire("7R1y6");
function $fddd6412f6ba7574$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fddd6412f6ba7574$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fddd6412f6ba7574$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fddd6412f6ba7574$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fddd6412f6ba7574$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $fddd6412f6ba7574$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $fddd6412f6ba7574$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $fddd6412f6ba7574$export$632685d741f3dbbf = $fddd6412f6ba7574$var$_objectSpread($fddd6412f6ba7574$var$_objectSpread({}, $fddd6412f6ba7574$export$958d0ae7f2977ae4), $fddd6412f6ba7574$export$d2dc61f58390201c);
var $fddd6412f6ba7574$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $fddd6412f6ba7574$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $fddd6412f6ba7574$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $fddd6412f6ba7574$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $fddd6412f6ba7574$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $fddd6412f6ba7574$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $fddd6412f6ba7574$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $fddd6412f6ba7574$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B778C)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $fddd6412f6ba7574$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $fddd6412f6ba7574$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.selected": "var(--ds-border-width-selected, 2px)",
    "border.width.focused": "var(--ds-border-width-focused, 2px)"
};
var $fddd6412f6ba7574$export$3c0a6c3e64bb180d = {
    "radius.xsmall": "var(--ds-radius-xsmall, 2px)",
    "radius.small": "var(--ds-radius-small, 3px)",
    "radius.medium": "var(--ds-radius-medium, 6px)",
    "radius.large": "var(--ds-radius-large, 8px)",
    "radius.xlarge": "var(--ds-radius-xlarge, 12px)",
    "radius.full": "var(--ds-radius-full, 9999px)",
    "radius.tile": "var(--ds-radius-tile, 25%)"
};
var $fddd6412f6ba7574$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.large": 'var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.medium": 'var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.metric.small": 'var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $fddd6412f6ba7574$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $fddd6412f6ba7574$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $fddd6412f6ba7574$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $fddd6412f6ba7574$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $fddd6412f6ba7574$export$b805719bc8cb376 = {
    large: 'var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    medium: 'var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $fddd6412f6ba7574$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $fddd6412f6ba7574$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $2ZUkg.css)((0, $fACfu.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $fddd6412f6ba7574$export$e615f061ca585a6c = $fddd6412f6ba7574$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $fddd6412f6ba7574$export$ca0f9c2de39ffed7(spacingProperty, $fddd6412f6ba7574$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $fddd6412f6ba7574$export$bf46c3f9eeafc71f = $fddd6412f6ba7574$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $fddd6412f6ba7574$export$ca0f9c2de39ffed7(spacingProperty, $fddd6412f6ba7574$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $fddd6412f6ba7574$export$e7af83bafe7f9e63 = $fddd6412f6ba7574$export$ca0f9c2de39ffed7("backgroundColor", $fddd6412f6ba7574$export$d1d79bf68ac056bd);
var $fddd6412f6ba7574$export$3a1bcba60b23d7f0 = $fddd6412f6ba7574$export$ca0f9c2de39ffed7("color", $fddd6412f6ba7574$export$8473307aa00d6ea1);
var $fddd6412f6ba7574$export$45f3f4fe16f9f7d5 = $fddd6412f6ba7574$export$ca0f9c2de39ffed7("fontWeight", $fddd6412f6ba7574$export$303e322c6b1ed114);
var $fddd6412f6ba7574$export$68cc305da27dbaa4 = $fddd6412f6ba7574$export$ca0f9c2de39ffed7("fontFamily", $fddd6412f6ba7574$export$3c7e9587132614b4);
var $fddd6412f6ba7574$export$128f10c238242f83 = $fddd6412f6ba7574$export$ca0f9c2de39ffed7("font", $fddd6412f6ba7574$export$6ffa317d5e70375);
var $fddd6412f6ba7574$export$219d364c0da35ae4 = $fddd6412f6ba7574$export$ca0f9c2de39ffed7("font", $fddd6412f6ba7574$export$236bfe3a33ef1292);
var $fddd6412f6ba7574$export$38845ca010b93505 = $fddd6412f6ba7574$export$ca0f9c2de39ffed7("fontWeight", $fddd6412f6ba7574$export$855cfd311192d666);
var $fddd6412f6ba7574$export$ff257d957d48c421 = $fddd6412f6ba7574$export$ca0f9c2de39ffed7((0, $7R1y6.CURRENT_SURFACE_CSS_VAR), $fddd6412f6ba7574$export$41a358c9c2356760);
var $fddd6412f6ba7574$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $fddd6412f6ba7574$export$41a358c9c2356760[color] !== undefined;
};
var $fddd6412f6ba7574$export$7001ce64d9ff7c7f = $fddd6412f6ba7574$export$ca0f9c2de39ffed7("font", $fddd6412f6ba7574$export$b805719bc8cb376);

});
parcelRegister("7R1y6", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $5b7eaf3be1f9cfa2$export$9d7b58831ae93caa; });
var $5b7eaf3be1f9cfa2$export$4ef52930e33717cd = "data-theme";
var $5b7eaf3be1f9cfa2$export$a00eac3f8684bcd0 = "data-color-mode";
var $5b7eaf3be1f9cfa2$export$2112803007239c61 = "data-contrast-mode";
var $5b7eaf3be1f9cfa2$export$352e418ed5b6193a = "data-custom-theme";
var $5b7eaf3be1f9cfa2$export$6f0c6fb8c80fcc92 = "ds";
var $5b7eaf3be1f9cfa2$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border",
    "radius"
];
var $5b7eaf3be1f9cfa2$export$dddac1532e822863 = "--".concat($5b7eaf3be1f9cfa2$export$6f0c6fb8c80fcc92, "-token-not-found");
var $5b7eaf3be1f9cfa2$export$9d7b58831ae93caa = "--".concat($5b7eaf3be1f9cfa2$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("7Ed46", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $591667501b74626c$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $591667501b74626c$export$f6c783d06584602c; });

var $d5B2s = parcelRequire("d5B2s");

var $fACfu = parcelRequire("fACfu");

var $fOsVV = parcelRequire("fOsVV");

var $132G4 = parcelRequire("132G4");

var $2ZUkg = parcelRequire("2ZUkg");

var $lNjCj = parcelRequire("lNjCj");

var $XAEGR = parcelRequire("XAEGR");
function $591667501b74626c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $591667501b74626c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $591667501b74626c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $591667501b74626c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $591667501b74626c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $591667501b74626c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $591667501b74626c$export$9a199fbafee0014e = {
    backgroundColor: (0, $lNjCj.backgroundColorMap),
    blockSize: (0, $lNjCj.dimensionMap),
    borderBlockColor: (0, $lNjCj.borderColorMap),
    borderBlockEndColor: (0, $lNjCj.borderColorMap),
    borderBlockEndWidth: (0, $lNjCj.borderWidthMap),
    borderBlockStartColor: (0, $lNjCj.borderColorMap),
    borderBlockStartWidth: (0, $lNjCj.borderWidthMap),
    borderBlockWidth: (0, $lNjCj.borderWidthMap),
    borderBottomColor: (0, $lNjCj.borderColorMap),
    borderBottomLeftRadius: (0, $lNjCj.borderRadiusMap),
    borderBottomRightRadius: (0, $lNjCj.borderRadiusMap),
    borderBottomWidth: (0, $lNjCj.borderWidthMap),
    borderColor: (0, $lNjCj.borderColorMap),
    borderEndEndRadius: (0, $lNjCj.borderRadiusMap),
    borderEndStartRadius: (0, $lNjCj.borderRadiusMap),
    borderInlineColor: (0, $lNjCj.borderColorMap),
    borderInlineEndColor: (0, $lNjCj.borderColorMap),
    borderInlineEndWidth: (0, $lNjCj.borderWidthMap),
    borderInlineStartColor: (0, $lNjCj.borderColorMap),
    borderInlineStartWidth: (0, $lNjCj.borderWidthMap),
    borderInlineWidth: (0, $lNjCj.borderWidthMap),
    borderLeftColor: (0, $lNjCj.borderColorMap),
    borderLeftWidth: (0, $lNjCj.borderWidthMap),
    borderRadius: (0, $lNjCj.borderRadiusMap),
    borderRightColor: (0, $lNjCj.borderColorMap),
    borderRightWidth: (0, $lNjCj.borderWidthMap),
    borderStartEndRadius: (0, $lNjCj.borderRadiusMap),
    borderStartStartRadius: (0, $lNjCj.borderRadiusMap),
    borderTopColor: (0, $lNjCj.borderColorMap),
    borderTopLeftRadius: (0, $lNjCj.borderRadiusMap),
    borderTopRightRadius: (0, $lNjCj.borderRadiusMap),
    borderTopWidth: (0, $lNjCj.borderWidthMap),
    borderWidth: (0, $lNjCj.borderWidthMap),
    bottom: (0, $lNjCj.allSpaceMap),
    boxShadow: (0, $lNjCj.shadowMap),
    color: (0, $lNjCj.textColorMap),
    columnGap: (0, $lNjCj.positiveSpaceMap),
    font: (0, $lNjCj.fontMap),
    fontFamily: (0, $lNjCj.fontFamilyMap),
    fontWeight: (0, $lNjCj.fontWeightMap),
    gap: (0, $lNjCj.positiveSpaceMap),
    height: (0, $lNjCj.dimensionMap),
    inlineSize: (0, $lNjCj.dimensionMap),
    inset: (0, $lNjCj.allSpaceMap),
    insetBlock: (0, $lNjCj.allSpaceMap),
    insetBlockEnd: (0, $lNjCj.allSpaceMap),
    insetBlockStart: (0, $lNjCj.allSpaceMap),
    insetInline: (0, $lNjCj.allSpaceMap),
    insetInlineEnd: (0, $lNjCj.allSpaceMap),
    insetInlineStart: (0, $lNjCj.allSpaceMap),
    left: (0, $lNjCj.allSpaceMap),
    margin: (0, $lNjCj.allSpaceMap),
    marginBlock: (0, $lNjCj.allSpaceMap),
    marginBlockEnd: (0, $lNjCj.allSpaceMap),
    marginBlockStart: (0, $lNjCj.allSpaceMap),
    marginBottom: (0, $lNjCj.allSpaceMap),
    marginInline: (0, $lNjCj.allSpaceMap),
    marginInlineEnd: (0, $lNjCj.allSpaceMap),
    marginInlineStart: (0, $lNjCj.allSpaceMap),
    marginLeft: (0, $lNjCj.allSpaceMap),
    marginRight: (0, $lNjCj.allSpaceMap),
    marginTop: (0, $lNjCj.allSpaceMap),
    maxBlockSize: (0, $lNjCj.dimensionMap),
    maxHeight: (0, $lNjCj.dimensionMap),
    maxInlineSize: (0, $lNjCj.dimensionMap),
    maxWidth: (0, $lNjCj.dimensionMap),
    minBlockSize: (0, $lNjCj.dimensionMap),
    minHeight: (0, $lNjCj.dimensionMap),
    minInlineSize: (0, $lNjCj.dimensionMap),
    minWidth: (0, $lNjCj.dimensionMap),
    opacity: (0, $lNjCj.opacityMap),
    outlineColor: (0, $lNjCj.borderColorMap),
    outlineOffset: (0, $lNjCj.allSpaceMap),
    outlineWidth: (0, $lNjCj.borderWidthMap),
    padding: (0, $lNjCj.positiveSpaceMap),
    paddingBlock: (0, $lNjCj.positiveSpaceMap),
    paddingBlockEnd: (0, $lNjCj.positiveSpaceMap),
    paddingBlockStart: (0, $lNjCj.positiveSpaceMap),
    paddingBottom: (0, $lNjCj.positiveSpaceMap),
    paddingInline: (0, $lNjCj.positiveSpaceMap),
    paddingInlineEnd: (0, $lNjCj.positiveSpaceMap),
    paddingInlineStart: (0, $lNjCj.positiveSpaceMap),
    paddingLeft: (0, $lNjCj.positiveSpaceMap),
    paddingRight: (0, $lNjCj.positiveSpaceMap),
    paddingTop: (0, $lNjCj.positiveSpaceMap),
    right: (0, $lNjCj.allSpaceMap),
    rowGap: (0, $lNjCj.positiveSpaceMap),
    top: (0, $lNjCj.allSpaceMap),
    width: (0, $lNjCj.dimensionMap),
    zIndex: (0, $lNjCj.layerMap)
};
var $591667501b74626c$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $591667501b74626c$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $XAEGR === "undefined" ? "undefined" : (0, $132G4.default)($XAEGR)) === "object" && (0, $132G4.default)($XAEGR.env) === "object" && false;
};
var $591667501b74626c$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $591667501b74626c$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $591667501b74626c$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $132G4.default)(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($591667501b74626c$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $fOsVV.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $132G4.default)(value) === "object" && $591667501b74626c$var$safeSelectors.test(key)) {
            styleObj[key] = $591667501b74626c$var$_transformStyles(value);
            return;
        }
        if ($591667501b74626c$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($591667501b74626c$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $591667501b74626c$export$9a199fbafee0014e)) return;
        var tokenValue = $591667501b74626c$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $591667501b74626c$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $591667501b74626c$var$_transformStyles(style);
    return (0, $fACfu.default)({}, $591667501b74626c$var$uniqueSymbol, (0, $2ZUkg.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $591667501b74626c$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $591667501b74626c$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $591667501b74626c$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $d5B2s.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$591667501b74626c$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $591667501b74626c$export$f6c783d06584602c(style) {
    return $591667501b74626c$var$baseXcss(style);
}

});


parcelRegister("glVwi", function(module, exports) {

$parcel$export(module.exports, "CloseButton", function () { return $be7b39c9353562a5$export$de65de8213222d10; });

var $iSvIT = parcelRequire("iSvIT");

var $hcLL1 = parcelRequire("hcLL1");

var $1yWop = parcelRequire("1yWop");
var $be7b39c9353562a5$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onBlur = _ref.onBlur, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hcLL1.default), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yWop))),
        label: label || "Close Modal",
        onBlur: onBlur,
        onClick: onClick
    });
};

});
parcelRegister("hcLL1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8689a4f94a661d0$export$2e2bcd8739ae039; });

var $5VbRa = parcelRequire("5VbRa");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");

var $5LD4E = parcelRequire("5LD4E");

var $1te6N = parcelRequire("1te6N");

var $ibbno = parcelRequire("ibbno");

var $74aO6 = parcelRequire("74aO6");

var $9wICq = parcelRequire("9wICq");

var $6wtUM = parcelRequire("6wtUM");
var $c8689a4f94a661d0$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $c8689a4f94a661d0$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $c8689a4f94a661d0$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, $4Onlm.default)(_ref, $c8689a4f94a661d0$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $4Onlm.default)(unsafeRest, $c8689a4f94a661d0$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $74aO6.default), (0, $5VbRa.default)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === "circle",
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9wICq.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6wtUM.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ibbno.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1te6N.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $74aO6.default), (0, $5VbRa.default)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === "circle",
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $5LD4E.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9wICq.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6wtUM.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ibbno.default), null, label)));
    });
}));
$c8689a4f94a661d0$var$IconButton.displayName = "IconButton";
var $c8689a4f94a661d0$export$2e2bcd8739ae039 = $c8689a4f94a661d0$var$IconButton;

});
parcelRegister("5LD4E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $432fa6cfba523dfc$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $432fa6cfba523dfc$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("1te6N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11237187efb286aa$export$2e2bcd8739ae039; });

var $5VbRa = parcelRequire("5VbRa");

var $fOsVV = parcelRequire("fOsVV");

var $fACfu = parcelRequire("fACfu");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $hmQ5H = parcelRequire("hmQ5H");

var $79Ejs = parcelRequire("79Ejs");

var $cp9jJ = parcelRequire("cp9jJ");

var $844uI = parcelRequire("844uI");

var $1Z36a = parcelRequire("1Z36a");

var $dH5of = parcelRequire("dH5of");
var $cMUcc = parcelRequire("cMUcc");

var $jxLBU = parcelRequire("jxLBU");

var $gr749 = parcelRequire("gr749");

var $gWVOm = parcelRequire("gWVOm");

var $eR9DZ = parcelRequire("eR9DZ");

var $bxtE3 = parcelRequire("bxtE3");

var $7mNyG = parcelRequire("7mNyG");

var $5NLRL = parcelRequire("5NLRL");

var $5bos5 = parcelRequire("5bos5");

var $bQdeG = parcelRequire("bQdeG");
function $11237187efb286aa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11237187efb286aa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11237187efb286aa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11237187efb286aa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $11237187efb286aa$var$tooltipZIndex = (0, $eR9DZ.layers).tooltip();
var $11237187efb286aa$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "0.0.0-development"
};
// Inverts motion direction
var $11237187efb286aa$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $11237187efb286aa$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $11237187efb286aa$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $5bos5.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $79Ejs.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $79Ejs.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $hmQ5H.usePlatformLeafSyntheticEventHandler)($11237187efb286aa$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $11237187efb286aa$var$analyticsAttributes));
    var onHideHandler = (0, $hmQ5H.usePlatformLeafSyntheticEventHandler)($11237187efb286aa$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $11237187efb286aa$var$analyticsAttributes));
    var apiRef = (0, $iSvIT.useRef)(null);
    var _useState = (0, $iSvIT.useState)("hide"), _useState2 = (0, $fOsVV.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $iSvIT.useRef)(null);
    var containerRef = (0, $iSvIT.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $iSvIT.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $844uI.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $844uI.default)(onShowHandler);
    var onHideHandlerStable = (0, $844uI.default)(onHideHandler);
    var delayStable = (0, $844uI.default)(delay);
    var canAppearStable = (0, $844uI.default)(canAppear);
    var hasCalledShowHandler = (0, $iSvIT.useRef)(false);
    var start = (0, $iSvIT.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $iSvIT.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $iSvIT.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $iSvIT.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $iSvIT.useRef)(false);
    (0, $iSvIT.useEffect)(function() {
        return (0, $bxtE3.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $iSvIT.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $7mNyG.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $iSvIT.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $cp9jJ.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $iSvIT.useEffect)(function() {
        if (state === "hide") return 0, $79Ejs.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $2e1kT.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $iSvIT.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $iSvIT.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $iSvIT.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $bQdeG.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $iSvIT.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $bQdeG.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $iSvIT.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $iSvIT.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(":focus-visible") && (0, $jxLBU.fg)("platform-tooltip-focus-visible-new")) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $iSvIT.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $iSvIT.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var handleOpenLayerObserverCloseSignal = (0, $iSvIT.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $1Z36a.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === "mouse" && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $5NLRL.default)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $iSvIT.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children($11237187efb286aa$var$_objectSpread($11237187efb286aa$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(CastTargetContainer, (0, $5VbRa.default)({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gWVOm.default), {
        zIndex: $11237187efb286aa$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gr749.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $11237187efb286aa$var$invertedDirection[$11237187efb286aa$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $dH5of.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $cMUcc.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $11237187efb286aa$var$_objectSpread($11237187efb286aa$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $11237187efb286aa$export$2e2bcd8739ae039 = $11237187efb286aa$var$Tooltip;

});
parcelRegister("hmQ5H", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $ca4ce5e99663293c$export$1a04351537078b55; });

var $fACfu = parcelRequire("fACfu");

var $iSvIT = parcelRequire("iSvIT");

var $8ipIc = parcelRequire("8ipIc");

var $kXY8N = parcelRequire("kXY8N");
function $ca4ce5e99663293c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ca4ce5e99663293c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ca4ce5e99663293c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ca4ce5e99663293c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ca4ce5e99663293c$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $8ipIc.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $kXY8N.useTrackedRef)(analyticsData);
    var fnRef = (0, $kXY8N.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $ca4ce5e99663293c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("79Ejs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5358a4f15c3d544b$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $5358a4f15c3d544b$export$2e2bcd8739ae039() {}

});

parcelRegister("cp9jJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $907f0c0a42bba724$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $jxLBU = parcelRequire("jxLBU");

var $60XUw = parcelRequire("60XUw");
function $907f0c0a42bba724$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $iSvIT.useRef)(false);
    var onKeyDown = (0, $iSvIT.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $60XUw.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $iSvIT.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $iSvIT.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled && (0, $jxLBU.fg)("platform_only_attach_escape_handler_on_view")) return;
        return (0, $2e1kT.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("60XUw", function(module, exports) {

$parcel$export(module.exports, "ESCAPE", function () { return $46113730e08b1d85$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $46113730e08b1d85$export$390330c10ff2b9a1 = "ArrowUp";
var $46113730e08b1d85$export$a80636c6f41931fe = "ArrowDown";
var $46113730e08b1d85$export$4af703091671bc = "Home";
var $46113730e08b1d85$export$e2bc30913faa5db7 = "End";
var $46113730e08b1d85$export$10f6869ed0a7d75b = "Tab";
var $46113730e08b1d85$export$8152f929a25a0ff4 = "Enter";
var $46113730e08b1d85$export$e51a3576c045c8d5 = "Space";
var $46113730e08b1d85$export$2bb790b9008907b4 = "Escape";

});


parcelRegister("844uI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5df22ef17fd43bf0$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $5df22ef17fd43bf0$export$2e2bcd8739ae039(value) {
    var ref = (0, $iSvIT.useRef)(value);
    (0, $iSvIT.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("bxtE3", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8669c5a86963f860$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $2e1kT = parcelRequire("2e1kT");
var $8669c5a86963f860$var$registrations = new Set();
var $8669c5a86963f860$var$cleanupEndEventListeners = null;
function $8669c5a86963f860$var$onDragStart() {
    if ($8669c5a86963f860$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $8669c5a86963f860$var$cleanupEndEventListeners = (0, $2e1kT.bindAll)(window, [
        {
            type: "dragend",
            listener: $8669c5a86963f860$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $8669c5a86963f860$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $8669c5a86963f860$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($8669c5a86963f860$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $8669c5a86963f860$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $8669c5a86963f860$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $8669c5a86963f860$var$cleanupEndEventListeners = null;
    var clone = Array.from($8669c5a86963f860$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $8669c5a86963f860$var$bindStartEvents() {
    return (0, $2e1kT.bindAll)(window, [
        {
            type: "dragstart",
            listener: $8669c5a86963f860$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $8669c5a86963f860$var$onDragStart
        }
    ]);
}
var $8669c5a86963f860$var$cleanupStartEventListeners = null;
function $8669c5a86963f860$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$8669c5a86963f860$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $8669c5a86963f860$var$cleanupStartEventListeners = $8669c5a86963f860$var$bindStartEvents();
    $8669c5a86963f860$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $8669c5a86963f860$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $8669c5a86963f860$var$registrations.delete(registration);
        if ($8669c5a86963f860$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $8669c5a86963f860$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $8669c5a86963f860$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("7mNyG", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $55d107c3a1087707$export$57bf213be019eeb0; });

var $iGxzm = parcelRequire("iGxzm");
// This file is a singleton for managing tooltips
var $55d107c3a1087707$var$active = null;
function $55d107c3a1087707$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($55d107c3a1087707$var$active && $55d107c3a1087707$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $iGxzm.clearScheduled)();
            $55d107c3a1087707$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $iGxzm.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $iGxzm.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $iGxzm.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($55d107c3a1087707$var$active && $55d107c3a1087707$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($55d107c3a1087707$var$active) {
            (0, $iGxzm.clearScheduled)();
            $55d107c3a1087707$var$active.entry.hide({
                isImmediate: true
            });
            $55d107c3a1087707$var$active.entry.done();
            $55d107c3a1087707$var$active = null;
        }
        // this tooltip is now the active tooltip
        $55d107c3a1087707$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $iGxzm.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("iGxzm", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $d9a6306a7ec6b2bd$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $d9a6306a7ec6b2bd$export$5f4d6617421d489b; });
var $d9a6306a7ec6b2bd$var$delayId = null;
function $d9a6306a7ec6b2bd$export$eaf678f6f93f5250() {
    if ($d9a6306a7ec6b2bd$var$delayId != null) {
        window.clearTimeout($d9a6306a7ec6b2bd$var$delayId);
        $d9a6306a7ec6b2bd$var$delayId = null;
    }
}
function $d9a6306a7ec6b2bd$export$5f4d6617421d489b(fn, delay) {
    $d9a6306a7ec6b2bd$export$eaf678f6f93f5250();
    $d9a6306a7ec6b2bd$var$delayId = window.setTimeout(function() {
        $d9a6306a7ec6b2bd$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("5NLRL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4396a8912c729fc8$export$2e2bcd8739ae039; });

var $8dLdn = parcelRequire("8dLdn");
function $4396a8912c729fc8$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $8dLdn.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("8dLdn", function(module, exports) {

$parcel$export(module.exports, "useIdSeed", function () { return $5fc4297c89e52f2b$export$6ee17796e3d70de2; });

var $132G4 = parcelRequire("132G4");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $jxLBU = parcelRequire("jxLBU");
var $5fc4297c89e52f2b$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $5fc4297c89e52f2b$var$react18UseId = ($5fc4297c89e52f2b$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $5fc4297c89e52f2b$var$_React$useId !== void 0 ? $5fc4297c89e52f2b$var$_React$useId : undefined;
function $5fc4297c89e52f2b$export$f680877a34711e37() {
    if ($5fc4297c89e52f2b$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        if ((0, $jxLBU.fg)("platform-dst-react-18-use-id-selector-safe")) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $5fc4297c89e52f2b$var$react18UseId().replace(/[:«»]/g, "_");
        return $5fc4297c89e52f2b$var$react18UseId();
    }
    return "uid".concat((0, $lzzak.useUID)());
}
var $5fc4297c89e52f2b$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($5fc4297c89e52f2b$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $132G4.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $132G4.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $5fc4297c89e52f2b$export$6ee17796e3d70de2() {
    if ($5fc4297c89e52f2b$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $5fc4297c89e52f2b$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $lzzak.useUIDSeed)();
}

});


parcelRegister("5bos5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c60f28276b50a6a$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");

var $jxLBU = parcelRequire("jxLBU");

var $kqOT3 = parcelRequire("kqOT3");
var $3c60f28276b50a6a$var$styles = {
    base: "_2rkofajl _11c8dcr7 _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
    baseRefreshedPadding: "_1q511b66 _85i51b66",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $3c60f28276b50a6a$var$TooltipContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $iSvIT.createElement((0, $kqOT3.default), {
        ref: ref,
        style: style,
        className: (0, $8v5gX.default)([
            $3c60f28276b50a6a$var$styles.base,
            (0, $jxLBU.fg)("platform-dst-tooltip-shortcuts") && $3c60f28276b50a6a$var$styles.baseRefreshedPadding,
            truncate && $3c60f28276b50a6a$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut
    }, children);
});
$3c60f28276b50a6a$var$TooltipContainer.displayName = "TooltipContainer";
var $3c60f28276b50a6a$export$2e2bcd8739ae039 = $3c60f28276b50a6a$var$TooltipContainer;

});
parcelRegister("kqOT3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edfdb57281eb1920$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");

var $jxLBU = parcelRequire("jxLBU");

var $cpMOg = parcelRequire("cpMOg");
var $edfdb57281eb1920$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $edfdb57281eb1920$var$TooltipPrimitive = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        role: "tooltip",
        className: (0, $8v5gX.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && (0, $jxLBU.fg)("platform-dst-tooltip-shortcuts") && /*#__PURE__*/ $iSvIT.createElement((0, $cpMOg.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$edfdb57281eb1920$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $edfdb57281eb1920$export$2e2bcd8739ae039 = $edfdb57281eb1920$var$TooltipPrimitive;

});
parcelRegister("cpMOg", function(module, exports) {

$parcel$export(module.exports, "TooltipShortcut", function () { return $909dae67c0e07046$export$5bcbc43c84236222; });
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");
var $909dae67c0e07046$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c81u0j _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d7jlr _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7"
};
var $909dae67c0e07046$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $8v5gX.default)([
            $909dae67c0e07046$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $iSvIT.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $8v5gX.default)([
                $909dae67c0e07046$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};

});



parcelRegister("bQdeG", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $89eed1699f98a4ad$export$642213d516a9b928; });
function $89eed1699f98a4ad$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("74aO6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52514a2d7270d084$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $4Onlm = parcelRequire("4Onlm");

var $8v5gX = parcelRequire("8v5gX");

var $iSvIT = parcelRequire("iSvIT");

var $bhOJS = parcelRequire("bhOJS");

var $5LD4E = parcelRequire("5LD4E");

var $4JfNt = parcelRequire("4JfNt");

var $gMPI3 = parcelRequire("gMPI3");

var $jxLBU = parcelRequire("jxLBU");

var $dNo0p = parcelRequire("dNo0p");

var $ibbno = parcelRequire("ibbno");

var $6wQwG = parcelRequire("6wQwG");

var $43MNC = parcelRequire("43MNC");

var $6wzpm = parcelRequire("6wzpm");
var $52514a2d7270d084$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $52514a2d7270d084$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $52514a2d7270d084$var$LOADING_LABEL = ", Loading";
var $52514a2d7270d084$var$styles = {
    base: "_2rkofajl _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1lh4 _30l31lh4 _9h8h1lh4",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $52514a2d7270d084$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $52514a2d7270d084$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $52514a2d7270d084$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $52514a2d7270d084$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $52514a2d7270d084$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $52514a2d7270d084$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $52514a2d7270d084$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $52514a2d7270d084$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $4Onlm.default)(_ref, $52514a2d7270d084$var$_excluded);
    var localRef = (0, $iSvIT.useRef)(null);
    var splitButtonContext = (0, $6wQwG.useSplitButtonContext)();
    var loadingLabelId = (0, $gMPI3.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton && (0, $jxLBU.fg)("platform-component-visual-refresh") ? "subtle" : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || "default";
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $4JfNt.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $4Onlm.default)(unsafeRest, $52514a2d7270d084$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $dNo0p.default), (0, $5VbRa.default)({}, saferRest, {
        componentName: componentName || "button",
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $5LD4E.default)([
            localRef,
            ref
        ]),
        xcss: (0, $bhOJS.cx)($52514a2d7270d084$var$styles.base, appearance === "default" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $52514a2d7270d084$var$defaultStyles.rootRefreshed : $52514a2d7270d084$var$defaultStyles.root), appearance === "default" && isInteractive && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $52514a2d7270d084$var$defaultStyles.interactiveRefreshed : $52514a2d7270d084$var$defaultStyles.interactive), appearance === "primary" && $52514a2d7270d084$var$primaryStyles.root, appearance === "primary" && isInteractive && $52514a2d7270d084$var$primaryStyles.interactive, appearance === "warning" && $52514a2d7270d084$var$warningStyles.root, appearance === "warning" && isInteractive && $52514a2d7270d084$var$warningStyles.interactive, appearance === "danger" && $52514a2d7270d084$var$dangerStyles.root, appearance === "danger" && isInteractive && $52514a2d7270d084$var$dangerStyles.interactive, appearance === "discovery" && $52514a2d7270d084$var$discoveryStyles.root, appearance === "discovery" && isInteractive && $52514a2d7270d084$var$discoveryStyles.interactive, appearance === "subtle" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $52514a2d7270d084$var$subtleStyles.rootRefreshed : $52514a2d7270d084$var$subtleStyles.root), appearance === "subtle" && isInteractive && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $52514a2d7270d084$var$subtleStyles.interactiveRefreshed : $52514a2d7270d084$var$subtleStyles.interactive), $52514a2d7270d084$var$styles.linkDecorationUnset, isSelected && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $52514a2d7270d084$var$selectedStyles.rootRefreshed : $52514a2d7270d084$var$selectedStyles.root), isSelected && isSplitButton && $52514a2d7270d084$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $52514a2d7270d084$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "danger" && $52514a2d7270d084$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "warning" && $52514a2d7270d084$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $52514a2d7270d084$var$selectedStyles.discovery, isDisabled && $52514a2d7270d084$var$styles.disabled, isDisabled && (!(0, $jxLBU.fg)("platform-component-visual-refresh") || appearance !== "default" && appearance !== "subtle") && $52514a2d7270d084$var$styles.sharedDisabled, isDisabled && appearance === "default" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $52514a2d7270d084$var$defaultStyles.disabledRefreshed : $52514a2d7270d084$var$defaultStyles.disabled), isCircle && !isSplitButton && $52514a2d7270d084$var$styles.circle, spacing === "compact" && $52514a2d7270d084$var$styles.spacingCompact, hasIconBefore && $52514a2d7270d084$var$styles.buttonIconBefore, shouldFitContainer && $52514a2d7270d084$var$styles.fullWidth, hasIconAfter && $52514a2d7270d084$var$styles.buttonIconAfter, isIconButton && $52514a2d7270d084$var$styles.iconButton, isIconButton && spacing === "compact" && $52514a2d7270d084$var$styles.iconButtonCompact, isLoading && $52514a2d7270d084$var$styles.loading, isSplitButton && $52514a2d7270d084$var$styles.splitButton, isNavigationSplitButton && $52514a2d7270d084$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($52514a2d7270d084$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $43MNC.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6wQwG.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $8v5gX.default)([
            $52514a2d7270d084$var$styles.loadingOverlay
        ])
    }, (0, $6wzpm.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ibbno.default), {
        id: loadingLabelId
    }, $52514a2d7270d084$var$LOADING_LABEL)));
});
var $52514a2d7270d084$export$2e2bcd8739ae039 = $52514a2d7270d084$var$ButtonBase;

});
parcelRegister("bhOJS", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $8378a3ec94e42066$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("iSvIT");


var $58uRT = parcelRequire("58uRT");
var $8378a3ec94e42066$var$_createStrictAPI = (0, $58uRT.createStrictAPI)(), $8378a3ec94e42066$var$XCSSProp = $8378a3ec94e42066$var$_createStrictAPI.XCSSProp, $8378a3ec94e42066$export$dbf350e5966cf602 = $8378a3ec94e42066$var$_createStrictAPI.css, $8378a3ec94e42066$export$eb1ecd84a24ee424 = $8378a3ec94e42066$var$_createStrictAPI.cssMap, $8378a3ec94e42066$export$a274e22fb40f762e = $8378a3ec94e42066$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("58uRT", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $3bd5a4e1774c7aa5$export$39716b4af53f4ad; });

var $4hnXA = parcelRequire("4hnXA");

var $f9DLK = parcelRequire("f9DLK");
function $3bd5a4e1774c7aa5$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $4hnXA.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $4hnXA.createStrictSetupError)();
        },
        cx: $f9DLK.cx,
        XCSSProp () {
            throw (0, $4hnXA.createStrictSetupError)();
        }
    };
}

});
parcelRegister("4hnXA", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $31db55e885f2c01f$export$c4df1cb0c2b4d77c; });
const $31db55e885f2c01f$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $31db55e885f2c01f$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});



parcelRegister("gMPI3", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $c3893d76f9007d3f$export$f680877a34711e37; });

var $132G4 = parcelRequire("132G4");

var $iSvIT = parcelRequire("iSvIT");

var $lzzak = parcelRequire("lzzak");

var $jxLBU = parcelRequire("jxLBU");
var $c3893d76f9007d3f$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $c3893d76f9007d3f$var$react18UseId = ($c3893d76f9007d3f$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId) !== null && $c3893d76f9007d3f$var$_React$useId !== void 0 ? $c3893d76f9007d3f$var$_React$useId : undefined;
function $c3893d76f9007d3f$export$f680877a34711e37() {
    if ($c3893d76f9007d3f$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        if ((0, $jxLBU.fg)("platform-dst-react-18-use-id-selector-safe")) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $c3893d76f9007d3f$var$react18UseId().replace(/[:«»]/g, "_");
        return $c3893d76f9007d3f$var$react18UseId();
    }
    return "uid".concat((0, $lzzak.useUID)());
}
var $c3893d76f9007d3f$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($c3893d76f9007d3f$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $132G4.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $132G4.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $c3893d76f9007d3f$export$6ee17796e3d70de2() {
    if ($c3893d76f9007d3f$var$react18UseId && (0, $jxLBU.fg)("platform-dst-react-18-use-id")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        var uid = $c3893d76f9007d3f$export$f680877a34711e37();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $lzzak.useUIDSeed)();
}

});

parcelRegister("dNo0p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0b278fb00c8f629$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");


var $f9DLK = parcelRequire("f9DLK");

var $lxoX2 = parcelRequire("lxoX2");

var $l9u68 = parcelRequire("l9u68");

var $4etuF = parcelRequire("4etuF");

var $ivZTz = parcelRequire("ivZTz");

var $h4Syc = parcelRequire("h4Syc");
var $a0b278fb00c8f629$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $a0b278fb00c8f629$var$_excluded2 = [
    "className"
];
var $a0b278fb00c8f629$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $a0b278fb00c8f629$var$Pressable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $4etuF.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $4Onlm.default)(_ref, $a0b278fb00c8f629$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $ivZTz.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $lxoX2.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.15.4",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $4Onlm.default)(htmlAttributes, $a0b278fb00c8f629$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement((0, $h4Syc.default), (0, $5VbRa.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $l9u68.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $f9DLK.cx)($a0b278fb00c8f629$var$styles.root, isDisabled && $a0b278fb00c8f629$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $a0b278fb00c8f629$export$2e2bcd8739ae039 = $a0b278fb00c8f629$var$Pressable;

});
parcelRegister("l9u68", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $f661c91032523201$export$95df08bae54cb4df; });
function $f661c91032523201$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_userAgentData = window.navigator["userAgentData"]) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $f661c91032523201$var$isIPhone() {
    return $f661c91032523201$var$testPlatform(/^iPhone/i);
}
function $f661c91032523201$var$isMac() {
    return $f661c91032523201$var$testPlatform(/^Mac/i);
}
function $f661c91032523201$var$isIPad() {
    return $f661c91032523201$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $f661c91032523201$var$isMac() && navigator.maxTouchPoints > 1;
}
function $f661c91032523201$var$isIOS() {
    return $f661c91032523201$var$isIPhone() || $f661c91032523201$var$isIPad();
}
function $f661c91032523201$export$95df08bae54cb4df() {
    if (typeof window !== "undefined" && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes("safari") && !ua.includes("chrome") : false;
    }
    return false;
}
function $f661c91032523201$export$e1865c3bedcd822b() {
    return $f661c91032523201$var$isMac() || $f661c91032523201$var$isIOS();
}

});

parcelRegister("h4Syc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6ed2000c6615764$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");

var $jxLBU = parcelRequire("jxLBU");
var $c6ed2000c6615764$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $c6ed2000c6615764$var$_excluded2 = [
    "className"
];
var $c6ed2000c6615764$var$focusRingStyles = null;
var $c6ed2000c6615764$var$insetFocusRingStyles = null;
// This is added to override and reset global styles that apps might be applying - for example,
// at the time of writing, Jira has global styles that targets all button and anchor elements,
// adding an outline on :focus.
var $c6ed2000c6615764$var$outlineResetStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $c6ed2000c6615764$var$Focusable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $4Onlm.default)(_ref, $c6ed2000c6615764$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $4Onlm.default)(htmlAttributes, $c6ed2000c6615764$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $5VbRa.default)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $8v5gX.default)([
            "_mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            (0, $jxLBU.fg)("platform_dst_compiled_primitives_outline_reset") && "_ymio1r31 _ypr0glyw _zcxs1o36",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});
var $c6ed2000c6615764$export$2e2bcd8739ae039 = $c6ed2000c6615764$var$Focusable;

});


parcelRegister("6wQwG", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", function () { return $4c0e79d2b4a89c9e$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $4c0e79d2b4a89c9e$export$47e2c6fdb142d947; });

var $iSvIT = parcelRequire("iSvIT");
var $4c0e79d2b4a89c9e$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $4c0e79d2b4a89c9e$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $iSvIT.useContext)($4c0e79d2b4a89c9e$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("43MNC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f4d4bc0af979060$export$2e2bcd8739ae039; });
function $2f4d4bc0af979060$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $2f4d4bc0af979060$var$tabKeyCode = 9;
function $2f4d4bc0af979060$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $2f4d4bc0af979060$var$tabKeyCode) return;
    $2f4d4bc0af979060$var$abort(event);
}
function $2f4d4bc0af979060$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $2f4d4bc0af979060$var$abort,
        onMouseUpCapture: $2f4d4bc0af979060$var$abort,
        onKeyDownCapture: $2f4d4bc0af979060$var$onKey,
        onKeyUpCapture: $2f4d4bc0af979060$var$onKey,
        onTouchStartCapture: $2f4d4bc0af979060$var$abort,
        onTouchEndCapture: $2f4d4bc0af979060$var$abort,
        onPointerDownCapture: $2f4d4bc0af979060$var$abort,
        onPointerUpCapture: $2f4d4bc0af979060$var$abort,
        onClickCapture: $2f4d4bc0af979060$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $2f4d4bc0af979060$var$abort
    } : events;
}

});

parcelRegister("6wzpm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c013282a7b23436$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $zlaVa = parcelRequire("zlaVa");
function $4c013282a7b23436$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $4c013282a7b23436$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $4c013282a7b23436$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $zlaVa.default), {
        size: $4c013282a7b23436$var$getIconSpacing(spacing),
        appearance: $4c013282a7b23436$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("zlaVa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06a3b1f121e3d984$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8v5gX = parcelRequire("8v5gX");

var $iSvIT = parcelRequire("iSvIT");

var $bl6zx = parcelRequire("bl6zx");

var $h78Xa = parcelRequire("h78Xa");

var $5GYIN = parcelRequire("5GYIN");
/**
 * Returns the appropriate circle stroke color.
 */ function $06a3b1f121e3d984$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $h78Xa.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $h78Xa.N0), ")");
}
var $06a3b1f121e3d984$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $06a3b1f121e3d984$var$loadIn = null;
var $06a3b1f121e3d984$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $06a3b1f121e3d984$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $06a3b1f121e3d984$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $5GYIN.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $06a3b1f121e3d984$var$getStrokeColor(appearance);
    var context = (0, $iSvIT.useContext)((0, $bl6zx.default));
    $06a3b1f121e3d984$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $8v5gX.default)([
            $06a3b1f121e3d984$var$styles.wrapperStyles,
            $06a3b1f121e3d984$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $8v5gX.default)([
            $06a3b1f121e3d984$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $8v5gX.default)([
            $06a3b1f121e3d984$var$styles.circleStyles
        ])
    })));
}));
var $06a3b1f121e3d984$export$2e2bcd8739ae039 = $06a3b1f121e3d984$var$Spinner;

});
parcelRegister("h78Xa", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $c75a0912fea9d17d$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $c75a0912fea9d17d$export$c39c0fe0f26207ae; });
// Reds
var $c75a0912fea9d17d$export$4b84fd0e2c617bd = "#FFEBE6";
var $c75a0912fea9d17d$export$b34b069eff244586 = "#FFBDAD";
var $c75a0912fea9d17d$export$be802dd0d8b57f35 = "#FF8F73";
var $c75a0912fea9d17d$export$60847d42f9da92a6 = "#FF7452";
var $c75a0912fea9d17d$export$4a7404f376229999 = "#FF5630";
var $c75a0912fea9d17d$export$2010d0fb4295b346 = "#DE350B";
var $c75a0912fea9d17d$export$2837b5a1a71d5c02 = "#BF2600";
var $c75a0912fea9d17d$export$8d9596b529bbb9cf = "#FFFAE6";
var $c75a0912fea9d17d$export$41060a744ab0b7ae = "#FFF0B3";
var $c75a0912fea9d17d$export$1cc05bbbf340e559 = "#FFE380";
var $c75a0912fea9d17d$export$5aae31392d72caaa = "#FFC400";
var $c75a0912fea9d17d$export$c6930421db9fa514 = "#FFAB00";
var $c75a0912fea9d17d$export$59619663aa6500fb = "#FF991F";
var $c75a0912fea9d17d$export$874739ea9e379ab6 = "#FF8B00";
var $c75a0912fea9d17d$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $c75a0912fea9d17d$export$69a3bf21b9686c2b = "#ABF5D1";
var $c75a0912fea9d17d$export$afbce1382ec95f73 = "#79F2C0";
var $c75a0912fea9d17d$export$747d86715d4175de = "#57D9A3";
var $c75a0912fea9d17d$export$940e1f69e873f202 = "#36B37E";
var $c75a0912fea9d17d$export$a49394138f7b8e85 = "#00875A";
var $c75a0912fea9d17d$export$6fa04827ac68a4fb = "#006644";
var $c75a0912fea9d17d$export$226de0355ed012f8 = "#DEEBFF";
var $c75a0912fea9d17d$export$8c13c2ee36917869 = "#B3D4FF";
var $c75a0912fea9d17d$export$ecfc1dff386a3e7a = "#4C9AFF";
var $c75a0912fea9d17d$export$215b7063051591f1 = "#2684FF";
var $c75a0912fea9d17d$export$e62e8919cca44969 = "#0065FF";
var $c75a0912fea9d17d$export$b3de0ae08da2ce64 = "#0052CC";
var $c75a0912fea9d17d$export$a6ee3d71bc067634 = "#0747A6";
var $c75a0912fea9d17d$export$67f15409e87642a1 = "#669DF1";
var $c75a0912fea9d17d$export$f0539dbc42dbb067 = "#8FB8F6";
var $c75a0912fea9d17d$export$363e4475840015bb = "#EAE6FF";
var $c75a0912fea9d17d$export$4b0a4417ed59760f = "#C0B6F2";
var $c75a0912fea9d17d$export$6011520a64d9a187 = "#998DD9";
var $c75a0912fea9d17d$export$a7175d4e9206bc80 = "#8777D9";
var $c75a0912fea9d17d$export$b48405b95304b5a1 = "#6554C0";
var $c75a0912fea9d17d$export$c71e4279dd54a18d = "#5243AA";
var $c75a0912fea9d17d$export$147899de772240ec = "#403294";
var $c75a0912fea9d17d$export$2cf711fe14c66f06 = "#E6FCFF";
var $c75a0912fea9d17d$export$7a8f4d33f6f9772c = "#B3F5FF";
var $c75a0912fea9d17d$export$776c9c497ef08533 = "#79E2F2";
var $c75a0912fea9d17d$export$69cb3ca10c1e330e = "#00C7E6";
var $c75a0912fea9d17d$export$9dc1ef0f3f48059b = "#00B8D9";
var $c75a0912fea9d17d$export$7c835c78b6fcdef8 = "#00A3BF";
var $c75a0912fea9d17d$export$6036577f95c3877e = "#008DA6";
var $c75a0912fea9d17d$export$29a4f05edc054374 = "#FFFFFF";
var $c75a0912fea9d17d$export$e655ef011c4aa1a2 = "#FAFBFC";
var $c75a0912fea9d17d$export$9fdfb749e33cdf97 = "#F4F5F7";
var $c75a0912fea9d17d$export$3e51e8f1440314ba = "#EBECF0";
var $c75a0912fea9d17d$export$1ce2d1575d444ceb = "#DFE1E6";
var $c75a0912fea9d17d$export$8754fc7e6d8b3000 = "#C1C7D0";
var $c75a0912fea9d17d$export$c2e91cbeada39b8b = "#B3BAC5";
var $c75a0912fea9d17d$export$5f71e19f3a7ad9de = "#A5ADBA";
var $c75a0912fea9d17d$export$eaa8c8a70ac22806 = "#97A0AF";
var $c75a0912fea9d17d$export$7c87d337fb91a97d = "#8993A4";
var $c75a0912fea9d17d$export$d6447c357493214f = "#7A869A";
var $c75a0912fea9d17d$export$f563ee71e9ee74cd = "#6B778C";
var $c75a0912fea9d17d$export$e2ef2124cf4024b1 = "#5E6C84";
var $c75a0912fea9d17d$export$eece5f492e429f08 = "#505F79";
var $c75a0912fea9d17d$export$c39c0fe0f26207ae = "#42526E";
var $c75a0912fea9d17d$export$7090862dc3038a9f = "#344563";
var $c75a0912fea9d17d$export$ad0bacf983b7ddaa = "#253858";
var $c75a0912fea9d17d$export$7d61b15e0da132af = "#172B4D";
var $c75a0912fea9d17d$export$fbda843f0a27fe96 = "#091E42";
var $c75a0912fea9d17d$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $c75a0912fea9d17d$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $c75a0912fea9d17d$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $c75a0912fea9d17d$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $c75a0912fea9d17d$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $c75a0912fea9d17d$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $c75a0912fea9d17d$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $c75a0912fea9d17d$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $c75a0912fea9d17d$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $c75a0912fea9d17d$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $c75a0912fea9d17d$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $c75a0912fea9d17d$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $c75a0912fea9d17d$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $c75a0912fea9d17d$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $c75a0912fea9d17d$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $c75a0912fea9d17d$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $c75a0912fea9d17d$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $c75a0912fea9d17d$export$2f6319cf7d736c2a = "#E6EDFA";
var $c75a0912fea9d17d$export$95126bc8884d6634 = "#DCE5F5";
var $c75a0912fea9d17d$export$8338d8c35d44ff1 = "#CED9EB";
var $c75a0912fea9d17d$export$5368d76ae4fbbda7 = "#B8C7E0";
var $c75a0912fea9d17d$export$9f0a771d16ec8d36 = "#ABBBD6";
var $c75a0912fea9d17d$export$abcf8c38338b4aa5 = "#9FB0CC";
var $c75a0912fea9d17d$export$97e81faa16a182c7 = "#8C9CB8";
var $c75a0912fea9d17d$export$bfe21c59123ecf33 = "#7988A3";
var $c75a0912fea9d17d$export$ee82aa2ea6a1558 = "#67758F";
var $c75a0912fea9d17d$export$682927c6ed76be02 = "#56637A";
var $c75a0912fea9d17d$export$91fd9994c5be9757 = "#455166";
var $c75a0912fea9d17d$export$d281fbfe3cff2df6 = "#3B475C";
var $c75a0912fea9d17d$export$3902c91d8b98a753 = "#313D52";
var $c75a0912fea9d17d$export$8e8133c1ba5845b5 = "#283447";
var $c75a0912fea9d17d$export$33ff357f6620b39 = "#202B3D";
var $c75a0912fea9d17d$export$633847cf062b69e0 = "#1B2638";
var $c75a0912fea9d17d$export$9776a6e503bdbf76 = "#121A29";
var $c75a0912fea9d17d$export$6c813d5160dff5db = "#0E1624";
var $c75a0912fea9d17d$export$3d4f271a500072a = "#0D1424";
var $c75a0912fea9d17d$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $c75a0912fea9d17d$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $c75a0912fea9d17d$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $c75a0912fea9d17d$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $c75a0912fea9d17d$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $c75a0912fea9d17d$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $c75a0912fea9d17d$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $c75a0912fea9d17d$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $c75a0912fea9d17d$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $c75a0912fea9d17d$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $c75a0912fea9d17d$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $c75a0912fea9d17d$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $c75a0912fea9d17d$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $c75a0912fea9d17d$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $c75a0912fea9d17d$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $c75a0912fea9d17d$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $c75a0912fea9d17d$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $c75a0912fea9d17d$export$d2adc5dedf09fced = "#292A2E";
var $c75a0912fea9d17d$export$f51762073d2bb381 = "#94C748";
var $c75a0912fea9d17d$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("5GYIN", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $424ffa019f46732a$export$4e9f1640bbe7a1a8; });
var $424ffa019f46732a$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("9wICq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ef9b69295f61469$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $8v5gX = parcelRequire("8v5gX");

var $iSvIT = parcelRequire("iSvIT");
var $6ef9b69295f61469$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $6ef9b69295f61469$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $8v5gX.default)([
            $6ef9b69295f61469$var$styles.common,
            type === "text" && $6ef9b69295f61469$var$styles.text,
            type === "icon" && $6ef9b69295f61469$var$styles.icon,
            isLoading && $6ef9b69295f61469$var$styles.fade,
            position === "before" && $6ef9b69295f61469$var$styles.beforeIcon,
            position === "after" && $6ef9b69295f61469$var$styles.afterIcon
        ])
    }, children);
};
var $6ef9b69295f61469$export$2e2bcd8739ae039 = $6ef9b69295f61469$var$Content;

});

parcelRegister("6wtUM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bfcefac422a4f2e$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");
function $4bfcefac422a4f2e$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $4bfcefac422a4f2e$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $4bfcefac422a4f2e$var$isIconRenderProp(Icon);
    var iconProps = {
        label: "",
        color: "currentColor",
        size: (0, $jxLBU.fg)("platform_dst_button_chevron_sizing") ? function(iconName) {
            return iconName.startsWith("Chevron") ? "small" : "medium";
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Icon, iconProps));
};
var $4bfcefac422a4f2e$export$2e2bcd8739ae039 = $4bfcefac422a4f2e$var$IconRenderer;

});


parcelRegister("1yWop", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $123642fd1c51e1e5$var$_react = $123642fd1c51e1e5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $123642fd1c51e1e5$var$_cross = $123642fd1c51e1e5$var$_interopRequireDefault((parcelRequire("8T8Qf")));

var $123642fd1c51e1e5$var$_cross2 = $123642fd1c51e1e5$var$_interopRequireDefault((parcelRequire("ir05j")));
function $123642fd1c51e1e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $123642fd1c51e1e5$var$CrossIcon = (props)=>/*#__PURE__*/ $123642fd1c51e1e5$var$_react.default.createElement($123642fd1c51e1e5$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $123642fd1c51e1e5$var$_cross2.default
    }, props));
$123642fd1c51e1e5$var$CrossIcon.displayName = "CrossIconMigration";
var $123642fd1c51e1e5$var$_default = module.exports.default = $123642fd1c51e1e5$var$CrossIcon;

});
parcelRegister("8T8Qf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $678a518c295960ca$var$_react = $678a518c295960ca$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $678a518c295960ca$var$_baseNew = $678a518c295960ca$var$_interopRequireDefault((parcelRequire("jfOWh")));
function $678a518c295960ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $678a518c295960ca$var$CrossIcon = (props)=>/*#__PURE__*/ $678a518c295960ca$var$_react.default.createElement($678a518c295960ca$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$678a518c295960ca$var$CrossIcon.displayName = "CrossIcon";
var $678a518c295960ca$var$_default = module.exports.default = $678a518c295960ca$var$CrossIcon;

});
parcelRegister("jfOWh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9IHFh")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("9IHFh")).Icon; });

var $9IHFh = parcelRequire("9IHFh");

});
parcelRegister("9IHFh", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $713a1803e5c7ba67$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $713a1803e5c7ba67$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");

var $jxLBU = parcelRequire("jxLBU");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $713a1803e5c7ba67$var$svgStyles = null;
var $713a1803e5c7ba67$var$iconStyles = null;
var $713a1803e5c7ba67$var$utilityIconStyles = null;
var $713a1803e5c7ba67$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $713a1803e5c7ba67$var$baseHcmStyles = null;
var $713a1803e5c7ba67$var$scaleSize = null;
var $713a1803e5c7ba67$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $713a1803e5c7ba67$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $713a1803e5c7ba67$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $713a1803e5c7ba67$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $713a1803e5c7ba67$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $713a1803e5c7ba67$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $jxLBU.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return /*#__PURE__*/ $iSvIT.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core";
    var size = "medium";
    if ("size" in props && props.size !== undefined) {
        if (typeof props.size === "string") size = props.size === "small" || props.size === "medium" ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === "small" || newSize === "medium" ? newSize : size;
        }
    }
    var baseSize = $713a1803e5c7ba67$var$baseSizeMap[type];
    var viewBoxPadding = $713a1803e5c7ba67$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $8v5gX.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === "utility" || size === "small") && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $8v5gX.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === "utility" ? $713a1803e5c7ba67$var$utilSizes[spacing] : size === "small" ? $713a1803e5c7ba67$var$coreSizeSmall[spacing] : $713a1803e5c7ba67$var$coreSizeMedium[spacing]
        ])
    }));
});
var $713a1803e5c7ba67$export$2e2bcd8739ae039 = $713a1803e5c7ba67$export$f04a61298a47a40f;

});



parcelRegister("ir05j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6bad06cacc528fe$var$_react = $d6bad06cacc528fe$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6Nm0f = parcelRequire("6Nm0f");
function $d6bad06cacc528fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d6bad06cacc528fe$var$CrossIcon = (props)=>/*#__PURE__*/ $d6bad06cacc528fe$var$_react.default.createElement($6Nm0f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$d6bad06cacc528fe$var$CrossIcon.displayName = "CrossIcon";
var $d6bad06cacc528fe$var$_default = module.exports.default = $d6bad06cacc528fe$var$CrossIcon;

});
parcelRegister("6Nm0f", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $4f28630789a9652a$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $fACfu = parcelRequire("fACfu");

var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");
function $4f28630789a9652a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4f28630789a9652a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4f28630789a9652a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4f28630789a9652a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $4f28630789a9652a$var$iconStyles = null;
var $4f28630789a9652a$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $4f28630789a9652a$var$baseHcmStyles = null;
var $4f28630789a9652a$var$primaryEqualsSecondaryHcmStyles = null;
var $4f28630789a9652a$var$secondaryTransparentHcmStyles = null;
var $4f28630789a9652a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $iSvIT.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + "px",
        height: height + "px"
    } : null;
    return /*#__PURE__*/ $iSvIT.createElement("span", (0, $5VbRa.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $4f28630789a9652a$var$_objectSpread($4f28630789a9652a$var$_objectSpread({}, customDimensions), {}, {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $8v5gX.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === "transparent" && "_4fyi1j28",
            size && $4f28630789a9652a$var$sizeStyles[size]
        ])
    }));
});
var $4f28630789a9652a$export$2e2bcd8739ae039 = $4f28630789a9652a$export$f04a61298a47a40f;

});





parcelRegister("32E8S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2370b2618cb710c6$export$2e2bcd8739ae039; });
/* modal-title.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $hgIUG = parcelRequire("hgIUG");

var $i7JlS = parcelRequire("i7JlS");

var $iCDRR = parcelRequire("iCDRR");

var $2v5e9 = parcelRequire("2v5e9");
var $2370b2618cb710c6$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E56910)"
};
var $2370b2618cb710c6$var$iconStyles = null;
var $2370b2618cb710c6$var$titleStyles = null;
var $2370b2618cb710c6$var$textStyles = null;
var $2370b2618cb710c6$var$truncatedTextStyles = null;
var $2370b2618cb710c6$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === "danger" ? (0, (/*@__PURE__*/$parcel$interopDefault($i7JlS))) : (0, (/*@__PURE__*/$parcel$interopDefault($iCDRR)));
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $hgIUG.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement(Icon, {
        label: appearance,
        color: $2370b2618cb710c6$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $2370b2618cb710c6$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $2v5e9.useModal)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return /*#__PURE__*/ $iSvIT.createElement("h1", {
        "data-testid": testId,
        className: (0, $hgIUG.default)([
            "_zulpu2gc _11c8lodh _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ])
    }, appearance && /*#__PURE__*/ $iSvIT.createElement($2370b2618cb710c6$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ $iSvIT.createElement("span", {
        id: titleId,
        "data-testid": testId && "".concat(testId, "-text"),
        className: (0, $hgIUG.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _slp31hna",
            !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
var $2370b2618cb710c6$export$2e2bcd8739ae039 = $2370b2618cb710c6$var$ModalTitle;

});
parcelRegister("i7JlS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d31c0f6238b8e4e9$var$_react = $d31c0f6238b8e4e9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d31c0f6238b8e4e9$var$_statusError = $d31c0f6238b8e4e9$var$_interopRequireDefault((parcelRequire("6JZqr")));

var $d31c0f6238b8e4e9$var$_error = $d31c0f6238b8e4e9$var$_interopRequireDefault((parcelRequire("PVKfR")));
function $d31c0f6238b8e4e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d31c0f6238b8e4e9$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $d31c0f6238b8e4e9$var$_react.default.createElement($d31c0f6238b8e4e9$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $d31c0f6238b8e4e9$var$_error.default
    }, props));
$d31c0f6238b8e4e9$var$StatusErrorIcon.displayName = "StatusErrorIconMigration";
var $d31c0f6238b8e4e9$var$_default = module.exports.default = $d31c0f6238b8e4e9$var$StatusErrorIcon;

});
parcelRegister("6JZqr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e8697d79593fd13$var$_react = $4e8697d79593fd13$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $4e8697d79593fd13$var$_baseNew = $4e8697d79593fd13$var$_interopRequireDefault((parcelRequire("jfOWh")));
function $4e8697d79593fd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e8697d79593fd13$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $4e8697d79593fd13$var$_react.default.createElement($4e8697d79593fd13$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$4e8697d79593fd13$var$StatusErrorIcon.displayName = "StatusErrorIcon";
var $4e8697d79593fd13$var$_default = module.exports.default = $4e8697d79593fd13$var$StatusErrorIcon;

});

parcelRegister("PVKfR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09c18e7f779ddb2e$var$_react = $09c18e7f779ddb2e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6Nm0f = parcelRequire("6Nm0f");
function $09c18e7f779ddb2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $09c18e7f779ddb2e$var$ErrorIcon = (props)=>/*#__PURE__*/ $09c18e7f779ddb2e$var$_react.default.createElement($6Nm0f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$09c18e7f779ddb2e$var$ErrorIcon.displayName = "ErrorIcon";
var $09c18e7f779ddb2e$var$_default = module.exports.default = $09c18e7f779ddb2e$var$ErrorIcon;

});


parcelRegister("iCDRR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8eab38261982826$var$_react = $d8eab38261982826$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d8eab38261982826$var$_statusWarning = $d8eab38261982826$var$_interopRequireDefault((parcelRequire("1WvaL")));

var $d8eab38261982826$var$_warning = $d8eab38261982826$var$_interopRequireDefault((parcelRequire("dSHIx")));
function $d8eab38261982826$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8eab38261982826$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $d8eab38261982826$var$_react.default.createElement($d8eab38261982826$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $d8eab38261982826$var$_warning.default
    }, props));
$d8eab38261982826$var$StatusWarningIcon.displayName = "StatusWarningIconMigration";
var $d8eab38261982826$var$_default = module.exports.default = $d8eab38261982826$var$StatusWarningIcon;

});
parcelRegister("1WvaL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16a3636f85723f49$var$_react = $16a3636f85723f49$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $16a3636f85723f49$var$_baseNew = $16a3636f85723f49$var$_interopRequireDefault((parcelRequire("jfOWh")));
function $16a3636f85723f49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $16a3636f85723f49$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $16a3636f85723f49$var$_react.default.createElement($16a3636f85723f49$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$16a3636f85723f49$var$StatusWarningIcon.displayName = "StatusWarningIcon";
var $16a3636f85723f49$var$_default = module.exports.default = $16a3636f85723f49$var$StatusWarningIcon;

});

parcelRegister("dSHIx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1b23ad7a36afe72$var$_react = $a1b23ad7a36afe72$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6Nm0f = parcelRequire("6Nm0f");
function $a1b23ad7a36afe72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a1b23ad7a36afe72$var$WarningIcon = (props)=>/*#__PURE__*/ $a1b23ad7a36afe72$var$_react.default.createElement($6Nm0f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$a1b23ad7a36afe72$var$WarningIcon.displayName = "WarningIcon";
var $a1b23ad7a36afe72$var$_default = module.exports.default = $a1b23ad7a36afe72$var$WarningIcon;

});



parcelRegister("eZqvo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae9b529c099b4b79$export$2e2bcd8739ae039; });
/* section-message.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $fOsVV = parcelRequire("fOsVV");

var $iSvIT = parcelRequire("iSvIT");

var $2LIMg = parcelRequire("2LIMg");

var $hcLL1 = parcelRequire("hcLL1");

var $cBwIt = parcelRequire("cBwIt");

var $1yWop = parcelRequire("1yWop");

var $gEwdP = parcelRequire("gEwdP");
var $5Q9cd = parcelRequire("5Q9cd");

var $kU1Dk = parcelRequire("kU1Dk");
var $ae9b529c099b4b79$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_1pfh1i6y"
};
var $ae9b529c099b4b79$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $ae9b529c099b4b79$var$SectionMessage = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "information" : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, isDismissible = _ref.isDismissible, onDismiss = _ref.onDismiss, testId = _ref.testId;
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $fOsVV.default)(_useState, 2), dismissed = _useState2[0], setDismissed = _useState2[1];
    var handleDismiss = (0, $iSvIT.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    var _getAppearanceIconSty = (0, $kU1Dk.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, $iSvIT.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, $iSvIT.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $iSvIT.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $2LIMg.default)([
            $ae9b529c099b4b79$var$sectionMessageStyles.container,
            $ae9b529c099b4b79$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $iSvIT.createElement((0, $gEwdP.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $2LIMg.default)([
            $ae9b529c099b4b79$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $iSvIT.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $iSvIT.createElement((0, $5Q9cd.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content"),
        xcss: $ae9b529c099b4b79$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $iSvIT.createElement((0, $cBwIt.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $2LIMg.default)([
            $ae9b529c099b4b79$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $iSvIT.createElement((0, $gEwdP.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? "list" : undefined,
        xcss: $ae9b529c099b4b79$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return(/*#__PURE__*/ // Only use a listitem role if more than one action is present
        $iSvIT.createElement((0, $gEwdP.default), {
            role: actionsArray.length > 1 ? "listitem" : undefined,
            key: id
        }, action));
    }))), isDismissible && /*#__PURE__*/ $iSvIT.createElement("div", {
        className: (0, $2LIMg.default)([
            $ae9b529c099b4b79$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $iSvIT.createElement((0, $hcLL1.default), {
        testId: testId && "".concat(testId, "--dismiss-button"),
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yWop))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$ae9b529c099b4b79$var$SectionMessage.displayName = "SectionMessage";
var $ae9b529c099b4b79$export$2e2bcd8739ae039 = $ae9b529c099b4b79$var$SectionMessage;

});
parcelRegister("2LIMg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2042b46da27ecb15$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $2042b46da27ecb15$var$ATOMIC_GROUP_LENGTH = 5;
function $2042b46da27ecb15$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $2042b46da27ecb15$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("cBwIt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92d2517e392272a4$export$2e2bcd8739ae039; });
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $fOsVV = parcelRequire("fOsVV");

var $iSvIT = parcelRequire("iSvIT");

var $8v5gX = parcelRequire("8v5gX");

var $9y3jk = parcelRequire("9y3jk");

var $gwBCR = parcelRequire("gwBCR");

var $gAfrQ = parcelRequire("gAfrQ");

var $XAEGR = parcelRequire("XAEGR");
var $92d2517e392272a4$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $92d2517e392272a4$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $92d2517e392272a4$var$headingColorStylesMap = {
    "color.text": "_syaz1fxt",
    "color.text.inverse": "_syaz15cr",
    "color.text.warning.inverse": "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $92d2517e392272a4$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $92d2517e392272a4$var$useColor = function useColor(colorProp) {
    var surface = (0, $gwBCR.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $9y3jk.inverseColorMap).hasOwnProperty(surface)) return (0, $9y3jk.inverseColorMap)[surface];
    return "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $92d2517e392272a4$var$Heading = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $XAEGR;
    var _useHeading = (0, $gAfrQ.useHeading)($92d2517e392272a4$var$sizeTagMap[size]), _useHeading2 = (0, $fOsVV.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $92d2517e392272a4$var$useColor(colorProp);
    return /*#__PURE__*/ $iSvIT.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $8v5gX.default)([
            $92d2517e392272a4$var$styles.reset,
            size && $92d2517e392272a4$var$headingSizeStylesMap[size],
            $92d2517e392272a4$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $92d2517e392272a4$export$2e2bcd8739ae039 = $92d2517e392272a4$var$Heading;

});
parcelRegister("9y3jk", function(module, exports) {

$parcel$export(module.exports, "inverseColorMap", function () { return $6f39db7a9cad0b3b$export$2185ce37f9bdd963; });

var $fACfu = parcelRequire("fACfu");

var $2ZUkg = parcelRequire("2ZUkg");

var $jIB5t = parcelRequire("jIB5t");
function $6f39db7a9cad0b3b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f39db7a9cad0b3b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f39db7a9cad0b3b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f39db7a9cad0b3b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6f39db7a9cad0b3b$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $6f39db7a9cad0b3b$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $6f39db7a9cad0b3b$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $6f39db7a9cad0b3b$export$632685d741f3dbbf = $6f39db7a9cad0b3b$var$_objectSpread($6f39db7a9cad0b3b$var$_objectSpread({}, $6f39db7a9cad0b3b$export$958d0ae7f2977ae4), $6f39db7a9cad0b3b$export$d2dc61f58390201c);
var $6f39db7a9cad0b3b$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $6f39db7a9cad0b3b$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $6f39db7a9cad0b3b$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $6f39db7a9cad0b3b$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $6f39db7a9cad0b3b$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $6f39db7a9cad0b3b$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $6f39db7a9cad0b3b$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $6f39db7a9cad0b3b$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B778C)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $6f39db7a9cad0b3b$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $6f39db7a9cad0b3b$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $6f39db7a9cad0b3b$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $6f39db7a9cad0b3b$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $6f39db7a9cad0b3b$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $6f39db7a9cad0b3b$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $6f39db7a9cad0b3b$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $6f39db7a9cad0b3b$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $6f39db7a9cad0b3b$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $6f39db7a9cad0b3b$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $2ZUkg.css)((0, $fACfu.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $6f39db7a9cad0b3b$export$e615f061ca585a6c = $6f39db7a9cad0b3b$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $6f39db7a9cad0b3b$export$ca0f9c2de39ffed7(spacingProperty, $6f39db7a9cad0b3b$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $6f39db7a9cad0b3b$export$bf46c3f9eeafc71f = $6f39db7a9cad0b3b$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $6f39db7a9cad0b3b$export$ca0f9c2de39ffed7(spacingProperty, $6f39db7a9cad0b3b$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $6f39db7a9cad0b3b$export$e7af83bafe7f9e63 = $6f39db7a9cad0b3b$export$ca0f9c2de39ffed7("backgroundColor", $6f39db7a9cad0b3b$export$d1d79bf68ac056bd);
var $6f39db7a9cad0b3b$export$3a1bcba60b23d7f0 = $6f39db7a9cad0b3b$export$ca0f9c2de39ffed7("color", $6f39db7a9cad0b3b$export$8473307aa00d6ea1);
var $6f39db7a9cad0b3b$export$45f3f4fe16f9f7d5 = $6f39db7a9cad0b3b$export$ca0f9c2de39ffed7("fontWeight", $6f39db7a9cad0b3b$export$303e322c6b1ed114);
var $6f39db7a9cad0b3b$export$68cc305da27dbaa4 = $6f39db7a9cad0b3b$export$ca0f9c2de39ffed7("fontFamily", $6f39db7a9cad0b3b$export$3c7e9587132614b4);
var $6f39db7a9cad0b3b$export$128f10c238242f83 = $6f39db7a9cad0b3b$export$ca0f9c2de39ffed7("font", $6f39db7a9cad0b3b$export$6ffa317d5e70375);
var $6f39db7a9cad0b3b$export$219d364c0da35ae4 = $6f39db7a9cad0b3b$export$ca0f9c2de39ffed7("font", $6f39db7a9cad0b3b$export$236bfe3a33ef1292);
var $6f39db7a9cad0b3b$export$38845ca010b93505 = $6f39db7a9cad0b3b$export$ca0f9c2de39ffed7("fontWeight", $6f39db7a9cad0b3b$export$855cfd311192d666);
var $6f39db7a9cad0b3b$export$ff257d957d48c421 = $6f39db7a9cad0b3b$export$ca0f9c2de39ffed7((0, $jIB5t.CURRENT_SURFACE_CSS_VAR), $6f39db7a9cad0b3b$export$41a358c9c2356760);
var $6f39db7a9cad0b3b$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $6f39db7a9cad0b3b$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("jIB5t", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $e5aee524470c6b95$export$9d7b58831ae93caa; });
var $e5aee524470c6b95$export$4ef52930e33717cd = "data-theme";
var $e5aee524470c6b95$export$a00eac3f8684bcd0 = "data-color-mode";
var $e5aee524470c6b95$export$2112803007239c61 = "data-contrast-mode";
var $e5aee524470c6b95$export$352e418ed5b6193a = "data-custom-theme";
var $e5aee524470c6b95$export$6f0c6fb8c80fcc92 = "ds";
var $e5aee524470c6b95$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $e5aee524470c6b95$export$dddac1532e822863 = "--".concat($e5aee524470c6b95$export$6f0c6fb8c80fcc92, "-token-not-found");
var $e5aee524470c6b95$export$9d7b58831ae93caa = "--".concat($e5aee524470c6b95$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("gwBCR", function(module, exports) {

$parcel$export(module.exports, "useSurface", function () { return $c07cd2351c65f945$export$1aeb4f6b93c4540d; });

var $iSvIT = parcelRequire("iSvIT");
var $c07cd2351c65f945$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $c07cd2351c65f945$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($c07cd2351c65f945$export$1ca2a26fecb070ae);
};
$c07cd2351c65f945$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});

parcelRegister("gAfrQ", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $c12bfdd288997cc4$export$97a37b1befbbf9b1; });

var $iSvIT = parcelRequire("iSvIT");
// Allows support for heading levels 1-9 via aria-level
var $c12bfdd288997cc4$var$HeadingLevelContext = /*#__PURE__*/ (0, $iSvIT.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $c12bfdd288997cc4$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $iSvIT.useContext)($c12bfdd288997cc4$var$HeadingLevelContext);
};
var $c12bfdd288997cc4$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $c12bfdd288997cc4$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $c12bfdd288997cc4$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $c12bfdd288997cc4$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($c12bfdd288997cc4$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $c12bfdd288997cc4$export$2e2bcd8739ae039 = $c12bfdd288997cc4$var$HeadingLevelContextProvider;

});


parcelRegister("gEwdP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1f9606067ced3df$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");

var $jmw91 = parcelRequire("jmw91");

var $eGOLG = parcelRequire("eGOLG");

var $6eCC0 = parcelRequire("6eCC0");
var $c1f9606067ced3df$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $c1f9606067ced3df$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $c1f9606067ced3df$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $jmw91.default)([
            $c1f9606067ced3df$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $c1f9606067ced3df$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $4Onlm.default)(_ref2, $c1f9606067ced3df$var$_excluded);
    var separatorComponent = typeof separator === "string" ? /*#__PURE__*/ $iSvIT.createElement($c1f9606067ced3df$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $iSvIT.createElement((0, $6eCC0.default), (0, $5VbRa.default)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: (0, $eGOLG.cx)(grow === "hug" && $c1f9606067ced3df$var$styles.hug, grow === "fill" && $c1f9606067ced3df$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$c1f9606067ced3df$var$Inline.displayName = "Inline";
var $c1f9606067ced3df$export$2e2bcd8739ae039 = $c1f9606067ced3df$var$Inline;

});
parcelRegister("eGOLG", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $ab1c5e6f8fe7e02e$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.38.1 */ parcelRequire("iSvIT");


var $7XLya = parcelRequire("7XLya");
var $ab1c5e6f8fe7e02e$var$strictApi = (0, $7XLya.createStrictAPI)();
var $ab1c5e6f8fe7e02e$export$dbf350e5966cf602 = $ab1c5e6f8fe7e02e$var$strictApi.css;
var $ab1c5e6f8fe7e02e$export$eb1ecd84a24ee424 = $ab1c5e6f8fe7e02e$var$strictApi.cssMap;
$ab1c5e6f8fe7e02e$var$strictApi.cssMap;
var $ab1c5e6f8fe7e02e$export$a274e22fb40f762e = $ab1c5e6f8fe7e02e$var$strictApi.cx;
var $ab1c5e6f8fe7e02e$var$XCSSProp = $ab1c5e6f8fe7e02e$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 

});
parcelRegister("7XLya", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $5cc2ed85a2a877d7$export$39716b4af53f4ad; });

var $lPqDP = parcelRequire("lPqDP");

var $kBiMY = parcelRequire("kBiMY");
function $5cc2ed85a2a877d7$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $lPqDP.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $lPqDP.createStrictSetupError)();
        },
        cx: $kBiMY.cx,
        XCSSProp () {
            throw (0, $lPqDP.createStrictSetupError)();
        }
    };
}

});
parcelRegister("lPqDP", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $fe4306d5e3ba5511$export$c4df1cb0c2b4d77c; });
const $fe4306d5e3ba5511$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $fe4306d5e3ba5511$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("kBiMY", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $eff5d66ddf6cf85b$export$a274e22fb40f762e; });

var $jmw91 = parcelRequire("jmw91");
const $eff5d66ddf6cf85b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $jmw91.default)(actualStyles);
};

});



parcelRegister("6eCC0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48a20071cd8b3965$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");

var $jmw91 = parcelRequire("jmw91");
var $48a20071cd8b3965$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $48a20071cd8b3965$var$rowGapMap = {
    "space.0": "_1p57ze3t",
    "space.025": "_1p57v77o",
    "space.050": "_1p571b66",
    "space.075": "_1p5712x7",
    "space.100": "_1p57u2gc",
    "space.150": "_1p57utpp",
    "space.200": "_1p57pxbi",
    "space.250": "_1p57v47k",
    "space.300": "_1p571ejb",
    "space.400": "_1p57xy5q",
    "space.500": "_1p571jfw",
    "space.600": "_1p57oahv",
    "space.800": "_1p57xncg",
    "space.1000": "_1p571epz"
};
var $48a20071cd8b3965$var$columnGapMap = {
    "space.0": "_gy1pze3t",
    "space.025": "_gy1pv77o",
    "space.050": "_gy1p1b66",
    "space.075": "_gy1p12x7",
    "space.100": "_gy1pu2gc",
    "space.150": "_gy1putpp",
    "space.200": "_gy1ppxbi",
    "space.250": "_gy1pv47k",
    "space.300": "_gy1p1ejb",
    "space.400": "_gy1pxy5q",
    "space.500": "_gy1p1jfw",
    "space.600": "_gy1poahv",
    "space.800": "_gy1pxncg",
    "space.1000": "_gy1p1epz"
};
var $48a20071cd8b3965$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    "space-between": "_1bah1yb4",
    "space-around": "_1bah1b1v",
    "space-evenly": "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $48a20071cd8b3965$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $48a20071cd8b3965$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $48a20071cd8b3965$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $48a20071cd8b3965$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $48a20071cd8b3965$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $4Onlm.default)(_ref, $48a20071cd8b3965$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement(Component, (0, $5VbRa.default)({}, ariaAttributes, {
        role: role,
        className: (0, $jmw91.default)([
            $48a20071cd8b3965$var$styles.root,
            gap && $48a20071cd8b3965$var$columnGapMap[gap],
            columnGap && $48a20071cd8b3965$var$columnGapMap[columnGap],
            gap && $48a20071cd8b3965$var$rowGapMap[gap],
            rowGap && $48a20071cd8b3965$var$rowGapMap[rowGap],
            alignItems && $48a20071cd8b3965$var$alignItemsMap[alignItems],
            direction && $48a20071cd8b3965$var$flexDirectionMap[direction],
            justifyContent && $48a20071cd8b3965$var$justifyContentMap[justifyContent],
            wrap && $48a20071cd8b3965$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$48a20071cd8b3965$var$Flex.displayName = "Flex";
var $48a20071cd8b3965$export$2e2bcd8739ae039 = $48a20071cd8b3965$var$Flex;

});


parcelRegister("5Q9cd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4408f137a1bb15c5$export$2e2bcd8739ae039; });
/* stack.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");


var $eGOLG = parcelRequire("eGOLG");

var $6eCC0 = parcelRequire("6eCC0");
var $4408f137a1bb15c5$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $4408f137a1bb15c5$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $4408f137a1bb15c5$var$Stack = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, $4Onlm.default)(_ref, $4408f137a1bb15c5$var$_excluded);
    return /*#__PURE__*/ $iSvIT.createElement((0, $6eCC0.default), (0, $5VbRa.default)({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $eGOLG.cx)(grow === "hug" && $4408f137a1bb15c5$var$styles.hug, grow === "fill" && $4408f137a1bb15c5$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$4408f137a1bb15c5$var$Stack.displayName = "Stack";
var $4408f137a1bb15c5$export$2e2bcd8739ae039 = $4408f137a1bb15c5$var$Stack;

});

parcelRegister("kU1Dk", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", function () { return $f37a4deed077921d$export$e9b82d2e21ac0c1f; });

var $fACfu = parcelRequire("fACfu");

var $iSvIT = parcelRequire("iSvIT");

var $li83e = parcelRequire("li83e");

var $i7JlS = parcelRequire("i7JlS");

var $9epW6 = parcelRequire("9epW6");

var $cKyvh = parcelRequire("cKyvh");

var $iCDRR = parcelRequire("iCDRR");

var $h7Vgg = parcelRequire("h7Vgg");
function $f37a4deed077921d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f37a4deed077921d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f37a4deed077921d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f37a4deed077921d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f37a4deed077921d$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $h7Vgg.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9epW6))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $h7Vgg.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $h7Vgg.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iCDRR))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $h7Vgg.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $h7Vgg.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i7JlS))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $h7Vgg.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $h7Vgg.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cKyvh))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $h7Vgg.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $h7Vgg.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($li83e))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $h7Vgg.P500), ")")
    }
};
function $f37a4deed077921d$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $f37a4deed077921d$var$appearanceIconSchema[appearance] || $f37a4deed077921d$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $f37a4deed077921d$var$_objectSpread($f37a4deed077921d$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRegister("li83e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f801863006889b84$var$_react = $f801863006889b84$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $f801863006889b84$var$_discovery = $f801863006889b84$var$_interopRequireDefault((parcelRequire("c6Xzs")));

var $f801863006889b84$var$_note = $f801863006889b84$var$_interopRequireDefault((parcelRequire("kx24a")));
function $f801863006889b84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f801863006889b84$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $f801863006889b84$var$_react.default.createElement($f801863006889b84$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $f801863006889b84$var$_note.default
    }, props));
$f801863006889b84$var$DiscoveryIcon.displayName = "DiscoveryIconMigration";
var $f801863006889b84$var$_default = module.exports.default = $f801863006889b84$var$DiscoveryIcon;

});
parcelRegister("c6Xzs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d14411e56dd4ce9$var$_react = $8d14411e56dd4ce9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8d14411e56dd4ce9$var$_baseNew = $8d14411e56dd4ce9$var$_interopRequireDefault((parcelRequire("jfOWh")));
function $8d14411e56dd4ce9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d14411e56dd4ce9$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $8d14411e56dd4ce9$var$_react.default.createElement($8d14411e56dd4ce9$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$8d14411e56dd4ce9$var$DiscoveryIcon.displayName = "DiscoveryIcon";
var $8d14411e56dd4ce9$var$_default = module.exports.default = $8d14411e56dd4ce9$var$DiscoveryIcon;

});

parcelRegister("kx24a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef287dff3aeb84fb$var$_react = $ef287dff3aeb84fb$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6Nm0f = parcelRequire("6Nm0f");
function $ef287dff3aeb84fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ef287dff3aeb84fb$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $ef287dff3aeb84fb$var$_react.default.createElement($6Nm0f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$ef287dff3aeb84fb$var$EditorNoteIcon.displayName = "EditorNoteIcon";
var $ef287dff3aeb84fb$var$_default = module.exports.default = $ef287dff3aeb84fb$var$EditorNoteIcon;

});


parcelRegister("9epW6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b898a4308639684$var$_react = $6b898a4308639684$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6b898a4308639684$var$_statusInformation = $6b898a4308639684$var$_interopRequireDefault((parcelRequire("azhDR")));

var $6b898a4308639684$var$_info = $6b898a4308639684$var$_interopRequireDefault((parcelRequire("18WFQ")));
function $6b898a4308639684$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b898a4308639684$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $6b898a4308639684$var$_react.default.createElement($6b898a4308639684$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $6b898a4308639684$var$_info.default
    }, props));
$6b898a4308639684$var$StatusInformationIcon.displayName = "StatusInformationIconMigration";
var $6b898a4308639684$var$_default = module.exports.default = $6b898a4308639684$var$StatusInformationIcon;

});
parcelRegister("azhDR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b1adb9473bdf05e$var$_react = $7b1adb9473bdf05e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7b1adb9473bdf05e$var$_baseNew = $7b1adb9473bdf05e$var$_interopRequireDefault((parcelRequire("jfOWh")));
function $7b1adb9473bdf05e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b1adb9473bdf05e$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $7b1adb9473bdf05e$var$_react.default.createElement($7b1adb9473bdf05e$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$7b1adb9473bdf05e$var$StatusInformationIcon.displayName = "StatusInformationIcon";
var $7b1adb9473bdf05e$var$_default = module.exports.default = $7b1adb9473bdf05e$var$StatusInformationIcon;

});

parcelRegister("18WFQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d540d353dbd869e$var$_react = $0d540d353dbd869e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6Nm0f = parcelRequire("6Nm0f");
function $0d540d353dbd869e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0d540d353dbd869e$var$InfoIcon = (props)=>/*#__PURE__*/ $0d540d353dbd869e$var$_react.default.createElement($6Nm0f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$0d540d353dbd869e$var$InfoIcon.displayName = "InfoIcon";
var $0d540d353dbd869e$var$_default = module.exports.default = $0d540d353dbd869e$var$InfoIcon;

});


parcelRegister("cKyvh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94848b91b79b81c0$var$_react = $94848b91b79b81c0$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $94848b91b79b81c0$var$_statusSuccess = $94848b91b79b81c0$var$_interopRequireDefault((parcelRequire("5PtmD")));

var $94848b91b79b81c0$var$_checkCircle = $94848b91b79b81c0$var$_interopRequireDefault((parcelRequire("1TYfO")));
function $94848b91b79b81c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94848b91b79b81c0$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $94848b91b79b81c0$var$_react.default.createElement($94848b91b79b81c0$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $94848b91b79b81c0$var$_checkCircle.default
    }, props));
$94848b91b79b81c0$var$StatusSuccessIcon.displayName = "StatusSuccessIconMigration";
var $94848b91b79b81c0$var$_default = module.exports.default = $94848b91b79b81c0$var$StatusSuccessIcon;

});
parcelRegister("5PtmD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43e87e462ea90376$var$_react = $43e87e462ea90376$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $43e87e462ea90376$var$_baseNew = $43e87e462ea90376$var$_interopRequireDefault((parcelRequire("jfOWh")));
function $43e87e462ea90376$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43e87e462ea90376$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $43e87e462ea90376$var$_react.default.createElement($43e87e462ea90376$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$43e87e462ea90376$var$StatusSuccessIcon.displayName = "StatusSuccessIcon";
var $43e87e462ea90376$var$_default = module.exports.default = $43e87e462ea90376$var$StatusSuccessIcon;

});

parcelRegister("1TYfO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1629aab229027388$var$_react = $1629aab229027388$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $6Nm0f = parcelRequire("6Nm0f");
function $1629aab229027388$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1629aab229027388$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $1629aab229027388$var$_react.default.createElement($6Nm0f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$1629aab229027388$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $1629aab229027388$var$_default = module.exports.default = $1629aab229027388$var$CheckCircleIcon;

});




parcelRegister("iUd7u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc37a240eeb32aad$export$2e2bcd8739ae039; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $7eaH5 = parcelRequire("7eaH5");
var $L9W86 = parcelRequire("L9W86");
var $eXPkl = parcelRequire("eXPkl");

var $9tTRA = parcelRequire("9tTRA");

var $l6RQR = parcelRequire("l6RQR");
var $dc37a240eeb32aad$var$packageName = "@atlaskit/select";
var $dc37a240eeb32aad$var$packageVersion = "0.0.0-development";
var $dc37a240eeb32aad$export$d1de3b251ccaa8a3 = (0, $l6RQR.default)((0, $9tTRA.default));
var $dc37a240eeb32aad$var$createAndFireEventOnAtlaskit = (0, $7eaH5.default)("atlaskit");
var $dc37a240eeb32aad$var$Select = (0, $L9W86.default)({
    componentName: "select",
    packageName: $dc37a240eeb32aad$var$packageName,
    packageVersion: $dc37a240eeb32aad$var$packageVersion
})((0, $eXPkl.default)({
    onChange: $dc37a240eeb32aad$var$createAndFireEventOnAtlaskit({
        action: "changed",
        actionSubject: "option",
        attributes: {
            componentName: "select",
            packageName: $dc37a240eeb32aad$var$packageName,
            packageVersion: $dc37a240eeb32aad$var$packageVersion
        }
    })
})($dc37a240eeb32aad$export$d1de3b251ccaa8a3));
var $dc37a240eeb32aad$export$2e2bcd8739ae039 = $dc37a240eeb32aad$var$Select;

});
parcelRegister("7eaH5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $543222c7abdf7ebf$export$2e2bcd8739ae039; });
var $543222c7abdf7ebf$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("L9W86", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08dc191919349448$export$2e2bcd8739ae039; });

var $5VbRa = parcelRequire("5VbRa");

var $fACfu = parcelRequire("fACfu");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");

var $jbp4S = parcelRequire("jbp4S");
var $08dc191919349448$var$_excluded = [
    "analyticsContext"
];
function $08dc191919349448$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $08dc191919349448$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $08dc191919349448$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $08dc191919349448$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $08dc191919349448$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, $4Onlm.default)(_ref, $08dc191919349448$var$_excluded);
            var analyticsData = (0, $iSvIT.useMemo)(function() {
                return $08dc191919349448$var$_objectSpread($08dc191919349448$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $jbp4S.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(WrappedComponent, (0, $5VbRa.default)({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $08dc191919349448$export$2e2bcd8739ae039 = $08dc191919349448$var$withAnalyticsContext;

});
parcelRegister("jbp4S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df727f52aabc215b$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $67X3T = parcelRequire("67X3T");

var $3vQy2 = parcelRequire("3vQy2");

var $7zcG9 = parcelRequire("7zcG9");
var $df727f52aabc215b$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $67X3T.default) || (0, $jxLBU.fg)("analytics-next-use-modern-context_jira");
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7zcG9.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $3vQy2.default), props);
};
var $df727f52aabc215b$export$2e2bcd8739ae039 = $df727f52aabc215b$var$ExportedAnalyticsContext;

});
parcelRegister("67X3T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $476135f2f2d79d62$export$2e2bcd8739ae039; });

var $XAEGR = parcelRequire("XAEGR");
var $476135f2f2d79d62$var$_process$env;
var /// <reference types="node" />
$476135f2f2d79d62$export$2e2bcd8739ae039 = typeof $XAEGR !== "undefined" && $XAEGR !== null && (($476135f2f2d79d62$var$_process$env = {}, $476135f2f2d79d62$var$_process$env === void 0) ? void 0 : $476135f2f2d79d62$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);

});

parcelRegister("3vQy2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28ed074e17924d92$export$2e2bcd8739ae039; });

var $d5B2s = parcelRequire("d5B2s");

var $6ji6y = parcelRequire("6ji6y");

var $ehCmD = parcelRequire("ehCmD");

var $cMQbY = parcelRequire("cMQbY");

var $lTcQE = parcelRequire("lTcQE");

var $llkr9 = parcelRequire("llkr9");

var $fACfu = parcelRequire("fACfu");

var $iSvIT = parcelRequire("iSvIT");

var $4J1z5 = parcelRequire("4J1z5");

var $lEO1D = parcelRequire("lEO1D");
function $28ed074e17924d92$var$_callSuper(t, o, e) {
    return o = (0, $lTcQE.default)(o), (0, $cMQbY.default)(t, $28ed074e17924d92$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $lTcQE.default)(t).constructor) : o.apply(t, e));
}
function $28ed074e17924d92$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($28ed074e17924d92$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $28ed074e17924d92$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).func
};
var $28ed074e17924d92$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $28ed074e17924d92$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, $6ji6y.default)(this, AnalyticsContext);
        _this = $28ed074e17924d92$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, $fACfu.default)(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, $fACfu.default)(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $28ed074e17924d92$var$noop : _this$context$getAtla;
            return [].concat((0, $d5B2s.default)(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, $fACfu.default)(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $28ed074e17924d92$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $llkr9.default)(AnalyticsContext, _Component);
    return (0, $ehCmD.default)(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lEO1D.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $iSvIT.Component));
(0, $fACfu.default)($28ed074e17924d92$var$AnalyticsContext, "contextTypes", $28ed074e17924d92$var$ContextTypes);
(0, $fACfu.default)($28ed074e17924d92$var$AnalyticsContext, "childContextTypes", $28ed074e17924d92$var$ContextTypes);
var $28ed074e17924d92$export$2e2bcd8739ae039 = $28ed074e17924d92$var$AnalyticsContext;

});

parcelRegister("7zcG9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5825a3112cee8173$export$2e2bcd8739ae039; });

var $d5B2s = parcelRequire("d5B2s");

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");

var $gK3vQ = parcelRequire("gK3vQ");

var $kXY8N = parcelRequire("kXY8N");
var $5825a3112cee8173$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $kXY8N.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $gK3vQ.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $iSvIT.useCallback)(function() {
        return [].concat((0, $d5B2s.default)(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $iSvIT.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lEO1D.default).Provider, {
        value: value
    }, children);
};
var $5825a3112cee8173$export$2e2bcd8739ae039 = $5825a3112cee8173$var$AnalyticsContext;

});



parcelRegister("eXPkl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae4e63e574cc6ae6$export$2e2bcd8739ae039; });

var $5VbRa = parcelRequire("5VbRa");

var $iSvIT = parcelRequire("iSvIT");

var $8ipIc = parcelRequire("8ipIc");

var $eetjo = parcelRequire("eetjo");
var $ae4e63e574cc6ae6$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $eetjo.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $8ipIc.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(WrappedComponent, (0, $5VbRa.default)({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $ae4e63e574cc6ae6$export$2e2bcd8739ae039 = $ae4e63e574cc6ae6$var$withAnalyticsEvents;

});
parcelRegister("eetjo", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $a5c91c33d1c88b89$export$9ebb5a84d17e5d18; });

var $fACfu = parcelRequire("fACfu");

var $132G4 = parcelRequire("132G4");

var $iSvIT = parcelRequire("iSvIT");

var $8ipIc = parcelRequire("8ipIc");
function $a5c91c33d1c88b89$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a5c91c33d1c88b89$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a5c91c33d1c88b89$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a5c91c33d1c88b89$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a5c91c33d1c88b89$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $8ipIc.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $iSvIT.useRef)({});
    var patchedProps = (0, $iSvIT.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, $132G4.default)(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $a5c91c33d1c88b89$var$_objectSpread($a5c91c33d1c88b89$var$_objectSpread({}, p), {}, (0, $fACfu.default)({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $a5c91c33d1c88b89$var$_objectSpread($a5c91c33d1c88b89$var$_objectSpread({}, p), {}, (0, $fACfu.default)({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("l6RQR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5e3ee4acf10e628$export$2e2bcd8739ae039; });

var $5VbRa = parcelRequire("5VbRa");

var $4Onlm = parcelRequire("4Onlm");

var $iSvIT = parcelRequire("iSvIT");
var $f5e3ee4acf10e628$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $f5e3ee4acf10e628$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? "default" : _props$validationStat, restProps = (0, $4Onlm.default)(props, $f5e3ee4acf10e628$var$_excluded);
        var internalSelectRef = (0, $iSvIT.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $iSvIT.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(WrappedComponent, (0, $5VbRa.default)({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === "error"
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = "AtlaskitSelect";
    return AtlaskitSelect;
}

});


parcelRegister("aUrB9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f148ac11233e659$export$2e2bcd8739ae039; });
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5VbRa = parcelRequire("5VbRa");

var $132G4 = parcelRequire("132G4");

var $fACfu = parcelRequire("fACfu");

var $4Onlm = parcelRequire("4Onlm");

var $ds4YM = parcelRequire("ds4YM");
var $6kDYt = parcelRequire("6kDYt");

var $iSvIT = parcelRequire("iSvIT");

var $bsD2b = parcelRequire("bsD2b");

var $jxLBU = parcelRequire("jxLBU");

var $w5qWe = parcelRequire("w5qWe");
var $7f148ac11233e659$var$_excluded = [
    "resize",
    "appearance",
    "isCompact",
    "isRequired",
    "isReadOnly",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "minimumRows",
    "testId",
    "maxHeight",
    "onBlur",
    "onFocus",
    "onChange",
    "value",
    "style"
];
function $7f148ac11233e659$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7f148ac11233e659$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7f148ac11233e659$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7f148ac11233e659$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7f148ac11233e659$var$packageName = "@atlaskit/textarea";
var $7f148ac11233e659$var$packageVersion = "8.0.0";
var $7f148ac11233e659$var$analyticsParams = {
    componentName: "textArea",
    packageName: $7f148ac11233e659$var$packageName,
    packageVersion: $7f148ac11233e659$var$packageVersion
};
var $7f148ac11233e659$var$lineHeightBase = 20;
var $7f148ac11233e659$var$lineHeightCompact = 16;
var $7f148ac11233e659$var$compactVerticalPadding = 2;
var $7f148ac11233e659$var$verticalPadding = 6;
var $7f148ac11233e659$var$transitionDuration = "0.2s";
var $7f148ac11233e659$var$borderWidth = 2;
var $7f148ac11233e659$var$baseStyles = null;
var $7f148ac11233e659$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u1j28 _jomr1j28 _7ehi3sij"
};
var $7f148ac11233e659$var$fontStyles = {
    default: "_ect41sbm",
    monospace: "_ect41odn _1tn21oud _14mdudxr",
    large: "_11c81doa _1tn21oud"
};
var $7f148ac11233e659$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
var $7f148ac11233e659$var$setSmartHeight = function setSmartHeight(el) {
    // Always reset height to auto before calculating new height
    el.style.height = "auto";
    var borderHeight = $7f148ac11233e659$var$borderWidth;
    var paddingBoxHeight = el.scrollHeight;
    var borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = "".concat(borderBoxHeight, "px");
};
var $7f148ac11233e659$var$InnerTextArea = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var ourRef = (0, $iSvIT.useRef)(null);
    var _props$resize = props.resize, resize = _props$resize === void 0 ? "smart" : _props$resize, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "standard" : _props$appearance, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$minimumRows = props.minimumRows, minimumRows = _props$minimumRows === void 0 ? 2 : _props$minimumRows, testId = props.testId, _props$maxHeight = props.maxHeight, maxHeight = _props$maxHeight === void 0 ? "50vh" : _props$maxHeight, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, value = props.value, style = props.style, rest = (0, $4Onlm.default)(props, $7f148ac11233e659$var$_excluded);
    var borderHeight = (0, $iSvIT.useMemo)(function() {
        return appearance === "none" ? 2 : 1;
    }, [
        appearance
    ]);
    (0, $iSvIT.useEffect)(function() {
        var el = ourRef.current;
        if (resize === "smart" && el) $7f148ac11233e659$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    var onBlurWithAnalytics = (0, $bsD2b.usePlatformLeafEventHandler)($7f148ac11233e659$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: "blurred"
    }, $7f148ac11233e659$var$analyticsParams));
    var onFocusWithAnalytics = (0, $bsD2b.usePlatformLeafEventHandler)($7f148ac11233e659$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: "focused"
    }, $7f148ac11233e659$var$analyticsParams));
    var getTextAreaRef = function getTextAreaRef(elementRef) {
        ourRef.current = elementRef;
        if (ref && (0, $132G4.default)(ref) === "object") // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === "function") ref(elementRef);
    };
    var handleOnChange = (0, $iSvIT.useCallback)(function(e) {
        var el = ourRef.current;
        if (resize === "smart" && el) $7f148ac11233e659$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    var controlProps = {
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-testid": testId ? testId : undefined
    };
    var compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("textarea", (0, $5VbRa.default)({}, controlProps, {
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows
    }, rest, {
        className: (0, $ds4YM.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c81oud _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v5641gs0 _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazovqm _slp31hna _153gksl0 _usy41kd8 _1a2sh9qi _vbqbhxcb _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fraksl0 _ibjd12ci _6zpvh9qi _19k01ouc _1idrpsu8 _1lephxcb _nmhq1fiz _1n388sxn _1luh3zdg _ndzbkwt5 _1vj0119y",
            $7f148ac11233e659$var$appearanceStyles[appearance],
            (0, $jxLBU.fg)("platform_design_system_team_safari_input_fix") && $7f148ac11233e659$var$fontStyles["large"],
            $7f148ac11233e659$var$fontStyles[isMonospaced ? "monospace" : "default"],
            $7f148ac11233e659$var$resizeStyles[resize],
            "_uzq71d1b _16lw1cn1"
        ]),
        style: $7f148ac11233e659$var$_objectSpread($7f148ac11233e659$var$_objectSpread({}, style), {}, {
            maxHeight: maxHeight,
            "--_5xk3r4": (0, $6kDYt.default)("var(--ds-text, ".concat((0, $w5qWe.N900), ")")),
            "--_19uzta9": (0, $6kDYt.default)("background-color ".concat($7f148ac11233e659$var$transitionDuration, " ease-in-out,\n               border-color ").concat($7f148ac11233e659$var$transitionDuration, " ease-in-out")),
            "--_dnrmjm": (0, $6kDYt.default)("var(--ds-text-disabled, ".concat((0, $w5qWe.N70), ")")),
            "--_t0vtv2": (0, $6kDYt.default)("var(--ds-background-input-pressed, ".concat((0, $w5qWe.N0), ")")),
            "--_xjqa3d": (0, $6kDYt.default)("var(--ds-border-focused, ".concat((0, $w5qWe.B200), ")")),
            "--_1n75f5r": (0, $6kDYt.default)("inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-focused, ".concat((0, $w5qWe.B200), ")"))),
            "--_4mkb4g": (0, $6kDYt.default)("var(--ds-background-input, ".concat((0, $w5qWe.N10), ")")),
            "--_1u9fbts": (0, $6kDYt.default)("var(--ds-border-danger, ".concat((0, $w5qWe.R400), ")")),
            "--_1l1juom": (0, $6kDYt.default)("inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-danger, ".concat((0, $w5qWe.R400), ")"))),
            "--_r5pknd": (0, $6kDYt.default)("var(--ds-background-disabled, ".concat((0, $w5qWe.N20), ")")),
            "--_1z08gfx": (0, $6kDYt.default)("var(--ds-background-input-hovered, ".concat((0, $w5qWe.N30), ")")),
            "--_vrm7dk": (0, $6kDYt.default)("var(--ds-text-subtlest, ".concat((0, $w5qWe.N200), ")")),
            "--_dqsusn": (0, $6kDYt.default)("".concat($7f148ac11233e659$var$lineHeightCompact * minimumRows + $7f148ac11233e659$var$compactVerticalPadding * 2 + borderHeight * 2, "px")),
            "--_n9nqvh": (0, $6kDYt.default)("".concat($7f148ac11233e659$var$lineHeightBase * minimumRows + $7f148ac11233e659$var$verticalPadding * 2 + borderHeight * 2, "px"))
        })
    }));
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ var $7f148ac11233e659$var$TextArea = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($7f148ac11233e659$var$InnerTextArea, (0, $5VbRa.default)({
        ref: ref
    }, props));
}));
$7f148ac11233e659$var$TextArea.displayName = "TextArea";
var $7f148ac11233e659$export$2e2bcd8739ae039 = $7f148ac11233e659$var$TextArea;

});
parcelRegister("ds4YM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cb1c0a759122e41$export$2e2bcd8739ae039; });
const $9cb1c0a759122e41$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $9cb1c0a759122e41$var$ATOMIC_GROUP_LENGTH = 5;
function $9cb1c0a759122e41$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $9cb1c0a759122e41$var$UNDERSCORE_UNICODE ? $9cb1c0a759122e41$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("6kDYt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49c39e6a8299c41d$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $49c39e6a8299c41d$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("bsD2b", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $858096a24b1fcb27$export$a4687b0234b40e28; });

var $fACfu = parcelRequire("fACfu");

var $iSvIT = parcelRequire("iSvIT");

var $eVFgy = parcelRequire("eVFgy");

var $dxUrb = parcelRequire("dxUrb");
function $858096a24b1fcb27$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $858096a24b1fcb27$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $858096a24b1fcb27$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $858096a24b1fcb27$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $858096a24b1fcb27$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $eVFgy.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $dxUrb.useTrackedRef)(analyticsData);
    var fnRef = (0, $dxUrb.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $858096a24b1fcb27$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("eVFgy", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $02ce09e7c28c010d$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $YDe6O = parcelRequire("YDe6O");

var $gPiWP = parcelRequire("gPiWP");
function $02ce09e7c28c010d$export$5bf35293e545f20c() {
    var analyticsContext = (0, $gPiWP.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $YDe6O.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("YDe6O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b64084a1066a431$export$2e2bcd8739ae039; });

var $d5B2s = parcelRequire("d5B2s");

var $6ji6y = parcelRequire("6ji6y");

var $ehCmD = parcelRequire("ehCmD");

var $cMQbY = parcelRequire("cMQbY");

var $lTcQE = parcelRequire("lTcQE");

var $dISfo = parcelRequire("dISfo");

var $llkr9 = parcelRequire("llkr9");

var $fACfu = parcelRequire("fACfu");

var $a8Ibv = parcelRequire("a8Ibv");
function $0b64084a1066a431$var$_callSuper(t, o, e) {
    return o = (0, $lTcQE.default)(o), (0, $cMQbY.default)(t, $0b64084a1066a431$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $lTcQE.default)(t).constructor) : o.apply(t, e));
}
function $0b64084a1066a431$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0b64084a1066a431$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0b64084a1066a431$var$_superPropGet(t, o, e, r) {
    var p = (0, $dISfo.default)((0, $lTcQE.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $0b64084a1066a431$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $0b64084a1066a431$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $0b64084a1066a431$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $6ji6y.default)(this, UIAnalyticsEvent);
        _this = $0b64084a1066a431$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $fACfu.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $fACfu.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $d5B2s.default)(_this.context);
            var handlers = (0, $d5B2s.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $fACfu.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $llkr9.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $ehCmD.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $0b64084a1066a431$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $a8Ibv.default));

});
parcelRegister("a8Ibv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $761cecdd22b1c056$export$2e2bcd8739ae039; });

var $132G4 = parcelRequire("132G4");

var $6ji6y = parcelRequire("6ji6y");

var $ehCmD = parcelRequire("ehCmD");

var $fACfu = parcelRequire("fACfu");
function $761cecdd22b1c056$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $761cecdd22b1c056$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $761cecdd22b1c056$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fACfu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $761cecdd22b1c056$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $761cecdd22b1c056$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $761cecdd22b1c056$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $761cecdd22b1c056$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $6ji6y.default)(this, AnalyticsEvent);
        (0, $fACfu.default)(this, "_isAnalyticsEvent", true);
        (0, $fACfu.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $761cecdd22b1c056$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $ehCmD.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $132G4.default)(updater) === "object") this.payload = $761cecdd22b1c056$var$_objectSpread($761cecdd22b1c056$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("gPiWP", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $c4001b627b061d90$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $c4001b627b061d90$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("dxUrb", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $9dca22bf3812416a$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $9dca22bf3812416a$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("w5qWe", function(module, exports) {

$parcel$export(module.exports, "R400", function () { return $06073440474b5b98$export$2010d0fb4295b346; });
$parcel$export(module.exports, "B200", function () { return $06073440474b5b98$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $06073440474b5b98$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $06073440474b5b98$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $06073440474b5b98$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $06073440474b5b98$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N70", function () { return $06073440474b5b98$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N200", function () { return $06073440474b5b98$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N900", function () { return $06073440474b5b98$export$fbda843f0a27fe96; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $06073440474b5b98$export$4b84fd0e2c617bd = "#FFEBE6";
var $06073440474b5b98$export$b34b069eff244586 = "#FFBDAD";
var $06073440474b5b98$export$be802dd0d8b57f35 = "#FF8F73";
var $06073440474b5b98$export$60847d42f9da92a6 = "#FF7452";
var $06073440474b5b98$export$4a7404f376229999 = "#FF5630";
var $06073440474b5b98$export$2010d0fb4295b346 = "#DE350B";
var $06073440474b5b98$export$2837b5a1a71d5c02 = "#BF2600";
var $06073440474b5b98$export$8d9596b529bbb9cf = "#FFFAE6";
var $06073440474b5b98$export$41060a744ab0b7ae = "#FFF0B3";
var $06073440474b5b98$export$1cc05bbbf340e559 = "#FFE380";
var $06073440474b5b98$export$5aae31392d72caaa = "#FFC400";
var $06073440474b5b98$export$c6930421db9fa514 = "#FFAB00";
var $06073440474b5b98$export$59619663aa6500fb = "#FF991F";
var $06073440474b5b98$export$874739ea9e379ab6 = "#FF8B00";
var $06073440474b5b98$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $06073440474b5b98$export$69a3bf21b9686c2b = "#ABF5D1";
var $06073440474b5b98$export$afbce1382ec95f73 = "#79F2C0";
var $06073440474b5b98$export$747d86715d4175de = "#57D9A3";
var $06073440474b5b98$export$940e1f69e873f202 = "#36B37E";
var $06073440474b5b98$export$a49394138f7b8e85 = "#00875A";
var $06073440474b5b98$export$6fa04827ac68a4fb = "#006644";
var $06073440474b5b98$export$226de0355ed012f8 = "#DEEBFF";
var $06073440474b5b98$export$8c13c2ee36917869 = "#B3D4FF";
var $06073440474b5b98$export$ecfc1dff386a3e7a = "#4C9AFF";
var $06073440474b5b98$export$215b7063051591f1 = "#2684FF";
var $06073440474b5b98$export$e62e8919cca44969 = "#0065FF";
var $06073440474b5b98$export$b3de0ae08da2ce64 = "#0052CC";
var $06073440474b5b98$export$a6ee3d71bc067634 = "#0747A6";
var $06073440474b5b98$export$67f15409e87642a1 = "#669DF1";
var $06073440474b5b98$export$f0539dbc42dbb067 = "#8FB8F6";
var $06073440474b5b98$export$363e4475840015bb = "#EAE6FF";
var $06073440474b5b98$export$4b0a4417ed59760f = "#C0B6F2";
var $06073440474b5b98$export$6011520a64d9a187 = "#998DD9";
var $06073440474b5b98$export$a7175d4e9206bc80 = "#8777D9";
var $06073440474b5b98$export$b48405b95304b5a1 = "#6554C0";
var $06073440474b5b98$export$c71e4279dd54a18d = "#5243AA";
var $06073440474b5b98$export$147899de772240ec = "#403294";
var $06073440474b5b98$export$2cf711fe14c66f06 = "#E6FCFF";
var $06073440474b5b98$export$7a8f4d33f6f9772c = "#B3F5FF";
var $06073440474b5b98$export$776c9c497ef08533 = "#79E2F2";
var $06073440474b5b98$export$69cb3ca10c1e330e = "#00C7E6";
var $06073440474b5b98$export$9dc1ef0f3f48059b = "#00B8D9";
var $06073440474b5b98$export$7c835c78b6fcdef8 = "#00A3BF";
var $06073440474b5b98$export$6036577f95c3877e = "#008DA6";
var $06073440474b5b98$export$29a4f05edc054374 = "#FFFFFF";
var $06073440474b5b98$export$e655ef011c4aa1a2 = "#FAFBFC";
var $06073440474b5b98$export$9fdfb749e33cdf97 = "#F4F5F7";
var $06073440474b5b98$export$3e51e8f1440314ba = "#EBECF0";
var $06073440474b5b98$export$1ce2d1575d444ceb = "#DFE1E6";
var $06073440474b5b98$export$8754fc7e6d8b3000 = "#C1C7D0";
var $06073440474b5b98$export$c2e91cbeada39b8b = "#B3BAC5";
var $06073440474b5b98$export$5f71e19f3a7ad9de = "#A5ADBA";
var $06073440474b5b98$export$eaa8c8a70ac22806 = "#97A0AF";
var $06073440474b5b98$export$7c87d337fb91a97d = "#8993A4";
var $06073440474b5b98$export$d6447c357493214f = "#7A869A";
var $06073440474b5b98$export$f563ee71e9ee74cd = "#6B778C";
var $06073440474b5b98$export$e2ef2124cf4024b1 = "#5E6C84";
var $06073440474b5b98$export$eece5f492e429f08 = "#505F79";
var $06073440474b5b98$export$c39c0fe0f26207ae = "#42526E";
var $06073440474b5b98$export$7090862dc3038a9f = "#344563";
var $06073440474b5b98$export$ad0bacf983b7ddaa = "#253858";
var $06073440474b5b98$export$7d61b15e0da132af = "#172B4D";
var $06073440474b5b98$export$fbda843f0a27fe96 = "#091E42";
var $06073440474b5b98$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $06073440474b5b98$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $06073440474b5b98$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $06073440474b5b98$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $06073440474b5b98$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $06073440474b5b98$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $06073440474b5b98$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $06073440474b5b98$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $06073440474b5b98$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $06073440474b5b98$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $06073440474b5b98$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $06073440474b5b98$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $06073440474b5b98$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $06073440474b5b98$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $06073440474b5b98$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $06073440474b5b98$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $06073440474b5b98$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $06073440474b5b98$export$2f6319cf7d736c2a = "#E6EDFA";
var $06073440474b5b98$export$95126bc8884d6634 = "#DCE5F5";
var $06073440474b5b98$export$8338d8c35d44ff1 = "#CED9EB";
var $06073440474b5b98$export$5368d76ae4fbbda7 = "#B8C7E0";
var $06073440474b5b98$export$9f0a771d16ec8d36 = "#ABBBD6";
var $06073440474b5b98$export$abcf8c38338b4aa5 = "#9FB0CC";
var $06073440474b5b98$export$97e81faa16a182c7 = "#8C9CB8";
var $06073440474b5b98$export$bfe21c59123ecf33 = "#7988A3";
var $06073440474b5b98$export$ee82aa2ea6a1558 = "#67758F";
var $06073440474b5b98$export$682927c6ed76be02 = "#56637A";
var $06073440474b5b98$export$91fd9994c5be9757 = "#455166";
var $06073440474b5b98$export$d281fbfe3cff2df6 = "#3B475C";
var $06073440474b5b98$export$3902c91d8b98a753 = "#313D52";
var $06073440474b5b98$export$8e8133c1ba5845b5 = "#283447";
var $06073440474b5b98$export$33ff357f6620b39 = "#202B3D";
var $06073440474b5b98$export$633847cf062b69e0 = "#1B2638";
var $06073440474b5b98$export$9776a6e503bdbf76 = "#121A29";
var $06073440474b5b98$export$6c813d5160dff5db = "#0E1624";
var $06073440474b5b98$export$3d4f271a500072a = "#0D1424";
var $06073440474b5b98$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $06073440474b5b98$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $06073440474b5b98$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $06073440474b5b98$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $06073440474b5b98$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $06073440474b5b98$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $06073440474b5b98$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $06073440474b5b98$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $06073440474b5b98$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $06073440474b5b98$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $06073440474b5b98$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $06073440474b5b98$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $06073440474b5b98$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $06073440474b5b98$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $06073440474b5b98$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $06073440474b5b98$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $06073440474b5b98$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $06073440474b5b98$export$d2adc5dedf09fced = "#292A2E";
var $06073440474b5b98$export$f51762073d2bb381 = "#94C748";
var $06073440474b5b98$export$95e26d54def96891 = "#B3DF72";

});


parcelRegister("29nIK", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $190ed27651162b6b$export$defe85febe8b728c; });

var $f2Ax6 = parcelRequire("f2Ax6");
var $190ed27651162b6b$export$defe85febe8b728c = (0, $f2Ax6.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts",
        description: "The title shown at the top of the feedback form encouraging users to leave feedback"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research",
        description: "The checkbox label letting users enrol themselves in future product research interviews"
    },
    canBeContactedLabel: {
        id: "feedback-collector.can-be-contacted.label",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>.",
        description: "The checkbox label to give consent to be contacted about their feedback"
    },
    canBeContactedLabelWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy.",
        description: "The checkbox label to give consent to be contacted about their feedback"
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy",
        description: "The text content for the Privacy Policy link"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind",
        description: "The textarea label listing feedback categories (bug, suggestions, questions, comments)"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind",
        description: "The textarea label where users can write their comment"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback",
        description: "The button to submit the feedback form"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel",
        description: "The button to cancel feedback submission"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback",
        description: "The button that allows users to give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue",
        description: "The textarea label where users can describe the bug or issue they have"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve",
        description: "The textarea label where users can write their suggestion"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?",
        description: "The textarea label where users can write their question"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option",
        description: "The default dropdown list option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant",
        description: "The textarea label where users can write their not relevant feedback"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate",
        description: "The textarea label where users can write their not accurate feedback"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow",
        description: "The textarea label where users can write their too slow feedback"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links",
        description: "The textarea label where users can write their unhelpful links feedback"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other",
        description: "The textarea label where users can write their other feedback"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question",
        description: "The feedback dropdown list option to ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment",
        description: "The feedback dropdown list option to leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug",
        description: "The feedback dropdown list option to report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement",
        description: "The feedback dropdown list option to suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback",
        description: "The feedback dropdown list label"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one",
        description: "The feedback dropdown list placeholder"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback",
        description: "Accessibility text used for the feedback icon"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products.",
        description: "Description shown when feedback is successfully submitted"
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!",
        description: "Button to dismiss successflag flag after submitting feedback"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback",
        description: "Section message title for anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback",
        description: "Notice that feedback is anonymous"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk",
        description: "Summary info of required fields asterisk."
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?",
        description: "The textarea label where users can write their suggestion for custom feedback collector"
    },
    canBeContactedLabelAppify: {
        id: "feedback-collector.can-be-contacted.label-appify",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the <a>Atlassian Privacy Policy</a>.",
        description: "The checkbox label to give consent to be contacted about their feedback"
    },
    canBeContactedLabelAppifyWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the Atlassian Privacy Policy.",
        description: "The checkbox label to give consent to be contacted about their feedback"
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps.",
        description: "Description shown when feedback is successfully submitted"
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type",
        description: "Error message when feedback type is not selected"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description",
        description: "Error message when description is not provided"
    }
});

});

parcelRegister("6MdMQ", function(module, exports) {

$parcel$export(module.exports, "IntlProviderWithResolvedMessages", function () { return $0145f7696339da10$export$f793de1293176fe6; });

var $4FQw5 = parcelRequire("4FQw5");

var $fOsVV = parcelRequire("fOsVV");

var $4QZRY = parcelRequire("4QZRY");

var $iSvIT = parcelRequire("iSvIT");

var $gRp5g = parcelRequire("gRp5g");

var $1lDdk = parcelRequire("1lDdk");
var $0145f7696339da10$export$f793de1293176fe6 = function IntlProviderWithResolvedMessages(_ref) {
    var children = _ref.children, locale = _ref.locale;
    var _useState = (0, $iSvIT.useState)(), _useState2 = (0, $fOsVV.default)(_useState, 2), resolvedMessagesForLocale = _useState2[0], setResolvedMessagesForLocale = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        var fetchMessageLocale = /*#__PURE__*/ function() {
            var _ref2 = (0, $4FQw5.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).mark(function _callee() {
                var messages;
                return (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!locale) {
                                _context.next = 5;
                                break;
                            }
                            _context.next = 3;
                            return (0, $1lDdk.getMessagesForLocale)(locale);
                        case 3:
                            messages = _context.sent;
                            setResolvedMessagesForLocale(messages);
                        case 5:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function fetchMessageLocale() {
                return _ref2.apply(this, arguments);
            };
        }();
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gRp5g.default), {
        locale: locale || "en",
        defaultLocale: "en",
        messages: resolvedMessagesForLocale
    }, children);
};

});
parcelRegister("1lDdk", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", function () { return $0fb62bb6677ce120$export$d0a3169680473b6c; });

var $4FQw5 = parcelRequire("4FQw5");

var $4QZRY = parcelRequire("4QZRY");
var $0fb62bb6677ce120$export$d0a3169680473b6c = /*#__PURE__*/ function() {
    var _ref = (0, $4FQw5.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).mark(function _callee(locale) {
        var messages, parentLocale, _messages;
        return (0, (/*@__PURE__*/$parcel$interopDefault($4QZRY))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    locale = locale.replace("-", "_");
                    _context.prev = 1;
                    _context.next = 4;
                    return import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ "../i18n/".concat(locale));
                case 4:
                    messages = _context.sent;
                    return _context.abrupt("return", messages.default);
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](1);
                case 10:
                    _context.prev = 10;
                    parentLocale = locale.split(/[-_]/)[0];
                    _context.next = 14;
                    return import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ "../i18n/".concat(parentLocale));
                case 14:
                    _messages = _context.sent;
                    return _context.abrupt("return", _messages.default);
                case 18:
                    _context.prev = 18;
                    _context.t1 = _context["catch"](10);
                case 20:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ],
            [
                10,
                18
            ]
        ]);
    }));
    return function getMessagesForLocale(_x) {
        return _ref.apply(this, arguments);
    };
}();

});





parcelRegister("hdt5D", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $900dbf592c828473$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $900dbf592c828473$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    feedbackTitle: {
        id: "fastshift.feedback-collector.feedback-title",
        defaultMessage: "Help us improve FastShift Portal",
        description: "Title for the feedback collector"
    },
    feedbackTitleDetails: {
        id: "fastshift.feedback-collector.feedback-title-details",
        defaultMessage: "We\u2019d love to hear about your experience using FastShift Portal. ",
        description: "Details for the feedback collector title"
    }
});

});



parcelRegister("hRDFa", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollectorAnalytics", function () { return (parcelRequire("6BFI3")).useFeedbackCollectorAnalytics; });
parcelRequire("aSZZG");
var $6BFI3 = parcelRequire("6BFI3");

});
parcelRegister("aSZZG", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollectorAnalytics", function () { return (parcelRequire("6BFI3")).useFeedbackCollectorAnalytics; });

var $6BFI3 = parcelRequire("6BFI3");

});
parcelRegister("6BFI3", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollectorAnalytics", function () { return $495a48a34ba9e191$export$c94f8da1b55a1fea; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $h0mGD = parcelRequire("h0mGD");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
const $495a48a34ba9e191$export$c94f8da1b55a1fea = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $h0mGD.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    const sendFeedbackCollectorOpenButtonClickUIEvent = (0, $iSvIT.useCallback)(()=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).FEEDBACK_COLLECTOR_OPEN_BUTTON,
            source: sourceKey
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendFeedbackCollectorSubmitButtonClickUIEvent = (0, $iSvIT.useCallback)((feedbackType)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).FEEDBACK_COLLECTOR_SUBMIT_BUTTON,
            source: sourceKey,
            attributes: {
                feedbackType: feedbackType
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendFeedbackCollectorOpenButtonClickUIEvent: sendFeedbackCollectorOpenButtonClickUIEvent,
        sendFeedbackCollectorSubmitButtonClickUIEvent: sendFeedbackCollectorSubmitButtonClickUIEvent
    };
};

});





parcelRegister("8wCJ8", function(module, exports) {

$parcel$export(module.exports, "NavigationProfile", function () { return (parcelRequire("jVPPg")).NavigationProfile; });

var $jVPPg = parcelRequire("jVPPg");

});
parcelRegister("jVPPg", function(module, exports) {

$parcel$export(module.exports, "NavigationProfile", function () { return $45a65fbe180e503b$export$a516508354e55db1; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $objBZ = parcelRequire("objBZ");

var $gf1F9 = parcelRequire("gf1F9");

var $hqrFq = parcelRequire("hqrFq");
var $baMJU = parcelRequire("baMJU");
var $cDjdn = parcelRequire("cDjdn");

var $etUpd = parcelRequire("etUpd");

var $bEK1x = parcelRequire("bEK1x");

var $jKp9A = parcelRequire("jKp9A");
var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $5wOn9 = parcelRequire("5wOn9");

var $9OyVr = parcelRequire("9OyVr");

var $6RkjL = parcelRequire("6RkjL");
const $45a65fbe180e503b$var$baseStyles = (0, $jAMCU.xcss)({
    marginInline: "auto",
    width: "320px"
});
const $45a65fbe180e503b$var$avatarStyles = (0, $jAMCU.xcss)({
    paddingInlineStart: "space.200"
});
const $45a65fbe180e503b$var$LOGOUT_URL = `${(0, $9OyVr.IDENTITY_BASE_URL)}/logout?continue=${encodeURIComponent(`${(0, $9OyVr.BASE_URL)}/fastshift`)}`;
const $45a65fbe180e503b$var$onLogOutClick = ()=>{
    window.location.assign($45a65fbe180e503b$var$LOGOUT_URL);
};
const $45a65fbe180e503b$export$a516508354e55db1 = ()=>{
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    const intl = (0, $f6qj2.default)();
    const userInfo = (0, $5wOn9.useLoggedInUser)();
    const onClose = ()=>{
        setIsOpen(false);
    };
    const renderTrigger = (triggerProps)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $etUpd.Profile), (0, $6iHNw._)((0, $7Knp0._)({}, triggerProps), {
            src: userInfo.picture,
            label: "Your profile and settings",
            onClick: ()=>setIsOpen((prev)=>!prev),
            testId: "profile-avatar-trigger"
        }));
    const menu = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
            xcss: $45a65fbe180e503b$var$baseStyles,
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $baMJU.default), {
                testId: "profile-content",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cDjdn.default), {
                        title: intl.formatMessage((0, $6RkjL.messages).accountSectionTitle),
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                            xcss: $45a65fbe180e503b$var$avatarStyles,
                            space: "space.200",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $objBZ.default), {
                                    size: "medium",
                                    src: userInfo.picture,
                                    name: userInfo.name
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                                            size: "small",
                                            children: userInfo.name
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                                            children: userInfo.email
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cDjdn.default), {
                        hasSeparator: true,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hqrFq.default), {
                            onClick: $45a65fbe180e503b$var$onLogOutClick,
                            testId: "logout-button",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $6RkjL.messages).profileLogout))
                        })
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bEK1x.Popup), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-end",
        zIndex: 1000,
        content: menu,
        trigger: renderTrigger
    });
};

});
parcelRegister("etUpd", function(module, exports) {

$parcel$export(module.exports, "Profile", function () { return $a8af871d00c7c79e$export$5120f2d0b8d4cab8; });

var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");

var $eA6Ct = parcelRequire("eA6Ct");

var $1zUAZ = parcelRequire("1zUAZ");
var $a8af871d00c7c79e$var$_excluded = [
    "src"
];
var $a8af871d00c7c79e$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var src = _ref.src, props = (0, $fzcGG.default)(_ref, $a8af871d00c7c79e$var$_excluded);
    var ProfileAvatar = (0, $iSvIT.useCallback)(function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eA6Ct.default), {
            appearance: "circle",
            src: src,
            size: "small"
        });
    }, [
        src
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1zUAZ.EndItem), (0, $jRswm.default)({}, props, {
        ref: ref,
        icon: ProfileAvatar
    }));
});

});
parcelRegister("eA6Ct", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9d98ffee92d854a$export$2e2bcd8739ae039; });
/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eLTr6 = parcelRequire("eLTr6");

var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $3XQNt = parcelRequire("3XQNt");

var $5CqIy = parcelRequire("5CqIy");

var $5Lx77 = parcelRequire("5Lx77");

var $7uJIT = parcelRequire("7uJIT");

var $2h6WA = parcelRequire("2h6WA");

var $39dOn = parcelRequire("39dOn");

var $7A0q4 = parcelRequire("7A0q4");

var $fxtBY = parcelRequire("fxtBY");
function $a9d98ffee92d854a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a9d98ffee92d854a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a9d98ffee92d854a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a9d98ffee92d854a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a9d98ffee92d854a$var$packageName = "@atlaskit/avatar";
var $a9d98ffee92d854a$var$packageVersion = "25.1.8";
var $a9d98ffee92d854a$var$containerStyles = null;
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $a9d98ffee92d854a$var$Avatar = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "circle" : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? "div" : _ref$as, _ref$isDecorative = _ref.isDecorative, isDecorative = _ref$isDecorative === void 0 ? false : _ref$isDecorative, imgLoading = _ref.imgLoading;
    var _useAnalyticsEvents = (0, $3XQNt.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $7uJIT.useAvatarContext)();
    var size = sizeProp || (context === null || context === void 0 ? void 0 : context.size) || "medium";
    var customPresenceNode = /*#__PURE__*/ (0, $iSvIT.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $iSvIT.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== "xxlarge" && size !== "xsmall";
    var lastAnalytics = (0, $iSvIT.useRef)(analyticsContext);
    var labelId = (0, $5CqIy.useId)();
    (0, $iSvIT.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $iSvIT.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== "function") return;
        var analyticsEvent = createAnalyticsEvent({
            action: "clicked",
            actionSubject: "avatar",
            attributes: {
                componentName: "avatar",
                packageName: $a9d98ffee92d854a$var$packageName,
                packageVersion: $a9d98ffee92d854a$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $a9d98ffee92d854a$var$_objectSpread({
            componentName: "avatar",
            packageName: $a9d98ffee92d854a$var$packageName,
            packageVersion: $a9d98ffee92d854a$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(" ");
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $iSvIT.createElement((0, $7uJIT.EnsureIsInsideAvatarContext).Provider, {
        value: true
    }, /*#__PURE__*/ $iSvIT.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? "img" : undefined,
        "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $8lTdX.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement((0, $7uJIT.AvatarContentContext).Provider, {
        value: {
            as: (0, $fxtBY.getCustomElement)(isDisabled, href, onClick),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            avatarImage: /*#__PURE__*/ $iSvIT.createElement((0, $2h6WA.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $iSvIT.createElement((0, $5Lx77.AvatarContent), null)), isPresence && /*#__PURE__*/ $iSvIT.createElement((0, $39dOn.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === "string" ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $iSvIT.createElement((0, $7A0q4.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === "string" ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $iSvIT.createElement("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$a9d98ffee92d854a$var$Avatar.displayName = "Avatar";
var $a9d98ffee92d854a$export$2e2bcd8739ae039 = $a9d98ffee92d854a$var$Avatar;

});
parcelRegister("5Lx77", function(module, exports) {

$parcel$export(module.exports, "AvatarContent", function () { return $011556d38a5eb65a$export$47fbc0b44cae5559; });
/* avatar-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $eLTr6 = parcelRequire("eLTr6");

var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $jxLBU = parcelRequire("jxLBU");

var $7uJIT = parcelRequire("7uJIT");
var $011556d38a5eb65a$var$boxShadowCssVar = "--avatar-box-shadow";
var $011556d38a5eb65a$var$bgColorCssVar = "--avatar-bg-color";
var $011556d38a5eb65a$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu194a _1ah3v77o _ra3xnqa1 _128m1bk5 _4dave4h9",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
var $011556d38a5eb65a$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1g4v _ez1ykb7n _gcm1182g _eeh8kb7n _jlxit94y"
};
var $011556d38a5eb65a$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $011556d38a5eb65a$var$borderRadiusMap = {
    xsmall: "_2rkogqwt _14mjgqwt",
    small: "_2rkogqwt _14mjgqwt",
    medium: "_2rkosqtm _14mjsqtm",
    large: "_2rkosqtm _14mjsqtm",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rkob7nn _14mjb7nn"
};
var $011556d38a5eb65a$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $7uJIT.useEnsureIsInsideAvatar)();
    var _useAvatarContent = (0, $7uJIT.useAvatarContent)(), Container = _useAvatarContent.as, appearance = _useAvatarContent.appearance, avatarImage = _useAvatarContent.avatarImage, _useAvatarContent$bor = _useAvatarContent.borderColor, borderColor = _useAvatarContent$bor === void 0 ? (0, $jxLBU.fg)("platform-component-visual-refresh") ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, #FFFFFF)" : _useAvatarContent$bor, href = _useAvatarContent.href, isDisabled = _useAvatarContent.isDisabled, label = _useAvatarContent.label, onClick = _useAvatarContent.onClick, contextRef = _useAvatarContent.ref, tabIndex = _useAvatarContent.tabIndex, target = _useAvatarContent.target, testId = _useAvatarContent.testId, size = _useAvatarContent.size, stackIndex = _useAvatarContent.stackIndex;
    var isInteractive = Boolean(onClick || href || isDisabled);
    return /*#__PURE__*/ $iSvIT.createElement(Container, (0, $jRswm.default)({
        style: (0, $eLTr6.default)((0, $eLTr6.default)({}, $011556d38a5eb65a$var$bgColorCssVar, borderColor), $011556d38a5eb65a$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === "button" ? "button" : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === "_blank" ? "noopener noreferrer" : undefined
    }, {
        className: (0, $8lTdX.default)([
            $011556d38a5eb65a$var$unboundStyles.root,
            $011556d38a5eb65a$var$styles.root,
            $011556d38a5eb65a$var$borderRadiusMap[size],
            appearance === "circle" && $011556d38a5eb65a$var$styles.circle,
            $011556d38a5eb65a$var$widthHeightMap[size],
            stackIndex !== undefined && $011556d38a5eb65a$var$styles.positionRelative,
            isInteractive && !isDisabled && $011556d38a5eb65a$var$unboundStyles.interactive,
            isDisabled && $011556d38a5eb65a$var$styles.disabled
        ])
    }), children || avatarImage);
});

});

parcelRegister("2h6WA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a828e3dd4736086$export$2e2bcd8739ae039; });
/* avatar-image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gaNY9 = parcelRequire("gaNY9");

var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $kNbgC = parcelRequire("kNbgC");

var $5dDZE = parcelRequire("5dDZE");

var $jxLBU = parcelRequire("jxLBU");
var $1a828e3dd4736086$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq",
    iconBg: "_bfhkr4aa",
    iconBGVisualRefresh: "_bfhk1v33",
    circle: "_2rko14q2"
};
var $1a828e3dd4736086$var$borderRadiusMap = {
    xsmall: "_2rkogqwt",
    small: "_2rkogqwt",
    medium: "_2rkosqtm",
    large: "_2rkosqtm",
    xlarge: "_2rkoi2wt",
    xxlarge: "_2rkob7nn"
};
var $1a828e3dd4736086$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $1a828e3dd4736086$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? "" : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId, imgLoading = _ref.imgLoading;
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $gaNY9.default)(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    // If src changes, reset state
    (0, $iSvIT.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $8lTdX.default)([
            $1a828e3dd4736086$var$styles.icon,
            (0, $jxLBU.fg)("platform-component-visual-refresh") ? $1a828e3dd4736086$var$styles.iconBGVisualRefresh : $1a828e3dd4736086$var$styles.iconBg,
            $1a828e3dd4736086$var$nestedSvgStylesMap[size]
        ])
    }, appearance === "circle" ? /*#__PURE__*/ $iSvIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kNbgC))), {
        label: alt,
        color: (0, $jxLBU.fg)("platform-component-visual-refresh") ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-inverse, #FFFFFF)",
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious",
        LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
    }) : /*#__PURE__*/ $iSvIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5dDZE))), {
        label: alt,
        color: (0, $jxLBU.fg)("platform-component-visual-refresh") ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-inverse, #FFFFFF)",
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious",
        LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
    }));
    return /*#__PURE__*/ $iSvIT.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? "".concat(testId, "--image") : "avatar-image",
        "data-ssr-placeholder-ignored": true,
        className: (0, $8lTdX.default)([
            $1a828e3dd4736086$var$styles.image,
            $1a828e3dd4736086$var$borderRadiusMap[size],
            appearance === "circle" && $1a828e3dd4736086$var$styles.circle
        ])
    });
};
var $1a828e3dd4736086$export$2e2bcd8739ae039 = $1a828e3dd4736086$var$AvatarImage;

});
parcelRegister("kNbgC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::325d0bc066f2b42d61e7c5ff0e093014>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2311fa5a3866591$var$_react = $f2311fa5a3866591$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $f2311fa5a3866591$var$_person = $f2311fa5a3866591$var$_interopRequireDefault((parcelRequire("lbYfX")));

var $f2311fa5a3866591$var$_person2 = $f2311fa5a3866591$var$_interopRequireDefault((parcelRequire("joQ1I")));
function $f2311fa5a3866591$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2311fa5a3866591$var$PersonIcon = (props)=>/*#__PURE__*/ $f2311fa5a3866591$var$_react.default.createElement($f2311fa5a3866591$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $f2311fa5a3866591$var$_person2.default
    }, props));
$f2311fa5a3866591$var$PersonIcon.Name = "PersonIconMigration";
var $f2311fa5a3866591$var$_default = module.exports.default = $f2311fa5a3866591$var$PersonIcon;

});
parcelRegister("lbYfX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f6d95dba7afa03e2$var$_react = $f6d95dba7afa03e2$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $f6d95dba7afa03e2$var$_baseNew = $f6d95dba7afa03e2$var$_interopRequireDefault((parcelRequire("110YT")));
function $f6d95dba7afa03e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f6d95dba7afa03e2$var$PersonIcon = (props)=>/*#__PURE__*/ $f6d95dba7afa03e2$var$_react.default.createElement($f6d95dba7afa03e2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$f6d95dba7afa03e2$var$PersonIcon.displayName = "PersonIcon";
var $f6d95dba7afa03e2$var$_default = module.exports.default = $f6d95dba7afa03e2$var$PersonIcon;

});
parcelRegister("110YT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5AjrF")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("5AjrF")).Icon; });

var $5AjrF = parcelRequire("5AjrF");

});
parcelRegister("5AjrF", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $410f65f4cbdf702c$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $410f65f4cbdf702c$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $jxLBU = parcelRequire("jxLBU");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $410f65f4cbdf702c$var$svgStyles = null;
var $410f65f4cbdf702c$var$iconStyles = null;
var $410f65f4cbdf702c$var$utilityIconStyles = null;
var $410f65f4cbdf702c$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $410f65f4cbdf702c$var$baseHcmStyles = null;
var $410f65f4cbdf702c$var$scaleSize = null;
var $410f65f4cbdf702c$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $410f65f4cbdf702c$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $410f65f4cbdf702c$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $410f65f4cbdf702c$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $410f65f4cbdf702c$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $410f65f4cbdf702c$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "none" : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $jxLBU.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return /*#__PURE__*/ $iSvIT.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core";
    var size = "size" in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === "small" || props.size === "medium") ? props.size : "medium";
    var baseSize = $410f65f4cbdf702c$var$baseSizeMap[type];
    var viewBoxPadding = $410f65f4cbdf702c$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $8lTdX.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === "utility" || size === "small") && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $iSvIT.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $8lTdX.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === "utility" ? $410f65f4cbdf702c$var$utilSizes[spacing] : size === "small" ? $410f65f4cbdf702c$var$coreSizeSmall[spacing] : $410f65f4cbdf702c$var$coreSizeMedium[spacing]
        ])
    }));
});
var $410f65f4cbdf702c$export$2e2bcd8739ae039 = $410f65f4cbdf702c$export$f04a61298a47a40f;

});



parcelRegister("joQ1I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1f89da32e49bb47$var$_react = $e1f89da32e49bb47$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $76rYF = parcelRequire("76rYF");

var $e1f89da32e49bb47$var$_person = $e1f89da32e49bb47$var$_interopRequireDefault((parcelRequire("lbYfX")));
function $e1f89da32e49bb47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e1f89da32e49bb47$var$PersonIcon = (props)=>/*#__PURE__*/ $e1f89da32e49bb47$var$_react.default.createElement($76rYF.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $e1f89da32e49bb47$var$_person.default
    }));
$e1f89da32e49bb47$var$PersonIcon.displayName = "PersonIcon";
var $e1f89da32e49bb47$var$_default = module.exports.default = $e1f89da32e49bb47$var$PersonIcon;

});
parcelRegister("76rYF", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $52becbb06e82ef68$export$3cfb73f70dfca966; });

var $jRswm = parcelRequire("jRswm");

var $fzcGG = parcelRequire("fzcGG");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $2Ifra = parcelRequire("2Ifra");
var $52becbb06e82ef68$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $52becbb06e82ef68$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $52becbb06e82ef68$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $iSvIT.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, $fzcGG.default)(_ref, $52becbb06e82ef68$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $jxLBU.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (iconSize === "small" || iconSize === "medium") && !(0, $jxLBU.fg)("platform-visual-refresh-icons-facade-removal")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Icon, (0, $jRswm.default)({}, props, {
                spacing: (0, $jxLBU.fg)("platform-visual-refresh-icons-facade-button-fix") ? $52becbb06e82ef68$var$sizeSpacingMap["utility"][iconSize] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(_Icon, (0, $jRswm.default)({}, props, {
                size: iconSize,
                spacing: $52becbb06e82ef68$var$sizeSpacingMap["core"][iconSize],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2Ifra.Icon), (0, $jRswm.default)({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("2Ifra", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $1f9baa567fa4fe01$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jRswm = parcelRequire("jRswm");

var $eLTr6 = parcelRequire("eLTr6");

var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");
function $1f9baa567fa4fe01$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f9baa567fa4fe01$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f9baa567fa4fe01$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eLTr6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f9baa567fa4fe01$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $1f9baa567fa4fe01$var$iconStyles = null;
var $1f9baa567fa4fe01$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $1f9baa567fa4fe01$var$baseHcmStyles = null;
var $1f9baa567fa4fe01$var$primaryEqualsSecondaryHcmStyles = null;
var $1f9baa567fa4fe01$var$secondaryTransparentHcmStyles = null;
var $1f9baa567fa4fe01$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $iSvIT.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + "px",
        height: height + "px"
    } : null;
    return /*#__PURE__*/ $iSvIT.createElement("span", (0, $jRswm.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $1f9baa567fa4fe01$var$_objectSpread($1f9baa567fa4fe01$var$_objectSpread({}, customDimensions), {}, {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $8lTdX.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === "transparent" && "_4fyi1j28",
            size && $1f9baa567fa4fe01$var$sizeStyles[size]
        ])
    }));
});
var $1f9baa567fa4fe01$export$2e2bcd8739ae039 = $1f9baa567fa4fe01$export$f04a61298a47a40f;

});




parcelRegister("5dDZE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df09611fb9f343ce3ed015b37269b5a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ccd307a0cae7b93$var$_react = $3ccd307a0cae7b93$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3ccd307a0cae7b93$var$_release = $3ccd307a0cae7b93$var$_interopRequireDefault((parcelRequire("93OUL")));

var $3ccd307a0cae7b93$var$_ship = $3ccd307a0cae7b93$var$_interopRequireDefault((parcelRequire("3Z5c7")));
function $3ccd307a0cae7b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3ccd307a0cae7b93$var$ReleaseIcon = (props)=>/*#__PURE__*/ $3ccd307a0cae7b93$var$_react.default.createElement($3ccd307a0cae7b93$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $3ccd307a0cae7b93$var$_ship.default
    }, props));
$3ccd307a0cae7b93$var$ReleaseIcon.Name = "ReleaseIconMigration";
var $3ccd307a0cae7b93$var$_default = module.exports.default = $3ccd307a0cae7b93$var$ReleaseIcon;

});
parcelRegister("93OUL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1a26e96d639121c034f7ae4d8530108>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $698be36cdde19f25$var$_react = $698be36cdde19f25$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $698be36cdde19f25$var$_baseNew = $698be36cdde19f25$var$_interopRequireDefault((parcelRequire("110YT")));
function $698be36cdde19f25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $698be36cdde19f25$var$ReleaseIcon = (props)=>/*#__PURE__*/ $698be36cdde19f25$var$_react.default.createElement($698be36cdde19f25$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$698be36cdde19f25$var$ReleaseIcon.displayName = "ReleaseIcon";
var $698be36cdde19f25$var$_default = module.exports.default = $698be36cdde19f25$var$ReleaseIcon;

});

parcelRegister("3Z5c7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e6b192297a2b9e8$var$_react = $2e6b192297a2b9e8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $76rYF = parcelRequire("76rYF");

var $2e6b192297a2b9e8$var$_release = $2e6b192297a2b9e8$var$_interopRequireDefault((parcelRequire("93OUL")));
function $2e6b192297a2b9e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2e6b192297a2b9e8$var$ShipIcon = (props)=>/*#__PURE__*/ $2e6b192297a2b9e8$var$_react.default.createElement($76rYF.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $2e6b192297a2b9e8$var$_release.default
    }));
$2e6b192297a2b9e8$var$ShipIcon.displayName = "ShipIcon";
var $2e6b192297a2b9e8$var$_default = module.exports.default = $2e6b192297a2b9e8$var$ShipIcon;

});



parcelRegister("39dOn", function(module, exports) {

$parcel$export(module.exports, "PresenceWrapper", function () { return $24aced0beadab161$export$972c5e90200fa0ef; });
/* presence.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $6owtp = parcelRequire("6owtp");

var $1SWH7 = parcelRequire("1SWH7");
var $24aced0beadab161$var$BusyIndicator = /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ $iSvIT.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $6owtp.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $iSvIT.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $6owtp.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $24aced0beadab161$var$FocusIndicator = /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ $iSvIT.createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $6owtp.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $24aced0beadab161$var$OfflineIndicator = /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ $iSvIT.createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $6owtp.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $iSvIT.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $6owtp.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $24aced0beadab161$var$OnlineIndicator = /*#__PURE__*/ $iSvIT.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $6owtp.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $24aced0beadab161$var$getPresence(presence) {
    switch(presence){
        case "busy":
            return $24aced0beadab161$var$BusyIndicator;
        case "focus":
            return $24aced0beadab161$var$FocusIndicator;
        case "offline":
            return $24aced0beadab161$var$OfflineIndicator;
        case "online":
            return $24aced0beadab161$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $24aced0beadab161$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ $iSvIT.createElement((0, $1SWH7.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $iSvIT.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $24aced0beadab161$var$getPresence(presence)) : children);
};
var $24aced0beadab161$export$2e2bcd8739ae039 = $24aced0beadab161$var$AvatarPresence;
var $24aced0beadab161$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
var $24aced0beadab161$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $24aced0beadab161$var$iconOffsetMap = {
    square: "_94n5myb0 _1xi2myb0",
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
var $24aced0beadab161$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        className: (0, $8lTdX.default)([
            $24aced0beadab161$var$styles.root,
            $24aced0beadab161$var$iconSizeMap[size],
            $24aced0beadab161$var$iconOffsetMap[size],
            appearance === "square" && $24aced0beadab161$var$iconOffsetMap["square"]
        ])
    }, /*#__PURE__*/ $iSvIT.createElement($24aced0beadab161$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("1SWH7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15f85d13d250387d$export$2e2bcd8739ae039; });
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");
var $15f85d13d250387d$var$styles = {
    root: "_2rko1q5u _1reo15vq _18m915vq _189e1bk5 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var $15f85d13d250387d$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $15f85d13d250387d$var$IconWrapper = function IconWrapper(_ref) {
    var bgColor = _ref.bgColor, children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $8lTdX.default)([
            $15f85d13d250387d$var$styles.root,
            $15f85d13d250387d$var$unboundStyles.root
        ])
    }, children);
};
var $15f85d13d250387d$export$2e2bcd8739ae039 = $15f85d13d250387d$var$IconWrapper;

});


parcelRegister("7A0q4", function(module, exports) {

$parcel$export(module.exports, "StatusWrapper", function () { return $584c387912630559$export$8045894f255f9726; });
/* status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $8lTdX = parcelRequire("8lTdX");

var $6owtp = parcelRequire("6owtp");

var $1SWH7 = parcelRequire("1SWH7");
var $584c387912630559$var$styles = {
    root: "_kqswstnw"
};
var $584c387912630559$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $584c387912630559$var$iconOffsetMap = {
    square: "_1xi2idpf _154iidpf",
    small: "_1xi2idpf _154iidpf",
    medium: "_1xi2idpf _154iidpf",
    large: "_1xi2t94y _154it94y",
    xlarge: "_1xi21v6z _154i1v6z"
};
var $584c387912630559$var$ApprovedIndicator = /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ $iSvIT.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $6owtp.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $iSvIT.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $6owtp.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $584c387912630559$var$DeclinedIndicator = /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ $iSvIT.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $6owtp.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $iSvIT.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $6owtp.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $584c387912630559$var$LockedIndicator = /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ $iSvIT.createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $6owtp.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $iSvIT.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $6owtp.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $584c387912630559$var$getStatus(status) {
    switch(status){
        case "approved":
            return $584c387912630559$var$ApprovedIndicator;
        case "declined":
            return $584c387912630559$var$DeclinedIndicator;
        case "locked":
            return $584c387912630559$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $584c387912630559$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ $iSvIT.createElement((0, $1SWH7.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $iSvIT.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $584c387912630559$var$getStatus(status)) : children);
};
var $584c387912630559$export$2e2bcd8739ae039 = $584c387912630559$var$AvatarStatus;
var $584c387912630559$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        className: (0, $8lTdX.default)([
            $584c387912630559$var$styles.root,
            $584c387912630559$var$iconSizeMap[size],
            $584c387912630559$var$iconOffsetMap[size],
            appearance === "square" && $584c387912630559$var$iconOffsetMap["square"]
        ])
    }, /*#__PURE__*/ $iSvIT.createElement($584c387912630559$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("fxtBY", function(module, exports) {

$parcel$export(module.exports, "getCustomElement", function () { return $b500e84bb2394990$export$83ee468102cdf04c; });
var $b500e84bb2394990$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return "a";
    if (onClick || isDisabled) return "button";
    return "span";
};

});


parcelRegister("1zUAZ", function(module, exports) {

$parcel$export(module.exports, "EndItem", function () { return $1264f60c53ffc1cd$export$b3477e90773be2d0; });

var $iSvIT = parcelRequire("iSvIT");

var $gQLF3 = parcelRequire("gQLF3");

var $hDoCV = parcelRequire("hDoCV");
var $1264f60c53ffc1cd$export$b3477e90773be2d0 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, forwardedRef) {
    var label = _ref.label, icon = _ref.icon, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, isSelected = _ref.isSelected, testId = _ref.testId, interactionName = _ref.interactionName, ariaControls = _ref["aria-controls"], ariaExpanded = _ref["aria-expanded"], ariaHasPopup = _ref["aria-haspopup"], _ref$isListItem = _ref.isListItem, isListItem = _ref$isListItem === void 0 ? true : _ref$isListItem;
    var Wrapper = isListItem ? (0, $gQLF3.ListItem) : (0, $iSvIT.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hDoCV.IconButton), {
        ref: forwardedRef,
        icon: icon,
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        appearance: "subtle",
        isSelected: isSelected,
        isTooltipDisabled: false,
        testId: testId,
        interactionName: interactionName,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup
    }));
});

});


parcelRegister("6RkjL", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $83db7a3812c26343$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $83db7a3812c26343$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    profileLogout: {
        id: "fastshift.navigation.profile.logout",
        defaultMessage: "Logout",
        description: "Label for the logout link in the profile section"
    },
    accountSectionTitle: {
        id: "fastshift.navigation.profile.account-section-title",
        defaultMessage: "ACCOUNT",
        description: "Title for the account section in the profile navigation"
    }
});

});



parcelRegister("jCR8P", function(module, exports) {

$parcel$export(module.exports, "AccessControlledPageContent", function () { return (parcelRequire("g1CGj")).AccessControlledPageContent; });

var $g1CGj = parcelRequire("g1CGj");

});
parcelRegister("g1CGj", function(module, exports) {

$parcel$export(module.exports, "AccessControlledPageContent", function () { return $cd995eb585d11dd4$export$3da7e6823a50f04c; });
/* access-controlled-page-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hK5Mw = parcelRequire("hK5Mw");

var $7akU3 = parcelRequire("7akU3");
var $jAMCU = parcelRequire("jAMCU");

var $9gh2a = parcelRequire("9gh2a");
parcelRequire("5m8h9");
var $2Brms = parcelRequire("2Brms");
parcelRequire("5XMUP");
var $gbLaZ = parcelRequire("gbLaZ");

var $d5VIE = parcelRequire("d5VIE");
const $cd995eb585d11dd4$var$PageContentContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1bsb1osq _p12f1yae",
            __cmplp.className
        ])
    }));
});
const $cd995eb585d11dd4$var$LoadingContainerStyles = (0, $jAMCU.xcss)({
    height: "80vh",
    width: "100%"
});
const $cd995eb585d11dd4$var$LoadingPageView = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($cd995eb585d11dd4$var$PageContentContainer, {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7akU3.default), {
            alignInline: "center",
            alignBlock: "center",
            xcss: $cd995eb585d11dd4$var$LoadingContainerStyles,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
                size: "xlarge",
                label: "Loading",
                testId: "loading-spinner"
            })
        })
    });
};
const $cd995eb585d11dd4$export$3da7e6823a50f04c = ({ userAccessState: userAccessState, children: children })=>{
    const pathname = (0, $hK5Mw.useLocation)().pathname;
    const { paths: paths } = (0, $gbLaZ.useRoutes)(); // always allow home path to render children
    if (pathname === paths.home) switch(userAccessState){
        case (0, $d5VIE.UserAccessValidationState).LOADING_PORTAL_ELIGIBILITY:
        case (0, $d5VIE.UserAccessValidationState).LOADING_USER_PERMISSIONS:
            return /*#__PURE__*/ (0, $loA2J.jsx)($cd995eb585d11dd4$var$LoadingPageView, {});
        case (0, $d5VIE.UserAccessValidationState).VALIDATION_SUCCESS:
        case (0, $d5VIE.UserAccessValidationState).VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE:
        case (0, $d5VIE.UserAccessValidationState).VALIDATION_FAIL_INELIGIBLE_FOR_PORTAL:
        default:
            return /*#__PURE__*/ (0, $loA2J.jsx)($cd995eb585d11dd4$var$PageContentContainer, {
                children: children
            });
    }
    switch(userAccessState){
        case (0, $d5VIE.UserAccessValidationState).LOADING_PORTAL_ELIGIBILITY:
        case (0, $d5VIE.UserAccessValidationState).LOADING_USER_PERMISSIONS:
            return /*#__PURE__*/ (0, $loA2J.jsx)($cd995eb585d11dd4$var$LoadingPageView, {});
        case (0, $d5VIE.UserAccessValidationState).VALIDATION_SUCCESS:
            return /*#__PURE__*/ (0, $loA2J.jsx)($cd995eb585d11dd4$var$PageContentContainer, {
                children: children
            });
        case (0, $d5VIE.UserAccessValidationState).VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE:
        case (0, $d5VIE.UserAccessValidationState).VALIDATION_FAIL_INELIGIBLE_FOR_PORTAL:
        default:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2Brms.FourOhFourDisplay), {});
    }
};

});
parcelRegister("d5VIE", function(module, exports) {

$parcel$export(module.exports, "UserAccessValidationState", function () { return $b084324b53f983f8$export$65223d64021ba6a8; });
$parcel$export(module.exports, "usePortalAuthenticationAndAccessControl", function () { return $b084324b53f983f8$export$6fd889175fcd8d17; });

var $iSvIT = parcelRequire("iSvIT");

var $hK5Mw = parcelRequire("hK5Mw");

var $gkhN4 = parcelRequire("gkhN4");

var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");

var $k0rCZ = parcelRequire("k0rCZ");
parcelRequire("5XMUP");
var $gbLaZ = parcelRequire("gbLaZ");

var $9OyVr = parcelRequire("9OyVr");

var $3p62O = parcelRequire("3p62O");
var $b084324b53f983f8$export$65223d64021ba6a8;
(function(UserAccessValidationState) {
    UserAccessValidationState["LOADING_PORTAL_ELIGIBILITY"] = "LOADING_PORTAL_ELIGIBILITY";
    UserAccessValidationState["LOADING_USER_PERMISSIONS"] = "LOADING_USER_PERMISSIONS";
    UserAccessValidationState["VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE"] = "VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE";
    UserAccessValidationState["VALIDATION_FAIL_INELIGIBLE_FOR_PORTAL"] = "VALIDATION_FAIL_INELIGIBLE_FOR_PORTAL";
    UserAccessValidationState["VALIDATION_SUCCESS"] = "VALIDATION_SUCCESS";
})($b084324b53f983f8$export$65223d64021ba6a8 || ($b084324b53f983f8$export$65223d64021ba6a8 = {}));
const $b084324b53f983f8$export$6fd889175fcd8d17 = ()=>{
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { isValidFastshiftRoute: isValidFastshiftRoute, domainId: domainId, paths: paths, isValidFastshiftPartnerRoute: isValidFastshiftPartnerRoute } = (0, $gbLaZ.useRoutes)();
    const { pathname: pathname } = (0, $hK5Mw.useLocation)();
    const navigate = (0, $hK5Mw.useNavigate)();
    const dispatch = (0, $8KnwD.useFastshiftDispatch)();
    const { data: userDetails, error: userDetailsError } = (0, $8KnwD.useFastshiftSelector)((state)=>state.userDetails);
    const { data: customerDomainData, error: customerDomainError } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomain);
    const { data: domainsForPartnerAccess } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomains);
    const [userAccessState, setUserAccessState] = (0, $iSvIT.useState)("LOADING_PORTAL_ELIGIBILITY");
    const isDisableAuthHookForTestingOnlyEnabled = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).sxpFastshiftPortalDisableAuthHookTestingOnly);
    const strippedPathname = (0, $iSvIT.useMemo)(()=>(0, $3p62O.removeTrailingSlash)(pathname), [
        pathname
    ]);
    const isPartnerOrInternal = (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "PARTNER" || (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "INTERNAL";
    const pageDomainIsPresentInPartnerSelectionTable = (0, $iSvIT.useMemo)(()=>{
        var _domainsForPartnerAccess_data;
        return domainsForPartnerAccess === null || domainsForPartnerAccess === void 0 ? void 0 : (_domainsForPartnerAccess_data = domainsForPartnerAccess.data) === null || _domainsForPartnerAccess_data === void 0 ? void 0 : _domainsForPartnerAccess_data.some((accessibleDomain)=>accessibleDomain.customerDomainId === domainId);
    }, [
        domainsForPartnerAccess,
        domainId
    ]);
    const shouldShowSideNav = (0, $iSvIT.useMemo)(()=>{
        return [
            "VALIDATION_SUCCESS",
            "LOADING_USER_PERMISSIONS"
        ].includes(userAccessState) && isValidFastshiftRoute(pathname) && strippedPathname !== paths.home;
    }, [
        userAccessState,
        isValidFastshiftRoute,
        pathname,
        strippedPathname,
        paths.home
    ]);
    const isOnHomeRoute = (0, $iSvIT.useMemo)(()=>strippedPathname === paths.home, [
        strippedPathname,
        paths.home
    ]);
    const resolvesIfUserIsAuthenticated = (0, $iSvIT.useCallback)(async ()=>{
        return stargateClient.me({});
    }, [
        stargateClient
    ]);
    const redirectToHomeRoute = ()=>{
        if (strippedPathname !== paths.home && !isDisableAuthHookForTestingOnlyEnabled) navigate(paths.home);
    };
    const redirectIneligibleUserToHome = ()=>{
        setUserAccessState("VALIDATION_FAIL_INELIGIBLE_FOR_PORTAL");
        redirectToHomeRoute();
    };
    // Trigger appropriate checks on page route change
    (0, $iSvIT.useEffect)(()=>{
        // if present, user has already passed portal eligibility checks
        if (userDetails) {
            // Avoid flickering/loading state when navigating between routes after success
            if (userAccessState !== "VALIDATION_SUCCESS") setUserAccessState("LOADING_USER_PERMISSIONS");
            return;
        }
        // if previously shown to be ineligible for portal
        if (userDetailsError) {
            redirectIneligibleUserToHome();
            return;
        }
        setUserAccessState("LOADING_PORTAL_ELIGIBILITY");
    // should only run when user changes page
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pathname
    ]);
    // Portal Eligibility: Check User is Authenticated
    (0, $iSvIT.useEffect)(()=>{
        if (userAccessState !== "LOADING_PORTAL_ELIGIBILITY") return;
        // if user details is not present, ensure user is authenticated and fetch details
        resolvesIfUserIsAuthenticated().then(()=>{
            // Retrieve /user details
            dispatch($k0rCZ.getUserDetails(stargateClient));
        }).catch(()=>{
            // Redirect to Identity to login user
            const currentDomain = window.location.hostname;
            // If fastshift domain - use new fastshift login auth redirect url
            if ((0, $9OyVr.FASTSHIFT_DOMAINS).includes(currentDomain)) {
                const fastshiftLoginAuthContinueUrl = encodeURIComponent(`${(0, $9OyVr.FASTSHIFT_BASE_URL)}${(0, $9OyVr.FASTSHIFT_AUTH_REDIRECT_URL)}`);
                const loginUrl = `${"https://id.atlassian.com"}/login?continue=${fastshiftLoginAuthContinueUrl}`;
                window.location.href = loginUrl;
            } else {
                const loginUrl = `${"https://id.atlassian.com"}/login?continue=${encodeURIComponent(`${(0, $9OyVr.BASE_URL)}${strippedPathname}`)}`;
                window.location.href = loginUrl;
            }
        });
    // should only run Portal Eligibility check is initiated
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userAccessState
    ]);
    // Portal Eligibility: Check User is Eligible
    (0, $iSvIT.useEffect)(()=>{
        if (userAccessState !== "LOADING_PORTAL_ELIGIBILITY") return;
        // still resolving details
        if (!userDetails && !userDetailsError) return;
        // if ineligible for portal
        if (userDetailsError) {
            redirectIneligibleUserToHome();
            return;
        }
        // at this point, permissions on specific page may be checked
        setUserAccessState("LOADING_USER_PERMISSIONS");
        // if on EAP home route, redirect to Milestone 2 home route
        if (strippedPathname === paths.eapHome) {
            redirectToHomeRoute();
            return;
        }
    // should only run when /user endpoint resolves during eligibility check
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userDetails,
        userDetailsError
    ]);
    // User Permissions: Page Check
    // eslint-disable-next-line complexity
    (0, $iSvIT.useEffect)(()=>{
        // Wait until portal eligibility (user details) is resolved
        if (!userDetails && !userDetailsError) return;
        // If user is ineligible for portal, do not perform route-level checks
        if (userDetailsError) return;
        // any authenticated user may access home /fastshift route
        if (strippedPathname === paths.home) {
            setUserAccessState("VALIDATION_SUCCESS");
            return;
        }
        // if not on a valid fastshift route, immediate 404
        if (!isValidFastshiftRoute(strippedPathname)) {
            setUserAccessState("VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE");
            return;
        }
        // check partner-specific routes (no domainId)
        if (!domainId) {
            if (isPartnerOrInternal && isValidFastshiftPartnerRoute(strippedPathname)) setUserAccessState("VALIDATION_SUCCESS");
            else setUserAccessState("VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE");
            return;
        }
        // domain-scoped routes:
        // customer may access their own page without waiting for domain API
        if ((userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "CUSTOMER" && domainId === userDetails.userDomain.domainId) {
            setUserAccessState("VALIDATION_SUCCESS");
            return;
        }
        // partners/internal may access domains from selection table
        if (isPartnerOrInternal) {
            if (pageDomainIsPresentInPartnerSelectionTable === true) {
                setUserAccessState("VALIDATION_SUCCESS");
                return;
            }
        }
        // still pending domain info -> keep current state (likely LOADING_USER_PERMISSIONS)
        if (!customerDomainData && !customerDomainError) return;
        // if /domain returns error, then user may not access page
        if (customerDomainError) {
            setUserAccessState("VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE");
            return;
        }
        // any user may access a page where /domain returns valid response
        if (customerDomainData && customerDomainData.customerDomainId === domainId) {
            setUserAccessState("VALIDATION_SUCCESS");
            return;
        }
        // default: no access
        setUserAccessState("VALIDATION_FAIL_NO_ACCESS_TO_SELECTED_ROUTE");
    }, [
        strippedPathname,
        domainId,
        userDetails,
        customerDomainData,
        customerDomainError,
        userDetailsError,
        isPartnerOrInternal,
        isValidFastshiftRoute,
        isValidFastshiftPartnerRoute,
        paths,
        pageDomainIsPresentInPartnerSelectionTable
    ]);
    return {
        userAccessState: userAccessState,
        shouldShowSideNav: shouldShowSideNav,
        isPartnerOrInternal: isPartnerOrInternal,
        isOnHomeRoute: isOnHomeRoute
    };
};

});
parcelRegister("3p62O", function(module, exports) {

$parcel$export(module.exports, "getDomainScopedPathKeys", function () { return $095383e63766436a$export$f1b565c028d844bf; });
$parcel$export(module.exports, "removeTrailingSlash", function () { return $095383e63766436a$export$b6d465111d914331; });

var $9OyVr = parcelRequire("9OyVr");
const $095383e63766436a$export$f1b565c028d844bf = ()=>Object.keys((0, $9OyVr.FASTSHIFT_PATHS)).filter((pathKey)=>(0, $9OyVr.FASTSHIFT_PATHS)[pathKey].includes(":domainId"));
const $095383e63766436a$export$b6d465111d914331 = (url)=>url.replace(/\/+$/, "");

});




parcelRegister("eFHR3", function(module, exports) {

$parcel$export(module.exports, "DomainScopedNavHeader", function () { return (parcelRequire("jGM2I")).DomainScopedNavHeader; });

var $jGM2I = parcelRequire("jGM2I");

});
parcelRegister("jGM2I", function(module, exports) {

$parcel$export(module.exports, "DomainScopedNavHeader", function () { return $952f393eb45d0acc$export$75394d8c360864dd; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $kLtJu = parcelRequire("kLtJu");

var $45W3N = parcelRequire("45W3N");

var $g2DEO = parcelRequire("g2DEO");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $g2OHD = parcelRequire("g2OHD");

var $bhreu = parcelRequire("bhreu");

var $8KnwD = parcelRequire("8KnwD");
parcelRequire("5XMUP");
var $gbLaZ = parcelRequire("gbLaZ");
parcelRequire("h4ybs");
var $grNmQ = parcelRequire("grNmQ");

var $HPkW5 = parcelRequire("HPkW5");
const $952f393eb45d0acc$var$selectedCustomerStyles = (0, $jAMCU.xcss)({
    paddingInlineStart: "space.100",
    paddingBlockEnd: "space.150",
    alignItems: "center",
    gap: "space.100"
});
const $952f393eb45d0acc$var$selectedCustomerTextStyles = (0, $jAMCU.xcss)({
    flex: 1
});
const $952f393eb45d0acc$var$CustomerDomainDisplay = ()=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    // use the customer domain id to get the customer name
    const { data: customerDomain, pending: isLoadingCustomerDomain } = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomain);
    // return skeleton if pending refresh or there is no data available
    if (!customerDomain || isLoadingCustomerDomain) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g2DEO.default), {
        xcss: $952f393eb45d0acc$var$selectedCustomerStyles,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), {
                height: "36px",
                width: "36px",
                borderRadius: "border.radius",
                testId: "customer-domain-logo-skeleton",
                isShimmering: true
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                xcss: $952f393eb45d0acc$var$selectedCustomerTextStyles,
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), {
                        height: "16px",
                        width: "100%",
                        testId: "customer-name-skeleton",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), {
                        height: "16px",
                        width: "100%",
                        testId: "customer-domain-skeleton",
                        isShimmering: true
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g2DEO.default), {
        xcss: $952f393eb45d0acc$var$selectedCustomerStyles,
        children: [
            customerDomain.customerLogoUrl ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                image: {
                    src: customerDomain.customerLogoUrl,
                    alt: formatMessage((0, $HPkW5.messages).logoAltText, {
                        name: customerDomain.customerName
                    })
                },
                style: {
                    width: "32px",
                    height: "32px",
                    borderRadius: "4px"
                }
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), {
                height: "36px",
                width: "36px",
                borderRadius: "4px",
                testId: "customer-domain-logo-skeleton"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                xcss: $952f393eb45d0acc$var$selectedCustomerTextStyles,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                        size: "large",
                        children: customerDomain.customerName
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                        color: "color.text.subtlest",
                        children: customerDomain.customerDomain
                    })
                ]
            })
        ]
    });
};
const $952f393eb45d0acc$export$75394d8c360864dd = ({ isOnDomainScopedPage: isOnDomainScopedPage })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { paths: paths } = (0, $gbLaZ.useRoutes)();
    const { sendCustomerSelectionBackButtonClickEvent: sendCustomerSelectionBackButtonClickEvent } = (0, $grNmQ.usePageLayoutAnalytics)();
    if (!isOnDomainScopedPage) return null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $45W3N.LinkMenuItem), {
                href: paths.selection,
                elemBefore: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kLtJu))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                }),
                onClick: ()=>{
                    sendCustomerSelectionBackButtonClickEvent(paths.selection);
                },
                children: formatMessage((0, $HPkW5.messages).customersBackLabel)
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($952f393eb45d0acc$var$CustomerDomainDisplay, {})
        ]
    });
};

});
parcelRegister("h4ybs", function(module, exports) {

$parcel$export(module.exports, "usePageNavLinks", function () { return (parcelRequire("c14sc")).usePageNavLinks; });
$parcel$export(module.exports, "useLoadDomainScopedState", function () { return (parcelRequire("cPOxq")).useLoadDomainScopedState; });
$parcel$export(module.exports, "usePageLayoutAnalytics", function () { return (parcelRequire("grNmQ")).usePageLayoutAnalytics; });

var $c14sc = parcelRequire("c14sc");

var $cPOxq = parcelRequire("cPOxq");

var $grNmQ = parcelRequire("grNmQ");

});
parcelRegister("c14sc", function(module, exports) {

$parcel$export(module.exports, "usePageNavLinks", function () { return $de418cd34c997cad$export$bf0e9f036a169a36; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $kqqsh = parcelRequire("kqqsh");

var $6x3OQ = parcelRequire("6x3OQ");

var $iHmgk = parcelRequire("iHmgk");
parcelRequire("5XMUP");
var $gbLaZ = parcelRequire("gbLaZ");

var $9OyVr = parcelRequire("9OyVr");

var $3p62O = parcelRequire("3p62O");

var $HPkW5 = parcelRequire("HPkW5");
const $de418cd34c997cad$export$bf0e9f036a169a36 = ()=>{
    var _navLinks_find;
    const { fullPathname: fullPathname, paths: paths } = (0, $gbLaZ.useRoutes)();
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    // note that the order of this navLinks array determines
    // the order of links displayed inside the sidenav component
    const navLinks = [
        // (Ordered) Partner Scoped Links
        {
            key: (0, $9OyVr.FASTSHIFT_PATH_KEYS).SELECTION,
            label: formatMessage((0, $HPkW5.messages).customersNavLabel),
            link: paths.selection,
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHmgk))), {
                label: ""
            })
        },
        {
            key: (0, $9OyVr.FASTSHIFT_PATH_KEYS).RESOURCES_PARTNER_SCOPED,
            label: formatMessage((0, $HPkW5.messages).resourcesNavLabel),
            link: paths.partnerResources,
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kqqsh))), {
                label: ""
            })
        },
        // (Ordered) Domain Scoped Links
        {
            key: (0, $9OyVr.FASTSHIFT_PATH_KEYS).OVERVIEW,
            label: formatMessage((0, $HPkW5.messages).forYouNavLabel),
            link: paths.domainScopedOverview,
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHmgk))), {
                label: ""
            })
        },
        {
            key: (0, $9OyVr.FASTSHIFT_PATH_KEYS).PLANNING,
            label: formatMessage((0, $HPkW5.messages).migrationPlanningNavLabel),
            link: paths.domainScopedPlanning,
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6x3OQ))), {
                label: ""
            })
        },
        {
            key: (0, $9OyVr.FASTSHIFT_PATH_KEYS).RESOURCES_DOMAIN_SCOPED,
            label: formatMessage((0, $HPkW5.messages).resourcesNavLabel),
            link: paths.domainScopedResources,
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kqqsh))), {
                label: ""
            })
        }
    ];
    const domainScopedPathKeys = (0, $3p62O.getDomainScopedPathKeys)();
    // find the key of the navlinks object with a link that matches the pathname
    const currentPageKey = (_navLinks_find = navLinks.find((navLink)=>navLink.link === fullPathname)) === null || _navLinks_find === void 0 ? void 0 : _navLinks_find.key;
    if (domainScopedPathKeys.includes(currentPageKey || "")) return {
        pageKey: currentPageKey,
        links: [
            ...navLinks.filter((navLink)=>domainScopedPathKeys.includes(navLink.key))
        ],
        isOnDomainScopedPage: true
    };
    return {
        pageKey: currentPageKey,
        links: [
            ...navLinks.filter((navLink)=>!domainScopedPathKeys.includes(navLink.key))
        ],
        isOnDomainScopedPage: false
    };
};

});
parcelRegister("HPkW5", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $639244f2ddb0f16c$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $639244f2ddb0f16c$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    customersNavLabel: {
        id: "fastshift-portal.page-layout.nav.customers-label",
        defaultMessage: "Customers",
        description: "Navigation label for customers page"
    },
    resourcesNavLabel: {
        id: "fastshift-portal.page-layout.nav.resources-label",
        defaultMessage: "Resources",
        description: "Navigation label for resources page"
    },
    forYouNavLabel: {
        id: "fastshift-portal.page-layout.nav.for-you-label",
        defaultMessage: "For You",
        description: "Navigation label for for you page"
    },
    migrationPlanningNavLabel: {
        id: "fastshift-portal.page-layout.nav.migration-planning-label",
        defaultMessage: "Migration Planning",
        description: "Navigation label for migration planning page"
    },
    collapseSidebarLabel: {
        id: "fastshift-portal.page-layout.sidebar.collapse-label",
        defaultMessage: "Collapse sidebar",
        description: "Label for collapse sidebar button"
    },
    expandSidebarLabel: {
        id: "fastshift-portal.page-layout.sidebar.expand-label",
        defaultMessage: "Expand sidebar",
        description: "Label for expand sidebar button"
    },
    fastshiftAppName: {
        id: "fastshift-portal.page-layout.app.name",
        defaultMessage: "Fastshift",
        description: "Application name for Fastshift"
    },
    homePageLabel: {
        id: "fastshift-portal.page-layout.app.home-page-label",
        defaultMessage: "Home page",
        description: "Label for home page link"
    },
    customersBackLabel: {
        id: "fastshift-portal.page-layout.nav.customers-back-label",
        defaultMessage: "Customers",
        description: "Label for back to customers link in sidebar header"
    },
    logoAltText: {
        id: "fastshift-portal.page-layout.logo.alt-text",
        defaultMessage: "{name} logo",
        description: "Alt text for the company logo of the selected customer"
    },
    betaLozenge: {
        id: "fastshift-portal.page-layout.app.beta-lozenge",
        defaultMessage: "Beta",
        description: "Beta lozenge"
    }
});

});


parcelRegister("cPOxq", function(module, exports) {

$parcel$export(module.exports, "useLoadDomainScopedState", function () { return $086d887a7ea3dd81$export$c25f886b0fc98cd3; });

var $iSvIT = parcelRequire("iSvIT");

var $gkhN4 = parcelRequire("gkhN4");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");

var $k0rCZ = parcelRequire("k0rCZ");
const $086d887a7ea3dd81$export$c25f886b0fc98cd3 = (customerDomainId)=>{
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const dispatch = (0, $8KnwD.useFastshiftDispatch)();
    const customerDomain = (0, $8KnwD.useFastshiftSelector)((state)=>state.customerDomain);
    (0, $iSvIT.useEffect)(()=>{
        var _customerDomain_data;
        // Fetch is not relevant to non-domain scoped pages
        if (!customerDomainId) return;
        // Don't refetch if domain-scoped state is already available
        if ((customerDomain === null || customerDomain === void 0 ? void 0 : (_customerDomain_data = customerDomain.data) === null || _customerDomain_data === void 0 ? void 0 : _customerDomain_data.customerDomainId) === customerDomainId) return;
        // Clear any outdated domain-scoped data
        // For example - a partner selected a different customer domain
        if (customerDomain === null || customerDomain === void 0 ? void 0 : customerDomain.data) dispatch($k0rCZ.clearAllCustomerDomainScopedState());
        dispatch($k0rCZ.getCustomerDomain({
            stargateClient: stargateClient,
            customerDomainId: customerDomainId
        }));
        dispatch($k0rCZ.getCustomerDomainEngagementDetails({
            stargateClient: stargateClient,
            customerDomainId: customerDomainId
        }));
    // Add once available: retrieve domain-scoped move tickets
    // Only run effect when URL Parameter is updated
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        customerDomainId
    ]);
};

});

parcelRegister("grNmQ", function(module, exports) {

$parcel$export(module.exports, "usePageLayoutAnalytics", function () { return $8819ee9b716968d4$export$e91aa6667fd40dd5; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $h0mGD = parcelRequire("h0mGD");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
const $8819ee9b716968d4$export$e91aa6667fd40dd5 = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $h0mGD.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    const sendSideNavLinkClickEvent = (0, $iSvIT.useCallback)((navLinkTitle, destinationRoute, isDomainScopedView)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).LINK,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).SIDE_NAV_LINK,
            source: sourceKey,
            attributes: {
                navLinkTitle: navLinkTitle,
                destinationRoute: destinationRoute,
                isDomainScopedView: isDomainScopedView
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendCustomerSelectionBackButtonClickEvent = (0, $iSvIT.useCallback)((destinationRoute)=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).LINK,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).CUSTOMER_SELECTION_BACK_LINK,
            source: sourceKey,
            attributes: {
                destinationRoute: destinationRoute
            }
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendSideNavLinkClickEvent: sendSideNavLinkClickEvent,
        sendCustomerSelectionBackButtonClickEvent: sendCustomerSelectionBackButtonClickEvent
    };
};

});





parcelRegister("57r8u", function(module, exports) {

$parcel$export(module.exports, "FastshiftPage", function () { return (parcelRequire("3VPg6")).FastshiftPage; });

var $3VPg6 = parcelRequire("3VPg6");

});
parcelRegister("3VPg6", function(module, exports) {

$parcel$export(module.exports, "FastshiftPage", function () { return $329099d0e1d5fc11$export$99add00aff814de5; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hK5Mw = parcelRequire("hK5Mw");
parcelRequire("5m8h9");
var $5wrp0 = parcelRequire("5wrp0");
parcelRequire("5XMUP");
var $gbLaZ = parcelRequire("gbLaZ");

var $9OyVr = parcelRequire("9OyVr");
parcelRequire("7zqwM");
var $8KnwD = parcelRequire("8KnwD");
parcelRequire("gEaRO");
var $gkhN4 = parcelRequire("gkhN4");
parcelRequire("8f74T");
var $8Kvwr = parcelRequire("8Kvwr");
parcelRequire("9yt5q");
var $1vZZu = parcelRequire("1vZZu");
const $329099d0e1d5fc11$export$99add00aff814de5 = ()=>{
    const { paths: paths, getPathByDomainId: getPathByDomainId } = (0, $gbLaZ.useRoutes)();
    (0, $8Kvwr.useFastshiftPageAnalytics)();
    const { data: userDetails, error: userDetailsError } = (0, $8KnwD.useFastshiftSelector)((state)=>state.userDetails);
    const navigate = (0, $hK5Mw.useNavigate)();
    const isPartnerOrInternal = (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "PARTNER" || (userDetails === null || userDetails === void 0 ? void 0 : userDetails.userType) === "INTERNAL";
    (0, $iSvIT.useEffect)(()=>{
        if (userDetails) {
            if (userDetails.userType === "CUSTOMER") {
                var _userDetails_userDomain;
                var _userDetails_userDomain_domainId;
                const url = getPathByDomainId((0, $9OyVr.FASTSHIFT_PATHS)[(0, $9OyVr.FASTSHIFT_PATH_KEYS).OVERVIEW], (_userDetails_userDomain_domainId = (_userDetails_userDomain = userDetails.userDomain) === null || _userDetails_userDomain === void 0 ? void 0 : _userDetails_userDomain.domainId) !== null && _userDetails_userDomain_domainId !== void 0 ? _userDetails_userDomain_domainId : "");
                if (url) navigate(url);
            } else if (isPartnerOrInternal) {
                const url = paths.selection;
                if (url) navigate(url);
            }
        }
    }, [
        userDetails,
        isPartnerOrInternal,
        navigate,
        getPathByDomainId,
        paths.selection
    ]);
    if (userDetailsError === (0, $gkhN4.FastshiftUserDetailsExpectedError).NO_ELIGIBLE_LICENSE) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1vZZu.NotEligibleDisplay), {
            ineligibilityReason: "no-license"
        })
    });
    if (userDetailsError === (0, $gkhN4.FastshiftUserDetailsExpectedError).NO_ACCESS) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1vZZu.NotEligibleDisplay), {
            ineligibilityReason: "not-linked"
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5wrp0.GenericErrorDisplay), {})
    });
};

});
parcelRegister("8f74T", function(module, exports) {

$parcel$export(module.exports, "useFastshiftPageAnalytics", function () { return (parcelRequire("8Kvwr")).useFastshiftPageAnalytics; });
$parcel$export(module.exports, "useFastshiftUIAnalytics", function () { return (parcelRequire("9VEpT")).useFastshiftUIAnalytics; });

var $8Kvwr = parcelRequire("8Kvwr");

var $9VEpT = parcelRequire("9VEpT");

});
parcelRegister("8Kvwr", function(module, exports) {

$parcel$export(module.exports, "useFastshiftPageAnalytics", function () { return $c97bc3707411fb48$export$e9a72f1288f66b0c; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $h0mGD = parcelRequire("h0mGD");
var $ih47h = parcelRequire("ih47h");
const $c97bc3707411fb48$export$e9a72f1288f66b0c = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $h0mGD.useFastshiftAnalyticsData)();
    const { fireScreenEvent: fireScreenEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    (0, $iSvIT.useEffect)(()=>{
        if (!identityAttrs) return;
        fireScreenEvent({
            name: sourceKey
        });
    }, [
        fireScreenEvent,
        sourceKey,
        identityAttrs
    ]);
};

});

parcelRegister("9VEpT", function(module, exports) {

$parcel$export(module.exports, "useFastshiftUIAnalytics", function () { return $4638b14439df2dfa$export$1c68f76135b864ca; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("enHYO");
var $h0mGD = parcelRequire("h0mGD");
var $ih47h = parcelRequire("ih47h");

var $k7z8r = parcelRequire("k7z8r");
const $4638b14439df2dfa$export$1c68f76135b864ca = ()=>{
    const { sourceKey: sourceKey, identityAttrs: identityAttrs } = (0, $h0mGD.useFastshiftAnalyticsData)(true);
    const { fireUIEvent: fireUIEvent } = (0, $ih47h.useFireAnalyticsEvents)(identityAttrs);
    const sendGoBackButtonClickUIEvent = (0, $iSvIT.useCallback)(()=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).GO_BACK_BUTTON,
            source: sourceKey,
            attributes: {}
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendSignInWithAnotherAccountButtonClickUIEvent = (0, $iSvIT.useCallback)(()=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).BUTTON,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).SIGN_IN_WITH_ANOTHER_ACCOUNT_BUTTON,
            source: sourceKey,
            attributes: {}
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    const sendContactSupportLinkClickUIEvent = (0, $iSvIT.useCallback)(()=>{
        fireUIEvent({
            action: (0, $k7z8r.ActionKey).CLICKED,
            actionSubject: (0, $k7z8r.ActionSubjectKey).LINK,
            actionSubjectId: (0, $k7z8r.ActionSubjectIdKey).CONTACT_SUPPORT_LINK,
            source: sourceKey,
            attributes: {}
        });
    }, [
        fireUIEvent,
        sourceKey
    ]);
    return {
        sendGoBackButtonClickUIEvent: sendGoBackButtonClickUIEvent,
        sendSignInWithAnotherAccountButtonClickUIEvent: sendSignInWithAnotherAccountButtonClickUIEvent,
        sendContactSupportLinkClickUIEvent: sendContactSupportLinkClickUIEvent
    };
};

});


parcelRegister("9yt5q", function(module, exports) {

$parcel$export(module.exports, "NotEligibleDisplay", function () { return (parcelRequire("1vZZu")).NotEligibleDisplay; });

var $1vZZu = parcelRequire("1vZZu");

});
parcelRegister("1vZZu", function(module, exports) {

$parcel$export(module.exports, "NotEligibleDisplay", function () { return $61cd7e2275a176aa$export$53f49d5ce0b525cc; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bM10s = parcelRequire("bM10s");

var $gf1F9 = parcelRequire("gf1F9");

var $9FeWi = parcelRequire("9FeWi");
var $jKp9A = parcelRequire("jKp9A");
var $g2DEO = parcelRequire("g2DEO");
var $7akU3 = parcelRequire("7akU3");
var $cgOuH = parcelRequire("cgOuH");
var $5P9nB = parcelRequire("5P9nB");
var $jAMCU = parcelRequire("jAMCU");

var $9OyVr = parcelRequire("9OyVr");

var $bWleG = parcelRequire("bWleG");
parcelRequire("8f74T");
var $9VEpT = parcelRequire("9VEpT");

var $6YBpK = parcelRequire("6YBpK");
const $61cd7e2275a176aa$var$padlockStyles = (0, $jAMCU.xcss)({
    marginBlockEnd: "space.150",
    paddingBlock: "space.300"
});
const $61cd7e2275a176aa$var$textStyles = (0, $jAMCU.xcss)({
    maxWidth: "580px",
    marginBlockEnd: "space.200"
});
const $61cd7e2275a176aa$var$SWITCH_ACCOUNT_IDENTITY_URL = `${(0, $9OyVr.IDENTITY_BASE_URL)}/login?continue=${encodeURIComponent(`${(0, $9OyVr.BASE_URL)}/fastshift`)}&prompt=select_account`;
const $61cd7e2275a176aa$export$53f49d5ce0b525cc = ({ ineligibilityReason: ineligibilityReason })=>{
    const { sendGoBackButtonClickUIEvent: sendGoBackButtonClickUIEvent, sendSignInWithAnotherAccountButtonClickUIEvent: sendSignInWithAnotherAccountButtonClickUIEvent } = (0, $9VEpT.useFastshiftUIAnalytics)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
        padding: "space.300",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g2DEO.default), {
            justifyContent: "center",
            alignItems: "center",
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jKp9A.default), {
                    xcss: $61cd7e2275a176aa$var$padlockStyles,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bWleG.PadlockIcon), {})
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cgOuH.default), {
                    space: "space.200",
                    alignInline: "center",
                    xcss: $61cd7e2275a176aa$var$textStyles,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $6YBpK.messages).notEligibleTitle))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5P9nB.default), {
                            align: "center",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($61cd7e2275a176aa$var$DescriptionMessage, {
                                ineligibilityReason: ineligibilityReason
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7akU3.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $bM10s.default), {
                            href: (0, $9OyVr.FASTSHIFT_PORTAL_MARKETING_URL),
                            onClick: ()=>sendGoBackButtonClickUIEvent(),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $6YBpK.messages).goBackButton))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $bM10s.default), {
                            href: $61cd7e2275a176aa$var$SWITCH_ACCOUNT_IDENTITY_URL,
                            appearance: "primary",
                            onClick: ()=>sendSignInWithAnotherAccountButtonClickUIEvent(),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $6YBpK.messages).signInWithAnotherAccountButton))
                        })
                    ]
                })
            ]
        })
    });
};
const $61cd7e2275a176aa$var$DescriptionMessage = ({ ineligibilityReason: ineligibilityReason })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { sendContactSupportLinkClickUIEvent: sendContactSupportLinkClickUIEvent } = (0, $9VEpT.useFastshiftUIAnalytics)();
    switch(ineligibilityReason){
        case "no-license":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $6YBpK.messages).noLicenseDescription), {
                values: {
                    contactSupportLink: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9FeWi.default), {
                        href: `${(0, $9OyVr.SAC_URL)}/contact`,
                        target: "_blank",
                        onClick: ()=>sendContactSupportLinkClickUIEvent(),
                        children: formatMessage((0, $6YBpK.messages).contactSupportAnchorText)
                    })
                }
            }));
        case "not-linked":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $6YBpK.messages).notLinkedDescription), {
                values: {
                    contactSupportLink: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9FeWi.default), {
                        href: `${(0, $9OyVr.SAC_URL)}/contact`,
                        target: "_blank",
                        onClick: ()=>sendContactSupportLinkClickUIEvent(),
                        children: formatMessage((0, $6YBpK.messages).contactSupportAnchorText)
                    })
                }
            }));
        default:
            return null;
    }
};

});
parcelRegister("bWleG", function(module, exports) {

$parcel$export(module.exports, "PadlockIcon", function () { return $abe958e17ae7e8b5$export$814f7e023436df33; });

var $loA2J = parcelRequire("loA2J");
const $abe958e17ae7e8b5$export$814f7e023436df33 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "162",
        height: "132",
        viewBox: "0 0 162 132",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M36.4193 46.0518C34.724 46.0518 33.055 45.9143 31.4579 45.6525C21.5939 44.0096 14.9568 37.6016 13.2419 28.078C12.9604 26.5136 12.8164 24.8576 12.8164 23.1623C12.8164 21.4671 12.9604 19.7653 13.2484 18.1878C14.9699 8.66416 21.607 2.25616 31.4579 0.619799C34.5997 0.0961628 38.0622 0.0830714 41.1975 0.593617C51.0615 2.19725 57.7117 8.61835 59.4331 18.2009C59.7146 19.7849 59.8651 21.4605 59.8651 23.1689C59.8651 24.8773 59.7211 26.5136 59.4462 28.078C57.7379 37.6605 51.0877 44.0816 41.204 45.6853C39.6724 45.934 38.0622 46.0649 36.4259 46.0649L36.4193 46.0518ZM36.4062 7.36162C35.1691 7.36162 33.932 7.4598 32.78 7.64962C25.9531 8.78852 21.548 13.0169 20.3633 19.5623C20.1604 20.6947 20.0557 21.8991 20.0557 23.1493C20.0557 24.3994 20.1604 25.5645 20.3568 26.6903C21.535 33.2293 25.9466 37.4642 32.78 38.6031C35.0644 38.9827 37.6302 38.9893 39.8949 38.6227C46.735 37.51 51.1466 33.2751 52.3248 26.6903C52.5277 25.5711 52.6259 24.3798 52.6259 23.1493C52.6259 21.9187 52.5211 20.7013 52.3182 19.5623C51.1335 12.9776 46.7219 8.74271 39.8949 7.62998C38.7888 7.45325 37.5975 7.36162 36.4062 7.36162Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M72.5238 24.3926H0.818359V96.098H72.5238V24.3926Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M46.9175 60.9825C47.0419 60.2822 47.1074 59.5425 47.1074 58.7571C47.1074 57.9716 47.0419 57.2058 46.911 56.4989C46.1583 52.2902 43.2325 49.6982 39.135 49.0305C38.4346 48.9193 37.7015 48.8604 36.9423 48.8604C36.183 48.8604 35.3845 48.9258 34.6579 49.0436C30.5539 49.7309 27.6412 52.3163 26.8819 56.4989C26.751 57.2058 26.6855 57.9585 26.6855 58.7571C26.6855 59.5556 26.751 60.2822 26.8754 60.9825C27.6281 65.1585 30.5474 67.7505 34.6579 68.4378C35.3845 68.5622 36.1503 68.6211 36.9423 68.6211C37.7343 68.6211 38.4412 68.5622 39.135 68.4509C43.239 67.7833 46.1648 65.1847 46.9175 60.9825Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M41.5051 63.5352H32.4004V80.7497H41.5051V63.5352Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M121.654 59.4704C121.628 59.0646 121.615 58.6523 121.615 58.2333C121.615 56.9897 121.72 55.7788 121.923 54.6464C123.107 48.101 127.519 43.8726 134.339 42.7337C135.491 42.5439 136.728 42.4457 137.966 42.4457C139.203 42.4457 140.348 42.5373 141.454 42.7141C148.281 43.8268 152.693 48.0617 153.878 54.6464C154.08 55.7788 154.185 56.9897 154.185 58.2333C154.185 58.6523 154.172 59.0646 154.146 59.4704H161.392C161.411 59.0581 161.418 58.6457 161.418 58.2333C161.418 56.5184 161.274 54.8493 160.986 53.2653C159.264 43.6828 152.621 37.2683 142.75 35.6581C139.615 35.1475 136.152 35.1606 133.011 35.6843C123.166 37.3272 116.529 43.7286 114.801 53.2523C114.513 54.8363 114.369 56.5119 114.369 58.2268C114.369 58.6392 114.376 59.0515 114.395 59.4639H121.641L121.654 59.4704Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M134.496 59.4707H62.791V131.176H134.496V59.4707Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M72.5241 59.4707H62.791V96.0991H72.5241V59.4707Z",
                fill: "#B7B9BE"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M109.983 96.0597C110.107 95.3593 110.173 94.6197 110.173 93.8342C110.173 93.0488 110.107 92.283 109.976 91.576C109.224 87.3673 106.298 84.7753 102.2 84.1077C101.5 83.9964 100.767 83.9375 100.008 83.9375C99.2484 83.9375 98.4499 84.003 97.7233 84.1208C93.6193 84.808 90.7066 87.3935 89.9473 91.576C89.8164 92.283 89.751 93.0357 89.751 93.8342C89.751 94.6328 89.8164 95.3593 89.9408 96.0597C90.6935 100.236 93.6128 102.828 97.7233 103.515C98.4499 103.639 99.2157 103.698 100.008 103.698C100.8 103.698 101.507 103.639 102.2 103.528C106.304 102.86 109.23 100.262 109.983 96.0597Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M104.571 98.6123H95.4658V115.827H104.571V98.6123Z",
                fill: "#1868DB"
            })
        ]
    });
};

});

parcelRegister("6YBpK", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $7e0aeec82087ad0b$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $7e0aeec82087ad0b$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    notEligibleTitle: {
        id: "fastshift.not-eligible.title",
        defaultMessage: "You can\u2019t access FastShift Portal",
        description: "Title for the not eligible display"
    },
    noLicenseDescription: {
        id: "fastshift.no-license.description",
        defaultMessage: "Your Atlassian account is not linked to a cloud license eligible to access FastShift Portal. Check your account status or {contactSupportLink} for further assistance.",
        description: "Description for the no license display"
    },
    notLinkedDescription: {
        id: "fastshift.not-linked.description",
        defaultMessage: "Your Atlassian account is not linked to any ongoing migration. If you believe you should have Portal access, {contactSupportLink}.",
        description: "Description for the not linked display"
    },
    contactSupportAnchorText: {
        id: "fastshift.not-eligible.contact-support-anchor-text",
        defaultMessage: "contact support",
        description: "Link text for contacting support"
    },
    goBackButton: {
        id: "fastshift.not-eligible.go-back-button",
        defaultMessage: "Go back",
        description: "Button text for going back to the previous display"
    },
    signInWithAnotherAccountButton: {
        id: "fastshift.not-eligible.sign-in-with-another-account",
        defaultMessage: "Sign in with another account",
        description: "Button text for signing in with another account"
    }
});

});






parcelRegister("glqYA", function(module, exports) {

$parcel$export(module.exports, "RedirectToSelectionPage", function () { return $a3a94ad6361f6a88$export$485895d4d5e7861a; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hK5Mw = parcelRequire("hK5Mw");

var $9gh2a = parcelRequire("9gh2a");
parcelRequire("5XMUP");
var $gbLaZ = parcelRequire("gbLaZ");
const $a3a94ad6361f6a88$export$485895d4d5e7861a = ()=>{
    const navigate = (0, $hK5Mw.useNavigate)();
    const { paths: paths } = (0, $gbLaZ.useRoutes)();
    (0, $iSvIT.useEffect)(()=>{
        const selectionPageUrl = paths.selection;
        navigate(selectionPageUrl);
    }, [
        navigate
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
        interactionName: "load",
        label: "Loading"
    });
};

});






//# sourceMappingURL=fastshift-dashboard-page.c0cfe0ff.js.map
